function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("lOTPs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$36fd791b15e6ae56$export$2e2bcd8739ae039);
    var $6GopH;
    const $36fd791b15e6ae56$var$getRouteWrapper = ()=>{
        return (0, (0, parcelRequire("6GopH")).getRoutes)();
    };
    var $36fd791b15e6ae56$export$2e2bcd8739ae039 = $36fd791b15e6ae56$var$getRouteWrapper;
});
parcelRegister("6GopH", function(module, exports) {
    $parcel$export(module.exports, "getRoutes", ()=>$26bc22beafcfd5a4$export$2f7745f2f5ab3897);
    var $cOT9R;
    var $6Zmj8;
    var $1yKC4;
    var $k4Mu2;
    var $1ZHmp;
    var $gDDbQ;
    var $19rw3;
    var $2UIX1;
    var $QkD8v;
    var $1NReT;
    var $9lLtf;
    var $2hn6E;
    var $5eUyE;
    var $5Fkpv;
    var $c31xm;
    var $hBCfM;
    var $6Ja6c;
    var $aZoVa;
    var $7RZwy;
    var $25GXG;
    var $2f84N;
    var $2zGx5;
    var $1ts3p;
    var $bG6rK;
    var $PhxiS;
    var $h3crr;
    var $lV7Ii;
    var $9oDXs;
    var $lvEQq;
    var $gAzgo;
    var $31eEZ;
    var $9rDnB;
    var $f4NWX;
    var $8MmQk;
    var $78qDW;
    var $1KnZe;
    var $9hZVU;
    var $bDcJ1;
    var $cPUT6;
    var $bkDFu;
    var $6uUNA;
    var $fo0m9;
    var $7q9tl;
    var $9GJG2;
    var $6NtPe;
    var $d7x0M;
    var $dIf7c;
    var $51f7x;
    var $k6cxW;
    var $lQc3c;
    var $k53hh;
    var $dtV5n;
    var $6fTgc;
    var $hFzxG;
    var $crhGk;
    var $8GTtw;
    var $1t2WJ;
    var $aVXMt;
    var $8J3oF;
    var $8HKzP;
    var $9zX6u;
    var $3TT71;
    var $1k4F6;
    var $hFTXE;
    var $7XDK7;
    var $afZWf;
    var $kz9Ms;
    var $7UKjs;
    var $4uVxF;
    var $5LJL6;
    var $6vUKc;
    var $iPzOZ;
    var $kazYN;
    var $8VD2Y;
    var $3taVL;
    var $ddL21;
    var $5JIl8;
    var $gf8aX;
    var $fRYz5;
    var $D0ZxL;
    var $bNEBO;
    var $Tiqy3;
    var $kAzeP;
    var $38yi9;
    var $k6E42;
    var $celWn;
    var $1vVNJ;
    var $eLbXI;
    var $2DvlN;
    var $eyw1v;
    var $anXSE;
    var $fvTO7;
    var $8ni4m;
    var $igDdP;
    var $4biuz;
    const $26bc22beafcfd5a4$export$d47aca795954578 = ()=>[
            ...(0, (0, parcelRequire("5eUyE")).connectRouteEntries),
            ...(0, (0, parcelRequire("6NtPe")).forgeRouteEntries),
            ...(0, (0, parcelRequire("8J3oF")).nextGenRouteEntries),
            ...(0, (0, parcelRequire("1k4F6")).polarisRouteEntries),
            ...(0, (0, parcelRequire("eLbXI")).softwareOnboardingRouteEntries),
            ...(0, (0, parcelRequire("eLbXI")).onboardingGetStartedRouteEntries),
            ...(0, (0, parcelRequire("1NReT")).classicProjectRouteEntries),
            ...(0, (0, parcelRequire("igDdP")).projectSettingsRouteEntries),
            ...(0, (0, parcelRequire("cOT9R")).migrationRouteEntries),
            ...(0, (0, parcelRequire("19rw3")).jiraBusinessRouteEntries),
            ...(0, (0, parcelRequire("fvTO7")).jiraAdminPagesRouteEntries),
            (0, (0, parcelRequire("1ZHmp")).archivedIssuesRedirectRouteEntry),
            ...(0, (0, parcelRequire("1ZHmp")).archivedIssuesRouteEntries),
            (0, (0, parcelRequire("k53hh")).issueCreateEmbedRouteEntry),
            ...(0, (0, parcelRequire("6fTgc")).issueNavigatorRouteEntries),
            ...(0, (0, parcelRequire("aVXMt")).getMarketplaceRoutes)(),
            ...(0, (0, parcelRequire("8VD2Y")).proformaRouteEntries),
            (0, (0, parcelRequire("dtV5n")).browseIssueEmbedRouteEntry),
            (0, (0, parcelRequire("dtV5n")).browseIssueRouteEntry),
            (0, (0, parcelRequire("9lLtf")).compassProductSettingsRouteEntry),
            (0, (0, parcelRequire("2hn6E")).confluenceProductSettingsRouteEntry),
            (0, (0, parcelRequire("hFzxG")).jiraHomeRouteEntry),
            (0, (0, parcelRequire("crhGk")).jiraSearchRouteEntry),
            (0, (0, parcelRequire("lQc3c")).homeRedirectRouteEntry),
            (0, (0, parcelRequire("k6cxW")).homeOnboardingRedirectRouteEntry),
            (0, (0, parcelRequire("hBCfM")).devopsConnectedProjectRouteEntry),
            (0, (0, parcelRequire("9zX6u")).peopleProfilesRouteEntry),
            (0, (0, parcelRequire("2DvlN")).trashProjectsDirectoryRouteEntry),
            (0, (0, parcelRequire("k6E42")).settingsAutomationRouteEntry),
            (0, (0, parcelRequire("2DvlN")).trashProjectsDirectory1RouteEntry),
            (0, (0, parcelRequire("k4Mu2")).archivedProjectsDirectoryRouteEntry),
            ...(0, (0, parcelRequire("2f84N")).projectsDirectoryRouteEntries),
            (0, (0, parcelRequire("QkD8v")).classicProjectSettingsIssueLayoutRouteEntry),
            (0, (0, parcelRequire("2UIX1")).classicProjectSettingsDataClassificationsRouteEntry),
            (0, (0, parcelRequire("3taVL")).projectComponentsRouteEntry),
            (0, (0, parcelRequire("3taVL")).projectComponents1RouteEntry),
            (0, (0, parcelRequire("gf8aX")).projectSettingsComponentsRouteEntry),
            (0, (0, parcelRequire("bNEBO")).projectVersionsRouteEntry),
            (0, (0, parcelRequire("5Fkpv")).createProjectRouteEntry),
            (0, (0, parcelRequire("fRYz5")).projectSettingsVersionsRouteEntry),
            (0, (0, parcelRequire("5JIl8")).projectPagesRouteEntry),
            (0, (0, parcelRequire("5JIl8")).projectPages1RouteEntry),
            (0, (0, parcelRequire("Tiqy3")).rovoDemandTestsRouteEntry),
            (0, (0, parcelRequire("8HKzP")).opsgenieScheduleRouteEntry),
            (0, (0, parcelRequire("8HKzP")).opsgenieSchedule1RouteEntry),
            (0, (0, parcelRequire("c31xm")).dashboardEditRouteEntry),
            (0, (0, parcelRequire("c31xm")).dashboardWallboardRouteEntry),
            (0, (0, parcelRequire("c31xm")).dashboardViewRouteEntry),
            (0, (0, parcelRequire("c31xm")).dashboardViewEmbedRouteEntry),
            (0, (0, parcelRequire("aZoVa")).dashboardsDirectoryRedirectRouteEntry),
            (0, (0, parcelRequire("aZoVa")).dashboardsDirectoryRouteEntry),
            (0, (0, parcelRequire("6Ja6c")).boardsDirectoryRedirectRouteEntry),
            (0, (0, parcelRequire("6Ja6c")).boardsDirectoryRouteEntry),
            (0, (0, parcelRequire("7RZwy")).filtersDirectoryRedirectRouteEntry),
            (0, (0, parcelRequire("7RZwy")).filtersDirectoryRouteEntry),
            (0, (0, parcelRequire("7RZwy")).secureFiltersDirectoryRedirectRouteEntry),
            ...(0, (0, parcelRequire("3TT71")).personalSettingsRouteEntries),
            (0, (0, parcelRequire("kAzeP")).customerServiceEscalationsRouteEntry),
            (0, (0, parcelRequire("38yi9")).customerServiceProductsRouteEntry),
            ...(0, (0, parcelRequire("6Zmj8")).advancedRoadmapsRouteEntries),
            (0, (0, parcelRequire("dIf7c")).globalSettingsCustomFieldsRouteEntry),
            (0, (0, parcelRequire("51f7x")).globalSettingsIssuesExplicitFieldAssociationRouteEntry),
            (0, (0, parcelRequire("celWn")).settingsCmdbFieldConfigRouteEntry),
            (0, (0, parcelRequire("1vVNJ")).settingsOauthCredentialsRouteEntry),
            (0, (0, parcelRequire("D0ZxL")).projectsRedirectRouteEntry),
            (0, (0, parcelRequire("gDDbQ")).browseProjectRedirectRouteEntry),
            (0, (0, parcelRequire("kazYN")).productsJswConfigurationRouteEntry),
            (0, (0, parcelRequire("kazYN")).productsJswStorageManagementRouteEntry),
            (0, (0, parcelRequire("iPzOZ")).productsJsmOrganizationsRouteEntry),
            (0, (0, parcelRequire("iPzOZ")).productsJsmOrganizations1RouteEntry),
            (0, (0, parcelRequire("afZWf")).productsJsmConfigurationRouteEntry),
            (0, (0, parcelRequire("7XDK7")).productsJsmComplianceRouteEntry),
            (0, (0, parcelRequire("6vUKc")).productsJsmKbPermissionsRouteEntry),
            (0, (0, parcelRequire("kz9Ms")).productsJsmEmailRequestsRouteEntry),
            (0, (0, parcelRequire("6uUNA")).eocTeamCustomerLogsRouteEntry),
            (0, (0, parcelRequire("6uUNA")).eocTeamCustomerLogsDownloadRouteEntry),
            (0, (0, parcelRequire("1ts3p")).eocApiKeyManagementRouteEntry),
            (0, (0, parcelRequire("d7x0M")).globalMailSettingsRouteEntry),
            (0, (0, parcelRequire("5LJL6")).productsJsmIncidentManagementToolsRouteEntry),
            (0, (0, parcelRequire("7UKjs")).productsJsmFeatureUsageRouteEntry),
            ...(0, (0, parcelRequire("4biuz")).servicedeskRouteEntries),
            (0, (0, parcelRequire("1yKC4")).archivedProjectDirectLinkRouteEntry),
            (0, (0, parcelRequire("c31xm")).selectedDashboardRouteEntry),
            (0, (0, parcelRequire("c31xm")).dashboardRouteEntry),
            (0, (0, parcelRequire("c31xm")).systemDashboardEditRouteEntry),
            ...(0, (0, parcelRequire("6Zmj8")).planRouteEntries),
            (0, (0, parcelRequire("6Zmj8")).planSetupPageRouteEntry),
            (0, (0, parcelRequire("6Zmj8")).planExportPageRouteEntry),
            (0, (0, parcelRequire("6Zmj8")).planPageRouteEntry),
            (0, (0, parcelRequire("6Zmj8")).planPageWithoutScenarioIdRouteEntry),
            (0, (0, parcelRequire("6Zmj8")).legacyPlanPageRedirectRouteEntry),
            (0, (0, parcelRequire("6Zmj8")).planReportPageRouteEntry),
            (0, (0, parcelRequire("6Zmj8")).legacyPlanReportPageRedirectRouteEntry),
            (0, (0, parcelRequire("25GXG")).plansDirectoryRouteEntry),
            (0, (0, parcelRequire("cPUT6")).eocScheduleGlobalRouteEntry),
            ...(0, (0, parcelRequire("lV7Ii")).eocGlobalAlertListRouteEntries),
            ...(0, (0, parcelRequire("bkDFu")).eocTeamAlertListRouteEntries),
            (0, (0, parcelRequire("9oDXs")).eocGlobalGroupDetailRouteEntry),
            (0, (0, parcelRequire("9oDXs")).eocTeamGroupDetailRouteEntry),
            ...(0, (0, parcelRequire("bDcJ1")).eocRoleBasedNotificationsRouteEntries),
            ...(0, (0, parcelRequire("gAzgo")).eocIncomingCallRouteEntries),
            (0, (0, parcelRequire("fo0m9")).unlockOperationsRouteEntry),
            ...(0, (0, parcelRequire("31eEZ")).eocIntegrationsRouteEntries),
            ...(0, (0, parcelRequire("1KnZe")).eocPoliciesRouteEntries),
            (0, (0, parcelRequire("8MmQk")).eocOverviewRouteEntry),
            (0, (0, parcelRequire("8MmQk")).eocOverviewAllTeamsRouteEntry),
            (0, (0, parcelRequire("lvEQq")).eocHeartbeatsRouteEntry),
            ...(0, (0, parcelRequire("9rDnB")).eocMaintenanceRouteEntries),
            (0, (0, parcelRequire("f4NWX")).eocOnCallRouteEntry),
            (0, (0, parcelRequire("f4NWX")).eocOnCall1RouteEntry),
            (0, (0, parcelRequire("7q9tl")).whoIsOnCallRouteEntry),
            (0, (0, parcelRequire("78qDW")).eocPermissionsRouteEntry),
            (0, (0, parcelRequire("PhxiS")).eocAutomationsRouteEntry),
            ...(0, (0, parcelRequire("2zGx5")).eocAlertIssueSyncingRouteEntries),
            ...(0, (0, parcelRequire("9hZVU")).eocOpsRouteEntries),
            (0, (0, parcelRequire("h3crr")).eocCustomRolesRouteEntry),
            (0, (0, parcelRequire("bG6rK")).eocAssignCustomRolesRouteEntry),
            (0, (0, parcelRequire("4uVxF")).productsJsmGlobalOpsReportsRouteEntry),
            (0, (0, parcelRequire("4uVxF")).productsJsmGlobalOpsReports1RouteEntry),
            (0, (0, parcelRequire("hFTXE")).productsJsmChatopsAndVideosToolsRouteEntry),
            (0, (0, parcelRequire("ddL21")).projectNotFoundRouteEntry),
            (0, (0, parcelRequire("9GJG2")).errorsNotFoundRouteEntry),
            (0, (0, parcelRequire("1t2WJ")).loginEmbedRouteEntry),
            ...(0, (0, parcelRequire("8ni4m")).helpCenterSettingsRouteEntries),
            (0, (0, parcelRequire("eyw1v")).userSegmentationRouteEntry),
            (0, (0, parcelRequire("8GTtw")).legacyRedirectRouteEntry)
        ];
    const $26bc22beafcfd5a4$var$rawRoutes = $26bc22beafcfd5a4$export$d47aca795954578();
    const $26bc22beafcfd5a4$export$2f7745f2f5ab3897 = ()=>{
        return $26bc22beafcfd5a4$var$rawRoutes;
    };
    function $26bc22beafcfd5a4$var$isPathBasedRoute(route) {
        return Boolean(route.path);
    }
    const $26bc22beafcfd5a4$export$6ca4f07048df7206 = ()=>$26bc22beafcfd5a4$export$d47aca795954578().filter($26bc22beafcfd5a4$var$isPathBasedRoute).map((0, (0, parcelRequire("anXSE")).default)).map(({ earlyAssets: earlyAssets, entryPoint: entryPoint, exact: exact, forPaint: forPaint, group: group, meta: meta, name: name, path: path, preloadOptions: preloadOptions, query: query, bifrost: bifrost })=>({
                earlyAssets: earlyAssets,
                entryPoint: entryPoint,
                exact: exact,
                forPaint: forPaint,
                group: group,
                meta: meta,
                name: name,
                path: path,
                preloadOptions: preloadOptions,
                query: query,
                bifrost: bifrost
            }));
});
parcelRegister("cOT9R", function(module, exports) {
    $parcel$export(module.exports, "migrationRouteEntries", ()=>$1b9e218c54e1d874$export$debd9f352e8a3e70);
    var $1WqFo;
    var $ffza4;
    var $co1wz;
    var $7XYc4;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $c1JR4;
    var $5lsNZ;
    var $dtU4a;
    var $iyPg5;
    var $lbAtn;
    const $1b9e218c54e1d874$export$debd9f352e8a3e70 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("c1JR4")).globalSettingsMigrationsHomeRoute), ()=>({
                ufoName: 'admin.c2c-migrations.home',
                canTransitionIn: ()=>(0, (0, parcelRequire("co1wz")).ff)('jira-system-settings-cloud-to-cloud-migration'),
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("1WqFo")).isFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, (0, parcelRequire("lbAtn")).default)),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("lbAtn")).LazySystemMigrationsHome)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("c1JR4")).globalSettingsMigrationsDashboardRoute), ()=>({
                ufoName: 'admin.c2c-migrations.dashboard',
                canTransitionIn: ()=>(0, (0, parcelRequire("co1wz")).ff)('jira-system-settings-cloud-to-cloud-migration'),
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("1WqFo")).isFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, (0, parcelRequire("dtU4a")).default)),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("dtU4a")).LazySystemC2cMigrationsDashboard)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("c1JR4")).globalSettingsMigrationsFocusPageRoute), ()=>({
                canTransitionIn: ()=>(0, (0, parcelRequire("co1wz")).ff)('jira-system-settings-cloud-to-cloud-migration'),
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("1WqFo")).isFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, (0, parcelRequire("iyPg5")).default)),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("iyPg5")).LazySystemC2cMigrationsFocusPage)
                ]
            }))
    ];
});
parcelRegister("7XYc4", function(module, exports) {
    $parcel$export(module.exports, "componentWithCondition", ()=>$d8879edec083173e$export$6e8ea24b15199873);
    var $5uXOq = parcelRequire("5uXOq");
    function $d8879edec083173e$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
        const ComponentWithCondition = (0, $5uXOq.forwardRef)((props, ref)=>condition() ? (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentTrue, {
                ...props,
                ref: ref
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentFalse, {
                ...props,
                ref: ref
            }));
        if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
        return ComponentWithCondition;
    }
});
parcelRegister("ibkIl", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsLayout", ()=>$3eb51436f6201a33$export$e6aef6083548e882);
    var $2BrOV;
    var $1XrjK;
    const $3eb51436f6201a33$export$e6aef6083548e882 = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout));
});
parcelRegister("c1JR4", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsMigrationsHomeRoute", ()=>$2d9c43db881ab996$export$12b9979f5c1ed5a4);
    $parcel$export(module.exports, "globalSettingsMigrationsDashboardRoute", ()=>$2d9c43db881ab996$export$b48d38ab4363f197);
    $parcel$export(module.exports, "globalSettingsMigrationsFocusPageRoute", ()=>$2d9c43db881ab996$export$50ae42a441766ba5);
    var $65Ltd;
    const $2d9c43db881ab996$export$12b9979f5c1ed5a4 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_HOME),
        path: '/jira/settings/system/migration/home'
    };
    const $2d9c43db881ab996$export$b48d38ab4363f197 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD),
        path: '/jira/settings/system/migration/dashboard'
    };
    const $2d9c43db881ab996$export$50ae42a441766ba5 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_FOCUS_PAGE),
        path: '/jira/settings/system/migration/:step(how-it-works|plan-configuration|choose-projects|choose-group-membership|select-customer|check-for-errors|review|view-details)/:migrationId?'
    };
});
parcelRegister("5lsNZ", function(module, exports) {
    $parcel$export(module.exports, "LazyNotFoundErrorPage", ()=>$5ed1828a3f7dd5a7$export$57c5c0b5a0cdb5b7);
    $parcel$export(module.exports, "default", ()=>$5ed1828a3f7dd5a7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $5ed1828a3f7dd5a7$export$57c5c0b5a0cdb5b7 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("iKEJ8")), {
        moduleId: "./src/packages/spa-apps/error-pages/not-found/src/index.tsx"
    });
    var $5ed1828a3f7dd5a7$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5ed1828a3f7dd5a7$export$57c5c0b5a0cdb5b7,
            pageId: "errors-404",
            shouldShowSpinner: false
        });
});
parcelRegister("iKEJ8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("92sUi"),
        $6fhBS("i5RRW"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8uqRL")
    ]).then(()=>parcelRequire('6iSaB'));
});
parcelRegister("dtU4a", function(module, exports) {
    $parcel$export(module.exports, "LazySystemC2cMigrationsDashboard", ()=>$bc6cc6da8c11fd31$export$422086745f2d10c4);
    $parcel$export(module.exports, "default", ()=>$bc6cc6da8c11fd31$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $bc6cc6da8c11fd31$export$422086745f2d10c4 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fpTnr"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/migrations/migrations-dashboard/src/index.tsx"
    });
    var $bc6cc6da8c11fd31$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $bc6cc6da8c11fd31$export$422086745f2d10c4,
            pageId: "system-c2c-migrations-dashboard",
            shouldShowSpinner: true
        });
});
parcelRegister("7yO8g", function(module, exports) {
    $parcel$export(module.exports, "markAsProductBundleReady", ()=>$beda9c6123873bbb$export$ff83c57004505abd);
    var $2SVPM;
    const $beda9c6123873bbb$export$ff83c57004505abd = (importedBundle)=>{
        if (!false) importedBundle.then(()=>{
            (0, (0, parcelRequire("2SVPM")).setProductBundleReadyForInitialRender)();
        });
        return importedBundle;
    };
});
parcelRegister("fpTnr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("fRrgV")
    ]).then(()=>parcelRequire('iKp4O'));
});
parcelRegister("iyPg5", function(module, exports) {
    $parcel$export(module.exports, "LazySystemC2cMigrationsFocusPage", ()=>$d155f242f0f0da60$export$e0c09a0ffb780ae2);
    $parcel$export(module.exports, "default", ()=>$d155f242f0f0da60$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $d155f242f0f0da60$export$e0c09a0ffb780ae2 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4T776"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/migrations/migrations-focus-page/src/index.tsx"
    });
    var $d155f242f0f0da60$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d155f242f0f0da60$export$e0c09a0ffb780ae2,
            pageId: "system-c2c-migrations-focus-page",
            shouldShowSpinner: true
        });
});
parcelRegister("4T776", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hHeRE")
    ]).then(()=>parcelRequire('kTuYj'));
});
parcelRegister("lbAtn", function(module, exports) {
    $parcel$export(module.exports, "LazySystemMigrationsHome", ()=>$226e70f7f9e8baab$export$b78d99112db11162);
    $parcel$export(module.exports, "default", ()=>$226e70f7f9e8baab$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $226e70f7f9e8baab$export$b78d99112db11162 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("l0fbZ"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/migrations/migrations-home/src/index.tsx"
    });
    var $226e70f7f9e8baab$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $226e70f7f9e8baab$export$b78d99112db11162,
            pageId: "system-migrations-home",
            shouldShowSpinner: true
        });
});
parcelRegister("l0fbZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("gx7r5")
    ]).then(()=>parcelRequire('2YNDR'));
});
parcelRegister("6Zmj8", function(module, exports) {
    $parcel$export(module.exports, "advancedRoadmapsRouteEntries", ()=>$ffe74f439a298da1$export$f43cc215b47dd576);
    $parcel$export(module.exports, "planPageRouteEntry", ()=>$ffe74f439a298da1$export$f85a75f1604118ff);
    $parcel$export(module.exports, "planRouteEntries", ()=>$ffe74f439a298da1$export$189ae5546a081577);
    $parcel$export(module.exports, "planPageWithoutScenarioIdRouteEntry", ()=>$ffe74f439a298da1$export$9cbef73b51558ef);
    $parcel$export(module.exports, "legacyPlanPageRedirectRouteEntry", ()=>$ffe74f439a298da1$export$e9cfdb950d40e917);
    $parcel$export(module.exports, "planReportPageRouteEntry", ()=>$ffe74f439a298da1$export$e71031acce6d7e47);
    $parcel$export(module.exports, "legacyPlanReportPageRedirectRouteEntry", ()=>$ffe74f439a298da1$export$c2a4c5c6576a704c);
    $parcel$export(module.exports, "planExportPageRouteEntry", ()=>$ffe74f439a298da1$export$d751e3552b21c604);
    $parcel$export(module.exports, "planSetupPageRouteEntry", ()=>$ffe74f439a298da1$export$2a24acea4e628148);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $87OsA;
    var $4R6GH;
    var $2BrOV;
    var $8iyFV;
    var $lmyls;
    var $937TY;
    var $451ix;
    var $2G9Bk;
    var $1XrjK;
    var $c3WQb;
    var $lv9xW;
    var $3RJkv;
    var $9UjCT;
    var $7OYJs;
    var $is7uC;
    var $5j7Th;
    var $3ibi7;
    var $5WheG;
    var $5Xf5s;
    var $aZlet;
    var $eGTiK;
    var $2CDtd;
    var $5ZrwA;
    var $a0VYb;
    var $aY4MJ;
    var $kJhPn;
    var $1TUUd;
    var $g4RX2;
    var $5A9fc;
    var $3IiyK;
    var $dF9Tz;
    var $f9NlF;
    var $hX07x;
    var $4mz8X;
    var $aEJq5;
    var $3qEAW;
    var $8ONdR;
    var $lisCo;
    var $4chOZ;
    var $lLICt;
    var $b28pv;
    var $eQDYJ;
    var $difX6;
    const $ffe74f439a298da1$export$f43cc215b47dd576 = [
        (0, (0, parcelRequire("eGTiK")).archivedPlansRouteEntry),
        (0, (0, parcelRequire("eGTiK")).trashPlansRouteEntry),
        (0, (0, parcelRequire("eGTiK")).trashedPlanDirectLinkRouteEntry),
        (0, (0, parcelRequire("eGTiK")).arjSettingsFinancialYearPageEntry),
        (0, (0, parcelRequire("eGTiK")).planIncrementRouteEntry),
        (0, (0, parcelRequire("eGTiK")).planIncrementsRouteEntry)
    ];
    const $ffe74f439a298da1$export$bca2008b514578a0 = (0, (0, parcelRequire("difX6")).withRedirection)((0, (0, parcelRequire("b28pv")).default), {
        to: '/timeline',
        redirectCondition: ()=>true
    });
    const $ffe74f439a298da1$export$f85a75f1604118ff = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwareAdvancedRoadmapsRoute), ()=>({
            ufoName: 'software-advanced-roadmaps-scenario',
            component: $ffe74f439a298da1$export$bca2008b514578a0,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("b28pv")).LazyPlanTimeline)
            ]
        }));
    const $ffe74f439a298da1$export$189ae5546a081577 = [
        ...(0, (0, parcelRequire("aZlet")).arjSettingsRouteEntries),
        ...(0, (0, parcelRequire("5Xf5s")).arjEmbedRouteEntries),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanDependenciesRoute), ()=>({
                component: (0, (0, parcelRequire("5ZrwA")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("451ix")).planLayout)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default),
                    horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                    onlyShowHorizontalOnNav4: true
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("5ZrwA")).LazyPlanDependenciesReport)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSummaryRoute), ()=>({
                ufoName: 'software-advanced-roadmaps-summary',
                component: (0, (0, parcelRequire("4chOZ")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("451ix")).planLayout)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("lv9xW")).advancedRoadmapsSummaryDataResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default),
                    horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                    onlyShowHorizontalOnNav4: true
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("4chOZ")).LazyPlanSummary)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanCalendarRoute), ()=>({
                ufoName: 'software-advanced-roadmaps-calendar',
                component: (0, (0, parcelRequire("2CDtd")).default),
                skeleton: ()=>(0, (0, parcelRequire("4R6GH")).fg)('platform_calendar_adoption_in_plans') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("is7uC")).CalendarSkeleton), null) : undefined,
                entryPoint () {
                    (0, (0, parcelRequire("87OsA")).setCapability)((0, $281cbd47ba46dd7d$export$f999749ac7a2cd1));
                    return (0, (0, parcelRequire("4R6GH")).fg)('platform_calendar_adoption_in_plans') ? (0, (0, parcelRequire("2CDtd")).planCalendarRouteEntry) : undefined;
                },
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("451ix")).planLayout)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default),
                    horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                    onlyShowHorizontalOnNav4: true
                },
                meta: {
                    capability: (0, $281cbd47ba46dd7d$export$f999749ac7a2cd1)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("2CDtd")).LazyPlanCalendar)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanReleasesRoute), ()=>({
                component: (0, (0, parcelRequire("aY4MJ")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("451ix")).planLayout)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default),
                    horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                    onlyShowHorizontalOnNav4: true
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("aY4MJ")).LazyPlanReleases)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanTimelineRoute), ()=>({
                component: (0, (0, parcelRequire("b28pv")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("451ix")).planLayout)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default),
                    horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                    onlyShowHorizontalOnNav4: true
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("b28pv")).LazyPlanTimeline)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsPermissionsRoute), ()=>({
                component: (0, (0, parcelRequire("f9NlF")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("451ix")).planLayout)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("f9NlF")).LazyPlanSettingsPermissions)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsSavedViewsRoute), ()=>({
                component: (0, (0, parcelRequire("3qEAW")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("451ix")).planLayout)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("3qEAW")).LazyPlanSettingsSavedViews)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsPlanInfoRoute), ()=>({
                component: (0, (0, parcelRequire("hX07x")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("451ix")).planLayout)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("hX07x")).LazyPlanSettingsPlanInfo)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsProgramBoardsRoute), ()=>({
                component: (0, (0, parcelRequire("4mz8X")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("451ix")).planLayout)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("4mz8X")).LazyPlanSettingsProgramBoards)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsSchedulingRoute), ()=>({
                component: (0, (0, parcelRequire("lisCo")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("451ix")).planLayout)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("lisCo")).LazyPlanSettingsScheduling)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsScenariosRoute), ()=>({
                component: (0, (0, parcelRequire("8ONdR")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("451ix")).planLayout)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("8ONdR")).LazyPlanSettingsScenarios)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsAutoSchedulerRoute), ()=>({
                component: (0, (0, parcelRequire("1TUUd")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("451ix")).planLayout)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("1TUUd")).LazyPlanSettingsAutoScheduler)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsCustomFieldsRoute), ()=>({
                component: (0, (0, parcelRequire("g4RX2")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("451ix")).planLayout)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("g4RX2")).LazyPlanSettingsCustomFields)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsExclusionRulesRoute), ()=>({
                component: (0, (0, parcelRequire("5A9fc")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("451ix")).planLayout)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("5A9fc")).LazyPlanSettingsExclusionRules)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsIssueSourcesRoute), ()=>({
                component: (0, (0, parcelRequire("dF9Tz")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("451ix")).planLayout)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("dF9Tz")).LazyPlanSettingsIssueSources)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsFindYourIssueRoute), ()=>({
                component: (0, (0, parcelRequire("3IiyK")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("451ix")).planLayout)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("3IiyK")).LazyPlanSettingsFindYourIssue)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanSettingsRemovedIssuesRoute), ()=>({
                component: (0, (0, parcelRequire("aEJq5")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("451ix")).planLayout)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PLAN_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("aEJq5")).LazyPlanSettingsRemovedIssues)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwarePlanTeamsRoute), ()=>({
                component: (0, (0, parcelRequire("lLICt")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("451ix")).planLayout)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                    (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'advanced-roadmaps-early-entry'
                    ]
                },
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                    sidebar: (0, (0, parcelRequire("937TY")).default),
                    horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                    onlyShowHorizontalOnNav4: true
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("lLICt")).LazyPlanTeams)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwareAdvancedRoadmapsGettingStartedRedirectRoute), ()=>({
                component: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                        to: "/jira/plans?create-sample-plan=true"
                    }),
                isRedirect: true,
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("b28pv")).LazyPlanTimeline)
                ]
            }))
    ];
    const $ffe74f439a298da1$export$9cbef73b51558ef = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwareAdvancedRoadmaps1Route), ()=>({
            ufoName: 'software-advanced-roadmaps-plan',
            component: (0, (0, parcelRequire("3ibi7")).RedirectPlanPageWithoutScenarioId),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("b28pv")).LazyPlanTimeline)
            ]
        }));
    const $ffe74f439a298da1$export$e9cfdb950d40e917 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwareAdvancedRoadmapsRedirectRoute), ()=>({
            component: (0, (0, parcelRequire("3ibi7")).RedirectLegacyPlanPage),
            isRedirect: true,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsScenarioIdResource)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("b28pv")).LazyPlanTimeline)
            ]
        }));
    const $ffe74f439a298da1$export$e71031acce6d7e47 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwareAdvancedRoadmaps3Route), ()=>({
            ufoName: 'software-advanced-roadmaps-report',
            component: (0, (0, parcelRequire("kJhPn")).default),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("451ix")).planLayout)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanReportPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("kJhPn")).LazyPlanReport)
            ]
        }));
    const $ffe74f439a298da1$export$c2a4c5c6576a704c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwareAdvancedRoadmapsRedirect1Route), ()=>({
            component: (0, (0, parcelRequire("5WheG")).default),
            isRedirect: true,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("b28pv")).LazyPlanTimeline)
            ]
        }));
    const $ffe74f439a298da1$var$ExportPageComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a0VYb")).LazyAdvancedRoadmapsPlanExport), null);
    const $ffe74f439a298da1$var$ExportPage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ffe74f439a298da1$var$ExportPageComponent,
            pageId: "advanced-roadmap",
            shouldShowSpinner: true
        });
    const $ffe74f439a298da1$export$d751e3552b21c604 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwareAdvancedRoadmaps5Route), ()=>({
            ufoName: 'software-advanced-roadmaps-scenario-export',
            component: $ffe74f439a298da1$var$ExportPage,
            layout: {
                isChromeless: true,
                globalComponents: [],
                rightSidebars: []
            },
            resources: [
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("b28pv")).LazyPlanTimeline)
            ]
        }));
    const $ffe74f439a298da1$export$2a24acea4e628148 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9UjCT")).softwareAdvancedRoadmapsSetupRoute), ()=>({
            component: (0, (0, parcelRequire("eQDYJ")).default),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("eQDYJ")).LazyAdvancedRoadmapsSetup)
            ]
        }));
});
const $281cbd47ba46dd7d$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $281cbd47ba46dd7d$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $281cbd47ba46dd7d$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $281cbd47ba46dd7d$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$6d592df97fba16ca = 'GIN_GLOBAL_ISSUE_NAVIGATOR';
const $281cbd47ba46dd7d$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $281cbd47ba46dd7d$export$4695c1a423ffe431 = 'DASHBOARD';
const $281cbd47ba46dd7d$export$4ce203fc8c0eb2d1 = 'ISSUE_MOVE';
const $281cbd47ba46dd7d$export$49d57bef9ac2550b = 'GLOBAL_ISSUE_CREATE';
const $281cbd47ba46dd7d$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $281cbd47ba46dd7d$export$9a80695e72849f84 = 'X-Atlassian-Capability';
parcelRegister("451ix", function(module, exports) {
    $parcel$export(module.exports, "planLayout", ()=>$fa12faadb00e7e4f$export$94e1d79bf65579e2);
    var $1XrjK;
    var $hPtZI;
    const $fa12faadb00e7e4f$export$b6292b5f7e5b5fad = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("BXMfg")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx"
    });
    const $fa12faadb00e7e4f$export$94e1d79bf65579e2 = (0, (0, parcelRequire("1XrjK")).createLayout)({
        globalComponents: [
            $fa12faadb00e7e4f$export$b6292b5f7e5b5fad
        ]
    });
});
parcelRegister("BXMfg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9iCqI").then(()=>parcelRequire('ikoZN'));
});
parcelRegister("c3WQb", function(module, exports) {
    $parcel$export(module.exports, "advancedRoadmapsReduxStoreStateResource", ()=>$20c66b93015d9910$export$6ca262338f199e4b);
    $parcel$export(module.exports, "advancedRoadmapsScenarioIdResource", ()=>$20c66b93015d9910$export$aec847b4ce72891);
    $parcel$export(module.exports, "advancedRoadmapsPlanPageInitialChecksResource", ()=>$20c66b93015d9910$export$7431e46c7ad56c3d);
    $parcel$export(module.exports, "advancedRoadmapsPlanReportPageInitialChecksResource", ()=>$20c66b93015d9910$export$bf0c5395c73cc255);
    $parcel$export(module.exports, "advancedRoadmapsLastVisitedProgramBoardIdResource", ()=>$20c66b93015d9910$export$f5b159e1fb19e04e);
    var $hGgHi = parcelRequire("hGgHi");
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $20c66b93015d9910$export$6ca262338f199e4b = (0, $dIdda.createResource)({
        type: 'ADVANCED_ROADMAPS_REDUX_STORE_STATE',
        getKey: ({ match: match })=>{
            const { params: params, query: query } = match;
            if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
            if (params.reportId != null) return params.reportId;
            if (query.r != null) return query.r;
            throw new Error('Unable to get resource key for ADVANCED_ROADMAPS_REDUX_STORE_STATE.');
        },
        getData: async ()=>undefined,
        isBrowserOnly: true,
        maxAge: Infinity
    });
    const $20c66b93015d9910$export$aec847b4ce72891 = (0, $dIdda.createResource)({
        type: (0, $025c2a539475c8ec$export$a0893d695ebee984),
        getKey: ({ query: query })=>`scenarioId_${query.id}`,
        getData: async ({ query: query })=>{
            const planId = query.id;
            const { id: id } = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/jpo/1.0/scenarios/${planId}`);
            return {
                scenarioId: id
            };
        },
        maxAge: 0
    });
    const $20c66b93015d9910$export$7431e46c7ad56c3d = (0, $dIdda.createResource)({
        type: (0, $025c2a539475c8ec$export$68390102872336b6),
        getKey: ({ match: match })=>{
            const { planId: planId, scenarioId: scenarioId } = match.params;
            return `planPageInitialChecks_${planId != null ? planId : ''}_${scenarioId != null ? scenarioId : ''}`;
        },
        getData: async ({ match: match })=>{
            const { planId: planId, scenarioId: scenarioId } = match.params;
            if (planId == null || planId === 'null' && planId === 'undefined' && planId === '') throw new Error('Plan cannot be loaded without a planId');
            let url = `/rest/jpo/1.0/plans/${planId}/checks`;
            if (scenarioId != null && scenarioId !== 'null' && scenarioId !== 'undefined' && scenarioId !== '') url = `${url}?sid=${scenarioId}`;
            const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(url);
            return response;
        },
        maxAge: Infinity
    });
    const $20c66b93015d9910$export$bf0c5395c73cc255 = (0, $dIdda.createResource)({
        type: (0, $025c2a539475c8ec$export$a00e869cafd63140),
        getKey: ({ match: match })=>`planReportPageInitialChecks_${match.params.reportId == null ? '' : match.params.reportId}`,
        getData: async ({ match: match })=>{
            const initialPlanChecksPromise = window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
            delete window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
            if (initialPlanChecksPromise) {
                const response = await initialPlanChecksPromise;
                return response;
            }
            const { reportId: reportId } = match.params;
            const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/jpo/1.0/reportinfo/generic/${reportId == null ? '' : reportId}/checks`);
            return response;
        },
        maxAge: Infinity
    });
    const $20c66b93015d9910$export$f5b159e1fb19e04e = (0, $dIdda.createResource)({
        type: (0, $025c2a539475c8ec$export$179a0d35e95a4d61),
        getKey: ({ query: query, match: match })=>`lastVisitedProgramBoardId_${query.id}_${match.params.planId}_${match.params.scenarioId}`,
        getData: async ({ match: match })=>{
            const RETRIES = 3;
            const DELAY = 500;
            const attemptFetch = async (remainingRetries)=>{
                const currentPlanId = match.params.planId;
                if (!(0, ($parcel$interopDefault($hGgHi)))(currentPlanId)) {
                    const defaultBoardIdResponse = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/jpo/2.0/plans/${currentPlanId}/increments/default`);
                    if (defaultBoardIdResponse === null) return {
                        boardId: null
                    };
                    const { id: id } = defaultBoardIdResponse;
                    return {
                        boardId: id
                    };
                }
                if (remainingRetries > 0) {
                    await new Promise((resolve)=>setTimeout(resolve, DELAY));
                    return attemptFetch(remainingRetries - 1);
                }
                throw new Error('Attempted to get the last visited program board of a plan without a plan id after multiple retries.');
            };
            return attemptFetch(RETRIES);
        },
        maxAge: Infinity
    });
});
const $025c2a539475c8ec$export$68390102872336b6 = 'ADVANCED_ROADMAPS_PLAN_INITIAL_CHECKS';
const $025c2a539475c8ec$export$a00e869cafd63140 = 'ADVANCED_ROADMAPS_REPORT_INITIAL_CHECKS';
const $025c2a539475c8ec$export$a0893d695ebee984 = 'ADVANCED_ROADMAPS_SCENARIO_ID';
const $025c2a539475c8ec$export$179a0d35e95a4d61 = 'ADVANCED_ROADMAPS_LAST_VISITED_PROGRAM_BOARD_ID';
parcelRegister("lv9xW", function(module, exports) {
    $parcel$export(module.exports, "advancedRoadmapsSummaryDataResource", ()=>$f87ae7e2901ac155$export$f9061628830b5175);
    $parcel$export(module.exports, "fetchAdvancedRoadmapsSummaryData", ()=>$f87ae7e2901ac155$export$2dfe99460dae6bc6);
    var $7f4tk;
    var $dIdda = parcelRequire("dIdda");
    var $5m5rT;
    const $f87ae7e2901ac155$var$getQueryParams = (routerQuery)=>{
        if (typeof window !== 'undefined') return Object.fromEntries(new URLSearchParams(window.location.search));
        return routerQuery;
    };
    const $f87ae7e2901ac155$export$f9061628830b5175 = (0, $dIdda.createResource)({
        type: 'ADVANCED_ROADMAPS_SUMMARY_DATA',
        getKey: ({ match: match })=>{
            const { params: params } = match;
            if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
            return 'none';
        },
        getData: async ({ match: match, query: query })=>{
            if (window.__ARJ_SUMMARY_PAGE_PROMISE__) {
                const response = window.__ARJ_SUMMARY_PAGE_PROMISE__;
                window.__ARJ_SUMMARY_PAGE_PROMISE__ = null;
                return response;
            }
            const { params: params } = match;
            return $f87ae7e2901ac155$export$2dfe99460dae6bc6(params, query, (0, (0, parcelRequire("5m5rT")).AVAILABLE_CHARTS));
        },
        maxAge: Infinity,
        isBrowserOnly: true
    });
    const $f87ae7e2901ac155$export$2dfe99460dae6bc6 = async (params, query, chartTypes)=>{
        if (params.planId == null) throw new Error('Unable to get fetch data for ADVANCED_ROADMAPS_SUMMARY_DATA. planId is not defined');
        const { startDate: startDate, endDate: endDate } = $f87ae7e2901ac155$var$getQueryParams(query);
        const customDateRangeParams = startDate && endDate ? {
            startDate: startDate,
            endDate: endDate
        } : {};
        const data = await (0, (0, parcelRequire("7f4tk")).default)('/rest/jpo/1.0/summary/data', {
            method: 'POST',
            body: JSON.stringify({
                planId: params.planId,
                scenarioId: params.scenarioId,
                chartTypes: chartTypes,
                ...customDateRangeParams
            })
        });
        return data;
    };
});
parcelRegister("5m5rT", function(module, exports) {
    $parcel$export(module.exports, "CHART_TYPES", ()=>$d315f648a94f47c0$export$3251435144ca69e2);
    $parcel$export(module.exports, "AVAILABLE_CHARTS", ()=>$d315f648a94f47c0$export$79cf9c14f738d70b);
    $parcel$export(module.exports, "SCHEDULING_MODES", ()=>$d315f648a94f47c0$export$92daf59e30346cd2);
    $parcel$export(module.exports, "CAPACITY_UNIT", ()=>$d315f648a94f47c0$export$494e761f17fc60a9);
    $parcel$export(module.exports, "SPRINT_STATE", ()=>$d315f648a94f47c0$export$38e437924c2adbda);
    const $d315f648a94f47c0$export$3251435144ca69e2 = {
        statusCategory: 'STATUS_CATEGORY',
        issueProgress: 'ISSUE_PROGRESS',
        teamProgress: 'TEAM_PROGRESS',
        teamCapacity: 'TEAM_CAPACITY',
        blockers: 'BLOCKERS',
        highestPriority: 'HIGHEST_PRIORITY',
        unassignedIssues: 'UNASSIGNED_ISSUES',
        overlappingBlockers: 'OVERLAPPING_BLOCKERS',
        overdue: 'OVERDUE'
    };
    const $d315f648a94f47c0$export$79cf9c14f738d70b = [
        $d315f648a94f47c0$export$3251435144ca69e2.statusCategory,
        $d315f648a94f47c0$export$3251435144ca69e2.issueProgress,
        $d315f648a94f47c0$export$3251435144ca69e2.teamProgress,
        $d315f648a94f47c0$export$3251435144ca69e2.teamCapacity,
        $d315f648a94f47c0$export$3251435144ca69e2.blockers,
        $d315f648a94f47c0$export$3251435144ca69e2.highestPriority,
        $d315f648a94f47c0$export$3251435144ca69e2.unassignedIssues,
        $d315f648a94f47c0$export$3251435144ca69e2.overlappingBlockers,
        $d315f648a94f47c0$export$3251435144ca69e2.overdue
    ];
    const $d315f648a94f47c0$export$92daf59e30346cd2 = {
        SCRUM: 'Scrum',
        KANBAN: 'Kanban'
    };
    const $d315f648a94f47c0$export$494e761f17fc60a9 = {
        HOURS: 'HOURS',
        POINTS: 'STORY_POINTS',
        DAYS: 'DAYS'
    };
    const $d315f648a94f47c0$export$38e437924c2adbda = {
        CLOSED: 'CLOSED',
        ACTIVE: 'ACTIVE',
        FUTURE: 'FUTURE'
    };
});
parcelRegister("9UjCT", function(module, exports) {
    $parcel$export(module.exports, "softwareAdvancedRoadmapsRoute", ()=>$6df62a94d3e772ef$export$21d57208bfbf7e92);
    $parcel$export(module.exports, "softwarePlanDependenciesRoute", ()=>$6df62a94d3e772ef$export$ad8296aa5394f696);
    $parcel$export(module.exports, "softwarePlanSummaryRoute", ()=>$6df62a94d3e772ef$export$25a8cf27557a612d);
    $parcel$export(module.exports, "softwarePlanCalendarRoute", ()=>$6df62a94d3e772ef$export$ca4c39d60ec156a2);
    $parcel$export(module.exports, "softwarePlanReleasesRoute", ()=>$6df62a94d3e772ef$export$850236b64b0aa28b);
    $parcel$export(module.exports, "softwarePlanTimelineRoute", ()=>$6df62a94d3e772ef$export$61abeb6a03d23dd3);
    $parcel$export(module.exports, "softwarePlanSettingsPermissionsRoute", ()=>$6df62a94d3e772ef$export$6734c29372722a5e);
    $parcel$export(module.exports, "softwarePlanSettingsSavedViewsRoute", ()=>$6df62a94d3e772ef$export$a0fec30f475e8756);
    $parcel$export(module.exports, "softwarePlanSettingsProgramBoardsRoute", ()=>$6df62a94d3e772ef$export$3d54c48a91a178c0);
    $parcel$export(module.exports, "softwarePlanSettingsPlanInfoRoute", ()=>$6df62a94d3e772ef$export$76e6bdc959f6fa97);
    $parcel$export(module.exports, "softwarePlanSettingsSchedulingRoute", ()=>$6df62a94d3e772ef$export$a215ef374dd2a8a9);
    $parcel$export(module.exports, "softwarePlanSettingsScenariosRoute", ()=>$6df62a94d3e772ef$export$d32efeefb944c6b7);
    $parcel$export(module.exports, "softwarePlanSettingsAutoSchedulerRoute", ()=>$6df62a94d3e772ef$export$e44088b2cc0206cf);
    $parcel$export(module.exports, "softwarePlanSettingsCustomFieldsRoute", ()=>$6df62a94d3e772ef$export$2634cd63c73f7a35);
    $parcel$export(module.exports, "softwarePlanSettingsExclusionRulesRoute", ()=>$6df62a94d3e772ef$export$358b0ca69a4bd731);
    $parcel$export(module.exports, "softwarePlanSettingsIssueSourcesRoute", ()=>$6df62a94d3e772ef$export$fa18324265e4400c);
    $parcel$export(module.exports, "softwarePlanSettingsFindYourIssueRoute", ()=>$6df62a94d3e772ef$export$ab61883f74eb27c2);
    $parcel$export(module.exports, "softwarePlanSettingsRemovedIssuesRoute", ()=>$6df62a94d3e772ef$export$8b77532ba9798e64);
    $parcel$export(module.exports, "softwarePlanTeamsRoute", ()=>$6df62a94d3e772ef$export$fc66f5c0de18ddc7);
    $parcel$export(module.exports, "softwareAdvancedRoadmaps1Route", ()=>$6df62a94d3e772ef$export$a3686c51bf984ef9);
    $parcel$export(module.exports, "softwareAdvancedRoadmapsRedirectRoute", ()=>$6df62a94d3e772ef$export$cc2401df741549fe);
    $parcel$export(module.exports, "softwareAdvancedRoadmaps3Route", ()=>$6df62a94d3e772ef$export$bd0ed90cfd1c0a55);
    $parcel$export(module.exports, "softwareAdvancedRoadmapsRedirect1Route", ()=>$6df62a94d3e772ef$export$264157b237e791ea);
    $parcel$export(module.exports, "softwareAdvancedRoadmaps5Route", ()=>$6df62a94d3e772ef$export$158bfed3a17a3f80);
    $parcel$export(module.exports, "softwareAdvancedRoadmapsSetupRoute", ()=>$6df62a94d3e772ef$export$442daaf7ae9abf13);
    $parcel$export(module.exports, "softwareAdvancedRoadmapsGettingStartedRedirectRoute", ()=>$6df62a94d3e772ef$export$38c76ea9ddc85b3);
    var $65Ltd;
    const $6df62a94d3e772ef$export$21d57208bfbf7e92 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
        path: '/jira/plans/:planId/scenarios/:scenarioId'
    };
    const $6df62a94d3e772ef$export$ad8296aa5394f696 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES),
        path: '/jira/plans/:planId/scenarios/:scenarioId/dependencies'
    };
    const $6df62a94d3e772ef$export$25a8cf27557a612d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY),
        path: '/jira/plans/:planId/scenarios/:scenarioId/summary'
    };
    const $6df62a94d3e772ef$export$ca4c39d60ec156a2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR),
        path: '/jira/plans/:planId/scenarios/:scenarioId/calendar'
    };
    const $6df62a94d3e772ef$export$850236b64b0aa28b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_RELEASES),
        path: '/jira/plans/:planId/scenarios/:scenarioId/releases'
    };
    const $6df62a94d3e772ef$export$61abeb6a03d23dd3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE),
        path: '/jira/plans/:planId/scenarios/:scenarioId/timeline'
    };
    const $6df62a94d3e772ef$export$6734c29372722a5e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PERMISSIONS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/permissions'
    };
    const $6df62a94d3e772ef$export$a0fec30f475e8756 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SAVED_VIEWS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/saved-views'
    };
    const $6df62a94d3e772ef$export$3d54c48a91a178c0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PROGRAM_BOARDS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/program-boards'
    };
    const $6df62a94d3e772ef$export$76e6bdc959f6fa97 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_PLAN_INFO),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/plan-info'
    };
    const $6df62a94d3e772ef$export$a215ef374dd2a8a9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCHEDULING),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scheduling'
    };
    const $6df62a94d3e772ef$export$d32efeefb944c6b7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_SCENARIOS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scenarios'
    };
    const $6df62a94d3e772ef$export$e44088b2cc0206cf = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_AUTO_SCHEDULER),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/auto-scheduler'
    };
    const $6df62a94d3e772ef$export$2634cd63c73f7a35 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_CUSTOM_FIELDS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/custom-fields'
    };
    const $6df62a94d3e772ef$export$358b0ca69a4bd731 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_EXCLUSION_RULES),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/exclusion-rules'
    };
    const $6df62a94d3e772ef$export$fa18324265e4400c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_ISSUE_SOURCES),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/issue-sources'
    };
    const $6df62a94d3e772ef$export$ab61883f74eb27c2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_FIND_YOUR_ISSUE),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/find-your-issue'
    };
    const $6df62a94d3e772ef$export$8b77532ba9798e64 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SETTINGS_REMOVED_ISSUES),
        path: '/jira/plans/:planId/scenarios/:scenarioId/settings/removed-issues'
    };
    const $6df62a94d3e772ef$export$fc66f5c0de18ddc7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_TEAMS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/teams'
    };
    const $6df62a94d3e772ef$export$a3686c51bf984ef9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
        path: '/jira/plans/:planId(\\d+)'
    };
    const $6df62a94d3e772ef$export$cc2401df741549fe = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_REDIRECT),
        path: '/secure/PortfolioPlanView.jspa'
    };
    const $6df62a94d3e772ef$export$bd0ed90cfd1c0a55 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
        path: '/jira/plans/reports/:reportId'
    };
    const $6df62a94d3e772ef$export$264157b237e791ea = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_REDIRECT),
        path: '/secure/PortfolioReportView.jspa'
    };
    const $6df62a94d3e772ef$export$158bfed3a17a3f80 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/export'
    };
    const $6df62a94d3e772ef$export$442daaf7ae9abf13 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_SETUP),
        path: '/jira/plans/:planId/setup'
    };
    const $6df62a94d3e772ef$export$38c76ea9ddc85b3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ADVANCED_ROADMAPS_GETTING_STARTED_REDIRECT),
        path: '/secure/PortfolioGettingStarted.jspa'
    };
});
parcelRegister("7OYJs", function(module, exports) {
    $parcel$export(module.exports, "ScreenRedirect", ()=>$49ac470f4c9a751a$export$fdd3e60cd227c2f7);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $95EVP;
    var $bVDE5;
    var $dIdda = parcelRequire("dIdda");
    const $49ac470f4c9a751a$export$fdd3e60cd227c2f7 = ({ to: to, persistSearchParams: persistSearchParams = true })=>{
        const [{ route: route, location: location, query: query }] = (0, $dIdda.useRouter)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        const [{ isInitialRender: isInitial }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
        (0, $5uXOq.useEffect)(()=>{
            if (!route || !eventRef.current) return;
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(eventRef.current, 'route redirected', {
                isInitial: isInitial,
                routeName: route.name
            });
            eventRef.current = null;
        }, [
            route,
            isInitial
        ]);
        if (Array.isArray(persistSearchParams)) {
            const persistParams = Object.keys(query).reduce((result, currentKey)=>{
                const shouldPersist = persistSearchParams.some((persistKey)=>currentKey.includes(persistKey));
                if (shouldPersist) result.push(`${currentKey}=${query[currentKey]}`);
                return result;
            }, []).join('&');
            if (persistParams !== '') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `${to}?${persistParams}`
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: to
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `${to}${persistSearchParams ? location.search : ''}`
        });
    };
});
parcelRegister("is7uC", function(module, exports) {
    $parcel$export(module.exports, "CalendarSkeleton", ()=>$7431abe7c0a30442$export$ebc7c47cc535837e);
    $parcel$export(module.exports, "CalendarEmbedSkeleton", ()=>$7431abe7c0a30442$export$bf543fe31d33292e);
    $parcel$export(module.exports, "CalendarNoHeaderSkeleton", ()=>$7431abe7c0a30442$export$504e7b05f3c54bf2);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $3a8Pq = parcelRequire("3a8Pq");
    var $eqvk7 = parcelRequire("eqvk7");
    var $hbVDT = parcelRequire("hbVDT");
    const $7431abe7c0a30442$var$customCssStyles = null;
    const $7431abe7c0a30442$export$ebc7c47cc535837e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($3a8Pq)))
        });
    const $7431abe7c0a30442$export$bf543fe31d33292e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($eqvk7)))
        });
    const $7431abe7c0a30442$export$504e7b05f3c54bf2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($hbVDT))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wgmglyw"
            ])
        });
});
parcelRegister("3a8Pq", function(module, exports) {
    module.exports = new URL("calendar-app-skeleton.tpl.77b09222.svg", import.meta.url).toString();
});
parcelRegister("eqvk7", function(module, exports) {
    module.exports = new URL("calendar-embed-app-skeleton.tpl.29c9a641.svg", import.meta.url).toString();
});
parcelRegister("hbVDT", function(module, exports) {
    module.exports = new URL("calendar-no-header-skeleton.tpl.d6779107.svg", import.meta.url).toString();
});
parcelRegister("3ibi7", function(module, exports) {
    $parcel$export(module.exports, "RedirectLegacyPlanPage", ()=>$3e6624904a2f18eb$export$c3e4fda2290a52bf);
    $parcel$export(module.exports, "RedirectPlanPageWithoutScenarioId", ()=>$3e6624904a2f18eb$export$ff420400c9900835);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $c3WQb;
    var $7OYJs;
    var $5W2CW;
    var $dIdda = parcelRequire("dIdda");
    const $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS = [
        'search'
    ];
    const $3e6624904a2f18eb$var$RedirectLegacyPlanPageWithoutScenarioId = ()=>{
        const [{ query: query }] = (0, $dIdda.useRouter)();
        const { data: data, loading: loading } = (0, $dIdda.useResource)((0, (0, parcelRequire("c3WQb")).advancedRoadmapsScenarioIdResource));
        if (loading || data === null) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: `/jira/plans/${query.id}/scenarios/${data.scenarioId}`,
            persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
        });
    };
    const $3e6624904a2f18eb$export$c3e4fda2290a52bf = ()=>{
        const [{ query: query }] = (0, $dIdda.useRouter)();
        const { id: id, sid: sid } = query;
        if (Number.isNaN(Number.parseFloat(sid))) return (0, ($parcel$interopDefault($5uXOq))).createElement($3e6624904a2f18eb$var$RedirectLegacyPlanPageWithoutScenarioId, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: `/jira/plans/${id}/scenarios/${sid}`,
            persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
        });
    };
    const $3e6624904a2f18eb$export$ff420400c9900835 = ()=>{
        const [{ match: match }] = (0, $dIdda.useRouter)();
        const { planId: planId } = match.params;
        if (planId === null || planId === undefined || Number.isNaN(Number.parseFloat(planId))) throw new Error('Plan cannot be loaded without planId');
        const { data: data, loading: loading } = (0, $dIdda.useResource)((0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource));
        if (loading || data === null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null);
        if (!data.success) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5W2CW")).ErrorScreen), {
            errorMessage: data.errorMessage
        });
        if (data.scenarioId === null || data.scenarioId === undefined || typeof data.scenarioId === 'string' && Number.isNaN(Number.parseFloat(data.scenarioId))) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: `/jira/plans/${planId}/scenarios/${data.scenarioId}`,
            persistSearchParams: $3e6624904a2f18eb$var$PERSIST_SEARCH_PARAMS
        });
    };
});
parcelRegister("5W2CW", function(module, exports) {
    $parcel$export(module.exports, "ErrorScreen", ()=>$50454f3b2d1014d6$export$42f84e610f279c31);
    var $5uXOq = parcelRequire("5uXOq");
    var $38Y30;
    var $6AaZy;
    var $1v2QX;
    var $jMY1T;
    const $50454f3b2d1014d6$export$42f84e610f279c31 = ({ errorMessage: errorMessage, isEmbedded: isEmbedded = false, planId: planId })=>{
        delete window.__ARJ_BACKLOG_PROMISE__;
        delete window.__ARJ_INFO_METADATA_PROMISE__;
        switch(errorMessage){
            case 0, $b31dd89598859846$export$aa64437890e7b596:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("38Y30")).RedirectToLoginPage), null);
            case 0, $b31dd89598859846$export$3fe2400c9d24940d:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6AaZy")).AsyncLicenseViolationErrorPage), {
                    isEmbedded: isEmbedded
                });
            case 0, $b31dd89598859846$export$4589763db20bfd7f:
            case 0, $b31dd89598859846$export$7e6358a0c21dff8c:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jMY1T")).AsyncNotFoundErrorPage), {
                    entity: (0, $b31dd89598859846$export$c303e491e026ebc6),
                    isEmbedded: isEmbedded
                });
            case 0, $b31dd89598859846$export$6519152a5f0e081:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jMY1T")).AsyncNotFoundErrorPage), {
                    entity: (0, $b31dd89598859846$export$9b928fc5e710e864),
                    isEmbedded: isEmbedded,
                    planId: planId
                });
            case 0, $b31dd89598859846$export$6128dc888243fa0a:
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1v2QX")).AsyncNoPlanPermissionErrorPage), {
                    isEmbedded: isEmbedded
                });
            default:
                return null;
        }
    };
});
parcelRegister("38Y30", function(module, exports) {
    $parcel$export(module.exports, "RedirectToLoginPage", ()=>$08f8c3f776d557a9$export$938182bd3fddc3a8);
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    const $08f8c3f776d557a9$export$3da29de62ed7a388 = ({ to: to })=>(0, ($parcel$interopDefault($5uXOq))).createElement("script", {
            dangerouslySetInnerHTML: {
                __html: `window.location.assign("${to}")`
            }
        });
    $08f8c3f776d557a9$export$3da29de62ed7a388.displayName = 'InlineRedirect';
    const $08f8c3f776d557a9$export$938182bd3fddc3a8 = ()=>{
        const [{ location: { pathname: pathname, search: search } }] = (0, $dIdda.useRouter)();
        const redirectUrl = pathname + search;
        const encodedRedirectUrl = encodeURIComponent(redirectUrl);
        let path = `/login.jsp?os_destination=${encodedRedirectUrl}`;
        const parentProductQueryName = 'parentProduct';
        const [parentProduct] = (0, $dIdda.useQueryParam)(parentProductQueryName);
        if (pathname.endsWith('/embed')) {
            const searchParams = new URLSearchParams(search);
            searchParams.delete(parentProductQueryName);
            let encodedLink = encodeURIComponent(`${pathname.slice(0, -6)}?${searchParams}`);
            if (pathname.includes('/issues/create')) encodedLink = encodeURIComponent('/jira/your-work?createissue=true');
            const encodedParentProduct = encodeURIComponent(parentProduct || '');
            path = `/jira-login/embed?destination=${encodedRedirectUrl}&link=${encodedLink}&parentProduct=${encodedParentProduct}`;
        }
        return false ? (0, ($parcel$interopDefault($5uXOq))).createElement($08f8c3f776d557a9$export$3da29de62ed7a388, {
            to: path
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: path
        });
    };
});
const $b31dd89598859846$export$aa64437890e7b596 = 'permission-violation';
const $b31dd89598859846$export$3fe2400c9d24940d = 'license-violation';
const $b31dd89598859846$export$4589763db20bfd7f = 'plan-not-found';
const $b31dd89598859846$export$6519152a5f0e081 = 'scenario-not-found';
const $b31dd89598859846$export$7e6358a0c21dff8c = 'report-not-found';
const $b31dd89598859846$export$6128dc888243fa0a = 'no-plan-permission';
const $b31dd89598859846$export$c303e491e026ebc6 = 'PLAN';
const $b31dd89598859846$export$9b928fc5e710e864 = 'SCENARIO';
parcelRegister("6AaZy", function(module, exports) {
    $parcel$export(module.exports, "AsyncLicenseViolationErrorPage", ()=>$05d56fdddce8137e$export$f5d9764f07badc4d);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $lfTZh;
    var $hPtZI;
    const $05d56fdddce8137e$var$LazyLicenseViolationErrorPage = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("eidU9")), {
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/license-violation/index.tsx"
    });
    const $05d56fdddce8137e$export$f5d9764f07badc4d = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "arj-license-violation-page",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($05d56fdddce8137e$var$LazyLicenseViolationErrorPage, props));
});
parcelRegister("eidU9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("ikYJz")
    ]).then(()=>parcelRequire('cGdIS'));
});
parcelRegister("1v2QX", function(module, exports) {
    $parcel$export(module.exports, "AsyncNoPlanPermissionErrorPage", ()=>$d08fb773ac6c1816$export$e595d2c5dfcb1d5a);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $lfTZh;
    var $hPtZI;
    const $d08fb773ac6c1816$var$LazyNoPlanPermissionErrorPage = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("6Qy3Y")), {
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/no-plan-permission/index.tsx"
    });
    const $d08fb773ac6c1816$export$e595d2c5dfcb1d5a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "arj-no-plan-permission",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d08fb773ac6c1816$var$LazyNoPlanPermissionErrorPage, props));
});
parcelRegister("6Qy3Y", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("db3ID")
    ]).then(()=>parcelRequire('dycHB'));
});
parcelRegister("jMY1T", function(module, exports) {
    $parcel$export(module.exports, "AsyncNotFoundErrorPage", ()=>$900bf2ccc30cc7be$export$8f6c907860218fdc);
    var $5uXOq = parcelRequire("5uXOq");
    var $kb4zh;
    var $lfTZh;
    var $hPtZI;
    const $900bf2ccc30cc7be$var$LazyNotFoundErrorPage = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("Fac9v")), {
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/error-screens/not-found/index.tsx"
    });
    const $900bf2ccc30cc7be$export$8f6c907860218fdc = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "arj-not-found-page",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($900bf2ccc30cc7be$var$LazyNotFoundErrorPage, props));
});
parcelRegister("Fac9v", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("4cS57")
    ]).then(()=>parcelRequire('3jte6'));
});
parcelRegister("5WheG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$135d7141d14abe41$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7OYJs;
    var $dIdda = parcelRequire("dIdda");
    var $135d7141d14abe41$export$2e2bcd8739ae039 = ()=>{
        const [{ query: query }] = (0, $dIdda.useRouter)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: `/jira/plans/reports/${query.r}`,
            persistSearchParams: false
        });
    };
});
parcelRegister("5Xf5s", function(module, exports) {
    $parcel$export(module.exports, "arjEmbedRouteEntries", ()=>$e4b20bcfc3d9d9f7$export$8535fa0728567020);
    var $8rnUp;
    var $9bWHl;
    var $kIRdi;
    var $lbSsJ;
    var $1RCb5;
    const $e4b20bcfc3d9d9f7$export$8535fa0728567020 = [
        (0, (0, parcelRequire("8rnUp")).arjCalendarEmbedRouteEntry),
        (0, (0, parcelRequire("9bWHl")).arjDependenciesEmbedRouteEntry),
        (0, (0, parcelRequire("kIRdi")).arjIncrementEmbedRouteEntry),
        (0, (0, parcelRequire("lbSsJ")).arjSummaryEmbedRouteEntry),
        (0, (0, parcelRequire("1RCb5")).arjTimelineEmbedRouteEntry)
    ];
});
parcelRegister("8rnUp", function(module, exports) {
    $parcel$export(module.exports, "arjCalendarEmbedRouteEntry", ()=>$994fd41f214cf799$export$309ed92381819b04);
    var $5uXOq = parcelRequire("5uXOq");
    var $87OsA;
    var $lkFvK;
    var $cSD7y;
    var $4R6GH;
    var $2G9Bk;
    var $1XrjK;
    var $c3WQb;
    var $2Ql51;
    var $bqNCs;
    var $5lsNZ;
    var $is7uC;
    var $02tNK;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $994fd41f214cf799$var$LazyPlanCalendarEmbed = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5wS2n"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-calendar/index.tsx"
    });
    const $994fd41f214cf799$var$PlanCalendarEmbedPage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $994fd41f214cf799$var$LazyPlanCalendarEmbed,
            pageId: "plan-calendar-embed",
            shouldShowSpinner: true
        });
    const $994fd41f214cf799$var$planCalendarEmbedRouteEntry = (0, (0, parcelRequire("lkFvK")).createChromelessEntryPoint)({
        main: (0, (0, parcelRequire("02tNK")).calendarEntryPoint)
    });
    const $994fd41f214cf799$export$309ed92381819b04 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bqNCs")).softwarePlanCalendarEmbedRoute), ()=>({
            ufoName: 'software-advanced-roadmaps-calendar-embed',
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('smart_links_for_plans', $994fd41f214cf799$var$PlanCalendarEmbedPage, (0, (0, parcelRequire("5lsNZ")).default)),
            skeleton: ()=>{
                if ((0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans')) return (0, (0, parcelRequire("4R6GH")).fg)('platform_calendar_adoption_in_plans') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("is7uC")).CalendarSkeleton), null) : undefined;
                return undefined;
            },
            entryPoint () {
                (0, (0, parcelRequire("87OsA")).setCapability)((0, $281cbd47ba46dd7d$export$f999749ac7a2cd1));
                if ((0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans')) return (0, (0, parcelRequire("4R6GH")).fg)('platform_calendar_adoption_in_plans') ? $994fd41f214cf799$var$planCalendarEmbedRouteEntry : undefined;
                return undefined;
            },
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)({
                isChromeless: true
            }),
            resources: [
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$f999749ac7a2cd1)
            },
            forPaint: [
                $994fd41f214cf799$var$LazyPlanCalendarEmbed
            ]
        }));
});
parcelRegister("lkFvK", function(module, exports) {
    $parcel$export(module.exports, "createChromelessEntryPoint", ()=>$6a0b20679c309df7$export$56ea489e9d4bfa04);
    $parcel$export(module.exports, "createPageEntryPoint", ()=>$6a0b20679c309df7$export$955a7619d2679b4c);
    var $adY3A;
    const $6a0b20679c309df7$export$56ea489e9d4bfa04 = (page)=>({
            root: page.main.root,
            getPreloadProps: (entryPointParams)=>({
                    entryPoints: {
                        [(0, $6d6ccf8a2b2c5b3c$export$900ddb492c628f48)]: {
                            entryPoint: page.main,
                            entryPointParams: entryPointParams
                        }
                    }
                }),
            toString: ()=>'ChromelessEntryPoint'
        });
    const $6a0b20679c309df7$export$955a7619d2679b4c = (page)=>({
            root: page.main.root,
            getPreloadProps: (entryPointParams)=>({
                    entryPoints: {
                        [(0, $6d6ccf8a2b2c5b3c$export$900ddb492c628f48)]: {
                            entryPoint: page.main,
                            entryPointParams: entryPointParams
                        },
                        [(0, $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae)]: {
                            entryPoint: (0, (0, parcelRequire("adY3A")).topNavigationEntryPoint),
                            entryPointParams: {
                                menuId: page.topNavigationMenuId
                            }
                        },
                        ...page.horizontalNavigation ? {
                            [(0, $6d6ccf8a2b2c5b3c$export$948d4d345566aed3)]: {
                                entryPoint: page.horizontalNavigation,
                                entryPointParams: {}
                            }
                        } : undefined,
                        ...page.rightSidebar ? {
                            [(0, $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb)]: {
                                entryPoint: page.rightSidebar,
                                entryPointParams: entryPointParams
                            }
                        } : undefined
                    }
                }),
            toString: ()=>'PageEntryPoint'
        });
});
const $6d6ccf8a2b2c5b3c$export$948d4d345566aed3 = '__pageLayoutHorizontalNavigation';
const $6d6ccf8a2b2c5b3c$export$50ea883ba6f28ff5 = '__pageLayoutLeftSidebar';
const $6d6ccf8a2b2c5b3c$export$900ddb492c628f48 = '__pageLayoutMainContent';
const $6d6ccf8a2b2c5b3c$export$bec6dca2e63de4ae = '__pageLayoutTopNavigation';
const $6d6ccf8a2b2c5b3c$export$7bf43119a6b49ddb = '__pageLayoutRightSidebar';
parcelRegister("bqNCs", function(module, exports) {
    $parcel$export(module.exports, "softwarePlanTimelineEmbedRoute", ()=>$1aa060c96d3de1a5$export$a60c43befc130169);
    $parcel$export(module.exports, "softwarePlanDependenciesEmbedRoute", ()=>$1aa060c96d3de1a5$export$aa2fcc70355c7d19);
    $parcel$export(module.exports, "softwarePlanCalendarEmbedRoute", ()=>$1aa060c96d3de1a5$export$df82cc5024b7f316);
    $parcel$export(module.exports, "softwarePlanSummaryEmbedRoute", ()=>$1aa060c96d3de1a5$export$2cee7cd37198b3fd);
    $parcel$export(module.exports, "softwarePlanIncrementEmbedRoute", ()=>$1aa060c96d3de1a5$export$a6b708cae2ed7f0c);
    var $65Ltd;
    const $1aa060c96d3de1a5$export$a60c43befc130169 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_TIMELINE_EMBED),
        path: '/jira/plans/:planId/scenarios/:scenarioId/timeline/embed'
    };
    const $1aa060c96d3de1a5$export$aa2fcc70355c7d19 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_DEPENDENCIES_EMBED),
        path: '/jira/plans/:planId/scenarios/:scenarioId/dependencies/embed'
    };
    const $1aa060c96d3de1a5$export$df82cc5024b7f316 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED),
        path: '/jira/plans/:planId/scenarios/:scenarioId/calendar/embed'
    };
    const $1aa060c96d3de1a5$export$2cee7cd37198b3fd = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_SUMMARY_EMBED),
        path: '/jira/plans/:planId/scenarios/:scenarioId/summary/embed'
    };
    const $1aa060c96d3de1a5$export$a6b708cae2ed7f0c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT_EMBED),
        path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId/embed'
    };
});
parcelRegister("02tNK", function(module, exports) {
    $parcel$export(module.exports, "calendarEntryPoint", ()=>$8623df52c8647276$export$19cf4b398f638dc6);
    var $4R6GH;
    var $7JhZX;
    var $2Ftxm;
    var $ikgNX;
    const $8623df52c8647276$var$ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED = 'software-plan-calendar-embed';
    function $8623df52c8647276$var$toPlanScenarioAri({ siteId: siteId, activationId: activationId, planId: planId, scenarioId: scenarioId }) {
        return `ari:cloud:jira:${siteId}:plan-scenario/activation/${activationId}/${planId}/scenario/${scenarioId}`;
    }
    function $8623df52c8647276$var$getStorageKeyFromScope(context) {
        const { match: { params: { planId: planId, scenarioId: scenarioId } } } = context;
        const LOCALSTORAGE_KEY_PREFIX = 'persist:calendar';
        return `${LOCALSTORAGE_KEY_PREFIX}/plan/${planId}/scenario/${scenarioId}`;
    }
    function $8623df52c8647276$var$getStorageValueFromScope(key) {
        const storedData = globalThis.localStorage?.getItem(key) || '';
        return storedData;
    }
    function $8623df52c8647276$var$toMidnightUTCString(date) {
        const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
        return new Date(utcMilliseconds).toISOString();
    }
    function $8623df52c8647276$var$toDate(date) {
        if (!date) return new Date();
        try {
            const _date = new Date(date);
            return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
        } catch (e) {
            return new Date();
        }
    }
    function $8623df52c8647276$var$createScope({ context: context, tenantContext: tenantContext }) {
        const { match: { params: { planId: planId, scenarioId: scenarioId } } } = context;
        const { cloudId: cloudId, activationId: activationId } = tenantContext;
        const planScenarioAri = $8623df52c8647276$var$toPlanScenarioAri({
            siteId: cloudId,
            activationId: activationId,
            planId: String(planId),
            scenarioId: String(scenarioId)
        });
        return {
            type: 'plan',
            ids: [
                planScenarioAri
            ]
        };
    }
    function $8623df52c8647276$var$buildScopeInput(scope) {
        return {
            ids: scope.ids
        };
    }
    function $8623df52c8647276$var$buildViewId(scope) {
        return scope.ids?.[0] ?? '';
    }
    function $8623df52c8647276$var$toViewMode(mode) {
        switch(mode){
            case 'week':
                return 'WEEK';
            case 'day':
                return 'DAY';
            default:
                return 'MONTH';
        }
    }
    function $8623df52c8647276$var$toWeekStart(weekStart) {
        switch(weekStart){
            case 'monday':
                return 'MONDAY';
            case 'saturday':
                return 'SATURDAY';
            default:
                return 'SUNDAY';
        }
    }
    function $8623df52c8647276$var$toCalendarWeekStart(weekStart) {
        switch(weekStart){
            case 'sunday':
                return 'sunday';
            case 'saturday':
                return 'saturday';
            default:
                return 'monday';
        }
    }
    function $8623df52c8647276$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, viewId: viewId }) {
        return {
            date: $8623df52c8647276$var$toMidnightUTCString(selectedDate),
            mode: $8623df52c8647276$var$toViewMode(viewRange),
            weekStart: $8623df52c8647276$var$toWeekStart(weekStartsOn),
            viewId: viewId
        };
    }
    function $8623df52c8647276$var$buildIssuesSearchInput(storageKey, filter, isEmbed) {
        if ((0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans')) return {
            additionalFilterQuery: isEmbed === true ? filter : filter || $8623df52c8647276$var$getStorageValueFromScope(storageKey)
        };
        return {
            additionalFilterQuery: $8623df52c8647276$var$getStorageValueFromScope(storageKey)
        };
    }
    function $8623df52c8647276$var$buildUnscheduledIssuesSearchInput() {
        return {
            additionalFilterQuery: ''
        };
    }
    function $8623df52c8647276$var$buildVersionsSearchInput() {
        return {
            versionStatuses: [
                'RELEASED',
                'UNRELEASED'
            ]
        };
    }
    function $8623df52c8647276$var$buildCalendarCrossProjectVersionsInput() {
        return {
            statuses: [
                'RELEASED',
                'UNRELEASED'
            ]
        };
    }
    function $8623df52c8647276$var$buildSprintsSearchInput() {
        return {
            sprintStates: [
                'ACTIVE',
                'FUTURE',
                'CLOSED'
            ]
        };
    }
    function $8623df52c8647276$var$buildSettingsParams(hideWeekends, hideSprints, hideVersions, hideIssues, hideIssueKey, weekStartsOnQueryParam) {
        if (hideWeekends || hideSprints || hideVersions || hideIssues || hideIssueKey || weekStartsOnQueryParam) return {
            hideWeekends: hideWeekends === 'true' || undefined,
            hideSprints: hideSprints === 'true' || undefined,
            hideVersions: hideVersions === 'true' || undefined,
            hideIssues: hideIssues === 'true' || undefined,
            hideIssueKey: hideIssueKey === 'true' || undefined,
            weekStartsOn: $8623df52c8647276$var$toCalendarWeekStart(weekStartsOnQueryParam)
        };
        return undefined;
    }
    const $8623df52c8647276$export$19cf4b398f638dc6 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("98rs3")), {
            moduleId: "53aec496"
        }),
        getPreloadProps: (entryPointRouteParams)=>{
            const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
            const { cloudId: cloudId } = tenantContext;
            const scope = $8623df52c8647276$var$createScope(entryPointRouteParams);
            const scopeInput = $8623df52c8647276$var$buildScopeInput(scope);
            const { date: date, filter: filter, hideWeekends: hideWeekends, hideSprints: hideSprints, hideVersions: hideVersions, hideIssues: hideIssues, hideIssueKey: hideIssueKey, weekStartsOn: weekStartsOnQueryParam } = context.query;
            const selectedDate = $8623df52c8647276$var$toDate(date);
            const hasFilterQueryParam = (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? Boolean(filter) : false;
            const routeName = (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? context.route.name : '';
            const settingsQueryParams = (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? $8623df52c8647276$var$buildSettingsParams(hideWeekends, hideSprints, hideVersions, hideIssues, hideIssueKey, weekStartsOnQueryParam) : {};
            const isEmbed = (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? routeName === $8623df52c8647276$var$ROUTE_NAMES_SOFTWARE_PLAN_CALENDAR_EMBED : false;
            const viewRange = 'month';
            const weekStartsOn = 'monday';
            const startDateField = 'startdate';
            const endDateField = 'duedate';
            const issueEventFields = {
                startDateField: startDateField,
                endDateField: endDateField
            };
            const storageKey = $8623df52c8647276$var$getStorageKeyFromScope(context);
            const viewId = $8623df52c8647276$var$buildViewId(scope);
            const filterQuery = (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? $8623df52c8647276$var$buildIssuesSearchInput(storageKey, filter, isEmbed) : $8623df52c8647276$var$buildIssuesSearchInput(storageKey);
            return {
                queries: {
                    calendarData: {
                        options: {
                            fetchPolicy: 'network-only'
                        },
                        parameters: (0, parcelRequire("7JhZX")).default,
                        variables: {
                            cloudId: cloudId,
                            scopeInput: scopeInput,
                            configurationInput: $8623df52c8647276$var$buildConfigurationInput({
                                selectedDate: selectedDate,
                                viewRange: viewRange,
                                weekStartsOn: weekStartsOn,
                                viewId: viewId
                            }),
                            issuesSearchInput: filterQuery,
                            unscheduledIssuesSearchInput: $8623df52c8647276$var$buildUnscheduledIssuesSearchInput(),
                            versionsSearchInput: $8623df52c8647276$var$buildVersionsSearchInput(),
                            sprintsSearchInput: $8623df52c8647276$var$buildSprintsSearchInput(),
                            crossProjectVersionsSearchInput: $8623df52c8647276$var$buildCalendarCrossProjectVersionsInput(),
                            viewId: viewId,
                            skipSprintSearch: false,
                            skipVersionSearch: false,
                            skipPanelIssueSearch: true,
                            skipCrossProjectVersionSearch: false,
                            schedulePermissionsEnabled: (0, (0, parcelRequire("4R6GH")).fg)('calendar_schedule_issue_permissions_check')
                        }
                    }
                },
                entryPoints: {},
                extraProps: {
                    scope: scope,
                    selectedDate: selectedDate,
                    viewRange: viewRange,
                    weekStartsOn: weekStartsOn,
                    issueEventFields: issueEventFields,
                    storageKey: storageKey,
                    hasFilterQueryParam: hasFilterQueryParam,
                    routeName: routeName,
                    settingsQueryParams: settingsQueryParams,
                    filterQuery: (0, (0, parcelRequire("4R6GH")).fg)('smart_links_for_plans') ? filterQuery.additionalFilterQuery : undefined
                }
            };
        }
    });
});
parcelRegister("7JhZX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$122674b135b0c50b$export$2e2bcd8739ae039);
    const $122674b135b0c50b$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "d57c5aa2501709c84ebb2ccbb5bf076d32ad8256d3bf18aa358f54a70584cfb8",
            "metadata": {},
            "name": "ui_jiraCalendarQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $122674b135b0c50b$export$2e2bcd8739ae039 = $122674b135b0c50b$var$node;
});
parcelRegister("98rs3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("axKNq")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gsa5D")
    ]).then(()=>parcelRequire('5zu1k'));
});
parcelRegister("5wS2n", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("5ubvA")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("b7hCy")
    ]).then(()=>parcelRequire('8ipiN'));
});
parcelRegister("9bWHl", function(module, exports) {
    $parcel$export(module.exports, "arjDependenciesEmbedRouteEntry", ()=>$1ac1c43ff241df29$export$2506a377ba649c46);
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $2G9Bk;
    var $1XrjK;
    var $c3WQb;
    var $2Ql51;
    var $bqNCs;
    var $5lsNZ;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $1ac1c43ff241df29$export$48681ab0b4246654 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fQisF"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-dependencies-report/index.tsx"
    });
    const $1ac1c43ff241df29$var$PlanDependenciesReportEmbedPage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1ac1c43ff241df29$export$48681ab0b4246654,
            pageId: "plan-dependencies-report-embed",
            shouldShowSpinner: true
        });
    const $1ac1c43ff241df29$export$2506a377ba649c46 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bqNCs")).softwarePlanDependenciesEmbedRoute), ()=>({
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('smart_links_for_plans', $1ac1c43ff241df29$var$PlanDependenciesReportEmbedPage, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)({
                isChromeless: true
            }),
            resources: [
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            forPaint: [
                $1ac1c43ff241df29$export$48681ab0b4246654
            ]
        }));
});
parcelRegister("fQisF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("4XDQa")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8czeq")
    ]).then(()=>parcelRequire('9WfFd'));
});
parcelRegister("kIRdi", function(module, exports) {
    $parcel$export(module.exports, "arjIncrementEmbedRouteEntry", ()=>$7aefdf7bc9d09622$export$3feed0b4da010c52);
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $2G9Bk;
    var $1XrjK;
    var $c3WQb;
    var $2Ql51;
    var $bqNCs;
    var $5lsNZ;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $7aefdf7bc9d09622$export$51f2083dff1ee684 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("35mct"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-increment/index.tsx"
    });
    const $7aefdf7bc9d09622$export$a2ae011b90c17927 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7aefdf7bc9d09622$export$51f2083dff1ee684,
            pageId: "plan-increment-embed",
            shouldShowSpinner: true
        });
    const $7aefdf7bc9d09622$export$3feed0b4da010c52 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bqNCs")).softwarePlanIncrementEmbedRoute), ()=>({
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('smart_links_for_plans', $7aefdf7bc9d09622$export$a2ae011b90c17927, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)({
                isChromeless: true
            }),
            resources: [
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            forPaint: [
                $7aefdf7bc9d09622$export$51f2083dff1ee684
            ]
        }));
});
parcelRegister("35mct", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("bxjtM")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jcetw")
    ]).then(()=>parcelRequire('f3Kyg'));
});
parcelRegister("lbSsJ", function(module, exports) {
    $parcel$export(module.exports, "arjSummaryEmbedRouteEntry", ()=>$2485c4cbac92f412$export$bdc2c75e02c29d7);
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $2G9Bk;
    var $1XrjK;
    var $c3WQb;
    parcelRequire("cP24C");
    var $lv9xW;
    var $3RJkv;
    var $2Ql51;
    var $bqNCs;
    var $5lsNZ;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $2485c4cbac92f412$var$LazyPlanSummaryEmbed = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("63ju8"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-summary/index.tsx"
    });
    const $2485c4cbac92f412$var$PlanSummaryEmbedPage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2485c4cbac92f412$var$LazyPlanSummaryEmbed,
            pageId: "plan-summary-embed",
            shouldShowSpinner: true
        });
    const $2485c4cbac92f412$export$bdc2c75e02c29d7 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bqNCs")).softwarePlanSummaryEmbedRoute), ()=>({
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('smart_links_for_plans', $2485c4cbac92f412$var$PlanSummaryEmbedPage, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)({
                isChromeless: true
            }),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("lv9xW")).advancedRoadmapsSummaryDataResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            forPaint: [
                $2485c4cbac92f412$var$LazyPlanSummaryEmbed
            ]
        }));
});
parcelRegister("cP24C", function(module, exports) {
    $parcel$export(module.exports, "useAdvancedRoadmapsSummaryDataResource", ()=>$d012d2ead08788e3$export$263a4c831540778e);
    $parcel$export(module.exports, "advancedRoadmapsSummaryDataResource", ()=>(parcelRequire("lv9xW")).advancedRoadmapsSummaryDataResource);
    var $dIdda = parcelRequire("dIdda");
    var $lv9xW;
    var $gZ6zR;
    const $d012d2ead08788e3$export$263a4c831540778e = ()=>(0, $dIdda.useResource)((0, (0, parcelRequire("lv9xW")).advancedRoadmapsSummaryDataResource));
});
parcelRegister("gZ6zR", function(module, exports) {
    $parcel$export(module.exports, "IssueStatus", ()=>$ad83cd0410dc011b$export$559eb15a98685419);
    $parcel$export(module.exports, "BlockType", ()=>$ad83cd0410dc011b$export$48808c686fe495c4);
    const $ad83cd0410dc011b$export$559eb15a98685419 = {
        TODO: 'TODO',
        IN_PROGRESS: 'IN_PROGRESS',
        DONE: 'DONE'
    };
    const $ad83cd0410dc011b$export$de194318c6dccbc1 = {
        INITIATIVE: 'INITIATIVE',
        EPIC: 'EPIC'
    };
    const $ad83cd0410dc011b$export$48808c686fe495c4 = {
        DELAY_WORK: 'DELAY_WORK',
        CRITICAL_PATH: 'CRITICAL_PATH',
        BLOCK_WORK: 'BLOCK_WORK'
    };
});
parcelRegister("63ju8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("8kWVn")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("83FIe")
    ]).then(()=>parcelRequire('3Wpua'));
});
parcelRegister("1RCb5", function(module, exports) {
    $parcel$export(module.exports, "arjTimelineEmbedRouteEntry", ()=>$08301ee8f84a61cf$export$a977d398db1904ff);
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $2G9Bk;
    var $1XrjK;
    var $c3WQb;
    var $2Ql51;
    var $bqNCs;
    var $5lsNZ;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $08301ee8f84a61cf$var$LazyPlanTimelineEmbed = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("q7sYD"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-timeline/index.tsx"
    });
    const $08301ee8f84a61cf$var$PlanTimelineEmbedPage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $08301ee8f84a61cf$var$LazyPlanTimelineEmbed,
            pageId: "plan-timeline-embed",
            shouldShowSpinner: true
        });
    const $08301ee8f84a61cf$export$a977d398db1904ff = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bqNCs")).softwarePlanTimelineEmbedRoute), ()=>({
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('smart_links_for_plans', $08301ee8f84a61cf$var$PlanTimelineEmbedPage, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)({
                isChromeless: true
            }),
            resources: [
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            forPaint: [
                $08301ee8f84a61cf$var$LazyPlanTimelineEmbed
            ]
        }));
});
parcelRegister("q7sYD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("6uHGD")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("29Kha")
    ]).then(()=>parcelRequire('iL9n8'));
});
parcelRegister("aZlet", function(module, exports) {
    $parcel$export(module.exports, "arjSettingsRouteEntries", ()=>$532fcc0d9c71be9f$export$87af7d91a16be1cf);
    var $3ZrJx;
    var $b1KWT;
    var $6PLMK;
    const $532fcc0d9c71be9f$export$87af7d91a16be1cf = [
        (0, (0, parcelRequire("3ZrJx")).arjSettingsDependenciesRouteEntry),
        (0, (0, parcelRequire("3ZrJx")).arjSettingsDependenciesLegacyRedirectRouteEntry),
        (0, (0, parcelRequire("b1KWT")).arjSettingsLoadingLimitsRouteEntry),
        (0, (0, parcelRequire("b1KWT")).arjSettingsLoadingLimitsLegacyRedirectRouteEntry),
        (0, (0, parcelRequire("6PLMK")).arjSettingsPermissionsRouteEntry),
        (0, (0, parcelRequire("6PLMK")).arjSettingsPermissionsRouteLegacyRedirectRouteEntry)
    ];
});
parcelRegister("3ZrJx", function(module, exports) {
    $parcel$export(module.exports, "arjSettingsDependenciesRouteEntry", ()=>$a09bf317e4b8989f$export$70386609aff5ba12);
    $parcel$export(module.exports, "arjSettingsDependenciesLegacyRedirectRouteEntry", ()=>$a09bf317e4b8989f$export$804f2d81dfbdd5c9);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3DNgf;
    var $3RJkv;
    var $2r2vQ;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $8C1Rj;
    const $a09bf317e4b8989f$export$4fcc3c0f6e792efc = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("ar2Tl"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/dependencies/index.tsx"
    });
    const $a09bf317e4b8989f$export$d6f045c7c1aaff50 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a09bf317e4b8989f$export$4fcc3c0f6e792efc,
            pageId: "arj-settings-dependencies",
            shouldShowSpinner: true
        });
    const $a09bf317e4b8989f$export$70386609aff5ba12 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2r2vQ")).softwareArjSettingsDependenciesRoute), ()=>({
            component: $a09bf317e4b8989f$export$d6f045c7c1aaff50,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("3DNgf")).issueLinkInformationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $a09bf317e4b8989f$export$4fcc3c0f6e792efc
            ]
        }));
    const $a09bf317e4b8989f$export$804f2d81dfbdd5c9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2r2vQ")).softwareArjSettingsDependenciesRedirectRoute), ()=>({
            component: (0, (0, parcelRequire("8C1Rj")).redirectTo)('/jira/plans/settings/dependencies'),
            isRedirect: true,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("3DNgf")).issueLinkInformationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $a09bf317e4b8989f$export$4fcc3c0f6e792efc
            ]
        }));
});
parcelRegister("2Fj5v", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a9ddf603830cf6c5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $hPtZI;
    const $a9ddf603830cf6c5$var$LazyGlobalProductsSettingsSidebar = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("5qELD")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/global-settings-products/src/index.tsx"
    });
    const $a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "globalProductsSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a9ddf603830cf6c5$var$LazyGlobalProductsSettingsSidebar, null)));
    $a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar.displayName = 'GlobalProductsSettingsSidebar';
    var $a9ddf603830cf6c5$export$2e2bcd8739ae039 = $a9ddf603830cf6c5$var$GlobalProductsSettingsSidebar;
});
parcelRegister("5qELD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("3FDyC")
    ]).then(()=>parcelRequire('hTSvC'));
});
parcelRegister("3DNgf", function(module, exports) {
    $parcel$export(module.exports, "issueLinkInformationResource", ()=>$8163e55c16e335dc$export$8d8544ca08d98837);
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $8163e55c16e335dc$var$body = {
        providers: [
            'issueLinks',
            'dependencySettings'
        ]
    };
    const $8163e55c16e335dc$var$url = '/rest/jpo/1.0/info/query';
    const $8163e55c16e335dc$var$fetchIssueLinkInformation = ()=>(0, (0, parcelRequire("eusud")).performPostRequest)($8163e55c16e335dc$var$url, {
            body: JSON.stringify($8163e55c16e335dc$var$body)
        });
    const $8163e55c16e335dc$export$8d8544ca08d98837 = (0, $dIdda.createResource)({
        type: 'ISSUE_LINK_INFORMATION',
        getKey: ()=>'issue-link-information',
        getData: async ()=>$8163e55c16e335dc$var$fetchIssueLinkInformation(),
        maxAge: 0
    });
});
parcelRegister("2r2vQ", function(module, exports) {
    $parcel$export(module.exports, "softwareArjSettingsDependenciesRoute", ()=>$9433f6efcfaf833c$export$e657c8aeaaf0932c);
    $parcel$export(module.exports, "softwareArjSettingsDependenciesRedirectRoute", ()=>$9433f6efcfaf833c$export$b55de156ac5f7c1b);
    $parcel$export(module.exports, "softwareArjSettingsLoadingLimitsRoute", ()=>$9433f6efcfaf833c$export$21eaa019c724fc9a);
    $parcel$export(module.exports, "softwareArjSettingsLoadingLimitsRedirectRoute", ()=>$9433f6efcfaf833c$export$c72a1b9971af07d9);
    $parcel$export(module.exports, "softwareArjSettingsPermissionsRoute", ()=>$9433f6efcfaf833c$export$6372897c47d731c0);
    $parcel$export(module.exports, "softwareArjSettingsPermissionsRedirectRoute", ()=>$9433f6efcfaf833c$export$4523847db2f1a42e);
    var $65Ltd;
    const $9433f6efcfaf833c$export$e657c8aeaaf0932c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES),
        path: '/jira/plans/settings/dependencies'
    };
    const $9433f6efcfaf833c$export$b55de156ac5f7c1b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_DEPENDENCIES_REDIRECT),
        path: '/secure/PortfolioDependencySettings.jspa'
    };
    const $9433f6efcfaf833c$export$21eaa019c724fc9a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS),
        path: '/jira/plans/settings/loading-limits'
    };
    const $9433f6efcfaf833c$export$c72a1b9971af07d9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_LOADING_LIMITS_REDIRECT),
        path: '/secure/PortfolioLoadingLimits.jspa'
    };
    const $9433f6efcfaf833c$export$6372897c47d731c0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS),
        path: '/jira/plans/settings/permissions'
    };
    const $9433f6efcfaf833c$export$4523847db2f1a42e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_PERMISSIONS_REDIRECT),
        path: '/secure/PortfolioPermissions.jspa'
    };
});
parcelRegister("8C1Rj", function(module, exports) {
    $parcel$export(module.exports, "redirectTo", ()=>$7016c06d4eae395e$export$2d47ce6f15e624e5);
    var $5uXOq = parcelRequire("5uXOq");
    var $7OYJs;
    const $7016c06d4eae395e$export$9090339aecaa99f2 = (CurrentComponent, redirectUrl, redirectCondition)=>()=>{
            if (redirectCondition()) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                to: redirectUrl
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement(CurrentComponent, null);
        };
    const $7016c06d4eae395e$export$2d47ce6f15e624e5 = (redirectUrl)=>()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                to: redirectUrl
            });
});
parcelRegister("ar2Tl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("bLzp5")
    ]).then(()=>parcelRequire('1Ba8D'));
});
parcelRegister("b1KWT", function(module, exports) {
    $parcel$export(module.exports, "arjSettingsLoadingLimitsRouteEntry", ()=>$7f2d172c3e4cc656$export$6786257309f86d8c);
    $parcel$export(module.exports, "arjSettingsLoadingLimitsLegacyRedirectRouteEntry", ()=>$7f2d172c3e4cc656$export$9f80102c0f64ad9b);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $azWKH;
    var $3RJkv;
    var $2r2vQ;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $8C1Rj;
    const $7f2d172c3e4cc656$export$64761ea1912fdcd9 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fvcVN"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/loading-limits/index.tsx"
    });
    const $7f2d172c3e4cc656$export$7bb4c0f22b467385 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7f2d172c3e4cc656$export$64761ea1912fdcd9,
            pageId: "arj-settings-loading-limits",
            shouldShowSpinner: true
        });
    const $7f2d172c3e4cc656$export$6786257309f86d8c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2r2vQ")).softwareArjSettingsLoadingLimitsRoute), ()=>({
            component: $7f2d172c3e4cc656$export$7bb4c0f22b467385,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("azWKH")).arjSettingsLoadingLimitsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $7f2d172c3e4cc656$export$64761ea1912fdcd9
            ]
        }));
    const $7f2d172c3e4cc656$export$9f80102c0f64ad9b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2r2vQ")).softwareArjSettingsLoadingLimitsRedirectRoute), ()=>({
            component: (0, (0, parcelRequire("8C1Rj")).redirectTo)('/jira/plans/settings/loading-limits'),
            isRedirect: true,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $7f2d172c3e4cc656$export$64761ea1912fdcd9
            ]
        }));
});
parcelRegister("azWKH", function(module, exports) {
    $parcel$export(module.exports, "arjSettingsLoadingLimitsResource", ()=>$a9399ce8867d02dc$export$c9e47fa9b57975f5);
    var $7f4tk;
    var $dIdda = parcelRequire("dIdda");
    const $a9399ce8867d02dc$export$c9e47fa9b57975f5 = (0, $dIdda.createResource)({
        type: (0, $a9d74ae4a12ce55b$export$cd7bb91dd2e30684),
        getKey: ()=>'loading-limits-information',
        getData: async ()=>(0, (0, parcelRequire("7f4tk")).default)('/rest/jpo/1.0/configuration'),
        maxAge: 0
    });
});
const $a9d74ae4a12ce55b$export$cd7bb91dd2e30684 = 'RESOURCE_TYPE_ARJ_SETTINGS_LOADING_LIMITS';
parcelRegister("fvcVN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("7EBJU")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("bDZ6z")
    ]).then(()=>parcelRequire('ieFCi'));
});
parcelRegister("6PLMK", function(module, exports) {
    $parcel$export(module.exports, "arjSettingsPermissionsRouteEntry", ()=>$ea6e9e2621e05a7f$export$4e97658a5cc15eaa);
    $parcel$export(module.exports, "arjSettingsPermissionsRouteLegacyRedirectRouteEntry", ()=>$ea6e9e2621e05a7f$export$949c8177281fcc39);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $1aR84;
    var $3RJkv;
    var $2r2vQ;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $8C1Rj;
    const $ea6e9e2621e05a7f$export$edb4ae7e85c7908d = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("julIg"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/permissions/index.tsx"
    });
    const $ea6e9e2621e05a7f$export$fa852ea42b98d3de = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ea6e9e2621e05a7f$export$edb4ae7e85c7908d,
            pageId: "arj-settings-permissions",
            shouldShowSpinner: true
        });
    const $ea6e9e2621e05a7f$export$4e97658a5cc15eaa = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2r2vQ")).softwareArjSettingsPermissionsRoute), ()=>({
            component: $ea6e9e2621e05a7f$export$fa852ea42b98d3de,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("1aR84")).getGlobalPermissionPageResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $ea6e9e2621e05a7f$export$edb4ae7e85c7908d
            ]
        }));
    const $ea6e9e2621e05a7f$export$949c8177281fcc39 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2r2vQ")).softwareArjSettingsPermissionsRedirectRoute), ()=>({
            component: (0, (0, parcelRequire("8C1Rj")).redirectTo)('/jira/plans/settings/permissions'),
            isRedirect: true,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("1aR84")).getGlobalPermissionPageResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $ea6e9e2621e05a7f$export$edb4ae7e85c7908d
            ]
        }));
});
parcelRegister("1aR84", function(module, exports) {
    $parcel$export(module.exports, "grantedPermissionsResource", ()=>$d675e556a71c706a$export$aa3daf3280e2a2d7);
    $parcel$export(module.exports, "permissionGroupsResource", ()=>$d675e556a71c706a$export$950060d83722e3bd);
    $parcel$export(module.exports, "getGlobalPermissionPageResources", ()=>$d675e556a71c706a$export$a09a91246a866817);
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $d675e556a71c706a$var$fetchGrantedPermissions = ()=>(0, (0, parcelRequire("eusud")).performPostRequest)('/rest/roadmaps/1.0/info/query', {
            body: JSON.stringify({
                providers: [
                    'permissions'
                ]
            })
        });
    const $d675e556a71c706a$var$fetchPermissionGroups = ()=>(0, (0, parcelRequire("eusud")).performPostRequest)('/rest/jpo/1.0/groupsandusers', {
            body: JSON.stringify({
                includeUsers: false,
                excludedGroups: [],
                excludedUsers: [],
                query: ''
            })
        });
    const $d675e556a71c706a$export$aa3daf3280e2a2d7 = (0, $dIdda.createResource)({
        type: 'ARJ_GLOBAL_PERMISSIONS_GRANTED',
        getKey: ()=>'arj-granted-permissions',
        getData: async ()=>$d675e556a71c706a$var$fetchGrantedPermissions(),
        maxAge: 0
    });
    const $d675e556a71c706a$export$950060d83722e3bd = (0, $dIdda.createResource)({
        type: 'ARJ_GLOBAL_PERMISSIONS_GROUPS',
        getKey: ()=>'arj-permission-groups',
        getData: async ()=>$d675e556a71c706a$var$fetchPermissionGroups(),
        maxAge: 0
    });
    const $d675e556a71c706a$export$a09a91246a866817 = ()=>[
            $d675e556a71c706a$export$aa3daf3280e2a2d7,
            $d675e556a71c706a$export$950060d83722e3bd
        ];
});
parcelRegister("julIg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("31VzL")
    ]).then(()=>parcelRequire('luimD'));
});
parcelRegister("eGTiK", function(module, exports) {
    $parcel$export(module.exports, "planIncrementsRouteEntry", ()=>$ed91b1902c212dd9$export$f7abc47036ff7dd9);
    $parcel$export(module.exports, "planIncrementRouteEntry", ()=>$ed91b1902c212dd9$export$a26fa5cabff8bc7c);
    $parcel$export(module.exports, "archivedPlansRouteEntry", ()=>$ed91b1902c212dd9$export$b9921058a8a65710);
    $parcel$export(module.exports, "trashPlansRouteEntry", ()=>$ed91b1902c212dd9$export$eabcbe4dd6fc9f1f);
    $parcel$export(module.exports, "trashedPlanDirectLinkRouteEntry", ()=>$ed91b1902c212dd9$export$dbcd0bd16f12397d);
    $parcel$export(module.exports, "arjSettingsFinancialYearPageEntry", ()=>$ed91b1902c212dd9$export$3907721420f39680);
    var $ffza4;
    var $2BrOV;
    var $ibkIl;
    var $8iyFV;
    var $lmyls;
    var $2Fj5v;
    var $937TY;
    var $451ix;
    var $2G9Bk;
    var $1XrjK;
    var $c3WQb;
    var $7j3uW;
    var $3RJkv;
    var $atU1t;
    var $4zCFt;
    var $h623d;
    var $lPefb;
    var $lGAHy;
    var $f74J4;
    var $jz1vo;
    var $guVc5;
    const $ed91b1902c212dd9$export$f7abc47036ff7dd9 = (0, (0, parcelRequire("2G9Bk")).createEntry)({
        ...(0, (0, parcelRequire("4zCFt")).planIncrementsRoute),
        exact: true
    }, ()=>({
            component: (0, (0, parcelRequire("lGAHy")).PlanProgram),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("451ix")).planLayout)),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default),
                horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                onlyShowHorizontalOnNav4: true
            },
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsLastVisitedProgramBoardIdResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("lGAHy")).LazyPlanProgram)
            ]
        }));
    const $ed91b1902c212dd9$export$a26fa5cabff8bc7c = (0, (0, parcelRequire("2G9Bk")).createEntry)({
        ...(0, (0, parcelRequire("4zCFt")).planIncrementRoute),
        exact: true
    }, ()=>({
            component: (0, (0, parcelRequire("lPefb")).PlanIncrement),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("451ix")).planLayout)),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS,
                sidebar: (0, (0, parcelRequire("937TY")).default),
                horizontal: (0, (0, parcelRequire("8iyFV")).AsyncHorizontalNavPlans),
                onlyShowHorizontalOnNav4: true
            },
            preloadOptions: {
                earlyChunks: [
                    'advanced-roadmaps-early-entry'
                ]
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarPlanResources)(),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsPlanPageInitialChecksResource),
                (0, (0, parcelRequire("c3WQb")).advancedRoadmapsReduxStoreStateResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("lPefb")).LazyPlanIncrement)
            ]
        }));
    const $ed91b1902c212dd9$export$b9921058a8a65710 = (0, (0, parcelRequire("2G9Bk")).createEntry)({
        ...(0, (0, parcelRequire("4zCFt")).archivedPlansRoute),
        exact: true
    }, ()=>({
            component: (0, (0, parcelRequire("h623d")).ArchivedPlansDirectory),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("h623d")).LazyArchivedPlans)
            ]
        }));
    const $ed91b1902c212dd9$export$eabcbe4dd6fc9f1f = (0, (0, parcelRequire("2G9Bk")).createEntry)({
        ...(0, (0, parcelRequire("4zCFt")).trashedPlansRoute),
        exact: true
    }, ()=>({
            component: (0, (0, parcelRequire("f74J4")).TrashedPlansDirectory),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("f74J4")).LazyTrashedPlans)
            ]
        }));
    const $ed91b1902c212dd9$export$dbcd0bd16f12397d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4zCFt")).trashedPlanDirectLinkRoute), ()=>({
            component: (0, (0, parcelRequire("guVc5")).TrashedPlanDirectLink),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("guVc5")).LazyTrashedPlanDirectLink)
            ],
            ufoName: 'plan-trashed'
        }));
    const $ed91b1902c212dd9$export$3907721420f39680 = (0, (0, parcelRequire("2G9Bk")).createEntry)({
        ...(0, (0, parcelRequire("4zCFt")).arjSettingsFinancialYearPageRoute),
        exact: true
    }, ()=>({
            component: (0, (0, parcelRequire("jz1vo")).ArjSettingsFinancialYear),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("7j3uW")).arjSettingsFinancialYearResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("jz1vo")).LazyArjSettingsFinancialYear)
            ]
        }));
});
parcelRegister("7j3uW", function(module, exports) {
    $parcel$export(module.exports, "arjSettingsFinancialYearResource", ()=>$59a235170c0d382a$export$da45020eede4a793);
    var $7f4tk;
    var $dIdda = parcelRequire("dIdda");
    const $59a235170c0d382a$export$da45020eede4a793 = (0, $dIdda.createResource)({
        type: (0, $b242b5aa0787944c$export$e8e0384e95388aa3),
        getKey: ()=>'financial-year-information',
        getData: async ()=>(0, (0, parcelRequire("7f4tk")).default)('/rest/jpo/1.0/fiscalYear'),
        maxAge: 0
    });
});
const $b242b5aa0787944c$export$e8e0384e95388aa3 = 'RESOURCE_TYPE_ARJ_SETTINGS_FINANCIAL_YEAR';
parcelRegister("4zCFt", function(module, exports) {
    $parcel$export(module.exports, "planIncrementsRoute", ()=>$e7d023757e398cfb$export$d0986e4bd9568b30);
    $parcel$export(module.exports, "planIncrementRoute", ()=>$e7d023757e398cfb$export$ef33a75556fde209);
    $parcel$export(module.exports, "archivedPlansRoute", ()=>$e7d023757e398cfb$export$29647353386ad146);
    $parcel$export(module.exports, "trashedPlansRoute", ()=>$e7d023757e398cfb$export$b1d2299a57fca83a);
    $parcel$export(module.exports, "trashedPlanDirectLinkRoute", ()=>$e7d023757e398cfb$export$1a9edb72cd49ca79);
    $parcel$export(module.exports, "arjSettingsFinancialYearPageRoute", ()=>$e7d023757e398cfb$export$7208300f00a36a5f);
    var $65Ltd;
    const $e7d023757e398cfb$export$d0986e4bd9568b30 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_INCREMENTS),
        path: '/jira/plans/:planId/scenarios/:scenarioId/program'
    };
    const $e7d023757e398cfb$export$ef33a75556fde209 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PLAN_INCREMENT),
        path: '/jira/plans/:planId/scenarios/:scenarioId/program/:incrementId'
    };
    const $e7d023757e398cfb$export$29647353386ad146 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_PLANS_DIRECTORY),
        path: '/jira/plans/settings/archive'
    };
    const $e7d023757e398cfb$export$b1d2299a57fca83a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_TRASH_PLANS_DIRECTORY),
        path: '/jira/plans/settings/trash'
    };
    const $e7d023757e398cfb$export$1a9edb72cd49ca79 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_TRASHED_PLAN_DIRECT_LINK),
        path: '/jira/plans/plan-trashed',
        exact: true
    };
    const $e7d023757e398cfb$export$7208300f00a36a5f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ARJ_SETTINGS_FINANCIAL_YEAR),
        path: '/jira/plans/settings/financial-year'
    };
});
parcelRegister("h623d", function(module, exports) {
    $parcel$export(module.exports, "LazyArchivedPlans", ()=>$e7e5083407abf400$export$cf676f47aba10db8);
    $parcel$export(module.exports, "ArchivedPlansDirectory", ()=>$e7e5083407abf400$export$ed59bbc59461c00f);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $e7e5083407abf400$export$cf676f47aba10db8 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3YFhg")).then((module)=>module.ArchivedPlans)), {
        moduleId: "./src/packages/spa-apps/admin-pages/archived-plans/src/index.tsx"
    });
    const $e7e5083407abf400$export$ed59bbc59461c00f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e7e5083407abf400$export$cf676f47aba10db8,
            pageId: "archived-plans",
            shouldShowSpinner: true
        });
});
parcelRegister("3YFhg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("19M8q")
    ]).then(()=>parcelRequire('14EEk'));
});
parcelRegister("lPefb", function(module, exports) {
    $parcel$export(module.exports, "LazyPlanIncrement", ()=>$4804ee23833a4e07$export$e7b9f83d442bac51);
    $parcel$export(module.exports, "PlanIncrement", ()=>$4804ee23833a4e07$export$5e1035d0876d64db);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $4804ee23833a4e07$export$e7b9f83d442bac51 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("35mct"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-increment/index.tsx"
    });
    const $4804ee23833a4e07$export$5e1035d0876d64db = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4804ee23833a4e07$export$e7b9f83d442bac51,
            pageId: "plan-increment",
            shouldShowSpinner: true
        });
});
parcelRegister("lGAHy", function(module, exports) {
    $parcel$export(module.exports, "LazyPlanProgram", ()=>$5ac0bb7d9b3f8806$export$9da4d4d5c4d7f749);
    $parcel$export(module.exports, "PlanProgram", ()=>$5ac0bb7d9b3f8806$export$fb30c2b19a4f5d59);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $5ac0bb7d9b3f8806$export$9da4d4d5c4d7f749 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4JKpA"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-program/index.tsx"
    });
    const $5ac0bb7d9b3f8806$export$fb30c2b19a4f5d59 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5ac0bb7d9b3f8806$export$9da4d4d5c4d7f749,
            pageId: "plan-program",
            shouldShowSpinner: true
        });
});
parcelRegister("4JKpA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("64R0p")),
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8elb9")
    ]).then(()=>parcelRequire('laRNy'));
});
parcelRegister("f74J4", function(module, exports) {
    $parcel$export(module.exports, "LazyTrashedPlans", ()=>$c48e9f8af231216f$export$6ac18b311b7e51a1);
    $parcel$export(module.exports, "TrashedPlansDirectory", ()=>$c48e9f8af231216f$export$b145fa65818ff157);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $c48e9f8af231216f$export$6ac18b311b7e51a1 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9LXXc")).then((module)=>module.TrashedPlans)), {
        moduleId: "./src/packages/spa-apps/admin-pages/trashed-plans/src/index.tsx"
    });
    const $c48e9f8af231216f$export$b145fa65818ff157 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c48e9f8af231216f$export$6ac18b311b7e51a1,
            pageId: "trashed-plans",
            shouldShowSpinner: true
        });
});
parcelRegister("9LXXc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("573g9")
    ]).then(()=>parcelRequire('95BjK'));
});
parcelRegister("jz1vo", function(module, exports) {
    $parcel$export(module.exports, "LazyArjSettingsFinancialYear", ()=>$21915a74b5053cfc$export$dd67c2f01a58231e);
    $parcel$export(module.exports, "ArjSettingsFinancialYear", ()=>$21915a74b5053cfc$export$785180185eba7ed9);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $21915a74b5053cfc$export$dd67c2f01a58231e = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("hf3HX")).then((module)=>module.ArjSettingsFinancialYear)), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/settings/financial-year/index.tsx"
    });
    const $21915a74b5053cfc$export$785180185eba7ed9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $21915a74b5053cfc$export$dd67c2f01a58231e,
            pageId: "arj-settings-financial-year",
            shouldShowSpinner: true
        });
});
parcelRegister("hf3HX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hCaEC")
    ]).then(()=>parcelRequire('7bDNN'));
});
parcelRegister("guVc5", function(module, exports) {
    $parcel$export(module.exports, "LazyTrashedPlanDirectLink", ()=>$50323c608fe813f4$export$20a71ac28e6a3c8f);
    $parcel$export(module.exports, "TrashedPlanDirectLink", ()=>$50323c608fe813f4$export$38f3a061bb1fceee);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $50323c608fe813f4$export$20a71ac28e6a3c8f = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1VgiI"))), {
        moduleId: "./src/packages/portfolio-3/plan-trashed-direct-link/src/index.tsx"
    });
    const $50323c608fe813f4$export$38f3a061bb1fceee = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $50323c608fe813f4$export$20a71ac28e6a3c8f,
            pageId: "trashed-plan-direct-link",
            shouldShowSpinner: false
        });
});
parcelRegister("1VgiI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1U1DX").then(()=>parcelRequire('kIqMQ'));
});
parcelRegister("2CDtd", function(module, exports) {
    $parcel$export(module.exports, "LazyPlanCalendar", ()=>$1e2a2395fa471a5f$export$3b1de511e34cdb8f);
    $parcel$export(module.exports, "default", ()=>$1e2a2395fa471a5f$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "planCalendarRouteEntry", ()=>$1e2a2395fa471a5f$export$21806ebf23f23060);
    var $5uXOq = parcelRequire("5uXOq");
    var $lkFvK;
    var $lmyls;
    var $02tNK;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $1e2a2395fa471a5f$export$3b1de511e34cdb8f = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5wS2n"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-calendar/index.tsx"
    });
    var $1e2a2395fa471a5f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1e2a2395fa471a5f$export$3b1de511e34cdb8f,
            pageId: "plan-calendar",
            shouldShowSpinner: true
        });
    const $1e2a2395fa471a5f$export$21806ebf23f23060 = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("02tNK")).calendarEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
    });
});
parcelRegister("5ZrwA", function(module, exports) {
    $parcel$export(module.exports, "LazyPlanDependenciesReport", ()=>$e16ddd24f9c31932$export$d4669c7a2f17c261);
    $parcel$export(module.exports, "default", ()=>$e16ddd24f9c31932$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $e16ddd24f9c31932$export$d4669c7a2f17c261 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fQisF"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-dependencies-report/index.tsx"
    });
    var $e16ddd24f9c31932$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e16ddd24f9c31932$export$d4669c7a2f17c261,
            pageId: "plan-dependencies-report",
            shouldShowSpinner: true
        });
});
parcelRegister("a0VYb", function(module, exports) {
    $parcel$export(module.exports, "LazyAdvancedRoadmapsPlanExport", ()=>$20c3b3923b6e567f$export$890fb5003e472449);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $20c3b3923b6e567f$export$890fb5003e472449 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5WOuA"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/index.tsx"
    });
    var $20c3b3923b6e567f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $20c3b3923b6e567f$export$890fb5003e472449,
            pageId: "advanced-roadmaps-plan",
            shouldShowSpinner: true
        });
});
parcelRegister("5WOuA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("ioM1b")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("LIqdo")
    ]).then(()=>parcelRequire('ecw8s'));
});
parcelRegister("aY4MJ", function(module, exports) {
    $parcel$export(module.exports, "LazyPlanReleases", ()=>$5e5a763517beeba1$export$749f5d2513e04ec0);
    $parcel$export(module.exports, "default", ()=>$5e5a763517beeba1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $5e5a763517beeba1$export$749f5d2513e04ec0 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2n942"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-releases/index.tsx"
    });
    var $5e5a763517beeba1$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5e5a763517beeba1$export$749f5d2513e04ec0,
            pageId: "plan-releases",
            shouldShowSpinner: true
        });
});
parcelRegister("2n942", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("auj8r")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("aEaZR")
    ]).then(()=>parcelRequire('1rmO9'));
});
parcelRegister("kJhPn", function(module, exports) {
    $parcel$export(module.exports, "LazyPlanReport", ()=>$14dca1083be77753$export$fe1fc08f511671db);
    $parcel$export(module.exports, "default", ()=>$14dca1083be77753$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $14dca1083be77753$export$fe1fc08f511671db = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lBp9O"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-report/index.tsx"
    });
    const $14dca1083be77753$var$PlanReport = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $14dca1083be77753$export$fe1fc08f511671db,
            pageId: "plan-report",
            shouldShowSpinner: true
        });
    var $14dca1083be77753$export$2e2bcd8739ae039 = $14dca1083be77753$var$PlanReport;
});
parcelRegister("lBp9O", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("gWdbV")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gF51l")
    ]).then(()=>parcelRequire('9UXSF'));
});
parcelRegister("1TUUd", function(module, exports) {
    $parcel$export(module.exports, "LazyPlanSettingsAutoScheduler", ()=>$f06db73ae321846e$export$8bcf7155849993f5);
    $parcel$export(module.exports, "default", ()=>$f06db73ae321846e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $f06db73ae321846e$export$8bcf7155849993f5 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2cXwo"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/auto-scheduler/index.tsx"
    });
    var $f06db73ae321846e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f06db73ae321846e$export$8bcf7155849993f5,
            pageId: "plan-settings-auto-scheduler",
            shouldShowSpinner: true
        });
});
parcelRegister("2cXwo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("5TMh3")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kssvB")
    ]).then(()=>parcelRequire('9U7wJ'));
});
parcelRegister("g4RX2", function(module, exports) {
    $parcel$export(module.exports, "LazyPlanSettingsCustomFields", ()=>$cdb52e9fe771d0f2$export$72bf44dbae2383e5);
    $parcel$export(module.exports, "default", ()=>$cdb52e9fe771d0f2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $cdb52e9fe771d0f2$export$72bf44dbae2383e5 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("cVT1A"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/custom-fields/index.tsx"
    });
    var $cdb52e9fe771d0f2$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cdb52e9fe771d0f2$export$72bf44dbae2383e5,
            pageId: "plan-settings-custom-fields",
            shouldShowSpinner: true
        });
});
parcelRegister("cVT1A", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("4NK3n")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("1osJI")
    ]).then(()=>parcelRequire('j09X0'));
});
parcelRegister("5A9fc", function(module, exports) {
    $parcel$export(module.exports, "LazyPlanSettingsExclusionRules", ()=>$db26989c73cd561c$export$78f61b03c267e6d9);
    $parcel$export(module.exports, "default", ()=>$db26989c73cd561c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $db26989c73cd561c$export$78f61b03c267e6d9 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("b5b81"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/exclusion-rules/index.tsx"
    });
    var $db26989c73cd561c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $db26989c73cd561c$export$78f61b03c267e6d9,
            pageId: "plan-settings-exclusion-rules",
            shouldShowSpinner: true
        });
});
parcelRegister("b5b81", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("krPFv")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("cQMR4")
    ]).then(()=>parcelRequire('8InOA'));
});
parcelRegister("3IiyK", function(module, exports) {
    $parcel$export(module.exports, "LazyPlanSettingsFindYourIssue", ()=>$ff7a36b49c810ac0$export$731998664b7d5e72);
    $parcel$export(module.exports, "default", ()=>$ff7a36b49c810ac0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $ff7a36b49c810ac0$export$731998664b7d5e72 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("hy8Qs"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/find-your-issue/index.tsx"
    });
    var $ff7a36b49c810ac0$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ff7a36b49c810ac0$export$731998664b7d5e72,
            pageId: "plan-settings-find-your-issue",
            shouldShowSpinner: true
        });
});
parcelRegister("hy8Qs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("jGDgV")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("fi5lj")
    ]).then(()=>parcelRequire('ZLjUl'));
});
parcelRegister("dF9Tz", function(module, exports) {
    $parcel$export(module.exports, "LazyPlanSettingsIssueSources", ()=>$1d1d6be6d81acd4b$export$7ba4b487efcedeb3);
    $parcel$export(module.exports, "default", ()=>$1d1d6be6d81acd4b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $1d1d6be6d81acd4b$export$7ba4b487efcedeb3 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4A9Do"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/issue-sources/index.tsx"
    });
    var $1d1d6be6d81acd4b$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1d1d6be6d81acd4b$export$7ba4b487efcedeb3,
            pageId: "plan-settings-issue-sources",
            shouldShowSpinner: true
        });
});
parcelRegister("4A9Do", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("h4JBs")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("9lRZr")
    ]).then(()=>parcelRequire('1GCm8'));
});
parcelRegister("f9NlF", function(module, exports) {
    $parcel$export(module.exports, "LazyPlanSettingsPermissions", ()=>$abf4c3b40edd7499$export$49f5b76ad5c06a42);
    $parcel$export(module.exports, "default", ()=>$abf4c3b40edd7499$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $abf4c3b40edd7499$export$49f5b76ad5c06a42 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("elgx3"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/permissions/index.tsx"
    });
    var $abf4c3b40edd7499$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $abf4c3b40edd7499$export$49f5b76ad5c06a42,
            pageId: "plan-settings-permissions",
            shouldShowSpinner: true
        });
});
parcelRegister("elgx3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("cSV9k")),
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fHQhR")
    ]).then(()=>parcelRequire('dx76p'));
});
parcelRegister("hX07x", function(module, exports) {
    $parcel$export(module.exports, "LazyPlanSettingsPlanInfo", ()=>$bfaea286a7dfd22d$export$c1344fd7d24991b3);
    $parcel$export(module.exports, "default", ()=>$bfaea286a7dfd22d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $bfaea286a7dfd22d$export$c1344fd7d24991b3 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("El4ba"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/plan-info/index.tsx"
    });
    var $bfaea286a7dfd22d$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $bfaea286a7dfd22d$export$c1344fd7d24991b3,
            pageId: "plan-settings-plan-info",
            shouldShowSpinner: true
        });
});
parcelRegister("El4ba", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("deC5G")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("8REMF")
    ]).then(()=>parcelRequire('8aOgd'));
});
parcelRegister("4mz8X", function(module, exports) {
    $parcel$export(module.exports, "LazyPlanSettingsProgramBoards", ()=>$4e98f7bb80f47578$export$ffdec728a47c437c);
    $parcel$export(module.exports, "default", ()=>$4e98f7bb80f47578$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $4e98f7bb80f47578$export$ffdec728a47c437c = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("i7FRg"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/program-boards/index.tsx"
    });
    var $4e98f7bb80f47578$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4e98f7bb80f47578$export$ffdec728a47c437c,
            pageId: "plan-settings-program-boards",
            shouldShowSpinner: true
        });
});
parcelRegister("i7FRg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("1QmTP")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6qkFP")
    ]).then(()=>parcelRequire('cckoo'));
});
parcelRegister("aEJq5", function(module, exports) {
    $parcel$export(module.exports, "LazyPlanSettingsRemovedIssues", ()=>$231dc95095132627$export$759df6301ec72119);
    $parcel$export(module.exports, "default", ()=>$231dc95095132627$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $231dc95095132627$export$759df6301ec72119 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3Wjz9"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/removed-issues/index.tsx"
    });
    var $231dc95095132627$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $231dc95095132627$export$759df6301ec72119,
            pageId: "plan-settings-removed-issues",
            shouldShowSpinner: true
        });
});
parcelRegister("3Wjz9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("4f2RV")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("5hVzx")
    ]).then(()=>parcelRequire('mRA5P'));
});
parcelRegister("3qEAW", function(module, exports) {
    $parcel$export(module.exports, "LazyPlanSettingsSavedViews", ()=>$c9d9875bc1407d2f$export$a5398542699d356a);
    $parcel$export(module.exports, "default", ()=>$c9d9875bc1407d2f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $c9d9875bc1407d2f$export$a5398542699d356a = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("vcVXi"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/saved-views/index.tsx"
    });
    var $c9d9875bc1407d2f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c9d9875bc1407d2f$export$a5398542699d356a,
            pageId: "plan-settings-saved-views",
            shouldShowSpinner: true
        });
});
parcelRegister("vcVXi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("4IywT")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("81iXg")
    ]).then(()=>parcelRequire('k5TsF'));
});
parcelRegister("8ONdR", function(module, exports) {
    $parcel$export(module.exports, "LazyPlanSettingsScenarios", ()=>$c099a15373f1563d$export$94104fcc1a6f460f);
    $parcel$export(module.exports, "default", ()=>$c099a15373f1563d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $c099a15373f1563d$export$94104fcc1a6f460f = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("jxqka"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/scenarios/index.tsx"
    });
    var $c099a15373f1563d$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c099a15373f1563d$export$94104fcc1a6f460f,
            pageId: "plan-settings-scenarios",
            shouldShowSpinner: true
        });
});
parcelRegister("jxqka", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("a8N0m")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("dZydx")
    ]).then(()=>parcelRequire('iF2yt'));
});
parcelRegister("lisCo", function(module, exports) {
    $parcel$export(module.exports, "LazyPlanSettingsScheduling", ()=>$185b06a78613502e$export$3bf11db1bbeae73e);
    $parcel$export(module.exports, "default", ()=>$185b06a78613502e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $185b06a78613502e$export$3bf11db1bbeae73e = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1yuH3"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-settings/scheduling/index.tsx"
    });
    var $185b06a78613502e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $185b06a78613502e$export$3bf11db1bbeae73e,
            pageId: "plan-settings-scheduling",
            shouldShowSpinner: true
        });
});
parcelRegister("1yuH3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("5gjrg")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("X6lWy")
    ]).then(()=>parcelRequire('j3U5Q'));
});
parcelRegister("4chOZ", function(module, exports) {
    $parcel$export(module.exports, "LazyPlanSummary", ()=>$46ebe5f117724405$export$c717f0d9d7f11b49);
    $parcel$export(module.exports, "default", ()=>$46ebe5f117724405$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $46ebe5f117724405$export$c717f0d9d7f11b49 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("63ju8"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-summary/index.tsx"
    });
    var $46ebe5f117724405$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $46ebe5f117724405$export$c717f0d9d7f11b49,
            pageId: "plan-summary",
            shouldShowSpinner: true
        });
});
parcelRegister("lLICt", function(module, exports) {
    $parcel$export(module.exports, "LazyPlanTeams", ()=>$25408c0bafe37967$export$f85952f98f28fed0);
    $parcel$export(module.exports, "default", ()=>$25408c0bafe37967$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $25408c0bafe37967$export$f85952f98f28fed0 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("7z32m"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-teams/index.tsx"
    });
    var $25408c0bafe37967$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $25408c0bafe37967$export$f85952f98f28fed0,
            pageId: "plan-teams",
            shouldShowSpinner: true
        });
});
parcelRegister("7z32m", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("g1QGP")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("itwp0")
    ]).then(()=>parcelRequire('j7IwW'));
});
parcelRegister("b28pv", function(module, exports) {
    $parcel$export(module.exports, "LazyPlanTimeline", ()=>$041228e5ad03e333$export$bf48e5f1529ddaeb);
    $parcel$export(module.exports, "default", ()=>$041228e5ad03e333$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $041228e5ad03e333$export$bf48e5f1529ddaeb = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("q7sYD"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/plan/src/ui/plan-timeline/index.tsx"
    });
    var $041228e5ad03e333$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $041228e5ad03e333$export$bf48e5f1529ddaeb,
            pageId: "plan-timeline",
            shouldShowSpinner: true
        });
});
parcelRegister("eQDYJ", function(module, exports) {
    $parcel$export(module.exports, "LazyAdvancedRoadmapsSetup", ()=>$3932c98213f58685$export$46bb3a1779d7815b);
    $parcel$export(module.exports, "default", ()=>$3932c98213f58685$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $3932c98213f58685$export$46bb3a1779d7815b = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("38bH9"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/advanced-roadmaps/setup/src/index.tsx"
    });
    var $3932c98213f58685$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3932c98213f58685$export$46bb3a1779d7815b,
            pageId: "advanced-roadmaps-setup",
            shouldShowSpinner: true
        });
});
parcelRegister("38bH9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("aRh7g")
    ]).then(()=>parcelRequire('bF4NR'));
});
parcelRegister("difX6", function(module, exports) {
    $parcel$export(module.exports, "withRedirection", ()=>$229a43442b588705$export$2c9e4550ef8bdea9);
    var $5uXOq = parcelRequire("5uXOq");
    var $7OYJs;
    var $dIdda = parcelRequire("dIdda");
    function $229a43442b588705$export$2c9e4550ef8bdea9(Component, { to: to, redirectCondition: redirectCondition }) {
        return ()=>{
            const [{ match: match }] = (0, $dIdda.useRouter)();
            if (match == null || match.params == null || match.params.planId == null || match.params.scenarioId == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                to: "/jira/plans"
            });
            if (!redirectCondition()) return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, null);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                to: `/jira/plans/${match.params.planId}/scenarios/${match.params.scenarioId}${to}`
            });
        };
    }
});
parcelRegister("1yKC4", function(module, exports) {
    $parcel$export(module.exports, "archivedProjectDirectLinkRouteEntry", ()=>$5ed731e7678da2da$export$45e68d450757a753);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $5TzjU;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $5ed731e7678da2da$export$bcbb38b3c86dba1f = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("aKeDz"))), {
        moduleId: "./src/packages/project-pages/project-archive/project-archived-direct-link/src/index.tsx"
    });
    const $5ed731e7678da2da$export$2e0968e4c0408481 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5ed731e7678da2da$export$bcbb38b3c86dba1f,
            pageId: "archived-project-direct-link",
            shouldShowSpinner: false
        });
    const $5ed731e7678da2da$export$45e68d450757a753 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5TzjU")).archivedProjectDirectLinkRoute), ()=>({
            component: $5ed731e7678da2da$export$2e0968e4c0408481,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $5ed731e7678da2da$export$bcbb38b3c86dba1f
            ],
            ufoName: 'project-archived'
        }));
});
parcelRegister("5TzjU", function(module, exports) {
    $parcel$export(module.exports, "archivedProjectDirectLinkRoute", ()=>$8c21a6752554eb0c$export$cd3fc26cf9f696e6);
    var $65Ltd;
    const $8c21a6752554eb0c$export$cd3fc26cf9f696e6 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_REDIRECTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_PROJECT_DIRECT_LINK),
        path: '/jira/errors/project-archived',
        exact: true
    };
});
parcelRegister("aKeDz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aLLse").then(()=>parcelRequire('hCnfn'));
});
parcelRegister("k4Mu2", function(module, exports) {
    $parcel$export(module.exports, "archivedProjectsDirectoryRouteEntry", ()=>$49dffa5818f3dec0$export$dc5f9e3c3931cc36);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $4jMkc;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $fNNHs;
    var $5I9ar;
    const $49dffa5818f3dec0$export$dc5f9e3c3931cc36 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fNNHs")).archivedProjectsDirectoryRoute), ()=>({
            component: (0, (0, parcelRequire("5I9ar")).default),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("4jMkc")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("5I9ar")).LazyArchivedProjectsAdmin)
            ],
            ufoName: 'admin.archived-projects'
        }));
});
parcelRegister("4jMkc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb7b1354cffbd527$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $hPtZI;
    const $bb7b1354cffbd527$var$LazyGlobalProjectsSettingsSidebar = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("2n134")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/global-settings-projects/src/index.tsx"
    });
    const $bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "globalProjectsSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($bb7b1354cffbd527$var$LazyGlobalProjectsSettingsSidebar, null)));
    $bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar.displayName = 'GlobalProjectsSettingsSidebar';
    var $bb7b1354cffbd527$export$2e2bcd8739ae039 = $bb7b1354cffbd527$var$GlobalProjectsSettingsSidebar;
});
parcelRegister("2n134", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("lhVk0")
    ]).then(()=>parcelRequire('1tunp'));
});
parcelRegister("fNNHs", function(module, exports) {
    $parcel$export(module.exports, "archivedProjectsDirectoryRoute", ()=>$8fcfc94cf4d76f81$export$b60634d0fa43f719);
    var $65Ltd;
    const $8fcfc94cf4d76f81$export$b60634d0fa43f719 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_PROJECTS_DIRECTORY),
        path: '/jira/settings/projects/archive',
        exact: true
    };
});
parcelRegister("5I9ar", function(module, exports) {
    $parcel$export(module.exports, "LazyArchivedProjectsAdmin", ()=>$7076addc4fa02bdc$export$b220ffb582ee39aa);
    $parcel$export(module.exports, "default", ()=>$7076addc4fa02bdc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $7076addc4fa02bdc$export$b220ffb582ee39aa = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("eoLhh"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/archived-projects/src/index.tsx"
    });
    var $7076addc4fa02bdc$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7076addc4fa02bdc$export$b220ffb582ee39aa,
            pageId: "archived-projects",
            shouldShowSpinner: true
        });
});
parcelRegister("eoLhh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8Dqf0")
    ]).then(()=>parcelRequire('jOclj'));
});
parcelRegister("1ZHmp", function(module, exports) {
    $parcel$export(module.exports, "archivedIssuesRedirectRouteEntry", ()=>$5e1b97c402b9e85a$export$f7d3667678a21360);
    $parcel$export(module.exports, "archivedIssuesRouteEntries", ()=>$5e1b97c402b9e85a$export$fdccb6efc62198e6);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $l71WK;
    var $9QpK7;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $dmKXV;
    var $koWFd;
    var $h0bZU;
    var $9s3j1;
    var $2G9Bk;
    var $1XrjK;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $kWhzP;
    var $5lsNZ;
    var $6Z2mh;
    var $5PD5h;
    var $e7bC3;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $5e1b97c402b9e85a$export$5cb97f431a00807d = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("b39Ju")).then(({ JiraIssuesArchive: JiraIssuesArchive })=>JiraIssuesArchive)), {
        moduleId: "./src/packages/spa-apps/archives/src/index.tsx"
    });
    const $5e1b97c402b9e85a$export$b8f3c7276fe36123 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5e1b97c402b9e85a$export$5cb97f431a00807d,
            pageId: "spa-apps/archives",
            shouldShowSpinner: true
        });
    const $5e1b97c402b9e85a$export$f7d3667678a21360 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kWhzP")).archivedIssuesRedirectRoute), ()=>({
            component: (0, (0, parcelRequire("9QpK7")).componentWithFF)('issues-archive-route_a4t84', $5e1b97c402b9e85a$export$b8f3c7276fe36123, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $5e1b97c402b9e85a$export$5cb97f431a00807d
            ]
        }));
    const $5e1b97c402b9e85a$var$getCommonProjectLayout = ()=>(0, (0, parcelRequire("1XrjK")).createLayout)((0, (0, parcelRequire("gyYxw")).genericProjectLayout));
    const $5e1b97c402b9e85a$export$fdccb6efc62198e6 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kWhzP")).archivedIssuesJswRoute), ()=>({
                component: (0, (0, parcelRequire("9QpK7")).componentWithFF)('issues-archive-route_a4t84', $5e1b97c402b9e85a$export$b8f3c7276fe36123, (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("1XrjK")).createLayout)((0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding)),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $5e1b97c402b9e85a$export$5cb97f431a00807d
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kWhzP")).archivedIssuesJswCompanyRoute), ()=>({
                component: (0, (0, parcelRequire("9QpK7")).componentWithFF)('issues-archive-route_a4t84', $5e1b97c402b9e85a$export$b8f3c7276fe36123, (0, (0, parcelRequire("5lsNZ")).default)),
                layout: $5e1b97c402b9e85a$var$getCommonProjectLayout(),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $5e1b97c402b9e85a$export$5cb97f431a00807d
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kWhzP")).archivedIssuesJsmRoute), ()=>({
                component: (0, (0, parcelRequire("9QpK7")).componentWithFF)('issues-archive-route_a4t84', $5e1b97c402b9e85a$export$b8f3c7276fe36123, (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $5e1b97c402b9e85a$export$5cb97f431a00807d
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kWhzP")).archivedIssuesJwmRoute), ()=>({
                component: (0, (0, parcelRequire("9QpK7")).componentWithFF)('issues-archive-route_a4t84', $5e1b97c402b9e85a$export$b8f3c7276fe36123, (0, (0, parcelRequire("5lsNZ")).default)),
                layout: $5e1b97c402b9e85a$var$getCommonProjectLayout(),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $5e1b97c402b9e85a$export$5cb97f431a00807d
                ]
            }))
    ];
});
parcelRegister("9QpK7", function(module, exports) {
    $parcel$export(module.exports, "componentWithFF", ()=>$4adaf4a620447263$export$377d327ec8da8be);
    var $co1wz;
    var $7XYc4;
    const $4adaf4a620447263$export$377d327ec8da8be = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)(featureFlagName), ComponentTrue, ComponentFalse);
});
parcelRegister("kWhzP", function(module, exports) {
    $parcel$export(module.exports, "archivedIssuesRedirectRoute", ()=>$c172348e4abef46c$export$1bfee70ca366d995);
    $parcel$export(module.exports, "archivedIssuesJswRoute", ()=>$c172348e4abef46c$export$15745ddd07707d60);
    $parcel$export(module.exports, "archivedIssuesJswCompanyRoute", ()=>$c172348e4abef46c$export$cd10ef5fdf01245b);
    $parcel$export(module.exports, "archivedIssuesJsmRoute", ()=>$c172348e4abef46c$export$1c7220e12a2118ce);
    $parcel$export(module.exports, "archivedIssuesJwmRoute", ()=>$c172348e4abef46c$export$4a6781d620bb402);
    var $65Ltd;
    const $c172348e4abef46c$export$1bfee70ca366d995 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ARCHIVE_ISSUES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY),
        path: '/jira/issues/archive',
        exact: true
    };
    const $c172348e4abef46c$export$15745ddd07707d60 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ARCHIVE_ISSUES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY),
        path: '/jira/software/projects/:projectKey/issues/archive',
        exact: true
    };
    const $c172348e4abef46c$export$cd10ef5fdf01245b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ARCHIVE_ISSUES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY),
        path: '/jira/software/c/projects/:projectKey/issues/archive',
        exact: true
    };
    const $c172348e4abef46c$export$1c7220e12a2118ce = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ARCHIVE_ISSUES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY),
        path: '/jira/servicedesk/projects/:projectKey/issues/archive',
        exact: true
    };
    const $c172348e4abef46c$export$4a6781d620bb402 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ARCHIVE_ISSUES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ARCHIVED_ISSUES_DIRECTORY),
        path: '/jira/core/projects/:projectKey/issues/archive',
        exact: true
    };
});
parcelRegister("b39Ju", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2y2gh")
    ]).then(()=>parcelRequire('f45ZV'));
});
parcelRegister("gDDbQ", function(module, exports) {
    $parcel$export(module.exports, "browseProjectRedirectRouteEntry", ()=>$5fa74d2477541baa$export$f9891419b34ab305);
    var $ffza4;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $1WlLE;
    var $lsCQw;
    var $7MCPm;
    const $5fa74d2477541baa$export$f9891419b34ab305 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lsCQw")).browseProjectRedirectRoute), ()=>({
            component: (0, (0, parcelRequire("7MCPm")).RedirectToLastVisitedProjectPage),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("1WlLE")).queuesNavigationItems),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
});
const $0c2b5b2aa81ed54b$export$9ab1d1d726b36319 = 'GENERIC_PROJECT_HORIZONTAL_NAV';
const $0c2b5b2aa81ed54b$export$712453ef44fd2eba = 'GENERIC_BUSINESS_TRANSITIONAL_PROJECT_HORIZONTAL_NAV';
parcelRegister("lsCQw", function(module, exports) {
    $parcel$export(module.exports, "browseProjectRedirectRoute", ()=>$8f408b6bf8b1e91d$export$f9cac37753487f39);
    var $65Ltd;
    const $8f408b6bf8b1e91d$export$f9cac37753487f39 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_REDIRECTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BROWSE_PROJECT_REDIRECT),
        path: '/browse/:projectKey([^-/]+)',
        exact: true,
        isRedirect: true
    };
});
parcelRegister("7MCPm", function(module, exports) {
    $parcel$export(module.exports, "RedirectToLastVisitedProjectPage", ()=>$4c121c4cc7d1faa6$export$86041af020f4c959);
    var $5uXOq = parcelRequire("5uXOq");
    var $hqxtv;
    const $4c121c4cc7d1faa6$export$86041af020f4c959 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hqxtv")).default), null);
});
parcelRegister("hqxtv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bda9d95137e1a17a$export$2e2bcd8739ae039);
    var $dIdda = parcelRequire("dIdda");
    var $aNBa3;
    var $bda9d95137e1a17a$export$2e2bcd8739ae039 = (0, $dIdda.withRouter)((0, (0, parcelRequire("aNBa3")).default));
});
parcelRegister("aNBa3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8d9c467899b3389b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $ebyGx = parcelRequire("ebyGx");
    var $le2LN;
    var $fDtbf;
    var $kUU4G;
    var $4Pf62;
    var $dJl1T;
    var $7f4tk;
    var $ebbSc;
    const $8d9c467899b3389b$var$buildEndpoint = (projectKey, initialRedirect)=>`/rest/internal/2/projectlandingpage/${projectKey}${initialRedirect ? '?initialRedirect=true' : ''}`;
    const $8d9c467899b3389b$var$allowListedSearchParams = [
        (0, $0592ef8772eedefd$export$29d3926e3d72cfb),
        (0, $0592ef8772eedefd$export$b3233b76460c1e7c)
    ];
    const $8d9c467899b3389b$var$redirectForAnonymousUser = (projectKey, history, startTime)=>{
        const destination = `/projects/${projectKey}/issues/?filter=allissues`;
        history.replace(destination);
        (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), 'History replace correctly triggered for anonymous user', {
            requestTime: (0, (0, parcelRequire("ebbSc")).getNow)() - startTime,
            destination: destination
        });
    };
    const $8d9c467899b3389b$export$c79af62ad7a1fe8a = (query)=>Object.fromEntries(Object.entries(query).filter(([key])=>$8d9c467899b3389b$var$allowListedSearchParams.some((allowedParam)=>key === allowedParam) || key.includes((0, $0592ef8772eedefd$export$29d3926e3d72cfb))));
    const $8d9c467899b3389b$export$283f1587d7a5369f = (searchQuery, queryInitializer)=>{
        const queryKeys = new URLSearchParams(searchQuery).toString();
        return queryKeys.length > 0 ? `${queryInitializer}${queryKeys}` : '';
    };
    class $8d9c467899b3389b$export$bf8d1fdc3b47a835 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { history: history, location: location, query: query, match: { params: params } } = this.props;
            const { initial: initial } = query;
            (0, (0, parcelRequire("kUU4G")).default)((0, (0, parcelRequire("fDtbf")).SPA_SSR_RENDERED_MARK));
            const startTime = (0, (0, parcelRequire("ebbSc")).getNow)();
            const projectKey = params.projectKey || (0, ($parcel$interopDefault($ebyGx))).parse((0, ($parcel$interopDefault($9XE6b)))(location, 'search', {})).projectKey;
            if (!params.projectKey) (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), 'queryString', {
                duration: (0, (0, parcelRequire("ebbSc")).getNow)() - startTime
            });
            if (projectKey) (0, (0, parcelRequire("7f4tk")).default)($8d9c467899b3389b$var$buildEndpoint(projectKey, !!initial)).then((response)=>{
                const endTime = (0, (0, parcelRequire("ebbSc")).getNow)();
                let searchQueryParams = '';
                const searchQuery = $8d9c467899b3389b$export$c79af62ad7a1fe8a(query);
                const queryInitializer = response.data.url.includes('?') ? '&' : '?';
                searchQueryParams = $8d9c467899b3389b$export$283f1587d7a5369f(searchQuery, queryInitializer);
                const destination = response.data.url + searchQueryParams;
                history.replace(destination);
                (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), 'History replace correctly triggered', {
                    requestTime: endTime - startTime,
                    destination: destination
                });
            }, (error)=>{
                const endTime = (0, (0, parcelRequire("ebbSc")).getNow)();
                if ((0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)().isAnonymous) $8d9c467899b3389b$var$redirectForAnonymousUser(projectKey, history, startTime);
                else (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData((0, $0592ef8772eedefd$export$25a759e49d5049db), `Error on request. Request time: ${endTime - startTime}`, error);
            });
        }
        render() {
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("le2LN")).default), {
                name: "last-visited-project-page-redirect"
            });
        }
    }
    var $8d9c467899b3389b$export$2e2bcd8739ae039 = $8d9c467899b3389b$export$bf8d1fdc3b47a835;
});
const $0592ef8772eedefd$export$25a759e49d5049db = 'spa-apps.common.redirect.last-visited-project-page';
const $0592ef8772eedefd$export$29d3926e3d72cfb = 'search';
const $0592ef8772eedefd$export$b3233b76460c1e7c = 'showProjectBuilder';
parcelRegister("ebbSc", function(module, exports) {
    $parcel$export(module.exports, "getNow", ()=>$fa5a995d36ebfbde$export$3991332aae1fc754);
    const $fa5a995d36ebfbde$export$3991332aae1fc754 = ()=>Date.now();
});
parcelRegister("19rw3", function(module, exports) {
    $parcel$export(module.exports, "jiraBusinessRouteEntries", ()=>$0e0d75857105a821$export$fb2091db9e7f9102);
    var $ffza4;
    var $l71WK;
    var $lRPBw;
    var $6e4Kt;
    var $6s1PB;
    var $2BrOV;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $dmKXV;
    var $aVFIE;
    var $2G9Bk;
    var $d8VYe;
    var $lNicp;
    var $kqhaB;
    var $3zj3N;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $2qbj6;
    var $4enCS;
    var $jrmpo;
    var $gRtje;
    var $fHgcM;
    var $8roOm;
    var $1UTJJ;
    var $bbl0b;
    var $9cJiv;
    var $3EqEA;
    var $7VVhE;
    var $d9uEV;
    var $kimPG;
    var $MxpLn;
    var $8PCBR;
    var $jZSKA;
    var $WrKYo;
    var $2GPzk;
    var $bh904;
    var $cRzP7;
    var $7wcBz;
    var $6JJeH;
    var $79rde;
    var $lh5sE;
    var $4hypd;
    const $0e0d75857105a821$export$fb2091db9e7f9102 = [
        (0, (0, parcelRequire("fHgcM")).classicBusinessProjectSummaryRouteEntry),
        (0, (0, parcelRequire("2qbj6")).jiraBusinessBoardRouteEntry),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jrmpo")).classicBusinessProjectCalendarEmbedRoute), ()=>({
                ufoName: 'jwm.calendar-embed-view',
                component: (0, (0, parcelRequire("3EqEA")).default),
                entryPoint () {
                    return (0, (0, parcelRequire("6s1PB")).expValEquals)('business_projects_shared_calendar', 'cohort', 'variation') ? (0, (0, parcelRequire("3EqEA")).businessCalendarEmbedRouteEntry) : undefined;
                },
                layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("3EqEA")).LazyCalendarEmbedView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jrmpo")).classicBusinessProjectCalendarRoute), ()=>({
                ufoName: 'jwm.calendar-view',
                component: (0, (0, parcelRequire("9cJiv")).default),
                entryPoint () {
                    return (0, (0, parcelRequire("6s1PB")).expValEquals)('business_projects_shared_calendar', 'cohort', 'variation') ? (0, (0, parcelRequire("9cJiv")).businessCalendarRouteEntry) : undefined;
                },
                layout: (0, (0, parcelRequire("lRPBw")).businessProjectLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("9cJiv")).LazyCalendarView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jrmpo")).classicBusinessProjectShortcutRoute), ()=>({
                component: (0, (0, parcelRequire("6JJeH")).default),
                layout: (0, (0, parcelRequire("lRPBw")).businessProjectLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("6JJeH")).LazyShortcutsView)
                ]
            })),
        (0, (0, parcelRequire("gRtje")).classicBusinessProjectListRouteEntry),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jrmpo")).classicBusinessProjectFormRoute), ()=>({
                ufoName: 'jwm.form-directory-view',
                component: (0, (0, parcelRequire("7VVhE")).default),
                layout: (0, (0, parcelRequire("lRPBw")).businessProjectLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("7VVhE")).LazyFormView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jrmpo")).classicBusinessProjectFormSubmitRoute), ()=>({
                ufoName: 'jwm.form-submit-view',
                component: (0, (0, parcelRequire("kimPG")).default),
                layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("kimPG")).LazyFormSubmitView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jrmpo")).classicBusinessProjectFormBuilderRoute), ()=>({
                ufoName: 'jwm.form-view',
                component: (0, (0, parcelRequire("d9uEV")).default),
                layout: (0, (0, parcelRequire("lRPBw")).businessProjectLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("d9uEV")).LazyFormBuilderView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jrmpo")).classicBusinessProjectTimelineRoute), ()=>({
                ufoName: 'jwm.timeline-view',
                component: (0, (0, parcelRequire("lh5sE")).default),
                layout: (0, (0, parcelRequire("lRPBw")).businessProjectLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("lh5sE")).LazyTimelineView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jrmpo")).classicBusinessProjectApprovalsRoute), ()=>({
                ufoName: 'jwm.approvals-view',
                component: (0, (0, parcelRequire("8roOm")).default),
                layout: (0, (0, parcelRequire("lRPBw")).businessProjectLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("8roOm")).LazyApprovalsView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jrmpo")).projectPagesRoute), ()=>({
                resources: [
                    ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                component: (0, (0, parcelRequire("cRzP7")).default),
                layout: (0, (0, parcelRequire("lRPBw")).businessProjectLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("cRzP7")).LazyProjectPages)
                ],
                ufoName: 'jwm.jwm-pages'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jrmpo")).classicBusinessProjectAttachmentsRoute), ()=>({
                ufoName: 'jwm.attachments-view',
                layout: (0, (0, parcelRequire("lRPBw")).businessProjectLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                entryPoint: ()=>(0, (0, parcelRequire("1UTJJ")).attachmentsPageEntryPoint),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)()
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jrmpo")).classicBusinessProjectTimelineEmbedRoute), ()=>({
                ufoName: 'jwm.timeline-embed-view',
                component: (0, (0, parcelRequire("4hypd")).default),
                layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("4hypd")).LazyTimelineEmbedView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jrmpo")).classicBusinessProjectListEmbedRoute), ()=>({
                ufoName: 'jwm.list-embed-view',
                component: (0, (0, parcelRequire("jZSKA")).default),
                layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                entryPoint: ()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? (0, (0, parcelRequire("8PCBR")).listPageEntryPoint) : undefined,
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("jZSKA")).LazyListEmbedView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jrmpo")).classicBusinessProjectBoardEmbedRoute), ()=>({
                ufoName: 'jwm.jwm-board-embed',
                component: (0, (0, parcelRequire("bbl0b")).default),
                layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                resources: [
                    ...(0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                    (0, (0, parcelRequire("d8VYe")).workflowIssuesResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("bbl0b")).LazyBoardEmbedView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jrmpo")).classicBusinessProjectFormSubmitEmbedRoute), ()=>({
                ufoName: 'jwm.form-submit-embed-view',
                component: (0, (0, parcelRequire("MxpLn")).default),
                layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("MxpLn")).LazyFormSubmitEmbedView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jrmpo")).classicBusinessProjectSummaryEmbedRoute), ()=>({
                ufoName: 'jwm.summary-view-embed',
                component: (0, (0, parcelRequire("79rde")).default),
                layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                resources: [
                    ...(0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                    (0, (0, parcelRequire("3zj3N")).summaryDataResource),
                    (0, (0, parcelRequire("kqhaB")).activityFeedResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("79rde")).LazySummaryEmbeddedView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jrmpo")).classicBusinessProjectSampleOnboardingRoute), ()=>({
                component: (0, (0, parcelRequire("7wcBz")).default),
                layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                resources: (0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                forPaint: [
                    (0, (0, parcelRequire("7wcBz")).LazySampleOnboardingView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jrmpo")).classicBusinessOverviewTimelineRoute), ()=>({
                component: (0, (0, parcelRequire("bh904")).default),
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalOverviewNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getOverviewViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("bh904")).LazyOverviewTimelineView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jrmpo")).classicBusinessOverviewCalendarRoute), ()=>({
                component: (0, (0, parcelRequire("WrKYo")).default),
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalOverviewNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getOverviewViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("WrKYo")).LazyOverviewCalendarView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jrmpo")).classicBusinessOverviewSummaryRoute), ()=>({
                component: (0, (0, parcelRequire("2GPzk")).default),
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("dmKXV")).default),
                    horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalOverviewNav)
                },
                resources: (0, (0, parcelRequire("lNicp")).getOverviewViewResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("2GPzk")).LazyOverviewSummaryView)
                ]
            })),
        (0, (0, parcelRequire("4enCS")).jiraBusinessProjectRedirectRouteEntry),
        (0, (0, parcelRequire("4enCS")).jiraBusinessOverviewRedirectRouteEntry)
    ];
});
parcelRegister("lRPBw", function(module, exports) {
    $parcel$export(module.exports, "businessProjectLayout", ()=>$d0bc40d3dc70d875$export$dfb0c3e0348f4429);
    var $2vSU6;
    var $1Du13;
    var $1XrjK;
    var $hPtZI;
    const $d0bc40d3dc70d875$var$Onboarding = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("XNjnS")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/business-project-layout/src/ui/onboarding/index.tsx"
    });
    const $d0bc40d3dc70d875$var$withAnyBusinessProjectContext = (Component)=>(0, (0, parcelRequire("1XrjK")).withProjectContext)(Component, {
            project: {
                style: 'any',
                type: (0, (0, parcelRequire("2vSU6")).CORE_PROJECT)
            }
        });
    const $d0bc40d3dc70d875$var$RightSidebars = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("2HD9l")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/business-project-layout/src/ui/right-sidebars/index.tsx"
    });
    const $d0bc40d3dc70d875$var$BusinessOnboarding = $d0bc40d3dc70d875$var$withAnyBusinessProjectContext($d0bc40d3dc70d875$var$Onboarding);
    const $d0bc40d3dc70d875$var$nonSettingsRightSidebars = [
        $d0bc40d3dc70d875$var$withAnyBusinessProjectContext($d0bc40d3dc70d875$var$RightSidebars)
    ];
    const $d0bc40d3dc70d875$var$sharedBusinessProjectLayout = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("1Du13")).projectLayout));
    const $d0bc40d3dc70d875$export$dfb0c3e0348f4429 = (0, (0, parcelRequire("1XrjK")).composeLayouts)($d0bc40d3dc70d875$var$sharedBusinessProjectLayout, {
        rightSidebars: $d0bc40d3dc70d875$var$nonSettingsRightSidebars,
        globalComponents: [
            $d0bc40d3dc70d875$var$BusinessOnboarding
        ]
    });
});
parcelRegister("XNjnS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("8VawK")
    ]).then(()=>parcelRequire('3PxNF'));
});
parcelRegister("2HD9l", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("b2COn")
    ]).then(()=>parcelRequire('lktzL'));
});
parcelRegister("aVFIE", function(module, exports) {
    $parcel$export(module.exports, "ThemedLazySkeleton", ()=>$136611be2ae39444$export$ddeb5d943c4f17e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $le2LN;
    var $lob44;
    const $136611be2ae39444$export$ddeb5d943c4f17e3 = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement($136611be2ae39444$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("le2LN")).default), {
            name: "themed-spinner"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lob44")).ThemedSpinner), null))));
    const $136611be2ae39444$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1osq _1bsb1osq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("lob44", function(module, exports) {
    $parcel$export(module.exports, "ThemedSpinner", ()=>$150e941eee16207a$export$271c7b154ad6c401);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $9MjbF;
    const $150e941eee16207a$export$271c7b154ad6c401 = (0, $5uXOq.memo)((props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($150e941eee16207a$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9MjbF")).default), {
            size: "large",
            ...props,
            testId: "project-theme-components.ui.themed-spinner"
        })));
    const $150e941eee16207a$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1xjgvy9e",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("d8VYe", function(module, exports) {
    $parcel$export(module.exports, "workflowIssuesResource", ()=>$6a9e21653771d63a$export$49027035af709702);
    $parcel$export(module.exports, "useWorkflowIssues", ()=>$6a9e21653771d63a$export$86b7de71bf71360d);
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $9YrR3;
    const $6a9e21653771d63a$var$RESOURCE_TYPE_KEY = 'BUSINESS_WORKFLOW_ISSUES';
    const $6a9e21653771d63a$export$49027035af709702 = (0, $dIdda.createResource)({
        type: $6a9e21653771d63a$var$RESOURCE_TYPE_KEY,
        getKey: (matchedRoute)=>{
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            return `${$6a9e21653771d63a$var$RESOURCE_TYPE_KEY}_${projectKey}`;
        },
        getDataLoader: ()=>Promise.resolve((parcelRequire("9YrR3"))),
        getData: (0, (0, parcelRequire("9YrR3")).default),
        maxAge: 1000,
        isBrowserOnly: true
    });
    const $6a9e21653771d63a$export$86b7de71bf71360d = ()=>(0, $dIdda.useResource)($6a9e21653771d63a$export$49027035af709702);
});
parcelRegister("9YrR3", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$465154b480a996b2$export$2e2bcd8739ae039);
    var $7juH2;
    var $x9xyg;
    var $jJZqs;
    var $8PRuf;
    var $iR3GG;
    const $465154b480a996b2$var$EMPTY_DATA = {
        workflows: [],
        lastChangedTime: null
    };
    function $465154b480a996b2$var$getEarlyPreload() {
        if (window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__) {
            const earlyPreloadPromise = window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__;
            window.__JIRA_BUSINESS_BOARD_WORKFLOWS_DATA_PROMISE__ = null;
            return earlyPreloadPromise.then((response)=>{
                if (!response.success) {
                    if (response.error.status === 304) throw new (0, (0, parcelRequire("7juH2")).Unchanged)('Workflow issues have not changed since the last request');
                    throw new (0, (0, parcelRequire("jJZqs")).default)(response.error.status);
                }
                return {
                    workflows: response.workflows,
                    lastChangedTime: null
                };
            });
        }
        return null;
    }
    function $465154b480a996b2$var$fetchData(projectKey) {
        const earlyPreload = $465154b480a996b2$var$getEarlyPreload();
        if (earlyPreload !== null) return earlyPreload;
        return (0, (0, parcelRequire("7juH2")).fetchWorkflowIssues)(projectKey);
    }
    async function $465154b480a996b2$export$2e2bcd8739ae039({ match: match }, { tenantContext: tenantContext }) {
        const { isAnonymous: isAnonymous } = tenantContext;
        if (isAnonymous) return $465154b480a996b2$var$EMPTY_DATA;
        try {
            (0, (0, parcelRequire("x9xyg")).setMark)((0, (0, parcelRequire("8PRuf")).prefetchApiStartMark));
            const workflows = await $465154b480a996b2$var$fetchData(match.params.projectKey ?? '');
            (0, (0, parcelRequire("x9xyg")).setMark)((0, (0, parcelRequire("8PRuf")).prefetchApiReadyMark));
            return workflows;
        } catch (error) {
            throw (0, (0, parcelRequire("iR3GG")).createResourceError)({
                component: 'spa.view.routes.business.board-workflows.getData',
                message: 'An error was thrown while prefetching board data',
                name: 'ResourceError'
            }, error);
        }
    }
});
parcelRegister("7juH2", function(module, exports) {
    $parcel$export(module.exports, "Unchanged", ()=>$16e71a1b1f979cb0$export$eccd6db33b8f6a89);
    $parcel$export(module.exports, "fetchWorkflowIssues", ()=>$16e71a1b1f979cb0$export$17e2e8212d93f58d);
    var $gKZoD;
    var $gN11a;
    var $aDvGo;
    var $jJZqs;
    class $16e71a1b1f979cb0$export$eccd6db33b8f6a89 extends Error {
    }
    const $16e71a1b1f979cb0$export$17e2e8212d93f58d = async (projectKey, ifChangedSince)=>{
        (0, (0, parcelRequire("gKZoD")).di)(fetch);
        try {
            (0, (0, parcelRequire("gN11a")).markViewMetric)('jwm-board', (0, $a286480ec63fa4c8$export$23e322eb7c526958));
            const url = `/rest/board-api/1/board/${projectKey}/workflows?excludeLabels=true`;
            const response = await fetch(url, {
                ...(0, (0, parcelRequire("aDvGo")).default),
                headers: ifChangedSince ? {
                    'x-aif-changed-since': ifChangedSince
                } : undefined
            });
            if (!response.ok) {
                if (response.status === 304) throw new $16e71a1b1f979cb0$export$eccd6db33b8f6a89('Workflow issues have not changed since the last request');
                throw new (0, (0, parcelRequire("jJZqs")).default)(response.status);
            }
            const lastChangedTime = response.headers.get('x-alast-changed-time');
            const workflows = await response.json();
            return {
                workflows: workflows.data,
                lastChangedTime: lastChangedTime
            };
        } finally{
            (0, (0, parcelRequire("gN11a")).markViewMetric)('jwm-board', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
        }
    };
});
const $a286480ec63fa4c8$export$747aad128920134d = 3000;
const $a286480ec63fa4c8$export$e4f8d353742c04ac = 4000;
const $a286480ec63fa4c8$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $a286480ec63fa4c8$export$23e322eb7c526958 = 'REQUEST_START';
const $a286480ec63fa4c8$export$83ca21a50372ea3b = 'REQUEST_END';
const $a286480ec63fa4c8$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $a286480ec63fa4c8$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $a286480ec63fa4c8$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $a286480ec63fa4c8$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $a286480ec63fa4c8$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $a286480ec63fa4c8$export$88ea1e280513690f = 'UI_RENDER_END';
parcelRegister("gN11a", function(module, exports) {
    $parcel$export(module.exports, "pageLoadMetrics", ()=>$f9c6206c3cbbca63$export$2878bf482e539059);
    $parcel$export(module.exports, "markViewMetric", ()=>$f9c6206c3cbbca63$export$8d15b4fb25f90514);
    var $cHBMC;
    const $f9c6206c3cbbca63$var$slo = {
        fmp: {
            initial: {
                threshold: (0, $a286480ec63fa4c8$export$747aad128920134d)
            },
            transition: {
                threshold: (0, $a286480ec63fa4c8$export$747aad128920134d)
            }
        },
        tti: {
            initial: {
                threshold: (0, $a286480ec63fa4c8$export$e4f8d353742c04ac)
            },
            transition: {
                threshold: (0, $a286480ec63fa4c8$export$e4f8d353742c04ac)
            }
        }
    };
    const $f9c6206c3cbbca63$var$timings = [
        {
            key: (0, $a286480ec63fa4c8$export$540ffd289e5e0562),
            startMark: (0, $a286480ec63fa4c8$export$23e322eb7c526958),
            endMark: (0, $a286480ec63fa4c8$export$83ca21a50372ea3b)
        },
        {
            key: (0, $a286480ec63fa4c8$export$821ca6ff41f300ec),
            startMark: (0, $a286480ec63fa4c8$export$7b887ee35f2b465e),
            endMark: (0, $a286480ec63fa4c8$export$ac953882305d6102)
        },
        {
            key: (0, $a286480ec63fa4c8$export$7f7f60b5526c5ee3),
            startMark: (0, $a286480ec63fa4c8$export$b78f0bbf209e5f4),
            endMark: (0, $a286480ec63fa4c8$export$88ea1e280513690f)
        }
    ];
    const $f9c6206c3cbbca63$export$2878bf482e539059 = {
        'approvals-view': (0, (0, parcelRequire("cHBMC")).metrics).pageLoad({
            key: 'jwm.approvals-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        summary: (0, (0, parcelRequire("cHBMC")).metrics).pageLoad({
            key: 'jwm.summary-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'summary-embed': (0, (0, parcelRequire("cHBMC")).metrics).pageLoad({
            key: 'jwm.summary-view-embed',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        list: (0, (0, parcelRequire("cHBMC")).metrics).pageLoad({
            key: 'jwm.list-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'list-embed': (0, (0, parcelRequire("cHBMC")).metrics).pageLoad({
            key: 'jwm.list-embed-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'software-list': (0, (0, parcelRequire("cHBMC")).metrics).pageLoad({
            key: 'jsw.list-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'software-list-embed': (0, (0, parcelRequire("cHBMC")).metrics).pageLoad({
            key: 'jsw.list-view-embed',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        timeline: (0, (0, parcelRequire("cHBMC")).metrics).pageLoad({
            key: 'jwm.timeline-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'timeline-embed': (0, (0, parcelRequire("cHBMC")).metrics).pageLoad({
            key: 'jwm.timeline-embed-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        calendar: (0, (0, parcelRequire("cHBMC")).metrics).pageLoad({
            key: 'jwm.calendar-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'calendar-embed': (0, (0, parcelRequire("cHBMC")).metrics).pageLoad({
            key: 'jwm.calendar-embed-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        form: (0, (0, parcelRequire("cHBMC")).metrics).pageLoad({
            key: 'jwm.form-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'form-submit': (0, (0, parcelRequire("cHBMC")).metrics).pageLoad({
            key: 'jwm.form-submit-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'form-submit-embed': (0, (0, parcelRequire("cHBMC")).metrics).pageLoad({
            key: 'jwm.form-submit-embed-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'form-directory': (0, (0, parcelRequire("cHBMC")).metrics).pageLoad({
            key: 'jwm.form-directory-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        board: (0, (0, parcelRequire("cHBMC")).metrics).pageLoad({
            key: 'jwm.board-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'jwm-board': (0, (0, parcelRequire("cHBMC")).metrics).pageLoad({
            key: 'jwm.jwm-board',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'jwm-board-embed': (0, (0, parcelRequire("cHBMC")).metrics).pageLoad({
            key: 'jwm.jwm-board-embed',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'jwm-pages': (0, (0, parcelRequire("cHBMC")).metrics).pageLoad({
            key: 'jwm.jwm-pages',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        }),
        'software-plan-calendar': (0, (0, parcelRequire("cHBMC")).metrics).pageLoad({
            key: 'jsw.plan-calendar-view',
            slo: $f9c6206c3cbbca63$var$slo,
            timings: $f9c6206c3cbbca63$var$timings
        })
    };
    const $f9c6206c3cbbca63$var$startedMarks = {};
    const $f9c6206c3cbbca63$export$8d15b4fb25f90514 = (view, mark)=>{
        const markKey = `${view}-${mark}`;
        if ($f9c6206c3cbbca63$var$startedMarks[markKey]) return;
        $f9c6206c3cbbca63$var$startedMarks[markKey] = true;
        const metric = $f9c6206c3cbbca63$export$2878bf482e539059[view];
        metric?.mark(mark);
    };
});
parcelRegister("8PRuf", function(module, exports) {
    $parcel$export(module.exports, "appBundleReadyMark", ()=>$0ec5205bf4957ca4$export$7e50945a65dd40e);
    $parcel$export(module.exports, "prefetchApiReadyMark", ()=>$0ec5205bf4957ca4$export$17cbe723d23101d8);
    $parcel$export(module.exports, "prefetchApiStartMark", ()=>$0ec5205bf4957ca4$export$887fadb22e7c7735);
    $parcel$export(module.exports, "jswRenderStartMark", ()=>$0ec5205bf4957ca4$export$bd099c0a906f4b3f);
    $parcel$export(module.exports, "jswCreateReduxStoreStartMark", ()=>$0ec5205bf4957ca4$export$d23ef9e7633e30e7);
    $parcel$export(module.exports, "jswCreateReduxStoreEndMark", ()=>$0ec5205bf4957ca4$export$319da6d901948a6d);
    $parcel$export(module.exports, "jswTransformCriticalDataStartMark", ()=>$0ec5205bf4957ca4$export$f0b6622cdc5c7e4f);
    $parcel$export(module.exports, "jswTransformCriticalDataEndMark", ()=>$0ec5205bf4957ca4$export$37e82663aa1e79a8);
    $parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", ()=>$0ec5205bf4957ca4$export$21146514eacceb12);
    $parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", ()=>$0ec5205bf4957ca4$export$4eb8d44ddb14424a);
    var $hXKq5;
    const $0ec5205bf4957ca4$export$7e50945a65dd40e = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$ff834eccc35b9089));
    const $0ec5205bf4957ca4$export$17cbe723d23101d8 = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$86b05e34d462ead8));
    const $0ec5205bf4957ca4$export$887fadb22e7c7735 = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$d6a604a7d9a390fb));
    const $0ec5205bf4957ca4$export$bd099c0a906f4b3f = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$3ae43cc1782d058f));
    const $0ec5205bf4957ca4$export$d23ef9e7633e30e7 = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$363f6703ffa600be));
    const $0ec5205bf4957ca4$export$319da6d901948a6d = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$e87b74567b79c8));
    const $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$99fe642459a8b02));
    const $0ec5205bf4957ca4$export$37e82663aa1e79a8 = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$ab1f5705fc8e0571));
    const $0ec5205bf4957ca4$export$21146514eacceb12 = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$8c3a9046da692c35));
    const $0ec5205bf4957ca4$export$4eb8d44ddb14424a = (0, (0, parcelRequire("hXKq5")).getPrefixedMarkName)((0, $ce556f125dee8174$export$5aa497d1efdcc5bf));
});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("kqhaB", function(module, exports) {
    $parcel$export(module.exports, "activityFeedResource", ()=>$1609d8a65ae37e85$export$928ea152e5c5de54);
    $parcel$export(module.exports, "useActivityFeed", ()=>$1609d8a65ae37e85$export$ee1fe267047f502f);
    var $4NbWL;
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    const $1609d8a65ae37e85$var$RESOURCE_TYPE_KEY = 'BUSINESS_ACTIVITY_FEED';
    const $1609d8a65ae37e85$var$EMPTY_DATA = {
        data: [],
        pageInfo: {
            hasNextPage: false,
            endCursor: ''
        }
    };
    const $1609d8a65ae37e85$export$928ea152e5c5de54 = (0, $dIdda.createResource)({
        type: $1609d8a65ae37e85$var$RESOURCE_TYPE_KEY,
        getKey: (matchedRoute)=>{
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            return `${$1609d8a65ae37e85$var$RESOURCE_TYPE_KEY}_${projectKey}`;
        },
        getData: async ({ match: match, query: query }, { tenantContext: { isAnonymous: isAnonymous } })=>{
            if (isAnonymous) return $1609d8a65ae37e85$var$EMPTY_DATA;
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            return (0, (0, parcelRequire("4NbWL")).fetchActivityFeed)(null, projectKey);
        },
        maxAge: 5000,
        isBrowserOnly: true
    });
    const $1609d8a65ae37e85$export$ee1fe267047f502f = ()=>(0, $dIdda.useResource)($1609d8a65ae37e85$export$928ea152e5c5de54);
});
parcelRegister("4NbWL", function(module, exports) {
    $parcel$export(module.exports, "fetchActivityFeed", ()=>$72e600639fed107e$export$967c92ed76f908b6);
    var $gKZoD;
    var $jJZqs;
    var $a8I18;
    const $72e600639fed107e$var$PAGE_SIZE = 10;
    const $72e600639fed107e$var$CONTENT_TYPE = 'application/atom+xml; charset=UTF-8';
    const $72e600639fed107e$var$STREAM_PROVIDERS = 'thirdparty issues';
    const $72e600639fed107e$export$967c92ed76f908b6 = (after, projectKey)=>{
        (0, (0, parcelRequire("gKZoD")).di)(fetch);
        const firstIndex = after != null ? Number(after) : 0;
        const maxResults = firstIndex + $72e600639fed107e$var$PAGE_SIZE;
        return fetch(`/plugins/servlet/streams?${new URLSearchParams({
            maxResults: maxResults,
            relativeLinks: true,
            streams: `key IS ${projectKey}`,
            providers: $72e600639fed107e$var$STREAM_PROVIDERS
        }).toString()}`, {
            headers: {
                'content-type': $72e600639fed107e$var$CONTENT_TYPE
            }
        }).then((response)=>{
            if (!response.ok) throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, `Error server response: ${response.status}`);
            return response.text();
        }).then((rawResponse)=>{
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(rawResponse, 'application/xml');
            const entries = (0, (0, parcelRequire("a8I18")).transformData)(xmlDoc);
            return {
                data: entries,
                pageInfo: {
                    hasNextPage: entries.length >= maxResults,
                    endCursor: String(entries.length)
                }
            };
        });
    };
});
parcelRegister("a8I18", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$26b06333cc6e5e1f$export$3ceb62baab058c6b);
    const $26b06333cc6e5e1f$export$3ceb62baab058c6b = (xmlDoc)=>{
        const result = [];
        for (const entry of xmlDoc.querySelectorAll('entry')){
            const id = entry.querySelector('id')?.textContent ?? '';
            const published = entry.querySelector('published')?.textContent ?? '';
            const name = entry.querySelector('author > name')?.textContent ?? '';
            const title = entry.querySelector('title')?.textContent ?? '';
            const iconUrl = entry.querySelector('[rel="http://streams.atlassian.com/syndication/icon"]')?.getAttribute('href') ?? '';
            const content = entry.querySelector('content')?.textContent;
            const feedItem = {
                id: id,
                author: {
                    name: name,
                    avatarUrl: ''
                },
                published: published,
                title: title,
                iconUrl: iconUrl,
                content: content
            };
            entry.querySelectorAll('author > link[rel=photo]').forEach((link)=>{
                if (link.getAttribute('media:height') === '48') feedItem.author.avatarUrl = link.getAttribute('href') ?? '';
            });
            result.push(feedItem);
        }
        return result;
    };
});
parcelRegister("3zj3N", function(module, exports) {
    $parcel$export(module.exports, "summaryDataResource", ()=>$acdbc5801b5f9bec$export$cdfee963587c1ea4);
    $parcel$export(module.exports, "useSummaryData", ()=>$acdbc5801b5f9bec$export$c82acf736eaa253c);
    var $aR4Ot;
    var $iR3GG;
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    const $acdbc5801b5f9bec$var$RESOURCE_TYPE_KEY = 'BUSINESS_SUMMARY_DATA';
    const $acdbc5801b5f9bec$var$EMPTY_DATA = {
        overviewItems: null,
        issuesByStatus: null,
        issuesByPriority: null,
        issuesByAssignee: null,
        issuesByType: null,
        workflowsCount: null
    };
    const $acdbc5801b5f9bec$export$cdfee963587c1ea4 = (0, $dIdda.createResource)({
        type: $acdbc5801b5f9bec$var$RESOURCE_TYPE_KEY,
        getKey: (matchedRoute)=>{
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(matchedRoute.match, matchedRoute.query);
            return `${$acdbc5801b5f9bec$var$RESOURCE_TYPE_KEY}_${projectKey}`;
        },
        getData: async ({ match: match, query: query }, { tenantContext: { cloudId: cloudId, isAnonymous: isAnonymous } })=>{
            if (isAnonymous) return $acdbc5801b5f9bec$var$EMPTY_DATA;
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            const jqlContext = `project = "${projectKey}"`;
            try {
                return await (0, (0, parcelRequire("aR4Ot")).fetchSummaryPageData)({
                    cloudId: cloudId,
                    jqlContext: jqlContext,
                    projectKey: projectKey
                });
            } catch (error) {
                const isClientError = error?.statusCode >= 400 && error?.statusCode < 500;
                throw (0, (0, parcelRequire("iR3GG")).createResourceError)({
                    component: 'spa.view.routes.business.summary-data.getData',
                    message: `An error was thrown while prefetching the summary data. Status code: ${error?.statusCode}. Message: ${error?.message}`,
                    name: 'ResourceError',
                    skipSentry: isClientError
                });
            }
        },
        maxAge: 5000,
        isBrowserOnly: true
    });
    const $acdbc5801b5f9bec$export$c82acf736eaa253c = ()=>(0, $dIdda.useResource)($acdbc5801b5f9bec$export$cdfee963587c1ea4);
});
parcelRegister("aR4Ot", function(module, exports) {
    $parcel$export(module.exports, "fetchSummaryPageData", ()=>$86d3799d8fb43b74$export$a3fa5b61d6f8cf86);
    var $jlq4V;
    var $6s1PB;
    var $4R6GH;
    var $eusud;
    var $6FqTo;
    var $7P4vu;
    const $86d3799d8fb43b74$var$QUERY_NAME = 'SummaryPageData';
    const $86d3799d8fb43b74$export$a3fa5b61d6f8cf86 = async ({ cloudId: cloudId, jqlContext: jqlContext, projectKey: projectKey })=>{
        const [expInlineStatusConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('business_summary_page_inline_status');
        const isExperimentSummaryPageInlineStatusEnabled = expInlineStatusConfig.get('isInlineStatusChangeEnabled', false);
        const response = await (0, (0, parcelRequire("eusud")).performPostRequest)(`/rest/gira/1/?operation=${$86d3799d8fb43b74$var$QUERY_NAME}`, {
            body: JSON.stringify({
                query: (0, (0, parcelRequire("6FqTo")).SUMMARY_PAGE_DATA_QUERY),
                variables: {
                    cloudId: cloudId,
                    jqlContext: jqlContext,
                    projectKey: projectKey,
                    doneThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$d5aac1de7fafa2b0)}`,
                    updatedThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$b10a33c38cc20983)}`,
                    createdThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$48eb4b4c930c6378)}`,
                    dueThisWeekJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$2573f5b8014b4068)}`,
                    issuesByStatusJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$8cca17e1017ba894)}`,
                    issuesByPriorityJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                    issuesByAssigneeJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                    issuesByTypeJql: `${jqlContext} AND ${(0, $cd053842fd66588d$export$c49e48bfa75ab23c)}`,
                    pagedDataPageSize: (0, $cd053842fd66588d$export$c0ecd9bd08a86184),
                    isWorkflowsCountEnabled: isExperimentSummaryPageInlineStatusEnabled,
                    isIssueTypeCountEnabled: isExperimentSummaryPageInlineStatusEnabled && !(0, (0, parcelRequire("4R6GH")).fg)('fun-1257_remove_max_issue_type_check'),
                    isStatusIdEnabled: isExperimentSummaryPageInlineStatusEnabled || (0, (0, parcelRequire("4R6GH")).fg)('fun-1257_remove_max_issue_type_check')
                }
            })
        });
        if (response.errors != null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
        if (response.data == null) throw new Error('GraphQL response has no data');
        return (0, (0, parcelRequire("7P4vu")).transformData)(response.data);
    };
});
const $cd053842fd66588d$export$d5aac1de7fafa2b0 = 'statusCategory = Done AND statusCategoryChangedDate >= -1w';
const $cd053842fd66588d$export$b10a33c38cc20983 = 'updatedDate >= -1w';
const $cd053842fd66588d$export$48eb4b4c930c6378 = 'createdDate >= -1w';
const $cd053842fd66588d$export$2573f5b8014b4068 = 'statusCategory != Done AND (duedate >= 0d AND duedate < 1w)';
const $cd053842fd66588d$export$8cca17e1017ba894 = '(statusCategory != Done OR (statusCategory = Done AND statusCategoryChangedDate >= -2w))';
const $cd053842fd66588d$export$c49e48bfa75ab23c = 'statusCategory != Done';
const $cd053842fd66588d$export$c0ecd9bd08a86184 = 8;
const $cd053842fd66588d$export$27f4fb65edc908d0 = `
  fragment IssuesByAssigneeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on UserField {
          userValue {
            accountId,
            avatarUrl,
            displayName
          }
        }
      }
      id,
      totalCount
    }
  }
`;
const $cd053842fd66588d$export$5b2a5373659a0414 = `
  fragment IssuesByTypeFragment on JWMItemGroupConnection {
    pageInfo {
      hasNextPage
      endCursor
    }
    nodes {
      field {
        ... on IssueTypeField {
              id
              name
              iconUrl
        }
      }
      id,
      totalCount
    }
  }
`;
parcelRegister("6FqTo", function(module, exports) {
    $parcel$export(module.exports, "SUMMARY_PAGE_DATA_QUERY", ()=>$7511339abc68f96a$export$7ea8f81ff5bf6361);
    const $7511339abc68f96a$export$7ea8f81ff5bf6361 = `
  query JiraBusinessSummaryPageData($cloudId: ID!, $jqlContext: String!, $doneThisWeekJql: String!, $updatedThisWeekJql: String!, $createdThisWeekJql: String!, $dueThisWeekJql: String!, $issuesByStatusJql: String!, $issuesByPriorityJql: String!, $issuesByAssigneeJql: String!, $issuesByTypeJql: String!, $pagedDataPageSize: Int!, $projectKey: String!, $isWorkflowsCountEnabled: Boolean!, $isIssueTypeCountEnabled: Boolean!, $isStatusIdEnabled: Boolean!) {
    jira {
      jqlBuilder(cloudId: $cloudId) {
        status: fieldValues(
          jqlTerm: "status"
          jqlContext: $jqlContext
          viewContext: JWM
        ) {
          edges {
            node {
              jqlTerm
              displayName
            }
          }
        }
      }
      doneThisWeek: jwmViewItems(cloudId: $cloudId, jql: $doneThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      updatedThisWeek: jwmViewItems(cloudId: $cloudId, jql: $updatedThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      createdThisWeek: jwmViewItems(cloudId: $cloudId, jql: $createdThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      dueThisWeek: jwmViewItems(cloudId: $cloudId, jql: $dueThisWeekJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      totalUnresolvedIssues: jwmViewItems(cloudId: $cloudId, jql: $issuesByAssigneeJql, first: 0) {
        ... on JiraWorkManagementViewItemConnection {
          totalCount
        }
      }
      projectIssueTypesCount: jiraProjectByKey(key: $projectKey, cloudId: $cloudId) @include(if: $isIssueTypeCountEnabled) {
        issueTypes {
          totalCount
        }
      }
    }
    issuesByStatus: jwmItemGroups(jql: $issuesByStatusJql, groupByFieldId: "status", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on StatusField {
              name
							statusId @include(if: $isStatusIdEnabled)
              category {
                key
              }
          }
        }
        totalCount
      }
    }
    issuesByPriority: jwmItemGroups(jql: $issuesByPriorityJql, groupByFieldId: "priority", fieldIds: [], first: 50) {
      nodes {
        id
        field {
          ...on PriorityField {
            iconUrl
            name
          }
        }
        totalCount
      }
    }
    issuesByAssignee: jwmItemGroups(jql: $issuesByAssigneeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "assignee", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByAssigneeFragment
    }
    issuesByType: jwmItemGroups(jql: $issuesByTypeJql, first: $pagedDataPageSize, fieldIds: [], groupByFieldId: "issuetype", sortBy: {field: GROUP_COUNT, direction: DESC}) {
      ...IssuesByTypeFragment
    }
    workflowsCount: jwmWorkflowWithIssueTypes(projectIdOrKey: $projectKey) @include(if: $isWorkflowsCountEnabled) {
      totalCount
    }
  }

  ${(0, $cd053842fd66588d$export$27f4fb65edc908d0)}
  ${(0, $cd053842fd66588d$export$5b2a5373659a0414)}
`;
});
parcelRegister("7P4vu", function(module, exports) {
    $parcel$export(module.exports, "transformData", ()=>$583dacb5a6b553e9$export$3ceb62baab058c6b);
    var $6s1PB;
    var $egekd;
    const $583dacb5a6b553e9$export$3ceb62baab058c6b = (data)=>{
        const [expInlineStatusConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('business_summary_page_inline_status');
        const isExperimentSummaryPageInlineStatusEnabled = expInlineStatusConfig.get('isInlineStatusChangeEnabled', false);
        return {
            overviewItems: {
                doneThisWeek: data.jira.doneThisWeek?.totalCount ?? 0,
                updatedThisWeek: data.jira.updatedThisWeek?.totalCount ?? 0,
                createdThisWeek: data.jira.createdThisWeek?.totalCount ?? 0,
                dueThisWeek: data.jira.dueThisWeek?.totalCount ?? 0
            },
            issuesByStatus: data.issuesByStatus?.nodes.map((node)=>({
                    id: node.id,
                    count: node.totalCount,
                    status: {
                        name: node.field.name,
                        statusId: isExperimentSummaryPageInlineStatusEnabled ? node.field.statusId : '',
                        jqlTerm: data.jira.jqlBuilder?.status.edges.find((status)=>status.node.displayName === node.field.name)?.node.jqlTerm,
                        category: {
                            key: node.field.category.key
                        }
                    }
                })) ?? null,
            issuesByPriority: data.issuesByPriority?.nodes.map((node)=>({
                    id: node.id,
                    count: node.totalCount,
                    priority: {
                        name: node.field.name,
                        iconUrl: node.field.iconUrl
                    }
                })) ?? null,
            issuesByAssignee: data.issuesByAssignee ? {
                ...(0, (0, parcelRequire("egekd")).transformIssuesByAssigneeData)(data.issuesByAssignee),
                totalUnresolvedIssues: data.jira.totalUnresolvedIssues?.totalCount ?? 0
            } : null,
            issuesByType: data.issuesByType ? {
                ...(0, (0, parcelRequire("egekd")).transformIssuesByTypeData)(data.issuesByType),
                totalUnresolvedIssues: data.jira.totalUnresolvedIssues?.totalCount ?? 0
            } : null,
            projectIssueTypesCount: data?.jira?.projectIssueTypesCount?.issueTypes?.totalCount ?? null,
            workflowsCount: data?.workflowsCount?.totalCount ?? null
        };
    };
});
parcelRegister("egekd", function(module, exports) {
    $parcel$export(module.exports, "transformIssuesByAssigneeData", ()=>$0d59c4e7b34bf6f1$export$cef1c6c4edf3287b);
    $parcel$export(module.exports, "transformIssuesByTypeData", ()=>$0d59c4e7b34bf6f1$export$bc7f7d59cba70a26);
    const $0d59c4e7b34bf6f1$export$cef1c6c4edf3287b = (data)=>({
            pageInfo: {
                hasNextPage: data.pageInfo.hasNextPage,
                endCursor: data.pageInfo.endCursor
            },
            data: data.nodes.map((node)=>({
                    id: node.id,
                    user: node.field.userValue ? {
                        avatarUrl: node.field.userValue.avatarUrl ?? '',
                        displayName: node.field.userValue.displayName,
                        accountId: node.field.userValue.accountId
                    } : null,
                    count: node.totalCount
                }))
        });
    const $0d59c4e7b34bf6f1$export$bc7f7d59cba70a26 = (data)=>({
            pageInfo: {
                hasNextPage: data.pageInfo.hasNextPage,
                endCursor: data.pageInfo.endCursor
            },
            data: data.nodes.map((node)=>({
                    id: node.id,
                    issueType: node.field ? {
                        iconUrl: node.field.iconUrl,
                        name: node.field.name,
                        id: node.field.id
                    } : null,
                    count: node.totalCount
                }))
        });
});
parcelRegister("2qbj6", function(module, exports) {
    $parcel$export(module.exports, "jiraBusinessBoardRouteEntry", ()=>$7bd4ff8b4781d2c1$export$c7fe0dd4417407a0);
    var $ffza4;
    var $l71WK;
    var $lRPBw;
    var $g5RGc;
    var $lmyls;
    var $dmKXV;
    var $aVFIE;
    var $2G9Bk;
    var $1XrjK;
    var $d8VYe;
    var $lNicp;
    var $aTZJA;
    var $d04s2;
    var $gkbjZ;
    const $7bd4ff8b4781d2c1$export$c7fe0dd4417407a0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aTZJA")).jiraBusinessBoardRoute), ()=>({
            component: (0, (0, parcelRequire("gkbjZ")).default),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("lRPBw")).businessProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                {
                    query: [
                        'issue-key'
                    ]
                }
            ])),
            skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("dmKXV")).default),
                horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                (0, (0, parcelRequire("d8VYe")).workflowIssuesResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("gkbjZ")).LazyBoardView)
            ],
            afterPaint: [
                (0, (0, parcelRequire("d04s2")).LazyIssueApp)
            ],
            preloadOptions: {
                earlyChunks: [
                    'business-board-early-entry'
                ]
            }
        }));
});
parcelRegister("aTZJA", function(module, exports) {
    $parcel$export(module.exports, "jiraBusinessBoardRoute", ()=>$c28d2a33370e0bea$export$14a5cbbd7e1e2dc2);
    var $65Ltd;
    const $c28d2a33370e0bea$export$14a5cbbd7e1e2dc2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD),
        ufoName: 'jwm.jwm-board',
        exact: true,
        path: '/jira/core/projects/:projectKey/board',
        query: [
            'issue-key?'
        ]
    };
});
parcelRegister("d04s2", function(module, exports) {
    $parcel$export(module.exports, "LazyIssueApp", ()=>$181a8d0a7b0b72cc$export$8c70dcc4643464f8);
    var $hPtZI;
    const $181a8d0a7b0b72cc$export$8c70dcc4643464f8 = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("82uFl")), {
        ssr: false,
        moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
    });
});
parcelRegister("82uFl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("92sUi"),
        $6fhBS("i5RRW"),
        $6fhBS("dsiAd"),
        $6fhBS("kWrFZ"),
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cggv6")
    ]).then(()=>parcelRequire('6qbjz'));
});
parcelRegister("gkbjZ", function(module, exports) {
    $parcel$export(module.exports, "LazyBoardView", ()=>$39c257a891cf9743$export$d663c6b2156921dd);
    $parcel$export(module.exports, "default", ()=>$39c257a891cf9743$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $39c257a891cf9743$export$d663c6b2156921dd = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("c5wMB")), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/business/board/src/index.tsx"
    });
    var $39c257a891cf9743$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $39c257a891cf9743$export$d663c6b2156921dd,
            pageId: "async-business-board",
            shouldShowSpinner: true
        });
});
parcelRegister("c5wMB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("3xlWT")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iL8G9")
    ]).then(()=>parcelRequire('ac4Ca'));
});
parcelRegister("4enCS", function(module, exports) {
    $parcel$export(module.exports, "jiraBusinessProjectRedirectRouteEntry", ()=>$372ca2c4b5e66a38$export$766e305da4c78de5);
    $parcel$export(module.exports, "jiraBusinessOverviewRedirectRouteEntry", ()=>$372ca2c4b5e66a38$export$3aa9116f715693e1);
    var $ffza4;
    var $l71WK;
    var $lRPBw;
    var $lmyls;
    var $dmKXV;
    var $2G9Bk;
    var $lNicp;
    var $9v9ib;
    var $7MCPm;
    var $6475a;
    const $372ca2c4b5e66a38$export$766e305da4c78de5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9v9ib")).jiraBusinessProjectRedirectRoute), ()=>({
            component: (0, (0, parcelRequire("7MCPm")).RedirectToLastVisitedProjectPage),
            layout: (0, (0, parcelRequire("lRPBw")).businessProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("dmKXV")).default),
                horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
            },
            resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    const $372ca2c4b5e66a38$export$3aa9116f715693e1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9v9ib")).jiraBusinessOverviewRedirectRoute), ()=>({
            component: (0, (0, parcelRequire("6475a")).default),
            layout: (0, (0, parcelRequire("lRPBw")).businessProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("dmKXV")).default),
                horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalOverviewNav)
            },
            resources: (0, (0, parcelRequire("lNicp")).getOverviewViewResources)(),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
});
parcelRegister("9v9ib", function(module, exports) {
    $parcel$export(module.exports, "jiraBusinessProjectRedirectRoute", ()=>$21f2029296bcfd0c$export$73b60789ceb8e1eb);
    $parcel$export(module.exports, "jiraBusinessOverviewRedirectRoute", ()=>$21f2029296bcfd0c$export$5ab0e07528c31349);
    var $65Ltd;
    const $21f2029296bcfd0c$export$73b60789ceb8e1eb = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_REDIRECT),
        path: '/jira/core/projects/:projectKey',
        exact: true,
        isRedirect: true
    };
    const $21f2029296bcfd0c$export$5ab0e07528c31349 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT),
        path: '/jira/core/overviews/:overviewId',
        exact: true,
        isRedirect: true
    };
});
parcelRegister("6475a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31755126abaef7af$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7OYJs;
    var $dIdda = parcelRequire("dIdda");
    const $31755126abaef7af$var$OverviewRedirect = ()=>{
        const [overviewId] = (0, $dIdda.usePathParam)('overviewId');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: `/jira/core/overviews/${overviewId}/summary`
        });
    };
    var $31755126abaef7af$export$2e2bcd8739ae039 = $31755126abaef7af$var$OverviewRedirect;
});
parcelRegister("jrmpo", function(module, exports) {
    $parcel$export(module.exports, "classicBusinessProjectSummaryRoute", ()=>$c7f3c03fe7edf119$export$3008bdf5c6ced894);
    $parcel$export(module.exports, "classicBusinessProjectCalendarRoute", ()=>$c7f3c03fe7edf119$export$ba1373c12ea65b4c);
    $parcel$export(module.exports, "classicBusinessProjectShortcutRoute", ()=>$c7f3c03fe7edf119$export$2dd4e8a37d8ac978);
    $parcel$export(module.exports, "classicBusinessProjectListRoute", ()=>$c7f3c03fe7edf119$export$f1e14ce95022c93a);
    $parcel$export(module.exports, "classicBusinessProjectFormRoute", ()=>$c7f3c03fe7edf119$export$e98776bdf96c88ac);
    $parcel$export(module.exports, "classicBusinessProjectFormSubmitRoute", ()=>$c7f3c03fe7edf119$export$3cd93ff55b29f07f);
    $parcel$export(module.exports, "classicBusinessProjectFormBuilderRoute", ()=>$c7f3c03fe7edf119$export$5f684808e671de5);
    $parcel$export(module.exports, "classicBusinessProjectTimelineRoute", ()=>$c7f3c03fe7edf119$export$4301c67fd317894a);
    $parcel$export(module.exports, "classicBusinessProjectApprovalsRoute", ()=>$c7f3c03fe7edf119$export$3109a183a442a02d);
    $parcel$export(module.exports, "projectPagesRoute", ()=>$c7f3c03fe7edf119$export$54a218ca6d1c056a);
    $parcel$export(module.exports, "classicBusinessProjectAttachmentsRoute", ()=>$c7f3c03fe7edf119$export$2d0c5d5ce5a00c);
    $parcel$export(module.exports, "classicBusinessProjectTimelineEmbedRoute", ()=>$c7f3c03fe7edf119$export$fb814f9911fc766e);
    $parcel$export(module.exports, "classicBusinessProjectCalendarEmbedRoute", ()=>$c7f3c03fe7edf119$export$e237859f2fc7cc7);
    $parcel$export(module.exports, "classicBusinessProjectListEmbedRoute", ()=>$c7f3c03fe7edf119$export$f0d33cf104c15274);
    $parcel$export(module.exports, "classicBusinessProjectBoardEmbedRoute", ()=>$c7f3c03fe7edf119$export$7d6a91d85236417);
    $parcel$export(module.exports, "classicBusinessProjectFormSubmitEmbedRoute", ()=>$c7f3c03fe7edf119$export$7e8fd15fdfa29385);
    $parcel$export(module.exports, "classicBusinessProjectSummaryEmbedRoute", ()=>$c7f3c03fe7edf119$export$13164dbb379620e2);
    $parcel$export(module.exports, "classicBusinessProjectSampleOnboardingRoute", ()=>$c7f3c03fe7edf119$export$cd9c218d7c968d2d);
    $parcel$export(module.exports, "classicBusinessOverviewTimelineRoute", ()=>$c7f3c03fe7edf119$export$13f0c823ff3059c2);
    $parcel$export(module.exports, "classicBusinessOverviewCalendarRoute", ()=>$c7f3c03fe7edf119$export$61383e5418d2ffe3);
    $parcel$export(module.exports, "classicBusinessOverviewSummaryRoute", ()=>$c7f3c03fe7edf119$export$4a86e6b12ce49af9);
    var $65Ltd;
    const $c7f3c03fe7edf119$export$3008bdf5c6ced894 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY),
        path: '/jira/core/projects/:projectKey/summary',
        exact: true
    };
    const $c7f3c03fe7edf119$export$ba1373c12ea65b4c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR),
        path: '/jira/core/projects/:projectKey/calendar',
        exact: true
    };
    const $c7f3c03fe7edf119$export$2dd4e8a37d8ac978 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SHORTCUT),
        path: '/jira/core/projects/:projectKey/shortcuts',
        exact: true
    };
    const $c7f3c03fe7edf119$export$f1e14ce95022c93a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST),
        path: '/jira/core/projects/:projectKey/list',
        exact: true
    };
    const $c7f3c03fe7edf119$export$e98776bdf96c88ac = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM),
        path: '/jira/core/projects/:projectKey/form',
        exact: true
    };
    const $c7f3c03fe7edf119$export$3cd93ff55b29f07f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT),
        path: '/jira/core/projects/:projectKey/form/:formId',
        exact: true
    };
    const $c7f3c03fe7edf119$export$5f684808e671de5 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_BUILDER),
        path: '/jira/core/projects/:projectKey/form/:formId/builder',
        exact: true
    };
    const $c7f3c03fe7edf119$export$4301c67fd317894a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE),
        path: '/jira/core/projects/:projectKey/timeline',
        exact: true
    };
    const $c7f3c03fe7edf119$export$3109a183a442a02d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_APPROVALS),
        path: '/jira/core/projects/:projectKey/approvals',
        exact: true
    };
    const $c7f3c03fe7edf119$export$54a218ca6d1c056a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_PAGES),
        path: '/jira/core/projects/:projectKey/pages'
    };
    const $c7f3c03fe7edf119$export$2d0c5d5ce5a00c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_ATTACHMENTS),
        path: '/jira/core/projects/:projectKey/attachments'
    };
    const $c7f3c03fe7edf119$export$fb814f9911fc766e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED),
        path: '/jira/core/projects/:projectKey/timeline/embed',
        exact: true
    };
    const $c7f3c03fe7edf119$export$e237859f2fc7cc7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED),
        path: '/jira/core/projects/:projectKey/calendar/embed',
        exact: true
    };
    const $c7f3c03fe7edf119$export$f0d33cf104c15274 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST_EMBED),
        path: '/jira/core/projects/:projectKey/list/embed',
        exact: true
    };
    const $c7f3c03fe7edf119$export$7d6a91d85236417 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD_EMBED),
        path: '/jira/core/projects/:projectKey/board/embed',
        exact: true
    };
    const $c7f3c03fe7edf119$export$7e8fd15fdfa29385 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT_EMBED),
        path: '/jira/core/projects/:projectKey/form/:formId/embed',
        exact: true
    };
    const $c7f3c03fe7edf119$export$13164dbb379620e2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY_EMBED),
        path: '/jira/core/projects/:projectKey/summary/embed',
        exact: true
    };
    const $c7f3c03fe7edf119$export$cd9c218d7c968d2d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SAMPLE_ONBOARDING),
        path: '/jira/core/sample/onboarding/:taskId',
        exact: true
    };
    const $c7f3c03fe7edf119$export$13f0c823ff3059c2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE),
        path: '/jira/core/overviews/:overviewId/timeline',
        exact: true
    };
    const $c7f3c03fe7edf119$export$61383e5418d2ffe3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR),
        path: '/jira/core/overviews/:overviewId/calendar',
        exact: true
    };
    const $c7f3c03fe7edf119$export$4a86e6b12ce49af9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY),
        path: '/jira/core/overviews/:overviewId/summary',
        exact: true
    };
});
parcelRegister("gRtje", function(module, exports) {
    $parcel$export(module.exports, "classicBusinessProjectListRouteEntry", ()=>$51524c4dee2e7b63$export$fe7e91eb3254e090);
    var $ffza4;
    var $l71WK;
    var $lRPBw;
    var $6s1PB;
    var $lmyls;
    var $dmKXV;
    var $aVFIE;
    var $2G9Bk;
    var $lNicp;
    var $jrmpo;
    var $8PCBR;
    const $51524c4dee2e7b63$export$fe7e91eb3254e090 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jrmpo")).classicBusinessProjectListRoute), ()=>({
            ufoName: 'jwm.list-view',
            component: (0, (0, parcelRequire("8PCBR")).default),
            layout: (0, (0, parcelRequire("lRPBw")).businessProjectLayout),
            skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
            entryPoint: ()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? (0, (0, parcelRequire("8PCBR")).listPageEntryPoint) : undefined,
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("dmKXV")).default),
                horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
            },
            resources: (0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("8PCBR")).LazyListView)
            ]
        }));
});
parcelRegister("8PCBR", function(module, exports) {
    $parcel$export(module.exports, "LazyListView", ()=>$f5609894035bdf64$export$4bfa19c758c39608);
    $parcel$export(module.exports, "default", ()=>$f5609894035bdf64$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "listPageEntryPoint", ()=>$f5609894035bdf64$export$c338b91a236e608a);
    var $5uXOq = parcelRequire("5uXOq");
    var $lkFvK;
    var $lmyls;
    var $2C7sQ;
    var $5j7Th;
    var $hPtZI;
    const $f5609894035bdf64$export$4bfa19c758c39608 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("3tPe4")), {
        moduleId: "./src/packages/spa-apps/business/list/src/index.tsx"
    });
    var $f5609894035bdf64$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f5609894035bdf64$export$4bfa19c758c39608,
            pageId: "async-business-list",
            shouldShowSpinner: true
        });
    const $f5609894035bdf64$export$c338b91a236e608a = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("2C7sQ")).listEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
});
parcelRegister("2C7sQ", function(module, exports) {
    $parcel$export(module.exports, "listEntryPoint", ()=>$7b34153964734d60$export$6be4f10150ff6073);
    var $EVQo4;
    var $2Ftxm;
    var $ikgNX;
    const $7b34153964734d60$var$FORMAT_RULES_FIRST = 20;
    const $7b34153964734d60$export$6be4f10150ff6073 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("3tPe4")), {
            moduleId: "b03343a1"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
            const { projectKey: projectKey } = context.match.params;
            if (!projectKey) throw new Error('projectKey is required');
            return {
                queries: {
                    formattingRulesQuery: {
                        parameters: (0, parcelRequire("EVQo4")).default,
                        variables: {
                            projectKey: projectKey,
                            cloudId: tenantContext.cloudId,
                            first: $7b34153964734d60$var$FORMAT_RULES_FIRST
                        },
                        options: {
                            fetchPolicy: 'network-only'
                        }
                    }
                },
                entryPoints: {},
                extraProps: {}
            };
        }
    });
});
parcelRegister("EVQo4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6fc143a99d34d8f4$export$2e2bcd8739ae039);
    const $6fc143a99d34d8f4$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "19617cae23dba3619feb6b7d7006b077c3444a7b0f92752732863a7b7f39d16b",
            "metadata": {},
            "name": "formatRulesQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $6fc143a99d34d8f4$export$2e2bcd8739ae039 = $6fc143a99d34d8f4$var$node;
});
parcelRegister("3tPe4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5NrjM")
    ]).then(()=>parcelRequire('zU4ax'));
});
parcelRegister("fHgcM", function(module, exports) {
    $parcel$export(module.exports, "classicBusinessProjectSummaryRouteEntry", ()=>$a3e453621b7ee07b$export$deec07bcf556562e);
    var $ffza4;
    var $l71WK;
    var $lRPBw;
    var $lmyls;
    var $dmKXV;
    var $aVFIE;
    var $2G9Bk;
    var $lNicp;
    var $kqhaB;
    var $3zj3N;
    var $jrmpo;
    var $a2EqF;
    const $a3e453621b7ee07b$export$deec07bcf556562e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jrmpo")).classicBusinessProjectSummaryRoute), ()=>({
            ufoName: 'jwm.summary-view',
            component: (0, (0, parcelRequire("a2EqF")).default),
            layout: (0, (0, parcelRequire("lRPBw")).businessProjectLayout),
            skeleton: (0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("dmKXV")).default),
                horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getProjectViewResources)(),
                (0, (0, parcelRequire("3zj3N")).summaryDataResource),
                (0, (0, parcelRequire("kqhaB")).activityFeedResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("a2EqF")).LazySummaryView)
            ]
        }));
});
parcelRegister("a2EqF", function(module, exports) {
    $parcel$export(module.exports, "LazySummaryView", ()=>$076358ef490f5e9c$export$68c09444cc6f2843);
    $parcel$export(module.exports, "default", ()=>$076358ef490f5e9c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $076358ef490f5e9c$export$68c09444cc6f2843 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("hx3VP")), {
        moduleId: "./src/packages/spa-apps/business/summary/src/index.tsx"
    });
    var $076358ef490f5e9c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $076358ef490f5e9c$export$68c09444cc6f2843,
            pageId: "async-business-summary",
            shouldShowSpinner: true
        });
});
parcelRegister("hx3VP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("8VzxY")
    ]).then(()=>parcelRequire('j5uWP'));
});
parcelRegister("8roOm", function(module, exports) {
    $parcel$export(module.exports, "LazyApprovalsView", ()=>$09fa0192771673de$export$70abf918dfb890e);
    $parcel$export(module.exports, "default", ()=>$09fa0192771673de$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $09fa0192771673de$export$70abf918dfb890e = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("axkjN")), {
        moduleId: "./src/packages/spa-apps/business/approvals/src/index.tsx"
    });
    var $09fa0192771673de$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $09fa0192771673de$export$70abf918dfb890e,
            pageId: "async-business-approvals",
            shouldShowSpinner: true
        });
});
parcelRegister("axkjN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bZeJi")
    ]).then(()=>parcelRequire('iJtUd'));
});
parcelRegister("1UTJJ", function(module, exports) {
    $parcel$export(module.exports, "attachmentsPageEntryPoint", ()=>$8d9ee4e688aa8c8e$export$d2dbce06a31f0f47);
    var $lkFvK;
    var $lmyls;
    var $6DXrm;
    const $8d9ee4e688aa8c8e$export$d2dbce06a31f0f47 = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("6DXrm")).attachmentsEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
});
parcelRegister("6DXrm", function(module, exports) {
    $parcel$export(module.exports, "attachmentsEntryPoint", ()=>$5488b7c894698968$export$d94bafd9d893ec98);
    var $k5Bhm;
    var $2Ftxm;
    var $ikgNX;
    const $5488b7c894698968$export$d94bafd9d893ec98 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("evIjU")), {
            moduleId: "26a1d436"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
            const { projectKey: projectKey } = context.match.params;
            if (!projectKey) throw new Error('projectKey is required');
            return {
                queries: {
                    jwmAttachmentsQuery: {
                        parameters: (0, parcelRequire("k5Bhm")).default,
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: [
                                projectKey
                            ],
                            filters: {
                                fileName: '',
                                authorIds: [],
                                mimeTypes: [],
                                dateRange: {
                                    before: undefined,
                                    after: undefined
                                }
                            },
                            durationInSeconds: 900,
                            maxTokenLength: 65534,
                            attachmentCount: 100
                        },
                        options: {
                            fetchPolicy: 'network-only'
                        }
                    }
                },
                entryPoints: {},
                extraProps: {}
            };
        }
    });
});
parcelRegister("k5Bhm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0688ceb8a3d584db$export$2e2bcd8739ae039);
    const $0688ceb8a3d584db$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "77efda0b857a2c013283d7a49b7393ff8f7e07bcad70eba5f1702dac7b6315f8",
            "metadata": {},
            "name": "uiJWMAttachmentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $0688ceb8a3d584db$export$2e2bcd8739ae039 = $0688ceb8a3d584db$var$node;
});
parcelRegister("evIjU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hg0ML")
    ]).then(()=>parcelRequire('hLT0c'));
});
parcelRegister("bbl0b", function(module, exports) {
    $parcel$export(module.exports, "LazyBoardEmbedView", ()=>$168a009788c7c0cc$export$a21a9228b9e68b40);
    $parcel$export(module.exports, "default", ()=>$168a009788c7c0cc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $168a009788c7c0cc$export$a21a9228b9e68b40 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("32mSj")), {
        moduleId: "./src/packages/spa-apps/business/board-embed/src/index.tsx"
    });
    var $168a009788c7c0cc$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $168a009788c7c0cc$export$a21a9228b9e68b40,
            pageId: "async-business-board-embed",
            shouldShowSpinner: true
        });
});
parcelRegister("32mSj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("hUhek")),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fRBgo")
    ]).then(()=>parcelRequire('azXNC'));
});
parcelRegister("9cJiv", function(module, exports) {
    $parcel$export(module.exports, "businessCalendarRouteEntry", ()=>$623de1afef111eb1$export$a3db41da3fd3ff21);
    $parcel$export(module.exports, "LazyCalendarView", ()=>$623de1afef111eb1$export$ebca96bcc4698ee2);
    $parcel$export(module.exports, "default", ()=>$623de1afef111eb1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lkFvK;
    var $lmyls;
    var $4wa6C;
    var $5j7Th;
    var $hPtZI;
    const $623de1afef111eb1$export$a3db41da3fd3ff21 = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("4wa6C")).calendarEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $623de1afef111eb1$export$ebca96bcc4698ee2 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("jPhO0")), {
        moduleId: "./src/packages/spa-apps/business/calendar/src/index.tsx"
    });
    var $623de1afef111eb1$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $623de1afef111eb1$export$ebca96bcc4698ee2,
            pageId: "async-business-calendar",
            shouldShowSpinner: true
        });
});
parcelRegister("4wa6C", function(module, exports) {
    $parcel$export(module.exports, "calendarEntryPoint", ()=>$38193f9d05bd632a$export$19cf4b398f638dc6);
    var $4R6GH;
    var $7JhZX;
    var $2Ftxm;
    var $ikgNX;
    function $38193f9d05bd632a$var$toMidnightUTCString(date) {
        const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
        return new Date(utcMilliseconds).toISOString();
    }
    function $38193f9d05bd632a$var$toDate(date) {
        if (!date) return new Date();
        try {
            const _date = new Date(date);
            return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
        } catch (e) {
            return new Date();
        }
    }
    function $38193f9d05bd632a$var$createScope({ context: context }) {
        return {
            type: 'project',
            projectKeys: [
                String(context.match.params.projectKey)
            ]
        };
    }
    function $38193f9d05bd632a$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
        const { cloudId: cloudId } = tenantContext;
        return {
            projectKeys: {
                cloudId: cloudId,
                keys: scope.projectKeys
            }
        };
    }
    function $38193f9d05bd632a$var$toViewMode(mode) {
        switch(mode){
            case 'week':
                return 'WEEK';
            case 'day':
                return 'DAY';
            default:
                return 'MONTH';
        }
    }
    function $38193f9d05bd632a$var$toWeekStart(weekStart) {
        switch(weekStart){
            case 'monday':
                return 'MONDAY';
            case 'saturday':
                return 'SATURDAY';
            default:
                return 'SUNDAY';
        }
    }
    function $38193f9d05bd632a$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
        return {
            date: $38193f9d05bd632a$var$toMidnightUTCString(selectedDate),
            mode: $38193f9d05bd632a$var$toViewMode(viewRange),
            weekStart: $38193f9d05bd632a$var$toWeekStart(weekStartsOn),
            startDateField: startDateField,
            endDateField: endDateField
        };
    }
    function $38193f9d05bd632a$var$buildIssuesSearchInput() {
        return {
            additionalFilterQuery: ''
        };
    }
    function $38193f9d05bd632a$var$buildUnscheduledIssuesSearchInput() {
        return {
            additionalFilterQuery: ''
        };
    }
    const $38193f9d05bd632a$export$19cf4b398f638dc6 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("8BtoG")), {
            moduleId: "70b39bf1"
        }),
        getPreloadProps: (entryPointRouteParams)=>{
            const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
            const { cloudId: cloudId } = tenantContext;
            const scope = $38193f9d05bd632a$var$createScope(entryPointRouteParams);
            const { date: date } = context.query;
            const selectedDate = $38193f9d05bd632a$var$toDate(date);
            const viewRange = 'month';
            const weekStartsOn = 'sunday';
            const startDateField = 'startdate';
            const endDateField = 'duedate';
            const issueEventFields = {
                startDateField: startDateField,
                endDateField: endDateField
            };
            return {
                queries: {
                    calendarData: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: (0, parcelRequire("7JhZX")).default,
                        variables: {
                            cloudId: cloudId,
                            scopeInput: $38193f9d05bd632a$var$buildScopeInput(entryPointRouteParams, scope),
                            configurationInput: $38193f9d05bd632a$var$buildConfigurationInput({
                                selectedDate: selectedDate,
                                viewRange: viewRange,
                                weekStartsOn: weekStartsOn,
                                startDateField: startDateField,
                                endDateField: endDateField
                            }),
                            issuesSearchInput: $38193f9d05bd632a$var$buildIssuesSearchInput(),
                            unscheduledIssuesSearchInput: $38193f9d05bd632a$var$buildUnscheduledIssuesSearchInput(),
                            versionsSearchInput: {
                                versionStatuses: [
                                    'RELEASED',
                                    'UNRELEASED'
                                ],
                                includeSharedReleases: true
                            },
                            sprintsSearchInput: null,
                            skipSprintSearch: true,
                            skipVersionSearch: false,
                            viewId: null,
                            schedulePermissionsEnabled: (0, (0, parcelRequire("4R6GH")).fg)('calendar_schedule_issue_permissions_check')
                        }
                    }
                },
                entryPoints: {},
                extraProps: {
                    scope: scope,
                    selectedDate: selectedDate,
                    viewRange: viewRange,
                    weekStartsOn: weekStartsOn,
                    issueEventFields: issueEventFields
                }
            };
        }
    });
});
parcelRegister("8BtoG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kkvf2")
    ]).then(()=>parcelRequire('jJF0P'));
});
parcelRegister("jPhO0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fBNW3")
    ]).then(()=>parcelRequire('425eT'));
});
parcelRegister("3EqEA", function(module, exports) {
    $parcel$export(module.exports, "businessCalendarEmbedRouteEntry", ()=>$70a9a2194c74ba61$export$146b7e01aca9816a);
    $parcel$export(module.exports, "LazyCalendarEmbedView", ()=>$70a9a2194c74ba61$export$152b9e0029b084e8);
    $parcel$export(module.exports, "default", ()=>$70a9a2194c74ba61$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lkFvK;
    var $4wa6C;
    var $5j7Th;
    var $hPtZI;
    const $70a9a2194c74ba61$export$146b7e01aca9816a = (0, (0, parcelRequire("lkFvK")).createChromelessEntryPoint)({
        main: (0, (0, parcelRequire("4wa6C")).calendarEntryPoint)
    });
    const $70a9a2194c74ba61$export$152b9e0029b084e8 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("ieQKQ")), {
        moduleId: "./src/packages/spa-apps/business/calendar-embed/src/index.tsx"
    });
    var $70a9a2194c74ba61$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $70a9a2194c74ba61$export$152b9e0029b084e8,
            pageId: "async-business-calendar-embed",
            shouldShowSpinner: true
        });
});
parcelRegister("ieQKQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1IlDx")
    ]).then(()=>parcelRequire('icB4w'));
});
parcelRegister("7VVhE", function(module, exports) {
    $parcel$export(module.exports, "LazyFormView", ()=>$32842b78cbaba6f2$export$240a58749ebba091);
    $parcel$export(module.exports, "default", ()=>$32842b78cbaba6f2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $32842b78cbaba6f2$export$240a58749ebba091 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("aWQgu")), {
        moduleId: "./src/packages/spa-apps/business/form/src/index.tsx"
    });
    var $32842b78cbaba6f2$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $32842b78cbaba6f2$export$240a58749ebba091,
            pageId: "async-business-form",
            shouldShowSpinner: true
        });
});
parcelRegister("aWQgu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jA7gz").then(()=>parcelRequire('4qzdE'));
});
parcelRegister("d9uEV", function(module, exports) {
    $parcel$export(module.exports, "LazyFormBuilderView", ()=>$69b26f1a607bfd2a$export$2076234d7fde1717);
    $parcel$export(module.exports, "default", ()=>$69b26f1a607bfd2a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $69b26f1a607bfd2a$export$2076234d7fde1717 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("9QELA")), {
        moduleId: "./src/packages/spa-apps/business/form-builder/src/index.tsx"
    });
    var $69b26f1a607bfd2a$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $69b26f1a607bfd2a$export$2076234d7fde1717,
            pageId: "async-business-form-builder",
            shouldShowSpinner: true
        });
});
parcelRegister("9QELA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("4nk9B")
    ]).then(()=>parcelRequire('fU1n9'));
});
parcelRegister("kimPG", function(module, exports) {
    $parcel$export(module.exports, "LazyFormSubmitView", ()=>$86d107866af1a870$export$258fcd204933dd75);
    $parcel$export(module.exports, "default", ()=>$86d107866af1a870$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $86d107866af1a870$export$258fcd204933dd75 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("eanHo")), {
        moduleId: "./src/packages/spa-apps/business/form-submit/src/index.tsx"
    });
    var $86d107866af1a870$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $86d107866af1a870$export$258fcd204933dd75,
            pageId: "async-business-form-submit",
            shouldShowSpinner: true
        });
});
parcelRegister("eanHo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("d9GTB")
    ]).then(()=>parcelRequire('hcjUE'));
});
parcelRegister("MxpLn", function(module, exports) {
    $parcel$export(module.exports, "LazyFormSubmitEmbedView", ()=>$7b75b9ef7f4c7083$export$4d2f42d18d020964);
    $parcel$export(module.exports, "default", ()=>$7b75b9ef7f4c7083$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $7b75b9ef7f4c7083$export$4d2f42d18d020964 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("ePboY")), {
        moduleId: "./src/packages/spa-apps/business/form-submit-embed/src/index.tsx"
    });
    var $7b75b9ef7f4c7083$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7b75b9ef7f4c7083$export$4d2f42d18d020964,
            pageId: "async-business-form-submit-embed",
            shouldShowSpinner: true
        });
});
parcelRegister("ePboY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("lY6ya")
    ]).then(()=>parcelRequire('7H3bY'));
});
parcelRegister("jZSKA", function(module, exports) {
    $parcel$export(module.exports, "LazyListEmbedView", ()=>$5d8b9133c744d9c4$export$55704f3c7b8c3364);
    $parcel$export(module.exports, "default", ()=>$5d8b9133c744d9c4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $5d8b9133c744d9c4$export$55704f3c7b8c3364 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("3yT5r")), {
        moduleId: "./src/packages/spa-apps/business/list-embed/src/index.tsx"
    });
    var $5d8b9133c744d9c4$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5d8b9133c744d9c4$export$55704f3c7b8c3364,
            pageId: "async-business-list-embed",
            shouldShowSpinner: true
        });
});
parcelRegister("3yT5r", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("lOtTG")
    ]).then(()=>parcelRequire('ik71Z'));
});
parcelRegister("WrKYo", function(module, exports) {
    $parcel$export(module.exports, "LazyOverviewCalendarView", ()=>$d22af251819eb3be$export$5b8a69e38f82df6c);
    $parcel$export(module.exports, "default", ()=>$d22af251819eb3be$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $d22af251819eb3be$export$5b8a69e38f82df6c = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("jyTiP")), {
        moduleId: "./src/packages/spa-apps/business/overview-calendar/src/index.tsx"
    });
    var $d22af251819eb3be$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d22af251819eb3be$export$5b8a69e38f82df6c,
            pageId: "async-business-overview-calendar",
            shouldShowSpinner: true
        });
});
parcelRegister("jyTiP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fukyz")
    ]).then(()=>parcelRequire('UcTEy'));
});
parcelRegister("2GPzk", function(module, exports) {
    $parcel$export(module.exports, "LazyOverviewSummaryView", ()=>$2d4de63580afb00a$export$125428653f4abe07);
    $parcel$export(module.exports, "default", ()=>$2d4de63580afb00a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $2d4de63580afb00a$export$125428653f4abe07 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("hchJ9")), {
        moduleId: "./src/packages/spa-apps/business/overview-summary/src/index.tsx"
    });
    var $2d4de63580afb00a$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2d4de63580afb00a$export$125428653f4abe07,
            pageId: "async-business-overview-summary",
            shouldShowSpinner: true
        });
});
parcelRegister("hchJ9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("6hewl")
    ]).then(()=>parcelRequire('6QJpB'));
});
parcelRegister("bh904", function(module, exports) {
    $parcel$export(module.exports, "LazyOverviewTimelineView", ()=>$e65cb4f5cee837b4$export$bfea8be13da0d217);
    $parcel$export(module.exports, "default", ()=>$e65cb4f5cee837b4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $e65cb4f5cee837b4$export$bfea8be13da0d217 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("3THqq")), {
        moduleId: "./src/packages/spa-apps/business/overview-timeline/src/index.tsx"
    });
    var $e65cb4f5cee837b4$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e65cb4f5cee837b4$export$bfea8be13da0d217,
            pageId: "async-business-overview-timeline",
            shouldShowSpinner: true
        });
});
parcelRegister("3THqq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8IHqF")
    ]).then(()=>parcelRequire('ge8BQ'));
});
parcelRegister("cRzP7", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectPages", ()=>$7e318392f3d5106d$export$c2115a649411f570);
    $parcel$export(module.exports, "default", ()=>$7e318392f3d5106d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $4OBei;
    const $7e318392f3d5106d$export$c2115a649411f570 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9ZUr6"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/business/pages/src/index.tsx"
    });
    const $7e318392f3d5106d$export$7c3b1828ada63555 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4OBei")).RedirectToProjectType), {
            page: "/pages"
        });
    var $7e318392f3d5106d$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7e318392f3d5106d$export$c2115a649411f570,
            pageId: "async-business-pages",
            shouldShowSpinner: false
        });
});
parcelRegister("4OBei", function(module, exports) {
    $parcel$export(module.exports, "RedirectToProjectType", ()=>$d0b7938065585b86$export$8a3df560509448b8);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $8zOmE;
    var $95EVP;
    var $dxCvy;
    var $bVDE5;
    var $dIdda = parcelRequire("dIdda");
    const $d0b7938065585b86$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $dIdda.Redirect), fireUIAnalytics: fireUIAnalytics = (0, (0, parcelRequire("8zOmE")).fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents), useResource: useResource = (0, $dIdda.useResource), useRouter: useRouter = (0, $dIdda.useRouter), useSpaStateTransition: useSpaStateTransition = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition) })=>{
        const [{ match: match, query: query, route: route }] = useRouter();
        const { data: data } = useResource((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        const [{ isInitialRender: isInitial }] = useSpaStateTransition();
        const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
        (0, $5uXOq.useEffect)(()=>{
            if (!data || !route || !eventRef.current) return;
            fireUIAnalytics(eventRef.current, 'route redirected', {
                isInitial: isInitial,
                routeName: route.name
            });
            eventRef.current = null;
        }, [
            data,
            fireUIAnalytics,
            isInitial,
            route
        ]);
        if (!data || !route) return null;
        const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
        let type;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                type = 'servicedesk';
                break;
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                type = 'core';
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            default:
                type = `software${simplified ? '' : '/c'}`;
        }
        const returnPage = typeof page === 'string' ? page : page(match, query);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: `/jira/${type}/projects/${projectKey}${returnPage}`
        });
    };
});
parcelRegister("9ZUr6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("lKmFv")
    ]).then(()=>parcelRequire('719qB'));
});
parcelRegister("7wcBz", function(module, exports) {
    $parcel$export(module.exports, "LazySampleOnboardingView", ()=>$d8c7c044abd4283c$export$e39375ab6521f3ef);
    $parcel$export(module.exports, "default", ()=>$d8c7c044abd4283c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $d8c7c044abd4283c$export$e39375ab6521f3ef = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("jvCkt")), {
        moduleId: "./src/packages/spa-apps/business/sample-onboarding/src/index.tsx"
    });
    var $d8c7c044abd4283c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d8c7c044abd4283c$export$e39375ab6521f3ef,
            pageId: "async-business-sample-onboarding",
            shouldShowSpinner: true
        });
});
parcelRegister("jvCkt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("lkM4h")
    ]).then(()=>parcelRequire('ePHET'));
});
parcelRegister("6JJeH", function(module, exports) {
    $parcel$export(module.exports, "LazyShortcutsView", ()=>$19b2198152d557fa$export$dfbcb99b55c05486);
    $parcel$export(module.exports, "default", ()=>$19b2198152d557fa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $19b2198152d557fa$export$dfbcb99b55c05486 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("hKI24")), {
        moduleId: "./src/packages/spa-apps/business/shortcut/src/index.tsx"
    });
    var $19b2198152d557fa$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $19b2198152d557fa$export$dfbcb99b55c05486,
            pageId: "async-business-shortcuts",
            shouldShowSpinner: true
        });
});
parcelRegister("hKI24", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dczku")
    ]).then(()=>parcelRequire('7WItf'));
});
parcelRegister("79rde", function(module, exports) {
    $parcel$export(module.exports, "LazySummaryEmbeddedView", ()=>$555c2b2940c866b0$export$a860d403525d69a5);
    $parcel$export(module.exports, "default", ()=>$555c2b2940c866b0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $555c2b2940c866b0$export$a860d403525d69a5 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("3k1Pf")), {
        moduleId: "./src/packages/spa-apps/business/summary-embed/src/index.tsx"
    });
    var $555c2b2940c866b0$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $555c2b2940c866b0$export$a860d403525d69a5,
            pageId: "async-business-summary-embed",
            shouldShowSpinner: true
        });
});
parcelRegister("3k1Pf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("4uhfd")
    ]).then(()=>parcelRequire('kB5po'));
});
parcelRegister("lh5sE", function(module, exports) {
    $parcel$export(module.exports, "LazyTimelineView", ()=>$6263e6dfd2780343$export$5ae50f261c16f52a);
    $parcel$export(module.exports, "default", ()=>$6263e6dfd2780343$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $6263e6dfd2780343$export$5ae50f261c16f52a = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("30tb6")), {
        moduleId: "./src/packages/spa-apps/business/timeline/src/index.tsx"
    });
    var $6263e6dfd2780343$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6263e6dfd2780343$export$5ae50f261c16f52a,
            pageId: "async-business-timeline",
            shouldShowSpinner: true
        });
});
parcelRegister("30tb6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bvt9E")
    ]).then(()=>parcelRequire('2sFVY'));
});
parcelRegister("4hypd", function(module, exports) {
    $parcel$export(module.exports, "LazyTimelineEmbedView", ()=>$daf37642b69bd70b$export$49e7774ce1be17a4);
    $parcel$export(module.exports, "default", ()=>$daf37642b69bd70b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $daf37642b69bd70b$export$49e7774ce1be17a4 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("iBRfX")), {
        moduleId: "./src/packages/spa-apps/business/timeline-embed/src/index.tsx"
    });
    var $daf37642b69bd70b$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $daf37642b69bd70b$export$49e7774ce1be17a4,
            pageId: "async-business-timeline-embed",
            shouldShowSpinner: true
        });
});
parcelRegister("iBRfX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("d88J6")
    ]).then(()=>parcelRequire('fm6i9'));
});
parcelRegister("2UIX1", function(module, exports) {
    $parcel$export(module.exports, "classicProjectSettingsDataClassificationsRouteEntry", ()=>$c035d1074a7f086e$export$5b0670f37204a43d);
    var $ffza4;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $1NY07;
    var $5H2aw;
    const $c035d1074a7f086e$export$5b0670f37204a43d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1NY07")).classicProjectSettingsDataClassificationsRoute), ()=>({
            component: (0, (0, parcelRequire("5H2aw")).default),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("5H2aw")).LazyDataClassificationsSettings)
            ]
        }));
});
parcelRegister("1NY07", function(module, exports) {
    $parcel$export(module.exports, "classicProjectSettingsDataClassificationsRoute", ()=>$904f4088ba13256f$export$952eefa1907e877a);
    var $65Ltd;
    const $904f4088ba13256f$export$952eefa1907e877a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CLASSIC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_DATA_CLASSIFICATIONS),
        path: '/plugins/servlet/project-config/:projectKey/data-classifications',
        exact: true
    };
});
parcelRegister("5H2aw", function(module, exports) {
    $parcel$export(module.exports, "LazyDataClassificationsSettings", ()=>$b4450c735413409b$export$b8abcf8aa8f4df56);
    $parcel$export(module.exports, "default", ()=>$b4450c735413409b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $b4450c735413409b$export$b8abcf8aa8f4df56 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2igd7"))), {
        moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
    });
    var $b4450c735413409b$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b4450c735413409b$export$b8abcf8aa8f4df56,
            pageId: "project-settings-data-classifications",
            shouldShowSpinner: false
        });
});
parcelRegister("2igd7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("6ibtl")
    ]).then(()=>parcelRequire('9iqsx'));
});
parcelRegister("QkD8v", function(module, exports) {
    $parcel$export(module.exports, "classicProjectSettingsIssueLayoutRouteEntry", ()=>$793958c8c0cec75f$export$47b3bdf88a7d176b);
    var $ffza4;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $lbUXA;
    var $33syc;
    const $793958c8c0cec75f$export$47b3bdf88a7d176b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lbUXA")).classicProjectSettingsIssueLayoutRoute), ()=>({
            ufoName: 'project-settings.issue-type.jsw-cmp',
            component: (0, (0, parcelRequire("33syc")).default),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("33syc")).LazyIssueTypeSettings)
            ]
        }));
});
parcelRegister("lbUXA", function(module, exports) {
    $parcel$export(module.exports, "classicProjectSettingsIssueLayoutRoute", ()=>$1cead9ea53333f91$export$c593179674352d0);
    var $65Ltd;
    const $1cead9ea53333f91$export$c593179674352d0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CLASSIC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_ISSUE_LAYOUT),
        path: '/plugins/servlet/project-config/:projectKey/issuelayout',
        query: [
            'screenId'
        ],
        exact: true
    };
});
parcelRegister("33syc", function(module, exports) {
    $parcel$export(module.exports, "LazyIssueTypeSettings", ()=>$f7c23974aa64ecd2$export$36dcfb52d47cb93a);
    $parcel$export(module.exports, "default", ()=>$f7c23974aa64ecd2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $f7c23974aa64ecd2$export$36dcfb52d47cb93a = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("61LFA"))), {
        moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
    });
    var $f7c23974aa64ecd2$export$2e2bcd8739ae039 = ({ match: match })=>{
        const { issueTypeId: issueTypeId } = match.params;
        const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f7c23974aa64ecd2$export$36dcfb52d47cb93a,
            pageId: pageId,
            shouldShowSpinner: false
        });
    };
});
parcelRegister("61LFA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6BhXI")
    ]).then(()=>parcelRequire('8SAZe'));
});
parcelRegister("1NReT", function(module, exports) {
    $parcel$export(module.exports, "classicProjectRouteEntries", ()=>$d1067266a88b60d4$export$5b4e616b6b4b672a);
    var $5uXOq = parcelRequire("5uXOq");
    var $e4eHl = parcelRequire("e4eHl");
    var $ffza4;
    var $6e4Kt;
    var $65Ltd;
    var $e2ctp;
    var $6s1PB;
    var $7XYc4;
    var $cSD7y;
    var $gyYxw;
    var $2BrOV;
    var $g5RGc;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $3HwlS;
    var $9s3j1;
    var $2G9Bk;
    var $1XrjK;
    var $dAmbh;
    var $g4ZHz;
    var $iNzEe;
    var $1E3vT;
    var $l2N2a;
    var $9yEpR;
    var $lfnsv;
    var $lJ1FP;
    var $f5kpo;
    var $2GkDw;
    var $3RJkv;
    var $dxCvy;
    var $aFVvc;
    var $hJAri;
    var $iZ82x;
    var $7GnDe;
    var $2Ql51;
    var $bMz5r;
    var $d04s2;
    var $5lsNZ;
    var $7MCPm;
    var $6cOYV;
    var $jSNrq;
    var $hvQbc;
    var $bXGW3;
    var $1BC32;
    var $bmpFr;
    var $6Nh7k;
    var $6UGN7;
    var $ebynk;
    var $9B5P6;
    var $f3iuv;
    var $4Pqzu;
    var $7Y3Wj;
    var $7OYJs;
    var $is7uC;
    var $8UJQ4;
    var $cTHJk;
    var $aJzGl;
    var $lm7AC;
    var $kfztd;
    var $5PD5h;
    var $e7bC3;
    var $7yO8g;
    var $hPtZI;
    var $c7uCQ;
    var $yxwH0;
    var $6XlJT;
    var $13pw2;
    var $33P3A;
    var $jK0PE;
    var $eQnNj;
    var $brJ9B;
    var $7KruY;
    var $89cBA;
    var $3woHG;
    const $d1067266a88b60d4$export$edb4b8cf67d7d767 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1vlac"))), {
        moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
    });
    const $d1067266a88b60d4$var$ProjectsDirectoryRedirect = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/projects"
        });
    const $d1067266a88b60d4$var$classicBacklogCapability = !false ? (0, $281cbd47ba46dd7d$export$571692eec8a399e1) : (0, $281cbd47ba46dd7d$export$93104dc4eba58ba4);
    const $d1067266a88b60d4$export$5b4e616b6b4b672a = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareRoadmapClassicRoute), ()=>({
                component: (0, (0, parcelRequire("c7uCQ")).TimelineRedirect),
                skeleton: (0, (0, parcelRequire("lm7AC")).RoadmapSkeleton),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                    {
                        query: [
                            'selectedIssue'
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("hJAri")).classicRoadmapResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'software-roadmap-early-entry'
                    ]
                },
                afterPaint: [
                    (0, (0, parcelRequire("d04s2")).LazyIssueApp)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("jK0PE")).LazyRoadmapViewClassic)
                ],
                ufoName: 'classic-roadmap'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareTimelineClassicRoute), ()=>({
                component: (0, (0, parcelRequire("jK0PE")).default),
                skeleton: (0, (0, parcelRequire("lm7AC")).RoadmapSkeleton),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                    {
                        query: [
                            'selectedIssue'
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("hJAri")).classicRoadmapResource)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'software-roadmap-early-entry'
                    ]
                },
                afterPaint: [
                    (0, (0, parcelRequire("d04s2")).LazyIssueApp)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("jK0PE")).LazyRoadmapViewClassic)
                ],
                ufoName: 'classic-roadmap'
            })),
        ...(0, (0, parcelRequire("hvQbc")).classicSoftwareBoardSettingsInsightsRouteEntries),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).rapidboardBacklogEmbedRoute), ()=>({
                ufoName: 'classic-backlog-embed',
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('enable_backlog_smartlink_route', (0, (0, parcelRequire("7Y3Wj")).RapidBoardSpaPage), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
                resources: [
                    ...(0, (0, parcelRequire("f5kpo")).getUIFBacklogDataResource)(),
                    ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                    (0, (0, parcelRequire("lJ1FP")).getEditModelResource)(),
                    (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)(),
                    (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
                ],
                afterPaint: [
                    (0, (0, parcelRequire("d04s2")).LazyIssueApp)
                ],
                forPaint: [
                    $d1067266a88b60d4$export$edb4b8cf67d7d767
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                meta: {
                    capability: $d1067266a88b60d4$var$classicBacklogCapability
                },
                earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY)
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).rapidboardBacklogRoute), ()=>({
                ufoName: 'classic-backlog',
                component: (0, (0, parcelRequire("7Y3Wj")).RapidBoardSpaPage),
                skeleton: (0, (0, parcelRequire("aJzGl")).NextGenBacklogSkeleton),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                    {
                        query: [
                            'selectedIssue',
                            'view=planning'
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("f5kpo")).getUIFBacklogDataResource)(),
                    ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                    (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                    (0, (0, parcelRequire("lJ1FP")).getEditModelResource)(),
                    (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)()
                ],
                afterPaint: [
                    (0, (0, parcelRequire("d04s2")).LazyIssueApp)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $d1067266a88b60d4$export$edb4b8cf67d7d767
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                meta: {
                    capability: $d1067266a88b60d4$var$classicBacklogCapability
                },
                earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY)
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareCalendarClassicEmbedRoute), ()=>({
                skeleton: (0, (0, parcelRequire("is7uC")).CalendarEmbedSkeleton),
                component: (0, (0, parcelRequire("is7uC")).CalendarEmbedSkeleton),
                entryPoint () {
                    if (false) return undefined;
                    return 0, (0, parcelRequire("eQnNj")).softwareCalendarRouteEntry;
                },
                layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
                resources: [
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
                ],
                ufoName: 'classic-calendar-embed'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareCalendarClassicRoute), ()=>({
                skeleton: (0, (0, parcelRequire("is7uC")).CalendarSkeleton),
                component: (0, (0, parcelRequire("is7uC")).CalendarSkeleton),
                entryPoint () {
                    if (false) return undefined;
                    return 0, (0, parcelRequire("eQnNj")).softwareCalendarRouteEntry;
                },
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                    {
                        query: [
                            'selectedIssue'
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
                ],
                afterPaint: [
                    (0, (0, parcelRequire("d04s2")).LazyIssueApp)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ],
                ufoName: 'classic-calendar'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareListEmbedClassicRoute), ()=>({
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('jsw_list_view', 'cohort', 'variation'), (0, (0, parcelRequire("brJ9B")).SoftwareListEmbedPage), (0, (0, parcelRequire("5lsNZ")).default)),
                skeleton: (0, (0, parcelRequire("cTHJk")).ListEmbedSkeleton),
                entryPoint () {
                    return (0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? (0, (0, parcelRequire("7KruY")).softwareListRouteEntry) : undefined;
                },
                layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
                resources: [
                    (0, (0, parcelRequire("aFVvc")).projectCreatePermissionsResource),
                    (0, (0, parcelRequire("iNzEe")).navigationResource),
                    (0, (0, parcelRequire("l2N2a")).projectDetailsResource),
                    (0, (0, parcelRequire("9yEpR")).storageDetailsResource),
                    (0, (0, parcelRequire("1E3vT")).navigationItemsResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("dAmbh")).configurationResource),
                    (0, (0, parcelRequire("g4ZHz")).fieldsResource)
                ],
                afterPaint: [
                    (0, (0, parcelRequire("d04s2")).LazyIssueApp)
                ],
                forPaint: [
                    (0, (0, parcelRequire("brJ9B")).LazySoftwareListEmbedView)
                ],
                ufoName: 'classic-list-embed'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareListClassicRoute), ()=>({
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('jsw_list_view', 'cohort', 'variation'), (0, (0, parcelRequire("brJ9B")).SoftwareListPage), (0, (0, parcelRequire("5lsNZ")).default)),
                skeleton: (0, (0, parcelRequire("cTHJk")).ListSkeleton),
                entryPoint () {
                    return (0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? (0, (0, parcelRequire("7KruY")).softwareListRouteEntry) : undefined;
                },
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                    {
                        query: [
                            'selectedIssue'
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    (0, (0, parcelRequire("aFVvc")).projectCreatePermissionsResource),
                    (0, (0, parcelRequire("iNzEe")).navigationResource),
                    (0, (0, parcelRequire("l2N2a")).projectDetailsResource),
                    (0, (0, parcelRequire("9yEpR")).storageDetailsResource),
                    (0, (0, parcelRequire("1E3vT")).navigationItemsResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("dAmbh")).configurationResource),
                    (0, (0, parcelRequire("g4ZHz")).fieldsResource)
                ],
                afterPaint: [
                    (0, (0, parcelRequire("d04s2")).LazyIssueApp)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("brJ9B")).LazySoftwareListView)
                ],
                ufoName: 'classic-list'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).rapidboardReportRoute), ()=>({
                component: (0, (0, parcelRequire("7Y3Wj")).RapidBoardSpaPage),
                skeleton: (0, (0, parcelRequire("8UJQ4")).ClassicReportSkeleton),
                layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                    ...(0, (0, parcelRequire("yxwH0")).getReportsCommonResource)()
                ],
                afterPaint: [
                    (0, (0, parcelRequire("d04s2")).LazyIssueApp)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoard),
                    (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoardApps)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY),
                ufoName: 'classic-report'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareReportsCycleTimeClassicRoute), ()=>({
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, (0, parcelRequire("89cBA")).CycleTimeReportClassic)),
                layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("yxwH0")).getReportsCommonResource)(),
                    (0, (0, parcelRequire("2GkDw")).devOpsProviderResource)
                ],
                afterPaint: [
                    (0, (0, parcelRequire("89cBA")).LazyCycleTimeReport)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("89cBA")).LazyCycleTimeReport)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC),
                        packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC)),
                        teamName: 'fusion-solaris'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareFormBuilderClassicRoute), ()=>({
                ufoName: 'classic-form-builder',
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expVal)('forms_for_jsw_experiment', 'isEnabled', false), (0, (0, parcelRequire("bmpFr")).FormBuilderPage), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav), ()=>null)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("l2N2a")).projectDetailsResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("bmpFr")).LazyFormBuilderView)
                ],
                afterPaint: [
                    (0, (0, parcelRequire("6UGN7")).LazyFormSubmitView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareFormSubmitClassicRoute), ()=>({
                ufoName: 'classic-form-submit',
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expVal)('forms_for_jsw_experiment', 'isEnabled', false), (0, (0, parcelRequire("6UGN7")).FormSubmitPage), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("l2N2a")).projectDetailsResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("6UGN7")).LazyFormSubmitView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareFormClassicRoute), ()=>({
                ufoName: 'classic-form',
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expVal)('forms_for_jsw_experiment', 'isEnabled', false), (0, (0, parcelRequire("6Nh7k")).FormPage), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav), ()=>null)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("l2N2a")).projectDetailsResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("6Nh7k")).LazyFormView)
                ],
                afterPaint: [
                    (0, (0, parcelRequire("bmpFr")).LazyFormBuilderView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareGoalsClassicRoute), ()=>({
                component: (0, (0, parcelRequire("6XlJT")).default),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareSummaryClassicRoute), ()=>({
                ufoName: 'classic-summary',
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('enable_jsw_summary_page', (0, (0, parcelRequire("f3iuv")).SummaryPage), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("f3iuv")).LazySummaryView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareClassicProformaIssueFormsDirectRoute), ()=>({
                component: (0, (0, parcelRequire("13pw2")).default),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
                },
                resources: [
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("13pw2")).LazyProformaIssueFormsDirect)
                ],
                perfMetricKey: 'issue-forms-direct'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareClassicProformaIssueFormsDirectEmbedRoute), ()=>({
                component: (0, (0, parcelRequire("33P3A")).default),
                layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
                resources: [
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("33P3A")).LazyProformaIssueFormsDirectEmbed)
                ],
                perfMetricKey: 'issue-forms-direct-embed'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareReportsDeploymentFrequencyClassicRoute), ()=>({
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, (0, parcelRequire("3woHG")).DeploymentFrequencyReportClassic)),
                layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("yxwH0")).getReportsCommonResource)(),
                    (0, (0, parcelRequire("2GkDw")).devOpsProviderResource)
                ],
                afterPaint: [
                    (0, (0, parcelRequire("3woHG")).LazyDeploymentFrequencyReport)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("3woHG")).LazyDeploymentFrequencyReport)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC),
                        packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC)),
                        teamName: 'fusion-solaris'
                    }
                }
            })),
        (0, (0, parcelRequire("jSNrq")).classicSoftwareBoardEmbedRouteEntry),
        (0, (0, parcelRequire("jSNrq")).classicSoftwareBoardRouteEntry),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).rapidboardUserBacklogRoute), ()=>({
                component: (0, (0, parcelRequire("7Y3Wj")).RapidBoardSpaPage),
                skeleton: (0, (0, parcelRequire("aJzGl")).NextGenBacklogSkeleton),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                    {
                        query: [
                            'selectedIssue'
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("f5kpo")).getUIFBacklogDataResource)(),
                    ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                    (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                    ...(0, (0, parcelRequire("3RJkv")).getUserBoardNavigationResources)(),
                    (0, (0, parcelRequire("lJ1FP")).getEditModelResource)(),
                    (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)()
                ],
                afterPaint: [
                    (0, (0, parcelRequire("d04s2")).LazyIssueApp)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $d1067266a88b60d4$export$edb4b8cf67d7d767
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                meta: {
                    capability: $d1067266a88b60d4$var$classicBacklogCapability
                },
                earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY)
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).rapidboardUserReportRoute), ()=>({
                component: (0, (0, parcelRequire("7Y3Wj")).RapidBoardSpaPage),
                skeleton: (0, (0, parcelRequire("8UJQ4")).ClassicReportSkeleton),
                layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                    ...(0, (0, parcelRequire("yxwH0")).getReportsCommonResource)(),
                    ...(0, (0, parcelRequire("3RJkv")).getUserBoardNavigationResources)()
                ],
                afterPaint: [
                    (0, (0, parcelRequire("d04s2")).LazyIssueApp)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoard),
                    (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoardApps)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY)
            })),
        (0, (0, parcelRequire("4Pqzu")).userBoardRouteEntry),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).rapidboardBacklog1Route), ()=>({
                ufoName: 'classic-backlog',
                component: (0, (0, parcelRequire("7Y3Wj")).RapidBoardSpaPage),
                skeleton: (0, (0, parcelRequire("aJzGl")).NextGenBacklogSkeleton),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                    {
                        query: [
                            'selectedIssue',
                            'view=planning'
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                    (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                    ...(0, (0, parcelRequire("3RJkv")).getUserBoardNavigationResources)()
                ],
                afterPaint: [
                    (0, (0, parcelRequire("d04s2")).LazyIssueApp)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoard),
                    (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoardApps)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                meta: {
                    capability: (0, $281cbd47ba46dd7d$export$93104dc4eba58ba4)
                },
                earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY)
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).rapidboardReport1Route), ()=>({
                component: (0, (0, parcelRequire("7Y3Wj")).RapidBoardSpaPage),
                skeleton: (0, (0, parcelRequire("8UJQ4")).ClassicReportSkeleton),
                layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                    ...(0, (0, parcelRequire("yxwH0")).getReportsCommonResource)(),
                    ...(0, (0, parcelRequire("3RJkv")).getUserBoardNavigationResources)()
                ],
                afterPaint: [
                    (0, (0, parcelRequire("d04s2")).LazyIssueApp)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoard),
                    (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoardApps)
                ],
                preloadOptions: {
                    earlyChunks: [
                        'rapidboard-early-entry'
                    ]
                },
                earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY),
                ufoName: 'classic-report'
            })),
        (0, (0, parcelRequire("bXGW3")).legacyRapidBoardRouteEntry),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).softwareCodeClassicRoute), ()=>({
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("iZ82x")).codePageResource)
                ],
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, (0, parcelRequire("brJ9B")).CodePageClassic)),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("brJ9B")).LazyCode)
                ]
            })),
        (0, (0, parcelRequire("9B5P6")).softwareSecurityClassicRouteEntry),
        (0, (0, parcelRequire("1BC32")).softwareDeploymentsClassicRouteEntry),
        (0, (0, parcelRequire("ebynk")).softwarePeriscopeClassicRouteEntry),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).rapidboardLastVisitedProjectRedirectRoute), ()=>({
                component: (0, (0, parcelRequire("7MCPm")).RedirectToLastVisitedProjectPage),
                layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                isRedirect: true,
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bMz5r")).projectDirectoryRedirectRoute), ()=>({
                component: $d1067266a88b60d4$var$ProjectsDirectoryRedirect,
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
                },
                isRedirect: true,
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("6cOYV")).softwareIncidentsClassicRouteEntry)
    ];
});
parcelRegister("lfnsv", function(module, exports) {
    $parcel$export(module.exports, "boardDetailsResource", ()=>$d78990d38f225e07$export$6c6984c55b171c5d);
    $parcel$export(module.exports, "getBoardDetailsResource", ()=>$d78990d38f225e07$export$b67eabcfc08e7c62);
    var $jcw0u;
    var $co1wz;
    var $7f4tk;
    var $gNStA;
    var $dIdda = parcelRequire("dIdda");
    const $d78990d38f225e07$export$90ce361a5838e31e = async (boardId)=>{
        try {
            return await (0, (0, parcelRequire("7f4tk")).default)(`/rest/agile/1.0/board/${boardId}`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'getBoardDetailsRequest',
                    packageName: 'jiraRouterResourcesClassicProjects',
                    teamName: 'a4t-pandora'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
    const $d78990d38f225e07$export$6c6984c55b171c5d = (0, $dIdda.createResource)({
        type: 'CLASSIC_BOARD_SETTING_BOARD_DETAILS',
        getKey: (routerContext)=>routerContext.query?.config ? 'cmp-board-settings' : 'not-cmp-board-setting',
        getData: async (routerContext)=>{
            const boardId = routerContext.match.params?.boardId ?? '';
            if (routerContext.query?.config) return $d78990d38f225e07$export$90ce361a5838e31e(boardId);
            return null;
        }
    });
    const $d78990d38f225e07$export$b67eabcfc08e7c62 = ()=>(0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('simplified-boards-milestone-2_07hbk'), $d78990d38f225e07$export$6c6984c55b171c5d);
});
parcelRegister("lJ1FP", function(module, exports) {
    $parcel$export(module.exports, "editModelResource", ()=>$16cc53c7df259df5$export$ab9a4786826fd2d);
    $parcel$export(module.exports, "getEditModelResource", ()=>$16cc53c7df259df5$export$5b9bac2cc4bf4511);
    var $jcw0u;
    var $co1wz;
    var $7f4tk;
    var $gNStA;
    var $dIdda = parcelRequire("dIdda");
    const $16cc53c7df259df5$export$ddbb511f9111736a = async (boardId)=>{
        try {
            return await (0, (0, parcelRequire("7f4tk")).default)(`/rest/greenhopper/1.0/rapidviewconfig/editmodel.json?cardLayoutConfig=false&rapidViewId=${boardId}`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'getEditModelRequest',
                    packageName: 'jiraRouterResourcesClassicProjects',
                    teamName: 'a4t-pandora'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
    const $16cc53c7df259df5$export$ab9a4786826fd2d = (0, $dIdda.createResource)({
        type: 'CLASSIC_BOARD_SETTING_EDIT_MODEL',
        getKey: (routerContext)=>routerContext.query?.config ? 'edit-model' : 'not-edit-model',
        getData: async (routerContext)=>{
            if (routerContext.query?.config) {
                const boardId = routerContext.match.params?.boardId ?? '';
                return $16cc53c7df259df5$export$ddbb511f9111736a(boardId);
            }
            return null;
        }
    });
    const $16cc53c7df259df5$export$5b9bac2cc4bf4511 = ()=>(0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('simplified-boards-milestone-2_07hbk') && !(0, (0, parcelRequire("co1wz")).ff)('board-settings-graphql-refactor_cyvz9'), $16cc53c7df259df5$export$ab9a4786826fd2d);
});
parcelRegister("f5kpo", function(module, exports) {
    $parcel$export(module.exports, "shouldLoadUIFBoardResources", ()=>$e96bf35f407138bb$export$d8d4641986a9ac7f);
    $parcel$export(module.exports, "getRapidboardResources", ()=>$e96bf35f407138bb$export$3a5e56bd5231a56b);
    $parcel$export(module.exports, "getRapidBoardDataResource", ()=>$e96bf35f407138bb$export$1c63de7f548f965f);
    $parcel$export(module.exports, "getUIFBacklogDataResource", ()=>$e96bf35f407138bb$export$ee826506b3baa13a);
    var $co1wz;
    var $4R6GH;
    var $5Nutl;
    var $gNStA;
    var $3R260;
    var $i6CNv;
    var $kdyVI;
    var $5jCaw;
    var $gQ2J4;
    var $fox5Q;
    const $e96bf35f407138bb$export$d8d4641986a9ac7f = ()=>!false;
    const $e96bf35f407138bb$export$462ca08d6ce67848 = ()=>!$e96bf35f407138bb$export$d8d4641986a9ac7f();
    const $e96bf35f407138bb$export$3a5e56bd5231a56b = ()=>[
            (0, (0, parcelRequire("fox5Q")).wrmBundleResource),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('jsw.classic.board.api-calls.modern-frontend'), (0, (0, parcelRequire("i6CNv")).boardConfigApiResource), (0, (0, parcelRequire("3R260")).boardConfigResource)),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)($e96bf35f407138bb$export$462ca08d6ce67848, (0, (0, parcelRequire("gQ2J4")).rapidboardResource))
        ];
    const $e96bf35f407138bb$export$1c63de7f548f965f = ()=>(0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('jsw.classic.board.api-calls.modern-frontend'), (0, (0, parcelRequire("kdyVI")).boardDataResource), (0, (0, parcelRequire("5jCaw")).initialAllDataResource));
    const $e96bf35f407138bb$export$ee826506b3baa13a = ()=>[
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>$e96bf35f407138bb$export$d8d4641986a9ac7f() && !(0, (0, parcelRequire("4R6GH")).fg)('indexeddb_cache_for_backlog'), (0, (0, parcelRequire("5Nutl")).uifBacklogResourceOld)),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>$e96bf35f407138bb$export$d8d4641986a9ac7f() && (0, (0, parcelRequire("4R6GH")).fg)('indexeddb_cache_for_backlog'), (0, (0, parcelRequire("5Nutl")).uifBacklogResource))
        ];
});
parcelRegister("5Nutl", function(module, exports) {
    $parcel$export(module.exports, "uifBacklogResourceOld", ()=>$9905b3c28d313f7e$export$db83ef0443397b85);
    $parcel$export(module.exports, "uifBacklogResource", ()=>$9905b3c28d313f7e$export$c182dffb98985208);
    var $dIdda = parcelRequire("dIdda");
    const $9905b3c28d313f7e$export$db83ef0443397b85 = (0, $dIdda.createResource)({
        type: (0, $2fdbe99f6cbea4f1$export$8f9824ba4409b537),
        getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>[
                'uif-backlog-data'
            ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
        getDataLoader: ()=>(parcelRequire("6b32i")),
        maxAge: 0
    });
    const $9905b3c28d313f7e$export$c182dffb98985208 = (0, $dIdda.createResource)({
        type: (0, $2fdbe99f6cbea4f1$export$d15ce4feabd76ea),
        getKey: ({ match: { params: { boardId: boardId } }, query: { config: config } })=>[
                'uif-backlog-data'
            ].concat(boardId ?? '').concat(config ? `config-${config}` : '').filter(Boolean).join('-'),
        getDataLoader: ()=>(parcelRequire("6zLm4")),
        maxAge: 0
    });
});
const $2fdbe99f6cbea4f1$export$d15ce4feabd76ea = 'NEXTGEN_BACKLOG_REST';
const $2fdbe99f6cbea4f1$export$8f9824ba4409b537 = 'NEXTGEN_BACKLOG_REST_OLD';
parcelRegister("6b32i", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hgAfI").then(()=>parcelRequire('gTjY8'));
});
parcelRegister("6zLm4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8723H").then(()=>parcelRequire('cpSf8'));
});
parcelRegister("3R260", function(module, exports) {
    $parcel$export(module.exports, "boardConfigResource", ()=>$2e0f91ad67d4bd03$export$5d16d5f1340da88f);
    var $dIdda = parcelRequire("dIdda");
    var $1odlY;
    const $2e0f91ad67d4bd03$export$5d16d5f1340da88f = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("1odlY")).RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("it1fP")),
        maxAge: Number.MAX_VALUE,
        isBrowserOnly: true
    });
});
parcelRegister("1odlY", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG", ()=>$fa7f7a1583a8dcf1$export$88e2a0b89be042c1);
    $parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA", ()=>$fa7f7a1583a8dcf1$export$ba075d0985968d1c);
    $parcel$export(module.exports, "RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS", ()=>$fa7f7a1583a8dcf1$export$395f77888d07f2e0);
    $parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_RESOURCE", ()=>$fa7f7a1583a8dcf1$export$4f7c4e3508fd2a07);
    $parcel$export(module.exports, "RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE", ()=>$fa7f7a1583a8dcf1$export$3328c8e71fda97bb);
    $parcel$export(module.exports, "WRM_RESOURCES_ARRAY", ()=>$fa7f7a1583a8dcf1$export$ef21257df3d71188);
    $parcel$export(module.exports, "WRM_HERITAGE_RESOURCES_FHD_ARRAY", ()=>$fa7f7a1583a8dcf1$export$ccd0929652c235de);
    $parcel$export(module.exports, "WRM_BOARD_RESOURCES_FHD_ARRAY", ()=>$fa7f7a1583a8dcf1$export$1d16bdcc94a40107);
    $parcel$export(module.exports, "WRM_BACKLOG_RESOURCES_FHD_ARRAY", ()=>$fa7f7a1583a8dcf1$export$1f599d2eef0a7281);
    const $fa7f7a1583a8dcf1$export$88e2a0b89be042c1 = 'RESOURCE_RAPIDBOARDS_BOARD_CONFIG';
    const $fa7f7a1583a8dcf1$export$ba075d0985968d1c = 'RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA';
    const $fa7f7a1583a8dcf1$export$395f77888d07f2e0 = 'PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS';
    const $fa7f7a1583a8dcf1$export$4f7c4e3508fd2a07 = 'RESOURCE_TYPE_RAPIDBOARDS_RESOURCE';
    const $fa7f7a1583a8dcf1$export$75dfa03544a19422 = 'ROADMAP';
    const $fa7f7a1583a8dcf1$export$3328c8e71fda97bb = 'RESOURCE_RAPIDBOARDS_WRM_BUNDLE';
    const $fa7f7a1583a8dcf1$export$ef21257df3d71188 = [
        '_super',
        'wrc!greenhopper-rapid-non-gadget',
        'wrc!gh-rapid',
        'wrc!jira.global',
        'wrc!jira.general',
        'wrc!atl.global',
        'wrc!jira.webresources:header',
        'wrc!jira.webresources:calendar',
        'wrc!jira.webresources:calendar-en',
        'wrc!jira.webresources:jira.webresources:calendar-localisation-moment',
        'wrc!com.atlassian.jira.project-templates-plugin:project-templates-plugin-resources',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-aui-toggle',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:profilecard',
        'wrc!gh-rapid-config',
        'wrc!gh-rapid-analytics',
        'wrc!gh-rapid-charts',
        'wrc!jira.webresources:mentions-feature',
        'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-dialog-resources-ctx'
    ];
    const $fa7f7a1583a8dcf1$export$ccd0929652c235de = [];
    const $fa7f7a1583a8dcf1$export$1d16bdcc94a40107 = [
        'wrc!gh-rapid-lwf-board-fhd',
        'wrc!jira.webresources:skate',
        'wrc!jira.webresources:feature-flags',
        'wrc!com.atlassian.auiplugin:aui-spinner',
        'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
        'wrc!com.atlassian.analytics.analytics-client:js-events'
    ];
    const $fa7f7a1583a8dcf1$export$1f599d2eef0a7281 = [
        'wrc!gh-rapid-backlog-fhd',
        'wrc!jira.webresources:skate',
        'wrc!jira.webresources:header',
        'wrc!jira.webresources:feature-flags',
        'wrc!com.atlassian.auiplugin:aui-spinner',
        'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
        'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
        'wrc!com.atlassian.analytics.analytics-client:js-events'
    ];
});
parcelRegister("it1fP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fEbPN").then(()=>parcelRequire('2M4Kz'));
});
parcelRegister("i6CNv", function(module, exports) {
    $parcel$export(module.exports, "boardConfigApiResource", ()=>$8a55ba0bef7e0e2a$export$dd9dec064acb0c4e);
    var $co1wz;
    var $dIdda = parcelRequire("dIdda");
    var $1odlY;
    const $8a55ba0bef7e0e2a$var$configResourceCacheTime = ()=>(0, (0, parcelRequire("co1wz")).getFeatureFlagValue)('jsw.classic.board.api-calls.config-cache-time', 0);
    const $8a55ba0bef7e0e2a$export$dd9dec064acb0c4e = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("1odlY")).RESOURCE_TYPE_RAPIDBOARDS_BOARD_CONFIG),
        getKey: ({ match: match, query: query })=>{
            const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
            return `rapidViewConfig-${boardId}`;
        },
        getDataLoader: ()=>(parcelRequire("ifUKB")),
        maxAge: false ? 0 : $8a55ba0bef7e0e2a$var$configResourceCacheTime() * 1000,
        isBrowserOnly: true
    });
});
parcelRegister("ifUKB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dz3p9").then(()=>parcelRequire('aCQV9'));
});
parcelRegister("kdyVI", function(module, exports) {
    $parcel$export(module.exports, "boardDataResource", ()=>$18aa0ee73b651f62$export$138fa635416978f7);
    var $dIdda = parcelRequire("dIdda");
    var $1odlY;
    var $9g2vH;
    const $18aa0ee73b651f62$export$138fa635416978f7 = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("1odlY")).RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA),
        getKey: ({ match: match, query: query, route: route })=>{
            const { name: name = '' } = route || {};
            const boardId = match.params.boardId != null ? match.params.boardId : query.rapidView;
            const { config: config } = query;
            const hasConfig = Boolean(config);
            let key = 'rapidBoardData';
            if ((0, (0, parcelRequire("9g2vH")).isBoardRoute)(name)) key = `boardData-${boardId}::hasConfig=${hasConfig}`;
            else if ((0, (0, parcelRequire("9g2vH")).isBacklogRoute)(name)) key = `backlogData-${boardId}::hasConfig=${hasConfig}`;
            return key;
        },
        getDataLoader: ()=>(parcelRequire("bnQeN")),
        maxAge: 0,
        isBrowserOnly: true
    });
});
parcelRegister("9g2vH", function(module, exports) {
    $parcel$export(module.exports, "isBoardRoute", ()=>$ccbac8c858ea0da2$export$437d4d6e25681588);
    $parcel$export(module.exports, "isBacklogRoute", ()=>$ccbac8c858ea0da2$export$bcb853db5e3e8054);
    var $65Ltd;
    const $ccbac8c858ea0da2$export$437d4d6e25681588 = (routeName)=>routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BOARD) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS);
    const $ccbac8c858ea0da2$export$bcb853db5e3e8054 = (routeName)=>routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED);
});
parcelRegister("bnQeN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("75jqm").then(()=>parcelRequire('iW9CS'));
});
parcelRegister("5jCaw", function(module, exports) {
    $parcel$export(module.exports, "initialAllDataResource", ()=>$df03d49e5d06a603$export$4680aabd39eb6d1c);
    var $dIdda = parcelRequire("dIdda");
    var $1odlY;
    const $df03d49e5d06a603$export$4680aabd39eb6d1c = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("1odlY")).RESOURCE_TYPE_RAPIDBOARDS_WRM_INITIAL_ALL_DATA),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("69EhV")),
        maxAge: Number.MAX_VALUE,
        isBrowserOnly: true
    });
});
parcelRegister("69EhV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9aQb5").then(()=>parcelRequire('GLfv4'));
});
parcelRegister("gQ2J4", function(module, exports) {
    $parcel$export(module.exports, "rapidboardResource", ()=>$b172ecb4db4f1d22$export$d0f42a55e7c5752c);
    var $dIdda = parcelRequire("dIdda");
    var $1odlY;
    const $b172ecb4db4f1d22$export$d0f42a55e7c5752c = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("1odlY")).RESOURCE_TYPE_RAPIDBOARDS_RESOURCE),
        getKey: ({ match: match })=>match.query.rapidView || '',
        getDataLoader: ()=>(parcelRequire("4ajRG")),
        maxAge: Number.MAX_VALUE,
        isBrowserOnly: true
    });
});
parcelRegister("4ajRG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hq4Ox").then(()=>parcelRequire('LP66E'));
});
parcelRegister("fox5Q", function(module, exports) {
    $parcel$export(module.exports, "wrmBundleResource", ()=>$bb15c3971b88e6fc$export$f199d15b7cd18df1);
    var $dIdda = parcelRequire("dIdda");
    var $1odlY;
    const $bb15c3971b88e6fc$export$f199d15b7cd18df1 = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("1odlY")).RESOURCE_TYPE_RAPIDBOARDS_WRM_BUNDLE),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("8kiyc")),
        maxAge: Number.MAX_SAFE_INTEGER,
        isBrowserOnly: true
    });
});
parcelRegister("8kiyc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3c33e").then(()=>parcelRequire('bdOyr'));
});
parcelRegister("2GkDw", function(module, exports) {
    $parcel$export(module.exports, "devOpsProviderResource", ()=>$3640b01f63c1fd17$export$19e58e21b24ae0d8);
    var $dIdda = parcelRequire("dIdda");
    const $3640b01f63c1fd17$export$19e58e21b24ae0d8 = (0, $dIdda.createResource)({
        type: (0, $e9cf201ab81d4288$export$5f92e516f4b78544),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("f6n3Y")),
        maxAge: 60000
    });
    const $3640b01f63c1fd17$export$b80f5852c41a5ca8 = ()=>(0, $dIdda.useResource)($3640b01f63c1fd17$export$19e58e21b24ae0d8);
});
const $e9cf201ab81d4288$export$5f92e516f4b78544 = 'SOFTWARE_DEVOPS_PROVIDERS';
const $e9cf201ab81d4288$export$d7f081d6dd0e72fc = 'bitbucket';
const $e9cf201ab81d4288$export$832d1d859726f915 = 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9';
const $e9cf201ab81d4288$export$5007979ef33118fc = 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N';
parcelRegister("f6n3Y", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7G5IV").then(()=>parcelRequire('2MQ7j'));
});
parcelRegister("hJAri", function(module, exports) {
    $parcel$export(module.exports, "classicRoadmapResource", ()=>$b200b290d50f82d3$export$e755913caca1ab8e);
    var $dIdda = parcelRequire("dIdda");
    const $b200b290d50f82d3$export$e755913caca1ab8e = (0, $dIdda.createResource)({
        type: (0, $87d7efe6336d8b83$export$75dfa03544a19422),
        getKey: ({ match: match })=>match.params.boardId || '',
        getDataLoader: ()=>(parcelRequire("2Pkdr")),
        isBrowserOnly: true
    });
});
const $87d7efe6336d8b83$export$75dfa03544a19422 = 'ROADMAP';
const $87d7efe6336d8b83$export$e905b9170ecbb599 = 'BOARD_CONTEXT_ROADMAP_SETTINGS';
parcelRegister("2Pkdr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8MG8R").then(()=>parcelRequire('g52eJ'));
});
parcelRegister("iZ82x", function(module, exports) {
    $parcel$export(module.exports, "codePageResource", ()=>$06e9ff5230710b90$export$642ce64cf3689406);
    var $65Ltd;
    var $ao2h1;
    var $euUUL;
    var $6mT2K;
    let $06e9ff5230710b90$var$numPullRequestsToFetch = 0;
    const $06e9ff5230710b90$export$642ce64cf3689406 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $96625f88cf395132$export$94a43d2ac55ac375),
        getQuery ({ match: { params: params }, query: query, route: { name: name } }, { tenantContext: { cloudId: cloudId } }) {
            const isCodeRoute = name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CODE) || name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CODE_CLASSIC);
            if (!$06e9ff5230710b90$var$numPullRequestsToFetch && isCodeRoute) $06e9ff5230710b90$var$numPullRequestsToFetch = (0, (0, parcelRequire("6mT2K")).getNumPullRequestsToFetch)(query);
            if (!isCodeRoute) $06e9ff5230710b90$var$numPullRequestsToFetch = 0;
            return {
                parameters: (0, (0, parcelRequire("euUUL")).default),
                options: {
                    fetchPolicy: 'store-and-network'
                },
                variables: {
                    cloudId: cloudId,
                    projectKey: params.projectKey ?? '',
                    pullRequestsUpdatedFrom: (0, (0, parcelRequire("6mT2K")).getPullRequestsUpdatedFromDate)(),
                    numPullRequestsToFetch: $06e9ff5230710b90$var$numPullRequestsToFetch,
                    siteAri: `ari:cloud:jira::site/${cloudId}`
                }
            };
        }
    });
});
parcelRegister("euUUL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1914e75096664626$export$2e2bcd8739ae039);
    var $h8xcT;
    const $1914e75096664626$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "numPullRequestsToFetch"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pullRequestsUpdatedFrom"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "siteAri"
        }, v5 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "siteAri"
            },
            {
                "kind": "Literal",
                "name": "providerTypes",
                "value": [
                    "DEV_INFO"
                ]
            }
        ], v6 = {
            "kind": "ScalarField",
            "name": "id"
        }, v7 = {
            "kind": "ScalarField",
            "name": "name"
        }, v8 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v9 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v10 = [
            v9
        ], v11 = {
            "kind": "ScalarField",
            "name": "status"
        }, v12 = {
            "concreteType": "JiraConfigStateConnection",
            "kind": "LinkedField",
            "name": "config",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraConfigState",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "appId"
                        },
                        v11
                    ]
                }
            ]
        }, v13 = [
            v12
        ], v14 = [
            v8
        ], v15 = [
            {
                "kind": "Literal",
                "name": "appId",
                "value": "bitbucket"
            },
            v9
        ], v16 = [
            v9,
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v17 = [
            {
                "kind": "Literal",
                "name": "sort",
                "value": {
                    "lastModified": {
                        "direction": "DESC",
                        "priority": 1
                    }
                }
            }
        ], v18 = [
            v12,
            v6
        ], v19 = {
            "kind": "ScalarField",
            "name": "lastUpdated"
        }, v20 = {
            "kind": "ScalarField",
            "name": "url"
        }, v21 = [
            v8,
            {
                "kind": "ScalarField",
                "name": "accountId"
            },
            v7,
            {
                "kind": "ScalarField",
                "name": "picture"
            },
            v6
        ], v22 = [
            v6
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4
                ],
                "kind": "Fragment",
                "name": "mainCodeInJiraUpdatedQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "DevOps",
                            "kind": "LinkedField",
                            "name": "devOps",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v5,
                                        "concreteType": "DevOpsProviders",
                                        "kind": "LinkedField",
                                        "name": "providers",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "DevOpsDevInfoProvider",
                                                "kind": "LinkedField",
                                                "name": "devInfoProviders",
                                                "plural": true,
                                                "selections": [
                                                    v6,
                                                    v7,
                                                    v8,
                                                    {
                                                        "args": v10,
                                                        "concreteType": "JiraAppConfigState",
                                                        "kind": "LinkedField",
                                                        "name": "configState",
                                                        "plural": false,
                                                        "selections": v13
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "devOps.providers"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "devOps"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": v10,
                            "concreteType": "CodeInJira",
                            "kind": "LinkedField",
                            "name": "codeInJira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "CodeInJiraUserConfiguration",
                                        "kind": "LinkedField",
                                        "name": "userConfiguration",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "CodeInJiraBitbucketWorkspace",
                                                    "kind": "LinkedField",
                                                    "name": "ownedBitbucketWorkspaces",
                                                    "plural": true,
                                                    "selections": v14
                                                },
                                                "action": "THROW",
                                                "path": "codeInJira.userConfiguration.ownedBitbucketWorkspaces"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "codeInJira.userConfiguration"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "codeInJira"
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraDevOpsQuery",
                                "kind": "LinkedField",
                                "name": "devOps",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v15,
                                        "concreteType": "JiraAppConfigState",
                                        "kind": "LinkedField",
                                        "name": "configState",
                                        "plural": false,
                                        "selections": v13
                                    }
                                ]
                            },
                            {
                                "args": v16,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v17,
                                        "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                                        "kind": "LinkedField",
                                        "name": "repositories",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": v14
                                            }
                                        ],
                                        "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "main_softwareCodePage_MainPage"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "main_softwareCodePage_Header"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "main_softwareCodePage_ConnectionPage"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v2,
                    v1,
                    v3,
                    v4,
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcimprovecodepageemptystaterelayprovider"
                    }
                ],
                "kind": "Operation",
                "name": "mainCodeInJiraUpdatedQuery",
                "selections": [
                    {
                        "concreteType": "DevOps",
                        "kind": "LinkedField",
                        "name": "devOps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v5,
                                "concreteType": "DevOpsProviders",
                                "kind": "LinkedField",
                                "name": "providers",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "DevOpsDevInfoProvider",
                                        "kind": "LinkedField",
                                        "name": "devInfoProviders",
                                        "plural": true,
                                        "selections": [
                                            v6,
                                            v7,
                                            v8,
                                            {
                                                "args": v10,
                                                "concreteType": "JiraAppConfigState",
                                                "kind": "LinkedField",
                                                "name": "configState",
                                                "plural": false,
                                                "selections": v18
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "homeUrl"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "namespace"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "args": v10,
                        "concreteType": "CodeInJira",
                        "kind": "LinkedField",
                        "name": "codeInJira",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "CodeInJiraUserConfiguration",
                                "kind": "LinkedField",
                                "name": "userConfiguration",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "CodeInJiraBitbucketWorkspace",
                                        "kind": "LinkedField",
                                        "name": "ownedBitbucketWorkspaces",
                                        "plural": true,
                                        "selections": [
                                            v8,
                                            {
                                                "kind": "ScalarField",
                                                "name": "uuid"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "slug"
                                            },
                                            v7
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraDevOpsQuery",
                                "kind": "LinkedField",
                                "name": "devOps",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v15,
                                        "concreteType": "JiraAppConfigState",
                                        "kind": "LinkedField",
                                        "name": "configState",
                                        "plural": false,
                                        "selections": v18
                                    }
                                ]
                            },
                            {
                                "args": v16,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v17,
                                        "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                                        "kind": "LinkedField",
                                        "name": "repositories",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    v8,
                                                    v6,
                                                    v19,
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v8,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v6,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "providerId"
                                                                    },
                                                                    v7,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "avatarUrl"
                                                                    },
                                                                    v20
                                                                ],
                                                                "type": "DevOpsRepository"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
                                    },
                                    v6,
                                    {
                                        "args": [
                                            {
                                                "fields": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "updatedFrom",
                                                        "variableName": "pullRequestsUpdatedFrom"
                                                    }
                                                ],
                                                "kind": "ObjectValue",
                                                "name": "filter"
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "first",
                                                "variableName": "numPullRequestsToFetch"
                                            },
                                            {
                                                "kind": "Literal",
                                                "name": "sort",
                                                "value": {
                                                    "lastUpdatedSortDirection": "DESC"
                                                }
                                            },
                                            {
                                                "kind": "Literal",
                                                "name": "type",
                                                "value": "project-associated-pr"
                                            }
                                        ],
                                        "concreteType": "AriGraphRelationshipConnection",
                                        "kind": "LinkedField",
                                        "name": "devOpsEntityRelationships",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "AriGraphRelationshipEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "AriGraphRelationship",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "AriGraphRelationshipNode",
                                                                "kind": "LinkedField",
                                                                "name": "to",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "data",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v8,
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    v11,
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "repositoryName"
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "repositoryId"
                                                                                    },
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "author",
                                                                                        "plural": false,
                                                                                        "selections": v21
                                                                                    },
                                                                                    {
                                                                                        "concreteType": "DevOpsReviewer",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "reviewers",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "user",
                                                                                                "plural": false,
                                                                                                "selections": v21
                                                                                            },
                                                                                            v8,
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "approvalStatus"
                                                                                            },
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "userId"
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "title"
                                                                                    },
                                                                                    v6,
                                                                                    v19,
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "commentCount"
                                                                                    },
                                                                                    v20,
                                                                                    {
                                                                                        "concreteType": "DevOpsBranchInfo",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "destinationBranch",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v7,
                                                                                            v20
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "pullRequestInternalId"
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "repositoryUrl"
                                                                                    },
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "authorId"
                                                                                    }
                                                                                ],
                                                                                "type": "DevOpsPullRequestDetails"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "Node",
                                                                                "abstractKey": "__isNode"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "ConfluencePage"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "ConfluenceSpace"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "DevOpsFeatureFlag"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "DevOpsOperationsComponentDetails"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "DevOpsOperationsIncidentDetails"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "DevOpsRepository"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "DevOpsSecurityVulnerabilityDetails"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "JiraConfluenceRemoteIssueLink"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "JiraCustomRemoteIssueLink"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "JiraIssueRemoteIssueLink"
                                                                            },
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": v22,
                                                                                "type": "JiraWebRemoteIssueLink"
                                                                            }
                                                                        ]
                                                                    },
                                                                    v6
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "PageInfo",
                                                "kind": "LinkedField",
                                                "name": "pageInfo",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasNextPage"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "133ff17ae88c722ba1d91f8fc407b9e8f0d1a640a4c93ec27cfe43dd6ef0142b",
                "metadata": {},
                "name": "mainCodeInJiraUpdatedQuery",
                "operationKind": "query",
                "text": null,
                "providedVariables": {
                    "__relay_internal__pv__atlassianjirarelayprovidersrcimprovecodepageemptystaterelayprovider": (0, (0, parcelRequire("h8xcT")).default)
                }
            }
        };
    }();
    $1914e75096664626$var$node.hash = "02f9224d53652182a109e4936760d09f";
    var $1914e75096664626$export$2e2bcd8739ae039 = $1914e75096664626$var$node;
});
parcelRegister("h8xcT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f9ec23850e5424c$export$2e2bcd8739ae039);
    var $6s1PB;
    var $7f9ec23850e5424c$export$2e2bcd8739ae039 = {
        get () {
            const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jira_improve_scm_onboarding');
            return expConfig.get('isEnabled', false);
        }
    };
});
parcelRegister("6mT2K", function(module, exports) {
    $parcel$export(module.exports, "isBitbucketProvider", ()=>$e46b745b21c77b2f$export$1f508885be28c4e);
    $parcel$export(module.exports, "codeErrorBoundaryAttributes", ()=>$e46b745b21c77b2f$export$ea10bb8bdf2072e5);
    $parcel$export(module.exports, "toSanitizedUrl", ()=>$e46b745b21c77b2f$export$36fdccbdcd093523);
    $parcel$export(module.exports, "useIsOverflowWidth", ()=>$e46b745b21c77b2f$export$2dcd60313c8d761b);
    $parcel$export(module.exports, "getPullRequestsUpdatedFromDate", ()=>$e46b745b21c77b2f$export$3784bdf6b4807521);
    $parcel$export(module.exports, "getNumPullRequestsToFetch", ()=>$e46b745b21c77b2f$export$a837c7c9c7670570);
    var $5uXOq = parcelRequire("5uXOq");
    var $5kchp = parcelRequire("5kchp");
    var $it1wb;
    var $gn1v9;
    var $eY2eW;
    var $1tSBh;
    const $e46b745b21c77b2f$export$36ebc9cd52c6b517 = (repository)=>repository === (0, (0, parcelRequire("1tSBh")).RepositoryTypes).REPO_BITBUCKET;
    const $e46b745b21c77b2f$export$1f508885be28c4e = (providerId)=>providerId === (0, (0, parcelRequire("eY2eW")).VcsProviderIds).BITBUCKET || providerId === (0, (0, parcelRequire("eY2eW")).DataDepotProviderIds).BITBUCKET_PROD || providerId === (0, (0, parcelRequire("eY2eW")).DataDepotProviderIds).BITBUCKET_STG;
    const $e46b745b21c77b2f$var$shouldCountToReliability = (error)=>{
        const okayErrors = [
            ...(0, (0, parcelRequire("eY2eW")).nonCriticalGqlErrors),
            ...(0, (0, parcelRequire("eY2eW")).nonReliabilityCriticalErrors)
        ];
        return !okayErrors.includes(error.message);
    };
    const $e46b745b21c77b2f$export$ea10bb8bdf2072e5 = (error)=>{
        if (error instanceof Error) return {
            countToReliability: $e46b745b21c77b2f$var$shouldCountToReliability(error)
        };
        return {
            countToReliability: true
        };
    };
    const $e46b745b21c77b2f$export$36fdccbdcd093523 = (url)=>(0, $5kchp.sanitizeUrl)(url);
    const $e46b745b21c77b2f$export$2dcd60313c8d761b = (ref, callback)=>{
        const [isOverflow, setIsOverflow] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useLayoutEffect)(()=>{
            const { current: current } = ref;
            const trigger = ()=>{
                const hasOverflow = current.scrollWidth > current.clientWidth;
                setIsOverflow(hasOverflow);
                if (callback) callback(hasOverflow);
            };
            if (current) {
                if ('ResizeObserver' in window) new ResizeObserver(trigger).observe(current);
                trigger();
            }
        }, [
            callback,
            ref
        ]);
        return isOverflow;
    };
    const $e46b745b21c77b2f$export$3784bdf6b4807521 = ()=>(0, (0, parcelRequire("it1wb")).default)((0, (0, parcelRequire("gn1v9")).default)(new Date(), {
            days: (0, (0, parcelRequire("eY2eW")).PULL_REQUESTS_UPDATED_FROM_NUMBER_OF_DAYS)
        })).toISOString();
    const $e46b745b21c77b2f$export$a837c7c9c7670570 = (queryParams)=>{
        const hasFilterOrSortQueryParam = Object.entries(queryParams).some(([key, value])=>(0, (0, parcelRequire("eY2eW")).queryParamsToWatch).includes(key) && value !== '');
        return hasFilterOrSortQueryParam ? (0, (0, parcelRequire("eY2eW")).MAX_NUMBER_OF_PULL_REQUESTS_TO_QUERY) : (0, (0, parcelRequire("eY2eW")).PULL_REQUESTS_TABLE_PAGE_SIZE);
    };
});
parcelRegister("5kchp", function(module, exports) {
    'use strict';
    var $3e0858899f98084b$var$invalidPrototcolRegex = /^(%20|\s)*(javascript|data)/im;
    var $3e0858899f98084b$var$ctrlCharactersRegex = /[^\x20-\x7E]/gmi;
    var $3e0858899f98084b$var$urlSchemeRegex = /^([^:]+):/gm;
    var $3e0858899f98084b$var$relativeFirstCharacters = [
        '.',
        '/'
    ];
    function $3e0858899f98084b$var$isRelativeUrl(url) {
        return $3e0858899f98084b$var$relativeFirstCharacters.indexOf(url[0]) > -1;
    }
    function $3e0858899f98084b$var$sanitizeUrl(url) {
        if (!url) return 'about:blank';
        var urlScheme, urlSchemeParseResults;
        var sanitizedUrl = url.replace($3e0858899f98084b$var$ctrlCharactersRegex, '');
        if ($3e0858899f98084b$var$isRelativeUrl(sanitizedUrl)) return sanitizedUrl;
        urlSchemeParseResults = sanitizedUrl.match($3e0858899f98084b$var$urlSchemeRegex);
        if (!urlSchemeParseResults) return 'about:blank';
        urlScheme = urlSchemeParseResults[0];
        if ($3e0858899f98084b$var$invalidPrototcolRegex.test(urlScheme)) return 'about:blank';
        return sanitizedUrl;
    }
    module.exports = {
        sanitizeUrl: $3e0858899f98084b$var$sanitizeUrl
    };
});
parcelRegister("eY2eW", function(module, exports) {
    $parcel$export(module.exports, "nonCriticalGqlErrors", ()=>$a2f3556545768e94$export$4b1abe4db5ed7515);
    $parcel$export(module.exports, "nonReliabilityCriticalErrors", ()=>$a2f3556545768e94$export$687544614e0812da);
    $parcel$export(module.exports, "cardBoxShadow", ()=>$a2f3556545768e94$export$7527a73da794030d);
    $parcel$export(module.exports, "cardBoxHoverShadow", ()=>$a2f3556545768e94$export$2ecfdc24b216c295);
    $parcel$export(module.exports, "MAX_NUMBER_OF_PULL_REQUESTS_TO_QUERY", ()=>$a2f3556545768e94$export$f84c6b6609a3dd30);
    $parcel$export(module.exports, "PULL_REQUESTS_TABLE_PAGE_SIZE", ()=>$a2f3556545768e94$export$ea15b38f3901f518);
    $parcel$export(module.exports, "PULL_REQUESTS_UPDATED_FROM_NUMBER_OF_DAYS", ()=>$a2f3556545768e94$export$2b8b0a4489f9147b);
    $parcel$export(module.exports, "COLLAPSIBLE_REGION_ID", ()=>$a2f3556545768e94$export$3b8f88133d28aaa6);
    $parcel$export(module.exports, "REPOSITORIES_HEADER_ID", ()=>$a2f3556545768e94$export$256a9f141103f328);
    $parcel$export(module.exports, "COLLAPSIBLE_REGION_DESCRIPTION_ID", ()=>$a2f3556545768e94$export$b0d4e90e40369b80);
    $parcel$export(module.exports, "featureIdToHelpMap", ()=>$a2f3556545768e94$export$1de4eaccc23a8747);
    $parcel$export(module.exports, "FILTER_CONTAINER_TEST_ID", ()=>$a2f3556545768e94$export$5c00a6bedc2037c8);
    $parcel$export(module.exports, "NO_RESULTS_CLEAR_FILTERS_BUTTON_TEST_ID", ()=>$a2f3556545768e94$export$f70ce14ba902adcb);
    $parcel$export(module.exports, "PULL_REQUESTS_TABLE_TEST_ID", ()=>$a2f3556545768e94$export$19381ed4387aa05b);
    $parcel$export(module.exports, "PULL_REQUESTS_DYNAMIC_TABLE_TEST_ID", ()=>$a2f3556545768e94$export$f3e116f999d4c5c1);
    $parcel$export(module.exports, "PULL_REQUESTS_EMPTY_STATE_TEST_ID", ()=>$a2f3556545768e94$export$c28f1cd40ae0394c);
    $parcel$export(module.exports, "SUMMARY_CELL_TEST_ID", ()=>$a2f3556545768e94$export$f69d7aa9c5e17d55);
    $parcel$export(module.exports, "SUMMARY_CELL_TITLE_LINK_TEST_ID", ()=>$a2f3556545768e94$export$4ed9a8a7faf641f);
    $parcel$export(module.exports, "SUMMARY_CELL_TARGET_BRANCH_LINK_TEST_ID", ()=>$a2f3556545768e94$export$c5322e755fd1028d);
    $parcel$export(module.exports, "SUMMARY_CELL_REPOSITORY_LINK_TEST_ID", ()=>$a2f3556545768e94$export$72fcd104fde041d6);
    $parcel$export(module.exports, "REVIEWERS_CELL_TEST_ID", ()=>$a2f3556545768e94$export$d8f600a480a9c2d4);
    $parcel$export(module.exports, "STATUS_CELL_TEST_ID", ()=>$a2f3556545768e94$export$9d9ab707c4e446cc);
    $parcel$export(module.exports, "COMMENTS_CELL_TEST_ID", ()=>$a2f3556545768e94$export$4da3056fdbfaf111);
    $parcel$export(module.exports, "LAST_UPDATED_CELL_TEST_ID", ()=>$a2f3556545768e94$export$e1134688b6a1032);
    $parcel$export(module.exports, "PULL_REQUESTS_ERROR_STATE_TEST_ID", ()=>$a2f3556545768e94$export$143249aa50321d51);
    $parcel$export(module.exports, "REPOSITORIES_ERROR_STATE_TEST_ID", ()=>$a2f3556545768e94$export$a46febdd3fe90de0);
    $parcel$export(module.exports, "IMPROVED_SCM_CONFIG_SCREEN_ERROR_TEST_ID", ()=>$a2f3556545768e94$export$333db4cac7ee017);
    $parcel$export(module.exports, "IMPROVE_READY_TO_CONNECT_EMPTY_STATE_TEST_ID", ()=>$a2f3556545768e94$export$5cbae081959768bd);
    $parcel$export(module.exports, "REPOSITORIES_FILTER_BUTTON_TEST_ID", ()=>$a2f3556545768e94$export$4939c117ba49bc9e);
    $parcel$export(module.exports, "AUTHOR_FILTER_BUTTON_TEST_ID", ()=>$a2f3556545768e94$export$5a92d7579dac6294);
    $parcel$export(module.exports, "REVIEWERS_FILTER_BUTTON_TEST_ID", ()=>$a2f3556545768e94$export$a77ea162c15f0290);
    $parcel$export(module.exports, "STATUS_FILTER_BUTTON_TEST_ID", ()=>$a2f3556545768e94$export$b7477204cae64b46);
    $parcel$export(module.exports, "QUERY_PARAM_SUMMARY", ()=>$a2f3556545768e94$export$39983b6fb040a5eb);
    $parcel$export(module.exports, "QUERY_PARAM_AUTHORS", ()=>$a2f3556545768e94$export$3d96f5f9ccd35be6);
    $parcel$export(module.exports, "QUERY_PARAM_REVIEWERS", ()=>$a2f3556545768e94$export$8a8927c29ab32b10);
    $parcel$export(module.exports, "QUERY_PARAM_STATUS", ()=>$a2f3556545768e94$export$3e8168848b996f7);
    $parcel$export(module.exports, "QUERY_PARAM_REPOSITORIES", ()=>$a2f3556545768e94$export$4adc519ba40b72a6);
    $parcel$export(module.exports, "QUERY_PARAM_SORT_KEY", ()=>$a2f3556545768e94$export$6da773286c35ef41);
    $parcel$export(module.exports, "QUERY_PARAM_SORT_ORDER", ()=>$a2f3556545768e94$export$810a1f7ed2facfcb);
    $parcel$export(module.exports, "queryParamsToWatch", ()=>$a2f3556545768e94$export$ba75fb5089c0eb0b);
    $parcel$export(module.exports, "VcsProviderIds", ()=>$a2f3556545768e94$export$7d5c3d28df5f438a);
    $parcel$export(module.exports, "DataDepotProviderIds", ()=>$a2f3556545768e94$export$7912a169c18abe9d);
    $parcel$export(module.exports, "FEEDBACK_COLLECTOR_LOCATION", ()=>$a2f3556545768e94$export$74189cec821240a6);
    $parcel$export(module.exports, "eligibleForConfigurationScreenStatuses", ()=>$a2f3556545768e94$export$3f3fc252f5066c72);
    $parcel$export(module.exports, "notEligibleForConfigurationScreenStatuses", ()=>$a2f3556545768e94$export$9ce5b1bba5f17875);
    const $a2f3556545768e94$export$4b1abe4db5ed7515 = [
        'HTTP status [403] while retrieving Bitbucket repository.',
        'HTTP status [404] while retrieving Bitbucket repository.',
        "Failed to retrieve Bitbucket repository because the user wasn't authorized."
    ];
    const $a2f3556545768e94$export$687544614e0812da = [
        'HTTP status [429] while retrieving Bitbucket repository.',
        "The user does not have 'View Development Tools' permission for the Jira project or the project does not exist",
        'The user does not have admin permission for the site, Jira, project or the project does not exist.',
        'Unable to get providers when contacting Jira due to 401 Unauthorized'
    ];
    const $a2f3556545768e94$export$7527a73da794030d = "var(--ds-shadow-overflow, 0 1px 1px rgb(9 30 66 / 25%), 0 0 1px 1px rgb(9 30 66 / 13%))";
    const $a2f3556545768e94$export$2ecfdc24b216c295 = "var(--ds-shadow-overflow, rgba(9, 30, 66, 0.31) 0px 0px 1px 0px, rgba(9, 30, 66, 0.25) 0px 8px 16px -6px)";
    const $a2f3556545768e94$export$f84c6b6609a3dd30 = 1000;
    const $a2f3556545768e94$export$ea15b38f3901f518 = 12;
    const $a2f3556545768e94$export$2b8b0a4489f9147b = 30;
    const $a2f3556545768e94$export$3b8f88133d28aaa6 = 'collapsible-repository-list';
    const $a2f3556545768e94$export$256a9f141103f328 = 'repository-list-header';
    const $a2f3556545768e94$export$b0d4e90e40369b80 = 'repository-list-description';
    const $a2f3556545768e94$export$1de4eaccc23a8747 = {
        'repository-list.pull-requests.empty-state': {
            helpArticleId: '5WUm7jlQnN9aiw9KOp1Ks1',
            href: 'https://support.atlassian.com/jira-software-cloud/docs/view-development-information-for-an-issue/'
        },
        'repository-list.pull-requests.description': {
            helpArticleId: '5WUm7jlQnN9aiw9KOp1Ks1',
            href: 'https://support.atlassian.com/jira-software-cloud/docs/view-development-information-for-an-issue/'
        }
    };
    const $a2f3556545768e94$export$5c00a6bedc2037c8 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.filter-container';
    const $a2f3556545768e94$export$f70ce14ba902adcb = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.no-results.clearfiltersbutton';
    const $a2f3556545768e94$export$19381ed4387aa05b = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-table';
    const $a2f3556545768e94$export$f3e116f999d4c5c1 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-table.dynamic-table';
    const $a2f3556545768e94$export$c28f1cd40ae0394c = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.pull-requests-empty-state';
    const $a2f3556545768e94$export$f69d7aa9c5e17d55 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filtered-table.pull-request-table.summary-cell';
    const $a2f3556545768e94$export$4ed9a8a7faf641f = `${$a2f3556545768e94$export$f69d7aa9c5e17d55}.title-link`;
    const $a2f3556545768e94$export$c5322e755fd1028d = `${$a2f3556545768e94$export$f69d7aa9c5e17d55}.target-branch-link`;
    const $a2f3556545768e94$export$72fcd104fde041d6 = `${$a2f3556545768e94$export$f69d7aa9c5e17d55}.repository-link`;
    const $a2f3556545768e94$export$d8f600a480a9c2d4 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.reviewers-cell';
    const $a2f3556545768e94$export$9d9ab707c4e446cc = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.status-cell';
    const $a2f3556545768e94$export$4da3056fdbfaf111 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.comments-cell';
    const $a2f3556545768e94$export$e1134688b6a1032 = 'software-code-page.ui.pages.repository-list.pull-requests.filtered-table.pull-request-table.last-updated-cell';
    const $a2f3556545768e94$export$143249aa50321d51 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-error-state';
    const $a2f3556545768e94$export$a46febdd3fe90de0 = 'software-code-page.ui.pages.main-page.repositories.repository-error-state';
    const $a2f3556545768e94$export$333db4cac7ee017 = 'software-code-page.ui.pages.improved-configure-step-error-state';
    const $a2f3556545768e94$export$5cbae081959768bd = 'software-code-page.ui.pages.ready-to-connect-empty-state-error-state';
    const $a2f3556545768e94$export$4939c117ba49bc9e = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.repository-filter.filter-button';
    const $a2f3556545768e94$export$5a92d7579dac6294 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.author-filter.filter-button';
    const $a2f3556545768e94$export$a77ea162c15f0290 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.reviewers-filter.filter-button';
    const $a2f3556545768e94$export$b7477204cae64b46 = 'software-code-page.ui.pages.main-page.pull-requests.pull-request-list.filters.status-filter.filter-button';
    const $a2f3556545768e94$export$39983b6fb040a5eb = 'summaryFilter';
    const $a2f3556545768e94$export$3d96f5f9ccd35be6 = 'authorsFilter';
    const $a2f3556545768e94$export$8a8927c29ab32b10 = 'reviewersFilter';
    const $a2f3556545768e94$export$3e8168848b996f7 = 'statusFilter';
    const $a2f3556545768e94$export$4adc519ba40b72a6 = 'repositoriesFilter';
    const $a2f3556545768e94$export$6da773286c35ef41 = 'sortKey';
    const $a2f3556545768e94$export$810a1f7ed2facfcb = 'sortOrder';
    const $a2f3556545768e94$export$ba75fb5089c0eb0b = [
        $a2f3556545768e94$export$39983b6fb040a5eb,
        $a2f3556545768e94$export$3d96f5f9ccd35be6,
        $a2f3556545768e94$export$8a8927c29ab32b10,
        $a2f3556545768e94$export$3e8168848b996f7,
        $a2f3556545768e94$export$4adc519ba40b72a6,
        $a2f3556545768e94$export$6da773286c35ef41,
        $a2f3556545768e94$export$810a1f7ed2facfcb
    ];
    const $a2f3556545768e94$export$7d5c3d28df5f438a = {
        BITBUCKET: 'bitbucket'
    };
    const $a2f3556545768e94$export$7912a169c18abe9d = {
        BITBUCKET_PROD: 'kRiZ7boFApjBINFF1L7wPrCa4iF8O6R9',
        BITBUCKET_STG: 'cOwtZiBfejjJAryJH0WPb1otsa4HrI1N',
        GITHUB_PROD: 'com.github.integration.production',
        GITHUB_STG: 'com.github.integration.staging'
    };
    const $a2f3556545768e94$export$74189cec821240a6 = 'jsw.code.page.header';
    const $a2f3556545768e94$export$3f3fc252f5066c72 = [
        'NOT_CONFIGURED',
        'NOT_SET',
        'PARTIALLY_CONFIGURED'
    ];
    const $a2f3556545768e94$export$9ce5b1bba5f17875 = [
        'CONFIGURED',
        'PROVIDER_ACTION_CONFIGURED',
        'PROVIDER_ACTION_NOT_CONFIGURED'
    ];
});
parcelRegister("1tSBh", function(module, exports) {
    $parcel$export(module.exports, "numberToTimestamp", ()=>$dbe340acf3f0dbdc$export$9a7be8324d19a048);
    $parcel$export(module.exports, "toProjectAri", ()=>$dbe340acf3f0dbdc$export$9429718a5f74f761);
    $parcel$export(module.exports, "RepositoryTypes", ()=>$dbe340acf3f0dbdc$export$b5ab924fb433d9ea);
    const $dbe340acf3f0dbdc$export$9a7be8324d19a048 = (time)=>{
        if (time < 0) throw new Error(`Trying to case invalid number(${time}) to Timestamp opaque type`);
        return time;
    };
    const $dbe340acf3f0dbdc$export$9429718a5f74f761 = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;
    const $dbe340acf3f0dbdc$export$b5ab924fb433d9ea = {
        REPO_BITBUCKET: 'REPO_BITBUCKET',
        REPO_GITHUB: 'REPO_GITHUB',
        REPO_GITLAB: 'REPO_GITLAB'
    };
    const $dbe340acf3f0dbdc$export$60dabe06d83cf844 = {
        CLASSIC: 'classic',
        OAUTH: 'oauth',
        BITBUCKET: 'bitbucket'
    };
});
const $96625f88cf395132$export$94a43d2ac55ac375 = 'SOFTWARE_CODE';
parcelRegister("bMz5r", function(module, exports) {
    $parcel$export(module.exports, "softwareRoadmapClassicRoute", ()=>$49eecc6e153fb76e$export$79089e2853f04197);
    $parcel$export(module.exports, "softwareTimelineClassicRoute", ()=>$49eecc6e153fb76e$export$ce5173f7e8fa932b);
    $parcel$export(module.exports, "softwareCalendarClassicRoute", ()=>$49eecc6e153fb76e$export$f2c3b99639d54eb8);
    $parcel$export(module.exports, "softwareCalendarClassicEmbedRoute", ()=>$49eecc6e153fb76e$export$ced2612fe5124ff8);
    $parcel$export(module.exports, "softwareListClassicRoute", ()=>$49eecc6e153fb76e$export$1bf758507ca6b2);
    $parcel$export(module.exports, "softwareSummaryClassicRoute", ()=>$49eecc6e153fb76e$export$b5046fccf399983f);
    $parcel$export(module.exports, "softwareListEmbedClassicRoute", ()=>$49eecc6e153fb76e$export$de5fcecec40b3c98);
    $parcel$export(module.exports, "softwareFormBuilderClassicRoute", ()=>$49eecc6e153fb76e$export$f6cfee0232aa1e);
    $parcel$export(module.exports, "softwareFormSubmitClassicRoute", ()=>$49eecc6e153fb76e$export$91d6851bf27349);
    $parcel$export(module.exports, "softwareFormClassicRoute", ()=>$49eecc6e153fb76e$export$ae560ee5b676193d);
    $parcel$export(module.exports, "softwareGoalsClassicRoute", ()=>$49eecc6e153fb76e$export$d12f3924cf53b545);
    $parcel$export(module.exports, "rapidboardBacklogRoute", ()=>$49eecc6e153fb76e$export$9e1d275c8078512e);
    $parcel$export(module.exports, "rapidboardBacklogEmbedRoute", ()=>$49eecc6e153fb76e$export$8c354886c7c664ea);
    $parcel$export(module.exports, "rapidboardReportRoute", ()=>$49eecc6e153fb76e$export$d37f637b09fb9fda);
    $parcel$export(module.exports, "softwareReportsCycleTimeClassicRoute", ()=>$49eecc6e153fb76e$export$1e5e610e11119ea7);
    $parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectRoute", ()=>$49eecc6e153fb76e$export$92f34907c6bf7007);
    $parcel$export(module.exports, "softwareClassicProformaIssueFormsDirectEmbedRoute", ()=>$49eecc6e153fb76e$export$16987cdd084cceba);
    $parcel$export(module.exports, "softwareReportsDeploymentFrequencyClassicRoute", ()=>$49eecc6e153fb76e$export$312c410cb3b49afe);
    $parcel$export(module.exports, "rapidboardUserBacklogRoute", ()=>$49eecc6e153fb76e$export$79c2d9718e914f91);
    $parcel$export(module.exports, "rapidboardUserReportRoute", ()=>$49eecc6e153fb76e$export$7b85bca17717def6);
    $parcel$export(module.exports, "rapidboardBacklog1Route", ()=>$49eecc6e153fb76e$export$ff874528b0b33a61);
    $parcel$export(module.exports, "rapidboardReport1Route", ()=>$49eecc6e153fb76e$export$d27f9ad2fc277ff9);
    $parcel$export(module.exports, "softwareCodeClassicRoute", ()=>$49eecc6e153fb76e$export$d92cd77785d00ff);
    $parcel$export(module.exports, "rapidboardLastVisitedProjectRedirectRoute", ()=>$49eecc6e153fb76e$export$991b1be164057e91);
    $parcel$export(module.exports, "projectDirectoryRedirectRoute", ()=>$49eecc6e153fb76e$export$3913c8bee519225c);
    var $65Ltd;
    const $49eecc6e153fb76e$var$jiraIssueFormCreateEndpoint = 'projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?';
    const $49eecc6e153fb76e$export$79089e2853f04197 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ROADMAP_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/roadmap'
    };
    const $49eecc6e153fb76e$export$ce5173f7e8fa932b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/timeline'
    };
    const $49eecc6e153fb76e$export$f2c3b99639d54eb8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar',
        queries: [
            'date?'
        ]
    };
    const $49eecc6e153fb76e$export$ced2612fe5124ff8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC_EMBED),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar/embed',
        queries: [
            'date?'
        ]
    };
    const $49eecc6e153fb76e$export$1bf758507ca6b2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/list'
    };
    const $49eecc6e153fb76e$export$b5046fccf399983f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SUMMARY_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/summary'
    };
    const $49eecc6e153fb76e$export$de5fcecec40b3c98 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST_CLASSIC_EMBED),
        path: '/jira/software/c/projects/:projectKey/list/embed'
    };
    const $49eecc6e153fb76e$export$f6cfee0232aa1e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_BUILDER_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/form/:formId/builder'
    };
    const $49eecc6e153fb76e$export$91d6851bf27349 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_SUBMIT_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/form/:formId'
    };
    const $49eecc6e153fb76e$export$ae560ee5b676193d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/form'
    };
    const $49eecc6e153fb76e$export$d12f3924cf53b545 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_GOALS_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/goals'
    };
    const $49eecc6e153fb76e$export$9e1d275c8078512e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog'
    };
    const $49eecc6e153fb76e$export$8c354886c7c664ea = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog/embed'
    };
    const $49eecc6e153fb76e$export$d37f637b09fb9fda = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_REPORT),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/:chartView'
    };
    const $49eecc6e153fb76e$export$1e5e610e11119ea7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/reports/cycle-time'
    };
    const $49eecc6e153fb76e$export$92f34907c6bf7007 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT),
        path: `/jira/software/c/${$49eecc6e153fb76e$var$jiraIssueFormCreateEndpoint}`,
        exact: true
    };
    const $49eecc6e153fb76e$export$16987cdd084cceba = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CLASSIC_PROFORMA_ISSUE_FORMS_DIRECT_EMBED),
        path: `/jira/software/c/${$49eecc6e153fb76e$var$jiraIssueFormCreateEndpoint}/embed`,
        exact: true
    };
    const $49eecc6e153fb76e$export$312c410cb3b49afe = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/reports/deployment-frequency'
    };
    const $49eecc6e153fb76e$export$79c2d9718e914f91 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG),
        path: '/jira/people/:accountId/boards/:boardId/backlog'
    };
    const $49eecc6e153fb76e$export$7b85bca17717def6 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_REPORT),
        path: '/jira/people/:accountId/boards/:boardId/reports/:chartView'
    };
    const $49eecc6e153fb76e$export$ff874528b0b33a61 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG),
        path: '/secure/RapidBoard.jspa',
        query: [
            'rapidView',
            'view=(planning|planning.nodetail)'
        ]
    };
    const $49eecc6e153fb76e$export$d27f9ad2fc277ff9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_REPORT),
        path: '/secure/RapidBoard.jspa',
        query: [
            'rapidView',
            'view=reporting',
            'chart'
        ]
    };
    const $49eecc6e153fb76e$export$d92cd77785d00ff = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CODE_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/code'
    };
    const $49eecc6e153fb76e$export$991b1be164057e91 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_LAST_VISITED_PROJECT_REDIRECT),
        path: '/secure/RapidBoard.jspa',
        query: [
            'projectKey'
        ]
    };
    const $49eecc6e153fb76e$export$3913c8bee519225c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_DIRECTORY_REDIRECT),
        path: '/secure/RapidBoard.jspa'
    };
});
parcelRegister("6cOYV", function(module, exports) {
    $parcel$export(module.exports, "softwareIncidentsNextGenRouteEntry", ()=>$9e60de4e7ff199f0$export$fd29243dbe4103);
    $parcel$export(module.exports, "softwareIncidentsClassicRouteEntry", ()=>$9e60de4e7ff199f0$export$c7d98bfe75274932);
    var $e4eHl = parcelRequire("e4eHl");
    var $65Ltd;
    var $lkFvK;
    var $co1wz;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $9s3j1;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5ee2G;
    var $drVya;
    var $5PD5h;
    var $5En1O;
    var $eXpsd;
    var $e7bC3;
    const $9e60de4e7ff199f0$var$entryPointDeprecated = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("eXpsd")).incidentsPageEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $9e60de4e7ff199f0$var$entryPoint = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("5En1O")).incidentsPageEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $9e60de4e7ff199f0$export$fd29243dbe4103 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5ee2G")).softwareIncidentsNextGenRoute), ()=>({
            entryPoint () {
                return (0, (0, parcelRequire("co1wz")).ff)('corex-operandi-incidents-page-in-jira_5ebja') ? $9e60de4e7ff199f0$var$entryPoint : $9e60de4e7ff199f0$var$entryPointDeprecated;
            },
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
            skeleton: (0, (0, parcelRequire("drVya")).IncidentsPageSkeleton),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("7GnDe")).incidentsInitialPageChecksResource),
                (0, (0, parcelRequire("7GnDe")).incidentsCustomFieldIdResource)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS)),
                    teamName: 'operandi'
                }
            },
            ufoName: 'software-incidents'
        }));
    const $9e60de4e7ff199f0$export$c7d98bfe75274932 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5ee2G")).softwareIncidentsClassicRoute), ()=>({
            entryPoint () {
                return (0, (0, parcelRequire("co1wz")).ff)('corex-operandi-incidents-page-in-jira_5ebja') ? $9e60de4e7ff199f0$var$entryPoint : $9e60de4e7ff199f0$var$entryPointDeprecated;
            },
            layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
            skeleton: (0, (0, parcelRequire("drVya")).IncidentsPageSkeleton),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("9s3j1")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("7GnDe")).incidentsInitialPageChecksResource),
                (0, (0, parcelRequire("7GnDe")).incidentsCustomFieldIdResource)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC)),
                    teamName: 'operandi'
                }
            },
            ufoName: 'software-incidents'
        }));
});
parcelRegister("5ee2G", function(module, exports) {
    $parcel$export(module.exports, "softwareIncidentsNextGenRoute", ()=>$8918f6db6c72ebfe$export$12e1ca6c7cfdfd49);
    $parcel$export(module.exports, "softwareIncidentsClassicRoute", ()=>$8918f6db6c72ebfe$export$3356a7870a2717f4);
    var $65Ltd;
    const $8918f6db6c72ebfe$export$12e1ca6c7cfdfd49 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS),
        path: '/jira/software/projects/:projectKey/incidents'
    };
    const $8918f6db6c72ebfe$export$3356a7870a2717f4 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_INCIDENTS_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/incidents'
    };
});
parcelRegister("drVya", function(module, exports) {
    $parcel$export(module.exports, "IncidentsPageSkeleton", ()=>$e5e4ca592020286c$export$3105d59d9ca899bd);
    $parcel$export(module.exports, "IncidentsTableSkeleton", ()=>$e5e4ca592020286c$export$7092b8ea63ebf9be);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $c1yjJ = parcelRequire("c1yjJ");
    var $80wl3 = parcelRequire("80wl3");
    const $e5e4ca592020286c$var$incidentsPageSkeletonStyles = null;
    const $e5e4ca592020286c$var$incidentsTableSkeletonStyles = null;
    const $e5e4ca592020286c$export$3105d59d9ca899bd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "skeletons.ui.incidents-page.app-skeleton-image-incidents-page",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1x27 _4t3i1osq _ca0q1ejb _19bv1jfw _u5f31jfw _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($c1yjJ)))
        }));
    const $e5e4ca592020286c$export$7092b8ea63ebf9be = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "skeletons.ui.incidents-page.app-skeleton-image-incidents-table",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($80wl3)))
        }));
});
parcelRegister("c1yjJ", function(module, exports) {
    module.exports = new URL("incidents-page-app-skeleton.tpl.5b656159.svg", import.meta.url).toString();
});
parcelRegister("80wl3", function(module, exports) {
    module.exports = new URL("incidents-page-table-skeleton.tpl.e8f337f1.svg", import.meta.url).toString();
});
parcelRegister("5En1O", function(module, exports) {
    $parcel$export(module.exports, "incidentsPageEntryPoint", ()=>$b9fe885d02827a63$export$a59477eea6e8cd7f);
    var $2T5vx;
    var $2Ftxm;
    var $ikgNX;
    const $b9fe885d02827a63$var$AriGraphSortOrderInput = {
        ASC: 'ASC',
        DESC: 'DESC'
    };
    const $b9fe885d02827a63$var$QUERY_PARAM_SEARCH = 'search';
    const $b9fe885d02827a63$var$QUERY_PARAM_PRIORITY = 'priority';
    const $b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE = 'affected-service';
    const $b9fe885d02827a63$var$QUERY_PARAM_STATUS = 'status';
    const $b9fe885d02827a63$var$QUERY_PARAM_SORT_BY = 'sortBy';
    const $b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER = 'sortOrder';
    const $b9fe885d02827a63$var$STATUS_SORT_KEY = 'status';
    const $b9fe885d02827a63$var$CREATED_SORT_KEY = 'created';
    const $b9fe885d02827a63$var$PRIORITY_SORT_KEY = 'priority';
    const $b9fe885d02827a63$var$SUMMARY_SORT_KEY = 'key';
    const $b9fe885d02827a63$var$ASC_SORT_KEY = 'ASC';
    const $b9fe885d02827a63$var$DESC_SORT_KEY = 'DESC';
    function $b9fe885d02827a63$var$notEmpty(value) {
        return Boolean(value);
    }
    const $b9fe885d02827a63$var$isPriority = $b9fe885d02827a63$var$notEmpty;
    const $b9fe885d02827a63$var$isStatus = (val)=>val === 'resolved' || val === 'open';
    const $b9fe885d02827a63$var$isSortBy = (val)=>val === $b9fe885d02827a63$var$STATUS_SORT_KEY || val === $b9fe885d02827a63$var$CREATED_SORT_KEY || val === $b9fe885d02827a63$var$PRIORITY_SORT_KEY || val === $b9fe885d02827a63$var$SUMMARY_SORT_KEY;
    const $b9fe885d02827a63$var$isSortOrder = (val)=>val === $b9fe885d02827a63$var$ASC_SORT_KEY || val === $b9fe885d02827a63$var$DESC_SORT_KEY;
    const $b9fe885d02827a63$var$isAffectedService = $b9fe885d02827a63$var$notEmpty;
    function $b9fe885d02827a63$var$parseParameter(parameter, parameterValidationFn) {
        return parameter == null ? undefined : parameter.split(',').map((str)=>str.trim()).filter(parameterValidationFn);
    }
    const $b9fe885d02827a63$var$parseQueryParams = (paramsRaw)=>{
        const result = {
            [$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY]: paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] && $b9fe885d02827a63$var$isSortBy(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY]) ? paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] : $b9fe885d02827a63$var$CREATED_SORT_KEY,
            [$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER]: paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER] && $b9fe885d02827a63$var$isSortOrder(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER]) ? paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER] : $b9fe885d02827a63$var$DESC_SORT_KEY
        };
        result[$b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE] = $b9fe885d02827a63$var$parseParameter(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE], $b9fe885d02827a63$var$isAffectedService);
        result[$b9fe885d02827a63$var$QUERY_PARAM_STATUS] = $b9fe885d02827a63$var$parseParameter(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_STATUS], $b9fe885d02827a63$var$isStatus);
        result[$b9fe885d02827a63$var$QUERY_PARAM_SEARCH] = paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_SEARCH] ?? undefined;
        result[$b9fe885d02827a63$var$QUERY_PARAM_PRIORITY] = $b9fe885d02827a63$var$parseParameter(paramsRaw[$b9fe885d02827a63$var$QUERY_PARAM_PRIORITY], $b9fe885d02827a63$var$isPriority);
        return result;
    };
    const $b9fe885d02827a63$var$getFilterValue = (values)=>({
            ...values.length > 0 ? {
                is: values
            } : {}
        });
    const $b9fe885d02827a63$var$parseStatusToFilterValues = (status)=>status.flatMap((stat)=>{
            switch(stat){
                case 'open':
                    return [
                        'NEW',
                        'INDETERMINATE'
                    ];
                case 'resolved':
                    return [
                        'DONE'
                    ];
                default:
                    return [
                        'UNDEFINED'
                    ];
            }
        });
    const $b9fe885d02827a63$var$getGqlFiltersFromQueryParams = (parsedQueryParams)=>({
            and: [
                {
                    to_status: $b9fe885d02827a63$var$getFilterValue($b9fe885d02827a63$var$parseStatusToFilterValues(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_STATUS] ?? [])),
                    to_priority: $b9fe885d02827a63$var$getFilterValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_PRIORITY] ?? []),
                    to_affectedServiceAris: $b9fe885d02827a63$var$getFilterValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_AFFECTED_SERVICE] ?? [])
                }
            ]
        });
    const $b9fe885d02827a63$var$parseSortDirection = (maybeDirection, defaultValue)=>{
        switch(maybeDirection?.toUpperCase()){
            case $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC.toUpperCase():
                return $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC;
            case $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC.toUpperCase():
                return $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC;
            default:
                return defaultValue;
        }
    };
    const $b9fe885d02827a63$var$getSortValue = (sortOrder)=>({
            priority: 2,
            direction: $b9fe885d02827a63$var$parseSortDirection(sortOrder, $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC)
        });
    const $b9fe885d02827a63$var$parseInverseSortDirection = (maybeDirection, defaultValue)=>{
        switch(maybeDirection?.toUpperCase()){
            case $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC.toUpperCase():
                return $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC;
            case $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC.toUpperCase():
                return $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC;
            default:
                return defaultValue;
        }
    };
    const $b9fe885d02827a63$var$getInverseSortValue = (sortOrder)=>({
            priority: 2,
            direction: $b9fe885d02827a63$var$parseInverseSortDirection(sortOrder, $b9fe885d02827a63$var$AriGraphSortOrderInput.ASC)
        });
    const $b9fe885d02827a63$var$getGraphStoreSortFromQueryParams = (parsedQueryParams)=>({
            lastModified: {
                priority: 1,
                direction: $b9fe885d02827a63$var$AriGraphSortOrderInput.DESC
            },
            ...$b9fe885d02827a63$var$STATUS_SORT_KEY === parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] ? {
                to_status: $b9fe885d02827a63$var$getSortValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER])
            } : {},
            ...$b9fe885d02827a63$var$PRIORITY_SORT_KEY === parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] ? {
                to_priority: $b9fe885d02827a63$var$getInverseSortValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER])
            } : {},
            ...$b9fe885d02827a63$var$CREATED_SORT_KEY === parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_BY] ? {
                createdAt: $b9fe885d02827a63$var$getSortValue(parsedQueryParams[$b9fe885d02827a63$var$QUERY_PARAM_SORT_ORDER])
            } : {}
        });
    const $b9fe885d02827a63$export$a59477eea6e8cd7f = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("6R6ro")).then((mod)=>mod.IncidentsPageWrapper), {
            moduleId: "5b8b4ff7"
        }),
        getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
                queries: {
                    incidentPageData: {
                        options: {
                            fetchPolicy: 'store-or-network'
                        },
                        parameters: (0, parcelRequire("2T5vx")).default,
                        variables: {
                            incidentPageSize: 30,
                            servicePageSize: 30,
                            cloudId: cloudId,
                            projectKey: context.match.params.projectKey ?? '',
                            filter: $b9fe885d02827a63$var$getGqlFiltersFromQueryParams($b9fe885d02827a63$var$parseQueryParams(context.query)),
                            sort: $b9fe885d02827a63$var$getGraphStoreSortFromQueryParams($b9fe885d02827a63$var$parseQueryParams(context.query)),
                            siteAri: `ari:cloud:jira::site/${cloudId}`
                        }
                    }
                }
            })
    });
});
parcelRegister("2T5vx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$58f54a3a0d651497$export$2e2bcd8739ae039);
    const $58f54a3a0d651497$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "50f41ae3db36d1741d384023d13472ac68cccc88abdb8a72fb04d3f7c9bc8670",
            "metadata": {
                "connection": [
                    {
                        "count": "servicePageSize",
                        "cursor": "after",
                        "direction": "forward",
                        "path": [
                            "jira",
                            "jiraProjectByKey",
                            "linkedOperationsComponentsByProject"
                        ]
                    }
                ]
            },
            "name": "srcIncidentsPageInternalQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $58f54a3a0d651497$export$2e2bcd8739ae039 = $58f54a3a0d651497$var$node;
});
parcelRegister("6R6ro", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cRbOs")
    ]).then(()=>parcelRequire('cwNeR'));
});
parcelRegister("eXpsd", function(module, exports) {
    $parcel$export(module.exports, "incidentsPageEntryPoint", ()=>$b93c8ec26a3d236d$export$a59477eea6e8cd7f);
    var $d23s9;
    var $2Ftxm;
    var $ikgNX;
    const $b93c8ec26a3d236d$export$a59477eea6e8cd7f = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("d6qce")).then((mod)=>mod.IncidentsPageLinkedServicesWrapper), {
            moduleId: "d6132459"
        }),
        getPreloadProps: ({ tenantContext: { cloudId: cloudId }, context: context })=>({
                queries: {
                    incidentPageData: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: (0, parcelRequire("d23s9")).default,
                        variables: {
                            cloudId: cloudId,
                            projectKey: context.match.params.projectKey ?? ''
                        }
                    }
                }
            })
    });
});
parcelRegister("d23s9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2978738121ef6b5$export$2e2bcd8739ae039);
    const $d2978738121ef6b5$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "8822ca061f1e1e9e11103925231d8d61251ca06c569e9da069f1b3faa1183aaf",
            "metadata": {
                "connection": [
                    {
                        "count": "first",
                        "cursor": "after",
                        "direction": "forward",
                        "path": [
                            "jira",
                            "jiraProjectByKey",
                            "associatedComponents"
                        ]
                    }
                ]
            },
            "name": "srcIncidentsLinkedServicesQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $d2978738121ef6b5$export$2e2bcd8739ae039 = $d2978738121ef6b5$var$node;
});
parcelRegister("d6qce", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9C5Ze")
    ]).then(()=>parcelRequire('8c2Ir'));
});
parcelRegister("jSNrq", function(module, exports) {
    $parcel$export(module.exports, "classicSoftwareBoardRouteEntry", ()=>$e5e1c502f00851e8$export$f2cd114cf8ab53aa);
    $parcel$export(module.exports, "classicSoftwareBoardEmbedRouteEntry", ()=>$e5e1c502f00851e8$export$b5558b683e9c45a4);
    var $1WqFo;
    var $ffza4;
    var $e2ctp;
    var $cSD7y;
    var $gyYxw;
    var $g5RGc;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $1XrjK;
    var $lfnsv;
    var $lJ1FP;
    var $f5kpo;
    var $3RJkv;
    var $ipmBb;
    var $dxCvy;
    var $7GnDe;
    var $2Ql51;
    var $f7Y15;
    var $gNStA;
    var $d04s2;
    var $5lsNZ;
    var $k7fxM;
    var $7Y3Wj;
    var $gcguf;
    var $5PD5h;
    const $e5e1c502f00851e8$var$classicBoardCapability = !false ? (0, $281cbd47ba46dd7d$export$664edf77d4c76110) : (0, $281cbd47ba46dd7d$export$fc5f182fc9019b1c);
    const $e5e1c502f00851e8$export$f2cd114cf8ab53aa = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("k7fxM")).classicSoftwareBoardRoute), ()=>({
            component: (0, (0, parcelRequire("7Y3Wj")).RapidBoardSpaPage),
            skeleton: (0, (0, parcelRequire("gcguf")).ClassicBoardSkeleton),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                {
                    query: [
                        'selectedIssue',
                        'view=detail'
                    ]
                },
                {
                    query: [
                        'selectedIssue',
                        'modal=detail'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)((0, (0, parcelRequire("f5kpo")).shouldLoadUIFBoardResources), (0, (0, parcelRequire("f7Y15")).uifBoardResource)),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("f5kpo")).shouldLoadUIFBoardResources)() && !(0, (0, parcelRequire("1WqFo")).isFedRamp)(), (0, (0, parcelRequire("ipmBb")).nextBestTaskFeatureResource)),
                (0, (0, parcelRequire("lJ1FP")).getEditModelResource)(),
                (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)()
            ],
            afterPaint: [
                (0, (0, parcelRequire("d04s2")).LazyIssueApp)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("7Y3Wj")).UIFBoardSpa)
            ],
            preloadOptions: {
                earlyChunks: [
                    'rapidboard-early-entry'
                ]
            },
            meta: {
                capability: $e5e1c502f00851e8$var$classicBoardCapability
            },
            earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY)
        }));
    const $e5e1c502f00851e8$export$b5558b683e9c45a4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("k7fxM")).classicSoftwareBoardEmbedRoute), ()=>({
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jira_board_smartlink_embed', (0, (0, parcelRequire("7Y3Wj")).RapidBoardSpaPage), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)({
                isChromeless: true
            }),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)((0, (0, parcelRequire("f5kpo")).shouldLoadUIFBoardResources), (0, (0, parcelRequire("f7Y15")).uifBoardResource)),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("f5kpo")).shouldLoadUIFBoardResources)() && !(0, (0, parcelRequire("1WqFo")).isFedRamp)(), (0, (0, parcelRequire("ipmBb")).nextBestTaskFeatureResource)),
                (0, (0, parcelRequire("lJ1FP")).getEditModelResource)(),
                (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)(),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            afterPaint: [
                (0, (0, parcelRequire("d04s2")).LazyIssueApp)
            ],
            forPaint: [
                (0, (0, parcelRequire("7Y3Wj")).UIFBoardSpa)
            ],
            meta: {
                capability: $e5e1c502f00851e8$var$classicBoardCapability
            }
        }));
});
parcelRegister("ipmBb", function(module, exports) {
    $parcel$export(module.exports, "nextBestTaskFeatureResource", ()=>$b97b42683de1c9b3$export$5d472f7d515300ca);
    var $jcw0u;
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $b97b42683de1c9b3$export$5d472f7d515300ca = (0, $dIdda.createResource)({
        type: (0, $167b031bfd6a6b6e$export$6f0555de4f60e84e),
        getKey: ()=>(0, $167b031bfd6a6b6e$export$7e7d7930e22ba39f),
        getData: async ()=>{
            try {
                return await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/3/mypreferences?key=${(0, $167b031bfd6a6b6e$export$b94951a11282ae6a)}`);
            } catch (error) {
                const initialValueNeverSet = error.statusCode === 404;
                if (initialValueNeverSet) return {
                    hasUserOptedIn: true
                };
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: (0, $167b031bfd6a6b6e$export$7f111648ca05f056),
                        packageName: (0, $167b031bfd6a6b6e$export$b8b9d90f9e5bd72b)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return {
                hasUserOptedIn: false
            };
        },
        maxAge: Number.MAX_VALUE
    });
});
const $167b031bfd6a6b6e$export$6f0555de4f60e84e = 'RESOURCE_TYPE_NEXT_BEST_TASK_FEATURE';
const $167b031bfd6a6b6e$export$7e7d7930e22ba39f = 'nbt-opt-in-resource-key';
const $167b031bfd6a6b6e$export$b94951a11282ae6a = 'next-best-task-feature';
const $167b031bfd6a6b6e$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesNextBestTask';
const $167b031bfd6a6b6e$export$7f111648ca05f056 = 'useResource.fetchNextBestTaskOptInPreference';
parcelRegister("f7Y15", function(module, exports) {
    $parcel$export(module.exports, "uifBoardResource", ()=>$6f8724e78df4e830$export$b65bcbbccad354ac);
    var $dIdda = parcelRequire("dIdda");
    const $6f8724e78df4e830$export$b65bcbbccad354ac = (0, $dIdda.createResource)({
        type: (0, $16d4c226f5e6f5f8$export$cfae566ecf2855f8),
        getKey: ({ match: { params: { boardId: boardId } }, route: { name: routeName }, query: { config: config } })=>{
            if (config) return `uif-board::${routeName}::config`;
            if (boardId == null) return `uif-board::${routeName}::not-found`;
            return `uif-board::${routeName}::${boardId}`;
        },
        getDataLoader: ()=>(parcelRequire("8SSc2")),
        maxAge: 0
    });
});
const $16d4c226f5e6f5f8$export$cfae566ecf2855f8 = 'UIF_BOARD';
parcelRegister("8SSc2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bLcEa").then(()=>parcelRequire('1HjYz'));
});
parcelRegister("k7fxM", function(module, exports) {
    $parcel$export(module.exports, "classicSoftwareBoardRoute", ()=>$b2c149f7138f811f$export$131d51ca54849e97);
    $parcel$export(module.exports, "classicSoftwareBoardEmbedRoute", ()=>$b2c149f7138f811f$export$122afcef7dfd252);
    var $65Ltd;
    const $b2c149f7138f811f$export$131d51ca54849e97 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId',
        ufoName: 'classic-board'
    };
    const $b2c149f7138f811f$export$122afcef7dfd252 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/embed',
        ufoName: 'classic-board-embed'
    };
});
parcelRegister("7Y3Wj", function(module, exports) {
    $parcel$export(module.exports, "UIFBoardSpa", ()=>$b34d0a459c6590c3$export$2164de18d39af313);
    $parcel$export(module.exports, "RapidBoardSpaPage", ()=>$b34d0a459c6590c3$export$4ceb6cf2934825b2);
    $parcel$export(module.exports, "LazyRapidBoard", ()=>$b34d0a459c6590c3$export$9de09057ba255cc4);
    $parcel$export(module.exports, "LazyRapidBoardWrmBundleResource", ()=>$b34d0a459c6590c3$export$bcb5bb6438a46dcb);
    $parcel$export(module.exports, "LazyRapidBoardDataApiResource", ()=>$b34d0a459c6590c3$export$d4640ceb9bdd4b4);
    $parcel$export(module.exports, "LazyRapidBoardConfigApiResource", ()=>$b34d0a459c6590c3$export$c96c36c0cbfb2c16);
    $parcel$export(module.exports, "LazyRapidBoardResource", ()=>$b34d0a459c6590c3$export$2ad64ed8eb98d9e);
    $parcel$export(module.exports, "LazyRapidBoardApps", ()=>$b34d0a459c6590c3$export$4a8825f3e310b97);
    var $5uXOq = parcelRequire("5uXOq");
    var $65Ltd;
    var $co1wz;
    var $5j7Th;
    var $hPtZI;
    const $b34d0a459c6590c3$export$2164de18d39af313 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("evG1K")), {
        moduleId: "./src/packages/spa-apps/next-gen-board/src/index.tsx"
    });
    const $b34d0a459c6590c3$export$bcc6315cf211edab = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("1vlac")), {
        moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
    });
    const $b34d0a459c6590c3$export$a1c59527bd5131cc = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("42ppS")).then((module)=>module.BoardConfigSwitcher), {
        moduleId: "./src/packages/router-routes/software/classic/board-settings/switcher/entries/src/index.tsx"
    });
    const $b34d0a459c6590c3$export$4ceb6cf2934825b2 = (props)=>{
        const { route: route, query: query, match: match } = props;
        const basePageId = route && route.name || 'rapid-board';
        const chartParam = query.chart ? `-${query.chart}` : '';
        const boardId = query.rapidView ?? match.params.boardId;
        const pageId = `${basePageId}-${boardId}${chartParam}`;
        if ([
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BOARD)
        ].includes(route.name) && !query.config) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b34d0a459c6590c3$export$2164de18d39af313,
            pageId: pageId,
            shouldShowSpinner: false
        });
        if ([
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED)
        ].includes(route.name) && !query.config) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b34d0a459c6590c3$export$bcc6315cf211edab,
            pageId: pageId,
            shouldShowSpinner: false
        });
        if ((0, (0, parcelRequire("co1wz")).ff)('simplified-boards-milestone-2_07hbk') && [
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BACKLOG),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD_EMBED),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BOARD),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG_EMBED)
        ].includes(route.name) && query.config) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b34d0a459c6590c3$export$a1c59527bd5131cc,
            pageId: pageId,
            shouldShowSpinner: false
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b34d0a459c6590c3$export$9de09057ba255cc4,
            pageId: pageId,
            shouldShowSpinner: false
        });
    };
    const $b34d0a459c6590c3$export$9de09057ba255cc4 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("5ERDu")), {
        moduleId: "./src/packages/spa-apps/rapid-board/src/index.tsx"
    });
    const $b34d0a459c6590c3$export$bcb5bb6438a46dcb = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("8kiyc")), {
        moduleId: "./src/packages/router-resources/classic-projects/src/services/wrm-bundle/get-data/index.tsx"
    });
    const $b34d0a459c6590c3$export$d4640ceb9bdd4b4 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("bnQeN")), {
        moduleId: "./src/packages/router-resources/classic-projects/src/services/data-api/get-data/index.tsx"
    });
    const $b34d0a459c6590c3$export$c96c36c0cbfb2c16 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("ifUKB")), {
        moduleId: "./src/packages/router-resources/classic-projects/src/services/config-api/get-data/index.tsx"
    });
    const $b34d0a459c6590c3$export$2ad64ed8eb98d9e = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("4ajRG")), {
        moduleId: "./src/packages/router-resources/classic-projects/src/services/rapidboard-resource/get-data/index.tsx"
    });
    const $b34d0a459c6590c3$export$4a8825f3e310b97 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("eFW1U")), {
        moduleId: "./src/packages/entry-rapid-board-wrm-apps/src/index.tsx"
    });
});
parcelRegister("evG1K", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("427Sh")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3dc2I")
    ]).then(()=>parcelRequire('dnhKp'));
});
parcelRegister("1vlac", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1QTgA")
    ]).then(()=>parcelRequire('1Xeln'));
});
parcelRegister("42ppS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("4phaX")
    ]).then(()=>parcelRequire('5su1b'));
});
parcelRegister("5ERDu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("5OUMf")
    ]).then(()=>parcelRequire('Gk4RP'));
});
parcelRegister("eFW1U", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bcehj").then(()=>parcelRequire('73mZu'));
});
parcelRegister("gcguf", function(module, exports) {
    $parcel$export(module.exports, "ClassicBoardSkeleton", ()=>$cff09f53ee9f2bb4$export$631611c5fdf027d5);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $p7KP7 = parcelRequire("p7KP7");
    const $cff09f53ee9f2bb4$var$customCssStyles = null;
    const $cff09f53ee9f2bb4$export$631611c5fdf027d5 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($p7KP7))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2zz1idpf"
            ])
        });
});
parcelRegister("p7KP7", function(module, exports) {
    module.exports = new URL("classic-board-app-skeleton.tpl.bf1c26f5.svg", import.meta.url).toString();
});
parcelRegister("hvQbc", function(module, exports) {
    $parcel$export(module.exports, "classicSoftwareBoardSettingsInsightsRouteEntries", ()=>$f7a61037070d3efe$export$4bab4a9393eceb86);
    var $7sHr7;
    var $eriCB;
    const $f7a61037070d3efe$export$4bab4a9393eceb86 = [
        (0, (0, parcelRequire("7sHr7")).rapidboardBacklogRouteEntry),
        (0, (0, parcelRequire("eriCB")).rapidboardBoardRouteEntry)
    ];
});
parcelRegister("7sHr7", function(module, exports) {
    $parcel$export(module.exports, "rapidboardBacklogRouteEntry", ()=>$213bc38e0eb732c2$export$afb310a61bc1979c);
    var $g87MG;
    var $ffza4;
    var $e2ctp;
    var $gyYxw;
    var $g5RGc;
    var $lmyls;
    var $hBv66;
    var $2G9Bk;
    var $1XrjK;
    var $lfnsv;
    var $f5kpo;
    var $3RJkv;
    var $d04s2;
    var $68mjh;
    var $7Y3Wj;
    var $aJzGl;
    var $5PD5h;
    var $ltiRJ;
    const $213bc38e0eb732c2$export$afb310a61bc1979c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("68mjh")).rapidboardBacklogRoute), ()=>({
            ufoName: 'rapidboard-backlog-insights',
            component: (0, (0, parcelRequire("ltiRJ")).InsightsSettingsRedirect),
            skeleton: (0, (0, parcelRequire("aJzGl")).NextGenBacklogSkeleton),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                {
                    query: [
                        'selectedIssue',
                        'view=planning'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectResource)(),
                ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                (0, (0, parcelRequire("g87MG")).issueHierarchyPageResource),
                (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)()
            ],
            afterPaint: [
                (0, (0, parcelRequire("d04s2")).LazyIssueApp)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoard),
                (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoardApps),
                (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoardDataApiResource),
                (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoardConfigApiResource),
                (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoardWrmBundleResource),
                (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoardResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'rapidboard-early-entry'
                ]
            },
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$93104dc4eba58ba4)
            },
            earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY)
        }));
});
parcelRegister("g87MG", function(module, exports) {
    $parcel$export(module.exports, "issueHierarchyPageResource", ()=>$6f06dee5876402c3$export$98d50a2e19509817);
    var $ao2h1;
    var $7a4aR;
    const $6f06dee5876402c3$export$98d50a2e19509817 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'RESOURCE1',
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("7a4aR")).default),
                variables: {
                    cloudId: tenantContext.cloudId
                }
            })
    });
});
parcelRegister("7a4aR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0ea8bf05e90a48f8$export$2e2bcd8739ae039);
    const $0ea8bf05e90a48f8$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "name"
        }, v3 = {
            "kind": "ScalarField",
            "name": "level"
        }, v4 = [
            {
                "concreteType": "JiraIssueTypeHierarchyLevel",
                "kind": "LinkedField",
                "name": "hierarchyLevel",
                "plural": false,
                "selections": [
                    v2,
                    v3
                ]
            },
            {
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "cmpIssueTypes",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueTypeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "issueTypeId"
                                    },
                                    v2,
                                    {
                                        "kind": "ScalarField",
                                        "name": "description"
                                    },
                                    {
                                        "concreteType": "JiraIssueTypeHierarchyLevel",
                                        "kind": "LinkedField",
                                        "name": "hierarchy",
                                        "plural": false,
                                        "selections": [
                                            v3
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "small"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ], v5 = {
            "concreteType": "JiraHierarchyConfigError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "code"
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        }, v6 = {
            "args": v1,
            "concreteType": "JiraIssueHierarchyConfigurationQuery",
            "kind": "LinkedField",
            "name": "issueHierarchyConfig",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueHierarchyConfigData",
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": v4
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                v5
            ]
        }, v7 = {
            "args": v1,
            "concreteType": "JiraIssueHierarchyLimits",
            "kind": "LinkedField",
            "name": "issueHierarchyLimits",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "maxLevels"
                },
                {
                    "kind": "ScalarField",
                    "name": "nameLength"
                }
            ]
        }, v8 = {
            "args": v1,
            "kind": "ScalarField",
            "name": "lockedIssueTypeIds"
        }, v9 = {
            "concreteType": "JiraIssueHierarchyConfigData",
            "kind": "LinkedField",
            "name": "issueHierarchyConfig",
            "plural": true,
            "selections": v4
        }, v10 = {
            "concreteType": "JiraLongRunningTaskProgress",
            "kind": "LinkedField",
            "name": "taskProgress",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "kind": "ScalarField",
                    "name": "progress"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "mainIssueHierarchyQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            v6,
                            v7,
                            v8,
                            {
                                "args": v1,
                                "concreteType": "JiraHierarchyConfigTask",
                                "kind": "LinkedField",
                                "name": "issueHierarchyConfigUpdateTask",
                                "plural": false,
                                "selections": [
                                    v9,
                                    v10,
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "saveButton_adminPagesIssueHierarchyDirectory"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "saveDialog_adminPagesIssueHierarchyDirectory"
                                    },
                                    v5
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "mainIssueHierarchyQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            v6,
                            v7,
                            v8,
                            {
                                "args": v1,
                                "concreteType": "JiraHierarchyConfigTask",
                                "kind": "LinkedField",
                                "name": "issueHierarchyConfigUpdateTask",
                                "plural": false,
                                "selections": [
                                    v9,
                                    v10,
                                    v5
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "b990d47758e2cd9b24e5dbee104f873a7f1b2aead336e44568500c9564afe54b",
                "metadata": {},
                "name": "mainIssueHierarchyQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $0ea8bf05e90a48f8$var$node.hash = "e780e64aedcd2278004df68a042f1343";
    var $0ea8bf05e90a48f8$export$2e2bcd8739ae039 = $0ea8bf05e90a48f8$var$node;
});
parcelRegister("68mjh", function(module, exports) {
    $parcel$export(module.exports, "rapidboardBacklogRoute", ()=>$3abe0786c84d74a5$export$9e1d275c8078512e);
    $parcel$export(module.exports, "rapidboardBoardRoute", ()=>$3abe0786c84d74a5$export$8163d70aae333a78);
    var $65Ltd;
    const $3abe0786c84d74a5$export$9e1d275c8078512e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BACKLOG),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId/backlog',
        query: [
            'config=insightsConfig'
        ]
    };
    const $3abe0786c84d74a5$export$8163d70aae333a78 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
        path: '/jira/software/c/projects/:projectKey/boards/:boardId',
        query: [
            'config=insightsConfig'
        ]
    };
});
parcelRegister("aJzGl", function(module, exports) {
    $parcel$export(module.exports, "NextGenBacklogSkeleton", ()=>$4eeb5ef1c1c47608$export$33cd465913cf178f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7XYc4;
    var $dCm1o;
    var $gnABE;
    var $bOdHA = parcelRequire("bOdHA");
    const $4eeb5ef1c1c47608$export$433c2e8574f2e911 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($bOdHA)))
        });
    const $4eeb5ef1c1c47608$export$88189b56881f213e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($4eeb5ef1c1c47608$var$Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($bOdHA)))
        }));
    const $4eeb5ef1c1c47608$export$33cd465913cf178f = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled), $4eeb5ef1c1c47608$export$88189b56881f213e, $4eeb5ef1c1c47608$export$433c2e8574f2e911);
    const $4eeb5ef1c1c47608$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1bgi _1xpi1tcg _1sbz1tcg _1cpn1tcg _13xs1tcg",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bOdHA", function(module, exports) {
    module.exports = new URL("next-gen-backlog-app-skeleton.tpl.28e29051.svg", import.meta.url).toString();
});
parcelRegister("ltiRJ", function(module, exports) {
    $parcel$export(module.exports, "InsightsSettingsRedirect", ()=>$018a8accd0bb9a64$export$f7bc2c5799e41684);
    var $ibA3M;
    var $dIdda = parcelRequire("dIdda");
    const $018a8accd0bb9a64$export$f7bc2c5799e41684 = ()=>{
        const { setSelectedConfigTab: setSelectedConfigTab } = (0, (0, parcelRequire("ibA3M")).useSelectedConfigTab)();
        const [, setConfigParam] = (0, $dIdda.useQueryParam)('config');
        setSelectedConfigTab('filter');
        setConfigParam('filter');
        return null;
    };
});
parcelRegister("ibA3M", function(module, exports) {
    $parcel$export(module.exports, "useSelectedConfigTab", ()=>$a2554898b8aa72da$export$9b386f1a3e61b385);
    const $a2554898b8aa72da$export$9b386f1a3e61b385 = ()=>{
        const SELECTED_CONFIG_TAB_KEY = 'selectedConfigTab';
        const getSelectedConfigTab = ()=>localStorage.getItem(SELECTED_CONFIG_TAB_KEY) || '';
        const setSelectedConfigTab = (newConfigTab)=>localStorage.setItem(SELECTED_CONFIG_TAB_KEY, `"${newConfigTab}"`);
        return {
            getSelectedConfigTab: getSelectedConfigTab,
            setSelectedConfigTab: setSelectedConfigTab
        };
    };
});
parcelRegister("eriCB", function(module, exports) {
    $parcel$export(module.exports, "rapidboardBoardRouteEntry", ()=>$4173ec798b4a3bc2$export$910bdb49ffbc1a01);
    var $g87MG;
    var $ffza4;
    var $e2ctp;
    var $gyYxw;
    var $g5RGc;
    var $lmyls;
    var $hBv66;
    var $2G9Bk;
    var $1XrjK;
    var $lfnsv;
    var $f5kpo;
    var $3RJkv;
    var $d04s2;
    var $68mjh;
    var $7Y3Wj;
    var $gcguf;
    var $5PD5h;
    var $ltiRJ;
    const $4173ec798b4a3bc2$export$910bdb49ffbc1a01 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("68mjh")).rapidboardBoardRoute), ()=>({
            ufoName: 'rapidboard-board-insights',
            component: (0, (0, parcelRequire("ltiRJ")).InsightsSettingsRedirect),
            skeleton: (0, (0, parcelRequire("gcguf")).ClassicBoardSkeleton),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                {
                    query: [
                        'selectedIssue',
                        'view=detail'
                    ]
                },
                {
                    query: [
                        'selectedIssue',
                        'modal=detail'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectResource)(),
                ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                (0, (0, parcelRequire("g87MG")).issueHierarchyPageResource),
                (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)()
            ],
            afterPaint: [
                (0, (0, parcelRequire("d04s2")).LazyIssueApp)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoard),
                (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoardApps),
                (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoardDataApiResource),
                (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoardConfigApiResource),
                (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoardWrmBundleResource),
                (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoardResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'rapidboard-early-entry'
                ]
            },
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$fc5f182fc9019b1c)
            },
            earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY)
        }));
});
parcelRegister("bXGW3", function(module, exports) {
    $parcel$export(module.exports, "legacyRapidBoardRouteEntry", ()=>$5e98dd01700151f4$export$4a5b9e48e40676ad);
    var $ffza4;
    var $e2ctp;
    var $gyYxw;
    var $g5RGc;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $1XrjK;
    var $f5kpo;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $d04s2;
    var $jIl52;
    var $7Y3Wj;
    var $gcguf;
    var $5PD5h;
    const $5e98dd01700151f4$export$4a5b9e48e40676ad = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jIl52")).rapidboardBoardRoute), ()=>({
            ufoName: 'classic-board',
            component: (0, (0, parcelRequire("7Y3Wj")).RapidBoardSpaPage),
            skeleton: (0, (0, parcelRequire("gcguf")).ClassicBoardSkeleton),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                {
                    query: [
                        'selectedIssue',
                        'view=detail'
                    ]
                },
                {
                    query: [
                        'selectedIssue',
                        'modal=detail'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                ...(0, (0, parcelRequire("3RJkv")).getUserBoardNavigationResources)()
            ],
            afterPaint: [
                (0, (0, parcelRequire("d04s2")).LazyIssueApp)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoard),
                (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoardApps)
            ],
            preloadOptions: {
                earlyChunks: [
                    'rapidboard-early-entry'
                ]
            },
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$fc5f182fc9019b1c)
            },
            earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY)
        }));
});
parcelRegister("jIl52", function(module, exports) {
    $parcel$export(module.exports, "rapidboardBoardRoute", ()=>$fd9da0460c22fa5a$export$8163d70aae333a78);
    var $65Ltd;
    const $fd9da0460c22fa5a$export$8163d70aae333a78 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_BOARD),
        path: '/secure/RapidBoard.jspa',
        query: [
            'rapidView'
        ]
    };
});
parcelRegister("1BC32", function(module, exports) {
    $parcel$export(module.exports, "softwareDeploymentsNextGenRouteEntry", ()=>$2cdb997b770c0bb4$export$7e5ccb20ad8e1612);
    $parcel$export(module.exports, "softwareDeploymentsClassicRouteEntry", ()=>$2cdb997b770c0bb4$export$dcf1f9ba660dedf6);
    var $5uXOq = parcelRequire("5uXOq");
    var $e4eHl = parcelRequire("e4eHl");
    var $ffza4;
    var $65Ltd;
    var $7XYc4;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $9s3j1;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $b4koY;
    var $7GnDe;
    var $5lsNZ;
    var $6dkMG;
    var $kfztd;
    var $5PD5h;
    var $e7bC3;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $2cdb997b770c0bb4$export$ed6d152d5551715c = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8awia"))), {
        moduleId: "./src/packages/spa-apps/deployments/src/index.tsx"
    });
    const $2cdb997b770c0bb4$export$35822a21682c5ed8 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2cdb997b770c0bb4$export$ed6d152d5551715c,
            pageId: "deploymentsNextGen",
            shouldShowSpinner: true
        });
    const $2cdb997b770c0bb4$export$7361c0feb3154afe = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2cdb997b770c0bb4$export$ed6d152d5551715c,
            pageId: "deploymentsClassic",
            shouldShowSpinner: true
        });
    const $2cdb997b770c0bb4$export$7e5ccb20ad8e1612 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6dkMG")).softwareDeploymentsRoute), ()=>({
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), $2cdb997b770c0bb4$export$35822a21682c5ed8),
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("b4koY")).deploymentPreconditionRelayResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $2cdb997b770c0bb4$export$ed6d152d5551715c
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS)),
                    teamName: 'fusion-solaris'
                }
            }
        }));
    const $2cdb997b770c0bb4$export$dcf1f9ba660dedf6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6dkMG")).softwareDeploymentsClassicRoute), ()=>({
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("b4koY")).deploymentPreconditionRelayResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), $2cdb997b770c0bb4$export$7361c0feb3154afe),
            layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("9s3j1")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $2cdb997b770c0bb4$export$ed6d152d5551715c
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC)),
                    teamName: 'fusion-solaris'
                }
            }
        }));
});
parcelRegister("b4koY", function(module, exports) {
    $parcel$export(module.exports, "deploymentPreconditionRelayResource", ()=>$b79457e490ba4467$export$50e4eedb9e6127c8);
    var $ao2h1;
    var $ajgeO;
    var $dIdda = parcelRequire("dIdda");
    const $b79457e490ba4467$export$a1c09d7f7318f85c = (0, $dIdda.createResource)({
        type: (0, $c47c39dbdbc02648$export$2171160371fac588),
        getKey: ({ query: query })=>query.projectKey,
        getDataLoader: ()=>(parcelRequire("hM28Z")),
        maxAge: 60000
    });
    const $b79457e490ba4467$export$50e4eedb9e6127c8 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $c47c39dbdbc02648$export$a969d0487e348031),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("ajgeO")).default),
                variables: {
                    cloudId: tenantContext.cloudId,
                    projectKey: String(match.params.projectKey)
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("ajgeO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e0f41d4aeb9b6b93$export$2e2bcd8739ae039);
    const $e0f41d4aeb9b6b93$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            }
        ], v1 = {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                }
            ],
            "kind": "ScalarField",
            "name": "deploymentsFeaturePreconditionByProjectKey"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "uiDeploymentsFeaturePreconditionQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": v1,
                                    "action": "THROW",
                                    "path": "jira.deploymentsFeaturePreconditionByProjectKey"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "uiDeploymentsFeaturePreconditionQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            v1
                        ]
                    }
                ]
            },
            "params": {
                "id": "0b497951b118068d82bb77e253f1fcb758c4dde1aa7f8eb01bf559f5961522f2",
                "metadata": {},
                "name": "uiDeploymentsFeaturePreconditionQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $e0f41d4aeb9b6b93$var$node.hash = "3337e3d6b76da02b643c63aacd15b239";
    var $e0f41d4aeb9b6b93$export$2e2bcd8739ae039 = $e0f41d4aeb9b6b93$var$node;
});
const $c47c39dbdbc02648$export$2171160371fac588 = 'SOFTWARE_DEPLOYMENTS_PRECONDITION';
const $c47c39dbdbc02648$export$a969d0487e348031 = 'SOFTWARE_DEPLOYMENTS_PRECONDITION_RELAY';
parcelRegister("hM28Z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("f0to4").then(()=>parcelRequire('96xO4'));
});
parcelRegister("6dkMG", function(module, exports) {
    $parcel$export(module.exports, "softwareDeploymentsRoute", ()=>$75bfb8b57cb3016c$export$3ba8dd9a7886e7d);
    $parcel$export(module.exports, "softwareDeploymentsClassicRoute", ()=>$75bfb8b57cb3016c$export$485e4a7b82f29d70);
    var $65Ltd;
    const $75bfb8b57cb3016c$export$3ba8dd9a7886e7d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS),
        path: '/jira/software/projects/:projectKey/deployments'
    };
    const $75bfb8b57cb3016c$export$485e4a7b82f29d70 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_DEPLOYMENTS_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/deployments'
    };
});
parcelRegister("kfztd", function(module, exports) {
    $parcel$export(module.exports, "isDevopsFeatureDisabledInFedRamp", ()=>$064393a36b21cb6e$export$18bfef4995ec57b7);
    var $1WqFo;
    var $eIXQk;
    const $064393a36b21cb6e$export$18bfef4995ec57b7 = ()=>(0, (0, parcelRequire("eIXQk")).isDisableDevopsFeaturesInFedRampEnvEnabled)() && (0, (0, parcelRequire("1WqFo")).isFedRamp)();
});
parcelRegister("eIXQk", function(module, exports) {
    $parcel$export(module.exports, "isDisableDevopsFeaturesInFedRampEnvEnabled", ()=>$4ce1ad45498aedfa$export$a803c452d83c73b6);
    var $co1wz;
    const $4ce1ad45498aedfa$export$a803c452d83c73b6 = ()=>(0, (0, parcelRequire("co1wz")).ff)('core-x-fedramp-m1-disable-devops-features_ag5zy');
});
parcelRegister("8awia", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cBa2R")
    ]).then(()=>parcelRequire('5EQGR'));
});
parcelRegister("bmpFr", function(module, exports) {
    $parcel$export(module.exports, "LazyFormBuilderView", ()=>$6bbae009e0a4162e$export$2076234d7fde1717);
    $parcel$export(module.exports, "FormBuilderPage", ()=>$6bbae009e0a4162e$export$a4c73b2a16981930);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $6bbae009e0a4162e$export$2076234d7fde1717 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("lHhzD")), {
        moduleId: "./src/packages/spa-apps/software/form-builder/src/index.tsx"
    });
    const $6bbae009e0a4162e$export$a4c73b2a16981930 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6bbae009e0a4162e$export$2076234d7fde1717,
            pageId: "async-software-form-builder",
            shouldShowSpinner: true
        });
});
parcelRegister("lHhzD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("kWlGu")
    ]).then(()=>parcelRequire('jM2sL'));
});
parcelRegister("6Nh7k", function(module, exports) {
    $parcel$export(module.exports, "LazyFormView", ()=>$7513c2d92a0c1be5$export$240a58749ebba091);
    $parcel$export(module.exports, "FormPage", ()=>$7513c2d92a0c1be5$export$7234abc5d81adb58);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $7513c2d92a0c1be5$export$240a58749ebba091 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("9bKt5")), {
        moduleId: "./src/packages/spa-apps/software/form/src/index.tsx"
    });
    const $7513c2d92a0c1be5$export$7234abc5d81adb58 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7513c2d92a0c1be5$export$240a58749ebba091,
            pageId: "async-software-form",
            shouldShowSpinner: true
        });
});
parcelRegister("9bKt5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("636Ie").then(()=>parcelRequire('jqjLM'));
});
parcelRegister("6UGN7", function(module, exports) {
    $parcel$export(module.exports, "LazyFormSubmitView", ()=>$a96ac2d599fb8faa$export$258fcd204933dd75);
    $parcel$export(module.exports, "FormSubmitPage", ()=>$a96ac2d599fb8faa$export$4258f48cc65dca00);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $a96ac2d599fb8faa$export$258fcd204933dd75 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("g0oJP")), {
        moduleId: "./src/packages/spa-apps/software/form-submit/src/index.tsx"
    });
    const $a96ac2d599fb8faa$export$4258f48cc65dca00 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a96ac2d599fb8faa$export$258fcd204933dd75,
            pageId: "async-software-form-submit",
            shouldShowSpinner: true
        });
});
parcelRegister("g0oJP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("9z4nz")
    ]).then(()=>parcelRequire('6SZAm'));
});
parcelRegister("ebynk", function(module, exports) {
    $parcel$export(module.exports, "softwarePeriscopeNextGenRouteEntry", ()=>$9db212062a348ac3$export$7db4d910357a4d89);
    $parcel$export(module.exports, "softwarePeriscopeClassicRouteEntry", ()=>$9db212062a348ac3$export$d7d49c1a51b3c0a9);
    var $5uXOq = parcelRequire("5uXOq");
    var $e4eHl = parcelRequire("e4eHl");
    var $1WqFo;
    var $ffza4;
    var $65Ltd;
    var $7XYc4;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $9s3j1;
    var $ajKFd;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5lsNZ;
    var $kXIYA;
    var $5PD5h;
    var $e7bC3;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $9db212062a348ac3$export$9c25b4571a88e1f = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9w6V0"))), {
        moduleId: "./src/packages/spa-apps/periscope/src/index.tsx"
    });
    const $9db212062a348ac3$export$d86ed8d2756a4d4d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9db212062a348ac3$export$9c25b4571a88e1f,
            pageId: "softwarePeriscopeNextGen",
            shouldShowSpinner: true
        });
    const $9db212062a348ac3$export$fd5920cadc24919d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9db212062a348ac3$export$9c25b4571a88e1f,
            pageId: "softwarePeriscopeClassic",
            shouldShowSpinner: true
        });
    const $9db212062a348ac3$export$7db4d910357a4d89 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kXIYA")).softwarePeriscopeRoute), ()=>({
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("1WqFo")).isFedRamp), (0, (0, parcelRequire("5lsNZ")).default), $9db212062a348ac3$export$d86ed8d2756a4d4d),
            skeleton: (0, (0, parcelRequire("ajKFd")).Skeleton),
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $9db212062a348ac3$export$9c25b4571a88e1f
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE)),
                    teamName: 'nova'
                }
            }
        }));
    const $9db212062a348ac3$export$d7d49c1a51b3c0a9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kXIYA")).softwarePeriscopeClassicRoute), ()=>({
            skeleton: (0, (0, parcelRequire("ajKFd")).Skeleton),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("1WqFo")).isFedRamp), (0, (0, parcelRequire("5lsNZ")).default), $9db212062a348ac3$export$fd5920cadc24919d),
            layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("9s3j1")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $9db212062a348ac3$export$9c25b4571a88e1f
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC)),
                    teamName: 'nova'
                }
            }
        }));
});
parcelRegister("ajKFd", function(module, exports) {
    $parcel$export(module.exports, "Skeleton", ()=>$b9eb4b3f312b449f$export$8f31e4c4a37b8e9c);
    $parcel$export(module.exports, "InsightsSkeleton", ()=>$b9eb4b3f312b449f$export$dd0b74c715df3275);
    $parcel$export(module.exports, "SuggestionsSkeleton", ()=>$b9eb4b3f312b449f$export$91f27b306afd627b);
    $parcel$export(module.exports, "WorkItemsSkeleton", ()=>$b9eb4b3f312b449f$export$1660f3159b79b22b);
    $parcel$export(module.exports, "WorkItemsVulnTabSkeleton", ()=>$b9eb4b3f312b449f$export$5aea7d4ed03d6ea6);
    $parcel$export(module.exports, "WorkItemsDeploymentTabSkeleton", ()=>$b9eb4b3f312b449f$export$ff38ee81427877e9);
    var $5uXOq = parcelRequire("5uXOq");
    var $6T4rd;
    var $fHbE4;
    var $jJ1Sb;
    var $koVbs;
    var $hWIK7;
    var $29cNf;
    const $b9eb4b3f312b449f$export$8f31e4c4a37b8e9c = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fHbE4")).default), {
            xcss: $b9eb4b3f312b449f$var$MainContainerStyles,
            "data-testId": "software-periscope-periscope-page.ui.loading",
            "aria-label": formatMessage((0, (0, parcelRequire("29cNf")).default).labelNonFinal),
            gap: "space.300"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fHbE4")).default), {
            xcss: $b9eb4b3f312b449f$var$leftColumnStyles,
            direction: "column"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $b9eb4b3f312b449f$var$InsightsContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hWIK7")).PeriscopeInsightsSkeleton), null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $b9eb4b3f312b449f$var$WorkItemsContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hWIK7")).PeriscopeWorkItemsSkeleton), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fHbE4")).default), {
            xcss: $b9eb4b3f312b449f$var$rightColumnStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $b9eb4b3f312b449f$var$SuggestionsContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hWIK7")).PeriscopeSuggestionsSkeleton), null))));
    };
    const $b9eb4b3f312b449f$export$dd0b74c715df3275 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $b9eb4b3f312b449f$var$InsightsContainerStyles,
            "data-testId": "software-periscope-periscope-page.insights-ui.loading",
            "aria-label": formatMessage((0, (0, parcelRequire("29cNf")).default).insightsLabelNonFinal),
            paddingBlockEnd: "space.400"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hWIK7")).PeriscopeInsightsSkeleton), null));
    };
    const $b9eb4b3f312b449f$export$91f27b306afd627b = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $b9eb4b3f312b449f$var$SuggestionsContainerStyles,
            "data-testId": "software-periscope-periscope-page.suggestions-ui.loading",
            "aria-label": formatMessage((0, (0, parcelRequire("29cNf")).default).suggestionsLabelNonFinal),
            paddingBlockEnd: "space.400"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hWIK7")).PeriscopeSuggestionsSkeleton), null));
    };
    const $b9eb4b3f312b449f$export$1660f3159b79b22b = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $b9eb4b3f312b449f$var$WorkItemsContainerStyles,
            "aria-label": formatMessage((0, (0, parcelRequire("29cNf")).default).workItemsLabelNonFinal),
            paddingBlockEnd: "space.400"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hWIK7")).PeriscopeWorkItemsSkeleton), null));
    };
    const $b9eb4b3f312b449f$export$5aea7d4ed03d6ea6 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $b9eb4b3f312b449f$var$WorkItemsVulnTabContainerStyles,
            "aria-label": formatMessage((0, (0, parcelRequire("29cNf")).default).workItemsVulnTabLabelNonFinal)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hWIK7")).DevelopmentPageWorkItemsVulnTabSkeleton), null));
    };
    const $b9eb4b3f312b449f$export$ff38ee81427877e9 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $b9eb4b3f312b449f$var$WorkItemsContainerStyles,
            "aria-label": formatMessage((0, (0, parcelRequire("29cNf")).default).workItemsDeploymentTabLabelNonFinal),
            paddingBlockEnd: "space.400"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hWIK7")).DevelopmentPageWorkItemsDeploymentTabSkeleton), null));
    };
    const $b9eb4b3f312b449f$var$MainContainerStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        width: '100%',
        height: '100%',
        display: 'flex',
        boxSizing: 'border-box',
        overflow: 'hidden'
    });
    const $b9eb4b3f312b449f$var$leftColumnStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        flex: '2 1 0'
    });
    const $b9eb4b3f312b449f$var$rightColumnStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        flex: '1 1 0'
    });
    const $b9eb4b3f312b449f$var$SuggestionsContainerStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        width: '100%',
        overflow: 'hidden',
        height: '650px',
        boxSizing: 'border-box'
    });
    const $b9eb4b3f312b449f$var$InsightsContainerStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        overflow: 'hidden',
        width: '100%',
        height: '385px',
        boxSizing: 'border-box'
    });
    const $b9eb4b3f312b449f$var$WorkItemsContainerStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        width: '100%',
        height: '600px',
        boxSizing: 'border-box',
        overflow: 'hidden'
    });
    const $b9eb4b3f312b449f$var$WorkItemsVulnTabContainerStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        width: '100%',
        height: '420px',
        boxSizing: 'border-box',
        overflow: 'hidden'
    });
});
parcelRegister("hWIK7", function(module, exports) {
    $parcel$export(module.exports, "PeriscopeSuggestionsSkeleton", ()=>$730ffbc9c8197f60$export$176dfe4c14771136);
    $parcel$export(module.exports, "PeriscopeInsightsSkeleton", ()=>$730ffbc9c8197f60$export$afb44f298901be44);
    $parcel$export(module.exports, "PeriscopeWorkItemsSkeleton", ()=>$730ffbc9c8197f60$export$298a6b6a251923c2);
    $parcel$export(module.exports, "DevelopmentPageWorkItemsVulnTabSkeleton", ()=>$730ffbc9c8197f60$export$8940e0b80e4066d6);
    $parcel$export(module.exports, "DevelopmentPageWorkItemsDeploymentTabSkeleton", ()=>$730ffbc9c8197f60$export$2f5ed71a7df2d4e6);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $2vpp7 = parcelRequire("2vpp7");
    var $47suu = parcelRequire("47suu");
    var $aR5hR = parcelRequire("aR5hR");
    var $bIAib = parcelRequire("bIAib");
    var $gqrFB = parcelRequire("gqrFB");
    var $2aQWX = parcelRequire("2aQWX");
    const $730ffbc9c8197f60$var$PeriscopePageSkeletonStyles = null;
    const $730ffbc9c8197f60$export$4aecc030c4d69f74 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "skeletons.ui.periscope-page.app-skeleton-image-periscope-page-new",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($aR5hR)))
        }));
    const $730ffbc9c8197f60$export$176dfe4c14771136 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "skeletons.ui.periscope-page.app-suggestions-skeleton",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($bIAib)))
        }));
    const $730ffbc9c8197f60$export$afb44f298901be44 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "skeletons.ui.periscope-page.app-insights-skeleton",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($47suu)))
        }));
    const $730ffbc9c8197f60$export$298a6b6a251923c2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($2aQWX)))
        }));
    const $730ffbc9c8197f60$export$8940e0b80e4066d6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($gqrFB)))
        }));
    const $730ffbc9c8197f60$export$2f5ed71a7df2d4e6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _xxs9glyw _nj22glyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($2vpp7)))
        }));
});
parcelRegister("2vpp7", function(module, exports) {
    module.exports = new URL("deployment-tab-skeleton.tpl.6442d1f9.svg", import.meta.url).toString();
});
parcelRegister("47suu", function(module, exports) {
    module.exports = new URL("insights.tpl.c29b665e.svg", import.meta.url).toString();
});
parcelRegister("aR5hR", function(module, exports) {
    module.exports = new URL("periscope-page-full-layout.tpl.243222d7.svg", import.meta.url).toString();
});
parcelRegister("bIAib", function(module, exports) {
    module.exports = new URL("suggestions.tpl.52cb06d0.svg", import.meta.url).toString();
});
parcelRegister("gqrFB", function(module, exports) {
    module.exports = new URL("vuln-tab-skeleton.tpl.1a18ea24.svg", import.meta.url).toString();
});
parcelRegister("2aQWX", function(module, exports) {
    module.exports = new URL("work-items.tpl.4ee9e4f3.svg", import.meta.url).toString();
});
parcelRegister("29cNf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34a050fcfbf5d355$export$2e2bcd8739ae039);
    var $7VHMR;
    var $34a050fcfbf5d355$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        labelNonFinal: {
            "id": "periscope.skeleton.label-non-final",
            "defaultMessage": "Loading"
        },
        suggestionsLabelNonFinal: {
            "id": "periscope.suggestions-skeleton.label-non-final",
            "defaultMessage": "Suggestions loading"
        },
        insightsLabelNonFinal: {
            "id": "periscope.insights-skeleton.label-non-final",
            "defaultMessage": "Developer insights loading"
        },
        workItemsLabelNonFinal: {
            "id": "periscope.work-items-skeleton.work-items-label-non-final",
            "defaultMessage": "Work items loading"
        },
        workItemsVulnTabLabelNonFinal: {
            "id": "periscope.work-items-skeleton.work-items-vuln-tab-label-non-final",
            "defaultMessage": "Work items vulnerability tab loading"
        },
        workItemsDeploymentTabLabelNonFinal: {
            "id": "periscope.work-items-skeleton.work-items-deployment-tab-label-non-final",
            "defaultMessage": "Work items deployment tab loading"
        }
    });
});
parcelRegister("kXIYA", function(module, exports) {
    $parcel$export(module.exports, "softwarePeriscopeRoute", ()=>$50b0eee0a3f432d7$export$7e7b18da5d3ceba0);
    $parcel$export(module.exports, "softwarePeriscopeClassicRoute", ()=>$50b0eee0a3f432d7$export$cb5cec74f302b3c6);
    var $65Ltd;
    const $50b0eee0a3f432d7$export$7e7b18da5d3ceba0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE),
        path: '/jira/software/projects/:projectKey/development'
    };
    const $50b0eee0a3f432d7$export$cb5cec74f302b3c6 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_PERISCOPE_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/development'
    };
});
parcelRegister("9w6V0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("WP2Js")
    ]).then(()=>parcelRequire('k9ngM'));
});
parcelRegister("9B5P6", function(module, exports) {
    $parcel$export(module.exports, "softwareSecurityNextGenRouteEntry", ()=>$1bbbe61aca30e3ab$export$a8dcfae475505e7a);
    $parcel$export(module.exports, "softwareSecurityClassicRouteEntry", ()=>$1bbbe61aca30e3ab$export$8acfebad16c9d6f2);
    var $5uXOq = parcelRequire("5uXOq");
    var $e4eHl = parcelRequire("e4eHl");
    var $ffza4;
    var $65Ltd;
    var $bwLf9;
    var $4R6GH;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $9s3j1;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $en8e6;
    var $5lsNZ;
    var $dynqk;
    var $kfztd;
    var $5PD5h;
    var $e7bC3;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $1bbbe61aca30e3ab$var$isSecurityPageEnabled = ()=>!(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)() && (0, (0, parcelRequire("4R6GH")).fg)('isotopes-security-page-in-jira-enabled-v2');
    const $1bbbe61aca30e3ab$export$30c10c4b0cb1d8e3 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("csz4l"))), {
        moduleId: "./src/packages/spa-apps/security/src/index.tsx"
    });
    const $1bbbe61aca30e3ab$export$c6cc344ea309349a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1bbbe61aca30e3ab$export$30c10c4b0cb1d8e3,
            pageId: "securityNextGen",
            shouldShowSpinner: true
        });
    const $1bbbe61aca30e3ab$export$b4dc9ba40afbdd9f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1bbbe61aca30e3ab$export$30c10c4b0cb1d8e3,
            pageId: "securityClassic",
            shouldShowSpinner: true
        });
    const $1bbbe61aca30e3ab$export$a8dcfae475505e7a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("dynqk")).softwareSecurityRoute), ()=>({
            component: (0, (0, parcelRequire("bwLf9")).default)($1bbbe61aca30e3ab$var$isSecurityPageEnabled, $1bbbe61aca30e3ab$export$c6cc344ea309349a, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
            ufoName: 'software-security-combined',
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("en8e6")).securityPageResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $1bbbe61aca30e3ab$export$30c10c4b0cb1d8e3
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY)),
                    teamName: 'fusion-isotopes'
                }
            }
        }));
    const $1bbbe61aca30e3ab$export$8acfebad16c9d6f2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("dynqk")).softwareSecurityClassicRoute), ()=>({
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("en8e6")).securityPageResource)
            ],
            ufoName: 'software-security-combined',
            component: (0, (0, parcelRequire("bwLf9")).default)($1bbbe61aca30e3ab$var$isSecurityPageEnabled, $1bbbe61aca30e3ab$export$b4dc9ba40afbdd9f, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("9s3j1")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $1bbbe61aca30e3ab$export$30c10c4b0cb1d8e3
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC)),
                    teamName: 'fusion-isotopes'
                }
            }
        }));
});
parcelRegister("bwLf9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a7ec252b6b084884$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $a7ec252b6b084884$export$2e2bcd8739ae039 = (conditionGetter, ComponentTrue, ComponentFalse)=>{
        const ComponentWithCondition = (props)=>conditionGetter() ? (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentTrue, props) : (0, ($parcel$interopDefault($5uXOq))).createElement(ComponentFalse, props);
        if (conditionGetter.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${conditionGetter.name}]`;
        return ComponentWithCondition;
    };
});
parcelRegister("en8e6", function(module, exports) {
    $parcel$export(module.exports, "securityPageResource", ()=>$ae0f760fa9a80a3f$export$2c5e3c161b8fe98);
    var $65Ltd;
    var $dXq4S;
    var $ao2h1;
    var $1UBcC;
    var $ac0bf;
    const $ae0f760fa9a80a3f$var$getNumberOfVulnerabilitiesToFetch = ()=>40;
    const $ae0f760fa9a80a3f$var$getNumberOfSecurityContainersToFetch = ()=>100;
    let $ae0f760fa9a80a3f$var$filters;
    const $ae0f760fa9a80a3f$export$2c5e3c161b8fe98 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $0a72320b8bc3a1aa$export$f24db22c3c834cb1),
        getQuery ({ match: { params: params }, query: query, route: { name: name } }, { tenantContext: { cloudId: cloudId, activationId: activationId } }) {
            const isSecRoute = name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY) || name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC);
            if (!$ae0f760fa9a80a3f$var$filters && isSecRoute) {
                const connectionAri = (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'security-container',
                    cloudId: cloudId,
                    activationId: activationId,
                    resourceId: ''
                });
                $ae0f760fa9a80a3f$var$filters = (0, (0, parcelRequire("ac0bf")).getGqlFiltersFromQueryParams)(query, connectionAri);
            }
            if (!isSecRoute) $ae0f760fa9a80a3f$var$filters = undefined;
            return {
                parameters: (0, (0, parcelRequire("1UBcC")).default),
                options: {
                    fetchPolicy: 'store-and-network'
                },
                variables: {
                    cloudAri: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira',
                        resourceType: 'site',
                        resourceId: cloudId
                    }),
                    cloudId: cloudId,
                    projectKey: params.projectKey ?? '',
                    numberOfVulnsToFetch: $ae0f760fa9a80a3f$var$getNumberOfVulnerabilitiesToFetch(),
                    getContainers: false,
                    numberOfContainersToFetch: $ae0f760fa9a80a3f$var$getNumberOfSecurityContainersToFetch(),
                    filter: $ae0f760fa9a80a3f$var$filters
                }
            };
        }
    });
});
parcelRegister("1UBcC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$511d4548ae93769f$export$2e2bcd8739ae039);
    const $511d4548ae93769f$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudAri"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "getContainers"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "numberOfContainersToFetch"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "numberOfVulnsToFetch"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v7 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v8 = {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        }, v9 = {
            "kind": "ScalarField",
            "name": "totalLinkedSecurityContainerCount"
        }, v10 = [
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "numberOfContainersToFetch"
            }
        ], v11 = {
            "kind": "ScalarField",
            "name": "providerId"
        }, v12 = [
            v11
        ], v13 = {
            "kind": "InlineFragment",
            "selections": v12,
            "type": "ThirdPartySecurityContainer"
        }, v14 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v15 = {
            "kind": "Variable",
            "name": "first",
            "variableName": "numberOfVulnsToFetch"
        }, v16 = [
            {
                "kind": "Literal",
                "name": "filter",
                "value": {
                    "and": {
                        "lastUpdated": {
                            "sort": {
                                "order": "ASC",
                                "priority": 1
                            }
                        }
                    }
                }
            },
            v15
        ], v17 = {
            "kind": "ScalarField",
            "name": "id"
        }, v18 = {
            "kind": "ScalarField",
            "name": "name"
        }, v19 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v20 = {
            "concreteType": "DevOps",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "cloudAri"
                        },
                        {
                            "kind": "Literal",
                            "name": "providerTypes",
                            "value": [
                                "SECURITY"
                            ]
                        }
                    ],
                    "concreteType": "DevOpsProviders",
                    "kind": "LinkedField",
                    "name": "providers",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DevOpsSecurityProvider",
                            "kind": "LinkedField",
                            "name": "securityProviders",
                            "plural": true,
                            "selections": [
                                v17,
                                {
                                    "kind": "ScalarField",
                                    "name": "appInstallationId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "logoUrl"
                                },
                                v18,
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 100
                                        }
                                    ],
                                    "concreteType": "AriGraphRelationshipConnection",
                                    "kind": "LinkedField",
                                    "name": "linkedWorkspaces",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "AriGraphRelationship",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v19
                                            ]
                                        }
                                    ],
                                    "storageKey": "linkedWorkspaces(first:100)"
                                }
                            ]
                        }
                    ]
                }
            ]
        }, v21 = [
            v17
        ], v22 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "Node",
            "abstractKey": "__isNode"
        }, v23 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "ConfluencePage"
        }, v24 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "ConfluenceSpace"
        }, v25 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "DevOpsFeatureFlag"
        }, v26 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "DevOpsOperationsComponentDetails"
        }, v27 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "DevOpsOperationsIncidentDetails"
        }, v28 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "DevOpsOperationsPostIncidentReviewDetails"
        }, v29 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "DevOpsPullRequestDetails"
        }, v30 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "DevOpsRepository"
        }, v31 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "DevOpsSecurityVulnerabilityDetails"
        }, v32 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "JiraConfluenceRemoteIssueLink"
        }, v33 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "JiraCustomRemoteIssueLink"
        }, v34 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "JiraIssueRemoteIssueLink"
        }, v35 = {
            "kind": "InlineFragment",
            "selections": v21,
            "type": "JiraWebRemoteIssueLink"
        }, v36 = [
            v8,
            v15
        ], v37 = {
            "kind": "ScalarField",
            "name": "url"
        }, v38 = {
            "kind": "ScalarField",
            "name": "key"
        }, v39 = {
            "kind": "ScalarField",
            "name": "cursor"
        }, v40 = {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "endCursor"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6
                ],
                "kind": "Fragment",
                "name": "mainSecurityInJiraQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v7,
                                    "concreteType": "JiraProject",
                                    "kind": "LinkedField",
                                    "name": "jiraProjectByKey",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": [
                                                v8,
                                                {
                                                    "kind": "Variable",
                                                    "name": "getContainers",
                                                    "variableName": "getContainers"
                                                },
                                                {
                                                    "kind": "Variable",
                                                    "name": "numberOfContainersToFetch",
                                                    "variableName": "numberOfContainersToFetch"
                                                }
                                            ],
                                            "kind": "FragmentSpread",
                                            "name": "main_softwareSecurityPage_MainPage"
                                        },
                                        v9,
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "args": v10,
                                                "concreteType": "AriGraphRelationshipConnection",
                                                "kind": "LinkedField",
                                                "name": "linkedSecurityContainers",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "AriGraphRelationshipEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "AriGraphRelationship",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "AriGraphRelationshipNode",
                                                                        "kind": "LinkedField",
                                                                        "name": "to",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "condition": "getContainers",
                                                                                "kind": "Condition",
                                                                                "passingValue": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "LinkedField",
                                                                                        "name": "data",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v13
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    v14
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "jira.jiraProjectByKey.linkedSecurityContainers"
                                        },
                                        {
                                            "alias": "linkedVulnsForAnalytics",
                                            "args": v16,
                                            "concreteType": "GraphJiraVulnerabilityConnection",
                                            "kind": "LinkedField",
                                            "name": "linkedSecurityVulnerabilitiesByProject",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "GraphJiraVulnerabilityEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "GraphJiraVulnerability",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "condition": "getContainers",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                            "kind": "LinkedField",
                                                                            "name": "vulnerability",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ThirdPartySecurityContainer",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "securityContainer",
                                                                                    "plural": false,
                                                                                    "selections": v12
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.jiraProjectByKey"
                            }
                        ]
                    },
                    v20
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v6,
                    v5,
                    v3,
                    v4,
                    v2
                ],
                "kind": "Operation",
                "name": "mainSecurityInJiraQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v7,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    v9,
                                    v17,
                                    {
                                        "args": v10,
                                        "concreteType": "AriGraphRelationshipConnection",
                                        "kind": "LinkedField",
                                        "name": "linkedSecurityContainers",
                                        "plural": false,
                                        "selections": [
                                            v14,
                                            {
                                                "concreteType": "AriGraphRelationshipEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "AriGraphRelationship",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "AriGraphRelationshipNode",
                                                                "kind": "LinkedField",
                                                                "name": "to",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "condition": "getContainers",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "data",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v19,
                                                                                    v13,
                                                                                    v22,
                                                                                    v23,
                                                                                    v24,
                                                                                    v25,
                                                                                    v26,
                                                                                    v27,
                                                                                    v28,
                                                                                    v29,
                                                                                    v30,
                                                                                    v31,
                                                                                    v32,
                                                                                    v33,
                                                                                    v34,
                                                                                    v35
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    v17
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "args": [
                                            v8
                                        ],
                                        "kind": "ScalarField",
                                        "name": "totalLinkedSecurityVulnerabilityCount"
                                    },
                                    {
                                        "args": v36,
                                        "concreteType": "GraphJiraVulnerabilityConnection",
                                        "kind": "LinkedField",
                                        "name": "linkedSecurityVulnerabilitiesByProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphJiraVulnerabilityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "GraphJiraVulnerability",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                "kind": "LinkedField",
                                                                "name": "vulnerability",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "title"
                                                                    },
                                                                    {
                                                                        "condition": "getContainers",
                                                                        "kind": "Condition",
                                                                        "passingValue": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "ThirdPartySecurityContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "securityContainer",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v17,
                                                                                    v18,
                                                                                    v37
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "DevOpsSecurityVulnerabilityIdentifier",
                                                                        "kind": "LinkedField",
                                                                        "name": "identifiers",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "displayName"
                                                                            },
                                                                            v37
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "DevOpsSecurityVulnerabilityAdditionalInfo",
                                                                        "kind": "LinkedField",
                                                                        "name": "additionalInfo",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "content"
                                                                            },
                                                                            v37
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "status"
                                                                    },
                                                                    {
                                                                        "concreteType": "AriGraphRelationshipConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "linkedJiraIssues",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "AriGraphRelationship",
                                                                                "kind": "LinkedField",
                                                                                "name": "nodes",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "AriGraphRelationshipNode",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "to",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v17,
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "data",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v19,
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "args": [
                                                                                                                    {
                                                                                                                        "kind": "Literal",
                                                                                                                        "name": "idsOrAliases",
                                                                                                                        "value": [
                                                                                                                            "summary",
                                                                                                                            "assignee",
                                                                                                                            "status",
                                                                                                                            "issuetype"
                                                                                                                        ]
                                                                                                                    }
                                                                                                                ],
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "fieldsByIdOrAlias",
                                                                                                                "plural": true,
                                                                                                                "selections": [
                                                                                                                    v19,
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "concreteType": "JiraStatus",
                                                                                                                                "kind": "LinkedField",
                                                                                                                                "name": "status",
                                                                                                                                "plural": false,
                                                                                                                                "selections": [
                                                                                                                                    v18,
                                                                                                                                    v17,
                                                                                                                                    {
                                                                                                                                        "concreteType": "JiraStatusCategory",
                                                                                                                                        "kind": "LinkedField",
                                                                                                                                        "name": "statusCategory",
                                                                                                                                        "plural": false,
                                                                                                                                        "selections": [
                                                                                                                                            v38,
                                                                                                                                            v17
                                                                                                                                        ]
                                                                                                                                    }
                                                                                                                                ]
                                                                                                                            }
                                                                                                                        ],
                                                                                                                        "type": "JiraStatusField"
                                                                                                                    },
                                                                                                                    v17,
                                                                                                                    {
                                                                                                                        "kind": "ScalarField",
                                                                                                                        "name": "fieldId"
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "kind": "ScalarField",
                                                                                                                                "name": "text"
                                                                                                                            }
                                                                                                                        ],
                                                                                                                        "type": "JiraSingleLineTextField"
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "kind": "LinkedField",
                                                                                                                                "name": "user",
                                                                                                                                "plural": false,
                                                                                                                                "selections": [
                                                                                                                                    v19,
                                                                                                                                    v18,
                                                                                                                                    {
                                                                                                                                        "kind": "ScalarField",
                                                                                                                                        "name": "picture"
                                                                                                                                    },
                                                                                                                                    v17
                                                                                                                                ]
                                                                                                                            }
                                                                                                                        ],
                                                                                                                        "type": "JiraSingleSelectUserPickerField"
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "concreteType": "JiraIssueType",
                                                                                                                                "kind": "LinkedField",
                                                                                                                                "name": "issueType",
                                                                                                                                "plural": false,
                                                                                                                                "selections": [
                                                                                                                                    v18,
                                                                                                                                    {
                                                                                                                                        "concreteType": "JiraAvatar",
                                                                                                                                        "kind": "LinkedField",
                                                                                                                                        "name": "avatar",
                                                                                                                                        "plural": false,
                                                                                                                                        "selections": [
                                                                                                                                            {
                                                                                                                                                "kind": "ScalarField",
                                                                                                                                                "name": "small"
                                                                                                                                            }
                                                                                                                                        ]
                                                                                                                                    },
                                                                                                                                    v17
                                                                                                                                ]
                                                                                                                            }
                                                                                                                        ],
                                                                                                                        "type": "JiraIssueTypeField"
                                                                                                                    }
                                                                                                                ],
                                                                                                                "storageKey": "fieldsByIdOrAlias(idsOrAliases:[\"summary\",\"assignee\",\"status\",\"issuetype\"])"
                                                                                                            },
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "issueId"
                                                                                                            },
                                                                                                            v38,
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "webUrl"
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "JiraIssue"
                                                                                                    },
                                                                                                    v22,
                                                                                                    v23,
                                                                                                    v24,
                                                                                                    v25,
                                                                                                    v26,
                                                                                                    v27,
                                                                                                    v28,
                                                                                                    v29,
                                                                                                    v30,
                                                                                                    v31,
                                                                                                    v32,
                                                                                                    v33,
                                                                                                    v34,
                                                                                                    v35
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v14
                                                                        ]
                                                                    },
                                                                    v17,
                                                                    v37,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "introducedDate"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "providerVulnerabilityId"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "securityContainerId"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "severity"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "description"
                                                                    }
                                                                ]
                                                            },
                                                            v17,
                                                            v19
                                                        ]
                                                    },
                                                    v39
                                                ]
                                            },
                                            v40
                                        ]
                                    },
                                    {
                                        "args": v36,
                                        "filters": [
                                            "filter"
                                        ],
                                        "handle": "connection",
                                        "key": "security__linkedSecurityVulnerabilitiesByProject",
                                        "kind": "LinkedHandle",
                                        "name": "linkedSecurityVulnerabilitiesByProject"
                                    },
                                    {
                                        "alias": "projectHaveVulnerabilityCheck",
                                        "args": [
                                            {
                                                "kind": "Literal",
                                                "name": "first",
                                                "value": 1
                                            }
                                        ],
                                        "concreteType": "GraphJiraVulnerabilityConnection",
                                        "kind": "LinkedField",
                                        "name": "linkedSecurityVulnerabilitiesByProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphJiraVulnerabilityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "GraphJiraVulnerability",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                "kind": "LinkedField",
                                                                "name": "vulnerability",
                                                                "plural": false,
                                                                "selections": [
                                                                    v19,
                                                                    v17
                                                                ]
                                                            },
                                                            v17
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "storageKey": "linkedSecurityVulnerabilitiesByProject(first:1)"
                                    },
                                    {
                                        "alias": "linkedVulnsForAnalytics",
                                        "args": v16,
                                        "concreteType": "GraphJiraVulnerabilityConnection",
                                        "kind": "LinkedField",
                                        "name": "linkedSecurityVulnerabilitiesByProject",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "GraphJiraVulnerabilityEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "GraphJiraVulnerability",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "condition": "getContainers",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "DevOpsSecurityVulnerabilityDetails",
                                                                        "kind": "LinkedField",
                                                                        "name": "vulnerability",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "ThirdPartySecurityContainer",
                                                                                "kind": "LinkedField",
                                                                                "name": "securityContainer",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v11,
                                                                                    v17
                                                                                ]
                                                                            },
                                                                            v17
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            v17
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "condition": "getContainers",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": v10,
                                                "concreteType": "AriGraphRelationshipConnection",
                                                "kind": "LinkedField",
                                                "name": "linkedSecurityContainers",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "AriGraphRelationshipEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "AriGraphRelationship",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "AriGraphRelationshipNode",
                                                                        "kind": "LinkedField",
                                                                        "name": "to",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "data",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v19,
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v18,
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "icon"
                                                                                            },
                                                                                            v37,
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "providerName"
                                                                                            },
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "lastUpdated"
                                                                                            },
                                                                                            v14,
                                                                                            v17
                                                                                        ],
                                                                                        "type": "ThirdPartySecurityContainer"
                                                                                    },
                                                                                    v22,
                                                                                    v23,
                                                                                    v24,
                                                                                    v25,
                                                                                    v26,
                                                                                    v27,
                                                                                    v28,
                                                                                    v29,
                                                                                    v30,
                                                                                    v31,
                                                                                    v32,
                                                                                    v33,
                                                                                    v34,
                                                                                    v35
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    v19
                                                                ]
                                                            },
                                                            v39
                                                        ]
                                                    },
                                                    v40
                                                ]
                                            },
                                            {
                                                "args": v10,
                                                "handle": "connection",
                                                "key": "security__linkedSecurityContainers",
                                                "kind": "LinkedHandle",
                                                "name": "linkedSecurityContainers"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v20
                ]
            },
            "params": {
                "id": "a1a80f3ccfe8934408165144c558b877d997fe187322dd28b0da2044aa214fed",
                "metadata": {},
                "name": "mainSecurityInJiraQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $511d4548ae93769f$var$node.hash = "e0029e5d1d9e6e62c9b62d69cc3a9f72";
    var $511d4548ae93769f$export$2e2bcd8739ae039 = $511d4548ae93769f$var$node;
});
parcelRegister("ac0bf", function(module, exports) {
    $parcel$export(module.exports, "getGqlFiltersFromQueryParams", ()=>$526907709998fa0b$export$2af359d48d48e5f1);
    var $5eeaw;
    var $3zFAD;
    var $3o4IF;
    const $526907709998fa0b$var$getFilterValue = (values, fieldStortKey, sortKey = (0, (0, parcelRequire("3zFAD")).initialVulnerabilityTableOptions).sortKey, sortOrder = (0, (0, parcelRequire("3zFAD")).initialVulnerabilityTableOptions).sortOrder)=>({
            ...values.length > 0 ? {
                values: values
            } : {},
            ...sortKey === fieldStortKey && {
                sort: {
                    priority: 2,
                    order: (0, (0, parcelRequire("3o4IF")).parseSortDirection)(sortOrder, (0, (0, parcelRequire("5eeaw")).AriGraphSortOrderInput).DESC)
                }
            }
        });
    const $526907709998fa0b$var$getOrDefault = (input, defaultArray)=>input.length ? input : defaultArray;
    const $526907709998fa0b$export$2af359d48d48e5f1 = (queryParams, connectionAri)=>{
        const containerValues = $526907709998fa0b$var$getOrDefault((0, (0, parcelRequire("3o4IF")).connectionQueryParamToFilter)(queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_CONTAINER], connectionAri).filter(Boolean), (0, (0, parcelRequire("3zFAD")).initialVulnerabilityTableOptions).connectionFilter);
        const statusQueryParams = (0, (0, parcelRequire("3o4IF")).arrayQueryParamToFilter)(queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_VULN_STATUS]);
        return {
            and: [
                {
                    lastUpdated: {
                        sort: {
                            priority: 1,
                            order: (0, (0, parcelRequire("5eeaw")).AriGraphSortOrderInput).DESC
                        }
                    },
                    to_severity: $526907709998fa0b$var$getFilterValue($526907709998fa0b$var$getOrDefault((0, (0, parcelRequire("3o4IF")).arrayQueryParamToFilter)(queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_SEVERITY]).map((0, (0, parcelRequire("3o4IF")).parseSeverity)).filter(Boolean), (0, (0, parcelRequire("3zFAD")).initialVulnerabilityTableOptions).severityFilter), 'severity', queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_SORT_KEY], queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_SORT_ORDER]),
                    to_status: $526907709998fa0b$var$getFilterValue(statusQueryParams.includes((0, (0, parcelRequire("3zFAD")).NO_FILTER_VULN_STATUS)) ? [] : $526907709998fa0b$var$getOrDefault(statusQueryParams.map((0, (0, parcelRequire("3o4IF")).parseStatus)).filter(Boolean), (0, (0, parcelRequire("3zFAD")).initialVulnerabilityTableOptions).statusFilter), 'status', queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_SORT_KEY], queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_SORT_ORDER]),
                    createdAt: {
                        ...queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_SORT_KEY] === 'introduced' && {
                            sort: {
                                priority: 2,
                                order: (0, (0, parcelRequire("3o4IF")).parseSortDirection)(queryParams[0, (0, parcelRequire("3zFAD")).QUERY_PARAM_SORT_ORDER], (0, (0, parcelRequire("5eeaw")).AriGraphSortOrderInput).DESC)
                            }
                        }
                    },
                    to_container: {
                        containerAri: {
                            value: {
                                ...containerValues.length > 0 ? {
                                    values: containerValues
                                } : {}
                            }
                        }
                    }
                }
            ]
        };
    };
});
parcelRegister("5eeaw", function(module, exports) {
    $parcel$export(module.exports, "AriGraphSortOrderInput", ()=>$f98addb8b52ad07a$export$3b69903df4cd6048);
    const $f98addb8b52ad07a$export$3b69903df4cd6048 = {
        ASC: 'ASC',
        DESC: 'DESC'
    };
});
parcelRegister("3zFAD", function(module, exports) {
    $parcel$export(module.exports, "QUERY_PARAM_SEARCH", ()=>$d1be2b44eb126533$export$a181206198b7f50c);
    $parcel$export(module.exports, "QUERY_PARAM_CONTAINER", ()=>$d1be2b44eb126533$export$3873b20ffa21b004);
    $parcel$export(module.exports, "QUERY_PARAM_SEVERITY", ()=>$d1be2b44eb126533$export$af01a3d59250f3d3);
    $parcel$export(module.exports, "QUERY_PARAM_VULN_STATUS", ()=>$d1be2b44eb126533$export$c315695f017955dc);
    $parcel$export(module.exports, "QUERY_PARAM_ISSUE_STATUS", ()=>$d1be2b44eb126533$export$2e69a24fe65d4109);
    $parcel$export(module.exports, "QUERY_PARAM_SORT_KEY", ()=>$d1be2b44eb126533$export$6da773286c35ef41);
    $parcel$export(module.exports, "QUERY_PARAM_SORT_ORDER", ()=>$d1be2b44eb126533$export$810a1f7ed2facfcb);
    $parcel$export(module.exports, "NO_FILTER_VULN_STATUS", ()=>$d1be2b44eb126533$export$d8115099d465de4c);
    $parcel$export(module.exports, "initialVulnerabilityTableOptions", ()=>$d1be2b44eb126533$export$e9b4ea84d666c490);
    const $d1be2b44eb126533$export$a181206198b7f50c = 'search';
    const $d1be2b44eb126533$export$3873b20ffa21b004 = 'container';
    const $d1be2b44eb126533$export$af01a3d59250f3d3 = 'severity';
    const $d1be2b44eb126533$export$c315695f017955dc = 'vulnerabilityStatus';
    const $d1be2b44eb126533$export$2e69a24fe65d4109 = 'issueStatus';
    const $d1be2b44eb126533$export$6da773286c35ef41 = 'sortKey';
    const $d1be2b44eb126533$export$810a1f7ed2facfcb = 'sortOrder';
    const $d1be2b44eb126533$export$d8115099d465de4c = 'NO-FILTERS';
    const $d1be2b44eb126533$export$afbc65bcea0cf17e = {
        searchFilter: '',
        connectionFilter: [],
        severityFilter: [],
        statusFilter: [
            'OPEN'
        ],
        jiraIssueStatusFilter: []
    };
    const $d1be2b44eb126533$export$e9b4ea84d666c490 = {
        sortKey: 'severity',
        sortOrder: 'DESC',
        ...$d1be2b44eb126533$export$afbc65bcea0cf17e
    };
});
parcelRegister("3o4IF", function(module, exports) {
    $parcel$export(module.exports, "arrayQueryParamToFilter", ()=>$dbe4482e2428caff$export$7500862c6689a767);
    $parcel$export(module.exports, "arrayFilterToQueryParam", ()=>$dbe4482e2428caff$export$b0dee3c5bfc7249e);
    $parcel$export(module.exports, "connectionFilterToQueryParam", ()=>$dbe4482e2428caff$export$a6950ca4fdc8498f);
    $parcel$export(module.exports, "connectionQueryParamToFilter", ()=>$dbe4482e2428caff$export$1040034504af5b41);
    $parcel$export(module.exports, "parseSeverity", ()=>$dbe4482e2428caff$export$3551b8a2cbdb5162);
    $parcel$export(module.exports, "parseStatus", ()=>$dbe4482e2428caff$export$2188844eb84f7f06);
    $parcel$export(module.exports, "parseSortDirection", ()=>$dbe4482e2428caff$export$85cf5c73b48a482e);
    var $chc6P = parcelRequire("chc6P");
    var $80afZ = parcelRequire("80afZ");
    var $5eeaw;
    var $i3r1A;
    const $dbe4482e2428caff$var$DELIMITER = ',';
    const $dbe4482e2428caff$var$ENCODED_DELIMITER = encodeURIComponent($dbe4482e2428caff$var$DELIMITER);
    const $dbe4482e2428caff$var$encodeDelimiter = (input)=>{
        const regex = new RegExp($dbe4482e2428caff$var$DELIMITER, 'g');
        return input.replace(regex, $dbe4482e2428caff$var$ENCODED_DELIMITER);
    };
    const $dbe4482e2428caff$var$decodeDelimiter = (input)=>{
        const regex = new RegExp($dbe4482e2428caff$var$ENCODED_DELIMITER, 'g');
        return input.replace(regex, $dbe4482e2428caff$var$DELIMITER);
    };
    const $dbe4482e2428caff$export$7500862c6689a767 = (queryParamString)=>queryParamString?.split($dbe4482e2428caff$var$DELIMITER)?.map($dbe4482e2428caff$var$decodeDelimiter) ?? [];
    const $dbe4482e2428caff$export$b0dee3c5bfc7249e = (filterArray)=>{
        if (filterArray.length === 0) return undefined;
        return filterArray.map((entity)=>$dbe4482e2428caff$var$encodeDelimiter(entity)).join($dbe4482e2428caff$var$DELIMITER);
    };
    const $dbe4482e2428caff$export$a6950ca4fdc8498f = (connectionArray)=>{
        if (connectionArray.length === 0) return undefined;
        const groupedConnectionsByAppKey = connectionArray.reduce((acc, connection)=>{
            const [, , , , securityParts] = connection.split(':');
            const [, , , appKey, ...containerId] = securityParts.split('/');
            if (!acc[appKey]) acc[appKey] = [];
            acc[appKey].push(containerId.join('/'));
            return acc;
        }, {});
        return JSON.stringify(groupedConnectionsByAppKey);
    };
    const $dbe4482e2428caff$export$1040034504af5b41 = (queryParamString, connectionAri)=>{
        if (!queryParamString) return [];
        const groupedConnectionsByAppKey = JSON.parse(queryParamString);
        return (0, ($parcel$interopDefault($chc6P)))(groupedConnectionsByAppKey, (containerIds, appKey)=>(0, ($parcel$interopDefault($80afZ)))(containerIds, (containerId)=>`${connectionAri}${appKey}/${containerId}`));
    };
    const $dbe4482e2428caff$export$3551b8a2cbdb5162 = (maybeSeverity)=>{
        switch(maybeSeverity?.toUpperCase()){
            case (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).CRITICAL.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).CRITICAL;
            case (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).HIGH.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).HIGH;
            case (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).LOW.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).LOW;
            case (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).MEDIUM.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).MEDIUM;
            case (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).UNKNOWN.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilitySeverityEnums).UNKNOWN;
            default:
                return undefined;
        }
    };
    const $dbe4482e2428caff$export$2188844eb84f7f06 = (maybeStatus)=>{
        switch(maybeStatus?.toUpperCase()){
            case (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).OPEN.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).OPEN;
            case (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).UNKNOWN.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).UNKNOWN;
            case (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).CLOSED.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).CLOSED;
            case (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).IGNORED.toUpperCase():
                return (0, (0, parcelRequire("i3r1A")).VulnerabilityStatusEnums).IGNORED;
            default:
                return undefined;
        }
    };
    const $dbe4482e2428caff$export$85cf5c73b48a482e = (maybeDirection, defaultValue)=>{
        switch(maybeDirection?.toUpperCase()){
            case (0, (0, parcelRequire("5eeaw")).AriGraphSortOrderInput).ASC.toUpperCase():
                return (0, (0, parcelRequire("5eeaw")).AriGraphSortOrderInput).ASC;
            case (0, (0, parcelRequire("5eeaw")).AriGraphSortOrderInput).DESC.toUpperCase():
                return (0, (0, parcelRequire("5eeaw")).AriGraphSortOrderInput).DESC;
            default:
                return defaultValue;
        }
    };
});
parcelRegister("chc6P", function(module, exports) {
    var $ekcP3 = parcelRequire("ekcP3");
    var $80afZ = parcelRequire("80afZ");
    function $8f007734a6a4d9ac$var$flatMap(collection, iteratee) {
        return $ekcP3($80afZ(collection, iteratee), 1);
    }
    module.exports = $8f007734a6a4d9ac$var$flatMap;
});
parcelRegister("80afZ", function(module, exports) {
    var $1nIHN = parcelRequire("1nIHN");
    var $bxDef = parcelRequire("bxDef");
    var $jXnVG = parcelRequire("jXnVG");
    var $8LQ84 = parcelRequire("8LQ84");
    function $5d3647a04b83e8d6$var$map(collection, iteratee) {
        var func = $8LQ84(collection) ? $1nIHN : $jXnVG;
        return func(collection, $bxDef(iteratee, 3));
    }
    module.exports = $5d3647a04b83e8d6$var$map;
});
parcelRegister("i3r1A", function(module, exports) {
    $parcel$export(module.exports, "VulnerabilitySeverityEnums", ()=>$e40f3ad586d15bb3$export$c1a102938d8dc10);
    $parcel$export(module.exports, "VulnerabilityStatusEnums", ()=>$e40f3ad586d15bb3$export$2d6749bded378262);
    const $e40f3ad586d15bb3$export$c1a102938d8dc10 = {
        CRITICAL: 'CRITICAL',
        HIGH: 'HIGH',
        LOW: 'LOW',
        MEDIUM: 'MEDIUM',
        UNKNOWN: 'UNKNOWN'
    };
    const $e40f3ad586d15bb3$export$2d6749bded378262 = {
        CLOSED: 'CLOSED',
        IGNORED: 'IGNORED',
        OPEN: 'OPEN',
        UNKNOWN: 'UNKNOWN'
    };
    const $e40f3ad586d15bb3$export$abf926511a2b65de = {
        DAST: 'DAST',
        SAST: 'SAST',
        SCA: 'SCA',
        UNKNOWN: 'UNKNOWN'
    };
});
const $0a72320b8bc3a1aa$export$f24db22c3c834cb1 = 'SOFTWARE_SECURITY';
parcelRegister("dynqk", function(module, exports) {
    $parcel$export(module.exports, "softwareSecurityRoute", ()=>$fff5c1eec5774fa9$export$3a4d4ecb82e1bfc8);
    $parcel$export(module.exports, "softwareSecurityClassicRoute", ()=>$fff5c1eec5774fa9$export$b7285748f1151353);
    var $65Ltd;
    const $fff5c1eec5774fa9$export$3a4d4ecb82e1bfc8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY),
        path: '/jira/software/projects/:projectKey/security'
    };
    const $fff5c1eec5774fa9$export$b7285748f1151353 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SECURITY_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/security'
    };
});
parcelRegister("csz4l", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eHlvD")
    ]).then(()=>parcelRequire('jbq29'));
});
parcelRegister("f3iuv", function(module, exports) {
    $parcel$export(module.exports, "LazySummaryView", ()=>$d82700466a756427$export$68c09444cc6f2843);
    $parcel$export(module.exports, "SummaryPage", ()=>$d82700466a756427$export$893608e1a22999b9);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $d82700466a756427$export$68c09444cc6f2843 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("5fsUP")), {
        moduleId: "./src/packages/spa-apps/software/summary/src/index.tsx"
    });
    const $d82700466a756427$export$893608e1a22999b9 = ()=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d82700466a756427$export$68c09444cc6f2843,
            pageId: "software-summary",
            shouldShowSpinner: true
        });
    };
});
parcelRegister("5fsUP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4VHZG")
    ]).then(()=>parcelRequire('iPGiI'));
});
parcelRegister("4Pqzu", function(module, exports) {
    $parcel$export(module.exports, "userBoardRouteEntry", ()=>$fd1485349b2df65b$export$cde4dacc737dc0f1);
    var $ffza4;
    var $gyYxw;
    var $g5RGc;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $1XrjK;
    var $lfnsv;
    var $lJ1FP;
    var $f5kpo;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $f7Y15;
    var $gNStA;
    var $d04s2;
    var $5mLQj;
    var $gcguf;
    var $5PD5h;
    var $7Y3Wj;
    const $fd1485349b2df65b$export$cde4dacc737dc0f1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5mLQj")).userBoardRoute), ()=>({
            component: (0, (0, parcelRequire("7Y3Wj")).RapidBoardSpaPage),
            skeleton: (0, (0, parcelRequire("gcguf")).ClassicBoardSkeleton),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("gyYxw")).genericProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                {
                    query: [
                        'selectedIssue',
                        'view=detail'
                    ]
                },
                {
                    query: [
                        'selectedIssue',
                        'modal=detail'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).classicBoardSidebars),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                ...(0, (0, parcelRequire("3RJkv")).getUserBoardNavigationResources)(),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)((0, (0, parcelRequire("f5kpo")).shouldLoadUIFBoardResources), (0, (0, parcelRequire("f7Y15")).uifBoardResource)),
                (0, (0, parcelRequire("lJ1FP")).getEditModelResource)(),
                (0, (0, parcelRequire("lfnsv")).getBoardDetailsResource)()
            ],
            afterPaint: [
                (0, (0, parcelRequire("d04s2")).LazyIssueApp)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoard),
                (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoardApps),
                (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoardDataApiResource),
                (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoardConfigApiResource),
                (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoardWrmBundleResource),
                (0, (0, parcelRequire("7Y3Wj")).LazyRapidBoardResource)
            ]
        }));
});
parcelRegister("5mLQj", function(module, exports) {
    $parcel$export(module.exports, "userBoardRoute", ()=>$94b3bd76047e314a$export$57a2a0fe739f16);
    var $65Ltd;
    var $e2ctp;
    const $94b3bd76047e314a$export$57a2a0fe739f16 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_RAPIDBOARD_USER_BOARD),
        path: '/jira/people/:accountId/boards/:boardId',
        preloadOptions: {
            earlyChunks: [
                'rapidboard-early-entry'
            ]
        },
        earlyAssets: (0, (0, parcelRequire("e2ctp")).AGGRESSIVE_EARLY_ASSET_STRATEGY)
    };
});
parcelRegister("8UJQ4", function(module, exports) {
    $parcel$export(module.exports, "ClassicReportSkeleton", ()=>$ca7240f722f926b7$export$d7667341f4db3b8d);
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $18D3n = parcelRequire("18D3n");
    const $ca7240f722f926b7$export$d7667341f4db3b8d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($18D3n)))
        });
});
parcelRegister("18D3n", function(module, exports) {
    module.exports = new URL("classic-report-app-skeleton.tpl.1daae66d.svg", import.meta.url).toString();
});
parcelRegister("cTHJk", function(module, exports) {
    $parcel$export(module.exports, "ListSkeleton", ()=>$a38265b6f9242f57$export$cbc3335f7a517046);
    $parcel$export(module.exports, "ListEmbedSkeleton", ()=>$a38265b6f9242f57$export$2638f1c98fe91c13);
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $2viXB = parcelRequire("2viXB");
    var $gSmeo = parcelRequire("gSmeo");
    const $a38265b6f9242f57$export$cbc3335f7a517046 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($2viXB)))
        });
    const $a38265b6f9242f57$export$2638f1c98fe91c13 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($gSmeo)))
        });
});
parcelRegister("2viXB", function(module, exports) {
    module.exports = new URL("list-app-skeleton.tpl.82508714.svg", import.meta.url).toString();
});
parcelRegister("gSmeo", function(module, exports) {
    module.exports = new URL("list-embed-app-skeleton.tpl.de94c811.svg", import.meta.url).toString();
});
parcelRegister("lm7AC", function(module, exports) {
    $parcel$export(module.exports, "RoadmapSkeleton", ()=>$eff6f905ab2e2dc3$export$66a1e8bb48359566);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7XYc4;
    var $4R6GH;
    var $3HwlS;
    var $dCm1o;
    var $gnABE;
    var $7jB1k = parcelRequire("7jB1k");
    var $aIPZQ = parcelRequire("aIPZQ");
    const $eff6f905ab2e2dc3$var$customCssStyles = null;
    const $eff6f905ab2e2dc3$export$66a1e8bb48359566 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($eff6f905ab2e2dc3$var$AppSkeletonImageContainer, null, (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($7jB1k))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2zz1idpf"
            ])
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($aIPZQ))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2zz1idpf"
            ])
        }));
    const $eff6f905ab2e2dc3$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1bgi _1xpi1tcg _1sbz1tcg _1cpn1tcg _13xs1tcg",
                __cmplp.className
            ])
        });
    });
    const $eff6f905ab2e2dc3$var$AppSkeletonImageContainer = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2'), ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($eff6f905ab2e2dc3$var$Wrapper, null, children), (0, $5uXOq.Fragment));
});
parcelRegister("7jB1k", function(module, exports) {
    module.exports = new URL("roadmap-app-skeleton-nav-refresh.tpl.ce6eb42e.svg", import.meta.url).toString();
});
parcelRegister("aIPZQ", function(module, exports) {
    module.exports = new URL("roadmap-app-skeleton.tpl.a54a882d.svg", import.meta.url).toString();
});
parcelRegister("c7uCQ", function(module, exports) {
    $parcel$export(module.exports, "TimelineRedirect", ()=>$02623e8fca40b314$export$c70b8d9ef0c891b2);
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    const $02623e8fca40b314$export$c70b8d9ef0c891b2 = ()=>{
        const [{ query: query, match: match }] = (0, $dIdda.useRouter)();
        const queryParams = new URLSearchParams(query).toString();
        const { projectKey: projectKey, boardId: boardId } = match.params;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: {
                pathname: `/jira/software/c/projects/${String(projectKey)}/boards/${String(boardId)}/timeline`,
                hash: '',
                search: queryParams
            }
        });
    };
});
parcelRegister("yxwH0", function(module, exports) {
    $parcel$export(module.exports, "getReportsCommonResource", ()=>$c75fcd785e66868e$export$8cb713295e6b7204);
    var $48Ij3;
    var $gcI3W;
    var $4Bwc0;
    const $c75fcd785e66868e$export$8cb713295e6b7204 = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $c75fcd785e66868e$export$f234446c23dc22a = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("48Ij3")).staticSidebarJSWReportsResource)
        ];
});
parcelRegister("48Ij3", function(module, exports) {
    $parcel$export(module.exports, "staticSidebarJSWReportsResource", ()=>$d94d5098764be5f8$export$5910307042ab3f6f);
    var $8YTna;
    var $dIdda = parcelRequire("dIdda");
    var $7xeIG;
    const $d94d5098764be5f8$export$5910307042ab3f6f = (0, $dIdda.createResource)({
        type: 'JIRA_SOFTWARE_REPORTS',
        getKey: ({ match: match, query: query })=>{
            const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
            return boardId ? `board-${boardId}` : 'none';
        },
        getData: async ({ match: match, query: query })=>{
            const boardId = (0, (0, parcelRequire("8YTna")).getBoardId)(match, query);
            if (boardId == null) return null;
            const response = await (0, (0, parcelRequire("7xeIG")).fetchJSWReports)(boardId);
            return response?.reports;
        },
        maxAge: 300000
    });
});
parcelRegister("7xeIG", function(module, exports) {
    $parcel$export(module.exports, "fetchJSWReports", ()=>$61400f9195fc4c28$export$a93a577d6971da2c);
    var $eusud;
    const $61400f9195fc4c28$export$a93a577d6971da2c = (boardId)=>{
        if (boardId == null) throw new Error('invalid boardId');
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/agile/latest/board/${boardId}/reports`);
    };
});
parcelRegister("4Bwc0", function(module, exports) {
    $parcel$export(module.exports, "devOpsReportPreconditionResource", ()=>$5073d432665dfcf8$export$96cb0eae1b3413f4);
    $parcel$export(module.exports, "useDevOpsReportPreconditionResource", ()=>$5073d432665dfcf8$export$e9adc6103e9ed514);
    var $dIdda = parcelRequire("dIdda");
    const $5073d432665dfcf8$export$96cb0eae1b3413f4 = (0, $dIdda.createResource)({
        type: (0, $16165c7eb855363c$export$14c5ce449424c281),
        getKey: ({ query: query })=>query.projectKey,
        getDataLoader: ()=>(parcelRequire("fUjXk")),
        maxAge: 60000
    });
    const $5073d432665dfcf8$export$e9adc6103e9ed514 = ()=>(0, $dIdda.useResource)($5073d432665dfcf8$export$96cb0eae1b3413f4);
});
const $16165c7eb855363c$export$14c5ce449424c281 = 'SOFTWARE_CYCLE_TIME_REPORT_PRECONDITION';
const $16165c7eb855363c$export$28dc7a217425f1a9 = 'VIEW_DEV_TOOLS';
const $16165c7eb855363c$export$a03e1c9d464f9477 = 'VIEW_AGGREGATED_DATA';
parcelRegister("fUjXk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("goFaC").then(()=>parcelRequire('5aldt'));
});
parcelRegister("6XlJT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a23aaa7a1201d94$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $4a23aaa7a1201d94$export$cabb458181f7566e = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6Aupt"))), {
        moduleId: "./src/packages/spa-apps/goals/src/index.tsx"
    });
    var $4a23aaa7a1201d94$export$2e2bcd8739ae039 = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4a23aaa7a1201d94$export$cabb458181f7566e,
            pageId: `classic-atlas-goals-${match.params.boardId || ''}`,
            shouldShowSpinner: false
        });
});
parcelRegister("6Aupt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hG41q").then(()=>parcelRequire('ksDNa'));
});
parcelRegister("13pw2", function(module, exports) {
    $parcel$export(module.exports, "LazyProformaIssueFormsDirect", ()=>$480a54898b863a19$export$a0f04dd35569e11);
    $parcel$export(module.exports, "default", ()=>$480a54898b863a19$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $480a54898b863a19$export$a0f04dd35569e11 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("9xG8v")), {
        moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct/src/index.tsx"
    });
    var $480a54898b863a19$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $480a54898b863a19$export$a0f04dd35569e11,
            pageId: "proforma-issue-forms-direct",
            shouldShowSpinner: true
        });
});
parcelRegister("9xG8v", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("jmhtg")
    ]).then(()=>parcelRequire('izbAs'));
});
parcelRegister("33P3A", function(module, exports) {
    $parcel$export(module.exports, "LazyProformaIssueFormsDirectEmbed", ()=>$a96f990777917c84$export$22681210aaeb910f);
    $parcel$export(module.exports, "default", ()=>$a96f990777917c84$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $a96f990777917c84$export$22681210aaeb910f = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("jDCWS")), {
        moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct-embed/src/index.tsx"
    });
    var $a96f990777917c84$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a96f990777917c84$export$22681210aaeb910f,
            pageId: "proforma-issue-forms-direct-embed",
            shouldShowSpinner: true
        });
});
parcelRegister("jDCWS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("a0moB")
    ]).then(()=>parcelRequire('4RuJw'));
});
parcelRegister("jK0PE", function(module, exports) {
    $parcel$export(module.exports, "LazyRoadmapViewClassic", ()=>$636a0aa010a33fb5$export$84165bb08bf42eef);
    $parcel$export(module.exports, "default", ()=>$636a0aa010a33fb5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $636a0aa010a33fb5$export$84165bb08bf42eef = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("i1VgZ"))), {
        moduleId: "./src/packages/spa-apps/roadmap/src/view/classic/index.tsx"
    });
    var $636a0aa010a33fb5$export$2e2bcd8739ae039 = ({ match: match })=>{
        const { boardId: boardId } = match.params;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $636a0aa010a33fb5$export$84165bb08bf42eef,
            pageId: `classic-roadmap-${boardId || ''}`,
            shouldShowSpinner: false
        });
    };
});
parcelRegister("i1VgZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("39IYm")
    ]).then(()=>parcelRequire('9PBZj'));
});
parcelRegister("eQnNj", function(module, exports) {
    $parcel$export(module.exports, "softwareCalendarRouteEntry", ()=>$24d3258934ab0fe5$export$83b1b9036cc7961a);
    var $lkFvK;
    var $lmyls;
    var $dQ4vn;
    const $24d3258934ab0fe5$export$83b1b9036cc7961a = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("dQ4vn")).calendarEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
});
parcelRegister("dQ4vn", function(module, exports) {
    $parcel$export(module.exports, "calendarEntryPoint", ()=>$d8251bf369abb7ad$export$19cf4b398f638dc6);
    var $4R6GH;
    var $7JhZX;
    var $2Ftxm;
    var $ikgNX;
    function $d8251bf369abb7ad$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
        return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
    }
    function $d8251bf369abb7ad$var$toMidnightUTCString(date) {
        const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
        return new Date(utcMilliseconds).toISOString();
    }
    function $d8251bf369abb7ad$var$toDate(date) {
        if (!date) return new Date();
        try {
            const _date = new Date(date);
            return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
        } catch (e) {
            return new Date();
        }
    }
    const $d8251bf369abb7ad$var$SOFTWARE_CALENDAR = 'software-calendar';
    const $d8251bf369abb7ad$var$SOFTWARE_CALENDAR_EMBED = 'software-calendar-embed';
    const $d8251bf369abb7ad$var$TEAM_MANAGED_CALENDAR_ROUTES = [
        $d8251bf369abb7ad$var$SOFTWARE_CALENDAR,
        $d8251bf369abb7ad$var$SOFTWARE_CALENDAR_EMBED
    ];
    function $d8251bf369abb7ad$var$createScope({ context: context, tenantContext: tenantContext }) {
        const { cloudId: cloudId } = tenantContext;
        const isTMP = $d8251bf369abb7ad$var$TEAM_MANAGED_CALENDAR_ROUTES.includes(context.route.name);
        return {
            type: 'board',
            boardId: $d8251bf369abb7ad$var$toBoardAri({
                siteId: cloudId,
                boardId: String(context.match.params.boardId)
            }),
            projectKeys: isTMP ? [
                String(context.match.params.projectKey)
            ] : []
        };
    }
    function $d8251bf369abb7ad$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
        const { cloudId: cloudId } = tenantContext;
        const scopeInput = {
            ids: [
                scope.boardId
            ]
        };
        if (scope.projectKeys && scope.projectKeys.length > 0) return {
            ...scopeInput,
            projectKeys: {
                cloudId: cloudId,
                keys: scope.projectKeys
            }
        };
        return scopeInput;
    }
    function $d8251bf369abb7ad$var$toViewMode(mode) {
        switch(mode){
            case 'week':
                return 'WEEK';
            case 'day':
                return 'DAY';
            default:
                return 'MONTH';
        }
    }
    function $d8251bf369abb7ad$var$toWeekStart(weekStart) {
        switch(weekStart){
            case 'monday':
                return 'MONDAY';
            case 'saturday':
                return 'SATURDAY';
            default:
                return 'SUNDAY';
        }
    }
    function $d8251bf369abb7ad$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, startDateField: startDateField, endDateField: endDateField }) {
        return {
            date: $d8251bf369abb7ad$var$toMidnightUTCString(selectedDate),
            mode: $d8251bf369abb7ad$var$toViewMode(viewRange),
            weekStart: $d8251bf369abb7ad$var$toWeekStart(weekStartsOn),
            startDateField: startDateField,
            endDateField: endDateField
        };
    }
    function $d8251bf369abb7ad$var$buildIssuesSearchInput() {
        return {
            additionalFilterQuery: ''
        };
    }
    function $d8251bf369abb7ad$var$buildUnscheduledIssuesSearchInput() {
        return {
            additionalFilterQuery: ''
        };
    }
    function $d8251bf369abb7ad$var$buildVersionsSearchInput() {
        return {
            versionStatuses: [
                'RELEASED',
                'UNRELEASED'
            ]
        };
    }
    function $d8251bf369abb7ad$var$buildSprintsSearchInput() {
        return {
            sprintStates: [
                'ACTIVE',
                'FUTURE',
                'CLOSED'
            ]
        };
    }
    const $d8251bf369abb7ad$export$19cf4b398f638dc6 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("fntlm")), {
            moduleId: "57ee20a5"
        }),
        getPreloadProps: (entryPointRouteParams)=>{
            const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
            const { cloudId: cloudId } = tenantContext;
            const scope = $d8251bf369abb7ad$var$createScope(entryPointRouteParams);
            const { date: date } = context.query;
            const selectedDate = $d8251bf369abb7ad$var$toDate(date);
            const boardId = String(context.match.params.boardId);
            const viewRange = 'month';
            const weekStartsOn = 'sunday';
            const startDateField = 'startdate';
            const endDateField = 'duedate';
            const issueEventFields = {
                startDateField: startDateField,
                endDateField: endDateField
            };
            return {
                queries: {
                    calendarData: {
                        options: {
                            fetchPolicy: 'store-and-network'
                        },
                        parameters: (0, parcelRequire("7JhZX")).default,
                        variables: {
                            cloudId: cloudId,
                            scopeInput: $d8251bf369abb7ad$var$buildScopeInput(entryPointRouteParams, scope),
                            configurationInput: $d8251bf369abb7ad$var$buildConfigurationInput({
                                selectedDate: selectedDate,
                                viewRange: viewRange,
                                weekStartsOn: weekStartsOn,
                                startDateField: startDateField,
                                endDateField: endDateField
                            }),
                            issuesSearchInput: $d8251bf369abb7ad$var$buildIssuesSearchInput(),
                            unscheduledIssuesSearchInput: $d8251bf369abb7ad$var$buildUnscheduledIssuesSearchInput(),
                            versionsSearchInput: $d8251bf369abb7ad$var$buildVersionsSearchInput(),
                            sprintsSearchInput: $d8251bf369abb7ad$var$buildSprintsSearchInput(),
                            skipSprintSearch: false,
                            skipVersionSearch: false,
                            viewId: null,
                            schedulePermissionsEnabled: (0, (0, parcelRequire("4R6GH")).fg)('calendar_schedule_issue_permissions_check')
                        }
                    }
                },
                entryPoints: {},
                extraProps: {
                    scope: scope,
                    selectedDate: selectedDate,
                    viewRange: viewRange,
                    weekStartsOn: weekStartsOn,
                    issueEventFields: issueEventFields,
                    boardId: boardId
                }
            };
        }
    });
});
parcelRegister("fntlm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iePIJ")
    ]).then(()=>parcelRequire('71XRW'));
});
parcelRegister("brJ9B", function(module, exports) {
    $parcel$export(module.exports, "LazyCode", ()=>$6049b4a08957accb$export$4beafd9dbad29bff);
    $parcel$export(module.exports, "LazySoftwareListView", ()=>$6049b4a08957accb$export$faa081cb222383ac);
    $parcel$export(module.exports, "LazySoftwareListEmbedView", ()=>$6049b4a08957accb$export$ce40123d7c2e29e7);
    $parcel$export(module.exports, "CodePageClassic", ()=>$6049b4a08957accb$export$95e2389b7ca7ccf2);
    $parcel$export(module.exports, "SoftwareListPage", ()=>$6049b4a08957accb$export$422a3a028ae77ad3);
    $parcel$export(module.exports, "SoftwareListEmbedPage", ()=>$6049b4a08957accb$export$4a0539d19a2e2694);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $iS0yP;
    const $6049b4a08957accb$export$4beafd9dbad29bff = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("492p0"))), {
        moduleId: "./src/packages/spa-apps/code/src/index.tsx"
    });
    const $6049b4a08957accb$export$faa081cb222383ac = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("5AKg6")), {
        moduleId: "./src/packages/spa-apps/business/jsw-list/src/index.tsx"
    });
    const $6049b4a08957accb$export$ce40123d7c2e29e7 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("5lA3L")), {
        moduleId: "./src/packages/spa-apps/business/jsw-list-embed/src/index.tsx"
    });
    const $6049b4a08957accb$export$d9e8184332f86b53 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6049b4a08957accb$export$4beafd9dbad29bff,
            pageId: `next-gen-code-${(0, (0, parcelRequire("iS0yP")).getBoardId)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    const $6049b4a08957accb$export$95e2389b7ca7ccf2 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6049b4a08957accb$export$4beafd9dbad29bff,
            pageId: `classic-code-${(0, (0, parcelRequire("iS0yP")).getBoardId)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    const $6049b4a08957accb$export$422a3a028ae77ad3 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6049b4a08957accb$export$faa081cb222383ac,
            pageId: `software-${(0, (0, parcelRequire("iS0yP")).getBoardId)({
                location: location,
                match: match
            })}-list`,
            shouldShowSpinner: true
        });
    const $6049b4a08957accb$export$4a0539d19a2e2694 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6049b4a08957accb$export$ce40123d7c2e29e7,
            pageId: `software-${(0, (0, parcelRequire("iS0yP")).getBoardId)({
                location: location,
                match: match
            })}-list-embed`,
            shouldShowSpinner: true
        });
});
parcelRegister("iS0yP", function(module, exports) {
    $parcel$export(module.exports, "getBoardId", ()=>$12fea879e07c880e$export$557c2f222778cea6);
    var $ebyGx = parcelRequire("ebyGx");
    const $12fea879e07c880e$export$557c2f222778cea6 = ({ location: location, match: match })=>{
        if (match && match.params.boardId) return match.params.boardId;
        const { rapidView: rapidView } = (0, ($parcel$interopDefault($ebyGx))).parse(location.search);
        return rapidView;
    };
});
parcelRegister("492p0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("donBI")
    ]).then(()=>parcelRequire('6LEOw'));
});
parcelRegister("5AKg6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("62r1i")
    ]).then(()=>parcelRequire('ycm07'));
});
parcelRegister("5lA3L", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("haEOE")
    ]).then(()=>parcelRequire('6xPmp'));
});
parcelRegister("7KruY", function(module, exports) {
    $parcel$export(module.exports, "softwareListRouteEntry", ()=>$2190319388c8e440$export$f30a66efa682bf2d);
    var $lkFvK;
    var $lmyls;
    var $3FuB0;
    const $2190319388c8e440$export$f30a66efa682bf2d = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("3FuB0")).listEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
});
parcelRegister("3FuB0", function(module, exports) {
    $parcel$export(module.exports, "listEntryPoint", ()=>$093e9fa498e2d713$export$6be4f10150ff6073);
    var $EVQo4;
    var $2Ftxm;
    var $ikgNX;
    const $093e9fa498e2d713$var$FORMAT_RULES_FIRST = 20;
    const $093e9fa498e2d713$export$6be4f10150ff6073 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("5AKg6")), {
            moduleId: "a7ba8596"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
            const { projectKey: projectKey } = context.match.params;
            if (!projectKey) throw new Error('projectKey is required');
            return {
                queries: {
                    formattingRulesQuery: {
                        parameters: (0, parcelRequire("EVQo4")).default,
                        variables: {
                            projectKey: projectKey,
                            cloudId: tenantContext.cloudId,
                            first: $093e9fa498e2d713$var$FORMAT_RULES_FIRST
                        },
                        options: {
                            fetchPolicy: 'network-only'
                        }
                    }
                },
                entryPoints: {},
                extraProps: {}
            };
        }
    });
});
parcelRegister("89cBA", function(module, exports) {
    $parcel$export(module.exports, "LazyCycleTimeReport", ()=>$f19a24813079175a$export$956f830ed027f1fb);
    $parcel$export(module.exports, "CycleTimeReportClassic", ()=>$f19a24813079175a$export$237924ba64065cc3);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $f19a24813079175a$export$956f830ed027f1fb = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("8ZMAu")), {
        moduleId: "./src/packages/spa-apps/cycle-time-report/src/index.tsx"
    });
    const $f19a24813079175a$export$e16ce0656a74a015 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f19a24813079175a$export$956f830ed027f1fb,
            pageId: "cycleTimeReportNextGen",
            shouldShowSpinner: true
        });
    const $f19a24813079175a$export$237924ba64065cc3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f19a24813079175a$export$956f830ed027f1fb,
            pageId: "cycleTimeReportClassic",
            shouldShowSpinner: true
        });
});
parcelRegister("8ZMAu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6uzq3")
    ]).then(()=>parcelRequire('iX103'));
});
parcelRegister("3woHG", function(module, exports) {
    $parcel$export(module.exports, "LazyDeploymentFrequencyReport", ()=>$edf6d9a26482ed8b$export$5113b2b19ec1fb53);
    $parcel$export(module.exports, "DeploymentFrequencyReportClassic", ()=>$edf6d9a26482ed8b$export$655707e8ae1053d3);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $edf6d9a26482ed8b$export$5113b2b19ec1fb53 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("2yRGG")), {
        moduleId: "./src/packages/spa-apps/deployment-frequency-report/src/index.tsx"
    });
    const $edf6d9a26482ed8b$export$e2db9c7426cdb53 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $edf6d9a26482ed8b$export$5113b2b19ec1fb53,
            pageId: "deploymentFrequencyReportNextGen",
            shouldShowSpinner: true
        });
    const $edf6d9a26482ed8b$export$655707e8ae1053d3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $edf6d9a26482ed8b$export$5113b2b19ec1fb53,
            pageId: "deploymentFrequencyReportClassic",
            shouldShowSpinner: true
        });
});
parcelRegister("2yRGG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1pebU")
    ]).then(()=>parcelRequire('6pwND'));
});
parcelRegister("9lLtf", function(module, exports) {
    $parcel$export(module.exports, "compassProductSettingsRouteEntry", ()=>$83f9e73406def487$export$703b5090da478c9c);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $bTLzO;
    var $3RJkv;
    var $a3NLL;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $83f9e73406def487$var$LazyCompassProductSettingsPage = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2nW1S"))), {
        moduleId: "./src/packages/spa-apps/compass-product-settings/src/index.tsx"
    });
    const $83f9e73406def487$export$cf9d12ec1710006a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $83f9e73406def487$var$LazyCompassProductSettingsPage,
            pageId: "async-compass-product-settings",
            shouldShowSpinner: true
        });
    const $83f9e73406def487$export$703b5090da478c9c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("a3NLL")).compassProductSettingsRoute), ()=>({
            component: $83f9e73406def487$export$cf9d12ec1710006a,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("bTLzO")).compassProductSettingsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $83f9e73406def487$var$LazyCompassProductSettingsPage
            ]
        }));
});
parcelRegister("bTLzO", function(module, exports) {
    $parcel$export(module.exports, "compassProductSettingsResource", ()=>$cfea6057f91373db$export$d18ff068d6c25455);
    $parcel$export(module.exports, "useCompassProductSettingsResource", ()=>$cfea6057f91373db$export$6cbcbd11d26ae36f);
    var $jcw0u;
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $cfea6057f91373db$export$d18ff068d6c25455 = (0, $dIdda.createResource)({
        type: (0, $0e2163be65099f64$export$6f0555de4f60e84e),
        getKey: ()=>'state',
        getData: async ()=>{
            try {
                const isCompassEnabledForNewProjects = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/3/application-properties?key=${(0, $0e2163be65099f64$export$5685d70c20140008)}`).then(({ value: value })=>value.toLowerCase().trim() === 'true');
                return {
                    isCompassEnabledForNewProjects: isCompassEnabledForNewProjects
                };
            } catch (error) {
                if (error?.statusCode === 404) return {
                    isCompassEnabledForNewProjects: true
                };
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: error,
                    meta: {
                        id: 'compassProductSettingsResource',
                        packageName: 'jiraRouterResourcesCompassProductSettings',
                        teamName: 'compass-lodestone'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                throw error;
            }
        }
    });
    const $cfea6057f91373db$export$6cbcbd11d26ae36f = ()=>(0, $dIdda.useResource)($cfea6057f91373db$export$d18ff068d6c25455);
});
const $0e2163be65099f64$export$6f0555de4f60e84e = 'RESOURCE_TYPE_COMPASS_PRODUCT_SETTINGS';
const $0e2163be65099f64$export$5685d70c20140008 = 'jira.admin.compass.is-enabled-for-new-project';
parcelRegister("a3NLL", function(module, exports) {
    $parcel$export(module.exports, "compassProductSettingsRoute", ()=>$92114b096359537f$export$48d633ce1d0d2a0e);
    var $65Ltd;
    const $92114b096359537f$export$48d633ce1d0d2a0e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_COMPASS_PRODUCT_SETTINGS),
        path: '/jira/settings/products/compass',
        exact: true
    };
});
parcelRegister("2nW1S", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("8asz0")
    ]).then(()=>parcelRequire('lIMc4'));
});
parcelRegister("2hn6E", function(module, exports) {
    $parcel$export(module.exports, "confluenceProductSettingsRouteEntry", ()=>$372b1d7617217f20$export$415552b116808717);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $9tUuF;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $372b1d7617217f20$var$LazyConfluenceProductSettingsPage = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("eGzdH"))), {
        moduleId: "./src/packages/spa-apps/confluence-product-settings/src/index.tsx"
    });
    const $372b1d7617217f20$export$a094475e0d3636f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $372b1d7617217f20$var$LazyConfluenceProductSettingsPage,
            pageId: "async-confluence-product-settings",
            shouldShowSpinner: true
        });
    const $372b1d7617217f20$export$415552b116808717 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9tUuF")).confluenceProductSettingsRoute), ()=>({
            component: $372b1d7617217f20$export$a094475e0d3636f,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $372b1d7617217f20$var$LazyConfluenceProductSettingsPage
            ]
        }));
});
parcelRegister("9tUuF", function(module, exports) {
    $parcel$export(module.exports, "confluenceProductSettingsRoute", ()=>$c743cd13da139c69$export$7b2b015fe316fc5d);
    var $65Ltd;
    const $c743cd13da139c69$export$7b2b015fe316fc5d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONFLUENCE_PRODUCT_SETTINGS),
        path: '/jira/settings/products/confluence',
        exact: true
    };
});
parcelRegister("eGzdH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("di7zh")
    ]).then(()=>parcelRequire('6AMhj'));
});
parcelRegister("5eUyE", function(module, exports) {
    $parcel$export(module.exports, "connectRouteEntries", ()=>$4d90b5804d47f5f4$export$b069a1c4b0240172);
    $parcel$export(module.exports, "servicedeskConnectProjectRouteEntry", ()=>$4d90b5804d47f5f4$export$72138a83eeba68eb);
    var $ffza4;
    var $3Ra5L;
    var $65Ltd;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $1XrjK;
    var $lNicp;
    var $hz6Yb;
    var $9UABi;
    var $bHhiy;
    var $3RJkv;
    var $atU1t;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    var $gmigy;
    var $6Z2mh;
    var $3wwwB;
    var $iTDbG;
    const $4d90b5804d47f5f4$export$4c06110e7d14ab3c = ()=>[
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            (0, (0, parcelRequire("9UABi")).connectProjectResources)
        ];
    const $4d90b5804d47f5f4$export$42d81a9df7aca3f8 = {
        component: (0, (0, parcelRequire("iTDbG")).default),
        navigation: {
            menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
            sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
            horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
        },
        forPaint: [
            (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
            (0, (0, parcelRequire("iTDbG")).LazyProjectsConnect)
        ],
        layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
        ufoName: 'jira-connect'
    };
    const $4d90b5804d47f5f4$var$getGeneralConnectRouteResources = ()=>[
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
            ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            (0, (0, parcelRequire("hz6Yb")).connectGeneralResources),
            (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
        ];
    const $4d90b5804d47f5f4$var$generalConnectRouteEntry = {
        layout: (0, (0, parcelRequire("1XrjK")).createLayout)(),
        navigation: {
            menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).ADDONS,
            sidebar: (0, (0, parcelRequire("hBv66")).genericConnectSidebars)
        },
        component: (0, (0, parcelRequire("3wwwB")).default),
        resources: $4d90b5804d47f5f4$var$getGeneralConnectRouteResources(),
        canTransitionIn: (current, next)=>{
            const { query: query } = next.match;
            if (query.mobile === 'true' || query.includeWebResources === 'true' || query.classifier === 'json') return false;
            const emceeKeyRegex = /com\.atlassian\.(jira|confluence)\.emcee($|\.local|\.staging|\.development\..*)/g;
            const addonKey = next.match.params.addonKey || '';
            if (emceeKeyRegex.test(addonKey)) return false;
            return true;
        },
        forPaint: [
            (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
            (0, (0, parcelRequire("3wwwB")).LazyGeneralConnect)
        ],
        ufoName: 'jira-connect'
    };
    const $4d90b5804d47f5f4$var$connectGeneralServiceDeskProjectRouteQuery = [
        ...(0, (0, parcelRequire("3Ra5L")).CONNECT_GENERAL_QUERY_PARAMS),
        ...(0, (0, parcelRequire("gmigy")).connectGeneralServiceDeskProjectRoute).query
    ];
    const $4d90b5804d47f5f4$export$b069a1c4b0240172 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)({
            ...(0, (0, parcelRequire("gmigy")).connectGeneralServiceDeskProjectRoute),
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CONNECT),
            query: $4d90b5804d47f5f4$var$connectGeneralServiceDeskProjectRouteQuery
        }, ()=>({
                ...$4d90b5804d47f5f4$var$generalConnectRouteEntry,
                resources: [
                    ...$4d90b5804d47f5f4$var$getGeneralConnectRouteResources(),
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationSingleResources)()
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("gmigy")).connectGeneralRoute), ()=>({
                ...$4d90b5804d47f5f4$var$generalConnectRouteEntry
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("gmigy")).connectGeneralInvalidRoute), ()=>({
                ...$4d90b5804d47f5f4$var$generalConnectRouteEntry
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("gmigy")).connectProjectRoute), ()=>({
                ...$4d90b5804d47f5f4$export$42d81a9df7aca3f8,
                resources: [
                    ...$4d90b5804d47f5f4$export$4c06110e7d14ab3c(),
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSharedNavigationSingleResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ]
            }))
    ];
    const $4d90b5804d47f5f4$export$72138a83eeba68eb = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("gmigy")).servicedeskConnectProjectRoute), ()=>({
            ...$4d90b5804d47f5f4$export$42d81a9df7aca3f8,
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            resources: [
                ...$4d90b5804d47f5f4$export$4c06110e7d14ab3c(),
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
});
parcelRegister("3Ra5L", function(module, exports) {
    $parcel$export(module.exports, "CONNECT_GENERAL_QUERY_PARAMS", ()=>$0bf6b9f3f002a423$export$2fdb05fdbf78d595);
    const $0bf6b9f3f002a423$export$2fdb05fdbf78d595 = [
        'mobile?!=true',
        'includeWebResources?!=true',
        'classifier?!=json',
        'project.key?',
        'project.id?'
    ];
});
parcelRegister("9UABi", function(module, exports) {
    $parcel$export(module.exports, "connectProjectResources", ()=>$fce046ce7cfaa8c3$export$7d2d082a4b91a6c7);
    var $8Vh1q;
    var $ggg5j;
    var $dIdda = parcelRequire("dIdda");
    const $fce046ce7cfaa8c3$export$7d2d082a4b91a6c7 = (0, $dIdda.createResource)({
        type: (0, $35b0c7feb103121f$export$da32d27651782c3),
        getKey: ({ query: query })=>{
            const { addonKey: addonKey, moduleKey: moduleKey } = (0, (0, parcelRequire("8Vh1q")).transformUrlToAddonAndModuleKeys)(query);
            if (addonKey !== '' && moduleKey !== '') return `${addonKey}-${moduleKey}`;
            return 'state';
        },
        depends: [
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource).type
        ],
        getDataLoader: ()=>(parcelRequire("actZ1"))
    });
});
parcelRegister("8Vh1q", function(module, exports) {
    $parcel$export(module.exports, "transformResponse", ()=>$beff5be7f4728df2$export$3361e9be8093ddcc);
    $parcel$export(module.exports, "extractContext", ()=>$beff5be7f4728df2$export$efdbd45f3e77a161);
    $parcel$export(module.exports, "transformQueryParams", ()=>$beff5be7f4728df2$export$9e3c3f47fc3ab3d0);
    $parcel$export(module.exports, "transformUrlToAddonAndModuleKeys", ()=>$beff5be7f4728df2$export$752ef5ab3d7ab15f);
    var $dJl1T;
    var $6VnTH;
    var $bsuuc;
    const $beff5be7f4728df2$export$3361e9be8093ddcc = (response)=>{
        try {
            const productContext = response.productCtx ? JSON.parse(response.productCtx) : {};
            const structuredContext = response.structuredContext ? JSON.parse(response.structuredContext) : {};
            const context = {
                productContext: productContext,
                structuredContext: structuredContext,
                productCtx: productContext
            };
            return {
                ...response,
                ...context,
                isFullPage: response.general === '1',
                user: {
                    timeZone: response.timeZone,
                    uid: response.uid || undefined,
                    ukey: response.ukey || undefined,
                    fullName: response.fullName || undefined
                },
                targets: {
                    env: {
                        resize: 'both'
                    }
                },
                history: {
                    state: ''
                },
                autoresize: true,
                ns: response.uniqueKey,
                containerId: `embedded-${response.uniqueKey}`,
                contextPath: response.cp,
                width: response.w || response.width,
                height: response.h || response.height
            };
        } catch (error) {
            const location = 'connect-iframe.transformer';
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, 'Failed to transform response', error);
            return {
                autoresize: true,
                productCtx: undefined,
                structuredContext: undefined,
                isFullPage: true,
                history: {
                    state: ''
                },
                targets: {
                    env: {
                        resize: 'both'
                    }
                }
            };
        }
    };
    const $beff5be7f4728df2$var$checkValueAndMapToNewName = (object, oldName, newName)=>{
        const newValue = object !== null && object[oldName] ? String(object[oldName]) : null;
        return newValue !== null ? {
            [newName]: newValue
        } : null;
    };
    const $beff5be7f4728df2$export$1f8eea5a5a32169f = (contextData)=>{
        const scope = contextData && contextData.scope || null;
        const project = contextData && contextData.project || null;
        const projectId = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'id', 'project.id');
        const projectKey = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'key', 'project.key');
        const boardType = $beff5be7f4728df2$var$checkValueAndMapToNewName(scope, 'type', 'board.type');
        const boardId = $beff5be7f4728df2$var$checkValueAndMapToNewName(scope, 'id', 'board.id');
        return {
            ...projectId,
            ...projectKey,
            ...boardType,
            ...boardId
        };
    };
    const $beff5be7f4728df2$export$efdbd45f3e77a161 = (projectSidebarNavInfo)=>{
        const project = projectSidebarNavInfo && (0, (0, parcelRequire("bsuuc")).extractData)(projectSidebarNavInfo) || null;
        const board = projectSidebarNavInfo?.jiraSoftwareNavData && (0, (0, parcelRequire("6VnTH")).extractData)(projectSidebarNavInfo.jiraSoftwareNavData) || null;
        const projectId = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'id', 'project.id');
        const projectKey = $beff5be7f4728df2$var$checkValueAndMapToNewName(project, 'key', 'project.key');
        const boardType = $beff5be7f4728df2$var$checkValueAndMapToNewName(board, 'type', 'board.type');
        const boardId = $beff5be7f4728df2$var$checkValueAndMapToNewName(board, 'id', 'board.id');
        return {
            ...projectId,
            ...projectKey,
            ...boardType,
            ...boardId
        };
    };
    const $beff5be7f4728df2$export$9e3c3f47fc3ab3d0 = (contextData, query)=>{
        const context = $beff5be7f4728df2$export$1f8eea5a5a32169f(contextData);
        return {
            ...query,
            ...context
        };
    };
    const $beff5be7f4728df2$export$752ef5ab3d7ab15f = (query)=>{
        const { selectedItem: selectedItem } = query;
        let addonKey = '';
        let moduleKey = '';
        if (selectedItem) {
            const urlPattern = selectedItem.includes('%3A') ? 'com.atlassian.plugins.atlassian-connect-plugin%3A' : 'com.atlassian.plugins.atlassian-connect-plugin:';
            [addonKey, moduleKey] = selectedItem.replace(urlPattern, '').split('__');
        }
        return {
            addonKey: addonKey,
            moduleKey: moduleKey
        };
    };
});
parcelRegister("6VnTH", function(module, exports) {
    $parcel$export(module.exports, "extractData", ()=>$4d73b10ca351bbb3$export$9df5fa0a366163d2);
    $parcel$export(module.exports, "extractUserBoard", ()=>$4d73b10ca351bbb3$export$67db9e2d1b6ed865);
    const $4d73b10ca351bbb3$export$9df5fa0a366163d2 = (jiraSoftwareNavData)=>{
        if (jiraSoftwareNavData.boardInfo == null) return null;
        const { boardInfo: { id: id, type: type = 'scrum', name: name } } = jiraSoftwareNavData;
        return {
            id: id,
            type: type,
            name: name,
            isProjectBoard: true
        };
    };
    const $4d73b10ca351bbb3$export$67db9e2d1b6ed865 = (userBoardNavData)=>{
        const { boardInfo: { id: id, type: type = 'scrum', name: name } } = userBoardNavData;
        return {
            id: id,
            type: type,
            name: name,
            isProjectBoard: false
        };
    };
});
const $35b0c7feb103121f$export$da32d27651782c3 = 'CONNECT_PROJECT';
parcelRegister("actZ1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("g7yss").then(()=>parcelRequire('4ECv0'));
});
parcelRegister("fpjJX", function(module, exports) {
    $parcel$export(module.exports, "getServiceDeskNavigationResources", ()=>$491f4fde535ee8ab$export$bc0bd65e6da57c1f);
    $parcel$export(module.exports, "getServiceDeskNavigationSingleResources", ()=>$491f4fde535ee8ab$export$41a9145ddbba28e5);
    $parcel$export(module.exports, "getServiceDeskSharedNavigationSingleResources", ()=>$491f4fde535ee8ab$export$2c543d6accc1eb9b);
    $parcel$export(module.exports, "getServiceDeskSettingsResources", ()=>$491f4fde535ee8ab$export$7bb3c4a2f6b127fb);
    $parcel$export(module.exports, "getServicedeskPageContextResources", ()=>$491f4fde535ee8ab$export$a8b852f03a310dc0);
    $parcel$export(module.exports, "getQueuesResources", ()=>$491f4fde535ee8ab$export$70b97995f4d5ef9f);
    $parcel$export(module.exports, "getIssueListSsrResource", ()=>$491f4fde535ee8ab$export$e1016cce62543991);
    $parcel$export(module.exports, "getKnowledgeBaseResources", ()=>$491f4fde535ee8ab$export$ed87d3b71544c4ef);
    $parcel$export(module.exports, "getInsightResources", ()=>$491f4fde535ee8ab$export$9e0cf1fab0581096);
    var $1WqFo;
    var $co1wz;
    var $4R6GH;
    var $5bkvv;
    var $b2pl3;
    var $gS5PF;
    var $6zFAI;
    var $gcI3W;
    var $ggg5j;
    var $iEUaw;
    var $bjZiV;
    var $3RJkv;
    var $dxCvy;
    var $8H3A4;
    var $cAofY;
    var $eUvlM;
    var $lbaDt;
    var $1WlLE;
    var $2cxgG;
    var $6sNnq;
    var $7GnDe;
    var $gNStA;
    var $gRzZD;
    const $491f4fde535ee8ab$export$bc0bd65e6da57c1f = ()=>[
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...$491f4fde535ee8ab$export$41a9145ddbba28e5()
        ];
    const $491f4fde535ee8ab$export$41a9145ddbba28e5 = ()=>[
            ...$491f4fde535ee8ab$export$9c1c5e389bd00e56(),
            ...$491f4fde535ee8ab$export$2c543d6accc1eb9b()
        ];
    const $491f4fde535ee8ab$export$9c1c5e389bd00e56 = ()=>[
            (0, (0, parcelRequire("1WlLE")).priorityGroupResource),
            (0, (0, parcelRequire("6sNnq")).featuresResource),
            (0, (0, parcelRequire("gS5PF")).staticSidebarJsmReportsResource)
        ];
    const $491f4fde535ee8ab$export$2c543d6accc1eb9b = ()=>[
            (0, (0, parcelRequire("1WlLE")).queuesNavigationItems),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('ssr_nav4_queues_sidebar'), (0, (0, parcelRequire("lbaDt")).requiredProjectProperties)),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('ssr_nav4_queues_sidebar'), (0, (0, parcelRequire("lbaDt")).requiredFrontendProperties)),
            (0, (0, parcelRequire("5bkvv")).forgeServiceDeskQueueModuleResource),
            (0, (0, parcelRequire("b2pl3")).staticJSMProjectConnectAddonsNavigationResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $491f4fde535ee8ab$export$7bb3c4a2f6b127fb = ()=>[
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            (0, (0, parcelRequire("eUvlM")).servicedeskPracticesResource),
            (0, (0, parcelRequire("cAofY")).serviceDeskContextResource),
            (0, (0, parcelRequire("8H3A4")).serviceDeskAnalyticsContextResource),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!(0, (0, parcelRequire("1WqFo")).isFedRamp)(), (0, (0, parcelRequire("2cxgG")).virtualAgentOnboardingResource))
        ];
    const $491f4fde535ee8ab$export$a8b852f03a310dc0 = ()=>[
            (0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache),
            (0, (0, parcelRequire("cAofY")).serviceDeskContextResource),
            (0, (0, parcelRequire("8H3A4")).serviceDeskAnalyticsContextResource)
        ];
    const $491f4fde535ee8ab$export$70b97995f4d5ef9f = ()=>[
            ...$491f4fde535ee8ab$export$a8b852f03a310dc0(),
            ...$491f4fde535ee8ab$export$bc0bd65e6da57c1f(),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('automation-templates-team-types-refactor-m1_isj0e'), (0, (0, parcelRequire("eUvlM")).servicedeskPracticesResource))
        ];
    const $491f4fde535ee8ab$export$e1016cce62543991 = ()=>[
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('ssr_view_queues_issuelist'), (0, (0, parcelRequire("1WlLE")).issueListSsrResource))
        ];
    const $491f4fde535ee8ab$export$ed87d3b71544c4ef = ()=>[
            (0, (0, parcelRequire("bjZiV")).kbConfluenceContextResource)
        ];
    const $491f4fde535ee8ab$export$9e0cf1fab0581096 = ()=>[
            (0, (0, parcelRequire("gRzZD")).workspaceResource)
        ];
});
parcelRegister("gS5PF", function(module, exports) {
    $parcel$export(module.exports, "staticSidebarJsmReportsResource", ()=>$e7e607725980fdf6$export$ec28065a31cce4ce);
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $cQGRH;
    const $e7e607725980fdf6$var$getIdentifier = (match, query)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
        return projectKey || projectId;
    };
    const $e7e607725980fdf6$export$ec28065a31cce4ce = (0, $dIdda.createResource)({
        type: 'NAVIGATION_SIDEBAR_JIRA_SERVICE_MANAGEMENT_REPORTS',
        getKey: ({ match: match, query: query })=>$e7e607725980fdf6$var$getIdentifier(match, query) ?? 'none',
        getData: async ({ match: match, query: query })=>{
            const projectKeyOrId = $e7e607725980fdf6$var$getIdentifier(match, query);
            if (projectKeyOrId == null) return null;
            return (0, (0, parcelRequire("cQGRH")).fetchJsmReportsSidebarNavInfo)(projectKeyOrId);
        },
        maxAge: 300000
    });
});
parcelRegister("cQGRH", function(module, exports) {
    $parcel$export(module.exports, "fetchJsmReportsSidebarNavInfo", ()=>$ed2ba0d649a8d8eb$export$c1dd51127051647d);
    var $eusud;
    const $ed2ba0d649a8d8eb$export$c1dd51127051647d = (projectIdOrKey)=>{
        if (projectIdOrKey == null) throw new Error('invalid project id or key');
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/navigation/4/servicedesk/project/${projectIdOrKey}/reports`);
    };
});
parcelRegister("bjZiV", function(module, exports) {
    $parcel$export(module.exports, "kbConfluenceContextResource", ()=>$450040dc63d5cc0e$export$8b58be1423986d17);
    var $dIdda = parcelRequire("dIdda");
    const $450040dc63d5cc0e$var$getDataLoader = ()=>(parcelRequire("f43qF"));
    const $450040dc63d5cc0e$export$8b58be1423986d17 = (0, $dIdda.createResource)({
        type: (0, $3139e13cdf89be01$export$54b5a0d1e8c78de6),
        getKey: ({ match: match })=>match.params.projectKey || '',
        getDataLoader: $450040dc63d5cc0e$var$getDataLoader,
        maxAge: Infinity
    });
});
const $3139e13cdf89be01$export$54b5a0d1e8c78de6 = 'KB_CONFLUENCE_CONTEXT';
parcelRegister("f43qF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2CTCs").then(()=>parcelRequire('2SeLy'));
});
parcelRegister("cAofY", function(module, exports) {
    $parcel$export(module.exports, "serviceDeskContextResource", ()=>$9c517de0cdc23225$export$5eaaf465969a9171);
    var $dK8AG;
    var $dIdda = parcelRequire("dIdda");
    const $9c517de0cdc23225$var$getDataLoader = ()=>(parcelRequire("jxdf6"));
    const $9c517de0cdc23225$export$5eaaf465969a9171 = (0, $dIdda.createResource)({
        type: (0, $4595635dbd9fca21$export$ac01662d5287bc5c),
        getKey: ({ match: match, query: query })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrIdFromMatchAndQuery)({
                match: match,
                query: query
            }),
        getDataLoader: $9c517de0cdc23225$var$getDataLoader,
        maxAge: Infinity
    });
});
const $4595635dbd9fca21$export$ac01662d5287bc5c = 'SERVICEDESK_CONTEXT';
parcelRegister("jxdf6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iNITq").then(()=>parcelRequire('g4PUK'));
});
parcelRegister("eUvlM", function(module, exports) {
    $parcel$export(module.exports, "servicedeskPracticesResource", ()=>$9479f477b801290f$export$2ae319305481e7de);
    $parcel$export(module.exports, "useWorkCategoriesQueueSupported", ()=>$9479f477b801290f$export$a86ac771006f14b3);
    $parcel$export(module.exports, "useWorkCategoriesAllSupported", ()=>$9479f477b801290f$export$fe081b1a59d3c818);
    $parcel$export(module.exports, "useWorkCategoriesAllSupportedWithForceRefreshOnMount", ()=>$9479f477b801290f$export$4d46346ef0bdc6b9);
    var $5uXOq = parcelRequire("5uXOq");
    var $dK8AG;
    var $oCMSG;
    var $dIdda = parcelRequire("dIdda");
    const $9479f477b801290f$var$getDataLoader = ()=>(parcelRequire("bvW9G"));
    const $9479f477b801290f$var$ONE_DAY_IN_MILLIS = 86400000;
    const $9479f477b801290f$export$2ae319305481e7de = (0, $dIdda.createResource)({
        type: (0, $990f0449915d93bf$export$45919c8f50bb1db5),
        getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
        getDataLoader: $9479f477b801290f$var$getDataLoader,
        maxAge: $9479f477b801290f$var$ONE_DAY_IN_MILLIS
    });
    const $9479f477b801290f$var$queuesOrder = [
        ...(0, (0, parcelRequire("oCMSG")).WORK_CATEGORIES_QUEUE_SUPPORTED)
    ];
    const $9479f477b801290f$var$workCategoryOrder = [
        ...$9479f477b801290f$var$queuesOrder,
        (0, (0, parcelRequire("oCMSG")).DEVELOPER_ESCALATION)
    ];
    const $9479f477b801290f$var$transformItsmPracticesList = (data)=>{
        if (!data?.practices) return null;
        return $9479f477b801290f$var$queuesOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
    };
    const $9479f477b801290f$var$transformServiceDeskPracticesList = (data)=>{
        if (!data?.practices) return null;
        return $9479f477b801290f$var$workCategoryOrder.filter((practice)=>data.practices.some((practiceInData)=>practiceInData.key === practice));
    };
    const $9479f477b801290f$export$a86ac771006f14b3 = ()=>{
        const { data: data, loading: loading, ...resource } = (0, $dIdda.useResource)($9479f477b801290f$export$2ae319305481e7de);
        const error = resource.error;
        return (0, $5uXOq.useMemo)(()=>({
                data: $9479f477b801290f$var$transformItsmPracticesList(data),
                loading: loading,
                error: error
            }), [
            data,
            error,
            loading
        ]);
    };
    const $9479f477b801290f$export$fe081b1a59d3c818 = ()=>{
        const { data: data, loading: loading, ...resource } = (0, $dIdda.useResource)($9479f477b801290f$export$2ae319305481e7de);
        const error = resource.error;
        return (0, $5uXOq.useMemo)(()=>({
                data: $9479f477b801290f$var$transformServiceDeskPracticesList(data),
                loading: loading,
                error: error
            }), [
            data,
            error,
            loading
        ]);
    };
    const $9479f477b801290f$export$4d46346ef0bdc6b9 = ()=>{
        const { data: data, loading: loading, refresh: refreshPractices, ...resource } = (0, $dIdda.useResource)($9479f477b801290f$export$2ae319305481e7de);
        const error = resource.error;
        (0, $5uXOq.useEffect)(()=>{
            if (!loading && !data && !error) refreshPractices();
        }, [
            data,
            error,
            loading,
            refreshPractices
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: $9479f477b801290f$var$transformServiceDeskPracticesList(data),
                loading: loading,
                error: error
            }), [
            data,
            error,
            loading
        ]);
    };
});
parcelRegister("oCMSG", function(module, exports) {
    $parcel$export(module.exports, "CHANGES", ()=>$4f9c4406e75c8aa5$export$8598196f74460271);
    $parcel$export(module.exports, "INCIDENTS", ()=>$4f9c4406e75c8aa5$export$a50b49a533b5f7bc);
    $parcel$export(module.exports, "PROBLEMS", ()=>$4f9c4406e75c8aa5$export$ceba70db1edb1def);
    $parcel$export(module.exports, "SERVICE_REQUEST", ()=>$4f9c4406e75c8aa5$export$3d1cda9bd50505e8);
    $parcel$export(module.exports, "POST_INCIDENT_REVIEWS", ()=>$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f);
    $parcel$export(module.exports, "DEVELOPER_ESCALATION", ()=>$4f9c4406e75c8aa5$export$81e62964cc725098);
    $parcel$export(module.exports, "NO_CATEGORY", ()=>$4f9c4406e75c8aa5$export$485b1216c42d8d4);
    $parcel$export(module.exports, "NO_PRACTICE", ()=>$4f9c4406e75c8aa5$export$52bf3f16b7812704);
    $parcel$export(module.exports, "SHORT_FORM_CHANGES", ()=>$4f9c4406e75c8aa5$export$a50185c8e9fb007e);
    $parcel$export(module.exports, "SHORT_FORM_INCIDENTS", ()=>$4f9c4406e75c8aa5$export$a54a30a3c3cce634);
    $parcel$export(module.exports, "SHORT_FORM_PROBLEMS", ()=>$4f9c4406e75c8aa5$export$354f3a4c6ac0c903);
    $parcel$export(module.exports, "SHORT_FORM_SERVICE_REQUEST", ()=>$4f9c4406e75c8aa5$export$335d3ac0c367f03f);
    $parcel$export(module.exports, "SHORT_FORM_POST_INCIDENT_REVIEWS", ()=>$4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f);
    $parcel$export(module.exports, "SHORT_FORM_DEVELOPER_ESCALATION", ()=>$4f9c4406e75c8aa5$export$cb41b99ca54e6bd);
    $parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED", ()=>$4f9c4406e75c8aa5$export$a2b1f8f055150f02);
    $parcel$export(module.exports, "ItsmPracticeToShortForm", ()=>$4f9c4406e75c8aa5$export$56c57f7ad650c45c);
    $parcel$export(module.exports, "PRACTICE_LABEL_MAP", ()=>$4f9c4406e75c8aa5$export$fbf0dfd01228e38d);
    $parcel$export(module.exports, "PRACTICE_LABEL_MAP_LOWER_CASE", ()=>$4f9c4406e75c8aa5$export$45ba5f49e9509c4d);
    $parcel$export(module.exports, "WORK_CATEGORIES_QUEUE_SUPPORTED_LABELS", ()=>$4f9c4406e75c8aa5$export$45952424a7f29b99);
    $parcel$export(module.exports, "CHANGES_JQL_NAME", ()=>$4f9c4406e75c8aa5$export$6c24c440228eac9c);
    $parcel$export(module.exports, "INCIDENTS_JQL_NAME", ()=>$4f9c4406e75c8aa5$export$5b65d27ec2d28d18);
    $parcel$export(module.exports, "DEVELOPER_ESCALATION_JQL_NAME", ()=>$4f9c4406e75c8aa5$export$3f757c5e00588ffd);
    $parcel$export(module.exports, "practiceKeyJqlNameMapping", ()=>$4f9c4406e75c8aa5$export$b78213db77524b5b);
    var $7c0in;
    var $kVZSN;
    const $4f9c4406e75c8aa5$export$8598196f74460271 = 'change-management';
    const $4f9c4406e75c8aa5$export$a50b49a533b5f7bc = 'incident-management';
    const $4f9c4406e75c8aa5$export$ceba70db1edb1def = 'problem-management';
    const $4f9c4406e75c8aa5$export$3d1cda9bd50505e8 = 'service-request';
    const $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f = 'post-incident-review';
    const $4f9c4406e75c8aa5$export$81e62964cc725098 = 'developer-escalation';
    const $4f9c4406e75c8aa5$export$485b1216c42d8d4 = 'no-category';
    const $4f9c4406e75c8aa5$export$f929a394dd190451 = 'no-category-new';
    const $4f9c4406e75c8aa5$export$52bf3f16b7812704 = 'no-practice';
    const $4f9c4406e75c8aa5$export$a50185c8e9fb007e = 'changes';
    const $4f9c4406e75c8aa5$export$a54a30a3c3cce634 = 'incidents';
    const $4f9c4406e75c8aa5$export$354f3a4c6ac0c903 = 'problems';
    const $4f9c4406e75c8aa5$export$335d3ac0c367f03f = 'service-requests';
    const $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f = 'post-incident-reviews';
    const $4f9c4406e75c8aa5$export$cb41b99ca54e6bd = 'developer-escalations';
    const $4f9c4406e75c8aa5$export$a613d808168c7b25 = [
        $4f9c4406e75c8aa5$export$8598196f74460271,
        $4f9c4406e75c8aa5$export$a50b49a533b5f7bc,
        $4f9c4406e75c8aa5$export$ceba70db1edb1def,
        $4f9c4406e75c8aa5$export$3d1cda9bd50505e8,
        $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f,
        $4f9c4406e75c8aa5$export$81e62964cc725098
    ];
    const $4f9c4406e75c8aa5$export$a2b1f8f055150f02 = [
        $4f9c4406e75c8aa5$export$3d1cda9bd50505e8,
        $4f9c4406e75c8aa5$export$a50b49a533b5f7bc,
        $4f9c4406e75c8aa5$export$ceba70db1edb1def,
        $4f9c4406e75c8aa5$export$8598196f74460271,
        $4f9c4406e75c8aa5$export$6ebf7b6bf1c580f
    ];
    const $4f9c4406e75c8aa5$export$5a9122a4028fb8ef = [
        ...$4f9c4406e75c8aa5$export$a2b1f8f055150f02,
        $4f9c4406e75c8aa5$export$485b1216c42d8d4
    ];
    const $4f9c4406e75c8aa5$export$f1b813cd23817ade = [
        $4f9c4406e75c8aa5$export$a50185c8e9fb007e,
        $4f9c4406e75c8aa5$export$a54a30a3c3cce634,
        $4f9c4406e75c8aa5$export$354f3a4c6ac0c903,
        $4f9c4406e75c8aa5$export$335d3ac0c367f03f,
        $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f,
        $4f9c4406e75c8aa5$export$cb41b99ca54e6bd
    ];
    const $4f9c4406e75c8aa5$export$56c57f7ad650c45c = {
        [$4f9c4406e75c8aa5$export$8598196f74460271]: $4f9c4406e75c8aa5$export$a50185c8e9fb007e,
        [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: $4f9c4406e75c8aa5$export$a54a30a3c3cce634,
        [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: $4f9c4406e75c8aa5$export$354f3a4c6ac0c903,
        [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: $4f9c4406e75c8aa5$export$335d3ac0c367f03f,
        [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: $4f9c4406e75c8aa5$export$7ffd7f2c2ae96b6f,
        [$4f9c4406e75c8aa5$export$485b1216c42d8d4]: $4f9c4406e75c8aa5$export$f929a394dd190451
    };
    const $4f9c4406e75c8aa5$export$fbf0dfd01228e38d = {
        [$4f9c4406e75c8aa5$export$8598196f74460271]: (0, (0, parcelRequire("kVZSN")).default).changes,
        [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: (0, (0, parcelRequire("kVZSN")).default).serviceRequests,
        [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: (0, (0, parcelRequire("kVZSN")).default).problems,
        [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: (0, (0, parcelRequire("kVZSN")).default).incidents,
        [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: (0, (0, parcelRequire("kVZSN")).default).postIncidentReviews,
        [$4f9c4406e75c8aa5$export$485b1216c42d8d4]: (0, (0, parcelRequire("kVZSN")).default).queues,
        [$4f9c4406e75c8aa5$export$81e62964cc725098]: (0, (0, parcelRequire("kVZSN")).default).developerEscalation,
        [$4f9c4406e75c8aa5$export$52bf3f16b7812704]: (0, (0, parcelRequire("kVZSN")).default).noCategory
    };
    const $4f9c4406e75c8aa5$export$45ba5f49e9509c4d = {
        [$4f9c4406e75c8aa5$export$8598196f74460271]: (0, (0, parcelRequire("kVZSN")).default).changesLower,
        [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: (0, (0, parcelRequire("kVZSN")).default).serviceRequestsLower,
        [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: (0, (0, parcelRequire("kVZSN")).default).problemsLower,
        [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: (0, (0, parcelRequire("kVZSN")).default).incidentsLower,
        [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: (0, (0, parcelRequire("kVZSN")).default).postIncidentReviewsLower,
        [$4f9c4406e75c8aa5$export$485b1216c42d8d4]: (0, (0, parcelRequire("kVZSN")).default).queuesLower,
        [$4f9c4406e75c8aa5$export$81e62964cc725098]: (0, (0, parcelRequire("kVZSN")).default).developerEscalationLower,
        [$4f9c4406e75c8aa5$export$52bf3f16b7812704]: (0, (0, parcelRequire("kVZSN")).default).noCategoryLower
    };
    const $4f9c4406e75c8aa5$export$45952424a7f29b99 = (0, (0, parcelRequire("7c0in")).getTypedKeys)($4f9c4406e75c8aa5$export$fbf0dfd01228e38d).reduce((acc, labelMapKey)=>{
        const queueKey = $4f9c4406e75c8aa5$export$a2b1f8f055150f02.find((key)=>key === labelMapKey);
        if (queueKey) acc[queueKey] = $4f9c4406e75c8aa5$export$fbf0dfd01228e38d[labelMapKey];
        return acc;
    }, {});
    const $4f9c4406e75c8aa5$export$6c24c440228eac9c = 'Changes';
    const $4f9c4406e75c8aa5$export$5b65d27ec2d28d18 = 'Incidents';
    const $4f9c4406e75c8aa5$export$51618dc8334072b = 'Problems';
    const $4f9c4406e75c8aa5$export$a34586940ac9c374 = 'Service requests';
    const $4f9c4406e75c8aa5$export$5497b62b513b7853 = 'Post-incident reviews';
    const $4f9c4406e75c8aa5$export$3f757c5e00588ffd = 'Developer escalation';
    const $4f9c4406e75c8aa5$export$b78213db77524b5b = {
        [$4f9c4406e75c8aa5$export$8598196f74460271]: $4f9c4406e75c8aa5$export$6c24c440228eac9c,
        [$4f9c4406e75c8aa5$export$a50b49a533b5f7bc]: $4f9c4406e75c8aa5$export$5b65d27ec2d28d18,
        [$4f9c4406e75c8aa5$export$ceba70db1edb1def]: $4f9c4406e75c8aa5$export$51618dc8334072b,
        [$4f9c4406e75c8aa5$export$3d1cda9bd50505e8]: $4f9c4406e75c8aa5$export$a34586940ac9c374,
        [$4f9c4406e75c8aa5$export$6ebf7b6bf1c580f]: $4f9c4406e75c8aa5$export$5497b62b513b7853,
        [$4f9c4406e75c8aa5$export$81e62964cc725098]: $4f9c4406e75c8aa5$export$3f757c5e00588ffd
    };
});
parcelRegister("7c0in", function(module, exports) {
    $parcel$export(module.exports, "hasProp", ()=>$2dc9189f096b533d$export$dd642ef726dcde21);
    $parcel$export(module.exports, "getTypedKeys", ()=>$2dc9189f096b533d$export$5206d47972fefe20);
    const $2dc9189f096b533d$export$dd642ef726dcde21 = (data, prop)=>prop in data;
    const $2dc9189f096b533d$export$5206d47972fefe20 = (obj)=>{
        return Object.keys(obj);
    };
});
parcelRegister("kVZSN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d218b9a030da8fd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5d218b9a030da8fd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        queues: {
            "id": "work-category.common.queues",
            "defaultMessage": "Queues"
        },
        serviceRequests: {
            "id": "work-category.common.service-requests",
            "defaultMessage": "Service requests"
        },
        incidents: {
            "id": "work-category.common.incidents",
            "defaultMessage": "Incidents"
        },
        changes: {
            "id": "work-category.common.changes",
            "defaultMessage": "Changes"
        },
        problems: {
            "id": "work-category.common.problems",
            "defaultMessage": "Problems"
        },
        postIncidentReviews: {
            "id": "work-category.common.post-incident-reviews",
            "defaultMessage": "Post-incident reviews"
        },
        noCategory: {
            "id": "work-category.common.no-category",
            "defaultMessage": "General"
        },
        queuesLower: {
            "id": "work-category.common.queues-lower",
            "defaultMessage": "queues"
        },
        serviceRequestsLower: {
            "id": "work-category.common.service-requests-lower",
            "defaultMessage": "service requests"
        },
        incidentsLower: {
            "id": "work-category.common.incidents-lower",
            "defaultMessage": "incidents"
        },
        changesLower: {
            "id": "work-category.common.changes-lower",
            "defaultMessage": "changes"
        },
        problemsLower: {
            "id": "work-category.common.problems-lower",
            "defaultMessage": "problems"
        },
        postIncidentReviewsLower: {
            "id": "work-category.common.post-incident-reviews-lower",
            "defaultMessage": "post-incident reviews"
        },
        noCategoryLower: {
            "id": "work-category.common.no-category-lower",
            "defaultMessage": "general"
        },
        developerEscalation: {
            "id": "work-category.common.developer-escalation",
            "defaultMessage": "Developer escalations"
        },
        developerEscalationLower: {
            "id": "work-category.common.developer-escalation-lower",
            "defaultMessage": "developer escalations"
        }
    });
});
const $990f0449915d93bf$export$45919c8f50bb1db5 = 'SERVICEDESK_PRACTICES';
parcelRegister("bvW9G", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jhLKO").then(()=>parcelRequire('8khb6'));
});
parcelRegister("lbaDt", function(module, exports) {
    $parcel$export(module.exports, "requiredProjectProperties", ()=>$3477ceb4f9b98b2e$export$fbeae45a65f4a5a6);
    $parcel$export(module.exports, "requiredFrontendProperties", ()=>$3477ceb4f9b98b2e$export$47241956725e3029);
    var $9XE6b = parcelRequire("9XE6b");
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $13HHi;
    const $3477ceb4f9b98b2e$var$getRequiredProjectPropertiesDataLoader = ()=>(parcelRequire("gssgh"));
    const $3477ceb4f9b98b2e$var$getKey = ({ match: match, query: query })=>(0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query).projectKey || (0, ($parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0];
    const $3477ceb4f9b98b2e$export$fbeae45a65f4a5a6 = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("13HHi")).RESOURCE_TYPE_SERVICEDESK_REQUIRED_PROJECT_PROPERTIES),
        getKey: $3477ceb4f9b98b2e$var$getKey,
        getDataLoader: $3477ceb4f9b98b2e$var$getRequiredProjectPropertiesDataLoader
    });
    const $3477ceb4f9b98b2e$var$getRequiredFrontendPropertiesDataLoader = ()=>(parcelRequire("fTSMy"));
    const $3477ceb4f9b98b2e$export$47241956725e3029 = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("13HHi")).RESOURCE_TYPE_SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES),
        getKey: $3477ceb4f9b98b2e$var$getKey,
        getDataLoader: $3477ceb4f9b98b2e$var$getRequiredFrontendPropertiesDataLoader,
        maxAge: (0, (0, parcelRequire("13HHi")).ONE_DAY_IN_MILLIS)
    });
});
parcelRegister("13HHi", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_REQUIRED_PROJECT_PROPERTIES", ()=>$e7877c2ea997c7d8$export$54b53cba12671494);
    $parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES", ()=>$e7877c2ea997c7d8$export$7d9318d6cfb0a4df);
    $parcel$export(module.exports, "ONE_DAY_IN_MILLIS", ()=>$e7877c2ea997c7d8$export$5a00268156ea5027);
    const $e7877c2ea997c7d8$export$54b53cba12671494 = 'SERVICEDESK_REQUIRED_PROJECT_PROPERTIES';
    const $e7877c2ea997c7d8$export$7d9318d6cfb0a4df = 'SERVICEDESK_REQUIRED_FRONTEND_PROPERTIES';
    const $e7877c2ea997c7d8$export$5a00268156ea5027 = 86400000;
});
parcelRegister("gssgh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7aPU6").then(()=>parcelRequire('d4USv'));
});
parcelRegister("fTSMy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4Lrpj").then(()=>parcelRequire('7UDgf'));
});
parcelRegister("2cxgG", function(module, exports) {
    $parcel$export(module.exports, "virtualAgentOnboardingResource", ()=>$e9d51fb7135f5412$export$d39827c053fda3aa);
    var $ao2h1;
    var $2j6fy;
    const $e9d51fb7135f5412$export$d39827c053fda3aa = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'SERVICEDESK_VIRTUAL_AGENT_ONBOARDING',
        isBrowserOnly: true,
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("2j6fy")).default),
                variables: {
                    cloudId: tenantContext.cloudId,
                    key: match.params.projectKey || ''
                }
            })
    });
});
parcelRegister("2j6fy", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$45b605658e5ce20d$export$2e2bcd8739ae039);
    var $7oHmH;
    const $45b605658e5ce20d$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "f9088e152f36ba09b78f1e067be176d1d2e7e1bab920efd3620300fc8bf9722e",
            "metadata": {},
            "name": "mainVirtualAgentSidebarQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $45b605658e5ce20d$export$2e2bcd8739ae039 = $45b605658e5ce20d$var$node;
});
parcelRegister("7oHmH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f0ef421b1798a33$export$2e2bcd8739ae039);
    var $4R6GH;
    var $3f0ef421b1798a33$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('require_ai_enabled_for_jsm_virtual_agent');
        }
    };
});
parcelRegister("6sNnq", function(module, exports) {
    $parcel$export(module.exports, "featuresResource", ()=>$d0a02e466fb63798$export$16f81cc9da2c6c47);
    var $9XE6b = parcelRequire("9XE6b");
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    const $d0a02e466fb63798$var$getDataLoader = ()=>(parcelRequire("8wbKs"));
    const $d0a02e466fb63798$var$ONE_DAY_IN_MILLIS = 86400000;
    const $d0a02e466fb63798$export$16f81cc9da2c6c47 = (0, $dIdda.createResource)({
        type: (0, $68b2e6d16c6e9952$export$3441b129810f29ed),
        getKey: ({ match: match, query: query })=>(0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query).projectKey || (0, ($parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
        getDataLoader: $d0a02e466fb63798$var$getDataLoader,
        maxAge: $d0a02e466fb63798$var$ONE_DAY_IN_MILLIS
    });
});
const $68b2e6d16c6e9952$export$3441b129810f29ed = 'SERVICEDESK_FEATURES';
parcelRegister("8wbKs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aOISr").then(()=>parcelRequire('frQmB'));
});
parcelRegister("gmigy", function(module, exports) {
    $parcel$export(module.exports, "connectGeneralRoute", ()=>$21bf0ffffba0953e$export$1fda4850b6314ff0);
    $parcel$export(module.exports, "connectGeneralInvalidRoute", ()=>$21bf0ffffba0953e$export$486ffffd0a2797a5);
    $parcel$export(module.exports, "connectGeneralServiceDeskProjectRoute", ()=>$21bf0ffffba0953e$export$e8a58aee75961b55);
    $parcel$export(module.exports, "connectProjectRoute", ()=>$21bf0ffffba0953e$export$27e7531864dfb704);
    $parcel$export(module.exports, "servicedeskConnectProjectRoute", ()=>$21bf0ffffba0953e$export$148fcbe26061b2c9);
    var $3Ra5L;
    var $kUeZd;
    var $65Ltd;
    const $21bf0ffffba0953e$export$1fda4850b6314ff0 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CONNECT),
        path: '/plugins/servlet/ac/:addonKey/:moduleKey',
        query: (0, (0, parcelRequire("3Ra5L")).CONNECT_GENERAL_QUERY_PARAMS)
    };
    const $21bf0ffffba0953e$export$486ffffd0a2797a5 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_INVALID),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CONNECT),
        path: '/plugins/servlet/ac/:addonKey//:moduleKey',
        query: (0, (0, parcelRequire("3Ra5L")).CONNECT_GENERAL_QUERY_PARAMS)
    };
    const $21bf0ffffba0953e$export$e8a58aee75961b55 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CONNECT),
        path: '/plugins/servlet/ac/:addonKey/:moduleKey',
        query: [
            'project.key',
            'servicedesk.serviceDeskId'
        ]
    };
    const $21bf0ffffba0953e$export$27e7531864dfb704 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CONNECT),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_PROJECT),
        path: '/projects/:projectKey',
        query: (0, (0, parcelRequire("kUeZd")).CONNECT_PROJECT_QUERY_PARAMS)
    };
    const $21bf0ffffba0953e$export$148fcbe26061b2c9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CONNECT_PROJECT),
        path: '/jira/servicedesk/projects/:projectKey',
        query: (0, (0, parcelRequire("kUeZd")).CONNECT_PROJECT_QUERY_PARAMS),
        exact: true
    };
});
parcelRegister("kUeZd", function(module, exports) {
    $parcel$export(module.exports, "CONNECT_PROJECT_QUERY_PARAMS", ()=>$e64562bb8c3fa371$export$9bb839aee83bf4d8);
    const $e64562bb8c3fa371$export$9bb839aee83bf4d8 = [
        'selectedItem=(^com.atlassian.plugins.atlassian-connect-plugin.*)'
    ];
});
parcelRegister("3wwwB", function(module, exports) {
    $parcel$export(module.exports, "LazyGeneralConnect", ()=>$49a774cbbfe614f4$export$c33275abe6c1e577);
    $parcel$export(module.exports, "default", ()=>$49a774cbbfe614f4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $49a774cbbfe614f4$export$c33275abe6c1e577 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("iGYap"))), {
        moduleId: "./src/packages/spa-apps/jira-connect/general-pages/src/index.tsx"
    });
    var $49a774cbbfe614f4$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $49a774cbbfe614f4$export$c33275abe6c1e577,
            pageId: "connect",
            shouldShowSpinner: true
        });
});
parcelRegister("iGYap", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cTtOi").then(()=>parcelRequire('crFp4'));
});
parcelRegister("iTDbG", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectsConnect", ()=>$c9a4402f23043c3c$export$3dadc93ff144628f);
    $parcel$export(module.exports, "default", ()=>$c9a4402f23043c3c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $c9a4402f23043c3c$export$3dadc93ff144628f = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dwmMO"))), {
        moduleId: "./src/packages/spa-apps/jira-connect/project-pages/src/index.tsx"
    });
    var $c9a4402f23043c3c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c9a4402f23043c3c$export$3dadc93ff144628f,
            pageId: "connect-projects",
            shouldShowSpinner: true
        });
});
parcelRegister("dwmMO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6lBjo").then(()=>parcelRequire('2GYK9'));
});
parcelRegister("5Fkpv", function(module, exports) {
    $parcel$export(module.exports, "createProjectRouteEntry", ()=>$654ebb131c30ba2a$export$28887e2da22c839a);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $gyYxw;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $3uqI9;
    var $5j7Th;
    var $hPtZI;
    const $654ebb131c30ba2a$export$5c005d1ab6cfe623 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("1OvmD")), {
        moduleId: "./src/packages/spa-apps/create-project/src/index.tsx"
    });
    const $654ebb131c30ba2a$export$43b852e2e1a047e8 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $654ebb131c30ba2a$export$5c005d1ab6cfe623,
            pageId: "spa-apps/create-project",
            shouldShowSpinner: true
        });
    const $654ebb131c30ba2a$export$28887e2da22c839a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("3uqI9")).createProjectRoute), ()=>({
            component: $654ebb131c30ba2a$export$43b852e2e1a047e8,
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $654ebb131c30ba2a$export$5c005d1ab6cfe623
            ]
        }));
});
parcelRegister("3uqI9", function(module, exports) {
    $parcel$export(module.exports, "createProjectRoute", ()=>$35bf16777764b53a$export$5ce9108542315ac8);
    var $65Ltd;
    const $35bf16777764b53a$export$5ce9108542315ac8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CREATE_PROJECT),
        path: '/jira/create-project',
        exact: true
    };
});
parcelRegister("1OvmD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("p91SI").then(()=>parcelRequire('6cT2s'));
});
parcelRegister("c31xm", function(module, exports) {
    $parcel$export(module.exports, "dashboardRouteEntry", ()=>$cf8020dd6e5d22c9$export$9fbbaafb58999ac3);
    $parcel$export(module.exports, "selectedDashboardRouteEntry", ()=>$cf8020dd6e5d22c9$export$ac09a8d3ecbafc5);
    $parcel$export(module.exports, "dashboardEditRouteEntry", ()=>$cf8020dd6e5d22c9$export$9b0fdfd6a51a17de);
    $parcel$export(module.exports, "dashboardWallboardRouteEntry", ()=>$cf8020dd6e5d22c9$export$6009dd8e88f1a7de);
    $parcel$export(module.exports, "dashboardViewRouteEntry", ()=>$cf8020dd6e5d22c9$export$18226b6422149926);
    $parcel$export(module.exports, "dashboardViewEmbedRouteEntry", ()=>$cf8020dd6e5d22c9$export$73a377380ff671af);
    $parcel$export(module.exports, "systemDashboardEditRouteEntry", ()=>$cf8020dd6e5d22c9$export$15f76f1b0d2d671);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $j6woB;
    var $Xtn30;
    var $e2ctp;
    var $2BrOV;
    var $ibkIl;
    var $gmpjq;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $1XrjK;
    var $gh1hi;
    var $3RJkv;
    var $atU1t;
    var $2Ql51;
    var $94QFg;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $4n0Oi;
    const $cf8020dd6e5d22c9$var$dashboardResources = [
        (0, (0, parcelRequire("gh1hi")).dashboardConfigAndWRMResource),
        (0, (0, parcelRequire("gh1hi")).dashboardAMDModulesResource),
        (0, (0, parcelRequire("gh1hi")).dashboardReactGadgetsResource),
        (0, (0, parcelRequire("gh1hi")).dashboardForgeResource)
    ];
    const $cf8020dd6e5d22c9$var$LazyDashboardView = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5lVAv"))), {
        moduleId: "./src/packages/global-pages/dashboard/view/src/index.tsx"
    });
    const $cf8020dd6e5d22c9$var$LazyDashboardViewEmbed = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dtemB"))), {
        moduleId: "./src/packages/global-pages/dashboard/view-embed/src/index.tsx"
    });
    const $cf8020dd6e5d22c9$var$LazyDashboardWallboard = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2yGxE"))), {
        moduleId: "./src/packages/global-pages/dashboard/wallboard/src/index.tsx"
    });
    const $cf8020dd6e5d22c9$var$LazyDashboardEdit = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("ixqoJ"))), {
        moduleId: "./src/packages/global-pages/dashboard/edit/src/index.tsx"
    });
    const $cf8020dd6e5d22c9$export$c8d59d34c3e8f345 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("atP20"))), {
        moduleId: "./src/packages/spa-apps/dashboard/system-dashboard-edit/src/index.tsx"
    });
    const $cf8020dd6e5d22c9$export$8d692f4ffba40a2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cf8020dd6e5d22c9$var$LazyDashboardView,
            pageId: "dashboard",
            shouldShowSpinner: false
        });
    const $cf8020dd6e5d22c9$export$86d9f777f9d4e312 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cf8020dd6e5d22c9$var$LazyDashboardViewEmbed,
            pageId: "dashboard",
            shouldShowSpinner: true
        });
    const $cf8020dd6e5d22c9$export$419b9eec5ed9880d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cf8020dd6e5d22c9$var$LazyDashboardWallboard,
            pageId: "dashboard",
            shouldShowSpinner: true
        });
    const $cf8020dd6e5d22c9$export$fb2c0a1de056b738 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cf8020dd6e5d22c9$var$LazyDashboardEdit,
            pageId: "dashboard",
            shouldShowSpinner: false
        });
    const $cf8020dd6e5d22c9$export$dcd19a888f8c85c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cf8020dd6e5d22c9$export$c8d59d34c3e8f345,
            pageId: "system-dashboard-edit",
            shouldShowSpinner: false
        });
    const $cf8020dd6e5d22c9$export$9fbbaafb58999ac3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("94QFg")).dashboardRoute), ()=>({
            component: (0, (0, parcelRequire("4n0Oi")).DashboardRedirect),
            layout: (0, (0, parcelRequire("gmpjq")).homepageLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$cf8020dd6e5d22c9$var$dashboardResources
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $cf8020dd6e5d22c9$var$LazyDashboardView
            ],
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
            },
            isRedirect: true,
            earlyAssets: (0, (0, parcelRequire("e2ctp")).NORMAL_EARLY_ASSET_STRATEGY)
        }));
    const $cf8020dd6e5d22c9$export$ac09a8d3ecbafc5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("94QFg")).selectedDashboardRoute), ()=>({
            component: (0, (0, parcelRequire("4n0Oi")).DashboardRedirect),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).DASHBOARDS
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$cf8020dd6e5d22c9$var$dashboardResources
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $cf8020dd6e5d22c9$var$LazyDashboardView
            ],
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
            },
            isRedirect: true,
            earlyAssets: (0, (0, parcelRequire("e2ctp")).NORMAL_EARLY_ASSET_STRATEGY)
        }));
    const $cf8020dd6e5d22c9$export$9b0fdfd6a51a17de = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("94QFg")).dashboardEditRoute), ()=>({
            component: $cf8020dd6e5d22c9$export$fb2c0a1de056b738,
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("j6woB")).dashboardBackgroundScriptsLayout)),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).DASHBOARDS
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$cf8020dd6e5d22c9$var$dashboardResources,
                (0, (0, parcelRequire("gh1hi")).gadgetDirectoryResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $cf8020dd6e5d22c9$var$LazyDashboardEdit
            ],
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
            },
            earlyAssets: (0, (0, parcelRequire("e2ctp")).NORMAL_EARLY_ASSET_STRATEGY)
        }));
    const $cf8020dd6e5d22c9$export$6009dd8e88f1a7de = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("94QFg")).dashboardWallboardRoute), ()=>({
            component: $cf8020dd6e5d22c9$export$419b9eec5ed9880d,
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)({
                globalComponents: [
                    (0, (0, parcelRequire("Xtn30")).DashboardBackgroundScripts)
                ],
                isChromeless: true
            }),
            resources: [
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource),
                ...$cf8020dd6e5d22c9$var$dashboardResources
            ],
            forPaint: [
                $cf8020dd6e5d22c9$var$LazyDashboardWallboard
            ],
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
            },
            earlyAssets: (0, (0, parcelRequire("e2ctp")).NORMAL_EARLY_ASSET_STRATEGY)
        }));
    const $cf8020dd6e5d22c9$export$18226b6422149926 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("94QFg")).dashboardViewRoute), ()=>({
            component: $cf8020dd6e5d22c9$export$8d692f4ffba40a2,
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), (0, (0, parcelRequire("j6woB")).dashboardBackgroundScriptsLayout)),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).DASHBOARDS
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$cf8020dd6e5d22c9$var$dashboardResources
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $cf8020dd6e5d22c9$var$LazyDashboardView
            ],
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
            },
            earlyAssets: (0, (0, parcelRequire("e2ctp")).NORMAL_EARLY_ASSET_STRATEGY),
            ufoName: 'dashboard'
        }));
    const $cf8020dd6e5d22c9$export$73a377380ff671af = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("94QFg")).dashboardViewEmbedRoute), ()=>({
            component: $cf8020dd6e5d22c9$export$86d9f777f9d4e312,
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)({
                globalComponents: [
                    (0, (0, parcelRequire("Xtn30")).DashboardBackgroundScripts)
                ],
                isChromeless: true
            }),
            resources: [
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource),
                ...$cf8020dd6e5d22c9$var$dashboardResources
            ],
            forPaint: [
                $cf8020dd6e5d22c9$var$LazyDashboardViewEmbed
            ],
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$4695c1a423ffe431)
            },
            earlyAssets: (0, (0, parcelRequire("e2ctp")).NORMAL_EARLY_ASSET_STRATEGY)
        }));
    const $cf8020dd6e5d22c9$export$15f76f1b0d2d671 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("94QFg")).systemDashboardEditRoute), ()=>({
            component: $cf8020dd6e5d22c9$export$dcd19a888f8c85c,
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("ibkIl")).globalSettingsLayout), (0, (0, parcelRequire("j6woB")).dashboardBackgroundScriptsLayout)),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                ...$cf8020dd6e5d22c9$var$dashboardResources,
                (0, (0, parcelRequire("gh1hi")).gadgetDirectoryResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $cf8020dd6e5d22c9$export$c8d59d34c3e8f345
            ],
            earlyAssets: (0, (0, parcelRequire("e2ctp")).NORMAL_EARLY_ASSET_STRATEGY)
        }));
});
parcelRegister("j6woB", function(module, exports) {
    $parcel$export(module.exports, "dashboardBackgroundScriptsLayout", ()=>$90a067693c09e346$export$f0a12e66953aa38a);
    var $1XrjK;
    var $Xtn30;
    const $90a067693c09e346$export$f0a12e66953aa38a = (0, (0, parcelRequire("1XrjK")).createLayout)({
        globalComponents: [
            (0, (0, parcelRequire("Xtn30")).DashboardBackgroundScripts)
        ]
    });
});
parcelRegister("Xtn30", function(module, exports) {
    $parcel$export(module.exports, "DashboardBackgroundScripts", ()=>$79510dabdd765f30$export$4095842bb2e8d712);
    var $fZUl0;
    const $79510dabdd765f30$export$4095842bb2e8d712 = (0, (0, parcelRequire("fZUl0")).LazyAfterPaintBackgroundScripts);
    $79510dabdd765f30$export$4095842bb2e8d712.displayName = 'ConditionalDashboardBackgroundScripts';
});
parcelRegister("fZUl0", function(module, exports) {
    $parcel$export(module.exports, "LazyAfterPaintBackgroundScripts", ()=>$f2fce09c535c3a19$export$d4768112536c9dc9);
    var $hPtZI;
    const $f2fce09c535c3a19$export$d4768112536c9dc9 = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("8o619")), {
        ssr: false,
        moduleId: "./src/packages/global-pages/dashboard/background-scripts/src/ui/index.tsx"
    });
});
parcelRegister("8o619", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7t741").then(()=>parcelRequire('bjmK5'));
});
parcelRegister("gmpjq", function(module, exports) {
    $parcel$export(module.exports, "homepageLayout", ()=>$226ab3e64821f6b2$export$5b7fb151d60504c);
    var $iqZds;
    var $2BrOV;
    var $1XrjK;
    const $226ab3e64821f6b2$export$5b7fb151d60504c = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("2BrOV")).globalLayout), {
        globalComponents: [
            (0, (0, parcelRequire("iqZds")).AsyncTransitionHomeRenderer),
            (0, (0, parcelRequire("iqZds")).AsyncWelcomeModalRenderer)
        ]
    });
});
parcelRegister("iqZds", function(module, exports) {
    $parcel$export(module.exports, "AsyncTransitionHomeRenderer", ()=>$d1122e3218429f7d$export$cb38f5a820347580);
    $parcel$export(module.exports, "AsyncWelcomeModalRenderer", ()=>$d1122e3218429f7d$export$9cda67d6c86d7b98);
    $parcel$export(module.exports, "eocChangeboardingLayout", ()=>$d1122e3218429f7d$export$b8fa7ac7019001bb);
    var $co1wz;
    var $7XYc4;
    var $1XrjK;
    var $hPtZI;
    const $d1122e3218429f7d$export$cb38f5a820347580 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9'), (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("3d3Of")).then((module)=>module.TransitionHomeRenderer), {
        ssr: false,
        moduleId: "./src/packages/eoc/changeboarding/src/ui/transition-home/main.tsx"
    }), ()=>null);
    $d1122e3218429f7d$export$cb38f5a820347580.displayName = 'AsyncTransitionHomeRenderer';
    const $d1122e3218429f7d$export$9cda67d6c86d7b98 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9'), (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("9lbpO")).then((module)=>module.WelcomeModalRenderer), {
        ssr: false,
        moduleId: "./src/packages/eoc/changeboarding/src/ui/wizard/main.tsx"
    }), ()=>null);
    $d1122e3218429f7d$export$9cda67d6c86d7b98.displayName = 'AsyncWelcomeModalRenderer';
    const $d1122e3218429f7d$export$b8fa7ac7019001bb = (0, (0, parcelRequire("1XrjK")).createLayout)({
        get globalComponents () {
            return [
                $d1122e3218429f7d$export$cb38f5a820347580,
                $d1122e3218429f7d$export$9cda67d6c86d7b98
            ];
        }
    });
});
parcelRegister("3d3Of", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("b3iUB")
    ]).then(()=>parcelRequire('dsKht'));
});
parcelRegister("9lbpO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("9RY0k")
    ]).then(()=>parcelRequire('cKcai'));
});
parcelRegister("gh1hi", function(module, exports) {
    $parcel$export(module.exports, "dashboardConfigAndWRMResource", ()=>$ca62b878c99c7128$export$2853c0e656e89346);
    $parcel$export(module.exports, "useDashboardResource", ()=>$ca62b878c99c7128$export$e5e5b3f462d6a4cb);
    $parcel$export(module.exports, "useMultiDashboardsResource", ()=>$ca62b878c99c7128$export$6a46406b05d8d13c);
    $parcel$export(module.exports, "dashboardAMDModulesResource", ()=>$ca62b878c99c7128$export$ef3fa55626812fa4);
    $parcel$export(module.exports, "useDashboardAMDModulesResource", ()=>$ca62b878c99c7128$export$efe0eb9a44e08d38);
    $parcel$export(module.exports, "dashboardReactGadgetsResource", ()=>$ca62b878c99c7128$export$39804ce8cc42cd04);
    $parcel$export(module.exports, "useDashboardReactGadgetsResource", ()=>$ca62b878c99c7128$export$31b430e01a1caab5);
    $parcel$export(module.exports, "dashboardForgeResource", ()=>$ca62b878c99c7128$export$4e0719e53da01e93);
    $parcel$export(module.exports, "gadgetDirectoryResource", ()=>$ca62b878c99c7128$export$36c9632be21fbb06);
    $parcel$export(module.exports, "useGadgetDirectoryResource", ()=>$ca62b878c99c7128$export$27f4c12e781b4572);
    $parcel$export(module.exports, "useDashboardForgeResource", ()=>$ca62b878c99c7128$export$75ca1b431898fd09);
    var $4R6GH;
    var $k2DRb;
    var $iVaKa;
    var $5vSAE;
    var $dIdda = parcelRequire("dIdda");
    var $3Yd87;
    var $abozY;
    var $04Brv;
    var $3cb5I;
    var $aVFmC;
    var $3Zhqx;
    var $8oOn8;
    const $ca62b878c99c7128$export$2853c0e656e89346 = (0, $dIdda.createResource)({
        type: (0, $e03099b7bef7f4cd$export$ca03ff6cc792cc16),
        getKey: (0, parcelRequire("abozY")).getKey,
        getData: (0, (0, parcelRequire("3cb5I")).default),
        maxAge: Infinity
    });
    const $ca62b878c99c7128$var$extractFirstPromise = (promise)=>promise ? promise.then((configs)=>configs && configs[0]) : null;
    const $ca62b878c99c7128$export$e5e5b3f462d6a4cb = ()=>{
        const resourceResponse = $ca62b878c99c7128$export$6a46406b05d8d13c();
        const { loading: loading, error: error, data: data, promise: promiseOfMultiConfigs, ...rest } = resourceResponse;
        const extractFirstUpdate = (getNewData)=>resourceResponse.update(([a])=>[
                    getNewData(a)
                ]);
        if (loading) return {
            ...rest,
            error: null,
            data: null,
            promise: $ca62b878c99c7128$var$extractFirstPromise(promiseOfMultiConfigs),
            loading: true,
            update: extractFirstUpdate
        };
        if (error) return {
            ...rest,
            error: error,
            data: null,
            promise: $ca62b878c99c7128$var$extractFirstPromise(promiseOfMultiConfigs),
            loading: false,
            update: extractFirstUpdate
        };
        if (data && !error) return {
            ...rest,
            loading: false,
            update: extractFirstUpdate,
            data: data[0],
            error: null,
            promise: $ca62b878c99c7128$var$extractFirstPromise(promiseOfMultiConfigs)
        };
        return {
            ...rest,
            loading: false,
            error: error,
            data: null,
            promise: null,
            update: extractFirstUpdate
        };
    };
    const $ca62b878c99c7128$export$6a46406b05d8d13c = ()=>(0, $dIdda.useResource)($ca62b878c99c7128$export$2853c0e656e89346);
    const $ca62b878c99c7128$export$ef3fa55626812fa4 = (0, (0, parcelRequire("3Yd87")).createDependentResource)({
        type: (0, $e03099b7bef7f4cd$export$e239393fd4e2bc85),
        getKey: (0, parcelRequire("abozY")).getKey,
        depends: [
            (0, $e03099b7bef7f4cd$export$ca03ff6cc792cc16)
        ],
        mapToSharedValue: (0, (0, parcelRequire("3Yd87")).withEitherDataOrError)((data)=>{
            const { gadgets: gadgets, preloadedModuleNames: preloadedModuleNames } = data.reduce((prev, curr)=>({
                    gadgets: prev.gadgets.concat(curr.gadgets),
                    preloadedModuleNames: prev.preloadedModuleNames.concat(curr.preloadedModuleNames)
                }), {
                gadgets: [],
                preloadedModuleNames: []
            });
            const moduleNames = (0, (0, parcelRequire("8oOn8")).gadgetsToUniqueSortedAmdModules)(gadgets);
            const isPreloaded = moduleNames.every((name)=>preloadedModuleNames.includes(name));
            return {
                moduleNames: moduleNames,
                isPreloaded: isPreloaded
            };
        }, (x)=>x),
        shouldUpdate: ({ sharedValue: a, amdModules: amdModules }, b)=>(0, (0, parcelRequire("3Yd87")).withEitherDataOrError)((prev, next)=>next.moduleNames.length > prev.moduleNames.length || next.moduleNames.some((name)=>amdModules?.[name] == null), ()=>true)(a, b),
        getData: (0, (0, parcelRequire("04Brv")).default),
        maxAge: Infinity,
        isBrowserOnly: true
    });
    const $ca62b878c99c7128$export$efe0eb9a44e08d38 = ()=>(0, $dIdda.useResource)($ca62b878c99c7128$export$ef3fa55626812fa4);
    const $ca62b878c99c7128$export$39804ce8cc42cd04 = (0, (0, parcelRequire("3Yd87")).createDependentResource)({
        type: (0, $e03099b7bef7f4cd$export$9e5db01432b13b67),
        getKey: (0, parcelRequire("abozY")).getKey,
        depends: [
            (0, $e03099b7bef7f4cd$export$ca03ff6cc792cc16)
        ],
        mapToSharedValue: (0, (0, parcelRequire("3Yd87")).withEitherDataOrError)((data)=>{
            const gadgets = data.flatMap((dashboard)=>dashboard.gadgets);
            return {
                reactGadgets: (0, (0, parcelRequire("8oOn8")).gadgetsToSortedReactGadgets)(gadgets)
            };
        }, (x)=>x),
        shouldUpdate: ({ sharedValue: a, reactGadgetsState: reactGadgetsState }, b)=>(0, (0, parcelRequire("3Yd87")).withEitherDataOrError)((prev, next)=>JSON.stringify(next.reactGadgets) !== JSON.stringify(prev.reactGadgets) || reactGadgetsState != null && Object.values(reactGadgetsState).some((v)=>!v), ()=>true)(a, b),
        getData: (0, (0, parcelRequire("3Zhqx")).default),
        maxAge: Infinity,
        isBrowserOnly: true
    });
    const $ca62b878c99c7128$export$31b430e01a1caab5 = ()=>(0, $dIdda.useResource)($ca62b878c99c7128$export$39804ce8cc42cd04);
    const $ca62b878c99c7128$export$4e0719e53da01e93 = (0, $dIdda.createResource)({
        type: (0, $e03099b7bef7f4cd$export$bce41807cc929d0f),
        getKey: (0, parcelRequire("abozY")).getKey,
        getData: async (_, { tenantContext: { cloudId: cloudId, activationId: activationId, locale: locale } })=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')) {
                const modules = await (0, (0, parcelRequire("5vSAE")).fetchModules)({
                    cloudId: cloudId,
                    types: [
                        (0, (0, parcelRequire("k2DRb")).DASHBOARD_GADGET_MODULE),
                        (0, (0, parcelRequire("k2DRb")).DASHBOARD_BACKGROUND_SCRIPT_MODULE)
                    ],
                    context: {},
                    includeHidden: false,
                    source: (0, (0, parcelRequire("k2DRb")).SOURCE_ROUTER)
                });
                return {
                    gadgets: modules[0, (0, parcelRequire("k2DRb")).DASHBOARD_GADGET_MODULE],
                    backgroundScripts: modules[0, (0, parcelRequire("k2DRb")).DASHBOARD_BACKGROUND_SCRIPT_MODULE]
                };
            }
            const contextIds = [
                `ari:cloud:jira:${cloudId}:workspace/${activationId}`
            ];
            const { extensions: extensions } = await (0, (0, parcelRequire("iVaKa")).default)(cloudId, [
                (0, (0, parcelRequire("k2DRb")).DASHBOARD_GADGET_MODULE),
                (0, (0, parcelRequire("k2DRb")).DASHBOARD_BACKGROUND_SCRIPT_MODULE)
            ], null, undefined, (0, (0, parcelRequire("k2DRb")).SOURCE_ROUTER), contextIds, locale);
            return {
                gadgets: extensions.jiraDashboardGadget,
                backgroundScripts: extensions.jiraDashboardBackgroundScript
            };
        },
        maxAge: Infinity
    });
    const $ca62b878c99c7128$export$36c9632be21fbb06 = (0, $dIdda.createResource)({
        type: (0, $e03099b7bef7f4cd$export$c07a25ebb6af1e84),
        getKey: ()=>'gadgetDirectoryItems',
        getData: (0, (0, parcelRequire("aVFmC")).default),
        maxAge: Infinity,
        isBrowserOnly: true
    });
    const $ca62b878c99c7128$export$27f4c12e781b4572 = ()=>(0, $dIdda.useResource)($ca62b878c99c7128$export$36c9632be21fbb06);
    const $ca62b878c99c7128$export$75ca1b431898fd09 = ()=>(0, $dIdda.useResource)($ca62b878c99c7128$export$4e0719e53da01e93);
});
parcelRegister("3Yd87", function(module, exports) {
    $parcel$export(module.exports, "withEitherDataOrError", ()=>$3e606a4e02c14aae$export$54e973088fdd59a1);
    $parcel$export(module.exports, "createDependentResource", ()=>$3e606a4e02c14aae$export$7f8dd41bdfd85a47);
    $parcel$export(module.exports, "SharedValueAggregateError", ()=>$3e606a4e02c14aae$export$36d5102d613df7c6);
    var $dIdda = parcelRequire("dIdda");
    const $3e606a4e02c14aae$export$54e973088fdd59a1 = (dataFn, errorFn)=>(...args)=>{
            const invalidArgs = args.filter((v)=>v == null || v instanceof Error);
            return invalidArgs.length ? errorFn(invalidArgs[0]) : dataFn(...args);
        };
    const $3e606a4e02c14aae$export$fcdc85dfc621ec7a = (dependencies, type)=>{
        const { [type]: resourceSlice } = dependencies;
        if (!resourceSlice) throw new (0, $dIdda.ResourceDependencyError)(`Cannot decode dependency "${type}", it may be missing from resource depends field`);
        return resourceSlice.data;
    };
    const $3e606a4e02c14aae$export$bee6a631bfb54474 = (dependencies, type)=>{
        const { [type]: resourceSlice } = dependencies;
        if (!resourceSlice) throw new Error(`Cannot decode dependency: "${type}" must be included in the resource depends field`);
        const { loading: loading, data: data, promise: promise, error: error } = resourceSlice;
        return loading && promise ? promise.then((v)=>v, (e)=>data ?? e) : data ?? error;
    };
    const $3e606a4e02c14aae$export$7f8dd41bdfd85a47 = ({ type: type, depends: depends, mapToSharedValue: mapToSharedValue, shouldUpdate: shouldUpdate, getData: getData, ...rest })=>(0, $dIdda.createResource)({
            ...rest,
            type: type,
            depends: [
                ...depends,
                type
            ],
            getData: (dataContext, storeContext)=>{
                const { dependencies: dependencies } = dataContext;
                const prevValue = $3e606a4e02c14aae$export$fcdc85dfc621ec7a(dependencies, type);
                const valuesOrPromises = depends.map((d)=>$3e606a4e02c14aae$export$bee6a631bfb54474(dependencies, d));
                const implementation = (depDataOrErrorOrNull)=>{
                    const newShared = mapToSharedValue(...depDataOrErrorOrNull);
                    return prevValue == null || prevValue instanceof Error || shouldUpdate(prevValue, newShared) ? getData(prevValue, newShared)(dataContext, storeContext) : prevValue;
                };
                return valuesOrPromises.some((v)=>v instanceof Promise) ? Promise.allSettled(valuesOrPromises).then((arr)=>arr.map((v)=>v.status === 'fulfilled' ? v.value : v.reason)).then(implementation) : implementation(valuesOrPromises);
            }
        });
    class $3e606a4e02c14aae$export$36d5102d613df7c6 extends Error {
        constructor({ name: name, isPrefetch: isPrefetch, sharedValue: sharedValue }){
            super(`${name} is missing dependency, prefetch [${isPrefetch}] sharedValue [${sharedValue}]`);
            this.skipSentry = true;
        }
    }
});
parcelRegister("abozY", function(module, exports) {
    $parcel$export(module.exports, "getKey", ()=>$707c98c2b1b4b40d$export$a47fb462a08de82f);
    var $65Ltd;
    var $JIPqS;
    const $707c98c2b1b4b40d$export$a47fb462a08de82f = ({ route: route, query: query, match: { params: params } })=>{
        if (route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT)) return 0, (0, parcelRequire("JIPqS")).SYSTEM_DASHBOARD_ID;
        if (route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_WALLBOARD)) return query.dashboardId?.split(',')[0];
        return params.dashboardId?.replace('last-visited', 'lastVisited') ?? query.selectPageId ?? 'lastVisited';
    };
});
parcelRegister("JIPqS", function(module, exports) {
    $parcel$export(module.exports, "GADGET_DISPLAY", ()=>$6c7fd970bbaee123$export$d7e1dfcefcde2410);
    $parcel$export(module.exports, "MAXIMIZED_PARAM", ()=>$6c7fd970bbaee123$export$86eaa19ea940a4f5);
    $parcel$export(module.exports, "CONNECT_ITEM_AMD_MODULE", ()=>$6c7fd970bbaee123$export$a1baea8b97610fd);
    $parcel$export(module.exports, "WEB_RESOURCE_MAP", ()=>$6c7fd970bbaee123$export$c6d360a8456d120a);
    $parcel$export(module.exports, "PRELOADED_GADGET_DATA_KEY", ()=>$6c7fd970bbaee123$export$30b970d16c2f5e0a);
    $parcel$export(module.exports, "SYSTEM_DASHBOARD_ID", ()=>$6c7fd970bbaee123$export$50eac80bcbebc737);
    $parcel$export(module.exports, "DASHBOARD_HEADER_HEIGHT", ()=>$6c7fd970bbaee123$export$e11ffd0409aa6522);
    $parcel$export(module.exports, "FOOTER_MARGIN", ()=>$6c7fd970bbaee123$export$4d708f4c16ae3a73);
    $parcel$export(module.exports, "GADGET_LOCAL_STORAGE_NAME", ()=>$6c7fd970bbaee123$export$255117c9adec50a5);
    $parcel$export(module.exports, "DASHBOARD_LOCAL_STORAGE_KEY_NAME", ()=>$6c7fd970bbaee123$export$e281465c09f561d4);
    $parcel$export(module.exports, "GADGET_DEFAULT_HEIGHT", ()=>$6c7fd970bbaee123$export$46dd0168a7875b47);
    $parcel$export(module.exports, "COLOR_MAP", ()=>$6c7fd970bbaee123$export$1468aefba37090f9);
    $parcel$export(module.exports, "COLOR_NAME_MAP", ()=>$6c7fd970bbaee123$export$5d9e688e192a63ae);
    $parcel$export(module.exports, "COLOR_CHECKMARK_MAP", ()=>$6c7fd970bbaee123$export$6906a4beef307ac4);
    $parcel$export(module.exports, "MODAL_ID", ()=>$6c7fd970bbaee123$export$ebdd5a8e5b1c2de5);
    $parcel$export(module.exports, "LAYOUTS", ()=>$6c7fd970bbaee123$export$87e50aced9c52ebb);
    $parcel$export(module.exports, "GADGET_HEIGHT_UPDATE_WAIT_TIME", ()=>$6c7fd970bbaee123$export$b0234a47b1a4a515);
    $parcel$export(module.exports, "GADGET_DRAG_CONTAINER_HEIGHT", ()=>$6c7fd970bbaee123$export$9674cd14c20d1c89);
    $parcel$export(module.exports, "GADGET_METRICS_TYPE", ()=>$6c7fd970bbaee123$export$46b6c8eb53069613);
    $parcel$export(module.exports, "PAGE_READY_METRIC_KEY", ()=>$6c7fd970bbaee123$export$464d2a6bcb398791);
    $parcel$export(module.exports, "DELETE_DASHBOARD_EXPERIENCE", ()=>$6c7fd970bbaee123$export$4f74f1f13671c49d);
    $parcel$export(module.exports, "COPY_DASHBOARD_EXPERIENCE", ()=>$6c7fd970bbaee123$export$3853fce65645c557);
    $parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH_EXPERIENCE", ()=>$6c7fd970bbaee123$export$c8c77659771c38b9);
    $parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD_EXPERIENCE", ()=>$6c7fd970bbaee123$export$707702c47e5b9648);
    $parcel$export(module.exports, "CREATE_DASHBOARD_EXPERIENCE", ()=>$6c7fd970bbaee123$export$efbab4efa7252143);
    $parcel$export(module.exports, "VIEW_DASHBOARD_EDITABLE_EXPERIENCE", ()=>$6c7fd970bbaee123$export$7b6f3ec1189de156);
    $parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EXPERIENCE", ()=>$6c7fd970bbaee123$export$f0e105144716a420);
    $parcel$export(module.exports, "VIEW_DASHBOARD_READONLY_EMBED_EXPERIENCE", ()=>$6c7fd970bbaee123$export$5ba84cd082269cd5);
    $parcel$export(module.exports, "VIEW_DASHBOARD_WALLBOARD_READONLY_EXPERIENCE", ()=>$6c7fd970bbaee123$export$6c84c6099fed3c23);
    $parcel$export(module.exports, "ADD_GADGET_EXPERIENCE", ()=>$6c7fd970bbaee123$export$3b17b4f7f722b1ae);
    $parcel$export(module.exports, "SAVE_AMD_GADGET_CONFIG_PREFERENCES", ()=>$6c7fd970bbaee123$export$c8900d7e874d42ca);
    $parcel$export(module.exports, "SAVE_FORGE_GADGET_CONFIG_PREFERENCES", ()=>$6c7fd970bbaee123$export$bac5a3e9d008da59);
    $parcel$export(module.exports, "SAVE_CUSTOM_GADGET_TITLE_PREFERENCES", ()=>$6c7fd970bbaee123$export$18b54b2c53cf6acd);
    $parcel$export(module.exports, "VIEW_WRM_GADGET_EXPERIENCE", ()=>$6c7fd970bbaee123$export$a3d5b76ea0c8f4ca);
    $parcel$export(module.exports, "CHANGE_LAYOUT_EXPERIENCE", ()=>$6c7fd970bbaee123$export$7254246f25b4cbc8);
    $parcel$export(module.exports, "DELETE_GADGET_EXPERIENCE", ()=>$6c7fd970bbaee123$export$40c4d345e57fce2d);
    $parcel$export(module.exports, "VIEW_REACT_GADGET_EXPERIENCE", ()=>$6c7fd970bbaee123$export$43fb10a4d8374f1a);
    $parcel$export(module.exports, "DASHBOARD_VIEW_SOURCENAME", ()=>$6c7fd970bbaee123$export$2f961c74af6d8735);
    $parcel$export(module.exports, "DASHBOARD_VIEW_EMBED_SOURCENAME", ()=>$6c7fd970bbaee123$export$dab1096b356df1cc);
    $parcel$export(module.exports, "DASHBOARD_EDIT_SOURCENAME", ()=>$6c7fd970bbaee123$export$32f0edca4eebb9c7);
    $parcel$export(module.exports, "DASHBOARD_WALLBOARD_VIEW_SOURCENAME", ()=>$6c7fd970bbaee123$export$791f7067c41dc5b1);
    $parcel$export(module.exports, "SYSTEM_DASHBOARD_EDIT_SOURCENAME", ()=>$6c7fd970bbaee123$export$eba1a497984af3ae);
    $parcel$export(module.exports, "COPY_DASHBOARD", ()=>$6c7fd970bbaee123$export$3578044b625436f9);
    $parcel$export(module.exports, "DASHBOARD_AUTOMATIC_REFRESH", ()=>$6c7fd970bbaee123$export$48bb59a846d62ea0);
    $parcel$export(module.exports, "DELETE_DASHBOARD", ()=>$6c7fd970bbaee123$export$e7dfbcf33cf2b19a);
    $parcel$export(module.exports, "DUPLICATE_GADGET_EXPERIENCE", ()=>$6c7fd970bbaee123$export$fabf79b25b44377f);
    $parcel$export(module.exports, "RENAME_OR_SHARE_DASHBOARD", ()=>$6c7fd970bbaee123$export$abba919f32a1a776);
    $parcel$export(module.exports, "GADGET_ERROR_TYPE", ()=>$6c7fd970bbaee123$export$768dad6811159849);
    $parcel$export(module.exports, "DASHBOARD_REFRESH_LOAD_BUFFER_MS", ()=>$6c7fd970bbaee123$export$ada294d471e7dfc3);
    $parcel$export(module.exports, "REFRESH_LABEL_UPDATE_INTERVAL", ()=>$6c7fd970bbaee123$export$f4280aaeba4d1d08);
    $parcel$export(module.exports, "CONNECT_GADGET_REFRESH_REQUEST_EVENT", ()=>$6c7fd970bbaee123$export$685171fdf5112bc4);
    $parcel$export(module.exports, "FORGE_JIRA_DASHBOARD_GADGET_REFRESH_EVENT", ()=>$6c7fd970bbaee123$export$4d8c12b9aaeac619);
    $parcel$export(module.exports, "ISSUE_SEARCH_DEFAULT_COLUMNS", ()=>$6c7fd970bbaee123$export$f07dac7b8de3bda);
    $parcel$export(module.exports, "DEPRECATED_GADGETS_MAP", ()=>$6c7fd970bbaee123$export$4ac59ce79d9e7591);
    $parcel$export(module.exports, "DEPRECATION_BANNER_V1", ()=>$6c7fd970bbaee123$export$b5d0f99a1924c478);
    var $gwIPs;
    var $cKw8Y;
    const $6c7fd970bbaee123$export$d7e1dfcefcde2410 = {
        MAXIMIZED: 'maximized',
        NORMAL: 'normal',
        HIDDEN: 'hidden'
    };
    const $6c7fd970bbaee123$export$86eaa19ea940a4f5 = 'maximized';
    const $6c7fd970bbaee123$export$a1baea8b97610fd = 'atlassian-connect/connect-dashboard-item';
    const $6c7fd970bbaee123$export$c6d360a8456d120a = {
        'jira-dashboard-items/assigned-to-me': 'com.atlassian.jira.gadgets:assigned-to-me-dashboard-item-resources',
        'jira-dashboard-items/filter-results': 'com.atlassian.jira.gadgets:filter-results-dashboard-item-resources',
        'jira-dashboard-items/createdvsresolved': 'com.atlassian.jira.gadgets:createdvsresolved-dashboard-item-resources',
        'jira-dashboard-items/favourite-filters': 'com.atlassian.jira.gadgets:favourite-filters-dashboard-item-resources',
        'jira-dashboard-items/in-progress': 'com.atlassian.jira.gadgets:in-progress-dashboard-item-resources',
        'jira-dashboard-items/stats': 'com.atlassian.jira.gadgets:stats-dashboard-item-resources',
        'jira-dashboard-items/watched': 'com.atlassian.jira.gadgets:watched-dashboard-item-resources',
        'jira-dashboard-items/labels': 'com.atlassian.jira.gadgets:labels-dashboard-item-resources',
        'jira-dashboard-items/bubble-chart-dashboard-item': 'com.atlassian.jira.gadgets:bubble-chart-dashboard-item-resources',
        'jira-dashboard-items/piechart': 'com.atlassian.jira.gadgets:piechart-dashboard-item-resources',
        'jira-dashboard-items/voted': 'com.atlassian.jira.gadgets:voted-dashboard-item-resources',
        'jira-dashboard-items/two-dimensional-stats': 'com.atlassian.jira.gadgets:two-dimensional-stats-dashboard-item-resources',
        'jira-dashboard-items/sprint-health': 'com.pyxis.greenhopper.jira:greenhopper-sprint-health-dashboard-item-resources',
        'jira-dashboard-items/sprint-days-remaining': 'com.pyxis.greenhopper.jira:greenhopper-days-remaining-dashboard-item-resources',
        'servicedesk/internal/dashboard-items/filter/filter-dashboard-item': 'com.atlassian.servicedesk.dashboard-items-plugin:spa-filter-dashboard-item-resources',
        'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'com.atlassian.servicedesk.servicedesk-reports-plugin:custom-report-dashboard-item-resources-spa',
        'jira-dashboard-items/projects': 'com.atlassian.jira.gadgets:projects-dashboard-item-resources',
        'jira-dashboard-items/issuescalendar': 'com.atlassian.jira.ext.calendar:issues-calendar-dashboard-item-resources',
        'jira-dashboard-items/activitystream': 'com.atlassian.streams.streams-jira-plugin:activitystream-dashboard-item-resources',
        'jira-dashboard-items/recently-created': 'com.atlassian.jira.gadgets:recently-created-chart-dashboard-item-resources',
        'jira-dashboard-items/resolution-time': 'com.atlassian.jira.gadgets:resolution-time-dashboard-item-resources',
        'jira-dashboard-items/timesince': 'com.atlassian.jira.gadgets:timesince-dashboard-item-resources',
        'jira-dashboard-items/spacer': 'com.atlassian.jira.gadgets:spacer-dashboard-item-resources',
        'jira-dashboard-items/sprint-burndown': 'com.pyxis.greenhopper.jira:greenhopper-sprint-burndown-dashboard-item-resources',
        'jira-dashboard-items/workload-pie-chart': 'com.atlassian.jira.gadgets:workload-pie-chart-dashboard-item-resources',
        'jira-dashboard-items/roadmap': 'com.atlassian.jira.gadgets:roadmap-dashboard-item-resources',
        'jira-dashboard-items/average-age-chart': 'com.atlassian.jira.gadgets:average-age-chart-dashboard-item-resources',
        'jira-dashboard-items/average-time-in-status-chart': 'com.atlassian.jira.gadgets:average-time-in-status-chart-dashboard-item-resources',
        'jira-dashboard-items/average-number-of-times-in-status-chart': 'com.atlassian.jira.gadgets:average-number-of-times-in-status-chart-dashboard-item-resources',
        'jira-dashboard-items/heat-map': 'com.atlassian.jira.gadgets:heat-map-dashboard-item-resources',
        'jira-dashboard-items/time-to-first-response': 'com.atlassian.jira.gadgets:time-to-first-response-dashboard-item-resources',
        'jira-dashboard-items/rapid-view': 'com.pyxis.greenhopper.jira:greenhopper-rapid-view-dashboard-item-resources',
        'jira-dashboard-items/version-report': 'com.pyxis.greenhopper.jira:greenhopper-version-report-dashboard-item-resources'
    };
    const $6c7fd970bbaee123$export$30b970d16c2f5e0a = 'DASHBOARD_GADGET_PRELOADED_DATA';
    const $6c7fd970bbaee123$export$50eac80bcbebc737 = '10000';
    const $6c7fd970bbaee123$export$e11ffd0409aa6522 = (0, (0, parcelRequire("gwIPs")).gridSize) * 10;
    const $6c7fd970bbaee123$export$4d708f4c16ae3a73 = (0, (0, parcelRequire("gwIPs")).gridSize) * 2;
    const $6c7fd970bbaee123$export$504bf5c8f7d402e9 = (0, (0, parcelRequire("gwIPs")).gridSize) * 3;
    const $6c7fd970bbaee123$export$255117c9adec50a5 = 'AG.congolmerate.cookie';
    const $6c7fd970bbaee123$export$e281465c09f561d4 = 'dashboard-data';
    const $6c7fd970bbaee123$export$46dd0168a7875b47 = 160;
    const $6c7fd970bbaee123$var$COLOR_BLUE = '#2684ff';
    const $6c7fd970bbaee123$var$COLOR_RED = '#ff5630';
    const $6c7fd970bbaee123$var$COLOR_YELLOW = '#ffab00';
    const $6c7fd970bbaee123$var$COLOR_GREEN = '#36b37e';
    const $6c7fd970bbaee123$var$COLOR_TEAL = '#00b8d9';
    const $6c7fd970bbaee123$var$COLOR_PURPLE = '#6554c0';
    const $6c7fd970bbaee123$var$COLOR_GRAY = '#97a0af';
    const $6c7fd970bbaee123$var$COLOR_WHITE = '#ffffff';
    const $6c7fd970bbaee123$export$1468aefba37090f9 = {
        color1: $6c7fd970bbaee123$var$COLOR_BLUE,
        color2: $6c7fd970bbaee123$var$COLOR_RED,
        color3: $6c7fd970bbaee123$var$COLOR_YELLOW,
        color4: $6c7fd970bbaee123$var$COLOR_GREEN,
        color5: $6c7fd970bbaee123$var$COLOR_TEAL,
        color6: $6c7fd970bbaee123$var$COLOR_PURPLE,
        color7: $6c7fd970bbaee123$var$COLOR_GRAY,
        color8: $6c7fd970bbaee123$var$COLOR_WHITE
    };
    const $6c7fd970bbaee123$export$5d9e688e192a63ae = {
        [$6c7fd970bbaee123$var$COLOR_BLUE]: (0, (0, parcelRequire("cKw8Y")).default).blue,
        [$6c7fd970bbaee123$var$COLOR_RED]: (0, (0, parcelRequire("cKw8Y")).default).red,
        [$6c7fd970bbaee123$var$COLOR_YELLOW]: (0, (0, parcelRequire("cKw8Y")).default).yellow,
        [$6c7fd970bbaee123$var$COLOR_GREEN]: (0, (0, parcelRequire("cKw8Y")).default).green,
        [$6c7fd970bbaee123$var$COLOR_TEAL]: (0, (0, parcelRequire("cKw8Y")).default).teal,
        [$6c7fd970bbaee123$var$COLOR_PURPLE]: (0, (0, parcelRequire("cKw8Y")).default).purple,
        [$6c7fd970bbaee123$var$COLOR_GRAY]: (0, (0, parcelRequire("cKw8Y")).default).gray,
        [$6c7fd970bbaee123$var$COLOR_WHITE]: (0, (0, parcelRequire("cKw8Y")).default).white
    };
    const $6c7fd970bbaee123$export$6906a4beef307ac4 = {
        color1: (0, $5e0c0d4e15efb4a6$exports).N10,
        color2: (0, $5e0c0d4e15efb4a6$exports).N10,
        color3: (0, $5e0c0d4e15efb4a6$exports).N500,
        color4: (0, $5e0c0d4e15efb4a6$exports).N10,
        color5: (0, $5e0c0d4e15efb4a6$exports).N500,
        color6: (0, $5e0c0d4e15efb4a6$exports).N10,
        color7: (0, $5e0c0d4e15efb4a6$exports).N10,
        color8: (0, $5e0c0d4e15efb4a6$exports).N500
    };
    const $6c7fd970bbaee123$export$ebdd5a8e5b1c2de5 = {
        EDIT_LAYOUT: 'edit-layout',
        DASHBOARD_COPY: 'dashboard-copy',
        AUTOMATIC_REFRESH: 'dashboard-automatic-refresh',
        DASHBOARD_RENAME_OR_SHARE: 'dashboard-rename-or-share',
        DASHBOARD_DELETE: 'dashboard-delete',
        CONFIGURE_WALLBOARD: 'configure-wallboard',
        DASHBOARD_CREATE: 'dashboard-create-on-dashboard-page'
    };
    const $6c7fd970bbaee123$export$87e50aced9c52ebb = [
        'A',
        'AA',
        'AAA',
        'BA',
        'AB'
    ];
    const $6c7fd970bbaee123$export$b0234a47b1a4a515 = 350;
    const $6c7fd970bbaee123$export$9674cd14c20d1c89 = 250;
    const $6c7fd970bbaee123$export$46b6c8eb53069613 = {
        REPORT: 'REPORT_GADGET_METRICS',
        TIMEOUT: 'TIMEOUT_GADGET_METRICS'
    };
    const $6c7fd970bbaee123$export$464d2a6bcb398791 = 'JIRA_SPA_PAGE_READY';
    const $6c7fd970bbaee123$export$4f74f1f13671c49d = 'delete-dashboard';
    const $6c7fd970bbaee123$export$3853fce65645c557 = 'copy-dashboard';
    const $6c7fd970bbaee123$export$c8c77659771c38b9 = 'dashboard-automatic-refresh';
    const $6c7fd970bbaee123$export$707702c47e5b9648 = 'rename-or-share-dashboard';
    const $6c7fd970bbaee123$export$efbab4efa7252143 = 'create-dashboard';
    const $6c7fd970bbaee123$export$7b6f3ec1189de156 = 'view-dashboard-editable';
    const $6c7fd970bbaee123$export$f0e105144716a420 = 'view-dashboard-readonly';
    const $6c7fd970bbaee123$export$5ba84cd082269cd5 = 'view-dashboard-readonly-embed';
    const $6c7fd970bbaee123$export$6c84c6099fed3c23 = 'view-dashboard-wallboard-readonly';
    const $6c7fd970bbaee123$export$3b17b4f7f722b1ae = 'add-gadget';
    const $6c7fd970bbaee123$export$c8900d7e874d42ca = 'save-amd-gadget-config';
    const $6c7fd970bbaee123$export$bac5a3e9d008da59 = 'save-forge-gadget-config';
    const $6c7fd970bbaee123$export$18b54b2c53cf6acd = 'save-custom-gadget-title-config';
    const $6c7fd970bbaee123$export$a3d5b76ea0c8f4ca = 'view-wrm-gadget';
    const $6c7fd970bbaee123$export$7254246f25b4cbc8 = 'change-layout';
    const $6c7fd970bbaee123$export$40c4d345e57fce2d = 'delete-gadget';
    const $6c7fd970bbaee123$export$43fb10a4d8374f1a = 'view-react-gadget';
    const $6c7fd970bbaee123$export$2f961c74af6d8735 = 'dashboardView';
    const $6c7fd970bbaee123$export$dab1096b356df1cc = 'dashboardViewEmbed';
    const $6c7fd970bbaee123$export$32f0edca4eebb9c7 = 'dashboardEdit';
    const $6c7fd970bbaee123$export$791f7067c41dc5b1 = 'dashboardWallboardView';
    const $6c7fd970bbaee123$export$eba1a497984af3ae = 'systemDashboardEdit';
    const $6c7fd970bbaee123$export$3578044b625436f9 = 'copyDashboard';
    const $6c7fd970bbaee123$export$48bb59a846d62ea0 = 'automaticRefresh';
    const $6c7fd970bbaee123$export$e7dfbcf33cf2b19a = 'deleteDashboard';
    const $6c7fd970bbaee123$export$fabf79b25b44377f = 'duplicateGadget';
    const $6c7fd970bbaee123$export$abba919f32a1a776 = 'renameOrShareDashboard';
    const $6c7fd970bbaee123$export$768dad6811159849 = {
        VIEW_ERROR: 'viewError',
        EDIT_ERROR: 'editError',
        CONFIG_ERROR: 'configError',
        NOT_SUPPORTED_ERROR: 'notSupportedError'
    };
    const $6c7fd970bbaee123$export$f8e04d62c0b5d07e = /^endeavour\.(spa|dashboard|gadget)\.[\w-]+$/;
    const $6c7fd970bbaee123$export$ada294d471e7dfc3 = 1000;
    const $6c7fd970bbaee123$export$f4280aaeba4d1d08 = 30000;
    const $6c7fd970bbaee123$export$685171fdf5112bc4 = 'jira_dashboard_item_refresh';
    const $6c7fd970bbaee123$export$4d8c12b9aaeac619 = 'JIRA_DASHBOARD_GADGET_REFRESH';
    const $6c7fd970bbaee123$export$f07dac7b8de3bda = [
        'issuetype',
        'issuekey',
        'summary',
        'priority'
    ];
    const $6c7fd970bbaee123$export$4ac59ce79d9e7591 = {
        'jira-dashboard-items/bubble-chart-dashboard-item': 'com.atlassian.jira.gadgets:bubble-chart-dashboard-item',
        'jira-dashboard-items/heat-map': 'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:heat-map-gadget/gadgets/heatmap-gadget.xml',
        'jira-dashboard-items/projects': 'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:project-gadget/gadgets/project-gadget.xml',
        'jira-dashboard-items/labels': 'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:labels-gadget/gadgets/labels-gadget.xml',
        'jira-dashboard-items/roadmap': 'rest/gadgets/1.0/g/com.atlassian.jira.gadgets:road-map-gadget/gadgets/roadmap-gadget.xml'
    };
    const $6c7fd970bbaee123$export$b5d0f99a1924c478 = 'deprecatedGadgetBannerDismissedV1';
});
var $5e0c0d4e15efb4a6$exports = {};
$parcel$export($5e0c0d4e15efb4a6$exports, "R50", ()=>$5e0c0d4e15efb4a6$export$4b84fd0e2c617bd);
$parcel$export($5e0c0d4e15efb4a6$exports, "R75", ()=>$5e0c0d4e15efb4a6$export$b34b069eff244586);
$parcel$export($5e0c0d4e15efb4a6$exports, "R100", ()=>$5e0c0d4e15efb4a6$export$be802dd0d8b57f35);
$parcel$export($5e0c0d4e15efb4a6$exports, "R200", ()=>$5e0c0d4e15efb4a6$export$60847d42f9da92a6);
$parcel$export($5e0c0d4e15efb4a6$exports, "R300", ()=>$5e0c0d4e15efb4a6$export$4a7404f376229999);
$parcel$export($5e0c0d4e15efb4a6$exports, "R400", ()=>$5e0c0d4e15efb4a6$export$2010d0fb4295b346);
$parcel$export($5e0c0d4e15efb4a6$exports, "R500", ()=>$5e0c0d4e15efb4a6$export$2837b5a1a71d5c02);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y50", ()=>$5e0c0d4e15efb4a6$export$8d9596b529bbb9cf);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y75", ()=>$5e0c0d4e15efb4a6$export$41060a744ab0b7ae);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y100", ()=>$5e0c0d4e15efb4a6$export$1cc05bbbf340e559);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y200", ()=>$5e0c0d4e15efb4a6$export$5aae31392d72caaa);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y300", ()=>$5e0c0d4e15efb4a6$export$c6930421db9fa514);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y400", ()=>$5e0c0d4e15efb4a6$export$59619663aa6500fb);
$parcel$export($5e0c0d4e15efb4a6$exports, "Y500", ()=>$5e0c0d4e15efb4a6$export$874739ea9e379ab6);
$parcel$export($5e0c0d4e15efb4a6$exports, "G50", ()=>$5e0c0d4e15efb4a6$export$8a6341c32b6a3ee6);
$parcel$export($5e0c0d4e15efb4a6$exports, "G75", ()=>$5e0c0d4e15efb4a6$export$69a3bf21b9686c2b);
$parcel$export($5e0c0d4e15efb4a6$exports, "G100", ()=>$5e0c0d4e15efb4a6$export$afbce1382ec95f73);
$parcel$export($5e0c0d4e15efb4a6$exports, "G200", ()=>$5e0c0d4e15efb4a6$export$747d86715d4175de);
$parcel$export($5e0c0d4e15efb4a6$exports, "G300", ()=>$5e0c0d4e15efb4a6$export$940e1f69e873f202);
$parcel$export($5e0c0d4e15efb4a6$exports, "G400", ()=>$5e0c0d4e15efb4a6$export$a49394138f7b8e85);
$parcel$export($5e0c0d4e15efb4a6$exports, "G500", ()=>$5e0c0d4e15efb4a6$export$6fa04827ac68a4fb);
$parcel$export($5e0c0d4e15efb4a6$exports, "B50", ()=>$5e0c0d4e15efb4a6$export$226de0355ed012f8);
$parcel$export($5e0c0d4e15efb4a6$exports, "B75", ()=>$5e0c0d4e15efb4a6$export$8c13c2ee36917869);
$parcel$export($5e0c0d4e15efb4a6$exports, "B100", ()=>$5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a);
$parcel$export($5e0c0d4e15efb4a6$exports, "B200", ()=>$5e0c0d4e15efb4a6$export$215b7063051591f1);
$parcel$export($5e0c0d4e15efb4a6$exports, "B300", ()=>$5e0c0d4e15efb4a6$export$e62e8919cca44969);
$parcel$export($5e0c0d4e15efb4a6$exports, "B400", ()=>$5e0c0d4e15efb4a6$export$b3de0ae08da2ce64);
$parcel$export($5e0c0d4e15efb4a6$exports, "B500", ()=>$5e0c0d4e15efb4a6$export$a6ee3d71bc067634);
$parcel$export($5e0c0d4e15efb4a6$exports, "B600", ()=>$5e0c0d4e15efb4a6$export$67f15409e87642a1);
$parcel$export($5e0c0d4e15efb4a6$exports, "B700", ()=>$5e0c0d4e15efb4a6$export$f0539dbc42dbb067);
$parcel$export($5e0c0d4e15efb4a6$exports, "P50", ()=>$5e0c0d4e15efb4a6$export$363e4475840015bb);
$parcel$export($5e0c0d4e15efb4a6$exports, "P75", ()=>$5e0c0d4e15efb4a6$export$4b0a4417ed59760f);
$parcel$export($5e0c0d4e15efb4a6$exports, "P100", ()=>$5e0c0d4e15efb4a6$export$6011520a64d9a187);
$parcel$export($5e0c0d4e15efb4a6$exports, "P200", ()=>$5e0c0d4e15efb4a6$export$a7175d4e9206bc80);
$parcel$export($5e0c0d4e15efb4a6$exports, "P300", ()=>$5e0c0d4e15efb4a6$export$b48405b95304b5a1);
$parcel$export($5e0c0d4e15efb4a6$exports, "P400", ()=>$5e0c0d4e15efb4a6$export$c71e4279dd54a18d);
$parcel$export($5e0c0d4e15efb4a6$exports, "P500", ()=>$5e0c0d4e15efb4a6$export$147899de772240ec);
$parcel$export($5e0c0d4e15efb4a6$exports, "T50", ()=>$5e0c0d4e15efb4a6$export$2cf711fe14c66f06);
$parcel$export($5e0c0d4e15efb4a6$exports, "T75", ()=>$5e0c0d4e15efb4a6$export$7a8f4d33f6f9772c);
$parcel$export($5e0c0d4e15efb4a6$exports, "T100", ()=>$5e0c0d4e15efb4a6$export$776c9c497ef08533);
$parcel$export($5e0c0d4e15efb4a6$exports, "T200", ()=>$5e0c0d4e15efb4a6$export$69cb3ca10c1e330e);
$parcel$export($5e0c0d4e15efb4a6$exports, "T300", ()=>$5e0c0d4e15efb4a6$export$9dc1ef0f3f48059b);
$parcel$export($5e0c0d4e15efb4a6$exports, "T400", ()=>$5e0c0d4e15efb4a6$export$7c835c78b6fcdef8);
$parcel$export($5e0c0d4e15efb4a6$exports, "T500", ()=>$5e0c0d4e15efb4a6$export$6036577f95c3877e);
$parcel$export($5e0c0d4e15efb4a6$exports, "N0", ()=>$5e0c0d4e15efb4a6$export$29a4f05edc054374);
$parcel$export($5e0c0d4e15efb4a6$exports, "N10", ()=>$5e0c0d4e15efb4a6$export$e655ef011c4aa1a2);
$parcel$export($5e0c0d4e15efb4a6$exports, "N20", ()=>$5e0c0d4e15efb4a6$export$9fdfb749e33cdf97);
$parcel$export($5e0c0d4e15efb4a6$exports, "N30", ()=>$5e0c0d4e15efb4a6$export$3e51e8f1440314ba);
$parcel$export($5e0c0d4e15efb4a6$exports, "N40", ()=>$5e0c0d4e15efb4a6$export$1ce2d1575d444ceb);
$parcel$export($5e0c0d4e15efb4a6$exports, "N50", ()=>$5e0c0d4e15efb4a6$export$8754fc7e6d8b3000);
$parcel$export($5e0c0d4e15efb4a6$exports, "N60", ()=>$5e0c0d4e15efb4a6$export$c2e91cbeada39b8b);
$parcel$export($5e0c0d4e15efb4a6$exports, "N70", ()=>$5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de);
$parcel$export($5e0c0d4e15efb4a6$exports, "N80", ()=>$5e0c0d4e15efb4a6$export$eaa8c8a70ac22806);
$parcel$export($5e0c0d4e15efb4a6$exports, "N90", ()=>$5e0c0d4e15efb4a6$export$7c87d337fb91a97d);
$parcel$export($5e0c0d4e15efb4a6$exports, "N100", ()=>$5e0c0d4e15efb4a6$export$d6447c357493214f);
$parcel$export($5e0c0d4e15efb4a6$exports, "N200", ()=>$5e0c0d4e15efb4a6$export$f563ee71e9ee74cd);
$parcel$export($5e0c0d4e15efb4a6$exports, "N300", ()=>$5e0c0d4e15efb4a6$export$e2ef2124cf4024b1);
$parcel$export($5e0c0d4e15efb4a6$exports, "N400", ()=>$5e0c0d4e15efb4a6$export$eece5f492e429f08);
$parcel$export($5e0c0d4e15efb4a6$exports, "N500", ()=>$5e0c0d4e15efb4a6$export$c39c0fe0f26207ae);
$parcel$export($5e0c0d4e15efb4a6$exports, "N600", ()=>$5e0c0d4e15efb4a6$export$7090862dc3038a9f);
$parcel$export($5e0c0d4e15efb4a6$exports, "N700", ()=>$5e0c0d4e15efb4a6$export$ad0bacf983b7ddaa);
$parcel$export($5e0c0d4e15efb4a6$exports, "N800", ()=>$5e0c0d4e15efb4a6$export$7d61b15e0da132af);
$parcel$export($5e0c0d4e15efb4a6$exports, "N900", ()=>$5e0c0d4e15efb4a6$export$fbda843f0a27fe96);
$parcel$export($5e0c0d4e15efb4a6$exports, "N10A", ()=>$5e0c0d4e15efb4a6$export$791e57b27ca738ef);
$parcel$export($5e0c0d4e15efb4a6$exports, "N20A", ()=>$5e0c0d4e15efb4a6$export$8d43898f60b96a82);
$parcel$export($5e0c0d4e15efb4a6$exports, "N30A", ()=>$5e0c0d4e15efb4a6$export$920c0d5c49070351);
$parcel$export($5e0c0d4e15efb4a6$exports, "N40A", ()=>$5e0c0d4e15efb4a6$export$46987b49aab6d1a8);
$parcel$export($5e0c0d4e15efb4a6$exports, "N50A", ()=>$5e0c0d4e15efb4a6$export$7d3359664e8bb0e5);
$parcel$export($5e0c0d4e15efb4a6$exports, "N60A", ()=>$5e0c0d4e15efb4a6$export$d2d3bedfb276cac0);
$parcel$export($5e0c0d4e15efb4a6$exports, "N70A", ()=>$5e0c0d4e15efb4a6$export$6e5e7499ff054f6d);
$parcel$export($5e0c0d4e15efb4a6$exports, "N80A", ()=>$5e0c0d4e15efb4a6$export$59264b346c877fa7);
$parcel$export($5e0c0d4e15efb4a6$exports, "N90A", ()=>$5e0c0d4e15efb4a6$export$d092757d7c64925c);
$parcel$export($5e0c0d4e15efb4a6$exports, "N100A", ()=>$5e0c0d4e15efb4a6$export$486ab785e4bac3c6);
$parcel$export($5e0c0d4e15efb4a6$exports, "N200A", ()=>$5e0c0d4e15efb4a6$export$fba592bbc6419fea);
$parcel$export($5e0c0d4e15efb4a6$exports, "N300A", ()=>$5e0c0d4e15efb4a6$export$13609db0e6812ab8);
$parcel$export($5e0c0d4e15efb4a6$exports, "N400A", ()=>$5e0c0d4e15efb4a6$export$fbae4efaa892d883);
$parcel$export($5e0c0d4e15efb4a6$exports, "N500A", ()=>$5e0c0d4e15efb4a6$export$f13946d26f440ce6);
$parcel$export($5e0c0d4e15efb4a6$exports, "N600A", ()=>$5e0c0d4e15efb4a6$export$19f58225ac52a306);
$parcel$export($5e0c0d4e15efb4a6$exports, "N700A", ()=>$5e0c0d4e15efb4a6$export$6384f09da70e7b62);
$parcel$export($5e0c0d4e15efb4a6$exports, "N800A", ()=>$5e0c0d4e15efb4a6$export$d0dccc730683edc2);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN900", ()=>$5e0c0d4e15efb4a6$export$2f6319cf7d736c2a);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN800", ()=>$5e0c0d4e15efb4a6$export$95126bc8884d6634);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN700", ()=>$5e0c0d4e15efb4a6$export$8338d8c35d44ff1);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN600", ()=>$5e0c0d4e15efb4a6$export$5368d76ae4fbbda7);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN500", ()=>$5e0c0d4e15efb4a6$export$9f0a771d16ec8d36);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN400", ()=>$5e0c0d4e15efb4a6$export$abcf8c38338b4aa5);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN300", ()=>$5e0c0d4e15efb4a6$export$97e81faa16a182c7);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN200", ()=>$5e0c0d4e15efb4a6$export$bfe21c59123ecf33);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN100", ()=>$5e0c0d4e15efb4a6$export$ee82aa2ea6a1558);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN90", ()=>$5e0c0d4e15efb4a6$export$682927c6ed76be02);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN80", ()=>$5e0c0d4e15efb4a6$export$91fd9994c5be9757);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN70", ()=>$5e0c0d4e15efb4a6$export$d281fbfe3cff2df6);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN60", ()=>$5e0c0d4e15efb4a6$export$3902c91d8b98a753);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN50", ()=>$5e0c0d4e15efb4a6$export$8e8133c1ba5845b5);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN40", ()=>$5e0c0d4e15efb4a6$export$33ff357f6620b39);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN30", ()=>$5e0c0d4e15efb4a6$export$633847cf062b69e0);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN20", ()=>$5e0c0d4e15efb4a6$export$9776a6e503bdbf76);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN10", ()=>$5e0c0d4e15efb4a6$export$6c813d5160dff5db);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN0", ()=>$5e0c0d4e15efb4a6$export$3d4f271a500072a);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN800A", ()=>$5e0c0d4e15efb4a6$export$fe151285c22759ec);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN700A", ()=>$5e0c0d4e15efb4a6$export$a101c6190d0da34);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN600A", ()=>$5e0c0d4e15efb4a6$export$4b16f52932fda51);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN500A", ()=>$5e0c0d4e15efb4a6$export$a74bcd7b9845b0d8);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN400A", ()=>$5e0c0d4e15efb4a6$export$9209c179316d1751);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN300A", ()=>$5e0c0d4e15efb4a6$export$88f55133f636c8dd);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN200A", ()=>$5e0c0d4e15efb4a6$export$51126f85d1009512);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN100A", ()=>$5e0c0d4e15efb4a6$export$a069b547bd23af78);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN90A", ()=>$5e0c0d4e15efb4a6$export$40cce05af3b2600a);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN80A", ()=>$5e0c0d4e15efb4a6$export$b78942185925a0d);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN70A", ()=>$5e0c0d4e15efb4a6$export$e058fb44b8eaafca);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN60A", ()=>$5e0c0d4e15efb4a6$export$92b0b8de26920c18);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN50A", ()=>$5e0c0d4e15efb4a6$export$67564f7459d3fc9e);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN40A", ()=>$5e0c0d4e15efb4a6$export$77868e1ca884ffa3);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN30A", ()=>$5e0c0d4e15efb4a6$export$2afd71d7d3ea2cd5);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN20A", ()=>$5e0c0d4e15efb4a6$export$f2a0acaab9972c70);
$parcel$export($5e0c0d4e15efb4a6$exports, "DN10A", ()=>$5e0c0d4e15efb4a6$export$9ab70e67d6475361);
$parcel$export($5e0c0d4e15efb4a6$exports, "T30", ()=>$5e0c0d4e15efb4a6$export$d2adc5dedf09fced);
$parcel$export($5e0c0d4e15efb4a6$exports, "L50", ()=>$5e0c0d4e15efb4a6$export$f51762073d2bb381);
$parcel$export($5e0c0d4e15efb4a6$exports, "L75", ()=>$5e0c0d4e15efb4a6$export$95e26d54def96891);
const $5e0c0d4e15efb4a6$export$4b84fd0e2c617bd = '#FFEBE6';
const $5e0c0d4e15efb4a6$export$b34b069eff244586 = '#FFBDAD';
const $5e0c0d4e15efb4a6$export$be802dd0d8b57f35 = '#FF8F73';
const $5e0c0d4e15efb4a6$export$60847d42f9da92a6 = '#FF7452';
const $5e0c0d4e15efb4a6$export$4a7404f376229999 = '#FF5630';
const $5e0c0d4e15efb4a6$export$2010d0fb4295b346 = '#DE350B';
const $5e0c0d4e15efb4a6$export$2837b5a1a71d5c02 = '#BF2600';
const $5e0c0d4e15efb4a6$export$8d9596b529bbb9cf = '#FFFAE6';
const $5e0c0d4e15efb4a6$export$41060a744ab0b7ae = '#FFF0B3';
const $5e0c0d4e15efb4a6$export$1cc05bbbf340e559 = '#FFE380';
const $5e0c0d4e15efb4a6$export$5aae31392d72caaa = '#FFC400';
const $5e0c0d4e15efb4a6$export$c6930421db9fa514 = '#FFAB00';
const $5e0c0d4e15efb4a6$export$59619663aa6500fb = '#FF991F';
const $5e0c0d4e15efb4a6$export$874739ea9e379ab6 = '#FF8B00';
const $5e0c0d4e15efb4a6$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $5e0c0d4e15efb4a6$export$69a3bf21b9686c2b = '#ABF5D1';
const $5e0c0d4e15efb4a6$export$afbce1382ec95f73 = '#79F2C0';
const $5e0c0d4e15efb4a6$export$747d86715d4175de = '#57D9A3';
const $5e0c0d4e15efb4a6$export$940e1f69e873f202 = '#36B37E';
const $5e0c0d4e15efb4a6$export$a49394138f7b8e85 = '#00875A';
const $5e0c0d4e15efb4a6$export$6fa04827ac68a4fb = '#006644';
const $5e0c0d4e15efb4a6$export$226de0355ed012f8 = '#DEEBFF';
const $5e0c0d4e15efb4a6$export$8c13c2ee36917869 = '#B3D4FF';
const $5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a = '#4C9AFF';
const $5e0c0d4e15efb4a6$export$215b7063051591f1 = '#2684FF';
const $5e0c0d4e15efb4a6$export$e62e8919cca44969 = '#0065FF';
const $5e0c0d4e15efb4a6$export$b3de0ae08da2ce64 = '#0052CC';
const $5e0c0d4e15efb4a6$export$a6ee3d71bc067634 = '#0747A6';
const $5e0c0d4e15efb4a6$export$67f15409e87642a1 = '#669DF1';
const $5e0c0d4e15efb4a6$export$f0539dbc42dbb067 = '#8FB8F6';
const $5e0c0d4e15efb4a6$export$363e4475840015bb = '#EAE6FF';
const $5e0c0d4e15efb4a6$export$4b0a4417ed59760f = '#C0B6F2';
const $5e0c0d4e15efb4a6$export$6011520a64d9a187 = '#998DD9';
const $5e0c0d4e15efb4a6$export$a7175d4e9206bc80 = '#8777D9';
const $5e0c0d4e15efb4a6$export$b48405b95304b5a1 = '#6554C0';
const $5e0c0d4e15efb4a6$export$c71e4279dd54a18d = '#5243AA';
const $5e0c0d4e15efb4a6$export$147899de772240ec = '#403294';
const $5e0c0d4e15efb4a6$export$2cf711fe14c66f06 = '#E6FCFF';
const $5e0c0d4e15efb4a6$export$7a8f4d33f6f9772c = '#B3F5FF';
const $5e0c0d4e15efb4a6$export$776c9c497ef08533 = '#79E2F2';
const $5e0c0d4e15efb4a6$export$69cb3ca10c1e330e = '#00C7E6';
const $5e0c0d4e15efb4a6$export$9dc1ef0f3f48059b = '#00B8D9';
const $5e0c0d4e15efb4a6$export$7c835c78b6fcdef8 = '#00A3BF';
const $5e0c0d4e15efb4a6$export$6036577f95c3877e = '#008DA6';
const $5e0c0d4e15efb4a6$export$29a4f05edc054374 = '#FFFFFF';
const $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2 = '#FAFBFC';
const $5e0c0d4e15efb4a6$export$9fdfb749e33cdf97 = '#F4F5F7';
const $5e0c0d4e15efb4a6$export$3e51e8f1440314ba = '#EBECF0';
const $5e0c0d4e15efb4a6$export$1ce2d1575d444ceb = '#DFE1E6';
const $5e0c0d4e15efb4a6$export$8754fc7e6d8b3000 = '#C1C7D0';
const $5e0c0d4e15efb4a6$export$c2e91cbeada39b8b = '#B3BAC5';
const $5e0c0d4e15efb4a6$export$5f71e19f3a7ad9de = '#A5ADBA';
const $5e0c0d4e15efb4a6$export$eaa8c8a70ac22806 = '#97A0AF';
const $5e0c0d4e15efb4a6$export$7c87d337fb91a97d = '#8993A4';
const $5e0c0d4e15efb4a6$export$d6447c357493214f = '#7A869A';
const $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd = '#6B778C';
const $5e0c0d4e15efb4a6$export$e2ef2124cf4024b1 = '#5E6C84';
const $5e0c0d4e15efb4a6$export$eece5f492e429f08 = '#505F79';
const $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae = '#42526E';
const $5e0c0d4e15efb4a6$export$7090862dc3038a9f = '#344563';
const $5e0c0d4e15efb4a6$export$ad0bacf983b7ddaa = '#253858';
const $5e0c0d4e15efb4a6$export$7d61b15e0da132af = '#172B4D';
const $5e0c0d4e15efb4a6$export$fbda843f0a27fe96 = '#091E42';
const $5e0c0d4e15efb4a6$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $5e0c0d4e15efb4a6$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $5e0c0d4e15efb4a6$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $5e0c0d4e15efb4a6$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $5e0c0d4e15efb4a6$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $5e0c0d4e15efb4a6$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $5e0c0d4e15efb4a6$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $5e0c0d4e15efb4a6$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $5e0c0d4e15efb4a6$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $5e0c0d4e15efb4a6$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $5e0c0d4e15efb4a6$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $5e0c0d4e15efb4a6$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $5e0c0d4e15efb4a6$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $5e0c0d4e15efb4a6$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $5e0c0d4e15efb4a6$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $5e0c0d4e15efb4a6$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $5e0c0d4e15efb4a6$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $5e0c0d4e15efb4a6$export$2f6319cf7d736c2a = '#E6EDFA';
const $5e0c0d4e15efb4a6$export$95126bc8884d6634 = '#DCE5F5';
const $5e0c0d4e15efb4a6$export$8338d8c35d44ff1 = '#CED9EB';
const $5e0c0d4e15efb4a6$export$5368d76ae4fbbda7 = '#B8C7E0';
const $5e0c0d4e15efb4a6$export$9f0a771d16ec8d36 = '#ABBBD6';
const $5e0c0d4e15efb4a6$export$abcf8c38338b4aa5 = '#9FB0CC';
const $5e0c0d4e15efb4a6$export$97e81faa16a182c7 = '#8C9CB8';
const $5e0c0d4e15efb4a6$export$bfe21c59123ecf33 = '#7988A3';
const $5e0c0d4e15efb4a6$export$ee82aa2ea6a1558 = '#67758F';
const $5e0c0d4e15efb4a6$export$682927c6ed76be02 = '#56637A';
const $5e0c0d4e15efb4a6$export$91fd9994c5be9757 = '#455166';
const $5e0c0d4e15efb4a6$export$d281fbfe3cff2df6 = '#3B475C';
const $5e0c0d4e15efb4a6$export$3902c91d8b98a753 = '#313D52';
const $5e0c0d4e15efb4a6$export$8e8133c1ba5845b5 = '#283447';
const $5e0c0d4e15efb4a6$export$33ff357f6620b39 = '#202B3D';
const $5e0c0d4e15efb4a6$export$633847cf062b69e0 = '#1B2638';
const $5e0c0d4e15efb4a6$export$9776a6e503bdbf76 = '#121A29';
const $5e0c0d4e15efb4a6$export$6c813d5160dff5db = '#0E1624';
const $5e0c0d4e15efb4a6$export$3d4f271a500072a = '#0D1424';
const $5e0c0d4e15efb4a6$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $5e0c0d4e15efb4a6$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $5e0c0d4e15efb4a6$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $5e0c0d4e15efb4a6$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $5e0c0d4e15efb4a6$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $5e0c0d4e15efb4a6$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $5e0c0d4e15efb4a6$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $5e0c0d4e15efb4a6$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $5e0c0d4e15efb4a6$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $5e0c0d4e15efb4a6$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $5e0c0d4e15efb4a6$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $5e0c0d4e15efb4a6$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $5e0c0d4e15efb4a6$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $5e0c0d4e15efb4a6$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $5e0c0d4e15efb4a6$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $5e0c0d4e15efb4a6$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $5e0c0d4e15efb4a6$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $5e0c0d4e15efb4a6$export$d2adc5dedf09fced = '#292A2E';
const $5e0c0d4e15efb4a6$export$f51762073d2bb381 = '#94C748';
const $5e0c0d4e15efb4a6$export$95e26d54def96891 = '#B3DF72';
parcelRegister("gwIPs", function(module, exports) {
    $parcel$export(module.exports, "gridSize", ()=>$80d528dbc2b11cbc$export$6d8204c2cb2e06b8);
    $parcel$export(module.exports, "borderRadius", ()=>$80d528dbc2b11cbc$export$7a57f79000377ca2);
    $parcel$export(module.exports, "fontSize", ()=>$80d528dbc2b11cbc$export$85e3c3ca0c6fb93);
    $parcel$export(module.exports, "fontFamily", ()=>$80d528dbc2b11cbc$export$a5975749f0374264);
    $parcel$export(module.exports, "codeFontFamily", ()=>$80d528dbc2b11cbc$export$356129969ee49c55);
    $parcel$export(module.exports, "contentHorizontalSpacing", ()=>$80d528dbc2b11cbc$export$22dec01f2c854397);
    $parcel$export(module.exports, "layers", ()=>$80d528dbc2b11cbc$export$7be255094ccdc533);
    $parcel$export(module.exports, "layout", ()=>$80d528dbc2b11cbc$export$b3219800bda33a1f);
    var $dtXUS;
    const $80d528dbc2b11cbc$export$6d8204c2cb2e06b8 = (0, (0, parcelRequire("dtXUS")).gridSize)();
    const $80d528dbc2b11cbc$export$7a57f79000377ca2 = (0, (0, parcelRequire("dtXUS")).borderRadius)();
    const $80d528dbc2b11cbc$export$85e3c3ca0c6fb93 = (0, (0, parcelRequire("dtXUS")).fontSize)();
    const $80d528dbc2b11cbc$export$a5975749f0374264 = (0, (0, parcelRequire("dtXUS")).fontFamily)();
    const $80d528dbc2b11cbc$export$356129969ee49c55 = (0, (0, parcelRequire("dtXUS")).codeFontFamily)();
    const $80d528dbc2b11cbc$export$22dec01f2c854397 = 40;
    const $80d528dbc2b11cbc$export$dab5ea164c6f81a = 100;
    const $80d528dbc2b11cbc$export$7be255094ccdc533 = {
        banner: (0, (0, parcelRequire("dtXUS")).layers).navigation(),
        card: (0, (0, parcelRequire("dtXUS")).layers).card(),
        dialog: (0, (0, parcelRequire("dtXUS")).layers).dialog(),
        navigation: (0, (0, parcelRequire("dtXUS")).layers).navigation(),
        leftSidebar: (0, (0, parcelRequire("dtXUS")).layers).navigation() - 1,
        rightSidebar: (0, (0, parcelRequire("dtXUS")).layers).navigation() - 1,
        layer: (0, (0, parcelRequire("dtXUS")).layers).layer(),
        blanket: (0, (0, parcelRequire("dtXUS")).layers).blanket(),
        modal: (0, (0, parcelRequire("dtXUS")).layers).modal(),
        flag: (0, (0, parcelRequire("dtXUS")).layers).flag(),
        spotlight: (0, (0, parcelRequire("dtXUS")).layers).spotlight(),
        tooltip: (0, (0, parcelRequire("dtXUS")).layers).tooltip(),
        mobileBanner: $80d528dbc2b11cbc$export$dab5ea164c6f81a
    };
    const $80d528dbc2b11cbc$export$b3219800bda33a1f = {
        issueIconSize: $80d528dbc2b11cbc$export$6d8204c2cb2e06b8 * 2
    };
});
parcelRegister("cKw8Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$81c05dd6e2dcad70$export$2e2bcd8739ae039);
    var $7VHMR;
    var $81c05dd6e2dcad70$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        blue: {
            "id": "dashboard-common.blue",
            "defaultMessage": "Blue"
        },
        red: {
            "id": "dashboard-common.red",
            "defaultMessage": "Red"
        },
        yellow: {
            "id": "dashboard-common.yellow",
            "defaultMessage": "Yellow"
        },
        green: {
            "id": "dashboard-common.green",
            "defaultMessage": "Green"
        },
        teal: {
            "id": "dashboard-common.teal",
            "defaultMessage": "Teal"
        },
        purple: {
            "id": "dashboard-common.purple",
            "defaultMessage": "Purple"
        },
        gray: {
            "id": "dashboard-common.gray",
            "defaultMessage": "Gray"
        },
        white: {
            "id": "dashboard-common.white",
            "defaultMessage": "White"
        }
    });
});
const $e03099b7bef7f4cd$export$ca03ff6cc792cc16 = 'DASHBOARD_CONFIG_AND_WRM';
const $e03099b7bef7f4cd$export$e239393fd4e2bc85 = 'DASHBOARD_AMD_MODULES';
const $e03099b7bef7f4cd$export$9e5db01432b13b67 = 'DASHBOARD_REACT_GADGETS';
const $e03099b7bef7f4cd$export$dd4bac16c565acb1 = 'DASHBOARD_FORGE_GADGETS';
const $e03099b7bef7f4cd$export$bce41807cc929d0f = 'DASHBOARD_FORGE';
const $e03099b7bef7f4cd$export$c07a25ebb6af1e84 = 'DASHBOARD_GADGET_DIRECTORY';
const $e03099b7bef7f4cd$export$58e1e8808435e4be = 'AVP_DASHBOARD';
parcelRegister("04Brv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff7f8eda58c85578$export$2e2bcd8739ae039);
    var $4su49;
    var $3Yd87;
    var $1IY2I;
    var $ff7f8eda58c85578$export$2e2bcd8739ae039 = (_maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch })=>{
            if (!sharedValue || sharedValue instanceof Error) throw new (0, (0, parcelRequire("3Yd87")).SharedValueAggregateError)({
                sharedValue: sharedValue,
                isPrefetch: isPrefetch,
                name: 'AMD modules resource'
            });
            return (async ()=>{
                const { moduleNames: moduleNames, isPreloaded: isPreloaded } = sharedValue;
                const maybePromiseAmdModules = isPreloaded || await (0, (0, parcelRequire("1IY2I")).loadAmdModules)((0, (0, parcelRequire("4su49")).asyncWrmRequire), moduleNames) ? (0, (0, parcelRequire("1IY2I")).evalAmdModules)(moduleNames) : null;
                const amdModules = maybePromiseAmdModules instanceof Promise ? await maybePromiseAmdModules : maybePromiseAmdModules;
                return {
                    sharedValue: sharedValue,
                    amdModules: amdModules
                };
            })();
        };
});
parcelRegister("1IY2I", function(module, exports) {
    $parcel$export(module.exports, "loadAmdModules", ()=>$d6efeb87a1192ef7$export$2c79895bd69a8d54);
    $parcel$export(module.exports, "evalAmdModules", ()=>$d6efeb87a1192ef7$export$d74eab33af9baaea);
    var $dJl1T;
    var $JIPqS;
    class $d6efeb87a1192ef7$var$ConnectDashboardItem {
        render() {}
        renderEdit() {}
    }
    const $d6efeb87a1192ef7$export$3bf37adbbdcafcc8 = (moduleName, retries = 5)=>{
        try {
            if (typeof window.require !== 'function') throw new TypeError('window.require is not a function');
            return window.require(moduleName);
        } catch (error) {
            if (error instanceof Error && /^No \S+$|^\S+ missing \S+$/.test(error.message)) {
                if (retries > 0) return new Promise((r)=>setTimeout(r, 100)).then(()=>$d6efeb87a1192ef7$export$3bf37adbbdcafcc8(moduleName, retries - 1));
            }
            throw error;
        }
    };
    const $d6efeb87a1192ef7$export$2c79895bd69a8d54 = async (wrmRequire, moduleNames)=>{
        if (moduleNames.length === 0) return false;
        const prefixedAmdResources = moduleNames.map((amdModule)=>(0, (0, parcelRequire("JIPqS")).WEB_RESOURCE_MAP)[amdModule]).map((resourceName)=>`wrc!${resourceName}`);
        try {
            await wrmRequire(prefixedAmdResources);
            return true;
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.dashboard.gadget.resource', `Failed to load web resources [${prefixedAmdResources.join(',')}]`, error);
            return false;
        }
    };
    const $d6efeb87a1192ef7$var$getSortedModuleNamesFromTuples = (tuples)=>tuples.map(([moduleName])=>moduleName).sort((a, b)=>a.localeCompare(b)).join(',');
    const $d6efeb87a1192ef7$export$d74eab33af9baaea = (amdModuleNames)=>{
        const tuplesOrPromises = amdModuleNames.map((amdModuleName)=>{
            try {
                const module = amdModuleName === (0, (0, parcelRequire("JIPqS")).CONNECT_ITEM_AMD_MODULE) ? $d6efeb87a1192ef7$var$ConnectDashboardItem : $d6efeb87a1192ef7$export$3bf37adbbdcafcc8(amdModuleName);
                return module instanceof Promise ? module.then((v)=>[
                        amdModuleName,
                        v
                    ]) : [
                    amdModuleName,
                    module
                ];
            } catch (error) {
                return Promise.reject(error);
            }
        });
        const hasPromise = tuplesOrPromises.some((entry)=>entry instanceof Promise);
        if (!hasPromise) {
            (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful synchronous bulk eval AMD modules');
            return Object.fromEntries(tuplesOrPromises);
        }
        return Promise.allSettled(tuplesOrPromises).then((results)=>{
            const tuples = results.map((result, i)=>{
                if (result.status === 'fulfilled') return result.value;
                const { reason: error } = result;
                const amdModuleName = amdModuleNames[i];
                const message = error instanceof Error ? error.message : String(error);
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD module [${amdModuleName}] with error [${message}]`, error);
                return [
                    amdModuleName,
                    null
                ];
            });
            const failedTuples = tuples.filter((module)=>module[1] === null);
            failedTuples.length > 0 ? (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('spa-apps.dashboard.resource', `Failed bulk eval AMD modules [${$d6efeb87a1192ef7$var$getSortedModuleNamesFromTuples(failedTuples)}]`) : (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData('spa-apps.dashboard.resource', 'Successful asynchronous bulk eval AMD modules');
            return Object.fromEntries(tuples);
        });
    };
});
parcelRegister("3cb5I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f465c16c9ac91f45$export$2e2bcd8739ae039);
    var $65Ltd;
    var $7RGnr;
    var $2j5ho;
    var $1LNzH;
    var $hoLk6;
    var $6T8HZ;
    var $abozY;
    var $8oOn8;
    const $f465c16c9ac91f45$var$generateScriptTagAndPreloadedModuleNames = async (configs)=>{
        const gadgets = configs.flatMap((config)=>config.gadgets);
        const preloadedModuleNames = (0, (0, parcelRequire("8oOn8")).gadgetsToUniqueSortedAmdModules)(gadgets);
        const wrmBundleDescriptor = await (0, (0, parcelRequire("1LNzH")).default)(preloadedModuleNames);
        return configs.map((config)=>{
            const scriptTags = [
                wrmBundleDescriptor ? (0, (0, parcelRequire("6T8HZ")).default)(wrmBundleDescriptor) : null,
                (0, (0, parcelRequire("hoLk6")).default)(config)
            ].filter(Boolean).join('\n') || null;
            return {
                ...config,
                scriptTags: scriptTags,
                preloadedModuleNames: preloadedModuleNames
            };
        });
    };
    var $f465c16c9ac91f45$export$2e2bcd8739ae039 = async (context)=>{
        const { route: route, query: query } = context;
        const originalConfigs = route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_WALLBOARD) ? await (0, (0, parcelRequire("2j5ho")).getDashboardsConfig)(query.dashboardId) : [
            await (0, (0, parcelRequire("2j5ho")).default)((0, (0, parcelRequire("abozY")).getKey)(context))
        ];
        const configs = originalConfigs.map((config)=>({
                ...config,
                gadgets: (0, (0, parcelRequire("7RGnr")).mapToReactGadgets)(config.gadgets)
            }));
        if (!false) return configs.map((config)=>({
                ...config,
                preloadedModuleNames: []
            }));
        return $f465c16c9ac91f45$var$generateScriptTagAndPreloadedModuleNames(configs);
    };
});
parcelRegister("7RGnr", function(module, exports) {
    $parcel$export(module.exports, "mapToReactGadgets", ()=>$119a071fe5fec8f8$export$c90615c5eb218d50);
    var $4R6GH;
    const $119a071fe5fec8f8$export$c90615c5eb218d50 = (gadgets)=>{
        const gadgetMapping = {
            ...(0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_filter_results_gadget') ? {
                'jira-dashboard-items/filter-results': 'react/filter-results'
            } : {},
            'servicedesk/internal/reports/feature/custom-report-dashboard-item/custom-report-dashboard-item': 'react/custom-report',
            ...(0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_assigned_to_me_gadget') ? {
                'jira-dashboard-items/assigned-to-me': 'react/assigned-to-me'
            } : {},
            ...(0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_issues_in_progress_gadget') ? {
                'jira-dashboard-items/in-progress': 'react/issues-in-progress'
            } : {},
            ...(0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_voted_issues_gadget') ? {
                'jira-dashboard-items/voted': 'react/voted-issues'
            } : {},
            ...(0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_watched_issues_gadget') ? {
                'jira-dashboard-items/watched': 'react/watched-issues'
            } : {}
        };
        const isMapped = (module)=>module !== undefined && module in gadgetMapping;
        return gadgets.map((gadget)=>{
            if (isMapped(gadget.amdModule)) return {
                ...gadget,
                reactKey: gadgetMapping[gadget.amdModule],
                amdModule: undefined,
                configurable: false,
                inlineHtml: undefined
            };
            return gadget;
        });
    };
});
parcelRegister("2j5ho", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ef874ace7c3cd69$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "getDashboardsConfig", ()=>$3ef874ace7c3cd69$export$1264b6af3adf5084);
    var $7f4tk;
    var $3ef874ace7c3cd69$export$2e2bcd8739ae039 = (id)=>(0, (0, parcelRequire("7f4tk")).default)(`/rest/dashboards/1.0/${id}.json`);
    const $3ef874ace7c3cd69$export$1264b6af3adf5084 = (idsCsv)=>(0, (0, parcelRequire("7f4tk")).default)(`/rest/dashboards/1.0?dashboardId=${idsCsv}`);
});
parcelRegister("1LNzH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1e5794ac0c0d1780$export$2e2bcd8739ae039);
    var $JIPqS;
    var $7f4tk;
    const $1e5794ac0c0d1780$var$CRITICAL_DEPENDENCIES = [
        'jira.webresources:util',
        'jira.webresources:feature-flags',
        'com.atlassian.jira.jira-atlaskit-plugin:overrides-general'
    ];
    const $1e5794ac0c0d1780$var$JIRA_HERITAGE_CRITICAL_BATCH = 'jira.heritage.critical';
    var $1e5794ac0c0d1780$export$2e2bcd8739ae039 = async (moduleNames)=>{
        if (moduleNames.length === 0) return Promise.resolve(null);
        const contextsToRequire = moduleNames.map((amdModule)=>(0, (0, parcelRequire("JIPqS")).WEB_RESOURCE_MAP)[amdModule]);
        const payload = {
            r: [],
            c: [
                ...$1e5794ac0c0d1780$var$CRITICAL_DEPENDENCIES,
                ...contextsToRequire
            ],
            xc: [
                $1e5794ac0c0d1780$var$JIRA_HERITAGE_CRITICAL_BATCH
            ],
            xr: []
        };
        return (0, (0, parcelRequire("7f4tk")).default)('/rest/webResources/1.0/resources', {
            method: 'POST',
            body: JSON.stringify(payload)
        });
    };
});
parcelRegister("hoLk6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9b2d88076d11343$export$2e2bcd8739ae039);
    var $JIPqS;
    var $83oax;
    var $d9b2d88076d11343$export$2e2bcd8739ae039 = (dashboardConfig)=>{
        if (dashboardConfig.gadgets.length === 0) return null;
        const prefetches = (0, (0, parcelRequire("83oax")).getPrefetches)(dashboardConfig);
        const preloadLinks = prefetches.map((prefetch)=>`<link rel="preload" as="fetch" href="${prefetch.url}" crossorigin="anonymous" />`).join('\n') || null;
        const syncPrefetchUrls = prefetches.filter((prefetch)=>prefetch.isSyncLoadingSupported()).map((prefetch)=>prefetch.url);
        if (preloadLinks != null && syncPrefetchUrls.length > 0) {
            const fetchScript = `
            <script type="text/javascript" data-defer-skip>
                const preloadUrls = ${JSON.stringify(syncPrefetchUrls)};
                window['${(0, (0, parcelRequire("JIPqS")).PRELOADED_GADGET_DATA_KEY)}'] = {};

                preloadUrls.forEach((preloadUrl) => {
                    fetch(preloadUrl)
                        .then(res => res.json())
                        .then(data => {
                            window['${(0, (0, parcelRequire("JIPqS")).PRELOADED_GADGET_DATA_KEY)}'][preloadUrl] = data;
                        });
                });
            </script>
        `;
            return preloadLinks + fetchScript;
        }
        return preloadLinks;
    };
});
parcelRegister("83oax", function(module, exports) {
    $parcel$export(module.exports, "getPrefetches", ()=>$6e3ee08c53b7707c$export$3144db3718ad5e57);
    var $bT0sh;
    const $6e3ee08c53b7707c$export$3144db3718ad5e57 = ({ gadgets: gadgets })=>{
        const lookup = (0, (0, parcelRequire("bT0sh")).getPrefetchDict)();
        return gadgets.flatMap((gadget)=>{
            const identifier = gadget.amdModule;
            const prefechProp = identifier != null ? lookup[identifier] : undefined;
            if (!prefechProp || !prefechProp.enabled) return [];
            const { func: func, priority: priority, isSyncLoadingSupported: isSyncLoadingSupported } = prefechProp;
            return func(gadget).map((url)=>({
                    url: url,
                    priority: priority,
                    isSyncLoadingSupported: isSyncLoadingSupported
                }));
        });
    };
});
parcelRegister("bT0sh", function(module, exports) {
    $parcel$export(module.exports, "getPrefetchDict", ()=>$e3f3a590c57f26d7$export$244cea94cab19e07);
    var $4R6GH;
    var $ltNbR;
    var $8lc67;
    var $cdUf4;
    const $e3f3a590c57f26d7$export$244cea94cab19e07 = ()=>({
            'jira-dashboard-items/activitystream': {
                func: (0, (0, parcelRequire("8lc67")).getActivityStreamPrefetchLink),
                priority: (0, (0, parcelRequire("ltNbR")).LOADING_PRIORITY).HIGH,
                enabled: true,
                isSyncLoadingSupported: ()=>false
            },
            'jira-dashboard-items/filter-results': {
                func: (0, (0, parcelRequire("cdUf4")).getFilterResultsPrefetchLink),
                priority: (0, (0, parcelRequire("ltNbR")).LOADING_PRIORITY).LOW,
                enabled: !(0, (0, parcelRequire("4R6GH")).fg)('endeavour_nin_filter_results_gadget'),
                isSyncLoadingSupported: ()=>true
            }
        });
});
parcelRegister("ltNbR", function(module, exports) {
    $parcel$export(module.exports, "LOADING_PRIORITY", ()=>$5a106311215627b2$export$cb9b1f2232733c1b);
    const $5a106311215627b2$export$cb9b1f2232733c1b = {
        HIGH: 'preload',
        LOW: 'prefetch'
    };
});
parcelRegister("8lc67", function(module, exports) {
    $parcel$export(module.exports, "getActivityStreamPrefetchLink", ()=>$cadf517d0dd42b8b$export$360928f5bf059a9e);
    var $ebyGx = parcelRequire("ebyGx");
    const $cadf517d0dd42b8b$var$replacer = (match, part1)=>String.fromCharCode(part1);
    const $cadf517d0dd42b8b$var$getDateValue = (dateValue, operatorLower)=>{
        const dateStr = `${dateValue}`;
        const operator = operatorLower.toUpperCase();
        let dateArr;
        if (dateStr.indexOf(' ') !== -1) dateArr = dateStr.split(' ');
        else if (operator === 'BETWEEN') dateArr = [
            dateValue,
            dateValue
        ];
        else dateArr = [
            dateValue
        ];
        return dateArr.map((date, index)=>{
            const dateInt = parseInt(date, 10);
            if (operator === 'AFTER' || operator === 'BETWEEN' && index === 1) return dateInt + 86400000 - 1;
            return dateInt;
        }).join(' ');
    };
    const $cadf517d0dd42b8b$var$handleSpecialCases = (rule)=>{
        let { value: value, operator: operator } = rule;
        const { type: type } = rule;
        if (Array.isArray(value)) {
            const encodedValues = [];
            value.forEach((val)=>{
                encodedValues.push(val.replace(/_/g, '\\_').replace(/ /g, '_'));
            });
            value = encodedValues.join(' ');
        }
        if (type === 'date') {
            if (operator === 'is') operator = 'between';
            value = $cadf517d0dd42b8b$var$getDateValue(value, operator);
            if (value.indexOf('NaN') !== -1) return {};
        } else if (type === 'list' || type === 'user') {
            value = value.replace(/,/g, ' ');
            value = value.replace(/_/g, '\\_');
        }
        return {
            value: value,
            operator: operator
        };
    };
    const $cadf517d0dd42b8b$var$getParamsFromRules = (rules)=>{
        const params = {};
        const providers = JSON.parse(decodeURIComponent(rules.replace(/&#([0-9]+);/g, $cadf517d0dd42b8b$var$replacer)))?.providers || [];
        const enabledProviders = [];
        providers.forEach((provider)=>{
            const providerKey = provider.provider;
            const { rules: providerRules } = provider;
            const stringifiedRules = [];
            if (!provider.disabled) {
                if (providerKey !== 'streams') enabledProviders.push(providerKey);
                providerRules.forEach((rule)=>{
                    const modifiedRuleObj = $cadf517d0dd42b8b$var$handleSpecialCases(rule);
                    const { operator: operator, value: value } = modifiedRuleObj;
                    if (operator && value) stringifiedRules.push([
                        rule.rule,
                        operator.toUpperCase(),
                        value
                    ].join(' '));
                });
                params[providerKey] = stringifiedRules;
            }
        });
        if (enabledProviders.length < providers.length - 1) params.providers = enabledProviders.join(' ');
        return params;
    };
    const $cadf517d0dd42b8b$export$3d7deb7cf8a9de04 = (gadget)=>{
        const prefs = Object.fromEntries(gadget.userPrefs?.fields.map((field)=>[
                field.name,
                field.value
            ]) ?? []);
        const params = {
            maxResults: prefs.numofentries ?? 25,
            relativeLinks: true,
            ...prefs.rules ? $cadf517d0dd42b8b$var$getParamsFromRules(prefs.rules) : {}
        };
        return (0, ($parcel$interopDefault($ebyGx))).stringify(params).replace(/%20/g, '+');
    };
    const $cadf517d0dd42b8b$var$ACTIVITY_STREAM_REST_URL = 'plugins/servlet/streams';
    const $cadf517d0dd42b8b$export$360928f5bf059a9e = (gadgetData)=>{
        const paramStr = $cadf517d0dd42b8b$export$3d7deb7cf8a9de04(gadgetData);
        return [
            `/${$cadf517d0dd42b8b$var$ACTIVITY_STREAM_REST_URL}?${paramStr}`
        ];
    };
});
parcelRegister("cdUf4", function(module, exports) {
    $parcel$export(module.exports, "getFilterResultsPrefetchLink", ()=>$7e69dbaeb4189994$export$947cd90004054337);
    var $ebyGx = parcelRequire("ebyGx");
    const $7e69dbaeb4189994$var$FILTER_RESULTS_REST_URL = 'rest/gadget/1.0/issueTable';
    const $7e69dbaeb4189994$export$947cd90004054337 = (gadgetData)=>{
        const { properties: properties } = gadgetData.context.dashboardItem;
        const data = {
            num: properties.num,
            tableContext: 'jira.table.cols.dashboard',
            addDefault: false,
            columnNames: typeof properties.columnNames === 'string' ? properties.columnNames.split('|') : undefined,
            enableSorting: true,
            paging: true,
            showActions: true,
            filterId: undefined,
            jql: undefined,
            sortBy: String(properties.sortBy && properties.sortBy !== '' ? properties.sortBy : null),
            startIndex: properties.startIndex ? properties.startIndex : 0
        };
        let queryType = '';
        if (properties.filterId) {
            queryType = 'filter';
            Object.assign(data, {
                filterId: properties.filterId
            });
        } else if (properties.jql) {
            queryType = 'jql';
            Object.assign(data, {
                jql: properties.jql
            });
        }
        const paramStr = (0, ($parcel$interopDefault($ebyGx))).stringify(data, {
            sort: false
        }).replace(/%20/g, '+');
        const preloadUrl = `/${$7e69dbaeb4189994$var$FILTER_RESULTS_REST_URL}/${queryType}?${paramStr}`;
        return [
            preloadUrl
        ];
    };
});
parcelRegister("6T8HZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8c547330881220e9$export$2e2bcd8739ae039);
    var $8c547330881220e9$export$2e2bcd8739ae039 = (response)=>{
        let resourceHtml = `
        <script type="text/javascript" data-defer-skip>
            window.WRM=window.WRM||{};window.WRM._unparsedData=window.WRM._unparsedData||{};window.WRM._unparsedErrors=window.WRM._unparsedErrors||{};
            WRM._unparsedData = Object.assign({}, WRM._unparsedData, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedData))}));
            WRM._unparsedErrors = Object.assign({}, WRM._unparsedErrors, JSON.parse(${JSON.stringify(JSON.stringify(response.unparsedErrors))}));
            if(window.WRM._dataArrived)window.WRM._dataArrived();
        </script>
    `;
        response.resources.forEach((resource)=>{
            const { url: url, resourceType: resourceType, key: key } = resource;
            if (resourceType === 'CSS') {
                const cssResource = `<link
                href=${url}
                type="text/css"
                rel="stylesheet"
                media="all"
                data-wrm-key=${key}
                data-wrm-batch-type="context"
            />`;
                resourceHtml += cssResource;
            } else {
                const jsResource = `<div>
                <script
                    type="text/javascript"
                    data-initially-rendered
                    data-defer-skip
                    src=${url}
                    data-wrm-key=${key}
                    data-wrm-batch-type="context"
                ></script>
            </div>`;
                resourceHtml += jsResource;
            }
        });
        return resourceHtml;
    };
});
parcelRegister("8oOn8", function(module, exports) {
    $parcel$export(module.exports, "gadgetsToUniqueSortedAmdModules", ()=>$d83f51a78c4f458b$export$598e0ea2a7525181);
    $parcel$export(module.exports, "gadgetsToSortedReactGadgets", ()=>$d83f51a78c4f458b$export$f98787198c197952);
    var $JIPqS;
    var $kspzT;
    const $d83f51a78c4f458b$export$598e0ea2a7525181 = (gadgets)=>gadgets.map(({ amdModule: amdModule })=>amdModule).filter(Boolean).filter((amdModule)=>amdModule in (0, (0, parcelRequire("JIPqS")).WEB_RESOURCE_MAP)).filter((v, i, a)=>a.indexOf(v) === i).sort() ?? [];
    const $d83f51a78c4f458b$export$f98787198c197952 = (gadgets)=>gadgets.reduce((gadgetsAccumulator, gadget)=>{
            if (!(0, (0, parcelRequire("kspzT")).isReactKey)(gadget.reactKey)) return gadgetsAccumulator;
            gadgetsAccumulator.push({
                reactKey: gadget.reactKey,
                id: gadget.id,
                userPrefs: gadget.userPrefs
            });
            return gadgetsAccumulator;
        }, []).sort((a, b)=>a.id.localeCompare(b.id));
});
parcelRegister("kspzT", function(module, exports) {
    $parcel$export(module.exports, "isReactKey", ()=>$7a81ea406ace6c08$export$6acd06c99f745b49);
    $parcel$export(module.exports, "default", ()=>$7a81ea406ace6c08$export$2e2bcd8739ae039);
    var $9zbBl;
    var $kvkwL;
    var $26UOd;
    const $7a81ea406ace6c08$var$GADGETS_DEFINITION = {
        [(0, (0, parcelRequire("26UOd")).REACT_KEY).FILTER_RESULTS]: (0, (0, parcelRequire("kvkwL")).FILTER_RESULTS_DEFINITION),
        [(0, (0, parcelRequire("26UOd")).REACT_KEY).ASSIGNED_TO_ME]: (0, (0, parcelRequire("kvkwL")).ASSIGNED_TO_ME_DEFINITION),
        [(0, (0, parcelRequire("26UOd")).REACT_KEY).ISSUES_IN_PROGRESS]: (0, (0, parcelRequire("kvkwL")).ISSUES_IN_PROGRESS_DEFINITION),
        [(0, (0, parcelRequire("26UOd")).REACT_KEY).VOTED_ISSUES]: (0, (0, parcelRequire("kvkwL")).VOTED_ISSUES_DEFINITION),
        [(0, (0, parcelRequire("26UOd")).REACT_KEY).WATCHED_ISSUES]: (0, (0, parcelRequire("kvkwL")).WATCHED_ISSUES_DEFINITION),
        [(0, (0, parcelRequire("26UOd")).REACT_KEY).CUSTOM_REPORT]: (0, (0, parcelRequire("9zbBl")).default)
    };
    function $7a81ea406ace6c08$export$6acd06c99f745b49(key) {
        return !!(key && Object.values((0, (0, parcelRequire("26UOd")).REACT_KEY)).includes(key));
    }
    var $7a81ea406ace6c08$export$2e2bcd8739ae039 = $7a81ea406ace6c08$var$GADGETS_DEFINITION;
});
parcelRegister("9zbBl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$088534adc4ba7ffc$export$2e2bcd8739ae039);
    var $cDOH2;
    var $jUheV;
    var $gM7kh;
    const $088534adc4ba7ffc$var$CUSTOM_REPORT_DEFINITION = {
        componentView: (0, (0, parcelRequire("jUheV")).LazyCustomReportGadgetView),
        componentEdit: (0, (0, parcelRequire("cDOH2")).LazyCustomReportGadgetEdit),
        getInitialState: (0, parcelRequire("gM7kh")).default,
        preload: (0, parcelRequire("jUheV")).preload
    };
    var $088534adc4ba7ffc$export$2e2bcd8739ae039 = $088534adc4ba7ffc$var$CUSTOM_REPORT_DEFINITION;
});
parcelRegister("cDOH2", function(module, exports) {
    $parcel$export(module.exports, "LazyCustomReportGadgetEdit", ()=>$e8ab1a4d1d8a6eb4$export$475e4a6fb8f40116);
    var $hPtZI;
    const $e8ab1a4d1d8a6eb4$export$475e4a6fb8f40116 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("8CO5O")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/custom-report-gadget/src/ui/edit/main.tsx"
    });
});
parcelRegister("8CO5O", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("3Na4y")
    ]).then(()=>parcelRequire('chhAm'));
});
parcelRegister("jUheV", function(module, exports) {
    $parcel$export(module.exports, "LazyCustomReportGadgetView", ()=>$e43675722e4e42c6$export$27df795d4f3ff173);
    $parcel$export(module.exports, "preload", ()=>$e43675722e4e42c6$export$513ccb98c53b8039);
    var $hPtZI;
    const $e43675722e4e42c6$export$27df795d4f3ff173 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("5b6PY")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/custom-report-gadget/src/ui/view/main.tsx"
    });
    const { preload: $e43675722e4e42c6$export$513ccb98c53b8039 } = $e43675722e4e42c6$export$27df795d4f3ff173;
});
parcelRegister("5b6PY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fBPHr").then(()=>parcelRequire('e2l8c'));
});
parcelRegister("gM7kh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1132aa73a645b93$export$2e2bcd8739ae039);
    const $d1132aa73a645b93$var$getInitialState = ()=>Promise.resolve({
            intervalValue: '1',
            isCustom: 'false',
            projectValue: '0',
            refresh: 'false',
            reportValue: '0',
            gadgetContentTitle: ''
        });
    var $d1132aa73a645b93$export$2e2bcd8739ae039 = $d1132aa73a645b93$var$getInitialState;
});
parcelRegister("kvkwL", function(module, exports) {
    $parcel$export(module.exports, "FILTER_RESULTS_DEFINITION", ()=>$676d00abfb59f2ab$export$3581891d04da6bb8);
    $parcel$export(module.exports, "ASSIGNED_TO_ME_DEFINITION", ()=>$676d00abfb59f2ab$export$652d5a9cc2c18d2e);
    $parcel$export(module.exports, "ISSUES_IN_PROGRESS_DEFINITION", ()=>$676d00abfb59f2ab$export$54b46348d1ed5d22);
    $parcel$export(module.exports, "VOTED_ISSUES_DEFINITION", ()=>$676d00abfb59f2ab$export$ea96ce30d34ce354);
    $parcel$export(module.exports, "WATCHED_ISSUES_DEFINITION", ()=>$676d00abfb59f2ab$export$5109728db227eae);
    var $5uXOq = parcelRequire("5uXOq");
    var $2egG3;
    var $eZ5lN;
    var $kdIR9;
    var $dzPNh;
    var $9KhHm;
    var $5ALJk;
    var $hfHPa;
    const $676d00abfb59f2ab$var$componentViewWithAdditionalState = (Component, additionalStateProps)=>(props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                state: props.state ? {
                    ...props.state,
                    ...additionalStateProps
                } : null
            });
    const $676d00abfb59f2ab$var$componentEditWithAdditionalState = (Component, additionalStateProps)=>(props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                state: props.state ? {
                    ...props.state,
                    ...additionalStateProps
                } : null
            });
    const $676d00abfb59f2ab$var$FILTER_RESULTS_CONFIG = {
        testId: 'react-issue-table-gadgets.filter-results.view'
    };
    const $676d00abfb59f2ab$export$3581891d04da6bb8 = {
        componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, (0, parcelRequire("dzPNh")).IssueTableGadgetView), $676d00abfb59f2ab$var$FILTER_RESULTS_CONFIG),
        componentEdit: (0, (0, parcelRequire("eZ5lN")).FilterResultsGadgetEdit),
        getInitialState: (0, (0, parcelRequire("hfHPa")).default)($676d00abfb59f2ab$var$FILTER_RESULTS_CONFIG),
        preload: (0, (0, parcelRequire("dzPNh")).preload)
    };
    const $676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG = {
        predeterminedJql: 'assignee = currentUser() AND statusCategory != 3 ORDER BY priority DESC, created ASC',
        defaultSortPrefs: {
            field: 'priority',
            direction: 'DESC'
        },
        testId: 'react-issue-table-gadgets.assigned-to-me.view'
    };
    const $676d00abfb59f2ab$export$652d5a9cc2c18d2e = {
        componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, (0, parcelRequire("dzPNh")).IssueTableGadgetView), $676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG),
        componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, (0, parcelRequire("2egG3")).AssignedToMeGadgetEdit), $676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG),
        getInitialState: (0, (0, parcelRequire("hfHPa")).default)($676d00abfb59f2ab$var$ASSIGNED_TO_ME_CONFIG),
        preload: (0, (0, parcelRequire("dzPNh")).preload)
    };
    const $676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG = {
        predeterminedJql: 'status = "In Progress" AND statusCategory != Done AND assignee = currentUser() ORDER BY priority DESC, created ASC',
        defaultSortPrefs: {
            field: 'priority',
            direction: 'DESC'
        },
        testId: 'react-issue-table-gadgets.issues-in-progress.view'
    };
    const $676d00abfb59f2ab$export$54b46348d1ed5d22 = {
        componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, (0, parcelRequire("dzPNh")).IssueTableGadgetView), $676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG),
        componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, (0, parcelRequire("kdIR9")).IssuesInProgressGadgetEdit), $676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG),
        getInitialState: (0, (0, parcelRequire("hfHPa")).default)($676d00abfb59f2ab$var$ISSUES_IN_PROGRESS_CONFIG),
        preload: (0, (0, parcelRequire("dzPNh")).preload)
    };
    const $676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG = {
        predeterminedJql: 'issue in votedIssues() AND statusCategory != Done ORDER BY votes DESC',
        predeterminedJqlIncludeResolved: 'issue in votedIssues() ORDER BY votes DESC',
        defaultSortPrefs: {
            field: 'votes',
            direction: 'DESC'
        },
        testId: 'react-issue-table-gadgets.voted-issues.view'
    };
    const $676d00abfb59f2ab$export$ea96ce30d34ce354 = {
        componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, (0, parcelRequire("dzPNh")).IssueTableGadgetView), $676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG),
        componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, (0, parcelRequire("9KhHm")).VotedIssuesGadgetEdit), $676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG),
        getInitialState: (0, (0, parcelRequire("hfHPa")).default)($676d00abfb59f2ab$var$VOTED_ISSUES_CONFIG),
        preload: (0, (0, parcelRequire("dzPNh")).preload)
    };
    const $676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG = {
        predeterminedJql: 'issue in watchedIssues() AND statusCategory != Done ORDER BY watchers DESC',
        predeterminedJqlIncludeResolved: 'issue in watchedIssues() ORDER BY watchers DESC',
        defaultSortPrefs: {
            field: 'watchers',
            direction: 'DESC'
        },
        testId: 'react-issue-table-gadgets.watched-issues.view'
    };
    const $676d00abfb59f2ab$export$5109728db227eae = {
        componentView: $676d00abfb59f2ab$var$componentViewWithAdditionalState((0, (0, parcelRequire("dzPNh")).IssueTableGadgetView), $676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG),
        componentEdit: $676d00abfb59f2ab$var$componentEditWithAdditionalState((0, (0, parcelRequire("5ALJk")).WatchedIssuesGadgetEdit), $676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG),
        getInitialState: (0, (0, parcelRequire("hfHPa")).default)($676d00abfb59f2ab$var$WATCHED_ISSUES_CONFIG),
        preload: (0, (0, parcelRequire("dzPNh")).preload)
    };
});
parcelRegister("2egG3", function(module, exports) {
    $parcel$export(module.exports, "AssignedToMeGadgetEdit", ()=>$91d75e80303bba8c$export$3ae3568d16dc8f35);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $834mM;
    var $hPtZI;
    const $91d75e80303bba8c$var$LazyAssignedToMeGadgetEdit = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("40Sx2")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/assigned-to-me/edit/main.tsx"
    });
    const $91d75e80303bba8c$export$3ae3568d16dc8f35 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "assigned-to-me-gadget-edit",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("834mM")).FilterResultsEditSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($91d75e80303bba8c$var$LazyAssignedToMeGadgetEdit, props));
    const { preload: $91d75e80303bba8c$export$513ccb98c53b8039 } = $91d75e80303bba8c$var$LazyAssignedToMeGadgetEdit;
});
parcelRegister("834mM", function(module, exports) {
    $parcel$export(module.exports, "FilterResultsEditSkeleton", ()=>$92b82de956011a8a$export$e10d91ce257e7374);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $cuyZg = parcelRequire("cuyZg");
    const $92b82de956011a8a$var$customCssStyles = null;
    const $92b82de956011a8a$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT = '698px';
    const $92b82de956011a8a$export$e10d91ce257e7374 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($cuyZg))),
            containerStyles: {
                height: $92b82de956011a8a$var$FILTER_RESULTS_EDIT_ESTIMATED_HEIGHT
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wgmglyw"
            ])
        });
});
parcelRegister("cuyZg", function(module, exports) {
    module.exports = new URL("filter-results-edit-skeleton.tpl.783fb7b7.svg", import.meta.url).toString();
});
parcelRegister("40Sx2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("a1jim")
    ]).then(()=>parcelRequire('1SEAb'));
});
parcelRegister("eZ5lN", function(module, exports) {
    $parcel$export(module.exports, "FilterResultsGadgetEdit", ()=>$fa7c1c640e166488$export$6dfceca003c43832);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $834mM;
    var $hPtZI;
    const $fa7c1c640e166488$var$LazyFilterResultsGadgetEdit = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("9Plb0")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/filter-results/edit/main.tsx"
    });
    const $fa7c1c640e166488$export$6dfceca003c43832 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "filter-results-gadget-edit",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("834mM")).FilterResultsEditSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($fa7c1c640e166488$var$LazyFilterResultsGadgetEdit, props));
    const { preload: $fa7c1c640e166488$export$513ccb98c53b8039 } = $fa7c1c640e166488$var$LazyFilterResultsGadgetEdit;
});
parcelRegister("9Plb0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("2WaJa")
    ]).then(()=>parcelRequire('eKgKX'));
});
parcelRegister("kdIR9", function(module, exports) {
    $parcel$export(module.exports, "IssuesInProgressGadgetEdit", ()=>$04f85077310bce7f$export$199fec410a0f70a2);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $834mM;
    var $hPtZI;
    const $04f85077310bce7f$var$LazyIssuesInProgressGadgetEdit = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("gK4xy")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/issues-in-progress/edit/main.tsx"
    });
    const $04f85077310bce7f$export$199fec410a0f70a2 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "issues-in-progress-gadget-edit",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("834mM")).FilterResultsEditSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($04f85077310bce7f$var$LazyIssuesInProgressGadgetEdit, props));
    const { preload: $04f85077310bce7f$export$513ccb98c53b8039 } = $04f85077310bce7f$var$LazyIssuesInProgressGadgetEdit;
});
parcelRegister("gK4xy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("lNlvX")
    ]).then(()=>parcelRequire('dk51x'));
});
parcelRegister("dzPNh", function(module, exports) {
    $parcel$export(module.exports, "IssueTableGadgetView", ()=>$0c0c24e495111ec5$export$da0765a3c10e16a3);
    $parcel$export(module.exports, "preload", ()=>$0c0c24e495111ec5$export$513ccb98c53b8039);
    var $5uXOq = parcelRequire("5uXOq");
    var $JIPqS;
    var $lfTZh;
    var $dNZVN;
    var $hPtZI;
    const $0c0c24e495111ec5$var$LazyIssueTableGadgetView = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("4J2zw")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/view/main.tsx"
    });
    const $0c0c24e495111ec5$export$da0765a3c10e16a3 = ({ customSkeletonHeightInPx: customSkeletonHeightInPx, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "filter-results-gadget-view",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dNZVN")).FilterResultsIssueTableSkeleton), {
                height: `${customSkeletonHeightInPx ?? (0, (0, parcelRequire("JIPqS")).GADGET_DEFAULT_HEIGHT)}px`
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0c0c24e495111ec5$var$LazyIssueTableGadgetView, {
            customSkeletonHeightInPx: customSkeletonHeightInPx,
            ...props
        }));
    const { preload: $0c0c24e495111ec5$export$513ccb98c53b8039 } = $0c0c24e495111ec5$var$LazyIssueTableGadgetView;
});
parcelRegister("dNZVN", function(module, exports) {
    $parcel$export(module.exports, "FilterResultsIssueTableSkeleton", ()=>$a73c71eae267b518$export$35d754053deeac73);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $dCGjE = parcelRequire("dCGjE");
    const $a73c71eae267b518$var$customCssStyles = null;
    const $a73c71eae267b518$export$35d754053deeac73 = ({ height: height })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($dCGjE))),
            containerStyles: {
                height: height
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wgmglyw"
            ])
        });
});
parcelRegister("dCGjE", function(module, exports) {
    module.exports = new URL("filter-results-issue-table-skeleton.tpl.a502204a.svg", import.meta.url).toString();
});
parcelRegister("4J2zw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kLRoU")
    ]).then(()=>parcelRequire('dfMo9'));
});
parcelRegister("9KhHm", function(module, exports) {
    $parcel$export(module.exports, "VotedIssuesGadgetEdit", ()=>$0ca7bf6a0d6f5346$export$7650b85a7a54914);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $834mM;
    var $hPtZI;
    const $0ca7bf6a0d6f5346$var$LazyVotedIssuesGadgetEdit = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("2Bzr9")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/voted-issues/edit/main.tsx"
    });
    const $0ca7bf6a0d6f5346$export$7650b85a7a54914 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "voted-issues-gadget-edit",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("834mM")).FilterResultsEditSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0ca7bf6a0d6f5346$var$LazyVotedIssuesGadgetEdit, props));
    const { preload: $0ca7bf6a0d6f5346$export$513ccb98c53b8039 } = $0ca7bf6a0d6f5346$var$LazyVotedIssuesGadgetEdit;
});
parcelRegister("2Bzr9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("bNNoR")
    ]).then(()=>parcelRequire('irHWu'));
});
parcelRegister("5ALJk", function(module, exports) {
    $parcel$export(module.exports, "WatchedIssuesGadgetEdit", ()=>$278dbe55a7acf378$export$a53864bd0bf8a85f);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $834mM;
    var $hPtZI;
    const $278dbe55a7acf378$var$LazyWatchedIssuesGadgetEdit = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("lGwmd")), {
        moduleId: "./src/packages/global-pages/dashboard/react-gadgets/issue-table-gadgets/src/ui/watched-issues/edit/main.tsx"
    });
    const $278dbe55a7acf378$export$a53864bd0bf8a85f = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "watched-issues-gadget-edit",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("834mM")).FilterResultsEditSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($278dbe55a7acf378$var$LazyWatchedIssuesGadgetEdit, props));
    const { preload: $278dbe55a7acf378$export$513ccb98c53b8039 } = $278dbe55a7acf378$var$LazyWatchedIssuesGadgetEdit;
});
parcelRegister("lGwmd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("h7Bte")
    ]).then(()=>parcelRequire('iLll9'));
});
parcelRegister("hfHPa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f27ae6f4005fc53$export$2e2bcd8739ae039);
    var $fJpBG;
    var $lgZ6q;
    var $8rq2P;
    var $jyMtv;
    const $9f27ae6f4005fc53$var$createGetInitialState = ({ predeterminedJql: predeterminedJql, predeterminedJqlIncludeResolved: predeterminedJqlIncludeResolved, defaultSortPrefs: defaultSortPrefs, testId: testId })=>async (resourceContext, userPrefs)=>{
            if (resourceContext?.tenantContext == null) throw new Error('Tenant context is not available');
            const { cloudId: cloudId, activationId: activationId } = resourceContext.tenantContext;
            const validUserPrefs = (0, (0, parcelRequire("jyMtv")).transformToValidUserPrefs)((0, (0, parcelRequire("fJpBG")).decodeUserPreferences)(userPrefs));
            if (validUserPrefs.filterId === undefined && predeterminedJql === undefined && predeterminedJqlIncludeResolved === undefined) throw new Error('FilterId or JQL has to be available to be able to load the gadget initial state');
            const sortPrefs = (()=>{
                if (validUserPrefs.sortField) return {
                    sortField: validUserPrefs.sortField,
                    sortDirection: validUserPrefs.sortDirection
                };
                if (defaultSortPrefs) return {
                    sortField: defaultSortPrefs.field,
                    sortDirection: defaultSortPrefs.direction
                };
            })();
            const includeResolved = validUserPrefs.showResolved;
            const jql = includeResolved ? predeterminedJqlIncludeResolved : predeterminedJql;
            const queryReference = await (0, (0, parcelRequire("8rq2P")).loadQueryWithUserPrefs)({
                ...validUserPrefs,
                ...sortPrefs
            }, (0, (0, parcelRequire("lgZ6q")).default), cloudId, activationId, 'store-and-network', jql);
            return {
                queryReference: queryReference,
                predeterminedJql: predeterminedJql,
                defaultSortPrefs: defaultSortPrefs,
                testId: testId
            };
        };
    var $9f27ae6f4005fc53$export$2e2bcd8739ae039 = $9f27ae6f4005fc53$var$createGetInitialState;
});
parcelRegister("fJpBG", function(module, exports) {
    $parcel$export(module.exports, "getUserPreferences", ()=>$a6145919a3771254$export$ae3f5fa351e2f57a);
    $parcel$export(module.exports, "decodeUserPreferences", ()=>$a6145919a3771254$export$ebdfc6c2778ef8e2);
    var $7f4tk;
    const $a6145919a3771254$var$isBooleanString = (str)=>[
            'true',
            'false'
        ].includes(str.toLowerCase().trim());
    const $a6145919a3771254$var$stringToBoolean = (str)=>str.toLowerCase().trim() === 'true';
    const $a6145919a3771254$export$ae3f5fa351e2f57a = (action)=>(0, (0, parcelRequire("7f4tk")).default)(action);
    const $a6145919a3771254$export$ebdfc6c2778ef8e2 = (userPreferences = [])=>userPreferences.reduce((output, { value: value, name: name })=>({
                ...output,
                [name]: $a6145919a3771254$var$isBooleanString(value) ? $a6145919a3771254$var$stringToBoolean(value) : value
            }), {});
});
parcelRegister("lgZ6q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$328d775330990290$export$2e2bcd8739ae039);
    var $6nwMW;
    var $1ZvTA;
    var $G39h7;
    var $6vKPN;
    var $1kHcz;
    const $328d775330990290$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "amountOfColumns"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "fieldSetIds"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterId"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v7 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isNotFilterFetch"
        }, v8 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueSearchInput"
        }, v9 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueTypeId"
        }, v10 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "namespace"
        }, v11 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }, v12 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryFieldSetsById"
        }, v13 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "viewId"
        }, v14 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v15 = {
            "kind": "ScalarField",
            "name": "key"
        }, v16 = {
            "kind": "ScalarField",
            "name": "id"
        }, v17 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v18 = {
            "kind": "ScalarField",
            "name": "fieldId"
        }, v19 = {
            "kind": "ScalarField",
            "name": "statusCategoryId"
        }, v20 = {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                v19,
                v16
            ]
        }, v21 = {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        }, v22 = {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        }, v23 = {
            "kind": "ScalarField",
            "name": "type"
        }, v24 = {
            "kind": "ScalarField",
            "name": "fieldSetId"
        }, v25 = {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isJiraIssueField"
        }, v26 = {
            "kind": "ScalarField",
            "name": "name"
        }, v27 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraAffectedServiceConnection",
                    "kind": "LinkedField",
                    "name": "selectedAffectedServicesConnection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraAffectedServiceEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraAffectedService",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "serviceId"
                                        },
                                        v26,
                                        v16
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraAffectedServicesField"
        }, v28 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraCmdbObjectConnection",
                    "kind": "LinkedField",
                    "name": "selectedCmdbObjectsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraCmdbObjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraCmdbObject",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "objectId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "label"
                                        },
                                        {
                                            "concreteType": "JiraCmdbAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "url48"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "QueryError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraCMDBField"
        }, v29 = [
            v26,
            v16
        ], v30 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraComponentConnection",
                    "kind": "LinkedField",
                    "name": "selectedComponentsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraComponentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraComponent",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": v29
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraComponentsField"
        }, v31 = {
            "kind": "ScalarField",
            "name": "date"
        }, v32 = {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isRequired"
                }
            ]
        }, v33 = {
            "kind": "ScalarField",
            "name": "lazyIsEditableInIssueView"
        }, v34 = {
            "kind": "ClientExtension",
            "selections": [
                v33
            ]
        }, v35 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "dateTime"
                }
            ],
            "type": "JiraDateTimePickerField"
        }, v36 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraEpic",
                    "kind": "LinkedField",
                    "name": "epic",
                    "plural": false,
                    "selections": [
                        v15,
                        {
                            "kind": "ScalarField",
                            "name": "summary"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "color"
                        },
                        v16
                    ]
                }
            ],
            "type": "JiraEpicLinkField"
        }, v37 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "renderedFieldHtml"
                }
            ],
            "type": "JiraFallbackField"
        }, v38 = {
            "kind": "ScalarField",
            "name": "text"
        }, v39 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraStatusCategory",
                    "kind": "LinkedField",
                    "name": "statusCategory",
                    "plural": false,
                    "selections": [
                        v26,
                        v19,
                        v16
                    ]
                }
            ],
            "type": "JiraStatusCategoryField"
        }, v40 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraStatus",
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                        v26,
                        {
                            "kind": "ScalarField",
                            "name": "statusId"
                        },
                        v20,
                        v16
                    ]
                }
            ],
            "type": "JiraStatusField"
        }, v41 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v42 = {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                }
            ],
            "concreteType": "JiraLabelConnection",
            "kind": "LinkedField",
            "name": "selectedLabelsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraLabelEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraLabel",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v26
                            ]
                        }
                    ]
                },
                v41
            ],
            "storageKey": "selectedLabelsConnection(first:1000)"
        }, v43 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "issueType",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "small"
                                }
                            ]
                        },
                        v26,
                        v16
                    ]
                }
            ],
            "type": "JiraIssueTypeField"
        }, v44 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "xsmall"
                }
            ]
        }, v45 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "parentIssue",
                    "plural": false,
                    "selections": [
                        v15,
                        {
                            "concreteType": "JiraSingleLineTextField",
                            "kind": "LinkedField",
                            "name": "summaryField",
                            "plural": false,
                            "selections": [
                                v38,
                                v16
                            ]
                        },
                        v16,
                        {
                            "concreteType": "JiraColorField",
                            "kind": "LinkedField",
                            "name": "issueColorField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraColor",
                                    "kind": "LinkedField",
                                    "name": "color",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "colorKey"
                                        },
                                        v16
                                    ]
                                },
                                v16
                            ]
                        },
                        {
                            "concreteType": "JiraIssueTypeField",
                            "kind": "LinkedField",
                            "name": "issueTypeField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                        v44,
                                        v26,
                                        v16
                                    ]
                                },
                                v16
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraParentIssueField"
        }, v46 = {
            "concreteType": "JiraPriority",
            "kind": "LinkedField",
            "name": "priority",
            "plural": false,
            "selections": [
                v26,
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                },
                v16
            ]
        }, v47 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        v26,
                        v15,
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "large"
                                }
                            ]
                        },
                        v16
                    ]
                }
            ],
            "type": "JiraProjectField"
        }, v48 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraResolution",
                    "kind": "LinkedField",
                    "name": "resolution",
                    "plural": false,
                    "selections": v29
                }
            ],
            "type": "JiraResolutionField"
        }, v49 = {
            "concreteType": "JiraSprintConnection",
            "kind": "LinkedField",
            "name": "selectedSprintsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraSprintEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraSprint",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v16,
                                {
                                    "kind": "ScalarField",
                                    "name": "sprintId"
                                },
                                v26,
                                {
                                    "kind": "ScalarField",
                                    "name": "state"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }, v50 = {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                v17,
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                {
                    "kind": "ScalarField",
                    "name": "picture"
                },
                v26,
                v16,
                {
                    "kind": "ScalarField",
                    "name": "accountStatus"
                }
            ]
        }, v51 = {
            "kind": "InlineFragment",
            "selections": [
                v26,
                {
                    "concreteType": "JiraVersionConnection",
                    "kind": "LinkedField",
                    "name": "selectedVersionsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraVersionEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": v29
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraMultipleVersionPickerField"
        }, v52 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraRichText",
                    "kind": "LinkedField",
                    "name": "richText",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraADF",
                            "kind": "LinkedField",
                            "name": "adfValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "json"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraRichTextField"
        }, v53 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraServiceManagementRequestType",
                    "kind": "LinkedField",
                    "name": "requestType",
                    "plural": false,
                    "selections": [
                        v26,
                        v44,
                        v16
                    ]
                }
            ],
            "type": "JiraServiceManagementRequestTypeField"
        }, v54 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                        }
                    ],
                    "concreteType": "JiraIssueLinkConnection",
                    "kind": "LinkedField",
                    "name": "issueLinkConnection",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v41
                            ]
                        },
                        {
                            "concreteType": "JiraIssueLinkEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueLink",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "issue",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                },
                                                v15,
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "ids",
                                                            "value": [
                                                                "statusCategory"
                                                            ]
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v17,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v20
                                                                            ],
                                                                            "type": "JiraStatusCategoryField"
                                                                        },
                                                                        v16
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                },
                                                v16
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "relationName"
                                        },
                                        v16
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraIssueLinkField"
        }, v55 = {
            "kind": "ScalarField",
            "name": "isStoryPointField"
        }, v56 = {
            "kind": "ScalarField",
            "name": "number"
        }, v57 = [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v23,
                            v24,
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v17,
                                                    v18,
                                                    v23,
                                                    v25,
                                                    v16,
                                                    v27,
                                                    v28,
                                                    v30,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v31,
                                                            v26,
                                                            v32,
                                                            v34
                                                        ],
                                                        "type": "JiraDatePickerField"
                                                    },
                                                    v35,
                                                    v36,
                                                    v37,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v38,
                                                            v26,
                                                            v34
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    v39,
                                                    v40,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v42,
                                                            v26,
                                                            v34
                                                        ],
                                                        "type": "JiraLabelsField"
                                                    },
                                                    v43,
                                                    v45,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v46,
                                                            v26,
                                                            v34
                                                        ],
                                                        "type": "JiraPriorityField"
                                                    },
                                                    v47,
                                                    v48,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v49,
                                                            v26,
                                                            v34
                                                        ],
                                                        "type": "JiraSprintField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v50,
                                                            v26,
                                                            v32,
                                                            v34
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                    },
                                                    v51,
                                                    v52,
                                                    v53,
                                                    v54,
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v55,
                                                                    v56,
                                                                    v26,
                                                                    v34
                                                                ],
                                                                "type": "JiraNumberField"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ], v58 = {
            "condition": "shouldQueryFieldSetsById",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        v21,
                        v22
                    ],
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSetsById",
                    "plural": false,
                    "selections": v57
                }
            ]
        }, v59 = {
            "condition": "shouldQueryFieldSetsById",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "fields": [
                                {
                                    "fields": [
                                        {
                                            "kind": "Variable",
                                            "name": "issueType",
                                            "variableName": "issueTypeId"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "project",
                                            "variableName": "projectId"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "projectContext"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "context"
                        },
                        {
                            "kind": "Variable",
                            "name": "filterId",
                            "variableName": "filterId"
                        },
                        v22,
                        {
                            "kind": "Variable",
                            "name": "namespace",
                            "variableName": "namespace"
                        },
                        {
                            "kind": "Variable",
                            "name": "viewId",
                            "variableName": "viewId"
                        }
                    ],
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSetsForIssueSearchView",
                    "plural": false,
                    "selections": v57
                }
            ]
        }, v60 = [
            {
                "kind": "ScalarField",
                "name": "cursor"
            },
            {
                "kind": "ScalarField",
                "name": "pageNumber"
            },
            {
                "kind": "ScalarField",
                "name": "isCurrent"
            }
        ], v61 = {
            "kind": "ScalarField",
            "name": "displayName"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    v13
                ],
                "kind": "Fragment",
                "name": "issueTableViewQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "issueTableView_reactIssueTableGadgets"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v2,
                    v8,
                    v10,
                    v13,
                    v1,
                    v3,
                    v12,
                    v0,
                    v6,
                    v4,
                    v7,
                    v5,
                    v9,
                    v11,
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                    }
                ],
                "kind": "Operation",
                "name": "issueTableViewQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "after",
                                        "variableName": "after"
                                    },
                                    v14,
                                    {
                                        "kind": "Variable",
                                        "name": "first",
                                        "variableName": "first"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "issueSearchInput",
                                        "variableName": "issueSearchInput"
                                    }
                                ],
                                "concreteType": "JiraIssueConnection",
                                "kind": "LinkedField",
                                "name": "issueSearchStable",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v15,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "issueId"
                                                    },
                                                    v16,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isResolved"
                                                    },
                                                    {
                                                        "args": [
                                                            {
                                                                "kind": "Literal",
                                                                "name": "ids",
                                                                "value": [
                                                                    "status"
                                                                ]
                                                            }
                                                        ],
                                                        "concreteType": "JiraIssueFieldConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fieldsById",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraIssueFieldEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "node",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v17,
                                                                            {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                    v18,
                                                                                    {
                                                                                        "concreteType": "JiraStatus",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "status",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v20,
                                                                                            v16
                                                                                        ]
                                                                                    }
                                                                                ],
                                                                                "type": "JiraStatusField"
                                                                            },
                                                                            v16
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "storageKey": "fieldsById(ids:[\"status\"])"
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "hasChildren"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": false,
                                                        "selections": [
                                                            v58,
                                                            v59
                                                        ]
                                                    },
                                                    {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            v58,
                                                            v59,
                                                            {
                                                                "kind": "ClientExtension",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueFieldSetConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueRowFieldSets",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueFieldSetEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssueFieldSet",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v23,
                                                                                            v24,
                                                                                            {
                                                                                                "concreteType": "JiraIssueFieldConnection",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "fields",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "concreteType": "JiraIssueFieldEdge",
                                                                                                        "kind": "LinkedField",
                                                                                                        "name": "edges",
                                                                                                        "plural": true,
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "LinkedField",
                                                                                                                "name": "node",
                                                                                                                "plural": false,
                                                                                                                "selections": [
                                                                                                                    v17,
                                                                                                                    v18,
                                                                                                                    v23,
                                                                                                                    v25,
                                                                                                                    v16,
                                                                                                                    v27,
                                                                                                                    v28,
                                                                                                                    v30,
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            v31,
                                                                                                                            v33,
                                                                                                                            v26,
                                                                                                                            v32
                                                                                                                        ],
                                                                                                                        "type": "JiraDatePickerField"
                                                                                                                    },
                                                                                                                    v35,
                                                                                                                    v36,
                                                                                                                    v37,
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            v38,
                                                                                                                            v33,
                                                                                                                            v26
                                                                                                                        ],
                                                                                                                        "type": "JiraSingleLineTextField"
                                                                                                                    },
                                                                                                                    v39,
                                                                                                                    v40,
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            v42,
                                                                                                                            v33,
                                                                                                                            v26
                                                                                                                        ],
                                                                                                                        "type": "JiraLabelsField"
                                                                                                                    },
                                                                                                                    v43,
                                                                                                                    v45,
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            v33,
                                                                                                                            v46,
                                                                                                                            v26
                                                                                                                        ],
                                                                                                                        "type": "JiraPriorityField"
                                                                                                                    },
                                                                                                                    v47,
                                                                                                                    v48,
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            v33,
                                                                                                                            v49,
                                                                                                                            v26
                                                                                                                        ],
                                                                                                                        "type": "JiraSprintField"
                                                                                                                    },
                                                                                                                    {
                                                                                                                        "kind": "InlineFragment",
                                                                                                                        "selections": [
                                                                                                                            v50,
                                                                                                                            v33,
                                                                                                                            v26,
                                                                                                                            v32
                                                                                                                        ],
                                                                                                                        "type": "JiraSingleSelectUserPickerField"
                                                                                                                    },
                                                                                                                    v51,
                                                                                                                    v52,
                                                                                                                    v53,
                                                                                                                    v54,
                                                                                                                    {
                                                                                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider",
                                                                                                                        "kind": "Condition",
                                                                                                                        "passingValue": true,
                                                                                                                        "selections": [
                                                                                                                            {
                                                                                                                                "kind": "InlineFragment",
                                                                                                                                "selections": [
                                                                                                                                    v55,
                                                                                                                                    v56,
                                                                                                                                    v33,
                                                                                                                                    v26
                                                                                                                                ],
                                                                                                                                "type": "JiraNumberField"
                                                                                                                            }
                                                                                                                        ]
                                                                                                                    }
                                                                                                                ]
                                                                                                            }
                                                                                                        ]
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ClientExtension",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "isHighlightedIssueRow"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            v17
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "totalIssueSearchResultCount"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "isCappingIssueSearchResult"
                                    },
                                    {
                                        "concreteType": "JiraIssueNavigatorPageInfo",
                                        "kind": "LinkedField",
                                        "name": "issueNavigatorPageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "firstIssuePosition"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "lastIssuePosition"
                                            }
                                        ]
                                    },
                                    {
                                        "args": [
                                            {
                                                "kind": "Literal",
                                                "name": "maxCursors",
                                                "value": 7
                                            },
                                            {
                                                "kind": "Variable",
                                                "name": "pageSize",
                                                "variableName": "first"
                                            }
                                        ],
                                        "concreteType": "JiraPageCursors",
                                        "kind": "LinkedField",
                                        "name": "pageCursors",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraPageCursor",
                                                "kind": "LinkedField",
                                                "name": "first",
                                                "plural": false,
                                                "selections": v60
                                            },
                                            {
                                                "concreteType": "JiraPageCursor",
                                                "kind": "LinkedField",
                                                "name": "around",
                                                "plural": true,
                                                "selections": v60
                                            },
                                            {
                                                "concreteType": "JiraPageCursor",
                                                "kind": "LinkedField",
                                                "name": "last",
                                                "plural": false,
                                                "selections": v60
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ClientExtension",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__id"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": [
                                    v14,
                                    v21
                                ],
                                "concreteType": "JiraIssueSearchFieldSetConnection",
                                "kind": "LinkedField",
                                "name": "fieldSetsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueSearchFieldSetEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueSearchFieldSet",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v24,
                                                    v23,
                                                    v61,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "jqlTerm"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isSortable"
                                                    },
                                                    {
                                                        "concreteType": "JiraFieldSetPreferences",
                                                        "kind": "LinkedField",
                                                        "name": "fieldSetPreferences",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "width"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JiraFieldType",
                                                        "kind": "LinkedField",
                                                        "name": "fieldType",
                                                        "plural": false,
                                                        "selections": [
                                                            v61
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    v41
                                ]
                            },
                            {
                                "condition": "isNotFilterFetch",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "id",
                                                "variableName": "filterAri"
                                            }
                                        ],
                                        "kind": "LinkedField",
                                        "name": "filter",
                                        "plural": false,
                                        "selections": [
                                            v17,
                                            v26,
                                            {
                                                "kind": "ScalarField",
                                                "name": "jql"
                                            },
                                            v16
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "f535fd5620adad4ea66c0101868b5e3fe364e9d8bf2922c3536406726a74d539",
                "metadata": {},
                "name": "issueTableViewQuery",
                "operationKind": "query",
                "text": null,
                "providedVariables": {
                    "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider": (0, (0, parcelRequire("6nwMW")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider": (0, (0, parcelRequire("6vKPN")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider": (0, (0, parcelRequire("1kHcz")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider": (0, (0, parcelRequire("G39h7")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider": (0, (0, parcelRequire("1ZvTA")).default)
                }
            }
        };
    }();
    $328d775330990290$var$node.hash = "8891cc5970ec5dda89c557d11236c0df";
    var $328d775330990290$export$2e2bcd8739ae039 = $328d775330990290$var$node;
});
parcelRegister("6nwMW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f1a5d4fbd61a98a$export$2e2bcd8739ae039);
    var $4R6GH;
    var $7f1a5d4fbd61a98a$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('jsc_-_m2_hierarchy_api_updates');
        }
    };
});
parcelRegister("1ZvTA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2d6cdb57bd1e2ae2$export$2e2bcd8739ae039);
    var $4R6GH;
    var $2d6cdb57bd1e2ae2$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('nin-issue-links-entry-point') ? 1 : 1000;
        }
    };
});
parcelRegister("G39h7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$21fc1eb961f329e9$export$2e2bcd8739ae039);
    var $4R6GH;
    var $21fc1eb961f329e9$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('nin-issue-links-entry-point');
        }
    };
});
parcelRegister("6vKPN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ea3753541dd030fd$export$2e2bcd8739ae039);
    var $4R6GH;
    var $ea3753541dd030fd$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('jira_spreadsheet_component_m1_api_updates');
        }
    };
});
parcelRegister("1kHcz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f1be49b7b7e3e3c$export$2e2bcd8739ae039);
    var $4R6GH;
    var $9f1be49b7b7e3e3c$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('nike_chin_story_points_inline_edit');
        }
    };
});
parcelRegister("8rq2P", function(module, exports) {
    $parcel$export(module.exports, "loadQueryWithUserPrefs", ()=>$3de2b9db429d32f1$export$700e212b8b5c678f);
    var $8Uumt = parcelRequire("8Uumt");
    var $5yJb9;
    var $kipqU;
    var $2mSjU;
    async function $3de2b9db429d32f1$export$700e212b8b5c678f({ filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection }, query, cloudId, activationId, fetchPolicy = 'store-or-network', jql) {
        const { variables: variables } = await (0, (0, parcelRequire("2mSjU")).transformToVariables)({
            userPrefs: {
                filterId: filterId,
                columnNames: columnNames,
                num: num,
                sortField: sortField,
                sortDirection: sortDirection
            },
            cloudId: cloudId,
            activationId: activationId,
            jql: jql
        });
        const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), query, variables, {
            fetchPolicy: fetchPolicy
        });
        if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
        return queryReference;
    }
});
parcelRegister("2mSjU", function(module, exports) {
    $parcel$export(module.exports, "transformToVariables", ()=>$1eea58ad38e5fdd1$export$a5cefa50115212b3);
    var $axGKd;
    var $czfFt;
    var $t3Q07;
    var $796ok;
    const $1eea58ad38e5fdd1$export$a5cefa50115212b3 = async ({ userPrefs: userPrefs, cloudId: cloudId, activationId: activationId, jql: jql, fetchIssueTableJqlFields: fetchIssueTableJqlFields })=>{
        const { filterId: filterId, columnNames: columnNames, num: num, sortField: sortField, sortDirection: sortDirection, showResolved: showResolved } = userPrefs;
        const filterAri = !jql && filterId ? (0, (0, parcelRequire("axGKd")).JiraFilterAri).create({
            filterId: filterId,
            siteId: cloudId,
            activationId: activationId
        }).toString() : '';
        const variables = {
            cloudId: cloudId,
            issueSearchInput: {
                ...jql ? {
                    jql: jql
                } : {
                    filterId: filterId
                }
            },
            after: null,
            first: num,
            fieldSetIds: columnNames,
            amountOfColumns: (0, (0, parcelRequire("czfFt")).MAX_COLUMNS),
            shouldQueryFieldSetsById: true,
            isNotFilterFetch: !filterAri,
            filterAri: filterAri
        };
        let fieldToJqlTermMap = new Map();
        if (!sortField || !sortDirection || ![
            'ASC',
            'DESC'
        ].includes(sortDirection)) return {
            variables: variables,
            fieldToJqlTermMap: fieldToJqlTermMap
        };
        let jqlToModify = jql;
        if (fetchIssueTableJqlFields && !jqlToModify && filterAri) {
            const result = await fetchIssueTableJqlFields(filterAri, variables.fieldSetIds, cloudId);
            fieldToJqlTermMap = result.fieldToJqlTermMap;
            jqlToModify = result.searchJql;
        }
        if (!jqlToModify) return {
            variables: variables,
            fieldToJqlTermMap: fieldToJqlTermMap
        };
        const [{ JqlUtils: JqlUtils }, { default: removeFieldClauseFromJql }, { default: findClauseInAst }] = await Promise.all([
            (parcelRequire("aH9Ys")),
            (parcelRequire("dbjD6")),
            (parcelRequire("6nHQF"))
        ]);
        const jqlUtils = new JqlUtils();
        const jqlTermForSortField = (0, (0, parcelRequire("796ok")).getJqlTermForField)(sortField, fieldToJqlTermMap);
        const modifiedJql = jqlUtils.jql(jqlToModify);
        const oldPrimarySortField = modifiedJql.getPrimarySortField();
        if (oldPrimarySortField) {
            const aliases = (0, (0, parcelRequire("t3Q07")).getAliasesForField)(jqlTermForSortField, fieldToJqlTermMap);
            const inclusiveAliases = Array.from(new Set([
                ...aliases,
                oldPrimarySortField
            ]));
            modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, inclusiveAliases);
        } else modifiedJql.setPrimarySortField(jqlTermForSortField, sortDirection, []);
        let finalJql = modifiedJql.jqlString;
        if (showResolved) {
            const jast = modifiedJql.jast;
            if (jast) {
                const statusClause = findClauseInAst(jast, 'statusCategory');
                if (statusClause) finalJql = removeFieldClauseFromJql(jast, statusClause);
            }
        }
        return {
            variables: {
                ...variables,
                issueSearchInput: {
                    jql: finalJql
                }
            },
            fieldToJqlTermMap: fieldToJqlTermMap
        };
    };
});
parcelRegister("czfFt", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$7f8ee02f08da8eac$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$7f8ee02f08da8eac$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "SORT_ASC", ()=>$7f8ee02f08da8eac$export$88956207daf9a17e);
    $parcel$export(module.exports, "SORT_DESC", ()=>$7f8ee02f08da8eac$export$bc14f97913aaf2a);
    $parcel$export(module.exports, "SORT_NONE", ()=>$7f8ee02f08da8eac$export$9c424bf3e8ffe64e);
    $parcel$export(module.exports, "MODIFY_COLUMNS", ()=>$7f8ee02f08da8eac$export$1f921c78ce6d243c);
    $parcel$export(module.exports, "REORDER_COLUMNS", ()=>$7f8ee02f08da8eac$export$83371d6c41a974aa);
    $parcel$export(module.exports, "MOVE_COLUMN_FIRST", ()=>$7f8ee02f08da8eac$export$957d455bb65919d8);
    $parcel$export(module.exports, "MOVE_COLUMN_LEFT", ()=>$7f8ee02f08da8eac$export$2082861c970802b0);
    $parcel$export(module.exports, "MOVE_COLUMN_RIGHT", ()=>$7f8ee02f08da8eac$export$21847d308b0769ad);
    $parcel$export(module.exports, "MOVE_COLUMN_LAST", ()=>$7f8ee02f08da8eac$export$c32913bc261af82d);
    $parcel$export(module.exports, "ROW_HEIGHT", ()=>$7f8ee02f08da8eac$export$88e6c5bab2ff80e8);
    $parcel$export(module.exports, "COLUMN_ID_MEATBALL_MENU", ()=>$7f8ee02f08da8eac$export$de4c02b525d877fa);
    $parcel$export(module.exports, "COLUMN_ID_EXPAND_BUTTON", ()=>$7f8ee02f08da8eac$export$c3266da279aa6b84);
    $parcel$export(module.exports, "COLUMN_ID_CHECKBOX", ()=>$7f8ee02f08da8eac$export$66b2a4a5f67468ac);
    $parcel$export(module.exports, "ACTION_COLUMNS", ()=>$7f8ee02f08da8eac$export$3dbdc5c16825be4d);
    $parcel$export(module.exports, "EXPAND_BUTTON_WIDTH", ()=>$7f8ee02f08da8eac$export$a1c171a82c45d53f);
    $parcel$export(module.exports, "EXPAND_CELL_PADDING", ()=>$7f8ee02f08da8eac$export$9c5dd6078b37aac2);
    $parcel$export(module.exports, "MAX_COLUMNS", ()=>$7f8ee02f08da8eac$export$7ec4af037f372df4);
    $parcel$export(module.exports, "CHILD_QUERY_PAGE_SIZE", ()=>$7f8ee02f08da8eac$export$d2372dfbd4e91a11);
    $parcel$export(module.exports, "KNOWN_COLUMN_TYPES", ()=>$7f8ee02f08da8eac$export$bbc2e8c301f97f97);
    $parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", ()=>$7f8ee02f08da8eac$export$1adf7afff96bbf16);
    $parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH_COMPACT", ()=>$7f8ee02f08da8eac$export$10016003aa27fa67);
    $parcel$export(module.exports, "MINIMUM_COLUMN_WIDTH", ()=>$7f8ee02f08da8eac$export$5575b9e0ed3ff59f);
    $parcel$export(module.exports, "DEFAULT_COLUMN_WIDTH", ()=>$7f8ee02f08da8eac$export$7c3f559e2ca95fa);
    $parcel$export(module.exports, "MAXIMUM_COLUMN_WIDTH", ()=>$7f8ee02f08da8eac$export$e1a42c2fefb5af25);
    $parcel$export(module.exports, "COLUMN_WIDTH_TEXT_LONG", ()=>$7f8ee02f08da8eac$export$bfe09a9186b98f8f);
    $parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SHORT", ()=>$7f8ee02f08da8eac$export$f2540f34b796306d);
    $parcel$export(module.exports, "COLUMN_WIDTH_TEXT_SUMMARY", ()=>$7f8ee02f08da8eac$export$954afb0fcf5a326);
    $parcel$export(module.exports, "COLUMN_OPERATION_REORDER", ()=>$7f8ee02f08da8eac$export$93758649595b2d58);
    $parcel$export(module.exports, "COLUMN_OPERATION_RESIZE", ()=>$7f8ee02f08da8eac$export$cad8c6a0b6e78898);
    $parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_FULL_HEIGHT", ()=>$7f8ee02f08da8eac$export$754b76ac8fa63350);
    $parcel$export(module.exports, "COLUMN_RESIZE_HANDLE_HEADER_ONLY", ()=>$7f8ee02f08da8eac$export$fa5c7dad7ee16383);
    $parcel$export(module.exports, "DENSITY_COMPACT", ()=>$7f8ee02f08da8eac$export$6c0a5a77457ca62);
    $parcel$export(module.exports, "DENSITY_FULL", ()=>$7f8ee02f08da8eac$export$119d8ab9a5bc4b2);
    $parcel$export(module.exports, "LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE", ()=>$7f8ee02f08da8eac$export$9ef77944c441ad07);
    $parcel$export(module.exports, "LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE", ()=>$7f8ee02f08da8eac$export$c1f680390b97c9e1);
    $parcel$export(module.exports, "CHILD_ITEMS_EXPERIENCE", ()=>$7f8ee02f08da8eac$export$e03155205bf92428);
    $parcel$export(module.exports, "CHILD_ITEMS_LOAD_MORE_EXPERIENCE", ()=>$7f8ee02f08da8eac$export$311c64c0d94dcdf3);
    $parcel$export(module.exports, "ANALYTICS_SOURCE", ()=>$7f8ee02f08da8eac$export$f7109619a5e9e0d6);
    const $7f8ee02f08da8eac$export$b8b9d90f9e5bd72b = 'jiraNativeIssueTable';
    const $7f8ee02f08da8eac$export$d57b6b390e78d90f = 'empanada';
    const $7f8ee02f08da8eac$export$88956207daf9a17e = 'ASC';
    const $7f8ee02f08da8eac$export$bc14f97913aaf2a = 'DESC';
    const $7f8ee02f08da8eac$export$9c424bf3e8ffe64e = 'NONE';
    const $7f8ee02f08da8eac$export$1f921c78ce6d243c = 'MODIFY_COLUMNS';
    const $7f8ee02f08da8eac$export$83371d6c41a974aa = 'REORDER_COLUMNS';
    const $7f8ee02f08da8eac$export$957d455bb65919d8 = 'MOVE_COLUMN_FIRST';
    const $7f8ee02f08da8eac$export$2082861c970802b0 = 'MOVE_COLUMN_LEFT';
    const $7f8ee02f08da8eac$export$21847d308b0769ad = 'MOVE_COLUMN_RIGHT';
    const $7f8ee02f08da8eac$export$c32913bc261af82d = 'MOVE_COLUMN_LAST';
    const $7f8ee02f08da8eac$export$e2bd4c1faded7921 = '1px';
    const $7f8ee02f08da8eac$export$cdb7fd9d999c7168 = 40;
    const $7f8ee02f08da8eac$export$88e6c5bab2ff80e8 = 40;
    const $7f8ee02f08da8eac$export$d5120333bf67ced2 = ()=>"var(--ds-space-300, 24px)";
    const $7f8ee02f08da8eac$export$a3c854b50595c804 = ()=>"var(--ds-space-050, 4px)";
    const $7f8ee02f08da8eac$export$de4c02b525d877fa = '__issuetable_internal_meatball';
    const $7f8ee02f08da8eac$export$c3266da279aa6b84 = '__issuetable_internal_expand_button';
    const $7f8ee02f08da8eac$export$66b2a4a5f67468ac = '__issuetable_internal_checkbox';
    const $7f8ee02f08da8eac$export$3dbdc5c16825be4d = [
        $7f8ee02f08da8eac$export$c3266da279aa6b84,
        $7f8ee02f08da8eac$export$de4c02b525d877fa
    ];
    const $7f8ee02f08da8eac$export$a1c171a82c45d53f = 24;
    const $7f8ee02f08da8eac$export$9c5dd6078b37aac2 = 16;
    const $7f8ee02f08da8eac$export$7ec4af037f372df4 = 500;
    const $7f8ee02f08da8eac$export$d2372dfbd4e91a11 = 50;
    const $7f8ee02f08da8eac$export$bbc2e8c301f97f97 = {
        ASSIGNEE: 'assignee',
        CHECKBOX: '__issuetable_internal_checkbox',
        DESCRIPTION: 'description',
        ENVIRONMENT: 'environment',
        EXPAND_BUTTON: '__issuetable_internal_expand_button',
        ISSUE_KEY: 'issuekey',
        ISSUE_OPERATIONS: '__issuetable_internal_meatball',
        STATUS: 'status',
        SUMMARY: 'summary',
        ISSUE_TYPE: 'issuetype',
        RESOLUTION: 'resolution',
        PARENT: 'parent',
        LABELS: 'labels',
        COMPONENTS: 'components',
        FIX_VERSIONS: 'fixVersions',
        STATUS_CATEGORY: 'statusCategory',
        PROJECT: 'project',
        READ_ONLY: 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield',
        SPRINT: 'com.pyxis.greenhopper.jira:gh-sprint',
        TEXT: 'com.atlassian.jira.plugin.system.customfieldtypes:textfield',
        EPIC_LINK: 'com.pyxis.greenhopper.jira:gh-epic-link',
        CREATED: 'created',
        RESOLUTION_DATE: 'resolutiondate',
        TEXT_AREA: 'com.atlassian.jira.plugin.system.customfieldtypes:textarea',
        UPDATED: 'updated',
        DUE_DATE: 'duedate',
        REPORTER: 'reporter',
        CREATOR: 'creator',
        PRIORITY: 'priority',
        AFFECTS_VERSIONS: 'versions',
        REQUEST_TYPE: 'com.atlassian.servicedesk:vp-origin',
        NUMBER: 'com.atlassian.jira.plugin.system.customfieldtypes:float',
        STORY_POINT_ESTIMATE: 'com.pyxis.greenhopper.jira:jsw-story-points'
    };
    const $7f8ee02f08da8eac$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
    const $7f8ee02f08da8eac$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
    const $7f8ee02f08da8eac$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
    const $7f8ee02f08da8eac$export$10016003aa27fa67 = 40;
    const $7f8ee02f08da8eac$export$5575b9e0ed3ff59f = 69;
    const $7f8ee02f08da8eac$export$7c3f559e2ca95fa = 170;
    const $7f8ee02f08da8eac$export$e1a42c2fefb5af25 = 999;
    const $7f8ee02f08da8eac$export$bfe09a9186b98f8f = 400;
    const $7f8ee02f08da8eac$export$f2540f34b796306d = 300;
    const $7f8ee02f08da8eac$export$954afb0fcf5a326 = 450;
    const $7f8ee02f08da8eac$export$93758649595b2d58 = 'reorder';
    const $7f8ee02f08da8eac$export$cad8c6a0b6e78898 = 'resize';
    const $7f8ee02f08da8eac$export$754b76ac8fa63350 = 'FULL_HEIGHT';
    const $7f8ee02f08da8eac$export$fa5c7dad7ee16383 = 'HEADER_ONLY';
    const $7f8ee02f08da8eac$export$6c0a5a77457ca62 = 'COMPACT';
    const $7f8ee02f08da8eac$export$119d8ab9a5bc4b2 = 'FULL';
    const $7f8ee02f08da8eac$export$9ef77944c441ad07 = 'LAZY_EDITABILITY_LOADER_CONTAINER_SCOPE';
    const $7f8ee02f08da8eac$export$c1f680390b97c9e1 = 'LAZY_MEDIA_VIEW_CONTEXT_LOADER_CONTAINER_SCOPE';
    const $7f8ee02f08da8eac$export$e03155205bf92428 = 'loadChildItems';
    const $7f8ee02f08da8eac$export$311c64c0d94dcdf3 = 'LoadMoreChildItems';
    const $7f8ee02f08da8eac$export$f7109619a5e9e0d6 = 'jira-native-issue-table';
});
parcelRegister("t3Q07", function(module, exports) {
    $parcel$export(module.exports, "getAliasesForField", ()=>$a3816529ae558e1d$export$94d69942fbe58a01);
    const $a3816529ae558e1d$export$94d69942fbe58a01 = (field, fieldToJqlTermMap)=>{
        let term = fieldToJqlTermMap.get(field);
        if (term === undefined) {
            for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === field) {
                term = keyValuePair[1];
                break;
            }
        }
        if (term === undefined) return [];
        const set = new Set();
        set.add(term);
        for (const keyValuePair of fieldToJqlTermMap.entries())if (keyValuePair[1] === term) set.add(keyValuePair[0]);
        return Array.from(set);
    };
});
parcelRegister("796ok", function(module, exports) {
    $parcel$export(module.exports, "getJqlTermForField", ()=>$ad837b869bddcad8$export$ef4e8b2c9bc7bd4d);
    var $bCU3R;
    const $ad837b869bddcad8$export$ef4e8b2c9bc7bd4d = (field, fieldToJqlTermMap)=>{
        const convertedField = (0, (0, parcelRequire("bCU3R")).convertFieldToJqlTerm)(field);
        const jqlTermForField = fieldToJqlTermMap.get(convertedField) ?? convertedField;
        return jqlTermForField;
    };
});
parcelRegister("bCU3R", function(module, exports) {
    $parcel$export(module.exports, "convertFieldToJqlTerm", ()=>$1e1011370a3a12e2$export$29f734dc2c61ea9d);
    const $1e1011370a3a12e2$export$29f734dc2c61ea9d = (fieldName)=>{
        if (/^customfield_\d+$/.test(fieldName)) {
            const customFieldId = fieldName.split('customfield_')[1];
            return `cf[${customFieldId}]`;
        }
        return fieldName;
    };
});
parcelRegister("aH9Ys", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dsheJ").then(()=>parcelRequire('aWG9Z'));
});
parcelRegister("dbjD6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1OMFw").then(()=>parcelRequire('eWn4R'));
});
parcelRegister("6nHQF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kK5xY").then(()=>parcelRequire('ajrrh'));
});
parcelRegister("jyMtv", function(module, exports) {
    $parcel$export(module.exports, "transformToValidUserPrefs", ()=>$8cfaebab7e294873$export$e9345b021afd3cc3);
    var $hwva3;
    var $Z4X9T;
    var $hCluT;
    const $8cfaebab7e294873$export$e9345b021afd3cc3 = (rawUserPrefs)=>{
        const pageSize = parseInt(rawUserPrefs.num, 10);
        const fieldSetIds = (0, (0, parcelRequire("hwva3")).convertUserPrefsToColumnNames)(rawUserPrefs.columnNames);
        const stringifiedFilterId = `${rawUserPrefs.filterId}`;
        const { sortDirection: sortDirection, sortField: sortField } = (0, (0, parcelRequire("Z4X9T")).getSortFieldAndDirection)(rawUserPrefs.sortBy);
        const showResolved = !!rawUserPrefs.showResolved;
        return {
            filterId: (0, (0, parcelRequire("hCluT")).isFilterId)(stringifiedFilterId) ? stringifiedFilterId : undefined,
            columnNames: fieldSetIds,
            num: !Number.isNaN(pageSize) ? pageSize : 10,
            sortDirection: sortDirection,
            sortField: sortField,
            showResolved: showResolved
        };
    };
});
parcelRegister("hwva3", function(module, exports) {
    $parcel$export(module.exports, "convertUserPrefsToColumnNames", ()=>$ffa5f3be2fc11704$export$6e5cdc232ebb20cf);
    var $JIPqS;
    const $ffa5f3be2fc11704$export$6e5cdc232ebb20cf = (columns)=>typeof columns === 'string' && columns !== '' && columns !== '--Default--' ? columns.split((0, $e997f85ca70fa8bf$export$a3d4af30107c4f4d)).map((col)=>col.replaceAll((0, $e997f85ca70fa8bf$export$952287cc7aef3a4c), (0, $e997f85ca70fa8bf$export$a3d4af30107c4f4d))) : (0, (0, parcelRequire("JIPqS")).ISSUE_SEARCH_DEFAULT_COLUMNS);
});
const $e997f85ca70fa8bf$export$dd03181e30c7d559 = 5;
const $e997f85ca70fa8bf$export$a3d4af30107c4f4d = '|';
const $e997f85ca70fa8bf$export$952287cc7aef3a4c = '%7C';
parcelRegister("Z4X9T", function(module, exports) {
    $parcel$export(module.exports, "getSortFieldAndDirection", ()=>$834bd6f85e4a1e0d$export$e535bb2dfaa4d10b);
    const $834bd6f85e4a1e0d$export$e535bb2dfaa4d10b = (sortByFromUserPrefs)=>{
        const [sortField, sortDirection] = typeof sortByFromUserPrefs === 'string' ? sortByFromUserPrefs.split(':') : [];
        if (!sortField || sortDirection !== 'ASC' && sortDirection !== 'DESC') return {};
        return {
            sortField: sortField,
            sortDirection: sortDirection
        };
    };
});
parcelRegister("hCluT", function(module, exports) {
    $parcel$export(module.exports, "isFilterId", ()=>$39fbd6b125bd3cbf$export$23be85030bd58047);
    const $39fbd6b125bd3cbf$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);
});
parcelRegister("26UOd", function(module, exports) {
    $parcel$export(module.exports, "REACT_KEY", ()=>$c373d1a6bf5d7ef6$export$e0e89108956f58f6);
    const $c373d1a6bf5d7ef6$export$c8ae0b83405368ed = 'react/filter-results';
    const $c373d1a6bf5d7ef6$export$d473668bb8826dfe = 'react/assigned-to-me';
    const $c373d1a6bf5d7ef6$export$e079ced6d62149e8 = 'react/issues-in-progress';
    const $c373d1a6bf5d7ef6$export$28c72363adc3f53a = 'react/voted-issues';
    const $c373d1a6bf5d7ef6$export$99faee4082b644a = 'react/watched-issues';
    const $c373d1a6bf5d7ef6$export$25f168992476ecb5 = 'react/custom-report';
    const $c373d1a6bf5d7ef6$export$e0e89108956f58f6 = {
        FILTER_RESULTS: $c373d1a6bf5d7ef6$export$c8ae0b83405368ed,
        ASSIGNED_TO_ME: $c373d1a6bf5d7ef6$export$d473668bb8826dfe,
        ISSUES_IN_PROGRESS: $c373d1a6bf5d7ef6$export$e079ced6d62149e8,
        VOTED_ISSUES: $c373d1a6bf5d7ef6$export$28c72363adc3f53a,
        WATCHED_ISSUES: $c373d1a6bf5d7ef6$export$99faee4082b644a,
        CUSTOM_REPORT: $c373d1a6bf5d7ef6$export$25f168992476ecb5
    };
});
parcelRegister("aVFmC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31463ce0406b73cb$export$2e2bcd8739ae039);
    var $eusud;
    var $31463ce0406b73cb$export$2e2bcd8739ae039 = async ()=>(0, (0, parcelRequire("eusud")).performGetRequest)('/rest/config/1.0/directoryitems.json');
});
parcelRegister("3Zhqx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b1c788e303134293$export$2e2bcd8739ae039);
    var $5IKQ6;
    var $kspzT;
    var $3Yd87;
    var $kGR9w;
    var $b1c788e303134293$export$2e2bcd8739ae039 = (maybePrevData, sharedValue)=>({ isPrefetch: isPrefetch }, spaContext)=>{
            if (!sharedValue || sharedValue instanceof Error) throw new (0, (0, parcelRequire("3Yd87")).SharedValueAggregateError)({
                sharedValue: sharedValue,
                isPrefetch: isPrefetch,
                name: 'AMD modules resource'
            });
            return (async ()=>{
                const { reactGadgets: nextGadgets } = sharedValue;
                const prev = maybePrevData != null && !(maybePrevData instanceof Error) && maybePrevData.reactGadgetsState || {};
                const persistedGadgets = nextGadgets.filter(({ id: id })=>!!prev[id]);
                const gadgetsToLoad = nextGadgets.filter((gadget)=>{
                    const isConfigurable = !!(0, (0, parcelRequire("kspzT")).default)[gadget.reactKey].componentEdit;
                    const isUnconfigured = isConfigurable && !(0, (0, parcelRequire("5IKQ6")).isGadgetConfigured)(gadget.userPrefs);
                    return !prev[gadget.id] && !isUnconfigured;
                });
                const skippedGadgets = nextGadgets.filter((gadget)=>!prev[gadget.id] && !gadgetsToLoad.some(({ id: id })=>id === gadget.id));
                const reactGadgetsState = {
                    ...Object.fromEntries(persistedGadgets.map(({ id: id })=>[
                            id,
                            prev[id]
                        ])),
                    ...Object.fromEntries(skippedGadgets.map(({ id: id })=>[
                            id,
                            {}
                        ])),
                    ...await (0, (0, parcelRequire("kGR9w")).loadReactGadgets)(gadgetsToLoad, spaContext)
                };
                return {
                    sharedValue: sharedValue,
                    reactGadgetsState: reactGadgetsState
                };
            })();
        };
});
parcelRegister("5IKQ6", function(module, exports) {
    $parcel$export(module.exports, "isGadgetConfigured", ()=>$ce7e823be599a5b0$export$b625fae487818738);
    const $ce7e823be599a5b0$export$b625fae487818738 = (userPrefs)=>userPrefs?.fields.some(({ name: name, value: value })=>name === 'isConfigured' && value === 'true') ?? false;
});
parcelRegister("kGR9w", function(module, exports) {
    $parcel$export(module.exports, "loadReactGadgets", ()=>$ae0204181dcaff49$export$7e1a3455761184a2);
    var $kspzT;
    const $ae0204181dcaff49$var$preloadGadgetBundles = (reactKeys)=>reactKeys.forEach((reactKey)=>{
            (0, (0, parcelRequire("kspzT")).default)[reactKey].preload();
        });
    const $ae0204181dcaff49$export$7e1a3455761184a2 = async (gadgets, spaContext)=>{
        const distinctReactKeys = [
            ...new Set(gadgets.map((gadget)=>gadget.reactKey))
        ];
        $ae0204181dcaff49$var$preloadGadgetBundles(distinctReactKeys);
        return Object.fromEntries(await Promise.all(gadgets.map(({ id: id, reactKey: reactKey, userPrefs: userPrefs })=>(0, (0, parcelRequire("kspzT")).default)[reactKey]?.getInitialState(spaContext, userPrefs?.fields || []).then((state)=>[
                    id,
                    state
                ], (error)=>[
                    id,
                    error
                ]))));
    };
});
parcelRegister("94QFg", function(module, exports) {
    $parcel$export(module.exports, "dashboardRoute", ()=>$0f4773b5d6aa4f26$export$3bf0ecb39349b6ef);
    $parcel$export(module.exports, "selectedDashboardRoute", ()=>$0f4773b5d6aa4f26$export$b32070ee9554c3fb);
    $parcel$export(module.exports, "dashboardEditRoute", ()=>$0f4773b5d6aa4f26$export$b6e00d2cd7369fbd);
    $parcel$export(module.exports, "dashboardWallboardRoute", ()=>$0f4773b5d6aa4f26$export$eaa33c953ab9ca63);
    $parcel$export(module.exports, "dashboardViewRoute", ()=>$0f4773b5d6aa4f26$export$24f1b2ff97b9d3e6);
    $parcel$export(module.exports, "dashboardViewEmbedRoute", ()=>$0f4773b5d6aa4f26$export$258b5e3f294617d2);
    $parcel$export(module.exports, "systemDashboardEditRoute", ()=>$0f4773b5d6aa4f26$export$7367fb465296c7dd);
    var $65Ltd;
    const $0f4773b5d6aa4f26$export$3bf0ecb39349b6ef = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DASHBOARD),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD),
        path: '/secure/Dashboard.jspa'
    };
    const $0f4773b5d6aa4f26$export$b32070ee9554c3fb = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DASHBOARD),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_SELECTED),
        path: '/secure/Dashboard.jspa',
        query: [
            'selectPageId'
        ]
    };
    const $0f4773b5d6aa4f26$export$b6e00d2cd7369fbd = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DASHBOARD),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_EDIT),
        path: '/jira/dashboards/:dashboardId(\\d+)/edit',
        query: [
            'maximized?'
        ],
        exact: true
    };
    const $0f4773b5d6aa4f26$export$eaa33c953ab9ca63 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DASHBOARD),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_WALLBOARD),
        path: '/jira/dashboards/wallboard',
        query: [
            'dashboardId',
            'cyclePeriod?',
            'transitionFx?',
            'random?'
        ],
        exact: true
    };
    const $0f4773b5d6aa4f26$export$24f1b2ff97b9d3e6 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DASHBOARD),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_VIEW),
        path: '/jira/dashboards/:dashboardId(\\d+|last-visited)',
        query: [
            'maximized?'
        ],
        exact: true
    };
    const $0f4773b5d6aa4f26$export$258b5e3f294617d2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DASHBOARD),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_VIEW_EMBED),
        path: '/jira/dashboards/:dashboardId(\\d+)/embed',
        query: [],
        exact: true
    };
    const $0f4773b5d6aa4f26$export$7367fb465296c7dd = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DASHBOARD),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SYSTEM_DASHBOARD_EDIT),
        path: '/secure/admin/EditDefaultDashboard(!default)?.jspa',
        query: [
            'maximized?'
        ]
    };
});
parcelRegister("4n0Oi", function(module, exports) {
    $parcel$export(module.exports, "DashboardRedirect", ()=>$55d04275d2bcfadf$export$da833ddcffcc38ba);
    var $5uXOq = parcelRequire("5uXOq");
    var $65Ltd;
    var $6jY6G;
    var $7OYJs;
    var $dIdda = parcelRequire("dIdda");
    const $55d04275d2bcfadf$export$da833ddcffcc38ba = ()=>{
        const [{ query: query, location: { hash: hash } }] = (0, $dIdda.useRouter)();
        const { path: path } = (0, (0, parcelRequire("6jY6G")).useRouteByName)((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARD_VIEW)) ?? {};
        if (path == null) throw new Error('Dashboard view route not found');
        const { selectPageId: id } = query;
        const idParam = /^\d+$/.test(id) ? id : 'last-visited';
        const generatedPath = (0, $dIdda.generatePath)(path, {
            dashboardId: idParam
        });
        const maximizedId = hash.match(/.*\/(?<id>\d+)/)?.groups?.id ?? null;
        const pathWithQuery = maximizedId !== null ? `${generatedPath}?maximized=${maximizedId}` : generatedPath;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: pathWithQuery,
            persistSearchParams: false
        });
    };
});
parcelRegister("5lVAv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("gsMi3")
    ]).then(()=>parcelRequire('iqENN'));
});
parcelRegister("dtemB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hXx3W")
    ]).then(()=>parcelRequire('9aF4A'));
});
parcelRegister("2yGxE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("luD3r")
    ]).then(()=>parcelRequire('7ykDM'));
});
parcelRegister("ixqoJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9VuHS")
    ]).then(()=>parcelRequire('7AfLj'));
});
parcelRegister("atP20", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8AY7a")
    ]).then(()=>parcelRequire('3VYlm'));
});
parcelRegister("hBCfM", function(module, exports) {
    $parcel$export(module.exports, "devopsConnectedProjectRouteEntry", ()=>$1b01c2efc4945821$export$ae258fb8ec2c1f86);
    var $ffza4;
    var $6e4Kt;
    var $2G9Bk;
    var $3RJkv;
    var $izma3;
    var $6IcGP;
    const $1b01c2efc4945821$export$ae258fb8ec2c1f86 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("izma3")).devopsConnectedProjectRoute), ()=>({
            ufoName: 'devops.connected-project',
            component: (0, (0, parcelRequire("6IcGP")).default),
            layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("6IcGP")).LazyDevopsConnectedProject)
            ]
        }));
});
parcelRegister("izma3", function(module, exports) {
    $parcel$export(module.exports, "devopsConnectedProjectRoute", ()=>$778b5363f1896dba$export$91257312631802bc);
    var $65Ltd;
    const $778b5363f1896dba$export$91257312631802bc = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DEVOPS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DEVOPS_CONNECTED_PROJECT),
        path: '/jira/devops/connected-project'
    };
});
parcelRegister("6IcGP", function(module, exports) {
    $parcel$export(module.exports, "LazyDevopsConnectedProject", ()=>$31d281e7968db385$export$dcd3d20b0038b35c);
    $parcel$export(module.exports, "default", ()=>$31d281e7968db385$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $31d281e7968db385$export$dcd3d20b0038b35c = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3cUWj"))), {
        moduleId: "./src/packages/spa-apps/devops-connected-project/src/index.tsx"
    });
    var $31d281e7968db385$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $31d281e7968db385$export$dcd3d20b0038b35c,
            pageId: "devops-connected-project",
            shouldShowSpinner: true
        });
});
parcelRegister("3cUWj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("aS4l7")
    ]).then(()=>parcelRequire('kGKHk'));
});
parcelRegister("6Ja6c", function(module, exports) {
    $parcel$export(module.exports, "boardsDirectoryRouteEntry", ()=>$63ac430661b12a63$export$e78b34c999194638);
    $parcel$export(module.exports, "boardsDirectoryRedirectRouteEntry", ()=>$63ac430661b12a63$export$2a34d21ecf479c40);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $bPjHb;
    var $3RJkv;
    var $4s7hB;
    var $7OYJs;
    var $3iOSp;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $63ac430661b12a63$var$BoardsDirectoryRedirect = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/boards"
        });
    const $63ac430661b12a63$var$LazyBoardsDirectory = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1Xk9t"))), {
        moduleId: "./src/packages/spa-apps/directories/boards/src/index.tsx"
    });
    const $63ac430661b12a63$export$3184a385d45edd0d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $63ac430661b12a63$var$LazyBoardsDirectory,
            pageId: "boards-directory",
            shouldShowSpinner: false
        });
    const $63ac430661b12a63$export$e78b34c999194638 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4s7hB")).boardsDirectoryRoute), ()=>({
            component: $63ac430661b12a63$export$3184a385d45edd0d,
            skeleton: (0, (0, parcelRequire("3iOSp")).BoardsDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bPjHb")).boardsDirectoryResource)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $63ac430661b12a63$var$LazyBoardsDirectory
            ]
        }));
    const $63ac430661b12a63$export$2a34d21ecf479c40 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4s7hB")).boardsDirectoryRedirectRoute), ()=>({
            component: $63ac430661b12a63$var$BoardsDirectoryRedirect,
            skeleton: (0, (0, parcelRequire("3iOSp")).BoardsDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bPjHb")).boardsDirectoryResource)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $63ac430661b12a63$var$LazyBoardsDirectory
            ],
            isRedirect: true
        }));
});
parcelRegister("bPjHb", function(module, exports) {
    $parcel$export(module.exports, "boardsDirectoryResource", ()=>$817f387e86427323$export$2646f173fa2c14f2);
    var $kbVA4;
    var $dIdda = parcelRequire("dIdda");
    const $817f387e86427323$export$2646f173fa2c14f2 = (0, $dIdda.createResource)({
        type: (0, $ee6731a28d0b2341$export$87526c4bd9c78abc),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("4stqG")),
        maxAge: (0, (0, parcelRequire("kbVA4")).MIN_MAX_AGE)
    });
});
const $ee6731a28d0b2341$export$87526c4bd9c78abc = 'BOARDS_DIRECTORY';
parcelRegister("4stqG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5815h").then(()=>parcelRequire('goVIR'));
});
parcelRegister("4s7hB", function(module, exports) {
    $parcel$export(module.exports, "boardsDirectoryRoute", ()=>$77dc14d95c28fe1d$export$f0fc6f4e8be87e85);
    $parcel$export(module.exports, "boardsDirectoryRedirectRoute", ()=>$77dc14d95c28fe1d$export$a4fba1ebd6ba91ee);
    var $65Ltd;
    const $77dc14d95c28fe1d$export$f0fc6f4e8be87e85 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BOARDS_DIRECTORY),
        path: '/jira/boards'
    };
    const $77dc14d95c28fe1d$export$a4fba1ebd6ba91ee = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_BOARDS_DIRECTORY)}-redirect`,
        path: '/secure/ManageRapidViews.jspa'
    };
});
parcelRegister("3iOSp", function(module, exports) {
    $parcel$export(module.exports, "BoardsDirectorySkeleton", ()=>$05eb234c240fc9e8$export$8194d6e87709f042);
    $parcel$export(module.exports, "DashboardsDirectorySkeleton", ()=>$05eb234c240fc9e8$export$75ef2bfed3801fb1);
    $parcel$export(module.exports, "FiltersDirectorySkeleton", ()=>$05eb234c240fc9e8$export$e76f94817327da1);
    $parcel$export(module.exports, "ProjectsDirectorySkeleton", ()=>$05eb234c240fc9e8$export$d94befb0e231760c);
    $parcel$export(module.exports, "PlansDirectorySkeleton", ()=>$05eb234c240fc9e8$export$6cd26a09efd6d158);
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $5SWcj = parcelRequire("5SWcj");
    var $8Ta6q = parcelRequire("8Ta6q");
    var $4vyYK = parcelRequire("4vyYK");
    var $4653I = parcelRequire("4653I");
    const $05eb234c240fc9e8$export$8194d6e87709f042 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($5SWcj)))
        });
    const $05eb234c240fc9e8$export$75ef2bfed3801fb1 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($8Ta6q)))
        });
    const $05eb234c240fc9e8$export$e76f94817327da1 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($4vyYK)))
        });
    const $05eb234c240fc9e8$export$d94befb0e231760c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($4653I)))
        });
    const $05eb234c240fc9e8$export$6cd26a09efd6d158 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($4653I)))
        });
});
parcelRegister("5SWcj", function(module, exports) {
    module.exports = new URL("boards-directory-app-skeleton.tpl.e4de30a4.svg", import.meta.url).toString();
});
parcelRegister("8Ta6q", function(module, exports) {
    module.exports = new URL("dashboards-directory-app-skeleton.tpl.eb730072.svg", import.meta.url).toString();
});
parcelRegister("4vyYK", function(module, exports) {
    module.exports = new URL("filters-directory-app-skeleton.tpl.6583ea61.svg", import.meta.url).toString();
});
parcelRegister("4653I", function(module, exports) {
    module.exports = new URL("projects-directory-app-skeleton.tpl.a21368f6.svg", import.meta.url).toString();
});
parcelRegister("1Xk9t", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("as2Yi")
    ]).then(()=>parcelRequire('3geiu'));
});
parcelRegister("aZoVa", function(module, exports) {
    $parcel$export(module.exports, "dashboardsDirectoryRouteEntry", ()=>$cd7e3d13d091ccad$export$748e329bd0c282a);
    $parcel$export(module.exports, "dashboardsDirectoryRedirectRouteEntry", ()=>$cd7e3d13d091ccad$export$8dae8091f8e43b97);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $4yCf0;
    var $3RJkv;
    var $3zTeb;
    var $7OYJs;
    var $3iOSp;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $cd7e3d13d091ccad$var$DashboardsDirectoryRedirect = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/dashboards"
        });
    const $cd7e3d13d091ccad$var$LazyDashboardsDirectory = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("bEh2s"))), {
        moduleId: "./src/packages/spa-apps/directories/dashboards/src/index.tsx"
    });
    const $cd7e3d13d091ccad$export$1cc6cc01050e1215 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cd7e3d13d091ccad$var$LazyDashboardsDirectory,
            pageId: "dashboards-directory",
            shouldShowSpinner: false
        });
    const $cd7e3d13d091ccad$export$748e329bd0c282a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("3zTeb")).dashboardsDirectoryRoute), ()=>({
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("4yCf0")).dashboardsDirectoryResource)
            ],
            component: $cd7e3d13d091ccad$export$1cc6cc01050e1215,
            skeleton: (0, (0, parcelRequire("3iOSp")).DashboardsDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).DASHBOARDS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $cd7e3d13d091ccad$var$LazyDashboardsDirectory
            ]
        }));
    const $cd7e3d13d091ccad$export$8dae8091f8e43b97 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("3zTeb")).dashboardsDirectoryRedirectRoute), ()=>({
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("4yCf0")).dashboardsDirectoryResource)
            ],
            component: !false ? $cd7e3d13d091ccad$var$DashboardsDirectoryRedirect : $cd7e3d13d091ccad$export$1cc6cc01050e1215,
            skeleton: (0, (0, parcelRequire("3iOSp")).DashboardsDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).DASHBOARDS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $cd7e3d13d091ccad$var$LazyDashboardsDirectory
            ],
            isRedirect: true
        }));
});
parcelRegister("4yCf0", function(module, exports) {
    $parcel$export(module.exports, "dashboardsDirectoryResource", ()=>$c9ec3cc3b6c0608d$export$1cf6c7815471c2a2);
    var $kbVA4;
    var $dIdda = parcelRequire("dIdda");
    const $c9ec3cc3b6c0608d$var$RESOURCE_TYPE_DASHBOARDS_DIRECTORY = 'DASHBOARDS_DIRECTORY';
    const $c9ec3cc3b6c0608d$export$1cf6c7815471c2a2 = (0, $dIdda.createResource)({
        type: $c9ec3cc3b6c0608d$var$RESOURCE_TYPE_DASHBOARDS_DIRECTORY,
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("heoI0")),
        maxAge: (0, (0, parcelRequire("kbVA4")).MIN_MAX_AGE)
    });
});
parcelRegister("heoI0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("yne3O").then(()=>parcelRequire('ciD6c'));
});
parcelRegister("3zTeb", function(module, exports) {
    $parcel$export(module.exports, "dashboardsDirectoryRoute", ()=>$ce3faeb59dd926fb$export$41bba408475cab16);
    $parcel$export(module.exports, "dashboardsDirectoryRedirectRoute", ()=>$ce3faeb59dd926fb$export$b96f6fb3c35a6fe5);
    var $65Ltd;
    const $ce3faeb59dd926fb$export$41bba408475cab16 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY),
        path: '/jira/dashboards'
    };
    const $ce3faeb59dd926fb$export$b96f6fb3c35a6fe5 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_DASHBOARDS_DIRECTORY_SECURE),
        path: '/secure/ConfigurePortalPages(!default.jspa|.jspa)'
    };
});
parcelRegister("bEh2s", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("e9jXk")
    ]).then(()=>parcelRequire('76rrf'));
});
parcelRegister("7RZwy", function(module, exports) {
    $parcel$export(module.exports, "filtersDirectoryRouteEntry", ()=>$37b0d6d8034450f5$export$ca77bc660994f51f);
    $parcel$export(module.exports, "filtersDirectoryRedirectRouteEntry", ()=>$37b0d6d8034450f5$export$41fb3f2a3e68c7c3);
    $parcel$export(module.exports, "secureFiltersDirectoryRedirectRouteEntry", ()=>$37b0d6d8034450f5$export$c2ec350ee9e78717);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $dRl24;
    var $3RJkv;
    var $13DBR;
    var $7OYJs;
    var $3iOSp;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $37b0d6d8034450f5$export$c56e739d3bb1fe19 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/filters"
        });
    const $37b0d6d8034450f5$var$LazyFiltersDirectory = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4D5lh"))), {
        moduleId: "./src/packages/spa-apps/directories/filters/src/index.tsx"
    });
    const $37b0d6d8034450f5$export$e5d735e83dacb7c7 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $37b0d6d8034450f5$var$LazyFiltersDirectory,
            pageId: "filters-directory",
            shouldShowSpinner: false
        });
    const $37b0d6d8034450f5$export$ca77bc660994f51f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("13DBR")).filtersDirectoryRoute), ()=>({
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dRl24")).filtersDirectoryResource)
            ],
            component: $37b0d6d8034450f5$export$e5d735e83dacb7c7,
            skeleton: (0, (0, parcelRequire("3iOSp")).FiltersDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).FILTERS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $37b0d6d8034450f5$var$LazyFiltersDirectory
            ]
        }));
    const $37b0d6d8034450f5$export$41fb3f2a3e68c7c3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("13DBR")).filtersDirectoryRedirectRoute), ()=>({
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dRl24")).filtersDirectoryResource)
            ],
            component: !false ? $37b0d6d8034450f5$export$c56e739d3bb1fe19 : $37b0d6d8034450f5$export$e5d735e83dacb7c7,
            skeleton: (0, (0, parcelRequire("3iOSp")).FiltersDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).FILTERS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $37b0d6d8034450f5$var$LazyFiltersDirectory
            ],
            isRedirect: true
        }));
    const $37b0d6d8034450f5$export$c2ec350ee9e78717 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("13DBR")).secureFiltersDirectoryRedirectRoute), ()=>({
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("dRl24")).filtersDirectoryResource)
            ],
            component: !false ? $37b0d6d8034450f5$export$c56e739d3bb1fe19 : $37b0d6d8034450f5$export$e5d735e83dacb7c7,
            skeleton: (0, (0, parcelRequire("3iOSp")).FiltersDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).FILTERS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $37b0d6d8034450f5$var$LazyFiltersDirectory
            ],
            isRedirect: true
        }));
});
parcelRegister("dRl24", function(module, exports) {
    $parcel$export(module.exports, "filtersDirectoryResource", ()=>$8b127055fac893b8$export$53f99086c62225b6);
    var $kbVA4;
    var $dIdda = parcelRequire("dIdda");
    const $8b127055fac893b8$export$53f99086c62225b6 = (0, $dIdda.createResource)({
        type: (0, $6d3ffd6df613c846$export$79e191bf6cb15284),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("1EVqG")),
        maxAge: (0, (0, parcelRequire("kbVA4")).MIN_MAX_AGE)
    });
});
const $6d3ffd6df613c846$export$79e191bf6cb15284 = 'FILTERS_DIRECTORY';
parcelRegister("1EVqG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8fxmU").then(()=>parcelRequire('cK9UE'));
});
parcelRegister("13DBR", function(module, exports) {
    $parcel$export(module.exports, "filtersDirectoryRoute", ()=>$4b1900cd8840fb6b$export$6350f52c8b40042d);
    $parcel$export(module.exports, "filtersDirectoryRedirectRoute", ()=>$4b1900cd8840fb6b$export$f4f86e1ddc30a625);
    $parcel$export(module.exports, "secureFiltersDirectoryRedirectRoute", ()=>$4b1900cd8840fb6b$export$50796f2aecd63181);
    var $65Ltd;
    const $4b1900cd8840fb6b$export$6350f52c8b40042d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY),
        path: '/jira/filters'
    };
    const $4b1900cd8840fb6b$export$f4f86e1ddc30a625 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY)}-redirect`,
        path: '/ManageFilters.jspa'
    };
    const $4b1900cd8840fb6b$export$50796f2aecd63181 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FILTERS_DIRECTORY_SECURE)}-redirect`,
        path: '/secure/ManageFilters.jspa'
    };
});
parcelRegister("4D5lh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7rph3")
    ]).then(()=>parcelRequire('3Zqmb'));
});
parcelRegister("25GXG", function(module, exports) {
    $parcel$export(module.exports, "plansDirectoryRouteEntry", ()=>$9a93b77d562e7847$export$4f9df77811fbdc1f);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $3RJkv;
    var $4TyVn;
    var $3iOSp;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $9a93b77d562e7847$var$LazyPlansDirectory = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lBR19"))), {
        moduleId: "./src/packages/spa-apps/directories/plans/src/index.tsx"
    });
    const $9a93b77d562e7847$export$8f357abd0af482a2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9a93b77d562e7847$var$LazyPlansDirectory,
            pageId: "plans-directory",
            shouldShowSpinner: false
        });
    const $9a93b77d562e7847$export$4f9df77811fbdc1f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4TyVn")).plansDirectoryRoute), ()=>({
            component: $9a93b77d562e7847$export$8f357abd0af482a2,
            skeleton: (0, (0, parcelRequire("3iOSp")).PlansDirectorySkeleton),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PLANS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $9a93b77d562e7847$var$LazyPlansDirectory
            ]
        }));
});
parcelRegister("4TyVn", function(module, exports) {
    $parcel$export(module.exports, "plansDirectoryRoute", ()=>$ed241e9e9a1b449e$export$143b4a1ef2ffc051);
    var $65Ltd;
    const $ed241e9e9a1b449e$export$143b4a1ef2ffc051 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLANS_DIRECTORY),
        path: '/jira/plans'
    };
});
parcelRegister("lBR19", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5XLCy")
    ]).then(()=>parcelRequire('flZBd'));
});
parcelRegister("2f84N", function(module, exports) {
    $parcel$export(module.exports, "projectsDirectoryRouteEntries", ()=>$07a2f1e51a24c4ff$export$445f7414e382a69c);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $lkFvK;
    var $co1wz;
    var $ibkIl;
    var $1ExYN;
    var $f849T;
    var $gmpjq;
    var $lmyls;
    var $4jMkc;
    var $2G9Bk;
    var $1XrjK;
    var $3RJkv;
    var $atU1t;
    var $hW253;
    var $1xIol;
    var $7OYJs;
    var $3iOSp;
    var $7wpGh;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $07a2f1e51a24c4ff$export$b68dd6112a931c10 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/projects"
        });
    const $07a2f1e51a24c4ff$export$74316a0a4963952b = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/settings/projects/manage"
        });
    const $07a2f1e51a24c4ff$var$LazyProjectsDirectory = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3C1eN"))), {
        moduleId: "./src/packages/spa-apps/directories/projects-v3/src/index.tsx"
    });
    const $07a2f1e51a24c4ff$var$LazyAdminProjectsDirectory = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($07a2f1e51a24c4ff$var$LazyProjectsDirectory, {
            isAdminProjectDirectoryRoute: true
        });
    const $07a2f1e51a24c4ff$export$ba9ef00f25a4745e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $07a2f1e51a24c4ff$var$LazyAdminProjectsDirectory,
            pageId: "projects-directory-manage-v3",
            shouldShowSpinner: false
        });
    const $07a2f1e51a24c4ff$var$rightSidebars = ()=>{
        if (false) return [];
        return (0, (0, parcelRequire("co1wz")).ff)('server-render-projects-directory-sidebar_rj9ki') ? [] : [
            (0, (0, parcelRequire("1ExYN")).JiraProjectsTemplateListRightPanel)
        ];
    };
    const $07a2f1e51a24c4ff$var$projectsDirectoryHomepageLayout = ()=>(0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("gmpjq")).homepageLayout), {
            rightSidebars: $07a2f1e51a24c4ff$var$rightSidebars()
        });
    const $07a2f1e51a24c4ff$var$projectsDirectorySettingsLayout = ()=>(0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("ibkIl")).globalSettingsLayout), {
            rightSidebars: $07a2f1e51a24c4ff$var$rightSidebars()
        });
    const $07a2f1e51a24c4ff$var$ffOffProjectsDirectoryPageEntryPoint = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("7wpGh")).projectsDirectoryEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
        rightSidebar: undefined
    });
    const $07a2f1e51a24c4ff$var$ffOnProjectsDirectoryPageEntryPoint = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("7wpGh")).projectsDirectoryEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
        rightSidebar: (0, (0, parcelRequire("f849T")).serverRenderedRightSidebar)
    });
    const $07a2f1e51a24c4ff$export$79292a834772288c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1xIol")).projectsDirectoryRoute), ()=>({
            entryPoint () {
                return (0, (0, parcelRequire("co1wz")).ff)('server-render-projects-directory-sidebar_rj9ki') ? $07a2f1e51a24c4ff$var$ffOnProjectsDirectoryPageEntryPoint : $07a2f1e51a24c4ff$var$ffOffProjectsDirectoryPageEntryPoint;
            },
            skeleton: (0, (0, parcelRequire("3iOSp")).ProjectsDirectorySkeleton),
            layout: $07a2f1e51a24c4ff$var$projectsDirectoryHomepageLayout(),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            ufoName: 'projects-directory-v3'
        }));
    const $07a2f1e51a24c4ff$var$adminProjectDirectoryResources = [
        (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
        (0, (0, parcelRequire("hW253")).projectsDirectoryPageResource)
    ];
    const $07a2f1e51a24c4ff$export$d5b1a46987369ee4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1xIol")).manageProjectsDirectoryRoute), ()=>({
            component: $07a2f1e51a24c4ff$export$ba9ef00f25a4745e,
            skeleton: (0, (0, parcelRequire("3iOSp")).ProjectsDirectorySkeleton),
            layout: $07a2f1e51a24c4ff$var$projectsDirectorySettingsLayout(),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("4jMkc")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$07a2f1e51a24c4ff$var$adminProjectDirectoryResources
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $07a2f1e51a24c4ff$var$LazyProjectsDirectory
            ],
            ufoName: 'projects-directory-v3-manage'
        }));
    const $07a2f1e51a24c4ff$export$445f7414e382a69c = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1xIol")).projectsDirectoryRedirectRoute), ()=>({
                component: $07a2f1e51a24c4ff$export$b68dd6112a931c10,
                skeleton: (0, (0, parcelRequire("3iOSp")).ProjectsDirectorySkeleton),
                isRedirect: true,
                layout: $07a2f1e51a24c4ff$var$projectsDirectoryHomepageLayout(),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("hW253")).projectsDirectoryPageResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $07a2f1e51a24c4ff$var$LazyProjectsDirectory
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1xIol")).projectsDirectoryLegacyPathRedirectRoute), ()=>({
                component: $07a2f1e51a24c4ff$export$b68dd6112a931c10,
                skeleton: (0, (0, parcelRequire("3iOSp")).ProjectsDirectorySkeleton),
                isRedirect: true,
                layout: $07a2f1e51a24c4ff$var$projectsDirectoryHomepageLayout(),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("hW253")).projectsDirectoryPageResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $07a2f1e51a24c4ff$var$LazyProjectsDirectory
                ]
            })),
        $07a2f1e51a24c4ff$export$79292a834772288c,
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1xIol")).projectsDirectoryManageRedirectRoute), ()=>({
                component: $07a2f1e51a24c4ff$export$74316a0a4963952b,
                skeleton: (0, (0, parcelRequire("3iOSp")).ProjectsDirectorySkeleton),
                isRedirect: true,
                layout: $07a2f1e51a24c4ff$var$projectsDirectorySettingsLayout(),
                navigation: {
                    sidebar: (0, (0, parcelRequire("4jMkc")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...$07a2f1e51a24c4ff$var$adminProjectDirectoryResources
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $07a2f1e51a24c4ff$var$LazyProjectsDirectory
                ]
            })),
        $07a2f1e51a24c4ff$export$d5b1a46987369ee4,
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1xIol")).projectsDirectoryManageRootRedirectRoute), ()=>({
                component: $07a2f1e51a24c4ff$export$74316a0a4963952b,
                skeleton: (0, (0, parcelRequire("3iOSp")).ProjectsDirectorySkeleton),
                isRedirect: true,
                layout: $07a2f1e51a24c4ff$var$projectsDirectorySettingsLayout(),
                navigation: {
                    sidebar: (0, (0, parcelRequire("4jMkc")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...$07a2f1e51a24c4ff$var$adminProjectDirectoryResources
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $07a2f1e51a24c4ff$var$LazyProjectsDirectory
                ]
            }))
    ];
});
parcelRegister("1ExYN", function(module, exports) {
    $parcel$export(module.exports, "JiraProjectsTemplateListRightPanel", ()=>$d823a751937e7046$export$521a9a721c9dad20);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $hsmeR;
    var $gkJw9;
    var $7Hq8b;
    const $d823a751937e7046$var$JiraProjectsTemplateListRightPanel = ()=>{
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        const { closeRightSidebar: closeRightSidebar } = (0, (0, parcelRequire("hsmeR")).useRightSidebarController)();
        const [localPanelId, setLocalPanelId] = (0, $5uXOq.useState)();
        const prevPanelIdRef = (0, $5uXOq.useRef)();
        const delayRef = (0, $5uXOq.useRef)(undefined);
        const panelId = rightSidebarCurrentState?.panelId;
        (0, $5uXOq.useEffect)(()=>{
            clearTimeout(delayRef.current);
            if (prevPanelIdRef.current === (0, (0, parcelRequire("7Hq8b")).PANEL_ID)) {
                if (rightSidebarCurrentState && panelId !== undefined && !rightSidebarCurrentState.isCollapsed && !rightSidebarCurrentState.isMinimised) setLocalPanelId(panelId);
                else delayRef.current = setTimeout(()=>{
                    setLocalPanelId(panelId);
                }, 310);
            } else setLocalPanelId(panelId);
            prevPanelIdRef.current = panelId;
            return ()=>clearTimeout(delayRef.current);
        }, [
            panelId,
            rightSidebarCurrentState
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                closeRightSidebar((0, (0, parcelRequire("7Hq8b")).PANEL_ID));
            }, [
            closeRightSidebar
        ]);
        if (localPanelId !== (0, (0, parcelRequire("7Hq8b")).PANEL_ID)) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gkJw9")).AsyncRightPanel), null);
    };
    const $d823a751937e7046$export$521a9a721c9dad20 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            fallback: "unmount",
            id: "right-sidebar-layout-component",
            packageName: "jiraGrowthRecommendationsInProjectList"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d823a751937e7046$var$JiraProjectsTemplateListRightPanel, null));
});
parcelRegister("gkJw9", function(module, exports) {
    $parcel$export(module.exports, "AsyncRightPanel", ()=>$2ea0e66ac4184052$export$7ef72c7d51d7de1e);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $gwZ1O;
    var $koeKL;
    var $kGfPy;
    const $2ea0e66ac4184052$var$runtimeProps = {};
    const $2ea0e66ac4184052$export$7ef72c7d51d7de1e = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("kGfPy")).asyncSidebar), {
            cloudId: cloudId
        });
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "right-side-panel",
            packageName: "jiraGrowthRecommendationsInProjectList",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: $2ea0e66ac4184052$var$runtimeProps,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gwZ1O")).ProjectListSidebarSkeleton), null)
        });
    };
    var $2ea0e66ac4184052$export$2e2bcd8739ae039 = $2ea0e66ac4184052$export$7ef72c7d51d7de1e;
});
parcelRegister("7XluA", function(module, exports) {
    $parcel$export(module.exports, "JiraEntryPointContainer", ()=>$f4c300dcb0cbacff$export$ee1e46af8fa2fb93);
    $parcel$export(module.exports, "NestedEntryPointContainer", ()=>$f4c300dcb0cbacff$export$54db9e88249c9162);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Bm0k;
    var $c5vfY;
    const $f4c300dcb0cbacff$export$ee1e46af8fa2fb93 = ({ entryPointReferenceSubject: entryPointReferenceSubject, ...containerProps })=>{
        const entryPointReference = (0, (0, parcelRequire("8Bm0k")).useEntryPointSubscription)(entryPointReferenceSubject);
        return entryPointReference ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c5vfY")).InternalEntryPointContainer), {
            ...containerProps,
            entryPointReference: entryPointReference,
            placeholderName: "jira-entry-point-container"
        }) : null;
    };
    const $f4c300dcb0cbacff$export$54db9e88249c9162 = (0, (0, parcelRequire("c5vfY")).InternalEntryPointContainer);
});
parcelRegister("8Bm0k", function(module, exports) {
    $parcel$export(module.exports, "useEntryPointSubscription", ()=>$0458c70c3d6616bf$export$3cd1c81e13390c49);
    var $5uXOq = parcelRequire("5uXOq");
    const $0458c70c3d6616bf$export$3cd1c81e13390c49 = (subject)=>{
        const [entryPointReference, setEntryPointReference] = (0, $5uXOq.useState)(subject.getValue);
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = subject.subscribe(setEntryPointReference);
            setEntryPointReference(subject.getValue());
            return unsubscribe;
        }, [
            subject
        ]);
        return entryPointReference;
    };
});
parcelRegister("c5vfY", function(module, exports) {
    $parcel$export(module.exports, "InternalEntryPointContainer", ()=>$df42b2d5b5551f77$export$5d4dc37edd8a3adb);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $39xOx;
    var $lfTZh;
    var $l8ruj;
    const $df42b2d5b5551f77$export$5d4dc37edd8a3adb = ({ entryPointReference: entryPointReference, errorAttributes: errorAttributes, errorFallback: errorFallback, fallback: fallback, id: id, packageName: packageName, placeholderName: placeholderName, runtimeProps: runtimeProps, teamName: teamName })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: id,
            packageName: packageName,
            teamName: teamName,
            attributes: errorAttributes,
            fallback: errorFallback
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: placeholderName ?? packageName ?? 'internal-entry-point-container',
            fallback: fallback
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
            entryPointReference: entryPointReference,
            props: runtimeProps
        }))));
});
parcelRegister("l8ruj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6056b4460d0127e0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $80cnJ;
    var $iNl9c;
    var $77kYm;
    var $7UTZj;
    function $6056b4460d0127e0$var$JiraUFOSegmentWrapper({ children: children }) {
        const interactionContext = (0, (0, parcelRequire("80cnJ")).useInteractionContext)();
        const relayProfilerContext = (0, $5uXOq.useMemo)(()=>({
                getInteractionContext: ()=>interactionContext,
                wrapPrepareQueryResource (cb) {
                    return cb();
                },
                retainQuery (info) {
                    this.getInteractionContext().retainQuery(info);
                }
            }), [
            interactionContext
        ]);
        const reactLooselyLazyContext = (0, $5uXOq.useMemo)(()=>{
            const moduleLoadingRequests = {};
            return {
                current: {
                    getInteractionContext () {
                        return interactionContext;
                    },
                    onPreload (moduleId, _priority) {
                        this.getInteractionContext().addPreload((0, (0, parcelRequire("iNl9c")).extractModuleName)(moduleId), performance.now());
                    },
                    onLoadStart (info) {
                        const timeoutId = setTimeout(()=>{
                            delete moduleLoadingRequests[info.identifier];
                        }, 30000);
                        const request = {
                            start: performance.now(),
                            timeoutId: timeoutId
                        };
                        moduleLoadingRequests[info.identifier] = request;
                    },
                    onLoadComplete (info) {
                        const request = moduleLoadingRequests[info.identifier];
                        if (request) {
                            clearTimeout(request.timeoutId);
                            delete moduleLoadingRequests[info.identifier];
                            this.getInteractionContext()?.addLoad((0, (0, parcelRequire("iNl9c")).extractModuleName)(info.identifier), request.start, performance.now());
                        }
                    },
                    placeholderFallBackMounted (id, name, lazyWait) {
                        if (lazyWait) return;
                        this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                    },
                    placeholderFallBackUnmounted (id, name, lazyWait) {
                        if (lazyWait) return;
                        this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                    }
                }
            };
        }, [
            interactionContext
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.ProfilerContext).Provider, {
            value: relayProfilerContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7UTZj")).ProfilerContext).Provider, {
            value: reactLooselyLazyContext
        }, children));
    }
    function $6056b4460d0127e0$export$2e2bcd8739ae039({ name: segmentName, children: children }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("77kYm")).default), {
            name: segmentName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($6056b4460d0127e0$var$JiraUFOSegmentWrapper, null, children));
    }
});
parcelRegister("4mO32", function(module, exports) {
    $parcel$export(module.exports, "useEntryPoint", ()=>$f8987436643ccece$export$338256068bc140fb);
    var $5uXOq = parcelRequire("5uXOq");
    var $c8WsS;
    var $9CqsK;
    var $j1gA4;
    var $bzXq1;
    const $f8987436643ccece$export$338256068bc140fb = (entryPoint, entryPointParams, metric, options = (0, (0, parcelRequire("c8WsS")).DEFAULT_OPTIONS))=>{
        const { entryPointReferenceSubject: entryPointReferenceSubject, ...loadActions } = (0, (0, parcelRequire("j1gA4")).useEntryPointLoadManager)(entryPoint, entryPointParams);
        const { startMetric: startMetric, stopMetric: stopMetric } = (0, (0, parcelRequire("bzXq1")).useMetricLogger)(metric);
        const entryPointActions = (0, (0, parcelRequire("9CqsK")).useEntryPointActions)(loadActions, options, startMetric);
        return (0, $5uXOq.useMemo)(()=>({
                entryPointActions: entryPointActions,
                entryPointReferenceSubject: entryPointReferenceSubject,
                stopMetric: stopMetric
            }), [
            entryPointActions,
            entryPointReferenceSubject,
            stopMetric
        ]);
    };
});
parcelRegister("c8WsS", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_OPTIONS", ()=>$34664e57314d5c26$export$93ca5d3f8675ae4c);
    const $34664e57314d5c26$export$93ca5d3f8675ae4c = {
        preloadMaxAge: 2000,
        timeToIntent: 200
    };
});
parcelRegister("9CqsK", function(module, exports) {
    $parcel$export(module.exports, "useEntryPointActions", ()=>$7bc2afeacf23b901$export$90681c8c3a56f09a);
    var $5uXOq = parcelRequire("5uXOq");
    var $jQsty;
    var $c8WsS;
    const $7bc2afeacf23b901$var$PRELOAD_KILLSWITCH = 'entry_point_preload';
    const $7bc2afeacf23b901$export$90681c8c3a56f09a = ({ loadEntryPoint: loadEntryPoint, unloadEntryPoint: unloadEntryPoint, commitPreload: commitPreload }, { preloadMaxAge: preloadMaxAge = (0, (0, parcelRequire("c8WsS")).DEFAULT_OPTIONS).preloadMaxAge, timeToIntent: timeToIntent = (0, (0, parcelRequire("c8WsS")).DEFAULT_OPTIONS).timeToIntent }, startMetric)=>{
        const preloadIntentTimeout = (0, $5uXOq.useRef)();
        const preloadMaxAgeTimeout = (0, $5uXOq.useRef)();
        const preloadLastRequested = (0, $5uXOq.useRef)(0);
        const cancelPreload = (0, $5uXOq.useCallback)(()=>{
            if (!(0, (0, parcelRequire("jQsty")).default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) {
                clearTimeout(preloadIntentTimeout.current);
                clearTimeout(preloadMaxAgeTimeout.current);
            }
        }, []);
        const load = (0, $5uXOq.useCallback)(()=>{
            cancelPreload();
            startMetric(preloadLastRequested.current);
            if (preloadLastRequested.current > 0) commitPreload();
            else loadEntryPoint();
            preloadLastRequested.current = 0;
        }, [
            cancelPreload,
            commitPreload,
            loadEntryPoint,
            startMetric
        ]);
        const preload = (0, $5uXOq.useCallback)(()=>{
            if ((0, (0, parcelRequire("jQsty")).default)($7bc2afeacf23b901$var$PRELOAD_KILLSWITCH)) return;
            cancelPreload();
            preloadIntentTimeout.current = setTimeout(()=>{
                preloadLastRequested.current = Date.now();
                loadEntryPoint({
                    isPreload: true
                });
                preloadMaxAgeTimeout.current = setTimeout(()=>{
                    preloadLastRequested.current = 0;
                }, preloadMaxAge);
            }, timeToIntent);
        }, [
            cancelPreload,
            loadEntryPoint,
            preloadMaxAge,
            timeToIntent
        ]);
        (0, $5uXOq.useEffect)(()=>cancelPreload, [
            cancelPreload
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                cancelPreload: cancelPreload,
                load: load,
                preload: preload,
                unload: unloadEntryPoint
            }), [
            cancelPreload,
            load,
            preload,
            unloadEntryPoint
        ]);
    };
});
parcelRegister("j1gA4", function(module, exports) {
    $parcel$export(module.exports, "useEntryPointLoadManager", ()=>$d6e83c6db8fa388b$export$bfae318f9651db2f);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $fiv1r;
    var $iU8T2;
    const $d6e83c6db8fa388b$export$bfae318f9651db2f = (entryPoint, entryPointParams)=>{
        const environmentProvider = (0, (0, parcelRequire("fiv1r")).useJiraRelayEnvironmentProvider)();
        const canLoad = (0, $5uXOq.useRef)(true);
        const timer = (0, $5uXOq.useRef)();
        const entryPointReferenceQueue = (0, $5uXOq.useRef)([]);
        const { getValue: getValue, setEntryPointReference: setEntryPointReference, subscribe: subscribe } = (0, (0, parcelRequire("iU8T2")).useEntryPointReferenceSubject)();
        const setNextUpdate = (0, $5uXOq.useCallback)((nextEntryPointReference)=>{
            setEntryPointReference(nextEntryPointReference);
            timer.current = setTimeout(()=>{
                const { current: currentQueue } = entryPointReferenceQueue;
                entryPointReferenceQueue.current = nextEntryPointReference === null ? (0, (0, parcelRequire("iU8T2")).removeAll)(currentQueue) : (0, (0, parcelRequire("iU8T2")).removeInactiveLoads)(currentQueue);
            }, 0);
        }, [
            setEntryPointReference
        ]);
        const load = (0, $5uXOq.useCallback)(({ isPreload: isPreload } = {
            isPreload: false
        })=>{
            if (canLoad.current) {
                const reference = (0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams);
                entryPointReferenceQueue.current.unshift({
                    value: reference,
                    isPreload: isPreload
                });
                if (isPreload) entryPointReferenceQueue.current = (0, (0, parcelRequire("iU8T2")).removeRedundantPreloads)(entryPointReferenceQueue.current);
                else setNextUpdate(reference);
            }
        }, [
            entryPoint,
            entryPointParams,
            environmentProvider,
            setNextUpdate
        ]);
        const unload = (0, $5uXOq.useCallback)(()=>{
            setNextUpdate(null);
        }, [
            setNextUpdate
        ]);
        const commitPreload = (0, $5uXOq.useCallback)(()=>{
            const [firstItem] = entryPointReferenceQueue.current;
            if (firstItem?.isPreload) {
                firstItem.isPreload = false;
                setNextUpdate(firstItem.value);
            }
        }, [
            setNextUpdate
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                clearTimeout(timer.current);
                canLoad.current = false;
                entryPointReferenceQueue.current = (0, (0, parcelRequire("iU8T2")).removeAll)(entryPointReferenceQueue.current);
            }, []);
        return {
            entryPointReferenceSubject: (0, $5uXOq.useMemo)(()=>({
                    getValue: getValue,
                    subscribe: subscribe
                }), [
                getValue,
                subscribe
            ]),
            loadEntryPoint: load,
            unloadEntryPoint: unload,
            commitPreload: commitPreload
        };
    };
});
parcelRegister("iU8T2", function(module, exports) {
    $parcel$export(module.exports, "removeRedundantPreloads", ()=>$011b3d8d407c2901$export$a5b3b808f05fede2);
    $parcel$export(module.exports, "removeInactiveLoads", ()=>$011b3d8d407c2901$export$ae329fe3ea179cb4);
    $parcel$export(module.exports, "removeAll", ()=>$011b3d8d407c2901$export$1cfc7aad5cb1833b);
    $parcel$export(module.exports, "useEntryPointReferenceSubject", ()=>$011b3d8d407c2901$export$322c8997d351da6a);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    const $011b3d8d407c2901$export$a5b3b808f05fede2 = (queue)=>{
        const [, ...potentialRedundantItems] = queue;
        potentialRedundantItems.forEach(({ isPreload: isPreload, value: value })=>{
            if (isPreload) value.dispose();
        });
        return queue.filter(({ value: value })=>!value.isDisposed);
    };
    const $011b3d8d407c2901$export$ae329fe3ea179cb4 = (queue)=>{
        if (queue.length === 0) return [];
        const [activeItem, ...redundantItems] = queue;
        redundantItems.forEach(({ value: value })=>{
            value.dispose();
        });
        return [
            activeItem
        ];
    };
    const $011b3d8d407c2901$export$1cfc7aad5cb1833b = (queue)=>{
        queue.forEach(({ value: value })=>{
            value.dispose();
        });
        return [];
    };
    const $011b3d8d407c2901$export$322c8997d351da6a = ()=>{
        const value = (0, $5uXOq.useRef)(null);
        const subscribers = (0, $5uXOq.useRef)();
        const subscribe = (0, $5uXOq.useCallback)((subscriber)=>{
            if (!subscribers.current) subscribers.current = new Set();
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current?.delete(subscriber);
            };
        }, []);
        const setEntryPointReference = (0, $5uXOq.useCallback)((entryPointReference)=>{
            value.current = entryPointReference;
            (0, $7nsd3.unstable_batchedUpdates)(()=>{
                if (subscribers.current) Array.from(subscribers.current).forEach((subscriber)=>{
                    subscriber(entryPointReference);
                });
            });
        }, []);
        const getValue = (0, $5uXOq.useCallback)(()=>value.current, []);
        (0, $5uXOq.useEffect)(()=>()=>{
                subscribers.current?.clear();
            }, []);
        return {
            getValue: getValue,
            setEntryPointReference: setEntryPointReference,
            subscribe: subscribe
        };
    };
});
parcelRegister("bzXq1", function(module, exports) {
    $parcel$export(module.exports, "useMetricLogger", ()=>$25198ca8fad8a13c$export$f291ec7cea728e1);
    var $5uXOq = parcelRequire("5uXOq");
    const $25198ca8fad8a13c$export$f291ec7cea728e1 = (metric)=>{
        const preloadStartTime = (0, $5uXOq.useRef)(0);
        const loadStartTime = (0, $5uXOq.useRef)(0);
        const startMetric = (0, $5uXOq.useCallback)((preloadTime = 0)=>{
            if (metric) {
                metric.start();
                preloadStartTime.current = preloadTime;
                loadStartTime.current = Date.now();
            }
        }, [
            metric
        ]);
        const stopMetric = (0, $5uXOq.useCallback)((additionalCustomData)=>{
            if (metric) {
                const preloadData = preloadStartTime.current > 0 ? {
                    preloadToStartDuration: loadStartTime.current - preloadStartTime.current
                } : undefined;
                const metricData = preloadData || additionalCustomData ? {
                    customData: {
                        ...preloadData,
                        ...additionalCustomData
                    }
                } : undefined;
                metric.stop(metricData);
            }
        }, [
            metric
        ]);
        return {
            startMetric: startMetric,
            stopMetric: stopMetric
        };
    };
});
parcelRegister("koeKL", function(module, exports) {
    $parcel$export(module.exports, "useCloudId", ()=>$559e3c14e9652b55$export$9da0f7c65f28ed16);
    var $9OXo1;
    const $559e3c14e9652b55$export$9da0f7c65f28ed16 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.cloudId;
    };
});
parcelRegister("kGfPy", function(module, exports) {
    $parcel$export(module.exports, "asyncSidebar", ()=>$b89f927130994d16$export$a9552895baaa7b3b);
    var $1b88j;
    var $2Ftxm;
    var $ikgNX;
    const $b89f927130994d16$export$a9552895baaa7b3b = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("aOBfa")), {
            moduleId: "6a9110b2"
        }),
        getPreloadProps: ({ cloudId: cloudId })=>({
                queries: {
                    templatesQueryRef: {
                        options: {
                            fetchPolicy: 'store-or-network'
                        },
                        parameters: (0, parcelRequire("1b88j")).default,
                        variables: {
                            cloudId: cloudId
                        }
                    }
                }
            })
    });
});
parcelRegister("1b88j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f8ad29d8f27e2c5$export$2e2bcd8739ae039);
    const $7f8ad29d8f27e2c5$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "d53e974e431db3cd183eaaccc995cde2da6295abb2ca1d5c4510995a129bb82a",
            "metadata": {},
            "name": "ui_growthRecommendationsInProjectList_RecommendationsInProjectListQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $7f8ad29d8f27e2c5$export$2e2bcd8739ae039 = $7f8ad29d8f27e2c5$var$node;
});
parcelRegister("aOBfa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hTT5V")
    ]).then(()=>parcelRequire('1sO0m'));
});
parcelRegister("7Hq8b", function(module, exports) {
    $parcel$export(module.exports, "SIDEBAR_WIDTH", ()=>$995a11da0cd37d3a$export$780035d9fe48eb32);
    $parcel$export(module.exports, "PANEL_ID", ()=>$995a11da0cd37d3a$export$e1d562d81d0e502d);
    $parcel$export(module.exports, "PROJECT_CREATE_SOURCE", ()=>$995a11da0cd37d3a$export$280536374592bda3);
    $parcel$export(module.exports, "PROJECT_TYPE_TARGETS_MAP", ()=>$995a11da0cd37d3a$export$990484f4e8c06c90);
    $parcel$export(module.exports, "getProductTypeCcpReferenceIdMapForEnv", ()=>$995a11da0cd37d3a$export$29629758934356a6);
    var $ar8lZ = parcelRequire("ar8lZ");
    var $35zuk;
    const $995a11da0cd37d3a$export$780035d9fe48eb32 = 365;
    const $995a11da0cd37d3a$export$e1d562d81d0e502d = 'recommendationsInProjectList';
    const $995a11da0cd37d3a$export$675d6d49067be942 = 'recommendationsInProjectListHoverAnchor';
    const $995a11da0cd37d3a$export$280536374592bda3 = 'recommendationsInProjectList';
    const $995a11da0cd37d3a$export$990484f4e8c06c90 = {
        BUSINESS: (0, $ar8lZ.Targets).JIRA_CORE,
        SOFTWARE: (0, $ar8lZ.Targets).JIRA_SOFTWARE,
        SERVICE_DESK: (0, $ar8lZ.Targets).JIRA_SERVICE_DESK,
        PRODUCT_DISCOVERY: (0, $ar8lZ.Targets).JIRA_PRODUCT_DISCOVERY
    };
    const $995a11da0cd37d3a$export$29629758934356a6 = (environment)=>{
        const env = environment === 'prod' ? 'prod' : 'staging';
        return {
            BUSINESS: (0, (0, parcelRequire("35zuk")).FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_work_management_cloud,
            SOFTWARE: (0, (0, parcelRequire("35zuk")).FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_software_cloud,
            SERVICE_DESK: (0, (0, parcelRequire("35zuk")).FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_service_management_cloud,
            PRODUCT_DISCOVERY: (0, (0, parcelRequire("35zuk")).FIRST_PARTY_CCP_PRODUCT_IDS)[env].jira_product_discovery
        };
    };
});
parcelRegister("f849T", function(module, exports) {
    $parcel$export(module.exports, "serverRenderedRightSidebar", ()=>$3e90ecc71eaea66f$export$4707e15fd1e8e43a);
    var $2Cry6;
    var $2Ftxm;
    var $ikgNX;
    const $3e90ecc71eaea66f$export$4707e15fd1e8e43a = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("02QCV")), {
            moduleId: "795c4be8"
        }),
        getPreloadProps: ({ tenantContext: tenantContext })=>({
                queries: {
                    templatesQueryRef: {
                        options: {
                            fetchPolicy: 'store-or-network'
                        },
                        parameters: (0, parcelRequire("2Cry6")).default,
                        variables: {
                            cloudId: tenantContext.cloudId,
                            isAnonymous: tenantContext.isAnonymous
                        }
                    }
                }
            })
    });
});
parcelRegister("2Cry6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c970ed461b0f69e3$export$2e2bcd8739ae039);
    const $c970ed461b0f69e3$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "b229b054ed73f6325d6caffd55b233a3c29d86aac2d49a1351ee057ca0f53039",
            "metadata": {},
            "name": "ssrExperiment_ui_growthRecommendationsInProjectList_RecommendationsInProjectListQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $c970ed461b0f69e3$export$2e2bcd8739ae039 = $c970ed461b0f69e3$var$node;
});
parcelRegister("02QCV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("4hxxI")
    ]).then(()=>parcelRequire('cf0PW'));
});
parcelRegister("hW253", function(module, exports) {
    $parcel$export(module.exports, "projectsDirectoryPageResource", ()=>$4c805bc331263d5b$export$aabb201a7f7100c5);
    var $8Uumt = parcelRequire("8Uumt");
    var $65Ltd;
    var $co1wz;
    var $4R6GH;
    var $gkT9B;
    var $8pIiT;
    var $5yJb9;
    var $kipqU;
    var $ao2h1;
    var $lVQ0r;
    var $dIdda = parcelRequire("dIdda");
    const $4c805bc331263d5b$export$aabb201a7f7100c5 = (0, $dIdda.createResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${(0, $ce818d5819645fe8$export$2150caade62dc875)}`,
        getKey: ()=>'projects-directory-relay',
        getData: async ({ query: query, route: route }, { tenantContext: tenantContext })=>{
            const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
            if (false && isAnonymous) return null;
            const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("lVQ0r")).default), {
                cloudId: tenantContext.cloudId,
                filter: (0, (0, parcelRequire("8pIiT")).mapQueryToFilter)((0, (0, parcelRequire("gkT9B")).filterInitialState), {
                    cloudId: cloudId,
                    query: (0, (0, parcelRequire("8pIiT")).sanitizeLegacyQuery)(query),
                    aliases: (0, (0, parcelRequire("gkT9B")).filterAliasMap)
                }),
                first: query?.page ? (0, (0, parcelRequire("gkT9B")).DEFAULT_LIMIT) * (parseInt(query.page, 10) || 1) : (0, (0, parcelRequire("gkT9B")).DEFAULT_LIMIT),
                last: (0, (0, parcelRequire("gkT9B")).DEFAULT_LIMIT),
                isAdminSettingsContext: route.name === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE),
                isAnonymous: isAnonymous,
                skipShouldShowRightSidebar: isAnonymous || (0, (0, parcelRequire("co1wz")).ff)('server-render-projects-directory-sidebar_rj9ki'),
                isImporterDiscoveryExperimentEnabled: (0, (0, parcelRequire("4R6GH")).fg)('jira_importer_projects_directory_cta_gate')
            }, {
                fetchPolicy: 'network-only'
            });
            if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            return queryReference;
        }
    });
});
parcelRegister("gkT9B", function(module, exports) {
    $parcel$export(module.exports, "TableColumns", ()=>$4e4ac97bc1b1894b$export$b0e68791ad9c52df);
    $parcel$export(module.exports, "SortableColumns", ()=>$4e4ac97bc1b1894b$export$f9e740ef44a4c43a);
    $parcel$export(module.exports, "FilterFields", ()=>$4e4ac97bc1b1894b$export$e38c2fbdcbc20613);
    $parcel$export(module.exports, "filterAliasMap", ()=>$4e4ac97bc1b1894b$export$5bc0ad9873e5cd89);
    $parcel$export(module.exports, "filterInitialState", ()=>$4e4ac97bc1b1894b$export$fcb7b3e474e67781);
    $parcel$export(module.exports, "DEFAULT_LIMIT", ()=>$4e4ac97bc1b1894b$export$ebc5ec3267fbcf57);
    $parcel$export(module.exports, "PROJECTS_DIRECTORY_EXPERIENCE", ()=>$4e4ac97bc1b1894b$export$7c1bd7128901e2c4);
    $parcel$export(module.exports, "MANAGE_PROJECTS_DIRECTORY_EXPERIENCE", ()=>$4e4ac97bc1b1894b$export$72fb94bf1b8ec849);
    var $7OwSg;
    const $4e4ac97bc1b1894b$export$b0e68791ad9c52df = {
        Favourites: 'favourite',
        Key: 'key',
        Name: 'name',
        Type: 'type',
        Lead: 'lead',
        Category: 'category',
        LastIssueUpdate: 'last_issue_updated_time',
        Url: 'url',
        Action: 'actions'
    };
    const $4e4ac97bc1b1894b$export$f9e740ef44a4c43a = [
        $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Favourites,
        $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Key,
        $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Name,
        $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Lead,
        $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Category,
        $4e4ac97bc1b1894b$export$b0e68791ad9c52df.LastIssueUpdate
    ];
    const $4e4ac97bc1b1894b$export$e38c2fbdcbc20613 = {
        Keyword: 'keyword',
        ProjectType: 'types',
        ProjectTypeLabel: 'ProjectTypeLabel',
        ProjectCategoryId: 'projectCategoryId',
        ProjectCategoryLabel: 'projectCategoryLabel',
        ...(0, (0, parcelRequire("7OwSg")).DefaultFilterFields)
    };
    const $4e4ac97bc1b1894b$export$5bc0ad9873e5cd89 = {
        contains: $4e4ac97bc1b1894b$export$e38c2fbdcbc20613.Keyword,
        selectedProjectType: $4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectType,
        selectedCategory: $4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectCategoryId
    };
    const $4e4ac97bc1b1894b$export$fcb7b3e474e67781 = {
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.Keyword]: '',
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectType]: '',
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectTypeLabel]: '',
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectCategoryId]: '',
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.ProjectCategoryLabel]: '',
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.SortOrder]: 'ASC',
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.SortKey]: $4e4ac97bc1b1894b$export$b0e68791ad9c52df.Name,
        [$4e4ac97bc1b1894b$export$e38c2fbdcbc20613.Page]: '1'
    };
    const $4e4ac97bc1b1894b$export$ebc5ec3267fbcf57 = 25;
    const $4e4ac97bc1b1894b$export$7c1bd7128901e2c4 = 'viewProjectsDirectoryV3';
    const $4e4ac97bc1b1894b$export$72fb94bf1b8ec849 = 'viewManageProjectsDirectoryV3';
});
parcelRegister("7OwSg", function(module, exports) {
    $parcel$export(module.exports, "DefaultFilterFields", ()=>$30cd11272c627f6b$export$7ecdd4b6ae40e139);
    $parcel$export(module.exports, "createUseFilter", ()=>$30cd11272c627f6b$export$ef79d9c1dcb09f8f);
    var $ebyGx = parcelRequire("ebyGx");
    var $jcw0u;
    var $7JoAD = parcelRequire("7JoAD");
    const $30cd11272c627f6b$export$7ecdd4b6ae40e139 = {
        SortOrder: 'sortOrder',
        SortKey: 'sortKey',
        Page: 'page'
    };
    const $30cd11272c627f6b$export$ef79d9c1dcb09f8f = (storeName, { getInitialState: getInitialState })=>{
        const actions = {
            updateFilter: (nameOrFilter, value)=>({ setState: setState, getState: getState }, { onUpdate: onUpdate })=>{
                    const newFilter = typeof nameOrFilter === 'object' ? nameOrFilter : {
                        [nameOrFilter]: value
                    };
                    setState({
                        ...getState(),
                        [$30cd11272c627f6b$export$7ecdd4b6ae40e139.Page]: 1,
                        ...newFilter
                    });
                    onUpdate(getState());
                },
            forceUpdate: ()=>({ getState: getState }, { onUpdate: onUpdate })=>onUpdate(getState())
        };
        const Store = (0, $7JoAD.createStore)({
            initialState: {},
            actions: actions,
            name: storeName
        });
        const useFilter = (0, $7JoAD.createHook)(Store);
        const useScopedFilter = (0, $7JoAD.createHook)(Store, {
            selector: (state, name)=>state[name]
        });
        const FilterContainer = (0, $7JoAD.createContainer)(Store, {
            onInit: ()=>({ setState: setState })=>{
                    try {
                        const routeQuery = (0, ($parcel$interopDefault($ebyGx))).parse(window.location.search);
                        setState(getInitialState({
                            routeQuery: routeQuery
                        }));
                    } catch (error) {
                        (0, (0, parcelRequire("jcw0u")).default)({
                            error: error,
                            meta: {
                                id: 'createUseFilter',
                                packageName: 'jiraDirectoryBaseV3',
                                teamName: 'jira-cosmos'
                            }
                        });
                    }
                },
            onCleanup: ()=>({ setState: setState })=>setState(getInitialState({
                        routeQuery: {}
                    }))
        });
        return {
            useFilter: useFilter,
            useScopedFilter: useScopedFilter,
            FilterContainer: FilterContainer
        };
    };
});
parcelRegister("8pIiT", function(module, exports) {
    $parcel$export(module.exports, "sanitizeLegacyQuery", ()=>$ddc7efe5cefc2e09$export$b6d5141c3209bd35);
    $parcel$export(module.exports, "mapQueryToFilter", ()=>$ddc7efe5cefc2e09$export$2274cd5f35844a96);
    var $2vSU6;
    var $dZhZb;
    var $dXq4S;
    var $gkT9B;
    const $ddc7efe5cefc2e09$var$LEGACY_ALL_VALUE = 'all';
    const $ddc7efe5cefc2e09$export$b6d5141c3209bd35 = (query)=>({
            ...query,
            selectedProjectType: query.selectedProjectType === $ddc7efe5cefc2e09$var$LEGACY_ALL_VALUE ? (0, (0, parcelRequire("gkT9B")).filterInitialState)[(0, (0, parcelRequire("gkT9B")).FilterFields).ProjectType] : query.selectedProjectType,
            selectedCategory: query.selectedCategory === $ddc7efe5cefc2e09$var$LEGACY_ALL_VALUE ? (0, (0, parcelRequire("gkT9B")).filterInitialState)[(0, (0, parcelRequire("gkT9B")).FilterFields).ProjectCategoryId] : query.selectedCategory
        });
    const $ddc7efe5cefc2e09$export$2274cd5f35844a96 = (filter, { cloudId: cloudId, query: query, aliases: aliases })=>{
        const variables = {};
        const { [(0, (0, parcelRequire("gkT9B")).FilterFields).Keyword]: keyword, [(0, (0, parcelRequire("gkT9B")).FilterFields).ProjectCategoryId]: projectCategoryId, [(0, (0, parcelRequire("gkT9B")).FilterFields).ProjectType]: types, [(0, (0, parcelRequire("gkT9B")).FilterFields).SortOrder]: sortOrder, [(0, (0, parcelRequire("gkT9B")).FilterFields).SortKey]: sortKey } = aliases && query ? (0, (0, parcelRequire("dZhZb")).matchAliases)(filter, query, aliases) : filter;
        if (keyword) variables.keyword = keyword;
        if (projectCategoryId) variables.projectCategoryId = (0, (0, parcelRequire("dXq4S")).isAri)(projectCategoryId) ? projectCategoryId : (0, (0, parcelRequire("dXq4S")).createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project-category',
            resourceId: projectCategoryId
        });
        if (sortKey || sortOrder) {
            const sortByValue = sortKey && (0, (0, parcelRequire("gkT9B")).SortableColumns).includes(sortKey) ? sortKey : (0, (0, parcelRequire("gkT9B")).filterInitialState)[(0, (0, parcelRequire("gkT9B")).FilterFields).SortKey];
            variables.sortBy = {
                order: [
                    'ASC',
                    'DESC'
                ].includes(sortOrder) ? sortOrder : (0, (0, parcelRequire("gkT9B")).filterInitialState)[(0, (0, parcelRequire("gkT9B")).FilterFields).SortOrder],
                sortBy: sortByValue.toUpperCase()
            };
        }
        if (types && typeof types === 'string') variables.types = types.split(',').filter((type)=>(0, (0, parcelRequire("2vSU6")).PROJECT_TYPES).includes(type)).map((type)=>type.toUpperCase());
        return variables;
    };
});
parcelRegister("dZhZb", function(module, exports) {
    $parcel$export(module.exports, "matchAliases", ()=>$e41b5d91b7cfd8ce$export$55f686d7a3507dbe);
    $parcel$export(module.exports, "serializeSelectOptions", ()=>$e41b5d91b7cfd8ce$export$74a705e0bee1565b);
    $parcel$export(module.exports, "serializeSelectOptionsLabel", ()=>$e41b5d91b7cfd8ce$export$eed751fcc55ddadd);
    $parcel$export(module.exports, "matchValueToSelectOptions", ()=>$e41b5d91b7cfd8ce$export$17e142fa55464467);
    var $ggSx2 = parcelRequire("ggSx2");
    var $cuHs1 = parcelRequire("cuHs1");
    const $e41b5d91b7cfd8ce$export$55f686d7a3507dbe = (filterState, query, aliases)=>Object.keys(query).reduce((filter, key)=>{
            const alias = aliases[key];
            const queryValue = query[key];
            const hasInitialValue = filter[key] !== undefined;
            if (hasInitialValue && queryValue) {
                filter[key] = queryValue;
                return filter;
            }
            if (!alias || !queryValue) return filter;
            filter[alias] = queryValue;
            return filter;
        }, {
            ...filterState
        });
    const $e41b5d91b7cfd8ce$export$40bf1812f0f07002 = (data, aliases)=>{
        const invertedAliases = (0, ($parcel$interopDefault($ggSx2)))(aliases);
        return (0, ($parcel$interopDefault($cuHs1)))(data, (_, key)=>invertedAliases[key] || key);
    };
    const $e41b5d91b7cfd8ce$export$74a705e0bee1565b = (options)=>options.map((v)=>v.value).join(',');
    const $e41b5d91b7cfd8ce$export$eed751fcc55ddadd = (options)=>options.map((v)=>v.label).join(',');
    const $e41b5d91b7cfd8ce$export$17e142fa55464467 = (value, options)=>value ? value.split(',').map((val)=>options.find((option)=>option.value === val)).filter(Boolean) : [];
});
parcelRegister("ggSx2", function(module, exports) {
    var $cxSdl = parcelRequire("cxSdl");
    var $fxKlj = parcelRequire("fxKlj");
    var $etyzk = parcelRequire("etyzk");
    var $bd8870e21c3833a0$var$objectProto = Object.prototype;
    var $bd8870e21c3833a0$var$nativeObjectToString = $bd8870e21c3833a0$var$objectProto.toString;
    var $bd8870e21c3833a0$var$invert = $fxKlj(function(result, value, key) {
        if (value != null && typeof value.toString != 'function') value = $bd8870e21c3833a0$var$nativeObjectToString.call(value);
        result[value] = key;
    }, $cxSdl($etyzk));
    module.exports = $bd8870e21c3833a0$var$invert;
});
parcelRegister("fxKlj", function(module, exports) {
    var $d1nCg = parcelRequire("d1nCg");
    function $b50de2cb57eb155c$var$createInverter(setter, toIteratee) {
        return function(object, iteratee) {
            return $d1nCg(object, setter, toIteratee(iteratee), {});
        };
    }
    module.exports = $b50de2cb57eb155c$var$createInverter;
});
parcelRegister("d1nCg", function(module, exports) {
    var $hDnyx = parcelRequire("hDnyx");
    function $97adb007e27dc709$var$baseInverter(object, setter, iteratee, accumulator) {
        $hDnyx(object, function(value, key, object) {
            setter(accumulator, iteratee(value), key, object);
        });
        return accumulator;
    }
    module.exports = $97adb007e27dc709$var$baseInverter;
});
parcelRegister("lVQ0r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0264f0fee7e7a1be$export$2e2bcd8739ae039);
    var $eiowN = parcelRequire("eiowN");
    const $0264f0fee7e7a1be$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAdminSettingsContext"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAnonymous"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isImporterDiscoveryExperimentEnabled"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "last"
        }, v7 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skipShouldShowRightSidebar"
        }, v8 = {
            "kind": "Variable",
            "name": "isAnonymous",
            "variableName": "isAnonymous"
        }, v9 = [
            v8
        ], v10 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v11 = {
            "alias": "canBrowseProjects",
            "args": [
                v10,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "BROWSE_PROJECTS"
                }
            ],
            "concreteType": "JiraPermission",
            "kind": "LinkedField",
            "name": "permission",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasPermission"
                }
            ]
        }, v12 = [
            v10
        ], v13 = [
            {
                "kind": "ScalarField",
                "name": "canPerform"
            }
        ], v14 = {
            "kind": "ScalarField",
            "name": "id"
        }, v15 = {
            "kind": "ScalarField",
            "name": "name"
        }, v16 = {
            "kind": "ScalarField",
            "name": "isFavourite"
        }, v17 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v18 = {
            "kind": "ScalarField",
            "name": "key"
        }, v19 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v20 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v21 = {
            "kind": "ScalarField",
            "name": "projectListRightPanelState"
        }, v22 = {
            "alias": "sidebarExperimentTemplates",
            "args": [
                v10,
                {
                    "kind": "Literal",
                    "name": "experimentKey",
                    "value": "sidebarExperiment"
                }
            ],
            "concreteType": "JiraProjectListViewTemplateConnection",
            "kind": "LinkedField",
            "name": "projectListViewTemplates",
            "plural": false,
            "selections": [
                v20
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7
                ],
                "kind": "Fragment",
                "name": "pageLayout_projectsDirectoryLayout_RootQuery",
                "selections": [
                    {
                        "args": [
                            v8,
                            {
                                "kind": "Variable",
                                "name": "isImporterDiscoveryExperimentEnabled",
                                "variableName": "isImporterDiscoveryExperimentEnabled"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "header_projectsDirectoryV3"
                    },
                    {
                        "args": v9,
                        "kind": "FragmentSpread",
                        "name": "refinementBar_projectsDirectoryV3_Filters"
                    },
                    {
                        "args": v9,
                        "kind": "FragmentSpread",
                        "name": "projectsList_projectsDirectoryV3_rootQueryRef"
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "isAdminSettingsContext",
                                "variableName": "isAdminSettingsContext"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "pageLayout_projectsDirectoryV3_ProjectDirectoryLayout"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "emptyView_projectsDirectoryV3"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "noPermissionViews_projectsDirectoryV3"
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            v11
                        ]
                    },
                    {
                        "condition": "skipShouldShowRightSidebar",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "rightPanel_projectsDirectoryV3_ShouldShowRightSidebar"
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v6,
                    v3,
                    v4,
                    v7,
                    v5
                ],
                "kind": "Operation",
                "name": "pageLayout_projectsDirectoryLayout_RootQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "canCreateProject",
                                "args": [
                                    v10,
                                    {
                                        "kind": "Literal",
                                        "name": "type",
                                        "value": "CREATE_PROJECT"
                                    }
                                ],
                                "kind": "ScalarField",
                                "name": "canPerform"
                            },
                            {
                                "args": v12,
                                "concreteType": "JiraWorkManagementLicensing",
                                "kind": "LinkedField",
                                "name": "jwmLicensing",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "currentUserSeatEdition"
                                    }
                                ]
                            },
                            {
                                "args": [
                                    v10,
                                    {
                                        "kind": "Variable",
                                        "name": "filter",
                                        "variableName": "filter"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "first",
                                        "variableName": "first"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "last",
                                        "variableName": "last"
                                    }
                                ],
                                "concreteType": "JiraProjectConnection",
                                "kind": "LinkedField",
                                "name": "allJiraProjects",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "alias": "canViewIssue",
                                                        "args": [
                                                            {
                                                                "kind": "Literal",
                                                                "name": "type",
                                                                "value": "VIEW_ISSUES"
                                                            }
                                                        ],
                                                        "concreteType": "JiraProjectAction",
                                                        "kind": "LinkedField",
                                                        "name": "action",
                                                        "plural": false,
                                                        "selections": v13,
                                                        "storageKey": "action(type:\"VIEW_ISSUES\")"
                                                    },
                                                    v14,
                                                    v15,
                                                    v16,
                                                    {
                                                        "concreteType": "JiraFavouriteValue",
                                                        "kind": "LinkedField",
                                                        "name": "favouriteValue",
                                                        "plural": false,
                                                        "selections": [
                                                            v16,
                                                            v17,
                                                            v14
                                                        ]
                                                    },
                                                    v18,
                                                    {
                                                        "concreteType": "JiraAvatar",
                                                        "kind": "LinkedField",
                                                        "name": "avatar",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "medium"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "projectStyle"
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "navigationMetadata",
                                                        "plural": false,
                                                        "selections": [
                                                            v19,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "boardId"
                                                                    },
                                                                    v14
                                                                ],
                                                                "type": "JiraSoftwareProjectNavigationMetadata"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "queueId"
                                                                    }
                                                                ],
                                                                "type": "JiraServiceManagementProjectNavigationMetadata"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "projectType"
                                                    },
                                                    {
                                                        "concreteType": "JiraProjectCategory",
                                                        "kind": "LinkedField",
                                                        "name": "category",
                                                        "plural": false,
                                                        "selections": [
                                                            v15,
                                                            v14
                                                        ]
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "lead",
                                                        "plural": false,
                                                        "selections": [
                                                            v19,
                                                            {
                                                                "kind": "TypeDiscriminator",
                                                                "abstractKey": "__isUser"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "accountId"
                                                            },
                                                            v15,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "picture"
                                                            },
                                                            v14
                                                        ]
                                                    },
                                                    {
                                                        "condition": "isAdminSettingsContext",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                            {
                                                                "alias": "lastUpdatedToolTipDate",
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "format",
                                                                        "value": "COMPLETE_DATETIME_FORMAT"
                                                                    }
                                                                ],
                                                                "kind": "ScalarField",
                                                                "name": "lastUpdatedFormatted",
                                                                "storageKey": "lastUpdatedFormatted(format:\"COMPLETE_DATETIME_FORMAT\")"
                                                            },
                                                            {
                                                                "alias": "lastUpdatedDisplayDate",
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "format",
                                                                        "value": "RELATIVE"
                                                                    }
                                                                ],
                                                                "kind": "ScalarField",
                                                                "name": "lastUpdatedFormatted",
                                                                "storageKey": "lastUpdatedFormatted(format:\"RELATIVE\")"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "projectUrl"
                                                    },
                                                    {
                                                        "alias": "canEdit",
                                                        "args": [
                                                            {
                                                                "kind": "Literal",
                                                                "name": "type",
                                                                "value": "EDIT_PROJECT_CONFIG"
                                                            }
                                                        ],
                                                        "concreteType": "JiraProjectAction",
                                                        "kind": "LinkedField",
                                                        "name": "action",
                                                        "plural": false,
                                                        "selections": v13,
                                                        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                                                    },
                                                    {
                                                        "alias": "canViewProjectConfig",
                                                        "args": [
                                                            {
                                                                "kind": "Literal",
                                                                "name": "type",
                                                                "value": "VIEW_PROJECT_CONFIG"
                                                            }
                                                        ],
                                                        "concreteType": "JiraProjectAction",
                                                        "kind": "LinkedField",
                                                        "name": "action",
                                                        "plural": false,
                                                        "selections": v13,
                                                        "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                                                    },
                                                    {
                                                        "alias": "jiraProjectType",
                                                        "kind": "ScalarField",
                                                        "name": "projectType"
                                                    },
                                                    {
                                                        "alias": "jiraProjectName",
                                                        "kind": "ScalarField",
                                                        "name": "name"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    v20,
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isHasTotal"
                                    }
                                ]
                            },
                            {
                                "alias": "canContactAdmin",
                                "args": [
                                    v10,
                                    {
                                        "kind": "Literal",
                                        "name": "keys",
                                        "value": "jira.show.contact.administrators.form"
                                    }
                                ],
                                "concreteType": "JiraApplicationProperty",
                                "kind": "LinkedField",
                                "name": "applicationPropertiesByKey",
                                "plural": true,
                                "selections": [
                                    v18,
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    },
                                    v14
                                ]
                            },
                            v11,
                            {
                                "condition": "isAnonymous",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "args": v12,
                                        "concreteType": "JiraUserPreferences",
                                        "kind": "LinkedField",
                                        "name": "userPreferences",
                                        "plural": false,
                                        "selections": [
                                            v21,
                                            v17
                                        ]
                                    },
                                    v22,
                                    {
                                        "args": v12,
                                        "concreteType": "JiraProjectCategoryConnection",
                                        "kind": "LinkedField",
                                        "name": "allJiraProjectCategories",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProjectCategoryEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    v19
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "isAnonymous",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "args": v12,
                                        "concreteType": "JiraProjectCategoryConnection",
                                        "kind": "LinkedField",
                                        "name": "allJiraProjectCategories",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProjectCategoryEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    v19,
                                                    {
                                                        "concreteType": "JiraProjectCategory",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v14,
                                                            v15
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": v12,
                                "concreteType": "JiraProjectTypeDetailsConnection",
                                "kind": "LinkedField",
                                "name": "allJiraProjectTypes",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectTypeDetailsEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProjectTypeDetails",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v18,
                                                    v14
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "skipShouldShowRightSidebar",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v12,
                                        "concreteType": "JiraUserPreferences",
                                        "kind": "LinkedField",
                                        "name": "userPreferences",
                                        "plural": false,
                                        "selections": [
                                            v21
                                        ]
                                    },
                                    v22
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "c5bf480cfcc7e1667e0f3ca7923ae0e7fb82b6dc49abd4df64797411cc629cfd",
                "metadata": {},
                "name": "pageLayout_projectsDirectoryLayout_RootQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $0264f0fee7e7a1be$var$node.hash = "44419374ddb19dca6c3a1596b677f976";
    (0, $eiowN.PreloadableQueryRegistry).set($0264f0fee7e7a1be$var$node.params.id, $0264f0fee7e7a1be$var$node);
    var $0264f0fee7e7a1be$export$2e2bcd8739ae039 = $0264f0fee7e7a1be$var$node;
});
const $ce818d5819645fe8$export$2150caade62dc875 = 'PROJECTS_DIRECTORY_RELAY';
parcelRegister("1xIol", function(module, exports) {
    $parcel$export(module.exports, "projectsDirectoryRoute", ()=>$4b60f76eec2e5934$export$74114064f06cd71b);
    $parcel$export(module.exports, "manageProjectsDirectoryRoute", ()=>$4b60f76eec2e5934$export$281a4490a0f8fb4c);
    $parcel$export(module.exports, "projectsDirectoryRedirectRoute", ()=>$4b60f76eec2e5934$export$d44f1be3782f0fde);
    $parcel$export(module.exports, "projectsDirectoryLegacyPathRedirectRoute", ()=>$4b60f76eec2e5934$export$c713f57300a82898);
    $parcel$export(module.exports, "projectsDirectoryManageRedirectRoute", ()=>$4b60f76eec2e5934$export$dbd3b6c012e8b6dc);
    $parcel$export(module.exports, "projectsDirectoryManageRootRedirectRoute", ()=>$4b60f76eec2e5934$export$4531e3b2e25fad23);
    var $65Ltd;
    const $4b60f76eec2e5934$export$74114064f06cd71b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY),
        path: '/jira/projects',
        exact: true
    };
    const $4b60f76eec2e5934$export$281a4490a0f8fb4c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE),
        path: '/jira/settings/projects/manage'
    };
    const $4b60f76eec2e5934$export$d44f1be3782f0fde = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY)}-redirect`,
        path: '/projects',
        exact: true
    };
    const $4b60f76eec2e5934$export$c713f57300a82898 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_DIRECTORIES),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY_LEGACY_PATH_SPA)}-redirect`,
        path: '/secure/BrowseProjects.jspa'
    };
    const $4b60f76eec2e5934$export$dbd3b6c012e8b6dc = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE)}-redirect`,
        path: '/secure/project/ViewProjects.jspa'
    };
    const $4b60f76eec2e5934$export$4531e3b2e25fad23 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_DIRECTORY_MANAGE)}-root-redirect`,
        path: '/jira/settings/projects',
        exact: true
    };
});
parcelRegister("7wpGh", function(module, exports) {
    $parcel$export(module.exports, "projectsDirectoryEntryPoint", ()=>$94d9041756c0d8ee$export$80225215a10b2688);
    var $co1wz;
    var $4R6GH;
    var $dXq4S;
    var $9M2wg;
    var $XE7Ks;
    var $ikgNX;
    const $94d9041756c0d8ee$var$DEFAULT_LIMIT = 25;
    const $94d9041756c0d8ee$var$PROJECTS_DIRECTORY_MANAGE = 'projects-directory-manage';
    const $94d9041756c0d8ee$var$DefaultFilterFields = {
        SortOrder: 'sortOrder',
        SortKey: 'sortKey',
        Page: 'page'
    };
    var $94d9041756c0d8ee$var$TableColumns;
    (function(TableColumns) {
        TableColumns["Favourites"] = "favourites";
        TableColumns["Key"] = "key";
        TableColumns["Name"] = "name";
        TableColumns["Type"] = "type";
        TableColumns["Lead"] = "lead";
        TableColumns["Category"] = "category";
        TableColumns["LastIssueUpdate"] = "last_issue_updated_time";
        TableColumns["Url"] = "url";
        TableColumns["Action"] = "actions";
    })($94d9041756c0d8ee$var$TableColumns || ($94d9041756c0d8ee$var$TableColumns = {}));
    const $94d9041756c0d8ee$var$SortableColumns = [
        "key",
        "name",
        "lead",
        "category",
        "last_issue_updated_time"
    ];
    const $94d9041756c0d8ee$var$FilterFields = {
        Keyword: 'keyword',
        ProjectType: 'types',
        ProjectCategoryId: 'projectCategoryId',
        ...$94d9041756c0d8ee$var$DefaultFilterFields
    };
    const $94d9041756c0d8ee$var$filterAliasMap = {
        contains: $94d9041756c0d8ee$var$FilterFields.Keyword,
        selectedProjectType: $94d9041756c0d8ee$var$FilterFields.ProjectType,
        selectedCategory: $94d9041756c0d8ee$var$FilterFields.ProjectCategoryId
    };
    const $94d9041756c0d8ee$var$filterInitialState = {
        [$94d9041756c0d8ee$var$FilterFields.Keyword]: '',
        [$94d9041756c0d8ee$var$FilterFields.ProjectType]: '',
        [$94d9041756c0d8ee$var$FilterFields.ProjectCategoryId]: '',
        [$94d9041756c0d8ee$var$FilterFields.SortOrder]: 'ASC',
        [$94d9041756c0d8ee$var$FilterFields.SortKey]: "name",
        [$94d9041756c0d8ee$var$FilterFields.Page]: '1'
    };
    const $94d9041756c0d8ee$var$LEGACY_ALL_VALUE = 'all';
    const $94d9041756c0d8ee$var$sanitizeLegacyQuery = (query = {})=>({
            ...query,
            selectedProjectType: query.selectedProjectType === $94d9041756c0d8ee$var$LEGACY_ALL_VALUE ? $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.ProjectType] : query.selectedProjectType,
            selectedCategory: query.selectedCategory === $94d9041756c0d8ee$var$LEGACY_ALL_VALUE ? $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.ProjectCategoryId] : query.selectedCategory
        });
    const $94d9041756c0d8ee$var$matchAliases = (filterState, query, aliases)=>Object.keys(query).reduce((filter, key)=>{
            const alias = aliases[key];
            const queryValue = query[key];
            const hasInitialValue = filter[key] !== undefined;
            if (hasInitialValue && queryValue) {
                filter[key] = queryValue;
                return filter;
            }
            if (!alias || !queryValue) return filter;
            filter[alias] = queryValue;
            return filter;
        }, {
            ...filterState
        });
    const $94d9041756c0d8ee$var$CORE_PROJECT = 'business';
    const $94d9041756c0d8ee$var$SOFTWARE_PROJECT = 'software';
    const $94d9041756c0d8ee$var$SERVICE_DESK_PROJECT = 'service_desk';
    const $94d9041756c0d8ee$var$PRODUCT_DISCOVERY_PROJECT = 'product_discovery';
    const $94d9041756c0d8ee$var$PROJECT_TYPES = [
        $94d9041756c0d8ee$var$CORE_PROJECT,
        $94d9041756c0d8ee$var$SOFTWARE_PROJECT,
        $94d9041756c0d8ee$var$SERVICE_DESK_PROJECT,
        $94d9041756c0d8ee$var$PRODUCT_DISCOVERY_PROJECT
    ];
    const $94d9041756c0d8ee$var$mapQueryToFilter = (filter, { cloudId: cloudId, query: query, aliases: aliases })=>{
        const variables = {};
        const { [$94d9041756c0d8ee$var$FilterFields.Keyword]: keyword, [$94d9041756c0d8ee$var$FilterFields.ProjectCategoryId]: projectCategoryId, [$94d9041756c0d8ee$var$FilterFields.ProjectType]: types, [$94d9041756c0d8ee$var$FilterFields.SortOrder]: sortOrder, [$94d9041756c0d8ee$var$FilterFields.SortKey]: sortKey } = aliases && query ? $94d9041756c0d8ee$var$matchAliases(filter, query, aliases) : filter;
        if (keyword) variables.keyword = keyword;
        if (projectCategoryId) variables.projectCategoryId = (0, (0, parcelRequire("dXq4S")).isAri)(projectCategoryId) ? projectCategoryId : (0, (0, parcelRequire("dXq4S")).createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project-category',
            resourceId: projectCategoryId
        });
        if (sortKey || sortOrder) {
            const sortByValue = sortKey && $94d9041756c0d8ee$var$SortableColumns.includes(sortKey) ? sortKey : $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.SortKey];
            variables.sortBy = {
                order: [
                    'ASC',
                    'DESC'
                ].includes(sortOrder) ? sortOrder : $94d9041756c0d8ee$var$filterInitialState[$94d9041756c0d8ee$var$FilterFields.SortOrder],
                sortBy: sortByValue.toUpperCase()
            };
        }
        if (types && typeof types === 'string') variables.types = types.split(',').filter((type)=>$94d9041756c0d8ee$var$PROJECT_TYPES.includes(type)).map((type)=>type.toUpperCase());
        return variables;
    };
    const $94d9041756c0d8ee$export$80225215a10b2688 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("XE7Ks")).JSResourceForUserVisible)(()=>(parcelRequire("4nnZF")), {
            moduleId: "b77224b3"
        }),
        getPreloadProps ({ context: { query: query, route: route }, tenantContext: tenantContext }) {
            const { cloudId: cloudId, isAnonymous: isAnonymous } = tenantContext;
            const extraProps = {
                isAdminProjectDirectoryRoute: route.name === $94d9041756c0d8ee$var$PROJECTS_DIRECTORY_MANAGE
            };
            if (false && isAnonymous) return {
                extraProps: extraProps
            };
            return {
                queries: {
                    projectsDirectoryPage: {
                        options: {
                            fetchPolicy: 'network-only'
                        },
                        parameters: (0, (0, parcelRequire("9M2wg")).default),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            filter: $94d9041756c0d8ee$var$mapQueryToFilter($94d9041756c0d8ee$var$filterInitialState, {
                                cloudId: cloudId,
                                query: $94d9041756c0d8ee$var$sanitizeLegacyQuery(query),
                                aliases: $94d9041756c0d8ee$var$filterAliasMap
                            }),
                            first: query?.page ? $94d9041756c0d8ee$var$DEFAULT_LIMIT * (parseInt(query.page, 10) || 1) : $94d9041756c0d8ee$var$DEFAULT_LIMIT,
                            last: $94d9041756c0d8ee$var$DEFAULT_LIMIT,
                            isAdminSettingsContext: route.name === $94d9041756c0d8ee$var$PROJECTS_DIRECTORY_MANAGE,
                            isAnonymous: isAnonymous,
                            skipShouldShowRightSidebar: isAnonymous || (0, (0, parcelRequire("co1wz")).ff)('server-render-projects-directory-sidebar_rj9ki'),
                            isImporterDiscoveryExperimentEnabled: (0, (0, parcelRequire("4R6GH")).fg)('jira_importer_projects_directory_cta_gate')
                        }
                    }
                },
                extraProps: extraProps
            };
        }
    });
});
parcelRegister("9M2wg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a2863fb0305ba6a4$export$2e2bcd8739ae039);
    const $a2863fb0305ba6a4$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "c5bf480cfcc7e1667e0f3ca7923ae0e7fb82b6dc49abd4df64797411cc629cfd",
            "metadata": {},
            "name": "pageLayout_projectsDirectoryLayout_RootQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $a2863fb0305ba6a4$export$2e2bcd8739ae039 = $a2863fb0305ba6a4$var$node;
});
parcelRegister("XE7Ks", function(module, exports) {
    $parcel$export(module.exports, "JSResourceForUserVisible", ()=>$425c709c1d4766fa$export$58f934f3d33a84b6);
    var $d90AH;
    var $jaFm2;
    var $8YBR8;
    const $425c709c1d4766fa$var$cache = (0, (0, parcelRequire("d90AH")).createCache)(new Map());
    function $425c709c1d4766fa$export$58f934f3d33a84b6(loader, opts) {
        return $425c709c1d4766fa$var$cache.get(opts.moduleId, ()=>(0, (0, parcelRequire("jaFm2")).PreloadableJSResource)(()=>(0, (0, parcelRequire("8YBR8")).postTask)(loader, {
                    priority: 'user-blocking'
                }), opts));
    }
});
parcelRegister("4nnZF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5jhjf")
    ]).then(()=>parcelRequire('j3Lmi'));
});
parcelRegister("3C1eN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fFisX")
    ]).then(()=>parcelRequire('eBOH6'));
});
parcelRegister("2zGx5", function(module, exports) {
    $parcel$export(module.exports, "eocAlertIssueSyncingRouteEntries", ()=>$7962a3c589e492de$export$cf5b5978205b681);
    var $5uXOq = parcelRequire("5uXOq");
    var $g6rf7;
    var $3vS1t;
    var $ffza4;
    var $lmyls;
    var $3Dk1Z;
    var $2Fj5v;
    var $iTMlN;
    var $fezpN;
    var $h3Ix2;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $lPjQY;
    var $5j7Th;
    var $bc6Qz;
    const $7962a3c589e492de$export$5a4922ba79d730f4 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, (0, parcelRequire("bc6Qz")).LazyAlertIssueSync),
            pageId: "async-jira-eoc-alert-issue-syncing",
            shouldShowSpinner: true
        });
    const $7962a3c589e492de$export$c21f2a7e1aa801a7 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, (0, parcelRequire("bc6Qz")).LazyAlertIssueSyncDetail),
            pageId: "async-jira-eoc-alert-issue-syncing",
            shouldShowSpinner: true
        });
    const $7962a3c589e492de$export$a26f24c49385cf3a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, (0, parcelRequire("bc6Qz")).LazyAlertIssueSyncCreate),
            pageId: "async-jira-eoc-alert-issue-syncing",
            shouldShowSpinner: true
        });
    const $7962a3c589e492de$export$c63d0942ec0f93c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lPjQY")).eocAlertIssueSyncingRoute), ()=>({
            component: $7962a3c589e492de$export$5a4922ba79d730f4,
            slot: null,
            basePath: '/jira/settings/products/ops',
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("g6rf7")).resources).configuredSyncsResource,
                (0, (0, parcelRequire("g6rf7")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, (0, parcelRequire("iTMlN")).AsyncHorizontalOperationsConfigurationNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("iTMlN")).LazyHorizontalOperationsConfigurationNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("bc6Qz")).LazyAlertIssueSync)
            ]
        }));
    const $7962a3c589e492de$export$7e604b22ae6e7c1e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lPjQY")).eocAlertIssueSyncingDetailRoute), ()=>({
            component: $7962a3c589e492de$export$5a4922ba79d730f4,
            slot: $7962a3c589e492de$export$c21f2a7e1aa801a7,
            basePath: '/jira/settings/products/ops',
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("g6rf7")).resources).configuredSyncsResource,
                (0, (0, parcelRequire("g6rf7")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, (0, parcelRequire("iTMlN")).AsyncHorizontalOperationsConfigurationNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("iTMlN")).LazyHorizontalOperationsConfigurationNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("bc6Qz")).LazyAlertIssueSync)
            ]
        }));
    const $7962a3c589e492de$export$92f4b6644eb6cb88 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lPjQY")).eocAlertIssueSyncingCreateRoute), ()=>({
            component: $7962a3c589e492de$export$5a4922ba79d730f4,
            slot: $7962a3c589e492de$export$a26f24c49385cf3a,
            basePath: '/jira/settings/products/ops',
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("g6rf7")).resources).configuredSyncsResource,
                (0, (0, parcelRequire("g6rf7")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, (0, parcelRequire("iTMlN")).AsyncHorizontalOperationsConfigurationNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("iTMlN")).LazyHorizontalOperationsConfigurationNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("bc6Qz")).LazyAlertIssueSync)
            ]
        }));
    const $7962a3c589e492de$export$be342a3401146aae = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lPjQY")).eocTeamAlertIssueSyncingRoute), ()=>({
            component: $7962a3c589e492de$export$5a4922ba79d730f4,
            layout: (0, (0, parcelRequire("h3Ix2")).opsTeamLayout),
            slot: null,
            basePath: '/jira/ops/teams',
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3vS1t")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("g6rf7")).resources).configuredSyncsResource,
                (0, (0, parcelRequire("g6rf7")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, (0, parcelRequire("3Dk1Z")).default),
                horizontal: (0, (0, parcelRequire("fezpN")).AsyncHorizontalOperationsNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("fezpN")).LazyHorizontalOperationsNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("bc6Qz")).LazyAlertIssueSync),
                (0, (0, parcelRequire("3Dk1Z")).LazyTeamDashboardSidebar)
            ]
        }));
    const $7962a3c589e492de$export$6298ff494c460e75 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lPjQY")).eocTeamAlertIssueSyncingDetailRoute), ()=>({
            component: $7962a3c589e492de$export$5a4922ba79d730f4,
            layout: (0, (0, parcelRequire("h3Ix2")).opsTeamLayout),
            slot: $7962a3c589e492de$export$c21f2a7e1aa801a7,
            basePath: '/jira/ops/teams',
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3vS1t")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("g6rf7")).resources).configuredSyncsResource,
                (0, (0, parcelRequire("g6rf7")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, (0, parcelRequire("3Dk1Z")).default),
                horizontal: (0, (0, parcelRequire("fezpN")).AsyncHorizontalOperationsNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("fezpN")).LazyHorizontalOperationsNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("bc6Qz")).LazyAlertIssueSync),
                (0, (0, parcelRequire("3Dk1Z")).LazyTeamDashboardSidebar)
            ]
        }));
    const $7962a3c589e492de$export$8c07dc381591dc69 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lPjQY")).eocTeamAlertIssueSyncingCreateRoute), ()=>({
            component: $7962a3c589e492de$export$5a4922ba79d730f4,
            layout: (0, (0, parcelRequire("h3Ix2")).opsTeamLayout),
            slot: $7962a3c589e492de$export$a26f24c49385cf3a,
            basePath: '/jira/ops/teams',
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3vS1t")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("g6rf7")).resources).configuredSyncsResource,
                (0, (0, parcelRequire("g6rf7")).resources).userAccessRightsResource,
                (0, (0, parcelRequire("g6rf7")).resources).getTeamResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, (0, parcelRequire("3Dk1Z")).default),
                horizontal: (0, (0, parcelRequire("fezpN")).AsyncHorizontalOperationsNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("fezpN")).LazyHorizontalOperationsNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("bc6Qz")).LazyAlertIssueSync),
                (0, (0, parcelRequire("3Dk1Z")).LazyTeamDashboardSidebar)
            ]
        }));
    const $7962a3c589e492de$export$cf5b5978205b681 = [
        $7962a3c589e492de$export$be342a3401146aae,
        $7962a3c589e492de$export$8c07dc381591dc69,
        $7962a3c589e492de$export$6298ff494c460e75,
        $7962a3c589e492de$export$c63d0942ec0f93c,
        $7962a3c589e492de$export$92f4b6644eb6cb88,
        $7962a3c589e492de$export$7e604b22ae6e7c1e
    ];
});
parcelRegister("g6rf7", function(module, exports) {
    $parcel$export(module.exports, "resources", ()=>$40dd9a07e2181ce4$export$bc99aaabaf7b70a7);
    var $9QbwC;
    var $8puz4;
    var $515aQ;
    var $2RB2M;
    const $40dd9a07e2181ce4$export$bc99aaabaf7b70a7 = {
        configuredSyncsResource: (0, parcelRequire("9QbwC")).configuredSyncsResource,
        userAccessRightsResource: (0, parcelRequire("2RB2M")).userAccessRightsResource,
        getTeamResource: (0, parcelRequire("515aQ")).getTeamResource,
        isCurrentSiteSyncEnabledResource: (0, parcelRequire("8puz4")).isCurrentSiteSyncEnabledResource
    };
});
parcelRegister("9QbwC", function(module, exports) {
    $parcel$export(module.exports, "configuredSyncsResource", ()=>$fecf708d2dca7eb5$export$333c290f4a1ec41c);
    var $dIdda = parcelRequire("dIdda");
    var $cf5um;
    var $BKqt3;
    const $fecf708d2dca7eb5$export$333c290f4a1ec41c = (0, $dIdda.createResource)({
        type: 'configuredSyncsResource',
        getKey: ({ query: query, match: match })=>{
            const teamId = match.params.teamId ?? query['teamId'];
            const keyword = query['keyword'];
            const type = query['type'];
            const page = query['page'] || '1';
            const status = query['status'];
            return (0, (0, parcelRequire("cf5um")).UrlHelper)('configuredSyncsResource', {
                page: page,
                keyword: keyword,
                type: type,
                status: status,
                teamId: teamId
            });
        },
        getData: (routerContext)=>(0, (0, parcelRequire("BKqt3")).default).getSyncs(routerContext.query, routerContext.match.params.teamId),
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("cf5um", function(module, exports) {
    $parcel$export(module.exports, "UrlHelper", ()=>$e630bf8368828a17$export$bacbc496e850c0a4);
    const $e630bf8368828a17$export$bacbc496e850c0a4 = (path, params = {})=>{
        const q = Object.entries(params).map(([k, v])=>v !== '' && !!v || v === false ? [
                k,
                v.toString()
            ] : undefined).filter((v)=>!!v);
        const qs = new URLSearchParams(q).toString();
        return `${path}${qs ? `?${qs}` : ''}`;
    };
});
parcelRegister("BKqt3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4d8fb921fcb2fdf6$export$2e2bcd8739ae039);
    var $6GHRr;
    var $cf5um;
    const $4d8fb921fcb2fdf6$var$getSyncs = async (query, pathParamTeamId)=>{
        const page = parseInt(query['page']) || 1;
        const offset = (page - 1) * (0, $21c3b1ddde10e154$export$31ecae7225aecec6);
        const queryParams = query ? {
            teamId: pathParamTeamId ?? query.teamId,
            type: query.type,
            keyword: query.keyword,
            status: query.status
        } : {};
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("cf5um")).UrlHelper)('/v1/entity-sync/unified', {
            ...queryParams,
            offset: offset.toString(),
            limit: (0, $21c3b1ddde10e154$export$31ecae7225aecec6)
        })).then((response)=>({
                data: response.data.integrations,
                pageCount: Math.ceil(response.data.count / (0, $21c3b1ddde10e154$export$31ecae7225aecec6)),
                itemCount: response.data.count
            }));
    };
    const $4d8fb921fcb2fdf6$var$patchSync = async (syncId, syncType, body, teamId)=>(0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("cf5um")).UrlHelper)(`/v1/entity-sync/unified/${syncId}`, {
            type: syncType,
            teamId: teamId
        }), {
            method: 'PATCH',
            body: body
        }).then((response)=>response.data);
    const $4d8fb921fcb2fdf6$var$deleteSync = async (syncId, syncType, teamId)=>(0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("cf5um")).UrlHelper)(`/v1/entity-sync/unified/${syncId}`, {
            type: syncType,
            teamId: teamId
        }), {
            method: 'DELETE',
            responseType: 'headers'
        });
    var $4d8fb921fcb2fdf6$export$2e2bcd8739ae039 = {
        getSyncs: $4d8fb921fcb2fdf6$var$getSyncs,
        patchSync: $4d8fb921fcb2fdf6$var$patchSync,
        deleteSync: $4d8fb921fcb2fdf6$var$deleteSync
    };
});
const $21c3b1ddde10e154$export$31ecae7225aecec6 = 20;
parcelRegister("8puz4", function(module, exports) {
    $parcel$export(module.exports, "isCurrentSiteSyncEnabledResource", ()=>$6d4537e384405ec0$export$94465df791bf80);
    var $dIdda = parcelRequire("dIdda");
    var $cyglR;
    const $6d4537e384405ec0$export$94465df791bf80 = (0, $dIdda.createResource)({
        type: 'isCurrentSiteSyncEnabledResource',
        getKey: ()=>`isCurrentSiteSyncEnabledResource`,
        getData: (0, (0, parcelRequire("cyglR")).getIsCurrentSiteSyncEnabled),
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("cyglR", function(module, exports) {
    $parcel$export(module.exports, "getIsCurrentSiteSyncEnabled", ()=>$75a5474449aea056$export$93fc09e39edf63d0);
    var $6GHRr;
    const $75a5474449aea056$export$93fc09e39edf63d0 = ()=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/entity-sync/is-current-site-enabled`).then((response)=>response.data.enabled);
});
parcelRegister("515aQ", function(module, exports) {
    $parcel$export(module.exports, "getTeamResource", ()=>$58f869b84e6c7a60$export$50271c9e7f21f10e);
    var $dIdda = parcelRequire("dIdda");
    var $lUMYZ;
    var $2FAs6;
    var $6GfrL;
    const $58f869b84e6c7a60$export$50271c9e7f21f10e = (0, $dIdda.createResource)({
        type: 'getSyncTeamResource',
        getKey: (routerContext)=>`getSyncTeamResource#${routerContext.match.params?.teamId}`,
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("lUMYZ")).assert)(!!teamId, new (0, (0, parcelRequire("2FAs6")).AssertionError)('getTeamResource', 'teamId should be set to fetch the team'));
            const result = await (0, (0, parcelRequire("6GfrL")).getTeam)(teamId);
            return result ?? null;
        },
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("lUMYZ", function(module, exports) {
    $parcel$export(module.exports, "assert", ()=>$81e8dde5ac968648$export$a7a9523472993e97);
    var $2FAs6;
    const $81e8dde5ac968648$export$a7a9523472993e97 = function(condition, err) {
        if (!condition) throw err;
    };
});
parcelRegister("2FAs6", function(module, exports) {
    $parcel$export(module.exports, "AssertionError", ()=>$b63305398955cc99$export$7750cdfb4db2c3d);
    class $b63305398955cc99$export$7750cdfb4db2c3d extends Error {
        constructor(id, message){
            super(`[${id}] ${message}`);
            this.id = id;
        }
    }
});
parcelRegister("6GfrL", function(module, exports) {
    $parcel$export(module.exports, "getTeam", ()=>$1b03db99c00862ed$export$491fe77f22ab2b51);
    var $6GHRr;
    const $1b03db99c00862ed$export$491fe77f22ab2b51 = (teamId)=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/alerts/responders/names`, {
            method: 'POST',
            body: {
                responders: [
                    {
                        id: teamId,
                        type: 'team'
                    }
                ]
            }
        }).then((response)=>response.values.filter((responder)=>!responder.deleted).at(0));
});
parcelRegister("2RB2M", function(module, exports) {
    $parcel$export(module.exports, "userAccessRightsResource", ()=>$a2ad2aed843e73be$export$69ddc7cc64ae9a02);
    var $dIdda = parcelRequire("dIdda");
    var $9X2VH;
    const $a2ad2aed843e73be$export$69ddc7cc64ae9a02 = (0, $dIdda.createResource)({
        type: 'userAccessRightsResource',
        getKey: ()=>'userAccessRightsResource',
        getData: (routerContext)=>(0, (0, parcelRequire("9X2VH")).getUserRights)(routerContext.match.params.teamId),
        maxAge: 600000,
        isBrowserOnly: true
    });
});
parcelRegister("9X2VH", function(module, exports) {
    $parcel$export(module.exports, "getUserRights", ()=>$619fdd2042d40d3c$export$84e2ed279bc4e64e);
    var $6GHRr;
    var $cf5um;
    const $619fdd2042d40d3c$export$84e2ed279bc4e64e = (teamId)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("cf5um")).UrlHelper)(`/v1/entity-sync/unified/rights`, {
            teamId: teamId
        })).then((response)=>response.data.userAccessRights);
    };
});
parcelRegister("3vS1t", function(module, exports) {
    $parcel$export(module.exports, "teamResource", ()=>$3d9377367a48e358$export$87453d709b90ccdf);
    $parcel$export(module.exports, "sidebarRightsResource", ()=>$3d9377367a48e358$export$3b3b9a5b0eddde66);
    $parcel$export(module.exports, "resources", ()=>$3d9377367a48e358$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $lUMYZ;
    var $2FAs6;
    var $WBqZE;
    const $3d9377367a48e358$export$87453d709b90ccdf = (0, $dIdda.createResource)({
        type: 'teamResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `team-dashboard/${teamId ?? ''}`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("lUMYZ")).assert)(!!teamId, new (0, (0, parcelRequire("2FAs6")).AssertionError)('teamSidebarResource', 'teamId should be set to fetch team-dashboard'));
            return (0, (0, parcelRequire("WBqZE")).getTeamByIdEndpoint)(teamId);
        },
        maxAge: 300000,
        isBrowserOnly: true
    });
    const $3d9377367a48e358$export$3b3b9a5b0eddde66 = (0, $dIdda.createResource)({
        type: 'sidebarRightsResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `team-dashboard/${teamId ?? ''}/sidebar-rights`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("lUMYZ")).assert)(!!teamId, new (0, (0, parcelRequire("2FAs6")).AssertionError)('teamSidebarResource', 'teamId should be set to fetch sidebar rights'));
            return (0, (0, parcelRequire("WBqZE")).getSidebarRightsEndpoint)(teamId);
        },
        isBrowserOnly: true,
        maxAge: Infinity
    });
    const $3d9377367a48e358$export$bc99aaabaf7b70a7 = [
        $3d9377367a48e358$export$87453d709b90ccdf,
        $3d9377367a48e358$export$3b3b9a5b0eddde66
    ];
});
parcelRegister("WBqZE", function(module, exports) {
    $parcel$export(module.exports, "getTeamByIdEndpoint", ()=>$4136c0de473583e6$export$bcb25b347f39b3f3);
    $parcel$export(module.exports, "getSidebarRightsEndpoint", ()=>$4136c0de473583e6$export$6f1f62156c62eb91);
    var $6GHRr;
    const $4136c0de473583e6$export$bcb25b347f39b3f3 = (teamId)=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/teams/${teamId}?includeImageUrls=true`);
    const $4136c0de473583e6$export$6f1f62156c62eb91 = (teamId)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/teams/${teamId}/menu-rights`);
    };
});
parcelRegister("3Dk1Z", function(module, exports) {
    $parcel$export(module.exports, "LazyTeamDashboardSidebar", ()=>$d15151561c6a9349$export$a1b7c53ff39475a6);
    $parcel$export(module.exports, "default", ()=>$d15151561c6a9349$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $hPtZI;
    const $d15151561c6a9349$export$a1b7c53ff39475a6 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("gR2RM")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/eoc-team-dashboard/src/index.tsx"
    });
    const $d15151561c6a9349$var$TeamDashboardSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "eocTeamDashboard"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d15151561c6a9349$export$a1b7c53ff39475a6, null));
    $d15151561c6a9349$var$TeamDashboardSidebar.displayName = 'TeamDashboardSidebar';
    var $d15151561c6a9349$export$2e2bcd8739ae039 = $d15151561c6a9349$var$TeamDashboardSidebar;
});
parcelRegister("gR2RM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("dXWqK")
    ]).then(()=>parcelRequire('hMnGK'));
});
parcelRegister("iTMlN", function(module, exports) {
    $parcel$export(module.exports, "LazyHorizontalOperationsConfigurationNav", ()=>$cd33ec0afa28f27a$export$aea682543f08e131);
    $parcel$export(module.exports, "AsyncHorizontalOperationsConfigurationNav", ()=>$cd33ec0afa28f27a$export$1f7a0efe3746ea0d);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $hPtZI;
    const $cd33ec0afa28f27a$export$aea682543f08e131 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("hbBAJ")).then(({ HorizontalOperationsConfiguration: HorizontalOperationsConfiguration })=>HorizontalOperationsConfiguration), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-operations-configuration/src/ui/index.tsx"
    });
    const $cd33ec0afa28f27a$export$1f7a0efe3746ea0d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jira-operations-configurations-horizontal-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "asyncHorizontalOperationsConfigurationNav",
            packageName: "jiraOperationsConfigurationsHorizontalNav",
            fallback: "flag",
            teamName: "50cent"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($cd33ec0afa28f27a$export$aea682543f08e131, null)));
});
parcelRegister("hbBAJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2AP6O")
    ]).then(()=>parcelRequire('fBQfD'));
});
parcelRegister("fezpN", function(module, exports) {
    $parcel$export(module.exports, "LazyHorizontalOperationsNav", ()=>$7836a14152b01d88$export$409c821653bbc63b);
    $parcel$export(module.exports, "LazyHorizontalOperationsOverviewNav", ()=>$7836a14152b01d88$export$82108adf6887e32e);
    $parcel$export(module.exports, "AsyncHorizontalOperationsNav", ()=>$7836a14152b01d88$export$1eb785f071697cc5);
    $parcel$export(module.exports, "AsyncHorizontalOperationsOverviewNav", ()=>$7836a14152b01d88$export$27e50c09ebb514f);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $hPtZI;
    const $7836a14152b01d88$export$409c821653bbc63b = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("atcAs")).then(({ HorizontalOperationsNav: HorizontalOperationsNav })=>HorizontalOperationsNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-operations/src/ui/index.tsx"
    });
    const $7836a14152b01d88$export$82108adf6887e32e = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("atcAs")).then(({ OverviewNav: OverviewNav })=>OverviewNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-operations/src/ui/index.tsx"
    });
    const $7836a14152b01d88$export$1eb785f071697cc5 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-operations-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "asyncHorizontalOperationsNav",
            packageName: "jiraOperationsHorizontalNav",
            fallback: "flag",
            teamName: "alexstrasza"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7836a14152b01d88$export$409c821653bbc63b, null)));
    const $7836a14152b01d88$export$27e50c09ebb514f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-operations-overview-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "asyncHorizontalOperationsOverviewNav",
            packageName: "jiraOperationsHorizontalNav",
            fallback: "flag",
            teamName: "alexstrasza"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7836a14152b01d88$export$82108adf6887e32e, null)));
});
parcelRegister("atcAs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("69byx")
    ]).then(()=>parcelRequire('10YpK'));
});
parcelRegister("h3Ix2", function(module, exports) {
    $parcel$export(module.exports, "opsTeamLayout", ()=>$687f5bad65d17575$export$53dd27149810df73);
    var $1XrjK;
    var $hPtZI;
    const $687f5bad65d17575$var$RightSidebars = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("cQXYd")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/ops-team-layout/src/ui/right-sidebars/index.tsx"
    });
    const $687f5bad65d17575$var$Onboarding = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("8cAy7")), {
        ssr: false,
        moduleId: "./src/packages/platform/ui/layouts/ops-team-layout/src/ui/onboarding/index.tsx"
    });
    const $687f5bad65d17575$export$53dd27149810df73 = (0, (0, parcelRequire("1XrjK")).createLayout)({
        get globalComponents () {
            return [
                $687f5bad65d17575$var$Onboarding
            ];
        },
        rightSidebars: [
            $687f5bad65d17575$var$RightSidebars
        ]
    });
});
parcelRegister("cQXYd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("iRSLc").then(()=>parcelRequire('c3FF8'));
});
parcelRegister("8cAy7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("g3ZhW").then(()=>parcelRequire('dSHkM'));
});
parcelRegister("lPjQY", function(module, exports) {
    $parcel$export(module.exports, "eocAlertIssueSyncingRoute", ()=>$afc98a59d9baec1c$export$73d6a0dc298aae15);
    $parcel$export(module.exports, "eocAlertIssueSyncingCreateRoute", ()=>$afc98a59d9baec1c$export$f271eef5f9ec6602);
    $parcel$export(module.exports, "eocAlertIssueSyncingDetailRoute", ()=>$afc98a59d9baec1c$export$f1b4093ef603b98d);
    $parcel$export(module.exports, "eocTeamAlertIssueSyncingRoute", ()=>$afc98a59d9baec1c$export$37ea7624561cbb89);
    $parcel$export(module.exports, "eocTeamAlertIssueSyncingCreateRoute", ()=>$afc98a59d9baec1c$export$915ef1948fe4650a);
    $parcel$export(module.exports, "eocTeamAlertIssueSyncingDetailRoute", ()=>$afc98a59d9baec1c$export$e91535fc2137c3b);
    var $65Ltd;
    const $afc98a59d9baec1c$export$73d6a0dc298aae15 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING),
        path: '/jira/settings/products/ops/syncs',
        exact: true
    };
    const $afc98a59d9baec1c$export$f271eef5f9ec6602 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_CREATE),
        path: '/jira/settings/products/ops/syncs/create',
        exact: true
    };
    const $afc98a59d9baec1c$export$f1b4093ef603b98d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ALERT_ISSUE_SYNCING_DETAIL),
        path: '/jira/settings/products/ops/syncs/:syncId',
        exact: true
    };
    const $afc98a59d9baec1c$export$37ea7624561cbb89 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING),
        path: '/jira/ops/teams/:teamId/syncs',
        exact: true
    };
    const $afc98a59d9baec1c$export$915ef1948fe4650a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_CREATE),
        path: '/jira/ops/teams/:teamId/syncs/create',
        exact: true
    };
    const $afc98a59d9baec1c$export$e91535fc2137c3b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_ISSUE_SYNCING_DETAIL),
        path: '/jira/ops/teams/:teamId/syncs/:syncId',
        exact: true
    };
});
parcelRegister("bc6Qz", function(module, exports) {
    $parcel$export(module.exports, "LazyAlertIssueSync", ()=>$9e8891c31cf06876$export$dbbcce89c7be1e71);
    $parcel$export(module.exports, "LazyAlertIssueSyncCreate", ()=>$9e8891c31cf06876$export$ff3e9ed7471eebce);
    $parcel$export(module.exports, "LazyAlertIssueSyncDetail", ()=>$9e8891c31cf06876$export$75137a2a583918e2);
    var $hPtZI;
    const $9e8891c31cf06876$export$dbbcce89c7be1e71 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("agiQP")).then((module)=>module.AlertIssueSync), {
        moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
    });
    const $9e8891c31cf06876$export$ff3e9ed7471eebce = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("agiQP")).then((module)=>module.AlertIssueSyncCreate), {
        moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
    });
    const $9e8891c31cf06876$export$75137a2a583918e2 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("agiQP")).then((module)=>module.AlertIssueSyncDetail), {
        moduleId: "./src/packages/eoc/eoc-alert-issue-syncing/src/index.tsx"
    });
});
parcelRegister("agiQP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("fBjqh")
    ]).then(()=>parcelRequire('gAySz'));
});
parcelRegister("1ts3p", function(module, exports) {
    $parcel$export(module.exports, "eocApiKeyManagementRouteEntry", ()=>$d20ff3bf1728b112$export$e18a6be3d2ffad71);
    var $803aO;
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $iTMlN;
    var $2G9Bk;
    var $3RJkv;
    var $171iV;
    var $gZxlv;
    const $d20ff3bf1728b112$export$e18a6be3d2ffad71 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("171iV")).eocApiKeyManagementRoute), ()=>({
            component: (0, (0, parcelRequire("gZxlv")).default),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, (0, parcelRequire("iTMlN")).AsyncHorizontalOperationsConfigurationNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("803aO")).resources)
            ],
            forPaint: [
                (0, (0, parcelRequire("iTMlN")).LazyHorizontalOperationsConfigurationNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("gZxlv")).LazyApiKeyManagement)
            ]
        }));
});
parcelRegister("803aO", function(module, exports) {
    $parcel$export(module.exports, "apiKeysResource", ()=>$b07ba6af60ec58b0$export$a98d5421eda11f29);
    $parcel$export(module.exports, "resources", ()=>$b07ba6af60ec58b0$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    parcelRequire("c4sFg");
    var $5NVbt;
    var $2bhPo;
    const $b07ba6af60ec58b0$export$a98d5421eda11f29 = (0, $dIdda.createResource)({
        type: 'api-key-management',
        getKey: ()=>'api-key-management',
        getData: async ({ dependencies: dependencies })=>{
            const data = await dependencies[(0, (0, parcelRequire("5NVbt")).eocUserResource).type]?.promise;
            return (0, (0, parcelRequire("2bhPo")).fetchKeys)(data.accountId);
        },
        isBrowserOnly: true,
        maxCache: 0,
        maxAge: 0,
        depends: [
            (0, (0, parcelRequire("5NVbt")).eocUserResource).type
        ]
    });
    const $b07ba6af60ec58b0$export$bc99aaabaf7b70a7 = [
        (0, (0, parcelRequire("5NVbt")).eocUserResource),
        $b07ba6af60ec58b0$export$a98d5421eda11f29
    ];
});
parcelRegister("c4sFg", function(module, exports) {
    $parcel$export(module.exports, "eocCommonResources", ()=>$dfc999710b2fe594$export$8977bbbf2f7167d2);
    $parcel$export(module.exports, "eocUserResource", ()=>(parcelRequire("5NVbt")).eocUserResource);
    var $5NVbt;
    const $dfc999710b2fe594$export$8977bbbf2f7167d2 = ()=>[
            (0, (0, parcelRequire("5NVbt")).eocUserResource)
        ];
});
parcelRegister("5NVbt", function(module, exports) {
    $parcel$export(module.exports, "eocUserResource", ()=>$2144ac01773377aa$export$3a08a0bdeef86956);
    var $dIdda = parcelRequire("dIdda");
    var $3PDu9;
    const $2144ac01773377aa$export$3a08a0bdeef86956 = (0, $dIdda.createResource)({
        type: 'create-user-resource',
        getKey: ()=>'create-user-resource',
        getData: async ()=>(0, (0, parcelRequire("3PDu9")).fetchJsmUserInfo)(),
        maxAge: Infinity,
        isBrowserOnly: true
    });
});
parcelRegister("3PDu9", function(module, exports) {
    $parcel$export(module.exports, "fetchJsmUserInfo", ()=>$e52317ab05ff3c66$export$7d750310098b5a7);
    var $6GHRr;
    var $aHQEx;
    const $e52317ab05ff3c66$var$JSM_BASE_URL = '/rest/api/3/myself';
    const $e52317ab05ff3c66$export$7d750310098b5a7 = ()=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)($e52317ab05ff3c66$var$JSM_BASE_URL, {
            exactUrl: true,
            errorTransformer: (0, (0, parcelRequire("aHQEx")).jsmErrorTransformer)
        });
    };
});
parcelRegister("2bhPo", function(module, exports) {
    $parcel$export(module.exports, "fetchKeys", ()=>$02143394728c9c8a$export$a0d93e1b78b8e70b);
    $parcel$export(module.exports, "deleteApiKey", ()=>$02143394728c9c8a$export$d2f8649a375a4113);
    var $6GHRr;
    const $02143394728c9c8a$export$a0d93e1b78b8e70b = async (accountId)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)('/api-keys/web?accountId=' + accountId);
    };
    const $02143394728c9c8a$export$d2f8649a375a4113 = async (key, accountId)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/api-keys/web?apiKey=${key}&accountId=${accountId}`, {
            method: 'DELETE'
        });
    };
});
parcelRegister("171iV", function(module, exports) {
    $parcel$export(module.exports, "eocApiKeyManagementRoute", ()=>$16f73de73692c402$export$84985159d5695f4d);
    var $65Ltd;
    const $16f73de73692c402$export$84985159d5695f4d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_API_KEY_MANAGEMENT),
        path: '/jira/settings/products/ops/api-key-management',
        exact: true
    };
});
parcelRegister("gZxlv", function(module, exports) {
    $parcel$export(module.exports, "LazyApiKeyManagement", ()=>$eddc6a8c98318a70$export$6ae4b26c31b1b0d2);
    $parcel$export(module.exports, "default", ()=>$eddc6a8c98318a70$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $eddc6a8c98318a70$export$6ae4b26c31b1b0d2 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("ck880")), {
        moduleId: "./src/packages/eoc/api-key-management/src/index.tsx"
    });
    var $eddc6a8c98318a70$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $eddc6a8c98318a70$export$6ae4b26c31b1b0d2,
            pageId: "async-jira-eoc-api-key-management",
            shouldShowSpinner: false
        });
});
parcelRegister("ck880", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("e41T5")
    ]).then(()=>parcelRequire('95iLR'));
});
parcelRegister("bG6rK", function(module, exports) {
    $parcel$export(module.exports, "eocAssignCustomRolesRouteEntry", ()=>$47346306c864179d$export$c51a4ee3e3f1b270);
    var $l0tH6;
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $iTMlN;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $atU1t;
    var $6UoAq;
    var $9Zb2K;
    const $47346306c864179d$export$c51a4ee3e3f1b270 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6UoAq")).eocAssignCustomRolesRoute), ()=>({
            component: (0, (0, parcelRequire("9Zb2K")).default),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, (0, parcelRequire("iTMlN")).AsyncHorizontalOperationsConfigurationNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("l0tH6")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("iTMlN")).LazyHorizontalOperationsConfigurationNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("9Zb2K")).LazyAssignCustomRoles)
            ]
        }));
});
parcelRegister("l0tH6", function(module, exports) {
    $parcel$export(module.exports, "rolesResource", ()=>$3f396b0d897adde6$export$52e29d5915d5f674);
    $parcel$export(module.exports, "resources", ()=>$3f396b0d897adde6$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $h1zio;
    const $3f396b0d897adde6$export$52e29d5915d5f674 = (0, $dIdda.createResource)({
        type: 'rolesResource',
        getKey: ()=>'rolesResource',
        getData: (0, (0, parcelRequire("h1zio")).getRolesEndpoint),
        isBrowserOnly: true
    });
    const $3f396b0d897adde6$export$bc99aaabaf7b70a7 = [
        $3f396b0d897adde6$export$52e29d5915d5f674
    ];
});
parcelRegister("h1zio", function(module, exports) {
    $parcel$export(module.exports, "getUsersEndpoint", ()=>$18a27074a4d38430$export$d372f7d69e481dba);
    $parcel$export(module.exports, "getFilteredUsersEndpoint", ()=>$18a27074a4d38430$export$d8f86d9603f031c0);
    $parcel$export(module.exports, "getRolesEndpoint", ()=>$18a27074a4d38430$export$7d0bc1a3c689fc74);
    $parcel$export(module.exports, "updateRoleOfUserEndpoint", ()=>$18a27074a4d38430$export$a0b296dc0259976f);
    var $6GHRr;
    var $bggUS;
    const $18a27074a4d38430$export$d372f7d69e481dba = ({ lastEvaluatedToken: lastEvaluatedToken, limit: limit, queryKey: queryKey })=>{
        const [_, query] = queryKey;
        let url = new (0, (0, parcelRequire("bggUS")).URLBuilder)(`/v1/users/search`).withQueryParam('limit', limit).withQueryParam('query', query).withQueryParam('cursor', lastEvaluatedToken).build();
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(url);
    };
    const $18a27074a4d38430$export$d8f86d9603f031c0 = ({ lastEvaluatedToken: lastEvaluatedToken, limit: limit, queryKey: queryKey })=>{
        const [_, ...filters] = queryKey;
        if (filters.length === 0) return Promise.resolve({
            lastEvaluatedToken: '',
            values: []
        });
        return (0, (0, parcelRequire("6GHRr")).eocFetch)('/v1/users/roles/filter', {
            method: 'POST',
            body: {
                limit: limit,
                roles: filters,
                offset: lastEvaluatedToken || 0
            }
        });
    };
    const $18a27074a4d38430$export$7d0bc1a3c689fc74 = ()=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)('/v1/users/roles');
    };
    const $18a27074a4d38430$export$a0b296dc0259976f = ({ roleId: roleId, accountId: accountId })=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/users/roles/assign`, {
            method: 'PATCH',
            body: {
                accountId: accountId,
                roleId: roleId
            }
        });
    };
});
parcelRegister("bggUS", function(module, exports) {
    $parcel$export(module.exports, "URLBuilder", ()=>$aebc8df41753efa5$export$61d2e8db329a11f8);
    class $aebc8df41753efa5$export$61d2e8db329a11f8 {
        constructor(url){
            this.url = url;
            this.params = {};
        }
        withQueryParam(key, value) {
            this.params[key] = value;
            return this;
        }
        build() {
            const filteredParams = Object.entries(this.params).filter(([, value])=>value !== undefined && value !== null && value !== '').map(([key, value])=>[
                    key,
                    value && value.toString()
                ]);
            const queryInstance = new URLSearchParams(filteredParams);
            const queryParams = queryInstance.toString();
            if (queryParams === '') return `${this.url}`;
            if (queryParams) return `${this.url}?${queryParams}`;
            return this.url;
        }
    }
});
parcelRegister("6UoAq", function(module, exports) {
    $parcel$export(module.exports, "eocAssignCustomRolesRoute", ()=>$c2ffe74049ce966a$export$79c37191a61ac94b);
    var $65Ltd;
    const $c2ffe74049ce966a$export$79c37191a61ac94b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ASSIGN_CUSTOM_ROLES),
        path: '/jira/settings/products/ops/role-assignment',
        exact: true
    };
});
parcelRegister("9Zb2K", function(module, exports) {
    $parcel$export(module.exports, "LazyAssignCustomRoles", ()=>$cbc95c821be59e53$export$fb6bafef9453a357);
    $parcel$export(module.exports, "default", ()=>$cbc95c821be59e53$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $cbc95c821be59e53$export$fb6bafef9453a357 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("79kmP")), {
        moduleId: "./src/packages/eoc/assign-custom-roles/src/index.tsx"
    });
    var $cbc95c821be59e53$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cbc95c821be59e53$export$fb6bafef9453a357,
            pageId: "async-eoc-assign-custom-roles",
            shouldShowSpinner: false
        });
});
parcelRegister("79kmP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("ligT4")
    ]).then(()=>parcelRequire('i3AK8'));
});
parcelRegister("PhxiS", function(module, exports) {
    $parcel$export(module.exports, "eocAutomationsRouteEntry", ()=>$9b4c7f67acf4fe32$export$6ff606556e19e12);
    var $3vS1t;
    var $ffza4;
    var $lmyls;
    var $3Dk1Z;
    var $h3Ix2;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $cygcr;
    var $12Bno;
    const $9b4c7f67acf4fe32$export$6ff606556e19e12 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cygcr")).eocAutomationsRoute), ()=>({
            component: (0, (0, parcelRequire("12Bno")).default),
            layout: (0, (0, parcelRequire("h3Ix2")).opsTeamLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3vS1t")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, (0, parcelRequire("3Dk1Z")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("12Bno")).LazyOpsTeamAutomation),
                (0, (0, parcelRequire("3Dk1Z")).LazyTeamDashboardSidebar)
            ]
        }));
});
parcelRegister("cygcr", function(module, exports) {
    $parcel$export(module.exports, "eocAutomationsRoute", ()=>$90433e9189dc0c80$export$4a84eb4d8d37c9d4);
    var $65Ltd;
    const $90433e9189dc0c80$export$4a84eb4d8d37c9d4 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_AUTOMATIONS),
        path: '/jira/ops/teams/:teamId/automations',
        exact: true
    };
});
parcelRegister("12Bno", function(module, exports) {
    $parcel$export(module.exports, "LazyOpsTeamAutomation", ()=>$1cf116b0539aa5be$export$903a0a44cc0933c5);
    $parcel$export(module.exports, "default", ()=>$1cf116b0539aa5be$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $1cf116b0539aa5be$export$903a0a44cc0933c5 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("d6ThE")), {
        moduleId: "./src/packages/spa-apps/ops-team-scope-automation/src/index.tsx"
    });
    var $1cf116b0539aa5be$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1cf116b0539aa5be$export$903a0a44cc0933c5,
            pageId: "ops-team-automation",
            shouldShowSpinner: true
        });
});
parcelRegister("d6ThE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9mAAJ")
    ]).then(()=>parcelRequire('j6Qxa'));
});
parcelRegister("h3crr", function(module, exports) {
    $parcel$export(module.exports, "eocCustomRolesRouteEntry", ()=>$1513c92d12ac2a7f$export$9c9bab95d425eb6f);
    var $ecifb;
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $iTMlN;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $atU1t;
    var $1nhoq;
    var $7vwGd;
    const $1513c92d12ac2a7f$export$9c9bab95d425eb6f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1nhoq")).eocCustomRolesRoute), ()=>({
            component: (0, (0, parcelRequire("7vwGd")).default),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, (0, parcelRequire("iTMlN")).AsyncHorizontalOperationsConfigurationNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("ecifb")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("iTMlN")).LazyHorizontalOperationsConfigurationNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("7vwGd")).LazyCustomRoles)
            ]
        }));
});
parcelRegister("ecifb", function(module, exports) {
    $parcel$export(module.exports, "customRolesResource", ()=>$595ab2f98dd2baa0$export$7140716a1b1b8e7a);
    $parcel$export(module.exports, "resources", ()=>$595ab2f98dd2baa0$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $37JJ8;
    const $595ab2f98dd2baa0$export$7140716a1b1b8e7a = (0, $dIdda.createResource)({
        type: 'rolesResource',
        getKey: ()=>'rolesResource',
        getData: (0, (0, parcelRequire("37JJ8")).getCustomRolesListEndpoint),
        isBrowserOnly: true
    });
    const $595ab2f98dd2baa0$export$bc99aaabaf7b70a7 = [
        $595ab2f98dd2baa0$export$7140716a1b1b8e7a
    ];
});
parcelRegister("37JJ8", function(module, exports) {
    $parcel$export(module.exports, "getPermissionsEndpoint", ()=>$9bfa7fcb4d1d8452$export$f97b589720c51ce1);
    $parcel$export(module.exports, "createCustomRoleEndpoint", ()=>$9bfa7fcb4d1d8452$export$5a7187e04c844900);
    $parcel$export(module.exports, "editCustomRoleEndpoint", ()=>$9bfa7fcb4d1d8452$export$304735a80b86192e);
    $parcel$export(module.exports, "deleteCustomRoleEndpoint", ()=>$9bfa7fcb4d1d8452$export$e12995ccad013f65);
    $parcel$export(module.exports, "getCustomRolesListEndpoint", ()=>$9bfa7fcb4d1d8452$export$3619edac53aa59fd);
    var $6GHRr;
    const $9bfa7fcb4d1d8452$export$f97b589720c51ce1 = ()=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/users/permissions`);
    const $9bfa7fcb4d1d8452$export$5a7187e04c844900 = (newCustomRole)=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/users/roles`, {
            method: 'POST',
            body: newCustomRole
        });
    const $9bfa7fcb4d1d8452$export$304735a80b86192e = (updatedCustomRole)=>{
        const { id: id } = updatedCustomRole;
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/users/roles/${id}`, {
            method: 'PATCH',
            body: updatedCustomRole
        });
    };
    const $9bfa7fcb4d1d8452$export$e12995ccad013f65 = (id)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/users/roles/${id}`, {
            method: 'DELETE'
        });
    };
    const $9bfa7fcb4d1d8452$export$3619edac53aa59fd = ()=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/users/roles`);
});
parcelRegister("1nhoq", function(module, exports) {
    $parcel$export(module.exports, "eocCustomRolesRoute", ()=>$7ef1808f7f01133d$export$3213a7325ca9911);
    var $65Ltd;
    const $7ef1808f7f01133d$export$3213a7325ca9911 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_CUSTOM_ROLES),
        path: '/jira/settings/products/ops/roles',
        exact: true
    };
});
parcelRegister("7vwGd", function(module, exports) {
    $parcel$export(module.exports, "LazyCustomRoles", ()=>$ae4b2d4dc59e70bc$export$78ed54710f55f948);
    $parcel$export(module.exports, "default", ()=>$ae4b2d4dc59e70bc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $ae4b2d4dc59e70bc$export$78ed54710f55f948 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("7yJdu")), {
        moduleId: "./src/packages/eoc/custom-roles/src/index.tsx"
    });
    var $ae4b2d4dc59e70bc$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ae4b2d4dc59e70bc$export$78ed54710f55f948,
            pageId: "async-eoc-custom-roles",
            shouldShowSpinner: false
        });
});
parcelRegister("7yJdu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("47IHZ")
    ]).then(()=>parcelRequire('WACar'));
});
parcelRegister("lV7Ii", function(module, exports) {
    $parcel$export(module.exports, "eocGlobalAlertListRouteEntries", ()=>$384a0ea22f315084$export$283761ff41b53cba);
    var $5uXOq = parcelRequire("5uXOq");
    var $kSUuU;
    var $3qG6K;
    var $ffza4;
    var $iqZds;
    var $lmyls;
    var $gLQQv;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $5CJ70;
    var $5j7Th;
    var $hPtZI;
    const $384a0ea22f315084$export$f4aafff31d950b6c = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("d8hKi")), {
        moduleId: "./src/packages/eoc/alert-list/src/ui/index.tsx"
    });
    const $384a0ea22f315084$export$9333bfa567c9c31 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $384a0ea22f315084$export$f4aafff31d950b6c,
            pageId: "async-jira-eoc-alert-list",
            shouldShowSpinner: false
        });
    const $384a0ea22f315084$export$851a659e50436cff = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5CJ70")).eocGlobalAlertListRoute), ()=>({
            component: $384a0ea22f315084$export$9333bfa567c9c31,
            layout: (0, (0, parcelRequire("iqZds")).eocChangeboardingLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3qG6K")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HOME,
                sidebar: (0, (0, parcelRequire("gLQQv")).AsyncSidebarEocGlobalAlerts)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $384a0ea22f315084$export$f4aafff31d950b6c,
                (0, (0, parcelRequire("gLQQv")).LazyGlobalAlertsSidebar)
            ]
        }));
    const $384a0ea22f315084$export$bcb93d8198d511b9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5CJ70")).eocGlobalAlertDetailRoute), ()=>({
            component: $384a0ea22f315084$export$9333bfa567c9c31,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3qG6K")).resources),
                ...(0, (0, parcelRequire("kSUuU")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HOME,
                sidebar: (0, (0, parcelRequire("gLQQv")).AsyncSidebarEocGlobalAlerts)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $384a0ea22f315084$export$f4aafff31d950b6c,
                (0, (0, parcelRequire("gLQQv")).LazyGlobalAlertsSidebar)
            ]
        }));
    const $384a0ea22f315084$export$283761ff41b53cba = [
        $384a0ea22f315084$export$851a659e50436cff,
        $384a0ea22f315084$export$bcb93d8198d511b9
    ];
});
parcelRegister("kSUuU", function(module, exports) {
    $parcel$export(module.exports, "alertDetailResource", ()=>$d1c1cfbbc144ebd1$export$f918335771807ac4);
    $parcel$export(module.exports, "logTypesResource", ()=>$d1c1cfbbc144ebd1$export$f9c57ab4d5f63686);
    $parcel$export(module.exports, "entityRelationTypesResource", ()=>$d1c1cfbbc144ebd1$export$a5515392cb45b9f8);
    $parcel$export(module.exports, "responderStatesResource", ()=>$d1c1cfbbc144ebd1$export$c3b70747662e5932);
    $parcel$export(module.exports, "resources", ()=>$d1c1cfbbc144ebd1$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $kzTEn;
    var $lUMYZ;
    var $2FAs6;
    var $c4sFg;
    var $gp4Sj;
    const $d1c1cfbbc144ebd1$export$f918335771807ac4 = (0, $dIdda.createResource)({
        type: 'alertDetailResource',
        getKey: (routerContext)=>`alertDetailResource#${routerContext.match.params.id}`,
        getData: async (routerContext)=>{
            const alertId = routerContext.match.params?.id;
            (0, (0, parcelRequire("lUMYZ")).assert)(!!alertId, new (0, (0, parcelRequire("2FAs6")).AssertionError)('alertDetailResource', 'alertId should be set to fetch alert-detail'));
            return (0, (0, parcelRequire("gp4Sj")).getAlertDetail)(alertId);
        },
        isBrowserOnly: true
    });
    const $d1c1cfbbc144ebd1$export$f9c57ab4d5f63686 = (0, $dIdda.createResource)({
        type: 'logTypesResource',
        getKey: (routerContext)=>`logTypesResource#${routerContext.match.params.id}`,
        getData: async ()=>{
            return (0, (0, parcelRequire("gp4Sj")).getAlertLogTypesEndpoint)();
        },
        isBrowserOnly: true
    });
    const $d1c1cfbbc144ebd1$export$a5515392cb45b9f8 = (0, $dIdda.createResource)({
        type: 'entityRelationTypesResource',
        getKey: (routerContext)=>`entityRelationTypesResource#${routerContext.match.params.id}`,
        getData: async (routerContext)=>{
            const alertId = routerContext.match.params?.id;
            (0, (0, parcelRequire("lUMYZ")).assert)(!!alertId, new (0, (0, parcelRequire("2FAs6")).AssertionError)('alertDetaentityRelationTypesResourceilResource', 'alertId should be set to fetch alert-detail'));
            return (0, (0, parcelRequire("gp4Sj")).getEntityRelationTypesEndpoint)(alertId);
        },
        isBrowserOnly: true
    });
    const $d1c1cfbbc144ebd1$export$c3b70747662e5932 = (0, $dIdda.createResource)({
        type: 'responderStatesResource',
        getKey: (routerContext)=>`responderStatesResource#${routerContext.match.params.id}`,
        getData: async (routerContext)=>{
            const alertId = routerContext.match.params?.id;
            (0, (0, parcelRequire("lUMYZ")).assert)(!!alertId, new (0, (0, parcelRequire("2FAs6")).AssertionError)('responderStatesResource', 'alertId should be set to fetch responder states'));
            return (0, (0, parcelRequire("gp4Sj")).getResponderStatesEndpoint)(alertId);
        },
        isBrowserOnly: true
    });
    const $d1c1cfbbc144ebd1$export$bc99aaabaf7b70a7 = [
        $d1c1cfbbc144ebd1$export$f918335771807ac4,
        $d1c1cfbbc144ebd1$export$f9c57ab4d5f63686,
        $d1c1cfbbc144ebd1$export$c3b70747662e5932,
        $d1c1cfbbc144ebd1$export$a5515392cb45b9f8,
        (0, (0, parcelRequire("kzTEn")).relatedAlertGroupResource),
        ...(0, (0, parcelRequire("c4sFg")).eocCommonResources)()
    ];
});
parcelRegister("kzTEn", function(module, exports) {
    $parcel$export(module.exports, "relatedAlertGroupResource", ()=>$9f540f4e599f57b0$export$35df14c9f0cfb113);
    var $dIdda = parcelRequire("dIdda");
    var $294ns;
    var $lUMYZ;
    var $2FAs6;
    var $7r9b9;
    const $9f540f4e599f57b0$export$35df14c9f0cfb113 = (0, $dIdda.createResource)({
        type: 'relatedAlertGroupResource',
        getKey: (routerContext)=>`relatedAlertGroupResource#${routerContext.match.params.id}`,
        getData: async (routerContext)=>{
            if (!(0, (0, parcelRequire("294ns")).fg)('aiops-related-alert-group')) return null;
            const alertId = routerContext.match.params?.id;
            (0, (0, parcelRequire("lUMYZ")).assert)(!!alertId, new (0, (0, parcelRequire("2FAs6")).AssertionError)('relatedAlertGroupResource', 'alertId should be set to fetch related alert-groups'));
            return (0, (0, parcelRequire("7r9b9")).getRelatedAlertGroup)(alertId);
        },
        isBrowserOnly: true
    });
});
parcelRegister("7r9b9", function(module, exports) {
    $parcel$export(module.exports, "getRelatedAlertGroup", ()=>$b11ffd9b105655bc$export$665e34f20aad273a);
    var $6GHRr;
    var $5TUKq;
    const $b11ffd9b105655bc$export$665e34f20aad273a = (alertId)=>(0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("5TUKq")).withAIOpsDomainPrefix)(`/v1/group-insights/get-group-of-alert?alertId=${alertId}`), {
            exactUrl: true
        });
});
parcelRegister("5TUKq", function(module, exports) {
    $parcel$export(module.exports, "withAIOpsDomainPrefix", ()=>$05dde3cc30c941b0$export$81c70e0016508593);
    var $294ns;
    var $aHQEx;
    const $05dde3cc30c941b0$export$81c70e0016508593 = (input)=>{
        const cloudId = (0, (0, parcelRequire("aHQEx")).getMeta)('ajs-cloud-id');
        if (cloudId) return (0, (0, parcelRequire("294ns")).fg)('platform.aiops-route-prefix-change_qwnpb') ? `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input : `/gateway/api/jsm/aiops/cloudId/${cloudId}/api` + input;
        return input;
    };
});
parcelRegister("gp4Sj", function(module, exports) {
    $parcel$export(module.exports, "getAlertDetail", ()=>$8625f89e90643edd$export$436b6d88c1865c54);
    $parcel$export(module.exports, "getAlertLogTypesEndpoint", ()=>$8625f89e90643edd$export$97200f7e7a7d1479);
    $parcel$export(module.exports, "getResponderStatesEndpoint", ()=>$8625f89e90643edd$export$498d1a9ea659d430);
    $parcel$export(module.exports, "getEntityRelationTypesEndpoint", ()=>$8625f89e90643edd$export$8f96130abdd7549d);
    var $6GHRr;
    const $8625f89e90643edd$export$436b6d88c1865c54 = (alertId)=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/alerts/${alertId}`);
    const $8625f89e90643edd$export$97200f7e7a7d1479 = ()=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/alerts/logs/types`);
    const $8625f89e90643edd$export$498d1a9ea659d430 = (alertId)=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/alerts/${alertId}/responder-states`);
    const $8625f89e90643edd$export$8f96130abdd7549d = (alertId)=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/alerts/${alertId}/entity-relations/relation-types`).then((res)=>({
                relationTypes: res.relationTypes.sort((a, b)=>a.label.localeCompare(b.label))
            }));
});
parcelRegister("3qG6K", function(module, exports) {
    $parcel$export(module.exports, "resources", ()=>$3e08dc36326af93b$export$bc99aaabaf7b70a7);
    var $c4sFg;
    var $eZr0M;
    var $f2nZL;
    var $2VPWI;
    var $i7Ytv;
    const $3e08dc36326af93b$export$bc99aaabaf7b70a7 = [
        (0, (0, parcelRequire("i7Ytv")).uiPreferencesResource),
        (0, (0, parcelRequire("2VPWI")).savedSearchesResource),
        (0, (0, parcelRequire("f2nZL")).compressionRatioResource),
        (0, (0, parcelRequire("eZr0M")).alertGroupingStateResource),
        ...(0, (0, parcelRequire("c4sFg")).eocCommonResources)()
    ];
});
parcelRegister("eZr0M", function(module, exports) {
    $parcel$export(module.exports, "alertGroupingStateResource", ()=>$03057c4e369ee0ab$export$722cc8285202ce44);
    var $dIdda = parcelRequire("dIdda");
    var $cYqfK;
    const $03057c4e369ee0ab$var$emptyAlertGroupingState = {
        isEnabled: false,
        reason: null
    };
    const $03057c4e369ee0ab$export$722cc8285202ce44 = (0, $dIdda.createResource)({
        type: 'alertGroupingStateResource',
        getKey: ()=>'alertGroupingStateResource',
        getData: async ()=>{
            try {
                const response = await (0, (0, parcelRequire("cYqfK")).getGroupFeatureStatus)();
                return response;
            } catch (e) {
                return $03057c4e369ee0ab$var$emptyAlertGroupingState;
            }
        },
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("cYqfK", function(module, exports) {
    $parcel$export(module.exports, "getGroupFeatureStatus", ()=>$e0e5d6f686b0640a$export$48deee62d9dfb365);
    var $6XbAL;
    var $6GHRr;
    var $anMYt;
    const $e0e5d6f686b0640a$export$48deee62d9dfb365 = ()=>{
        const url = new (0, (0, parcelRequire("6XbAL")).URLBuilder)((0, (0, parcelRequire("anMYt")).withAIOpsDomainPrefix)('/v1/aiops/feature-state')).withQueryParam('featureName', 'alert-grouping').build();
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(url, {
            exactUrl: true
        });
    };
});
parcelRegister("6XbAL", function(module, exports) {
    $parcel$export(module.exports, "URLBuilder", ()=>$5d1481e3b203e8da$export$61d2e8db329a11f8);
    class $5d1481e3b203e8da$export$61d2e8db329a11f8 {
        constructor(url){
            this.url = url;
            this.params = {};
        }
        withQueryParam(key, value) {
            this.params[key] = value;
            return this;
        }
        build() {
            const filteredParams = Object.entries(this.params).filter(([, value])=>value !== undefined && value !== null && value !== '');
            const queryInstance = new URLSearchParams(filteredParams);
            const queryParams = queryInstance.toString();
            if (queryParams) return `${this.url}?${queryParams}`;
            return this.url;
        }
    }
});
parcelRegister("anMYt", function(module, exports) {
    $parcel$export(module.exports, "validateTimeInput", ()=>$8378989392268214$export$8880da3ae4274888);
    $parcel$export(module.exports, "validateBetweenInput", ()=>$8378989392268214$export$57c3e855fbf300fa);
    $parcel$export(module.exports, "isInvalidDateValue", ()=>$8378989392268214$export$f18cd4bc58b99a27);
    $parcel$export(module.exports, "removeQuotes", ()=>$8378989392268214$export$dd2bdf5049bf0915);
    $parcel$export(module.exports, "withQuote", ()=>$8378989392268214$export$8708814d32e406db);
    $parcel$export(module.exports, "calculateTimes", ()=>$8378989392268214$export$b362bc6892126b7a);
    $parcel$export(module.exports, "getDefaultFilterQuery", ()=>$8378989392268214$export$16cce822d8159876);
    $parcel$export(module.exports, "isResponderAlert", ()=>$8378989392268214$export$78656db4ffc3ccd8);
    $parcel$export(module.exports, "isGroupAlert", ()=>$8378989392268214$export$be2243d4df51c704);
    $parcel$export(module.exports, "withAIOpsDomainPrefix", ()=>$8378989392268214$export$81c70e0016508593);
    $parcel$export(module.exports, "getCloudIdForDevEnvironment", ()=>$8378989392268214$export$fc6ce7ac2248d7f5);
    var $jovBr;
    var $eZDAP;
    var $gn1v9;
    var $294ns;
    var $aHQEx;
    var $8Brxw;
    var $clSDj;
    var $6lfz8;
    var $6cAn5 = parcelRequire("6cAn5");
    const $8378989392268214$export$8880da3ae4274888 = (intl, timeDigits, timeUnit)=>{
        if (!timeDigits) return;
        const timeDigitsNumber = parseInt(timeDigits);
        if (isNaN(timeDigitsNumber)) return intl.formatMessage((0, (0, parcelRequire("6lfz8")).default).validNumber);
        if (timeUnit === 'hours' && (timeDigitsNumber < 1 || timeDigitsNumber > 99999)) return intl.formatMessage((0, (0, parcelRequire("6lfz8")).default).hoursNotInRange);
        if (timeUnit === 'days' && (timeDigitsNumber < 1 || timeDigitsNumber > 9999)) return intl.formatMessage((0, (0, parcelRequire("6lfz8")).default).daysNotInRange);
        if (timeUnit === 'weeks' && (timeDigitsNumber < 1 || timeDigitsNumber > 999)) return intl.formatMessage((0, (0, parcelRequire("6lfz8")).default).weeksNotInRange);
        if (timeUnit === 'months' && (timeDigitsNumber < 1 || timeDigitsNumber > 99)) return intl.formatMessage((0, (0, parcelRequire("6lfz8")).default).monthsNotInRange);
        if (timeUnit === 'years' && (timeDigitsNumber < 1 || timeDigitsNumber > 9)) return intl.formatMessage((0, (0, parcelRequire("6lfz8")).default).yearsNotInRange);
    };
    const $8378989392268214$export$57c3e855fbf300fa = (intl, value)=>{
        if (value) {
            const { startDate: startDate, endDate: endDate } = value;
            if (!startDate && !endDate) return;
            if (startDate && endDate && new Date(startDate) > new Date(endDate)) return intl.formatMessage((0, (0, parcelRequire("6lfz8")).default).validationMessageBeforeGreaterThanAfter);
            if (value && (startDate !== '' && !(0, (0, parcelRequire("jovBr")).default)(new Date(startDate)) || endDate !== '' && !(0, (0, parcelRequire("jovBr")).default)(new Date(endDate)))) return intl.formatMessage((0, (0, parcelRequire("6lfz8")).default).validationMessageInvalidDateFormat);
        }
        return;
    };
    const $8378989392268214$export$f18cd4bc58b99a27 = (value)=>{
        return !(0, (0, parcelRequire("jovBr")).default)((0, (0, parcelRequire("eZDAP")).default)(value)) && value !== '';
    };
    const $8378989392268214$export$dd2bdf5049bf0915 = (value)=>{
        return value.replace(/^"(.*)"$/, '$1');
    };
    const $8378989392268214$export$d4aae9ad13afd6c = (data)=>{
        return {
            ...data,
            label: data.name,
            value: data.id
        };
    };
    const $8378989392268214$export$8708814d32e406db = (value)=>{
        if ((0, (0, parcelRequire("8Brxw")).hasSpaceRegEx).test(value) || (0, (0, parcelRequire("8Brxw")).hasColonRegex).test(value)) return `${0, (0, parcelRequire("clSDj")).STRING_LITERAL_DOUBLE_QUOTE}${value}${0, (0, parcelRequire("clSDj")).STRING_LITERAL_DOUBLE_QUOTE}`;
        else return value;
    };
    const $8378989392268214$export$b362bc6892126b7a = (time)=>{
        if (!time) return {
            from: undefined,
            to: undefined
        };
        if (time.range === 'all') return {
            from: undefined,
            to: undefined
        };
        if (time.range === 'custom') return {
            from: time.from,
            to: time.to
        };
        const now = new Date();
        const subAmount = {
            [time.range]: time.value
        };
        return {
            from: (0, (0, parcelRequire("gn1v9")).default)(now, subAmount).getTime(),
            to: now.getTime()
        };
    };
    const $8378989392268214$export$16cce822d8159876 = (query, teamId)=>{
        if (teamId) {
            if (query) return `${0, (0, parcelRequire("clSDj")).IDENTIFIER_RESPONDERS}: ${teamId} ${0, (0, parcelRequire("clSDj")).LOGICAL_OPERATOR_AND} ${query}`;
            return `${0, (0, parcelRequire("clSDj")).IDENTIFIER_RESPONDERS}: ${teamId}`;
        }
        return query;
    };
    const $8378989392268214$export$78656db4ffc3ccd8 = (alert)=>alert && alert.alertType === 'responder';
    const $8378989392268214$export$be2243d4df51c704 = (alert)=>alert.entityType === 'group';
    const $8378989392268214$export$81c70e0016508593 = (input)=>{
        const cloudId = (0, (0, parcelRequire("aHQEx")).getMeta)('ajs-cloud-id');
        if (cloudId) return (0, (0, parcelRequire("294ns")).fg)('platform.aiops-route-prefix-change_qwnpb') ? `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input : `/gateway/api/jsm/aiops/cloudId/${cloudId}/api` + input;
        return input;
    };
    const $8378989392268214$var$isDevEnvironment = ()=>{
        return typeof $6cAn5 !== 'undefined' && ($6cAn5?.env?.STORYBOOK === 'true' || $6cAn5?.env?.NODE_ENV === 'development') || window.location.hostname === 'localhost';
    };
    const $8378989392268214$export$fc6ce7ac2248d7f5 = ()=>{
        if ($8378989392268214$var$isDevEnvironment()) return 'abc-def-ghi-jkl';
        return undefined;
    };
});
parcelRegister("8Brxw", function(module, exports) {
    $parcel$export(module.exports, "TAB_KEY", ()=>$8320b6fdbc011979$export$da8c7facc28740b1);
    $parcel$export(module.exports, "ENTER_KEY", ()=>$8320b6fdbc011979$export$4162dbd8c730437);
    $parcel$export(module.exports, "ESCAPE_KEY", ()=>$8320b6fdbc011979$export$728705b4513abbb5);
    $parcel$export(module.exports, "SPACE_KEY", ()=>$8320b6fdbc011979$export$a47625ee19580f99);
    $parcel$export(module.exports, "LEFT_KEY", ()=>$8320b6fdbc011979$export$ba950c21a0561bed);
    $parcel$export(module.exports, "UP_KEY", ()=>$8320b6fdbc011979$export$16859d5882a95fea);
    $parcel$export(module.exports, "RIGHT_KEY", ()=>$8320b6fdbc011979$export$4b96cad863d88376);
    $parcel$export(module.exports, "DOWN_KEY", ()=>$8320b6fdbc011979$export$fc0cf2556509233e);
    $parcel$export(module.exports, "SUGGESTION_CARD_Y_POS", ()=>$8320b6fdbc011979$export$87b2b08fc4c97f78);
    $parcel$export(module.exports, "hasSpaceRegEx", ()=>$8320b6fdbc011979$export$a07ca273fbeffcb8);
    $parcel$export(module.exports, "hasStartingQuotesRegex", ()=>$8320b6fdbc011979$export$a3aaedcec21ac282);
    $parcel$export(module.exports, "hasEndingQuotesRegex", ()=>$8320b6fdbc011979$export$e5ad519d04ef012a);
    $parcel$export(module.exports, "hasNewLinesRegex", ()=>$8320b6fdbc011979$export$7645e556e9948ecd);
    $parcel$export(module.exports, "EMAIL_REGEX", ()=>$8320b6fdbc011979$export$7b7637218245c8a);
    $parcel$export(module.exports, "hasColonRegex", ()=>$8320b6fdbc011979$export$65a2b373cb60e599);
    const $8320b6fdbc011979$export$da8c7facc28740b1 = 'Tab';
    const $8320b6fdbc011979$export$4162dbd8c730437 = 'Enter';
    const $8320b6fdbc011979$export$728705b4513abbb5 = 'Escape';
    const $8320b6fdbc011979$export$a47625ee19580f99 = ' ';
    const $8320b6fdbc011979$export$ba950c21a0561bed = 'ArrowLeft';
    const $8320b6fdbc011979$export$16859d5882a95fea = 'ArrowUp';
    const $8320b6fdbc011979$export$4b96cad863d88376 = 'ArrowRight';
    const $8320b6fdbc011979$export$fc0cf2556509233e = 'ArrowDown';
    const $8320b6fdbc011979$export$87b2b08fc4c97f78 = 28;
    const $8320b6fdbc011979$export$a07ca273fbeffcb8 = /\s/;
    const $8320b6fdbc011979$export$8866d083cd03ffd7 = /^\s|\s$/;
    const $8320b6fdbc011979$export$a3aaedcec21ac282 = /^('|")/;
    const $8320b6fdbc011979$export$e5ad519d04ef012a = /('|")$/;
    const $8320b6fdbc011979$export$7645e556e9948ecd = /(\r\n|\n|\r)/gm;
    const $8320b6fdbc011979$export$7b7637218245c8a = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const $8320b6fdbc011979$export$65a2b373cb60e599 = /:/;
});
parcelRegister("clSDj", function(module, exports) {
    $parcel$export(module.exports, "TOKEN_TYPES", ()=>$8d513e98992829f2$export$e92b897d610f2aba);
    $parcel$export(module.exports, "LEFT_PARENTHESIS", ()=>$8d513e98992829f2$export$9ce7f372949a1546);
    $parcel$export(module.exports, "RIGHT_PARENTHESIS", ()=>$8d513e98992829f2$export$bbbb3f477a9839e0);
    $parcel$export(module.exports, "OPERATOR_EQUAL_TO", ()=>$8d513e98992829f2$export$ea7497008076d6d2);
    $parcel$export(module.exports, "OPERATOR_GROUP_FOR_ASSISTANT", ()=>$8d513e98992829f2$export$e75c84803c67e1f4);
    $parcel$export(module.exports, "LOGICAL_OPERATOR_AND", ()=>$8d513e98992829f2$export$61308b2610174a70);
    $parcel$export(module.exports, "LOGICAL_OPERATOR_OR", ()=>$8d513e98992829f2$export$1de654320eb3e523);
    $parcel$export(module.exports, "BOOLEAN_LITERAL_TRUE", ()=>$8d513e98992829f2$export$ff7eed6ac2251302);
    $parcel$export(module.exports, "BOOLEAN_LITERAL_FALSE", ()=>$8d513e98992829f2$export$4b436fec6f13b741);
    $parcel$export(module.exports, "BOOLEAN_LITERAL_GROUP", ()=>$8d513e98992829f2$export$8cbc171ac4843075);
    $parcel$export(module.exports, "STRING_LITERAL_DOUBLE_QUOTE", ()=>$8d513e98992829f2$export$347c7cb6285a1d61);
    $parcel$export(module.exports, "STRING_LITERAL_STATUS_OPEN", ()=>$8d513e98992829f2$export$910131ff5cd3d496);
    $parcel$export(module.exports, "STRING_LITERAL_STATUS_CLOSED", ()=>$8d513e98992829f2$export$2aa0d26cb4549272);
    $parcel$export(module.exports, "STRING_LITERAL_STATUS_ACKED", ()=>$8d513e98992829f2$export$572cec90aa166025);
    $parcel$export(module.exports, "STRING_LITERAL_STATUS_SNOOZED", ()=>$8d513e98992829f2$export$f94109650ec67751);
    $parcel$export(module.exports, "STRING_LITERAL_STATUS_GROUP", ()=>$8d513e98992829f2$export$3a3a37e9da45a2a4);
    $parcel$export(module.exports, "STRING_LITERAL_PRIORITY_GROUP", ()=>$8d513e98992829f2$export$9ef3f42fa10fce44);
    $parcel$export(module.exports, "NULL_LITERAL", ()=>$8d513e98992829f2$export$c2b6d31a7a2d40ba);
    $parcel$export(module.exports, "IDENTIFIER_ALIAS", ()=>$8d513e98992829f2$export$21c480ed86e9d13);
    $parcel$export(module.exports, "IDENTIFIER_CLOSED_BY", ()=>$8d513e98992829f2$export$534c195089710c34);
    $parcel$export(module.exports, "IDENTIFIER_DEDUPLICATION", ()=>$8d513e98992829f2$export$4699ad3805947d4d);
    $parcel$export(module.exports, "IDENTIFIER_ENTITY", ()=>$8d513e98992829f2$export$2a30b5099ba66c99);
    $parcel$export(module.exports, "IDENTIFIER_IS_SEEN", ()=>$8d513e98992829f2$export$7926b4c2836db847);
    $parcel$export(module.exports, "IDENTIFIER_MESSAGE", ()=>$8d513e98992829f2$export$5a8895646b1d5248);
    $parcel$export(module.exports, "IDENTIFIER_ASSIGNEE", ()=>$8d513e98992829f2$export$4047502bdab1e205);
    $parcel$export(module.exports, "IDENTIFIER_PRIORITY", ()=>$8d513e98992829f2$export$5922c06b76ebb57d);
    $parcel$export(module.exports, "IDENTIFIER_COMPONENTS", ()=>$8d513e98992829f2$export$1122634b5d555f05);
    $parcel$export(module.exports, "IDENTIFIER_SERVICES", ()=>$8d513e98992829f2$export$ec912454cd7d858a);
    $parcel$export(module.exports, "IDENTIFIER_RESPONDERS", ()=>$8d513e98992829f2$export$44673ddac1790242);
    $parcel$export(module.exports, "IDENTIFIER_SOURCE", ()=>$8d513e98992829f2$export$f250d53474e801dc);
    $parcel$export(module.exports, "IDENTIFIER_STATUS", ()=>$8d513e98992829f2$export$43181828ba8680e4);
    $parcel$export(module.exports, "IDENTIFIER_TAG", ()=>$8d513e98992829f2$export$8242733866920892);
    $parcel$export(module.exports, "IDENTIFIER_TINY_ID", ()=>$8d513e98992829f2$export$c833829cf31052f0);
    $parcel$export(module.exports, "IDENTIFIER_ACKNOWLEDGED", ()=>$8d513e98992829f2$export$5f1e5c89a704810f);
    $parcel$export(module.exports, "IDENTIFIER_ACKNOWLEDGED_BY", ()=>$8d513e98992829f2$export$89d93eb7117999c0);
    $parcel$export(module.exports, "IDENTIFIER_TEAMS", ()=>$8d513e98992829f2$export$a79eb1864dd7b745);
    $parcel$export(module.exports, "IDENTIFIER_GROUP_ALERT", ()=>$8d513e98992829f2$export$888a9cda49b5e18c);
    $parcel$export(module.exports, "IDENTIFIER_BOOLEAN_GROUP", ()=>$8d513e98992829f2$export$60745b712d37edf9);
    $parcel$export(module.exports, "IDENTIFIER_GROUP_ALL", ()=>$8d513e98992829f2$export$b38df7dc61d42293);
    $parcel$export(module.exports, "splitToTokensRegex", ()=>$8d513e98992829f2$export$28041d1d2a85f002);
    $parcel$export(module.exports, "isKeywordRegex", ()=>$8d513e98992829f2$export$290f3472231a2ca1);
    $parcel$export(module.exports, "isModifierRegex", ()=>$8d513e98992829f2$export$56079d3966b6b26c);
    $parcel$export(module.exports, "isComplexOperatorRegex", ()=>$8d513e98992829f2$export$3f6ac43c2355116b);
    $parcel$export(module.exports, "isWSRegex", ()=>$8d513e98992829f2$export$b1b0fc0dc5c83a12);
    $parcel$export(module.exports, "isIdentifierRegex", ()=>$8d513e98992829f2$export$218cf3eb73c65394);
    $parcel$export(module.exports, "isLogicalOperatorRegex", ()=>$8d513e98992829f2$export$a46484930d6fa80f);
    $parcel$export(module.exports, "isOperatorRegex", ()=>$8d513e98992829f2$export$d48805fc5b137dc9);
    const $8d513e98992829f2$export$e92b897d610f2aba = [
        'WHITE_SPACE',
        'SEPARATOR',
        'IDENTIFIER',
        'MODIFIER',
        'KEYWORD',
        'LOGICAL_OPERATOR',
        'STRING_LITERAL',
        'NUMBER_LITERAL',
        'BOOLEAN_LITERAL',
        'NULL_LITERAL',
        'OPERATOR'
    ];
    const $8d513e98992829f2$export$9ce7f372949a1546 = '(';
    const $8d513e98992829f2$export$bbbb3f477a9839e0 = ')';
    const $8d513e98992829f2$export$adbc66edc544fda9 = '=';
    const $8d513e98992829f2$export$fbd271ef020db0c = '!=';
    const $8d513e98992829f2$export$ea7497008076d6d2 = ':';
    const $8d513e98992829f2$export$6d44219c9e0c2567 = '!:';
    const $8d513e98992829f2$export$f8636d23c210043c = '<';
    const $8d513e98992829f2$export$1892bd0c818db570 = '<=';
    const $8d513e98992829f2$export$386b1ae18a32d690 = '>';
    const $8d513e98992829f2$export$44a62afa61d82568 = '>=';
    const $8d513e98992829f2$export$e75c84803c67e1f4 = [
        $8d513e98992829f2$export$adbc66edc544fda9,
        $8d513e98992829f2$export$f8636d23c210043c,
        $8d513e98992829f2$export$1892bd0c818db570,
        $8d513e98992829f2$export$386b1ae18a32d690,
        $8d513e98992829f2$export$44a62afa61d82568
    ];
    const $8d513e98992829f2$export$61308b2610174a70 = 'AND';
    const $8d513e98992829f2$export$1de654320eb3e523 = 'OR';
    const $8d513e98992829f2$export$184522872a5410fc = 'not';
    const $8d513e98992829f2$export$ff7eed6ac2251302 = 'true';
    const $8d513e98992829f2$export$4b436fec6f13b741 = 'false';
    const $8d513e98992829f2$export$8cbc171ac4843075 = [
        $8d513e98992829f2$export$ff7eed6ac2251302,
        $8d513e98992829f2$export$4b436fec6f13b741
    ];
    const $8d513e98992829f2$export$347c7cb6285a1d61 = '"';
    const $8d513e98992829f2$export$d84ab70dc909b702 = "'";
    const $8d513e98992829f2$export$910131ff5cd3d496 = `${$8d513e98992829f2$export$347c7cb6285a1d61}open${$8d513e98992829f2$export$347c7cb6285a1d61}`;
    const $8d513e98992829f2$export$2aa0d26cb4549272 = `${$8d513e98992829f2$export$347c7cb6285a1d61}closed${$8d513e98992829f2$export$347c7cb6285a1d61}`;
    const $8d513e98992829f2$export$572cec90aa166025 = `${$8d513e98992829f2$export$347c7cb6285a1d61}acknowledged${$8d513e98992829f2$export$347c7cb6285a1d61}`;
    const $8d513e98992829f2$export$f94109650ec67751 = `${$8d513e98992829f2$export$347c7cb6285a1d61}snoozed${$8d513e98992829f2$export$347c7cb6285a1d61}`;
    const $8d513e98992829f2$export$3a3a37e9da45a2a4 = [
        $8d513e98992829f2$export$910131ff5cd3d496,
        $8d513e98992829f2$export$2aa0d26cb4549272,
        $8d513e98992829f2$export$572cec90aa166025,
        $8d513e98992829f2$export$f94109650ec67751
    ];
    const $8d513e98992829f2$export$928c1edd572e94f0 = 'P1';
    const $8d513e98992829f2$export$22202070e5f64c55 = 'P2';
    const $8d513e98992829f2$export$537865d58d2072a3 = 'P3';
    const $8d513e98992829f2$export$3d5cfea3feefee83 = 'P4';
    const $8d513e98992829f2$export$fe945cac89cd21a5 = 'P5';
    const $8d513e98992829f2$export$9ef3f42fa10fce44 = [
        $8d513e98992829f2$export$928c1edd572e94f0,
        $8d513e98992829f2$export$22202070e5f64c55,
        $8d513e98992829f2$export$537865d58d2072a3,
        $8d513e98992829f2$export$3d5cfea3feefee83,
        $8d513e98992829f2$export$fe945cac89cd21a5
    ];
    const $8d513e98992829f2$export$c2b6d31a7a2d40ba = 'null';
    const $8d513e98992829f2$export$5a484b762b542c13 = 'actions';
    const $8d513e98992829f2$export$21c480ed86e9d13 = 'alias';
    const $8d513e98992829f2$export$534c195089710c34 = 'closedBy';
    const $8d513e98992829f2$export$4699ad3805947d4d = 'count';
    const $8d513e98992829f2$export$7c3401d7874d69f5 = 'createdAt';
    const $8d513e98992829f2$export$afffcbd5b444e040 = 'description';
    const $8d513e98992829f2$export$e1e61c3bf43fff11 = 'details.key';
    const $8d513e98992829f2$export$aa35da9746edbfe2 = 'details.value';
    const $8d513e98992829f2$export$b620b7163533b409 = 'detailsPair';
    const $8d513e98992829f2$export$2a30b5099ba66c99 = 'entity';
    const $8d513e98992829f2$export$2bfb49435a331d16 = 'integration.name';
    const $8d513e98992829f2$export$feced558810f4b3e = 'integration.type';
    const $8d513e98992829f2$export$7926b4c2836db847 = 'isSeen';
    const $8d513e98992829f2$export$5a8895646b1d5248 = 'message';
    const $8d513e98992829f2$export$4047502bdab1e205 = 'owner';
    const $8d513e98992829f2$export$5922c06b76ebb57d = 'priority';
    const $8d513e98992829f2$export$1122634b5d555f05 = 'components';
    const $8d513e98992829f2$export$ec912454cd7d858a = 'services';
    const $8d513e98992829f2$export$44673ddac1790242 = 'responders';
    const $8d513e98992829f2$export$f250d53474e801dc = 'source';
    const $8d513e98992829f2$export$43181828ba8680e4 = 'status';
    const $8d513e98992829f2$export$a1959e1b76e880dd = 'sync.name';
    const $8d513e98992829f2$export$8417ff61f7a57db6 = 'sync.type';
    const $8d513e98992829f2$export$8242733866920892 = 'tags';
    const $8d513e98992829f2$export$c833829cf31052f0 = 'tinyId';
    const $8d513e98992829f2$export$78d4faf48faf13c2 = 'updatedAt';
    const $8d513e98992829f2$export$5f1e5c89a704810f = 'acknowledged';
    const $8d513e98992829f2$export$89d93eb7117999c0 = 'acknowledgedBy';
    const $8d513e98992829f2$export$1ee0ad656333fc23 = 'aggregatorIds';
    const $8d513e98992829f2$export$d42da2034504d6de = 'alertId';
    const $8d513e98992829f2$export$8464a15b62fb09bb = 'alertType';
    const $8d513e98992829f2$export$2f7ba2848fc019c6 = 'encrypted';
    const $8d513e98992829f2$export$86e4b68c61c8cca5 = 'encryptionId';
    const $8d513e98992829f2$export$cd9dc7ab4d04d11c = 'lastOccurredAt';
    const $8d513e98992829f2$export$8508b76d4c14d7e = 'notify';
    const $8d513e98992829f2$export$e73ddf8d219f28b7 = 'snoozedUntil';
    const $8d513e98992829f2$export$a79eb1864dd7b745 = 'teams';
    const $8d513e98992829f2$export$888a9cda49b5e18c = [
        $8d513e98992829f2$export$5f1e5c89a704810f,
        $8d513e98992829f2$export$89d93eb7117999c0,
        $8d513e98992829f2$export$1ee0ad656333fc23,
        $8d513e98992829f2$export$d42da2034504d6de,
        $8d513e98992829f2$export$8464a15b62fb09bb,
        $8d513e98992829f2$export$2f7ba2848fc019c6,
        $8d513e98992829f2$export$86e4b68c61c8cca5,
        $8d513e98992829f2$export$cd9dc7ab4d04d11c,
        $8d513e98992829f2$export$8508b76d4c14d7e,
        $8d513e98992829f2$export$e73ddf8d219f28b7,
        $8d513e98992829f2$export$a79eb1864dd7b745,
        $8d513e98992829f2$export$5a484b762b542c13,
        $8d513e98992829f2$export$21c480ed86e9d13,
        $8d513e98992829f2$export$534c195089710c34,
        $8d513e98992829f2$export$4699ad3805947d4d,
        $8d513e98992829f2$export$7c3401d7874d69f5,
        $8d513e98992829f2$export$afffcbd5b444e040,
        $8d513e98992829f2$export$e1e61c3bf43fff11,
        $8d513e98992829f2$export$aa35da9746edbfe2,
        $8d513e98992829f2$export$b620b7163533b409,
        $8d513e98992829f2$export$2a30b5099ba66c99,
        $8d513e98992829f2$export$2bfb49435a331d16,
        $8d513e98992829f2$export$feced558810f4b3e,
        $8d513e98992829f2$export$7926b4c2836db847,
        $8d513e98992829f2$export$5a8895646b1d5248,
        $8d513e98992829f2$export$4047502bdab1e205,
        $8d513e98992829f2$export$5922c06b76ebb57d,
        $8d513e98992829f2$export$44673ddac1790242,
        $8d513e98992829f2$export$1122634b5d555f05,
        $8d513e98992829f2$export$ec912454cd7d858a,
        $8d513e98992829f2$export$f250d53474e801dc,
        $8d513e98992829f2$export$43181828ba8680e4,
        $8d513e98992829f2$export$a1959e1b76e880dd,
        $8d513e98992829f2$export$8417ff61f7a57db6,
        $8d513e98992829f2$export$8242733866920892,
        $8d513e98992829f2$export$c833829cf31052f0,
        $8d513e98992829f2$export$78d4faf48faf13c2
    ];
    const $8d513e98992829f2$export$60745b712d37edf9 = [
        $8d513e98992829f2$export$5f1e5c89a704810f,
        $8d513e98992829f2$export$7926b4c2836db847
    ];
    const $8d513e98992829f2$export$b38df7dc61d42293 = [
        ...$8d513e98992829f2$export$888a9cda49b5e18c
    ];
    const $8d513e98992829f2$var$splitToTokensCases = [
        ...[
            $8d513e98992829f2$export$d84ab70dc909b702,
            $8d513e98992829f2$export$347c7cb6285a1d61
        ].map((i)=>`(${i}.*?${i})`),
        ...[
            $8d513e98992829f2$export$d84ab70dc909b702,
            $8d513e98992829f2$export$347c7cb6285a1d61
        ].map((i)=>`(${i}.*)`),
        ...[
            $8d513e98992829f2$export$9ce7f372949a1546,
            $8d513e98992829f2$export$bbbb3f477a9839e0,
            $8d513e98992829f2$export$adbc66edc544fda9,
            $8d513e98992829f2$export$fbd271ef020db0c,
            $8d513e98992829f2$export$ea7497008076d6d2,
            $8d513e98992829f2$export$6d44219c9e0c2567,
            $8d513e98992829f2$export$44a62afa61d82568,
            $8d513e98992829f2$export$386b1ae18a32d690,
            $8d513e98992829f2$export$1892bd0c818db570,
            $8d513e98992829f2$export$f8636d23c210043c
        ].map((i)=>`(\\${i})`),
        ...[
            $8d513e98992829f2$export$61308b2610174a70,
            $8d513e98992829f2$export$1de654320eb3e523,
            $8d513e98992829f2$export$ff7eed6ac2251302,
            $8d513e98992829f2$export$4b436fec6f13b741,
            $8d513e98992829f2$export$184522872a5410fc,
            `is\\s*null`,
            `is\\s*not\\s*null`
        ].map((i)=>`(\\b${i}(?=\\s|$))`),
        '(\\s+)'
    ];
    const $8d513e98992829f2$export$28041d1d2a85f002 = new RegExp($8d513e98992829f2$var$splitToTokensCases.join('|'), 'gi');
    const $8d513e98992829f2$export$290f3472231a2ca1 = /^(is(  *)not(  *)null)$|^(is(  *)null)$/i;
    const $8d513e98992829f2$export$56079d3966b6b26c = /^not$/i;
    const $8d513e98992829f2$export$3f6ac43c2355116b = /^<=$|^>=$|^!=$|^!:$/;
    const $8d513e98992829f2$export$b1b0fc0dc5c83a12 = /^\s+$/;
    const $8d513e98992829f2$export$218cf3eb73c65394 = new RegExp($8d513e98992829f2$export$b38df7dc61d42293.map((i)=>`^${i}$`).join('|'));
    const $8d513e98992829f2$export$a46484930d6fa80f = /^and$|^or$/i;
    const $8d513e98992829f2$export$d48805fc5b137dc9 = /^[=:<>]$/;
});
parcelRegister("6lfz8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$412c31c7b253dc45$export$2e2bcd8739ae039);
    var $7VHMR;
    const $412c31c7b253dc45$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        validationMessageBeforeGreaterThanAfter: {
            id: `eoc.alert-list.common.utils.validation-message-before-greater-than-after.no-translate`,
            defaultMessage: "'Before' field cannot be later than 'After' field.",
            description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
        },
        validationMessageInvalidDateFormat: {
            id: `eoc.alert-list.common.utils.validation-message-invalid-date-format.no-translate`,
            defaultMessage: 'Invalid date format.',
            description: 'Invalid date format.'
        },
        validNumber: {
            id: `eoc.alert-list.common.utils.validation-not-number.no-translate`,
            defaultMessage: 'Enter a valid number.',
            description: 'The error message that shown when user write different chars other than numeric chars.'
        },
        hoursNotInRange: {
            id: `eoc.alert-list.common.utils.validation-message-hours-not-in-range.no-translate`,
            defaultMessage: 'Enter a number between 1-99999.',
            description: 'Message displayed to the user when hours value is not in range'
        },
        daysNotInRange: {
            id: `eoc.alert-list.common.utils.validation-message-days-not-in-range.no-translate`,
            defaultMessage: 'Enter a number between 1-9999.',
            description: 'Message displayed to the user when days value is not in range'
        },
        weeksNotInRange: {
            id: `eoc.alert-list.common.utils.validation-message-weeks-not-in-range.no-translate`,
            defaultMessage: 'Enter a number between 1-999.',
            description: 'Message displayed to the user when weeks value is not in range'
        },
        monthsNotInRange: {
            id: `eoc.alert-list.common.utils.validation-message-months-not-in-range.no-translate`,
            defaultMessage: 'Enter a number between 1-99.',
            description: 'Message displayed to the user when months value is not in range'
        },
        yearsNotInRange: {
            id: `eoc.alert-list.common.utils.validation-message-years-not-in-range.no-translate`,
            defaultMessage: 'Enter a number between 1-9.',
            description: 'Message displayed to the user when years value is not in range'
        }
    });
    var $412c31c7b253dc45$export$2e2bcd8739ae039 = $412c31c7b253dc45$var$messages;
});
parcelRegister("f2nZL", function(module, exports) {
    $parcel$export(module.exports, "compressionRatioResource", ()=>$3d1ea21623f31886$export$8c912e73f758af2);
    var $dIdda = parcelRequire("dIdda");
    var $01A5V;
    const $3d1ea21623f31886$var$emptyCompressionBanner = {
        compressionRatio: 0,
        uniqueGroupCount: 0,
        rollingWindow: 0
    };
    const $3d1ea21623f31886$export$8c912e73f758af2 = (0, $dIdda.createResource)({
        type: 'compressionRatioResource',
        getKey: ()=>'compressionRatioResource',
        getData: async ()=>{
            try {
                const response = await (0, (0, parcelRequire("01A5V")).getCompressionRatio)();
                return response;
            } catch (e) {
                return $3d1ea21623f31886$var$emptyCompressionBanner;
            }
        },
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("01A5V", function(module, exports) {
    $parcel$export(module.exports, "getCompressionRatio", ()=>$a31d67d3474d549c$export$4991457f359db4f7);
    var $6GHRr;
    var $anMYt;
    const $a31d67d3474d549c$export$4991457f359db4f7 = ()=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("anMYt")).withAIOpsDomainPrefix)('/v1/alert-insights/compression-ratio'), {
            exactUrl: true
        });
    };
});
parcelRegister("2VPWI", function(module, exports) {
    $parcel$export(module.exports, "savedSearchesResource", ()=>$06a9f4fe15932c3c$export$d915b849e6dd786b);
    var $dIdda = parcelRequire("dIdda");
    var $1mf4f;
    const $06a9f4fe15932c3c$export$d915b849e6dd786b = (0, $dIdda.createResource)({
        type: 'savedSearchesResource',
        getKey: ()=>'savedSearchesResource',
        getData: ()=>(0, (0, parcelRequire("1mf4f")).getSavedSearchesEndpoint)(),
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("1mf4f", function(module, exports) {
    $parcel$export(module.exports, "getSavedSearchesEndpoint", ()=>$d134aa6f3be242f4$export$3b7b44889eb94cd0);
    $parcel$export(module.exports, "createSavedSearchEndpoint", ()=>$d134aa6f3be242f4$export$4976332c0ec66407);
    $parcel$export(module.exports, "deleteSearchEndpoint", ()=>$d134aa6f3be242f4$export$401da4a793944201);
    var $6GHRr;
    const $d134aa6f3be242f4$export$3b7b44889eb94cd0 = ()=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)('/v1/alerts/saved-searches');
    };
    const $d134aa6f3be242f4$export$4976332c0ec66407 = (data)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)('/v1/alerts/saved-searches', {
            method: 'POST',
            body: data
        });
    };
    const $d134aa6f3be242f4$export$401da4a793944201 = (id)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/alerts/saved-searches/${id}`, {
            method: 'DELETE',
            responseType: 'headers'
        });
    };
});
parcelRegister("i7Ytv", function(module, exports) {
    $parcel$export(module.exports, "uiPreferencesResource", ()=>$4f24d65c111d8e60$export$4e143f0fe4b2e025);
    var $dIdda = parcelRequire("dIdda");
    var $38unf;
    const $4f24d65c111d8e60$export$4e143f0fe4b2e025 = (0, $dIdda.createResource)({
        type: 'uiPreferencesResource',
        getKey: ()=>'uiPreferencesResource',
        getData: ()=>(0, (0, parcelRequire("38unf")).getUiPreferencesEndpoint)(),
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("38unf", function(module, exports) {
    $parcel$export(module.exports, "getUiPreferencesEndpoint", ()=>$e86400c880c24b8d$export$afa4854419ed2fc8);
    $parcel$export(module.exports, "updateUiPreferencesEndpoint", ()=>$e86400c880c24b8d$export$4990793476d8f783);
    var $6GHRr;
    const $e86400c880c24b8d$export$afa4854419ed2fc8 = ()=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)('/v1/alerts/ui-preferences');
    };
    const $e86400c880c24b8d$export$4990793476d8f783 = (data)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)('/v1/alerts/ui-preferences', {
            method: 'PATCH',
            body: data
        });
    };
});
parcelRegister("gLQQv", function(module, exports) {
    $parcel$export(module.exports, "LazyGlobalAlertsSidebar", ()=>$423d186a1838bb07$export$674fd99c08c90491);
    $parcel$export(module.exports, "AsyncSidebarEocGlobalAlerts", ()=>$423d186a1838bb07$export$a1c034c1031e8711);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $hPtZI;
    const $423d186a1838bb07$export$674fd99c08c90491 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("E6d9p")).then((bundle)=>bundle), {
        moduleId: "./src/packages/navigation-apps/sidebar/eoc-global-alerts/src/index.tsx"
    });
    const $423d186a1838bb07$export$a1c034c1031e8711 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "eocGlobalAlerts"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($423d186a1838bb07$export$674fd99c08c90491, null));
});
parcelRegister("E6d9p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("39Zx1")
    ]).then(()=>parcelRequire('2kjD7'));
});
parcelRegister("5CJ70", function(module, exports) {
    $parcel$export(module.exports, "eocGlobalAlertDetailRoute", ()=>$f4309291528957cf$export$4c5c22da74ff47b1);
    $parcel$export(module.exports, "eocGlobalAlertListRoute", ()=>$f4309291528957cf$export$29721341dde2ed3d);
    var $65Ltd;
    const $f4309291528957cf$export$4c5c22da74ff47b1 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ALERT_DETAIL),
        path: '/jira/ops/alerts/:id',
        exact: true
    };
    const $f4309291528957cf$export$29721341dde2ed3d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_ALERTS),
        path: '/jira/ops/alerts',
        exact: true
    };
});
parcelRegister("d8hKi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1Z4yj")
    ]).then(()=>parcelRequire('cHlJB'));
});
parcelRegister("9oDXs", function(module, exports) {
    $parcel$export(module.exports, "eocGlobalGroupDetailRouteEntry", ()=>$b412556f032cd6c3$export$66928ab349190059);
    $parcel$export(module.exports, "eocTeamGroupDetailRouteEntry", ()=>$b412556f032cd6c3$export$2b25520e20820251);
    var $3qG6K;
    var $39Ps4;
    var $3vS1t;
    var $ffza4;
    var $co1wz;
    var $7XYc4;
    var $lmyls;
    var $gLQQv;
    var $3Dk1Z;
    var $h3Ix2;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $5lsNZ;
    var $lhSEt;
    var $lgLgL;
    const $b412556f032cd6c3$export$66928ab349190059 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lhSEt")).eocGlobalGroupDetailRoute), ()=>({
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('platform.aiops-smart-view_yf5qp'), (0, (0, parcelRequire("lgLgL")).default), (0, (0, parcelRequire("5lsNZ")).default)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("39Ps4")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...(0, (0, parcelRequire("3qG6K")).resources)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HOME,
                sidebar: (0, (0, parcelRequire("gLQQv")).AsyncSidebarEocGlobalAlerts)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("lgLgL")).LazyGroupDetail),
                (0, (0, parcelRequire("gLQQv")).LazyGlobalAlertsSidebar)
            ]
        }));
    const $b412556f032cd6c3$export$2b25520e20820251 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lhSEt")).eocTeamGroupDetailRoute), ()=>({
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('platform.aiops-smart-view_yf5qp'), (0, (0, parcelRequire("lgLgL")).default), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("h3Ix2")).opsTeamLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3vS1t")).resources),
                ...(0, (0, parcelRequire("39Ps4")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...(0, (0, parcelRequire("3qG6K")).resources)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, (0, parcelRequire("3Dk1Z")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("lgLgL")).LazyGroupDetail),
                (0, (0, parcelRequire("3Dk1Z")).LazyTeamDashboardSidebar)
            ]
        }));
});
parcelRegister("39Ps4", function(module, exports) {
    $parcel$export(module.exports, "groupHeaderResource", ()=>$f72f24fc6cc1b937$export$e6ba56f6b67069c8);
    $parcel$export(module.exports, "aiSuggestionsResource", ()=>$f72f24fc6cc1b937$export$94675faef1d4568b);
    $parcel$export(module.exports, "resources", ()=>$f72f24fc6cc1b937$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $lUMYZ;
    var $2FAs6;
    var $HWVaX;
    const $f72f24fc6cc1b937$export$e6ba56f6b67069c8 = (0, $dIdda.createResource)({
        type: 'groupHeaderResource',
        getKey: (routerContext)=>`groupHeaderResource#${routerContext.match.params.id}`,
        getData: async (routerContext)=>{
            const groupId = routerContext.match.params?.id;
            (0, (0, parcelRequire("lUMYZ")).assert)(!!groupId, new (0, (0, parcelRequire("2FAs6")).AssertionError)('groupHeaderResource', 'groupId should be set to fetch group-detail-header'));
            return (0, (0, parcelRequire("HWVaX")).getHeaderDetails)(groupId);
        },
        isBrowserOnly: true
    });
    const $f72f24fc6cc1b937$export$94675faef1d4568b = (0, $dIdda.createResource)({
        type: 'aiSuggestionsResource',
        getKey: (routerContext)=>`aiSuggestionsResource#${routerContext.match.params.id}`,
        getData: async (routerContext)=>{
            const groupId = routerContext.match.params?.id;
            (0, (0, parcelRequire("lUMYZ")).assert)(!!groupId, new (0, (0, parcelRequire("2FAs6")).AssertionError)('aiSuggestionsResource', 'groupId should be set to fetch ai-suggestions for any group'));
            return (0, (0, parcelRequire("HWVaX")).getAISuggestions)(groupId);
        },
        isBrowserOnly: true
    });
    const $f72f24fc6cc1b937$export$bc99aaabaf7b70a7 = [
        $f72f24fc6cc1b937$export$e6ba56f6b67069c8,
        $f72f24fc6cc1b937$export$94675faef1d4568b
    ];
});
parcelRegister("HWVaX", function(module, exports) {
    $parcel$export(module.exports, "getHeaderDetails", ()=>$43b7a43d567decd6$export$c0f2e4bfcbff05d1);
    $parcel$export(module.exports, "getAISuggestions", ()=>$43b7a43d567decd6$export$34bb7a15a54039a5);
    $parcel$export(module.exports, "addGroupAssignee", ()=>$43b7a43d567decd6$export$bd5bdebdb6d9abb);
    $parcel$export(module.exports, "actionOnGroup", ()=>$43b7a43d567decd6$export$5353a5d2604523c0);
    $parcel$export(module.exports, "getAlertCountForGroupAction", ()=>$43b7a43d567decd6$export$b47efb0a9602f0c8);
    var $6GHRr;
    var $9P1qs;
    const $43b7a43d567decd6$export$c0f2e4bfcbff05d1 = (groupId)=>(0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("9P1qs")).withAIOpsPrefix)(`/v1/group-insights/${groupId}`), {
            exactUrl: true
        });
    const $43b7a43d567decd6$export$34bb7a15a54039a5 = (groupId)=>(0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("9P1qs")).withAIOpsPrefix)(`/v1/group-insights/getSimilar/${groupId}`), {
            exactUrl: true
        });
    const $43b7a43d567decd6$export$bd5bdebdb6d9abb = (groupId, assigneeId)=>(0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("9P1qs")).withAIOpsPrefix)(`/v1/group-insights/${groupId}/add-assignee/${assigneeId}`), {
            method: 'PUT',
            exactUrl: true
        });
    const $43b7a43d567decd6$export$5353a5d2604523c0 = (groupId, action, payload = {})=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("9P1qs")).withAIOpsPrefix)(`/v1/alert-insights/bulk-action`), {
            method: 'PUT',
            exactUrl: true,
            body: {
                groupId: groupId,
                actionType: action,
                ...payload
            }
        });
    };
    const $43b7a43d567decd6$export$b47efb0a9602f0c8 = (groupId, action)=>{
        const urlSearchParams = new URLSearchParams();
        urlSearchParams.set('actionType', action);
        urlSearchParams.set('groupId', groupId);
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("9P1qs")).withAIOpsPrefix)(`/v1/alert-insights/check-all-action?${urlSearchParams}`), {
            exactUrl: true
        });
    };
});
parcelRegister("9P1qs", function(module, exports) {
    $parcel$export(module.exports, "withAIOpsPrefix", ()=>$b422d7ed288707f6$export$5ad74397753c99a2);
    var $294ns;
    var $aHQEx;
    const $b422d7ed288707f6$export$5ad74397753c99a2 = (input)=>{
        const cloudId = (0, (0, parcelRequire("aHQEx")).getMeta)('ajs-cloud-id');
        if (cloudId) return (0, (0, parcelRequire("294ns")).getBooleanFF)('platform.aiops-route-prefix-change_qwnpb') ? `/gateway/api/jira/aiops/cloudId/${cloudId}/api` + input : `/gateway/api/jsm/aiops/cloudId/${cloudId}/api` + input;
        return input;
    };
});
parcelRegister("lhSEt", function(module, exports) {
    $parcel$export(module.exports, "eocGlobalGroupDetailRoute", ()=>$61dbc99cfecef4f3$export$e6569aff8dfd4c1d);
    $parcel$export(module.exports, "eocTeamGroupDetailRoute", ()=>$61dbc99cfecef4f3$export$aa8cf61e94739f21);
    var $65Ltd;
    const $61dbc99cfecef4f3$export$e6569aff8dfd4c1d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_GROUP_DETAIL),
        path: '/jira/ops/group-detail/:id',
        exact: true
    };
    const $61dbc99cfecef4f3$export$aa8cf61e94739f21 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_GROUP_DETAIL),
        path: '/jira/ops/teams/:teamId/group-detail/:id',
        exact: true
    };
});
parcelRegister("lgLgL", function(module, exports) {
    $parcel$export(module.exports, "LazyGroupDetail", ()=>$009be0886fa71d74$export$8d4b3992eb19d436);
    $parcel$export(module.exports, "default", ()=>$009be0886fa71d74$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $009be0886fa71d74$export$8d4b3992eb19d436 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("115sl")), {
        moduleId: "./src/packages/eoc/group-detail/src/ui/index.tsx"
    });
    var $009be0886fa71d74$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $009be0886fa71d74$export$8d4b3992eb19d436,
            pageId: "async-jira-eoc-group-detail",
            shouldShowSpinner: false
        });
});
parcelRegister("115sl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dTpji")
    ]).then(()=>parcelRequire('9kpiP'));
});
parcelRegister("lvEQq", function(module, exports) {
    $parcel$export(module.exports, "eocHeartbeatsRouteEntry", ()=>$c885df6a6405ba26$export$2c2d6115c4280a08);
    var $5uXOq = parcelRequire("5uXOq");
    var $7MLhH;
    var $3vS1t;
    var $ffza4;
    var $lmyls;
    var $3Dk1Z;
    var $fezpN;
    var $h3Ix2;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $jH6Qa;
    var $5j7Th;
    var $hPtZI;
    const $c885df6a6405ba26$var$LazyHeartbeats = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("8074j")), {
        moduleId: "./src/packages/eoc/heartbeats/src/index.tsx"
    });
    const $c885df6a6405ba26$var$HeartbeatsComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c885df6a6405ba26$var$LazyHeartbeats,
            pageId: "async-jira-eoc-heartbeats",
            shouldShowSpinner: false
        });
    const $c885df6a6405ba26$export$2c2d6115c4280a08 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jH6Qa")).heartbeatsRoute), ()=>({
            component: $c885df6a6405ba26$var$HeartbeatsComponent,
            layout: (0, (0, parcelRequire("h3Ix2")).opsTeamLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("7MLhH")).resources),
                ...(0, (0, parcelRequire("3vS1t")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, (0, parcelRequire("3Dk1Z")).default),
                horizontal: (0, (0, parcelRequire("fezpN")).AsyncHorizontalOperationsNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("fezpN")).LazyHorizontalOperationsNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $c885df6a6405ba26$var$LazyHeartbeats,
                (0, (0, parcelRequire("3Dk1Z")).LazyTeamDashboardSidebar)
            ]
        }));
});
parcelRegister("7MLhH", function(module, exports) {
    $parcel$export(module.exports, "heartbeatsResource", ()=>$0dc8ac1837cca323$export$dd38e2aa5cfda9c9);
    $parcel$export(module.exports, "heartbeatsUserRightsResource", ()=>$0dc8ac1837cca323$export$b5d9a0bcdfa848ce);
    $parcel$export(module.exports, "resources", ()=>$0dc8ac1837cca323$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $cCkIw;
    const $0dc8ac1837cca323$export$dd38e2aa5cfda9c9 = (0, $dIdda.createResource)({
        type: 'heartbeatsResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `heartbeats/${teamId ?? ''}`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            if (!teamId) return;
            return (0, (0, parcelRequire("cCkIw")).getHeartbeatsEndpoint)(teamId);
        },
        isBrowserOnly: true
    });
    const $0dc8ac1837cca323$export$b5d9a0bcdfa848ce = (0, $dIdda.createResource)({
        type: 'heartbeatsUserRightsResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `heartbeats-user-rights/${teamId ?? ''}`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return (0, (0, parcelRequire("cCkIw")).getHeartbeatsUserRights)(teamId);
        },
        isBrowserOnly: true
    });
    const $0dc8ac1837cca323$export$bc99aaabaf7b70a7 = [
        $0dc8ac1837cca323$export$dd38e2aa5cfda9c9,
        $0dc8ac1837cca323$export$b5d9a0bcdfa848ce
    ];
});
parcelRegister("cCkIw", function(module, exports) {
    $parcel$export(module.exports, "getHeartbeatsEndpoint", ()=>$89d90dace72e0b14$export$c322dad372dcb08b);
    $parcel$export(module.exports, "validateHeartbeatNameEndpoint", ()=>$89d90dace72e0b14$export$676f6aee59f124b0);
    $parcel$export(module.exports, "createHeartbeatEndpoint", ()=>$89d90dace72e0b14$export$891ea85cc6973b32);
    $parcel$export(module.exports, "updateHeartbeatEndpoint", ()=>$89d90dace72e0b14$export$7311481b59e02e06);
    $parcel$export(module.exports, "switchHeartbeatEndpoint", ()=>$89d90dace72e0b14$export$5df993f1c74d7e8e);
    $parcel$export(module.exports, "deleteHeartbeatEndpoint", ()=>$89d90dace72e0b14$export$716e365975fc2cd1);
    $parcel$export(module.exports, "getHeartbeatsUserRights", ()=>$89d90dace72e0b14$export$26eaca11f3b4e506);
    $parcel$export(module.exports, "updateAutoCreationEndpoint", ()=>$89d90dace72e0b14$export$38097aade6a3b234);
    var $6GHRr;
    const $89d90dace72e0b14$export$c322dad372dcb08b = (teamId)=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/teams/${teamId}/heartbeats`, {
            method: 'GET'
        });
    const $89d90dace72e0b14$export$676f6aee59f124b0 = (teamId, heartbeatName)=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/teams/${teamId}/heartbeats/validateEmail?heartbeatName=${encodeURIComponent(heartbeatName)}`, {
            method: 'GET',
            responseType: 'headers'
        });
    const $89d90dace72e0b14$export$891ea85cc6973b32 = (teamId, heartbeat)=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/teams/${teamId}/heartbeats`, {
            method: 'POST',
            body: heartbeat
        });
    const $89d90dace72e0b14$export$7311481b59e02e06 = (teamId, heartbeat)=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/teams/${teamId}/heartbeats`, {
            method: 'PUT',
            body: heartbeat
        });
    const $89d90dace72e0b14$export$5df993f1c74d7e8e = (teamId, enable, name)=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/teams/${teamId}/heartbeats/enable?enabled=${enable}&name=${encodeURIComponent(name)}`, {
            method: 'PATCH'
        });
    const $89d90dace72e0b14$export$716e365975fc2cd1 = (teamId, name)=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/teams/${teamId}/heartbeats?name=${encodeURIComponent(name)}`, {
            method: 'DELETE',
            responseType: 'headers'
        });
    const $89d90dace72e0b14$export$26eaca11f3b4e506 = (teamId)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}heartbeats/rights`);
    };
    const $89d90dace72e0b14$export$38097aade6a3b234 = (teamId, autoCreateEnabled)=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}heartbeats/updateHeartbeatAutoCreation?autoCreateEnabled=${autoCreateEnabled}`, {
            method: 'POST',
            responseType: 'headers'
        });
});
parcelRegister("jH6Qa", function(module, exports) {
    $parcel$export(module.exports, "heartbeatsRoute", ()=>$3d5192328e8485c6$export$e935ec688da4c447);
    var $65Ltd;
    const $3d5192328e8485c6$export$e935ec688da4c447 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_HEARTBEATS),
        path: '/jira/ops/teams/:teamId/heartbeats',
        exact: true
    };
});
parcelRegister("8074j", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5jEdq")
    ]).then(()=>parcelRequire('4uAlQ'));
});
parcelRegister("gAzgo", function(module, exports) {
    $parcel$export(module.exports, "eocIncomingCallRouteEntries", ()=>$0cb28d0cbf2b2b29$export$5d3c7bc3dee8745d);
    var $5uXOq = parcelRequire("5uXOq");
    var $5eKhc;
    var $ffza4;
    var $lmyls;
    var $2Fj5v;
    var $iTMlN;
    var $2G9Bk;
    var $3RJkv;
    var $1Pyrp;
    var $5j7Th;
    var $ldWCQ;
    const $0cb28d0cbf2b2b29$export$742ca8be503e0313 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, (0, parcelRequire("ldWCQ")).LazyIncomingCall),
            pageId: "async-jira-eoc-incoming-call",
            shouldShowSpinner: false
        });
    const $0cb28d0cbf2b2b29$export$6ec51edee1972588 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, (0, parcelRequire("ldWCQ")).LazyIncomingCallDetail),
            pageId: "async-jira-eoc-incoming-call-detail",
            shouldShowSpinner: false
        });
    const $0cb28d0cbf2b2b29$export$bf8ccc758901febd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1Pyrp")).globalIncomingCallRoute), ()=>({
            component: $0cb28d0cbf2b2b29$export$742ca8be503e0313,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("5eKhc")).listResources)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, (0, parcelRequire("iTMlN")).AsyncHorizontalOperationsConfigurationNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("iTMlN")).LazyHorizontalOperationsConfigurationNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("ldWCQ")).LazyIncomingCall)
            ]
        }));
    const $0cb28d0cbf2b2b29$export$39f40714591c98c0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1Pyrp")).globalIncomingCallDetailRoute), ()=>({
            component: $0cb28d0cbf2b2b29$export$6ec51edee1972588,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("5eKhc")).detailResources)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("ldWCQ")).LazyIncomingCall)
            ]
        }));
    const $0cb28d0cbf2b2b29$export$5d3c7bc3dee8745d = [
        $0cb28d0cbf2b2b29$export$bf8ccc758901febd,
        $0cb28d0cbf2b2b29$export$39f40714591c98c0
    ];
});
parcelRegister("5eKhc", function(module, exports) {
    $parcel$export(module.exports, "listResources", ()=>$d43cdb56aea819e2$export$c83d9fd41123ab31);
    $parcel$export(module.exports, "detailResources", ()=>$d43cdb56aea819e2$export$63630293105c0f4e);
    var $c8Fty;
    var $e8eGC;
    const $d43cdb56aea819e2$export$c83d9fd41123ab31 = [
        (0, (0, parcelRequire("e8eGC")).listResource)
    ];
    const $d43cdb56aea819e2$export$63630293105c0f4e = [
        (0, (0, parcelRequire("c8Fty")).detailResource)
    ];
});
parcelRegister("c8Fty", function(module, exports) {
    $parcel$export(module.exports, "detailResource", ()=>$4f75debae3dca716$export$13d78d45f8054f1e);
    var $dIdda = parcelRequire("dIdda");
    var $lUMYZ;
    var $2FAs6;
    var $cPQ9G;
    const $4f75debae3dca716$export$13d78d45f8054f1e = (0, $dIdda.createResource)({
        type: 'getDetailResource',
        getKey: ()=>'getDetailResource',
        getData: async (routerContext)=>{
            const id = routerContext.match.params?.id;
            (0, (0, parcelRequire("lUMYZ")).assert)(!!id, new (0, (0, parcelRequire("2FAs6")).AssertionError)('detailResource', 'id should be set to fetch incoming call detail'));
            return (0, (0, parcelRequire("cPQ9G")).getDetail)(id);
        },
        isBrowserOnly: true
    });
});
parcelRegister("cPQ9G", function(module, exports) {
    $parcel$export(module.exports, "getDetail", ()=>$d10bd02f0a42541b$export$d6c3faeb2ce9d297);
    var $6GHRr;
    var $jQfmv;
    const $d10bd02f0a42541b$export$d6c3faeb2ce9d297 = (id)=>{
        const endpoint = `${(0, (0, parcelRequire("jQfmv")).urls).incomingCall.detail.url(id)}`;
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(endpoint);
    };
});
parcelRegister("jQfmv", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$ec891d7b992d2e13$export$bcae9ba627f604b6);
    const $ec891d7b992d2e13$export$bcae9ba627f604b6 = Object.freeze({
        incomingCall: {
            url: ()=>`/v1/incoming-call`,
            detail: {
                url: (incomingCallId = ':incomingCallId')=>`${$ec891d7b992d2e13$export$bcae9ba627f604b6.incomingCall.url()}/${incomingCallId}`
            }
        }
    });
});
parcelRegister("e8eGC", function(module, exports) {
    $parcel$export(module.exports, "listResource", ()=>$bf76cf757139db70$export$5ee018e9baf9d633);
    var $khUH4;
    var $r5hJG;
    const $bf76cf757139db70$export$5ee018e9baf9d633 = (0, (0, parcelRequire("khUH4")).createPaginatedResource)({
        type: 'getListResource',
        getKey: ()=>'getListResource',
        getData: ()=>(0, (0, parcelRequire("r5hJG")).getList),
        isBrowserOnly: true
    });
});
parcelRegister("khUH4", function(module, exports) {
    $parcel$export(module.exports, "createPaginatedResource", ()=>$cc3b2cd4810a11c0$export$561b032e4d26d1e8);
    var $dIdda = parcelRequire("dIdda");
    const $cc3b2cd4810a11c0$export$561b032e4d26d1e8 = ({ getData: getData, getKey: getKey, ...arg })=>{
        return (0, $dIdda.createResource)({
            ...arg,
            getKey: (routerContext, customContext)=>{
                const { query: query } = routerContext;
                const page = query['page'] || '1';
                const key = `${getKey(routerContext, customContext)}#${page}`;
                return key;
            },
            getData: (routerContext, customContext)=>{
                const { query: query } = routerContext;
                const page = parseInt(query['page']) || 1;
                return getData(routerContext, customContext)({
                    page: page
                });
            }
        });
    };
});
parcelRegister("r5hJG", function(module, exports) {
    $parcel$export(module.exports, "getList", ()=>$f9b283c2ac279966$export$73fffd6dda5144e);
    $parcel$export(module.exports, "addIncomingCall", ()=>$f9b283c2ac279966$export$cdae09ff00c893b2);
    var $6GHRr;
    var $jQfmv;
    const $f9b283c2ac279966$export$73fffd6dda5144e = ({ page: page })=>{
        const limit = 20;
        const offset = (page - 1) * limit;
        const params = new URLSearchParams({
            offset: `${offset}`,
            limit: `${limit}`,
            sortBy: 'name',
            sort: 'asc'
        });
        const endpoint = `${(0, (0, parcelRequire("jQfmv")).urls).incomingCall.url()}?${params.toString()}`;
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(endpoint).then(({ data: data, count: count })=>{
            return {
                data: data,
                count: Math.ceil(count / limit)
            };
        });
    };
    const $f9b283c2ac279966$export$cdae09ff00c893b2 = (params)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("jQfmv")).urls).incomingCall.url(), {
            method: 'POST',
            body: params
        });
    };
});
parcelRegister("1Pyrp", function(module, exports) {
    $parcel$export(module.exports, "globalIncomingCallRoute", ()=>$0ecdac041b69c905$export$8dd2e8adca05d8a3);
    $parcel$export(module.exports, "globalIncomingCallDetailRoute", ()=>$0ecdac041b69c905$export$10f19333da6ac52c);
    var $65Ltd;
    const $0ecdac041b69c905$export$8dd2e8adca05d8a3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_INCOMING_CALL),
        path: '/jira/settings/products/ops/incoming-call',
        exact: true
    };
    const $0ecdac041b69c905$export$10f19333da6ac52c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_INCOMING_CALL_DETAIL),
        path: '/jira/settings/products/ops/incoming-call/:id',
        exact: true
    };
});
parcelRegister("ldWCQ", function(module, exports) {
    $parcel$export(module.exports, "LazyIncomingCall", ()=>$25997639b70bd430$export$d76e6607b7e88a7b);
    $parcel$export(module.exports, "LazyIncomingCallDetail", ()=>$25997639b70bd430$export$1c56f2b1fdd5d724);
    var $hPtZI;
    const $25997639b70bd430$export$d76e6607b7e88a7b = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("4DnHd")).then((module)=>module.IncomingCallPage), {
        moduleId: "./src/packages/eoc/incoming-call/src/index.tsx"
    });
    const $25997639b70bd430$export$1c56f2b1fdd5d724 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("4DnHd")).then((module)=>module.IncomingCallDetailPage), {
        moduleId: "./src/packages/eoc/incoming-call/src/index.tsx"
    });
});
parcelRegister("4DnHd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dXV8c")
    ]).then(()=>parcelRequire('8oycJ'));
});
parcelRegister("31eEZ", function(module, exports) {
    $parcel$export(module.exports, "eocIntegrationsRouteEntries", ()=>$6b3ff6d01c7ec3bb$export$de0b5a5b87cf45f3);
    var $5uXOq = parcelRequire("5uXOq");
    var $j0tDD;
    var $1FQsM;
    var $3vS1t;
    var $ffza4;
    var $lmyls;
    var $3Dk1Z;
    var $2Fj5v;
    var $iTMlN;
    var $fezpN;
    var $h3Ix2;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $bY3c8;
    var $5j7Th;
    var $fwS2L;
    const $6b3ff6d01c7ec3bb$export$434c3e2269913ac0 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, (0, parcelRequire("fwS2L")).LazyIntegrationAutomation),
            pageId: "async-jira-eoc-integration-automation",
            shouldShowSpinner: true
        });
    const $6b3ff6d01c7ec3bb$export$8bb99f196e0be5b6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, (0, parcelRequire("fwS2L")).LazyIntegrationDetail),
            pageId: "async-jira-eoc-integration-automation",
            shouldShowSpinner: true
        });
    const $6b3ff6d01c7ec3bb$export$5cb14595364f02c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, (0, parcelRequire("fwS2L")).LazyIntegrationCreate),
            pageId: "async-jira-eoc-integration-automation",
            shouldShowSpinner: true
        });
    const $6b3ff6d01c7ec3bb$export$955768269b79c203 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, (0, parcelRequire("fwS2L")).LazyIntegrationList),
            pageId: "async-jira-eoc-integration-automation",
            shouldShowSpinner: true
        });
    const $6b3ff6d01c7ec3bb$export$b545b4a4c4cee016 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: (0, (0, parcelRequire("fwS2L")).LazyIntegrationLog),
            pageId: "async-jira-eoc-integration-automation",
            shouldShowSpinner: true
        });
    const $6b3ff6d01c7ec3bb$export$ded9494f81dd2a4d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bY3c8")).teamIntegrationsRoute), ()=>({
            basePath: '/jira/ops/teams',
            component: $6b3ff6d01c7ec3bb$export$434c3e2269913ac0,
            layout: (0, (0, parcelRequire("h3Ix2")).opsTeamLayout),
            slot: null,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3vS1t")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("1FQsM")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("1FQsM")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, (0, parcelRequire("3Dk1Z")).default),
                horizontal: (0, (0, parcelRequire("fezpN")).AsyncHorizontalOperationsNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("fezpN")).LazyHorizontalOperationsNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("fwS2L")).LazyIntegrationAutomation),
                (0, (0, parcelRequire("3Dk1Z")).LazyTeamDashboardSidebar)
            ]
        }));
    const $6b3ff6d01c7ec3bb$export$52ee366e7b51f38d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bY3c8")).teamIntegrationListRoute), ()=>({
            basePath: '/jira/ops/teams',
            component: $6b3ff6d01c7ec3bb$export$434c3e2269913ac0,
            layout: (0, (0, parcelRequire("h3Ix2")).opsTeamLayout),
            slot: $6b3ff6d01c7ec3bb$export$955768269b79c203,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3vS1t")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("1FQsM")).resources).integrationListResource,
                (0, (0, parcelRequire("1FQsM")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, (0, parcelRequire("3Dk1Z")).default),
                horizontal: (0, (0, parcelRequire("fezpN")).AsyncHorizontalOperationsNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("fezpN")).LazyHorizontalOperationsNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("fwS2L")).LazyIntegrationAutomation),
                (0, (0, parcelRequire("3Dk1Z")).LazyTeamDashboardSidebar)
            ]
        }));
    const $6b3ff6d01c7ec3bb$export$83aea99d18750f08 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bY3c8")).teamIntegrationCreateRoute), ()=>({
            basePath: '/jira/ops/teams',
            component: $6b3ff6d01c7ec3bb$export$434c3e2269913ac0,
            layout: (0, (0, parcelRequire("h3Ix2")).opsTeamLayout),
            slot: $6b3ff6d01c7ec3bb$export$5cb14595364f02c,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3vS1t")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("1FQsM")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("1FQsM")).resources).integrationListResource,
                (0, (0, parcelRequire("1FQsM")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, (0, parcelRequire("3Dk1Z")).default),
                horizontal: (0, (0, parcelRequire("fezpN")).AsyncHorizontalOperationsNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("fezpN")).LazyHorizontalOperationsNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("fwS2L")).LazyIntegrationAutomation),
                (0, (0, parcelRequire("3Dk1Z")).LazyTeamDashboardSidebar)
            ]
        }));
    const $6b3ff6d01c7ec3bb$export$7e0b6b79953422c1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bY3c8")).teamIntegrationDetailRoute), ()=>({
            basePath: '/jira/ops/teams',
            component: $6b3ff6d01c7ec3bb$export$434c3e2269913ac0,
            layout: (0, (0, parcelRequire("h3Ix2")).opsTeamLayout),
            slot: $6b3ff6d01c7ec3bb$export$8bb99f196e0be5b6,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3vS1t")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("1FQsM")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("1FQsM")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, (0, parcelRequire("3Dk1Z")).default),
                horizontal: (0, (0, parcelRequire("fezpN")).AsyncHorizontalOperationsNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("fezpN")).LazyHorizontalOperationsNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("fwS2L")).LazyIntegrationAutomation),
                (0, (0, parcelRequire("3Dk1Z")).LazyTeamDashboardSidebar)
            ]
        }));
    const $6b3ff6d01c7ec3bb$export$d5e169223d2a5d1d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bY3c8")).teamIntegrationLogRoute), ()=>({
            basePath: '/jira/ops/teams',
            component: $6b3ff6d01c7ec3bb$export$434c3e2269913ac0,
            slot: $6b3ff6d01c7ec3bb$export$b545b4a4c4cee016,
            layout: (0, (0, parcelRequire("h3Ix2")).opsTeamLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3vS1t")).resources),
                ...(0, (0, parcelRequire("j0tDD")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("1FQsM")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("1FQsM")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, (0, parcelRequire("3Dk1Z")).default),
                horizontal: (0, (0, parcelRequire("fezpN")).AsyncHorizontalOperationsNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("fezpN")).LazyHorizontalOperationsNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("fwS2L")).LazyIntegrationAutomation),
                (0, (0, parcelRequire("3Dk1Z")).LazyTeamDashboardSidebar)
            ]
        }));
    const $6b3ff6d01c7ec3bb$export$6e5cd6656076550f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bY3c8")).globalIntegrationsRoute), ()=>({
            basePath: '/jira/settings/products/ops',
            component: $6b3ff6d01c7ec3bb$export$434c3e2269913ac0,
            slot: null,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("1FQsM")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("1FQsM")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, (0, parcelRequire("iTMlN")).AsyncHorizontalOperationsConfigurationNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("iTMlN")).LazyHorizontalOperationsConfigurationNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("fwS2L")).LazyIntegrationAutomation)
            ]
        }));
    const $6b3ff6d01c7ec3bb$export$790602da39f8af00 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bY3c8")).globalIntegrationListRoute), ()=>({
            basePath: '/jira/settings/products/ops',
            component: $6b3ff6d01c7ec3bb$export$434c3e2269913ac0,
            slot: $6b3ff6d01c7ec3bb$export$955768269b79c203,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("1FQsM")).resources).integrationListResource,
                (0, (0, parcelRequire("1FQsM")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, (0, parcelRequire("iTMlN")).AsyncHorizontalOperationsConfigurationNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("iTMlN")).LazyHorizontalOperationsConfigurationNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("fwS2L")).LazyIntegrationAutomation)
            ]
        }));
    const $6b3ff6d01c7ec3bb$export$62eef9a2917f041f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bY3c8")).globalIntegrationCreateRoute), ()=>({
            basePath: '/jira/settings/products/ops',
            component: $6b3ff6d01c7ec3bb$export$434c3e2269913ac0,
            slot: $6b3ff6d01c7ec3bb$export$5cb14595364f02c,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("1FQsM")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("1FQsM")).resources).integrationListResource,
                (0, (0, parcelRequire("1FQsM")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, (0, parcelRequire("iTMlN")).AsyncHorizontalOperationsConfigurationNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("iTMlN")).LazyHorizontalOperationsConfigurationNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("fwS2L")).LazyIntegrationAutomation)
            ]
        }));
    const $6b3ff6d01c7ec3bb$export$b66abbccbf93e9ad = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bY3c8")).globalIntegrationDetailRoute), ()=>({
            basePath: '/jira/settings/products/ops',
            component: $6b3ff6d01c7ec3bb$export$434c3e2269913ac0,
            slot: $6b3ff6d01c7ec3bb$export$8bb99f196e0be5b6,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("1FQsM")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("1FQsM")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, (0, parcelRequire("iTMlN")).AsyncHorizontalOperationsConfigurationNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("iTMlN")).LazyHorizontalOperationsConfigurationNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("fwS2L")).LazyIntegrationAutomation)
            ]
        }));
    const $6b3ff6d01c7ec3bb$export$d30f51d0f351bd8a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bY3c8")).globalIntegrationLogRoute), ()=>({
            basePath: '/jira/settings/products/ops',
            component: $6b3ff6d01c7ec3bb$export$434c3e2269913ac0,
            slot: $6b3ff6d01c7ec3bb$export$b545b4a4c4cee016,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("j0tDD")).resources),
                (0, (0, parcelRequire("1FQsM")).resources).configuredIntegrationsResource,
                (0, (0, parcelRequire("1FQsM")).resources).userAccessRightsResource
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, (0, parcelRequire("iTMlN")).AsyncHorizontalOperationsConfigurationNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("iTMlN")).LazyHorizontalOperationsConfigurationNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("fwS2L")).LazyIntegrationAutomation)
            ]
        }));
    const $6b3ff6d01c7ec3bb$export$de0b5a5b87cf45f3 = [
        $6b3ff6d01c7ec3bb$export$ded9494f81dd2a4d,
        $6b3ff6d01c7ec3bb$export$52ee366e7b51f38d,
        $6b3ff6d01c7ec3bb$export$83aea99d18750f08,
        $6b3ff6d01c7ec3bb$export$7e0b6b79953422c1,
        $6b3ff6d01c7ec3bb$export$d5e169223d2a5d1d,
        $6b3ff6d01c7ec3bb$export$6e5cd6656076550f,
        $6b3ff6d01c7ec3bb$export$790602da39f8af00,
        $6b3ff6d01c7ec3bb$export$62eef9a2917f041f,
        $6b3ff6d01c7ec3bb$export$b66abbccbf93e9ad,
        $6b3ff6d01c7ec3bb$export$d30f51d0f351bd8a
    ];
});
parcelRegister("j0tDD", function(module, exports) {
    $parcel$export(module.exports, "resources", ()=>$c413cbd4a1ade7e4$export$bc99aaabaf7b70a7);
    $parcel$export(module.exports, "downloadResources", ()=>$c413cbd4a1ade7e4$export$8571305c82629fe4);
    var $c4sFg;
    var $5Qv1w;
    var $3uaDM;
    var $a9MnA;
    var $jQsJs;
    const $c413cbd4a1ade7e4$export$bc99aaabaf7b70a7 = [
        (0, (0, parcelRequire("jQsJs")).uiSettingsResource),
        (0, (0, parcelRequire("a9MnA")).logsResource),
        (0, (0, parcelRequire("5Qv1w")).byokInformationResource),
        ...(0, (0, parcelRequire("c4sFg")).eocCommonResources)()
    ];
    const $c413cbd4a1ade7e4$export$8571305c82629fe4 = [
        (0, (0, parcelRequire("3uaDM")).downloadAuditLogsResource),
        ...(0, (0, parcelRequire("c4sFg")).eocCommonResources)()
    ];
});
parcelRegister("5Qv1w", function(module, exports) {
    $parcel$export(module.exports, "byokInformationResource", ()=>$edbdc09ef6acd0d8$export$c6b84cb74d1ed3b9);
    var $dIdda = parcelRequire("dIdda");
    var $hfyOq;
    const $edbdc09ef6acd0d8$export$c6b84cb74d1ed3b9 = (0, $dIdda.createResource)({
        type: 'byok-information-resource',
        getKey: ()=>'byok-information-resource',
        getData: async ()=>(0, (0, parcelRequire("hfyOq")).fetchByokInformation)(),
        maxAge: Infinity,
        isBrowserOnly: true
    });
});
parcelRegister("hfyOq", function(module, exports) {
    $parcel$export(module.exports, "fetchByokInformation", ()=>$38f61802ef951f2e$export$5244b5a582b643da);
    var $6GHRr;
    const $38f61802ef951f2e$export$5244b5a582b643da = async ()=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)('/v1/customers/byok-setting');
    };
});
parcelRegister("3uaDM", function(module, exports) {
    $parcel$export(module.exports, "downloadAuditLogsResource", ()=>$fbbcde41b541d2a5$export$304da75014b88b78);
    var $dIdda = parcelRequire("dIdda");
    var $lUMYZ;
    var $2FAs6;
    var $lp2XZ;
    const $fbbcde41b541d2a5$export$304da75014b88b78 = (0, $dIdda.createResource)({
        type: 'download-audit-logs-resource',
        getKey: ()=>'download-audit-logs-resource',
        getData: async (routerContext)=>{
            const uniqueKey = routerContext.match.params.exportUniqueKey;
            (0, (0, parcelRequire("lUMYZ")).assert)(!!uniqueKey, new (0, (0, parcelRequire("2FAs6")).AssertionError)('downloadAuditLogs resource', 'uniqueKey must be defined'));
            return (0, (0, parcelRequire("lp2XZ")).fetchDownloadLinkEndpoint)(uniqueKey);
        },
        maxAge: 0,
        isBrowserOnly: true
    });
});
parcelRegister("lp2XZ", function(module, exports) {
    $parcel$export(module.exports, "fetchDownloadLinkEndpoint", ()=>$168d2f3896ddb5bf$export$c8df7e5942ba1d96);
    var $6GHRr;
    const $168d2f3896ddb5bf$export$c8df7e5942ba1d96 = async (exportUniqueKey)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/logs/export/${exportUniqueKey}/download`, {
            responseType: 'text'
        });
    };
});
parcelRegister("a9MnA", function(module, exports) {
    $parcel$export(module.exports, "logsResource", ()=>$84658f0ece65a024$export$fd88b4310d3f52ff);
    var $dIdda = parcelRequire("dIdda");
    var $jcGhI;
    const $84658f0ece65a024$export$fd88b4310d3f52ff = (0, $dIdda.createResource)({
        type: 'ui-get-logs',
        getKey: (routerContext)=>{
            const integrationId = routerContext.match.params.integrationId;
            const urlParam = new URLSearchParams();
            Object.entries(routerContext.query).forEach(([key, value])=>{
                if (value) urlParam.set(key, value);
            });
            return !!integrationId ? `integration-${integrationId}-logs#${urlParam.toString()}` : `ui-get-logs#${urlParam.toString()}`;
        },
        getData: async (routerContext)=>{
            return (0, (0, parcelRequire("jcGhI")).fetchLogs)({
                fromUnit: routerContext.query?.fromUnit,
                fromValue: routerContext.query?.fromValue,
                startTimestamp: routerContext.query?.startTimestamp,
                endTimestamp: routerContext.query?.endTimestamp,
                eventCategories: routerContext.query?.eventCategories,
                levels: routerContext.query?.levels,
                size: routerContext.query?.size ?? 30,
                insertedAt: routerContext.query?.insertedAt,
                searchString: routerContext.query?.searchString,
                pageDirection: routerContext.query?.pageDirection ?? 'NEXT',
                integrationId: routerContext.match.params.integrationId
            });
        },
        maxAge: 60000,
        isBrowserOnly: true
    });
});
parcelRegister("jcGhI", function(module, exports) {
    $parcel$export(module.exports, "fetchLogs", ()=>$81e68d0f7a4cced5$export$b9fcc8145a518db4);
    var $6GHRr;
    var $6JWV4;
    const $81e68d0f7a4cced5$export$b9fcc8145a518db4 = async (params)=>{
        const urlParams = (0, (0, parcelRequire("6JWV4")).generateLogParams)(params);
        return (0, (0, parcelRequire("6GHRr")).eocFetch)('/v1/logs/search?' + urlParams.toString()).then((response)=>(0, (0, parcelRequire("6JWV4")).postProcessLogsSearch)(urlParams, response));
    };
});
parcelRegister("6JWV4", function(module, exports) {
    $parcel$export(module.exports, "isValidTimePeriodFormat", ()=>$6c3059b5790b0777$export$2214112898027187);
    $parcel$export(module.exports, "getBetweenErrorMessage", ()=>$6c3059b5790b0777$export$b29a6f1d6d345720);
    $parcel$export(module.exports, "isValidBetweenInput", ()=>$6c3059b5790b0777$export$7b619dd534dac336);
    $parcel$export(module.exports, "isInvalidDateValue", ()=>$6c3059b5790b0777$export$f18cd4bc58b99a27);
    $parcel$export(module.exports, "checkQueryIncludesValue", ()=>$6c3059b5790b0777$export$792d5c0a6d15a15e);
    $parcel$export(module.exports, "parseGroupOptionQuery", ()=>$6c3059b5790b0777$export$f344cca10df5ca13);
    $parcel$export(module.exports, "parseOptionQuery", ()=>$6c3059b5790b0777$export$100c2d7fc380fbfa);
    $parcel$export(module.exports, "collectQueryParamsFromOptions", ()=>$6c3059b5790b0777$export$4db9080fab1bce85);
    $parcel$export(module.exports, "calculateTimeBetween", ()=>$6c3059b5790b0777$export$42dac873831f0e2);
    $parcel$export(module.exports, "generateLogParams", ()=>$6c3059b5790b0777$export$85293a2f3995ddcc);
    $parcel$export(module.exports, "fromUnitConverter", ()=>$6c3059b5790b0777$export$ae02811946c03a4b);
    $parcel$export(module.exports, "createBaseQuery", ()=>$6c3059b5790b0777$export$9a8301702bf003c4);
    $parcel$export(module.exports, "calculateNewStartAndEndTimestamp", ()=>$6c3059b5790b0777$export$b06db0f8b326b929);
    $parcel$export(module.exports, "isDetailsSectionEmpty", ()=>$6c3059b5790b0777$export$74cb10c4b9924e49);
    $parcel$export(module.exports, "generateParamsForOneMonthInterval", ()=>$6c3059b5790b0777$export$130612b33e678a37);
    $parcel$export(module.exports, "calculateWidthAccordingToLevel", ()=>$6c3059b5790b0777$export$e083dc64e00e053b);
    $parcel$export(module.exports, "getSourceStringFromUrl", ()=>$6c3059b5790b0777$export$c6631e198cf7c0f4);
    $parcel$export(module.exports, "makeMarkup", ()=>$6c3059b5790b0777$export$59302306c6f78677);
    $parcel$export(module.exports, "postProcessLogsSearch", ()=>$6c3059b5790b0777$export$9a858fe3837c0be0);
    var $5uXOq = parcelRequire("5uXOq");
    var $grR0x;
    var $jj52j;
    var $jovBr;
    var $eZDAP;
    var $gn1v9;
    var $gccSB = parcelRequire("gccSB");
    var $hGgHi = parcelRequire("hGgHi");
    var $lUMYZ;
    var $2FAs6;
    var $9yChj;
    var $3kJ5a;
    var $6YSxp;
    var $8ftHD;
    const $6c3059b5790b0777$var$isNumeric = (value)=>/^\d+$/.test(value);
    const $6c3059b5790b0777$export$2214112898027187 = (timeDigits, timeUnit)=>{
        return timeDigits === '' || timeDigits !== undefined && $6c3059b5790b0777$var$isNumeric(timeDigits) && parseInt(timeDigits, 10) > -1 && (0, (0, parcelRequire("3kJ5a")).RANGE_OPTIONS).includes(timeUnit);
    };
    const $6c3059b5790b0777$export$b29a6f1d6d345720 = (intl, value)=>{
        if (!value?.startDate && !value?.endDate) return intl.formatMessage((0, (0, parcelRequire("8ftHD")).default).validationMessageAtLeastOneValue);
        if (value?.startDate && value?.endDate && new Date(value?.startDate) > new Date(value?.endDate)) return intl.formatMessage((0, (0, parcelRequire("8ftHD")).default).validationMessageBeforeGreaterThanAfter);
        if (value && (value?.startDate !== '' && !(0, (0, parcelRequire("jovBr")).default)(new Date(value?.startDate)) || value?.endDate !== '' && !(0, (0, parcelRequire("jovBr")).default)(new Date(value?.endDate)))) return intl.formatMessage((0, (0, parcelRequire("8ftHD")).default).validationMessageInvalidDateFormat);
        return undefined;
    };
    const $6c3059b5790b0777$export$7b619dd534dac336 = (value)=>{
        if (!value?.startDate && !value?.endDate) return false;
        if (value?.startDate && value?.endDate && new Date(value?.startDate) > new Date(value?.endDate)) return false;
        if (value && (value?.startDate !== '' && !(0, (0, parcelRequire("jovBr")).default)(new Date(value?.startDate)) || value?.endDate !== '' && !(0, (0, parcelRequire("jovBr")).default)(new Date(value?.endDate)))) return false;
        return true;
    };
    const $6c3059b5790b0777$export$f18cd4bc58b99a27 = (value)=>{
        return !(0, (0, parcelRequire("jovBr")).default)((0, (0, parcelRequire("eZDAP")).default)(value)) && value !== '';
    };
    const $6c3059b5790b0777$export$760bb1b75585fb94 = (value)=>{
        return value.map((event)=>event.value).join(',');
    };
    const $6c3059b5790b0777$export$792d5c0a6d15a15e = (query, value)=>{
        return query?.includes(value.toString()) ?? false;
    };
    const $6c3059b5790b0777$export$f344cca10df5ca13 = (query, options)=>{
        if (!query) return [];
        const labels = [];
        options.map((option)=>{
            option.options.map((item)=>labels.push(item));
        });
        return labels.filter(({ value: value })=>$6c3059b5790b0777$export$792d5c0a6d15a15e(query, value));
    };
    const $6c3059b5790b0777$export$100c2d7fc380fbfa = (query, options)=>{
        if (!query) return [];
        return options.filter((label)=>query.includes(label.value.toString()));
    };
    const $6c3059b5790b0777$export$422789958d8174dd = (unit)=>(0, (0, parcelRequire("3kJ5a")).RANGE_OPTIONS).includes(unit);
    const $6c3059b5790b0777$export$4db9080fab1bce85 = (options)=>{
        return options.map((option)=>option.value).join(',');
    };
    const $6c3059b5790b0777$var$isTimeQueryParamsValid = (params)=>{
        if (params.has('startTimestamp') && params.has('endTimestamp')) return true;
        else if (params.has('fromUnit') && params.has('fromValue')) return true;
        return false;
    };
    const $6c3059b5790b0777$export$42dac873831f0e2 = (params)=>{
        const now = new Date();
        if (!params.get('startTimestamp') && !params.get('endTimestamp') && params.get('fromUnit') && params.get('fromValue')) {
            const parsedFromValue = parseInt(params.get('fromValue') ?? '1');
            switch(params.get('fromUnit')){
                case 'HOUR':
                    params.set('endTimestamp', (now.getTime() * (0, (0, parcelRequire("6YSxp")).NANOSECONDS_IN_MILLISECOND)).toString());
                    params.set('startTimestamp', ((0, (0, parcelRequire("gn1v9")).default)(now, {
                        hours: parsedFromValue
                    }).getTime() * (0, (0, parcelRequire("6YSxp")).NANOSECONDS_IN_MILLISECOND)).toString());
                    break;
                case 'DAY':
                    params.set('endTimestamp', (now.getTime() * (0, (0, parcelRequire("6YSxp")).NANOSECONDS_IN_MILLISECOND)).toString());
                    params.set('startTimestamp', ((0, (0, parcelRequire("gn1v9")).default)(now, {
                        days: parsedFromValue
                    }).getTime() * (0, (0, parcelRequire("6YSxp")).NANOSECONDS_IN_MILLISECOND)).toString());
                    break;
                case 'WEEK':
                    params.set('endTimestamp', (now.getTime() * (0, (0, parcelRequire("6YSxp")).NANOSECONDS_IN_MILLISECOND)).toString());
                    params.set('startTimestamp', ((0, (0, parcelRequire("gn1v9")).default)(now, {
                        weeks: parsedFromValue
                    }).getTime() * (0, (0, parcelRequire("6YSxp")).NANOSECONDS_IN_MILLISECOND)).toString());
                    break;
                case 'MONTH':
                    params.set('endTimestamp', (now.getTime() * (0, (0, parcelRequire("6YSxp")).NANOSECONDS_IN_MILLISECOND)).toString());
                    params.set('startTimestamp', ((0, (0, parcelRequire("gn1v9")).default)(now, {
                        months: parsedFromValue
                    }).getTime() * (0, (0, parcelRequire("6YSxp")).NANOSECONDS_IN_MILLISECOND)).toString());
                    break;
            }
            params.delete('fromUnit');
            params.delete('fromValue');
        }
        return params;
    };
    const $6c3059b5790b0777$export$85293a2f3995ddcc = (params)=>{
        const urlParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value])=>{
            if (value) urlParams.append(key, decodeURI(value));
        });
        if (!$6c3059b5790b0777$var$isTimeQueryParamsValid(urlParams)) {
            urlParams.delete('fromUnit');
            urlParams.delete('fromValue');
            urlParams.delete('startTimestamp');
            urlParams.delete('endTimestamp');
            urlParams.append('fromUnit', 'DAY');
            urlParams.append('fromValue', '1');
        }
        return $6c3059b5790b0777$export$42dac873831f0e2(urlParams);
    };
    const $6c3059b5790b0777$var$calculateTimeDifference = (startDate, endDate)=>{
        const minutesDiff = (0, (0, parcelRequire("grR0x")).default)(endDate, startDate);
        if (minutesDiff < 60) return {
            hours: 1,
            days: 0,
            weeks: 0,
            months: 0,
            years: 0
        };
        const hoursDiff = minutesDiff / 60;
        const daysDiff = minutesDiff / 60 / 24;
        const weeksDiff = minutesDiff / 60 / 24 / 7;
        const monthsDiff = minutesDiff / 60 / 24 / 7 / 4;
        return {
            hours: hoursDiff > 0 ? Math.floor(hoursDiff) : 0,
            days: daysDiff > 0 ? Math.floor(daysDiff) : 0,
            weeks: weeksDiff > 0 ? Math.floor(weeksDiff) : 0,
            months: monthsDiff > 0 ? Math.floor(monthsDiff) : 0
        };
    };
    const $6c3059b5790b0777$export$ae02811946c03a4b = (startDate, endDate)=>{
        const parsedStartDate = (0, (0, parcelRequire("eZDAP")).default)(startDate);
        const parsedEndDate = (0, (0, parcelRequire("eZDAP")).default)(endDate);
        const timeDifference = $6c3059b5790b0777$var$calculateTimeDifference(parsedStartDate, parsedEndDate);
        if (timeDifference.months > 0) return {
            timeUnit: 'MONTH',
            timeDigits: timeDifference.months.toString()
        };
        else if (timeDifference.weeks > 0) return {
            timeUnit: 'WEEK',
            timeDigits: timeDifference.weeks.toString()
        };
        else if (timeDifference.days > 0) return {
            timeUnit: 'DAY',
            timeDigits: timeDifference.days.toString()
        };
        else return {
            timeUnit: 'HOUR',
            timeDigits: timeDifference.hours.toString()
        };
    };
    const $6c3059b5790b0777$export$9a8301702bf003c4 = (query)=>{
        let searchQuery = {};
        if (query.searchString) searchQuery = {
            ...searchQuery,
            searchString: query.searchString
        };
        if (query.startTimestamp && query.endTimestamp) searchQuery = {
            ...searchQuery,
            startTimestamp: query.startTimestamp,
            endTimestamp: query.endTimestamp
        };
        if (query.timeType) searchQuery = {
            ...searchQuery,
            timeType: query.timeType
        };
        if (query.eventCategories) searchQuery = {
            ...searchQuery,
            eventCategories: query.eventCategories
        };
        if (query.levels) searchQuery = {
            ...searchQuery,
            levels: query.levels
        };
        if (query.size) searchQuery = {
            ...searchQuery,
            size: query.size
        };
        return searchQuery;
    };
    function $6c3059b5790b0777$export$b06db0f8b326b929(startTimestamp, endTimestamp) {
        const startDateIntValue = parseInt(startTimestamp) / (0, (0, parcelRequire("6YSxp")).NANOSECONDS_IN_MILLISECOND);
        const endDateIntValue = parseInt(endTimestamp) / (0, (0, parcelRequire("6YSxp")).NANOSECONDS_IN_MILLISECOND);
        const { timeDigits: fromValue, timeUnit: fromUnit } = $6c3059b5790b0777$export$ae02811946c03a4b((0, (0, parcelRequire("jj52j")).default)(startDateIntValue), (0, (0, parcelRequire("jj52j")).default)(endDateIntValue));
        const params = $6c3059b5790b0777$export$42dac873831f0e2(new URLSearchParams({
            fromValue: fromValue,
            fromUnit: fromUnit
        }));
        const startTimestampParams = params.get('startTimestamp');
        const endTimestampParams = params.get('endTimestamp');
        (0, (0, parcelRequire("lUMYZ")).assert)(!(0, ($parcel$interopDefault($hGgHi)))(startTimestampParams) && !(0, ($parcel$interopDefault($hGgHi)))(endTimestampParams), new (0, (0, parcelRequire("2FAs6")).AssertionError)('calculateNewStartAndEndTimestamp', 'startTimestamp and endTimestamp should not be null'));
        return {
            startTimestamp: startTimestampParams,
            endTimestamp: endTimestampParams
        };
    }
    const $6c3059b5790b0777$export$74cb10c4b9924e49 = (importantField, raw, isImportantFieldEmpty)=>{
        if (!importantField || !raw) return true;
        const parsedImportantField = JSON.parse(importantField);
        const parsedRaw = JSON.parse(raw);
        return ((0, ($parcel$interopDefault($gccSB)))(parsedImportantField) || isImportantFieldEmpty === true) && (0, ($parcel$interopDefault($gccSB)))(parsedRaw);
    };
    const $6c3059b5790b0777$export$130612b33e678a37 = ()=>{
        const params = $6c3059b5790b0777$export$42dac873831f0e2(new URLSearchParams({
            fromUnit: 'MONTH',
            fromValue: '1'
        }));
        const startDate = params.get('startTimestamp');
        const endDate = params.get('endTimestamp');
        (0, (0, parcelRequire("lUMYZ")).assert)(!!startDate && !!endDate, new (0, (0, parcelRequire("2FAs6")).AssertionError)('generateParamsForOneMonthInterval', 'startTimestamp and endDate should not be null'));
        return {
            dateTimeValue: {
                startDate: startDate,
                endDate: endDate
            },
            timeType: (0, (0, parcelRequire("9yChj")).TimeRadioOptions).WITHIN_THE_LAST
        };
    };
    const $6c3059b5790b0777$export$e083dc64e00e053b = (level)=>{
        const BASE_OFFSET = 18;
        return `${(0, (0, parcelRequire("6YSxp")).DETAIL_ITEM_BASE_WIDTH) - level * BASE_OFFSET}px`;
    };
    const $6c3059b5790b0777$export$c6631e198cf7c0f4 = (search)=>{
        const splittedSearch = search.split(/source=/i);
        if (splittedSearch.length > 1) return decodeURIComponent(splittedSearch[1]);
        return '';
    };
    function $6c3059b5790b0777$export$59302306c6f78677(fragment, key) {
        const { nodeName: nodeName, nodeType: nodeType, childNodes: childNodes, textContent: textContent } = fragment;
        if (nodeType === Node.TEXT_NODE) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: key
        }, textContent);
        const children = [];
        childNodes.forEach((childNode, i)=>{
            const markup = $6c3059b5790b0777$export$59302306c6f78677(childNode, String(i));
            if (markup) children.push(markup);
        });
        switch(nodeName){
            case 'B':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("b", {
                    key: key
                }, children);
            case 'I':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("i", {
                    key: key
                }, children);
            case 'STRONG':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("strong", {
                    key: key
                }, children);
            case 'EM':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("em", {
                    key: key
                }, children);
            case 'CODE':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("code", {
                    key: key
                }, children);
        }
        if (children.length === 1) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: key
        }, children[0]);
        if (children.length) return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            key: key
        }, children);
        return null;
    }
    const $6c3059b5790b0777$export$9a858fe3837c0be0 = (urlParams, response)=>{
        if (urlParams.get('startTimestamp') && urlParams.get('endTimestamp')) return {
            ...response,
            data: {
                ...response.data,
                pagination: {
                    ...response.data.pagination,
                    calcStartDate: urlParams.get('startTimestamp'),
                    calcEndDate: urlParams.get('endTimestamp')
                }
            }
        };
        return response;
    };
});
parcelRegister("9yChj", function(module, exports) {
    $parcel$export(module.exports, "TimeRadioOptions", ()=>$4a8ccb113abb393a$export$ff1338756af30600);
    var $4a8ccb113abb393a$export$ff1338756af30600;
    (function(TimeRadioOptions) {
        TimeRadioOptions["WITHIN_THE_LAST"] = "withinTheLast";
        TimeRadioOptions["BETWEEN"] = "between";
    })($4a8ccb113abb393a$export$ff1338756af30600 || ($4a8ccb113abb393a$export$ff1338756af30600 = {}));
});
parcelRegister("3kJ5a", function(module, exports) {
    $parcel$export(module.exports, "RANGE_OPTIONS", ()=>$7d1bba6b022014a7$export$a0f3448347834e6b);
    const $7d1bba6b022014a7$export$a0f3448347834e6b = [
        'HOUR',
        'DAY',
        'WEEK',
        'MONTH'
    ];
});
parcelRegister("6YSxp", function(module, exports) {
    $parcel$export(module.exports, "PAGE_SIZE_QUERY_PARAM", ()=>$bf45fa2d846624a3$export$4b254bc84a71033a);
    $parcel$export(module.exports, "NANOSECONDS_IN_MILLISECOND", ()=>$bf45fa2d846624a3$export$753f41e31eccb6d7);
    $parcel$export(module.exports, "getHeaderWidths", ()=>$bf45fa2d846624a3$export$8aa6dbdb947f7df1);
    $parcel$export(module.exports, "DETAIL_ITEM_BASE_WIDTH", ()=>$bf45fa2d846624a3$export$1220f90483bde21);
    var $294ns;
    const $bf45fa2d846624a3$export$4b254bc84a71033a = 'size';
    const $bf45fa2d846624a3$export$753f41e31eccb6d7 = 1000000;
    const $bf45fa2d846624a3$export$8aa6dbdb947f7df1 = (params)=>{
        const { DATE_HEADER_WIDTH: DATE_HEADER_WIDTH, CATEGORY_HEADER_WIDTH: CATEGORY_HEADER_WIDTH, TYPE_HEADER_WIDTH: TYPE_HEADER_WIDTH, ACTOR_HEADER_WIDTH: ACTOR_HEADER_WIDTH } = params.showEventCategoryField ? {
            DATE_HEADER_WIDTH: 16,
            CATEGORY_HEADER_WIDTH: 16,
            TYPE_HEADER_WIDTH: 10,
            ACTOR_HEADER_WIDTH: 16
        } : {
            DATE_HEADER_WIDTH: 14,
            CATEGORY_HEADER_WIDTH: 0,
            TYPE_HEADER_WIDTH: 12,
            ACTOR_HEADER_WIDTH: 22
        };
        const columnsToShow = [
            DATE_HEADER_WIDTH,
            CATEGORY_HEADER_WIDTH,
            TYPE_HEADER_WIDTH,
            ...(0, (0, parcelRequire("294ns")).getBooleanFF)('platform.pun.audit-logs-actor-column_sxmw6') ? [
                ACTOR_HEADER_WIDTH
            ] : []
        ];
        let sum = 0;
        columnsToShow.forEach((width)=>{
            sum += width;
        });
        return {
            DATE_HEADER_WIDTH: `${DATE_HEADER_WIDTH}%`,
            CATEGORY_HEADER_WIDTH: `${CATEGORY_HEADER_WIDTH}%`,
            TYPE_HEADER_WIDTH: `${TYPE_HEADER_WIDTH}%`,
            ACTOR_HEADER_WIDTH: `${ACTOR_HEADER_WIDTH}%`,
            CHANGE_SUMMARY_HEADER_WIDTH: `${100 - sum}%`
        };
    };
    const $bf45fa2d846624a3$export$1220f90483bde21 = 250;
});
parcelRegister("8ftHD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$89f75301a929fba9$export$2e2bcd8739ae039);
    var $7VHMR;
    const $89f75301a929fba9$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        validationMessageBeforeGreaterThanAfter: {
            id: `eoc.customer-logs.common.utils.validation-message-before-greater-than-after.no-translate`,
            defaultMessage: 'Specify a valid time range.',
            description: 'Message displayed to the user when the Before date used is greater than the after date while specifying dates'
        },
        validationMessageInvalidDateFormat: {
            id: `eoc.customer-logs.common.utils.validation-message-invalid-date-format.no-translate`,
            defaultMessage: 'Invalid date format.',
            description: 'Invalid date format.'
        },
        validationMessageAtLeastOneValue: {
            id: `eoc.customer-logs.common.utils.validation-message-at-least-one-value.no-translate`,
            defaultMessage: 'Select at least one value.',
            description: 'Message displayed to the user when there is no selected before and end date together'
        }
    });
    var $89f75301a929fba9$export$2e2bcd8739ae039 = $89f75301a929fba9$var$messages;
});
parcelRegister("jQsJs", function(module, exports) {
    $parcel$export(module.exports, "uiSettingsResource", ()=>$7a802f7e484b5089$export$f2b33518cf31cd40);
    var $dIdda = parcelRequire("dIdda");
    var $eoIyz;
    const $7a802f7e484b5089$export$f2b33518cf31cd40 = (0, $dIdda.createResource)({
        type: 'ui-settings-resource',
        getKey: ()=>'ui-settings-resource',
        getData: async ()=>(0, (0, parcelRequire("eoIyz")).fetchUiSettingsEndpoint)(),
        maxAge: Infinity,
        isBrowserOnly: true
    });
});
parcelRegister("eoIyz", function(module, exports) {
    $parcel$export(module.exports, "fetchUiSettingsEndpoint", ()=>$1113260c8c212499$export$ea2f12bcbdce2020);
    var $6GHRr;
    const $1113260c8c212499$export$ea2f12bcbdce2020 = async ()=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)('/v1/logs');
    };
});
parcelRegister("1FQsM", function(module, exports) {
    $parcel$export(module.exports, "resources", ()=>$7ef91db4c8a485ad$export$bc99aaabaf7b70a7);
    var $7cyVq;
    var $fllxb;
    var $4V10u;
    const $7ef91db4c8a485ad$export$bc99aaabaf7b70a7 = {
        configuredIntegrationsResource: (0, parcelRequire("7cyVq")).configuredIntegrationsResource,
        integrationListResource: (0, parcelRequire("fllxb")).integrationListResource,
        userAccessRightsResource: (0, parcelRequire("4V10u")).userAccessRightsResource
    };
});
parcelRegister("7cyVq", function(module, exports) {
    $parcel$export(module.exports, "configuredIntegrationsResource", ()=>$6e69b20ce7be78ba$export$4136019b80be5917);
    var $dIdda = parcelRequire("dIdda");
    var $6Fn2T;
    var $bgY87;
    const $6e69b20ce7be78ba$export$4136019b80be5917 = (0, $dIdda.createResource)({
        type: 'configuredIntegrationsResource',
        getKey: ({ query: query, match: match })=>{
            const teamId = match.params.teamId ?? query['teamId'];
            const group = query['group'];
            const keyword = query['keyword'];
            const status = query['status'];
            const page = query['page'] || '1';
            return (0, (0, parcelRequire("6Fn2T")).UrlHelper)((0, $1baabb3d5e6d5677$export$bc7daa294a7c75e4), {
                [(0, $1baabb3d5e6d5677$export$d26137cf824a9e53)]: page,
                [(0, $1baabb3d5e6d5677$export$299579ccbdd63cbc)]: keyword,
                [(0, $1baabb3d5e6d5677$export$d7415cfdee4bffc8)]: group,
                [(0, $1baabb3d5e6d5677$export$ce2c93e90dda8613)]: status,
                [(0, $1baabb3d5e6d5677$export$4e0ddb4dc97eb573)]: teamId
            });
        },
        getData: (routerContext)=>(0, (0, parcelRequire("bgY87")).default).getIntegrations(routerContext.query, routerContext.match.params.teamId),
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("6Fn2T", function(module, exports) {
    $parcel$export(module.exports, "UrlHelper", ()=>$96e9d2c66de0c25b$export$bacbc496e850c0a4);
    const $96e9d2c66de0c25b$export$bacbc496e850c0a4 = (path, params = {})=>{
        const q = Object.entries(params).map(([k, v])=>v !== '' && !!v || v === false ? [
                k,
                v.toString()
            ] : undefined).filter((v)=>!!v);
        const qs = new URLSearchParams(q).toString().replace(/%2C/g, ',');
        return `${path}${qs ? `?${qs}` : ''}`;
    };
});
parcelRegister("bgY87", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5ade864a167393cc$export$2e2bcd8739ae039);
    var $6GHRr;
    var $6Fn2T;
    const $5ade864a167393cc$var$getIntegrations = async (query, pathParamTeamId)=>{
        const page = parseInt(query['page']) || 1;
        const offset = (page - 1) * (0, $3f8aadfc309abf53$export$31ecae7225aecec6);
        const queryParams = query ? {
            teamId: pathParamTeamId ?? query.teamId,
            group: query.group,
            keyword: query.keyword,
            status: query.status
        } : {};
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("6Fn2T")).UrlHelper)('/v3/integrations/unified', {
            ...queryParams,
            offset: offset.toString(),
            limit: (0, $3f8aadfc309abf53$export$31ecae7225aecec6)
        })).then((response)=>({
                data: response.data.integrations,
                pageCount: Math.ceil(response.data.count / (0, $3f8aadfc309abf53$export$31ecae7225aecec6)),
                itemCount: response.data.count,
                platformTeamId: response.data.platformTeamId
            }));
    };
    const $5ade864a167393cc$var$patchIntegration = async (integrationId, integrationType, body, teamId)=>(0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("6Fn2T")).UrlHelper)(`/v3/integrations/unified/${integrationId}`, {
            type: integrationType,
            teamId: teamId
        }), {
            method: 'PATCH',
            body: body
        }).then((response)=>response.data);
    const $5ade864a167393cc$var$deleteIntegration = async (integrationId, integrationType, teamId)=>(0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("6Fn2T")).UrlHelper)(`/v3/integrations/unified/${integrationId}`, {
            type: integrationType,
            teamId: teamId
        }), {
            method: 'DELETE',
            responseType: 'headers'
        });
    var $5ade864a167393cc$export$2e2bcd8739ae039 = {
        getIntegrations: $5ade864a167393cc$var$getIntegrations,
        patchIntegration: $5ade864a167393cc$var$patchIntegration,
        deleteIntegration: $5ade864a167393cc$var$deleteIntegration
    };
});
const $3f8aadfc309abf53$export$31ecae7225aecec6 = 20;
const $1baabb3d5e6d5677$export$bc7daa294a7c75e4 = 'configuredIntegrationsResource';
const $1baabb3d5e6d5677$export$d26137cf824a9e53 = 'page';
const $1baabb3d5e6d5677$export$299579ccbdd63cbc = 'keyword';
const $1baabb3d5e6d5677$export$d7415cfdee4bffc8 = 'group';
const $1baabb3d5e6d5677$export$ce2c93e90dda8613 = 'status';
const $1baabb3d5e6d5677$export$4e0ddb4dc97eb573 = 'teamId';
parcelRegister("fllxb", function(module, exports) {
    $parcel$export(module.exports, "integrationListResource", ()=>$06aa0551d181baad$export$f60a40a11a6e0ee4);
    var $dIdda = parcelRequire("dIdda");
    var $lkhdL;
    const $06aa0551d181baad$export$f60a40a11a6e0ee4 = (0, $dIdda.createResource)({
        type: 'integrationListResource',
        getKey: ({ query: query })=>{
            const group = query['group'];
            const keyword = query['keyword'];
            return `integrationListResource?group=${group}&keyword=${keyword}`;
        },
        getData: async (routerContext)=>await (0, (0, parcelRequire("lkhdL")).default).getIntegrationList(routerContext.query, routerContext.match.params.teamId),
        maxAge: 300000,
        isBrowserOnly: true
    });
});
parcelRegister("lkhdL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3f17668e81a5169f$export$2e2bcd8739ae039);
    var $6GHRr;
    var $6Fn2T;
    const $3f17668e81a5169f$var$getIntegrationList = (query, teamId)=>{
        const { keyword: keyword, group: group } = query ?? {};
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("6Fn2T")).UrlHelper)(`/v3/integrations/unified/supported-integrations`, {
            keyword: keyword,
            group: group,
            teamId: teamId
        })).then((response)=>{
            const { labels: labels, availableGroups: availableGroups, allTypes: allTypes, platformTeamId: platformTeamId } = response.data;
            return {
                labels: labels,
                availableGroups: availableGroups,
                allTypes: allTypes,
                platformTeamId: platformTeamId
            };
        });
    };
    const $3f17668e81a5169f$var$getIntegrationTypes = (integrationType, teamId)=>(0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("6Fn2T")).UrlHelper)(`/v3/integrations/unified/${integrationType}/types`, {
            teamId: teamId
        })).then((response)=>response.data.map((integrationType)=>({
                    ...integrationType,
                    value: integrationType.type,
                    label: integrationType.displayName
                })));
    var $3f17668e81a5169f$export$2e2bcd8739ae039 = {
        getIntegrationList: $3f17668e81a5169f$var$getIntegrationList,
        getIntegrationTypes: $3f17668e81a5169f$var$getIntegrationTypes
    };
});
parcelRegister("4V10u", function(module, exports) {
    $parcel$export(module.exports, "userAccessRightsResource", ()=>$297d824cbf9fc4aa$export$69ddc7cc64ae9a02);
    var $dIdda = parcelRequire("dIdda");
    var $aMr9Y;
    const $297d824cbf9fc4aa$export$69ddc7cc64ae9a02 = (0, $dIdda.createResource)({
        type: 'userAccessRightsResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params.teamId;
            return `userAccessRightsResource#${!!teamId ? teamId : ''}`;
        },
        getData: (routerContext)=>(0, (0, parcelRequire("aMr9Y")).getUserRights)(routerContext.match.params.teamId),
        maxAge: 3600000,
        isBrowserOnly: true
    });
});
parcelRegister("aMr9Y", function(module, exports) {
    $parcel$export(module.exports, "getUserRights", ()=>$2f8086606aaa963b$export$84e2ed279bc4e64e);
    var $6GHRr;
    var $6Fn2T;
    const $2f8086606aaa963b$export$84e2ed279bc4e64e = (teamId)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("6Fn2T")).UrlHelper)(`/v3/integrations/unified/rights`, {
            teamId: teamId
        })).then((response)=>response.data);
    };
});
parcelRegister("bY3c8", function(module, exports) {
    $parcel$export(module.exports, "teamIntegrationsRoute", ()=>$71acb2a72131fd04$export$400ead354c81dee3);
    $parcel$export(module.exports, "teamIntegrationListRoute", ()=>$71acb2a72131fd04$export$b8218f375778e6d7);
    $parcel$export(module.exports, "teamIntegrationCreateRoute", ()=>$71acb2a72131fd04$export$a2ec7da6c43acbbf);
    $parcel$export(module.exports, "teamIntegrationDetailRoute", ()=>$71acb2a72131fd04$export$72169399df792b7c);
    $parcel$export(module.exports, "teamIntegrationLogRoute", ()=>$71acb2a72131fd04$export$ca02d7b2c7df3d60);
    $parcel$export(module.exports, "globalIntegrationsRoute", ()=>$71acb2a72131fd04$export$e196ff2390a1ec56);
    $parcel$export(module.exports, "globalIntegrationListRoute", ()=>$71acb2a72131fd04$export$270e16f240db883b);
    $parcel$export(module.exports, "globalIntegrationCreateRoute", ()=>$71acb2a72131fd04$export$bb272d36e3c3b7c1);
    $parcel$export(module.exports, "globalIntegrationDetailRoute", ()=>$71acb2a72131fd04$export$f826f15073eda98);
    $parcel$export(module.exports, "globalIntegrationLogRoute", ()=>$71acb2a72131fd04$export$71884dc820e415fc);
    var $65Ltd;
    const $71acb2a72131fd04$export$400ead354c81dee3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATIONS),
        path: '/jira/ops/teams/:teamId/integrations',
        exact: true
    };
    const $71acb2a72131fd04$export$b8218f375778e6d7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_LIST),
        path: '/jira/ops/teams/:teamId/integrations/list',
        exact: true
    };
    const $71acb2a72131fd04$export$a2ec7da6c43acbbf = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_CREATE),
        path: '/jira/ops/teams/:teamId/integrations/create/:type',
        exact: true
    };
    const $71acb2a72131fd04$export$72169399df792b7c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_DETAIL),
        path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId',
        exact: true
    };
    const $71acb2a72131fd04$export$ca02d7b2c7df3d60 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_INTEGRATION_LOG),
        path: '/jira/ops/teams/:teamId/integrations/:type/:integrationId/logs',
        exact: true
    };
    const $71acb2a72131fd04$export$e196ff2390a1ec56 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_INTEGRATIONS),
        path: '/jira/settings/products/ops/integrations',
        exact: true
    };
    const $71acb2a72131fd04$export$270e16f240db883b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_INTEGRATION_LIST),
        path: '/jira/settings/products/ops/integrations/list',
        exact: true
    };
    const $71acb2a72131fd04$export$bb272d36e3c3b7c1 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_INTEGRATION_CREATE),
        path: '/jira/settings/products/ops/integrations/create/:type',
        exact: true
    };
    const $71acb2a72131fd04$export$f826f15073eda98 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_INTEGRATION_DETAIL),
        path: '/jira/settings/products/ops/integrations/:type/:integrationId',
        exact: true
    };
    const $71acb2a72131fd04$export$71884dc820e415fc = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_INTEGRATION_LOG),
        path: '/jira/settings/products/ops/integrations/:type/:integrationId/logs',
        exact: true
    };
});
parcelRegister("fwS2L", function(module, exports) {
    $parcel$export(module.exports, "LazyIntegrationAutomation", ()=>$3157621202ba1387$export$68c40afda0287b61);
    $parcel$export(module.exports, "LazyIntegrationDetail", ()=>$3157621202ba1387$export$fd7f60e3df94c902);
    $parcel$export(module.exports, "LazyIntegrationCreate", ()=>$3157621202ba1387$export$aa9358ade7cb53ee);
    $parcel$export(module.exports, "LazyIntegrationList", ()=>$3157621202ba1387$export$993132b847f26efa);
    $parcel$export(module.exports, "LazyIntegrationLog", ()=>$3157621202ba1387$export$b02ef932401d95fc);
    var $hPtZI;
    const $3157621202ba1387$export$68c40afda0287b61 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("hvjO3")).then((module)=>module.IntegrationAutomation), {
        moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
    });
    const $3157621202ba1387$export$fd7f60e3df94c902 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("hvjO3")).then((module)=>module.IntegrationDetail), {
        moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
    });
    const $3157621202ba1387$export$aa9358ade7cb53ee = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("hvjO3")).then((module)=>module.IntegrationCreate), {
        moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
    });
    const $3157621202ba1387$export$993132b847f26efa = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("hvjO3")).then((module)=>module.IntegrationList), {
        moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
    });
    const $3157621202ba1387$export$b02ef932401d95fc = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("hvjO3")).then((module)=>module.IntegrationLog), {
        moduleId: "./src/packages/eoc/integration-automation/src/index.tsx"
    });
});
parcelRegister("hvjO3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4EsQl")
    ]).then(()=>parcelRequire('5QWfc'));
});
parcelRegister("9rDnB", function(module, exports) {
    $parcel$export(module.exports, "eocMaintenanceRouteEntries", ()=>$7ad94afcb3b299a0$export$ed40a3967b4f2617);
    var $5uXOq = parcelRequire("5uXOq");
    var $7OwrB;
    var $3vS1t;
    var $ffza4;
    var $lmyls;
    var $3Dk1Z;
    var $2Fj5v;
    var $iTMlN;
    var $fezpN;
    var $h3Ix2;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $1thjM;
    var $5j7Th;
    var $hPtZI;
    const $7ad94afcb3b299a0$var$LazyMaintenance = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("auNeJ")), {
        moduleId: "./src/packages/eoc/maintenance/src/index.tsx"
    });
    const $7ad94afcb3b299a0$var$MaintenanceComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7ad94afcb3b299a0$var$LazyMaintenance,
            pageId: "async-jira-eoc-maintenance",
            shouldShowSpinner: false
        });
    const $7ad94afcb3b299a0$var$eocMaintenanceRouteEntry = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1thjM")).maintenanceRoute), ()=>({
            component: $7ad94afcb3b299a0$var$MaintenanceComponent,
            layout: (0, (0, parcelRequire("h3Ix2")).opsTeamLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("7OwrB")).resources),
                ...(0, (0, parcelRequire("3vS1t")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, (0, parcelRequire("3Dk1Z")).default),
                horizontal: (0, (0, parcelRequire("fezpN")).AsyncHorizontalOperationsNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("fezpN")).LazyHorizontalOperationsNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $7ad94afcb3b299a0$var$LazyMaintenance,
                (0, (0, parcelRequire("3Dk1Z")).LazyTeamDashboardSidebar)
            ]
        }));
    const $7ad94afcb3b299a0$var$eocGlobalMaintenanceRouteEntry = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1thjM")).globalMaintenanceRoute), ()=>({
            component: $7ad94afcb3b299a0$var$MaintenanceComponent,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("7OwrB")).resources)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, (0, parcelRequire("iTMlN")).AsyncHorizontalOperationsConfigurationNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("iTMlN")).LazyHorizontalOperationsConfigurationNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $7ad94afcb3b299a0$var$LazyMaintenance
            ]
        }));
    const $7ad94afcb3b299a0$export$ed40a3967b4f2617 = [
        $7ad94afcb3b299a0$var$eocMaintenanceRouteEntry,
        $7ad94afcb3b299a0$var$eocGlobalMaintenanceRouteEntry
    ];
});
parcelRegister("7OwrB", function(module, exports) {
    $parcel$export(module.exports, "maintenanceResource", ()=>$b67ad4ac529c8a79$export$5486c78261efb2c3);
    $parcel$export(module.exports, "maintenanceUserRightsResource", ()=>$b67ad4ac529c8a79$export$e4c92d8948e3625);
    $parcel$export(module.exports, "resources", ()=>$b67ad4ac529c8a79$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $c4sFg;
    var $f5udF;
    const $b67ad4ac529c8a79$export$5486c78261efb2c3 = (0, $dIdda.createResource)({
        type: 'maintenanceResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `maintenance/${teamId ?? ''}`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return (0, (0, parcelRequire("f5udF")).getMaintenance)(teamId);
        },
        isBrowserOnly: true
    });
    const $b67ad4ac529c8a79$export$e4c92d8948e3625 = (0, $dIdda.createResource)({
        type: 'maintenanceUserRightsResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `maintenance-user-rights/${teamId ?? ''}`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return (0, (0, parcelRequire("f5udF")).getMaintenanceUserRights)(teamId);
        },
        isBrowserOnly: true
    });
    const $b67ad4ac529c8a79$export$bc99aaabaf7b70a7 = [
        ...(0, (0, parcelRequire("c4sFg")).eocCommonResources)(),
        $b67ad4ac529c8a79$export$5486c78261efb2c3,
        $b67ad4ac529c8a79$export$e4c92d8948e3625
    ];
});
parcelRegister("f5udF", function(module, exports) {
    $parcel$export(module.exports, "getMaintenance", ()=>$797c8cbf9d57eb7b$export$9cc878e1852c5ee1);
    $parcel$export(module.exports, "deleteMaintenance", ()=>$797c8cbf9d57eb7b$export$f64242288df38e86);
    $parcel$export(module.exports, "cancelMaintenance", ()=>$797c8cbf9d57eb7b$export$2d4a5362bda1b3c1);
    $parcel$export(module.exports, "changeDateAndTime", ()=>$797c8cbf9d57eb7b$export$2162fcbd04e23a3d);
    $parcel$export(module.exports, "getMaintenanceUserRights", ()=>$797c8cbf9d57eb7b$export$60048f3b7e7bf9b9);
    $parcel$export(module.exports, "createMaintenance", ()=>$797c8cbf9d57eb7b$export$602dd976bd963418);
    $parcel$export(module.exports, "updateMaintenance", ()=>$797c8cbf9d57eb7b$export$fa55cd063e1b15c2);
    var $6GHRr;
    const $797c8cbf9d57eb7b$export$9cc878e1852c5ee1 = (teamId)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances`);
    };
    const $797c8cbf9d57eb7b$export$f64242288df38e86 = (teamId, id)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}`, {
            method: 'DELETE',
            responseType: 'headers'
        });
    };
    const $797c8cbf9d57eb7b$export$2d4a5362bda1b3c1 = (teamId, id)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/cancel`, {
            method: 'PATCH'
        });
    };
    const $797c8cbf9d57eb7b$export$2162fcbd04e23a3d = (teamId, id, endDate)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/${id}/updateEndDate`, {
            method: 'PATCH',
            body: {
                endDate: endDate
            }
        });
    };
    const $797c8cbf9d57eb7b$export$60048f3b7e7bf9b9 = (teamId)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/${teamId ? `teams/${teamId}/` : ''}maintenances/rights`);
    };
    const $797c8cbf9d57eb7b$export$602dd976bd963418 = (payload, teamId)=>{
        const url = teamId ? `/v1/teams/${teamId}/maintenances` : '/v1/maintenances';
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(url, {
            method: 'POST',
            body: payload
        });
    };
    const $797c8cbf9d57eb7b$export$fa55cd063e1b15c2 = (payload, id, teamId)=>{
        const url = teamId ? `/v1/teams/${teamId}/maintenances/${id}` : `/v1/maintenances/${id}`;
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(url, {
            method: 'PUT',
            body: payload
        });
    };
});
parcelRegister("1thjM", function(module, exports) {
    $parcel$export(module.exports, "maintenanceRoute", ()=>$b5650c0e42d18fd9$export$b997369a5c2dab54);
    $parcel$export(module.exports, "globalMaintenanceRoute", ()=>$b5650c0e42d18fd9$export$9d65c6548c3b50e4);
    var $65Ltd;
    const $b5650c0e42d18fd9$export$b997369a5c2dab54 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_MAINTENANCE),
        path: '/jira/ops/teams/:teamId/maintenance',
        exact: true
    };
    const $b5650c0e42d18fd9$export$9d65c6548c3b50e4 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_MAINTENANCE),
        path: '/jira/settings/products/ops/maintenance',
        exact: true
    };
});
parcelRegister("auNeJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("9feTp")
    ]).then(()=>parcelRequire('iqyJK'));
});
parcelRegister("f4NWX", function(module, exports) {
    $parcel$export(module.exports, "eocOnCallRouteEntry", ()=>$cc7a94948fc6ee4a$export$ac245212b12db871);
    $parcel$export(module.exports, "eocOnCall1RouteEntry", ()=>$cc7a94948fc6ee4a$export$8657ca08ca5cbfc6);
    var $3xYTN;
    var $3vS1t;
    var $ffza4;
    var $lmyls;
    var $3Dk1Z;
    var $fezpN;
    var $h3Ix2;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $k2SBW;
    var $fLXNK;
    const $cc7a94948fc6ee4a$export$ac245212b12db871 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("k2SBW")).routeNamesEocOnCallRedirectRoute), ()=>({
            component: (0, (0, parcelRequire("fLXNK")).OnCallRedirect),
            layout: (0, (0, parcelRequire("h3Ix2")).opsTeamLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3vS1t")).resources)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, (0, parcelRequire("3Dk1Z")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("3Dk1Z")).LazyTeamDashboardSidebar)
            ],
            isRedirect: true
        }));
    const $cc7a94948fc6ee4a$export$8657ca08ca5cbfc6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("k2SBW")).eocOnCallRoute), ()=>({
            component: (0, (0, parcelRequire("fLXNK")).default),
            layout: (0, (0, parcelRequire("h3Ix2")).opsTeamLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3vS1t")).resources),
                ...(0, (0, parcelRequire("3xYTN")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, (0, parcelRequire("3Dk1Z")).default),
                horizontal: (0, (0, parcelRequire("fezpN")).AsyncHorizontalOperationsNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("fezpN")).LazyHorizontalOperationsNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("fLXNK")).LazyOnCall),
                (0, (0, parcelRequire("3Dk1Z")).LazyTeamDashboardSidebar)
            ]
        }));
});
parcelRegister("3xYTN", function(module, exports) {
    $parcel$export(module.exports, "getTeamResource", ()=>$2f61a5c23dc01a22$export$50271c9e7f21f10e);
    $parcel$export(module.exports, "resources", ()=>$2f61a5c23dc01a22$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $lUMYZ;
    var $2FAs6;
    var $4nrcX;
    var $5TZU2;
    var $6OdQx;
    const $2f61a5c23dc01a22$export$50271c9e7f21f10e = (0, $dIdda.createResource)({
        type: 'getTeamResource',
        getKey: ()=>'getTeamResource',
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("lUMYZ")).assert)(!!teamId, new (0, (0, parcelRequire("2FAs6")).AssertionError)('getTeamResource', 'teamId should be set to fetch on-call'));
            return (0, (0, parcelRequire("6OdQx")).getTeam)(teamId);
        },
        isBrowserOnly: true
    });
    const $2f61a5c23dc01a22$export$bc99aaabaf7b70a7 = [
        ...(0, (0, parcelRequire("5TZU2")).resources),
        (0, (0, parcelRequire("4nrcX")).routingRulesResource),
        $2f61a5c23dc01a22$export$50271c9e7f21f10e
    ];
});
parcelRegister("4nrcX", function(module, exports) {
    $parcel$export(module.exports, "routingRulesResource", ()=>$b818fcfd86478289$export$7f38c73dca88500e);
    var $dIdda = parcelRequire("dIdda");
    var $lUMYZ;
    var $2FAs6;
    var $4GqWZ;
    const $b818fcfd86478289$export$7f38c73dca88500e = (0, $dIdda.createResource)({
        type: 'routingRulesResource',
        getKey: ()=>'routingRulesResource',
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("lUMYZ")).assert)(!!teamId, new (0, (0, parcelRequire("2FAs6")).AssertionError)('routingRulesResource', 'teamId should be set to fetch routing-rules'));
            return (0, (0, parcelRequire("4GqWZ")).getRoutingRules)(teamId);
        },
        isBrowserOnly: true
    });
});
parcelRegister("4GqWZ", function(module, exports) {
    $parcel$export(module.exports, "getRoutingRules", ()=>$9d8e423ae8d82976$export$425c24c86196521);
    var $6GHRr;
    const $9d8e423ae8d82976$export$425c24c86196521 = (teamId)=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/teams/${teamId}/routing-rules`);
});
parcelRegister("5TZU2", function(module, exports) {
    $parcel$export(module.exports, "getSchedulesResource", ()=>$7c07457166e08439$export$6b2b3e2a53cc13e2);
    $parcel$export(module.exports, "getUiPreferencesResource", ()=>$7c07457166e08439$export$5c6454d866055bdd);
    $parcel$export(module.exports, "getScheduleRightsResource", ()=>$7c07457166e08439$export$9d9ecb8586783931);
    $parcel$export(module.exports, "getScheduleTimeTemplatesResource", ()=>$7c07457166e08439$export$90251855f07c54b4);
    $parcel$export(module.exports, "resources", ()=>$7c07457166e08439$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $c4sFg;
    var $fkBkZ;
    var $Uh1A5;
    var $laMNL;
    var $jvTVN;
    var $4nlLJ;
    var $kUHok;
    const $7c07457166e08439$export$6b2b3e2a53cc13e2 = (0, $dIdda.createResource)({
        type: 'getSchedulesResource',
        getKey: ()=>'getSchedulesResource',
        isBrowserOnly: true,
        getData: async (routerExtendedContext)=>(0, (0, parcelRequire("jvTVN")).endpoints).getScheduleList((0, (0, parcelRequire("Uh1A5")).getTeamIdFromContext)(routerExtendedContext))
    });
    const $7c07457166e08439$export$5c6454d866055bdd = (0, $dIdda.createResource)({
        type: 'getSchedulePreferencesResource',
        getKey: ()=>'getSchedulePreferencesResource',
        isBrowserOnly: true,
        getData: async (routerExtendedContext)=>(0, (0, parcelRequire("4nlLJ")).endpoints).getUiPreferences((0, (0, parcelRequire("Uh1A5")).getTeamIdFromContext)(routerExtendedContext))
    });
    const $7c07457166e08439$export$9d9ecb8586783931 = (0, $dIdda.createResource)({
        type: 'getScheduleRightsResource',
        getKey: ()=>'getScheduleRightsResource',
        isBrowserOnly: true,
        getData: async (routerExtendedContext)=>(0, (0, parcelRequire("kUHok")).endpoints).getScheduleRights((0, (0, parcelRequire("Uh1A5")).getTeamIdFromContext)(routerExtendedContext))
    });
    const $7c07457166e08439$export$90251855f07c54b4 = (0, $dIdda.createResource)({
        type: 'getScheduleTimeTemplatesResource',
        getKey: ()=>'getScheduleTimeTemplatesResourceurce',
        isBrowserOnly: true,
        getData: async ()=>(0, (0, parcelRequire("laMNL")).endpoints).getScheduleTimeTemplates()
    });
    const $7c07457166e08439$export$bc99aaabaf7b70a7 = [
        $7c07457166e08439$export$6b2b3e2a53cc13e2,
        $7c07457166e08439$export$5c6454d866055bdd,
        $7c07457166e08439$export$9d9ecb8586783931,
        $7c07457166e08439$export$90251855f07c54b4,
        ...(0, (0, parcelRequire("fkBkZ")).resources),
        ...(0, (0, parcelRequire("c4sFg")).eocCommonResources)()
    ];
});
parcelRegister("fkBkZ", function(module, exports) {
    $parcel$export(module.exports, "getTimezonesResource", ()=>$ce04f8f63207cc57$export$7524ea9fda8149c6);
    $parcel$export(module.exports, "resources", ()=>$ce04f8f63207cc57$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $9Yuwc;
    const $ce04f8f63207cc57$export$7524ea9fda8149c6 = (0, $dIdda.createResource)({
        type: 'getEocTimezonesResource',
        getKey: ()=>'getEocTimezonesResource',
        isBrowserOnly: true,
        getData: async ()=>(0, (0, parcelRequire("9Yuwc")).endpoints).getTimezones()
    });
    const $ce04f8f63207cc57$export$bc99aaabaf7b70a7 = [
        $ce04f8f63207cc57$export$7524ea9fda8149c6
    ];
});
parcelRegister("9Yuwc", function(module, exports) {
    $parcel$export(module.exports, "endpoints", ()=>$f5149ea3f470bcef$export$3a2536d80ecc00e7);
    var $6GHRr;
    var $3yMjH;
    const $f5149ea3f470bcef$var$getTimezones = async ()=>{
        const response = await (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("3yMjH")).urls).customers.timezones.url(), {
            method: 'GET'
        });
        const adjusted = response.timezones.map((timezone)=>({
                ...timezone,
                offset: timezone.offset * 60000,
                currentOffset: timezone.currentOffset * 60000
            }));
        return {
            ...response,
            timezones: adjusted
        };
    };
    const $f5149ea3f470bcef$var$getTimeTemplates = ()=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("3yMjH")).urls).schedules.timeTemplates.rotation.url(), {
            method: 'GET'
        });
    };
    const $f5149ea3f470bcef$export$3a2536d80ecc00e7 = {
        getTimezones: $f5149ea3f470bcef$var$getTimezones,
        getTimeTemplates: $f5149ea3f470bcef$var$getTimeTemplates
    };
});
parcelRegister("3yMjH", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$697ae6c7659d5528$export$bcae9ba627f604b6);
    const $697ae6c7659d5528$export$bcae9ba627f604b6 = Object.freeze({
        alerts: {
            responders: {
                names: {
                    url: ()=>'/v1/alerts/responders/names'
                },
                autoComplete: {
                    url: ()=>'/v1/alerts/responders/auto-complete'
                }
            }
        },
        schedules: {
            url: ()=>`/v1/schedules`,
            scheduleId: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}`,
                clone: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/clone`
                },
                name: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/name`
                },
                timezone: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/timezone`
                },
                enable: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/enable`
                },
                disable: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/disable`
                },
                webCalendarUrl: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/web-calendar-url`
                },
                timeline: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/timeline`
                },
                overrides: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/overrides`,
                    alias: {
                        url: ({ scheduleId: scheduleId, alias: alias } = {
                            scheduleId: ':scheduleId',
                            alias: ':alias'
                        })=>`/v1/schedules/${scheduleId}/overrides/${alias}`
                    },
                    bulk: {
                        url: ({ scheduleId: scheduleId } = {
                            scheduleId: ':scheduleId'
                        })=>`/v1/schedules/${scheduleId}/overrides/bulk`
                    }
                },
                rotations: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/rotations`,
                    rotationId: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}`,
                        order: {
                            url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                                scheduleId: ':scheduleId',
                                rotationId: ':rotationId'
                            })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/order`
                        },
                        name: {
                            url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                                scheduleId: ':scheduleId',
                                rotationId: ':rotationId'
                            })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/name`
                        }
                    }
                }
            },
            timeTemplates: {
                rotation: {
                    url: ()=>'/v1/schedules/time-templates/rotation'
                }
            }
        },
        customers: {
            timezones: {
                url: ()=>'/v1/customers/timezones'
            }
        }
    });
});
parcelRegister("Uh1A5", function(module, exports) {
    $parcel$export(module.exports, "getTeamIdFromContext", ()=>$64b2f4afb139c18d$export$3ea727bebc3792bb);
    var $lUMYZ;
    var $2FAs6;
    var $h8Lr1;
    const $64b2f4afb139c18d$export$3ea727bebc3792bb = (routerContext)=>{
        const teamId = (0, (0, parcelRequire("h8Lr1")).getSafe)(()=>routerContext.match.params.teamId, null);
        (0, (0, parcelRequire("lUMYZ")).assert)(!(0, (0, parcelRequire("h8Lr1")).isEmpty)(teamId), new (0, (0, parcelRequire("2FAs6")).AssertionError)('eoc-schedule', 'teamId in routerContext is not defined'));
        return teamId;
    };
});
parcelRegister("h8Lr1", function(module, exports) {
    $parcel$export(module.exports, "getSafe", ()=>$4d0721edbf0298c6$export$fedb900c0ea4e699);
    $parcel$export(module.exports, "isEmpty", ()=>$4d0721edbf0298c6$export$dd1bc94b04021eeb);
    $parcel$export(module.exports, "isNullOrUndefined", ()=>$4d0721edbf0298c6$export$bedb7023a7733221);
    $parcel$export(module.exports, "noLeadingOrTrailingSpaces", ()=>$4d0721edbf0298c6$export$5fc068d42db64a99);
    var $peH6Z;
    const $4d0721edbf0298c6$export$fedb900c0ea4e699 = (fn, defaultValue)=>{
        try {
            return fn();
        } catch  {
            return defaultValue;
        }
    };
    const $4d0721edbf0298c6$export$dd1bc94b04021eeb = (input)=>{
        if (input !== 0 && input !== false && !input) return true;
        if (!(input instanceof Date) && typeof input === 'object' && Object.keys(input).length === 0) return true;
        return false;
    };
    const $4d0721edbf0298c6$export$bedb7023a7733221 = (input)=>{
        return input === null || input === undefined;
    };
    const $4d0721edbf0298c6$export$5fc068d42db64a99 = (message)=>({ formatMessage: formatMessage })=>(value)=>{
                if (typeof value === 'string' && (value.startsWith(' ') || value.endsWith(' '))) return message ?? formatMessage((0, (0, parcelRequire("peH6Z")).messages).nameSpaceValidationError);
            };
});
parcelRegister("peH6Z", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$617a295a9400d540$export$defe85febe8b728c);
    var $7VHMR;
    const $617a295a9400d540$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noOne: {
            id: 'eoc-schedule.common.no-one',
            defaultMessage: 'No one',
            description: 'Name of the user whose type is no-one.'
        },
        error: {
            id: 'eoc-schedule.common.error',
            defaultMessage: 'Error',
            description: 'Just simple error message.'
        },
        tryAgain: {
            id: 'eoc-schedule.common.try-again',
            defaultMessage: 'Try again',
            description: 'Try again message when an error occurs.'
        },
        cancel: {
            id: 'eoc-schedule.common.cancel',
            defaultMessage: 'Cancel',
            description: 'A cancel button.'
        },
        confirm: {
            id: 'eoc-schedule.common.confirm',
            defaultMessage: 'Confirm',
            description: 'A confirm button.'
        },
        addOverride: {
            id: 'eoc-schedule.common.add-override',
            defaultMessage: 'Add override',
            description: 'Adding override for a period item.'
        },
        overrideButton: {
            id: 'eoc-schedule.common.override',
            defaultMessage: 'Override',
            description: 'A override button.'
        },
        saveButton: {
            id: 'eoc-schedule.common.save',
            defaultMessage: 'Save',
            description: 'A save button.'
        },
        edit: {
            id: 'eoc-schedule.common.edit',
            defaultMessage: 'Edit',
            description: 'Button for editing schedule.'
        },
        turnOff: {
            id: 'eoc-schedule.common.turn-off',
            defaultMessage: 'Turn off',
            description: 'Button for turn-offing schedule.'
        },
        turnOn: {
            id: 'eoc-schedule.common.turn-on',
            defaultMessage: 'Turn on',
            description: 'Button for turn-on schedule.'
        },
        delete: {
            id: 'eoc-schedule.common.delete',
            defaultMessage: 'Delete',
            description: 'Button for deleting schedule or rotation.'
        },
        duplicate: {
            id: 'eoc-schedule.common.duplicate',
            defaultMessage: 'Duplicate',
            description: 'Button for duplicating schedule or rotation.'
        },
        remove: {
            id: 'eoc-schedule.common.remove',
            defaultMessage: 'Remove',
            description: 'Button for removing participant.'
        },
        start: {
            id: 'eoc-schedule.common.start',
            defaultMessage: 'Start',
            description: 'Label for start time and date.'
        },
        end: {
            id: 'eoc-schedule.common.end',
            defaultMessage: 'End',
            description: 'Label for end time and date.'
        },
        startTime: {
            id: 'eoc-schedule.common.start-time',
            defaultMessage: 'Start time',
            description: 'Label for start time and date.'
        },
        endTime: {
            id: 'eoc-schedule.common.end-time',
            defaultMessage: 'End time',
            description: 'Label for end time and date.'
        },
        startDate: {
            id: 'eoc-schedule.common.start-date',
            defaultMessage: 'Start date',
            description: 'Label for start time and date.'
        },
        endDate: {
            id: 'eoc-schedule.common.end-date',
            defaultMessage: 'End date',
            description: 'Label for end time and date.'
        },
        team: {
            id: 'eoc-schedule.common.team',
            defaultMessage: 'Team',
            description: 'Label that indicates responder is of type: Team'
        },
        escalation: {
            id: 'eoc-schedule.common.escalation',
            defaultMessage: 'Escalation',
            description: 'Label that indicates responder is of type: Escalation'
        },
        schedule: {
            id: 'eoc-schedule.common.schedule',
            defaultMessage: 'Schedule',
            description: 'Label that indicates responder is of type: Schedule'
        },
        selectionCount: {
            id: 'eoc-schedule.common.selection-count',
            defaultMessage: '{count} shifts selected',
            description: 'Indicates how many shifts are selected for override.'
        },
        quickOverrideTitle: {
            id: 'eoc-schedule.common.quick-override-title',
            defaultMessage: 'OVERRIDE',
            description: 'Title for quick override card.'
        },
        search: {
            id: 'eoc-schedule.common.search',
            defaultMessage: 'Search',
            description: 'Label of search icon that shown inside search participant field'
        },
        replaceWith: {
            id: 'eoc-schedule.common.replace-with',
            defaultMessage: 'Replace with',
            description: 'A button for opening popup for replacing a participant.'
        },
        participants: {
            id: 'eoc-schedule.common.participants',
            defaultMessage: 'Participants',
            description: 'Label for participants.'
        },
        addParticipants: {
            id: 'eoc-schedule.common.add-participants',
            defaultMessage: 'Add people, teams, and escalation policies',
            description: 'Placeholder text for auto complete field for participants (responders).'
        },
        select: {
            id: 'eoc-schedule.common.select',
            defaultMessage: 'Select',
            description: 'Label that indicates selecting.'
        },
        teamDeleted: {
            id: 'eoc-schedule.common.team-deleted',
            defaultMessage: 'Team deleted',
            description: 'Fallback responder name that suggest team is deleted.'
        },
        deletedSchedule: {
            id: 'eoc-schedule.common.deleted-schedule',
            defaultMessage: 'Deleted schedule',
            description: 'Fallback responder name that suggest schedule is deleted.'
        },
        deletedEscalation: {
            id: 'eoc-schedule.common.deleted-escalation',
            defaultMessage: 'Deleted escalation',
            description: 'Fallback responder name that suggest escalation is deleted.'
        },
        formerUser: {
            id: 'eoc-schedule.common.former-user',
            defaultMessage: 'Former user',
            description: 'Fallback responder name that suggest user is deactivated or deleted.'
        },
        discard: {
            id: 'eoc-schedule.common.discard',
            defaultMessage: 'Discard',
            description: 'Button for discarding.'
        },
        confirmProceed: {
            id: 'eoc-schedule.common.confirm-proceed',
            defaultMessage: 'Are you sure to proceed?',
            description: 'A confirmation for proceeding.'
        },
        required: {
            id: 'eoc-schedule.common.required',
            defaultMessage: 'This field is required.',
            description: 'A text that informs users that field should be filled.'
        },
        noSpaceAtEndOrStart: {
            id: 'eoc-schedule.common.no-space-at-end-or-start',
            defaultMessage: 'Field cannot contain spaces at start or end.',
            description: 'A text that informs users that field cannot start or end with spaces.'
        },
        maxLength: {
            id: 'eoc-schedule.common.max-length',
            defaultMessage: 'Field cannot be longer than {max} characters.',
            description: 'A text that informs users that field should be shorter than certain length.'
        },
        maxValue: {
            id: 'eoc-schedule.common.max-value',
            defaultMessage: 'Field should be less than {max}.',
            description: 'A text that informs users that field should be less than certain value.'
        },
        minValue: {
            id: 'eoc-schedule.common.min-value',
            defaultMessage: 'Enter digit 1 or more.',
            description: 'This sentence instructs the user to input a numeric value of at least 1 digit or greater.'
        },
        timePast: {
            id: 'eoc-schedule.common.time-past',
            defaultMessage: 'Time should be later than current time.',
            description: 'Validation error that indicates time values is in past.'
        },
        startLaterEnd: {
            id: 'eoc-schedule.common.start-later-end',
            defaultMessage: 'Start time should be earlier than the end time.',
            description: 'Validation error that indicates start time is later than the end time.'
        },
        endEarlierStart: {
            id: 'eoc-schedule.common.end-earlier-start',
            defaultMessage: 'End time should be later than the start time.',
            description: 'Validation error that indicates end time is earlier than the start time.'
        },
        startEndSame: {
            id: 'eoc-schedule.common.start-end-same',
            defaultMessage: 'Start and end time cannot be same.',
            description: 'Validation error that indicates start and end time should be different.'
        },
        thirtyMinuteInterval: {
            id: 'eoc-schedule.common.thirty-minute-intervals',
            defaultMessage: 'Time should be defined as 30 minute intervals.',
            description: 'Validation error that indicates time can be in 30 minutes intervals.'
        },
        nameSpaceValidationError: {
            id: 'eoc-schedule.common.name-space-validation-error',
            defaultMessage: 'The name cannot start or end with a space.',
            description: 'Error message for name validation when it starts or ends with a space'
        }
    });
});
parcelRegister("laMNL", function(module, exports) {
    $parcel$export(module.exports, "endpoints", ()=>$4c7da5693defee18$export$3a2536d80ecc00e7);
    var $6GHRr;
    var $dceR4;
    const $4c7da5693defee18$var$orderRotation = ({ scheduleId: scheduleId, after: after, rotationId: rotationId })=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("dceR4")).urls).schedules.scheduleId.rotations.rotationId.order.url({
            rotationId: rotationId,
            scheduleId: scheduleId
        }), {
            method: 'PATCH',
            body: {
                after: after
            }
        });
    };
    const $4c7da5693defee18$var$getRotation = ({ scheduleId: scheduleId, rotationId: rotationId })=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("dceR4")).urls).schedules.scheduleId.rotations.rotationId.url({
            scheduleId: scheduleId,
            rotationId: rotationId
        }), {
            method: 'GET'
        });
    };
    const $4c7da5693defee18$var$deleteRotation = ({ scheduleId: scheduleId, rotationId: rotationId })=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("dceR4")).urls).schedules.scheduleId.rotations.rotationId.url({
            scheduleId: scheduleId,
            rotationId: rotationId
        }), {
            method: 'DELETE'
        });
    };
    const $4c7da5693defee18$var$addRotation = ({ name: name, responders: responders, restrictions: restrictions, rotationType: rotationType, hasEndTime: hasEndTime, rotationPeriod: rotationPeriod, scheduleId: scheduleId, timeTemplateId: timeTemplateId, timingType: timingType, startTimeRaw: startTimeRaw, endTimeRaw: endTimeRaw })=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("dceR4")).urls).schedules.scheduleId.rotations.url({
            scheduleId: scheduleId
        }), {
            method: 'POST',
            body: {
                name: name,
                responders: responders,
                restrictions: restrictions,
                rotationType: rotationType,
                timeTemplateId: timeTemplateId,
                timingType: timingType,
                rotationPeriod: rotationPeriod,
                startTimeRaw: startTimeRaw,
                endTimeRaw: endTimeRaw,
                hasEndTime: hasEndTime
            }
        });
    };
    const $4c7da5693defee18$var$editRotation = ({ id: id, name: name, responders: responders, restrictions: restrictions, rotationType: rotationType, rotationPeriod: rotationPeriod, hasEndTime: hasEndTime, timingType: timingType, scheduleId: scheduleId, timeTemplateId: timeTemplateId, startTimeRaw: startTimeRaw, endTimeRaw: endTimeRaw })=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("dceR4")).urls).schedules.scheduleId.rotations.rotationId.url({
            scheduleId: scheduleId,
            rotationId: id
        }), {
            method: 'PUT',
            body: {
                id: id,
                name: name,
                responders: responders,
                restrictions: restrictions,
                rotationType: rotationType,
                rotationPeriod: rotationPeriod,
                timeTemplateId: timeTemplateId,
                timingType: timingType,
                startTimeRaw: startTimeRaw,
                endTimeRaw: endTimeRaw,
                hasEndTime: hasEndTime
            }
        });
    };
    const $4c7da5693defee18$var$getScheduleTimeTemplates = ()=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("dceR4")).urls).schedules.timeTemplates.rotation.url(), {
            method: 'GET'
        });
    };
    const $4c7da5693defee18$export$3a2536d80ecc00e7 = {
        deleteRotation: $4c7da5693defee18$var$deleteRotation,
        getRotation: $4c7da5693defee18$var$getRotation,
        orderRotation: $4c7da5693defee18$var$orderRotation,
        addRotation: $4c7da5693defee18$var$addRotation,
        editRotation: $4c7da5693defee18$var$editRotation,
        getScheduleTimeTemplates: $4c7da5693defee18$var$getScheduleTimeTemplates
    };
});
parcelRegister("dceR4", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$d93d3e44155bb3d6$export$bcae9ba627f604b6);
    const $d93d3e44155bb3d6$export$bcae9ba627f604b6 = Object.freeze({
        alerts: {
            responders: {
                names: {
                    url: ()=>'/v1/alerts/responders/names'
                },
                autoComplete: {
                    url: ()=>'/v1/alerts/responders/auto-complete'
                }
            }
        },
        schedules: {
            url: ()=>`/v1/schedules`,
            teams: {
                teamId: {
                    url: ({ teamId: teamId } = {
                        teamId: ':teamId'
                    })=>`/v1/schedules/teams/${teamId}`,
                    rights: {
                        url: ({ teamId: teamId } = {
                            teamId: ':teamId'
                        })=>`/v1/schedules/teams/${teamId}/rights`
                    }
                }
            },
            scheduleId: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`/v1/schedules/${scheduleId}`,
                clone: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/clone`
                },
                name: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/name`
                },
                timezone: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/timezone`
                },
                enable: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/enable`
                },
                disable: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/disable`
                },
                webCalendarUrl: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/web-calendar-url`
                },
                timeline: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/timeline`
                },
                overrides: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/overrides`,
                    alias: {
                        url: ({ scheduleId: scheduleId, alias: alias } = {
                            scheduleId: ':scheduleId',
                            alias: ':alias'
                        })=>`/v1/schedules/${scheduleId}/overrides/${alias}`
                    },
                    bulk: {
                        url: ({ scheduleId: scheduleId } = {
                            scheduleId: ':scheduleId'
                        })=>`/v1/schedules/${scheduleId}/overrides/bulk`
                    }
                },
                rotations: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`/v1/schedules/${scheduleId}/rotations`,
                    rotationId: {
                        url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                            scheduleId: ':scheduleId',
                            rotationId: ':rotationId'
                        })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}`,
                        order: {
                            url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                                scheduleId: ':scheduleId',
                                rotationId: ':rotationId'
                            })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/order`
                        },
                        name: {
                            url: ({ scheduleId: scheduleId, rotationId: rotationId } = {
                                scheduleId: ':scheduleId',
                                rotationId: ':rotationId'
                            })=>`/v1/schedules/${scheduleId}/rotations/${rotationId}/name`
                        }
                    }
                }
            },
            timeTemplates: {
                rotation: {
                    url: ()=>'/v1/schedules/time-templates/rotation'
                }
            }
        },
        customers: {
            timezones: {
                url: ()=>'/v1/customers/timezones'
            }
        },
        uiPreference: {
            schedule: {
                team: {
                    teamId: {
                        url: ({ teamId: teamId } = {
                            teamId: ':teamId'
                        })=>`/v1/users/ui-preference/schedule/team/${teamId}`
                    }
                }
            }
        },
        onboarding: {
            completeTask: {
                url: ()=>'/v1/onboarding/complete-task'
            }
        }
    });
});
parcelRegister("jvTVN", function(module, exports) {
    $parcel$export(module.exports, "endpoints", ()=>$17b9d652f70be5cd$export$3a2536d80ecc00e7);
    var $6GHRr;
    var $dceR4;
    const $17b9d652f70be5cd$var$getScheduleList = (teamId)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("dceR4")).urls).schedules.teams.teamId.url({
            teamId: teamId
        }));
    };
    const $17b9d652f70be5cd$var$updateSchedule = ({ scheduleId: scheduleId, description: description, name: name, enabled: enabled, timezone: timezone })=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("dceR4")).urls).schedules.scheduleId.url({
            scheduleId: scheduleId
        }), {
            method: 'PATCH',
            body: {
                description: description,
                name: name,
                enabled: enabled,
                timezone: timezone
            }
        });
    };
    const $17b9d652f70be5cd$var$deleteSchedule = ({ scheduleId: scheduleId })=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("dceR4")).urls).schedules.scheduleId.url({
            scheduleId: scheduleId
        }), {
            method: 'DELETE'
        });
    };
    const $17b9d652f70be5cd$export$3a2536d80ecc00e7 = {
        deleteSchedule: $17b9d652f70be5cd$var$deleteSchedule,
        getScheduleList: $17b9d652f70be5cd$var$getScheduleList,
        updateSchedule: $17b9d652f70be5cd$var$updateSchedule
    };
});
parcelRegister("4nlLJ", function(module, exports) {
    $parcel$export(module.exports, "endpoints", ()=>$7ea89e0b4a6df9a7$export$3a2536d80ecc00e7);
    var $6GHRr;
    var $dceR4;
    const $7ea89e0b4a6df9a7$var$getUiPreferences = (teamId)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("dceR4")).urls).uiPreference.schedule.team.teamId.url({
            teamId: teamId
        }));
    };
    const $7ea89e0b4a6df9a7$var$updateUiPreferences = ({ teamId: teamId, key: key, value: value })=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("dceR4")).urls).uiPreference.schedule.team.teamId.url({
            teamId: teamId
        }), {
            method: 'PATCH',
            body: {
                [key]: value
            }
        });
    };
    const $7ea89e0b4a6df9a7$export$3a2536d80ecc00e7 = {
        getUiPreferences: $7ea89e0b4a6df9a7$var$getUiPreferences,
        updateUiPreferences: $7ea89e0b4a6df9a7$var$updateUiPreferences
    };
});
parcelRegister("kUHok", function(module, exports) {
    $parcel$export(module.exports, "endpoints", ()=>$618ae75198becc44$export$3a2536d80ecc00e7);
    var $6GHRr;
    var $dceR4;
    const $618ae75198becc44$var$getScheduleRights = (teamId)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("dceR4")).urls).schedules.teams.teamId.rights.url({
            teamId: teamId
        }));
    };
    const $618ae75198becc44$var$createSchedule = ({ description: description, name: name, teamId: teamId, timezone: timezone })=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("dceR4")).urls).schedules.url(), {
            method: 'POST',
            body: {
                description: description,
                name: name,
                teamId: teamId,
                timezone: timezone,
                enabled: true
            }
        });
    };
    const $618ae75198becc44$var$cloneSchedule = ({ description: description, name: name, enabled: enabled, timezone: timezone, teamId: teamId, scheduleId: scheduleId })=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("dceR4")).urls).schedules.scheduleId.clone.url({
            scheduleId: scheduleId
        }), {
            method: 'POST',
            body: {
                description: description,
                name: name,
                enabled: enabled,
                timezone: timezone,
                teamId: teamId
            }
        });
    };
    const $618ae75198becc44$export$3a2536d80ecc00e7 = {
        createSchedule: $618ae75198becc44$var$createSchedule,
        getScheduleRights: $618ae75198becc44$var$getScheduleRights,
        cloneSchedule: $618ae75198becc44$var$cloneSchedule
    };
});
parcelRegister("6OdQx", function(module, exports) {
    $parcel$export(module.exports, "getTeam", ()=>$989d25ff8100620f$export$491fe77f22ab2b51);
    var $6GHRr;
    const $989d25ff8100620f$export$491fe77f22ab2b51 = (teamId)=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/alerts/responders/names`, {
            method: 'POST',
            body: {
                responders: [
                    {
                        id: teamId,
                        type: 'team'
                    }
                ]
            }
        });
});
parcelRegister("k2SBW", function(module, exports) {
    $parcel$export(module.exports, "routeNamesEocOnCallRedirectRoute", ()=>$5a3df92a84226c6a$export$18cec3860c46aaf2);
    $parcel$export(module.exports, "eocOnCallRoute", ()=>$5a3df92a84226c6a$export$5eaa466ae8a4d7d3);
    var $65Ltd;
    const $5a3df92a84226c6a$export$18cec3860c46aaf2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ON_CALL_REDIRECT),
        path: '/jira/ops/teams/:teamId',
        exact: true
    };
    const $5a3df92a84226c6a$export$5eaa466ae8a4d7d3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ON_CALL),
        path: '/jira/ops/teams/:teamId/on-call',
        exact: true
    };
});
parcelRegister("fLXNK", function(module, exports) {
    $parcel$export(module.exports, "OnCallRedirect", ()=>$da08681b2a2ed397$export$659b7ce11c160b32);
    $parcel$export(module.exports, "LazyOnCall", ()=>$da08681b2a2ed397$export$772095aa22362f73);
    $parcel$export(module.exports, "default", ()=>$da08681b2a2ed397$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    var $dIdda = parcelRequire("dIdda");
    const $da08681b2a2ed397$export$659b7ce11c160b32 = ()=>{
        const [routeContext] = (0, $dIdda.useRouter)();
        const redirectionUrl = `${routeContext.location.pathname}/on-call`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: redirectionUrl
        });
    };
    const $da08681b2a2ed397$export$772095aa22362f73 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("4uLc4")), {
        moduleId: "./src/packages/eoc/on-call/src/index.tsx"
    });
    var $da08681b2a2ed397$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $da08681b2a2ed397$export$772095aa22362f73,
            pageId: "async-jira-eoc-on-call",
            shouldShowSpinner: false
        });
});
parcelRegister("4uLc4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("b0ycI")
    ]).then(()=>parcelRequire('38rnw'));
});
parcelRegister("8MmQk", function(module, exports) {
    $parcel$export(module.exports, "eocOverviewRouteEntry", ()=>$0a523b5d7d04a7f3$export$f1a859c727c30be4);
    $parcel$export(module.exports, "eocOverviewAllTeamsRouteEntry", ()=>$0a523b5d7d04a7f3$export$842d7c81068bb64e);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $lmyls;
    var $fezpN;
    var $2G9Bk;
    var $5OcAv;
    var $bHhiy;
    var $3RJkv;
    var $jAUdg;
    var $5j7Th;
    var $hPtZI;
    const $0a523b5d7d04a7f3$var$LazyOverviewPage = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("9oNUK")).then((m)=>m.OverviewPage), {
        moduleId: "./src/packages/eoc/overview/src/ui/overview-page/index.tsx"
    });
    const $0a523b5d7d04a7f3$var$LazyOverviewAllTeamsPage = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("8tAz8")).then((m)=>m.AllTeamsPage), {
        moduleId: "./src/packages/eoc/overview/src/ui/all-teams-page/index.tsx"
    });
    const $0a523b5d7d04a7f3$var$EocOverviewComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0a523b5d7d04a7f3$var$LazyOverviewPage,
            pageId: "async-jira-eoc-overview",
            shouldShowSpinner: false
        });
    const $0a523b5d7d04a7f3$var$EocOverviewAllTeamsComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0a523b5d7d04a7f3$var$LazyOverviewAllTeamsPage,
            pageId: "async-jira-eoc-overview-all-teams",
            shouldShowSpinner: false
        });
    const $0a523b5d7d04a7f3$export$f1a859c727c30be4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jAUdg")).eocOverviewRoute), ()=>({
            component: $0a523b5d7d04a7f3$var$EocOverviewComponent,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("5OcAv")).getTeamsResource)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HOME,
                horizontal: (0, (0, parcelRequire("fezpN")).AsyncHorizontalOperationsOverviewNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("fezpN")).LazyHorizontalOperationsOverviewNav),
                $0a523b5d7d04a7f3$var$LazyOverviewPage
            ]
        }));
    const $0a523b5d7d04a7f3$export$842d7c81068bb64e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jAUdg")).eocOverviewAllTeamsRoute), ()=>({
            component: $0a523b5d7d04a7f3$var$EocOverviewAllTeamsComponent,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("5OcAv")).getTeamsResource)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HOME,
                horizontal: (0, (0, parcelRequire("fezpN")).AsyncHorizontalOperationsOverviewNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("fezpN")).LazyHorizontalOperationsOverviewNav),
                $0a523b5d7d04a7f3$var$LazyOverviewAllTeamsPage
            ]
        }));
});
parcelRegister("5OcAv", function(module, exports) {
    $parcel$export(module.exports, "getTeamsResource", ()=>$221e2d1c864e815a$export$27d854bd39923fc7);
    var $gv69P;
    var $eujWk;
    var $dIdda = parcelRequire("dIdda");
    const $221e2d1c864e815a$export$27d854bd39923fc7 = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("eujWk")).getTeamsResource).type,
        getKey: (0, (0, parcelRequire("eujWk")).getTeamsResource).getKey,
        getData: async (_, { tenantContext: { atlassianAccountId: atlassianAccountId, isSiteAdmin: isSiteAdmin, isAdmin: isAdmin } })=>{
            if (!atlassianAccountId) return null;
            const shouldSeeAllTeams = isSiteAdmin || isAdmin;
            return (0, (0, parcelRequire("gv69P")).getTeams)({
                queryParams: {
                    accountId: !shouldSeeAllTeams ? atlassianAccountId : undefined,
                    showAvatar: true
                }
            });
        },
        isBrowserOnly: true,
        maxAge: 0
    });
});
parcelRegister("gv69P", function(module, exports) {
    $parcel$export(module.exports, "getTeams", ()=>$82d5cec35c13c4db$export$5a622455e94bac3);
    var $6GHRr;
    const $82d5cec35c13c4db$export$5a622455e94bac3 = ({ url: url, queryParams: queryParams })=>{
        const params = new URLSearchParams();
        if (queryParams.keyword) params.append('keyword', queryParams.keyword);
        if (queryParams.size) params.append('size', queryParams.size.toString());
        if (queryParams.offset) params.append('offset', queryParams.offset.toString());
        if (queryParams.accountId) params.append('memberId', queryParams.accountId);
        if (queryParams.showAvatar) params.append('showAvatar', String(queryParams.showAvatar));
        if (url) return (0, (0, parcelRequire("6GHRr")).eocFetch)(`${url}${params.toString() ? `?${params.toString()}` : ''}`, {
            exactUrl: true
        });
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/teams${params.toString() ? `?${params.toString()}` : ''}`);
    };
});
parcelRegister("eujWk", function(module, exports) {
    $parcel$export(module.exports, "getTeamsResource", ()=>$fde367a319970b3b$export$27d854bd39923fc7);
    var $dIdda = parcelRequire("dIdda");
    var $gv69P;
    const $fde367a319970b3b$export$27d854bd39923fc7 = (0, $dIdda.createResource)({
        type: 'getTeamsResource',
        getKey: ()=>'overview',
        getData: async ()=>{
            throw new Error('getData of getTeamsResource is not implemented in platform package, you should do it in your product');
        },
        isBrowserOnly: true
    });
});
parcelRegister("jAUdg", function(module, exports) {
    $parcel$export(module.exports, "eocOverviewRoute", ()=>$963d9bbc50a3fbba$export$cb929d46451a5c12);
    $parcel$export(module.exports, "eocOverviewAllTeamsRoute", ()=>$963d9bbc50a3fbba$export$dbe53627482b9f0f);
    var $65Ltd;
    const $963d9bbc50a3fbba$export$cb929d46451a5c12 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_OVERVIEW),
        path: '/jira/ops/overview',
        exact: true
    };
    const $963d9bbc50a3fbba$export$dbe53627482b9f0f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_OVERVIEW_ALL_TEAMS),
        path: '/jira/ops/overview/teams',
        exact: true
    };
});
parcelRegister("9oNUK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("92gV4")
    ]).then(()=>parcelRequire('hTI3Y'));
});
parcelRegister("8tAz8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hbHCQ")
    ]).then(()=>parcelRequire('jMqXq'));
});
parcelRegister("78qDW", function(module, exports) {
    $parcel$export(module.exports, "eocPermissionsRouteEntry", ()=>$35644870254acca5$export$c2ced436a30c60dc);
    var $i1ozZ;
    var $3vS1t;
    var $ffza4;
    var $lmyls;
    var $3Dk1Z;
    var $fezpN;
    var $h3Ix2;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $awiPu;
    var $haBWo;
    const $35644870254acca5$export$c2ced436a30c60dc = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("awiPu")).eocPermissionsRoute), ()=>({
            component: (0, (0, parcelRequire("haBWo")).default),
            layout: (0, (0, parcelRequire("h3Ix2")).opsTeamLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("i1ozZ")).pageAccessResource),
                ...(0, (0, parcelRequire("i1ozZ")).resources),
                ...(0, (0, parcelRequire("3vS1t")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, (0, parcelRequire("3Dk1Z")).default),
                horizontal: (0, (0, parcelRequire("fezpN")).AsyncHorizontalOperationsNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("fezpN")).LazyHorizontalOperationsNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("haBWo")).LazyMemberRoles),
                (0, (0, parcelRequire("3Dk1Z")).LazyTeamDashboardSidebar)
            ]
        }));
});
parcelRegister("i1ozZ", function(module, exports) {
    $parcel$export(module.exports, "pageAccessResource", ()=>$646b9461317aae52$export$b0d36f8262140e35);
    $parcel$export(module.exports, "memberRolesResource", ()=>$646b9461317aae52$export$5c4885c1f1a535b);
    $parcel$export(module.exports, "getTeamResource", ()=>$646b9461317aae52$export$50271c9e7f21f10e);
    $parcel$export(module.exports, "customTeamRolesResource", ()=>$646b9461317aae52$export$ed1eb48699cf7893);
    $parcel$export(module.exports, "resources", ()=>$646b9461317aae52$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $lUMYZ;
    var $2FAs6;
    var $dKosV;
    const $646b9461317aae52$var$mapStatus = (status, userAccessLevel)=>{
        if (userAccessLevel === 'INTERNAL_INACTIVE') return 'suspended';
        if (status === 'REQUEST_ACCESS' || status === 'DENIED_REQUEST_EXISTS' || status === 'FORBIDDEN' || status === 'DIRECT_ACCESS') return 'invite';
        if (status === 'ACCESS_EXISTS') return 'member';
        if (status === 'PENDING_REQUEST_EXISTS') return 'pending';
        if (status === '' || status === undefined) return 'member';
        return 'invite';
    };
    const $646b9461317aae52$var$checkPageAccessRightsOnRouteDependency = async (dependencies)=>{
        let isAuthorizedToSeeMemberRolesPage = false;
        if (dependencies[$646b9461317aae52$var$PAGE_ACCESS_RESOURCE_TYPE]) {
            const data = await dependencies[$646b9461317aae52$var$PAGE_ACCESS_RESOURCE_TYPE].promise;
            isAuthorizedToSeeMemberRolesPage = data?.productOrTeamAdmin;
        }
        return isAuthorizedToSeeMemberRolesPage;
    };
    const $646b9461317aae52$var$PAGE_ACCESS_RESOURCE_TYPE = 'pageAccessResource';
    const $646b9461317aae52$export$b0d36f8262140e35 = (0, $dIdda.createResource)({
        type: $646b9461317aae52$var$PAGE_ACCESS_RESOURCE_TYPE,
        getKey: ()=>'pageAccessResource',
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("lUMYZ")).assert)(!!teamId, new (0, (0, parcelRequire("2FAs6")).AssertionError)('pageAccessResource', 'teamId should be set to fetch page access'));
            return (0, (0, parcelRequire("dKosV")).getMemberRolesPageAccess)(teamId);
        },
        isBrowserOnly: true
    });
    const $646b9461317aae52$export$5c4885c1f1a535b = (0, $dIdda.createResource)({
        type: 'memberRolesResource',
        getKey: ()=>'memberRolesResource',
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            const dependencies = routerContext.dependencies;
            (0, (0, parcelRequire("lUMYZ")).assert)(!!teamId, new (0, (0, parcelRequire("2FAs6")).AssertionError)('memberRolesResource', 'teamId should be set to fetch member-roles'));
            const isAuthorizedToSeeMemberRolesPage = await $646b9461317aae52$var$checkPageAccessRightsOnRouteDependency(dependencies);
            if (!isAuthorizedToSeeMemberRolesPage) return null;
            const gqlResponse = await (0, (0, parcelRequire("dKosV")).getMembers)(teamId);
            let members = [];
            members = gqlResponse?.data.team.teamV2.members.edges.map((edge)=>edge.node.member);
            const teamMembers = await (0, (0, parcelRequire("dKosV")).getRoleAndJSMLicenseInfoEndpoint)({
                platformTeamId: teamId,
                accountIds: members.map((member)=>member.accountId)
            }).then((res)=>{
                const users = members.map((user)=>{
                    const userWithRole = res.teamMembers.find((userWithRole)=>userWithRole.accountId === user.accountId);
                    return {
                        ...user,
                        role: userWithRole?.roleId || 'user',
                        jsmLicense: userWithRole?.jsmLicense || false,
                        jiraAdmin: userWithRole?.jiraAdmin || false,
                        invitationStatus: 'member'
                    };
                });
                return users;
            });
            const membersWithoutJSMLicense = teamMembers.filter((teamMembers)=>!teamMembers.jsmLicense);
            if (membersWithoutJSMLicense.length > 0) {
                const accountIds = membersWithoutJSMLicense.map((member)=>member.accountId).join(',');
                const membersWithFullInfo = await (0, (0, parcelRequire("dKosV")).getJSMInvitationStatusInfoEndpoint)({
                    accountIds: accountIds
                }).then((res)=>{
                    const users = teamMembers.map((user)=>{
                        const userWithInvitationStatus = res.embeddedValue.find((userWithInvitationStatus)=>userWithInvitationStatus.accountId === user.accountId);
                        return {
                            ...user,
                            invitationStatus: $646b9461317aae52$var$mapStatus(userWithInvitationStatus?.accessMode, userWithInvitationStatus?.userAccessLevel)
                        };
                    });
                    return users;
                }).catch((err)=>{
                    return teamMembers;
                });
                return membersWithFullInfo;
            }
            return teamMembers;
        },
        isBrowserOnly: true,
        depends: [
            $646b9461317aae52$var$PAGE_ACCESS_RESOURCE_TYPE
        ]
    });
    const $646b9461317aae52$export$50271c9e7f21f10e = (0, $dIdda.createResource)({
        type: 'getTeamResource',
        getKey: ()=>'getTeamResource',
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("lUMYZ")).assert)(!!teamId, new (0, (0, parcelRequire("2FAs6")).AssertionError)('getTeamResource', 'teamId should be set to fetch team info on member roles'));
            return (0, (0, parcelRequire("dKosV")).getTeam)(teamId);
        },
        isBrowserOnly: true
    });
    const $646b9461317aae52$export$ed1eb48699cf7893 = (0, $dIdda.createResource)({
        type: 'customTeamRolesResource',
        getKey: ()=>'customRolesResource',
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            const dependencies = routerContext.dependencies;
            (0, (0, parcelRequire("lUMYZ")).assert)(!!teamId, new (0, (0, parcelRequire("2FAs6")).AssertionError)('customTeamRolesResource', 'teamId should be set to fetch custom-team-roles'));
            const isAuthorizedToSeeMemberRolesPage = await $646b9461317aae52$var$checkPageAccessRightsOnRouteDependency(dependencies);
            if (!isAuthorizedToSeeMemberRolesPage) return null;
            return (0, (0, parcelRequire("dKosV")).getCustomTeamRolesEndpoint)(teamId);
        },
        isBrowserOnly: true,
        depends: [
            $646b9461317aae52$var$PAGE_ACCESS_RESOURCE_TYPE
        ]
    });
    const $646b9461317aae52$export$bc99aaabaf7b70a7 = [
        $646b9461317aae52$export$5c4885c1f1a535b,
        $646b9461317aae52$export$50271c9e7f21f10e,
        $646b9461317aae52$export$ed1eb48699cf7893
    ];
});
parcelRegister("dKosV", function(module, exports) {
    $parcel$export(module.exports, "getMembers", ()=>$86eb79ea990caad9$export$f4931e6f9feb30c5);
    $parcel$export(module.exports, "getMemberRolesPageAccess", ()=>$86eb79ea990caad9$export$95d4c4e762437fdd);
    $parcel$export(module.exports, "getRoleAndJSMLicenseInfoEndpoint", ()=>$86eb79ea990caad9$export$38ab389cb64a5000);
    $parcel$export(module.exports, "getJSMInvitationStatusInfoEndpoint", ()=>$86eb79ea990caad9$export$fd43007da8683026);
    $parcel$export(module.exports, "getTeam", ()=>$86eb79ea990caad9$export$491fe77f22ab2b51);
    $parcel$export(module.exports, "getCustomTeamRolesEndpoint", ()=>$86eb79ea990caad9$export$ebfa293eb1ef42f5);
    var $294ns;
    var $6GHRr;
    var $aHQEx;
    const $86eb79ea990caad9$var$operationName = 'memberRolesTeamMembersQuery';
    const $86eb79ea990caad9$export$f4931e6f9feb30c5 = (teamId)=>{
        const queryUrl = '/gateway/api/graphql';
        const teamAri = `ari:cloud:identity::team/${teamId}`;
        const siteId = (0, (0, parcelRequire("aHQEx")).getMeta)('ajs-cloud-id');
        const membersQueryV2 = `query memberRolesTeamMembersQuery($teamId: ID!, $siteId: String!) {
		team {
			teamV2 (id: $teamId, siteId: $siteId) @optIn(to: "Team-v2") {
				id
				members ${(0, (0, parcelRequire("294ns")).fg)('platform_increase_limit_of_members_query') ? '(first: 300)' : ''}{
					edges {
						cursor
						node {
							member  {
								... on AtlassianAccountUser {
									email
								}
								name
								picture
								accountId
								accountStatus
							}
							state
							role
						}
					}
				}
			}
		}
	}
	`;
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(queryUrl, {
            method: 'POST',
            body: JSON.stringify({
                operationName: $86eb79ea990caad9$var$operationName,
                query: membersQueryV2,
                variables: {
                    teamId: teamAri,
                    siteId: siteId
                }
            }),
            headers: {
                'Content-Type': 'application/json',
                'X-ExperimentalApi': 'teams-beta, team-members-beta'
            },
            exactUrl: true
        });
    };
    const $86eb79ea990caad9$export$95d4c4e762437fdd = (teamId)=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/teams/members/member-roles-page-access?platformTeamId=${teamId}`);
    const $86eb79ea990caad9$export$38ab389cb64a5000 = ({ platformTeamId: platformTeamId, accountIds: accountIds })=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/teams/members`, {
            method: 'POST',
            body: {
                platformTeamId: platformTeamId,
                accountIds: accountIds
            }
        });
    const $86eb79ea990caad9$export$fd43007da8683026 = ({ accountIds: accountIds })=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/users/access-request-capabilities?accountIds=${accountIds}`, {
            method: 'GET'
        });
    const $86eb79ea990caad9$export$491fe77f22ab2b51 = (teamId)=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/alerts/responders/names`, {
            method: 'POST',
            body: {
                responders: [
                    {
                        id: teamId,
                        type: 'team'
                    }
                ]
            }
        });
    const $86eb79ea990caad9$export$ebfa293eb1ef42f5 = (platformTeamId)=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/teams/${platformTeamId}/roles`);
});
parcelRegister("awiPu", function(module, exports) {
    $parcel$export(module.exports, "eocPermissionsRoute", ()=>$3b187ddb8aa38409$export$8e6afd724de3be6e);
    var $65Ltd;
    const $3b187ddb8aa38409$export$8e6afd724de3be6e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_PERMISSIONS),
        path: '/jira/ops/teams/:teamId/settings',
        exact: true
    };
});
parcelRegister("haBWo", function(module, exports) {
    $parcel$export(module.exports, "LazyMemberRoles", ()=>$54e18f7965bed61c$export$27b4fb95241ab47);
    $parcel$export(module.exports, "default", ()=>$54e18f7965bed61c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $54e18f7965bed61c$export$27b4fb95241ab47 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("90Y3w")), {
        moduleId: "./src/packages/eoc/member-roles/src/ui/index.tsx"
    });
    var $54e18f7965bed61c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $54e18f7965bed61c$export$27b4fb95241ab47,
            pageId: "async-jira-eoc-member-roles",
            shouldShowSpinner: false
        });
});
parcelRegister("90Y3w", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("gZDDu")
    ]).then(()=>parcelRequire('6Zxu7'));
});
parcelRegister("1KnZe", function(module, exports) {
    $parcel$export(module.exports, "eocPoliciesRouteEntries", ()=>$784323cf5d6d6d47$export$3a28949e52d2d60f);
    var $5uXOq = parcelRequire("5uXOq");
    var $fJKjb;
    var $3vS1t;
    var $ffza4;
    var $lmyls;
    var $3Dk1Z;
    var $2Fj5v;
    var $iTMlN;
    var $fezpN;
    var $h3Ix2;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $4Wrw9;
    var $5j7Th;
    var $hPtZI;
    const $784323cf5d6d6d47$var$LazyAlertPolicies = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("9A51b")), {
        moduleId: "./src/packages/eoc/policies/src/index.tsx"
    });
    const $784323cf5d6d6d47$var$AlertPoliciesComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $784323cf5d6d6d47$var$LazyAlertPolicies,
            pageId: "async-jira-eoc-alert-policies",
            shouldShowSpinner: false
        });
    const $784323cf5d6d6d47$export$eb1e2324ca2031e2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4Wrw9")).alertPoliciesRoute), ()=>({
            component: $784323cf5d6d6d47$var$AlertPoliciesComponent,
            layout: (0, (0, parcelRequire("h3Ix2")).opsTeamLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("fJKjb")).resources),
                ...(0, (0, parcelRequire("3vS1t")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, (0, parcelRequire("3Dk1Z")).default),
                horizontal: (0, (0, parcelRequire("fezpN")).AsyncHorizontalOperationsNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("fezpN")).LazyHorizontalOperationsNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $784323cf5d6d6d47$var$LazyAlertPolicies,
                (0, (0, parcelRequire("3Dk1Z")).LazyTeamDashboardSidebar)
            ]
        }));
    const $784323cf5d6d6d47$export$2ee2f43d380cc210 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4Wrw9")).globalPoliciesRoute), ()=>({
            component: $784323cf5d6d6d47$var$AlertPoliciesComponent,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("fJKjb")).resources)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, (0, parcelRequire("iTMlN")).AsyncHorizontalOperationsConfigurationNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("iTMlN")).LazyHorizontalOperationsConfigurationNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $784323cf5d6d6d47$var$LazyAlertPolicies
            ]
        }));
    const $784323cf5d6d6d47$export$3a28949e52d2d60f = [
        $784323cf5d6d6d47$export$eb1e2324ca2031e2,
        $784323cf5d6d6d47$export$2ee2f43d380cc210
    ];
});
parcelRegister("fJKjb", function(module, exports) {
    $parcel$export(module.exports, "teamPolicyResource", ()=>$340accc112d59d0c$export$10d7fa513f08ef83);
    $parcel$export(module.exports, "notificationPolicyResource", ()=>$340accc112d59d0c$export$6d5f23d9118ad678);
    $parcel$export(module.exports, "globalPolicyResource", ()=>$340accc112d59d0c$export$7aed80da979a5112);
    $parcel$export(module.exports, "resources", ()=>$340accc112d59d0c$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $d9Vq4;
    const $340accc112d59d0c$export$10d7fa513f08ef83 = (0, $dIdda.createResource)({
        type: 'teamPolicyResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `team-policy/${teamId ?? ''}`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            if (!teamId) return null;
            return (0, (0, parcelRequire("d9Vq4")).getTeamPolicies)(teamId);
        },
        isBrowserOnly: true
    });
    const $340accc112d59d0c$export$6d5f23d9118ad678 = (0, $dIdda.createResource)({
        type: 'notificationPolicyResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return `notification-policy/${teamId}`;
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            if (!teamId) return;
            return (0, (0, parcelRequire("d9Vq4")).getNotificationPolicies)(teamId);
        },
        isBrowserOnly: true
    });
    const $340accc112d59d0c$export$7aed80da979a5112 = (0, $dIdda.createResource)({
        type: 'globalPolicyResource',
        getKey: (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            if (teamId) return `global-policy/${teamId}`;
            return 'global-policy';
        },
        getData: async (routerContext)=>{
            const teamId = routerContext.match.params?.teamId;
            return (0, (0, parcelRequire("d9Vq4")).getGlobalPolicies)(teamId);
        },
        isBrowserOnly: true
    });
    const $340accc112d59d0c$export$4cb385c2db8b1e99 = (0, $dIdda.createResource)({
        type: 'policyMaintenanceRightsResource',
        getKey: ()=>'policy-maintenance-rights-resource',
        getData: async ()=>{
            return (0, (0, parcelRequire("d9Vq4")).getPolicyMaintenanceRights)();
        },
        isBrowserOnly: true
    });
    const $340accc112d59d0c$export$bc99aaabaf7b70a7 = [
        $340accc112d59d0c$export$10d7fa513f08ef83,
        $340accc112d59d0c$export$7aed80da979a5112,
        $340accc112d59d0c$export$4cb385c2db8b1e99,
        $340accc112d59d0c$export$6d5f23d9118ad678
    ];
});
parcelRegister("d9Vq4", function(module, exports) {
    $parcel$export(module.exports, "getTeamPolicies", ()=>$75b53fdc14e57b48$export$fead0944caa1c797);
    $parcel$export(module.exports, "getGlobalPolicies", ()=>$75b53fdc14e57b48$export$17fc7fbef061a8c3);
    $parcel$export(module.exports, "getNotificationPolicies", ()=>$75b53fdc14e57b48$export$342525d9423e55ad);
    $parcel$export(module.exports, "getPolicyMaintenanceRights", ()=>$75b53fdc14e57b48$export$f630cbf5586dce0a);
    $parcel$export(module.exports, "updateUIPreferenceEndpoint", ()=>$75b53fdc14e57b48$export$6a437b43ab11275d);
    $parcel$export(module.exports, "changePolicyOrderEndpoint", ()=>$75b53fdc14e57b48$export$57186d786c96b52a);
    $parcel$export(module.exports, "enablePolicyEndpoint", ()=>$75b53fdc14e57b48$export$6fecd226d8e55346);
    $parcel$export(module.exports, "disablePolicyEndpoint", ()=>$75b53fdc14e57b48$export$8c0cd218e00b7d9b);
    $parcel$export(module.exports, "deletePolicyEndpoint", ()=>$75b53fdc14e57b48$export$f9feac6c1dcc516f);
    $parcel$export(module.exports, "createPolicyEndpoint", ()=>$75b53fdc14e57b48$export$b0108c51b962e788);
    $parcel$export(module.exports, "updatePolicyEndpoint", ()=>$75b53fdc14e57b48$export$8eabce250a2dd205);
    var $6GHRr;
    const $75b53fdc14e57b48$export$fead0944caa1c797 = (teamId)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/teams/${teamId}/policies?type=alert`);
    };
    const $75b53fdc14e57b48$export$17fc7fbef061a8c3 = (teamId)=>{
        if (teamId) return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/alerts/policies?preferredUITeamId=${teamId}`);
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/alerts/policies`);
    };
    const $75b53fdc14e57b48$export$342525d9423e55ad = (teamId)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/teams/${teamId}/policies?type=notification`);
    };
    const $75b53fdc14e57b48$export$f630cbf5586dce0a = ()=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/alerts/ui-preferences/policy-maintenance-rights`);
    };
    const $75b53fdc14e57b48$export$6a437b43ab11275d = ({ teamId: teamId, ...payload })=>{
        let url = `/v1/alerts/ui-preferences/policies`;
        if (teamId) url = `${url}?teamId=${teamId}`;
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(url, {
            method: 'PATCH',
            body: payload,
            responseType: 'headers'
        });
    };
    const $75b53fdc14e57b48$export$57186d786c96b52a = (payload)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/order`, {
            method: 'PATCH',
            body: {
                after: payload.after
            },
            responseType: 'headers'
        });
    };
    const $75b53fdc14e57b48$export$6fecd226d8e55346 = (payload)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/enable`, {
            method: 'POST',
            responseType: 'headers'
        });
    };
    const $75b53fdc14e57b48$export$8c0cd218e00b7d9b = (payload)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}/disable`, {
            method: 'POST',
            responseType: 'headers'
        });
    };
    const $75b53fdc14e57b48$export$f9feac6c1dcc516f = (payload)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
            method: 'DELETE',
            responseType: 'headers'
        });
    };
    const $75b53fdc14e57b48$export$b0108c51b962e788 = (payload)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/teams/${payload.teamId}/policies`, {
            method: 'POST',
            body: payload
        });
    };
    const $75b53fdc14e57b48$export$8eabce250a2dd205 = (payload)=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/teams/${payload.teamId}/policies/${payload.id}`, {
            method: 'PUT',
            body: payload
        });
    };
});
parcelRegister("4Wrw9", function(module, exports) {
    $parcel$export(module.exports, "alertPoliciesRoute", ()=>$a4216a36228c2696$export$eab7ea9e54b67f16);
    $parcel$export(module.exports, "globalPoliciesRoute", ()=>$a4216a36228c2696$export$4eb24a8e860a3df7);
    var $65Ltd;
    const $a4216a36228c2696$export$eab7ea9e54b67f16 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_POLICIES),
        path: '/jira/ops/teams/:teamId/policies',
        exact: true
    };
    const $a4216a36228c2696$export$4eb24a8e860a3df7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_POLICIES),
        path: '/jira/settings/products/ops/policies',
        exact: true
    };
});
parcelRegister("9A51b", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("d7ZnT")
    ]).then(()=>parcelRequire('3IgJn'));
});
parcelRegister("9hZVU", function(module, exports) {
    $parcel$export(module.exports, "eocOpsRouteEntries", ()=>$756c00e161e435ff$export$1d5f1cc699ecefa3);
    var $cowY1;
    var $3vS1t;
    var $ffza4;
    var $lmyls;
    var $3Dk1Z;
    var $fezpN;
    var $h3Ix2;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $iuldR;
    var $5GbXG;
    const $756c00e161e435ff$export$c5606e8eeca32c0f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iuldR")).eocTeamReportsHomePageRoute), ()=>({
            component: (0, (0, parcelRequire("5GbXG")).OpsReportsRedirect),
            layout: (0, (0, parcelRequire("h3Ix2")).opsTeamLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3vS1t")).resources),
                ...(0, (0, parcelRequire("cowY1")).resources),
                (0, (0, parcelRequire("cowY1")).opsReportsPermissionResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, (0, parcelRequire("3Dk1Z")).default),
                horizontal: (0, (0, parcelRequire("fezpN")).AsyncHorizontalOperationsNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("fezpN")).LazyHorizontalOperationsNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("5GbXG")).LazyOpsReportsRedirect),
                (0, (0, parcelRequire("3Dk1Z")).LazyTeamDashboardSidebar)
            ]
        }));
    const $756c00e161e435ff$export$be0522f298067d5d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iuldR")).eocGlobalReportsHomePageRouteNav4), ()=>({
            component: (0, (0, parcelRequire("5GbXG")).OpsReportsRedirect),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("cowY1")).resources),
                (0, (0, parcelRequire("cowY1")).opsReportsPermissionResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, (0, parcelRequire("3Dk1Z")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("fezpN")).LazyHorizontalOperationsNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("5GbXG")).LazyOpsReportsRedirect),
                (0, (0, parcelRequire("3Dk1Z")).LazyTeamDashboardSidebar)
            ]
        }));
    const $756c00e161e435ff$export$1016100af7c78cd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iuldR")).eocGlobalReportsNav4Route), ()=>({
            component: (0, (0, parcelRequire("5GbXG")).GlobalOpsReports),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("cowY1")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HOME
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("5GbXG")).LazyGlobalOpsReports)
            ]
        }));
    const $756c00e161e435ff$export$df0202187c23a21d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iuldR")).eocReportsUnsubscribeRoute), ()=>({
            component: (0, (0, parcelRequire("5GbXG")).OpsReportsUnsubscribe),
            layout: (0, (0, parcelRequire("h3Ix2")).opsTeamLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("5GbXG")).LazyOpsReportsUnsubscribe)
            ]
        }));
    const $756c00e161e435ff$export$cd1c1a81e516fec5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iuldR")).eocReportsTeamRoute), ()=>({
            component: (0, (0, parcelRequire("5GbXG")).OpsReports),
            layout: (0, (0, parcelRequire("h3Ix2")).opsTeamLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3vS1t")).resources),
                ...(0, (0, parcelRequire("cowY1")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, (0, parcelRequire("3Dk1Z")).default),
                horizontal: (0, (0, parcelRequire("fezpN")).AsyncHorizontalOperationsNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("fezpN")).LazyHorizontalOperationsNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("5GbXG")).LazyOpsReports),
                (0, (0, parcelRequire("3Dk1Z")).LazyTeamDashboardSidebar)
            ]
        }));
    const $756c00e161e435ff$export$1d5f1cc699ecefa3 = [
        $756c00e161e435ff$export$c5606e8eeca32c0f,
        $756c00e161e435ff$export$df0202187c23a21d,
        $756c00e161e435ff$export$be0522f298067d5d,
        $756c00e161e435ff$export$1016100af7c78cd,
        $756c00e161e435ff$export$cd1c1a81e516fec5
    ];
});
parcelRegister("cowY1", function(module, exports) {
    $parcel$export(module.exports, "opsReportsResource", ()=>$a476915e872eec36$export$8498311fc7a4ab48);
    $parcel$export(module.exports, "opsReportsPermissionResource", ()=>$a476915e872eec36$export$c432f280d76e2acf);
    $parcel$export(module.exports, "resources", ()=>$a476915e872eec36$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $lUMYZ;
    var $2FAs6;
    var $4fJJU;
    var $1H2IZ;
    const $a476915e872eec36$export$8498311fc7a4ab48 = (0, $dIdda.createResource)({
        type: 'opsReportsResource',
        getKey: ()=>'opsReportsResource',
        getData: async ()=>{
            const settings = await (0, (0, parcelRequire("1H2IZ")).getReportSettings)();
            const api = (0, (0, parcelRequire("1H2IZ")).getDashboards);
            return {
                settings: settings,
                dashboards: settings.showReportingMaintenance ? null : await api()
            };
        },
        maxAge: Infinity,
        isBrowserOnly: true
    });
    const $a476915e872eec36$export$c432f280d76e2acf = (0, $dIdda.createResource)({
        type: 'opsReportsPermissionResource',
        getKey: ({ match: match })=>{
            return `opsReportsPermissionResource-${match.params?.teamId}`;
        },
        getData: async (routerContext)=>{
            const isTeamDashboard = (0, (0, parcelRequire("4fJJU")).isTeamReportsUrl)(routerContext.match.url);
            const teamId = routerContext.match.params?.teamId;
            (0, (0, parcelRequire("lUMYZ")).assert)(!isTeamDashboard || !!teamId, new (0, (0, parcelRequire("2FAs6")).AssertionError)('opsReportsPermissionResource', 'teamId should be set to fetch reports permissions on TeamDashboard page'));
            return (0, (0, parcelRequire("1H2IZ")).getReportRights)(teamId);
        },
        isBrowserOnly: true,
        maxAge: Infinity
    });
    const $a476915e872eec36$export$bc99aaabaf7b70a7 = [
        $a476915e872eec36$export$8498311fc7a4ab48,
        $a476915e872eec36$export$c432f280d76e2acf
    ];
});
parcelRegister("4fJJU", function(module, exports) {
    $parcel$export(module.exports, "withReportingPrefix", ()=>$8f83b2cf6ca49406$export$c0f073d636267c44);
    $parcel$export(module.exports, "isTeamReportsUrl", ()=>$8f83b2cf6ca49406$export$f923ac475871fcad);
    var $aHQEx;
    function $8f83b2cf6ca49406$export$c0f073d636267c44(input) {
        if (window.__OG__) return '/webapi' + input;
        const cloudId = (0, (0, parcelRequire("aHQEx")).getMeta)('ajs-cloud-id');
        if (cloudId) return `/gateway/api/jsm/ops/reporting/cloudId/${cloudId}/api` + input;
        return input;
    }
    const $8f83b2cf6ca49406$export$f923ac475871fcad = (pathName)=>pathName.startsWith('/jira/ops/teams/');
});
parcelRegister("1H2IZ", function(module, exports) {
    $parcel$export(module.exports, "getDashboards", ()=>$3b9cce8a9c52648b$export$8e4b6d6c4fec08f3);
    $parcel$export(module.exports, "getReportSettings", ()=>$3b9cce8a9c52648b$export$9114b8a872caf5d8);
    $parcel$export(module.exports, "getSsoEmbedUrlEndpoint", ()=>$3b9cce8a9c52648b$export$8384a95746267bd8);
    $parcel$export(module.exports, "getReportRights", ()=>$3b9cce8a9c52648b$export$f4a61c3c8c619f12);
    $parcel$export(module.exports, "getAVPEmbedTokens", ()=>$3b9cce8a9c52648b$export$fb46892f83504a42);
    var $6GHRr;
    var $4fJJU;
    var $cc9Pp;
    const $3b9cce8a9c52648b$export$8e4b6d6c4fec08f3 = ()=>(0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("4fJJU")).withReportingPrefix)('/v5/reports/dashboards'), {
            exactUrl: true,
            errorTransformer: (0, parcelRequire("cc9Pp")).opsReportsErrorTransformer
        });
    const $3b9cce8a9c52648b$export$e69121e90ce0231b = ()=>(0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("4fJJU")).withReportingPrefix)('/v3/reports/dashboards'), {
            exactUrl: true,
            errorTransformer: (0, parcelRequire("cc9Pp")).opsReportsErrorTransformer
        });
    const $3b9cce8a9c52648b$export$9114b8a872caf5d8 = ()=>(0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("4fJJU")).withReportingPrefix)('/v3/reports/index'), {
            exactUrl: true,
            errorTransformer: (0, parcelRequire("cc9Pp")).opsReportsErrorTransformer
        });
    const $3b9cce8a9c52648b$export$8384a95746267bd8 = (isDarkMode, dashboardId, teamId)=>{
        const queryParam = teamId ? {
            theme: isDarkMode ? 'DarkMode' : '',
            dashboardId: dashboardId,
            teamId: teamId,
            _: Date.now().toString()
        } : {
            theme: isDarkMode ? 'DarkMode' : '',
            dashboardId: dashboardId,
            _: Date.now().toString()
        };
        const url = `/v3/reports/dashboard?${new URLSearchParams(queryParam).toString()}`;
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("4fJJU")).withReportingPrefix)(url), {
            exactUrl: true,
            errorTransformer: (0, parcelRequire("cc9Pp")).opsReportsErrorTransformer
        });
    };
    const $3b9cce8a9c52648b$export$f4a61c3c8c619f12 = (teamId)=>{
        let url = '/v3/reports/rights';
        if (teamId) url += `?teamId=${teamId}`;
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("4fJJU")).withReportingPrefix)(url), {
            exactUrl: true,
            errorTransformer: (0, parcelRequire("cc9Pp")).opsReportsErrorTransformer
        });
    };
    const $3b9cce8a9c52648b$export$fb46892f83504a42 = (dashboardId, teamId)=>{
        let url = '/v3/reports/embed-token';
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("4fJJU")).withReportingPrefix)(url), {
            exactUrl: true,
            method: 'POST',
            body: {
                dashboardId: dashboardId,
                teamId: teamId
            },
            errorTransformer: (0, parcelRequire("cc9Pp")).opsReportsErrorTransformer
        });
    };
});
parcelRegister("cc9Pp", function(module, exports) {
    $parcel$export(module.exports, "opsReportsErrorTransformer", ()=>$032514e5956db199$export$b170750bd4489531);
    var $h3bae;
    const $032514e5956db199$var$mediaTypeRegex = /(^application\/json$)|(^application\/json([\s\t]?;.+?)*([\s\t]?;[\s\t]?charset=(("utf-8")|(utf-8)|("ISO-8859-1")|(ISO-8859-1))))/i;
    const $032514e5956db199$export$b170750bd4489531 = (e)=>{
        if ((0, (0, parcelRequire("h3bae")).isHTTPError)(e)) {
            const contentType = e.response.headers.get('Content-Type');
            if (contentType && $032514e5956db199$var$mediaTypeRegex.test(contentType)) return e.response.json().then((data)=>new (0, (0, parcelRequire("h3bae")).StreamedHTTPError)(e, data, data.message));
            return e.response.text().then((message)=>new (0, (0, parcelRequire("h3bae")).StreamedHTTPError)(e, message, message));
        }
        return e;
    };
});
parcelRegister("iuldR", function(module, exports) {
    $parcel$export(module.exports, "eocTeamReportsHomePageRoute", ()=>$99922e52e7ec0235$export$c71b9e52093cd3a);
    $parcel$export(module.exports, "eocGlobalReportsHomePageRouteNav4", ()=>$99922e52e7ec0235$export$4209bfa031a1bc9e);
    $parcel$export(module.exports, "eocReportsUnsubscribeRoute", ()=>$99922e52e7ec0235$export$72cde899ee974e6e);
    $parcel$export(module.exports, "eocGlobalReportsNav4Route", ()=>$99922e52e7ec0235$export$2344cc35fd2eff4e);
    $parcel$export(module.exports, "eocReportsTeamRoute", ()=>$99922e52e7ec0235$export$c9e0796615c034f3);
    var $65Ltd;
    const $99922e52e7ec0235$export$c71b9e52093cd3a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS),
        path: '/jira/ops/teams/:teamId/reports',
        exact: true
    };
    const $99922e52e7ec0235$export$4209bfa031a1bc9e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_REPORTS),
        path: '/jira/ops/reports',
        exact: true
    };
    const $99922e52e7ec0235$export$72cde899ee974e6e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS_UNSUBSCRIBE),
        path: '/jira/ops/reports/unsubscribe/:templateId/:subscriptionId',
        exact: true
    };
    const $99922e52e7ec0235$export$2344cc35fd2eff4e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_GLOBAL_REPORT_DASHBOARD),
        path: '/jira/ops/reports/:dashboardId',
        exact: true
    };
    const $99922e52e7ec0235$export$c9e0796615c034f3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_REPORTS_TEAM),
        path: '/jira/ops/teams/:teamId/reports/:dashboardId',
        exact: true
    };
});
parcelRegister("5GbXG", function(module, exports) {
    $parcel$export(module.exports, "LazyOpsReports", ()=>$cba1f7031d59cee6$export$2404f0e35deca592);
    $parcel$export(module.exports, "LazyOpsReportsRedirect", ()=>$cba1f7031d59cee6$export$d33ea1a773b744e);
    $parcel$export(module.exports, "LazyGlobalOpsReports", ()=>$cba1f7031d59cee6$export$66850ec5549adba6);
    $parcel$export(module.exports, "LazyOpsReportsUnsubscribe", ()=>$cba1f7031d59cee6$export$5fd77c3bbfb22cbd);
    $parcel$export(module.exports, "OpsReportsRedirect", ()=>$cba1f7031d59cee6$export$22253dbadb46d0cf);
    $parcel$export(module.exports, "GlobalOpsReports", ()=>$cba1f7031d59cee6$export$648ddf2d1f8b1c3f);
    $parcel$export(module.exports, "OpsReports", ()=>$cba1f7031d59cee6$export$87e6a54b4f5dc91e);
    $parcel$export(module.exports, "OpsReportsUnsubscribe", ()=>$cba1f7031d59cee6$export$7f366d77015c286f);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $cba1f7031d59cee6$export$2404f0e35deca592 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("jubOI")), {
        moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
    });
    const $cba1f7031d59cee6$export$d33ea1a773b744e = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("jubOI")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
        moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
    });
    const $cba1f7031d59cee6$export$66850ec5549adba6 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("jubOI")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
        moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
    });
    const $cba1f7031d59cee6$export$5fd77c3bbfb22cbd = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("jubOI")).then((exportedMembers)=>exportedMembers.OpsReportsUnsubscribe), {
        moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
    });
    const $cba1f7031d59cee6$export$22253dbadb46d0cf = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cba1f7031d59cee6$export$d33ea1a773b744e,
            pageId: "async-jira-eoc-ops-reports-redirect",
            shouldShowSpinner: false
        });
    const $cba1f7031d59cee6$export$648ddf2d1f8b1c3f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cba1f7031d59cee6$export$66850ec5549adba6,
            pageId: "async-jira-eoc-global-ops-reports",
            shouldShowSpinner: false
        });
    const $cba1f7031d59cee6$export$87e6a54b4f5dc91e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cba1f7031d59cee6$export$2404f0e35deca592,
            pageId: "async-jira-eoc-ops-reports",
            shouldShowSpinner: false
        });
    const $cba1f7031d59cee6$export$7f366d77015c286f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cba1f7031d59cee6$export$5fd77c3bbfb22cbd,
            pageId: "async-jira-eoc-ops-reports-unsubscribe",
            shouldShowSpinner: false
        });
});
parcelRegister("jubOI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("1I1Wy")),
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4Hqzh")
    ]).then(()=>parcelRequire('eHCOd'));
});
parcelRegister("bDcJ1", function(module, exports) {
    $parcel$export(module.exports, "eocRoleBasedNotificationsRouteEntries", ()=>$02e4c36ee22bcb25$export$80002c8e4483fef1);
    var $5uXOq = parcelRequire("5uXOq");
    var $8CY9s;
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $iTMlN;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $atU1t;
    var $bh1GB;
    var $5j7Th;
    var $hPtZI;
    const $02e4c36ee22bcb25$export$15a244aba8f3b406 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("e2wkZ")).then((module)=>module.RoleBasedNotificationsPage), {
        moduleId: "./src/packages/eoc/role-based-notifications/src/index.tsx"
    });
    const $02e4c36ee22bcb25$export$5211e5a7ed694f98 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("e2wkZ")).then((module)=>module.RoleBasedNotificationDetail), {
        moduleId: "./src/packages/eoc/role-based-notifications/src/index.tsx"
    });
    const $02e4c36ee22bcb25$export$8994be6f8ad6a04a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $02e4c36ee22bcb25$export$15a244aba8f3b406,
            pageId: "async-jira-eoc-role-based-notifications",
            shouldShowSpinner: false
        });
    const $02e4c36ee22bcb25$export$445112c3a1089cc5 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $02e4c36ee22bcb25$export$5211e5a7ed694f98,
            pageId: "async-jira-eoc-role-based-notifications",
            shouldShowSpinner: false
        });
    const $02e4c36ee22bcb25$export$60de9875bb8ef1d6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bh1GB")).roleBasedNotificationsRoute), ()=>({
            component: $02e4c36ee22bcb25$export$8994be6f8ad6a04a,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("8CY9s")).resources)[0],
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, (0, parcelRequire("iTMlN")).AsyncHorizontalOperationsConfigurationNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("iTMlN")).LazyHorizontalOperationsConfigurationNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $02e4c36ee22bcb25$export$15a244aba8f3b406
            ]
        }));
    const $02e4c36ee22bcb25$export$565325825b04cec6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bh1GB")).roleBasedNotificationsDetailRoute), ()=>({
            component: $02e4c36ee22bcb25$export$8994be6f8ad6a04a,
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            slot: $02e4c36ee22bcb25$export$445112c3a1089cc5,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("8CY9s")).resources)[0],
                (0, (0, parcelRequire("8CY9s")).resources)[1],
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("iTMlN")).LazyHorizontalOperationsConfigurationNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $02e4c36ee22bcb25$export$15a244aba8f3b406
            ]
        }));
    const $02e4c36ee22bcb25$export$80002c8e4483fef1 = [
        $02e4c36ee22bcb25$export$60de9875bb8ef1d6,
        $02e4c36ee22bcb25$export$565325825b04cec6
    ];
});
parcelRegister("8CY9s", function(module, exports) {
    $parcel$export(module.exports, "roleBasedNotificationsResource", ()=>$2490572559687797$export$9a716bf20d804ec3);
    $parcel$export(module.exports, "notificationDetailResource", ()=>$2490572559687797$export$8ad8a0a20fd0ed5a);
    $parcel$export(module.exports, "resources", ()=>$2490572559687797$export$bc99aaabaf7b70a7);
    var $dIdda = parcelRequire("dIdda");
    var $lUMYZ;
    var $2FAs6;
    var $cIGrt;
    const $2490572559687797$export$9a716bf20d804ec3 = (0, $dIdda.createResource)({
        type: 'roleBasedNotificationsResource',
        getKey: ()=>'roleBasedNotificationsResource',
        getData: (0, (0, parcelRequire("cIGrt")).getRoleBasedNotificationsEndpoint),
        isBrowserOnly: true,
        maxAge: 300000
    });
    const $2490572559687797$export$8ad8a0a20fd0ed5a = (0, $dIdda.createResource)({
        type: 'notificationDetailResource',
        getKey: ({ match: match })=>{
            const settingId = match.params['id'];
            return `notificationDetailResource-id=${settingId}`;
        },
        getData: ({ match: match })=>{
            const settingId = match.params['id'];
            (0, (0, parcelRequire("lUMYZ")).assert)(!!settingId, new (0, (0, parcelRequire("2FAs6")).AssertionError)('notificationDetailResource', 'settingId is required'));
            return (0, (0, parcelRequire("cIGrt")).getRoleBasedNotificationDetailEndpoint)(settingId);
        },
        isBrowserOnly: true
    });
    const $2490572559687797$export$bc99aaabaf7b70a7 = [
        $2490572559687797$export$9a716bf20d804ec3,
        $2490572559687797$export$8ad8a0a20fd0ed5a
    ];
});
parcelRegister("cIGrt", function(module, exports) {
    $parcel$export(module.exports, "getRoleBasedNotificationsEndpoint", ()=>$4a5da105b9aa4fd5$export$db67dfe9fe98cd49);
    $parcel$export(module.exports, "getRoleBasedNotificationDetailEndpoint", ()=>$4a5da105b9aa4fd5$export$5522446e6d3ee73);
    var $6GHRr;
    const $4a5da105b9aa4fd5$export$db67dfe9fe98cd49 = ()=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/role-based-notifications`);
    const $4a5da105b9aa4fd5$export$5522446e6d3ee73 = (settingId)=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/role-based-notifications/${settingId}`);
});
parcelRegister("bh1GB", function(module, exports) {
    $parcel$export(module.exports, "roleBasedNotificationsRoute", ()=>$6ac7f6b07af18790$export$5a10092825ee32e4);
    $parcel$export(module.exports, "roleBasedNotificationsDetailRoute", ()=>$6ac7f6b07af18790$export$659aa6d7cd021e4b);
    var $65Ltd;
    const $6ac7f6b07af18790$export$5a10092825ee32e4 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS),
        path: '/jira/settings/products/ops/role-based-notifications',
        exact: true
    };
    const $6ac7f6b07af18790$export$659aa6d7cd021e4b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_ROLE_BASED_NOTIFICATIONS_DETAIL),
        path: '/jira/settings/products/ops/role-based-notifications/:id',
        exact: true
    };
});
parcelRegister("e2wkZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3aNwp")
    ]).then(()=>parcelRequire('2ddPE'));
});
parcelRegister("cPUT6", function(module, exports) {
    $parcel$export(module.exports, "eocScheduleGlobalRouteEntry", ()=>$7f9b61c89fe6f1c9$export$831e8756cdaae4ba);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $lmyls;
    var $2Fj5v;
    var $iTMlN;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $mflLs;
    var $5j7Th;
    var $hPtZI;
    const $7f9b61c89fe6f1c9$var$LazyScheduleGlobalPage = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("aSaEv")).then((m)=>m.ScheduleGlobalPage), {
        moduleId: "./src/packages/eoc/schedule-global/src/ui/index.tsx"
    });
    const $7f9b61c89fe6f1c9$var$EocScheduleGlobalComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7f9b61c89fe6f1c9$var$LazyScheduleGlobalPage,
            pageId: "async-jira-eoc-schedule-global",
            shouldShowSpinner: false
        });
    const $7f9b61c89fe6f1c9$export$831e8756cdaae4ba = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("mflLs")).eocScheduleGlobalRoute), ()=>({
            component: $7f9b61c89fe6f1c9$var$EocScheduleGlobalComponent,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, (0, parcelRequire("iTMlN")).AsyncHorizontalOperationsConfigurationNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("iTMlN")).LazyHorizontalOperationsConfigurationNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $7f9b61c89fe6f1c9$var$LazyScheduleGlobalPage
            ]
        }));
});
parcelRegister("mflLs", function(module, exports) {
    $parcel$export(module.exports, "eocScheduleGlobalRoute", ()=>$6cae6731b8f81714$export$10454dc485142eb6);
    var $65Ltd;
    const $6cae6731b8f81714$export$10454dc485142eb6 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_SCHEDULES),
        path: '/jira/settings/products/ops/schedules',
        exact: true
    };
});
parcelRegister("aSaEv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9nnOd")
    ]).then(()=>parcelRequire('94AYi'));
});
parcelRegister("bkDFu", function(module, exports) {
    $parcel$export(module.exports, "eocTeamAlertListRouteEntries", ()=>$58f11685dabb370d$export$a727cbd3cbcc2153);
    var $kSUuU;
    var $3qG6K;
    var $3vS1t;
    var $ffza4;
    var $lmyls;
    var $3Dk1Z;
    var $fezpN;
    var $h3Ix2;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $czaLN;
    var $cgOQ8;
    const $58f11685dabb370d$export$de37dab3b3ed8e5c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("czaLN")).eocTeamAlertListRoute), ()=>({
            component: (0, (0, parcelRequire("cgOQ8")).default),
            layout: (0, (0, parcelRequire("h3Ix2")).opsTeamLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3vS1t")).resources),
                ...(0, (0, parcelRequire("3qG6K")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, (0, parcelRequire("3Dk1Z")).default),
                horizontal: (0, (0, parcelRequire("fezpN")).AsyncHorizontalOperationsNav),
                onlyShowHorizontalOnNav4: true
            },
            forPaint: [
                (0, (0, parcelRequire("fezpN")).LazyHorizontalOperationsNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("cgOQ8")).LazyAlertList),
                (0, (0, parcelRequire("3Dk1Z")).LazyTeamDashboardSidebar)
            ]
        }));
    const $58f11685dabb370d$export$94aaa7006da9d63a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("czaLN")).eocTeamAlertDetailRoute), ()=>({
            component: (0, (0, parcelRequire("cgOQ8")).default),
            layout: (0, (0, parcelRequire("h3Ix2")).opsTeamLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3vS1t")).resources),
                ...(0, (0, parcelRequire("3qG6K")).resources),
                ...(0, (0, parcelRequire("kSUuU")).resources),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                sidebar: (0, (0, parcelRequire("3Dk1Z")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("cgOQ8")).LazyAlertList),
                (0, (0, parcelRequire("3Dk1Z")).LazyTeamDashboardSidebar)
            ]
        }));
    const $58f11685dabb370d$export$a727cbd3cbcc2153 = [
        $58f11685dabb370d$export$de37dab3b3ed8e5c,
        $58f11685dabb370d$export$94aaa7006da9d63a
    ];
});
parcelRegister("czaLN", function(module, exports) {
    $parcel$export(module.exports, "eocTeamAlertListRoute", ()=>$e47e25e553b4e53f$export$94efd60f23d97aa5);
    $parcel$export(module.exports, "eocTeamAlertDetailRoute", ()=>$e47e25e553b4e53f$export$ac102dc13a0f4aff);
    var $65Ltd;
    const $e47e25e553b4e53f$export$94efd60f23d97aa5 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERTS),
        path: '/jira/ops/teams/:teamId/alerts',
        exact: true
    };
    const $e47e25e553b4e53f$export$ac102dc13a0f4aff = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_ALERT_DETAILS),
        path: '/jira/ops/teams/:teamId/alerts/:id',
        exact: true
    };
});
parcelRegister("cgOQ8", function(module, exports) {
    $parcel$export(module.exports, "LazyAlertList", ()=>$c4eca2f6e4b2f333$export$f4aafff31d950b6c);
    $parcel$export(module.exports, "default", ()=>$c4eca2f6e4b2f333$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $c4eca2f6e4b2f333$export$f4aafff31d950b6c = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("d8hKi")), {
        moduleId: "./src/packages/eoc/alert-list/src/ui/index.tsx"
    });
    var $c4eca2f6e4b2f333$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c4eca2f6e4b2f333$export$f4aafff31d950b6c,
            pageId: "async-jira-eoc-alert-list",
            shouldShowSpinner: false
        });
});
parcelRegister("6uUNA", function(module, exports) {
    $parcel$export(module.exports, "eocTeamCustomerLogsRouteEntry", ()=>$b1cb59fcc9012060$export$42ca979ec2919b23);
    $parcel$export(module.exports, "eocTeamCustomerLogsDownloadRouteEntry", ()=>$b1cb59fcc9012060$export$d2ce6f09ef8aa840);
    var $j0tDD;
    var $ffza4;
    var $9QpK7;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $iTMlN;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $5lsNZ;
    var $1JonP;
    var $8OJXJ;
    const $b1cb59fcc9012060$export$42ca979ec2919b23 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1JonP")).eocTeamCustomerLogsRoute), ()=>({
            component: (0, (0, parcelRequire("8OJXJ")).default),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, (0, parcelRequire("iTMlN")).AsyncHorizontalOperationsConfigurationNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("j0tDD")).resources)
            ],
            forPaint: [
                (0, (0, parcelRequire("iTMlN")).LazyHorizontalOperationsConfigurationNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("8OJXJ")).LazyCustomerLogs)
            ]
        }));
    const $b1cb59fcc9012060$export$d2ce6f09ef8aa840 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1JonP")).eocTeamCustomerLogsDownloadRoute), ()=>({
            component: (0, (0, parcelRequire("9QpK7")).componentWithFF)('platform.pun.audit-logs-export-log-release_dvp2f', (0, (0, parcelRequire("8OJXJ")).CustomerLogsDownloadPage), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            resources: [
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...(0, (0, parcelRequire("j0tDD")).downloadResources)
            ],
            forPaint: [
                (0, (0, parcelRequire("8OJXJ")).LazyCustomerLogsDownLoad)
            ]
        }));
});
parcelRegister("1JonP", function(module, exports) {
    $parcel$export(module.exports, "eocTeamCustomerLogsRoute", ()=>$1e276f535e94effd$export$4b517044f5f7830d);
    $parcel$export(module.exports, "eocTeamCustomerLogsDownloadRoute", ()=>$1e276f535e94effd$export$678856ccddc0bc05);
    var $65Ltd;
    const $1e276f535e94effd$export$4b517044f5f7830d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS),
        path: '/jira/settings/products/ops/jira-service-management-audit-logs',
        exact: true
    };
    const $1e276f535e94effd$export$678856ccddc0bc05 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_TEAM_CUSTOMER_LOGS_DOWNLOAD),
        path: '/jira/settings/products/ops/jira-service-management-audit-logs/download/:exportUniqueKey',
        exact: true
    };
});
parcelRegister("8OJXJ", function(module, exports) {
    $parcel$export(module.exports, "LazyCustomerLogs", ()=>$ff16a0c6b99cd2b6$export$6e30e25faf4f6dce);
    $parcel$export(module.exports, "LazyCustomerLogsDownLoad", ()=>$ff16a0c6b99cd2b6$export$898c7cb3b28a6104);
    $parcel$export(module.exports, "default", ()=>$ff16a0c6b99cd2b6$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "CustomerLogsDownloadPage", ()=>$ff16a0c6b99cd2b6$export$a5786cf859b7b457);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $ff16a0c6b99cd2b6$export$6e30e25faf4f6dce = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("jSpQ7")), {
        moduleId: "./src/packages/eoc/customer-logs/src/index.tsx"
    });
    const $ff16a0c6b99cd2b6$export$898c7cb3b28a6104 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("jSpQ7")).then(({ CustomerLogsDownloadPage: CustomerLogsDownloadPage })=>CustomerLogsDownloadPage), {
        moduleId: "./src/packages/eoc/customer-logs/src/index.tsx"
    });
    var $ff16a0c6b99cd2b6$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ff16a0c6b99cd2b6$export$6e30e25faf4f6dce,
            pageId: "async-jira-eoc-customer-logs",
            shouldShowSpinner: false
        });
    const $ff16a0c6b99cd2b6$export$a5786cf859b7b457 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ff16a0c6b99cd2b6$export$898c7cb3b28a6104,
            pageId: "async-jira-eoc-customer-logs-download",
            shouldShowSpinner: false
        });
});
parcelRegister("jSpQ7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("cVwzB")
    ]).then(()=>parcelRequire('ecO2s'));
});
parcelRegister("fo0m9", function(module, exports) {
    $parcel$export(module.exports, "unlockOperationsRouteEntry", ()=>$82aec00f2e2dda3e$export$c058f4d1c0667ce1);
    var $ffza4;
    var $iqZds;
    var $co1wz;
    var $7XYc4;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $l1EdH;
    var $3RJkv;
    var $5lsNZ;
    var $1hDsb;
    var $3E8Yw;
    const $82aec00f2e2dda3e$export$c058f4d1c0667ce1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1hDsb")).unlockOperationsRoute), ()=>({
            layout: (0, (0, parcelRequire("iqZds")).eocChangeboardingLayout),
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('opsgenie-consolidation-transitioning-state_d7vm9'), (0, (0, parcelRequire("3E8Yw")).default), (0, (0, parcelRequire("5lsNZ")).default)),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("l1EdH")).resources)
            ],
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("3E8Yw")).LazyUnlockOperations)
            ]
        }));
});
parcelRegister("l1EdH", function(module, exports) {
    $parcel$export(module.exports, "resources", ()=>$05907c872dfc2fcc$export$bc99aaabaf7b70a7);
    var $ieJ0b;
    const $05907c872dfc2fcc$export$bc99aaabaf7b70a7 = [
        (0, (0, parcelRequire("ieJ0b")).transitioningDetailsResource)
    ];
});
parcelRegister("ieJ0b", function(module, exports) {
    $parcel$export(module.exports, "transitioningDetailsResource", ()=>$86a5b96e0cefda11$export$850d76e0c9ffbdeb);
    var $jcw0u;
    var $eusud;
    var $dIdda = parcelRequire("dIdda");
    const $86a5b96e0cefda11$export$7985153d37586c9a = (cloudId)=>(0, (0, parcelRequire("eusud")).performGetRequest)(`/gateway/api/jsm/ops/web/${cloudId}/v1/customers/transitioning-details`).catch((err)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getTransitioningDetails',
                    packageName: 'jiraRouterResourcesEocUnlockOperations',
                    teamName: 'alexstrasza'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        });
    const $86a5b96e0cefda11$export$850d76e0c9ffbdeb = (0, $dIdda.createResource)({
        type: 'EOC_UNLOCK_OPERATIONS',
        getKey: ()=>'eoc-unlock-operations',
        getData: async (_, { tenantContext: { cloudId: cloudId } })=>$86a5b96e0cefda11$export$7985153d37586c9a(cloudId),
        maxAge: 0,
        isBrowserOnly: true
    });
});
parcelRegister("1hDsb", function(module, exports) {
    $parcel$export(module.exports, "unlockOperationsRoute", ()=>$c1d60f0c94994434$export$30306de7e00bc5a2);
    var $65Ltd;
    const $c1d60f0c94994434$export$30306de7e00bc5a2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_UNLOCK_OPERATIONS),
        path: '/jira/settings/products/ops/unlock',
        exact: true
    };
});
parcelRegister("3E8Yw", function(module, exports) {
    $parcel$export(module.exports, "LazyUnlockOperations", ()=>$c4c082612871271f$export$55e4754d556d072);
    $parcel$export(module.exports, "default", ()=>$c4c082612871271f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $c4c082612871271f$export$55e4754d556d072 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("8Piip")), {
        moduleId: "./src/packages/eoc/unlock-operations/src/index.tsx"
    });
    var $c4c082612871271f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c4c082612871271f$export$55e4754d556d072,
            pageId: "eoc-products-unlock-operations",
            shouldShowSpinner: false
        });
});
parcelRegister("8Piip", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("laeSv")
    ]).then(()=>parcelRequire('1lA3p'));
});
parcelRegister("7q9tl", function(module, exports) {
    $parcel$export(module.exports, "whoIsOnCallRouteEntry", ()=>$0b947f3e1def635b$export$fee33ca9661e49dd);
    var $5uXOq = parcelRequire("5uXOq");
    var $lPj61;
    var $ffza4;
    var $iqZds;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $5Dlsd;
    var $5j7Th;
    var $hPtZI;
    const $0b947f3e1def635b$export$7b03e7437c5d4f77 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("c2Cr1")), {
        moduleId: "./src/packages/eoc/who-is-on-call/src/ui/index.tsx"
    });
    const $0b947f3e1def635b$export$51430a0cf6ef3c09 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0b947f3e1def635b$export$7b03e7437c5d4f77,
            pageId: "async-jira-eoc-who-is-on-call",
            shouldShowSpinner: false
        });
    const $0b947f3e1def635b$export$fee33ca9661e49dd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Dlsd")).whoIsOnCallRoute), ()=>({
            layout: (0, (0, parcelRequire("iqZds")).eocChangeboardingLayout),
            component: $0b947f3e1def635b$export$51430a0cf6ef3c09,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...(0, (0, parcelRequire("lPj61")).resources)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $0b947f3e1def635b$export$7b03e7437c5d4f77
            ]
        }));
});
parcelRegister("lPj61", function(module, exports) {
    $parcel$export(module.exports, "resources", ()=>$68cd0c6e90609015$export$bc99aaabaf7b70a7);
    $parcel$export(module.exports, "widgetResources", ()=>$68cd0c6e90609015$export$bce3244764eac6e6);
    $parcel$export(module.exports, "createMyTeamsResource", ()=>(parcelRequire("bxazU")).createMyTeamsResource);
    $parcel$export(module.exports, "createStatusResource", ()=>(parcelRequire("chS2w")).createStatusResource);
    $parcel$export(module.exports, "createUserTimelineResource", ()=>(parcelRequire("bQMQs")).createUserTimelineResource);
    $parcel$export(module.exports, "createSchedulesResource", ()=>(parcelRequire("7efXe")).createSchedulesResource);
    parcelRequire("c4sFg");
    var $5NVbt;
    var $bxazU;
    var $jxggJ;
    var $7efXe;
    var $chS2w;
    var $bQMQs;
    const $68cd0c6e90609015$export$bc99aaabaf7b70a7 = [
        (0, (0, parcelRequire("5NVbt")).eocUserResource),
        (0, (0, parcelRequire("bxazU")).createMyTeamsResource)(),
        (0, (0, parcelRequire("chS2w")).createStatusResource)(),
        (0, (0, parcelRequire("jxggJ")).createOpsTeamsResource)()
    ];
    const $68cd0c6e90609015$export$bce3244764eac6e6 = [
        ()=>(0, (0, parcelRequire("5NVbt")).eocUserResource),
        (callback, depends)=>(0, (0, parcelRequire("bxazU")).createMyTeamsResource)(callback, depends),
        (callback, depends)=>(0, (0, parcelRequire("chS2w")).createStatusResource)(callback, depends),
        (callback, depends)=>(0, (0, parcelRequire("bQMQs")).createUserTimelineResource)(callback, depends),
        (callback, depends)=>(0, (0, parcelRequire("7efXe")).createSchedulesResource)(callback, depends)
    ];
});
parcelRegister("bxazU", function(module, exports) {
    $parcel$export(module.exports, "createMyTeamsResource", ()=>$d1b957e4f8046598$export$bf86fb90d0661bcb);
    var $dIdda = parcelRequire("dIdda");
    var $jqX1v;
    const $d1b957e4f8046598$export$bf86fb90d0661bcb = (checkConsolidationOnRouteDependency, depends)=>(0, $dIdda.createResource)({
            type: 'myTeamsResource',
            getKey: ()=>'myTeamsResource',
            getData: async ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("jqX1v")).getMyTeamsEndpoint)();
            },
            isBrowserOnly: true,
            depends: depends
        });
});
parcelRegister("jqX1v", function(module, exports) {
    $parcel$export(module.exports, "getMyTeamsEndpoint", ()=>$db8f762642a18589$export$abe46da7d1f191a7);
    var $6GHRr;
    const $db8f762642a18589$export$abe46da7d1f191a7 = ()=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/alerts/responders/suggested`);
    };
});
parcelRegister("jxggJ", function(module, exports) {
    $parcel$export(module.exports, "createOpsTeamsResource", ()=>$fad29276ce44d157$export$99505a9d792f516c);
    var $dIdda = parcelRequire("dIdda");
    var $cfPS2;
    const $fad29276ce44d157$export$99505a9d792f516c = (checkConsolidationOnRouteDependency, depends)=>(0, $dIdda.createResource)({
            type: 'opsTeamsResource',
            getKey: ()=>'opsTeamsResource',
            getData: async ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("cfPS2")).getOpsTeamsEndpoint)().then((response)=>{
                    return response.values;
                });
            },
            isBrowserOnly: true,
            depends: depends
        });
});
parcelRegister("cfPS2", function(module, exports) {
    $parcel$export(module.exports, "getOpsTeamsEndpoint", ()=>$6e7a6d94857f00e7$export$7498ba30158c16cd);
    var $6GHRr;
    var $aabIo;
    const $6e7a6d94857f00e7$export$7498ba30158c16cd = ()=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("aabIo")).urls).teams.url());
    };
});
parcelRegister("aabIo", function(module, exports) {
    $parcel$export(module.exports, "urls", ()=>$03f512f395ba1134$export$bcae9ba627f604b6);
    $parcel$export(module.exports, "SPOTLIGHT_NAMES", ()=>$03f512f395ba1134$export$a7c923252528b255);
    $parcel$export(module.exports, "SPOTLIGHT_TOURS", ()=>$03f512f395ba1134$export$38c46ed7a5bc80a0);
    $parcel$export(module.exports, "WhoIsOnCallHandler", ()=>$03f512f395ba1134$export$1e7191618d5d4548);
    $parcel$export(module.exports, "WhoIsOnCallWidgetHandler", ()=>$03f512f395ba1134$export$d05bbb1ada0e07c4);
    const $03f512f395ba1134$export$bcae9ba627f604b6 = Object.freeze({
        schedules: {
            url: ()=>`/v1/schedules`,
            user: {
                url: ()=>`${$03f512f395ba1134$export$bcae9ba627f604b6.schedules.url()}/user`,
                timeline: {
                    url: ()=>`${$03f512f395ba1134$export$bcae9ba627f604b6.schedules.user.url()}/timeline`,
                    export: {
                        url: ()=>`${$03f512f395ba1134$export$bcae9ba627f604b6.schedules.user.timeline.url()}/export`
                    }
                },
                userId: {
                    url: ({ userId: userId } = {
                        userId: ':userId'
                    })=>`${$03f512f395ba1134$export$bcae9ba627f604b6.schedules.user.url()}/${userId}`
                }
            },
            onCalls: {
                url: ()=>`${$03f512f395ba1134$export$bcae9ba627f604b6.schedules.url()}/on-calls`
            },
            scheduleId: {
                url: ({ scheduleId: scheduleId } = {
                    scheduleId: ':scheduleId'
                })=>`${$03f512f395ba1134$export$bcae9ba627f604b6.schedules.url()}/${scheduleId}`,
                timeline: {
                    url: ({ scheduleId: scheduleId } = {
                        scheduleId: ':scheduleId'
                    })=>`${$03f512f395ba1134$export$bcae9ba627f604b6.schedules.scheduleId.url({
                            scheduleId: scheduleId
                        })}/timeline`
                }
            }
        },
        wioc: {
            status: {
                url: ()=>`${$03f512f395ba1134$export$bcae9ba627f604b6.schedules.url()}/user/on-calls`
            }
        },
        teams: {
            url: ()=>`/v1/teams`
        }
    });
    const $03f512f395ba1134$export$a7c923252528b255 = {
        firstOverlappingPeriod: 'eoc-who-is-on-call_first_overlapping_period'
    };
    const $03f512f395ba1134$export$38c46ed7a5bc80a0 = {
        overlappingPeriod: 'eoc-who-is-on-call-overlapping-period'
    };
    class $03f512f395ba1134$export$1e7191618d5d4548 {
        handler(message, context) {
            throw new Error('Not implemented');
        }
    }
    class $03f512f395ba1134$export$d05bbb1ada0e07c4 {
        handler(message, context) {
            throw new Error('Not implemented');
        }
    }
});
parcelRegister("7efXe", function(module, exports) {
    $parcel$export(module.exports, "createSchedulesResource", ()=>$a87ce7b6eedfea69$export$b5e65ca3f82b01c5);
    var $dIdda = parcelRequire("dIdda");
    var $kTx1Z;
    const $a87ce7b6eedfea69$export$b5e65ca3f82b01c5 = (checkConsolidationOnRouteDependency, depends)=>(0, $dIdda.createResource)({
            type: 'schedulesResource',
            getKey: ()=>'schedulesResource',
            getData: async ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("kTx1Z")).getSchedulesEndpoint)();
            },
            isBrowserOnly: true,
            depends: depends
        });
});
parcelRegister("kTx1Z", function(module, exports) {
    $parcel$export(module.exports, "getSchedulesEndpoint", ()=>$83657c13527f49dc$export$e8e940098db1b988);
    var $6GHRr;
    var $aabIo;
    const $83657c13527f49dc$export$e8e940098db1b988 = ()=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`${(0, (0, parcelRequire("aabIo")).urls).schedules.onCalls.url()}`);
    };
});
parcelRegister("chS2w", function(module, exports) {
    $parcel$export(module.exports, "createStatusResource", ()=>$16a8c68ce35cf520$export$3d1c353e2693418c);
    var $dIdda = parcelRequire("dIdda");
    var $hCi4O;
    var $2SqJr;
    const $16a8c68ce35cf520$export$3d1c353e2693418c = (checkConsolidationOnRouteDependency, depends)=>(0, $dIdda.createResource)({
            type: 'statusResource',
            getKey: ()=>'statusResource',
            getData: async ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("hCi4O")).getStatus)().then((0, (0, parcelRequire("2SqJr")).transformStatusResponse));
            },
            isBrowserOnly: true,
            depends: depends
        });
});
parcelRegister("hCi4O", function(module, exports) {
    $parcel$export(module.exports, "getStatus", ()=>$748195afd0964b55$export$b70265791d2079d4);
    var $6GHRr;
    var $aabIo;
    const $748195afd0964b55$export$b70265791d2079d4 = ()=>{
        return (0, (0, parcelRequire("6GHRr")).eocFetch)((0, (0, parcelRequire("aabIo")).urls).wioc.status.url(), {
            method: 'GET'
        });
    };
});
parcelRegister("2SqJr", function(module, exports) {
    $parcel$export(module.exports, "transformStatusResponse", ()=>$b7a3f9438039fbe8$export$44a749c89534e42c);
    const $b7a3f9438039fbe8$export$44a749c89534e42c = ({ currentTimeUtcMillis: currentTimeUtcMillis, onCallUntilUtcMillis: onCallUntilUtcMillis, onCallUntilOffsetMillis: onCallUntilOffsetMillis, isCurrentOnCall: isCurrentOnCall, isParticipantOfAnyRotation: isParticipantOfAnyRotation, nextOnCallEndUtcMillis: nextOnCallEndUtcMillis, nextOnCallEndOffsetMillis: nextOnCallEndOffsetMillis, nextOnCallStartUtcMillis: nextOnCallStartUtcMillis, nextOnCallStartOffsetMillis: nextOnCallStartOffsetMillis })=>{
        return {
            currentDate: currentTimeUtcMillis,
            currentShiftEnd: onCallUntilUtcMillis,
            currentShiftEndOffset: onCallUntilOffsetMillis,
            isOnCall: isCurrentOnCall,
            isParticipantOfAnyRotation: isParticipantOfAnyRotation,
            nextEndDate: nextOnCallEndUtcMillis,
            nextEndOffset: nextOnCallEndOffsetMillis,
            nextStartDate: nextOnCallStartUtcMillis,
            nextStartOffset: nextOnCallStartOffsetMillis
        };
    };
});
parcelRegister("bQMQs", function(module, exports) {
    $parcel$export(module.exports, "createUserTimelineResource", ()=>$accf1372fb604bbc$export$a479dcc35c33def1);
    var $dIdda = parcelRequire("dIdda");
    parcelRequire("c4sFg");
    var $5NVbt;
    var $dNyHj;
    const $accf1372fb604bbc$export$a479dcc35c33def1 = (checkConsolidationOnRouteDependency, depends)=>(0, $dIdda.createResource)({
            type: 'userTimelineResource',
            getKey: ()=>'userTimelineResource',
            getData: async ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                const data = await dependencies[(0, (0, parcelRequire("5NVbt")).eocUserResource).type]?.promise;
                const accountId = data?.accountId;
                const timezone = data?.timeZone;
                if (!accountId || !timezone) return null;
                return (0, (0, parcelRequire("dNyHj")).getWidgetTimeline)(accountId);
            },
            isBrowserOnly: true,
            depends: [
                ...depends ? depends : [],
                (0, (0, parcelRequire("5NVbt")).eocUserResource).type
            ]
        });
});
parcelRegister("dNyHj", function(module, exports) {
    $parcel$export(module.exports, "getWidgetTimeline", ()=>$dca9b885266f6875$export$bd80cae08a85b1f0);
    var $gr1DO;
    var $6GHRr;
    var $aabIo;
    var $7zIYP;
    const $dca9b885266f6875$export$bd80cae08a85b1f0 = (accountId)=>{
        const formattedCurrent = (0, (0, parcelRequire("gr1DO")).default)(new Date(), 'UTC', "yyyy-MM-dd'T'HH:mm:ss.SSSXX");
        const urlParams = new URLSearchParams({
            currentDate: formattedCurrent,
            accountId: accountId,
            mode: 'timeline',
            timelineType: '6'
        });
        return (0, (0, parcelRequire("6GHRr")).eocFetch)(`${(0, (0, parcelRequire("aabIo")).urls).schedules.user.timeline.url()}?${urlParams.toString()}`, {
            method: 'GET'
        }).then((0, (0, parcelRequire("7zIYP")).transformUserTimelineResponse));
    };
});
parcelRegister("gr1DO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bf7070d90aa90bbf$export$2e2bcd8739ae039);
    var $fwbX5;
    var $klL8P;
    var $2QEk5;
    function $bf7070d90aa90bbf$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
        var extendedOptions = (0, ($parcel$interopDefault((0, parcelRequire("fwbX5")))))(options);
        extendedOptions.timeZone = timeZone;
        extendedOptions.originalDate = date;
        return (0, (0, parcelRequire("klL8P")).default)((0, (0, parcelRequire("2QEk5")).default)(date, timeZone), formatStr, extendedOptions);
    }
});
parcelRegister("fwbX5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $b4c31d9870379ac2$var$cloneObject;
    var $b4c31d9870379ac2$var$_index = $b4c31d9870379ac2$var$_interopRequireDefault((parcelRequire("cpl5v")));
    function $b4c31d9870379ac2$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $b4c31d9870379ac2$var$cloneObject(dirtyObject) {
        return (0, $b4c31d9870379ac2$var$_index.default)({}, dirtyObject);
    }
    module.exports = module.exports.default;
});
parcelRegister("cpl5v", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $90882d6ff669df4d$var$assign;
    function $90882d6ff669df4d$var$assign(target, dirtyObject) {
        if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
        dirtyObject = dirtyObject || {};
        for(var property in dirtyObject)if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) target[property] = dirtyObject[property];
        return target;
    }
    module.exports = module.exports.default;
});
parcelRegister("klL8P", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed0a5618e671c639$export$2e2bcd8739ae039);
    var $aR9Qf;
    var $hSWQe;
    var $8Bm5s;
    var $ed0a5618e671c639$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
    function $ed0a5618e671c639$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
        var formatStr = String(dirtyFormatStr);
        var options = dirtyOptions || {};
        var matches = formatStr.match($ed0a5618e671c639$var$tzFormattingTokensRegExp);
        if (matches) {
            var date = (0, (0, parcelRequire("8Bm5s")).default)(options.originalDate || dirtyDate, options);
            formatStr = matches.reduce(function(result, token) {
                if (token[0] === "'") return result;
                var pos = result.indexOf(token);
                var precededByQuotedSection = result[pos - 1] === "'";
                var replaced = result.replace(token, "'" + (0, (0, parcelRequire("hSWQe")).default)[token[0]](date, token, null, options) + "'");
                return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
            }, formatStr);
        }
        return (0, ($parcel$interopDefault((0, parcelRequire("aR9Qf")))))(dirtyDate, formatStr, options);
    }
});
parcelRegister("aR9Qf", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $7e767cfeba790ebe$var$format;
    var $7e767cfeba790ebe$var$_index = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("ck8JK")));
    var $7e767cfeba790ebe$var$_index2 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("kvNR5")));
    var $7e767cfeba790ebe$var$_index3 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("bQkcE")));
    var $7e767cfeba790ebe$var$_index4 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $7e767cfeba790ebe$var$_index5 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("3ckvK")));
    var $7e767cfeba790ebe$var$_index6 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("awKAW")));
    var $7e767cfeba790ebe$var$_index7 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("jGQTC")));
    var $5qguX;
    var $7e767cfeba790ebe$var$_index9 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $7e767cfeba790ebe$var$_index10 = $7e767cfeba790ebe$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $7e767cfeba790ebe$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $7e767cfeba790ebe$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
    var $7e767cfeba790ebe$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    var $7e767cfeba790ebe$var$escapedStringRegExp = /^'([^]*?)'?$/;
    var $7e767cfeba790ebe$var$doubleQuoteRegExp = /''/g;
    var $7e767cfeba790ebe$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
    function $7e767cfeba790ebe$var$format(dirtyDate, dirtyFormatStr, dirtyOptions) {
        (0, $7e767cfeba790ebe$var$_index10.default)(2, arguments);
        var formatStr = String(dirtyFormatStr);
        var options = dirtyOptions || {};
        var locale = options.locale || $7e767cfeba790ebe$var$_index2.default;
        var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $7e767cfeba790ebe$var$_index9.default)(localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $7e767cfeba790ebe$var$_index9.default)(options.firstWeekContainsDate);
        if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
        var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $7e767cfeba790ebe$var$_index9.default)(localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $7e767cfeba790ebe$var$_index9.default)(options.weekStartsOn);
        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
        if (!locale.localize) throw new RangeError('locale must contain localize property');
        if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
        var originalDate = (0, $7e767cfeba790ebe$var$_index4.default)(dirtyDate);
        if (!(0, $7e767cfeba790ebe$var$_index.default)(originalDate)) throw new RangeError('Invalid time value');
        var timezoneOffset = (0, $7e767cfeba790ebe$var$_index7.default)(originalDate);
        var utcDate = (0, $7e767cfeba790ebe$var$_index3.default)(originalDate, timezoneOffset);
        var formatterOptions = {
            firstWeekContainsDate: firstWeekContainsDate,
            weekStartsOn: weekStartsOn,
            locale: locale,
            _originalDate: originalDate
        };
        var result = formatStr.match($7e767cfeba790ebe$var$longFormattingTokensRegExp).map(function(substring) {
            var firstCharacter = substring[0];
            if (firstCharacter === 'p' || firstCharacter === 'P') {
                var longFormatter = $7e767cfeba790ebe$var$_index6.default[firstCharacter];
                return longFormatter(substring, locale.formatLong, formatterOptions);
            }
            return substring;
        }).join('').match($7e767cfeba790ebe$var$formattingTokensRegExp).map(function(substring) {
            if (substring === "''") return "'";
            var firstCharacter = substring[0];
            if (firstCharacter === "'") return $7e767cfeba790ebe$var$cleanEscapedString(substring);
            var formatter = $7e767cfeba790ebe$var$_index5.default[firstCharacter];
            if (formatter) {
                if (!options.useAdditionalWeekYearTokens && (0, (0, parcelRequire("5qguX")).isProtectedWeekYearToken)(substring)) (0, (0, parcelRequire("5qguX")).throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
                if (!options.useAdditionalDayOfYearTokens && (0, (0, parcelRequire("5qguX")).isProtectedDayOfYearToken)(substring)) (0, (0, parcelRequire("5qguX")).throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
                return formatter(utcDate, substring, locale.localize, formatterOptions);
            }
            if (firstCharacter.match($7e767cfeba790ebe$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
            return substring;
        }).join('');
        return result;
    }
    function $7e767cfeba790ebe$var$cleanEscapedString(input) {
        return input.match($7e767cfeba790ebe$var$escapedStringRegExp)[1].replace($7e767cfeba790ebe$var$doubleQuoteRegExp, "'");
    }
    module.exports = module.exports.default;
});
parcelRegister("ck8JK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $8f8e2146dfa1d727$var$isValid;
    var $8f8e2146dfa1d727$var$_index = $8f8e2146dfa1d727$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $8f8e2146dfa1d727$var$_index2 = $8f8e2146dfa1d727$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $8f8e2146dfa1d727$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $8f8e2146dfa1d727$var$isValid(dirtyDate) {
        (0, $8f8e2146dfa1d727$var$_index2.default)(1, arguments);
        var date = (0, $8f8e2146dfa1d727$var$_index.default)(dirtyDate);
        return !isNaN(date);
    }
    module.exports = module.exports.default;
});
parcelRegister("2pWQP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $1c2b912e6615b0b5$var$toDate;
    var $1c2b912e6615b0b5$var$_index = $1c2b912e6615b0b5$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $1c2b912e6615b0b5$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $1c2b912e6615b0b5$var$toDate(argument) {
        (0, $1c2b912e6615b0b5$var$_index.default)(1, arguments);
        var argStr = Object.prototype.toString.call(argument);
        if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') return new Date(argument.getTime());
        else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
        else {
            if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
                console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule");
                console.warn(new Error().stack);
            }
            return new Date(NaN);
        }
    }
    module.exports = module.exports.default;
});
parcelRegister("6eBfj", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $48a0f126c2293ab3$var$requiredArgs;
    function $48a0f126c2293ab3$var$requiredArgs(required, args) {
        if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
    }
    module.exports = module.exports.default;
});
parcelRegister("kvNR5", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eeed6020e120f946$var$_index = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("5u9TK")));
    var $eeed6020e120f946$var$_index2 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("e7AgV")));
    var $eeed6020e120f946$var$_index3 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("8U2eY")));
    var $eeed6020e120f946$var$_index4 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("b9d75")));
    var $eeed6020e120f946$var$_index5 = $eeed6020e120f946$var$_interopRequireDefault((parcelRequire("hHwuU")));
    function $eeed6020e120f946$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $eeed6020e120f946$var$locale = {
        code: 'en-US',
        formatDistance: $eeed6020e120f946$var$_index.default,
        formatLong: $eeed6020e120f946$var$_index2.default,
        formatRelative: $eeed6020e120f946$var$_index3.default,
        localize: $eeed6020e120f946$var$_index4.default,
        match: $eeed6020e120f946$var$_index5.default,
        options: {
            weekStartsOn: 0,
            firstWeekContainsDate: 1
        }
    };
    var $eeed6020e120f946$var$_default = $eeed6020e120f946$var$locale;
    module.exports.default = $eeed6020e120f946$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("5u9TK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $3fe76ea3cd34e32f$var$formatDistance;
    var $3fe76ea3cd34e32f$var$formatDistanceLocale = {
        lessThanXSeconds: {
            one: 'less than a second',
            other: 'less than {{count}} seconds'
        },
        xSeconds: {
            one: '1 second',
            other: '{{count}} seconds'
        },
        halfAMinute: 'half a minute',
        lessThanXMinutes: {
            one: 'less than a minute',
            other: 'less than {{count}} minutes'
        },
        xMinutes: {
            one: '1 minute',
            other: '{{count}} minutes'
        },
        aboutXHours: {
            one: 'about 1 hour',
            other: 'about {{count}} hours'
        },
        xHours: {
            one: '1 hour',
            other: '{{count}} hours'
        },
        xDays: {
            one: '1 day',
            other: '{{count}} days'
        },
        aboutXWeeks: {
            one: 'about 1 week',
            other: 'about {{count}} weeks'
        },
        xWeeks: {
            one: '1 week',
            other: '{{count}} weeks'
        },
        aboutXMonths: {
            one: 'about 1 month',
            other: 'about {{count}} months'
        },
        xMonths: {
            one: '1 month',
            other: '{{count}} months'
        },
        aboutXYears: {
            one: 'about 1 year',
            other: 'about {{count}} years'
        },
        xYears: {
            one: '1 year',
            other: '{{count}} years'
        },
        overXYears: {
            one: 'over 1 year',
            other: 'over {{count}} years'
        },
        almostXYears: {
            one: 'almost 1 year',
            other: 'almost {{count}} years'
        }
    };
    function $3fe76ea3cd34e32f$var$formatDistance(token, count, options) {
        options = options || {};
        var result;
        if (typeof $3fe76ea3cd34e32f$var$formatDistanceLocale[token] === 'string') result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token];
        else if (count === 1) result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token].one;
        else result = $3fe76ea3cd34e32f$var$formatDistanceLocale[token].other.replace('{{count}}', count);
        if (options.addSuffix) {
            if (options.comparison > 0) return 'in ' + result;
            else return result + ' ago';
        }
        return result;
    }
    module.exports = module.exports.default;
});
parcelRegister("e7AgV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $a47ddb0366100c31$var$_index = $a47ddb0366100c31$var$_interopRequireDefault((parcelRequire("4raqC")));
    function $a47ddb0366100c31$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $a47ddb0366100c31$var$dateFormats = {
        full: 'EEEE, MMMM do, y',
        long: 'MMMM do, y',
        medium: 'MMM d, y',
        short: 'MM/dd/yyyy'
    };
    var $a47ddb0366100c31$var$timeFormats = {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a'
    };
    var $a47ddb0366100c31$var$dateTimeFormats = {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
    };
    var $a47ddb0366100c31$var$formatLong = {
        date: (0, $a47ddb0366100c31$var$_index.default)({
            formats: $a47ddb0366100c31$var$dateFormats,
            defaultWidth: 'full'
        }),
        time: (0, $a47ddb0366100c31$var$_index.default)({
            formats: $a47ddb0366100c31$var$timeFormats,
            defaultWidth: 'full'
        }),
        dateTime: (0, $a47ddb0366100c31$var$_index.default)({
            formats: $a47ddb0366100c31$var$dateTimeFormats,
            defaultWidth: 'full'
        })
    };
    var $a47ddb0366100c31$var$_default = $a47ddb0366100c31$var$formatLong;
    module.exports.default = $a47ddb0366100c31$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("4raqC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $33b1c5e9f7814c0e$var$buildFormatLongFn;
    function $33b1c5e9f7814c0e$var$buildFormatLongFn(args) {
        return function() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var width = options.width ? String(options.width) : args.defaultWidth;
            var format = args.formats[width] || args.formats[args.defaultWidth];
            return format;
        };
    }
    module.exports = module.exports.default;
});
parcelRegister("8U2eY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $67b54aa1e07b4b42$var$formatRelative;
    var $67b54aa1e07b4b42$var$formatRelativeLocale = {
        lastWeek: "'last' eeee 'at' p",
        yesterday: "'yesterday at' p",
        today: "'today at' p",
        tomorrow: "'tomorrow at' p",
        nextWeek: "eeee 'at' p",
        other: 'P'
    };
    function $67b54aa1e07b4b42$var$formatRelative(token, _date, _baseDate, _options) {
        return $67b54aa1e07b4b42$var$formatRelativeLocale[token];
    }
    module.exports = module.exports.default;
});
parcelRegister("b9d75", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $81dab50370972ecd$var$_index = $81dab50370972ecd$var$_interopRequireDefault((parcelRequire("llBmH")));
    function $81dab50370972ecd$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $81dab50370972ecd$var$eraValues = {
        narrow: [
            'B',
            'A'
        ],
        abbreviated: [
            'BC',
            'AD'
        ],
        wide: [
            'Before Christ',
            'Anno Domini'
        ]
    };
    var $81dab50370972ecd$var$quarterValues = {
        narrow: [
            '1',
            '2',
            '3',
            '4'
        ],
        abbreviated: [
            'Q1',
            'Q2',
            'Q3',
            'Q4'
        ],
        wide: [
            '1st quarter',
            '2nd quarter',
            '3rd quarter',
            '4th quarter'
        ]
    };
    var $81dab50370972ecd$var$monthValues = {
        narrow: [
            'J',
            'F',
            'M',
            'A',
            'M',
            'J',
            'J',
            'A',
            'S',
            'O',
            'N',
            'D'
        ],
        abbreviated: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        wide: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ]
    };
    var $81dab50370972ecd$var$dayValues = {
        narrow: [
            'S',
            'M',
            'T',
            'W',
            'T',
            'F',
            'S'
        ],
        short: [
            'Su',
            'Mo',
            'Tu',
            'We',
            'Th',
            'Fr',
            'Sa'
        ],
        abbreviated: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ],
        wide: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ]
    };
    var $81dab50370972ecd$var$dayPeriodValues = {
        narrow: {
            am: 'a',
            pm: 'p',
            midnight: 'mi',
            noon: 'n',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night'
        },
        abbreviated: {
            am: 'AM',
            pm: 'PM',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night'
        },
        wide: {
            am: 'a.m.',
            pm: 'p.m.',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'morning',
            afternoon: 'afternoon',
            evening: 'evening',
            night: 'night'
        }
    };
    var $81dab50370972ecd$var$formattingDayPeriodValues = {
        narrow: {
            am: 'a',
            pm: 'p',
            midnight: 'mi',
            noon: 'n',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night'
        },
        abbreviated: {
            am: 'AM',
            pm: 'PM',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night'
        },
        wide: {
            am: 'a.m.',
            pm: 'p.m.',
            midnight: 'midnight',
            noon: 'noon',
            morning: 'in the morning',
            afternoon: 'in the afternoon',
            evening: 'in the evening',
            night: 'at night'
        }
    };
    function $81dab50370972ecd$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        var rem100 = number % 100;
        if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
            case 1:
                return number + 'st';
            case 2:
                return number + 'nd';
            case 3:
                return number + 'rd';
        }
        return number + 'th';
    }
    var $81dab50370972ecd$var$localize = {
        ordinalNumber: $81dab50370972ecd$var$ordinalNumber,
        era: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$eraValues,
            defaultWidth: 'wide'
        }),
        quarter: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$quarterValues,
            defaultWidth: 'wide',
            argumentCallback: function(quarter) {
                return Number(quarter) - 1;
            }
        }),
        month: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$monthValues,
            defaultWidth: 'wide'
        }),
        day: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$dayValues,
            defaultWidth: 'wide'
        }),
        dayPeriod: (0, $81dab50370972ecd$var$_index.default)({
            values: $81dab50370972ecd$var$dayPeriodValues,
            defaultWidth: 'wide',
            formattingValues: $81dab50370972ecd$var$formattingDayPeriodValues,
            defaultFormattingWidth: 'wide'
        })
    };
    var $81dab50370972ecd$var$_default = $81dab50370972ecd$var$localize;
    module.exports.default = $81dab50370972ecd$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("llBmH", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $f8a88b0d5d631bc1$var$buildLocalizeFn;
    function $f8a88b0d5d631bc1$var$buildLocalizeFn(args) {
        return function(dirtyIndex, dirtyOptions) {
            var options = dirtyOptions || {};
            var context = options.context ? String(options.context) : 'standalone';
            var valuesArray;
            if (context === 'formatting' && args.formattingValues) {
                var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
                var width = options.width ? String(options.width) : defaultWidth;
                valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
            } else {
                var _defaultWidth = args.defaultWidth;
                var _width = options.width ? String(options.width) : args.defaultWidth;
                valuesArray = args.values[_width] || args.values[_defaultWidth];
            }
            var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
            return valuesArray[index];
        };
    }
    module.exports = module.exports.default;
});
parcelRegister("hHwuU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ce2fa922bf4a591b$var$_index = $ce2fa922bf4a591b$var$_interopRequireDefault((parcelRequire("1IY7t")));
    var $ce2fa922bf4a591b$var$_index2 = $ce2fa922bf4a591b$var$_interopRequireDefault((parcelRequire("liduU")));
    function $ce2fa922bf4a591b$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $ce2fa922bf4a591b$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
    var $ce2fa922bf4a591b$var$parseOrdinalNumberPattern = /\d+/i;
    var $ce2fa922bf4a591b$var$matchEraPatterns = {
        narrow: /^(b|a)/i,
        abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
        wide: /^(before christ|before common era|anno domini|common era)/i
    };
    var $ce2fa922bf4a591b$var$parseEraPatterns = {
        any: [
            /^b/i,
            /^(a|c)/i
        ]
    };
    var $ce2fa922bf4a591b$var$matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](th|st|nd|rd)? quarter/i
    };
    var $ce2fa922bf4a591b$var$parseQuarterPatterns = {
        any: [
            /1/i,
            /2/i,
            /3/i,
            /4/i
        ]
    };
    var $ce2fa922bf4a591b$var$matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
        wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
    };
    var $ce2fa922bf4a591b$var$parseMonthPatterns = {
        narrow: [
            /^j/i,
            /^f/i,
            /^m/i,
            /^a/i,
            /^m/i,
            /^j/i,
            /^j/i,
            /^a/i,
            /^s/i,
            /^o/i,
            /^n/i,
            /^d/i
        ],
        any: [
            /^ja/i,
            /^f/i,
            /^mar/i,
            /^ap/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^au/i,
            /^s/i,
            /^o/i,
            /^n/i,
            /^d/i
        ]
    };
    var $ce2fa922bf4a591b$var$matchDayPatterns = {
        narrow: /^[smtwf]/i,
        short: /^(su|mo|tu|we|th|fr|sa)/i,
        abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
        wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
    };
    var $ce2fa922bf4a591b$var$parseDayPatterns = {
        narrow: [
            /^s/i,
            /^m/i,
            /^t/i,
            /^w/i,
            /^t/i,
            /^f/i,
            /^s/i
        ],
        any: [
            /^su/i,
            /^m/i,
            /^tu/i,
            /^w/i,
            /^th/i,
            /^f/i,
            /^sa/i
        ]
    };
    var $ce2fa922bf4a591b$var$matchDayPeriodPatterns = {
        narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
        any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
    };
    var $ce2fa922bf4a591b$var$parseDayPeriodPatterns = {
        any: {
            am: /^a/i,
            pm: /^p/i,
            midnight: /^mi/i,
            noon: /^no/i,
            morning: /morning/i,
            afternoon: /afternoon/i,
            evening: /evening/i,
            night: /night/i
        }
    };
    var $ce2fa922bf4a591b$var$match = {
        ordinalNumber: (0, $ce2fa922bf4a591b$var$_index.default)({
            matchPattern: $ce2fa922bf4a591b$var$matchOrdinalNumberPattern,
            parsePattern: $ce2fa922bf4a591b$var$parseOrdinalNumberPattern,
            valueCallback: function(value) {
                return parseInt(value, 10);
            }
        }),
        era: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchEraPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: $ce2fa922bf4a591b$var$parseEraPatterns,
            defaultParseWidth: 'any'
        }),
        quarter: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchQuarterPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: $ce2fa922bf4a591b$var$parseQuarterPatterns,
            defaultParseWidth: 'any',
            valueCallback: function(index) {
                return index + 1;
            }
        }),
        month: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchMonthPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: $ce2fa922bf4a591b$var$parseMonthPatterns,
            defaultParseWidth: 'any'
        }),
        day: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchDayPatterns,
            defaultMatchWidth: 'wide',
            parsePatterns: $ce2fa922bf4a591b$var$parseDayPatterns,
            defaultParseWidth: 'any'
        }),
        dayPeriod: (0, $ce2fa922bf4a591b$var$_index2.default)({
            matchPatterns: $ce2fa922bf4a591b$var$matchDayPeriodPatterns,
            defaultMatchWidth: 'any',
            parsePatterns: $ce2fa922bf4a591b$var$parseDayPeriodPatterns,
            defaultParseWidth: 'any'
        })
    };
    var $ce2fa922bf4a591b$var$_default = $ce2fa922bf4a591b$var$match;
    module.exports.default = $ce2fa922bf4a591b$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("1IY7t", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $141888fa04c95812$var$buildMatchPatternFn;
    function $141888fa04c95812$var$buildMatchPatternFn(args) {
        return function(string) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var matchResult = string.match(args.matchPattern);
            if (!matchResult) return null;
            var matchedString = matchResult[0];
            var parseResult = string.match(args.parsePattern);
            if (!parseResult) return null;
            var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
            value = options.valueCallback ? options.valueCallback(value) : value;
            var rest = string.slice(matchedString.length);
            return {
                value: value,
                rest: rest
            };
        };
    }
    module.exports = module.exports.default;
});
parcelRegister("liduU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $f805bfb7f96f3bcc$var$buildMatchFn;
    function $f805bfb7f96f3bcc$var$buildMatchFn(args) {
        return function(string) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var width = options.width;
            var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
            var matchResult = string.match(matchPattern);
            if (!matchResult) return null;
            var matchedString = matchResult[0];
            var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
            var key = Array.isArray(parsePatterns) ? $f805bfb7f96f3bcc$var$findIndex(parsePatterns, function(pattern) {
                return pattern.test(matchedString);
            }) : $f805bfb7f96f3bcc$var$findKey(parsePatterns, function(pattern) {
                return pattern.test(matchedString);
            });
            var value;
            value = args.valueCallback ? args.valueCallback(key) : key;
            value = options.valueCallback ? options.valueCallback(value) : value;
            var rest = string.slice(matchedString.length);
            return {
                value: value,
                rest: rest
            };
        };
    }
    function $f805bfb7f96f3bcc$var$findKey(object, predicate) {
        for(var key in object){
            if (object.hasOwnProperty(key) && predicate(object[key])) return key;
        }
        return undefined;
    }
    function $f805bfb7f96f3bcc$var$findIndex(array, predicate) {
        for(var key = 0; key < array.length; key++){
            if (predicate(array[key])) return key;
        }
        return undefined;
    }
    module.exports = module.exports.default;
});
parcelRegister("bQkcE", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $89f438ee982b4fb2$var$subMilliseconds;
    var $89f438ee982b4fb2$var$_index = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $89f438ee982b4fb2$var$_index2 = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("7f9OM")));
    var $89f438ee982b4fb2$var$_index3 = $89f438ee982b4fb2$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $89f438ee982b4fb2$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $89f438ee982b4fb2$var$subMilliseconds(dirtyDate, dirtyAmount) {
        (0, $89f438ee982b4fb2$var$_index3.default)(2, arguments);
        var amount = (0, $89f438ee982b4fb2$var$_index.default)(dirtyAmount);
        return (0, $89f438ee982b4fb2$var$_index2.default)(dirtyDate, -amount);
    }
    module.exports = module.exports.default;
});
parcelRegister("aSksP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $7eaed23c7cdcf6c0$var$toInteger;
    function $7eaed23c7cdcf6c0$var$toInteger(dirtyNumber) {
        if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
        var number = Number(dirtyNumber);
        if (isNaN(number)) return number;
        return number < 0 ? Math.ceil(number) : Math.floor(number);
    }
    module.exports = module.exports.default;
});
parcelRegister("7f9OM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $54618cc00c3fb8fc$var$addMilliseconds;
    var $54618cc00c3fb8fc$var$_index = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $54618cc00c3fb8fc$var$_index2 = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $54618cc00c3fb8fc$var$_index3 = $54618cc00c3fb8fc$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $54618cc00c3fb8fc$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $54618cc00c3fb8fc$var$addMilliseconds(dirtyDate, dirtyAmount) {
        (0, $54618cc00c3fb8fc$var$_index3.default)(2, arguments);
        var timestamp = (0, $54618cc00c3fb8fc$var$_index2.default)(dirtyDate).getTime();
        var amount = (0, $54618cc00c3fb8fc$var$_index.default)(dirtyAmount);
        return new Date(timestamp + amount);
    }
    module.exports = module.exports.default;
});
parcelRegister("3ckvK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2542672a600cd2b8$var$_index = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("kFGp1")));
    var $2542672a600cd2b8$var$_index2 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("3xdEO")));
    var $2542672a600cd2b8$var$_index3 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("6Falt")));
    var $2542672a600cd2b8$var$_index4 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("gUvh1")));
    var $2542672a600cd2b8$var$_index5 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("46m4m")));
    var $2542672a600cd2b8$var$_index6 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("3ihh3")));
    var $2542672a600cd2b8$var$_index7 = $2542672a600cd2b8$var$_interopRequireDefault((parcelRequire("bQ2eo")));
    function $2542672a600cd2b8$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $2542672a600cd2b8$var$dayPeriodEnum = {
        am: 'am',
        pm: 'pm',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    };
    var $2542672a600cd2b8$var$formatters = {
        G: function(date, token, localize) {
            var era = date.getUTCFullYear() > 0 ? 1 : 0;
            switch(token){
                case 'G':
                case 'GG':
                case 'GGG':
                    return localize.era(era, {
                        width: 'abbreviated'
                    });
                case 'GGGGG':
                    return localize.era(era, {
                        width: 'narrow'
                    });
                case 'GGGG':
                default:
                    return localize.era(era, {
                        width: 'wide'
                    });
            }
        },
        y: function(date, token, localize) {
            if (token === 'yo') {
                var signedYear = date.getUTCFullYear();
                var year = signedYear > 0 ? signedYear : 1 - signedYear;
                return localize.ordinalNumber(year, {
                    unit: 'year'
                });
            }
            return $2542672a600cd2b8$var$_index.default.y(date, token);
        },
        Y: function(date, token, localize, options) {
            var signedWeekYear = (0, $2542672a600cd2b8$var$_index6.default)(date, options);
            var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
            if (token === 'YY') {
                var twoDigitYear = weekYear % 100;
                return (0, $2542672a600cd2b8$var$_index7.default)(twoDigitYear, 2);
            }
            if (token === 'Yo') return localize.ordinalNumber(weekYear, {
                unit: 'year'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(weekYear, token.length);
        },
        R: function(date, token) {
            var isoWeekYear = (0, $2542672a600cd2b8$var$_index4.default)(date);
            return (0, $2542672a600cd2b8$var$_index7.default)(isoWeekYear, token.length);
        },
        u: function(date, token) {
            var year = date.getUTCFullYear();
            return (0, $2542672a600cd2b8$var$_index7.default)(year, token.length);
        },
        Q: function(date, token, localize) {
            var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
            switch(token){
                case 'Q':
                    return String(quarter);
                case 'QQ':
                    return (0, $2542672a600cd2b8$var$_index7.default)(quarter, 2);
                case 'Qo':
                    return localize.ordinalNumber(quarter, {
                        unit: 'quarter'
                    });
                case 'QQQ':
                    return localize.quarter(quarter, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'QQQQQ':
                    return localize.quarter(quarter, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'QQQQ':
                default:
                    return localize.quarter(quarter, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        q: function(date, token, localize) {
            var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
            switch(token){
                case 'q':
                    return String(quarter);
                case 'qq':
                    return (0, $2542672a600cd2b8$var$_index7.default)(quarter, 2);
                case 'qo':
                    return localize.ordinalNumber(quarter, {
                        unit: 'quarter'
                    });
                case 'qqq':
                    return localize.quarter(quarter, {
                        width: 'abbreviated',
                        context: 'standalone'
                    });
                case 'qqqqq':
                    return localize.quarter(quarter, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'qqqq':
                default:
                    return localize.quarter(quarter, {
                        width: 'wide',
                        context: 'standalone'
                    });
            }
        },
        M: function(date, token, localize) {
            var month = date.getUTCMonth();
            switch(token){
                case 'M':
                case 'MM':
                    return $2542672a600cd2b8$var$_index.default.M(date, token);
                case 'Mo':
                    return localize.ordinalNumber(month + 1, {
                        unit: 'month'
                    });
                case 'MMM':
                    return localize.month(month, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'MMMMM':
                    return localize.month(month, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'MMMM':
                default:
                    return localize.month(month, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        L: function(date, token, localize) {
            var month = date.getUTCMonth();
            switch(token){
                case 'L':
                    return String(month + 1);
                case 'LL':
                    return (0, $2542672a600cd2b8$var$_index7.default)(month + 1, 2);
                case 'Lo':
                    return localize.ordinalNumber(month + 1, {
                        unit: 'month'
                    });
                case 'LLL':
                    return localize.month(month, {
                        width: 'abbreviated',
                        context: 'standalone'
                    });
                case 'LLLLL':
                    return localize.month(month, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'LLLL':
                default:
                    return localize.month(month, {
                        width: 'wide',
                        context: 'standalone'
                    });
            }
        },
        w: function(date, token, localize, options) {
            var week = (0, $2542672a600cd2b8$var$_index5.default)(date, options);
            if (token === 'wo') return localize.ordinalNumber(week, {
                unit: 'week'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(week, token.length);
        },
        I: function(date, token, localize) {
            var isoWeek = (0, $2542672a600cd2b8$var$_index3.default)(date);
            if (token === 'Io') return localize.ordinalNumber(isoWeek, {
                unit: 'week'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(isoWeek, token.length);
        },
        d: function(date, token, localize) {
            if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
                unit: 'date'
            });
            return $2542672a600cd2b8$var$_index.default.d(date, token);
        },
        D: function(date, token, localize) {
            var dayOfYear = (0, $2542672a600cd2b8$var$_index2.default)(date);
            if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
                unit: 'dayOfYear'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(dayOfYear, token.length);
        },
        E: function(date, token, localize) {
            var dayOfWeek = date.getUTCDay();
            switch(token){
                case 'E':
                case 'EE':
                case 'EEE':
                    return localize.day(dayOfWeek, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'EEEEE':
                    return localize.day(dayOfWeek, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'EEEEEE':
                    return localize.day(dayOfWeek, {
                        width: 'short',
                        context: 'formatting'
                    });
                case 'EEEE':
                default:
                    return localize.day(dayOfWeek, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        e: function(date, token, localize, options) {
            var dayOfWeek = date.getUTCDay();
            var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
            switch(token){
                case 'e':
                    return String(localDayOfWeek);
                case 'ee':
                    return (0, $2542672a600cd2b8$var$_index7.default)(localDayOfWeek, 2);
                case 'eo':
                    return localize.ordinalNumber(localDayOfWeek, {
                        unit: 'day'
                    });
                case 'eee':
                    return localize.day(dayOfWeek, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'eeeee':
                    return localize.day(dayOfWeek, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'eeeeee':
                    return localize.day(dayOfWeek, {
                        width: 'short',
                        context: 'formatting'
                    });
                case 'eeee':
                default:
                    return localize.day(dayOfWeek, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        c: function(date, token, localize, options) {
            var dayOfWeek = date.getUTCDay();
            var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
            switch(token){
                case 'c':
                    return String(localDayOfWeek);
                case 'cc':
                    return (0, $2542672a600cd2b8$var$_index7.default)(localDayOfWeek, token.length);
                case 'co':
                    return localize.ordinalNumber(localDayOfWeek, {
                        unit: 'day'
                    });
                case 'ccc':
                    return localize.day(dayOfWeek, {
                        width: 'abbreviated',
                        context: 'standalone'
                    });
                case 'ccccc':
                    return localize.day(dayOfWeek, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'cccccc':
                    return localize.day(dayOfWeek, {
                        width: 'short',
                        context: 'standalone'
                    });
                case 'cccc':
                default:
                    return localize.day(dayOfWeek, {
                        width: 'wide',
                        context: 'standalone'
                    });
            }
        },
        i: function(date, token, localize) {
            var dayOfWeek = date.getUTCDay();
            var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
            switch(token){
                case 'i':
                    return String(isoDayOfWeek);
                case 'ii':
                    return (0, $2542672a600cd2b8$var$_index7.default)(isoDayOfWeek, token.length);
                case 'io':
                    return localize.ordinalNumber(isoDayOfWeek, {
                        unit: 'day'
                    });
                case 'iii':
                    return localize.day(dayOfWeek, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'iiiii':
                    return localize.day(dayOfWeek, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'iiiiii':
                    return localize.day(dayOfWeek, {
                        width: 'short',
                        context: 'formatting'
                    });
                case 'iiii':
                default:
                    return localize.day(dayOfWeek, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        a: function(date, token, localize) {
            var hours = date.getUTCHours();
            var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
            switch(token){
                case 'a':
                case 'aa':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'aaa':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }).toLowerCase();
                case 'aaaaa':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'aaaa':
                default:
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        b: function(date, token, localize) {
            var hours = date.getUTCHours();
            var dayPeriodEnumValue;
            if (hours === 12) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.noon;
            else if (hours === 0) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.midnight;
            else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
            switch(token){
                case 'b':
                case 'bb':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'bbb':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }).toLowerCase();
                case 'bbbbb':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'bbbb':
                default:
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        B: function(date, token, localize) {
            var hours = date.getUTCHours();
            var dayPeriodEnumValue;
            if (hours >= 17) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.evening;
            else if (hours >= 12) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.afternoon;
            else if (hours >= 4) dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.morning;
            else dayPeriodEnumValue = $2542672a600cd2b8$var$dayPeriodEnum.night;
            switch(token){
                case 'B':
                case 'BB':
                case 'BBB':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'abbreviated',
                        context: 'formatting'
                    });
                case 'BBBBB':
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'BBBB':
                default:
                    return localize.dayPeriod(dayPeriodEnumValue, {
                        width: 'wide',
                        context: 'formatting'
                    });
            }
        },
        h: function(date, token, localize) {
            if (token === 'ho') {
                var hours = date.getUTCHours() % 12;
                if (hours === 0) hours = 12;
                return localize.ordinalNumber(hours, {
                    unit: 'hour'
                });
            }
            return $2542672a600cd2b8$var$_index.default.h(date, token);
        },
        H: function(date, token, localize) {
            if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
                unit: 'hour'
            });
            return $2542672a600cd2b8$var$_index.default.H(date, token);
        },
        K: function(date, token, localize) {
            var hours = date.getUTCHours() % 12;
            if (token === 'Ko') return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(hours, token.length);
        },
        k: function(date, token, localize) {
            var hours = date.getUTCHours();
            if (hours === 0) hours = 24;
            if (token === 'ko') return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
            return (0, $2542672a600cd2b8$var$_index7.default)(hours, token.length);
        },
        m: function(date, token, localize) {
            if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
                unit: 'minute'
            });
            return $2542672a600cd2b8$var$_index.default.m(date, token);
        },
        s: function(date, token, localize) {
            if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
                unit: 'second'
            });
            return $2542672a600cd2b8$var$_index.default.s(date, token);
        },
        S: function(date, token) {
            return $2542672a600cd2b8$var$_index.default.S(date, token);
        },
        X: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            if (timezoneOffset === 0) return 'Z';
            switch(token){
                case 'X':
                    return $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'XXXX':
                case 'XX':
                    return $2542672a600cd2b8$var$formatTimezone(timezoneOffset);
                case 'XXXXX':
                case 'XXX':
                default:
                    return $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
            }
        },
        x: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            switch(token){
                case 'x':
                    return $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'xxxx':
                case 'xx':
                    return $2542672a600cd2b8$var$formatTimezone(timezoneOffset);
                case 'xxxxx':
                case 'xxx':
                default:
                    return $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
            }
        },
        O: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            switch(token){
                case 'O':
                case 'OO':
                case 'OOO':
                    return 'GMT' + $2542672a600cd2b8$var$formatTimezoneShort(timezoneOffset, ':');
                case 'OOOO':
                default:
                    return 'GMT' + $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
            }
        },
        z: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timezoneOffset = originalDate.getTimezoneOffset();
            switch(token){
                case 'z':
                case 'zz':
                case 'zzz':
                    return 'GMT' + $2542672a600cd2b8$var$formatTimezoneShort(timezoneOffset, ':');
                case 'zzzz':
                default:
                    return 'GMT' + $2542672a600cd2b8$var$formatTimezone(timezoneOffset, ':');
            }
        },
        t: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timestamp = Math.floor(originalDate.getTime() / 1000);
            return (0, $2542672a600cd2b8$var$_index7.default)(timestamp, token.length);
        },
        T: function(date, token, _localize, options) {
            var originalDate = options._originalDate || date;
            var timestamp = originalDate.getTime();
            return (0, $2542672a600cd2b8$var$_index7.default)(timestamp, token.length);
        }
    };
    function $2542672a600cd2b8$var$formatTimezoneShort(offset, dirtyDelimiter) {
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = Math.floor(absOffset / 60);
        var minutes = absOffset % 60;
        if (minutes === 0) return sign + String(hours);
        var delimiter = dirtyDelimiter || '';
        return sign + String(hours) + delimiter + (0, $2542672a600cd2b8$var$_index7.default)(minutes, 2);
    }
    function $2542672a600cd2b8$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
        if (offset % 60 === 0) {
            var sign = offset > 0 ? '-' : '+';
            return sign + (0, $2542672a600cd2b8$var$_index7.default)(Math.abs(offset) / 60, 2);
        }
        return $2542672a600cd2b8$var$formatTimezone(offset, dirtyDelimiter);
    }
    function $2542672a600cd2b8$var$formatTimezone(offset, dirtyDelimiter) {
        var delimiter = dirtyDelimiter || '';
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = (0, $2542672a600cd2b8$var$_index7.default)(Math.floor(absOffset / 60), 2);
        var minutes = (0, $2542672a600cd2b8$var$_index7.default)(absOffset % 60, 2);
        return sign + hours + delimiter + minutes;
    }
    var $2542672a600cd2b8$var$_default = $2542672a600cd2b8$var$formatters;
    module.exports.default = $2542672a600cd2b8$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("kFGp1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f0c88744bd108133$var$_index = $f0c88744bd108133$var$_interopRequireDefault((parcelRequire("bQ2eo")));
    function $f0c88744bd108133$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $f0c88744bd108133$var$formatters = {
        y: function(date, token) {
            var signedYear = date.getUTCFullYear();
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return (0, $f0c88744bd108133$var$_index.default)(token === 'yy' ? year % 100 : year, token.length);
        },
        M: function(date, token) {
            var month = date.getUTCMonth();
            return token === 'M' ? String(month + 1) : (0, $f0c88744bd108133$var$_index.default)(month + 1, 2);
        },
        d: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCDate(), token.length);
        },
        a: function(date, token) {
            var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
            switch(token){
                case 'a':
                case 'aa':
                    return dayPeriodEnumValue.toUpperCase();
                case 'aaa':
                    return dayPeriodEnumValue;
                case 'aaaaa':
                    return dayPeriodEnumValue[0];
                case 'aaaa':
                default:
                    return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
            }
        },
        h: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
        },
        H: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCHours(), token.length);
        },
        m: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCMinutes(), token.length);
        },
        s: function(date, token) {
            return (0, $f0c88744bd108133$var$_index.default)(date.getUTCSeconds(), token.length);
        },
        S: function(date, token) {
            var numberOfDigits = token.length;
            var milliseconds = date.getUTCMilliseconds();
            var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
            return (0, $f0c88744bd108133$var$_index.default)(fractionalSeconds, token.length);
        }
    };
    var $f0c88744bd108133$var$_default = $f0c88744bd108133$var$formatters;
    module.exports.default = $f0c88744bd108133$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("bQ2eo", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $89e6481d20123ee2$var$addLeadingZeros;
    function $89e6481d20123ee2$var$addLeadingZeros(number, targetLength) {
        var sign = number < 0 ? '-' : '';
        var output = Math.abs(number).toString();
        while(output.length < targetLength)output = '0' + output;
        return sign + output;
    }
    module.exports = module.exports.default;
});
parcelRegister("3xdEO", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $292f0c3a5495486a$var$getUTCDayOfYear;
    var $292f0c3a5495486a$var$_index = $292f0c3a5495486a$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $292f0c3a5495486a$var$_index2 = $292f0c3a5495486a$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $292f0c3a5495486a$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $292f0c3a5495486a$var$MILLISECONDS_IN_DAY = 86400000;
    function $292f0c3a5495486a$var$getUTCDayOfYear(dirtyDate) {
        (0, $292f0c3a5495486a$var$_index2.default)(1, arguments);
        var date = (0, $292f0c3a5495486a$var$_index.default)(dirtyDate);
        var timestamp = date.getTime();
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
        var startOfYearTimestamp = date.getTime();
        var difference = timestamp - startOfYearTimestamp;
        return Math.floor(difference / $292f0c3a5495486a$var$MILLISECONDS_IN_DAY) + 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("6Falt", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $4d9e98caba6dac2d$var$getUTCISOWeek;
    var $4d9e98caba6dac2d$var$_index = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $4d9e98caba6dac2d$var$_index2 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("6nDqw")));
    var $4d9e98caba6dac2d$var$_index3 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("hI2kM")));
    var $4d9e98caba6dac2d$var$_index4 = $4d9e98caba6dac2d$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $4d9e98caba6dac2d$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $4d9e98caba6dac2d$var$MILLISECONDS_IN_WEEK = 604800000;
    function $4d9e98caba6dac2d$var$getUTCISOWeek(dirtyDate) {
        (0, $4d9e98caba6dac2d$var$_index4.default)(1, arguments);
        var date = (0, $4d9e98caba6dac2d$var$_index.default)(dirtyDate);
        var diff = (0, $4d9e98caba6dac2d$var$_index2.default)(date).getTime() - (0, $4d9e98caba6dac2d$var$_index3.default)(date).getTime();
        return Math.round(diff / $4d9e98caba6dac2d$var$MILLISECONDS_IN_WEEK) + 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("6nDqw", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $4a53796a96b58804$var$startOfUTCISOWeek;
    var $4a53796a96b58804$var$_index = $4a53796a96b58804$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $4a53796a96b58804$var$_index2 = $4a53796a96b58804$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $4a53796a96b58804$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $4a53796a96b58804$var$startOfUTCISOWeek(dirtyDate) {
        (0, $4a53796a96b58804$var$_index2.default)(1, arguments);
        var weekStartsOn = 1;
        var date = (0, $4a53796a96b58804$var$_index.default)(dirtyDate);
        var day = date.getUTCDay();
        var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
        date.setUTCDate(date.getUTCDate() - diff);
        date.setUTCHours(0, 0, 0, 0);
        return date;
    }
    module.exports = module.exports.default;
});
parcelRegister("hI2kM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $ce485b424b643216$var$startOfUTCISOWeekYear;
    var $ce485b424b643216$var$_index = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("gUvh1")));
    var $ce485b424b643216$var$_index2 = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("6nDqw")));
    var $ce485b424b643216$var$_index3 = $ce485b424b643216$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $ce485b424b643216$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $ce485b424b643216$var$startOfUTCISOWeekYear(dirtyDate) {
        (0, $ce485b424b643216$var$_index3.default)(1, arguments);
        var year = (0, $ce485b424b643216$var$_index.default)(dirtyDate);
        var fourthOfJanuary = new Date(0);
        fourthOfJanuary.setUTCFullYear(year, 0, 4);
        fourthOfJanuary.setUTCHours(0, 0, 0, 0);
        var date = (0, $ce485b424b643216$var$_index2.default)(fourthOfJanuary);
        return date;
    }
    module.exports = module.exports.default;
});
parcelRegister("gUvh1", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $c4fa22996f39566a$var$getUTCISOWeekYear;
    var $c4fa22996f39566a$var$_index = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $c4fa22996f39566a$var$_index2 = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("6nDqw")));
    var $c4fa22996f39566a$var$_index3 = $c4fa22996f39566a$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $c4fa22996f39566a$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $c4fa22996f39566a$var$getUTCISOWeekYear(dirtyDate) {
        (0, $c4fa22996f39566a$var$_index3.default)(1, arguments);
        var date = (0, $c4fa22996f39566a$var$_index.default)(dirtyDate);
        var year = date.getUTCFullYear();
        var fourthOfJanuaryOfNextYear = new Date(0);
        fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
        fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
        var startOfNextYear = (0, $c4fa22996f39566a$var$_index2.default)(fourthOfJanuaryOfNextYear);
        var fourthOfJanuaryOfThisYear = new Date(0);
        fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
        fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
        var startOfThisYear = (0, $c4fa22996f39566a$var$_index2.default)(fourthOfJanuaryOfThisYear);
        if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
        else if (date.getTime() >= startOfThisYear.getTime()) return year;
        else return year - 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("46m4m", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $2fc8d772b38d0976$var$getUTCWeek;
    var $2fc8d772b38d0976$var$_index = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $2fc8d772b38d0976$var$_index2 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("clhRK")));
    var $2fc8d772b38d0976$var$_index3 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("cbqvD")));
    var $2fc8d772b38d0976$var$_index4 = $2fc8d772b38d0976$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $2fc8d772b38d0976$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    var $2fc8d772b38d0976$var$MILLISECONDS_IN_WEEK = 604800000;
    function $2fc8d772b38d0976$var$getUTCWeek(dirtyDate, options) {
        (0, $2fc8d772b38d0976$var$_index4.default)(1, arguments);
        var date = (0, $2fc8d772b38d0976$var$_index.default)(dirtyDate);
        var diff = (0, $2fc8d772b38d0976$var$_index2.default)(date, options).getTime() - (0, $2fc8d772b38d0976$var$_index3.default)(date, options).getTime();
        return Math.round(diff / $2fc8d772b38d0976$var$MILLISECONDS_IN_WEEK) + 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("clhRK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $8fc54dfcfb604fc4$var$startOfUTCWeek;
    var $8fc54dfcfb604fc4$var$_index = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $8fc54dfcfb604fc4$var$_index2 = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $8fc54dfcfb604fc4$var$_index3 = $8fc54dfcfb604fc4$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $8fc54dfcfb604fc4$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $8fc54dfcfb604fc4$var$startOfUTCWeek(dirtyDate, dirtyOptions) {
        (0, $8fc54dfcfb604fc4$var$_index3.default)(1, arguments);
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, $8fc54dfcfb604fc4$var$_index.default)(localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, $8fc54dfcfb604fc4$var$_index.default)(options.weekStartsOn);
        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
        var date = (0, $8fc54dfcfb604fc4$var$_index2.default)(dirtyDate);
        var day = date.getUTCDay();
        var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
        date.setUTCDate(date.getUTCDate() - diff);
        date.setUTCHours(0, 0, 0, 0);
        return date;
    }
    module.exports = module.exports.default;
});
parcelRegister("cbqvD", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $8deb134e55cb5294$var$startOfUTCWeekYear;
    var $8deb134e55cb5294$var$_index = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $8deb134e55cb5294$var$_index2 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("3ihh3")));
    var $8deb134e55cb5294$var$_index3 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("clhRK")));
    var $8deb134e55cb5294$var$_index4 = $8deb134e55cb5294$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $8deb134e55cb5294$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $8deb134e55cb5294$var$startOfUTCWeekYear(dirtyDate, dirtyOptions) {
        (0, $8deb134e55cb5294$var$_index4.default)(1, arguments);
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $8deb134e55cb5294$var$_index.default)(localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $8deb134e55cb5294$var$_index.default)(options.firstWeekContainsDate);
        var year = (0, $8deb134e55cb5294$var$_index2.default)(dirtyDate, dirtyOptions);
        var firstWeek = new Date(0);
        firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
        firstWeek.setUTCHours(0, 0, 0, 0);
        var date = (0, $8deb134e55cb5294$var$_index3.default)(firstWeek, dirtyOptions);
        return date;
    }
    module.exports = module.exports.default;
});
parcelRegister("3ihh3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $266073c9a73c0f7b$var$getUTCWeekYear;
    var $266073c9a73c0f7b$var$_index = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("aSksP")));
    var $266073c9a73c0f7b$var$_index2 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("2pWQP")));
    var $266073c9a73c0f7b$var$_index3 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("clhRK")));
    var $266073c9a73c0f7b$var$_index4 = $266073c9a73c0f7b$var$_interopRequireDefault((parcelRequire("6eBfj")));
    function $266073c9a73c0f7b$var$_interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    function $266073c9a73c0f7b$var$getUTCWeekYear(dirtyDate, dirtyOptions) {
        (0, $266073c9a73c0f7b$var$_index4.default)(1, arguments);
        var date = (0, $266073c9a73c0f7b$var$_index2.default)(dirtyDate, dirtyOptions);
        var year = date.getUTCFullYear();
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, $266073c9a73c0f7b$var$_index.default)(localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, $266073c9a73c0f7b$var$_index.default)(options.firstWeekContainsDate);
        if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
        var firstWeekOfNextYear = new Date(0);
        firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
        firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
        var startOfNextYear = (0, $266073c9a73c0f7b$var$_index3.default)(firstWeekOfNextYear, dirtyOptions);
        var firstWeekOfThisYear = new Date(0);
        firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
        firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
        var startOfThisYear = (0, $266073c9a73c0f7b$var$_index3.default)(firstWeekOfThisYear, dirtyOptions);
        if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
        else if (date.getTime() >= startOfThisYear.getTime()) return year;
        else return year - 1;
    }
    module.exports = module.exports.default;
});
parcelRegister("awKAW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    function $7aa109506ceedd4b$var$dateLongFormatter(pattern, formatLong) {
        switch(pattern){
            case 'P':
                return formatLong.date({
                    width: 'short'
                });
            case 'PP':
                return formatLong.date({
                    width: 'medium'
                });
            case 'PPP':
                return formatLong.date({
                    width: 'long'
                });
            case 'PPPP':
            default:
                return formatLong.date({
                    width: 'full'
                });
        }
    }
    function $7aa109506ceedd4b$var$timeLongFormatter(pattern, formatLong) {
        switch(pattern){
            case 'p':
                return formatLong.time({
                    width: 'short'
                });
            case 'pp':
                return formatLong.time({
                    width: 'medium'
                });
            case 'ppp':
                return formatLong.time({
                    width: 'long'
                });
            case 'pppp':
            default:
                return formatLong.time({
                    width: 'full'
                });
        }
    }
    function $7aa109506ceedd4b$var$dateTimeLongFormatter(pattern, formatLong) {
        var matchResult = pattern.match(/(P+)(p+)?/);
        var datePattern = matchResult[1];
        var timePattern = matchResult[2];
        if (!timePattern) return $7aa109506ceedd4b$var$dateLongFormatter(pattern, formatLong);
        var dateTimeFormat;
        switch(datePattern){
            case 'P':
                dateTimeFormat = formatLong.dateTime({
                    width: 'short'
                });
                break;
            case 'PP':
                dateTimeFormat = formatLong.dateTime({
                    width: 'medium'
                });
                break;
            case 'PPP':
                dateTimeFormat = formatLong.dateTime({
                    width: 'long'
                });
                break;
            case 'PPPP':
            default:
                dateTimeFormat = formatLong.dateTime({
                    width: 'full'
                });
                break;
        }
        return dateTimeFormat.replace('{{date}}', $7aa109506ceedd4b$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $7aa109506ceedd4b$var$timeLongFormatter(timePattern, formatLong));
    }
    var $7aa109506ceedd4b$var$longFormatters = {
        p: $7aa109506ceedd4b$var$timeLongFormatter,
        P: $7aa109506ceedd4b$var$dateTimeLongFormatter
    };
    var $7aa109506ceedd4b$var$_default = $7aa109506ceedd4b$var$longFormatters;
    module.exports.default = $7aa109506ceedd4b$var$_default;
    module.exports = module.exports.default;
});
parcelRegister("jGQTC", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = $e55af8a2cb6edd32$var$getTimezoneOffsetInMilliseconds;
    function $e55af8a2cb6edd32$var$getTimezoneOffsetInMilliseconds(date) {
        var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
        utcDate.setUTCFullYear(date.getFullYear());
        return date.getTime() - utcDate.getTime();
    }
    module.exports = module.exports.default;
});
parcelRegister("5qguX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.isProtectedDayOfYearToken = $3f2c2dab40599caa$var$isProtectedDayOfYearToken;
    module.exports.isProtectedWeekYearToken = $3f2c2dab40599caa$var$isProtectedWeekYearToken;
    module.exports.throwProtectedError = $3f2c2dab40599caa$var$throwProtectedError;
    var $3f2c2dab40599caa$var$protectedDayOfYearTokens = [
        'D',
        'DD'
    ];
    var $3f2c2dab40599caa$var$protectedWeekYearTokens = [
        'YY',
        'YYYY'
    ];
    function $3f2c2dab40599caa$var$isProtectedDayOfYearToken(token) {
        return $3f2c2dab40599caa$var$protectedDayOfYearTokens.indexOf(token) !== -1;
    }
    function $3f2c2dab40599caa$var$isProtectedWeekYearToken(token) {
        return $3f2c2dab40599caa$var$protectedWeekYearTokens.indexOf(token) !== -1;
    }
    function $3f2c2dab40599caa$var$throwProtectedError(token, format, input) {
        if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    }
});
parcelRegister("hSWQe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d0551f7ef5f0a605$export$2e2bcd8739ae039);
    var $cySFC = parcelRequire("cySFC");
    var $9h5G9 = parcelRequire("9h5G9");
    var $d0551f7ef5f0a605$var$MILLISECONDS_IN_MINUTE = 60000;
    var $d0551f7ef5f0a605$var$formatters = {
        X: function(date, token, localize, options) {
            var timezoneOffset = $d0551f7ef5f0a605$var$getTimeZoneOffset(options.timeZone, date);
            if (timezoneOffset === 0) return 'Z';
            switch(token){
                case 'X':
                    return $d0551f7ef5f0a605$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'XXXX':
                case 'XX':
                    return $d0551f7ef5f0a605$var$formatTimezone(timezoneOffset);
                case 'XXXXX':
                case 'XXX':
                default:
                    return $d0551f7ef5f0a605$var$formatTimezone(timezoneOffset, ':');
            }
        },
        x: function(date, token, localize, options) {
            var timezoneOffset = $d0551f7ef5f0a605$var$getTimeZoneOffset(options.timeZone, date);
            switch(token){
                case 'x':
                    return $d0551f7ef5f0a605$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
                case 'xxxx':
                case 'xx':
                    return $d0551f7ef5f0a605$var$formatTimezone(timezoneOffset);
                case 'xxxxx':
                case 'xxx':
                default:
                    return $d0551f7ef5f0a605$var$formatTimezone(timezoneOffset, ':');
            }
        },
        O: function(date, token, localize, options) {
            var timezoneOffset = $d0551f7ef5f0a605$var$getTimeZoneOffset(options.timeZone, date);
            switch(token){
                case 'O':
                case 'OO':
                case 'OOO':
                    return 'GMT' + $d0551f7ef5f0a605$var$formatTimezoneShort(timezoneOffset, ':');
                case 'OOOO':
                default:
                    return 'GMT' + $d0551f7ef5f0a605$var$formatTimezone(timezoneOffset, ':');
            }
        },
        z: function(date, token, localize, options) {
            switch(token){
                case 'z':
                case 'zz':
                case 'zzz':
                    return (0, $cySFC.default)('short', date, options);
                case 'zzzz':
                default:
                    return (0, $cySFC.default)('long', date, options);
            }
        }
    };
    function $d0551f7ef5f0a605$var$getTimeZoneOffset(timeZone, originalDate) {
        var timeZoneOffset = timeZone ? (0, $9h5G9.default)(timeZone, originalDate, true) / $d0551f7ef5f0a605$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
        if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
        return timeZoneOffset;
    }
    function $d0551f7ef5f0a605$var$addLeadingZeros(number, targetLength) {
        var sign = number < 0 ? '-' : '';
        var output = Math.abs(number).toString();
        while(output.length < targetLength)output = '0' + output;
        return sign + output;
    }
    function $d0551f7ef5f0a605$var$formatTimezone(offset, dirtyDelimeter) {
        var delimeter = dirtyDelimeter || '';
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = $d0551f7ef5f0a605$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
        var minutes = $d0551f7ef5f0a605$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
        return sign + hours + delimeter + minutes;
    }
    function $d0551f7ef5f0a605$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
        if (offset % 60 === 0) {
            var sign = offset > 0 ? '-' : '+';
            return sign + $d0551f7ef5f0a605$var$addLeadingZeros(Math.abs(offset) / 60, 2);
        }
        return $d0551f7ef5f0a605$var$formatTimezone(offset, dirtyDelimeter);
    }
    function $d0551f7ef5f0a605$var$formatTimezoneShort(offset, dirtyDelimiter) {
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = Math.floor(absOffset / 60);
        var minutes = absOffset % 60;
        if (minutes === 0) return sign + String(hours);
        var delimiter = dirtyDelimiter || '';
        return sign + String(hours) + delimiter + $d0551f7ef5f0a605$var$addLeadingZeros(minutes, 2);
    }
    var $d0551f7ef5f0a605$export$2e2bcd8739ae039 = $d0551f7ef5f0a605$var$formatters;
});
parcelRegister("cySFC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$92531169d1622c5c$export$2e2bcd8739ae039);
    function $92531169d1622c5c$export$2e2bcd8739ae039(length, date, options) {
        var dtf = $92531169d1622c5c$var$getDTF(length, options.timeZone, options.locale);
        return dtf.formatToParts ? $92531169d1622c5c$var$partsTimeZone(dtf, date) : $92531169d1622c5c$var$hackyTimeZone(dtf, date);
    }
    function $92531169d1622c5c$var$partsTimeZone(dtf, date) {
        var formatted = dtf.formatToParts(date);
        for(var i = formatted.length - 1; i >= 0; --i){
            if (formatted[i].type === 'timeZoneName') return formatted[i].value;
        }
    }
    function $92531169d1622c5c$var$hackyTimeZone(dtf, date) {
        var formatted = dtf.format(date).replace(/\u200E/g, '');
        var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
        return tzNameMatch ? tzNameMatch[0].substr(1) : '';
    }
    function $92531169d1622c5c$var$getDTF(length, timeZone, locale) {
        if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
        return new Intl.DateTimeFormat(locale ? [
            locale.code,
            'en-US'
        ] : undefined, {
            timeZone: timeZone,
            timeZoneName: length
        });
    }
});
parcelRegister("9h5G9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c0a1b4aadf6867a$export$2e2bcd8739ae039);
    var $1Y7KK = parcelRequire("1Y7KK");
    var $7Y9XY = parcelRequire("7Y9XY");
    var $6c0a1b4aadf6867a$var$MILLISECONDS_IN_HOUR = 3600000;
    var $6c0a1b4aadf6867a$var$MILLISECONDS_IN_MINUTE = 60000;
    var $6c0a1b4aadf6867a$var$patterns = {
        timezone: /([Z+-].*)$/,
        timezoneZ: /^(Z)$/,
        timezoneHH: /^([+-]\d{2})$/,
        timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
    };
    function $6c0a1b4aadf6867a$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
        var token;
        var absoluteOffset;
        if (!timezoneString) return 0;
        token = $6c0a1b4aadf6867a$var$patterns.timezoneZ.exec(timezoneString);
        if (token) return 0;
        var hours;
        token = $6c0a1b4aadf6867a$var$patterns.timezoneHH.exec(timezoneString);
        if (token) {
            hours = parseInt(token[1], 10);
            if (!$6c0a1b4aadf6867a$var$validateTimezone(hours)) return NaN;
            return -(hours * $6c0a1b4aadf6867a$var$MILLISECONDS_IN_HOUR);
        }
        token = $6c0a1b4aadf6867a$var$patterns.timezoneHHMM.exec(timezoneString);
        if (token) {
            hours = parseInt(token[2], 10);
            var minutes = parseInt(token[3], 10);
            if (!$6c0a1b4aadf6867a$var$validateTimezone(hours, minutes)) return NaN;
            absoluteOffset = Math.abs(hours) * $6c0a1b4aadf6867a$var$MILLISECONDS_IN_HOUR + minutes * $6c0a1b4aadf6867a$var$MILLISECONDS_IN_MINUTE;
            return token[1] === '+' ? -absoluteOffset : absoluteOffset;
        }
        if ($6c0a1b4aadf6867a$var$isValidTimezoneIANAString(timezoneString)) {
            date = new Date(date || Date.now());
            var utcDate = isUtcDate ? date : $6c0a1b4aadf6867a$var$toUtcDate(date);
            var offset = $6c0a1b4aadf6867a$var$calcOffset(utcDate, timezoneString);
            var fixedOffset = isUtcDate ? offset : $6c0a1b4aadf6867a$var$fixOffset(date, offset, timezoneString);
            return -fixedOffset;
        }
        return NaN;
    }
    function $6c0a1b4aadf6867a$var$toUtcDate(date) {
        return (0, $7Y9XY.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    }
    function $6c0a1b4aadf6867a$var$calcOffset(date, timezoneString) {
        var tokens = (0, $1Y7KK.default)(date, timezoneString);
        var asUTC = (0, $7Y9XY.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
        var asTS = date.getTime();
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return asUTC - asTS;
    }
    function $6c0a1b4aadf6867a$var$fixOffset(date, offset, timezoneString) {
        var localTS = date.getTime();
        var utcGuess = localTS - offset;
        var o2 = $6c0a1b4aadf6867a$var$calcOffset(new Date(utcGuess), timezoneString);
        if (offset === o2) return offset;
        utcGuess -= o2 - offset;
        var o3 = $6c0a1b4aadf6867a$var$calcOffset(new Date(utcGuess), timezoneString);
        if (o2 === o3) return o2;
        return Math.max(o2, o3);
    }
    function $6c0a1b4aadf6867a$var$validateTimezone(hours, minutes) {
        return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
    }
    var $6c0a1b4aadf6867a$var$validIANATimezoneCache = {};
    function $6c0a1b4aadf6867a$var$isValidTimezoneIANAString(timeZoneString) {
        if ($6c0a1b4aadf6867a$var$validIANATimezoneCache[timeZoneString]) return true;
        try {
            new Intl.DateTimeFormat(undefined, {
                timeZone: timeZoneString
            });
            $6c0a1b4aadf6867a$var$validIANATimezoneCache[timeZoneString] = true;
            return true;
        } catch (error) {
            return false;
        }
    }
});
parcelRegister("1Y7KK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16f1689a650a57ef$export$2e2bcd8739ae039);
    function $16f1689a650a57ef$export$2e2bcd8739ae039(date, timeZone) {
        var dtf = $16f1689a650a57ef$var$getDateTimeFormat(timeZone);
        return dtf.formatToParts ? $16f1689a650a57ef$var$partsOffset(dtf, date) : $16f1689a650a57ef$var$hackyOffset(dtf, date);
    }
    var $16f1689a650a57ef$var$typeToPos = {
        year: 0,
        month: 1,
        day: 2,
        hour: 3,
        minute: 4,
        second: 5
    };
    function $16f1689a650a57ef$var$partsOffset(dtf, date) {
        try {
            var formatted = dtf.formatToParts(date);
            var filled = [];
            for(var i = 0; i < formatted.length; i++){
                var pos = $16f1689a650a57ef$var$typeToPos[formatted[i].type];
                if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
            }
            return filled;
        } catch (error) {
            if (error instanceof RangeError) return [
                NaN
            ];
            throw error;
        }
    }
    function $16f1689a650a57ef$var$hackyOffset(dtf, date) {
        var formatted = dtf.format(date);
        var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
        return [
            parsed[3],
            parsed[1],
            parsed[2],
            parsed[4],
            parsed[5],
            parsed[6]
        ];
    }
    var $16f1689a650a57ef$var$dtfCache = {};
    function $16f1689a650a57ef$var$getDateTimeFormat(timeZone) {
        if (!$16f1689a650a57ef$var$dtfCache[timeZone]) {
            var testDateFormatted = new Intl.DateTimeFormat('en-US', {
                hourCycle: 'h23',
                timeZone: 'America/New_York',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            }).format(new Date('2014-06-25T04:00:00.123Z'));
            var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
            $16f1689a650a57ef$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
                hourCycle: 'h23',
                timeZone: timeZone,
                year: 'numeric',
                month: 'numeric',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            }) : new Intl.DateTimeFormat('en-US', {
                hour12: false,
                timeZone: timeZone,
                year: 'numeric',
                month: 'numeric',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit'
            });
        }
        return $16f1689a650a57ef$var$dtfCache[timeZone];
    }
});
parcelRegister("7Y9XY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5cd5de1d4e8bb320$export$2e2bcd8739ae039);
    function $5cd5de1d4e8bb320$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
        var utcDate = new Date(0);
        utcDate.setUTCFullYear(fullYear, month, day);
        utcDate.setUTCHours(hour, minute, second, millisecond);
        return utcDate;
    }
});
parcelRegister("8Bm5s", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6432e977b473e28b$export$2e2bcd8739ae039);
    var $aSksP;
    var $jGQTC;
    var $9h5G9 = parcelRequire("9h5G9");
    var $6mIEj = parcelRequire("6mIEj");
    var $6432e977b473e28b$var$MILLISECONDS_IN_HOUR = 3600000;
    var $6432e977b473e28b$var$MILLISECONDS_IN_MINUTE = 60000;
    var $6432e977b473e28b$var$DEFAULT_ADDITIONAL_DIGITS = 2;
    var $6432e977b473e28b$var$patterns = {
        dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
        datePattern: /^([0-9W+-]+)(.*)/,
        plainTime: /:/,
        YY: /^(\d{2})$/,
        YYY: [
            /^([+-]\d{2})$/,
            /^([+-]\d{3})$/,
            /^([+-]\d{4})$/
        ],
        YYYY: /^(\d{4})/,
        YYYYY: [
            /^([+-]\d{4})/,
            /^([+-]\d{5})/,
            /^([+-]\d{6})/
        ],
        MM: /^-(\d{2})$/,
        DDD: /^-?(\d{3})$/,
        MMDD: /^-?(\d{2})-?(\d{2})$/,
        Www: /^-?W(\d{2})$/,
        WwwD: /^-?W(\d{2})-?(\d{1})$/,
        HH: /^(\d{2}([.,]\d*)?)$/,
        HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
        HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
        timeZone: (0, $6mIEj.default)
    };
    function $6432e977b473e28b$export$2e2bcd8739ae039(argument, dirtyOptions) {
        if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
        if (argument === null) return new Date(NaN);
        var options = dirtyOptions || {};
        var additionalDigits = options.additionalDigits == null ? $6432e977b473e28b$var$DEFAULT_ADDITIONAL_DIGITS : (0, ($parcel$interopDefault((0, parcelRequire("aSksP")))))(options.additionalDigits);
        if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
        if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') return new Date(argument.getTime());
        else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
        else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
        var dateStrings = $6432e977b473e28b$var$splitDateString(argument);
        var parseYearResult = $6432e977b473e28b$var$parseYear(dateStrings.date, additionalDigits);
        var year = parseYearResult.year;
        var restDateString = parseYearResult.restDateString;
        var date = $6432e977b473e28b$var$parseDate(restDateString, year);
        if (isNaN(date)) return new Date(NaN);
        if (date) {
            var timestamp = date.getTime();
            var time = 0;
            var offset;
            if (dateStrings.time) {
                time = $6432e977b473e28b$var$parseTime(dateStrings.time);
                if (isNaN(time)) return new Date(NaN);
            }
            if (dateStrings.timeZone || options.timeZone) {
                offset = (0, $9h5G9.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
                if (isNaN(offset)) return new Date(NaN);
            } else {
                offset = (0, ($parcel$interopDefault((0, parcelRequire("jGQTC")))))(new Date(timestamp + time));
                offset = (0, ($parcel$interopDefault((0, parcelRequire("jGQTC")))))(new Date(timestamp + time + offset));
            }
            return new Date(timestamp + time + offset);
        } else return new Date(NaN);
    }
    function $6432e977b473e28b$var$splitDateString(dateString) {
        var dateStrings = {};
        var parts = $6432e977b473e28b$var$patterns.dateTimePattern.exec(dateString);
        var timeString;
        if (!parts) {
            parts = $6432e977b473e28b$var$patterns.datePattern.exec(dateString);
            if (parts) {
                dateStrings.date = parts[1];
                timeString = parts[2];
            } else {
                dateStrings.date = null;
                timeString = dateString;
            }
        } else {
            dateStrings.date = parts[1];
            timeString = parts[3];
        }
        if (timeString) {
            var token = $6432e977b473e28b$var$patterns.timeZone.exec(timeString);
            if (token) {
                dateStrings.time = timeString.replace(token[1], '');
                dateStrings.timeZone = token[1].trim();
            } else dateStrings.time = timeString;
        }
        return dateStrings;
    }
    function $6432e977b473e28b$var$parseYear(dateString, additionalDigits) {
        var patternYYY = $6432e977b473e28b$var$patterns.YYY[additionalDigits];
        var patternYYYYY = $6432e977b473e28b$var$patterns.YYYYY[additionalDigits];
        var token;
        token = $6432e977b473e28b$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
        if (token) {
            var yearString = token[1];
            return {
                year: parseInt(yearString, 10),
                restDateString: dateString.slice(yearString.length)
            };
        }
        token = $6432e977b473e28b$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
        if (token) {
            var centuryString = token[1];
            return {
                year: parseInt(centuryString, 10) * 100,
                restDateString: dateString.slice(centuryString.length)
            };
        }
        return {
            year: null
        };
    }
    function $6432e977b473e28b$var$parseDate(dateString, year) {
        if (year === null) return null;
        var token;
        var date;
        var month;
        var week;
        if (dateString.length === 0) {
            date = new Date(0);
            date.setUTCFullYear(year);
            return date;
        }
        token = $6432e977b473e28b$var$patterns.MM.exec(dateString);
        if (token) {
            date = new Date(0);
            month = parseInt(token[1], 10) - 1;
            if (!$6432e977b473e28b$var$validateDate(year, month)) return new Date(NaN);
            date.setUTCFullYear(year, month);
            return date;
        }
        token = $6432e977b473e28b$var$patterns.DDD.exec(dateString);
        if (token) {
            date = new Date(0);
            var dayOfYear = parseInt(token[1], 10);
            if (!$6432e977b473e28b$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
            date.setUTCFullYear(year, 0, dayOfYear);
            return date;
        }
        token = $6432e977b473e28b$var$patterns.MMDD.exec(dateString);
        if (token) {
            date = new Date(0);
            month = parseInt(token[1], 10) - 1;
            var day = parseInt(token[2], 10);
            if (!$6432e977b473e28b$var$validateDate(year, month, day)) return new Date(NaN);
            date.setUTCFullYear(year, month, day);
            return date;
        }
        token = $6432e977b473e28b$var$patterns.Www.exec(dateString);
        if (token) {
            week = parseInt(token[1], 10) - 1;
            if (!$6432e977b473e28b$var$validateWeekDate(year, week)) return new Date(NaN);
            return $6432e977b473e28b$var$dayOfISOWeekYear(year, week);
        }
        token = $6432e977b473e28b$var$patterns.WwwD.exec(dateString);
        if (token) {
            week = parseInt(token[1], 10) - 1;
            var dayOfWeek = parseInt(token[2], 10) - 1;
            if (!$6432e977b473e28b$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
            return $6432e977b473e28b$var$dayOfISOWeekYear(year, week, dayOfWeek);
        }
        return null;
    }
    function $6432e977b473e28b$var$parseTime(timeString) {
        var token;
        var hours;
        var minutes;
        token = $6432e977b473e28b$var$patterns.HH.exec(timeString);
        if (token) {
            hours = parseFloat(token[1].replace(',', '.'));
            if (!$6432e977b473e28b$var$validateTime(hours)) return NaN;
            return hours % 24 * $6432e977b473e28b$var$MILLISECONDS_IN_HOUR;
        }
        token = $6432e977b473e28b$var$patterns.HHMM.exec(timeString);
        if (token) {
            hours = parseInt(token[1], 10);
            minutes = parseFloat(token[2].replace(',', '.'));
            if (!$6432e977b473e28b$var$validateTime(hours, minutes)) return NaN;
            return hours % 24 * $6432e977b473e28b$var$MILLISECONDS_IN_HOUR + minutes * $6432e977b473e28b$var$MILLISECONDS_IN_MINUTE;
        }
        token = $6432e977b473e28b$var$patterns.HHMMSS.exec(timeString);
        if (token) {
            hours = parseInt(token[1], 10);
            minutes = parseInt(token[2], 10);
            var seconds = parseFloat(token[3].replace(',', '.'));
            if (!$6432e977b473e28b$var$validateTime(hours, minutes, seconds)) return NaN;
            return hours % 24 * $6432e977b473e28b$var$MILLISECONDS_IN_HOUR + minutes * $6432e977b473e28b$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
        }
        return null;
    }
    function $6432e977b473e28b$var$dayOfISOWeekYear(isoWeekYear, week, day) {
        week = week || 0;
        day = day || 0;
        var date = new Date(0);
        date.setUTCFullYear(isoWeekYear, 0, 4);
        var fourthOfJanuaryDay = date.getUTCDay() || 7;
        var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
        date.setUTCDate(date.getUTCDate() + diff);
        return date;
    }
    var $6432e977b473e28b$var$DAYS_IN_MONTH = [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    var $6432e977b473e28b$var$DAYS_IN_MONTH_LEAP_YEAR = [
        31,
        29,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    function $6432e977b473e28b$var$isLeapYearIndex(year) {
        return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
    }
    function $6432e977b473e28b$var$validateDate(year, month, date) {
        if (month < 0 || month > 11) return false;
        if (date != null) {
            if (date < 1) return false;
            var isLeapYear = $6432e977b473e28b$var$isLeapYearIndex(year);
            if (isLeapYear && date > $6432e977b473e28b$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
            if (!isLeapYear && date > $6432e977b473e28b$var$DAYS_IN_MONTH[month]) return false;
        }
        return true;
    }
    function $6432e977b473e28b$var$validateDayOfYearDate(year, dayOfYear) {
        if (dayOfYear < 1) return false;
        var isLeapYear = $6432e977b473e28b$var$isLeapYearIndex(year);
        if (isLeapYear && dayOfYear > 366) return false;
        if (!isLeapYear && dayOfYear > 365) return false;
        return true;
    }
    function $6432e977b473e28b$var$validateWeekDate(year, week, day) {
        if (week < 0 || week > 52) return false;
        if (day != null && (day < 0 || day > 6)) return false;
        return true;
    }
    function $6432e977b473e28b$var$validateTime(hours, minutes, seconds) {
        if (hours != null && (hours < 0 || hours >= 25)) return false;
        if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
        if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
        return true;
    }
});
parcelRegister("6mIEj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a276e939be80677$export$2e2bcd8739ae039);
    var $4a276e939be80677$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
    var $4a276e939be80677$export$2e2bcd8739ae039 = $4a276e939be80677$var$tzPattern;
});
parcelRegister("2QEk5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$212fb76ac823dc5f$export$2e2bcd8739ae039);
    var $9h5G9 = parcelRequire("9h5G9");
    var $8Bm5s;
    function $212fb76ac823dc5f$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
        var date = (0, (0, parcelRequire("8Bm5s")).default)(dirtyDate, options);
        var offsetMilliseconds = (0, $9h5G9.default)(timeZone, date, true);
        var d = new Date(date.getTime() - offsetMilliseconds);
        var resultDate = new Date(0);
        resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
        return resultDate;
    }
});
parcelRegister("7zIYP", function(module, exports) {
    $parcel$export(module.exports, "transformUserTimelineResponse", ()=>$1c86e0101dc62313$export$78049913b79774a2);
    var $dRQUI;
    const $1c86e0101dc62313$export$78049913b79774a2 = ({ startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, startOffsetMillis: startOffsetMillis, endOffsetMillis: endOffsetMillis, utcTimeOffsetMillis: utcTimeOffsetMillis, currentTime: currentTime, periods: periods, ...data })=>{
        return {
            startEpoch: startTimeUtcMillis,
            endEpoch: endTimeUtcMillis,
            nowEpoch: currentTime,
            startOffset: startOffsetMillis,
            endOffset: endOffsetMillis,
            nowOffset: utcTimeOffsetMillis,
            data: {
                ...data,
                periods: periods.map((0, (0, parcelRequire("dRQUI")).fromMergedPeriodResponseToClusterPeriod))
            }
        };
    };
});
parcelRegister("dRQUI", function(module, exports) {
    $parcel$export(module.exports, "fromMergedPeriodResponseToClusterPeriod", ()=>$fb90e7a436622624$export$9b0bac75f135bd57);
    const $fb90e7a436622624$export$9b0bac75f135bd57 = (mergedPeriodResponse)=>{
        const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, overlappingPeriods: overlappingPeriods } = mergedPeriodResponse;
        const clusterPeriod = {
            id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
            startEpoch: startTimeUtcMillis,
            endEpoch: endTimeUtcMillis,
            isTrueStartTime: isTrueStartTime,
            isTrueEndTime: isTrueEndTime,
            startOffset: periodStartOffsetMillis,
            endOffset: periodEndOffsetMillis,
            overlaps: overlappingPeriods.map($fb90e7a436622624$var$fromOverlappingPeriodResponseToOverlappingPeriod)
        };
        return clusterPeriod;
    };
    const $fb90e7a436622624$var$fromOverlappingPeriodResponseToOverlappingPeriod = (overlappingPeriodResponse)=>{
        const { startTimeUtcMillis: startTimeUtcMillis, endTimeUtcMillis: endTimeUtcMillis, periodStartOffsetMillis: periodStartOffsetMillis, periodEndOffsetMillis: periodEndOffsetMillis, overlappingRotations: overlappingRotations, isTrueStartTime: isTrueStartTime, isTrueEndTime: isTrueEndTime } = overlappingPeriodResponse;
        const overlappingPeriod = {
            id: `${startTimeUtcMillis}-${endTimeUtcMillis}`,
            startEpoch: startTimeUtcMillis,
            endEpoch: endTimeUtcMillis,
            startOffset: periodStartOffsetMillis,
            endOffset: periodEndOffsetMillis,
            overlaps: overlappingRotations,
            isTrueStartTime: isTrueStartTime,
            isTrueEndTime: isTrueEndTime
        };
        return overlappingPeriod;
    };
});
parcelRegister("5Dlsd", function(module, exports) {
    $parcel$export(module.exports, "whoIsOnCallRoute", ()=>$d411783403a09613$export$26b06efd7311586b);
    var $65Ltd;
    const $d411783403a09613$export$26b06efd7311586b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_EOC),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EOC_WHO_IS_ON_CALL),
        path: '/jira/ops/who-is-on-call',
        exact: true
    };
});
parcelRegister("c2Cr1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("g1eRw")
    ]).then(()=>parcelRequire('eV5T9'));
});
parcelRegister("9GJG2", function(module, exports) {
    $parcel$export(module.exports, "errorsNotFoundRouteEntry", ()=>$9dd385bec704f15e$export$c4c012a49b465e94);
    var $ffza4;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $5lsNZ;
    var $7JdpQ;
    const $9dd385bec704f15e$export$c4c012a49b465e94 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("7JdpQ")).errorsNotFoundRoute), ()=>({
            component: (0, (0, parcelRequire("5lsNZ")).default),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("5lsNZ")).LazyNotFoundErrorPage)
            ]
        }));
});
parcelRegister("7JdpQ", function(module, exports) {
    $parcel$export(module.exports, "errorsNotFoundRoute", ()=>$36fb274e5b4d9090$export$465fa01c0f3a0551);
    var $65Ltd;
    const $36fb274e5b4d9090$export$465fa01c0f3a0551 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ERRORS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ERRORS_NOT_FOUND),
        path: '/jira/:projectType(software|servicedesk|core)'
    };
});
parcelRegister("6NtPe", function(module, exports) {
    $parcel$export(module.exports, "forgeRouteEntries", ()=>$a901f652fe0a27d8$export$b1d92ac5cda62e7e);
    var $ffza4;
    var $gyYxw;
    var $ibkIl;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $iFaFr;
    var $hBv66;
    var $iHiHz;
    var $78U7j;
    var $h0bZU;
    var $2G9Bk;
    var $1XrjK;
    var $lNicp;
    var $bHhiy;
    var $2YqLE;
    var $3RJkv;
    var $atU1t;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    var $ehr4r;
    var $6Z2mh;
    var $hIGzE;
    var $6bHdH;
    var $aRZh7;
    var $ioJTL;
    var $9mZwV;
    const $a901f652fe0a27d8$export$fc82fa1ad8302441 = ()=>({
            component: (0, (0, parcelRequire("hIGzE")).default),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("iHiHz")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("hIGzE")).LazyForgeAdminPage)
            ]
        });
    const $a901f652fe0a27d8$export$1c55fbe0ae1da308 = ()=>({
            component: (0, (0, parcelRequire("ioJTL")).default),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSharedNavigationSingleResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("ioJTL")).LazyForgeProjectPage)
            ]
        });
    const $a901f652fe0a27d8$export$95c93c3fcfde8901 = ()=>({
            component: (0, (0, parcelRequire("6bHdH")).default),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("5bkvv")).forgeCustomFieldTypeResource),
                (0, (0, parcelRequire("2YqLE")).fieldContextConfigPageResource),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("6bHdH")).LazyForgeFieldContextConfigPage)
            ]
        });
    const $a901f652fe0a27d8$export$a2f53aa48e785c7 = ()=>({
            component: (0, (0, parcelRequire("9mZwV")).default),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("9mZwV")).LazyForgeServiceDeskQueuePage)
            ]
        });
    const $a901f652fe0a27d8$export$dbdc27694c56b868 = ()=>({
            component: (0, (0, parcelRequire("aRZh7")).default),
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)(),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).ADDONS,
                sidebar: (0, (0, parcelRequire("iFaFr")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationForgeGlobalPageResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("aRZh7")).LazyForgeGlobalPage)
            ]
        });
    const $a901f652fe0a27d8$export$b1d92ac5cda62e7e = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ehr4r")).forgeAdminSettingsRoute), ()=>$a901f652fe0a27d8$export$fc82fa1ad8302441()),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ehr4r")).forgeAdminRoute), ()=>$a901f652fe0a27d8$export$fc82fa1ad8302441()),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ehr4r")).forgeProjectRoute), ()=>$a901f652fe0a27d8$export$1c55fbe0ae1da308()),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ehr4r")).forgeServicedeskQueueRoute), ()=>$a901f652fe0a27d8$export$a2f53aa48e785c7()),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ehr4r")).forgeFieldContextualConfigurationRoute), ()=>$a901f652fe0a27d8$export$95c93c3fcfde8901()),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ehr4r")).forgeGlobalRoute), ()=>$a901f652fe0a27d8$export$dbdc27694c56b868())
    ];
});
parcelRegister("78U7j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f593a4193eb44f7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $hPtZI;
    const $4f593a4193eb44f7$var$LazyGlobalIssuesSettingsSidebar = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("jCoeB")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/global-settings-issues/src/index.tsx"
    });
    const $4f593a4193eb44f7$var$GlobalIssuesSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "globalIssuesSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4f593a4193eb44f7$var$LazyGlobalIssuesSettingsSidebar, null)));
    var $4f593a4193eb44f7$export$2e2bcd8739ae039 = $4f593a4193eb44f7$var$GlobalIssuesSettingsSidebar;
});
parcelRegister("jCoeB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jkFzD").then(()=>parcelRequire('dZptX'));
});
parcelRegister("2YqLE", function(module, exports) {
    $parcel$export(module.exports, "fieldContextConfigPageResource", ()=>$2520f99c62492240$export$686a607053a18611);
    var $dIdda = parcelRequire("dIdda");
    const $2520f99c62492240$export$686a607053a18611 = (0, $dIdda.createResource)({
        type: (0, $714c31c1c770eaf3$export$4b80522d38222ad),
        getKey: ()=>'data',
        getDataLoader: ()=>(parcelRequire("gAT5i")),
        maxAge: 5000
    });
});
const $714c31c1c770eaf3$export$4b80522d38222ad = 'FORGE_FIELD_CONTEXTUAL_CONFIG';
parcelRegister("gAT5i", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("ftzT3").then(()=>parcelRequire('ei6Pl'));
});
parcelRegister("ehr4r", function(module, exports) {
    $parcel$export(module.exports, "forgeAdminSettingsRoute", ()=>$9d69eef872039dea$export$392534a80a0b9b11);
    $parcel$export(module.exports, "forgeAdminRoute", ()=>$9d69eef872039dea$export$157f97e6454c2a9f);
    $parcel$export(module.exports, "forgeProjectRoute", ()=>$9d69eef872039dea$export$998d01fc8f4c3224);
    $parcel$export(module.exports, "forgeServicedeskQueueRoute", ()=>$9d69eef872039dea$export$b77275b989ab42a6);
    $parcel$export(module.exports, "forgeFieldContextualConfigurationRoute", ()=>$9d69eef872039dea$export$2ee4468dd8e9636f);
    $parcel$export(module.exports, "forgeGlobalRoute", ()=>$9d69eef872039dea$export$4146dba061d1c72d);
    var $65Ltd;
    const $9d69eef872039dea$export$392534a80a0b9b11 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_ADMIN_SETTINGS),
        path: '/jira/settings/apps/:settingsType(configure|get-started)/:appId/:envId/:route?'
    };
    const $9d69eef872039dea$export$157f97e6454c2a9f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_ADMIN),
        path: '/jira/settings/apps/:appId/:envId/:route?'
    };
    const $9d69eef872039dea$export$998d01fc8f4c3224 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT),
        path: '/jira/:projectType(software|software/c|servicedesk|core)/projects/:projectKey/apps/:appId/:envId/:route?'
    };
    const $9d69eef872039dea$export$b77275b989ab42a6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_SERVICEDESK_QUEUE),
        path: '/jira/servicedesk/projects/:projectKey/queues/apps/:appId/:envId/:route?'
    };
    const $9d69eef872039dea$export$2ee4468dd8e9636f = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_FIELD_CONTEXTUAL_CONFIGURATION),
        path: '/jira/settings/issues/field/:fieldId/context/:contextId/configure/app'
    };
    const $9d69eef872039dea$export$4146dba061d1c72d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_GLOBAL),
        path: '/jira/apps/:appId/:envId/:route?'
    };
});
parcelRegister("hIGzE", function(module, exports) {
    $parcel$export(module.exports, "LazyForgeAdminPage", ()=>$bef31a55bb1643fb$export$66ee65dcd4a6458d);
    $parcel$export(module.exports, "default", ()=>$bef31a55bb1643fb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $bef31a55bb1643fb$export$66ee65dcd4a6458d = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("5bXwS")), {
        moduleId: "./src/packages/spa-apps/forge/admin/src/index.tsx"
    });
    const $bef31a55bb1643fb$export$c9e5f500ef472147 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $bef31a55bb1643fb$export$66ee65dcd4a6458d,
            pageId: "forge-spa-admin",
            shouldShowSpinner: true
        });
    var $bef31a55bb1643fb$export$2e2bcd8739ae039 = $bef31a55bb1643fb$export$c9e5f500ef472147;
});
parcelRegister("5bXwS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("f8cIm").then(()=>parcelRequire('bqE5a'));
});
parcelRegister("6bHdH", function(module, exports) {
    $parcel$export(module.exports, "LazyForgeFieldContextConfigPage", ()=>$b96b1546635e7c38$export$c53e206c7fd6fb76);
    $parcel$export(module.exports, "default", ()=>$b96b1546635e7c38$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $b96b1546635e7c38$export$c53e206c7fd6fb76 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("32VdM")), {
        moduleId: "./src/packages/spa-apps/forge/field-contextual-config/src/index.tsx"
    });
    const $b96b1546635e7c38$export$50bd0baee0b2f946 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b96b1546635e7c38$export$c53e206c7fd6fb76,
            pageId: "forge-spa-field-context-config",
            shouldShowSpinner: true
        });
    var $b96b1546635e7c38$export$2e2bcd8739ae039 = $b96b1546635e7c38$export$50bd0baee0b2f946;
});
parcelRegister("32VdM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("5CiUy").then(()=>parcelRequire('jBnrF'));
});
parcelRegister("aRZh7", function(module, exports) {
    $parcel$export(module.exports, "LazyForgeGlobalPage", ()=>$8f6029962fb4c5dc$export$332293feb5cffd72);
    $parcel$export(module.exports, "default", ()=>$8f6029962fb4c5dc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $8f6029962fb4c5dc$export$332293feb5cffd72 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("98CQn")), {
        moduleId: "./src/packages/spa-apps/forge/global/src/index.tsx"
    });
    const $8f6029962fb4c5dc$export$4c36a7b018e5e5cc = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8f6029962fb4c5dc$export$332293feb5cffd72,
            pageId: "forge-spa-global",
            shouldShowSpinner: true
        });
    var $8f6029962fb4c5dc$export$2e2bcd8739ae039 = $8f6029962fb4c5dc$export$4c36a7b018e5e5cc;
});
parcelRegister("98CQn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("erHCa").then(()=>parcelRequire('eZUti'));
});
parcelRegister("ioJTL", function(module, exports) {
    $parcel$export(module.exports, "LazyForgeProjectPage", ()=>$495262f31d81d9db$export$27b0c9e982208d7e);
    $parcel$export(module.exports, "default", ()=>$495262f31d81d9db$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $495262f31d81d9db$export$27b0c9e982208d7e = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("9ORLZ")), {
        moduleId: "./src/packages/spa-apps/forge/project/src/index.tsx"
    });
    const $495262f31d81d9db$export$99737a64be9f5f1 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $495262f31d81d9db$export$27b0c9e982208d7e,
            pageId: "forge-spa-project",
            shouldShowSpinner: true
        });
    var $495262f31d81d9db$export$2e2bcd8739ae039 = $495262f31d81d9db$export$99737a64be9f5f1;
});
parcelRegister("9ORLZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cBmhJ").then(()=>parcelRequire('kGkpN'));
});
parcelRegister("9mZwV", function(module, exports) {
    $parcel$export(module.exports, "LazyForgeServiceDeskQueuePage", ()=>$ebb310d709581894$export$62e1bcb9c27c99b5);
    $parcel$export(module.exports, "default", ()=>$ebb310d709581894$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $ebb310d709581894$export$62e1bcb9c27c99b5 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("74XPL")), {
        moduleId: "./src/packages/spa-apps/forge/servicedesk-queue/src/index.tsx"
    });
    const $ebb310d709581894$export$e83b7c5b466e791a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ebb310d709581894$export$62e1bcb9c27c99b5,
            pageId: "forge-spa-servicedesk-queue",
            shouldShowSpinner: true
        });
    var $ebb310d709581894$export$2e2bcd8739ae039 = $ebb310d709581894$export$e83b7c5b466e791a;
});
parcelRegister("74XPL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2GKln").then(()=>parcelRequire('6Ue2s'));
});
parcelRegister("d7x0M", function(module, exports) {
    $parcel$export(module.exports, "globalMailSettingsRouteEntry", ()=>$94bf6699a35b0833$export$5e1236665a530df4);
    var $ffza4;
    var $bwLf9;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $18xUs;
    var $euIkX;
    var $21A4f;
    const $94bf6699a35b0833$export$5e1236665a530df4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("18xUs")).globalMailSettingsRoute), ()=>({
            ufoName: 'admin.global-mail-settings',
            component: (0, (0, parcelRequire("bwLf9")).default)(()=>true, (0, (0, parcelRequire("21A4f")).default), (0, (0, parcelRequire("euIkX")).default)),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("21A4f")).LazyGlobalMailSettings)
            ]
        }));
});
parcelRegister("18xUs", function(module, exports) {
    $parcel$export(module.exports, "globalMailSettingsRoute", ()=>$f9477dd155e645fe$export$e69b84daf70501b3);
    var $65Ltd;
    const $f9477dd155e645fe$export$e69b84daf70501b3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_MAIL_SETTINGS),
        path: '/secure/admin/global-mail-settings',
        exact: true
    };
});
parcelRegister("euIkX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1a0afe23818eb6ed$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3mK2k;
    var $1a0afe23818eb6ed$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3mK2k")).default), null);
});
parcelRegister("21A4f", function(module, exports) {
    $parcel$export(module.exports, "LazyGlobalMailSettings", ()=>$cc4123579e370fa7$export$a133d90b2004a90e);
    $parcel$export(module.exports, "default", ()=>$cc4123579e370fa7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $cc4123579e370fa7$export$a133d90b2004a90e = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("7OdtI"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/global-mail-settings/src/index.tsx"
    });
    var $cc4123579e370fa7$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cc4123579e370fa7$export$a133d90b2004a90e,
            pageId: "global-mail-settings",
            shouldShowSpinner: false
        });
});
parcelRegister("7OdtI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("8yfIj")
    ]).then(()=>parcelRequire('7ROZZ'));
});
parcelRegister("dIf7c", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsCustomFieldsRouteEntry", ()=>$13bdc7f7e2c68d21$export$d83c2e469d070766);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $cpdjw;
    var $3RJkv;
    var $atU1t;
    var $g1Jzd;
    var $eUwrd;
    const $13bdc7f7e2c68d21$export$d83c2e469d070766 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("g1Jzd")).globalSettingsCustomFieldsRoute), ()=>({
            ufoName: 'admin.custom-fields-directory',
            component: (0, (0, parcelRequire("eUwrd")).default),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("cpdjw")).customFieldsDirectoryResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("eUwrd")).LazyCustomFieldsDirectoryAdmin)
            ]
        }));
});
parcelRegister("cpdjw", function(module, exports) {
    $parcel$export(module.exports, "customFieldsDirectoryResource", ()=>$dcd1379dc352c4e2$export$3d783f106e15b01a);
    var $dIdda = parcelRequire("dIdda");
    const $dcd1379dc352c4e2$export$3d783f106e15b01a = (0, $dIdda.createResource)({
        type: (0, $d558514bbbbc39cd$export$f237bae095c310e7),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("2qCzi"))
    });
});
const $d558514bbbbc39cd$export$f237bae095c310e7 = 'CUSTOM_FIELDS_DIRECTORY';
parcelRegister("2qCzi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8mAnw").then(()=>parcelRequire('fFz2g'));
});
parcelRegister("g1Jzd", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsCustomFieldsRoute", ()=>$48a2162c2bcbc13a$export$45e7d93edcc9507f);
    var $65Ltd;
    const $48a2162c2bcbc13a$export$45e7d93edcc9507f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_CUSTOM_FIELDS),
        path: '/secure/admin/ViewCustomFields(!default)?.jspa'
    };
});
parcelRegister("eUwrd", function(module, exports) {
    $parcel$export(module.exports, "LazyCustomFieldsDirectoryAdmin", ()=>$0183f6c188d0635c$export$55a5c16f39a046af);
    $parcel$export(module.exports, "default", ()=>$0183f6c188d0635c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $0183f6c188d0635c$export$55a5c16f39a046af = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kI1WL"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/custom-fields-directory/src/index.tsx"
    });
    var $0183f6c188d0635c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0183f6c188d0635c$export$55a5c16f39a046af,
            pageId: "admin-pages-custom-fields-directory",
            shouldShowSpinner: true
        });
});
parcelRegister("kI1WL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2lIOR")
    ]).then(()=>parcelRequire('4ZT30'));
});
parcelRegister("51f7x", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRouteEntry", ()=>$9651cb580c71c297$export$5519b86c9ea602e1);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $1RJbT;
    var $aYyVm;
    const $9651cb580c71c297$export$5519b86c9ea602e1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1RJbT")).globalSettingsIssuesExplicitFieldAssociationRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            component: (0, (0, parcelRequire("aYyVm")).LazyExplicitFieldsProjectListPage),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("aYyVm")).LazyExplicitFieldsProjectListPromise)
            ]
        }));
});
parcelRegister("1RJbT", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesExplicitFieldAssociationRoute", ()=>$e49bb87876b98a92$export$4f2c2d125c2b811a);
    var $65Ltd;
    const $e49bb87876b98a92$export$4f2c2d125c2b811a = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_EXPLICIT_FIELD_ASSOCIATION_PROJECT_LIST),
        path: '/jira/settings/issues/explicit-field-association'
    };
});
parcelRegister("aYyVm", function(module, exports) {
    $parcel$export(module.exports, "LazyExplicitFieldsProjectListPromise", ()=>$95736e1c9d4aba6e$export$7b11685155ada84d);
    $parcel$export(module.exports, "LazyExplicitFieldsProjectListPage", ()=>$95736e1c9d4aba6e$export$e81c180c4f4833e);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $95736e1c9d4aba6e$export$7b11685155ada84d = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>{
        return (0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("7wmre")).then((bundle)=>bundle.ExplicitFieldAssociationProjectListApp));
    }, {
        moduleId: "./src/packages/admin-pages/explicit-field-association/project-list/src/index.tsx"
    });
    const $95736e1c9d4aba6e$export$e81c180c4f4833e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $95736e1c9d4aba6e$export$7b11685155ada84d,
            pageId: "jira-admin-pages-explicit-field-association-project-list",
            shouldShowSpinner: true
        });
});
parcelRegister("7wmre", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eNmuD"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3r4bl")
    ]).then(()=>parcelRequire('61Yus'));
});
parcelRegister("k6cxW", function(module, exports) {
    $parcel$export(module.exports, "homeOnboardingRedirectRouteEntry", ()=>$c38858cd7db392da$export$2740cfaa979353b9);
    var $ffza4;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $kZ4WS;
    var $dzpo2;
    const $c38858cd7db392da$export$2740cfaa979353b9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kZ4WS")).homeOnboardingRedirectRoute), ()=>({
            component: (0, (0, parcelRequire("dzpo2")).default),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            isRedirect: true,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
});
parcelRegister("kZ4WS", function(module, exports) {
    $parcel$export(module.exports, "homeOnboardingRedirectRoute", ()=>$80e6677eddcef453$export$2eaffde3ad991b33);
    var $65Ltd;
    const $80e6677eddcef453$export$2eaffde3ad991b33 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HOME),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HOME_ONBOARDING_REDIRECT),
        path: '/jira/your-work-onboarding',
        exact: true
    };
});
parcelRegister("dzpo2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff7a191a114ce3ba$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5oFIy;
    var $dIdda = parcelRequire("dIdda");
    const $ff7a191a114ce3ba$var$JiraHomeOnboardingRedirect = ()=>{
        const { replace: replace } = (0, $dIdda.useRouterActions)();
        replace('/jira/your-work');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), {
            eventName: "JiraHomeOnboardingRedirect loaded",
            componentName: "JiraHomeOnboardingRedirect",
            attributes: {
                isRedirectionEnabled: true
            }
        });
    };
    var $ff7a191a114ce3ba$export$2e2bcd8739ae039 = $ff7a191a114ce3ba$var$JiraHomeOnboardingRedirect;
});
parcelRegister("5oFIy", function(module, exports) {
    $parcel$export(module.exports, "FireUiAnalytics", ()=>$3ea3e1dfbcd8cda6$export$5a67e7291fd4569e);
    $parcel$export(module.exports, "FireTrackAnalytics", ()=>$3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86);
    $parcel$export(module.exports, "FireOperationalAnalytics", ()=>$3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da);
    $parcel$export(module.exports, "FireScreenAnalytics", ()=>$3ea3e1dfbcd8cda6$export$2ccf161b817b43b);
    var $5uXOq = parcelRequire("5uXOq");
    var $fpTxz;
    var $8zOmE;
    class $3ea3e1dfbcd8cda6$var$FireComponent extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { type: type, attributes: attributes, eventName: eventName, componentName: componentName, action: actionProps, actionSubject: actionSubjectProps, actionSubjectId: actionSubjectIdProps } = this.props;
            if (eventName && (actionProps || actionSubjectProps)) throw Error('eventName is an alias for action & actionSubject, provide only one of those');
            if (componentName && actionSubjectIdProps) throw Error('componentName is an alias for actionSubjectId, provide only one of those');
            const eventNameSplit = eventName ? eventName.split(' ') : [];
            const action = actionProps || eventNameSplit[1];
            const actionSubject = actionSubjectProps || eventNameSplit[0];
            if (!action || !actionSubject) throw Error('eventName should exist and be in the format "subject action", i.e. "button clicked", "menu opened", "issue created", etc');
            const actionSubjectId = actionSubjectIdProps || componentName;
            const analyticsEvent = this.props.createAnalyticsEvent({
                action: action
            });
            (0, (0, parcelRequire("8zOmE")).fireAnalytics)(analyticsEvent, type, {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                attributes: attributes
            });
        }
        render() {
            return null;
        }
    }
    const $3ea3e1dfbcd8cda6$export$64eb47d7b94ba089 = (0, (0, parcelRequire("fpTxz")).default)()($3ea3e1dfbcd8cda6$var$FireComponent);
    const $3ea3e1dfbcd8cda6$export$5a67e7291fd4569e = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
            ...props,
            type: (0, $4d5e0871c06cee03$export$a1562d08625f5d7e)
        });
    const $3ea3e1dfbcd8cda6$export$5f0d7aae8dfa8b86 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
            ...props,
            type: (0, $4d5e0871c06cee03$export$947dac6c72b26f81)
        });
    const $3ea3e1dfbcd8cda6$export$b71c3ada5d4ec5da = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
            ...props,
            type: (0, $4d5e0871c06cee03$export$12346a674644c156)
        });
    const $3ea3e1dfbcd8cda6$export$2ccf161b817b43b = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3ea3e1dfbcd8cda6$export$64eb47d7b94ba089, {
            ...props,
            type: (0, $4d5e0871c06cee03$export$f1d537d508d2945a),
            eventName: "screen viewed"
        });
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("lQc3c", function(module, exports) {
    $parcel$export(module.exports, "homeRedirectRouteEntry", ()=>$de227c172beddad9$export$5379c026da4201e6);
    var $ffza4;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $6L7lV;
    var $crx5O;
    const $de227c172beddad9$export$5379c026da4201e6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6L7lV")).homeRedirectRoute), ()=>({
            component: (0, (0, parcelRequire("crx5O")).default),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            isRedirect: true,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
});
parcelRegister("6L7lV", function(module, exports) {
    $parcel$export(module.exports, "homeRedirectRoute", ()=>$d0046bbda59507f3$export$f7a252c9d61f8f94);
    var $65Ltd;
    const $d0046bbda59507f3$export$f7a252c9d61f8f94 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HOME),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HOME_REDIRECT),
        path: '/jira',
        exact: true
    };
});
parcelRegister("crx5O", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$92d7d72ca8393409$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dXRYE;
    var $92d7d72ca8393409$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dXRYE")).default), null);
});
parcelRegister("dXRYE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e5a49877dbf7e167$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dJl1T;
    var $9vlEn;
    var $dIdda = parcelRequire("dIdda");
    const $e5a49877dbf7e167$var$JiraBaseRedirectWrapper = ()=>{
        const { data: data, loading: loading } = (0, $dIdda.useResource)((0, (0, parcelRequire("9vlEn")).userHomepageResource));
        (0, $5uXOq.useEffect)(()=>{
            if (!loading && data == null) (0, (0, parcelRequire("dJl1T")).default).safeInfoWithoutCustomerData((0, $2791311ae97b7f0a$export$25a759e49d5049db), 'userHomepage data is null');
        }, [
            loading,
            data
        ]);
        if (loading) return null;
        if (data == null) {
            window.location.replace('/jira');
            return null;
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: data.homepagePreference
        });
    };
    var $e5a49877dbf7e167$export$2e2bcd8739ae039 = $e5a49877dbf7e167$var$JiraBaseRedirectWrapper;
});
const $2791311ae97b7f0a$export$25a759e49d5049db = 'spa-apps.common.redirect.jira-base-routing';
parcelRegister("k53hh", function(module, exports) {
    $parcel$export(module.exports, "issueCreateEmbedRouteEntry", ()=>$5e1de5a76ddb2c35$export$abd0bbe95839baf7);
    var $5uXOq = parcelRequire("5uXOq");
    var $6e4Kt;
    var $2G9Bk;
    var $2Ql51;
    var $k4qUs;
    var $9NiTW;
    var $5j7Th;
    var $hPtZI;
    const $5e1de5a76ddb2c35$var$handleEmbedLinkClick = (e)=>{
        const eventTarget = e.target;
        if (eventTarget && eventTarget instanceof HTMLAnchorElement && eventTarget.target !== '_blank') eventTarget.target = '_blank';
    };
    const $5e1de5a76ddb2c35$export$980ea815ec2d0180 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("6QVTY")), {
        ssr: false,
        moduleId: "./src/packages/issue-create/issue-create-embed/src/index.tsx"
    });
    const $5e1de5a76ddb2c35$export$87fa8eff34eb030a = ()=>{
        (0, $5uXOq.useEffect)(()=>{
            window.addEventListener('click', $5e1de5a76ddb2c35$var$handleEmbedLinkClick, true);
            return ()=>{
                window.removeEventListener('click', $5e1de5a76ddb2c35$var$handleEmbedLinkClick);
            };
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NiTW")).AuthenticationCheck), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5e1de5a76ddb2c35$export$980ea815ec2d0180,
            pageId: "spa-apps/issue-create-embed",
            shouldShowSpinner: true
        }));
    };
    const $5e1de5a76ddb2c35$export$abd0bbe95839baf7 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("k4qUs")).issueCreateEmbedRoute), ()=>({
            component: $5e1de5a76ddb2c35$export$87fa8eff34eb030a,
            resources: [
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
            forPaint: [
                $5e1de5a76ddb2c35$export$980ea815ec2d0180
            ]
        }));
});
parcelRegister("k4qUs", function(module, exports) {
    $parcel$export(module.exports, "issueCreateEmbedRoute", ()=>$2d82bbe7596c5321$export$c155f4de16b62110);
    var $65Ltd;
    const $2d82bbe7596c5321$export$c155f4de16b62110 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE_CREATE_EMBED),
        path: '/jira/issues/create/embed'
    };
});
parcelRegister("9NiTW", function(module, exports) {
    $parcel$export(module.exports, "checkAuthentication", ()=>$ad297a7f2ce81084$export$b8dbb7d6029c5413);
    $parcel$export(module.exports, "AuthenticationCheck", ()=>$ad297a7f2ce81084$export$e9b9096e887386fe);
    var $5uXOq = parcelRequire("5uXOq");
    var $9OXo1;
    var $38Y30;
    const $ad297a7f2ce81084$export$b8dbb7d6029c5413 = (tenantContext)=>Boolean(tenantContext.atlassianAccountId);
    const $ad297a7f2ce81084$export$e9b9096e887386fe = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            if ($ad297a7f2ce81084$export$b8dbb7d6029c5413(tenantContext)) return children;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("38Y30")).RedirectToLoginPage), null);
        });
});
parcelRegister("6QVTY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("kWrFZ"),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4KqZA")
    ]).then(()=>parcelRequire('5tdjr'));
});
parcelRegister("6fTgc", function(module, exports) {
    $parcel$export(module.exports, "issueNavigatorRouteEntries", ()=>$1f4483ba9d8ac23e$export$f9a1f59ec7d1f215);
    var $ffza4;
    var $co1wz;
    var $gyYxw;
    var $2BrOV;
    var $lmyls;
    var $hBv66;
    var $2G9Bk;
    var $1XrjK;
    var $bHhiy;
    var $d04s2;
    var $kumTR;
    var $1gXMV;
    var $lHYIV;
    var $fERWs;
    var $1QOEF;
    var $cFu3S;
    var $4nXyN;
    var $jrl3R;
    var $3B53X;
    var $glkO2;
    var $04Vlk;
    var $flsjf;
    var $b8f12;
    var $gGOoR;
    var $kF7iq;
    const $1f4483ba9d8ac23e$export$f9a1f59ec7d1f215 = [
        (0, (0, parcelRequire("glkO2")).issueNavigatorProjectClassicRouteEntry),
        (0, (0, parcelRequire("flsjf")).issueNavigatorProjectSoftwareRouteEntry),
        (0, (0, parcelRequire("04Vlk")).issueNavigatorProjectServicedeskRouteEntry),
        (0, (0, parcelRequire("3B53X")).issueNavigatorProjectBusinessRouteEntry),
        (0, (0, parcelRequire("jrl3R")).issueNavigatorGlobalRouteEntry),
        (0, (0, parcelRequire("4nXyN")).issueNavigatorGlobalJiraRouteEntry),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kumTR")).projectIssueNavigatorRoute), ()=>({
                ...(0, (0, parcelRequire("fERWs")).common),
                component: (0, (0, parcelRequire("kF7iq")).default),
                skeleton: (0, (0, parcelRequire("lHYIV")).ProjectIssueNavigatorSkeleton),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("b8f12")).LazyProjectIssueNavigator)
                ],
                afterPaint: [
                    (0, (0, parcelRequire("d04s2")).LazyIssueApp)
                ],
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
                },
                resources: [
                    ...(0, (0, parcelRequire("cFu3S")).getCommonProjectResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                layout: (0, (0, parcelRequire("1XrjK")).createLayout)((0, (0, parcelRequire("gyYxw")).genericProjectLayout))
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kumTR")).globalIssueNavigatorBrowseIssueRedirectRoute), ()=>({
                ...(0, (0, parcelRequire("fERWs")).common),
                component: (0, (0, parcelRequire("gGOoR")).default),
                skeleton: (0, (0, parcelRequire("1gXMV")).GlobalIssueNavigatorSkeleton),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("b8f12")).LazyGlobalIssueNavigator)
                ],
                canTransitionIn: ()=>(0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8'),
                ufoName: 'global-issue-navigator-jfe',
                navigation: (0, (0, parcelRequire("1QOEF")).getCommonGlobalNavigation)(),
                resources: [
                    ...(0, (0, parcelRequire("1QOEF")).getCommonGlobalResources)()
                ],
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout)
            }))
    ];
});
parcelRegister("kumTR", function(module, exports) {
    $parcel$export(module.exports, "projectIssueNavigatorRoute", ()=>$3108d9738994971d$export$126b16ec65343bf);
    $parcel$export(module.exports, "softwareIssueNavigatorRoute", ()=>$3108d9738994971d$export$ccfb6c4a189316bc);
    $parcel$export(module.exports, "projectIssueNavigatorClassicRoute", ()=>$3108d9738994971d$export$fa71d22b1c44463b);
    $parcel$export(module.exports, "servicedeskIssuesRoute", ()=>$3108d9738994971d$export$4be84a96ac761ab0);
    $parcel$export(module.exports, "projectIssueNavigatorCoreRoute", ()=>$3108d9738994971d$export$e961cccd2405cdd0);
    $parcel$export(module.exports, "globalIssueNavigatorRoute", ()=>$3108d9738994971d$export$f4c8e8bc55cd2008);
    $parcel$export(module.exports, "globalIssueNavigator1Route", ()=>$3108d9738994971d$export$2dfbbe89ed354013);
    $parcel$export(module.exports, "globalIssueNavigatorBrowseIssueRedirectRoute", ()=>$3108d9738994971d$export$34695dccebecc6bc);
    var $65Ltd;
    const $3108d9738994971d$export$126b16ec65343bf = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
        path: '/projects/:projectKey/issues/:issueKey?'
    };
    const $3108d9738994971d$export$ccfb6c4a189316bc = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ISSUE_NAVIGATOR),
        path: '/jira/software/projects/:projectKey/issues/:issueKey?'
    };
    const $3108d9738994971d$export$fa71d22b1c44463b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/issues/:issueKey?'
    };
    const $3108d9738994971d$export$4be84a96ac761ab0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ISSUES),
        path: '/jira/servicedesk/projects/:projectKey/issues/:issueKey?'
    };
    const $3108d9738994971d$export$e961cccd2405cdd0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE),
        path: '/jira/core/projects/:projectKey/issues/:issueKey?'
    };
    const $3108d9738994971d$export$f4c8e8bc55cd2008 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
        path: '/issues/:issueKey?'
    };
    const $3108d9738994971d$export$2dfbbe89ed354013 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR),
        path: '/jira/issues/:issueKey?'
    };
    const $3108d9738994971d$export$34695dccebecc6bc = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ISSUE_NAVIGATOR_BROWSE_ISSUE_REDIRECT),
        path: '/browse/:issueKey?',
        query: [
            'jql|filter'
        ]
    };
});
parcelRegister("1gXMV", function(module, exports) {
    $parcel$export(module.exports, "GlobalIssueNavigatorSkeleton", ()=>$c87e28c0f4513050$export$51681996374b2585);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $3hk93 = parcelRequire("3hk93");
    const $c87e28c0f4513050$var$customCssStyles = null;
    const $c87e28c0f4513050$export$51681996374b2585 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($3hk93))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2zz1zwfg _slt8zwfg _1od57vkz"
            ])
        });
});
parcelRegister("3hk93", function(module, exports) {
    module.exports = new URL("global-issue-navigator-skeleton.tpl.b1bf4b99.svg", import.meta.url).toString();
});
parcelRegister("lHYIV", function(module, exports) {
    $parcel$export(module.exports, "ProjectIssueNavigatorSkeleton", ()=>$8afa09f5da2bc6b1$export$112138f5f732a994);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $hDeVo = parcelRequire("hDeVo");
    const $8afa09f5da2bc6b1$var$customCssStyles = null;
    const $8afa09f5da2bc6b1$export$112138f5f732a994 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($hDeVo))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2zz1zwfg _slt8zwfg _1od57vkz"
            ])
        });
});
parcelRegister("hDeVo", function(module, exports) {
    module.exports = new URL("project-issue-navigator-skeleton.tpl.2a1718d8.svg", import.meta.url).toString();
});
parcelRegister("fERWs", function(module, exports) {
    $parcel$export(module.exports, "common", ()=>$906089a3c28fb671$export$919daad019702595);
    var $e4eHl = parcelRequire("e4eHl");
    var $65Ltd;
    const $906089a3c28fb671$export$919daad019702595 = {
        apdexIgnoreParams: [
            'issueKey'
        ],
        meta: {
            capability: (0, $281cbd47ba46dd7d$export$d0ad1160bb95ce50),
            reporting: {
                id: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR),
                packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ISSUE_NAVIGATOR)),
                teamName: 'empanada'
            }
        }
    };
});
parcelRegister("1QOEF", function(module, exports) {
    $parcel$export(module.exports, "getCommonGlobalNavigation", ()=>$797f27ab9ceb3235$export$2f31f4f387017d83);
    $parcel$export(module.exports, "getCommonGlobalResources", ()=>$797f27ab9ceb3235$export$343e92405307cf8d);
    var $4R6GH;
    var $lmyls;
    var $96w9D;
    var $8Wi6S;
    var $8CVvd;
    var $bATyw;
    var $89kiv;
    var $3RJkv;
    var $atU1t;
    var $gNStA;
    const $797f27ab9ceb3235$export$2f31f4f387017d83 = ()=>({
            menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).FILTERS,
            sidebar: (0, (0, parcelRequire("8Wi6S")).AsyncSidebarFiltersGlobal)
        });
    const $797f27ab9ceb3235$export$343e92405307cf8d = ()=>[
            (0, (0, parcelRequire("89kiv")).issueNavigatorRelayResource),
            (0, (0, parcelRequire("89kiv")).issueNavigatorFilterRelayResource),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('nin_request_hydrate_query_earlier'), (0, (0, parcelRequire("89kiv")).issueNavigatorHydrationRelayResource)),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
            (0, (0, parcelRequire("bATyw")).isNinGlobalScopeEnrolmentEnabledResource),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)((0, (0, parcelRequire("8CVvd")).getWillShowNav3), (0, (0, parcelRequire("96w9D")).sidebarFiltersGlobalResource))
        ];
});
parcelRegister("96w9D", function(module, exports) {
    $parcel$export(module.exports, "sidebarFiltersGlobalResource", ()=>$4afb52221e3a3f09$export$7e0b804085f0470d);
    var $ao2h1;
    var $gBXKh;
    var $6YG83;
    const $4afb52221e3a3f09$export$7e0b804085f0470d = (0, (0, parcelRequire("6YG83")).withGiraAggAnonSsrFix)((0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'NAVIGATION_SIDEBAR_FILTERS_GLOBAL',
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("gBXKh")).default),
                variables: {
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    }));
});
parcelRegister("gBXKh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a0f1ab872360a786$export$2e2bcd8739ae039);
    const $a0f1ab872360a786$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v2 = [
            v1
        ], v3 = {
            "kind": "ScalarField",
            "name": "filterId"
        }, v4 = {
            "kind": "ScalarField",
            "name": "isFavourite"
        }, v5 = {
            "kind": "ScalarField",
            "name": "jql"
        }, v6 = {
            "kind": "ScalarField",
            "name": "name"
        }, v7 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ],
            "type": "JiraCustomFilter"
        }, v8 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2,
                                    "kind": "FragmentSpread",
                                    "name": "starredFiltersList_navigationAppsSidebarCommon"
                                },
                                {
                                    "args": v2,
                                    "kind": "FragmentSpread",
                                    "name": "systemFilters_navigationAppsSidebarFilters_SystemFiltersSection"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "JiraFilterConnection",
                                "kind": "LinkedField",
                                "name": "favouriteFilters",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraFilterEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v3,
                                                    {
                                                        "kind": "TypeDiscriminator",
                                                        "abstractKey": "__isJiraFilter"
                                                    },
                                                    v4,
                                                    v5,
                                                    v6,
                                                    v7,
                                                    v8
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": [
                                    v1,
                                    {
                                        "kind": "Literal",
                                        "name": "isFavourite",
                                        "value": false
                                    }
                                ],
                                "concreteType": "JiraSystemFilterConnection",
                                "kind": "LinkedField",
                                "name": "systemFilters",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSystemFilterEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSystemFilter",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v3,
                                                    v8,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v4,
                                                            v5,
                                                            v6,
                                                            v7
                                                        ],
                                                        "type": "JiraFilter",
                                                        "abstractKey": "__isJiraFilter"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "0fc7dfdbeee4792faa92449e364dd4b9b51f2ed2fc3bd618160e27885c980a88",
                "metadata": {},
                "name": "menuNavigationAppsSidebarFiltersGlobalScopeQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $a0f1ab872360a786$var$node.hash = "b5467e25277d67ce676aa25dd3a16377";
    var $a0f1ab872360a786$export$2e2bcd8739ae039 = $a0f1ab872360a786$var$node;
});
parcelRegister("6YG83", function(module, exports) {
    $parcel$export(module.exports, "withGiraAggAnonSsrFix", ()=>$895edd6ed19f0aa8$export$f4b29e78f4c0a526);
    const $895edd6ed19f0aa8$export$f4b29e78f4c0a526 = (resource)=>{
        if (!resource || !resource.getData) return resource;
        const originalGetData = resource.getData;
        resource.getData = (routerContext, customContext)=>{
            if (false && customContext.tenantContext.isAnonymous) return Promise.resolve(null);
            return originalGetData(routerContext, customContext);
        };
        return resource;
    };
});
parcelRegister("8Wi6S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c9fa7b304f828b3$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "AsyncSidebarFiltersGlobal", ()=>$7c9fa7b304f828b3$export$1af88ebe65f50e73);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $hPtZI;
    const $7c9fa7b304f828b3$var$LazySidebarFiltersLegacy = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("d3UTn")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/filters/src/index.tsx"
    });
    const $7c9fa7b304f828b3$var$AsyncSidebarFiltersLegacy = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "filters"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7c9fa7b304f828b3$var$LazySidebarFiltersLegacy, null)));
    var $7c9fa7b304f828b3$export$2e2bcd8739ae039 = $7c9fa7b304f828b3$var$AsyncSidebarFiltersLegacy;
    const $7c9fa7b304f828b3$var$LazySidebarFiltersGlobal = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("8GB8S")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle.SidebarFiltersGlobal;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/filters/src/ui/global-scope/index.tsx"
    });
    const $7c9fa7b304f828b3$export$1af88ebe65f50e73 = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "filters-global"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7c9fa7b304f828b3$var$LazySidebarFiltersGlobal, null)));
});
parcelRegister("d3UTn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("iTs3w")
    ]).then(()=>parcelRequire('7T8w9'));
});
parcelRegister("8GB8S", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("2dpYI")
    ]).then(()=>parcelRequire('hcPI1'));
});
parcelRegister("bATyw", function(module, exports) {
    $parcel$export(module.exports, "isNinGlobalScopeEnrolmentEnabledResource", ()=>$a818348721ae6866$export$3f6390b4131d761b);
    var $dIdda = parcelRequire("dIdda");
    const $a818348721ae6866$var$getDataLoader = ()=>(parcelRequire("b9fyS"));
    const $a818348721ae6866$export$3f6390b4131d761b = (0, $dIdda.createResource)({
        type: 'NIN_GLOBAL_SCOPE_ENROLMENT_RESOURCE',
        getKey: ()=>'ninGlobalScopeEnrolment',
        getDataLoader: $a818348721ae6866$var$getDataLoader
    });
});
parcelRegister("b9fyS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("f9qz1").then(()=>parcelRequire('dIecw'));
});
parcelRegister("89kiv", function(module, exports) {
    $parcel$export(module.exports, "issueNavigatorRelayResource", ()=>$93f22f98fd07bff0$export$b4096f516fb93159);
    $parcel$export(module.exports, "issueNavigatorFilterRelayResource", ()=>$93f22f98fd07bff0$export$44ca3a0b25f38d83);
    $parcel$export(module.exports, "issueNavigatorHydrationRelayResource", ()=>$93f22f98fd07bff0$export$967ef0cfbd1cc946);
    var $8Uumt = parcelRequire("8Uumt");
    var $axGKd;
    var $9Nvh7;
    var $6UAdF;
    var $dXq4S;
    var $5yJb9;
    var $kipqU;
    var $ao2h1;
    var $16Yit;
    var $kvekU;
    var $hTvlq;
    var $dIdda = parcelRequire("dIdda");
    var $5bSAg;
    var $aBKbA;
    const $93f22f98fd07bff0$export$b4096f516fb93159 = (0, $dIdda.createResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${(0, (0, parcelRequire("5bSAg")).RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY)}`,
        getKey: ()=>'issue-navigator-relay',
        getData: async (routerContext, { tenantContext: tenantContext })=>{
            if (false && tenantContext.isAnonymous) return null;
            const { projectKey: projectKey, issueKey: issueKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, (0, parcelRequire("aBKbA")).getParams)(routerContext);
            const jqlOrFilterId = (0, (0, parcelRequire("aBKbA")).getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
            const maxIssuesPerPage = (0, (0, parcelRequire("6UAdF")).getMaxIssuesPerPage)();
            const variables = {
                cloudId: tenantContext.cloudId,
                first: issueKey == null ? maxIssuesPerPage : null,
                issueSearchInput: jqlOrFilterId,
                namespace: (0, (0, parcelRequire("6UAdF")).ISSUE_SEARCH_NAMESPACE),
                after: null,
                options: {
                    issueKey: issueKey
                },
                fieldSetIds: [],
                shouldQueryFieldSetsById: false,
                filterId: Boolean(filter) && (0, (0, parcelRequire("9Nvh7")).isCustomFilter)(filter) ? filter : null,
                amountOfColumns: (0, (0, parcelRequire("6UAdF")).MAX_AMOUNT_OF_COLUMNS),
                atlassianIntelligenceProductFeature: (0, (0, parcelRequire("6UAdF")).NATURAL_LANGUAGE_TO_JQL)
            };
            const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("hTvlq")).default), variables, {
                fetchPolicy: 'network-only',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            });
            if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            return queryReference;
        },
        maxAge: 0
    });
    const $93f22f98fd07bff0$export$44ca3a0b25f38d83 = (0, $dIdda.createResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${(0, (0, parcelRequire("5bSAg")).RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY)}`,
        getKey: ()=>'issue-navigator-filter-relay',
        getData: async (routerContext, { tenantContext: tenantContext })=>{
            if (false && tenantContext.isAnonymous) return null;
            const { filter: filter } = (0, (0, parcelRequire("aBKbA")).getParams)(routerContext);
            const includeFilter = Boolean(filter) && (0, (0, parcelRequire("9Nvh7")).isFilterId)(filter);
            const variables = {
                includeFilter: includeFilter,
                filterAri: includeFilter ? (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'filter',
                    resourceId: filter,
                    activationId: tenantContext.activationId
                }) : ''
            };
            const options = {
                fetchPolicy: includeFilter ? 'network-only' : 'store-only'
            };
            const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("kvekU")).default), variables, options);
            if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            return queryReference;
        },
        maxAge: 0
    });
    const $93f22f98fd07bff0$export$967ef0cfbd1cc946 = (0, $dIdda.createResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${(0, (0, parcelRequire("5bSAg")).RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY)}`,
        getKey: ()=>'issue-navigator-hydration-relay',
        getData: async (routerContext, { tenantContext: tenantContext })=>{
            if (false && tenantContext.isAnonymous) return null;
            const { projectKey: projectKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, (0, parcelRequire("aBKbA")).getParams)(routerContext);
            const jqlOrFilterId = (0, (0, parcelRequire("aBKbA")).getJqlOrFilterId)(defaultJql, jqlParam, filter, projectKey);
            const variables = {
                accountId: tenantContext.atlassianAccountId ?? '',
                cloudId: tenantContext.cloudId,
                includeUser: true,
                includeJira: true,
                isFilter: 'filterId' in jqlOrFilterId,
                jql: 'jql' in jqlOrFilterId && jqlOrFilterId.jql || '',
                filterAri: 'filterId' in jqlOrFilterId && (0, (0, parcelRequire("axGKd")).JiraFilterAri).create({
                    siteId: tenantContext.cloudId,
                    filterId: filter,
                    activationId: tenantContext.activationId
                }).toString() || '',
                isNinShowOutOfContextFieldsAsOnlyUnselectable: true,
                viewContext: null
            };
            const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("16Yit")).default), variables, {
                fetchPolicy: 'network-only',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            });
            if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            return queryReference;
        },
        maxAge: 0,
        isBrowserOnly: true
    });
});
parcelRegister("9Nvh7", function(module, exports) {
    $parcel$export(module.exports, "isCustomFilter", ()=>$08e78f523b28c02b$export$31180e7f1db565e5);
    $parcel$export(module.exports, "isFilterId", ()=>$08e78f523b28c02b$export$23be85030bd58047);
    const $08e78f523b28c02b$export$31180e7f1db565e5 = (filterId)=>/^\d+$/.test(filterId);
    const $08e78f523b28c02b$export$887fa95a5a5cf197 = (filterId)=>/^-\d+$/.test(filterId);
    const $08e78f523b28c02b$export$23be85030bd58047 = (value)=>value !== undefined && /^-?\d+$/.test(value);
});
parcelRegister("6UAdF", function(module, exports) {
    $parcel$export(module.exports, "sortDirections", ()=>$8e65b6d66c73d810$export$73034536b9adc928);
    $parcel$export(module.exports, "FilterTypes", ()=>$8e65b6d66c73d810$export$ad2e3f13451a5d44);
    $parcel$export(module.exports, "SearchInputTypes", ()=>$8e65b6d66c73d810$export$75a31bc7c097ba4b);
    $parcel$export(module.exports, "views", ()=>$8e65b6d66c73d810$export$d0079916fe6800ac);
    $parcel$export(module.exports, "defaultOrderFields", ()=>$8e65b6d66c73d810$export$2bd49f8f262d7cbb);
    $parcel$export(module.exports, "ISSUE_SEARCH_NAMESPACE", ()=>$8e65b6d66c73d810$export$de2495608df10495);
    $parcel$export(module.exports, "DEFAULT_ORDER_FIELD", ()=>$8e65b6d66c73d810$export$393cb330f31d305c);
    $parcel$export(module.exports, "DEFAULT_SORT_DIRECTION", ()=>$8e65b6d66c73d810$export$8ea18fa9e35fdf25);
    $parcel$export(module.exports, "DEFAULT_VIEW_ID", ()=>$8e65b6d66c73d810$export$500b5c379b5c7f2e);
    $parcel$export(module.exports, "MAX_ISSUES_PER_PAGE", ()=>$8e65b6d66c73d810$export$f88f58d1a4b2078b);
    $parcel$export(module.exports, "getMaxIssuesPerPage", ()=>$8e65b6d66c73d810$export$8c67ad1f64ab5a9c);
    $parcel$export(module.exports, "ANALYTICS_SOURCE", ()=>$8e65b6d66c73d810$export$f7109619a5e9e0d6);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$8e65b6d66c73d810$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$8e65b6d66c73d810$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "EXPERIENCE_NAME", ()=>$8e65b6d66c73d810$export$52919046b94109dc);
    $parcel$export(module.exports, "ANALYTICS_LIST_VIEW_SOURCE_NAME", ()=>$8e65b6d66c73d810$export$81d9767bc5c1549e);
    $parcel$export(module.exports, "ANALYTICS_DETAIL_VIEW_SOURCE_NAME", ()=>$8e65b6d66c73d810$export$524ae4278a57eea2);
    $parcel$export(module.exports, "LIST_VIEW_ID", ()=>$8e65b6d66c73d810$export$af225181779390f4);
    $parcel$export(module.exports, "MAX_AMOUNT_OF_COLUMNS", ()=>$8e65b6d66c73d810$export$608eeb3a32afef02);
    $parcel$export(module.exports, "COLUMN_TYPE_EPIC_LINK", ()=>$8e65b6d66c73d810$export$ce9e2d7c178a9557);
    $parcel$export(module.exports, "COLUMN_TYPE_PARENT_LINK", ()=>$8e65b6d66c73d810$export$1adf7afff96bbf16);
    $parcel$export(module.exports, "NATURAL_LANGUAGE_TO_JQL", ()=>$8e65b6d66c73d810$export$55628b4c44d1522a);
    $parcel$export(module.exports, "supportedOrderFields", ()=>$8e65b6d66c73d810$export$3630aa1c4c69277f);
    $parcel$export(module.exports, "getSupportedFieldForAlias", ()=>$8e65b6d66c73d810$export$eaadab3243bf458);
    var $032ey;
    var $czfFt;
    const $8e65b6d66c73d810$export$73034536b9adc928 = {
        ASC: 'ASC',
        DESC: 'DESC',
        NONE: 'NONE'
    };
    const $8e65b6d66c73d810$export$3f42f49c284d5b58 = {
        TODO: 2,
        COMPLETE: 3,
        IN_PROGRESS: 4
    };
    const $8e65b6d66c73d810$export$ad2e3f13451a5d44 = {
        ID: 'filterId',
        JQL: 'filterJql'
    };
    const $8e65b6d66c73d810$export$75a31bc7c097ba4b = {
        JQL: 'jql',
        FILTER: 'filter',
        FILTER_AND_JQL: 'filterAndJql'
    };
    const $8e65b6d66c73d810$export$d0079916fe6800ac = {
        list: 'list-view',
        detail: 'split-view'
    };
    const $8e65b6d66c73d810$export$2bd49f8f262d7cbb = {
        created: 'created',
        lastviewed: 'lastviewed',
        updated: 'updated'
    };
    const $8e65b6d66c73d810$export$92a576f896a9bf72 = {
        myopenissues: Symbol('myopenissues'),
        reportedbyme: Symbol('reportedbyme'),
        allopenissues: Symbol('allopenissues'),
        doneissues: Symbol('doneissues'),
        recentlyviewed: Symbol('recentlyviewed'),
        resolvedrecently: Symbol('resolvedrecently'),
        updatedrecently: Symbol('updatedrecently'),
        allissues: Symbol('allissues')
    };
    const $8e65b6d66c73d810$export$de2495608df10495 = 'ISSUE_NAVIGATOR';
    const $8e65b6d66c73d810$export$66816805c55e43b7 = 'jira.issues.preferred.layout.key';
    const $8e65b6d66c73d810$export$393cb330f31d305c = $8e65b6d66c73d810$export$2bd49f8f262d7cbb.created;
    const $8e65b6d66c73d810$export$8ea18fa9e35fdf25 = $8e65b6d66c73d810$export$73034536b9adc928.DESC;
    const $8e65b6d66c73d810$export$500b5c379b5c7f2e = 'list_default';
    const $8e65b6d66c73d810$export$f88f58d1a4b2078b = 50;
    const $8e65b6d66c73d810$export$8c67ad1f64ab5a9c = ()=>$8e65b6d66c73d810$export$f88f58d1a4b2078b;
    const $8e65b6d66c73d810$export$9d7b852b1c962aa3 = 1000;
    const $8e65b6d66c73d810$export$f7109619a5e9e0d6 = 'issue-navigator-next';
    const $8e65b6d66c73d810$export$b8b9d90f9e5bd72b = 'jiraIssueNavigator';
    const $8e65b6d66c73d810$export$d57b6b390e78d90f = 'empanada';
    const $8e65b6d66c73d810$export$52919046b94109dc = 'showPinIssueList';
    const $8e65b6d66c73d810$export$81d9767bc5c1549e = 'issueNavigatorListView';
    const $8e65b6d66c73d810$export$524ae4278a57eea2 = 'issueNavigatorDetailView';
    const $8e65b6d66c73d810$export$af478702fa9b9a17 = 'user.search.mode';
    const $8e65b6d66c73d810$export$84f45d3374492a7c = 'BLANK';
    const $8e65b6d66c73d810$export$e1eb2ddab803c5ec = (0, (0, parcelRequire("032ey")).SEARCH_MODE_BASIC);
    const $8e65b6d66c73d810$export$af225181779390f4 = 'list_default';
    const $8e65b6d66c73d810$export$608eeb3a32afef02 = (0, (0, parcelRequire("czfFt")).MAX_COLUMNS);
    const $8e65b6d66c73d810$export$ce9e2d7c178a9557 = 'com.pyxis.greenhopper.jira:gh-epic-link';
    const $8e65b6d66c73d810$export$1adf7afff96bbf16 = 'com.atlassian.jpo:jpo-custom-field-parent';
    const $8e65b6d66c73d810$export$55628b4c44d1522a = 'NATURAL_LANGUAGE_TO_JQL';
    const $8e65b6d66c73d810$export$3630aa1c4c69277f = {
        created: {
            jqlTerm: 'created',
            fieldType: 'created',
            aliases: []
        },
        key: {
            jqlTerm: 'key',
            fieldType: 'issuekey',
            aliases: [
                'issuekey'
            ]
        },
        lastviewed: {
            jqlTerm: 'lastviewed',
            fieldType: 'lastviewed',
            aliases: []
        },
        priority: {
            jqlTerm: 'priority',
            fieldType: 'priority',
            aliases: []
        },
        resolved: {
            jqlTerm: 'resolved',
            fieldType: 'resolutiondate',
            aliases: []
        },
        status: {
            jqlTerm: 'status',
            fieldType: 'status',
            aliases: []
        },
        updated: {
            jqlTerm: 'updated',
            fieldType: 'updated',
            aliases: []
        },
        issuetype: {
            jqlTerm: 'issuetype',
            fieldType: 'issuetype',
            aliases: [
                'type'
            ]
        },
        assignee: {
            jqlTerm: 'assignee',
            fieldType: 'assignee',
            aliases: []
        },
        duedate: {
            jqlTerm: 'duedate',
            fieldType: 'duedate',
            aliases: []
        },
        reporter: {
            jqlTerm: 'reporter',
            fieldType: 'reporter',
            aliases: []
        },
        summary: {
            jqlTerm: 'summary',
            fieldType: 'summary',
            aliases: []
        }
    };
    const $8e65b6d66c73d810$export$eaadab3243bf458 = (alias)=>Object.keys($8e65b6d66c73d810$export$3630aa1c4c69277f).find((key)=>$8e65b6d66c73d810$export$3630aa1c4c69277f[key]?.aliases.includes(alias));
});
parcelRegister("032ey", function(module, exports) {
    $parcel$export(module.exports, "SEARCH_MODE_BASIC", ()=>$e090bb7ab54db3ef$export$f963d14b266e4d2e);
    $parcel$export(module.exports, "SEARCH_MODE_ADVANCED", ()=>$e090bb7ab54db3ef$export$aad1d9eb9b751555);
    $parcel$export(module.exports, "SERVER_SEARCH_MODE_BASIC", ()=>$e090bb7ab54db3ef$export$87c41a6b3123c00f);
    $parcel$export(module.exports, "SERVER_SEARCH_MODE_ADVANCED", ()=>$e090bb7ab54db3ef$export$a7a000706ebc3ba8);
    $parcel$export(module.exports, "DEFAULT_SEARCH_MODE", ()=>$e090bb7ab54db3ef$export$e1eb2ddab803c5ec);
    $parcel$export(module.exports, "mapSearchModeToAnalyticAtribute", ()=>$e090bb7ab54db3ef$export$70c8f980e4a50682);
    $parcel$export(module.exports, "SEARCH_MODE_SWITCHER_LEFT_LOCATION", ()=>$e090bb7ab54db3ef$export$4dab29e715a4e6fb);
    $parcel$export(module.exports, "SEARCH_MODE_SWITCHER_RIGHT_LOCATION", ()=>$e090bb7ab54db3ef$export$59848395da0b4bcb);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$e090bb7ab54db3ef$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$e090bb7ab54db3ef$export$d57b6b390e78d90f);
    const $e090bb7ab54db3ef$export$f963d14b266e4d2e = 'basic';
    const $e090bb7ab54db3ef$export$aad1d9eb9b751555 = 'advanced';
    const $e090bb7ab54db3ef$export$87c41a6b3123c00f = 'BASIC';
    const $e090bb7ab54db3ef$export$a7a000706ebc3ba8 = 'ADVANCED';
    const $e090bb7ab54db3ef$export$e1eb2ddab803c5ec = $e090bb7ab54db3ef$export$f963d14b266e4d2e;
    const $e090bb7ab54db3ef$export$70c8f980e4a50682 = {
        [$e090bb7ab54db3ef$export$f963d14b266e4d2e]: $e090bb7ab54db3ef$export$f963d14b266e4d2e,
        [$e090bb7ab54db3ef$export$aad1d9eb9b751555]: 'JQL'
    };
    const $e090bb7ab54db3ef$export$4dab29e715a4e6fb = 'Left';
    const $e090bb7ab54db3ef$export$59848395da0b4bcb = 'Right';
    const $e090bb7ab54db3ef$export$b8b9d90f9e5bd72b = 'jiraJqlBuilder';
    const $e090bb7ab54db3ef$export$d57b6b390e78d90f = 'empanada';
});
parcelRegister("16Yit", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$296a6f030570708c$export$2e2bcd8739ae039);
    const $296a6f030570708c$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeJira"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeUser"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isFilter"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isNinShowOutOfContextFieldsAsOnlyUnselectable"
        }, v7 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }, v8 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "viewContext"
        }, v9 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v10 = {
            "kind": "Variable",
            "name": "viewContext",
            "variableName": "viewContext"
        }, v11 = [
            {
                "kind": "Variable",
                "name": "query",
                "variableName": "jql"
            },
            v10
        ], v12 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v13 = [
            v12
        ], v14 = [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "filterAri"
            },
            v10
        ], v15 = {
            "kind": "ScalarField",
            "name": "id"
        }, v16 = [
            v12,
            {
                "kind": "ScalarField",
                "name": "picture"
            },
            v15
        ], v17 = {
            "kind": "ScalarField",
            "name": "jqlTerm"
        }, v18 = {
            "kind": "ScalarField",
            "name": "displayName"
        }, v19 = {
            "kind": "ScalarField",
            "name": "key"
        }, v20 = [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "colorName"
                    },
                    v15
                ]
            }
        ], v21 = {
            "kind": "ScalarField",
            "name": "optionId"
        }, v22 = [
            v12,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jql"
                    },
                    {
                        "kind": "LinkedField",
                        "name": "fields",
                        "plural": true,
                        "selections": [
                            v12,
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    v17,
                                    {
                                        "concreteType": "JiraJqlField",
                                        "kind": "LinkedField",
                                        "name": "field",
                                        "plural": false,
                                        "selections": [
                                            v18,
                                            {
                                                "concreteType": "JiraJqlSearchTemplate",
                                                "kind": "LinkedField",
                                                "name": "searchTemplate",
                                                "plural": false,
                                                "selections": [
                                                    v19
                                                ]
                                            },
                                            {
                                                "condition": "isNinShowOutOfContextFieldsAsOnlyUnselectable",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "shouldShowInContext"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "type"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "description"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "operators"
                                            },
                                            {
                                                "concreteType": "JiraFieldType",
                                                "kind": "LinkedField",
                                                "name": "fieldType",
                                                "plural": false,
                                                "selections": [
                                                    v18
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": true,
                                        "selections": [
                                            v12,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v17,
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "values",
                                                        "plural": true,
                                                        "selections": [
                                                            v12,
                                                            v17,
                                                            v18,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraProject",
                                                                        "kind": "LinkedField",
                                                                        "name": "project",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v19,
                                                                            {
                                                                                "concreteType": "JiraAvatar",
                                                                                "kind": "LinkedField",
                                                                                "name": "avatar",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "small"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v15
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlProjectFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v20,
                                                                "type": "JiraJqlStatusFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v20,
                                                                "type": "JiraJqlStatusCategoryFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssueType",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueTypes",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraAvatar",
                                                                                "kind": "LinkedField",
                                                                                "name": "avatar",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "ScalarField",
                                                                                        "name": "xsmall"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v15
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlIssueTypeFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "name": "user",
                                                                        "plural": false,
                                                                        "selections": v16
                                                                    }
                                                                ],
                                                                "type": "JiraJqlUserFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraPriority",
                                                                        "kind": "LinkedField",
                                                                        "name": "priority",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "iconUrl"
                                                                            },
                                                                            v15
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlPriorityFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraIssue",
                                                                        "kind": "LinkedField",
                                                                        "name": "issue",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueFieldConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "fields",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssueFieldEdge",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "edges",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "node",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v12,
                                                                                                    {
                                                                                                        "kind": "InlineFragment",
                                                                                                        "selections": [
                                                                                                            {
                                                                                                                "kind": "ScalarField",
                                                                                                                "name": "text"
                                                                                                            }
                                                                                                        ],
                                                                                                        "type": "JiraSingleLineTextField"
                                                                                                    },
                                                                                                    v15
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v15
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlIssueFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSprint",
                                                                        "kind": "LinkedField",
                                                                        "name": "sprint",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "state"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "boardName"
                                                                            },
                                                                            v15
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlSprintFieldValue"
                                                            },
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                    v21,
                                                                    {
                                                                        "concreteType": "JiraJqlCascadingOptionFieldValue",
                                                                        "kind": "LinkedField",
                                                                        "name": "parentOption",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v18,
                                                                            v17,
                                                                            v21
                                                                        ]
                                                                    }
                                                                ],
                                                                "type": "JiraJqlCascadingOptionFieldValue"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "JiraJqlQueryHydratedValue"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v17,
                                                    {
                                                        "concreteType": "QueryError",
                                                        "kind": "LinkedField",
                                                        "name": "error",
                                                        "plural": false,
                                                        "selections": v13
                                                    }
                                                ],
                                                "type": "JiraJqlQueryHydratedError"
                                            }
                                        ]
                                    }
                                ],
                                "type": "JiraJqlQueryHydratedField"
                            }
                        ]
                    }
                ],
                "type": "JiraJqlHydratedQuery"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "message"
                    }
                ],
                "type": "QueryError"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8
                ],
                "kind": "Fragment",
                "name": "hydrateJqlBuilderQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "ui_jqlBuilder_JQLBuilderUI_hydrationQueryData"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "useHydratedValues"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "jqlEditor_jqlBuilderBasic_JQLEditorUI"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "useQuery"
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "useHydratedValues_cascadeSelectPicker"
                    },
                    {
                        "condition": "includeJira",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v9,
                                        "concreteType": "JiraJqlBuilder",
                                        "kind": "LinkedField",
                                        "name": "jqlBuilder",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "condition": "isFilter",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                    {
                                                        "args": v11,
                                                        "kind": "LinkedField",
                                                        "name": "hydrateJqlQuery",
                                                        "plural": false,
                                                        "selections": v13
                                                    }
                                                ]
                                            },
                                            {
                                                "condition": "isFilter",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                    {
                                                        "args": v14,
                                                        "kind": "LinkedField",
                                                        "name": "hydrateJqlQueryForFilter",
                                                        "plural": false,
                                                        "selections": v13
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v4,
                    v3,
                    v7,
                    v6,
                    v8,
                    v5,
                    v2
                ],
                "kind": "Operation",
                "name": "hydrateJqlBuilderQuery",
                "selections": [
                    {
                        "condition": "includeUser",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "accountId",
                                        "variableName": "accountId"
                                    }
                                ],
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": v16
                            }
                        ]
                    },
                    {
                        "condition": "includeJira",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v9,
                                        "concreteType": "JiraJqlBuilder",
                                        "kind": "LinkedField",
                                        "name": "jqlBuilder",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "condition": "isFilter",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                    {
                                                        "args": v11,
                                                        "kind": "LinkedField",
                                                        "name": "hydrateJqlQuery",
                                                        "plural": false,
                                                        "selections": v22
                                                    }
                                                ]
                                            },
                                            {
                                                "condition": "isFilter",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                    {
                                                        "args": v14,
                                                        "kind": "LinkedField",
                                                        "name": "hydrateJqlQueryForFilter",
                                                        "plural": false,
                                                        "selections": v22
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "2b9a5d2ee5abe9af1719751bca7766699a66994c17bd0771bb1457a53c717bba",
                "metadata": {},
                "name": "hydrateJqlBuilderQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $296a6f030570708c$var$node.hash = "c0c7d28e17786c2301b149d4cb764ad1";
    var $296a6f030570708c$export$2e2bcd8739ae039 = $296a6f030570708c$var$node;
});
parcelRegister("kvekU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d76682723f87707c$export$2e2bcd8739ae039);
    const $d76682723f87707c$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "filterAri"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "includeFilter"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "main_FilterQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_IssueNavigator_filterQuery"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "main_FilterQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "includeFilter",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "id",
                                                "variableName": "filterAri"
                                            }
                                        ],
                                        "kind": "LinkedField",
                                        "name": "filter",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            },
                                            {
                                                "kind": "TypeDiscriminator",
                                                "abstractKey": "__isJiraFilter"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "jql"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isEditable"
                                                    }
                                                ],
                                                "type": "JiraCustomFilter"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "filterId"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "name"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "isFavourite"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "b9373e4d70177ba3d0d672c65e67a2165b4a0d774802f56dbef66239dd52c8e5",
                "metadata": {},
                "name": "main_FilterQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $d76682723f87707c$var$node.hash = "181bb07a6bafd05a2033750384a06766";
    var $d76682723f87707c$export$2e2bcd8739ae039 = $d76682723f87707c$var$node;
});
parcelRegister("hTvlq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff9dfb30fc1873c4$export$2e2bcd8739ae039);
    var $6nwMW;
    var $5oQtH;
    var $1q6lK;
    var $1ZvTA;
    var $G39h7;
    var $6vKPN;
    var $5y5Fx;
    var $1kHcz;
    const $ff9dfb30fc1873c4$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "after"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "amountOfColumns"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "atlassianIntelligenceProductFeature"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "before"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "fieldSetIds"
        }, v6 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterId"
        }, v7 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v8 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueSearchInput"
        }, v9 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueTypeId"
        }, v10 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "last"
        }, v11 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "namespace"
        }, v12 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "options"
        }, v13 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectId"
        }, v14 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryFieldSetsById"
        }, v15 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "viewId"
        }, v16 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v17 = [
            v16
        ], v18 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v19 = [
            {
                "fields": [
                    {
                        "kind": "Variable",
                        "name": "feature",
                        "variableName": "atlassianIntelligenceProductFeature"
                    }
                ],
                "kind": "ObjectValue",
                "name": "atlassianIntelligenceProductFeatureInput"
            },
            v16
        ], v20 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v21 = {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        }, v22 = {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        }, v23 = {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }, v24 = {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        }, v25 = {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        }, v26 = [
            v21,
            v22,
            v16,
            v23,
            v24,
            v25,
            {
                "kind": "Variable",
                "name": "options",
                "variableName": "options"
            }
        ], v27 = {
            "kind": "ScalarField",
            "name": "key"
        }, v28 = {
            "kind": "ScalarField",
            "name": "id"
        }, v29 = {
            "kind": "ScalarField",
            "name": "issueId"
        }, v30 = {
            "kind": "ScalarField",
            "name": "isResolved"
        }, v31 = {
            "kind": "ScalarField",
            "name": "fieldId"
        }, v32 = {
            "kind": "ScalarField",
            "name": "statusCategoryId"
        }, v33 = {
            "concreteType": "JiraStatusCategory",
            "kind": "LinkedField",
            "name": "statusCategory",
            "plural": false,
            "selections": [
                v32,
                v28
            ]
        }, v34 = {
            "args": [
                {
                    "kind": "Literal",
                    "name": "ids",
                    "value": [
                        "status"
                    ]
                }
            ],
            "concreteType": "JiraIssueFieldConnection",
            "kind": "LinkedField",
            "name": "fieldsById",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v20,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v31,
                                        {
                                            "concreteType": "JiraStatus",
                                            "kind": "LinkedField",
                                            "name": "status",
                                            "plural": false,
                                            "selections": [
                                                v33,
                                                v28
                                            ]
                                        }
                                    ],
                                    "type": "JiraStatusField"
                                },
                                v28
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "fieldsById(ids:[\"status\"])"
        }, v35 = {
            "kind": "Variable",
            "name": "filterId",
            "variableName": "filterId"
        }, v36 = {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        }, v37 = {
            "kind": "Variable",
            "name": "namespace",
            "variableName": "namespace"
        }, v38 = {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
        }, v39 = [
            {
                "fields": [
                    {
                        "fields": [
                            {
                                "kind": "Variable",
                                "name": "issueType",
                                "variableName": "issueTypeId"
                            },
                            {
                                "kind": "Variable",
                                "name": "project",
                                "variableName": "projectId"
                            }
                        ],
                        "kind": "ObjectValue",
                        "name": "projectContext"
                    }
                ],
                "kind": "ObjectValue",
                "name": "context"
            },
            v35,
            v36,
            v37,
            v38
        ], v40 = {
            "kind": "ScalarField",
            "name": "name"
        }, v41 = {
            "kind": "ScalarField",
            "name": "text"
        }, v42 = {
            "kind": "ScalarField",
            "name": "picture"
        }, v43 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "small"
                }
            ]
        }, v44 = {
            "args": v39,
            "concreteType": "JiraIssueFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSetsForIssueSearchView",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fields",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueFieldEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v20,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v31,
                                                                v40,
                                                                v41
                                                            ],
                                                            "type": "JiraSingleLineTextField"
                                                        },
                                                        v28,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v31,
                                                                v40,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v20,
                                                                        v40,
                                                                        v42,
                                                                        v28
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSingleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v31,
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v40,
                                                                        v43,
                                                                        v28
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraIssueTypeField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v31,
                                                                v33
                                                            ],
                                                            "type": "JiraStatusCategoryField"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }, v45 = {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasChildren"
                }
            ]
        }, v46 = {
            "kind": "ScalarField",
            "name": "type"
        }, v47 = {
            "kind": "ScalarField",
            "name": "fieldSetId"
        }, v48 = {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isJiraIssueField"
        }, v49 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraAffectedServiceConnection",
                    "kind": "LinkedField",
                    "name": "selectedAffectedServicesConnection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraAffectedServiceEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraAffectedService",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "serviceId"
                                        },
                                        v40,
                                        v28
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraAffectedServicesField"
        }, v50 = {
            "kind": "ScalarField",
            "name": "message"
        }, v51 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraCmdbObjectConnection",
                    "kind": "LinkedField",
                    "name": "selectedCmdbObjectsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraCmdbObjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraCmdbObject",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "objectId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "label"
                                        },
                                        {
                                            "concreteType": "JiraCmdbAvatar",
                                            "kind": "LinkedField",
                                            "name": "avatar",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "url48"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "QueryError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v50
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraCMDBField"
        }, v52 = [
            v40,
            v28
        ], v53 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraComponentConnection",
                    "kind": "LinkedField",
                    "name": "selectedComponentsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraComponentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraComponent",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": v52
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraComponentsField"
        }, v54 = {
            "kind": "ScalarField",
            "name": "date"
        }, v55 = {
            "concreteType": "JiraFieldConfig",
            "kind": "LinkedField",
            "name": "fieldConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isRequired"
                }
            ]
        }, v56 = {
            "kind": "ScalarField",
            "name": "lazyIsEditableInIssueView"
        }, v57 = {
            "kind": "ClientExtension",
            "selections": [
                v56
            ]
        }, v58 = {
            "kind": "InlineFragment",
            "selections": [
                v54,
                v40,
                v55,
                v57
            ],
            "type": "JiraDatePickerField"
        }, v59 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "dateTime"
                }
            ],
            "type": "JiraDateTimePickerField"
        }, v60 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraEpic",
                    "kind": "LinkedField",
                    "name": "epic",
                    "plural": false,
                    "selections": [
                        v27,
                        {
                            "kind": "ScalarField",
                            "name": "summary"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "color"
                        },
                        v28
                    ]
                }
            ],
            "type": "JiraEpicLinkField"
        }, v61 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "renderedFieldHtml"
                }
            ],
            "type": "JiraFallbackField"
        }, v62 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraStatusCategory",
                    "kind": "LinkedField",
                    "name": "statusCategory",
                    "plural": false,
                    "selections": [
                        v40,
                        v32,
                        v28
                    ]
                }
            ],
            "type": "JiraStatusCategoryField"
        }, v63 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraStatus",
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                        v40,
                        {
                            "kind": "ScalarField",
                            "name": "statusId"
                        },
                        v33,
                        v28
                    ]
                }
            ],
            "type": "JiraStatusField"
        }, v64 = [
            v40
        ], v65 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v66 = {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000
                }
            ],
            "concreteType": "JiraLabelConnection",
            "kind": "LinkedField",
            "name": "selectedLabelsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraLabelEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraLabel",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": v64
                        }
                    ]
                },
                v65
            ],
            "storageKey": "selectedLabelsConnection(first:1000)"
        }, v67 = {
            "kind": "InlineFragment",
            "selections": [
                v66,
                v40,
                v57
            ],
            "type": "JiraLabelsField"
        }, v68 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "issueType",
                    "plural": false,
                    "selections": [
                        v43,
                        v40,
                        v28
                    ]
                }
            ],
            "type": "JiraIssueTypeField"
        }, v69 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "xsmall"
                }
            ]
        }, v70 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "parentIssue",
                    "plural": false,
                    "selections": [
                        v27,
                        {
                            "concreteType": "JiraSingleLineTextField",
                            "kind": "LinkedField",
                            "name": "summaryField",
                            "plural": false,
                            "selections": [
                                v41,
                                v28
                            ]
                        },
                        v28,
                        {
                            "concreteType": "JiraColorField",
                            "kind": "LinkedField",
                            "name": "issueColorField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraColor",
                                    "kind": "LinkedField",
                                    "name": "color",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "colorKey"
                                        },
                                        v28
                                    ]
                                },
                                v28
                            ]
                        },
                        {
                            "concreteType": "JiraIssueTypeField",
                            "kind": "LinkedField",
                            "name": "issueTypeField",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueType",
                                    "kind": "LinkedField",
                                    "name": "issueType",
                                    "plural": false,
                                    "selections": [
                                        v69,
                                        v40,
                                        v28
                                    ]
                                },
                                v28
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraParentIssueField"
        }, v71 = {
            "kind": "ScalarField",
            "name": "iconUrl"
        }, v72 = {
            "concreteType": "JiraPriority",
            "kind": "LinkedField",
            "name": "priority",
            "plural": false,
            "selections": [
                v40,
                v71,
                v28
            ]
        }, v73 = {
            "kind": "InlineFragment",
            "selections": [
                v72,
                v40,
                v57
            ],
            "type": "JiraPriorityField"
        }, v74 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        v40,
                        v27,
                        {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "large"
                                }
                            ]
                        },
                        v28
                    ]
                }
            ],
            "type": "JiraProjectField"
        }, v75 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraResolution",
                    "kind": "LinkedField",
                    "name": "resolution",
                    "plural": false,
                    "selections": v52
                }
            ],
            "type": "JiraResolutionField"
        }, v76 = {
            "concreteType": "JiraSprintConnection",
            "kind": "LinkedField",
            "name": "selectedSprintsConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraSprintEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraSprint",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                v28,
                                {
                                    "kind": "ScalarField",
                                    "name": "sprintId"
                                },
                                v40,
                                {
                                    "kind": "ScalarField",
                                    "name": "state"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }, v77 = {
            "kind": "InlineFragment",
            "selections": [
                v76,
                v40,
                v57
            ],
            "type": "JiraSprintField"
        }, v78 = {
            "kind": "ScalarField",
            "name": "accountId"
        }, v79 = {
            "kind": "ScalarField",
            "name": "accountStatus"
        }, v80 = {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                v20,
                v78,
                v42,
                v40,
                v28,
                v79
            ]
        }, v81 = {
            "kind": "InlineFragment",
            "selections": [
                v40,
                {
                    "concreteType": "JiraVersionConnection",
                    "kind": "LinkedField",
                    "name": "selectedVersionsConnection",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraVersionEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraVersion",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": v52
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraMultipleVersionPickerField"
        }, v82 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraRichText",
                    "kind": "LinkedField",
                    "name": "richText",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraADF",
                            "kind": "LinkedField",
                            "name": "adfValue",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraAdfToConvertedPlainText",
                                    "kind": "LinkedField",
                                    "name": "convertedPlainText",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "plainText"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraRichTextField"
        }, v83 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraServiceManagementRequestType",
                    "kind": "LinkedField",
                    "name": "requestType",
                    "plural": false,
                    "selections": [
                        v40,
                        v69,
                        v28
                    ]
                }
            ],
            "type": "JiraServiceManagementRequestTypeField"
        }, v84 = {
            "kind": "ScalarField",
            "name": "hasNextPage"
        }, v85 = {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                        }
                    ],
                    "concreteType": "JiraIssueLinkConnection",
                    "kind": "LinkedField",
                    "name": "issueLinkConnection",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        v84
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v65
                            ]
                        },
                        {
                            "concreteType": "JiraIssueLinkEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueLink",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "issue",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "webUrl"
                                                },
                                                v27,
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "ids",
                                                            "value": [
                                                                "statusCategory"
                                                            ]
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v20,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v33
                                                                            ],
                                                                            "type": "JiraStatusCategoryField"
                                                                        },
                                                                        v28
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                },
                                                v28
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "relationName"
                                        },
                                        v28
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraIssueLinkField"
        }, v86 = {
            "kind": "ScalarField",
            "name": "isStoryPointField"
        }, v87 = {
            "kind": "ScalarField",
            "name": "number"
        }, v88 = {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v86,
                        v87,
                        v40,
                        v57
                    ],
                    "type": "JiraNumberField"
                }
            ]
        }, v89 = [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v46,
                            v47,
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v20,
                                                    v31,
                                                    v46,
                                                    v48,
                                                    v28,
                                                    v49,
                                                    v51,
                                                    v53,
                                                    v58,
                                                    v59,
                                                    v60,
                                                    v61,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v41,
                                                            v40,
                                                            v57
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    v62,
                                                    v63,
                                                    v67,
                                                    v68,
                                                    v70,
                                                    v73,
                                                    v74,
                                                    v75,
                                                    v77,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v80,
                                                            v40,
                                                            v55,
                                                            v57
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                    },
                                                    v81,
                                                    v82,
                                                    v83,
                                                    v85,
                                                    v88
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ], v90 = {
            "condition": "shouldQueryFieldSetsById",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "fieldSetIds",
                            "variableName": "fieldSetIds"
                        },
                        v36
                    ],
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSetsById",
                    "plural": false,
                    "selections": v89
                }
            ]
        }, v91 = {
            "condition": "shouldQueryFieldSetsById",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": v39,
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSetsForIssueSearchView",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldSet",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v46,
                                        v47,
                                        {
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "fields",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v31,
                                                                v46,
                                                                v48,
                                                                v49,
                                                                v51,
                                                                v53,
                                                                v58,
                                                                v59,
                                                                v60,
                                                                v61,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v46,
                                                                        v57
                                                                    ],
                                                                    "type": "JiraSingleLineTextField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraStatusCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "statusCategory",
                                                                            "plural": false,
                                                                            "selections": v64
                                                                        }
                                                                    ],
                                                                    "type": "JiraStatusCategoryField"
                                                                },
                                                                v63,
                                                                v67,
                                                                v70,
                                                                v73,
                                                                v74,
                                                                v75,
                                                                v77,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v46,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "user",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v78,
                                                                                v79
                                                                            ]
                                                                        },
                                                                        v55,
                                                                        v57
                                                                    ],
                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                },
                                                                v81,
                                                                v82,
                                                                v83,
                                                                v85,
                                                                v88
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }, v92 = {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                v90,
                v91
            ]
        }, v93 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "issueRowFieldSets",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldSet",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v46,
                                        v47,
                                        {
                                            "concreteType": "JiraIssueFieldConnection",
                                            "kind": "LinkedField",
                                            "name": "fields",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v20,
                                                                v31,
                                                                v46,
                                                                v48,
                                                                v28,
                                                                v49,
                                                                v51,
                                                                v53,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v54,
                                                                        v56,
                                                                        v40,
                                                                        v55
                                                                    ],
                                                                    "type": "JiraDatePickerField"
                                                                },
                                                                v59,
                                                                v60,
                                                                v61,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v41,
                                                                        v56,
                                                                        v40
                                                                    ],
                                                                    "type": "JiraSingleLineTextField"
                                                                },
                                                                v62,
                                                                v63,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v66,
                                                                        v56,
                                                                        v40
                                                                    ],
                                                                    "type": "JiraLabelsField"
                                                                },
                                                                v68,
                                                                v70,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v56,
                                                                        v72,
                                                                        v40
                                                                    ],
                                                                    "type": "JiraPriorityField"
                                                                },
                                                                v74,
                                                                v75,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v56,
                                                                        v76,
                                                                        v40
                                                                    ],
                                                                    "type": "JiraSprintField"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v80,
                                                                        v56,
                                                                        v40,
                                                                        v55
                                                                    ],
                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                },
                                                                v81,
                                                                v82,
                                                                v83,
                                                                v85,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v86,
                                                                                v87,
                                                                                v56,
                                                                                v40
                                                                            ],
                                                                            "type": "JiraNumberField"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }, v94 = {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                v90,
                v91,
                v93
            ]
        }, v95 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isHighlightedIssueRow"
                }
            ]
        }, v96 = {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        }, v97 = [
            {
                "kind": "Literal",
                "name": "maxCursors",
                "value": 7
            }
        ], v98 = {
            "kind": "ScalarField",
            "name": "cursor"
        }, v99 = {
            "kind": "ScalarField",
            "name": "isCurrent"
        }, v100 = {
            "kind": "ScalarField",
            "name": "pageNumber"
        }, v101 = [
            v100,
            v98,
            v99
        ], v102 = {
            "concreteType": "JiraPageCursor",
            "kind": "LinkedField",
            "name": "last",
            "plural": false,
            "selections": v101
        }, v103 = {
            "concreteType": "JiraPageCursor",
            "kind": "LinkedField",
            "name": "first",
            "plural": false,
            "selections": [
                v98,
                v100,
                v99
            ]
        }, v104 = {
            "kind": "ScalarField",
            "name": "firstIssuePosition"
        }, v105 = {
            "kind": "ScalarField",
            "name": "lastIssuePosition"
        }, v106 = {
            "kind": "LinkedField",
            "name": "issueSearchError",
            "plural": false,
            "selections": [
                v20,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "messages"
                        }
                    ],
                    "type": "JiraInvalidJqlError"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v50,
                        {
                            "kind": "ScalarField",
                            "name": "errorType"
                        }
                    ],
                    "type": "JiraInvalidSyntaxError"
                }
            ]
        }, v107 = {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        }, v108 = [
            v16,
            v35,
            v37,
            v38
        ], v109 = {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isJiraIssueSearchViewResult"
        }, v110 = {
            "kind": "ScalarField",
            "name": "viewId"
        }, v111 = [
            {
                "kind": "Literal",
                "name": "filter",
                "value": {
                    "fieldSetSelectedState": "SELECTED"
                }
            },
            v36
        ], v112 = {
            "kind": "ScalarField",
            "name": "displayName"
        }, v113 = {
            "concreteType": "JiraIssueSearchFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueSearchFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v47,
                        v46,
                        v112,
                        {
                            "kind": "ScalarField",
                            "name": "jqlTerm"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isSortable"
                        },
                        {
                            "concreteType": "JiraFieldSetPreferences",
                            "kind": "LinkedField",
                            "name": "fieldSetPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "width"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraFieldType",
                            "kind": "LinkedField",
                            "name": "fieldType",
                            "plural": false,
                            "selections": [
                                v112
                            ]
                        }
                    ]
                }
            ]
        }, v114 = {
            "kind": "ScalarField",
            "name": "hasDefaultFieldSets"
        }, v115 = {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2apiupdatesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isHierarchyEnabled"
                },
                v18
            ]
        }, v116 = {
            "kind": "InlineFragment",
            "selections": [
                v50,
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        v20,
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                }
            ],
            "type": "QueryError"
        }, v117 = {
            "kind": "InlineFragment",
            "selections": [
                v28
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        }, v118 = {
            "kind": "ScalarField",
            "name": "endCursor"
        }, v119 = {
            "kind": "ScalarField",
            "name": "jql"
        }, v120 = {
            "kind": "ScalarField",
            "name": "fieldType"
        }, v121 = {
            "kind": "ScalarField",
            "name": "issueCount"
        }, v122 = {
            "kind": "LinkedField",
            "name": "fieldValue",
            "plural": false,
            "selections": [
                v20,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v112,
                        {
                            "concreteType": "JiraPriority",
                            "kind": "LinkedField",
                            "name": "priority",
                            "plural": false,
                            "selections": [
                                v71,
                                v28
                            ]
                        }
                    ],
                    "type": "JiraJqlPriorityFieldValue"
                }
            ]
        }, v123 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 50
            }
        ], v124 = {
            "condition": "shouldQueryFieldSetsById",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": v39,
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSetsForIssueSearchView",
                    "plural": false,
                    "selections": v89
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5,
                    v6,
                    v7,
                    v8,
                    v9,
                    v10,
                    v11,
                    v12,
                    v13,
                    v14,
                    v15
                ],
                "kind": "Fragment",
                "name": "main_IssueNavigatorQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_IssueNavigator_issueQuery"
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v17,
                                "concreteType": "JiraUserPreferences",
                                "kind": "LinkedField",
                                "name": "userPreferences",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "main_issueNavigator_IssueNavigator_userPreferences"
                                    }
                                ]
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "main_issueNavigator_IssueNavigator_jira"
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v4,
                    v8,
                    v7,
                    v10,
                    v3,
                    v0,
                    v11,
                    v15,
                    v12,
                    v6,
                    v5,
                    v14,
                    v1,
                    v2,
                    v9,
                    v13,
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2apiupdatesrelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider"
                    }
                ],
                "kind": "Operation",
                "name": "main_IssueNavigatorQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v17,
                                "concreteType": "JiraUserPreferences",
                                "kind": "LinkedField",
                                "name": "userPreferences",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "jqlBuilderSearchMode"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "isNaturalLanguageSpotlightTourEnabled"
                                    },
                                    v18
                                ]
                            },
                            {
                                "args": v19,
                                "kind": "ScalarField",
                                "name": "shouldShowAtlassianIntelligence"
                            },
                            {
                                "args": v19,
                                "kind": "LinkedField",
                                "name": "atlassianIntelligenceAction",
                                "plural": false,
                                "selections": [
                                    v20,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "isAccessible"
                                            }
                                        ],
                                        "type": "JiraAccessAtlassianIntelligenceFeature"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "link"
                                            }
                                        ],
                                        "type": "JiraEnableAtlassianIntelligenceDeepLink"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v26,
                                        "concreteType": "JiraIssueConnection",
                                        "kind": "LinkedField",
                                        "name": "issueSearchStable",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssue",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v27,
                                                            v28,
                                                            v29,
                                                            v30,
                                                            v34,
                                                            v44,
                                                            v45,
                                                            v92,
                                                            v94,
                                                            v95
                                                        ]
                                                    },
                                                    v20,
                                                    v18
                                                ]
                                            },
                                            v96,
                                            {
                                                "args": v97,
                                                "concreteType": "JiraPageCursors",
                                                "kind": "LinkedField",
                                                "name": "pageCursors",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraPageCursor",
                                                        "kind": "LinkedField",
                                                        "name": "around",
                                                        "plural": true,
                                                        "selections": [
                                                            v98,
                                                            v99,
                                                            v100
                                                        ]
                                                    },
                                                    v102,
                                                    v103
                                                ],
                                                "storageKey": "pageCursors(maxCursors:7)"
                                            },
                                            {
                                                "concreteType": "JiraIssueNavigatorPageInfo",
                                                "kind": "LinkedField",
                                                "name": "issueNavigatorPageInfo",
                                                "plural": false,
                                                "selections": [
                                                    v104,
                                                    v105,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "firstIssueKeyFromNextPage"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "lastIssueKeyFromPreviousPage"
                                                    }
                                                ]
                                            },
                                            v106,
                                            v107,
                                            v18
                                        ]
                                    },
                                    {
                                        "args": v108,
                                        "kind": "LinkedField",
                                        "name": "issueSearchViewResult",
                                        "plural": false,
                                        "selections": [
                                            v20,
                                            v109,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v110,
                                                    {
                                                        "args": v111,
                                                        "concreteType": "JiraIssueSearchFieldSetConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fieldSets",
                                                        "plural": false,
                                                        "selections": [
                                                            v113,
                                                            v65,
                                                            v18
                                                        ]
                                                    },
                                                    v28,
                                                    v114,
                                                    v115
                                                ],
                                                "type": "JiraIssueSearchView"
                                            },
                                            v116,
                                            v117
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": v26,
                                        "concreteType": "JiraIssueConnection",
                                        "kind": "LinkedField",
                                        "name": "issueSearch",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    v98,
                                                    {
                                                        "concreteType": "JiraIssue",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v20,
                                                            v28,
                                                            v27,
                                                            v29,
                                                            v30,
                                                            v34,
                                                            v44,
                                                            v45,
                                                            v92,
                                                            v94,
                                                            v95
                                                        ]
                                                    },
                                                    v20
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraIssueNavigatorPageInfo",
                                                "kind": "LinkedField",
                                                "name": "issueNavigatorPageInfo",
                                                "plural": false,
                                                "selections": [
                                                    v104,
                                                    v105
                                                ]
                                            },
                                            {
                                                "args": v97,
                                                "concreteType": "JiraPageCursors",
                                                "kind": "LinkedField",
                                                "name": "pageCursors",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraPageCursor",
                                                        "kind": "LinkedField",
                                                        "name": "around",
                                                        "plural": true,
                                                        "selections": v101
                                                    },
                                                    v102,
                                                    v103
                                                ],
                                                "storageKey": "pageCursors(maxCursors:7)"
                                            },
                                            v96,
                                            v106,
                                            v107,
                                            {
                                                "concreteType": "PageInfo",
                                                "kind": "LinkedField",
                                                "name": "pageInfo",
                                                "plural": false,
                                                "selections": [
                                                    v118,
                                                    v84,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "hasPreviousPage"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "startCursor"
                                                    }
                                                ]
                                            },
                                            v18
                                        ]
                                    },
                                    {
                                        "args": v26,
                                        "filters": [
                                            "cloudId",
                                            "issueSearchInput",
                                            "options"
                                        ],
                                        "handle": "connection",
                                        "key": "IssueNavigatorIssueSearchPagination__issueSearch",
                                        "kind": "LinkedHandle",
                                        "name": "issueSearch"
                                    },
                                    {
                                        "args": v108,
                                        "kind": "LinkedField",
                                        "name": "issueSearchViewResult",
                                        "plural": false,
                                        "selections": [
                                            v20,
                                            v109,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v110,
                                                    v28,
                                                    v114,
                                                    {
                                                        "args": v111,
                                                        "concreteType": "JiraIssueSearchFieldSetConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fieldSets",
                                                        "plural": false,
                                                        "selections": [
                                                            v65,
                                                            v113,
                                                            v18
                                                        ]
                                                    },
                                                    v115
                                                ],
                                                "type": "JiraIssueSearchView"
                                            },
                                            v116,
                                            v117
                                        ]
                                    },
                                    {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                            {
                                                "args": v108,
                                                "kind": "LinkedField",
                                                "name": "jiraIssueSearchView",
                                                "plural": false,
                                                "selections": [
                                                    v20,
                                                    v28,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "args": [
                                                                    v21,
                                                                    v22,
                                                                    v23,
                                                                    v24,
                                                                    v25
                                                                ],
                                                                "concreteType": "JiraSpreadsheetGroupConnection",
                                                                "kind": "LinkedField",
                                                                "name": "groups",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraSpreadsheetGroup",
                                                                        "kind": "LinkedField",
                                                                        "name": "firstGroup",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v28,
                                                                            v119,
                                                                            v120,
                                                                            v121,
                                                                            v122,
                                                                            {
                                                                                "args": v123,
                                                                                "concreteType": "JiraIssueConnection",
                                                                                "kind": "LinkedField",
                                                                                "name": "issues",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssueEdge",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "edges",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            v20,
                                                                                            v98,
                                                                                            {
                                                                                                "concreteType": "JiraIssue",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "node",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    v20,
                                                                                                    v28,
                                                                                                    v27,
                                                                                                    v29,
                                                                                                    v30,
                                                                                                    v34,
                                                                                                    v45,
                                                                                                    {
                                                                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
                                                                                                        "kind": "Condition",
                                                                                                        "passingValue": false,
                                                                                                        "selections": [
                                                                                                            v90,
                                                                                                            v124
                                                                                                        ]
                                                                                                    },
                                                                                                    {
                                                                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider",
                                                                                                        "kind": "Condition",
                                                                                                        "passingValue": true,
                                                                                                        "selections": [
                                                                                                            v90,
                                                                                                            v124,
                                                                                                            v93
                                                                                                        ]
                                                                                                    },
                                                                                                    v95
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    },
                                                                                    {
                                                                                        "concreteType": "PageInfo",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "pageInfo",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v118,
                                                                                            v84
                                                                                        ]
                                                                                    },
                                                                                    v18
                                                                                ],
                                                                                "storageKey": "issues(first:50)"
                                                                            },
                                                                            {
                                                                                "args": v123,
                                                                                "handle": "connection",
                                                                                "key": "firstGroupSection_nativeIssueTable__issues",
                                                                                "kind": "LinkedHandle",
                                                                                "name": "issues"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraSpreadsheetGroupEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraSpreadsheetGroup",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v28,
                                                                                    v120,
                                                                                    v121,
                                                                                    v119,
                                                                                    v122
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    v18
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraGroupedListView"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "94600e66bbb9b4dac7ad5c3f1ad16a60c07640c865137d38531575d633d18d5e",
                "metadata": {},
                "name": "main_IssueNavigatorQuery",
                "operationKind": "query",
                "text": null,
                "providedVariables": {
                    "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, (0, parcelRequire("5oQtH")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcischildissuestotalcountenabledrelayprovider": (0, (0, parcelRequire("6nwMW")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcjscm1apiupdatesrelayprovider": (0, (0, parcelRequire("6vKPN")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider": (0, (0, parcelRequire("1kHcz")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider": (0, (0, parcelRequire("G39h7")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider": (0, (0, parcelRequire("1ZvTA")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2apiupdatesrelayprovider": (0, (0, parcelRequire("5y5Fx")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcisrefactornintoviewschemaenabledrelayprovider": (0, (0, parcelRequire("1q6lK")).default)
                }
            }
        };
    }();
    $ff9dfb30fc1873c4$var$node.hash = "ad05a88027f7cf0b44b467f5d310c31d";
    var $ff9dfb30fc1873c4$export$2e2bcd8739ae039 = $ff9dfb30fc1873c4$var$node;
});
parcelRegister("5oQtH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$63783baa7e252f12$export$2e2bcd8739ae039);
    var $6s1PB;
    var $63783baa7e252f12$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("6s1PB")).expVal)('jira_spreadsheet_component_m1', 'isInfiniteScrollingEnabled', false);
        }
    };
});
parcelRegister("1q6lK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$181eac5504cd1c95$export$2e2bcd8739ae039);
    var $4R6GH;
    var $181eac5504cd1c95$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('refactor_nin_to_jira_view_schema');
        }
    };
});
parcelRegister("5y5Fx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59ea24ee5943008b$export$2e2bcd8739ae039);
    var $4R6GH;
    const $59ea24ee5943008b$var$JscM2ApiUpdatesRelayProvider = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('jsc_-_m2_hierarchy_api_updates');
        }
    };
    var $59ea24ee5943008b$export$2e2bcd8739ae039 = $59ea24ee5943008b$var$JscM2ApiUpdatesRelayProvider;
});
parcelRegister("5bSAg", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_RELAY", ()=>$2134dee38b024167$export$c300d3b7f3dc697d);
    $parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_FILTER_RELAY", ()=>$2134dee38b024167$export$b99d8b4e19091835);
    $parcel$export(module.exports, "RESOURCE_TYPE_ISSUE_NAVIGATOR_HYDRATION_RELAY", ()=>$2134dee38b024167$export$1b65799bbeba8a33);
    $parcel$export(module.exports, "defaultOrderFields", ()=>$2134dee38b024167$export$2bd49f8f262d7cbb);
    $parcel$export(module.exports, "sortDirections", ()=>$2134dee38b024167$export$73034536b9adc928);
    const $2134dee38b024167$export$c300d3b7f3dc697d = 'ISSUE_NAVIGATOR_RELAY';
    const $2134dee38b024167$export$b99d8b4e19091835 = 'ISSUE_NAVIGATOR_FILTER_RELAY';
    const $2134dee38b024167$export$1b65799bbeba8a33 = 'ISSUE_NAVIGATOR_HYDRATION_RELAY';
    const $2134dee38b024167$export$2bd49f8f262d7cbb = {
        created: 'created',
        lastviewed: 'lastviewed',
        updated: 'updated'
    };
    const $2134dee38b024167$export$73034536b9adc928 = {
        ASC: 'ASC',
        DESC: 'DESC',
        NONE: 'NONE'
    };
});
parcelRegister("aBKbA", function(module, exports) {
    $parcel$export(module.exports, "getDefaultJqlGin", ()=>$b87185164056f069$export$8780b1523384f42d);
    $parcel$export(module.exports, "getParams", ()=>$b87185164056f069$export$ec161d740909e39d);
    $parcel$export(module.exports, "getJqlOrFilterId", ()=>$b87185164056f069$export$b968a035fc2aa57b);
    var $9Nvh7;
    var $g5X3G;
    var $8zzKy;
    var $5bSAg;
    const $b87185164056f069$export$8780b1523384f42d = ()=>`ORDER BY ${(0, (0, parcelRequire("5bSAg")).defaultOrderFields).created} ${(0, (0, parcelRequire("5bSAg")).sortDirections).DESC}`;
    const $b87185164056f069$export$ec161d740909e39d = ({ match: { params: params }, query: query })=>{
        const { projectKey: projectKey, issueKey: issueKey } = params;
        const { filter: filter, jql: jql } = query;
        const defaultJql = projectKey !== null && projectKey !== undefined ? (0, (0, parcelRequire("8zzKy")).getDefaultJql)((0, (0, parcelRequire("g5X3G")).toProjectKey)(projectKey)) : $b87185164056f069$export$8780b1523384f42d();
        return {
            page: 1,
            jql: jql,
            issueKey: issueKey,
            projectKey: projectKey,
            filter: filter,
            defaultJql: defaultJql
        };
    };
    const $b87185164056f069$export$b968a035fc2aa57b = (defaultJql, jqlParam, filter, projectKey)=>{
        if (typeof jqlParam === 'string') return {
            jql: jqlParam
        };
        if (typeof filter === 'string' && filter !== '') {
            if ((0, (0, parcelRequire("9Nvh7")).isFilterId)(filter)) return {
                filterId: filter
            };
            const filterJql = projectKey !== null && projectKey !== undefined ? (0, (0, parcelRequire("8zzKy")).mapFilterToJql)(projectKey, filter) : undefined;
            if (filterJql !== undefined) return {
                jql: filterJql
            };
        }
        return {
            jql: defaultJql
        };
    };
});
parcelRegister("8zzKy", function(module, exports) {
    $parcel$export(module.exports, "isFilterKey", ()=>$f8caace292c4edec$export$2cad587bb603edda);
    $parcel$export(module.exports, "mapFilterToJql", ()=>$f8caace292c4edec$export$1d71dda738f608f);
    $parcel$export(module.exports, "getDefaultJql", ()=>$f8caace292c4edec$export$346d50fe8350b1d0);
    $parcel$export(module.exports, "getUrlPrefix", ()=>$f8caace292c4edec$export$821d4141d135e0d0);
    var $ebyGx = parcelRequire("ebyGx");
    var $6UAdF;
    var $2s5Ei;
    const $f8caace292c4edec$export$2cad587bb603edda = (filter)=>typeof filter === 'string' && filter in (0, (0, parcelRequire("2s5Ei")).Filters);
    const $f8caace292c4edec$export$1d71dda738f608f = (projectKey, filter)=>{
        if (!$f8caace292c4edec$export$2cad587bb603edda(filter)) return undefined;
        const clauses = [
            `project = "${projectKey}"`
        ];
        let order = (0, (0, parcelRequire("6UAdF")).DEFAULT_ORDER_FIELD);
        const direction = (0, (0, parcelRequire("6UAdF")).DEFAULT_SORT_DIRECTION);
        switch((0, (0, parcelRequire("2s5Ei")).Filters)[filter]){
            case (0, (0, parcelRequire("2s5Ei")).Filters).myopenissues:
                clauses.push('assignee IN (currentUser())');
                clauses.push(`statusCategory IN (${(0, (0, parcelRequire("2s5Ei")).StatusCategoryValues).TO_DO}, ${(0, (0, parcelRequire("2s5Ei")).StatusCategoryValues).IN_PROGRESS})`);
                break;
            case (0, (0, parcelRequire("2s5Ei")).Filters).reportedbyme:
                clauses.push('reporter IN (currentUser())');
                break;
            case (0, (0, parcelRequire("2s5Ei")).Filters).allopenissues:
                clauses.push(`statusCategory IN (${(0, (0, parcelRequire("2s5Ei")).StatusCategoryValues).TO_DO}, ${(0, (0, parcelRequire("2s5Ei")).StatusCategoryValues).IN_PROGRESS})`);
                order = (0, (0, parcelRequire("6UAdF")).defaultOrderFields).updated;
                break;
            case (0, (0, parcelRequire("2s5Ei")).Filters).doneissues:
                clauses.push(`statusCategory = ${(0, (0, parcelRequire("2s5Ei")).StatusCategoryValues).DONE}`);
                break;
            case (0, (0, parcelRequire("2s5Ei")).Filters).recentlyviewed:
                order = (0, (0, parcelRequire("6UAdF")).defaultOrderFields).lastviewed;
                break;
            case (0, (0, parcelRequire("2s5Ei")).Filters).resolvedrecently:
                clauses.push('resolved >= -1w');
                order = (0, (0, parcelRequire("6UAdF")).defaultOrderFields).updated;
                break;
            case (0, (0, parcelRequire("2s5Ei")).Filters).updatedrecently:
                order = (0, (0, parcelRequire("6UAdF")).defaultOrderFields).updated;
                break;
            case (0, (0, parcelRequire("2s5Ei")).Filters).allissues:
                order = (0, (0, parcelRequire("6UAdF")).defaultOrderFields).created;
                break;
            default:
        }
        return `${clauses.join(' AND ')} ORDER BY ${order} ${direction}`.trim();
    };
    const $f8caace292c4edec$export$346d50fe8350b1d0 = (projectKey)=>`project = "${projectKey}" ORDER BY ${0, (0, parcelRequire("6UAdF")).DEFAULT_ORDER_FIELD} ${0, (0, parcelRequire("6UAdF")).DEFAULT_SORT_DIRECTION}`;
    const $f8caace292c4edec$export$e5b4f9d05e643346 = (search, match)=>({
            ...(0, $ebyGx.parse)(search),
            ...match && match.params
        });
    const $f8caace292c4edec$export$821d4141d135e0d0 = (url)=>{
        const match = url.match(/^(.*)\/projects.*$/);
        return (match && match[1]) ?? '';
    };
});
parcelRegister("2s5Ei", function(module, exports) {
    $parcel$export(module.exports, "Filters", ()=>$ff462caa91749c6a$export$92a576f896a9bf72);
    $parcel$export(module.exports, "StatusCategoryValues", ()=>$ff462caa91749c6a$export$72d6e2acce8f36fd);
    const $ff462caa91749c6a$export$92a576f896a9bf72 = {
        myopenissues: Symbol('myopenissues'),
        reportedbyme: Symbol('reportedbyme'),
        allopenissues: Symbol('allopenissues'),
        doneissues: Symbol('doneissues'),
        recentlyviewed: Symbol('recentlyviewed'),
        resolvedrecently: Symbol('resolvedrecently'),
        updatedrecently: Symbol('updatedrecently'),
        allissues: Symbol('allissues')
    };
    const $ff462caa91749c6a$export$72d6e2acce8f36fd = {
        TO_DO: '"To Do"',
        DONE: '"Done"',
        IN_PROGRESS: '"In Progress"'
    };
});
parcelRegister("cFu3S", function(module, exports) {
    $parcel$export(module.exports, "getCommonProjectResources", ()=>$c7c9a307c1aca60f$export$6236a7417086ea8d);
    var $co1wz;
    var $4R6GH;
    var $5bkvv;
    var $8uKLe;
    var $1b36n;
    var $a3OKn;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $lNicp;
    var $bATyw;
    var $89kiv;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $gNStA;
    const $c7c9a307c1aca60f$export$6236a7417086ea8d = ()=>[
            (0, (0, parcelRequire("89kiv")).issueNavigatorRelayResource),
            (0, (0, parcelRequire("89kiv")).issueNavigatorFilterRelayResource),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('nin_request_hydrate_query_earlier'), (0, (0, parcelRequire("89kiv")).issueNavigatorHydrationRelayResource)),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8'), (0, (0, parcelRequire("a3OKn")).sidebarProjectIssuesResource)),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8'), (0, (0, parcelRequire("bATyw")).isNinGlobalScopeEnrolmentEnabledResource)),
            (0, (0, parcelRequire("1b36n")).staticSidebarDefaultPINFiltersResource)
        ];
});
parcelRegister("1b36n", function(module, exports) {
    $parcel$export(module.exports, "staticSidebarDefaultPINFiltersResource", ()=>$f0c33588b62c7651$export$d3efe54a881807bf);
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $elyZV;
    const $f0c33588b62c7651$export$d3efe54a881807bf = (0, $dIdda.createResource)({
        type: 'JIRA_PROJECT_DEFAULT_PIN_FILTERS_NAV_DATA',
        getKey: ({ match: match, query: query })=>{
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            return projectKey || 'none';
        },
        getData: async ({ match: match, query: query })=>{
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            if (projectKey == null) return null;
            return (0, (0, parcelRequire("elyZV")).fetchDefaultPINFiltersNavData)(projectKey);
        },
        maxAge: 300000
    });
});
parcelRegister("elyZV", function(module, exports) {
    $parcel$export(module.exports, "fetchDefaultPINFiltersNavData", ()=>$88433d457c0f5220$export$268c1bcb44a0ddd3);
    var $eusud;
    const $88433d457c0f5220$var$extractNavIds = (result)=>new Set((result['com.atlassian.jira.jira-projects-issue-navigator:generic-filters'] || []).map((filterNavItem)=>filterNavItem.id));
    const $88433d457c0f5220$export$268c1bcb44a0ddd3 = async (projectKey)=>{
        if (projectKey == null) throw new Error('invalid project id or key');
        const result = await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/filters/1.0/filters?projectKey=${projectKey}`);
        const filterNavIds = $88433d457c0f5220$var$extractNavIds(result);
        return {
            hasMyOpenIssues: filterNavIds.has('myopenissues'),
            hasReportedByMe: filterNavIds.has('reportedbyme'),
            hasAllIssues: filterNavIds.has('allissues'),
            hasAllOpenIssues: filterNavIds.has('allopenissues'),
            hasDoneIssues: filterNavIds.has('doneissues'),
            hasViewedRecently: filterNavIds.has('recentlyviewed'),
            hasCreatedRecently: filterNavIds.has('addedrecently'),
            hasResolvedRecently: filterNavIds.has('resolvedrecently'),
            hasUpdatedRecently: filterNavIds.has('updatedrecently')
        };
    };
});
parcelRegister("a3OKn", function(module, exports) {
    $parcel$export(module.exports, "sidebarProjectIssuesResource", ()=>$b491cf2963738bcf$export$be31dd7adcfd2297);
    var $ao2h1;
    var $59JDz;
    var $6YG83;
    const $b491cf2963738bcf$export$be31dd7adcfd2297 = (0, (0, parcelRequire("6YG83")).withGiraAggAnonSsrFix)((0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'NAVIGATION_SIDEBAR_STARRED_FILTERS',
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("59JDz")).default),
                variables: {
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    }));
});
parcelRegister("59JDz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6bc7247f574fad09$export$2e2bcd8739ae039);
    const $6bc7247f574fad09$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v1,
                                    "kind": "FragmentSpread",
                                    "name": "starredFiltersList_navigationAppsSidebarCommon"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraFilterConnection",
                                "kind": "LinkedField",
                                "name": "favouriteFilters",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraFilterEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "filterId"
                                                    },
                                                    {
                                                        "kind": "TypeDiscriminator",
                                                        "abstractKey": "__isJiraFilter"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isFavourite"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "jql"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "name"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "isEditable"
                                                            }
                                                        ],
                                                        "type": "JiraCustomFilter"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "id"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "1063ffb01e7d9700d29f2ab69b528826f756e1e7c6a83a44336b83304ee1aa8e",
                "metadata": {},
                "name": "starredFiltersContainer_starredFilters_mainStarredFilters_NavigationAppsSidebarQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $6bc7247f574fad09$var$node.hash = "86a313b9769c9a6a731e02bed044f4d2";
    var $6bc7247f574fad09$export$2e2bcd8739ae039 = $6bc7247f574fad09$var$node;
});
parcelRegister("4nXyN", function(module, exports) {
    $parcel$export(module.exports, "issueNavigatorGlobalJiraRouteEntry", ()=>$a09e1f9770441a11$export$8925c79a030fdfe8);
    var $ffza4;
    var $co1wz;
    var $2BrOV;
    var $2G9Bk;
    var $kumTR;
    var $1gXMV;
    var $fERWs;
    var $1QOEF;
    var $b8f12;
    const $a09e1f9770441a11$export$8925c79a030fdfe8 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kumTR")).globalIssueNavigator1Route), ()=>({
            ...(0, (0, parcelRequire("fERWs")).common),
            component: (0, (0, parcelRequire("b8f12")).GinRedirect),
            skeleton: (0, (0, parcelRequire("1gXMV")).GlobalIssueNavigatorSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("b8f12")).LazyGlobalIssueNavigator)
            ],
            canTransitionIn: ()=>(0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8'),
            ufoName: 'global-issue-navigator-jfe',
            navigation: (0, (0, parcelRequire("1QOEF")).getCommonGlobalNavigation)(),
            resources: [
                ...(0, (0, parcelRequire("1QOEF")).getCommonGlobalResources)()
            ],
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout)
        }));
});
parcelRegister("b8f12", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectIssueNavigator", ()=>$b7591135658477a3$export$5fcc10c40c224fbc);
    $parcel$export(module.exports, "ProjectIssueNavigator", ()=>$b7591135658477a3$export$2de79bdf33dbf27c);
    $parcel$export(module.exports, "LazyServiceDeskProjectIssueNavigator", ()=>$b7591135658477a3$export$8570b543078b8f17);
    $parcel$export(module.exports, "ServiceDeskIssueNavigator", ()=>$b7591135658477a3$export$5cc1791bbdb6f266);
    $parcel$export(module.exports, "LazyGlobalIssueNavigator", ()=>$b7591135658477a3$export$8ff267588532c2ce);
    $parcel$export(module.exports, "GinRedirect", ()=>$b7591135658477a3$export$3b4f172f4310bbc);
    var $5uXOq = parcelRequire("5uXOq");
    var $1kQCU;
    var $VILOn;
    var $7SHTM;
    var $1gXMV;
    var $7yO8g;
    var $5j7Th;
    var $cZpsT;
    var $hPtZI;
    var $kUl3E;
    const $b7591135658477a3$export$5fcc10c40c224fbc = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1UnUc")).then((module)=>module.ProjectIssueNavigatorSPA)), {
        moduleId: "./src/packages/spa-apps/project-issue-navigator/src/index.tsx"
    });
    const $b7591135658477a3$export$2de79bdf33dbf27c = ({ match: match, query: query })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b7591135658477a3$export$5fcc10c40c224fbc,
            pageId: (0, (0, parcelRequire("kUl3E")).default)(match, query),
            shouldShowSpinner: false
        });
    const $b7591135658477a3$export$8570b543078b8f17 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1UnUc")).then((module)=>module.ServiceDeskProjectIssueNavigatorSPA)), {
        moduleId: "./src/packages/spa-apps/project-issue-navigator/src/index.tsx"
    });
    const $b7591135658477a3$export$5cc1791bbdb6f266 = ({ match: match, query: query })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b7591135658477a3$export$8570b543078b8f17,
            pageId: (0, (0, parcelRequire("kUl3E")).default)(match, query),
            shouldShowSpinner: false
        });
    const $b7591135658477a3$export$8ff267588532c2ce = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("90rvf")), {
        moduleId: "./src/packages/spa-apps/global-issue-navigator/src/index.tsx"
    });
    const $b7591135658477a3$export$4bd5bc3fa8a52567 = ({ match: match, query: query })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b7591135658477a3$export$8ff267588532c2ce,
            pageId: (0, (0, parcelRequire("kUl3E")).default)(match, query),
            shouldShowSpinner: false
        });
    const $b7591135658477a3$export$3b4f172f4310bbc = (props)=>{
        const [isNinGlobalScopeEnrolmentEnabled, resourceData] = (0, (0, parcelRequire("1kQCU")).useGlobalScopeEnrolmentEnable)();
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        (0, $5uXOq.useEffect)(()=>{
            if (resourceData !== null && resourceData !== undefined) (0, (0, parcelRequire("VILOn")).setIsGlobalScopeEnrolmentEnabledInLocalStorage)(resourceData);
        }, [
            resourceData
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isNinGlobalScopeEnrolmentEnabled === false) window.location.reload();
        }, [
            isNinGlobalScopeEnrolmentEnabled
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isNinGlobalScopeEnrolmentEnabled) {
                const globalGINFlagDisabled = (0, (0, parcelRequire("VILOn")).getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage)();
                if (globalGINFlagDisabled !== false) {
                    !isAnonymous && (0, (0, parcelRequire("7SHTM")).resetGlobalScopeForcedOptOutGinFlag)();
                    (0, (0, parcelRequire("VILOn")).setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage)();
                }
            }
        }, [
            isAnonymous,
            isNinGlobalScopeEnrolmentEnabled
        ]);
        return isNinGlobalScopeEnrolmentEnabled === true ? (0, ($parcel$interopDefault($5uXOq))).createElement($b7591135658477a3$export$4bd5bc3fa8a52567, props) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1gXMV")).GlobalIssueNavigatorSkeleton), null);
    };
});
parcelRegister("1kQCU", function(module, exports) {
    $parcel$export(module.exports, "useGlobalScopeOptOutFlow", ()=>$d96a4352cc61ecaf$export$f39dd0211cb78bcf);
    $parcel$export(module.exports, "useGlobalScopeEnrolmentEnable", ()=>$d96a4352cc61ecaf$export$f45d1a4e873cac44);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $6s1PB;
    var $co1wz;
    var $pa9q9;
    var $VILOn;
    var $7SHTM;
    var $bATyw;
    var $bVDE5;
    var $cZpsT;
    var $dIdda = parcelRequire("dIdda");
    var $aK1ba;
    var $cnynt;
    const $d96a4352cc61ecaf$export$f39dd0211cb78bcf = (href)=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        const redirectToGin = (0, $5uXOq.useCallback)(()=>{
            if (href) window.location.assign(href);
            else window.location.reload();
        }, [
            href
        ]);
        const { renderFeedbackDialog: renderFeedbackDialog } = (0, (0, parcelRequire("aK1ba")).default)({
            onClose: redirectToGin,
            isAdminSettingsModal: false
        });
        return (0, $5uXOq.useCallback)(async (preventDefault)=>{
            if (!(0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8') || !(0, (0, parcelRequire("VILOn")).getIsGlobalScopeEnrolmentEnabledFromLocalStorage)()) return;
            preventDefault && preventDefault();
            try {
                !isAnonymous && await (0, (0, parcelRequire("7SHTM")).setIsGlobalScopeEnrolmentEnabledUserPreference)(false);
                (0, (0, parcelRequire("VILOn")).setIsGlobalScopeEnrolmentEnabledInLocalStorage)(false);
                renderFeedbackDialog();
                sessionStorage.setItem('showGinOptOutFlag', 'true');
            } catch (error) {
                showFlag({
                    type: 'error',
                    title: (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("cnynt")).default).errorOptOutTitleIssueTermRefresh : (0, (0, parcelRequire("cnynt")).default).errorOptOutTitle,
                    description: (0, (0, parcelRequire("cnynt")).default).errorOptOutDesc,
                    testId: 'issue-navigator-action-meatball-menu.ui.error-flag'
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'optOutOfNin',
                        packageName: 'jiraIssueNavigatorChangeboarding',
                        teamName: 'empanada'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    error: error
                });
            }
        }, [
            isAnonymous,
            renderFeedbackDialog,
            showFlag
        ]);
    };
    const $d96a4352cc61ecaf$export$f45d1a4e873cac44 = ()=>{
        const [localStorageData] = (0, $5uXOq.useState)((0, (0, parcelRequire("VILOn")).getIsGlobalScopeEnrolmentEnabledFromLocalStorage));
        const { data: resourceData } = (0, $dIdda.useResource)((0, (0, parcelRequire("bATyw")).isNinGlobalScopeEnrolmentEnabledResource));
        const [{ isInitialRender: isInitialRender }] = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition)();
        let isNinGlobalScopeEnrolmentEnabled;
        if (isInitialRender) isNinGlobalScopeEnrolmentEnabled = true;
        else if (localStorageData !== null && localStorageData !== undefined) isNinGlobalScopeEnrolmentEnabled = localStorageData;
        else isNinGlobalScopeEnrolmentEnabled = resourceData;
        return [
            isNinGlobalScopeEnrolmentEnabled,
            resourceData
        ];
    };
});
parcelRegister("VILOn", function(module, exports) {
    $parcel$export(module.exports, "getIsGlobalScopeEnrolmentEnabledFromLocalStorage", ()=>$5dc42c779a970b72$export$55632339cd4dae9c);
    $parcel$export(module.exports, "getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage", ()=>$5dc42c779a970b72$export$7b78bfe0a111cecf);
    $parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledInLocalStorage", ()=>$5dc42c779a970b72$export$82b2633cf7498c5e);
    $parcel$export(module.exports, "setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage", ()=>$5dc42c779a970b72$export$458eda2352a1e223);
    var $bSSG7;
    var $dJl1T;
    const $5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY = 'jira.nin.global.scope.enrolment';
    const $5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY = 'jira.user.nin.global.scope.enrolment.flag.disabled';
    const $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('nin-changeboarding');
    const $5dc42c779a970b72$export$34434fbbe40a8047 = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.remove($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
    const $5dc42c779a970b72$export$55632339cd4dae9c = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
    const $5dc42c779a970b72$export$7b78bfe0a111cecf = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY);
    const $5dc42c779a970b72$export$82b2633cf7498c5e = (isNINEnrolmentEnabled)=>{
        try {
            $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY, isNINEnrolmentEnabled);
        } catch (e) {
            (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage value, removing instead');
            $5dc42c779a970b72$export$34434fbbe40a8047();
        }
    };
    const $5dc42c779a970b72$export$458eda2352a1e223 = ()=>{
        try {
            $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY, false);
        } catch (e) {
            (0, (0, parcelRequire("dJl1T")).default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage flag value');
        }
    };
});
parcelRegister("bSSG7", function(module, exports) {
    $parcel$export(module.exports, "createLocalStorageProvider", ()=>$63804f80e89e547d$export$697e65b1658f821b);
    $parcel$export(module.exports, "createLocalExpirableStorageProvider", ()=>$63804f80e89e547d$export$59acef2b3ab1df90);
    var $gJBT6 = parcelRequire("gJBT6");
    var $fNVZf;
    var $dEJQ9;
    const $63804f80e89e547d$export$697e65b1658f821b = (0, ($parcel$interopDefault($gJBT6)))((appPrefix)=>(0, (0, parcelRequire("fNVZf")).createStorageProvider)(appPrefix, (0, (0, parcelRequire("dEJQ9")).makeLocalStore)()));
    const $63804f80e89e547d$export$59acef2b3ab1df90 = (0, ($parcel$interopDefault($gJBT6)))((appPrefix)=>{
        if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
        const store = (0, (0, parcelRequire("dEJQ9")).makeLocalExpirableStore)();
        return store.namespace(appPrefix);
    });
});
parcelRegister("fNVZf", function(module, exports) {
    $parcel$export(module.exports, "plugins", ()=>$04caddce42518619$export$8b3ca321c77fdea6);
    $parcel$export(module.exports, "createStorageProvider", ()=>$04caddce42518619$export$8441605555fbd60c);
    var $fKgem = parcelRequire("fKgem");
    var $c7J1U;
    const $04caddce42518619$export$8b3ca321c77fdea6 = [
        (0, ($parcel$interopDefault($fKgem))),
        (0, (0, parcelRequire("c7J1U")).default)
    ];
    const $04caddce42518619$export$8441605555fbd60c = (appPrefix, store)=>store.namespace(appPrefix);
});
parcelRegister("c7J1U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$99d922a6a243a194$export$2e2bcd8739ae039);
    var $jcw0u;
    var $cuNKJ;
    function $99d922a6a243a194$var$cleanUpPlugin() {
        const self = this;
        const timestamps = self.createStore(self.storage, null, self._namespacePrefix + (0, (0, parcelRequire("cuNKJ")).NAMESPACE));
        function set(superFn, key, val) {
            try {
                if (!self.hasNamespace((0, (0, parcelRequire("cuNKJ")).NAMESPACE))) timestamps.set(key, Date.now());
                superFn();
            } catch (e) {
                if (e.code === (0, (0, parcelRequire("cuNKJ")).LOCAL_STORAGE_FULL_ERROR_CODE) || e.code === (0, (0, parcelRequire("cuNKJ")).LOCAL_STORAGE_FULL_FF_ERROR_CODE)) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'browserLocalStorageFullError',
                            packageName: 'jiraBrowserStorageProviders',
                            teamName: 'magma'
                        },
                        attributes: {
                            namespace: self._namespacePrefix
                        },
                        error: e,
                        skipSentry: true
                    });
                    if (self.cleanWhenFull()) self.set(superFn, key, val);
                } else {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'storageCleanupPluginError',
                            packageName: 'jiraBrowserStorageProviders',
                            teamName: 'magma'
                        },
                        attributes: {
                            isLegacyFunction: false
                        },
                        error: e
                    });
                    throw e;
                }
            }
        }
        function remove(superFn, key) {
            if (!self.hasNamespace((0, (0, parcelRequire("cuNKJ")).NAMESPACE))) timestamps.remove(key);
            return superFn();
        }
        function getTotalCount() {
            let count = 0;
            self.each(()=>{
                count += 1;
            });
            return count;
        }
        function cleanWhenFull(superFn, minAge = (0, (0, parcelRequire("cuNKJ")).FOUR_WEEKS)) {
            const currTime = Date.now();
            const numKeysBefore = self.getTotalCount();
            self.each((_value, key)=>{
                const created = !self.hasNamespace((0, (0, parcelRequire("cuNKJ")).NAMESPACE)) ? timestamps.get(key) : null;
                if (typeof created === 'number' && currTime - created > minAge) self.remove(key);
            });
            const itemsRemovedCount = numKeysBefore - self.getTotalCount();
            if (!itemsRemovedCount && minAge - (0, (0, parcelRequire("cuNKJ")).ONE_WEEK) >= (0, (0, parcelRequire("cuNKJ")).ONE_WEEK)) return self.cleanWhenFull(minAge - (0, (0, parcelRequire("cuNKJ")).ONE_WEEK));
            return itemsRemovedCount === 0;
        }
        return {
            set: set,
            remove: remove,
            cleanWhenFull: cleanWhenFull,
            getTotalCount: getTotalCount
        };
    }
    var $99d922a6a243a194$export$2e2bcd8739ae039 = $99d922a6a243a194$var$cleanUpPlugin;
});
parcelRegister("cuNKJ", function(module, exports) {
    $parcel$export(module.exports, "NAMESPACE", ()=>$d21613ddd27d5bbf$export$6aad947bda0f3f46);
    $parcel$export(module.exports, "ONE_WEEK", ()=>$d21613ddd27d5bbf$export$8187f416f1cc43d8);
    $parcel$export(module.exports, "FOUR_WEEKS", ()=>$d21613ddd27d5bbf$export$6e952fa7d47190cf);
    $parcel$export(module.exports, "LOCAL_STORAGE_FULL_ERROR_CODE", ()=>$d21613ddd27d5bbf$export$da99ebca8f453abd);
    $parcel$export(module.exports, "LOCAL_STORAGE_FULL_FF_ERROR_CODE", ()=>$d21613ddd27d5bbf$export$ea28dfd9333cda2d);
    const $d21613ddd27d5bbf$export$6aad947bda0f3f46 = 'timestamps';
    const $d21613ddd27d5bbf$export$8187f416f1cc43d8 = 604800000;
    const $d21613ddd27d5bbf$export$6e952fa7d47190cf = 4 * $d21613ddd27d5bbf$export$8187f416f1cc43d8;
    const $d21613ddd27d5bbf$export$da99ebca8f453abd = 22;
    const $d21613ddd27d5bbf$export$ea28dfd9333cda2d = 1014;
});
parcelRegister("dEJQ9", function(module, exports) {
    $parcel$export(module.exports, "makeLocalStore", ()=>$dcae70c06981fc99$export$b2631085fe8db7af);
    $parcel$export(module.exports, "makeLocalExpirableStore", ()=>$dcae70c06981fc99$export$cf816b43e73de947);
    var $fKgem = parcelRequire("fKgem");
    var $kzObv = parcelRequire("kzObv");
    var $c4CII = parcelRequire("c4CII");
    var $4Zgux = parcelRequire("4Zgux");
    var $2NjNT = parcelRequire("2NjNT");
    var $fNVZf;
    const $dcae70c06981fc99$export$b2631085fe8db7af = ()=>(0, ($parcel$interopDefault($c4CII))).createStore([
            (0, ($parcel$interopDefault($4Zgux))),
            (0, ($parcel$interopDefault($2NjNT)))
        ], (0, (0, parcelRequire("fNVZf")).plugins));
    const $dcae70c06981fc99$export$cf816b43e73de947 = ()=>(0, ($parcel$interopDefault($c4CII))).createStore([
            (0, ($parcel$interopDefault($4Zgux))),
            (0, ($parcel$interopDefault($2NjNT)))
        ], [
            (0, ($parcel$interopDefault($fKgem))),
            (0, ($parcel$interopDefault($kzObv)))
        ]);
});
parcelRegister("7SHTM", function(module, exports) {
    $parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledUserPreference", ()=>$a1fa570fc83fd392$export$2fc59b10f256dbee);
    $parcel$export(module.exports, "resetGlobalScopeForcedOptOutGinFlag", ()=>$a1fa570fc83fd392$export$89f09c81b642e3c7);
    var $jcw0u;
    var $eusud;
    const $a1fa570fc83fd392$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION = `
    mutation SetGlobalScopeUserPreferenceMutation($input: SetMyPreferenceInput!) {
        setMyPreference(input: $input) {
            success
        }
    }
`;
    const $a1fa570fc83fd392$var$setGlobalScopeUserPreference = async (input)=>{
        const result = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/', {
            body: JSON.stringify({
                query: $a1fa570fc83fd392$var$SET_GLOBAL_SCOPE_USER_PREFERENCE_MUTATION,
                variables: {
                    input: input
                }
            })
        });
        if (result.data.setMyPreference.success !== true) throw new Error(`Error setting user preference: ${input.key}`, {
            cause: result.errors?.[0]
        });
    };
    const $a1fa570fc83fd392$export$2fc59b10f256dbee = async (value)=>$a1fa570fc83fd392$var$setGlobalScopeUserPreference({
            key: 'jira.user.nin.global.scope.enrolment',
            value: value ? 'nin' : 'gin'
        });
    const $a1fa570fc83fd392$export$89f09c81b642e3c7 = async ()=>$a1fa570fc83fd392$var$setGlobalScopeUserPreference({
            key: 'jira.user.nin.global.scope.enrolment.flag.disabled',
            value: false
        }).catch((error)=>(0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'resetGlobalScopeGinFlag',
                    packageName: 'jiraIssueNavigatorGlobalScopeEnrolment',
                    teamName: 'empanada'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            }));
});
parcelRegister("cZpsT", function(module, exports) {
    $parcel$export(module.exports, "useIsAnonymous", ()=>$5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b);
    var $9OXo1;
    const $5ea99a868eaaf0f7$export$bf7b5d502f6d6d3b = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.isAnonymous;
    };
});
parcelRegister("aK1ba", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$106d1fc5065910b3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6T4rd;
    var $1m92z;
    var $jJ1Sb;
    var $6s1PB;
    var $7iULw;
    var $dseDh;
    var $koVbs;
    var $6jY6G;
    var $bw7Gm;
    var $4DPZY;
    var $9OXo1;
    var $g7SDw;
    const $106d1fc5065910b3$export$3fe286306fb8ddfb = 'global-scope-issue-navigator-opt-out';
    const $106d1fc5065910b3$var$unknownAttributeValue = 'unknown';
    const $106d1fc5065910b3$export$b028e515f8f652e0 = ({ isSiteAdmin: isSiteAdmin, routeName: routeName, routeGroup: routeGroup, projectType: projectType, isProjectSimplified: isProjectSimplified, cloudId: cloudId })=>[
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).LOCATION,
                value: (0, (0, parcelRequire("bw7Gm")).default)(window.location.href)
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).REFERER,
                value: document.referrer ? (0, (0, parcelRequire("bw7Gm")).default)(document.referrer) : ''
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).USER_AGENT,
                value: navigator.userAgent
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).SCREEN_RESOLUTION,
                value: `${window.screen.width} x ${window.screen.height}`
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).ROUTE_NAME,
                value: routeName
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).ROUTE_GROUP,
                value: routeGroup
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).IS_SIMPLIFIED_PROJECT,
                value: isProjectSimplified.toString()
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).IS_ADMIN,
                value: isSiteAdmin.toString()
            },
            {
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).PROJECT_TYPE,
                value: projectType
            },
            {
                id: 'cloud-id',
                value: cloudId
            }
        ];
    const $106d1fc5065910b3$export$3a73a4e2115ebf73 = ({ isAdminSettingsModal: isAdminSettingsModal = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const titleDetails = isAdminSettingsModal ? formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("g7SDw")).default).titleDetailsAdminIssueTermRefresh : (0, (0, parcelRequire("g7SDw")).default).titleDetailsAdmin) : formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("g7SDw")).default).titleDetailsUserIssueTermRefresh : (0, (0, parcelRequire("g7SDw")).default).titleDetailsUser);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $106d1fc5065910b3$var$feedbackTitleDetailsContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1m92z")).default), {
            as: "p"
        }, titleDetails));
    };
    const $106d1fc5065910b3$var$useFeedbackDialog = ({ isAdminSettingsModal: isAdminSettingsModal = false, onClose: onClose = ()=>undefined })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { openFeedbackCollector: openFeedbackCollector } = (0, (0, parcelRequire("dseDh")).useFeedbackCollectorActions)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const [{ data: projectData }] = (0, (0, parcelRequire("4DPZY")).useContainerContext)();
        const { cloudId: cloudId, isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const routeGroup = route.group ?? $106d1fc5065910b3$var$unknownAttributeValue;
        const routeName = route.name ?? $106d1fc5065910b3$var$unknownAttributeValue;
        let projectType = $106d1fc5065910b3$var$unknownAttributeValue;
        let isProjectSimplified = false;
        if (projectData && 'project' in projectData && projectData.project) {
            projectType = projectData.project.type;
            isProjectSimplified = projectData.project.isSimplified;
        }
        const renderFeedbackDialog = (0, $5uXOq.useCallback)(()=>{
            openFeedbackCollector({
                feedbackGroupId: $106d1fc5065910b3$export$3fe286306fb8ddfb,
                entrypointId: (0, (0, parcelRequire("7iULw")).ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR),
                onClose: onClose,
                feedbackContext: $106d1fc5065910b3$export$b028e515f8f652e0({
                    isSiteAdmin: isSiteAdmin,
                    cloudId: cloudId,
                    routeGroup: routeGroup,
                    routeName: routeName,
                    projectType: projectType,
                    isProjectSimplified: isProjectSimplified
                }),
                feedbackTitle: formatMessage((0, (0, parcelRequire("g7SDw")).default).title),
                feedbackTitleDetails: (0, ($parcel$interopDefault($5uXOq))).createElement($106d1fc5065910b3$export$3a73a4e2115ebf73, {
                    isAdminSettingsModal: isAdminSettingsModal
                }),
                selectLabel: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("g7SDw")).default).reasonTitleIssueTermRefresh : (0, (0, parcelRequire("g7SDw")).default).reasonTitle),
                summaryPlaceholder: ' ',
                submitButtonLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).submitCaption),
                cancelButtonLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).cancelCaption),
                feedbackGroupLabels: {
                    empty: {
                        selectOptionLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonPlaceholder)
                    },
                    bug: {
                        fieldLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonQuestion),
                        selectOptionLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonBug)
                    },
                    comment: {
                        fieldLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonQuestion),
                        selectOptionLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonSpeed)
                    },
                    suggestion: {
                        fieldLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonQuestion),
                        selectOptionLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonOthers)
                    },
                    question: {
                        fieldLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonQuestion),
                        selectOptionLabel: formatMessage((0, (0, parcelRequire("g7SDw")).default).reasonParity)
                    }
                }
            });
        }, [
            openFeedbackCollector,
            onClose,
            isSiteAdmin,
            cloudId,
            routeGroup,
            routeName,
            projectType,
            isProjectSimplified,
            formatMessage,
            isAdminSettingsModal
        ]);
        return {
            renderFeedbackDialog: renderFeedbackDialog
        };
    };
    var $106d1fc5065910b3$export$2e2bcd8739ae039 = $106d1fc5065910b3$var$useFeedbackDialog;
    const $106d1fc5065910b3$var$feedbackTitleDetailsContainerStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        marginBottom: 'space.050'
    });
});
parcelRegister("4DPZY", function(module, exports) {
    $parcel$export(module.exports, "useContainerContext", ()=>$a65e0c39573f7437$export$c7066c2d215990cf);
    $parcel$export(module.exports, "ContainerContextSubscriber", ()=>$a65e0c39573f7437$export$5b87a78c45d5dd17);
    var $5uXOq = parcelRequire("5uXOq");
    var $7xTO3;
    var $ggg5j;
    var $dIdda = parcelRequire("dIdda");
    var $6SkQo;
    const $a65e0c39573f7437$var$useProjectContext = ()=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, $dIdda.useResource)((0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource));
        const projectContext = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("6SkQo")).getProjectContext)(data), [
            data
        ]);
        return [
            {
                data: projectContext,
                error: error,
                loading: loading
            },
            {
                fetch: refresh,
                refetch: refresh
            }
        ];
    };
    const $a65e0c39573f7437$var$useUserBoardContext = ()=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, $dIdda.useResource)((0, (0, parcelRequire("7xTO3")).staticJSWUserBoardSidebarNavigationResource));
        const userContext = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("6SkQo")).getUserContext)(data), [
            data
        ]);
        return [
            {
                data: userContext,
                error: error,
                loading: loading
            },
            {
                fetch: refresh,
                refetch: refresh
            }
        ];
    };
    const $a65e0c39573f7437$export$c7066c2d215990cf = ()=>{
        const projectContext = $a65e0c39573f7437$var$useProjectContext();
        const userBoardContext = $a65e0c39573f7437$var$useUserBoardContext();
        if (userBoardContext && userBoardContext[0] && userBoardContext[0].data != null) return userBoardContext;
        return projectContext;
    };
    const $a65e0c39573f7437$export$5b87a78c45d5dd17 = (props)=>{
        const [data, actions] = $a65e0c39573f7437$export$c7066c2d215990cf();
        return props.children(data, actions);
    };
    $a65e0c39573f7437$export$5b87a78c45d5dd17.displayName = 'ContainerContextSubscriber';
});
parcelRegister("6SkQo", function(module, exports) {
    $parcel$export(module.exports, "getUserContext", ()=>$84cf60e2c9c0e289$export$114c35c2c23732ab);
    $parcel$export(module.exports, "getProjectContext", ()=>$84cf60e2c9c0e289$export$d17fffd59c7b3c60);
    var $2vSU6;
    var $bsuuc;
    const $84cf60e2c9c0e289$export$114c35c2c23732ab = (userBoardNavData)=>{
        const { boardInfo: boardInfo, owner: owner } = userBoardNavData;
        return {
            contextType: 'user',
            user: {
                id: owner.id,
                name: owner.name,
                avatarUrl: owner.avatarUrl,
                profileUrl: owner.profileUrl,
                accountId: owner.accountId
            },
            scope: {
                id: boardInfo.id,
                type: boardInfo.type,
                name: boardInfo.name
            }
        };
    };
    const $84cf60e2c9c0e289$var$getScope = (projectNavInfo)=>{
        if (projectNavInfo.projectType === 'jira_software' && projectNavInfo?.jiraSoftwareNavData?.boardInfo) {
            const { boardInfo: boardInfo } = projectNavInfo.jiraSoftwareNavData;
            return {
                id: boardInfo.id,
                type: boardInfo.type,
                name: boardInfo.name
            };
        }
        return undefined;
    };
    const $84cf60e2c9c0e289$var$getProjectType = (projectType)=>{
        switch(projectType){
            case 'business':
                return 0, (0, parcelRequire("2vSU6")).CORE_PROJECT;
            case 'software':
                return 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT;
            case 'service_desk':
                return 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT;
            case 'product_discovery':
                return 0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT;
            default:
                return null;
        }
    };
    const $84cf60e2c9c0e289$export$d17fffd59c7b3c60 = (projectNavInfo)=>{
        const project = (0, (0, parcelRequire("bsuuc")).extractData)(projectNavInfo);
        const scope = $84cf60e2c9c0e289$var$getScope(projectNavInfo);
        if (project) {
            const projectType = $84cf60e2c9c0e289$var$getProjectType(project.type);
            if (projectType) return {
                contextType: 'project',
                project: {
                    key: project.key,
                    id: project.id,
                    name: project.name,
                    type: projectType,
                    isSimplified: project.isSimplified,
                    avatarUrl: project.avatarUrl,
                    style: (0, (0, parcelRequire("bsuuc")).getStyle)(project.isSimplified)
                },
                scope: scope
            };
        }
        return null;
    };
});
parcelRegister("g7SDw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5fa18157d389278a$export$2e2bcd8739ae039);
    var $7VHMR;
    const $5fa18157d389278a$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.title",
            "defaultMessage": "Let us know why you're moving"
        },
        titleDetailsAdmin: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-admin",
            "defaultMessage": "You and your users will be able to use the old issue search temporarily."
        },
        titleDetailsUser: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-user",
            "defaultMessage": "You'll be able to use the old issue search temporarily."
        },
        submitCaption: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.submit-caption",
            "defaultMessage": "Send feedback"
        },
        cancelCaption: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.cancel-caption",
            "defaultMessage": "Skip"
        },
        reasonTitle: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-title",
            "defaultMessage": "What is your reason to go back to the old issue search?"
        },
        reasonPlaceholder: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-placeholder",
            "defaultMessage": "Select an option"
        },
        reasonParity: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-parity",
            "defaultMessage": "Features are missing"
        },
        reasonSpeed: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-speed",
            "defaultMessage": "It's slow"
        },
        reasonBug: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-bug",
            "defaultMessage": "There's a bug"
        },
        reasonOthers: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-others",
            "defaultMessage": "Others"
        },
        reasonQuestion: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-question",
            "defaultMessage": "Can you provide more details? It'll help make search better for everyone."
        },
        titleDetailsAdminIssueTermRefresh: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-admin-issue-term-refresh",
            "defaultMessage": "You and your users will be able to use the old issue search temporarily."
        },
        titleDetailsUserIssueTermRefresh: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.title-details-user-issue-term-refresh",
            "defaultMessage": "You'll be able to use the old issue search temporarily."
        },
        reasonTitleIssueTermRefresh: {
            "id": "issue-navigator-changeboarding.common.opt-out-feedback.reason-title-issue-term-refresh",
            "defaultMessage": "What is your reason to go back to the old issue search?"
        }
    });
    var $5fa18157d389278a$export$2e2bcd8739ae039 = $5fa18157d389278a$var$messages;
});
parcelRegister("cnynt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c37d0c1deb4d01ea$export$2e2bcd8739ae039);
    var $7VHMR;
    const $c37d0c1deb4d01ea$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorOptOutTitle: {
            "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-title",
            "defaultMessage": "We couldn't switch to the old issue search"
        },
        errorOptOutDesc: {
            "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-desc",
            "defaultMessage": "Refresh and try again."
        },
        errorOptOutTitleIssueTermRefresh: {
            "id": "issue-navigator-changeboarding.controllers.global-scope-enrolment-flow.error-opt-out-title-issue-term-refresh",
            "defaultMessage": "We couldn't switch to the old issue search"
        }
    });
    var $c37d0c1deb4d01ea$export$2e2bcd8739ae039 = $c37d0c1deb4d01ea$var$messages;
});
parcelRegister("kUl3E", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$138ed00c0e48b315$export$2e2bcd8739ae039);
    var $138ed00c0e48b315$export$2e2bcd8739ae039 = ({ params: params }, { filter: filter, orderby: orderby, keyword: keyword })=>{
        const { projectKey: projectKey, issueKey: issueKey } = params;
        const pageIdPrefix = 'new-issue-navigator';
        let pageId = '';
        try {
            pageId = `${pageIdPrefix}${(projectKey !== null && projectKey !== undefined ? `-${projectKey}` : '') + (issueKey !== null && issueKey !== undefined ? `-${issueKey}` : '') + (filter !== undefined ? `-${filter}` : '') + (orderby !== undefined ? `-${orderby}` : '') + (keyword !== undefined ? `-${keyword}` : '')}`;
        } catch  {
            pageId = pageIdPrefix;
        }
        return pageId;
    };
});
parcelRegister("1UnUc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iIfyN")
    ]).then(()=>parcelRequire('jABZI'));
});
parcelRegister("90rvf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("azMOH")
    ]).then(()=>parcelRequire('iUdxh'));
});
parcelRegister("jrl3R", function(module, exports) {
    $parcel$export(module.exports, "issueNavigatorGlobalRouteEntry", ()=>$25e6f63d1902d36e$export$3e58fe44312b4093);
    var $ffza4;
    var $co1wz;
    var $2BrOV;
    var $2G9Bk;
    var $kumTR;
    var $1gXMV;
    var $fERWs;
    var $1QOEF;
    var $b8f12;
    const $25e6f63d1902d36e$export$3e58fe44312b4093 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kumTR")).globalIssueNavigatorRoute), ()=>({
            ...(0, (0, parcelRequire("fERWs")).common),
            component: (0, (0, parcelRequire("b8f12")).GinRedirect),
            skeleton: (0, (0, parcelRequire("1gXMV")).GlobalIssueNavigatorSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("b8f12")).LazyGlobalIssueNavigator)
            ],
            canTransitionIn: ()=>(0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8'),
            ufoName: 'global-issue-navigator-jfe',
            navigation: (0, (0, parcelRequire("1QOEF")).getCommonGlobalNavigation)(),
            resources: [
                ...(0, (0, parcelRequire("1QOEF")).getCommonGlobalResources)()
            ],
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout)
        }));
});
parcelRegister("3B53X", function(module, exports) {
    $parcel$export(module.exports, "issueNavigatorProjectBusinessRouteEntry", ()=>$99398975b82221bf$export$ce258b07e4b7eb8c);
    var $ffza4;
    var $l71WK;
    var $gyYxw;
    var $lmyls;
    var $dmKXV;
    var $2G9Bk;
    var $1XrjK;
    var $d04s2;
    var $kumTR;
    var $lHYIV;
    var $fERWs;
    var $cFu3S;
    var $b8f12;
    const $99398975b82221bf$export$ce258b07e4b7eb8c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kumTR")).projectIssueNavigatorCoreRoute), ()=>({
            ...(0, (0, parcelRequire("fERWs")).common),
            component: (0, (0, parcelRequire("b8f12")).ProjectIssueNavigator),
            skeleton: (0, (0, parcelRequire("lHYIV")).ProjectIssueNavigatorSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("b8f12")).LazyProjectIssueNavigator)
            ],
            afterPaint: [
                (0, (0, parcelRequire("d04s2")).LazyIssueApp)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("dmKXV")).default),
                horizontal: (0, (0, parcelRequire("l71WK")).AsyncHorizontalProjectNav)
            },
            resources: [
                ...(0, (0, parcelRequire("cFu3S")).getCommonProjectResources)()
            ],
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)((0, (0, parcelRequire("gyYxw")).genericProjectLayout))
        }));
});
parcelRegister("glkO2", function(module, exports) {
    $parcel$export(module.exports, "issueNavigatorProjectClassicRouteEntry", ()=>$41789f7b84696902$export$88d5f4117ce3d0fb);
    var $ffza4;
    var $gyYxw;
    var $lmyls;
    var $9s3j1;
    var $2G9Bk;
    var $1XrjK;
    var $d04s2;
    var $kumTR;
    var $lHYIV;
    var $5PD5h;
    var $fERWs;
    var $cFu3S;
    var $b8f12;
    const $41789f7b84696902$export$88d5f4117ce3d0fb = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kumTR")).projectIssueNavigatorClassicRoute), ()=>({
            ...(0, (0, parcelRequire("fERWs")).common),
            component: (0, (0, parcelRequire("b8f12")).ProjectIssueNavigator),
            skeleton: (0, (0, parcelRequire("lHYIV")).ProjectIssueNavigatorSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("b8f12")).LazyProjectIssueNavigator)
            ],
            afterPaint: [
                (0, (0, parcelRequire("d04s2")).LazyIssueApp)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("9s3j1")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("cFu3S")).getCommonProjectResources)()
            ],
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)((0, (0, parcelRequire("gyYxw")).genericProjectLayout))
        }));
});
parcelRegister("04Vlk", function(module, exports) {
    $parcel$export(module.exports, "issueNavigatorProjectServicedeskRouteEntry", ()=>$20147c9440522c21$export$b779296ccb8ca1a8);
    var $ffza4;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $1WlLE;
    var $d04s2;
    var $kumTR;
    var $6Z2mh;
    var $lHYIV;
    var $fERWs;
    var $cFu3S;
    var $b8f12;
    const $20147c9440522c21$export$b779296ccb8ca1a8 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kumTR")).servicedeskIssuesRoute), ()=>({
            ...(0, (0, parcelRequire("fERWs")).common),
            component: (0, (0, parcelRequire("b8f12")).ServiceDeskIssueNavigator),
            skeleton: (0, (0, parcelRequire("lHYIV")).ProjectIssueNavigatorSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("b8f12")).LazyServiceDeskProjectIssueNavigator)
            ],
            afterPaint: [
                (0, (0, parcelRequire("d04s2")).LazyIssueApp)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("cFu3S")).getCommonProjectResources)(),
                (0, (0, parcelRequire("1WlLE")).queuesNavigationItems),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout)
        }));
});
parcelRegister("flsjf", function(module, exports) {
    $parcel$export(module.exports, "issueNavigatorProjectSoftwareRouteEntry", ()=>$a82ae7782e05cd6a$export$2a50f64378877c9d);
    var $ffza4;
    var $lmyls;
    var $koWFd;
    var $2G9Bk;
    var $1XrjK;
    var $d04s2;
    var $kumTR;
    var $lHYIV;
    var $5PD5h;
    var $e7bC3;
    var $fERWs;
    var $cFu3S;
    var $b8f12;
    const $a82ae7782e05cd6a$export$2a50f64378877c9d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kumTR")).softwareIssueNavigatorRoute), ()=>({
            ...(0, (0, parcelRequire("fERWs")).common),
            component: (0, (0, parcelRequire("b8f12")).ProjectIssueNavigator),
            skeleton: (0, (0, parcelRequire("lHYIV")).ProjectIssueNavigatorSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("b8f12")).LazyProjectIssueNavigator)
            ],
            afterPaint: [
                (0, (0, parcelRequire("d04s2")).LazyIssueApp)
            ],
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("cFu3S")).getCommonProjectResources)()
            ],
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)((0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding))
        }));
});
parcelRegister("gGOoR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$265d2c27687434ef$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7OYJs;
    var $dIdda = parcelRequire("dIdda");
    var $265d2c27687434ef$export$2e2bcd8739ae039 = ()=>{
        const [{ match: match }] = (0, $dIdda.useRouter)();
        const issueKey = match.params.issueKey ?? '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: `/issues/${issueKey}`
        });
    };
});
parcelRegister("kF7iq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e5b5921263d4891a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $jcw0u;
    var $iXVV6;
    var $5oFIy;
    var $dxCvy;
    var $dIdda = parcelRequire("dIdda");
    var $e5b5921263d4891a$export$2e2bcd8739ae039 = ()=>{
        const [{ match: match, query: query }] = (0, $dIdda.useRouter)();
        const { data: data, error: error, loading: loading } = (0, $dIdda.useResource)((0, (0, parcelRequire("dxCvy")).projectContextResource));
        (0, $5uXOq.useEffect)(()=>{
            if (error) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'useResourceProjectContext',
                    packageName: 'jiraRouterRoutesIssueNavigatorEntries'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }, [
            error
        ]);
        if (!data && !loading || error) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "pinRedirectFailed"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null));
        if (!data) return null;
        const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
        let type;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                type = 'servicedesk';
                break;
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                type = 'core';
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            default:
                type = `software${simplified ? '' : '/c'}`;
        }
        const issueKey = match.params.issueKey ?? '';
        const queryParams = new URLSearchParams(query).toString();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "pinRedirect"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/jira/${type}/projects/${projectKey}/issues/${issueKey}?${queryParams}`
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null));
    };
});
parcelRegister("hFzxG", function(module, exports) {
    $parcel$export(module.exports, "jiraHomeRouteEntry", ()=>$f9946918a701eac6$export$578dcb61ac3cb57a);
    var $5uXOq = parcelRequire("5uXOq");
    var $lPj61;
    var $ffza4;
    var $3H5ry;
    var $l9RBL;
    var $gmpjq;
    var $lmyls;
    var $2G9Bk;
    var $bHhiy;
    var $aILzD;
    var $3RJkv;
    var $kbked;
    var $7sjxl;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $f9946918a701eac6$var$LazyJiraHomePage = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("pC8Oc"))), {
        moduleId: "./src/packages/spa-apps/jira-home/src/index.tsx"
    });
    const $f9946918a701eac6$var$checkConsolidationOnRouteDependency = async (dependencies)=>{
        const data = await dependencies[0, $5a94e356f9d5e220$export$25ee35b01de9d734].promise;
        return (0, (0, parcelRequire("3H5ry")).checkShouldUseJSM)(data);
    };
    const $f9946918a701eac6$export$fe7946d7dc386f9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f9946918a701eac6$var$LazyJiraHomePage,
            pageId: "jira-home",
            shouldShowSpinner: false
        });
    const $f9946918a701eac6$export$578dcb61ac3cb57a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kbked")).jiraHomeRoute), ()=>({
            ufoName: 'jira-home',
            component: $f9946918a701eac6$export$fe7946d7dc386f9c,
            skeleton: (0, (0, parcelRequire("7sjxl")).YourWorkSkeleton),
            layout: (0, (0, parcelRequire("gmpjq")).homepageLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HOME
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("aILzD")).jiraHomeResourceWithCache),
                (0, (0, parcelRequire("l9RBL")).jiraHomePageRightSidePanelResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...(0, (0, parcelRequire("lPj61")).widgetResources).map((resourceCreator)=>resourceCreator($f9946918a701eac6$var$checkConsolidationOnRouteDependency, [
                        (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                    ]))
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f9946918a701eac6$var$LazyJiraHomePage
            ]
        }));
});
parcelRegister("l9RBL", function(module, exports) {
    $parcel$export(module.exports, "jiraHomePageRightSidePanelResource", ()=>$eed57b2562d325e4$export$9cba342d9ec5384d);
    var $ao2h1;
    var $a4BhB;
    var $jKXj9;
    const $eed57b2562d325e4$var$isBroadcastWidgetEnabled = ()=>false;
    const $eed57b2562d325e4$export$9cba342d9ec5384d = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, (0, parcelRequire("jKXj9")).JIRA_HOME_PAGE_RIGHT_SIDE_PANEL),
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("a4BhB")).default),
                variables: {
                    cloudId: tenantContext.cloudId,
                    broadcastWidgetEnabled: $eed57b2562d325e4$var$isBroadcastWidgetEnabled()
                },
                options: {
                    fetchPolicy: 'network-only'
                }
            })
    });
});
parcelRegister("a4BhB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$616ef8e6ff77d43c$export$2e2bcd8739ae039);
    const $616ef8e6ff77d43c$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "broadcastWidgetEnabled"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "main_rightSidePanel_RootQuery",
                "selections": [
                    {
                        "condition": "broadcastWidgetEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "FragmentSpread",
                                "name": "main_homeBroadcastWidget_Widget"
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "main_rightSidePanel_RootQuery",
                "selections": [
                    {
                        "condition": "broadcastWidgetEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "concreteType": "JiraQuery",
                                "kind": "LinkedField",
                                "name": "jira",
                                "plural": false,
                                "selections": [
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "cloudId",
                                                "variableName": "cloudId"
                                            }
                                        ],
                                        "concreteType": "JiraUserBroadcastMessageConnection",
                                        "kind": "LinkedField",
                                        "name": "allJiraUserBroadcastMessages",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraUserBroadcastMessageEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraUserBroadcastMessage",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "shouldDisplay"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "id"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "d1e74aae483d14f57577f9505f3c4efaab555f7aa6ddfb379804496ec3f405f1",
                "metadata": {},
                "name": "main_rightSidePanel_RootQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $616ef8e6ff77d43c$var$node.hash = "174d1e9e3edb60b5684e0806b3d7342e";
    var $616ef8e6ff77d43c$export$2e2bcd8739ae039 = $616ef8e6ff77d43c$var$node;
});
parcelRegister("jKXj9", function(module, exports) {
    $parcel$export(module.exports, "RIGHT_PANEL_WIDTH", ()=>$64d3bec226f7ff92$export$750459958906793);
    $parcel$export(module.exports, "RIGHT_SIDE_PANEL_EXPERIENCE", ()=>$64d3bec226f7ff92$export$2eb41e47cfa429b7);
    $parcel$export(module.exports, "JIRA_HOME_PAGE_RIGHT_SIDE_PANEL", ()=>$64d3bec226f7ff92$export$6c783d91630ece21);
    var $gwIPs;
    const $64d3bec226f7ff92$export$750459958906793 = (0, (0, parcelRequire("gwIPs")).gridSize) * 49;
    const $64d3bec226f7ff92$export$2eb41e47cfa429b7 = {
        experience: 'jiraHomeRightSidePanel',
        experienceId: undefined,
        analyticsSource: 'jira-home'
    };
    const $64d3bec226f7ff92$export$6c783d91630ece21 = 'JIRA_HOME_PAGE_RIGHT_SIDE_PANEL';
});
const $5a94e356f9d5e220$export$25ee35b01de9d734 = 'EOC_TENANT';
parcelRegister("aILzD", function(module, exports) {
    $parcel$export(module.exports, "jiraHomeResourceWithCache", ()=>$9f71890db935ba06$export$1da15dc2d924240c);
    var $dIdda = parcelRequire("dIdda");
    const $9f71890db935ba06$export$1da15dc2d924240c = (0, $dIdda.createResource)({
        type: (0, $dac9c443ac5dd9ad$export$e79da7e0d9d1c1f2),
        getKey: ()=>'jira-home',
        getDataLoader: ()=>(parcelRequire("klVCQ")),
        maxAge: Infinity
    });
});
const $dac9c443ac5dd9ad$export$e79da7e0d9d1c1f2 = 'JIRA_HOME';
parcelRegister("klVCQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("7kTIJ")
    ]).then(()=>parcelRequire('fvAUD'));
});
parcelRegister("7sjxl", function(module, exports) {
    $parcel$export(module.exports, "YourWorkSkeleton", ()=>$8865bd588e4a0ff3$export$62cf62fa23284b71);
    $parcel$export(module.exports, "YourWorkItemListSkeleton", ()=>$8865bd588e4a0ff3$export$31cebe1052db844);
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $6L7Ws = parcelRequire("6L7Ws");
    var $aN3q5 = parcelRequire("aN3q5");
    const $8865bd588e4a0ff3$export$62cf62fa23284b71 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($6L7Ws)))
        });
    const $8865bd588e4a0ff3$export$31cebe1052db844 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($aN3q5))),
            containerStyles: {
                maxHeight: '30em'
            }
        });
});
parcelRegister("6L7Ws", function(module, exports) {
    module.exports = new URL("your-work-app-skeleton.tpl.14d150b5.svg", import.meta.url).toString();
});
parcelRegister("aN3q5", function(module, exports) {
    module.exports = new URL("your-work-itemlist-skeleton.tpl.e9027f83.svg", import.meta.url).toString();
});
parcelRegister("pC8Oc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eLhUl")
    ]).then(()=>parcelRequire('jyj7M'));
});
parcelRegister("crhGk", function(module, exports) {
    $parcel$export(module.exports, "jiraSearchRouteEntry", ()=>$a8fe8d7b4d12b7ef$export$76b74d5744e69817);
    var $ffza4;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $d5GUp;
    var $7kiuE;
    var $5ZrME;
    const $a8fe8d7b4d12b7ef$export$76b74d5744e69817 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("d5GUp")).jiraSearchRoute), ()=>({
            component: (0, (0, parcelRequire("7kiuE")).JiraSearchRedirect),
            isRedirect: true,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("5ZrME")).jiraSearchResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
});
parcelRegister("d5GUp", function(module, exports) {
    $parcel$export(module.exports, "jiraSearchRoute", ()=>$00c74f90175a79ab$export$a3a93dcf611b611a);
    var $65Ltd;
    const $00c74f90175a79ab$export$a3a93dcf611b611a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_REDIRECTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_JIRA_SEARCH),
        path: '/jira/search',
        exact: true
    };
});
parcelRegister("7kiuE", function(module, exports) {
    $parcel$export(module.exports, "JiraSearchRedirect", ()=>$c1df58920245e964$export$ee180957879b33ac);
    var $5uXOq = parcelRequire("5uXOq");
    var $c65JB;
    var $dIdda = parcelRequire("dIdda");
    var $lFlWg;
    var $5ZrME;
    const $c1df58920245e964$export$ee180957879b33ac = ()=>{
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)((0, (0, parcelRequire("5ZrME")).jiraSearchResource));
        if (loading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c65JB")).IssueViewSkeleton), null);
        if (error || !data?.url) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lFlWg")).QuickSearchToGlobalIssueNavigatorRedirect), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: data.url,
            push: false
        });
    };
});
parcelRegister("lFlWg", function(module, exports) {
    $parcel$export(module.exports, "QuickSearchToGlobalIssueNavigatorRedirect", ()=>$2bd6861b4d276506$export$968c2900ae111000);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $4R6GH;
    var $6jY6G;
    var $8zOmE;
    var $95EVP;
    var $bATyw;
    var $dIdda = parcelRequire("dIdda");
    const $2bd6861b4d276506$export$968c2900ae111000 = ({ Redirect: Redirect = (0, $dIdda.Redirect), fireScreenAnalytics: fireScreenAnalytics = (0, (0, parcelRequire("8zOmE")).fireScreenAnalytics), useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents), useCurrentRoute: useCurrentRoute = (0, (0, parcelRequire("6jY6G")).useCurrentRoute), useQueryParam: useQueryParam = (0, $dIdda.useQueryParam) })=>{
        const route = useCurrentRoute();
        const [searchString] = useQueryParam('searchString');
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        let isNinEnabled;
        if ((0, (0, parcelRequire("4R6GH")).fg)('nin-text-fields-new-text-search-field') || (0, (0, parcelRequire("co1wz")).ff)('nin_expose_text_option_jql_builder_4kwzo')) ({ data: isNinEnabled } = (0, $dIdda.useResource)((0, (0, parcelRequire("bATyw")).isNinGlobalScopeEnrolmentEnabledResource)));
        else isNinEnabled = true;
        (0, $5uXOq.useEffect)(()=>{
            if (!route) return;
            const screenEvent = createAnalyticsEvent({
                screenName: 'quickSearchRedirect',
                attributes: {
                    type: route.name
                }
            });
            fireScreenAnalytics(screenEvent);
        }, [
            createAnalyticsEvent,
            fireScreenAnalytics,
            route
        ]);
        let jql;
        if (isNinEnabled && (0, (0, parcelRequire("4R6GH")).fg)('nin-text-fields-new-text-search-field')) jql = searchString != null ? `textfields ~ "${searchString}"` : 'ORDER BY created DESC';
        else if (isNinEnabled && (0, (0, parcelRequire("co1wz")).ff)('nin_expose_text_option_jql_builder_4kwzo')) jql = searchString != null ? `summary ~ "${searchString}" OR description ~ "${searchString}" ORDER BY created DESC` : 'ORDER BY created DESC';
        else jql = searchString != null ? `text ~ "${searchString}"` : 'order by created DESC';
        const redirectUrl = `/issues/?jql=${encodeURIComponent(jql)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: redirectUrl
        });
    };
    var $2bd6861b4d276506$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($2bd6861b4d276506$export$968c2900ae111000, null);
});
parcelRegister("5ZrME", function(module, exports) {
    $parcel$export(module.exports, "jiraSearchResource", ()=>$c763bb61845622fe$export$d23832be0ebf8a93);
    var $ebyGx = parcelRequire("ebyGx");
    var $7f4tk;
    var $dIdda = parcelRequire("dIdda");
    const $c763bb61845622fe$export$486bd66a4d919be7 = 'RESOURCE_TYPE_JIRA_SEARCH';
    const $c763bb61845622fe$export$d23832be0ebf8a93 = (0, $dIdda.createResource)({
        type: $c763bb61845622fe$export$486bd66a4d919be7,
        getKey: ()=>'search',
        getData: ({ query: query }, { tenantContext: tenantContext })=>{
            const { atlassianAccountId: atlassianAccountId } = tenantContext;
            if (!atlassianAccountId || !query?.searchString) return null;
            const queryStr = (0, ($parcel$interopDefault($ebyGx))).stringify({
                searchString: query.searchString
            });
            return (0, (0, parcelRequire("7f4tk")).default)(`/rest/navigation/4/quicksearch?${queryStr}`);
        },
        isBrowserOnly: true
    });
});
parcelRegister("1t2WJ", function(module, exports) {
    $parcel$export(module.exports, "loginEmbedRouteEntry", ()=>$5ec52c3f3a973163$export$faa46f8c5e1f06d3);
    var $5uXOq = parcelRequire("5uXOq");
    var $6e4Kt;
    var $2G9Bk;
    var $3CP8V;
    var $5j7Th;
    var $hPtZI;
    const $5ec52c3f3a973163$export$53d5d548e4e9b86 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("35DJb")), {
        moduleId: "./src/packages/spa-apps/login-embed/src/index.tsx"
    });
    const $5ec52c3f3a973163$export$2a94dc6e96350c82 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5ec52c3f3a973163$export$53d5d548e4e9b86,
            pageId: "spa-apps/login-embed",
            shouldShowSpinner: true
        });
    const $5ec52c3f3a973163$export$faa46f8c5e1f06d3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("3CP8V")).loginEmbedRoute), ()=>({
            component: $5ec52c3f3a973163$export$2a94dc6e96350c82,
            layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout)
        }));
});
parcelRegister("3CP8V", function(module, exports) {
    $parcel$export(module.exports, "loginEmbedRoute", ()=>$b818456f90aef923$export$9efae7a8e8e69866);
    var $65Ltd;
    const $b818456f90aef923$export$9efae7a8e8e69866 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ERRORS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LOGIN_EMBED),
        path: '/jira-login/embed'
    };
});
parcelRegister("35DJb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bt202").then(()=>parcelRequire('8LbPV'));
});
parcelRegister("aVXMt", function(module, exports) {
    $parcel$export(module.exports, "getMarketplaceRoutes", ()=>$671f611e278b4662$export$fd3c71e3bfb4df9e);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $2BrOV;
    var $lmyls;
    var $5bkvv;
    var $iHiHz;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $4zecE;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $671f611e278b4662$var$LazyMarketplace = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("azvSc"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/marketplace/src/index.tsx"
    });
    const $671f611e278b4662$var$MarketplaceComponent = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $671f611e278b4662$var$LazyMarketplace,
            pageId: "marketplace",
            shouldShowSpinner: true
        });
    const $671f611e278b4662$var$findAppsRouteEntry = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4zecE")).findAppsRoute), ()=>({
            component: $671f611e278b4662$var$MarketplaceComponent,
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).ADDONS,
                sidebar: (0, (0, parcelRequire("iHiHz")).default)
            },
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $671f611e278b4662$var$LazyMarketplace
            ],
            ufoName: 'embedded-marketplace'
        }));
    const $671f611e278b4662$export$423a1c80bb2f8b9a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4zecE")).appRequestRoute), ()=>({
            component: $671f611e278b4662$var$MarketplaceComponent,
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).ADDONS,
                sidebar: (0, (0, parcelRequire("iHiHz")).default)
            },
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $671f611e278b4662$var$LazyMarketplace
            ]
        }));
    const $671f611e278b4662$export$875d88a44b1ff74c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4zecE")).promotionsRoute), ()=>({
            component: $671f611e278b4662$var$MarketplaceComponent,
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).ADDONS,
                sidebar: (0, (0, parcelRequire("iHiHz")).default)
            },
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $671f611e278b4662$var$LazyMarketplace
            ]
        }));
    const $671f611e278b4662$export$fd3c71e3bfb4df9e = ()=>[
            $671f611e278b4662$var$findAppsRouteEntry,
            $671f611e278b4662$export$423a1c80bb2f8b9a,
            $671f611e278b4662$export$875d88a44b1ff74c
        ];
});
parcelRegister("4zecE", function(module, exports) {
    $parcel$export(module.exports, "findAppsRoute", ()=>$75d0c5179e224132$export$e264ef643451c60a);
    $parcel$export(module.exports, "appRequestRoute", ()=>$75d0c5179e224132$export$e5429b8cad3b4991);
    $parcel$export(module.exports, "promotionsRoute", ()=>$75d0c5179e224132$export$45df65bfacbf9a2a);
    var $65Ltd;
    const $75d0c5179e224132$export$e264ef643451c60a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_MARKETPLACE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_MARKETPLACE_INDEX),
        path: '/jira/marketplace'
    };
    const $75d0c5179e224132$export$e5429b8cad3b4991 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_MARKETPLACE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_MARKETPLACE_APP_REQUESTS),
        path: '/jira/marketplace/manage/app-requests'
    };
    const $75d0c5179e224132$export$45df65bfacbf9a2a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_MARKETPLACE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_MARKETPLACE_PROMOTIONS),
        path: '/jira/marketplace/manage/promotions'
    };
});
parcelRegister("azvSc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jfNVT")
    ]).then(()=>parcelRequire('lA7ML'));
});
parcelRegister("8J3oF", function(module, exports) {
    $parcel$export(module.exports, "nextGenRouteEntries", ()=>$1f4b902ae477a058$export$688b56fcbc2637ac);
    var $5uXOq = parcelRequire("5uXOq");
    var $e4eHl = parcelRequire("e4eHl");
    var $ebyGx = parcelRequire("ebyGx");
    var $ffza4;
    var $65Ltd;
    var $7XYc4;
    var $cSD7y;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $2GkDw;
    var $3RJkv;
    var $dxCvy;
    var $iZ82x;
    var $7GnDe;
    var $d04s2;
    var $5lsNZ;
    var $6cOYV;
    var $jxmtx;
    var $j2ARM;
    var $5iGg6;
    var $4r1Od;
    var $1BC32;
    var $atnoN;
    var $ewGRl;
    var $7X8vn;
    var $1CtwK;
    var $8gCKI;
    var $ebynk;
    var $dxMY7;
    var $hYD8Y;
    var $9B5P6;
    var $b3Ytp;
    var $a0ObZ;
    var $e8rgT;
    var $kfztd;
    var $5PD5h;
    var $e7bC3;
    var $dIdda = parcelRequire("dIdda");
    var $4GBKo;
    var $21yN6;
    var $kotYl;
    var $cD5C5;
    var $bekEk;
    var $c3kjm;
    var $9XjvH;
    var $5v1XH;
    var $g0ZNl;
    var $eSx59;
    var $kgB1V;
    var $fzG6k;
    const $1f4b902ae477a058$var$SoftwareNextgenRedirectComponent = ({ location: location })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: (0, (0, parcelRequire("21yN6")).pickNextGenView)(location)
        });
    const $1f4b902ae477a058$var$SoftwareTimelineLegacyRedirect = ({ query: query })=>{
        const { projectKey: projectKey, rapidView: rapidView, ...restQuery } = query;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: {
                pathname: `/jira/software/projects/${projectKey}/boards/${rapidView}/timeline`,
                hash: '',
                search: (0, ($parcel$interopDefault($ebyGx))).stringify(restQuery)
            }
        });
    };
    const $1f4b902ae477a058$export$688b56fcbc2637ac = [
        (0, (0, parcelRequire("5iGg6")).softwareBoardEmbedRouteEntry),
        (0, (0, parcelRequire("5iGg6")).softwareBoardRouteEntry),
        (0, (0, parcelRequire("j2ARM")).softwareBacklogEmbedRouteEntry),
        (0, (0, parcelRequire("j2ARM")).softwareBacklogRouteEntry),
        (0, (0, parcelRequire("atnoN")).softwareFormBuilderRouteEntry),
        (0, (0, parcelRequire("ewGRl")).softwareFormRouteEntry),
        (0, (0, parcelRequire("7X8vn")).softwareFormSubmitRouteEntry),
        (0, (0, parcelRequire("1CtwK")).softwareGoalsRouteEntry),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jxmtx")).softwareReportsBurnupRoute), ()=>({
                ufoName: 'software-reports.burnup-chart',
                component: (0, (0, parcelRequire("c3kjm")).default),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("4GBKo")).getTMPReportsCommonResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("c3kjm")).LazyNextGenBurnupReport)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jxmtx")).softwareReportsVelocityRoute), ()=>({
                ufoName: 'software-reports.velocity-report',
                component: (0, (0, parcelRequire("fzG6k")).default),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("4GBKo")).getTMPReportsCommonResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("fzG6k")).LazyNextGenVelocityReport)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jxmtx")).softwareReportsCumulativeRoute), ()=>({
                ufoName: 'software-reports.cumulative-flow-diagram',
                component: (0, (0, parcelRequire("5v1XH")).default),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("4GBKo")).getTMPReportsCommonResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("5v1XH")).LazyNextGenCumulativeReport)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jxmtx")).softwareReportsBurndownRoute), ()=>({
                ufoName: 'software-reports.burndown-chart',
                component: (0, (0, parcelRequire("bekEk")).default),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("4GBKo")).getTMPReportsCommonResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("bekEk")).LazyNextGenBurndownReport)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jxmtx")).softwareReportsCycleTimeRoute), ()=>({
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, (0, parcelRequire("g0ZNl")).CycleTimeReportNextGen)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("4GBKo")).getTMPReportsCommonResource)(),
                    (0, (0, parcelRequire("2GkDw")).devOpsProviderResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("g0ZNl")).LazyCycleTimeReport)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME),
                        packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME)),
                        teamName: 'fusion-solaris'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jxmtx")).softwareReportsDeploymentFrequencyRoute), ()=>({
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, (0, parcelRequire("eSx59")).DeploymentFrequencyReportNextGen)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("4GBKo")).getTMPReportsCommonResource)(),
                    (0, (0, parcelRequire("2GkDw")).devOpsProviderResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("eSx59")).LazyDeploymentFrequencyReport)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY),
                        packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY)),
                        teamName: 'fusion-solaris'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jxmtx")).softwareReportsControlRoute), ()=>({
                ufoName: 'software-reports.control-chart',
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jsw_enable_avp_control_chart', (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, (0, parcelRequire("9XjvH")).ControlPage)), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("4GBKo")).getTMPReportsCommonResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("9XjvH")).LazyNextGenControlReport)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL),
                        packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL)),
                        teamName: 'helios-reports'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jxmtx")).softwareReportsRoute), ()=>({
                component: (0, (0, parcelRequire("kgB1V")).default),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    ...(0, (0, parcelRequire("4GBKo")).getTMPReportsCommonResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("kgB1V")).LazyNextGenReportsOverview)
                ],
                ufoName: 'software-reports.overview'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jxmtx")).softwareNextgenRedirectRoute), ()=>({
                component: $1f4b902ae477a058$var$SoftwareNextgenRedirectComponent,
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                afterPaint: [
                    (0, (0, parcelRequire("d04s2")).LazyIssueApp)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("5iGg6")).LazyBoardPage)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jxmtx")).softwareCodeRoute), ()=>({
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, (0, parcelRequire("cD5C5")).CodePageNextGen)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutCode),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                    (0, (0, parcelRequire("iZ82x")).codePageResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("cD5C5")).LazyCode)
                ],
                ufoName: 'next-gen-code'
            })),
        (0, (0, parcelRequire("9B5P6")).softwareSecurityNextGenRouteEntry),
        (0, (0, parcelRequire("b3Ytp")).softwareSummaryRouteEntry),
        (0, (0, parcelRequire("1BC32")).softwareDeploymentsNextGenRouteEntry),
        (0, (0, parcelRequire("ebynk")).softwarePeriscopeNextGenRouteEntry),
        (0, (0, parcelRequire("e8rgT")).softwareVersionDetailEmbedRouteEntry),
        (0, (0, parcelRequire("e8rgT")).softwareVersionDetailRouteEntry),
        (0, (0, parcelRequire("e8rgT")).softwareVersionDetailNoTabPathRedirectRouteEntry),
        (0, (0, parcelRequire("e8rgT")).softwareVersionDetailLegacyRedirectRouteEntry),
        (0, (0, parcelRequire("dxMY7")).softwareRequestsRouteEntry),
        (0, (0, parcelRequire("dxMY7")).softwareRequestsClassicRouteEntry),
        (0, (0, parcelRequire("a0ObZ")).softwareTimelineRouteEntry),
        (0, (0, parcelRequire("hYD8Y")).softwareRoadmapRouteEntry),
        (0, (0, parcelRequire("4r1Od")).softwareCalendarEmbedRouteEntry),
        (0, (0, parcelRequire("4r1Od")).softwareCalendarRouteEntry),
        (0, (0, parcelRequire("8gCKI")).softwareListEmbedRouteEntry),
        (0, (0, parcelRequire("8gCKI")).softwareListRouteEntry),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jxmtx")).softwareRoadmapRedirectRoute), ()=>({
                component: $1f4b902ae477a058$var$SoftwareTimelineLegacyRedirect,
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                afterPaint: [
                    (0, (0, parcelRequire("d04s2")).LazyIssueApp)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("kotYl")).LazyNextGenRoadmap)
                ]
            })),
        (0, (0, parcelRequire("6cOYV")).softwareIncidentsNextGenRouteEntry)
    ];
});
parcelRegister("jxmtx", function(module, exports) {
    $parcel$export(module.exports, "softwareReportsBurnupRoute", ()=>$1126b5bd57f5ad9d$export$5b818a6914ca8376);
    $parcel$export(module.exports, "softwareReportsVelocityRoute", ()=>$1126b5bd57f5ad9d$export$cde83a6497756848);
    $parcel$export(module.exports, "softwareReportsCumulativeRoute", ()=>$1126b5bd57f5ad9d$export$3c48ddd40d00b0d2);
    $parcel$export(module.exports, "softwareReportsBurndownRoute", ()=>$1126b5bd57f5ad9d$export$e0d8c26cb1430ae4);
    $parcel$export(module.exports, "softwareReportsCycleTimeRoute", ()=>$1126b5bd57f5ad9d$export$c777bb8f2591081);
    $parcel$export(module.exports, "softwareReportsDeploymentFrequencyRoute", ()=>$1126b5bd57f5ad9d$export$bbf45ab0423b990);
    $parcel$export(module.exports, "softwareReportsControlRoute", ()=>$1126b5bd57f5ad9d$export$8c91815cd4b1c078);
    $parcel$export(module.exports, "softwareReportsRoute", ()=>$1126b5bd57f5ad9d$export$5bf75a5d8c554930);
    $parcel$export(module.exports, "softwareNextgenRedirectRoute", ()=>$1126b5bd57f5ad9d$export$6072946fe7f2d45a);
    $parcel$export(module.exports, "softwareCodeRoute", ()=>$1126b5bd57f5ad9d$export$9d24fc75b0f1d9a0);
    $parcel$export(module.exports, "softwareRoadmapRedirectRoute", ()=>$1126b5bd57f5ad9d$export$866215abd09c0f4d);
    var $65Ltd;
    const $1126b5bd57f5ad9d$export$5b818a6914ca8376 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_BURNUP),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burnup'
    };
    const $1126b5bd57f5ad9d$export$cde83a6497756848 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_VELOCITY),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports/velocity'
    };
    const $1126b5bd57f5ad9d$export$3c48ddd40d00b0d2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CUMULATIVE),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cumulative'
    };
    const $1126b5bd57f5ad9d$export$e0d8c26cb1430ae4 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_BURNDOWN),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports/burndown'
    };
    const $1126b5bd57f5ad9d$export$c777bb8f2591081 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CYCLE_TIME),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports/cycle-time'
    };
    const $1126b5bd57f5ad9d$export$bbf45ab0423b990 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_DEPLOYMENT_FREQUENCY),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports/deployment-frequency'
    };
    const $1126b5bd57f5ad9d$export$8c91815cd4b1c078 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS_CONTROL),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports/control'
    };
    const $1126b5bd57f5ad9d$export$5bf75a5d8c554930 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REPORTS),
        path: '/jira/software/projects/:projectKey/boards/:boardId/reports'
    };
    const $1126b5bd57f5ad9d$export$6072946fe7f2d45a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_NEXTGEN_REDIRECT),
        path: '/secure/NextGen.jspa'
    };
    const $1126b5bd57f5ad9d$export$9d24fc75b0f1d9a0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CODE),
        path: '/jira/software/projects/:projectKey/code'
    };
    const $1126b5bd57f5ad9d$export$866215abd09c0f4d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ROADMAP_REDIRECT),
        path: '/secure/Roadmap.jspa'
    };
});
parcelRegister("j2ARM", function(module, exports) {
    $parcel$export(module.exports, "softwareBacklogRouteEntry", ()=>$d6d069823c19bbe2$export$a5f8ba02d2755510);
    $parcel$export(module.exports, "softwareBacklogEmbedRouteEntry", ()=>$d6d069823c19bbe2$export$7cd14dee22609378);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $cSD7y;
    var $g5RGc;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $1XrjK;
    var $3RJkv;
    var $aN2bG;
    var $bAB30;
    var $9SRRO;
    var $dxCvy;
    var $7GnDe;
    var $2Ql51;
    var $d04s2;
    var $5lsNZ;
    var $hziQo;
    var $aJzGl;
    var $5PD5h;
    var $e7bC3;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $d3645;
    const $d6d069823c19bbe2$export$edb4b8cf67d7d767 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1vlac"))), {
        moduleId: "./src/packages/spa-apps/next-gen-backlog/src/index.tsx"
    });
    const $d6d069823c19bbe2$var$BacklogPage = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d6d069823c19bbe2$export$edb4b8cf67d7d767,
            pageId: `next-gen-backlog-${(0, (0, parcelRequire("d3645")).getBoardId)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    const $d6d069823c19bbe2$export$a5f8ba02d2755510 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hziQo")).softwareBacklogRoute), ()=>({
            component: $d6d069823c19bbe2$var$BacklogPage,
            skeleton: (0, (0, parcelRequire("aJzGl")).NextGenBacklogSkeleton),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).softwareProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                {
                    query: [
                        'selectedIssue'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("bAB30")).conditionalBacklogResource),
                (0, (0, parcelRequire("aN2bG")).conditionalBacklogRelayResource),
                (0, (0, parcelRequire("9SRRO")).customFiltersResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'software-backlog-early-entry'
                ]
            },
            afterPaint: [
                (0, (0, parcelRequire("d04s2")).LazyIssueApp)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $d6d069823c19bbe2$export$edb4b8cf67d7d767
            ],
            ufoName: 'next-gen-backlog',
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$c17f34c425972af1)
            }
        }));
    const $d6d069823c19bbe2$export$7cd14dee22609378 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("hziQo")).softwareBacklogEmbedRoute), ()=>({
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('enable_backlog_smartlink_route', $d6d069823c19bbe2$var$BacklogPage, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)({
                isChromeless: true
            }),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("bAB30")).conditionalBacklogResource),
                (0, (0, parcelRequire("aN2bG")).conditionalBacklogRelayResource),
                (0, (0, parcelRequire("9SRRO")).customFiltersResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            afterPaint: [
                (0, (0, parcelRequire("d04s2")).LazyIssueApp)
            ],
            forPaint: [
                $d6d069823c19bbe2$export$edb4b8cf67d7d767
            ],
            ufoName: 'next-gen-backlog-embed',
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$c17f34c425972af1)
            }
        }));
    var $d6d069823c19bbe2$export$2e2bcd8739ae039 = $d6d069823c19bbe2$var$BacklogPage;
});
parcelRegister("aN2bG", function(module, exports) {
    $parcel$export(module.exports, "backlogRelayResource", ()=>$41127204b5cff3a5$export$ad514b81f9e160d0);
    $parcel$export(module.exports, "conditionalBacklogRelayResource", ()=>$41127204b5cff3a5$export$4a013be7938fa775);
    var $co1wz;
    var $dXq4S;
    var $ao2h1;
    var $loNZB;
    var $gNStA;
    const $41127204b5cff3a5$export$ad514b81f9e160d0 = (0, (0, parcelRequire("gNStA")).browserOnlyResourceWithCondition)(()=>false, (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $fe839261f35d1611$export$463905a04a9a75ce),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("loNZB")).default),
                variables: {
                    boardId: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira-software',
                        cloudId: tenantContext.cloudId,
                        resourceType: 'board',
                        resourceId: String(match.params.boardId)
                    }),
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'store-or-network'
                }
            }),
        captureErrors: true
    }));
    const $41127204b5cff3a5$export$4a013be7938fa775 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('jsw.perf.critical-backlog-with-relay'), $41127204b5cff3a5$export$ad514b81f9e160d0);
});
parcelRegister("loNZB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$92280695afeb1d20$export$2e2bcd8739ae039);
    const $92280695afeb1d20$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "boardId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "boardId",
                "variableName": "boardId"
            }
        ], v2 = [
            {
                "kind": "Literal",
                "name": "state",
                "value": [
                    "ACTIVE",
                    "FUTURE"
                ]
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "id"
        }, v4 = {
            "kind": "ScalarField",
            "name": "name"
        }, v5 = {
            "kind": "ScalarField",
            "name": "goal"
        }, v6 = {
            "kind": "ScalarField",
            "name": "startDate"
        }, v7 = {
            "kind": "ScalarField",
            "name": "endDate"
        }, v8 = {
            "kind": "ScalarField",
            "name": "daysRemaining"
        }, v9 = {
            "kind": "ScalarField",
            "name": "key"
        }, v10 = {
            "kind": "ScalarField",
            "name": "summary"
        }, v11 = {
            "kind": "ScalarField",
            "name": "labels"
        }, v12 = {
            "kind": "ScalarField",
            "name": "iconUrl"
        }, v13 = {
            "kind": "ScalarField",
            "name": "category"
        }, v14 = {
            "kind": "ScalarField",
            "name": "accountId"
        }, v15 = {
            "kind": "ScalarField",
            "name": "picture"
        }, v16 = {
            "kind": "ScalarField",
            "name": "flagged"
        }, v17 = {
            "kind": "ScalarField",
            "name": "done"
        }, v18 = {
            "kind": "ScalarField",
            "name": "parentId"
        }, v19 = {
            "kind": "ScalarField",
            "name": "storyPoints"
        }, v20 = {
            "kind": "ScalarField",
            "name": "value"
        }, v21 = {
            "kind": "ScalarField",
            "name": "valueAsText"
        }, v22 = {
            "kind": "ScalarField",
            "name": "dueDate"
        }, v23 = {
            "kind": "ScalarField",
            "name": "complete"
        }, v24 = {
            "kind": "ScalarField",
            "name": "total"
        }, v25 = {
            "kind": "ScalarField",
            "name": "fixVersionsIds"
        }, v26 = {
            "kind": "ScalarField",
            "name": "sprintState"
        }, v27 = {
            "kind": "ScalarField",
            "name": "boardIssueListKey"
        }, v28 = {
            "kind": "ScalarField",
            "name": "requestColumnMigration"
        }, v29 = {
            "kind": "ScalarField",
            "name": "rankCustomFieldId"
        }, v30 = {
            "kind": "ScalarField",
            "name": "color"
        }, v31 = {
            "kind": "ScalarField",
            "name": "permissions"
        }, v32 = {
            "kind": "ScalarField",
            "name": "hierarchyLevelType"
        }, v33 = {
            "kind": "ScalarField",
            "name": "hasRequiredFields"
        }, v34 = {
            "kind": "ScalarField",
            "name": "status"
        }, v35 = {
            "concreteType": "CurrentEstimation",
            "kind": "LinkedField",
            "name": "current",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "customFieldId"
                }
            ]
        }, v36 = {
            "kind": "ScalarField",
            "name": "statisticFieldId"
        }, v37 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v38 = {
            "kind": "ScalarField",
            "name": "defaultUnit"
        }, v39 = {
            "kind": "ScalarField",
            "name": "workingDaysPerWeek"
        }, v40 = {
            "kind": "ScalarField",
            "name": "workingHoursPerDay"
        }, v41 = {
            "kind": "ScalarField",
            "name": "defaultFormat"
        }, v42 = [
            v3,
            v4,
            v12
        ], v43 = {
            "concreteType": "SoftwareCard",
            "kind": "LinkedField",
            "name": "cards",
            "plural": true,
            "selections": [
                v3,
                v9,
                v10,
                v11,
                {
                    "concreteType": "CardType",
                    "kind": "LinkedField",
                    "name": "type",
                    "plural": false,
                    "selections": v42
                },
                {
                    "concreteType": "CardStatus",
                    "kind": "LinkedField",
                    "name": "status",
                    "plural": false,
                    "selections": [
                        v3,
                        v4,
                        v13
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "assignee",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v14,
                        v4,
                        v15,
                        v3
                    ]
                },
                v16,
                v17,
                v18,
                {
                    "concreteType": "Estimate",
                    "kind": "LinkedField",
                    "name": "estimate",
                    "plural": false,
                    "selections": [
                        v19,
                        {
                            "concreteType": "OriginalEstimate",
                            "kind": "LinkedField",
                            "name": "originalEstimate",
                            "plural": false,
                            "selections": [
                                v20,
                                v21
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "CardPriority",
                    "kind": "LinkedField",
                    "name": "priority",
                    "plural": false,
                    "selections": [
                        v4,
                        v12
                    ]
                },
                v22,
                {
                    "concreteType": "ChildCardsMetadata",
                    "kind": "LinkedField",
                    "name": "childCardsMetadata",
                    "plural": false,
                    "selections": [
                        v23,
                        v24
                    ]
                },
                v25
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "aggBacklogDataQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": v1,
                            "concreteType": "BoardScope",
                            "kind": "LinkedField",
                            "name": "boardScope",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v2,
                                        "concreteType": "Sprint",
                                        "kind": "LinkedField",
                                        "name": "sprints",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v3,
                                                "action": "THROW",
                                                "path": "boardScope.sprints.id"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v4,
                                                "action": "THROW",
                                                "path": "boardScope.sprints.name"
                                            },
                                            v5,
                                            v6,
                                            v7,
                                            v8,
                                            {
                                                "concreteType": "SoftwareCard",
                                                "kind": "LinkedField",
                                                "name": "cards",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3,
                                                        "action": "THROW",
                                                        "path": "boardScope.sprints.cards.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9,
                                                        "action": "THROW",
                                                        "path": "boardScope.sprints.cards.key"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v10,
                                                        "action": "THROW",
                                                        "path": "boardScope.sprints.cards.summary"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v11,
                                                        "action": "THROW",
                                                        "path": "boardScope.sprints.cards.labels"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CardType",
                                                            "kind": "LinkedField",
                                                            "name": "type",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.sprints.cards.type.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.sprints.cards.type.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v12,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.sprints.cards.type.iconUrl"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.sprints.cards.type"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CardStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.sprints.cards.status.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.sprints.cards.status.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v13,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.sprints.cards.status.category"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.sprints.cards.status"
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "assignee",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v14,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.assignee.accountId"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.assignee.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v15,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.assignee.picture"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v16,
                                                        "action": "THROW",
                                                        "path": "boardScope.sprints.cards.flagged"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v17,
                                                        "action": "THROW",
                                                        "path": "boardScope.sprints.cards.done"
                                                    },
                                                    v18,
                                                    {
                                                        "concreteType": "Estimate",
                                                        "kind": "LinkedField",
                                                        "name": "estimate",
                                                        "plural": false,
                                                        "selections": [
                                                            v19,
                                                            {
                                                                "concreteType": "OriginalEstimate",
                                                                "kind": "LinkedField",
                                                                "name": "originalEstimate",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v20,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.sprints.cards.estimate.originalEstimate.value"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v21,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.sprints.cards.estimate.originalEstimate.valueAsText"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "CardPriority",
                                                        "kind": "LinkedField",
                                                        "name": "priority",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.priority.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v12,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.priority.iconUrl"
                                                            }
                                                        ]
                                                    },
                                                    v22,
                                                    {
                                                        "concreteType": "ChildCardsMetadata",
                                                        "kind": "LinkedField",
                                                        "name": "childCardsMetadata",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v23,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.childCardsMetadata.complete"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v24,
                                                                "action": "THROW",
                                                                "path": "boardScope.sprints.cards.childCardsMetadata.total"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v25,
                                                        "action": "THROW",
                                                        "path": "boardScope.sprints.cards.fixVersionsIds"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v26,
                                                "action": "THROW",
                                                "path": "boardScope.sprints.sprintState"
                                            }
                                        ],
                                        "storageKey": "sprints(state:[\"ACTIVE\",\"FUTURE\"])"
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.sprints"
                                },
                                {
                                    "concreteType": "Backlog",
                                    "kind": "LinkedField",
                                    "name": "backlog",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v27,
                                            "action": "THROW",
                                            "path": "boardScope.backlog.boardIssueListKey"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v28,
                                            "action": "THROW",
                                            "path": "boardScope.backlog.requestColumnMigration"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "SoftwareCard",
                                                "kind": "LinkedField",
                                                "name": "cards",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3,
                                                        "action": "THROW",
                                                        "path": "boardScope.backlog.cards.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9,
                                                        "action": "THROW",
                                                        "path": "boardScope.backlog.cards.key"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v10,
                                                        "action": "THROW",
                                                        "path": "boardScope.backlog.cards.summary"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v11,
                                                        "action": "THROW",
                                                        "path": "boardScope.backlog.cards.labels"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CardType",
                                                            "kind": "LinkedField",
                                                            "name": "type",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.backlog.cards.type.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.backlog.cards.type.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v12,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.backlog.cards.type.iconUrl"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.backlog.cards.type"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CardStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.backlog.cards.status.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.backlog.cards.status.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v13,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.backlog.cards.status.category"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.backlog.cards.status"
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "assignee",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v14,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.assignee.accountId"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.assignee.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v15,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.assignee.picture"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v16,
                                                        "action": "THROW",
                                                        "path": "boardScope.backlog.cards.flagged"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v17,
                                                        "action": "THROW",
                                                        "path": "boardScope.backlog.cards.done"
                                                    },
                                                    v18,
                                                    {
                                                        "concreteType": "Estimate",
                                                        "kind": "LinkedField",
                                                        "name": "estimate",
                                                        "plural": false,
                                                        "selections": [
                                                            v19,
                                                            {
                                                                "concreteType": "OriginalEstimate",
                                                                "kind": "LinkedField",
                                                                "name": "originalEstimate",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v20,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.backlog.cards.estimate.originalEstimate.value"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v21,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.backlog.cards.estimate.originalEstimate.valueAsText"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "CardPriority",
                                                        "kind": "LinkedField",
                                                        "name": "priority",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v4,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.priority.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v12,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.priority.iconUrl"
                                                            }
                                                        ]
                                                    },
                                                    v22,
                                                    {
                                                        "concreteType": "ChildCardsMetadata",
                                                        "kind": "LinkedField",
                                                        "name": "childCardsMetadata",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v23,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.childCardsMetadata.complete"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v24,
                                                                "action": "THROW",
                                                                "path": "boardScope.backlog.cards.childCardsMetadata.total"
                                                            }
                                                        ]
                                                    },
                                                    v25
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.backlog.cards"
                                        }
                                    ]
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "SoftwareBoard",
                                        "kind": "LinkedField",
                                        "name": "board",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "SoftwareCard",
                                                    "kind": "LinkedField",
                                                    "name": "cards",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v3,
                                                            "action": "THROW",
                                                            "path": "boardScope.board.cards.id"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v9,
                                                            "action": "THROW",
                                                            "path": "boardScope.board.cards.key"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v10,
                                                            "action": "THROW",
                                                            "path": "boardScope.board.cards.summary"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v11,
                                                            "action": "THROW",
                                                            "path": "boardScope.board.cards.labels"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "CardType",
                                                                "kind": "LinkedField",
                                                                "name": "type",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v3,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.board.cards.type.id"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v4,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.board.cards.type.name"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v12,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.board.cards.type.iconUrl"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "boardScope.board.cards.type"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "concreteType": "CardStatus",
                                                                "kind": "LinkedField",
                                                                "name": "status",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v3,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.board.cards.status.id"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v4,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.board.cards.status.name"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v13,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.board.cards.status.category"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "boardScope.board.cards.status"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "assignee",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v14,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.assignee.accountId"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.assignee.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v15,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.assignee.picture"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v16,
                                                            "action": "THROW",
                                                            "path": "boardScope.board.cards.flagged"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v17,
                                                            "action": "THROW",
                                                            "path": "boardScope.board.cards.done"
                                                        },
                                                        v18,
                                                        {
                                                            "concreteType": "Estimate",
                                                            "kind": "LinkedField",
                                                            "name": "estimate",
                                                            "plural": false,
                                                            "selections": [
                                                                v19,
                                                                {
                                                                    "concreteType": "OriginalEstimate",
                                                                    "kind": "LinkedField",
                                                                    "name": "originalEstimate",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v20,
                                                                            "action": "THROW",
                                                                            "path": "boardScope.board.cards.estimate.originalEstimate.value"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v21,
                                                                            "action": "THROW",
                                                                            "path": "boardScope.board.cards.estimate.originalEstimate.valueAsText"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "CardPriority",
                                                            "kind": "LinkedField",
                                                            "name": "priority",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v4,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.priority.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v12,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.priority.iconUrl"
                                                                }
                                                            ]
                                                        },
                                                        v22,
                                                        {
                                                            "concreteType": "ChildCardsMetadata",
                                                            "kind": "LinkedField",
                                                            "name": "childCardsMetadata",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v23,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.childCardsMetadata.complete"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v24,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cards.childCardsMetadata.total"
                                                                }
                                                            ]
                                                        },
                                                        v25
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "boardScope.board.cards"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v29,
                                                "action": "THROW",
                                                "path": "boardScope.board.rankCustomFieldId"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.board"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "CardParent",
                                        "kind": "LinkedField",
                                        "name": "cardParents",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v3,
                                                "action": "THROW",
                                                "path": "boardScope.cardParents.id"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v9,
                                                "action": "THROW",
                                                "path": "boardScope.cardParents.key"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v10,
                                                "action": "THROW",
                                                "path": "boardScope.cardParents.summary"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "CardType",
                                                    "kind": "LinkedField",
                                                    "name": "cardType",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v3,
                                                            "action": "THROW",
                                                            "path": "boardScope.cardParents.cardType.id"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v4,
                                                            "action": "THROW",
                                                            "path": "boardScope.cardParents.cardType.name"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v12,
                                                            "action": "THROW",
                                                            "path": "boardScope.cardParents.cardType.iconUrl"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "boardScope.cardParents.cardType"
                                            },
                                            v30
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.cardParents"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "CurrentUser",
                                        "kind": "LinkedField",
                                        "name": "currentUser",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v31,
                                                "action": "THROW",
                                                "path": "boardScope.currentUser.permissions"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.currentUser"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "SoftwareProject",
                                        "kind": "LinkedField",
                                        "name": "projectLocation",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v3,
                                                "action": "THROW",
                                                "path": "boardScope.projectLocation.id"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v9,
                                                "action": "THROW",
                                                "path": "boardScope.projectLocation.key"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v4,
                                                "action": "THROW",
                                                "path": "boardScope.projectLocation.name"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "CardType",
                                                    "kind": "LinkedField",
                                                    "name": "cardTypes",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v3,
                                                            "action": "THROW",
                                                            "path": "boardScope.projectLocation.cardTypes.id"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v4,
                                                            "action": "THROW",
                                                            "path": "boardScope.projectLocation.cardTypes.name"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v12,
                                                            "action": "THROW",
                                                            "path": "boardScope.projectLocation.cardTypes.iconUrl"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v32,
                                                            "action": "THROW",
                                                            "path": "boardScope.projectLocation.cardTypes.hierarchyLevelType"
                                                        },
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v33,
                                                            "action": "THROW",
                                                            "path": "boardScope.projectLocation.cardTypes.hasRequiredFields"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "boardScope.projectLocation.cardTypes"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.projectLocation"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "BoardFeature",
                                        "kind": "LinkedField",
                                        "name": "features",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v9,
                                                "action": "THROW",
                                                "path": "boardScope.features.key"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v34,
                                                "action": "THROW",
                                                "path": "boardScope.features.status"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.features"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "EstimationConfig",
                                        "kind": "LinkedField",
                                        "name": "estimation",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v35,
                                                "action": "THROW",
                                                "path": "boardScope.estimation.current"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "AvailableEstimations",
                                                    "kind": "LinkedField",
                                                    "name": "available",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": v36,
                                                            "action": "THROW",
                                                            "path": "boardScope.estimation.available.statisticFieldId"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "boardScope.estimation.available"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.estimation"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "boardScope"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v37,
                                        "concreteType": "JiraTimeTrackingSettings",
                                        "kind": "LinkedField",
                                        "name": "globalTimeTrackingSettings",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v38,
                                                "action": "THROW",
                                                "path": "jira.globalTimeTrackingSettings.defaultUnit"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v39,
                                                "action": "THROW",
                                                "path": "jira.globalTimeTrackingSettings.workingDaysPerWeek"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v40,
                                                "action": "THROW",
                                                "path": "jira.globalTimeTrackingSettings.workingHoursPerDay"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v41,
                                                "action": "THROW",
                                                "path": "jira.globalTimeTrackingSettings.defaultFormat"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.globalTimeTrackingSettings"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "aggBacklogDataQuery",
                "selections": [
                    {
                        "args": v1,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "Sprint",
                                "kind": "LinkedField",
                                "name": "sprints",
                                "plural": true,
                                "selections": [
                                    v3,
                                    v4,
                                    v5,
                                    v6,
                                    v7,
                                    v8,
                                    v43,
                                    v26
                                ],
                                "storageKey": "sprints(state:[\"ACTIVE\",\"FUTURE\"])"
                            },
                            {
                                "concreteType": "Backlog",
                                "kind": "LinkedField",
                                "name": "backlog",
                                "plural": false,
                                "selections": [
                                    v27,
                                    v28,
                                    v43
                                ]
                            },
                            {
                                "concreteType": "SoftwareBoard",
                                "kind": "LinkedField",
                                "name": "board",
                                "plural": false,
                                "selections": [
                                    v43,
                                    v29,
                                    v3
                                ]
                            },
                            {
                                "concreteType": "CardParent",
                                "kind": "LinkedField",
                                "name": "cardParents",
                                "plural": true,
                                "selections": [
                                    v3,
                                    v9,
                                    v10,
                                    {
                                        "concreteType": "CardType",
                                        "kind": "LinkedField",
                                        "name": "cardType",
                                        "plural": false,
                                        "selections": v42
                                    },
                                    v30
                                ]
                            },
                            {
                                "concreteType": "CurrentUser",
                                "kind": "LinkedField",
                                "name": "currentUser",
                                "plural": false,
                                "selections": [
                                    v31
                                ]
                            },
                            {
                                "concreteType": "SoftwareProject",
                                "kind": "LinkedField",
                                "name": "projectLocation",
                                "plural": false,
                                "selections": [
                                    v3,
                                    v9,
                                    v4,
                                    {
                                        "concreteType": "CardType",
                                        "kind": "LinkedField",
                                        "name": "cardTypes",
                                        "plural": true,
                                        "selections": [
                                            v3,
                                            v4,
                                            v12,
                                            v32,
                                            v33
                                        ]
                                    }
                                ]
                            },
                            {
                                "concreteType": "BoardFeature",
                                "kind": "LinkedField",
                                "name": "features",
                                "plural": true,
                                "selections": [
                                    v9,
                                    v34
                                ]
                            },
                            {
                                "concreteType": "EstimationConfig",
                                "kind": "LinkedField",
                                "name": "estimation",
                                "plural": false,
                                "selections": [
                                    v35,
                                    {
                                        "concreteType": "AvailableEstimations",
                                        "kind": "LinkedField",
                                        "name": "available",
                                        "plural": true,
                                        "selections": [
                                            v36
                                        ]
                                    }
                                ]
                            },
                            v3
                        ]
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v37,
                                "concreteType": "JiraTimeTrackingSettings",
                                "kind": "LinkedField",
                                "name": "globalTimeTrackingSettings",
                                "plural": false,
                                "selections": [
                                    v38,
                                    v39,
                                    v40,
                                    v41
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "f0265750b202c0ceda593f31130e4808462f54c3702123d91fff9c415016144e",
                "metadata": {},
                "name": "aggBacklogDataQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $92280695afeb1d20$var$node.hash = "5066bdc9703e345e9762320044e879c8";
    var $92280695afeb1d20$export$2e2bcd8739ae039 = $92280695afeb1d20$var$node;
});
const $fe839261f35d1611$export$faa68b3df5415bcb = 'NEXTGEN_BACKLOG_CUSTOM_FILTERS';
const $fe839261f35d1611$export$a0ef589381533a7c = 'NEXTGEN_BACKLOG';
const $fe839261f35d1611$export$463905a04a9a75ce = 'NEXTGEN_BACKLOG_RELAY';
parcelRegister("bAB30", function(module, exports) {
    $parcel$export(module.exports, "backlogResource", ()=>$d3029439c7d3b0b0$export$31d171ba71468137);
    $parcel$export(module.exports, "conditionalBacklogResource", ()=>$d3029439c7d3b0b0$export$c77659376558c168);
    var $co1wz;
    var $gNStA;
    var $dIdda = parcelRequire("dIdda");
    const $d3029439c7d3b0b0$export$31d171ba71468137 = (0, (0, parcelRequire("gNStA")).browserOnlyResourceWithCondition)(()=>false, (0, $dIdda.createResource)({
        type: (0, $fe839261f35d1611$export$a0ef589381533a7c),
        getKey: ({ match: match })=>match.params.boardId || '',
        getDataLoader: ()=>(parcelRequire("h0LF7")),
        maxAge: 3600000
    }));
    const $d3029439c7d3b0b0$export$c77659376558c168 = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!(0, (0, parcelRequire("co1wz")).ff)('jsw.perf.critical-backlog-with-relay'), $d3029439c7d3b0b0$export$31d171ba71468137);
});
parcelRegister("h0LF7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("k5lf7").then(()=>parcelRequire('lq5RB'));
});
parcelRegister("9SRRO", function(module, exports) {
    $parcel$export(module.exports, "customFiltersResource", ()=>$87093d7252240507$export$3e390340716755de);
    var $dXq4S;
    var $ao2h1;
    var $aYacW;
    var $gNStA;
    const $87093d7252240507$export$3e390340716755de = (0, (0, parcelRequire("gNStA")).browserOnlyResourceWithCondition)(()=>false, (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $fe839261f35d1611$export$faa68b3df5415bcb),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("aYacW")).default),
                variables: {
                    boardId: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira-software',
                        cloudId: tenantContext.cloudId,
                        resourceType: 'board',
                        resourceId: String(match.params.boardId)
                    })
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            }),
        captureErrors: true
    }));
});
parcelRegister("aYacW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16318ecaa49178e6$export$2e2bcd8739ae039);
    const $16318ecaa49178e6$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "boardId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "boardId",
                "variableName": "boardId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "viewBacklogCustomFiltersQuery",
                "selections": [
                    {
                        "args": v1,
                        "kind": "FragmentSpread",
                        "name": "customFilter_softwareFilters_CustomFilterRelay"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "viewBacklogCustomFiltersQuery",
                "selections": [
                    {
                        "args": v1,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "CustomFilter",
                                "kind": "LinkedField",
                                "name": "customFilters",
                                "plural": true,
                                "selections": [
                                    v2,
                                    {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    }
                                ]
                            },
                            v2
                        ]
                    }
                ]
            },
            "params": {
                "id": "494a9992c544e6be8f44d8b97ba70f29edc0d248b0153079b00cda817f4f7082",
                "metadata": {},
                "name": "viewBacklogCustomFiltersQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $16318ecaa49178e6$var$node.hash = "071c255f9696fe84a9c3982d42cfa5c0";
    var $16318ecaa49178e6$export$2e2bcd8739ae039 = $16318ecaa49178e6$var$node;
});
parcelRegister("hziQo", function(module, exports) {
    $parcel$export(module.exports, "softwareBacklogRoute", ()=>$4f240af7c8d4803a$export$fb454ec14936c0ab);
    $parcel$export(module.exports, "softwareBacklogEmbedRoute", ()=>$4f240af7c8d4803a$export$bc022a39c42aba2f);
    var $65Ltd;
    const $4f240af7c8d4803a$export$fb454ec14936c0ab = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BACKLOG),
        path: '/jira/software/projects/:projectKey/boards/:boardId/backlog'
    };
    const $4f240af7c8d4803a$export$bc022a39c42aba2f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BACKLOG_EMBED),
        path: '/jira/software/projects/:projectKey/boards/:boardId/backlog/embed',
        exact: true
    };
});
parcelRegister("d3645", function(module, exports) {
    $parcel$export(module.exports, "getBoardId", ()=>$8f60ec15db3f7d28$export$557c2f222778cea6);
    var $ebyGx = parcelRequire("ebyGx");
    const $8f60ec15db3f7d28$export$557c2f222778cea6 = ({ location: location, match: match })=>{
        if (match && match.params.boardId) return match.params.boardId;
        const { rapidView: rapidView } = (0, ($parcel$interopDefault($ebyGx))).parse(location.search);
        return rapidView;
    };
});
parcelRegister("5iGg6", function(module, exports) {
    $parcel$export(module.exports, "LazyBoardPage", ()=>$ccb682e3f2b95fd8$export$bd9ede4ec384f41d);
    $parcel$export(module.exports, "softwareBoardRouteEntry", ()=>$ccb682e3f2b95fd8$export$2964ea1cdd5afa39);
    $parcel$export(module.exports, "softwareBoardEmbedRouteEntry", ()=>$ccb682e3f2b95fd8$export$ff8632c8a0f5d984);
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $1WqFo;
    var $ffza4;
    var $co1wz;
    var $cSD7y;
    var $g5RGc;
    var $lmyls;
    var $koWFd;
    var $2G9Bk;
    var $1XrjK;
    var $5qQ9I;
    var $3RJkv;
    var $ipmBb;
    var $2Ql51;
    var $gNStA;
    var $d04s2;
    var $5lsNZ;
    var $2gnjX;
    var $6awMq;
    var $5PD5h;
    var $e7bC3;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $ccb682e3f2b95fd8$export$bd9ede4ec384f41d = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("evG1K"))), {
        moduleId: "./src/packages/spa-apps/next-gen-board/src/index.tsx"
    });
    const $ccb682e3f2b95fd8$var$getBoardId = ({ location: location, match: match })=>{
        if (match && match.params.boardId) return match.params.boardId;
        const { rapidView: rapidView } = (0, ($parcel$interopDefault($ebyGx))).parse(location.search);
        return rapidView;
    };
    const $ccb682e3f2b95fd8$export$78e6ebf73d7f732b = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ccb682e3f2b95fd8$export$bd9ede4ec384f41d,
            pageId: `next-gen-board-${$ccb682e3f2b95fd8$var$getBoardId({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    const $ccb682e3f2b95fd8$var$conditionalBoardResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition)(()=>!(0, (0, parcelRequire("co1wz")).ff)('jsw.perf.critical-board-with-relay'), (0, (0, parcelRequire("5qQ9I")).boardResource));
    const $ccb682e3f2b95fd8$var$conditionalBoardRelayResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition)(()=>(0, (0, parcelRequire("co1wz")).ff)('jsw.perf.critical-board-with-relay'), (0, (0, parcelRequire("5qQ9I")).boardRelayResource));
    const $ccb682e3f2b95fd8$var$conditionalBoardNBTOptInResource = (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!(0, (0, parcelRequire("1WqFo")).isFedRamp)(), (0, (0, parcelRequire("ipmBb")).nextBestTaskFeatureResource));
    const $ccb682e3f2b95fd8$export$2964ea1cdd5afa39 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2gnjX")).softwareBoardRoute), ()=>({
            component: $ccb682e3f2b95fd8$export$78e6ebf73d7f732b,
            skeleton: (0, (0, parcelRequire("6awMq")).NextGenBoardSkeleton),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).softwareProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                {
                    query: [
                        'selectedIssue'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectResource)(),
                $ccb682e3f2b95fd8$var$conditionalBoardResource,
                (0, (0, parcelRequire("5qQ9I")).customFiltersResource),
                $ccb682e3f2b95fd8$var$conditionalBoardRelayResource,
                $ccb682e3f2b95fd8$var$conditionalBoardNBTOptInResource
            ],
            preloadOptions: {
                earlyChunks: [
                    'software-board-early-entry'
                ]
            },
            afterPaint: [
                (0, (0, parcelRequire("d04s2")).LazyIssueApp)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $ccb682e3f2b95fd8$export$bd9ede4ec384f41d
            ],
            ufoName: 'next-gen-board',
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$f364828958cffad0)
            }
        }));
    const $ccb682e3f2b95fd8$export$ff8632c8a0f5d984 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2gnjX")).softwareBoardEmbedRoute), ()=>({
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jira_board_smartlink_embed', $ccb682e3f2b95fd8$export$78e6ebf73d7f732b, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)({
                isChromeless: true
            }),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectResource)(),
                $ccb682e3f2b95fd8$var$conditionalBoardNBTOptInResource,
                $ccb682e3f2b95fd8$var$conditionalBoardResource,
                $ccb682e3f2b95fd8$var$conditionalBoardRelayResource,
                (0, (0, parcelRequire("5qQ9I")).customFiltersResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            afterPaint: [
                (0, (0, parcelRequire("d04s2")).LazyIssueApp)
            ],
            forPaint: [
                $ccb682e3f2b95fd8$export$bd9ede4ec384f41d
            ],
            ufoName: 'next-gen-board-embed',
            meta: {
                capability: (0, $281cbd47ba46dd7d$export$f364828958cffad0)
            }
        }));
});
parcelRegister("5qQ9I", function(module, exports) {
    $parcel$export(module.exports, "boardResource", ()=>$21d99b29ea940c83$export$286b76e0f2661cfb);
    $parcel$export(module.exports, "customFiltersResource", ()=>$21d99b29ea940c83$export$3e390340716755de);
    $parcel$export(module.exports, "boardRelayResource", ()=>$21d99b29ea940c83$export$81ac23db76b1f935);
    var $dXq4S;
    var $ao2h1;
    var $6mTNg;
    var $9fgCw;
    var $gNStA;
    var $dIdda = parcelRequire("dIdda");
    const $21d99b29ea940c83$export$286b76e0f2661cfb = (0, (0, parcelRequire("gNStA")).browserOnlyResourceWithCondition)(()=>false, (0, $dIdda.createResource)({
        type: (0, $a00fc8fb83f2948a$export$a38ac7339e3f31db),
        getKey: ({ match: match })=>match.params.boardId || '',
        getDataLoader: ()=>(parcelRequire("4WcEM")),
        maxAge: 3600000
    }));
    const $21d99b29ea940c83$export$3e390340716755de = (0, (0, parcelRequire("gNStA")).browserOnlyResourceWithCondition)(()=>false, (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $a00fc8fb83f2948a$export$b48bcc76a0105016),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("9fgCw")).default),
                variables: {
                    boardId: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira-software',
                        cloudId: tenantContext.cloudId,
                        resourceType: 'board',
                        resourceId: String(match.params.boardId)
                    })
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    }));
    const $21d99b29ea940c83$export$81ac23db76b1f935 = (0, (0, parcelRequire("gNStA")).browserOnlyResourceWithCondition)(()=>false, (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $a00fc8fb83f2948a$export$5cef388780439aec),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("6mTNg")).default),
                variables: {
                    boardId: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira-software',
                        cloudId: tenantContext.cloudId,
                        resourceType: 'board',
                        resourceId: String(match.params.boardId)
                    })
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    }));
});
parcelRegister("6mTNg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ddc6b6eeb5cc2255$export$2e2bcd8739ae039);
    const $ddc6b6eeb5cc2255$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67",
            "metadata": {},
            "name": "boardWithRouterRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $ddc6b6eeb5cc2255$export$2e2bcd8739ae039 = $ddc6b6eeb5cc2255$var$node;
});
parcelRegister("9fgCw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59a4f75157ae0306$export$2e2bcd8739ae039);
    const $59a4f75157ae0306$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b",
            "metadata": {},
            "name": "viewBoardCustomFiltersQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $59a4f75157ae0306$export$2e2bcd8739ae039 = $59a4f75157ae0306$var$node;
});
const $a00fc8fb83f2948a$export$a38ac7339e3f31db = 'NEXTGEN_BOARD';
const $a00fc8fb83f2948a$export$b48bcc76a0105016 = 'NEXTGEN_BOARD_CUSTOM_FILTERS';
const $a00fc8fb83f2948a$export$5cef388780439aec = 'NEXTGEN_BOARD_RELAY';
parcelRegister("4WcEM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jxTcV").then(()=>parcelRequire('11pNz'));
});
parcelRegister("2gnjX", function(module, exports) {
    $parcel$export(module.exports, "softwareBoardRoute", ()=>$3dfae82cef4e3065$export$9ae2c0a566d4e0f6);
    $parcel$export(module.exports, "softwareBoardEmbedRoute", ()=>$3dfae82cef4e3065$export$f55626b64e3fcb4f);
    var $65Ltd;
    const $3dfae82cef4e3065$export$9ae2c0a566d4e0f6 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BOARDS),
        exact: true,
        path: '/jira/software/projects/:projectKey/boards/:boardId'
    };
    const $3dfae82cef4e3065$export$f55626b64e3fcb4f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BOARDS_EMBED),
        exact: true,
        path: '/jira/software/projects/:projectKey/boards/:boardId/embed'
    };
});
parcelRegister("6awMq", function(module, exports) {
    $parcel$export(module.exports, "NextGenBoardSkeleton", ()=>$65aec8795a513038$export$25a9d0fbcb127c90);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $d69qo = parcelRequire("d69qo");
    const $65aec8795a513038$var$customCssStyles = null;
    const $65aec8795a513038$export$25a9d0fbcb127c90 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($d69qo))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2zz1idpf"
            ])
        });
});
parcelRegister("d69qo", function(module, exports) {
    module.exports = new URL("next-gen-board-app-skeleton.tpl.d10f8ca5.svg", import.meta.url).toString();
});
parcelRegister("4r1Od", function(module, exports) {
    $parcel$export(module.exports, "softwareCalendarEmbedRouteEntry", ()=>$2abc171a2b01be16$export$24fc07c22f0d06);
    $parcel$export(module.exports, "softwareCalendarRouteEntry", ()=>$2abc171a2b01be16$export$83b1b9036cc7961a);
    var $ffza4;
    var $6e4Kt;
    var $lkFvK;
    var $g5RGc;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $1XrjK;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $2Ql51;
    var $d04s2;
    var $8k0oT;
    var $is7uC;
    var $5PD5h;
    var $e7bC3;
    var $dQ4vn;
    const $2abc171a2b01be16$export$24fc07c22f0d06 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8k0oT")).softwareCalendarEmbedRoute), ()=>({
            skeleton: (0, (0, parcelRequire("is7uC")).CalendarEmbedSkeleton),
            component: (0, (0, parcelRequire("is7uC")).CalendarEmbedSkeleton),
            entryPoint () {
                if (false) return undefined;
                return $2abc171a2b01be16$export$d154630e8966be91;
            },
            layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
            resources: [
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
            ],
            ufoName: 'next-gen-calendar-embed'
        }));
    const $2abc171a2b01be16$export$d154630e8966be91 = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("dQ4vn")).calendarEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $2abc171a2b01be16$export$83b1b9036cc7961a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8k0oT")).softwareCalendarRoute), ()=>({
            skeleton: (0, (0, parcelRequire("is7uC")).CalendarSkeleton),
            component: (0, (0, parcelRequire("is7uC")).CalendarSkeleton),
            entryPoint () {
                if (false) return undefined;
                return $2abc171a2b01be16$export$d154630e8966be91;
            },
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).softwareProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                {
                    query: [
                        'selectedIssue'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
            ],
            afterPaint: [
                (0, (0, parcelRequire("d04s2")).LazyIssueApp)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ],
            ufoName: 'next-gen-calendar'
        }));
});
parcelRegister("8k0oT", function(module, exports) {
    $parcel$export(module.exports, "softwareCalendarRoute", ()=>$c4f64c4eb4de5dcd$export$d6730f103a4ad844);
    $parcel$export(module.exports, "softwareCalendarEmbedRoute", ()=>$c4f64c4eb4de5dcd$export$b55c4d4efb097c1c);
    var $65Ltd;
    const $c4f64c4eb4de5dcd$export$d6730f103a4ad844 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR),
        path: '/jira/software/projects/:projectKey/boards/:boardId/calendar',
        queries: [
            'date?'
        ]
    };
    const $c4f64c4eb4de5dcd$export$b55c4d4efb097c1c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR_EMBED),
        path: '/jira/software/projects/:projectKey/boards/:boardId/calendar/embed',
        queries: [
            'date?'
        ]
    };
});
parcelRegister("atnoN", function(module, exports) {
    $parcel$export(module.exports, "softwareFormBuilderRouteEntry", ()=>$c07fcdd97b2971f3$export$e8dede7671fad23d);
    var $ffza4;
    var $6s1PB;
    var $7XYc4;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $3HwlS;
    var $koWFd;
    var $2G9Bk;
    var $l2N2a;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5lsNZ;
    var $gLylS;
    var $6UGN7;
    var $5PD5h;
    var $e7bC3;
    var $bmpFr;
    const $c07fcdd97b2971f3$export$e8dede7671fad23d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("gLylS")).softwareFormBuilderRoute), ()=>({
            ufoName: 'next-gen-form-builder',
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expVal)('forms_for_jsw_experiment', 'isEnabled', false), (0, (0, parcelRequire("bmpFr")).FormBuilderPage), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav), ()=>null)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("l2N2a")).projectDetailsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("bmpFr")).LazyFormBuilderView)
            ],
            afterPaint: [
                (0, (0, parcelRequire("6UGN7")).LazyFormSubmitView)
            ]
        }));
});
parcelRegister("gLylS", function(module, exports) {
    $parcel$export(module.exports, "softwareFormBuilderRoute", ()=>$eae3d589575bf64f$export$c5589046ee2a390d);
    var $65Ltd;
    const $eae3d589575bf64f$export$c5589046ee2a390d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_BUILDER),
        path: '/jira/software/projects/:projectKey/form/:formId/builder',
        exact: true
    };
});
parcelRegister("ewGRl", function(module, exports) {
    $parcel$export(module.exports, "softwareFormRouteEntry", ()=>$17db4816c5775fc6$export$563e3b39911993a0);
    var $ffza4;
    var $6s1PB;
    var $7XYc4;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $3HwlS;
    var $koWFd;
    var $2G9Bk;
    var $l2N2a;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5lsNZ;
    var $bmpFr;
    var $kQa77;
    var $5PD5h;
    var $e7bC3;
    var $6Nh7k;
    const $17db4816c5775fc6$export$563e3b39911993a0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kQa77")).softwareFormRoute), ()=>({
            ufoName: 'next-gen-form',
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expVal)('forms_for_jsw_experiment', 'isEnabled', false), (0, (0, parcelRequire("6Nh7k")).FormPage), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav), ()=>null),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("l2N2a")).projectDetailsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("6Nh7k")).LazyFormView)
            ],
            afterPaint: [
                (0, (0, parcelRequire("bmpFr")).LazyFormBuilderView)
            ]
        }));
});
parcelRegister("kQa77", function(module, exports) {
    $parcel$export(module.exports, "softwareFormRoute", ()=>$8a4fe24690c451f7$export$a46217d369231a5);
    var $65Ltd;
    const $8a4fe24690c451f7$export$a46217d369231a5 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM),
        path: '/jira/software/projects/:projectKey/form',
        exact: true
    };
});
parcelRegister("7X8vn", function(module, exports) {
    $parcel$export(module.exports, "softwareFormSubmitRouteEntry", ()=>$3e2bc0f3ee8b3d3b$export$752724866670c36);
    var $ffza4;
    var $6e4Kt;
    var $6s1PB;
    var $7XYc4;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $2G9Bk;
    var $l2N2a;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5lsNZ;
    var $apwDT;
    var $6UGN7;
    const $3e2bc0f3ee8b3d3b$export$752724866670c36 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("apwDT")).softwareFormSubmitRoute), ()=>({
            ufoName: 'next-gen-form-submit',
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expVal)('forms_for_jsw_experiment', 'isEnabled', false), (0, (0, parcelRequire("6UGN7")).FormSubmitPage), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("l2N2a")).projectDetailsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("6UGN7")).LazyFormSubmitView)
            ]
        }));
});
parcelRegister("apwDT", function(module, exports) {
    $parcel$export(module.exports, "softwareFormSubmitRoute", ()=>$aa997c99ae3f3555$export$75b28ee1c7f02f00);
    var $65Ltd;
    const $aa997c99ae3f3555$export$75b28ee1c7f02f00 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_FORM_SUBMIT),
        path: '/jira/software/projects/:projectKey/form/:formId',
        exact: true
    };
});
parcelRegister("1CtwK", function(module, exports) {
    $parcel$export(module.exports, "softwareGoalsRouteEntry", ()=>$b91813a6c321b4f0$export$d3fcc412edfa2068);
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $9JQsR;
    var $5PD5h;
    var $x6sAR;
    const $b91813a6c321b4f0$export$d3fcc412edfa2068 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9JQsR")).softwareGoalsRoute), ()=>({
            component: (0, (0, parcelRequire("x6sAR")).default),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
            ]
        }));
});
parcelRegister("9JQsR", function(module, exports) {
    $parcel$export(module.exports, "softwareGoalsRoute", ()=>$bef6f7dee26f8872$export$2328fed7ebee3cce);
    var $65Ltd;
    const $bef6f7dee26f8872$export$2328fed7ebee3cce = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_GOALS),
        exact: true,
        path: '/jira/software/projects/:projectKey/goals'
    };
});
parcelRegister("x6sAR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f4f250cf13a0bcf2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $f4f250cf13a0bcf2$export$69b07a7049b7beab = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6Aupt"))), {
        moduleId: "./src/packages/spa-apps/goals/src/index.tsx"
    });
    var $f4f250cf13a0bcf2$export$2e2bcd8739ae039 = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f4f250cf13a0bcf2$export$69b07a7049b7beab,
            pageId: `atlas-goals-${match.params.boardId || ''}`,
            shouldShowSpinner: false
        });
});
parcelRegister("8gCKI", function(module, exports) {
    $parcel$export(module.exports, "softwareListRouteEntry", ()=>$8c2860a002a4fb1b$export$f30a66efa682bf2d);
    $parcel$export(module.exports, "softwareListEmbedRouteEntry", ()=>$8c2860a002a4fb1b$export$1099e0e49394fa9a);
    var $ffza4;
    var $6e4Kt;
    var $lkFvK;
    var $6s1PB;
    var $7XYc4;
    var $g5RGc;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $1XrjK;
    var $dAmbh;
    var $g4ZHz;
    var $iNzEe;
    var $l2N2a;
    var $3RJkv;
    var $dxCvy;
    var $aFVvc;
    var $7GnDe;
    var $d04s2;
    var $5lsNZ;
    var $1ISGN;
    var $cTHJk;
    var $5PD5h;
    var $e7bC3;
    var $3FuB0;
    var $dDP0o;
    const $8c2860a002a4fb1b$var$getListProjectResources = ()=>[
            (0, (0, parcelRequire("aFVvc")).projectCreatePermissionsResource),
            (0, (0, parcelRequire("iNzEe")).navigationResource),
            (0, (0, parcelRequire("l2N2a")).projectDetailsResource),
            (0, (0, parcelRequire("dAmbh")).configurationResource),
            (0, (0, parcelRequire("g4ZHz")).fieldsResource)
        ];
    const $8c2860a002a4fb1b$export$4425668b2cd90292 = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("3FuB0")).listEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8c2860a002a4fb1b$export$f30a66efa682bf2d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1ISGN")).softwareListRoute), ()=>({
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('jsw_list_view', 'cohort', 'variation'), (0, (0, parcelRequire("dDP0o")).SoftwareListPage), (0, (0, parcelRequire("5lsNZ")).default)),
            skeleton: (0, (0, parcelRequire("cTHJk")).ListSkeleton),
            entryPoint () {
                return (0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? $8c2860a002a4fb1b$export$4425668b2cd90292 : undefined;
            },
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).softwareProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                {
                    query: [
                        'selectedIssue'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                ...$8c2860a002a4fb1b$var$getListProjectResources()
            ],
            afterPaint: [
                (0, (0, parcelRequire("d04s2")).LazyIssueApp)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("dDP0o")).LazyNextGenList)
            ],
            ufoName: 'next-gen-list'
        }));
    const $8c2860a002a4fb1b$export$1099e0e49394fa9a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1ISGN")).softwareListEmbedRoute), ()=>({
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('jsw_list_view', 'cohort', 'variation'), (0, (0, parcelRequire("dDP0o")).SoftwareListEmbedPage), (0, (0, parcelRequire("5lsNZ")).default)),
            skeleton: (0, (0, parcelRequire("cTHJk")).ListEmbedSkeleton),
            entryPoint () {
                return (0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation') ? $8c2860a002a4fb1b$export$4425668b2cd90292 : undefined;
            },
            layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$8c2860a002a4fb1b$var$getListProjectResources()
            ],
            forPaint: [
                (0, (0, parcelRequire("dDP0o")).LazyNextGenListEmbed)
            ],
            ufoName: 'next-gen-list-embed'
        }));
});
parcelRegister("1ISGN", function(module, exports) {
    $parcel$export(module.exports, "softwareListRoute", ()=>$8179d3d41cbbed07$export$f3a5b1b732315e13);
    $parcel$export(module.exports, "softwareListEmbedRoute", ()=>$8179d3d41cbbed07$export$70dd8df584442004);
    var $65Ltd;
    const $8179d3d41cbbed07$export$f3a5b1b732315e13 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST),
        path: '/jira/software/projects/:projectKey/list'
    };
    const $8179d3d41cbbed07$export$70dd8df584442004 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST_EMBED),
        path: '/jira/software/projects/:projectKey/list/embed'
    };
});
parcelRegister("dDP0o", function(module, exports) {
    $parcel$export(module.exports, "LazyNextGenList", ()=>$435c36ebe30f5714$export$26b97a235767fc3c);
    $parcel$export(module.exports, "LazyNextGenListEmbed", ()=>$435c36ebe30f5714$export$8c61f5f5c58f351f);
    $parcel$export(module.exports, "SoftwareListPage", ()=>$435c36ebe30f5714$export$422a3a028ae77ad3);
    $parcel$export(module.exports, "SoftwareListEmbedPage", ()=>$435c36ebe30f5714$export$4a0539d19a2e2694);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $435c36ebe30f5714$export$26b97a235767fc3c = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5AKg6"))), {
        moduleId: "./src/packages/spa-apps/business/jsw-list/src/index.tsx"
    });
    const $435c36ebe30f5714$export$8c61f5f5c58f351f = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5lA3L"))), {
        moduleId: "./src/packages/spa-apps/business/jsw-list-embed/src/index.tsx"
    });
    const $435c36ebe30f5714$export$422a3a028ae77ad3 = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $435c36ebe30f5714$export$26b97a235767fc3c,
            pageId: `next-gen-list-${match.params.boardId || ''}`,
            shouldShowSpinner: false
        });
    const $435c36ebe30f5714$export$4a0539d19a2e2694 = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $435c36ebe30f5714$export$8c61f5f5c58f351f,
            pageId: `next-gen-list-${match.params.boardId || ''}-embed`,
            shouldShowSpinner: false
        });
});
parcelRegister("dxMY7", function(module, exports) {
    $parcel$export(module.exports, "softwareRequestsRouteEntry", ()=>$494b6205f04c7d39$export$fe880b76c2e8d7cf);
    $parcel$export(module.exports, "softwareRequestsClassicRouteEntry", ()=>$494b6205f04c7d39$export$db399ba51c2e38a6);
    var $ffza4;
    var $co1wz;
    var $7XYc4;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $1b36n;
    var $a3OKn;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $9s3j1;
    var $2G9Bk;
    var $1XrjK;
    var $lNicp;
    var $bATyw;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $ifLyg;
    var $gNStA;
    var $d04s2;
    var $5lsNZ;
    var $fe326;
    var $lHYIV;
    var $5PD5h;
    var $e7bC3;
    var $3mhLI;
    const $494b6205f04c7d39$var$isRequestsTabEnabled = ()=>{
        const requestTabFFValue = (0, (0, parcelRequire("co1wz")).getMultivariateFeatureFlag)('growth.discovery-of-jsm-requests-tab.experiment', 'control', [
            'sticky',
            'not-enrolled-sticky',
            'non-sticky',
            'not-enrolled-non-sticky',
            'control',
            'not-enrolled'
        ]);
        return requestTabFFValue === 'sticky' || requestTabFFValue === 'non-sticky';
    };
    const $494b6205f04c7d39$var$getCommonProjectResources = ()=>[
            (0, (0, parcelRequire("ifLyg")).issueNavigatorRelayResource),
            (0, (0, parcelRequire("ifLyg")).issueNavigatorFilterRelayResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8'), (0, (0, parcelRequire("a3OKn")).sidebarProjectIssuesResource)),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8'), (0, (0, parcelRequire("bATyw")).isNinGlobalScopeEnrolmentEnabledResource)),
            (0, (0, parcelRequire("1b36n")).staticSidebarDefaultPINFiltersResource)
        ];
    const $494b6205f04c7d39$var$getCommonProject = ()=>({
            apdexIgnoreParams: [
                'issueKey'
            ],
            skeleton: (0, (0, parcelRequire("lHYIV")).ProjectIssueNavigatorSkeleton),
            resources: [
                ...$494b6205f04c7d39$var$getCommonProjectResources()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("3mhLI")).LazyRequests)
            ],
            afterPaint: [
                (0, (0, parcelRequire("d04s2")).LazyIssueApp)
            ]
        });
    const $494b6205f04c7d39$export$fe880b76c2e8d7cf = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fe326")).softwareRequestsRoute), ()=>({
            ...$494b6205f04c7d39$var$getCommonProject(),
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)($494b6205f04c7d39$var$isRequestsTabEnabled, (0, (0, parcelRequire("3mhLI")).LazyNextGenRequestsPage), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).softwareProjectLayout)),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            ufoName: 'next-gen-requests'
        }));
    const $494b6205f04c7d39$export$db399ba51c2e38a6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fe326")).softwareRequestsClassicRoute), ()=>({
            ...$494b6205f04c7d39$var$getCommonProject(),
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)($494b6205f04c7d39$var$isRequestsTabEnabled, (0, (0, parcelRequire("3mhLI")).LazyClassicRequestsPage), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).softwareProjectLayout)),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("9s3j1")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            ufoName: 'classic-requests'
        }));
});
parcelRegister("ifLyg", function(module, exports) {
    $parcel$export(module.exports, "issueNavigatorRelayResource", ()=>$4dcf5ef0b4493f61$export$b4096f516fb93159);
    $parcel$export(module.exports, "issueNavigatorFilterRelayResource", ()=>$4dcf5ef0b4493f61$export$44ca3a0b25f38d83);
    var $8Uumt = parcelRequire("8Uumt");
    var $9Nvh7;
    var $6UAdF;
    var $dXq4S;
    var $5yJb9;
    var $kipqU;
    var $ao2h1;
    var $kvekU;
    var $hTvlq;
    var $dIdda = parcelRequire("dIdda");
    var $eqdHS;
    var $bS4S3;
    const $4dcf5ef0b4493f61$var$RESOURCE_TYPE_REQUEST_TAB_ISSUE_NAVIGATOR_FILTER_RELAY = 'REQUEST_TAB_ISSUE_NAVIGATOR_FILTER_RELAY';
    const $4dcf5ef0b4493f61$var$RESOURCE_TYPE_REQUEST_TAB_ISSUE_NAVIGATOR_RELAY = 'REQUEST_TAB_ISSUE_NAVIGATOR_RELAY';
    const $4dcf5ef0b4493f61$export$b4096f516fb93159 = (0, $dIdda.createResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${$4dcf5ef0b4493f61$var$RESOURCE_TYPE_REQUEST_TAB_ISSUE_NAVIGATOR_RELAY}`,
        getKey: ()=>'request-tab-issue-navigator-relay',
        getData: async (routerContext, { tenantContext: tenantContext })=>{
            if (false && tenantContext.isAnonymous) return null;
            let projectKey = '';
            try {
                const response = await (0, (0, parcelRequire("bS4S3")).getLatestJSMProjectRequest)();
                projectKey = response?.values?.[0]?.key;
            } catch (error) {
                console.log(error);
            }
            const { issueKey: issueKey, jql: jqlParam, defaultJql: defaultJql, filter: filter } = (0, (0, parcelRequire("eqdHS")).getParams)(routerContext, projectKey);
            const jqlOrFilterId = (0, (0, parcelRequire("eqdHS")).getJqlOrFilterId)(projectKey, defaultJql, jqlParam, filter);
            const maxIssuesPerPage = (0, (0, parcelRequire("6UAdF")).getMaxIssuesPerPage)();
            const variables = {
                cloudId: tenantContext.cloudId,
                first: issueKey == null ? maxIssuesPerPage : null,
                issueSearchInput: jqlOrFilterId,
                namespace: (0, (0, parcelRequire("6UAdF")).ISSUE_SEARCH_NAMESPACE),
                after: null,
                options: {
                    issueKey: issueKey
                },
                fieldSetIds: [],
                shouldQueryFieldSetsById: false,
                viewId: (0, (0, parcelRequire("6UAdF")).LIST_VIEW_ID),
                amountOfColumns: (0, (0, parcelRequire("6UAdF")).MAX_AMOUNT_OF_COLUMNS),
                atlassianIntelligenceProductFeature: (0, (0, parcelRequire("6UAdF")).NATURAL_LANGUAGE_TO_JQL)
            };
            const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("hTvlq")).default), variables, {
                fetchPolicy: 'network-only',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            });
            if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            return queryReference;
        },
        maxAge: 0
    });
    const $4dcf5ef0b4493f61$export$44ca3a0b25f38d83 = (0, $dIdda.createResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${$4dcf5ef0b4493f61$var$RESOURCE_TYPE_REQUEST_TAB_ISSUE_NAVIGATOR_FILTER_RELAY}`,
        getKey: ()=>'request-tab-issue-navigator-filter-relay',
        getData: async (routerContext, { tenantContext: tenantContext })=>{
            if (false && tenantContext.isAnonymous) return null;
            let projectKey = '';
            try {
                const response = await (0, (0, parcelRequire("bS4S3")).getLatestJSMProjectRequest)();
                projectKey = response?.values?.[0]?.key;
            } catch (error) {
                console.log(error);
            }
            const { filter: filter } = (0, (0, parcelRequire("eqdHS")).getParams)(routerContext, projectKey);
            const includeFilter = Boolean(filter) && (0, (0, parcelRequire("9Nvh7")).isFilterId)(filter);
            const variables = {
                includeFilter: includeFilter,
                filterAri: includeFilter ? (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'filter',
                    resourceId: filter,
                    activationId: tenantContext.activationId
                }) : ''
            };
            const options = {
                fetchPolicy: includeFilter ? 'network-only' : 'store-only'
            };
            const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("kvekU")).default), variables, options);
            if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            return queryReference;
        },
        maxAge: 0
    });
});
parcelRegister("eqdHS", function(module, exports) {
    $parcel$export(module.exports, "getParams", ()=>$f6e98a15759e1b83$export$ec161d740909e39d);
    $parcel$export(module.exports, "getJqlOrFilterId", ()=>$f6e98a15759e1b83$export$b968a035fc2aa57b);
    var $9Nvh7;
    var $g5X3G;
    var $8zzKy;
    const $f6e98a15759e1b83$export$ec161d740909e39d = ({ match: { params: params }, query: query }, projectKey)=>{
        const { issueKey: issueKey } = params;
        const { filter: filter, jql: jql } = query;
        const defaultJql = (0, (0, parcelRequire("8zzKy")).getDefaultJql)((0, (0, parcelRequire("g5X3G")).toProjectKey)(projectKey));
        return {
            page: 1,
            jql: jql,
            issueKey: issueKey,
            projectKey: projectKey,
            filter: filter,
            defaultJql: defaultJql
        };
    };
    const $f6e98a15759e1b83$export$b968a035fc2aa57b = (projectKey, defaultJql, jqlParam, filter)=>{
        if (typeof jqlParam === 'string') return {
            jql: jqlParam
        };
        if (typeof filter === 'string' && filter !== '') {
            if ((0, (0, parcelRequire("9Nvh7")).isFilterId)(filter)) return {
                filterId: filter
            };
            const filterJql = (0, (0, parcelRequire("8zzKy")).mapFilterToJql)(projectKey, filter);
            if (filterJql !== undefined) return {
                jql: filterJql
            };
        }
        return {
            jql: defaultJql
        };
    };
});
parcelRegister("bS4S3", function(module, exports) {
    $parcel$export(module.exports, "getLatestJSMProjectRequest", ()=>$7fc07189608a8a75$export$9cbf5320d7abb785);
    var $ebyGx = parcelRequire("ebyGx");
    var $jcw0u;
    var $eusud;
    const $7fc07189608a8a75$export$9cbf5320d7abb785 = async ()=>{
        try {
            const queryParams = (0, ($parcel$interopDefault($ebyGx))).stringify({
                maxResults: '1',
                orderBy: 'lastIssueUpdatedTime',
                typeKey: 'service_desk'
            });
            const response = await (0, (0, parcelRequire("eusud")).performGetRequestWithRetry)(`/rest/api/3/project/search?${queryParams}`);
            return response;
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getLatestJSMProjectRequest',
                    packageName: 'jiraRouterResourcesSoftwareRequests'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
parcelRegister("fe326", function(module, exports) {
    $parcel$export(module.exports, "softwareRequestsRoute", ()=>$b3b6cc1efadfe03b$export$5a84dbc6e86abbed);
    $parcel$export(module.exports, "softwareRequestsClassicRoute", ()=>$b3b6cc1efadfe03b$export$e45e557c8c37bcea);
    var $65Ltd;
    const $b3b6cc1efadfe03b$export$5a84dbc6e86abbed = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REQUESTS),
        path: '/jira/software/projects/:projectKey/requests'
    };
    const $b3b6cc1efadfe03b$export$e45e557c8c37bcea = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_REQUESTS_CLASSIC),
        path: '/jira/software/c/projects/:projectKey/requests'
    };
});
parcelRegister("3mhLI", function(module, exports) {
    $parcel$export(module.exports, "LazyRequests", ()=>$bc75567830629fd0$export$3b235a8105f91b2b);
    $parcel$export(module.exports, "LazyNextGenRequestsPage", ()=>$bc75567830629fd0$export$b357b5f614f36f9a);
    $parcel$export(module.exports, "LazyClassicRequestsPage", ()=>$bc75567830629fd0$export$f6b20eb362411299);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $Z5W8v;
    const $bc75567830629fd0$export$3b235a8105f91b2b = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fuWlC"))), {
        moduleId: "./src/packages/software/requests/requests-page/src/index.tsx"
    });
    const $bc75567830629fd0$export$b357b5f614f36f9a = ({ match: match, query: query })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $bc75567830629fd0$export$3b235a8105f91b2b,
            pageId: (0, (0, parcelRequire("Z5W8v")).default)('next-gen-requests', match, query),
            shouldShowSpinner: false
        });
    const $bc75567830629fd0$export$f6b20eb362411299 = ({ match: match, query: query })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $bc75567830629fd0$export$3b235a8105f91b2b,
            pageId: (0, (0, parcelRequire("Z5W8v")).default)('classic-requests', match, query),
            shouldShowSpinner: false
        });
});
parcelRegister("Z5W8v", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab2f1a53fc8de961$export$2e2bcd8739ae039);
    var $ab2f1a53fc8de961$export$2e2bcd8739ae039 = (pageIdPrefix, { params: params }, { filter: filter, orderby: orderby, keyword: keyword })=>{
        const { projectKey: projectKey, issueKey: issueKey } = params;
        let pageId = '';
        try {
            pageId = `${pageIdPrefix}${(projectKey !== null && projectKey !== undefined ? `-${projectKey}` : '') + (issueKey !== null && issueKey !== undefined ? `-${issueKey}` : '') + (filter !== undefined ? `-${filter}` : '') + (orderby !== undefined ? `-${orderby}` : '') + (keyword !== undefined ? `-${keyword}` : '')}`;
        } catch  {
            pageId = pageIdPrefix;
        }
        return pageId;
    };
});
parcelRegister("fuWlC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("giGBa")
    ]).then(()=>parcelRequire('enu17'));
});
parcelRegister("hYD8Y", function(module, exports) {
    $parcel$export(module.exports, "softwareRoadmapRouteEntry", ()=>$f9f5d14d16dfafed$export$c1d875e34d537389);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $g5RGc;
    var $lmyls;
    var $koWFd;
    var $2G9Bk;
    var $1XrjK;
    var $3RJkv;
    var $jsFU4;
    var $d04s2;
    var $eIjIv;
    var $lm7AC;
    var $5PD5h;
    var $e7bC3;
    var $dIdda = parcelRequire("dIdda");
    var $9SSv2;
    const $f9f5d14d16dfafed$export$dd8650bb193f860b = ({ match: { params: { projectKey: projectKey, boardId: boardId } }, query: query })=>{
        const queryParams = new URLSearchParams(query).toString();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: {
                pathname: `/jira/software/projects/${String(projectKey)}/boards/${String(boardId)}/timeline`,
                hash: '',
                search: queryParams
            }
        });
    };
    const $f9f5d14d16dfafed$export$c1d875e34d537389 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("eIjIv")).softwareRoadmapRoute), ()=>({
            component: $f9f5d14d16dfafed$export$dd8650bb193f860b,
            skeleton: (0, (0, parcelRequire("lm7AC")).RoadmapSkeleton),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).softwareProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                {
                    query: [
                        'selectedIssue'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectResource)(),
                (0, (0, parcelRequire("jsFU4")).nextGenRoadmapResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'software-roadmap-early-entry'
                ]
            },
            afterPaint: [
                (0, (0, parcelRequire("d04s2")).LazyIssueApp)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("9SSv2")).LazyNextGenRoadmap)
            ],
            ufoName: 'next-gen-roadmap'
        }));
});
parcelRegister("jsFU4", function(module, exports) {
    $parcel$export(module.exports, "nextGenRoadmapResource", ()=>$0b5ed5206b5a609e$export$2750f87d68dfb02a);
    var $dIdda = parcelRequire("dIdda");
    const $0b5ed5206b5a609e$export$2750f87d68dfb02a = (0, $dIdda.createResource)({
        type: (0, $87d7efe6336d8b83$export$75dfa03544a19422),
        getKey: ({ match: match })=>match.params.boardId || '',
        getDataLoader: ()=>(parcelRequire("O4yt4")),
        maxAge: 3600000,
        isBrowserOnly: true
    });
});
parcelRegister("O4yt4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8Fxs8").then(()=>parcelRequire('d0ZST'));
});
parcelRegister("eIjIv", function(module, exports) {
    $parcel$export(module.exports, "softwareRoadmapRoute", ()=>$11f30805918c6c16$export$a4a573c36fc75b30);
    var $65Ltd;
    const $11f30805918c6c16$export$a4a573c36fc75b30 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ROADMAP),
        path: '/jira/software/projects/:projectKey/boards/:boardId/roadmap'
    };
});
parcelRegister("9SSv2", function(module, exports) {
    $parcel$export(module.exports, "LazyNextGenRoadmap", ()=>$fba9adf99f1ad42b$export$1339c847cf4ab57);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $fba9adf99f1ad42b$export$1339c847cf4ab57 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("gFf95"))), {
        moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
    });
    var $fba9adf99f1ad42b$export$2e2bcd8739ae039 = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $fba9adf99f1ad42b$export$1339c847cf4ab57,
            pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
            shouldShowSpinner: false
        });
});
parcelRegister("gFf95", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7pA40")
    ]).then(()=>parcelRequire('9ImcE'));
});
parcelRegister("b3Ytp", function(module, exports) {
    $parcel$export(module.exports, "softwareSummaryRouteEntry", ()=>$6558dfd987f061ce$export$a2560b0baf928c49);
    var $e4eHl = parcelRequire("e4eHl");
    var $ffza4;
    var $65Ltd;
    var $cSD7y;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5lsNZ;
    var $3VVVg;
    var $5PD5h;
    var $e7bC3;
    var $f3iuv;
    const $6558dfd987f061ce$export$a2560b0baf928c49 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("3VVVg")).softwareSummaryRoute), ()=>({
            ufoName: 'next-gen-summary',
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('enable_jsw_summary_page', (0, (0, parcelRequire("f3iuv")).SummaryPage), (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("f3iuv")).LazySummaryView)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SUMMARY),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SUMMARY)),
                    teamName: 'Helios - Reports'
                }
            }
        }));
});
parcelRegister("3VVVg", function(module, exports) {
    $parcel$export(module.exports, "softwareSummaryRoute", ()=>$63f9b7ea3e0b13b0$export$c6629202e90df62a);
    var $65Ltd;
    const $63f9b7ea3e0b13b0$export$c6629202e90df62a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_SUMMARY),
        path: '/jira/software/projects/:projectKey/summary'
    };
});
parcelRegister("a0ObZ", function(module, exports) {
    $parcel$export(module.exports, "softwareTimelineRouteEntry", ()=>$31385a75e55d4e4a$export$ace6a996c7e99f3);
    var $ffza4;
    var $g5RGc;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $1XrjK;
    var $3RJkv;
    var $dxCvy;
    var $jsFU4;
    var $7GnDe;
    var $d04s2;
    var $iG9cw;
    var $lm7AC;
    var $5PD5h;
    var $e7bC3;
    var $fAhgR;
    const $31385a75e55d4e4a$export$ace6a996c7e99f3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iG9cw")).softwareTimelineRoute), ()=>({
            component: (0, (0, parcelRequire("fAhgR")).default),
            skeleton: (0, (0, parcelRequire("lm7AC")).RoadmapSkeleton),
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("e7bC3")).softwareProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                {
                    query: [
                        'selectedIssue'
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("koWFd")).default),
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("jsFU4")).nextGenRoadmapResource)
            ],
            preloadOptions: {
                earlyChunks: [
                    'software-roadmap-early-entry'
                ]
            },
            afterPaint: [
                (0, (0, parcelRequire("d04s2")).LazyIssueApp)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("fAhgR")).LazyNextGenRoadmap)
            ],
            ufoName: 'next-gen-roadmap'
        }));
});
parcelRegister("iG9cw", function(module, exports) {
    $parcel$export(module.exports, "softwareTimelineRoute", ()=>$3f6f4b13cca02c21$export$d25dafcda96d5af9);
    var $65Ltd;
    const $3f6f4b13cca02c21$export$d25dafcda96d5af9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE),
        path: '/jira/software/projects/:projectKey/boards/:boardId/timeline'
    };
});
parcelRegister("fAhgR", function(module, exports) {
    $parcel$export(module.exports, "LazyNextGenRoadmap", ()=>$faefef5a329d510c$export$1339c847cf4ab57);
    $parcel$export(module.exports, "default", ()=>$faefef5a329d510c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $faefef5a329d510c$export$1339c847cf4ab57 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("gFf95"))), {
        moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
    });
    var $faefef5a329d510c$export$2e2bcd8739ae039 = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $faefef5a329d510c$export$1339c847cf4ab57,
            pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
            shouldShowSpinner: false
        });
});
parcelRegister("e8rgT", function(module, exports) {
    $parcel$export(module.exports, "softwareVersionDetailRouteEntry", ()=>$9c57977169cc077f$export$c97dabcfe9d495fa);
    $parcel$export(module.exports, "softwareVersionDetailEmbedRouteEntry", ()=>$9c57977169cc077f$export$83102a6097008c79);
    $parcel$export(module.exports, "softwareVersionDetailNoTabPathRedirectRouteEntry", ()=>$9c57977169cc077f$export$28d16aae32969765);
    $parcel$export(module.exports, "softwareVersionDetailLegacyRedirectRouteEntry", ()=>$9c57977169cc077f$export$f29aafdff734071c);
    var $5uXOq = parcelRequire("5uXOq");
    var $e4eHl = parcelRequire("e4eHl");
    var $ffza4;
    var $65Ltd;
    var $cSD7y;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $9s3j1;
    var $2G9Bk;
    var $1XrjK;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $kt0pG;
    var $5lsNZ;
    var $aE7PK;
    var $9n75Q;
    var $5PD5h;
    var $e7bC3;
    var $dIdda = parcelRequire("dIdda");
    var $jchNA;
    const $9c57977169cc077f$var$VersionDetailPageLegacyRedirect = ({ match: { params: { projectKey: projectKey, versionId: versionId, tab: tab } } })=>{
        if (projectKey == null || versionId == null) throw Error('projectKey or versionId not found in match object of RouteContext');
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/projects/${projectKey}/versions/${versionId}/tab/${tab != null ? tab : 'release-report-all-issues'}`
        });
    };
    const $9c57977169cc077f$export$c97dabcfe9d495fa = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aE7PK")).softwareVersionDetailRoute), ()=>({
            component: (0, (0, parcelRequire("jchNA")).VersionDetailPage),
            skeleton: (0, (0, parcelRequire("9n75Q")).VersionDetailSkeleton),
            canTransitionIn: ()=>true,
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: [
                    (0, (0, parcelRequire("koWFd")).default),
                    (0, (0, parcelRequire("9s3j1")).default)
                ]
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("kt0pG")).versionDetailsRelayResourceCustom),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("jchNA")).LazyVersionDetail)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL)),
                    teamName: 'fusion-solaris'
                }
            }
        }));
    const $9c57977169cc077f$export$83102a6097008c79 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aE7PK")).softwareVersionDetailRouteEmbed), ()=>({
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jira_release_smartlink_embed', (0, (0, parcelRequire("jchNA")).VersionDetailPage), (0, (0, parcelRequire("5lsNZ")).default)),
            skeleton: (0, (0, parcelRequire("9n75Q")).VersionDetailSkeleton),
            canTransitionIn: ()=>true,
            layout: (0, (0, parcelRequire("1XrjK")).createLayout)({
                isChromeless: true
            }),
            navigation: {
                sidebar: null,
                horizontal: undefined
            },
            resources: [
                (0, (0, parcelRequire("kt0pG")).versionDetailsRelayResourceCustom),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("jchNA")).LazyVersionDetail)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_EMBED),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_EMBED)),
                    teamName: 'fusion-solaris'
                }
            }
        }));
    const $9c57977169cc077f$export$28d16aae32969765 = (0, (0, parcelRequire("2G9Bk")).createEntry)({
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH),
        path: '/projects/:projectKey/versions/:versionId'
    }, ()=>({
            component: $9c57977169cc077f$var$VersionDetailPageLegacyRedirect,
            canTransitionIn: ()=>true,
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: [
                    (0, (0, parcelRequire("koWFd")).default),
                    (0, (0, parcelRequire("9s3j1")).default)
                ],
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("jchNA")).LazyVersionDetail)
            ]
        }));
    const $9c57977169cc077f$export$f29aafdff734071c = (0, (0, parcelRequire("2G9Bk")).createEntry)({
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_LEGACY_REDIRECT),
        path: '/browse/:projectKey/fixforversion/:versionId'
    }, ()=>({
            component: $9c57977169cc077f$var$VersionDetailPageLegacyRedirect,
            canTransitionIn: ()=>true,
            layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: [
                    (0, (0, parcelRequire("koWFd")).default),
                    (0, (0, parcelRequire("9s3j1")).default)
                ],
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("jchNA")).LazyVersionDetail)
            ]
        }));
});
parcelRegister("kt0pG", function(module, exports) {
    $parcel$export(module.exports, "versionDetailsRelayResourceCustom", ()=>$57dfad429d4f47cb$export$c56c5b19da4d0fd1);
    var $8Uumt = parcelRequire("8Uumt");
    var $4R6GH;
    var $dXq4S;
    var $5yJb9;
    var $kipqU;
    var $ao2h1;
    var $dvgjB;
    var $kfztd;
    var $20fNh;
    var $9NiTW;
    var $dIdda = parcelRequire("dIdda");
    const $57dfad429d4f47cb$export$c56c5b19da4d0fd1 = (0, $dIdda.createResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${(0, $afc34106ac722f11$export$9fe575a15a87a796)}`,
        getKey: ({ match: match })=>{
            const { versionId: versionId } = match.params;
            const parsedVersionId = String(versionId ?? '').replace(/\D/g, '');
            return `jsw-releases-version-details-main-query-relay-${parsedVersionId}`;
        },
        getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
            const { versionId: versionId } = match.params;
            const { filters: filters, sortBy: sortBy } = (0, (0, parcelRequire("20fNh")).toVersionIssuesGraphQLVariables)(query);
            const parsedVersionId = String(versionId ?? '').replace(/\D/g, '');
            const variables = {
                cloudAri: (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'site',
                    resourceId: tenantContext.cloudId
                }),
                versionAri: (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'version/activation',
                    resourceId: String(`${tenantContext.activationId}/${parsedVersionId}`)
                }),
                sortBy: sortBy,
                filters: filters,
                skip: !(0, (0, parcelRequire("9NiTW")).checkAuthentication)(tenantContext) || parsedVersionId.length === 0,
                isDevopsFeatureDisabledInFedRamp: (0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)(),
                isIssueSummarisedDeploymentsMigratedToAgs: (0, (0, parcelRequire("4R6GH")).fg)('solaris_migrate_summurized_deployments_to_ags_re'),
                shouldIncludeDevOpsFieldsViaAgs: !(0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp)() && (0, (0, parcelRequire("4R6GH")).fg)('solaris_migrate_summurized_deployments_to_ags_re')
            };
            const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("dvgjB")).default), variables, {
                fetchPolicy: 'store-or-network'
            });
            if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            return queryReference;
        },
        maxAge: 0
    });
});
parcelRegister("dvgjB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ecc7304dc73fa0e$export$2e2bcd8739ae039);
    const $8ecc7304dc73fa0e$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "82741647e71f2cf9a8f9e0329b8b9192cd671f81a20c453bd333c79575469f60",
            "metadata": {},
            "name": "uiVersionDetailsQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $8ecc7304dc73fa0e$export$2e2bcd8739ae039 = $8ecc7304dc73fa0e$var$node;
});
parcelRegister("20fNh", function(module, exports) {
    $parcel$export(module.exports, "toVersionIssuesGraphQLVariables", ()=>$3e331943907e0f7c$export$72df1c7780b3e8e2);
    $parcel$export(module.exports, "useVersionIssuesGraphQLVariables", ()=>$3e331943907e0f7c$export$3d12d3ffbce57135);
    var $3hGWp;
    var $jPgXx;
    var $3dG8c;
    const $3e331943907e0f7c$var$accountIdToAriStr = (accountIds)=>{
        if (accountIds == null) return null;
        return accountIds.map((accountId)=>accountId === 'UNASSIGNED' ? null : `ari:cloud:identity::user/${accountId}`);
    };
    const $3e331943907e0f7c$export$72df1c7780b3e8e2 = (queryParams)=>{
        const parsedQueryParams = (0, (0, parcelRequire("3dG8c")).parseQueryParams)(queryParams);
        return {
            filters: {
                searchStr: parsedQueryParams[0, $5d187be87424268f$export$e39925d10cebc0b] ?? null,
                epicIds: parsedQueryParams[0, $5d187be87424268f$export$b98a7875ddbefaac] ?? null,
                statusCategories: parsedQueryParams[0, $5d187be87424268f$export$c307007520232013] != null ? parsedQueryParams[0, $5d187be87424268f$export$c307007520232013].filter((0, (0, parcelRequire("jPgXx")).isVersionStatusCategory)) : null,
                warningCategories: parsedQueryParams[0, $5d187be87424268f$export$2552faed9df6a2cd] ?? null,
                assigneeAccountIds: $3e331943907e0f7c$var$accountIdToAriStr(parsedQueryParams[0, $5d187be87424268f$export$f78d8c81fcad32a2])
            },
            sortBy: {
                sortByField: parsedQueryParams[0, $5d187be87424268f$export$13d5b2891ca65cd6] ?? 'CREATED',
                order: parsedQueryParams[0, $5d187be87424268f$export$810a1f7ed2facfcb] ?? 'ASC'
            }
        };
    };
    const $3e331943907e0f7c$export$3d12d3ffbce57135 = ()=>{
        const [queryParams] = (0, (0, parcelRequire("3hGWp")).useQueryParams)((0, $5d187be87424268f$export$e39925d10cebc0b), (0, $5d187be87424268f$export$b98a7875ddbefaac), (0, $5d187be87424268f$export$c307007520232013), (0, $5d187be87424268f$export$2552faed9df6a2cd), (0, $5d187be87424268f$export$f78d8c81fcad32a2), (0, $5d187be87424268f$export$13d5b2891ca65cd6), (0, $5d187be87424268f$export$810a1f7ed2facfcb));
        return $3e331943907e0f7c$export$72df1c7780b3e8e2(queryParams);
    };
});
parcelRegister("3hGWp", function(module, exports) {
    $parcel$export(module.exports, "useQueryParams", ()=>$afd0e0a12e1f2496$export$b37ee0d76c6d2fbc);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $hGgHi = parcelRequire("hGgHi");
    var $9xWGk = parcelRequire("9xWGk");
    var $ebyGx = parcelRequire("ebyGx");
    var $dIdda = parcelRequire("dIdda");
    const $afd0e0a12e1f2496$export$b37ee0d76c6d2fbc = (...queryParamsToWatch)=>{
        const [{ location: { pathname: pathname }, query: query }, { push: push, replace: replace }] = (0, $dIdda.useRouter)();
        const queryParamsRef = (0, $5uXOq.useRef)({});
        const parsedQueryParams = (0, $5uXOq.useMemo)(()=>{
            const newQueryParams = queryParamsToWatch.reduce((accumulator, currentValue)=>{
                accumulator[currentValue] = query[currentValue] || undefined;
                return accumulator;
            }, {});
            if (!(0, ($parcel$interopDefault($ajpes)))(queryParamsRef.current, newQueryParams)) queryParamsRef.current = newQueryParams;
            return queryParamsRef.current;
        }, [
            query,
            queryParamsToWatch
        ]);
        const setQueryParams = (0, $5uXOq.useCallback)((newQueryParams, options)=>{
            const parsedSearch = (0, ($parcel$interopDefault($9xWGk)))({
                ...query,
                ...newQueryParams
            }, (value)=>(0, ($parcel$interopDefault($hGgHi)))(value));
            const { updateType: updateType, ...stringifyOptions } = options ?? {};
            const strSearch = (0, ($parcel$interopDefault($ebyGx))).stringify(parsedSearch, stringifyOptions);
            const url = pathname + (strSearch !== '' ? `?${strSearch}` : '');
            updateType === 'replace' ? replace(url) : push(url);
        }, [
            pathname,
            push,
            replace,
            query
        ]);
        return [
            parsedQueryParams,
            setQueryParams
        ];
    };
});
const $5d187be87424268f$export$e39925d10cebc0b = 'text';
const $5d187be87424268f$export$b98a7875ddbefaac = 'epics';
const $5d187be87424268f$export$c307007520232013 = 'statusCategory';
const $5d187be87424268f$export$2552faed9df6a2cd = 'warnings';
const $5d187be87424268f$export$f78d8c81fcad32a2 = 'assignee';
const $5d187be87424268f$export$13d5b2891ca65cd6 = 'sortBy';
const $5d187be87424268f$export$810a1f7ed2facfcb = 'sortOrder';
parcelRegister("jPgXx", function(module, exports) {
    $parcel$export(module.exports, "isWarningsFilterValue", ()=>$1bd9df170beee33d$export$5c25bcf27380084);
    $parcel$export(module.exports, "toWarningsFilterValue", ()=>$1bd9df170beee33d$export$ac3017cd78edb8a1);
    $parcel$export(module.exports, "isVersionStatusCategory", ()=>$1bd9df170beee33d$export$3af93bbba0d4241a);
    $parcel$export(module.exports, "isSortBy", ()=>$1bd9df170beee33d$export$472650e4cbd40b70);
    $parcel$export(module.exports, "isSortOrder", ()=>$1bd9df170beee33d$export$dfece8cb679d32a3);
    var $gULOk;
    const $1bd9df170beee33d$export$5c25bcf27380084 = (val)=>val === 'OPEN_PULL_REQUEST' || val === 'UNREVIEWED_CODE' || val === 'FAILING_BUILD' || val === 'OPEN_REVIEW';
    const $1bd9df170beee33d$export$ac3017cd78edb8a1 = (statusCategoryFromQueryParam)=>statusCategoryFromQueryParam.filter($1bd9df170beee33d$export$5c25bcf27380084);
    const $1bd9df170beee33d$export$3af93bbba0d4241a = (val)=>val === (0, (0, parcelRequire("gULOk")).TODO) || val === (0, (0, parcelRequire("gULOk")).IN_PROGRESS) || val === (0, (0, parcelRequire("gULOk")).DONE);
    const $1bd9df170beee33d$export$472650e4cbd40b70 = (val)=>val === 'ASSIGNEE' || val === 'CREATED' || val === 'KEY' || val === 'PRIORITY' || val === 'STATUS' || val === 'TYPE';
    const $1bd9df170beee33d$export$dfece8cb679d32a3 = (val)=>val === 'ASC' || val === 'DESC';
});
parcelRegister("gULOk", function(module, exports) {
    $parcel$export(module.exports, "UNDEFINED", ()=>$e77315bf13f8b83b$export$6db089fe7b26f5b6);
    $parcel$export(module.exports, "TODO", ()=>$e77315bf13f8b83b$export$aa456a5030160740);
    $parcel$export(module.exports, "IN_PROGRESS", ()=>$e77315bf13f8b83b$export$5a9ac66c2785cc13);
    $parcel$export(module.exports, "DONE", ()=>$e77315bf13f8b83b$export$71efb3495f6084f2);
    $parcel$export(module.exports, "STATUS_CATEGORIES", ()=>$e77315bf13f8b83b$export$d9119300f9d9a815);
    $parcel$export(module.exports, "StatusCategoryTypes", ()=>$e77315bf13f8b83b$export$5d42a08d46cffe7);
    $parcel$export(module.exports, "StatusCategoryIds", ()=>$e77315bf13f8b83b$export$3f42f49c284d5b58);
    $parcel$export(module.exports, "statusCategoryKeys", ()=>$e77315bf13f8b83b$export$f3f919dc0f56d9eb);
    $parcel$export(module.exports, "statusCategoryForId", ()=>$e77315bf13f8b83b$export$3e9e3002956ff4fb);
    $parcel$export(module.exports, "categoryIdForStatusCategory", ()=>$e77315bf13f8b83b$export$7b16b0022aac2d46);
    $parcel$export(module.exports, "isValidStatusCategoryKey", ()=>$e77315bf13f8b83b$export$d928f247c903643a);
    const $e77315bf13f8b83b$export$6db089fe7b26f5b6 = 'UNDEFINED';
    const $e77315bf13f8b83b$export$aa456a5030160740 = 'TODO';
    const $e77315bf13f8b83b$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
    const $e77315bf13f8b83b$export$71efb3495f6084f2 = 'DONE';
    const $e77315bf13f8b83b$export$d9119300f9d9a815 = [
        $e77315bf13f8b83b$export$6db089fe7b26f5b6,
        $e77315bf13f8b83b$export$aa456a5030160740,
        $e77315bf13f8b83b$export$5a9ac66c2785cc13,
        $e77315bf13f8b83b$export$71efb3495f6084f2
    ];
    const $e77315bf13f8b83b$var$statusCategories = [
        {
            id: '1',
            statusCategory: $e77315bf13f8b83b$export$6db089fe7b26f5b6
        },
        {
            id: '2',
            statusCategory: $e77315bf13f8b83b$export$aa456a5030160740
        },
        {
            id: '4',
            statusCategory: $e77315bf13f8b83b$export$5a9ac66c2785cc13
        },
        {
            id: '3',
            statusCategory: $e77315bf13f8b83b$export$71efb3495f6084f2
        }
    ];
    const $e77315bf13f8b83b$export$5d42a08d46cffe7 = Object.freeze({
        NEW: 'new',
        INDETERMINATE: 'indeterminate',
        DONE: 'done',
        UNDEFINED: 'undefined'
    });
    const $e77315bf13f8b83b$export$3f42f49c284d5b58 = Object.freeze({
        [$e77315bf13f8b83b$export$5d42a08d46cffe7.UNDEFINED]: 1,
        [$e77315bf13f8b83b$export$5d42a08d46cffe7.NEW]: 2,
        [$e77315bf13f8b83b$export$5d42a08d46cffe7.DONE]: 3,
        [$e77315bf13f8b83b$export$5d42a08d46cffe7.INDETERMINATE]: 4
    });
    const $e77315bf13f8b83b$export$f3f919dc0f56d9eb = Object.values($e77315bf13f8b83b$export$5d42a08d46cffe7);
    const $e77315bf13f8b83b$export$3e9e3002956ff4fb = (statusCategoryId)=>{
        const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
        return value ? value.statusCategory : $e77315bf13f8b83b$export$6db089fe7b26f5b6;
    };
    const $e77315bf13f8b83b$export$7b16b0022aac2d46 = (statusCategory)=>{
        const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
        return Number(value ? value.id : '1');
    };
    const $e77315bf13f8b83b$export$d928f247c903643a = (key)=>$e77315bf13f8b83b$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);
});
parcelRegister("3dG8c", function(module, exports) {
    $parcel$export(module.exports, "isAnyFilterApplied", ()=>$89761db99e7e0304$export$e6b3ec1d09429da8);
    $parcel$export(module.exports, "parseQueryParams", ()=>$89761db99e7e0304$export$67c4cee80a3410cd);
    var $g5X3G;
    var $jPgXx;
    const $89761db99e7e0304$export$e6b3ec1d09429da8 = (parsedQueryParams)=>parsedQueryParams[0, $5d187be87424268f$export$e39925d10cebc0b] != null && parsedQueryParams[0, $5d187be87424268f$export$e39925d10cebc0b].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$b98a7875ddbefaac] != null && parsedQueryParams[0, $5d187be87424268f$export$b98a7875ddbefaac].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$c307007520232013] != null && parsedQueryParams[0, $5d187be87424268f$export$c307007520232013].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$2552faed9df6a2cd] != null && parsedQueryParams[0, $5d187be87424268f$export$2552faed9df6a2cd].length > 0 || parsedQueryParams[0, $5d187be87424268f$export$f78d8c81fcad32a2] != null && parsedQueryParams[0, $5d187be87424268f$export$f78d8c81fcad32a2].length > 0;
    const $89761db99e7e0304$export$2a2e94972ab280d4 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim()).map((0, (0, parcelRequire("g5X3G")).toIssueId));
    const $89761db99e7e0304$export$fb136b568c6d78b5 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>str.trim()).filter((0, (0, parcelRequire("jPgXx")).isVersionStatusCategory));
    const $89761db99e7e0304$export$5cb324c621ca24e8 = (paramValue)=>paramValue == null ? undefined : (0, (0, parcelRequire("jPgXx")).toWarningsFilterValue)(paramValue.split(',').map((str)=>str.trim()));
    const $89761db99e7e0304$export$6c8eda0352c7cf5 = (paramValue)=>paramValue == null ? undefined : paramValue.split(',').map((str)=>(0, (0, parcelRequire("g5X3G")).toAccountId)(str.trim()));
    const $89761db99e7e0304$export$67c4cee80a3410cd = (paramsRaw)=>{
        const result = {};
        result[0, $5d187be87424268f$export$e39925d10cebc0b] = paramsRaw[0, $5d187be87424268f$export$e39925d10cebc0b];
        result[0, $5d187be87424268f$export$b98a7875ddbefaac] = $89761db99e7e0304$export$2a2e94972ab280d4(paramsRaw[0, $5d187be87424268f$export$b98a7875ddbefaac]);
        result[0, $5d187be87424268f$export$c307007520232013] = $89761db99e7e0304$export$fb136b568c6d78b5(paramsRaw[0, $5d187be87424268f$export$c307007520232013]);
        result[0, $5d187be87424268f$export$2552faed9df6a2cd] = $89761db99e7e0304$export$5cb324c621ca24e8(paramsRaw[0, $5d187be87424268f$export$2552faed9df6a2cd]);
        result[0, $5d187be87424268f$export$f78d8c81fcad32a2] = $89761db99e7e0304$export$6c8eda0352c7cf5(paramsRaw[0, $5d187be87424268f$export$f78d8c81fcad32a2]);
        result[0, $5d187be87424268f$export$13d5b2891ca65cd6] = paramsRaw[0, $5d187be87424268f$export$13d5b2891ca65cd6] && (0, (0, parcelRequire("jPgXx")).isSortBy)(paramsRaw[0, $5d187be87424268f$export$13d5b2891ca65cd6]) ? paramsRaw[0, $5d187be87424268f$export$13d5b2891ca65cd6] : 'CREATED';
        result[0, $5d187be87424268f$export$810a1f7ed2facfcb] = paramsRaw[0, $5d187be87424268f$export$810a1f7ed2facfcb] && (0, (0, parcelRequire("jPgXx")).isSortOrder)(paramsRaw[0, $5d187be87424268f$export$810a1f7ed2facfcb]) ? paramsRaw[0, $5d187be87424268f$export$810a1f7ed2facfcb] : 'ASC';
        return result;
    };
});
const $afc34106ac722f11$export$9fe575a15a87a796 = 'PROJECTS_VERSION_DETAILS';
parcelRegister("aE7PK", function(module, exports) {
    $parcel$export(module.exports, "softwareVersionDetailRoute", ()=>$9ca6f67dcea727c8$export$eb3633614d0521b0);
    $parcel$export(module.exports, "softwareVersionDetailRouteEmbed", ()=>$9ca6f67dcea727c8$export$56f4dbe2a66a0830);
    var $65Ltd;
    const $9ca6f67dcea727c8$export$eb3633614d0521b0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL),
        path: '/projects/:projectKey/versions/:versionId/tab/:tab',
        ufoName: 'software.version-details-page'
    };
    const $9ca6f67dcea727c8$export$56f4dbe2a66a0830 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_EMBED),
        path: '/projects/:projectKey/versions/:versionId/tab/:tab/embed',
        exact: true,
        ufoName: 'software.version-details-page-embed'
    };
    const $9ca6f67dcea727c8$export$f22288f2d2f1b9ea = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_NO_TAB_PATH),
        path: '/projects/:projectKey/versions/:versionId'
    };
    const $9ca6f67dcea727c8$export$3fc8dbcec208bca0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_VERSION_DETAIL_LEGACY_REDIRECT),
        path: '/browse/:projectKey/fixforversion/:versionId'
    };
});
parcelRegister("9n75Q", function(module, exports) {
    $parcel$export(module.exports, "VersionDetailSkeleton", ()=>$eef94ee10d7cccdd$export$b3661a594ba34350);
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $eFyfI = parcelRequire("eFyfI");
    const $eef94ee10d7cccdd$export$b3661a594ba34350 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($eFyfI)))
        });
});
parcelRegister("eFyfI", function(module, exports) {
    module.exports = new URL("version-detail-skeleton.tpl.c4c4fc18.svg", import.meta.url).toString();
});
parcelRegister("jchNA", function(module, exports) {
    $parcel$export(module.exports, "LazyVersionDetail", ()=>$5cbf8f752618c8e3$export$2d31f5f47e6584e0);
    $parcel$export(module.exports, "VersionDetailPage", ()=>$5cbf8f752618c8e3$export$231cc5186b991031);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $5cbf8f752618c8e3$export$2d31f5f47e6584e0 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("hvTZA"))), {
        moduleId: "./src/packages/spa-apps/version-detail/src/index.tsx"
    });
    const $5cbf8f752618c8e3$export$231cc5186b991031 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5cbf8f752618c8e3$export$2d31f5f47e6584e0,
            pageId: "version-detail",
            shouldShowSpinner: false
        });
});
parcelRegister("hvTZA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("cnMnO")
    ]).then(()=>parcelRequire('2WNCY'));
});
parcelRegister("4GBKo", function(module, exports) {
    $parcel$export(module.exports, "getTMPReportsCommonResource", ()=>$e8677532a1aaea76$export$f234446c23dc22a);
    var $48Ij3;
    var $gcI3W;
    var $4Bwc0;
    const $e8677532a1aaea76$export$8cb713295e6b7204 = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource)
        ];
    const $e8677532a1aaea76$export$f234446c23dc22a = ()=>[
            (0, (0, parcelRequire("4Bwc0")).devOpsReportPreconditionResource),
            (0, (0, parcelRequire("gcI3W")).staticProjectReportsSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("48Ij3")).staticSidebarJSWReportsResource)
        ];
});
parcelRegister("21yN6", function(module, exports) {
    $parcel$export(module.exports, "pickNextGenView", ()=>$4ad36038fa160dbe$export$8c47088cd9b527ba);
    var $ebyGx = parcelRequire("ebyGx");
    const $4ad36038fa160dbe$var$PLAN = 'planning';
    const $4ad36038fa160dbe$var$REPORTING = 'reporting';
    const $4ad36038fa160dbe$var$REPORTS = 'reports';
    const $4ad36038fa160dbe$var$constructUrlForView = (url, view, searchResult)=>{
        if (view.startsWith($4ad36038fa160dbe$var$PLAN)) return `${url}/backlog`;
        if (view.startsWith($4ad36038fa160dbe$var$REPORTING) || view.startsWith($4ad36038fa160dbe$var$REPORTS)) {
            if (searchResult.report) return `${url}/reports/${searchResult.report}`;
            return `${url}/reports`;
        }
        return url;
    };
    const $4ad36038fa160dbe$var$KNOWN_KEYS = [
        'rapidView',
        'projectKey',
        'view',
        'report'
    ];
    const $4ad36038fa160dbe$var$forwardUnknownQueryParams = (url, queryParams)=>{
        const query = (0, ($parcel$interopDefault($ebyGx))).stringify(Object.entries(queryParams).filter(([k])=>!$4ad36038fa160dbe$var$KNOWN_KEYS.includes(k)).reduce((result, [k, v])=>({
                [k]: v,
                ...result
            }), {}));
        if (query) return `${url}?${query}`;
        return url;
    };
    const $4ad36038fa160dbe$export$8c47088cd9b527ba = (location)=>{
        const searchResult = (0, ($parcel$interopDefault($ebyGx))).parse(location.search);
        const url = `/jira/software/projects/${searchResult.projectKey}/boards/${searchResult.rapidView}`;
        if (searchResult.view) return $4ad36038fa160dbe$var$forwardUnknownQueryParams($4ad36038fa160dbe$var$constructUrlForView(url, searchResult.view, searchResult), searchResult);
        return $4ad36038fa160dbe$var$forwardUnknownQueryParams(url, searchResult);
    };
});
parcelRegister("kotYl", function(module, exports) {
    $parcel$export(module.exports, "LazyNextGenRoadmap", ()=>$fadca415ac9d888e$export$1339c847cf4ab57);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $fadca415ac9d888e$export$1339c847cf4ab57 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("gFf95"))), {
        moduleId: "./src/packages/spa-apps/roadmap/src/view/next-gen/index.tsx"
    });
    var $fadca415ac9d888e$export$2e2bcd8739ae039 = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $fadca415ac9d888e$export$1339c847cf4ab57,
            pageId: `next-gen-roadmap-${match.params.boardId || ''}`,
            shouldShowSpinner: false
        });
});
parcelRegister("cD5C5", function(module, exports) {
    $parcel$export(module.exports, "LazyCode", ()=>$e02d9e74ba3f4d5c$export$4beafd9dbad29bff);
    $parcel$export(module.exports, "CodePageNextGen", ()=>$e02d9e74ba3f4d5c$export$d9e8184332f86b53);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $bzM7d;
    const $e02d9e74ba3f4d5c$export$4beafd9dbad29bff = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("492p0"))), {
        moduleId: "./src/packages/spa-apps/code/src/index.tsx"
    });
    const $e02d9e74ba3f4d5c$export$d9e8184332f86b53 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e02d9e74ba3f4d5c$export$4beafd9dbad29bff,
            pageId: `next-gen-code-${(0, (0, parcelRequire("bzM7d")).getBoardId)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
    const $e02d9e74ba3f4d5c$export$95e2389b7ca7ccf2 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e02d9e74ba3f4d5c$export$4beafd9dbad29bff,
            pageId: `classic-code-${(0, (0, parcelRequire("bzM7d")).getBoardId)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
});
parcelRegister("bzM7d", function(module, exports) {
    $parcel$export(module.exports, "getBoardId", ()=>$8d5a6727ab17b6ba$export$557c2f222778cea6);
    var $ebyGx = parcelRequire("ebyGx");
    const $8d5a6727ab17b6ba$export$557c2f222778cea6 = ({ location: location, match: match })=>{
        if (match && match.params.boardId) return match.params.boardId;
        const { rapidView: rapidView } = (0, ($parcel$interopDefault($ebyGx))).parse(location.search);
        return rapidView;
    };
});
parcelRegister("bekEk", function(module, exports) {
    $parcel$export(module.exports, "LazyNextGenBurndownReport", ()=>$51e496184ed5259a$export$10cd1e761434952);
    $parcel$export(module.exports, "default", ()=>$51e496184ed5259a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $bzM7d;
    const $51e496184ed5259a$export$10cd1e761434952 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2rEkP"))), {
        moduleId: "./src/packages/spa-apps/next-gen-reports/burndown/src/index.tsx"
    });
    var $51e496184ed5259a$export$2e2bcd8739ae039 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $51e496184ed5259a$export$10cd1e761434952,
            pageId: `next-gen-reports-burndown-${(0, (0, parcelRequire("bzM7d")).getBoardId)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
});
parcelRegister("2rEkP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("72D8w")
    ]).then(()=>parcelRequire('68CUZ'));
});
parcelRegister("c3kjm", function(module, exports) {
    $parcel$export(module.exports, "LazyNextGenBurnupReport", ()=>$2f0cf451fae61f8d$export$2ae7ab3b633c1d15);
    $parcel$export(module.exports, "default", ()=>$2f0cf451fae61f8d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $bzM7d;
    const $2f0cf451fae61f8d$export$2ae7ab3b633c1d15 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4W8bb"))), {
        moduleId: "./src/packages/spa-apps/next-gen-reports/burnup/src/index.tsx"
    });
    var $2f0cf451fae61f8d$export$2e2bcd8739ae039 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2f0cf451fae61f8d$export$2ae7ab3b633c1d15,
            pageId: `next-gen-reports-burnup-${(0, (0, parcelRequire("bzM7d")).getBoardId)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
});
parcelRegister("4W8bb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7R4iz")
    ]).then(()=>parcelRequire('e2Cll'));
});
parcelRegister("9XjvH", function(module, exports) {
    $parcel$export(module.exports, "LazyNextGenControlReport", ()=>$a8fc70484e9dc624$export$3b0b331107fce76);
    $parcel$export(module.exports, "ControlPage", ()=>$a8fc70484e9dc624$export$90d0561918744b3b);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $a8fc70484e9dc624$export$3b0b331107fce76 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fdH6B"))), {
        moduleId: "./src/packages/spa-apps/control-report/src/index.tsx"
    });
    const $a8fc70484e9dc624$export$90d0561918744b3b = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a8fc70484e9dc624$export$3b0b331107fce76,
            pageId: "controlReportNextGen",
            shouldShowSpinner: true
        });
});
parcelRegister("fdH6B", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("jdpLP")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("gTfme")
    ]).then(()=>parcelRequire('gcELT'));
});
parcelRegister("5v1XH", function(module, exports) {
    $parcel$export(module.exports, "LazyNextGenCumulativeReport", ()=>$d11158d5657ed65b$export$c588973e5bd18a8d);
    $parcel$export(module.exports, "default", ()=>$d11158d5657ed65b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $bzM7d;
    const $d11158d5657ed65b$export$c588973e5bd18a8d = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fYO6O"))), {
        moduleId: "./src/packages/spa-apps/next-gen-reports/cumulative/src/index.tsx"
    });
    var $d11158d5657ed65b$export$2e2bcd8739ae039 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d11158d5657ed65b$export$c588973e5bd18a8d,
            pageId: `next-gen-reports-cumulative-${(0, (0, parcelRequire("bzM7d")).getBoardId)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
});
parcelRegister("fYO6O", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8KQmP")
    ]).then(()=>parcelRequire('ejLY3'));
});
parcelRegister("g0ZNl", function(module, exports) {
    $parcel$export(module.exports, "LazyCycleTimeReport", ()=>$494bd3c8d60b6ff9$export$956f830ed027f1fb);
    $parcel$export(module.exports, "CycleTimeReportNextGen", ()=>$494bd3c8d60b6ff9$export$e16ce0656a74a015);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $494bd3c8d60b6ff9$export$956f830ed027f1fb = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("8ZMAu")), {
        moduleId: "./src/packages/spa-apps/cycle-time-report/src/index.tsx"
    });
    const $494bd3c8d60b6ff9$export$e16ce0656a74a015 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $494bd3c8d60b6ff9$export$956f830ed027f1fb,
            pageId: "cycleTimeReportNextGen",
            shouldShowSpinner: true
        });
    const $494bd3c8d60b6ff9$export$237924ba64065cc3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $494bd3c8d60b6ff9$export$956f830ed027f1fb,
            pageId: "cycleTimeReportClassic",
            shouldShowSpinner: true
        });
});
parcelRegister("eSx59", function(module, exports) {
    $parcel$export(module.exports, "LazyDeploymentFrequencyReport", ()=>$2f62bb5293f966a6$export$5113b2b19ec1fb53);
    $parcel$export(module.exports, "DeploymentFrequencyReportNextGen", ()=>$2f62bb5293f966a6$export$e2db9c7426cdb53);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $2f62bb5293f966a6$export$5113b2b19ec1fb53 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("2yRGG")), {
        moduleId: "./src/packages/spa-apps/deployment-frequency-report/src/index.tsx"
    });
    const $2f62bb5293f966a6$export$e2db9c7426cdb53 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2f62bb5293f966a6$export$5113b2b19ec1fb53,
            pageId: "deploymentFrequencyReportNextGen",
            shouldShowSpinner: true
        });
    const $2f62bb5293f966a6$export$655707e8ae1053d3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2f62bb5293f966a6$export$5113b2b19ec1fb53,
            pageId: "deploymentFrequencyReportClassic",
            shouldShowSpinner: true
        });
});
parcelRegister("kgB1V", function(module, exports) {
    $parcel$export(module.exports, "LazyNextGenReportsOverview", ()=>$5b9a94bde6be5ad0$export$dbd12c5c20c26961);
    $parcel$export(module.exports, "default", ()=>$5b9a94bde6be5ad0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $bzM7d;
    const $5b9a94bde6be5ad0$export$dbd12c5c20c26961 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("eQoM0"))), {
        moduleId: "./src/packages/spa-apps/next-gen-reports/overview/src/index.tsx"
    });
    var $5b9a94bde6be5ad0$export$2e2bcd8739ae039 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5b9a94bde6be5ad0$export$dbd12c5c20c26961,
            pageId: `next-gen-reports-overview-${(0, (0, parcelRequire("bzM7d")).getBoardId)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
});
parcelRegister("eQoM0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6EDMQ").then(()=>parcelRequire('iZwfI'));
});
parcelRegister("fzG6k", function(module, exports) {
    $parcel$export(module.exports, "LazyNextGenVelocityReport", ()=>$29d7a4515738ef63$export$a2ca519c668b2f72);
    $parcel$export(module.exports, "default", ()=>$29d7a4515738ef63$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $bzM7d;
    const $29d7a4515738ef63$export$a2ca519c668b2f72 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("h3sjI"))), {
        moduleId: "./src/packages/spa-apps/next-gen-reports/velocity/src/index.tsx"
    });
    var $29d7a4515738ef63$export$2e2bcd8739ae039 = ({ location: location, match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $29d7a4515738ef63$export$a2ca519c668b2f72,
            pageId: `next-gen-reports-velocity-${(0, (0, parcelRequire("bzM7d")).getBoardId)({
                location: location,
                match: match
            })}`,
            shouldShowSpinner: false
        });
});
parcelRegister("h3sjI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iTOtj")
    ]).then(()=>parcelRequire('59dUe'));
});
parcelRegister("8HKzP", function(module, exports) {
    $parcel$export(module.exports, "opsgenieScheduleRouteEntry", ()=>$d33ce51d8c4b9036$export$f128c1c4a1f0d631);
    $parcel$export(module.exports, "opsgenieSchedule1RouteEntry", ()=>$d33ce51d8c4b9036$export$924db6cf10ba8696);
    var $e4eHl = parcelRequire("e4eHl");
    var $ffza4;
    var $65Ltd;
    var $7XYc4;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $koWFd;
    var $9s3j1;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5lsNZ;
    var $kiJ5H;
    var $kfztd;
    var $5PD5h;
    var $fyMYi;
    const $d33ce51d8c4b9036$export$f128c1c4a1f0d631 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kiJ5H")).routeNamesOpsgenieScheduleRedirectRoute), ()=>({
            component: !false ? (0, (0, parcelRequire("fyMYi")).OpsgenieScheduleRedirect) : (0, (0, parcelRequire("fyMYi")).default),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("fyMYi")).LazyOpsGenieSchedule)
            ],
            isRedirect: true
        }));
    const $d33ce51d8c4b9036$export$924db6cf10ba8696 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kiJ5H")).opsgenieScheduleRoute), ()=>({
            ufoName: 'project-opsgenie-schedule',
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, (0, parcelRequire("fyMYi")).default)),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: [
                    (0, (0, parcelRequire("koWFd")).default),
                    (0, (0, parcelRequire("9s3j1")).default)
                ],
                horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("fyMYi")).LazyOpsGenieSchedule)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_OPSGENIE_SCHEDULE),
                    packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_OPSGENIE_SCHEDULE)),
                    teamName: 'fusion-solaris'
                }
            }
        }));
});
parcelRegister("kiJ5H", function(module, exports) {
    $parcel$export(module.exports, "routeNamesOpsgenieScheduleRedirectRoute", ()=>$e2179af5de02be12$export$830cd0c207772936);
    $parcel$export(module.exports, "opsgenieScheduleRoute", ()=>$e2179af5de02be12$export$534a7ac096cb1da2);
    var $65Ltd;
    const $e2179af5de02be12$export$830cd0c207772936 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_OPSGENIE_SCHEDULE)}-redirect`,
        path: '/projects/:projectKey',
        query: [
            'selectedItem=com.atlassian.jira.jira-projects-plugin:opsgenie-schedule-page'
        ]
    };
    const $e2179af5de02be12$export$534a7ac096cb1da2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_OPSGENIE_SCHEDULE),
        path: '/jira/:projectType(software|software/c)/projects/:projectKey/on-call-schedule'
    };
});
parcelRegister("fyMYi", function(module, exports) {
    $parcel$export(module.exports, "LazyOpsGenieSchedule", ()=>$aa55fbc557add2b7$export$3a9c3ff70731bdd6);
    $parcel$export(module.exports, "OpsgenieScheduleRedirect", ()=>$aa55fbc557add2b7$export$6ffd640c3062d976);
    $parcel$export(module.exports, "default", ()=>$aa55fbc557add2b7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $dRTnK;
    const $aa55fbc557add2b7$export$3a9c3ff70731bdd6 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8xFuS"))), {
        moduleId: "./src/packages/spa-apps/project/opsgenie-schedule/src/index.tsx"
    });
    const $aa55fbc557add2b7$export$6ffd640c3062d976 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dRTnK")).RedirectToProjectType), {
            page: "/on-call-schedule"
        });
    var $aa55fbc557add2b7$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $aa55fbc557add2b7$export$3a9c3ff70731bdd6,
            pageId: "opsgenie-schedule",
            shouldShowSpinner: true
        });
});
parcelRegister("dRTnK", function(module, exports) {
    $parcel$export(module.exports, "RedirectToProjectType", ()=>$f4de23917d090f8e$export$8a3df560509448b8);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $8zOmE;
    var $95EVP;
    var $dxCvy;
    var $bVDE5;
    var $dIdda = parcelRequire("dIdda");
    const $f4de23917d090f8e$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $dIdda.Redirect), fireUIAnalytics: fireUIAnalytics = (0, (0, parcelRequire("8zOmE")).fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents), useResource: useResource = (0, $dIdda.useResource), useRouter: useRouter = (0, $dIdda.useRouter), useSpaStateTransition: useSpaStateTransition = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition) })=>{
        const [{ match: match, query: query, route: route }] = useRouter();
        const { data: data } = useResource((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        const [{ isInitialRender: isInitial }] = useSpaStateTransition();
        const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
        (0, $5uXOq.useEffect)(()=>{
            if (!data || !route || !eventRef.current) return;
            fireUIAnalytics(eventRef.current, 'route redirected', {
                isInitial: isInitial,
                routeName: route.name
            });
            eventRef.current = null;
        }, [
            data,
            fireUIAnalytics,
            isInitial,
            route
        ]);
        if (!data || !route) return null;
        const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
        let type;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                type = 'servicedesk';
                break;
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                type = 'core';
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            default:
                type = `software${simplified ? '' : '/c'}`;
        }
        const returnPage = typeof page === 'string' ? page : page(match, query);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: `/jira/${type}/projects/${projectKey}${returnPage}`
        });
    };
});
parcelRegister("8xFuS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bVWcI")
    ]).then(()=>parcelRequire('dz9Sq'));
});
parcelRegister("9zX6u", function(module, exports) {
    $parcel$export(module.exports, "peopleProfilesRouteEntry", ()=>$7f2f7b5455866fc1$export$219b6cc00b2f91a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $6s1PB;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $5UHoB;
    var $bHhiy;
    var $3RJkv;
    var $54b5G;
    var $6Z2mh;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $7f2f7b5455866fc1$var$LazyPeopleProfiles = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2Qbtr"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/people-profiles/src/index.tsx"
    });
    const $7f2f7b5455866fc1$export$9e44232fa48ba2ee = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7f2f7b5455866fc1$var$LazyPeopleProfiles,
            pageId: "people-profiles",
            shouldShowSpinner: true
        });
    const $7f2f7b5455866fc1$export$219b6cc00b2f91a0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("54b5G")).peopleProfilesRoute), ()=>({
            component: $7f2f7b5455866fc1$export$9e44232fa48ba2ee,
            layout: (0, (0, parcelRequire("5UHoB")).layoutWithCondition)(()=>(0, (0, parcelRequire("6s1PB")).expValEquals)('jsm_getting_started_page_for_nple_exp', 'cohort', 'variation'), (0, (0, parcelRequire("6Z2mh")).rightSidebarsLayout), (0, (0, parcelRequire("2BrOV")).globalLayout)),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $7f2f7b5455866fc1$var$LazyPeopleProfiles
            ],
            ufoName: 'people-profiles'
        }));
});
parcelRegister("5UHoB", function(module, exports) {
    $parcel$export(module.exports, "layoutWithCondition", ()=>$201222bac9c3aac5$export$c5db53e93ba35c0f);
    const $201222bac9c3aac5$export$c5db53e93ba35c0f = (conditionGetter, itemTrue, itemFalse)=>({
            get isChromeless () {
                return conditionGetter() ? itemTrue.isChromeless : itemFalse.isChromeless;
            },
            get globalComponents () {
                return conditionGetter() ? itemTrue.globalComponents : itemFalse.globalComponents;
            },
            get rightSidebars () {
                return conditionGetter() ? itemTrue.rightSidebars : itemFalse.rightSidebars;
            }
        });
});
parcelRegister("54b5G", function(module, exports) {
    $parcel$export(module.exports, "peopleProfilesRoute", ()=>$9c4266ad8ee353d0$export$1338132568be849);
    var $65Ltd;
    const $9c4266ad8ee353d0$export$1338132568be849 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PEOPLE_PROFILES),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PEOPLE_INDEX),
        path: '/jira/people/:subPath?'
    };
});
parcelRegister("2Qbtr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("2Lfdl"),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2vt1O")
    ]).then(()=>parcelRequire('3sora'));
});
parcelRegister("3TT71", function(module, exports) {
    $parcel$export(module.exports, "personalSettingsRouteEntries", ()=>$5daf430235f9fc0a$export$d604d3ad2662a845);
    var $5uXOq = parcelRequire("5uXOq");
    var $1WqFo;
    var $hqoB3;
    parcelRequire("c4sFg");
    var $5NVbt;
    var $ffza4;
    var $lkFvK;
    var $3H5ry;
    var $co1wz;
    var $2BrOV;
    var $lmyls;
    var $cRWZh;
    var $1C2yb;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $eOlBz;
    var $ipmBb;
    var $gNStA;
    var $cojyC;
    var $7OYJs;
    var $h1H2H;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $5daf430235f9fc0a$var$LazyLegacyPersonalSettings = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("jwMPq"))), {
        moduleId: "./src/packages/spa-apps/personal-settings-legacy/src/index.tsx"
    });
    const $5daf430235f9fc0a$var$personalSettingsNotificationsEntryPointPage = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("h1H2H")).personalSettingsNotificationsEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).NOTIFICATIONS
    });
    const $5daf430235f9fc0a$var$LazyGeneralPersonalSettings = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1QXuJ"))), {
        moduleId: "./src/packages/spa-apps/personal-settings/general/src/index.tsx"
    });
    const $5daf430235f9fc0a$var$LazyOpsNotificationsPersonalSettings = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9Rv37"))), {
        moduleId: "./src/packages/spa-apps/personal-settings/ops-notifications/src/index.tsx"
    });
    const $5daf430235f9fc0a$var$checkConsolidationOnRouteDependency = (dependencies)=>{
        const { data: data } = dependencies[0, $5a94e356f9d5e220$export$25ee35b01de9d734];
        return (0, (0, parcelRequire("3H5ry")).checkShouldUseJSM)(data);
    };
    const $5daf430235f9fc0a$export$31dadfd5bc64c9c9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5daf430235f9fc0a$var$LazyLegacyPersonalSettings,
            pageId: "personal-settings",
            shouldShowSpinner: true
        });
    const $5daf430235f9fc0a$export$81bedf006ef32751 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5daf430235f9fc0a$var$LazyGeneralPersonalSettings,
            pageId: "personal-settings-general",
            shouldShowSpinner: true
        });
    const $5daf430235f9fc0a$export$e30af76ba1def364 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5daf430235f9fc0a$var$LazyOpsNotificationsPersonalSettings,
            pageId: "personal-settings-notifications",
            shouldShowSpinner: true
        });
    const $5daf430235f9fc0a$var$getLabsResources = ()=>[
            (0, (0, parcelRequire("eOlBz")).newIssueViewTransitionLockInStatusResource),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!(0, (0, parcelRequire("1WqFo")).isFedRamp)(), (0, (0, parcelRequire("ipmBb")).nextBestTaskFeatureResource))
        ];
    const $5daf430235f9fc0a$export$89646e32fa7698db = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cojyC")).legacyPersonalSettingsRoute), ()=>({
            component: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                    to: (0, (0, parcelRequire("1C2yb")).GENERAL_PERSONAL_SETTINGS_PATH)
                }),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PERSONAL_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROFILE
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("hqoB3")).createContactsResource)($5daf430235f9fc0a$var$checkConsolidationOnRouteDependency, [
                    (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                ]),
                (0, (0, parcelRequire("hqoB3")).createNotificationPreferencesResource)($5daf430235f9fc0a$var$checkConsolidationOnRouteDependency, [
                    (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                ]),
                (0, (0, parcelRequire("5NVbt")).eocUserResource),
                (0, (0, parcelRequire("hqoB3")).createMuteResource)($5daf430235f9fc0a$var$checkConsolidationOnRouteDependency, [
                    (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                ]),
                (0, (0, parcelRequire("hqoB3")).createQuietHoursResource)($5daf430235f9fc0a$var$checkConsolidationOnRouteDependency, [
                    (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                ]),
                (0, (0, parcelRequire("hqoB3")).createForwardingRulesResource)($5daf430235f9fc0a$var$checkConsolidationOnRouteDependency, [
                    (0, $5a94e356f9d5e220$export$25ee35b01de9d734)
                ]),
                ...$5daf430235f9fc0a$var$getLabsResources()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $5daf430235f9fc0a$var$LazyLegacyPersonalSettings
            ]
        }));
    const $5daf430235f9fc0a$export$e8b7e9281fc3db35 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cojyC")).generalPersonalSettingsRoute), ()=>({
            component: $5daf430235f9fc0a$export$81bedf006ef32751,
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PERSONAL_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROFILE,
                sidebar: (0, (0, parcelRequire("cRWZh")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...$5daf430235f9fc0a$var$getLabsResources()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $5daf430235f9fc0a$var$LazyGeneralPersonalSettings
            ]
        }));
    const $5daf430235f9fc0a$export$640c1b3b96c9032e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cojyC")).notificationsPersonalSettingsRoute), ()=>({
            component: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                    to: (0, (0, parcelRequire("1C2yb")).getNotificationsPersonalSettingsPath)()
                }),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PERSONAL_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROFILE,
                sidebar: (0, (0, parcelRequire("cRWZh")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            pageId: 'personal-settings-notifications',
            entryPoint () {
                return (0, (0, parcelRequire("co1wz")).ff)('sea-1973-notifications-hub') ? $5daf430235f9fc0a$var$personalSettingsNotificationsEntryPointPage : undefined;
            }
        }));
    const $5daf430235f9fc0a$export$d604d3ad2662a845 = [
        $5daf430235f9fc0a$export$89646e32fa7698db,
        $5daf430235f9fc0a$export$e8b7e9281fc3db35,
        $5daf430235f9fc0a$export$640c1b3b96c9032e,
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cojyC")).opsNotificationsPersonalSettingsRoute), ()=>({
                component: $5daf430235f9fc0a$export$e30af76ba1def364,
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PERSONAL_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROFILE,
                    sidebar: (0, (0, parcelRequire("cRWZh")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                    (0, (0, parcelRequire("hqoB3")).createContactsResource)(),
                    (0, (0, parcelRequire("hqoB3")).createNotificationPreferencesResource)(),
                    (0, (0, parcelRequire("5NVbt")).eocUserResource),
                    (0, (0, parcelRequire("hqoB3")).createMuteResource)(),
                    (0, (0, parcelRequire("hqoB3")).createQuietHoursResource)(),
                    (0, (0, parcelRequire("hqoB3")).createForwardingRulesResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $5daf430235f9fc0a$var$LazyOpsNotificationsPersonalSettings
                ]
            }))
    ];
});
parcelRegister("hqoB3", function(module, exports) {
    $parcel$export(module.exports, "createNotificationPreferencesResource", ()=>$e40e8fd5e625f059$export$731980bd233a4797);
    $parcel$export(module.exports, "createContactsResource", ()=>$e40e8fd5e625f059$export$b9ca444b0be3df97);
    $parcel$export(module.exports, "createMuteResource", ()=>$e40e8fd5e625f059$export$c849cfac68bc6e80);
    $parcel$export(module.exports, "createQuietHoursResource", ()=>$e40e8fd5e625f059$export$efc5e8690061f9cc);
    $parcel$export(module.exports, "createForwardingRulesResource", ()=>$e40e8fd5e625f059$export$5314dca65b4e5888);
    var $dIdda = parcelRequire("dIdda");
    parcelRequire("c4sFg");
    var $5NVbt;
    var $cwSx6;
    const $e40e8fd5e625f059$export$731980bd233a4797 = (checkConsolidationOnRouteDependency, depends)=>(0, $dIdda.createResource)({
            type: 'notificationPreferencesResource',
            getKey: ()=>'notificationPreferencesResource',
            getData: ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("cwSx6")).getNotificationPreferences)();
            },
            isBrowserOnly: true,
            depends: depends
        });
    const $e40e8fd5e625f059$export$b9ca444b0be3df97 = (checkConsolidationOnRouteDependency, depends)=>(0, $dIdda.createResource)({
            type: 'contactsResource',
            getKey: ()=>'contactsResource',
            getData: async ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                const data = await (0, (0, parcelRequire("cwSx6")).getContact)();
                return data.contacts;
            },
            isBrowserOnly: true,
            depends: depends
        });
    const $e40e8fd5e625f059$export$c849cfac68bc6e80 = (checkConsolidationOnRouteDependency, depends)=>(0, $dIdda.createResource)({
            type: 'muteResource',
            getKey: ()=>'muteResource',
            getData: ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("cwSx6")).getMuteDetail)();
            },
            isBrowserOnly: true,
            depends: depends
        });
    const $e40e8fd5e625f059$export$efc5e8690061f9cc = (checkConsolidationOnRouteDependency, depends)=>(0, $dIdda.createResource)({
            type: 'quietHoursResource',
            getKey: ()=>'quietHoursResource',
            getData: ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("cwSx6")).getQuietHoursDetail)();
            },
            isBrowserOnly: true,
            depends: depends
        });
    const $e40e8fd5e625f059$export$5314dca65b4e5888 = (checkConsolidationOnRouteDependency, depends)=>(0, $dIdda.createResource)({
            type: 'forwardingRulesResource',
            getKey: ()=>'forwardingRulesResource',
            getData: ({ dependencies: dependencies })=>{
                const isConsolidated = checkConsolidationOnRouteDependency ? checkConsolidationOnRouteDependency(dependencies) : true;
                if (!isConsolidated) return null;
                return (0, (0, parcelRequire("cwSx6")).getForwardingRules)().then(({ values: values })=>values);
            },
            isBrowserOnly: true,
            depends: depends
        });
});
parcelRegister("cwSx6", function(module, exports) {
    $parcel$export(module.exports, "getNotificationPreferences", ()=>$ac329e4203768d39$export$60e139c3026f21bc);
    $parcel$export(module.exports, "getContact", ()=>$ac329e4203768d39$export$52411745da118fc8);
    $parcel$export(module.exports, "getMuteDetail", ()=>$ac329e4203768d39$export$80a4e62998a806a6);
    $parcel$export(module.exports, "getQuietHoursDetail", ()=>$ac329e4203768d39$export$44a94c74f358d02f);
    $parcel$export(module.exports, "getForwardingRules", ()=>$ac329e4203768d39$export$2161af98e3d645a5);
    var $6GHRr;
    const $ac329e4203768d39$export$60e139c3026f21bc = ()=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/users/notification-preferences`);
    const $ac329e4203768d39$export$52411745da118fc8 = ()=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/users/contact`);
    const $ac329e4203768d39$export$80a4e62998a806a6 = ()=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/users/notifications/mute`);
    const $ac329e4203768d39$export$44a94c74f358d02f = ()=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/users/quiet-hours/details`);
    const $ac329e4203768d39$export$2161af98e3d645a5 = ()=>(0, (0, parcelRequire("6GHRr")).eocFetch)(`/v1/alerts/notifications/forwarding-rules`);
});
parcelRegister("cRWZh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8fc6117fdc2ce1b9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $hPtZI;
    const $8fc6117fdc2ce1b9$var$LazyPersonalSettingsSidebar = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("gzRSC")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/personal-settings/src/index.tsx"
    });
    const $8fc6117fdc2ce1b9$var$PersonalSettingsSidebar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "personalSettings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8fc6117fdc2ce1b9$var$LazyPersonalSettingsSidebar, null));
    var $8fc6117fdc2ce1b9$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($8fc6117fdc2ce1b9$var$PersonalSettingsSidebar);
});
parcelRegister("gzRSC", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("gMZ9X")
    ]).then(()=>parcelRequire('6re9h'));
});
parcelRegister("1C2yb", function(module, exports) {
    $parcel$export(module.exports, "LEGACY_PERSONAL_SETTINGS_PATH", ()=>$63706130a90445cd$export$b468ccdb67523656);
    $parcel$export(module.exports, "GENERAL_PERSONAL_SETTINGS_PATH", ()=>$63706130a90445cd$export$693b70d1bcef8627);
    $parcel$export(module.exports, "NOTIFICATIONS_PERSONAL_SETTINGS_PATH", ()=>$63706130a90445cd$export$21946ea4c58fd4c9);
    $parcel$export(module.exports, "OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH", ()=>$63706130a90445cd$export$2321c59d517801c8);
    $parcel$export(module.exports, "getGeneralPersonalSettingsPath", ()=>$63706130a90445cd$export$db9e3ccc1e5e3317);
    $parcel$export(module.exports, "getNotificationsPersonalSettingsPath", ()=>$63706130a90445cd$export$64a672523a583594);
    var $co1wz;
    const $63706130a90445cd$export$b468ccdb67523656 = '/secure/ViewPersonalSettings.jspa';
    const $63706130a90445cd$export$a974f4af282a75ba = '/jira/settings/personal';
    const $63706130a90445cd$export$693b70d1bcef8627 = `${$63706130a90445cd$export$a974f4af282a75ba}/general`;
    const $63706130a90445cd$export$21946ea4c58fd4c9 = `${$63706130a90445cd$export$a974f4af282a75ba}/notifications`;
    const $63706130a90445cd$export$2321c59d517801c8 = `${$63706130a90445cd$export$a974f4af282a75ba}/alert-notifications`;
    function $63706130a90445cd$export$db9e3ccc1e5e3317() {
        return $63706130a90445cd$export$693b70d1bcef8627;
    }
    function $63706130a90445cd$export$88a45ae8c4b1c664() {
        return $63706130a90445cd$export$2321c59d517801c8;
    }
    function $63706130a90445cd$export$64a672523a583594() {
        if ((0, (0, parcelRequire("co1wz")).ff)('sea-1973-notifications-hub')) return $63706130a90445cd$export$21946ea4c58fd4c9;
        return $63706130a90445cd$export$693b70d1bcef8627;
    }
});
parcelRegister("cojyC", function(module, exports) {
    $parcel$export(module.exports, "legacyPersonalSettingsRoute", ()=>$e797a93ba9e40aac$export$dd556eb586bb36b8);
    $parcel$export(module.exports, "generalPersonalSettingsRoute", ()=>$e797a93ba9e40aac$export$7a6c9715a86f906b);
    $parcel$export(module.exports, "notificationsPersonalSettingsRoute", ()=>$e797a93ba9e40aac$export$55ab09b9d6beb8be);
    $parcel$export(module.exports, "opsNotificationsPersonalSettingsRoute", ()=>$e797a93ba9e40aac$export$68ebdd4eccb7b383);
    $parcel$export(module.exports, "getGeneralPersonalSettingsRouteForLink", ()=>$e797a93ba9e40aac$export$cbf079e07fb96768);
    $parcel$export(module.exports, "getNotificationsPersonalSettingsRouteForLink", ()=>$e797a93ba9e40aac$export$9b4c78a3c84b549f);
    var $65Ltd;
    var $co1wz;
    var $1C2yb;
    var $3zMaf;
    const $e797a93ba9e40aac$export$dd556eb586bb36b8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PERSONAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PERSONAL_SETTINGS),
        path: (0, (0, parcelRequire("1C2yb")).LEGACY_PERSONAL_SETTINGS_PATH)
    };
    const $e797a93ba9e40aac$export$7a6c9715a86f906b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PERSONAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PERSONAL_SETTINGS_GENERAL),
        path: (0, (0, parcelRequire("1C2yb")).GENERAL_PERSONAL_SETTINGS_PATH)
    };
    const $e797a93ba9e40aac$export$55ab09b9d6beb8be = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PERSONAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PERSONAL_SETTINGS_NOTIFICATIONS),
        path: (0, (0, parcelRequire("1C2yb")).NOTIFICATIONS_PERSONAL_SETTINGS_PATH),
        skeleton: (0, (0, parcelRequire("3zMaf")).PersonalSettingsNotificationsAppSkeleton)
    };
    const $e797a93ba9e40aac$export$68ebdd4eccb7b383 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PERSONAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PERSONAL_SETTINGS_OPS_NOTIFICATIONS),
        path: (0, (0, parcelRequire("1C2yb")).OPS_NOTIFICATIONS_PERSONAL_SETTINGS_PATH)
    };
    const $e797a93ba9e40aac$export$cbf079e07fb96768 = ()=>{
        return $e797a93ba9e40aac$export$7a6c9715a86f906b;
    };
    const $e797a93ba9e40aac$export$9b4c78a3c84b549f = ()=>{
        if ((0, (0, parcelRequire("co1wz")).ff)('sea-1973-notifications-hub')) return $e797a93ba9e40aac$export$55ab09b9d6beb8be;
        return $e797a93ba9e40aac$export$7a6c9715a86f906b;
    };
});
parcelRegister("3zMaf", function(module, exports) {
    $parcel$export(module.exports, "PersonalSettingsNotificationsAppSkeleton", ()=>$cd52272f9c2fac90$export$b542eb2d3193b983);
    $parcel$export(module.exports, "PersonalSettingsNotificationsGlobalTableSkeleton", ()=>$cd52272f9c2fac90$export$d58f6bbbc1838cb2);
    $parcel$export(module.exports, "ProjectNotificationAccordionSkeleton", ()=>$cd52272f9c2fac90$export$8cb773cb6fc17338);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $gnABE;
    var $bSzQR = parcelRequire("bSzQR");
    var $D73Nc = parcelRequire("D73Nc");
    var $eVLyC = parcelRequire("eVLyC");
    var $8z1qR = parcelRequire("8z1qR");
    const $cd52272f9c2fac90$var$maxWidthCssStyles = null;
    const $cd52272f9c2fac90$var$customCssStyles = null;
    const $cd52272f9c2fac90$export$b542eb2d3193b983 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($eVLyC))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12f8stt _19pkidpf _2hwx1wug _otyridpf _18u01wug"
            ])
        });
    const $cd52272f9c2fac90$export$d58f6bbbc1838cb2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($cd52272f9c2fac90$var$SkeletonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($bSzQR))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wgmglyw"
            ])
        }));
    const $cd52272f9c2fac90$export$46fc11a564484c9c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($cd52272f9c2fac90$var$SkeletonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($D73Nc))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wgmglyw"
            ])
        }));
    const $cd52272f9c2fac90$export$8cb773cb6fc17338 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($cd52272f9c2fac90$var$SkeletonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($8z1qR))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1wgmglyw"
            ])
        }));
    const $cd52272f9c2fac90$var$SkeletonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_c71ldgin _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bSzQR", function(module, exports) {
    module.exports = new URL("global-table-skeleton-with-projects.tpl.5a5d24b9.svg", import.meta.url).toString();
});
parcelRegister("D73Nc", function(module, exports) {
    module.exports = new URL("mimetype-skeleton.tpl.8b750352.svg", import.meta.url).toString();
});
parcelRegister("eVLyC", function(module, exports) {
    module.exports = new URL("personal-settings-notifications-app-skeleton-with-projects.tpl.d18b3c58.svg", import.meta.url).toString();
});
parcelRegister("8z1qR", function(module, exports) {
    module.exports = new URL("project-accordion-skeleton.tpl.cee2df62.svg", import.meta.url).toString();
});
parcelRegister("h1H2H", function(module, exports) {
    $parcel$export(module.exports, "personalSettingsNotificationsEntryPoint", ()=>$0e73b796ef7555dc$export$44d710abd316d1f1);
    var $7P45F;
    var $2Ftxm;
    var $ikgNX;
    const $0e73b796ef7555dc$export$44d710abd316d1f1 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("fSgLp")), {
            moduleId: "fe0c927e"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    pageAndProject: {
                        options: {
                            fetchPolicy: 'network-only'
                        },
                        parameters: (0, parcelRequire("7P45F")).default,
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectIds: context.query?.projectIds ? context.query.projectIds.split(',') : []
                        }
                    }
                },
                extraProps: {
                    accountId: tenantContext.atlassianAccountId
                }
            })
    });
});
parcelRegister("7P45F", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$49af4b582b9c7470$export$2e2bcd8739ae039);
    var $jA1kf;
    var $aRLRj;
    const $49af4b582b9c7470$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v2 = [
            v1
        ], v3 = [
            v1,
            {
                "kind": "Literal",
                "name": "first",
                "value": 50
            }
        ], v4 = {
            "kind": "ScalarField",
            "name": "id"
        }, v5 = [
            v4,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "xsmall"
                    }
                ]
            }
        ], v6 = [
            {
                "kind": "ScalarField",
                "name": "channel"
            },
            {
                "kind": "ScalarField",
                "name": "isEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "isEditable"
            }
        ], v7 = [
            v4,
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "concreteType": "JiraNotificationChannel",
                "kind": "LinkedField",
                "name": "emailChannel",
                "plural": false,
                "selections": v6
            },
            {
                "concreteType": "JiraNotificationChannel",
                "kind": "LinkedField",
                "name": "inProductChannel",
                "plural": false,
                "selections": v6
            },
            {
                "kind": "ScalarField",
                "name": "category"
            }
        ], v8 = {
            "concreteType": "JiraNotificationPreferences",
            "kind": "LinkedField",
            "name": "preferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueAssigned",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueUpdated",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueDeleted",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentCreated",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentEdited",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentDeleted",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueCreated",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueMoved",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "mentionsCombined",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "worklogCombined",
                    "plural": false,
                    "selections": v7
                },
                {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "miscellaneousIssueEventCombined",
                    "plural": false,
                    "selections": v7
                }
            ]
        }, v9 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0
                ],
                "kind": "Fragment",
                "name": "ui_NotificationsPageAndProjectQuery",
                "selections": [
                    {
                        "kind": "FragmentSpread",
                        "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_projects"
                    },
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v2,
                                        "concreteType": "JiraNotificationGlobalPreference",
                                        "kind": "LinkedField",
                                        "name": "notificationGlobalPreference",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "globalNotificationsConfigTable_personalSettingsNotificationsConfigTable_GlobalNotificationConfigTable_allPreferencesData"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "globalNotificationsConfigTable_personalSettingsNotificationsConfigTable_GlobalNotificationConfigTableNew_allPreferencesData"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "JiraNotificationOptions",
                                                    "kind": "LinkedField",
                                                    "name": "options",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "notificationPreferencesOptionsWrapper_personalSettingsPreferenceFields_NotificationPreferencesOptions"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.notificationGlobalPreference.options"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.notificationGlobalPreference"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v0,
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider"
                    },
                    {
                        "defaultValue": null,
                        "kind": "LocalArgument",
                        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneousissueeventscombinedtyperelayprovider"
                    }
                ],
                "kind": "Operation",
                "name": "ui_NotificationsPageAndProjectQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "concreteType": "JiraNotificationProjectPreferenceConnection",
                                "kind": "LinkedField",
                                "name": "allNotificationProjectPreferences",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectNotificationPreferenceEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraNotificationProjectPreferences",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v4,
                                                    {
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "project",
                                                        "plural": false,
                                                        "selections": v5
                                                    },
                                                    v8,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    v9
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "totalCount"
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    v9
                                ]
                            },
                            {
                                "args": v3,
                                "filters": [
                                    "cloudId"
                                ],
                                "handle": "connection",
                                "key": "projects_allNotificationProjectPreferences",
                                "kind": "LinkedHandle",
                                "name": "allNotificationProjectPreferences"
                            },
                            {
                                "args": v2,
                                "concreteType": "JiraNotificationGlobalPreference",
                                "kind": "LinkedField",
                                "name": "notificationGlobalPreference",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraNotificationOptions",
                                        "kind": "LinkedField",
                                        "name": "options",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "isEmailNotificationEnabled"
                                            },
                                            v4,
                                            {
                                                "kind": "ScalarField",
                                                "name": "notifyWhenRoleAssigneeEnabled"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "notifyWhenRoleReporterEnabled"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "notifyOwnChangesEnabled"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "batchWindow"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "dailyBatchLocalTime"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "emailMimeType"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "isEmailMimeTypeEditable"
                                            }
                                        ]
                                    },
                                    v8
                                ]
                            },
                            {
                                "alias": "allJiraProjectsForModal",
                                "args": [
                                    v1,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "notificationConfigurationState": "DEFAULT",
                                            "sortBy": {
                                                "sortBy": "NAME"
                                            }
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 5
                                    }
                                ],
                                "concreteType": "JiraProjectConnection",
                                "kind": "LinkedField",
                                "name": "allJiraProjects",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": v5
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "53f3d60954200f154c88e73ebc6b1de039499c465fe34dd17387911de4878f3c",
                "metadata": {},
                "name": "ui_NotificationsPageAndProjectQuery",
                "operationKind": "query",
                "text": null,
                "providedVariables": {
                    "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider": (0, (0, parcelRequire("jA1kf")).default),
                    "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneousissueeventscombinedtyperelayprovider": (0, (0, parcelRequire("aRLRj")).default)
                }
            }
        };
    }();
    $49af4b582b9c7470$var$node.hash = "1621d2a295f8f96a16a6e0ec0a3befd7";
    var $49af4b582b9c7470$export$2e2bcd8739ae039 = $49af4b582b9c7470$var$node;
});
parcelRegister("jA1kf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$349f2b9cab96c314$export$2e2bcd8739ae039);
    var $349f2b9cab96c314$export$2e2bcd8739ae039 = {
        get () {
            return true;
        }
    };
});
parcelRegister("aRLRj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$511f4f2fc3e0f0f3$export$2e2bcd8739ae039);
    var $511f4f2fc3e0f0f3$export$2e2bcd8739ae039 = {
        get () {
            return true;
        }
    };
});
parcelRegister("fSgLp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("5d5n9")
    ]).then(()=>parcelRequire('4DJNq'));
});
parcelRegister("jwMPq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("64osF")
    ]).then(()=>parcelRequire('3hooO'));
});
parcelRegister("1QXuJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dsU72")
    ]).then(()=>parcelRequire('6keru'));
});
parcelRegister("9Rv37", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3dsjz")
    ]).then(()=>parcelRequire('aV66n'));
});
parcelRegister("1k4F6", function(module, exports) {
    $parcel$export(module.exports, "polarisRouteEntries", ()=>$a401463e87f56f84$export$44e0cb320cb148ed);
    var $3L1EU;
    var $g5olQ;
    var $ecUH3;
    var $6okEU;
    var $9YDUs;
    var $h3JFI;
    const $a401463e87f56f84$export$44e0cb320cb148ed = [
        (0, (0, parcelRequire("3L1EU")).polarisCollectionsRouteEntry),
        (0, (0, parcelRequire("g5olQ")).polarisIdeasRouteEntry),
        (0, (0, parcelRequire("ecUH3")).polarisOnboardingRouteEntry),
        (0, (0, parcelRequire("6okEU")).polarisSettingsAccessRouteEntry),
        (0, (0, parcelRequire("9YDUs")).polarisSettingsGlobalFieldsRouteEntry),
        (0, (0, parcelRequire("h3JFI")).polarisUnlicensedRouteEntry)
    ];
});
parcelRegister("3L1EU", function(module, exports) {
    $parcel$export(module.exports, "polarisCollectionsRouteEntry", ()=>$4aedad13e1b8926d$export$a034dc25c21d1029);
    var $ffza4;
    var $4R6GH;
    var $2BrOV;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $lvXAA;
    var $iI3aS;
    const $4aedad13e1b8926d$export$a034dc25c21d1029 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lvXAA")).polarisCollectionsRoute), ()=>({
            ufoName: 'jpd.collections',
            component: (0, (0, parcelRequire("iI3aS")).default),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            canTransitionIn: (current, next)=>{
                if ((0, (0, parcelRequire("4R6GH")).fg)('jira_nav4')) {
                    if (!(0, (0, parcelRequire("4R6GH")).fg)('jpd-nav-v4-disable-page-refresh-to-collection')) {
                        if ((0, (0, parcelRequire("4R6GH")).fg)('jpd-sidebar-v4-for-roadmaps-overview')) {
                            if (current?.match?.params?.collectionUUID && !next?.match?.params?.collectionUUID || !current?.match?.params?.collectionUUID && next?.match?.params?.collectionUUID) return false;
                            return true;
                        }
                        if (current.match.path !== next.match.path) return false;
                    }
                }
                return true;
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("iI3aS")).LazyCollectionsPage)
            ]
        }));
});
parcelRegister("lvXAA", function(module, exports) {
    $parcel$export(module.exports, "polarisIdeasRoute", ()=>$cf474476a77ac482$export$54c333cd4ed2d70e);
    $parcel$export(module.exports, "polarisCollectionsRoute", ()=>$cf474476a77ac482$export$d415b74f78a5f159);
    $parcel$export(module.exports, "polarisOnboardingRoute", ()=>$cf474476a77ac482$export$6696e9deb45fe980);
    $parcel$export(module.exports, "polarisSettingsAccessRoute", ()=>$cf474476a77ac482$export$bfdcdf76e802d67d);
    $parcel$export(module.exports, "polarisSettingsGlobalFieldsRoute", ()=>$cf474476a77ac482$export$d1d77b6a84982ab8);
    $parcel$export(module.exports, "polarisUnlicensedRoute", ()=>$cf474476a77ac482$export$32b1bc71501d2751);
    var $65Ltd;
    const $cf474476a77ac482$export$54c333cd4ed2d70e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_POLARIS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_IDEAS),
        path: '/jira/polaris/projects/:projectKey/ideas/:section?/:resource?',
        exact: true
    };
    const $cf474476a77ac482$export$d415b74f78a5f159 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_POLARIS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_COLLECTIONS),
        path: '/jira/polaris/roadmaps/:collectionUUID?/:section?/:resource?',
        query: [
            'projects?',
            'owners?'
        ],
        exact: true
    };
    const $cf474476a77ac482$export$6696e9deb45fe980 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_POLARIS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_ONBOARDING),
        path: '/welcome/discovery',
        exact: true
    };
    const $cf474476a77ac482$export$bfdcdf76e802d67d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_SETTINGS_ACCESS),
        path: '/jira/settings/products/jira-product-discovery/access',
        exact: true
    };
    const $cf474476a77ac482$export$d1d77b6a84982ab8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_SETTINGS_GLOBAL_FIELDS),
        path: '/jira/settings/products/jira-product-discovery/global-fields',
        exact: true
    };
    const $cf474476a77ac482$export$32b1bc71501d2751 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_POLARIS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_POLARIS_UNLICENSED),
        path: '/jira/polaris/unlicensed',
        exact: true
    };
});
parcelRegister("iI3aS", function(module, exports) {
    $parcel$export(module.exports, "LazyCollectionsPage", ()=>$1bfc7c5d195e4066$export$f7960e7dbd7e5265);
    $parcel$export(module.exports, "default", ()=>$1bfc7c5d195e4066$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dWQF5;
    var $7yO8g;
    var $5j7Th;
    var $9OXo1;
    var $hPtZI;
    var $dIdda = parcelRequire("dIdda");
    const $1bfc7c5d195e4066$export$f7960e7dbd7e5265 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("bQinH"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/polaris/collections/src/index.tsx"
    });
    const $1bfc7c5d195e4066$var$useJpdLicensed = ()=>{
        const context = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return context.licensedProducts['jira-product-discovery'];
    };
    const $1bfc7c5d195e4066$export$3bba33442c4150b1 = ()=>{
        const jpdLicensed = $1bfc7c5d195e4066$var$useJpdLicensed();
        const crossProjectViewsEnabled = (0, (0, parcelRequire("dWQF5")).useIsCrossProjectViewsEnabled)();
        if (!jpdLicensed) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: "/jira/polaris/unlicensed"
        });
        if (!crossProjectViewsEnabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: "/jira"
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1bfc7c5d195e4066$export$f7960e7dbd7e5265,
            pageId: "async-polaris-collections",
            shouldShowSpinner: false
        });
    };
    var $1bfc7c5d195e4066$export$2e2bcd8739ae039 = $1bfc7c5d195e4066$export$3bba33442c4150b1;
});
parcelRegister("dWQF5", function(module, exports) {
    $parcel$export(module.exports, "useIsViewPermissionsEnabled", ()=>$901349e77566565e$export$a94405ffcb20c356);
    $parcel$export(module.exports, "useIsCrossProjectViewsEnabled", ()=>$901349e77566565e$export$34d097b1cd6f89c1);
    var $co1wz;
    var $efvDm;
    var $ldyPw;
    var $9OXo1;
    const $901349e77566565e$export$8aa8a7878fd61770 = ()=>{
        const { appEditions: appEditions } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const jpdEdition = (0, (0, parcelRequire("ldyPw")).getEdition)((0, (0, parcelRequire("efvDm")).JIRA_PRODUCT_DISCOVERY), appEditions);
        return jpdEdition === (0, (0, parcelRequire("ldyPw")).toEdition)((0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION));
    };
    const $901349e77566565e$export$a94405ffcb20c356 = ()=>{
        const isPremium = $901349e77566565e$export$8aa8a7878fd61770();
        return isPremium && (0, (0, parcelRequire("co1wz")).ff)('polaris.view-permissions_plaoi');
    };
    const $901349e77566565e$export$34d097b1cd6f89c1 = ()=>{
        const isPremium = $901349e77566565e$export$8aa8a7878fd61770();
        return isPremium;
    };
});
parcelRegister("bQinH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("2Lfdl"),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4iOXD")
    ]).then(()=>parcelRequire('jaSwr'));
});
parcelRegister("g5olQ", function(module, exports) {
    $parcel$export(module.exports, "polarisIdeasRouteEntry", ()=>$a75ffafad7078936$export$26631f98f007b2d2);
    var $ffza4;
    var $4R6GH;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $3HwlS;
    var $eviST;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $lvXAA;
    var $hO84v;
    const $a75ffafad7078936$export$26631f98f007b2d2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lvXAA")).polarisIdeasRoute), ()=>({
            ufoName: 'jpd.project',
            component: (0, (0, parcelRequire("hO84v")).default),
            layout: (0, (0, parcelRequire("eviST")).polarisProjectLayout),
            canTransitionIn: (current, next)=>{
                if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && !(0, (0, parcelRequire("4R6GH")).fg)('jpd-nav-v4-disable-page-refresh-between-projects') && current?.match?.params?.projectKey && next?.match?.params?.projectKey && current.match.params.projectKey !== next.match.params.projectKey) return false;
                return true;
            },
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("hO84v")).LazyIdeasPage)
            ]
        }));
});
parcelRegister("eviST", function(module, exports) {
    $parcel$export(module.exports, "polarisProjectLayout", ()=>$501e6cef37d28e94$export$d5273c1a2e2fe212);
    var $1Du13;
    var $1XrjK;
    const $501e6cef37d28e94$export$d5273c1a2e2fe212 = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("1Du13")).projectLayout));
});
parcelRegister("hO84v", function(module, exports) {
    $parcel$export(module.exports, "LazyIdeasPage", ()=>$9c1678c5da04bd73$export$3fd7cf4494189548);
    $parcel$export(module.exports, "default", ()=>$9c1678c5da04bd73$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $9OXo1;
    var $hPtZI;
    var $dIdda = parcelRequire("dIdda");
    const $9c1678c5da04bd73$export$3fd7cf4494189548 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("jecZ6"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/polaris/ideas/src/index.tsx"
    });
    const $9c1678c5da04bd73$var$useJpdLicensed = ()=>{
        const context = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return context.licensedProducts['jira-product-discovery'];
    };
    const $9c1678c5da04bd73$export$8e495e768b5bbae5 = ()=>{
        const jpdLicensed = $9c1678c5da04bd73$var$useJpdLicensed();
        if (!jpdLicensed) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: "/jira/polaris/unlicensed"
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9c1678c5da04bd73$export$3fd7cf4494189548,
            pageId: "async-polaris-ideas",
            shouldShowSpinner: false
        });
    };
    var $9c1678c5da04bd73$export$2e2bcd8739ae039 = $9c1678c5da04bd73$export$8e495e768b5bbae5;
});
parcelRegister("jecZ6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("2Lfdl"),
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2ZyA4")
    ]).then(()=>parcelRequire('glCkY'));
});
parcelRegister("ecUH3", function(module, exports) {
    $parcel$export(module.exports, "polarisOnboardingRouteEntry", ()=>$9a1e9d5292b9a0dc$export$a297a71cb150e2af);
    var $ffza4;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $aFVvc;
    var $lvXAA;
    var $dQc5Q;
    const $9a1e9d5292b9a0dc$export$a297a71cb150e2af = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lvXAA")).polarisOnboardingRoute), ()=>({
            component: (0, (0, parcelRequire("dQc5Q")).default),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            canTransitionIn: ()=>true,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("aFVvc")).projectCreatePermissionsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("dQc5Q")).LazyOnboardingPage)
            ]
        }));
});
parcelRegister("dQc5Q", function(module, exports) {
    $parcel$export(module.exports, "LazyOnboardingPage", ()=>$ff87f692d7c58a17$export$13889cc3ce0d5a93);
    $parcel$export(module.exports, "default", ()=>$ff87f692d7c58a17$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $ff87f692d7c58a17$export$13889cc3ce0d5a93 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lqC9u"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/polaris/onboarding/src/index.tsx"
    });
    var $ff87f692d7c58a17$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ff87f692d7c58a17$export$13889cc3ce0d5a93,
            pageId: "async-polaris-onboarding",
            shouldShowSpinner: false
        });
});
parcelRegister("lqC9u", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("5kvjN")
    ]).then(()=>parcelRequire('2PQGe'));
});
parcelRegister("6okEU", function(module, exports) {
    $parcel$export(module.exports, "polarisSettingsAccessRouteEntry", ()=>$23f05070dbae84f0$export$9c0f51630c25c3d);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $lvXAA;
    var $4csue;
    const $23f05070dbae84f0$export$9c0f51630c25c3d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lvXAA")).polarisSettingsAccessRoute), ()=>({
            component: (0, (0, parcelRequire("4csue")).AccessSettingsPage),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("4csue")).LazyAccessSettingsPage)
            ]
        }));
});
parcelRegister("4csue", function(module, exports) {
    $parcel$export(module.exports, "LazyAccessSettingsPage", ()=>$ff4634525ed299f8$export$b66ea0dcd38af7f0);
    $parcel$export(module.exports, "AccessSettingsPage", ()=>$ff4634525ed299f8$export$d46497fe68b0853c);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $ff4634525ed299f8$export$b66ea0dcd38af7f0 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3K3ey"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/polaris/settings-access/src/index.tsx"
    });
    const $ff4634525ed299f8$export$d46497fe68b0853c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ff4634525ed299f8$export$b66ea0dcd38af7f0,
            pageId: "async-polaris-settings-access",
            shouldShowSpinner: false
        });
});
parcelRegister("3K3ey", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6iZL1")
    ]).then(()=>parcelRequire('ab4oe'));
});
parcelRegister("9YDUs", function(module, exports) {
    $parcel$export(module.exports, "polarisSettingsGlobalFieldsRouteEntry", ()=>$8b674ae9037c6c90$export$e29465c661741392);
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $lvXAA;
    var $6gpmn;
    const $8b674ae9037c6c90$export$e29465c661741392 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lvXAA")).polarisSettingsGlobalFieldsRoute), ()=>({
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            entryPoint () {
                return 0, (0, parcelRequire("6gpmn")).polarisProductGlobalFieldsSettingsPageEntryPoint;
            }
        }));
});
parcelRegister("6gpmn", function(module, exports) {
    $parcel$export(module.exports, "polarisProductGlobalFieldsSettingsPageEntryPoint", ()=>$dd5db072b96b7a9a$export$c682ebcd2290352f);
    var $lkFvK;
    var $lmyls;
    var $gZZ5s;
    const $dd5db072b96b7a9a$export$c682ebcd2290352f = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("gZZ5s")).polarisProductGlobalFieldsSettingsEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS
    });
});
parcelRegister("gZZ5s", function(module, exports) {
    $parcel$export(module.exports, "polarisProductGlobalFieldsSettingsEntryPoint", ()=>$7946c690dff6c696$export$f2f24531058bc251);
    var $2Ftxm;
    var $ikgNX;
    const $7946c690dff6c696$export$f2f24531058bc251 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("2mQtY")), {
            moduleId: "fead11bc"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("2mQtY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jhjZS")
    ]).then(()=>parcelRequire('b26tT'));
});
parcelRegister("h3JFI", function(module, exports) {
    $parcel$export(module.exports, "polarisUnlicensedRouteEntry", ()=>$ed78a6ddbb53401e$export$f975154b9b0ce777);
    var $ffza4;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $aFVvc;
    var $lvXAA;
    var $5gkML;
    const $ed78a6ddbb53401e$export$f975154b9b0ce777 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lvXAA")).polarisUnlicensedRoute), ()=>({
            component: (0, (0, parcelRequire("5gkML")).default),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            canTransitionIn: ()=>true,
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("aFVvc")).projectCreatePermissionsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("5gkML")).LazyUnlicensedPage)
            ]
        }));
});
parcelRegister("5gkML", function(module, exports) {
    $parcel$export(module.exports, "LazyUnlicensedPage", ()=>$14579de685a40428$export$394984ca86b38b8f);
    $parcel$export(module.exports, "default", ()=>$14579de685a40428$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $14579de685a40428$export$394984ca86b38b8f = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("i4r4O"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/polaris/unlicensed/src/index.tsx"
    });
    var $14579de685a40428$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $14579de685a40428$export$394984ca86b38b8f,
            pageId: "async-polaris-unlicensed",
            shouldShowSpinner: false
        });
});
parcelRegister("i4r4O", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("c1qtf")
    ]).then(()=>parcelRequire('5KpQH'));
});
parcelRegister("hFTXE", function(module, exports) {
    $parcel$export(module.exports, "productsJsmChatopsAndVideosToolsRouteEntry", ()=>$070da13ff0ee1dfd$export$8b55e723205ec5f3);
    var $1WqFo;
    var $ffza4;
    var $7XYc4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $iTMlN;
    var $2G9Bk;
    var $3RJkv;
    var $5lsNZ;
    var $1p0qF;
    var $j78rb;
    const $070da13ff0ee1dfd$export$8b55e723205ec5f3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1p0qF")).productsJsmChatopsAndVideosToolsRoute), ()=>({
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("1WqFo")).isFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, (0, parcelRequire("j78rb")).default)),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default),
                horizontal: (0, (0, parcelRequire("iTMlN")).AsyncHorizontalOperationsConfigurationNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("iTMlN")).LazyHorizontalOperationsConfigurationNav),
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("j78rb")).LazyProductsJsmChatopsAndVideoTools)
            ]
        }));
});
parcelRegister("1p0qF", function(module, exports) {
    $parcel$export(module.exports, "productsJsmChatopsAndVideosToolsRoute", ()=>$fd7d06f493534a34$export$7c663ddc097df1e8);
    var $65Ltd;
    const $fd7d06f493534a34$export$7c663ddc097df1e8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_CHATOPS_AND_VIDEOS_TOOLS),
        path: '/jira/settings/products/ops/jira-service-management-chatops-and-video-tools',
        exact: true
    };
});
parcelRegister("j78rb", function(module, exports) {
    $parcel$export(module.exports, "LazyProductsJsmChatopsAndVideoTools", ()=>$2b1085a0fa643a34$export$1b7f55251df02fe9);
    $parcel$export(module.exports, "default", ()=>$2b1085a0fa643a34$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $2b1085a0fa643a34$export$1b7f55251df02fe9 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("jrDYR"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-chatops-and-video-tools/src/index.tsx"
    });
    var $2b1085a0fa643a34$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2b1085a0fa643a34$export$1b7f55251df02fe9,
            pageId: "products-jsm-chatops-and-video-tools",
            shouldShowSpinner: false
        });
});
parcelRegister("jrDYR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("g6LyJ")
    ]).then(()=>parcelRequire('1H43T'));
});
parcelRegister("7XDK7", function(module, exports) {
    $parcel$export(module.exports, "productsJsmComplianceRouteEntry", ()=>$174710657e8d90a3$export$9cc9423a3967333b);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $ln45z;
    var $9WIUh;
    const $174710657e8d90a3$export$9cc9423a3967333b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ln45z")).productsJsmComplianceRoute), ()=>({
            component: (0, (0, parcelRequire("9WIUh")).default),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("9WIUh")).LazyProductsJsmCompliance)
            ],
            ufoName: 'admin.jsm-compliance'
        }));
});
parcelRegister("ln45z", function(module, exports) {
    $parcel$export(module.exports, "productsJsmComplianceRoute", ()=>$08e82cf7bae7e6bd$export$6196bf08f64419da);
    var $65Ltd;
    const $08e82cf7bae7e6bd$export$6196bf08f64419da = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_COMPLIANCE),
        path: '/jira/settings/products/jira-service-management-compliance',
        exact: true
    };
});
parcelRegister("9WIUh", function(module, exports) {
    $parcel$export(module.exports, "LazyProductsJsmCompliance", ()=>$62ef4b19010ca280$export$159d8c0e1862cd2b);
    $parcel$export(module.exports, "default", ()=>$62ef4b19010ca280$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $62ef4b19010ca280$export$159d8c0e1862cd2b = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("rdcLu"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-compliance/src/index.tsx"
    });
    var $62ef4b19010ca280$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $62ef4b19010ca280$export$159d8c0e1862cd2b,
            pageId: "products-jsm-compliance",
            shouldShowSpinner: false
        });
});
parcelRegister("rdcLu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cbWbk")
    ]).then(()=>parcelRequire('dxuco'));
});
parcelRegister("afZWf", function(module, exports) {
    $parcel$export(module.exports, "productsJsmConfigurationRouteEntry", ()=>$774aaf4ac519071a$export$461f2b06a7a914db);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $ic40n;
    var $eKojW;
    const $774aaf4ac519071a$export$461f2b06a7a914db = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ic40n")).productsJsmConfigurationRoute), ()=>({
            ufoName: 'admin.jsm-configuration',
            component: (0, (0, parcelRequire("eKojW")).default),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("eKojW")).LazyProductsJsmConfiguration)
            ]
        }));
});
parcelRegister("ic40n", function(module, exports) {
    $parcel$export(module.exports, "productsJsmConfigurationRoute", ()=>$4c00404c905ea593$export$2ad48fbde4743a97);
    var $65Ltd;
    const $4c00404c905ea593$export$2ad48fbde4743a97 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_CONFIGURATION),
        path: '/jira/settings/products/jira-service-management-configuration',
        exact: true
    };
});
parcelRegister("eKojW", function(module, exports) {
    $parcel$export(module.exports, "LazyProductsJsmConfiguration", ()=>$2e07bdac6faf88fe$export$aa3f3d5ca376f305);
    $parcel$export(module.exports, "default", ()=>$2e07bdac6faf88fe$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $2e07bdac6faf88fe$export$aa3f3d5ca376f305 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("jkggo"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-configuration/src/index.tsx"
    });
    var $2e07bdac6faf88fe$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2e07bdac6faf88fe$export$aa3f3d5ca376f305,
            pageId: "products-jsm-configuration",
            shouldShowSpinner: false
        });
});
parcelRegister("jkggo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("76E7u")
    ]).then(()=>parcelRequire('14xmF'));
});
parcelRegister("kz9Ms", function(module, exports) {
    $parcel$export(module.exports, "productsJsmEmailRequestsRouteEntry", ()=>$b3d6f3f852ae8387$export$3f8d7424a47f4dd);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $9tEPi;
    var $HR4Qz;
    const $b3d6f3f852ae8387$export$3f8d7424a47f4dd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9tEPi")).productsJsmEmailRequestsRoute), ()=>({
            ufoName: 'admin.jsm-email-requests',
            component: (0, (0, parcelRequire("HR4Qz")).default),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("HR4Qz")).LazyProductsJsmEmailRequests)
            ]
        }));
});
parcelRegister("9tEPi", function(module, exports) {
    $parcel$export(module.exports, "productsJsmEmailRequestsRoute", ()=>$39e09a7f118d3e37$export$6288bb6ea42acf0c);
    var $65Ltd;
    const $39e09a7f118d3e37$export$6288bb6ea42acf0c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_EMAIL_REQUESTS),
        path: '/jira/settings/products/jira-service-management-email-requests',
        exact: true
    };
});
parcelRegister("HR4Qz", function(module, exports) {
    $parcel$export(module.exports, "LazyProductsJsmEmailRequests", ()=>$f8c99b7a302373fc$export$4c9d90d0caf04d67);
    $parcel$export(module.exports, "default", ()=>$f8c99b7a302373fc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $f8c99b7a302373fc$export$4c9d90d0caf04d67 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9yb6w"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-email-requests/src/index.tsx"
    });
    var $f8c99b7a302373fc$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f8c99b7a302373fc$export$4c9d90d0caf04d67,
            pageId: "products-jsm-email-requests",
            shouldShowSpinner: false
        });
});
parcelRegister("9yb6w", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("245Fj")
    ]).then(()=>parcelRequire('c81zX'));
});
parcelRegister("7UKjs", function(module, exports) {
    $parcel$export(module.exports, "productsJsmFeatureUsageRouteEntry", ()=>$ff94c4ea1a42404b$export$80a3e4dda2dcd1a4);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $kJYlA;
    var $gRzZD;
    var $3FCb0;
    const $ff94c4ea1a42404b$export$80a3e4dda2dcd1a4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kJYlA")).productsJsmFeatureUsageRoute), ()=>({
            component: (0, (0, parcelRequire("3FCb0")).default),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("gRzZD")).workspaceResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("3FCb0")).LazyProductsJsmFeatureUsage)
            ]
        }));
});
parcelRegister("kJYlA", function(module, exports) {
    $parcel$export(module.exports, "productsJsmFeatureUsageRoute", ()=>$a10f73d8276a285a$export$f98dec539fffaa15);
    var $65Ltd;
    const $a10f73d8276a285a$export$f98dec539fffaa15 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_FEATURE_USAGE),
        path: '/jira/settings/products/servicedesk/feature-usage',
        exact: true
    };
});
parcelRegister("3FCb0", function(module, exports) {
    $parcel$export(module.exports, "LazyProductsJsmFeatureUsage", ()=>$48028ef535c008c9$export$5ad1c1e822bd5d34);
    $parcel$export(module.exports, "default", ()=>$48028ef535c008c9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $48028ef535c008c9$export$5ad1c1e822bd5d34 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("Sfb3W"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-feature-usage/src/index.tsx"
    });
    var $48028ef535c008c9$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $48028ef535c008c9$export$5ad1c1e822bd5d34,
            pageId: "products-jsm-feature-usage",
            shouldShowSpinner: false
        });
});
parcelRegister("Sfb3W", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4vv1Q")
    ]).then(()=>parcelRequire('g4KKw'));
});
parcelRegister("4uVxF", function(module, exports) {
    $parcel$export(module.exports, "productsJsmGlobalOpsReportsRouteEntry", ()=>$299013a509e9e419$export$6a7fc41fb2523290);
    $parcel$export(module.exports, "productsJsmGlobalOpsReports1RouteEntry", ()=>$299013a509e9e419$export$6d6efd297963f785);
    var $cowY1;
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $8lQTm;
    var $4HfNx;
    const $299013a509e9e419$export$6a7fc41fb2523290 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8lQTm")).productsJsmGlobalOpsReportsRoute), ()=>({
            component: (0, (0, parcelRequire("4HfNx")).GlobalOpsReports),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("cowY1")).resources),
                (0, (0, parcelRequire("cowY1")).opsReportsPermissionResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("4HfNx")).LazyOpsReportsRedirect)
            ]
        }));
    const $299013a509e9e419$export$6d6efd297963f785 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8lQTm")).productsJsmGlobalOpsReports1Route), ()=>({
            component: (0, (0, parcelRequire("4HfNx")).OpsReportsRedirect),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                ...(0, (0, parcelRequire("cowY1")).resources),
                (0, (0, parcelRequire("cowY1")).opsReportsPermissionResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("4HfNx")).LazyGlobalOpsReports)
            ]
        }));
});
parcelRegister("8lQTm", function(module, exports) {
    $parcel$export(module.exports, "productsJsmGlobalOpsReportsRoute", ()=>$65cc4cb0f286e501$export$d92d66762943b115);
    $parcel$export(module.exports, "productsJsmGlobalOpsReports1Route", ()=>$65cc4cb0f286e501$export$6b3539e7e6bf13e8);
    var $65Ltd;
    const $65cc4cb0f286e501$export$d92d66762943b115 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_GLOBAL_OPS_REPORTS),
        path: '/jira/settings/products/ops/reports/:dashboardId',
        exact: true
    };
    const $65cc4cb0f286e501$export$6b3539e7e6bf13e8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_GLOBAL_OPS_REPORTS),
        path: '/jira/settings/products/ops/reports',
        exact: true
    };
});
parcelRegister("4HfNx", function(module, exports) {
    $parcel$export(module.exports, "LazyOpsReportsRedirect", ()=>$59dec6d88aab4fac$export$d33ea1a773b744e);
    $parcel$export(module.exports, "LazyGlobalOpsReports", ()=>$59dec6d88aab4fac$export$66850ec5549adba6);
    $parcel$export(module.exports, "OpsReportsRedirect", ()=>$59dec6d88aab4fac$export$22253dbadb46d0cf);
    $parcel$export(module.exports, "GlobalOpsReports", ()=>$59dec6d88aab4fac$export$648ddf2d1f8b1c3f);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $59dec6d88aab4fac$export$2404f0e35deca592 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("jubOI")), {
        moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
    });
    const $59dec6d88aab4fac$export$d33ea1a773b744e = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("jubOI")).then((exportedMembers)=>exportedMembers.OpsReportsRedirect), {
        moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
    });
    const $59dec6d88aab4fac$export$66850ec5549adba6 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("jubOI")).then((exportedMembers)=>exportedMembers.GlobalOpsReports), {
        moduleId: "./src/packages/eoc/ops-reports/src/index.tsx"
    });
    const $59dec6d88aab4fac$export$22253dbadb46d0cf = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $59dec6d88aab4fac$export$d33ea1a773b744e,
            pageId: "async-jira-eoc-ops-reports-redirect",
            shouldShowSpinner: false
        });
    const $59dec6d88aab4fac$export$648ddf2d1f8b1c3f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $59dec6d88aab4fac$export$66850ec5549adba6,
            pageId: "async-jira-eoc-global-ops-reports",
            shouldShowSpinner: false
        });
    const $59dec6d88aab4fac$export$87e6a54b4f5dc91e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $59dec6d88aab4fac$export$2404f0e35deca592,
            pageId: "async-jira-eoc-ops-reports",
            shouldShowSpinner: false
        });
});
parcelRegister("5LJL6", function(module, exports) {
    $parcel$export(module.exports, "productsJsmIncidentManagementToolsRouteEntry", ()=>$a9989e069a7a91c8$export$773f8e3318be1dd5);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $1xBLC;
    var $6MP9S;
    const $a9989e069a7a91c8$export$773f8e3318be1dd5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1xBLC")).productsJsmIncidentManagementToolsRoute), ()=>({
            component: (0, (0, parcelRequire("6MP9S")).default),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("6MP9S")).LazyProductsJsmIncidentManagementTools)
            ]
        }));
});
parcelRegister("1xBLC", function(module, exports) {
    $parcel$export(module.exports, "productsJsmIncidentManagementToolsRoute", ()=>$8638548b7cc72441$export$da6d538ddabade32);
    var $65Ltd;
    const $8638548b7cc72441$export$da6d538ddabade32 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_INCIDENT_MANAGEMENT_TOOLS),
        path: '/jira/settings/products/jira-service-management-incident-management-tools',
        exact: true
    };
});
parcelRegister("6MP9S", function(module, exports) {
    $parcel$export(module.exports, "LazyProductsJsmIncidentManagementTools", ()=>$63d70171d6cec69e$export$f541eb9b8f00bfaf);
    $parcel$export(module.exports, "default", ()=>$63d70171d6cec69e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $63d70171d6cec69e$export$f541eb9b8f00bfaf = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("ajzu3"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/products-jsm-incident-management-tools/src/index.tsx"
    });
    var $63d70171d6cec69e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $63d70171d6cec69e$export$f541eb9b8f00bfaf,
            pageId: "products-jsm-incident-management-tools",
            shouldShowSpinner: false
        });
});
parcelRegister("ajzu3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("Z8lzP")
    ]).then(()=>parcelRequire('joBQW'));
});
parcelRegister("6vUKc", function(module, exports) {
    $parcel$export(module.exports, "productsJsmKbPermissionsRouteEntry", ()=>$3f056040ba7b93df$export$717e134eb971b450);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $7SI0i;
    var $knyuK;
    const $3f056040ba7b93df$export$717e134eb971b450 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("7SI0i")).productsJsmKbPermissionsRoute), ()=>({
            component: (0, (0, parcelRequire("knyuK")).default),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("knyuK")).LazyProductsJsmKbPermissions)
            ]
        }));
});
parcelRegister("7SI0i", function(module, exports) {
    $parcel$export(module.exports, "productsJsmKbPermissionsRoute", ()=>$f2c102c6218d46df$export$339486410c7a783f);
    var $65Ltd;
    const $f2c102c6218d46df$export$339486410c7a783f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_KB_PERMISSIONS),
        path: '/jira/settings/products/jira-service-management-knowledge-base-permissions',
        exact: true
    };
});
parcelRegister("knyuK", function(module, exports) {
    $parcel$export(module.exports, "LazyProductsJsmKbPermissions", ()=>$724367026054fd0c$export$a3e7bdc5dbf2d47e);
    $parcel$export(module.exports, "default", ()=>$724367026054fd0c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $724367026054fd0c$export$a3e7bdc5dbf2d47e = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kWvsB"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-kb-permissions/src/index.tsx"
    });
    var $724367026054fd0c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $724367026054fd0c$export$a3e7bdc5dbf2d47e,
            pageId: "products-jsm-kb-permissions",
            shouldShowSpinner: false
        });
});
parcelRegister("kWvsB", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2dsVz")
    ]).then(()=>parcelRequire('glk23'));
});
parcelRegister("iPzOZ", function(module, exports) {
    $parcel$export(module.exports, "productsJsmOrganizationsRouteEntry", ()=>$5b81a6ea47f38625$export$34d843946d3894aa);
    $parcel$export(module.exports, "productsJsmOrganizations1RouteEntry", ()=>$5b81a6ea47f38625$export$6d18fd46547afb8e);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $38BXB;
    var $7CBZS;
    var $6nu63;
    var $esddG;
    var $3RJkv;
    var $49aFO;
    var $5JNlT;
    var $ckuB6;
    const $5b81a6ea47f38625$export$34d843946d3894aa = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("49aFO")).productsJsmOrganizationsRoute), ()=>({
            ufoName: 'admin.jsm-organization-page-list',
            isRedirect: false,
            component: (0, (0, parcelRequire("ckuB6")).default),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("esddG")).productsJsmOrganizationListResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("ckuB6")).LazyProductsJsmOrganizations)
            ]
        }));
    const $5b81a6ea47f38625$export$6d18fd46547afb8e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("49aFO")).productsJsmOrganizations1Route), ()=>({
            ufoName: 'admin.jsm-organization-page-list',
            isRedirect: false,
            component: (0, (0, parcelRequire("5JNlT")).default),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("7CBZS")).productsJsmOrganizationDetailsResource),
                (0, (0, parcelRequire("6nu63")).productsJsmOrganizationMembersResource),
                (0, (0, parcelRequire("esddG")).productsJsmOrganizationListResource),
                (0, (0, parcelRequire("38BXB")).jsmEmailDomainsListResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("5JNlT")).LazyProductsJsmOrganizationDetails)
            ]
        }));
});
parcelRegister("38BXB", function(module, exports) {
    $parcel$export(module.exports, "jsmEmailDomainsListResource", ()=>$02fee81a891a3dc1$export$8e956348e5d47a3c);
    var $dIdda = parcelRequire("dIdda");
    const $02fee81a891a3dc1$export$8e956348e5d47a3c = (0, $dIdda.createResource)({
        type: (0, $fb7ceb315fdf5327$export$2bde433b962efbdd),
        getKey: ()=>'email-domains-list',
        isBrowserOnly: true,
        getDataLoader: ()=>(parcelRequire("kAcB4"))
    });
});
const $fb7ceb315fdf5327$export$2bde433b962efbdd = 'JSM_EMAIL_DOMAINS_LIST';
parcelRegister("kAcB4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bY8Ab").then(()=>parcelRequire('bHzRo'));
});
parcelRegister("7CBZS", function(module, exports) {
    $parcel$export(module.exports, "productsJsmOrganizationDetailsResource", ()=>$d8ebe0a210bfc926$export$ccda79811a15bf5);
    var $dIdda = parcelRequire("dIdda");
    const $d8ebe0a210bfc926$export$ccda79811a15bf5 = (0, $dIdda.createResource)({
        type: (0, $1b34d67fee3735c4$export$52408f1a0f23569a),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("7ouAH"))
    });
});
const $1b34d67fee3735c4$export$52408f1a0f23569a = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_DETAILS';
parcelRegister("7ouAH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2PPIk").then(()=>parcelRequire('dXKCD'));
});
parcelRegister("6nu63", function(module, exports) {
    $parcel$export(module.exports, "productsJsmOrganizationMembersResource", ()=>$36d00fa173b898da$export$65c7941bd3e14d00);
    var $dIdda = parcelRequire("dIdda");
    const $36d00fa173b898da$var$TEN_SECONDS_IN_MILLIS = 10000;
    const $36d00fa173b898da$export$65c7941bd3e14d00 = (0, $dIdda.createResource)({
        type: (0, $b3f9f4e37cbce264$export$d3eec3e4b4eac6ac),
        getKey: (routerContext)=>`OrganizationMembers-${routerContext.match.params.organizationId}-${routerContext.query.page}-${routerContext.query.query}`,
        getDataLoader: ()=>(parcelRequire("hMnTg")),
        maxAge: $36d00fa173b898da$var$TEN_SECONDS_IN_MILLIS
    });
});
const $b3f9f4e37cbce264$export$d3eec3e4b4eac6ac = 'PRODUCT_JSM_ORGANIZATION_MEMBERS';
parcelRegister("hMnTg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9Veo5").then(()=>parcelRequire('kx7O4'));
});
parcelRegister("esddG", function(module, exports) {
    $parcel$export(module.exports, "productsJsmOrganizationListResource", ()=>$ad899c035903db82$export$3e38a27ad406d7f7);
    var $dIdda = parcelRequire("dIdda");
    const $ad899c035903db82$var$TEN_SECONDS_IN_MILLIS = 10000;
    const $ad899c035903db82$export$3e38a27ad406d7f7 = (0, $dIdda.createResource)({
        type: (0, $5073c414a8292ea0$export$50de2841b08b875f),
        getKey: (routerContext)=>routerContext.query.page,
        getDataLoader: ()=>(parcelRequire("eX5Nx")),
        maxAge: $ad899c035903db82$var$TEN_SECONDS_IN_MILLIS
    });
});
const $5073c414a8292ea0$export$27676104f3192a88 = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST_LEGACY';
const $5073c414a8292ea0$export$50de2841b08b875f = 'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_LIST';
parcelRegister("eX5Nx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hlkXx").then(()=>parcelRequire('v9BTs'));
});
parcelRegister("49aFO", function(module, exports) {
    $parcel$export(module.exports, "productsJsmOrganizationsRoute", ()=>$330184d7ffd51616$export$512fa30726e0049d);
    $parcel$export(module.exports, "productsJsmOrganizations1Route", ()=>$330184d7ffd51616$export$3ae664dd3f8b73dc);
    var $65Ltd;
    const $330184d7ffd51616$export$512fa30726e0049d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_ORGANIZATIONS),
        path: '/jira/settings/products/servicedesk/organizations',
        exact: true
    };
    const $330184d7ffd51616$export$3ae664dd3f8b73dc = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_ORGANIZATIONS),
        path: '/jira/settings/products/servicedesk/organizations/:organizationId',
        exact: true
    };
});
parcelRegister("5JNlT", function(module, exports) {
    $parcel$export(module.exports, "LazyProductsJsmOrganizationDetails", ()=>$2542e7a566ffd224$export$ff149ceefa65ab70);
    $parcel$export(module.exports, "default", ()=>$2542e7a566ffd224$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $2542e7a566ffd224$export$ff149ceefa65ab70 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("h6rJc"))), {
        moduleId: "./src/packages/admin-pages/products-jsm-organization-details/src/ui/index.tsx"
    });
    var $2542e7a566ffd224$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2542e7a566ffd224$export$ff149ceefa65ab70,
            pageId: "products-jsm-organization-details",
            shouldShowSpinner: true
        });
});
parcelRegister("h6rJc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("eZECP")
    ]).then(()=>parcelRequire('dgpeW'));
});
parcelRegister("ckuB6", function(module, exports) {
    $parcel$export(module.exports, "LazyProductsJsmOrganizations", ()=>$34fecedc618348fb$export$410bec6e06fd4723);
    $parcel$export(module.exports, "default", ()=>$34fecedc618348fb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $34fecedc618348fb$export$410bec6e06fd4723 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("jSPp3"))), {
        moduleId: "./src/packages/admin-pages/products-jsm-organizations-list/src/ui/index.tsx"
    });
    var $34fecedc618348fb$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $34fecedc618348fb$export$410bec6e06fd4723,
            pageId: "products-jsm-organizations-list",
            shouldShowSpinner: true
        });
});
parcelRegister("jSPp3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("1t34o")
    ]).then(()=>parcelRequire('hfcIv'));
});
parcelRegister("kazYN", function(module, exports) {
    $parcel$export(module.exports, "productsJswConfigurationRouteEntry", ()=>$7730befe0883f27a$export$2f65b1ec4ed05f91);
    $parcel$export(module.exports, "productsJswStorageManagementRouteEntry", ()=>$7730befe0883f27a$export$c62ca2d3fcc552a5);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $3RJkv;
    var $hwXlc;
    var $1vQWT;
    var $6xaw5;
    var $esWmF;
    var $bARgN;
    const $7730befe0883f27a$export$2f65b1ec4ed05f91 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6xaw5")).productsJswConfigurationRoute), ()=>({
            ufoName: 'admin.jsw-configuration',
            component: (0, (0, parcelRequire("esWmF")).default),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("hwXlc")).productsJswConfigurationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("esWmF")).LazyProductsJswConfiguration)
            ]
        }));
    const $7730befe0883f27a$export$c62ca2d3fcc552a5 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6xaw5")).productsJswConfigurationStorageManagementRoute), ()=>({
            ufoName: 'admin.jsw-configuration.storage-management',
            component: (0, (0, parcelRequire("bARgN")).default),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("2Fj5v")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                (0, (0, parcelRequire("1vQWT")).productsJswStorageManagementResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("bARgN")).LazyProductsJswStorageManagement)
            ]
        }));
});
parcelRegister("hwXlc", function(module, exports) {
    $parcel$export(module.exports, "productsJswConfigurationResource", ()=>$3248841597f2b624$export$b6a5741c2b47fb17);
    var $dIdda = parcelRequire("dIdda");
    const $3248841597f2b624$export$b6a5741c2b47fb17 = (0, $dIdda.createResource)({
        type: (0, $8b1aa0975152cf4f$export$73be8e1edd21e2d),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("kr4uP"))
    });
});
const $8b1aa0975152cf4f$export$73be8e1edd21e2d = 'RESOURCE_TYPE_PRODUCT_JSW_CONFIGURATION';
parcelRegister("kr4uP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2WYZL").then(()=>parcelRequire('bX4Lv'));
});
parcelRegister("1vQWT", function(module, exports) {
    $parcel$export(module.exports, "productsJswStorageManagementResource", ()=>$20cc0f4a1ad53cba$export$2cd668845b3478bd);
    var $dIdda = parcelRequire("dIdda");
    const $20cc0f4a1ad53cba$export$2cd668845b3478bd = (0, $dIdda.createResource)({
        type: (0, $593b84e85768ae60$export$1ac222647be3baf8),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("u9ZMa"))
    });
});
const $593b84e85768ae60$export$1ac222647be3baf8 = 'RESOURCE_TYPE_PRODUCT_JSW_STORAGE_MANAGEMENT';
parcelRegister("u9ZMa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jkZvt").then(()=>parcelRequire('a5z0r'));
});
parcelRegister("6xaw5", function(module, exports) {
    $parcel$export(module.exports, "productsJswConfigurationRoute", ()=>$d216b5e2d2bdeeff$export$decdad53ba9b97af);
    $parcel$export(module.exports, "productsJswConfigurationStorageManagementRoute", ()=>$d216b5e2d2bdeeff$export$6e126b0e7eabff82);
    var $65Ltd;
    const $d216b5e2d2bdeeff$export$decdad53ba9b97af = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSW_CONFIGURATION),
        path: '/jira/settings/products/jira-software-configuration',
        exact: true
    };
    const $d216b5e2d2bdeeff$export$6e126b0e7eabff82 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSW_STORAGE_MANAGEMENT),
        path: '/jira/settings/products/jira-software-configuration/storage-management',
        exact: true
    };
});
parcelRegister("esWmF", function(module, exports) {
    $parcel$export(module.exports, "LazyProductsJswConfiguration", ()=>$90ae9e1263695143$export$f9a32397033f9ced);
    $parcel$export(module.exports, "default", ()=>$90ae9e1263695143$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $90ae9e1263695143$export$f9a32397033f9ced = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fW9gA"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/products-jsw-configuration/src/index.tsx"
    });
    var $90ae9e1263695143$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $90ae9e1263695143$export$f9a32397033f9ced,
            pageId: "products-jsw-configuration",
            shouldShowSpinner: false
        });
});
parcelRegister("fW9gA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("1Xl7E")
    ]).then(()=>parcelRequire('1eYnA'));
});
parcelRegister("bARgN", function(module, exports) {
    $parcel$export(module.exports, "LazyProductsJswStorageManagement", ()=>$bad793b8f28a1de3$export$a4f5e12ce817cbb8);
    $parcel$export(module.exports, "default", ()=>$bad793b8f28a1de3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $bad793b8f28a1de3$export$a4f5e12ce817cbb8 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9WQFp"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/products-jsw-storage-management/src/index.tsx"
    });
    var $bad793b8f28a1de3$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $bad793b8f28a1de3$export$a4f5e12ce817cbb8,
            pageId: "products-jsw-storage-management",
            shouldShowSpinner: true
        });
});
parcelRegister("9WQFp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gWzc8")
    ]).then(()=>parcelRequire('2i4Yq'));
});
parcelRegister("8VD2Y", function(module, exports) {
    $parcel$export(module.exports, "proformaRouteEntries", ()=>$0946abf0655b0a01$export$2763334cca1560d7);
    var $ffza4;
    var $6e4Kt;
    var $18N1t;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $ilmr0;
    var $6Z2mh;
    var $e7bC3;
    var $6dVUC;
    var $6VQ64;
    var $edJLT;
    var $5cTgp;
    const $0946abf0655b0a01$export$786e5a0c86be676a = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ilmr0")).routeGroupsServicedeskRouteNamesProformaExportRoute), ()=>({
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                component: (0, (0, parcelRequire("6dVUC")).default),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("6dVUC")).LazyProformaExport)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ilmr0")).routeGroupsServicedeskRouteNamesProformaIssueFormsGeneralRoute), ()=>({
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                component: (0, (0, parcelRequire("5cTgp")).default),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("5cTgp")).LazyProformaIssueFormsGeneral)
                ],
                perfMetricKey: 'issue-forms-general'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ilmr0")).routeGroupsServicedeskRouteNamesProformaIssueFormsDirectRoute), ()=>({
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                resources: [
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                component: (0, (0, parcelRequire("6VQ64")).default),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
                },
                forPaint: [
                    (0, (0, parcelRequire("6VQ64")).LazyProformaIssueFormsDirect)
                ],
                perfMetricKey: 'issue-forms-direct'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ilmr0")).routeGroupsServicedeskRouteNamesProformaIssueFormsDirectEmbedRoute), ()=>({
                layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
                resources: [
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                component: (0, (0, parcelRequire("edJLT")).default),
                forPaint: [
                    (0, (0, parcelRequire("edJLT")).LazyProformaIssueFormsDirectEmbed)
                ],
                perfMetricKey: 'issue-forms-direct-embed'
            }))
    ];
    const $0946abf0655b0a01$export$c4313dd46c85e3d3 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ilmr0")).routeGroupsClassicBusinessRouteNamesProformaExportRoute), ()=>({
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                component: (0, (0, parcelRequire("6dVUC")).default),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("6dVUC")).LazyProformaExport)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ilmr0")).routeGroupsClassicBusinessRouteNamesProformaIssueFormsGeneralRoute), ()=>({
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                component: (0, (0, parcelRequire("5cTgp")).default),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("5cTgp")).LazyProformaIssueFormsGeneral)
                ],
                perfMetricKey: 'issue-forms-general'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ilmr0")).routeGroupsClassicBusinessRouteNamesProformaIssueFormsDirectRoute), ()=>({
                layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
                resources: [
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                component: (0, (0, parcelRequire("6VQ64")).default),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
                },
                forPaint: [
                    (0, (0, parcelRequire("6VQ64")).LazyProformaIssueFormsDirect)
                ],
                perfMetricKey: 'issue-forms-direct'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ilmr0")).routeGroupsClassicBusinessRouteNamesProformaIssueFormsDirectEmbedRoute), ()=>({
                layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
                resources: [
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                component: (0, (0, parcelRequire("edJLT")).default),
                forPaint: [
                    (0, (0, parcelRequire("edJLT")).LazyProformaIssueFormsDirectEmbed)
                ],
                perfMetricKey: 'issue-forms-direct-embed'
            }))
    ];
    const $0946abf0655b0a01$export$2e672712b21297b8 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ilmr0")).routeGroupsSoftwareRouteNamesProformaExportRoute), ()=>({
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                component: (0, (0, parcelRequire("6dVUC")).default),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("6dVUC")).LazyProformaExport)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ilmr0")).routeGroupsSoftwareRouteNamesProformaIssueFormsGeneralRoute), ()=>({
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                component: (0, (0, parcelRequire("5cTgp")).default),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("5cTgp")).LazyProformaIssueFormsGeneral)
                ],
                perfMetricKey: 'issue-forms-general'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ilmr0")).routeGroupsSoftwareRouteNamesProformaIssueFormsDirectRoute), ()=>({
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                resources: [
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                component: (0, (0, parcelRequire("6VQ64")).default),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
                },
                forPaint: [
                    (0, (0, parcelRequire("6VQ64")).LazyProformaIssueFormsDirect)
                ],
                perfMetricKey: 'issue-forms-direct'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ilmr0")).routeGroupsSoftwareRouteNamesProformaIssueFormsDirectEmbedRoute), ()=>({
                layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
                resources: [
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                component: (0, (0, parcelRequire("edJLT")).default),
                forPaint: [
                    (0, (0, parcelRequire("edJLT")).LazyProformaIssueFormsDirectEmbed)
                ],
                perfMetricKey: 'issue-forms-direct-embed'
            }))
    ];
    const $0946abf0655b0a01$export$2763334cca1560d7 = [
        ...$0946abf0655b0a01$export$786e5a0c86be676a,
        ...$0946abf0655b0a01$export$c4313dd46c85e3d3,
        ...$0946abf0655b0a01$export$2e672712b21297b8
    ];
});
parcelRegister("ilmr0", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsServicedeskRouteNamesProformaExportRoute", ()=>$db696cd0fbc4b110$export$158441d4f5c68fb9);
    $parcel$export(module.exports, "routeGroupsServicedeskRouteNamesProformaIssueFormsGeneralRoute", ()=>$db696cd0fbc4b110$export$416ac492f873673a);
    $parcel$export(module.exports, "routeGroupsServicedeskRouteNamesProformaIssueFormsDirectRoute", ()=>$db696cd0fbc4b110$export$574435c4e2f6a27e);
    $parcel$export(module.exports, "routeGroupsServicedeskRouteNamesProformaIssueFormsDirectEmbedRoute", ()=>$db696cd0fbc4b110$export$d48be9e2caaca83d);
    $parcel$export(module.exports, "routeGroupsClassicBusinessRouteNamesProformaExportRoute", ()=>$db696cd0fbc4b110$export$fb73a18f932b2c15);
    $parcel$export(module.exports, "routeGroupsClassicBusinessRouteNamesProformaIssueFormsGeneralRoute", ()=>$db696cd0fbc4b110$export$ec7e58425379b5d0);
    $parcel$export(module.exports, "routeGroupsClassicBusinessRouteNamesProformaIssueFormsDirectRoute", ()=>$db696cd0fbc4b110$export$76ab9f3014b2e370);
    $parcel$export(module.exports, "routeGroupsClassicBusinessRouteNamesProformaIssueFormsDirectEmbedRoute", ()=>$db696cd0fbc4b110$export$55ce393dc053bec4);
    $parcel$export(module.exports, "routeGroupsSoftwareRouteNamesProformaExportRoute", ()=>$db696cd0fbc4b110$export$4c5d46fe4c460ef9);
    $parcel$export(module.exports, "routeGroupsSoftwareRouteNamesProformaIssueFormsGeneralRoute", ()=>$db696cd0fbc4b110$export$7de22a6665b73706);
    $parcel$export(module.exports, "routeGroupsSoftwareRouteNamesProformaIssueFormsDirectRoute", ()=>$db696cd0fbc4b110$export$c02a5b8ecf73713e);
    $parcel$export(module.exports, "routeGroupsSoftwareRouteNamesProformaIssueFormsDirectEmbedRoute", ()=>$db696cd0fbc4b110$export$cd0e54104fd6e37c);
    var $65Ltd;
    const $db696cd0fbc4b110$var$CORE_PRODUCT = 'core';
    const $db696cd0fbc4b110$var$SOFTWARE_PRODUCT = 'software';
    const $db696cd0fbc4b110$var$SERVICE_DESK_PRODUCT = 'servicedesk';
    const $db696cd0fbc4b110$var$jiraIssueFormCreateEndpoint = 'projects/:projectKey/forms/form/direct/:templateFormId/:issueTypeId?';
    const $db696cd0fbc4b110$var$EXPORT_URL = '/jira/forms/export';
    const $db696cd0fbc4b110$var$ISSUE_FORMS_GENERAL_URL = '/jira/forms/create';
    const $db696cd0fbc4b110$export$158441d4f5c68fb9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROFORMA),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_EXPORT_SERVICEDESK),
        path: $db696cd0fbc4b110$var$EXPORT_URL,
        exact: true
    };
    const $db696cd0fbc4b110$export$416ac492f873673a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROFORMA),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_SERVICEDESK),
        path: $db696cd0fbc4b110$var$ISSUE_FORMS_GENERAL_URL,
        exact: true
    };
    const $db696cd0fbc4b110$export$574435c4e2f6a27e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SERVICEDESK),
        path: `/jira/${$db696cd0fbc4b110$var$SERVICE_DESK_PRODUCT}/${$db696cd0fbc4b110$var$jiraIssueFormCreateEndpoint}`,
        exact: true
    };
    const $db696cd0fbc4b110$export$d48be9e2caaca83d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SERVICEDESK),
        path: `/jira/${$db696cd0fbc4b110$var$SERVICE_DESK_PRODUCT}/${$db696cd0fbc4b110$var$jiraIssueFormCreateEndpoint}/embed`,
        exact: true
    };
    const $db696cd0fbc4b110$export$fb73a18f932b2c15 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROFORMA),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_EXPORT_CLASSIC_BUSINESS),
        path: $db696cd0fbc4b110$var$EXPORT_URL,
        exact: true
    };
    const $db696cd0fbc4b110$export$ec7e58425379b5d0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROFORMA),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_CLASSIC_BUSINESS),
        path: $db696cd0fbc4b110$var$ISSUE_FORMS_GENERAL_URL,
        exact: true
    };
    const $db696cd0fbc4b110$export$76ab9f3014b2e370 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_CLASSIC_BUSINESS),
        path: `/jira/${$db696cd0fbc4b110$var$CORE_PRODUCT}/${$db696cd0fbc4b110$var$jiraIssueFormCreateEndpoint}`,
        exact: true
    };
    const $db696cd0fbc4b110$export$55ce393dc053bec4 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_BUSINESS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_CLASSIC_BUSINESS),
        path: `/jira/${$db696cd0fbc4b110$var$CORE_PRODUCT}/${$db696cd0fbc4b110$var$jiraIssueFormCreateEndpoint}/embed`,
        exact: true
    };
    const $db696cd0fbc4b110$export$4c5d46fe4c460ef9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROFORMA),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_EXPORT_SOFTWARE),
        path: $db696cd0fbc4b110$var$EXPORT_URL,
        exact: true
    };
    const $db696cd0fbc4b110$export$7de22a6665b73706 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROFORMA),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_GENERAL_SOFTWARE),
        path: $db696cd0fbc4b110$var$ISSUE_FORMS_GENERAL_URL,
        exact: true
    };
    const $db696cd0fbc4b110$export$c02a5b8ecf73713e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_SOFTWARE),
        path: `/jira/${$db696cd0fbc4b110$var$SOFTWARE_PRODUCT}/${$db696cd0fbc4b110$var$jiraIssueFormCreateEndpoint}`,
        exact: true
    };
    const $db696cd0fbc4b110$export$cd0e54104fd6e37c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROFORMA_ISSUE_FORMS_DIRECT_EMBED_SOFTWARE),
        path: `/jira/${$db696cd0fbc4b110$var$SOFTWARE_PRODUCT}/${$db696cd0fbc4b110$var$jiraIssueFormCreateEndpoint}/embed`,
        exact: true
    };
});
parcelRegister("6dVUC", function(module, exports) {
    $parcel$export(module.exports, "LazyProformaExport", ()=>$f012061ea42d3cc1$export$5e0d802a5d865352);
    $parcel$export(module.exports, "default", ()=>$f012061ea42d3cc1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $f012061ea42d3cc1$export$5e0d802a5d865352 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("a8m8q")), {
        moduleId: "./src/packages/spa-apps/proforma-export/src/index.tsx"
    });
    var $f012061ea42d3cc1$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f012061ea42d3cc1$export$5e0d802a5d865352,
            pageId: "proforma-export",
            shouldShowSpinner: true
        });
});
parcelRegister("a8m8q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dw3QA")
    ]).then(()=>parcelRequire('dtDoN'));
});
parcelRegister("6VQ64", function(module, exports) {
    $parcel$export(module.exports, "LazyProformaIssueFormsDirect", ()=>$33e9f81a484baab5$export$a0f04dd35569e11);
    $parcel$export(module.exports, "default", ()=>$33e9f81a484baab5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $33e9f81a484baab5$export$a0f04dd35569e11 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("9xG8v")), {
        moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct/src/index.tsx"
    });
    var $33e9f81a484baab5$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $33e9f81a484baab5$export$a0f04dd35569e11,
            pageId: "proforma-issue-forms-direct",
            shouldShowSpinner: true
        });
});
parcelRegister("edJLT", function(module, exports) {
    $parcel$export(module.exports, "LazyProformaIssueFormsDirectEmbed", ()=>$321227a7cf9935db$export$22681210aaeb910f);
    $parcel$export(module.exports, "default", ()=>$321227a7cf9935db$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $321227a7cf9935db$export$22681210aaeb910f = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("jDCWS")), {
        moduleId: "./src/packages/spa-apps/proforma-issue-forms-direct-embed/src/index.tsx"
    });
    var $321227a7cf9935db$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $321227a7cf9935db$export$22681210aaeb910f,
            pageId: "proforma-issue-forms-direct-embed",
            shouldShowSpinner: true
        });
});
parcelRegister("5cTgp", function(module, exports) {
    $parcel$export(module.exports, "LazyProformaIssueFormsGeneral", ()=>$06427390ad9a129c$export$7c16b09eb95f1c5d);
    $parcel$export(module.exports, "default", ()=>$06427390ad9a129c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $06427390ad9a129c$export$7c16b09eb95f1c5d = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("k5RCi")), {
        moduleId: "./src/packages/spa-apps/proforma-issue-forms-general/src/index.tsx"
    });
    var $06427390ad9a129c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $06427390ad9a129c$export$7c16b09eb95f1c5d,
            pageId: "proforma-issue-forms-general",
            shouldShowSpinner: true
        });
});
parcelRegister("k5RCi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("4lyh8")
    ]).then(()=>parcelRequire('28Pju'));
});
parcelRegister("3taVL", function(module, exports) {
    $parcel$export(module.exports, "projectComponentsRouteEntry", ()=>$5a7f40c2fa85616b$export$e60f53ff5ae626cd);
    $parcel$export(module.exports, "projectComponents1RouteEntry", ()=>$5a7f40c2fa85616b$export$25cf284456caeeef);
    var $ffza4;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $xNRJ9;
    var $dxCvy;
    var $7GnDe;
    var $l2b5P;
    var $holgx;
    const $5a7f40c2fa85616b$export$e60f53ff5ae626cd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("l2b5P")).projectComponentsRedirectRoute), ()=>({
            component: !false ? (0, (0, parcelRequire("holgx")).ComponentsRedirect) : (0, (0, parcelRequire("holgx")).default),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("xNRJ9")).projectsComponentsResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("holgx")).LazyProjectComponents)
            ],
            isRedirect: true
        }));
    const $5a7f40c2fa85616b$export$25cf284456caeeef = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("l2b5P")).projectComponentsRoute), ()=>({
            ufoName: 'project-components-view',
            component: (0, (0, parcelRequire("holgx")).default),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("xNRJ9")).projectsComponentsResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("holgx")).LazyProjectComponents)
            ]
        }));
});
parcelRegister("xNRJ9", function(module, exports) {
    $parcel$export(module.exports, "projectsComponentsResource", ()=>$e6f1f6e8951a4819$export$557cc3eff8939b3);
    var $kbVA4;
    var $dIdda = parcelRequire("dIdda");
    const $e6f1f6e8951a4819$export$557cc3eff8939b3 = (0, $dIdda.createResource)({
        type: (0, $7f7620b307267b7d$export$ae1b86a8daeb387d),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("5qUfp")),
        maxAge: (0, (0, parcelRequire("kbVA4")).MIN_MAX_AGE)
    });
});
const $7f7620b307267b7d$export$ae1b86a8daeb387d = 'PROJECTS_COMPONENTS';
parcelRegister("5qUfp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bUZ7U").then(()=>parcelRequire('77Eyd'));
});
parcelRegister("l2b5P", function(module, exports) {
    $parcel$export(module.exports, "projectComponentsRedirectRoute", ()=>$a98d732e7459c7e9$export$d370abe25253fa1b);
    $parcel$export(module.exports, "projectComponentsRoute", ()=>$a98d732e7459c7e9$export$f76189bea494b0b8);
    var $jhtWp;
    var $65Ltd;
    const $a98d732e7459c7e9$export$d370abe25253fa1b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_COMPONENTS)}-redirect`,
        path: '/projects/:projectKey',
        query: (0, (0, parcelRequire("jhtWp")).PROJECTS_COMPONENTS_QUERY_PARAMS)
    };
    const $a98d732e7459c7e9$export$f76189bea494b0b8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_COMPONENTS),
        path: '/jira/:projectType(software|software/c|servicedesk|core)/projects/:projectKey/components'
    };
});
parcelRegister("jhtWp", function(module, exports) {
    $parcel$export(module.exports, "PROJECTS_COMPONENTS_QUERY_PARAMS", ()=>$650eb9307abab3e5$export$1d7a0c194c3e83f2);
    const $650eb9307abab3e5$export$1d7a0c194c3e83f2 = [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:components-page'
    ];
});
parcelRegister("holgx", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectComponents", ()=>$15d396b2dbadf93f$export$f32c20cfbc84532c);
    $parcel$export(module.exports, "ComponentsRedirect", ()=>$15d396b2dbadf93f$export$9cf9ae84482ff18e);
    $parcel$export(module.exports, "default", ()=>$15d396b2dbadf93f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aZsz6 = parcelRequire("aZsz6");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $6XreI;
    const $15d396b2dbadf93f$export$f32c20cfbc84532c = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8IENq"))), {
        moduleId: "./src/packages/spa-apps/project/components/src/index.tsx"
    });
    const $15d396b2dbadf93f$export$9cf9ae84482ff18e = ()=>{
        const page = (_, { selectedItem: selectedItem, ...rest })=>{
            const querystring = (0, $aZsz6.qs).stringify(rest, true);
            return `/components${querystring}`;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6XreI")).RedirectToProjectType), {
            page: page
        });
    };
    var $15d396b2dbadf93f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $15d396b2dbadf93f$export$f32c20cfbc84532c,
            pageId: "project-components",
            shouldShowSpinner: false
        });
});
parcelRegister("6XreI", function(module, exports) {
    $parcel$export(module.exports, "RedirectToProjectType", ()=>$d19b3848ac7d27f0$export$8a3df560509448b8);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $8zOmE;
    var $95EVP;
    var $dxCvy;
    var $bVDE5;
    var $dIdda = parcelRequire("dIdda");
    const $d19b3848ac7d27f0$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $dIdda.Redirect), fireUIAnalytics: fireUIAnalytics = (0, (0, parcelRequire("8zOmE")).fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents), useResource: useResource = (0, $dIdda.useResource), useRouter: useRouter = (0, $dIdda.useRouter), useSpaStateTransition: useSpaStateTransition = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition) })=>{
        const [{ match: match, query: query, route: route }] = useRouter();
        const { data: data } = useResource((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        const [{ isInitialRender: isInitial }] = useSpaStateTransition();
        const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
        (0, $5uXOq.useEffect)(()=>{
            if (!data || !route || !eventRef.current) return;
            fireUIAnalytics(eventRef.current, 'route redirected', {
                isInitial: isInitial,
                routeName: route.name
            });
            eventRef.current = null;
        }, [
            data,
            fireUIAnalytics,
            isInitial,
            route
        ]);
        if (!data || !route) return null;
        const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
        let type;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                type = 'servicedesk';
                break;
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                type = 'core';
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            default:
                type = `software${simplified ? '' : '/c'}`;
        }
        const returnPage = typeof page === 'string' ? page : page(match, query);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: `/jira/${type}/projects/${projectKey}${returnPage}`
        });
    };
});
parcelRegister("8IENq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dRI4W")
    ]).then(()=>parcelRequire('2NjcZ'));
});
parcelRegister("ddL21", function(module, exports) {
    $parcel$export(module.exports, "projectNotFoundRouteEntry", ()=>$1a16a8f438816e9f$export$beae48175e3016b8);
    var $lkFvK;
    var $2BrOV;
    var $lmyls;
    var $2G9Bk;
    var $3RJkv;
    var $9ZpnC;
    var $T9TsM;
    const $1a16a8f438816e9f$export$f5a338b3fe5182bb = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("T9TsM")).projectNotFoundEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $1a16a8f438816e9f$export$beae48175e3016b8 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9ZpnC")).projectNotFoundRoute), ()=>({
            entryPoint () {
                return $1a16a8f438816e9f$export$f5a338b3fe5182bb;
            },
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            pageId: 'project-not-found-page-id'
        }));
});
parcelRegister("9ZpnC", function(module, exports) {
    $parcel$export(module.exports, "projectNotFoundRoute", ()=>$e511c19c3ef6a85a$export$ad23ddca45852d02);
    var $65Ltd;
    const $e511c19c3ef6a85a$export$ad23ddca45852d02 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_ERRORS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_NOT_FOUND),
        path: '/jira/:projectType(software|servicedesk|core|polaris)/projects/not-found',
        exact: true
    };
});
parcelRegister("T9TsM", function(module, exports) {
    $parcel$export(module.exports, "projectNotFoundEntryPoint", ()=>$ad3635ddd4e67df5$export$6ffa2f426ba3b25a);
    var $2Ftxm;
    var $ikgNX;
    const $ad3635ddd4e67df5$export$6ffa2f426ba3b25a = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("kI4TI")), {
            moduleId: "51ed29c5"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("kI4TI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("d3O83").then(()=>parcelRequire('L9JRT'));
});
parcelRegister("5JIl8", function(module, exports) {
    $parcel$export(module.exports, "projectPagesRouteEntry", ()=>$b563891c809eb2df$export$babf32528ef518e9);
    $parcel$export(module.exports, "projectPages1RouteEntry", ()=>$b563891c809eb2df$export$6e8865417e6a38c);
    var $ffza4;
    var $7XYc4;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $5lsNZ;
    var $cwfYW;
    var $kfztd;
    var $9V7O8;
    const $b563891c809eb2df$export$babf32528ef518e9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cwfYW")).routeNamesProjectPagesLegacyRoute), ()=>({
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            component: !false ? (0, (0, parcelRequire("9V7O8")).PagesRedirect) : (0, (0, parcelRequire("9V7O8")).default),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("9V7O8")).LazyProjectPages)
            ],
            isRedirect: true
        }));
    const $b563891c809eb2df$export$6e8865417e6a38c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cwfYW")).projectPagesRoute), ()=>({
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, (0, parcelRequire("9V7O8")).default)),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("9V7O8")).LazyProjectPages)
            ]
        }));
});
parcelRegister("cwfYW", function(module, exports) {
    $parcel$export(module.exports, "routeNamesProjectPagesLegacyRoute", ()=>$c33c3f26abfe30a3$export$2d09da22e737849e);
    $parcel$export(module.exports, "projectPagesRoute", ()=>$c33c3f26abfe30a3$export$54a218ca6d1c056a);
    var $65Ltd;
    const $c33c3f26abfe30a3$export$2d09da22e737849e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_PAGES)}-legacy`,
        path: '/projects/:projectKey',
        query: [
            'selectedItem=com.atlassian.jira.jira-projects-plugin:project-pages-page'
        ]
    };
    const $c33c3f26abfe30a3$export$54a218ca6d1c056a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_PAGES),
        path: '/jira/:projectType(software|software/c|servicedesk)/projects/:projectKey/pages'
    };
});
parcelRegister("9V7O8", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectPages", ()=>$4be66c9d92628f7f$export$c2115a649411f570);
    $parcel$export(module.exports, "PagesRedirect", ()=>$4be66c9d92628f7f$export$7c3b1828ada63555);
    $parcel$export(module.exports, "default", ()=>$4be66c9d92628f7f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $3jbwx;
    const $4be66c9d92628f7f$export$c2115a649411f570 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5mCC5"))), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/project/pages/src/index.tsx"
    });
    const $4be66c9d92628f7f$export$7c3b1828ada63555 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3jbwx")).RedirectToProjectType), {
            page: "/pages"
        });
    var $4be66c9d92628f7f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4be66c9d92628f7f$export$c2115a649411f570,
            pageId: "project-pages",
            shouldShowSpinner: false
        });
});
parcelRegister("3jbwx", function(module, exports) {
    $parcel$export(module.exports, "RedirectToProjectType", ()=>$b1c3ef54235a025d$export$8a3df560509448b8);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $8zOmE;
    var $95EVP;
    var $dxCvy;
    var $bVDE5;
    var $dIdda = parcelRequire("dIdda");
    const $b1c3ef54235a025d$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $dIdda.Redirect), fireUIAnalytics: fireUIAnalytics = (0, (0, parcelRequire("8zOmE")).fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents), useResource: useResource = (0, $dIdda.useResource), useRouter: useRouter = (0, $dIdda.useRouter), useSpaStateTransition: useSpaStateTransition = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition) })=>{
        const [{ match: match, query: query, route: route }] = useRouter();
        const { data: data } = useResource((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        const [{ isInitialRender: isInitial }] = useSpaStateTransition();
        const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
        (0, $5uXOq.useEffect)(()=>{
            if (!data || !route || !eventRef.current) return;
            fireUIAnalytics(eventRef.current, 'route redirected', {
                isInitial: isInitial,
                routeName: route.name
            });
            eventRef.current = null;
        }, [
            data,
            fireUIAnalytics,
            isInitial,
            route
        ]);
        if (!data || !route) return null;
        const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
        let type;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                type = 'servicedesk';
                break;
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                type = 'core';
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            default:
                type = `software${simplified ? '' : '/c'}`;
        }
        const returnPage = typeof page === 'string' ? page : page(match, query);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: `/jira/${type}/projects/${projectKey}${returnPage}`
        });
    };
});
parcelRegister("5mCC5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3dqRu")
    ]).then(()=>parcelRequire('8nMC7'));
});
parcelRegister("gf8aX", function(module, exports) {
    $parcel$export(module.exports, "projectSettingsComponentsRouteEntry", ()=>$5874d8a4e3dac2e3$export$72497f4e39dd0df4);
    var $ffza4;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $xNRJ9;
    var $dxCvy;
    var $7GnDe;
    var $dQmaR;
    var $d83t6;
    const $5874d8a4e3dac2e3$export$72497f4e39dd0df4 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("dQmaR")).projectSettingsComponentsRoute), ()=>({
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("xNRJ9")).projectsComponentsResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            component: (0, (0, parcelRequire("d83t6")).default),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("d83t6")).LazyProjectComponentsSettings)
            ]
        }));
});
parcelRegister("dQmaR", function(module, exports) {
    $parcel$export(module.exports, "projectSettingsComponentsRoute", ()=>$d95fb97e443a9f50$export$79cbce13eeecd53);
    var $65Ltd;
    const $d95fb97e443a9f50$export$79cbce13eeecd53 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS),
        path: '/plugins/servlet/project-config/:projectKey/administer-components'
    };
});
parcelRegister("d83t6", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectComponentsSettings", ()=>$2794979f407c5b17$export$bb69d8c36391123);
    $parcel$export(module.exports, "default", ()=>$2794979f407c5b17$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aZsz6 = parcelRequire("aZsz6");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $a25Ol;
    const $2794979f407c5b17$export$bb69d8c36391123 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8IENq"))), {
        moduleId: "./src/packages/spa-apps/project/components/src/index.tsx"
    });
    const $2794979f407c5b17$export$60cfbcd781a48d01 = ()=>{
        const page = (_, { selectedItem: selectedItem, ...rest })=>{
            const querystring = (0, $aZsz6.qs).stringify(rest, true);
            return `/settings/components${querystring}`;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a25Ol")).RedirectToProjectType), {
            page: page
        });
    };
    var $2794979f407c5b17$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2794979f407c5b17$export$bb69d8c36391123,
            pageId: "project-settings-components",
            shouldShowSpinner: true
        });
});
parcelRegister("a25Ol", function(module, exports) {
    $parcel$export(module.exports, "RedirectToProjectType", ()=>$55786e10b01ad2e7$export$8a3df560509448b8);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $8zOmE;
    var $95EVP;
    var $dxCvy;
    var $bVDE5;
    var $dIdda = parcelRequire("dIdda");
    const $55786e10b01ad2e7$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $dIdda.Redirect), fireUIAnalytics: fireUIAnalytics = (0, (0, parcelRequire("8zOmE")).fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents), useResource: useResource = (0, $dIdda.useResource), useRouter: useRouter = (0, $dIdda.useRouter), useSpaStateTransition: useSpaStateTransition = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition) })=>{
        const [{ match: match, query: query, route: route }] = useRouter();
        const { data: data } = useResource((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        const [{ isInitialRender: isInitial }] = useSpaStateTransition();
        const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
        (0, $5uXOq.useEffect)(()=>{
            if (!data || !route || !eventRef.current) return;
            fireUIAnalytics(eventRef.current, 'route redirected', {
                isInitial: isInitial,
                routeName: route.name
            });
            eventRef.current = null;
        }, [
            data,
            fireUIAnalytics,
            isInitial,
            route
        ]);
        if (!data || !route) return null;
        const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
        let type;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                type = 'servicedesk';
                break;
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                type = 'core';
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            default:
                type = `software${simplified ? '' : '/c'}`;
        }
        const returnPage = typeof page === 'string' ? page : page(match, query);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: `/jira/${type}/projects/${projectKey}${returnPage}`
        });
    };
});
parcelRegister("fRYz5", function(module, exports) {
    $parcel$export(module.exports, "projectSettingsVersionsRouteEntry", ()=>$c850b44c9898a4f7$export$4791201b4877aa5d);
    var $ffza4;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $bC7QJ;
    var $7GnDe;
    var $94kpz;
    var $af7CK;
    const $c850b44c9898a4f7$export$4791201b4877aa5d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("94kpz")).projectSettingsVersionsRoute), ()=>({
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("bC7QJ")).projectVersionsRelayResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            component: (0, (0, parcelRequire("af7CK")).RelayVersions),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("af7CK")).LazyRelayProjectVersions)
            ]
        }));
});
parcelRegister("bC7QJ", function(module, exports) {
    $parcel$export(module.exports, "projectVersionsRelayResource", ()=>$d194483d3a062e97$export$7e8aa1360f86345c);
    var $8Uumt = parcelRequire("8Uumt");
    var $e8T8A;
    var $5yJb9;
    var $kipqU;
    var $ao2h1;
    var $lqMPx;
    var $dIdda = parcelRequire("dIdda");
    const $d194483d3a062e97$export$7e8aa1360f86345c = (0, $dIdda.createResource)({
        type: `${(0, (0, parcelRequire("ao2h1")).RELAY_RESOURCE_TYPE)}_${(0, $92b865e141ed2a4f$export$59aa73792ad9507a)}`,
        getKey: ({ match: match })=>{
            const { projectKey: projectKey } = match.params;
            return `project-version-query-relay-${projectKey}`;
        },
        getData: async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
            const variables = {
                initialLoadCount: 20,
                cloudId: tenantContext.cloudId,
                projectKey: match.params.projectKey,
                filter: (0, (0, parcelRequire("e8T8A")).transformStatusFromParam)(query[0, $6868fc0fce0c2912$export$3e8168848b996f7]),
                searchString: query[0, $6868fc0fce0c2912$export$a181206198b7f50c] || '',
                sortBy: {
                    sortByField: (0, (0, parcelRequire("e8T8A")).transformSortFieldFromParam)(query[0, $6868fc0fce0c2912$export$a3482d3a8df0e725]),
                    order: (0, (0, parcelRequire("e8T8A")).transformSortOrderFromParam)(query[0, $6868fc0fce0c2912$export$71089821f361e881])
                }
            };
            const queryReference = (0, $8Uumt.loadQuery)((0, (0, parcelRequire("5yJb9")).default)(), (0, (0, parcelRequire("lqMPx")).default), variables, {
                fetchPolicy: 'store-or-network'
            });
            if (false && queryReference.id != null) await (0, (0, parcelRequire("kipqU")).QueryPromisesMap).get(queryReference.id);
            return queryReference;
        },
        maxAge: 0
    });
});
const $6868fc0fce0c2912$export$a181206198b7f50c = 'contains';
const $6868fc0fce0c2912$export$3e8168848b996f7 = 'status';
const $6868fc0fce0c2912$export$71089821f361e881 = 'orderDirection';
const $6868fc0fce0c2912$export$a3482d3a8df0e725 = 'orderField';
const $6868fc0fce0c2912$export$3c5e605ca7ade9f2 = 'NAME';
const $6868fc0fce0c2912$export$50241fe906e4f94e = 'RELEASE_DATE';
const $6868fc0fce0c2912$export$99a467bcc22b8df9 = 'START_DATE';
const $6868fc0fce0c2912$export$d44826c816b5619b = 'DESCRIPTION';
const $6868fc0fce0c2912$export$34694f8d8b23ee2a = 'SEQUENCE';
const $6868fc0fce0c2912$export$cb638d1fae624fbf = 20;
const $6868fc0fce0c2912$export$bbcbc202f2dfa28c = 3;
const $6868fc0fce0c2912$export$b983f2cb1f658a55 = 'RELEASED';
const $6868fc0fce0c2912$export$cb459d726a8530a5 = 'UNRELEASED';
const $6868fc0fce0c2912$export$c936349447a77fe0 = 'ARCHIVED';
const $6868fc0fce0c2912$export$c5ed97509d0e2aaf = 'projectVersions';
parcelRegister("e8T8A", function(module, exports) {
    $parcel$export(module.exports, "transformStatusFromParam", ()=>$b959dd84148d7436$export$5760f9690301cdb);
    $parcel$export(module.exports, "transformStatusToParam", ()=>$b959dd84148d7436$export$46595832dd863016);
    $parcel$export(module.exports, "transformSortOrderFromParam", ()=>$b959dd84148d7436$export$1945e6d2f31e09e6);
    $parcel$export(module.exports, "transformSortFieldFromParam", ()=>$b959dd84148d7436$export$f842a0d1846d319d);
    $parcel$export(module.exports, "transformStatusToDropdownSelection", ()=>$b959dd84148d7436$export$7dad705635760cfe);
    $parcel$export(module.exports, "getUpdatedDisplayedStatuses", ()=>$b959dd84148d7436$export$ce4c948ba1d53df4);
    $parcel$export(module.exports, "getFormattedVersionDate", ()=>$b959dd84148d7436$export$5a6eeb16be7dd21d);
    var $1O7Kb;
    var $brjCS;
    const $b959dd84148d7436$export$5760f9690301cdb = (input)=>{
        switch(input){
            case 'no-filter':
                return [
                    (0, (0, parcelRequire("brjCS")).RELEASED),
                    (0, (0, parcelRequire("brjCS")).UNRELEASED),
                    (0, (0, parcelRequire("brjCS")).ARCHIVED)
                ];
            case 'all':
                return [
                    (0, (0, parcelRequire("brjCS")).RELEASED),
                    (0, (0, parcelRequire("brjCS")).UNRELEASED),
                    (0, (0, parcelRequire("brjCS")).ARCHIVED)
                ];
            default:
                {
                    const params = (input || '').split('-');
                    const result = [
                        ...params.includes('released') ? [
                            (0, (0, parcelRequire("brjCS")).RELEASED)
                        ] : [],
                        ...params.includes('unreleased') ? [
                            (0, (0, parcelRequire("brjCS")).UNRELEASED)
                        ] : [],
                        ...params.includes('archived') ? [
                            (0, (0, parcelRequire("brjCS")).ARCHIVED)
                        ] : []
                    ];
                    return result.length ? result : [
                        (0, (0, parcelRequire("brjCS")).UNRELEASED)
                    ];
                }
        }
    };
    const $b959dd84148d7436$export$46595832dd863016 = (input)=>{
        if (input) {
            if (input.length === 0) return 'no-filter';
            if (input.length > 2) return 'all';
            return [
                input.includes((0, (0, parcelRequire("brjCS")).RELEASED)) && [
                    'released'
                ],
                input.includes((0, (0, parcelRequire("brjCS")).UNRELEASED)) && [
                    'unreleased'
                ],
                input.includes((0, (0, parcelRequire("brjCS")).ARCHIVED)) && [
                    'archived'
                ]
            ].filter(Boolean).join('-');
        }
        return undefined;
    };
    const $b959dd84148d7436$export$1945e6d2f31e09e6 = (input)=>{
        switch(input){
            case 'ASC':
                return 0, $2a9e000a443b1a95$export$1dee026a19752d6b;
            case 'DESC':
                return 0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65;
            default:
                return 0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65;
        }
    };
    const $b959dd84148d7436$export$f842a0d1846d319d = (input)=>{
        switch(input){
            case 'NAME':
                return 0, $6868fc0fce0c2912$export$3c5e605ca7ade9f2;
            case 'RELEASEDATE':
                return 0, $6868fc0fce0c2912$export$50241fe906e4f94e;
            case 'STARTDATE':
                return 0, $6868fc0fce0c2912$export$99a467bcc22b8df9;
            case 'DESCRIPTION':
                return 0, $6868fc0fce0c2912$export$d44826c816b5619b;
            case 'SEQUENCE':
                return 0, $6868fc0fce0c2912$export$34694f8d8b23ee2a;
            default:
                return 0, $6868fc0fce0c2912$export$34694f8d8b23ee2a;
        }
    };
    const $b959dd84148d7436$export$7dad705635760cfe = (input)=>{
        switch(input){
            case 'no-filter':
                return [];
            case 'all':
                return [
                    (0, (0, parcelRequire("brjCS")).RELEASED),
                    (0, (0, parcelRequire("brjCS")).UNRELEASED),
                    (0, (0, parcelRequire("brjCS")).ARCHIVED)
                ];
            default:
                {
                    const params = (input || '').split('-');
                    const result = [
                        ...params.includes('released') ? [
                            (0, (0, parcelRequire("brjCS")).RELEASED)
                        ] : [],
                        ...params.includes('unreleased') ? [
                            (0, (0, parcelRequire("brjCS")).UNRELEASED)
                        ] : [],
                        ...params.includes('archived') ? [
                            (0, (0, parcelRequire("brjCS")).ARCHIVED)
                        ] : []
                    ];
                    return result.length ? result : [
                        (0, (0, parcelRequire("brjCS")).UNRELEASED)
                    ];
                }
        }
    };
    const $b959dd84148d7436$export$ce4c948ba1d53df4 = (displayedStatuses, selectedStatuses, newStatus)=>{
        if (displayedStatuses.length === (0, $6868fc0fce0c2912$export$bbcbc202f2dfa28c)) {
            if (!selectedStatuses.length) return [
                newStatus
            ];
            return displayedStatuses.filter((status)=>status !== newStatus);
        }
        return displayedStatuses.includes(newStatus) ? displayedStatuses.filter((item)=>item !== newStatus) : [
            ...displayedStatuses,
            newStatus
        ];
    };
    const $b959dd84148d7436$export$5a6eeb16be7dd21d = (versionDate, formatDate)=>versionDate != null ? formatDate(new Date(versionDate), {
            timeZone: (0, (0, parcelRequire("1O7Kb")).VERSION_DATE_FORMAT_OPTION).timeZone,
            dateStyle: 'long'
        }) : '';
});
const $2a9e000a443b1a95$export$1dee026a19752d6b = 'ASC';
const $2a9e000a443b1a95$export$b6abcf7fa1d94f65 = 'DESC';
parcelRegister("1O7Kb", function(module, exports) {
    $parcel$export(module.exports, "VERSION_DATE_FORMAT_OPTION", ()=>$db4b27c65287280e$export$d54c0d576c2caef5);
    const $db4b27c65287280e$export$d54c0d576c2caef5 = {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        timeZone: 'UTC'
    };
});
parcelRegister("brjCS", function(module, exports) {
    $parcel$export(module.exports, "RELEASED", ()=>$96a1491cb0f9d4eb$export$b983f2cb1f658a55);
    $parcel$export(module.exports, "UNRELEASED", ()=>$96a1491cb0f9d4eb$export$cb459d726a8530a5);
    $parcel$export(module.exports, "ARCHIVED", ()=>$96a1491cb0f9d4eb$export$c936349447a77fe0);
    const $96a1491cb0f9d4eb$export$b983f2cb1f658a55 = 'RELEASED';
    const $96a1491cb0f9d4eb$export$cb459d726a8530a5 = 'UNRELEASED';
    const $96a1491cb0f9d4eb$export$c936349447a77fe0 = 'ARCHIVED';
    var $96a1491cb0f9d4eb$export$2e2bcd8739ae039 = [
        $96a1491cb0f9d4eb$export$b983f2cb1f658a55,
        $96a1491cb0f9d4eb$export$cb459d726a8530a5,
        $96a1491cb0f9d4eb$export$c936349447a77fe0
    ];
});
parcelRegister("lqMPx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$08cc25b93689af36$export$2e2bcd8739ae039);
    const $08cc25b93689af36$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filter"
        }, v2 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "initialLoadCount"
        }, v3 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v4 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchString"
        }, v5 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sortBy"
        }, v6 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v7 = {
            "kind": "ScalarField",
            "name": "projectId"
        }, v8 = {
            "kind": "ScalarField",
            "name": "name"
        }, v9 = {
            "kind": "ScalarField",
            "name": "key"
        }, v10 = {
            "alias": "jiraProjectType",
            "kind": "ScalarField",
            "name": "projectType"
        }, v11 = {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        }, v12 = {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "searchString"
        }, v13 = {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }, v14 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v15 = {
            "kind": "ScalarField",
            "name": "cursor"
        }, v16 = {
            "kind": "ScalarField",
            "name": "statusCode"
        }, v17 = {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "endCursor"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                }
            ]
        }, v18 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v19 = [
            v11,
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "initialLoadCount"
            },
            v12,
            v13
        ], v20 = {
            "kind": "ScalarField",
            "name": "id"
        }, v21 = {
            "kind": "ScalarField",
            "name": "totalCount"
        }, v22 = [
            v21
        ], v23 = [
            {
                "kind": "Literal",
                "name": "filter",
                "value": "DONE"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1,
                    v2,
                    v3,
                    v4,
                    v5
                ],
                "kind": "Fragment",
                "name": "uiProjectVersionsQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v6,
                                        "concreteType": "JiraProject",
                                        "kind": "LinkedField",
                                        "name": "jiraProjectByKey",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": v7,
                                                "action": "THROW",
                                                "path": "jira.jiraProjectByKey.projectId"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v8,
                                                "action": "THROW",
                                                "path": "jira.jiraProjectByKey.name"
                                            },
                                            {
                                                "kind": "RequiredField",
                                                "field": v9,
                                                "action": "THROW",
                                                "path": "jira.jiraProjectByKey.key"
                                            },
                                            v10,
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "alias": "versions",
                                                    "args": [
                                                        v11,
                                                        v12,
                                                        v13
                                                    ],
                                                    "concreteType": "JiraVersionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "__uiProject__versions_connection",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraVersionEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v14,
                                                                v15,
                                                                {
                                                                    "concreteType": "JiraVersion",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v14
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "QueryError",
                                                            "kind": "LinkedField",
                                                            "name": "errors",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "extensions",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v16
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v17,
                                                        v18
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.jiraProjectByKey.versions"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.jiraProjectByKey"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    },
                    {
                        "args": v19,
                        "kind": "FragmentSpread",
                        "name": "table_projectVersions"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v2,
                    v1,
                    v4,
                    v5,
                    v0,
                    v3
                ],
                "kind": "Operation",
                "name": "uiProjectVersionsQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v6,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    v7,
                                    v8,
                                    v9,
                                    v10,
                                    {
                                        "args": v19,
                                        "concreteType": "JiraVersionConnection",
                                        "kind": "LinkedField",
                                        "name": "versions",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraVersionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    v14,
                                                    v15,
                                                    {
                                                        "concreteType": "JiraVersion",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v14,
                                                            v20,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "status"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "description"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "startDate"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "releaseDate"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "overdue"
                                                            },
                                                            {
                                                                "alias": "allIssues",
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "filter",
                                                                        "value": "ALL"
                                                                    }
                                                                ],
                                                                "concreteType": "JiraIssueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issues",
                                                                "plural": false,
                                                                "selections": v22,
                                                                "storageKey": "issues(filter:\"ALL\")"
                                                            },
                                                            {
                                                                "alias": "doneIssues",
                                                                "args": v23,
                                                                "concreteType": "JiraIssueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issues",
                                                                "plural": false,
                                                                "selections": v22,
                                                                "storageKey": "issues(filter:\"DONE\")"
                                                            },
                                                            {
                                                                "alias": "done",
                                                                "args": v23,
                                                                "concreteType": "JiraIssueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issues",
                                                                "plural": false,
                                                                "selections": v22,
                                                                "storageKey": "issues(filter:\"DONE\")"
                                                            },
                                                            {
                                                                "alias": "inProgress",
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "filter",
                                                                        "value": "IN_PROGRESS"
                                                                    }
                                                                ],
                                                                "concreteType": "JiraIssueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issues",
                                                                "plural": false,
                                                                "selections": v22,
                                                                "storageKey": "issues(filter:\"IN_PROGRESS\")"
                                                            },
                                                            {
                                                                "alias": "toDo",
                                                                "args": [
                                                                    {
                                                                        "kind": "Literal",
                                                                        "name": "filter",
                                                                        "value": "TODO"
                                                                    }
                                                                ],
                                                                "concreteType": "JiraIssueConnection",
                                                                "kind": "LinkedField",
                                                                "name": "issues",
                                                                "plural": false,
                                                                "selections": v22,
                                                                "storageKey": "issues(filter:\"TODO\")"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "versionId"
                                                            },
                                                            v8,
                                                            v18
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "QueryError",
                                                "kind": "LinkedField",
                                                "name": "errors",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "extensions",
                                                        "plural": true,
                                                        "selections": [
                                                            v14,
                                                            v16
                                                        ]
                                                    }
                                                ]
                                            },
                                            v17,
                                            v18,
                                            v21
                                        ]
                                    },
                                    {
                                        "args": v19,
                                        "filters": [
                                            "filter",
                                            "searchString",
                                            "sortBy"
                                        ],
                                        "handle": "connection",
                                        "key": "uiProject__versions",
                                        "kind": "LinkedHandle",
                                        "name": "versions"
                                    },
                                    v20,
                                    {
                                        "kind": "ScalarField",
                                        "name": "projectType"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "a6e359ecda35492174250b1c105fa73cbd222dbbdae576ab9b3b84813585a559",
                "metadata": {
                    "connection": [
                        {
                            "count": "initialLoadCount",
                            "cursor": null,
                            "direction": "forward",
                            "path": [
                                "jira",
                                "jiraProjectByKey",
                                "versions"
                            ]
                        }
                    ]
                },
                "name": "uiProjectVersionsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $08cc25b93689af36$var$node.hash = "3bed4070fd244faac23cfc6a62e64f6c";
    var $08cc25b93689af36$export$2e2bcd8739ae039 = $08cc25b93689af36$var$node;
});
const $92b865e141ed2a4f$export$59aa73792ad9507a = 'PROJECT_VERSIONS';
parcelRegister("94kpz", function(module, exports) {
    $parcel$export(module.exports, "projectSettingsVersionsRoute", ()=>$703d543a7ad60312$export$cc9450e5d7579b99);
    var $65Ltd;
    const $703d543a7ad60312$export$cc9450e5d7579b99 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS),
        path: '/plugins/servlet/project-config/:projectKey/administer-versions'
    };
});
parcelRegister("af7CK", function(module, exports) {
    $parcel$export(module.exports, "LazyRelayProjectVersions", ()=>$4b5729de9815f9dc$export$9036da4fa9f7a66f);
    $parcel$export(module.exports, "RelayVersions", ()=>$4b5729de9815f9dc$export$9aff7dab80671d9);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $4b5729de9815f9dc$export$9036da4fa9f7a66f = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("7J051"))), {
        moduleId: "./src/packages/spa-apps/project/relay-versions/src/index.tsx"
    });
    const $4b5729de9815f9dc$export$9aff7dab80671d9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4b5729de9815f9dc$export$9036da4fa9f7a66f,
            pageId: "relay-project-versions",
            shouldShowSpinner: false
        });
});
parcelRegister("7J051", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("guRgf")
    ]).then(()=>parcelRequire('5E2pR'));
});
parcelRegister("D0ZxL", function(module, exports) {
    $parcel$export(module.exports, "projectsRedirectRouteEntry", ()=>$4352c9150dc3830e$export$56f9921db324f30);
    var $ffza4;
    var $gyYxw;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $7MCPm;
    var $4HPds;
    const $4352c9150dc3830e$export$56f9921db324f30 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4HPds")).projectsRedirectRoute), ()=>({
            isRedirect: true,
            component: (0, (0, parcelRequire("7MCPm")).RedirectToLastVisitedProjectPage),
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
});
parcelRegister("4HPds", function(module, exports) {
    $parcel$export(module.exports, "projectsRedirectRoute", ()=>$0def52f3c20b06e9$export$e6bc3ea427ddafb8);
    var $65Ltd;
    const $0def52f3c20b06e9$export$e6bc3ea427ddafb8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_REDIRECTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECTS_REDIRECT),
        path: '/projects/:projectKey',
        query: [
            'selectedItem!=(.+)'
        ],
        exact: true
    };
});
parcelRegister("bNEBO", function(module, exports) {
    $parcel$export(module.exports, "projectVersionsRouteEntry", ()=>$57f6bcf0c0b40681$export$982bc443ef89cc3f);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $gyYxw;
    var $lmyls;
    var $hBv66;
    var $2G9Bk;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $bC7QJ;
    var $dwV0k;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $57f6bcf0c0b40681$export$9036da4fa9f7a66f = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("7J051"))), {
        moduleId: "./src/packages/spa-apps/project/relay-versions/src/index.tsx"
    });
    const $57f6bcf0c0b40681$export$9aff7dab80671d9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $57f6bcf0c0b40681$export$9036da4fa9f7a66f,
            pageId: "relay-project-versions",
            shouldShowSpinner: false
        });
    const $57f6bcf0c0b40681$export$982bc443ef89cc3f = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("dwV0k")).projectVersionsRoute), ()=>({
            resources: [
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectResource)(),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("bC7QJ")).projectVersionsRelayResource)
            ],
            component: $57f6bcf0c0b40681$export$9aff7dab80671d9,
            layout: (0, (0, parcelRequire("gyYxw")).genericProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319)
            },
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $57f6bcf0c0b40681$export$9036da4fa9f7a66f
            ]
        }));
});
parcelRegister("dwV0k", function(module, exports) {
    $parcel$export(module.exports, "projectVersionsRoute", ()=>$2adcd26097a17fc3$export$fb5516756c3eba40);
    var $kMGqE;
    var $65Ltd;
    const $2adcd26097a17fc3$export$fb5516756c3eba40 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_VERSIONS),
        path: '/projects/:projectKey',
        query: (0, (0, parcelRequire("kMGqE")).PROJECTS_VERSIONS_QUERY_PARAMS)
    };
});
parcelRegister("kMGqE", function(module, exports) {
    $parcel$export(module.exports, "PROJECTS_VERSIONS_QUERY_PARAMS", ()=>$91224398be5e0171$export$ad46185437bb571a);
    const $91224398be5e0171$export$ad46185437bb571a = [
        'selectedItem=com.atlassian.jira.jira-projects-plugin:release-page'
    ];
});
parcelRegister("Tiqy3", function(module, exports) {
    $parcel$export(module.exports, "rovoDemandTestsRouteEntry", ()=>$ad2b1e4948a3529a$export$95ed5e2f774d3f79);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $cSD7y;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $5lsNZ;
    var $e1H0R;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $ad2b1e4948a3529a$export$ad2594850aa1640c = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4OVrg"))), {
        moduleId: "./src/packages/spa-apps/rovo-demand-tests/src/index.tsx"
    });
    const $ad2b1e4948a3529a$export$12d166f59b63486e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ad2b1e4948a3529a$export$ad2594850aa1640c,
            pageId: "rovo-demand-tests",
            shouldShowSpinner: false
        });
    const $ad2b1e4948a3529a$export$95ed5e2f774d3f79 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("e1H0R")).rovoDemandTestsRoute), ()=>({
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
            ],
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jsw_rovo_demand_tests_gate', $ad2b1e4948a3529a$export$12d166f59b63486e, (0, (0, parcelRequire("5lsNZ")).default)),
            layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $ad2b1e4948a3529a$export$ad2594850aa1640c
            ]
        }));
});
parcelRegister("e1H0R", function(module, exports) {
    $parcel$export(module.exports, "rovoDemandTestsRoute", ()=>$55f35adcbcfe2307$export$cb08569a5439c36a);
    var $65Ltd;
    const $55f35adcbcfe2307$export$cb08569a5439c36a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_COMPONENTS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ROVO_DEMAND_TESTS),
        path: '/jira/software/rovo/discover'
    };
});
parcelRegister("4OVrg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2Nk6X").then(()=>parcelRequire('8ImNC'));
});
parcelRegister("kAzeP", function(module, exports) {
    $parcel$export(module.exports, "customerServiceEscalationsRouteEntry", ()=>$907c348c7aa50cd6$export$36a7c374f4474cc1);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $e4B7v;
    var $7fRd9;
    var $h4Vg7;
    var $6Z2mh;
    var $e9YVH;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $907c348c7aa50cd6$var$LazyServicedeskCustomerServiceEscalations = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dEz0W"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/customer-service-escalations/src/index.tsx"
    });
    const $907c348c7aa50cd6$export$1a08682f4847bb2f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $907c348c7aa50cd6$var$LazyServicedeskCustomerServiceEscalations,
            pageId: "spa-apps/servicedesk/customer-service-escalations",
            shouldShowSpinner: true
        });
    const $907c348c7aa50cd6$export$36a7c374f4474cc1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("h4Vg7")).escalationsRoute), ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("e4B7v")).componentFilterResource),
                (0, (0, parcelRequire("7fRd9")).priorityFilterResource)
            ],
            component: $907c348c7aa50cd6$export$1a08682f4847bb2f,
            perfMetricKey: 'jsm-customer-service-escalations-component-load',
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $907c348c7aa50cd6$var$LazyServicedeskCustomerServiceEscalations
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_SERVICE_ESCALATIONS,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_SERVICE_ESCALATIONS),
                    teamName: 'boysenberry'
                }
            }
        }));
});
parcelRegister("e4B7v", function(module, exports) {
    $parcel$export(module.exports, "componentFilterResource", ()=>$ff0131666c555211$export$306e389909032632);
    $parcel$export(module.exports, "useComponentFilterResource", ()=>$ff0131666c555211$export$e13868d6ab2288af);
    var $dK8AG;
    var $dIdda = parcelRequire("dIdda");
    const $ff0131666c555211$var$getDataLoader = ()=>(parcelRequire("6JIaQ"));
    const $ff0131666c555211$export$306e389909032632 = (0, $dIdda.createResource)({
        type: 'ESCALATIONS_COMPONENT_FILTER_RESOURCE',
        getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
        getDataLoader: $ff0131666c555211$var$getDataLoader
    });
    const $ff0131666c555211$export$e13868d6ab2288af = ()=>(0, $dIdda.useResource)($ff0131666c555211$export$306e389909032632);
});
parcelRegister("6JIaQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("2IGml").then(()=>parcelRequire('hXg9m'));
});
parcelRegister("7fRd9", function(module, exports) {
    $parcel$export(module.exports, "priorityFilterResource", ()=>$1ec7e880e057744a$export$ca03c5f9fc44703e);
    $parcel$export(module.exports, "usePriorityFilterResource", ()=>$1ec7e880e057744a$export$3654f46b6bb12558);
    var $4R6GH;
    var $dK8AG;
    var $dIdda = parcelRequire("dIdda");
    const $1ec7e880e057744a$var$getDataLoader = ()=>(parcelRequire("j4Bjz"));
    const $1ec7e880e057744a$export$ca03c5f9fc44703e = (0, $dIdda.createResource)({
        type: 'ESCALATIONS_PRIORITY_FILTER_RESOURCE',
        getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
        getDataLoader: $1ec7e880e057744a$var$getDataLoader
    });
    const $1ec7e880e057744a$export$3654f46b6bb12558 = ()=>(0, $dIdda.useResource)((0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag') ? $1ec7e880e057744a$export$ca03c5f9fc44703e : (0, $dIdda.createResource)({
            type: 'ESCALATIONS_PRIORITY_FILTER_RESOURCE',
            getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
            getDataLoader: $1ec7e880e057744a$var$getDataLoader
        }));
});
parcelRegister("j4Bjz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cfFsf").then(()=>parcelRequire('ejgJG'));
});
parcelRegister("h4Vg7", function(module, exports) {
    $parcel$export(module.exports, "escalationsRoute", ()=>$d065d46729096355$export$3d91b36833b7ddb9);
    var $65Ltd;
    const $d065d46729096355$export$3d91b36833b7ddb9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_ESCALATIONS),
        path: '/jira/servicedesk/projects/:projectKey/escalations',
        exact: true
    };
});
parcelRegister("e9YVH", function(module, exports) {
    $parcel$export(module.exports, "APP_NAMES", ()=>$26ff993b947c317f$export$4116f3d0d9d6bed7);
    $parcel$export(module.exports, "toPackageName", ()=>$26ff993b947c317f$export$f31a652635bd75fe);
    const $26ff993b947c317f$export$4116f3d0d9d6bed7 = {
        ACCOUNTS: 'servicedesk.accounts',
        APP_DISCOVERY: 'servicedesk.app-discovery',
        ATLASSIAN_ANALYTICS: 'servicedesk.atlassian-analytics',
        AUTOMATION_EDIT_RULE: 'servicedesk.automation.edit-rule',
        AUTOMATION_SUMMARY: 'servicedesk.automation.summary',
        AUTOMATION_VIEW_LOG: 'servicedesk.automation.view-log',
        BOARD: 'servicedesk.board',
        BOARD_SETTINGS: 'servicedesk.board-settings',
        CALENDAR: 'servicedesk.calendar',
        PROJECT_SUMMARY: 'servicedesk.project-summary',
        CHANGE_CALENDAR: 'servicedesk.change-calendar',
        CHANGE_MANAGEMENT_SETTINGS: 'servicedesk.change-management.settings',
        CREATE_PROJECT: 'servicedesk.create-project',
        CSAT_CONFIG: 'servicedesk.csat-configuration',
        CUSTOMER_PERMISSIONS: 'servicedesk.customer-permissions',
        CONTACTS: 'servicedesk.contacts',
        CUSTOMERS: 'servicedesk.customers',
        CUSTOMER_DETAILS: 'servicedesk.customer-details',
        CUSTOMER_SERVICE_ESCALATIONS: 'servicedesk.customer-service-escalations',
        CUSTOMER_SERVICE_PRODUCTS: 'servicedesk.customer-service-products',
        INVITE_TEAM_DIALOG: 'servicedesk.invite-team-dialog',
        ISSUE_SCHEDULE_CHANGE: 'servicedesk.issue.schedule-change',
        ITSM_FEATURES_SETTINGS: 'servicedesk.itsm-features.settings',
        ITSM_SAMPLE_SPACE: 'servicedesk.itsm-sample-space',
        JOURNEYS: 'servicedesk.journeys',
        JOURNEY_CONFIG: 'servicedesk.journey-config',
        GETTING_STARTED_PAGE: 'servicedesk.getting-started-page',
        KB_BROWSE_ARTICLES: 'servicedesk.knowledge-base.browse-articles',
        KB_CATEGORY: 'servicedesk.knowledge-base.category',
        KB_DRAFTS: 'servicedesk.knowledge-base.drafts',
        KB_BROWSE_CATEGORIES: 'servicedesk.knowledge-base.browse-categories',
        KB_SUGGESTED_ARTICLES: 'servicedesk.knowledge-base.suggested-articles',
        KB_EMBED_EDITOR: 'servicedesk.knowledge-article.embed-editor',
        KB_LANDING: 'servicedesk.knowledge-base.landing',
        KB_REPORTS_REQUESTS: 'servicedesk.kb-requests.reports',
        KB_SEARCH: 'servicedesk.knowledge-base.search',
        KB_SETTINGS: 'servicedesk.knowledge.settings',
        KB_SETUP: 'servicedesk.knowledge-base.setup',
        KB_VIEW_ARTICLE: 'servicedesk.knowledge-base.view-article',
        ORGANIZATION: 'servicedesk.organization',
        ORGANIZATIONS: 'servicedesk.organizations',
        ORGANIZATION_DETAILS: 'servicedesk.organization-details',
        PORTAL_SETTINGS: 'servicedesk.portal-settings',
        QUEUES_AGENT_VIEW: 'servicedesk.queues.agent-view',
        QUEUES_EDIT_VIEW: 'servicedesk.queues.edit-view',
        QUEUES_MAIN: 'servicedesk.queues.main',
        REPORTS_CUSTOM: 'servicedesk.reports.custom',
        REPORTS_CUSTOM_CREATE: 'servicedesk.reports.custom-create',
        REPORTS_CUSTOM_EDIT: 'servicedesk.reports.custom-edit',
        REPORTS_HOME_PAGE: 'servicedesk.reports.home-page',
        REPORTS_SATISFACTION: 'servicedesk.reports.satisfaction',
        REPORTS_WORKLOAD: 'servicedesk.reports.workload',
        REQUEST_TYPES_CONFIG: 'servicedesk.request-types-config',
        REQUEST_TYPE_FIELDS: 'servicedesk.request-type-fields',
        SLA_SETTINGS: 'servicedesk.sla-settings',
        VIRTUAL_AGENT_BROWSE_CONVERSATIONS: 'servicedesk.virtual-agent.browse-conversations',
        VIRTUAL_AGENT_BROWSE_INTENTS: 'servicedesk.virtual-agent.browse-intents',
        VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS: 'servicedesk.virtual-agent.browse-standard-flows',
        VIRTUAL_AGENT_LANDING: 'servicedesk.virtual-agent.landing',
        VIRTUAL_AGENT_SETTINGS: 'servicedesk.virtual-agent.settings',
        VIRTUAL_AGENT_VIEW_INTENT: 'servicedesk.virtual-agent.view-intent',
        VIRTUAL_AGENT_VIEW_STANDARD_FLOW: 'servicedesk.virtual-agent.view-standard-flow',
        PRACTICE_CONFIG_MODULE: 'servicedesk.practice-config-module',
        CREATE_SERVICE_MODAL: 'servicedesk.create-service-modal',
        UPDATE_SERVICE_MODAL: 'servicedesk.update-service-modal',
        LANGUAGE_SETTINGS: 'servicedesk.language-settings',
        LINKED_ALERTS_MODAL: 'servicedesk.link-alerts-modal',
        INSIGHT_ASSETS_REPORTS: 'servicedesk.insight-cmdb-assets_reports',
        INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT: 'servicedesk.insight-cmdb-assets_reports_default_redirect',
        INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE: 'servicedesk.insight-cmdb-assets_reports_unsubscribe',
        INSIGHT_OBJECT_VIEW: 'servicedesk.insight-cmdb-object',
        INSIGHT_OBJECT_SCHEMA: 'servicedesk.insight-cmdb-object-schema',
        INSIGHT_OBJECT_SCHEMA_CONFIGURATION: 'servicedesk.insight-cmdb-object-schema-configuration',
        INSIGHT_OBJECT_TYPE_CONFIGURATION: 'servicedesk.insight-object-type-configuration',
        INSIGHT_GLOBAL_CONFIGURATION: 'servicedesk.insight-cmdb-global-configuration',
        INSIGHT_LANDING_PAGE: 'servicedesk.insight-cmdb-landing-page',
        CUSTOMER_NOTIFICATIONS_MAIN_VIEW: 'servicedesk.customer-notifications-settings.main-view',
        CUSTOMER_NOTIFICATIONS_INVITE_CUSTOMER_VIEW: 'servicedesk.customer-notifications-settings.invite-customer-view',
        CUSTOMER_NOTIFICATIONS_RULE_VIEW: 'servicedesk.customer-notifications-settings.rule-view',
        CUSTOMER_NOTIFICATIONS_TEMPLATE_VIEW: 'servicedesk.customer-notifications-settings.template-view',
        CUSTOMER_NOTIFICATIONS_UNKNOWN_VIEW: 'servicedesk.customer-notifications-settings.unknown-view',
        SERVICES_WITHOUT_PROJECT_VIEW: 'servicedesk.services-without-project-view',
        SERVICE_DETAIL_WITHOUT_PROJECT_VIEW: 'servicedesk.service-detail-without-project-view',
        WIDGET_SETTINGS: 'servicedesk.widget-settings'
    };
    const $26ff993b947c317f$var$ANALYTICS_PACKAGE_NAMES = {
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ACCOUNTS]: 'servicedeskAccounts',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.APP_DISCOVERY]: 'serviceDeskAppDiscovery',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ATLASSIAN_ANALYTICS]: 'serviceDeskAtlassianAnalytics',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.AUTOMATION_EDIT_RULE]: 'servicedeskAutomationEditView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.AUTOMATION_SUMMARY]: 'servicedeskAutomationEditRule',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.AUTOMATION_VIEW_LOG]: 'servicedeskAutomationViewLog',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.BOARD]: 'servicedeskBoard',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.BOARD_SETTINGS]: 'servicedeskBoardSettings',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CALENDAR]: 'servicedeskCalendar',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.PROJECT_SUMMARY]: 'servicedeskProjectSummary',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CHANGE_CALENDAR]: 'servicedeskChangeCalendar',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CHANGE_MANAGEMENT_SETTINGS]: 'servicedeskChangeManagementSettings',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CREATE_PROJECT]: 'servicedeskCreateProject',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CSAT_CONFIG]: 'servicedeskCsatConfig',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CONTACTS]: 'servicedeskContacts',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_PERMISSIONS]: 'servicedeskCustomerPermissions',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMERS]: 'servicedeskCustomers',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_DETAILS]: 'servicedeskCustomerDetails',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_ESCALATIONS]: 'servicedeskCustomerServiceEscalations',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_SERVICE_PRODUCTS]: 'servicedeskCustomerServiceProducts',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INVITE_TEAM_DIALOG]: 'servicedeskInviteTeamDialog',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ISSUE_SCHEDULE_CHANGE]: 'servicedeskIssueScheduleChange',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ITSM_FEATURES_SETTINGS]: 'servicedeskItsmFeaturesSettings',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ITSM_SAMPLE_SPACE]: 'servicedeskItsmSampleSpace',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.JOURNEYS]: 'servicedeskJourneys',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.JOURNEY_CONFIG]: 'servicedeskJourneyConfig',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_BROWSE_ARTICLES]: 'servicedeskKnowledgeBaseBrowseArticles',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_BROWSE_CATEGORIES]: 'servicedeskKnowledgeBaseBrowseCategories',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_CATEGORY]: 'servicedeskKnowledgeBaseCategory',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_DRAFTS]: 'servicedeskKnowledgeBaseDrafts',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SUGGESTED_ARTICLES]: 'servicedeskKnowledgeBaseSuggestedArticles',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_EMBED_EDITOR]: 'servicedeskKnowledgeBaseEmbedEditor',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_LANDING]: 'servicedeskKnowledgeBaseLanding',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_REPORTS_REQUESTS]: 'servicedeskKbRequestsReports',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SEARCH]: 'servicedeskKnowledgeBaseSearch',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SETTINGS]: 'servicedeskKnowledgeSettings',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_SETUP]: 'servicedeskKnowledgeBaseSetup',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.KB_VIEW_ARTICLE]: 'servicedeskKnowledgeBaseViewArticle',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.LANGUAGE_SETTINGS]: 'servicedeskLanguageSettingsTranslations',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ORGANIZATION]: 'servicedeskOrganization',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ORGANIZATIONS]: 'servicedeskOrganizations',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.ORGANIZATION_DETAILS]: 'servicedeskOrganizationDetails',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.PORTAL_SETTINGS]: 'servicedeskPortalSettings',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.QUEUES_AGENT_VIEW]: 'servicedeskQueuesAgentView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.QUEUES_EDIT_VIEW]: 'servicedeskQueuesEditView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.QUEUES_MAIN]: 'servicedeskQueuesMain',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_CUSTOM]: 'servicedeskReportsCustom',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_CUSTOM_CREATE]: 'servicedeskReportsCustomCreate',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_CUSTOM_EDIT]: 'servicedeskReportsCustomEdit',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_HOME_PAGE]: 'servicedeskReportsHomePage',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_SATISFACTION]: 'servicedeskReportsSatisfaction',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REPORTS_WORKLOAD]: 'servicedeskReportsWorkload',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REQUEST_TYPES_CONFIG]: 'servicedeskRequestTypesConfig',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.REQUEST_TYPE_FIELDS]: 'servicedeskRequestTypeFields',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.SLA_SETTINGS]: 'servicedeskSlaSettings',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_CONVERSATIONS]: 'servicedeskVirtualAgentBrowseConversations',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_INTENTS]: 'servicedeskVirtualAgentBrowseIntents',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS]: 'servicedeskVirtualAgentBrowseStandardFlows',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_LANDING]: 'servicedeskVirtualAgentLanding',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_SETTINGS]: 'servicedeskVirtualAgentSettings',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_VIEW_INTENT]: 'servicedeskVirtualAgentViewIntent',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.VIRTUAL_AGENT_VIEW_STANDARD_FLOW]: 'servicedeskVirtualAgentViewStandardFlow',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.PRACTICE_CONFIG_MODULE]: 'servicedeskPracticeConfigModule',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CREATE_SERVICE_MODAL]: 'servicedeskCreateServiceModal',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.UPDATE_SERVICE_MODAL]: 'servicedeskUpdateServiceModal',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.LINKED_ALERTS_MODAL]: 'servicedeskLinkAlertsModal',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS]: 'servicedeskAssetsReports',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT]: 'servicedeskAssetsReportsDefaultRedirect',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE]: 'servicedeskAssetsReportsUnsubscribe',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_VIEW]: 'servicedeskObjectView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_SCHEMA]: 'servicedeskObjectSchema',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_SCHEMA_CONFIGURATION]: 'servicedeskObjectSchemaConfiguration',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_OBJECT_TYPE_CONFIGURATION]: 'servicedeskObjectTypeConfiguration',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_GLOBAL_CONFIGURATION]: 'servicedeskInsightGlobalConfiguration',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.INSIGHT_LANDING_PAGE]: 'servicedeskInsightLandingPage',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_MAIN_VIEW]: 'servicedeskCustomerNotificationsMainView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_INVITE_CUSTOMER_VIEW]: 'servicedeskCustomerNotificationsInviteCustomerView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_RULE_VIEW]: 'servicedeskCustomerNotificationsRuleView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_TEMPLATE_VIEW]: 'servicedeskCustomerNotificationsTemplateView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.CUSTOMER_NOTIFICATIONS_UNKNOWN_VIEW]: 'servicedeskCustomerNotificationsUnknownView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.GETTING_STARTED_PAGE]: 'servicedeskGettingStartedPage',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.SERVICES_WITHOUT_PROJECT_VIEW]: 'servicedeskServicesWithoutProjectView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.SERVICE_DETAIL_WITHOUT_PROJECT_VIEW]: 'servicedeskServiceDetailWithoutProjectView',
        [$26ff993b947c317f$export$4116f3d0d9d6bed7.WIDGET_SETTINGS]: 'servicedeskWidgetSettings'
    };
    const $26ff993b947c317f$export$f31a652635bd75fe = (appName)=>$26ff993b947c317f$var$ANALYTICS_PACKAGE_NAMES[appName];
});
parcelRegister("dEz0W", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("74akO")
    ]).then(()=>parcelRequire('81cgT'));
});
parcelRegister("38yi9", function(module, exports) {
    $parcel$export(module.exports, "customerServiceProductsRouteEntry", ()=>$805e5a863a2a14d2$export$8e015e39dbc90d0b);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $cEOhb;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $fpjJX;
    var $7yABM;
    var $giJhw;
    var $6Z2mh;
    var $e9YVH;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $805e5a863a2a14d2$var$LazyServicedeskCustomerServiceProducts = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9N9XD"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/customer-service-products/src/index.tsx"
    });
    const $805e5a863a2a14d2$export$46ba99069f037d90 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $805e5a863a2a14d2$var$LazyServicedeskCustomerServiceProducts,
            pageId: "spa-apps/servicedesk/customer-service-products",
            shouldShowSpinner: true
        });
    const $805e5a863a2a14d2$export$8e015e39dbc90d0b = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("giJhw")).productsRoute), ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                horizontal: (0, (0, parcelRequire("cEOhb")).AsyncDirectoryNav),
                onlyShowHorizontalOnNav4: true
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("7yABM")).customerServiceProductsQueryResource)
            ],
            component: $805e5a863a2a14d2$export$46ba99069f037d90,
            perfMetricKey: 'jsm-customer-service-products-component-load',
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $805e5a863a2a14d2$var$LazyServicedeskCustomerServiceProducts
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_SERVICE_PRODUCTS,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_SERVICE_PRODUCTS),
                    teamName: 'boysenberry'
                }
            }
        }));
});
parcelRegister("cEOhb", function(module, exports) {
    $parcel$export(module.exports, "AsyncDirectoryNav", ()=>$c28aa1a42d481780$export$a237f415539577a5);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $hPtZI;
    const $c28aa1a42d481780$var$LazyDirectoryNav = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("4P2oj")).then(({ DirectoryHorizontalNav: DirectoryHorizontalNav })=>DirectoryHorizontalNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/directory/src/ui/index.tsx"
    });
    const $c28aa1a42d481780$export$a237f415539577a5 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-jsm-directory-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($c28aa1a42d481780$var$LazyDirectoryNav, null));
});
parcelRegister("4P2oj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gpMCn").then(()=>parcelRequire('emSF0'));
});
parcelRegister("7yABM", function(module, exports) {
    $parcel$export(module.exports, "PRODUCTS_PAGE_SIZE", ()=>$cbdcceb1886ba86d$export$9e59a0b3e9d74a99);
    $parcel$export(module.exports, "customerServiceProductsQueryResource", ()=>$cbdcceb1886ba86d$export$f9257217f5333b1a);
    var $ao2h1;
    var $aPLvO;
    const $cbdcceb1886ba86d$export$9e59a0b3e9d74a99 = 50;
    const $cbdcceb1886ba86d$export$f9257217f5333b1a = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'CUSTOMER_SERVICE_PRODUCTS_QUERY',
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("aPLvO")).default),
                variables: {
                    cloudId: tenantContext.cloudId,
                    first: $cbdcceb1886ba86d$export$9e59a0b3e9d74a99
                },
                options: {
                    fetchPolicy: 'network-only'
                }
            })
    });
});
parcelRegister("aPLvO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$06c174000e8c134e$export$2e2bcd8739ae039);
    const $06c174000e8c134e$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "first"
            }
        ], v1 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v2 = {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }, v3 = [
            v2
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "srcCustomerServiceProductsQuery",
                "selections": [
                    {
                        "args": [
                            v1,
                            v2
                        ],
                        "kind": "FragmentSpread",
                        "name": "productsPage_servicedeskCustomerServiceProducts"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "srcCustomerServiceProductsQuery",
                "selections": [
                    {
                        "args": [
                            v1
                        ],
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "concreteType": "CustomerServiceProductConnection",
                                "kind": "LinkedField",
                                "name": "productConnections",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "CustomerServiceProductEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "CustomerServiceProduct",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "id"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "name"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "entitlementsCount"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "cursor"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ClientExtension",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__id"
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": v3,
                                "handle": "connection",
                                "key": "customerServiceProducts_productConnections",
                                "kind": "LinkedHandle",
                                "name": "productConnections"
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "bb8d4ae9602322e43ac61cf45c886f9ecad88afb1aaa237fd8615ea59abb7c16",
                "metadata": {},
                "name": "srcCustomerServiceProductsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $06c174000e8c134e$var$node.hash = "3c49696a6cdc337af280ec80f957ea89";
    var $06c174000e8c134e$export$2e2bcd8739ae039 = $06c174000e8c134e$var$node;
});
parcelRegister("giJhw", function(module, exports) {
    $parcel$export(module.exports, "productsRoute", ()=>$1d2598756cc9eba4$export$7d9d0206a326c6b5);
    var $65Ltd;
    const $1d2598756cc9eba4$export$7d9d0206a326c6b5 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_SERVICE_PRODUCTS),
        path: '/jira/servicedesk/projects/:projectKey/products',
        exact: true
    };
});
parcelRegister("9N9XD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("itg0z")
    ]).then(()=>parcelRequire('fSKfx'));
});
parcelRegister("k6E42", function(module, exports) {
    $parcel$export(module.exports, "settingsAutomationRouteEntry", ()=>$1257e9ea29a7eb00$export$4df9f9dcaf8565c9);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $fnXWd;
    var $fMK33;
    const $1257e9ea29a7eb00$export$4df9f9dcaf8565c9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fnXWd")).settingsAutomationRoute), ()=>({
            component: (0, (0, parcelRequire("fMK33")).default),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("cOg46")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("fMK33")).LazyGlobalAutomation)
            ]
        }));
});
parcelRegister("fnXWd", function(module, exports) {
    $parcel$export(module.exports, "settingsAutomationRoute", ()=>$eb1cb53bd08a56ff$export$b314ab31b2da625b);
    var $65Ltd;
    const $eb1cb53bd08a56ff$export$b314ab31b2da625b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SETTINGS_AUTOMATION),
        path: '/jira/settings/automation',
        exact: true
    };
});
parcelRegister("fMK33", function(module, exports) {
    $parcel$export(module.exports, "LazyGlobalAutomation", ()=>$e4cf560ebe587071$export$4189991a2992b828);
    $parcel$export(module.exports, "default", ()=>$e4cf560ebe587071$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aZsz6 = parcelRequire("aZsz6");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $i9k4m;
    const $e4cf560ebe587071$export$4189991a2992b828 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9P7lL"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/automation/src/index.tsx"
    });
    const $e4cf560ebe587071$export$7c85ddcd4f0a813f = ()=>{
        const page = (_, { selectedItem: selectedItem, ...rest })=>{
            const querystring = (0, $aZsz6.qs).stringify(rest, true);
            return `/automation${querystring}`;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i9k4m")).RedirectToProjectType), {
            page: page
        });
    };
    var $e4cf560ebe587071$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e4cf560ebe587071$export$4189991a2992b828,
            pageId: "global-automation",
            shouldShowSpinner: false
        });
});
parcelRegister("i9k4m", function(module, exports) {
    $parcel$export(module.exports, "RedirectToProjectType", ()=>$5f4113c49e08a927$export$8a3df560509448b8);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $8zOmE;
    var $95EVP;
    var $dxCvy;
    var $bVDE5;
    var $dIdda = parcelRequire("dIdda");
    const $5f4113c49e08a927$export$8a3df560509448b8 = ({ Redirect: Redirect = (0, $dIdda.Redirect), fireUIAnalytics: fireUIAnalytics = (0, (0, parcelRequire("8zOmE")).fireUIAnalytics), page: page, useAnalyticsEvents: useAnalyticsEvents = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents), useResource: useResource = (0, $dIdda.useResource), useRouter: useRouter = (0, $dIdda.useRouter), useSpaStateTransition: useSpaStateTransition = (0, (0, parcelRequire("bVDE5")).useSpaStateTransition) })=>{
        const [{ match: match, query: query, route: route }] = useRouter();
        const { data: data } = useResource((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const { createAnalyticsEvent: createAnalyticsEvent } = useAnalyticsEvents();
        const [{ isInitialRender: isInitial }] = useSpaStateTransition();
        const eventRef = (0, $5uXOq.useRef)(createAnalyticsEvent({}));
        (0, $5uXOq.useEffect)(()=>{
            if (!data || !route || !eventRef.current) return;
            fireUIAnalytics(eventRef.current, 'route redirected', {
                isInitial: isInitial,
                routeName: route.name
            });
            eventRef.current = null;
        }, [
            data,
            fireUIAnalytics,
            isInitial,
            route
        ]);
        if (!data || !route) return null;
        const { projectKey: projectKey, projectType: projectType, simplified: simplified } = data;
        let type;
        switch(projectType){
            case 0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT:
                type = 'servicedesk';
                break;
            case 0, (0, parcelRequire("2vSU6")).CORE_PROJECT:
                type = 'core';
                break;
            case 0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT:
            default:
                type = `software${simplified ? '' : '/c'}`;
        }
        const returnPage = typeof page === 'string' ? page : page(match, query);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Redirect, {
            to: `/jira/${type}/projects/${projectKey}${returnPage}`
        });
    };
});
parcelRegister("9P7lL", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("bCJgs").then(()=>parcelRequire('b0ztm'));
});
parcelRegister("celWn", function(module, exports) {
    $parcel$export(module.exports, "settingsCmdbFieldConfigRouteEntry", ()=>$02dde8a9c2dbcc64$export$c68a412f25295511);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $gOVMI;
    var $gRzZD;
    var $5Td0i;
    const $02dde8a9c2dbcc64$export$c68a412f25295511 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("gOVMI")).settingsCmdbFieldConfigRoute), ()=>({
            ufoName: 'admin.cmdb-field-config',
            component: (0, (0, parcelRequire("5Td0i")).AsyncCmdbFieldConfigPage),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("78U7j")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("gRzZD")).workspaceResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("5Td0i")).LazyCMDBFieldConfigAdmin)
            ]
        }));
});
parcelRegister("gOVMI", function(module, exports) {
    $parcel$export(module.exports, "settingsCmdbFieldConfigRoute", ()=>$138051bf045948cb$export$5097bfaa68f86ca6);
    var $65Ltd;
    const $138051bf045948cb$export$5097bfaa68f86ca6 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SETTINGS_CMDB_FIELD_CONFIG),
        path: '/secure/admin/CmdbObjectFieldConfiguration'
    };
});
parcelRegister("5Td0i", function(module, exports) {
    $parcel$export(module.exports, "LazyCMDBFieldConfigAdmin", ()=>$03d0290def261ead$export$ccc6da5137e23637);
    $parcel$export(module.exports, "AsyncCmdbFieldConfigPage", ()=>$03d0290def261ead$export$8dfbe255f554ebab);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $03d0290def261ead$export$ccc6da5137e23637 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9F4l4"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/cmdb-field-config/src/index.tsx"
    });
    const $03d0290def261ead$export$8dfbe255f554ebab = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $03d0290def261ead$export$ccc6da5137e23637,
            pageId: "admin-pages-cmdb-field-config",
            shouldShowSpinner: true
        });
});
parcelRegister("9F4l4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("HYkbB")
    ]).then(()=>parcelRequire('gXCe1'));
});
parcelRegister("1vVNJ", function(module, exports) {
    $parcel$export(module.exports, "settingsOauthCredentialsRouteEntry", ()=>$1289356c16bfcb3d$export$d1c67ceb7c5e2d6a);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $5bkvv;
    var $iHiHz;
    var $2G9Bk;
    var $ldGiq;
    var $3RJkv;
    var $atU1t;
    var $nvVwd;
    var $jTwes;
    const $1289356c16bfcb3d$export$d1c67ceb7c5e2d6a = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("nvVwd")).settingsOauthCredentialsRoute), ()=>({
            component: (0, (0, parcelRequire("jTwes")).default),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_APPS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("iHiHz")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("5bkvv")).getNavigationSidebarGlobalSettingsResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                (0, (0, parcelRequire("ldGiq")).adminOauthCredentialsResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("jTwes")).LazyOAuthCredentialsAdmin)
            ],
            ufoName: 'admin.oauth-credentials'
        }));
});
parcelRegister("ldGiq", function(module, exports) {
    $parcel$export(module.exports, "adminOauthCredentialsResource", ()=>$b7e65fd0b40325af$export$870d7919c1ca4482);
    var $dIdda = parcelRequire("dIdda");
    const $b7e65fd0b40325af$var$RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS = 'ADMIN_OAUTH_CREDENTIALS';
    const $b7e65fd0b40325af$export$870d7919c1ca4482 = (0, $dIdda.createResource)({
        type: $b7e65fd0b40325af$var$RESOURCE_TYPE_ADMIN_OAUTH_CREDENTIALS,
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("6bf0E"))
    });
});
parcelRegister("6bf0E", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gaQPp").then(()=>parcelRequire('8EYbC'));
});
parcelRegister("nvVwd", function(module, exports) {
    $parcel$export(module.exports, "settingsOauthCredentialsRoute", ()=>$e6898ce9887259a6$export$c0ee28def7ef8783);
    var $65Ltd;
    const $e6898ce9887259a6$export$c0ee28def7ef8783 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SETTINGS_OAUTH_CREDENTIALS),
        path: '/secure/admin/oauth-credentials'
    };
});
parcelRegister("jTwes", function(module, exports) {
    $parcel$export(module.exports, "LazyOAuthCredentialsAdmin", ()=>$a25b27e0ebd790aa$export$101baa25055633e8);
    $parcel$export(module.exports, "default", ()=>$a25b27e0ebd790aa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $a25b27e0ebd790aa$export$101baa25055633e8 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kmNep"))), {
        moduleId: "./src/packages/spa-apps/admin-oauth-credentials/src/index.tsx"
    });
    var $a25b27e0ebd790aa$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a25b27e0ebd790aa$export$101baa25055633e8,
            pageId: "admin-oauth-credentials",
            shouldShowSpinner: true
        });
});
parcelRegister("kmNep", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("1cBTL")
    ]).then(()=>parcelRequire('imW3j'));
});
parcelRegister("eLbXI", function(module, exports) {
    $parcel$export(module.exports, "softwareOnboardingRouteEntries", ()=>$983d5942deafccf1$export$23e1ab8ae95bd3a8);
    $parcel$export(module.exports, "onboardingGetStartedRouteEntries", ()=>$983d5942deafccf1$export$d06c2ab36705e562);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $6e4Kt;
    var $7XYc4;
    var $4R6GH;
    var $lmyls;
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $koWFd;
    var $2G9Bk;
    var $c4yut;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $2Ql51;
    var $5lsNZ;
    var $kO7pc;
    var $5PD5h;
    var $e7bC3;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $983d5942deafccf1$export$31e9f06d3389e445 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3aW4r"))), {
        moduleId: "./src/packages/spa-apps/software/onboarding/src/index.tsx"
    });
    const $983d5942deafccf1$export$689f7402bb424709 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3YmAs"))), {
        moduleId: "./src/packages/spa-apps/onboarding/get-started/src/index.tsx"
    });
    const $983d5942deafccf1$export$ee768d69c6e3a8bd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $983d5942deafccf1$export$31e9f06d3389e445,
            pageId: "software-onboarding",
            shouldShowSpinner: false
        });
    const $983d5942deafccf1$export$d11bafa06a0717e3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $983d5942deafccf1$export$689f7402bb424709,
            pageId: "onboarding-get-started",
            shouldShowSpinner: false
        });
    const $983d5942deafccf1$export$23e1ab8ae95bd3a8 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kO7pc")).softwareOnboardingRoute), ()=>({
                component: $983d5942deafccf1$export$ee768d69c6e3a8bd,
                layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
                resources: [
                    (0, (0, parcelRequire("c4yut")).jswOnboardingResource),
                    (0, (0, parcelRequire("2Ql51")).themePreferenceResource)
                ],
                forPaint: [
                    $983d5942deafccf1$export$31e9f06d3389e445
                ],
                canTransitionIn: ()=>false
            }))
    ];
    const $983d5942deafccf1$export$d06c2ab36705e562 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("kO7pc")).softwareOnboardingGetStartedRoute), ()=>({
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jira_one_screen_onboarding_feature_gate'), $983d5942deafccf1$export$d11bafa06a0717e3, (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    horizontal: (0, (0, parcelRequire("5PD5h")).AsyncHorizontalSoftwareProjectNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $983d5942deafccf1$export$689f7402bb424709
                ],
                canTransitionIn: ()=>true,
                ufoName: 'software-onboarding-get-started'
            }))
    ];
});
parcelRegister("c4yut", function(module, exports) {
    $parcel$export(module.exports, "jswOnboardingResource", ()=>$1ebe6dd05980f4f8$export$be21a2d8a350a80);
    $parcel$export(module.exports, "useJswOnboardingResource", ()=>$1ebe6dd05980f4f8$export$83f546a45ad58d0a);
    var $dIdda = parcelRequire("dIdda");
    const $1ebe6dd05980f4f8$export$be21a2d8a350a80 = (0, $dIdda.createResource)({
        type: (0, $156934826e437e4d$export$692203fca66f4d77),
        getKey: ()=>'jsw_onboarding',
        getDataLoader: ()=>(parcelRequire("528PX"))
    });
    const $1ebe6dd05980f4f8$export$83f546a45ad58d0a = ()=>(0, $dIdda.useResource)($1ebe6dd05980f4f8$export$be21a2d8a350a80);
});
const $156934826e437e4d$export$692203fca66f4d77 = 'RESOURCE_TYPE_SOFTWARE_ONBOARDING';
parcelRegister("528PX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("knzjr").then(()=>parcelRequire('4W57j'));
});
parcelRegister("kO7pc", function(module, exports) {
    $parcel$export(module.exports, "softwareOnboardingRoute", ()=>$e78715d128f3ead6$export$5e6c92d2f34c1e48);
    $parcel$export(module.exports, "softwareOnboardingGetStartedRoute", ()=>$e78715d128f3ead6$export$c25273c48ccc0eb9);
    var $65Ltd;
    const $e78715d128f3ead6$export$5e6c92d2f34c1e48 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ONBOARDING),
        path: '/welcome/software',
        exact: true
    };
    const $e78715d128f3ead6$export$c25273c48ccc0eb9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_ONBOARDING_GET_STARTED),
        path: '/jira/software/projects/:projectKey/get-started',
        exact: true
    };
});
parcelRegister("3aW4r", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("epspQ")
    ]).then(()=>parcelRequire('iCmWy'));
});
parcelRegister("3YmAs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("lRXx5")
    ]).then(()=>parcelRequire('dN3qt'));
});
parcelRegister("2DvlN", function(module, exports) {
    $parcel$export(module.exports, "trashProjectsDirectoryRouteEntry", ()=>$06c044741f640b75$export$27d1f352c2f7acae);
    $parcel$export(module.exports, "trashProjectsDirectory1RouteEntry", ()=>$06c044741f640b75$export$f52136d9a0848792);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $4jMkc;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $bErDa;
    var $aphUL;
    var $8gSP9;
    const $06c044741f640b75$export$27d1f352c2f7acae = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bErDa")).trashProjectsDirectoryRoute), ()=>({
            ufoName: 'admin.trashed-projects',
            component: (0, (0, parcelRequire("aphUL")).default),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("4jMkc")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("8gSP9")).LazyTrashedProjectsAdmin)
            ],
            isRedirect: true
        }));
    const $06c044741f640b75$export$f52136d9a0848792 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bErDa")).trashProjectsDirectory1Route), ()=>({
            ufoName: 'admin.trashed-projects',
            component: (0, (0, parcelRequire("8gSP9")).default),
            layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
            navigation: {
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PROJECTS_SETTINGS,
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                sidebar: (0, (0, parcelRequire("4jMkc")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("8gSP9")).LazyTrashedProjectsAdmin)
            ]
        }));
});
parcelRegister("bErDa", function(module, exports) {
    $parcel$export(module.exports, "trashProjectsDirectoryRoute", ()=>$1ff62763f0dba905$export$74ec9fecd42fa96e);
    $parcel$export(module.exports, "trashProjectsDirectory1Route", ()=>$1ff62763f0dba905$export$a788f0ca96b92194);
    var $65Ltd;
    const $1ff62763f0dba905$export$74ec9fecd42fa96e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_TRASH_PROJECTS_DIRECTORY),
        path: '/secure/projects/trash',
        exact: true
    };
    const $1ff62763f0dba905$export$a788f0ca96b92194 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_TRASH_PROJECTS_DIRECTORY),
        path: '/jira/settings/projects/trash',
        exact: true
    };
});
parcelRegister("aphUL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$70186afa73ef93b4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXVV6;
    var $5oFIy;
    var $dIdda = parcelRequire("dIdda");
    var $70186afa73ef93b4$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "projectsTrashRedirect"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: "/jira/settings/projects/trash"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null));
});
parcelRegister("8gSP9", function(module, exports) {
    $parcel$export(module.exports, "LazyTrashedProjectsAdmin", ()=>$67a748fd05680154$export$dd65a8ee0a9ac24f);
    $parcel$export(module.exports, "default", ()=>$67a748fd05680154$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $67a748fd05680154$export$dd65a8ee0a9ac24f = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8xD9Z"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/trashed-projects/src/index.tsx"
    });
    var $67a748fd05680154$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $67a748fd05680154$export$dd65a8ee0a9ac24f,
            pageId: "trashed-projects",
            shouldShowSpinner: true
        });
});
parcelRegister("8xD9Z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4t5t3")
    ]).then(()=>parcelRequire('lYlbz'));
});
parcelRegister("eyw1v", function(module, exports) {
    $parcel$export(module.exports, "userSegmentationRouteEntry", ()=>$a13d3834c7078910$export$2af76482b576a135);
    var $6e4Kt;
    var $2G9Bk;
    var $374cP;
    var $1z26X;
    const $a13d3834c7078910$export$2af76482b576a135 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("374cP")).userSegmentationRoute), ()=>({
            ufoName: 'user-segmentation',
            component: (0, (0, parcelRequire("1z26X")).UserSegmentation),
            layout: (0, (0, parcelRequire("6e4Kt")).chromelessLayout),
            forPaint: [
                (0, (0, parcelRequire("1z26X")).LazyUserSegmentation)
            ]
        }));
});
parcelRegister("374cP", function(module, exports) {
    $parcel$export(module.exports, "userSegmentationRoute", ()=>$1d680cf55b0c704c$export$b0b13170cadf6395);
    var $65Ltd;
    const $1d680cf55b0c704c$export$b0b13170cadf6395 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_USER_SEGMENTATION),
        path: '/jira/get-started',
        exact: true
    };
});
parcelRegister("1z26X", function(module, exports) {
    $parcel$export(module.exports, "LazyUserSegmentation", ()=>$16f27a0ded4f6683$export$bf9c9e0729c919f5);
    $parcel$export(module.exports, "UserSegmentation", ()=>$16f27a0ded4f6683$export$15f8c5ccbb9c7ec3);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $16f27a0ded4f6683$export$bf9c9e0729c919f5 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6SBG5"))), {
        moduleId: "./src/packages/user-segmentation/src/index.tsx"
    });
    const $16f27a0ded4f6683$export$15f8c5ccbb9c7ec3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $16f27a0ded4f6683$export$bf9c9e0729c919f5,
            pageId: "user-segmentation",
            shouldShowSpinner: true
        });
});
parcelRegister("6SBG5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("eCiAS")
    ]).then(()=>parcelRequire('jL0w0'));
});
parcelRegister("anXSE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$286d76c503aa7d78$export$2e2bcd8739ae039);
    const $286d76c503aa7d78$var$applyLazyOpts = (route)=>{
        if ('lazyOpts' in route && typeof route.lazyOpts === 'function') {
            const hydratedRoute = {
                ...route,
                ...route.lazyOpts()
            };
            delete hydratedRoute.lazyOpts;
            return hydratedRoute;
        }
        return route;
    };
    var $286d76c503aa7d78$export$2e2bcd8739ae039 = $286d76c503aa7d78$var$applyLazyOpts;
});
parcelRegister("fvTO7", function(module, exports) {
    $parcel$export(module.exports, "jiraAdminPagesRouteEntries", ()=>$e8fc18994c4f5903$export$c9b96dd6f5a7b454);
    var $6brEB;
    var $aTmw6;
    var $ifqwm;
    var $iNRWv;
    var $11c0v;
    var $eNXnf;
    var $1UGby;
    var $lscMY;
    var $7hJUw;
    var $fxhat;
    var $cxMNV;
    var $9IRtC;
    var $3WKJT;
    var $jvuJF;
    var $h6cNv;
    var $hYrF0;
    var $fU2U7;
    const $e8fc18994c4f5903$export$c9b96dd6f5a7b454 = [
        ...(0, (0, parcelRequire("jvuJF")).screensPageRouteEntries),
        ...(0, (0, parcelRequire("fU2U7")).workflowPagesRouteEntries),
        ...(0, (0, parcelRequire("11c0v")).issueTypesRouteEntries),
        ...(0, (0, parcelRequire("6brEB")).contactAdministratorRouteEntries),
        ...(0, (0, parcelRequire("hYrF0")).systemRouteEntries),
        ...(0, (0, parcelRequire("1UGby")).customerAccessRouteEntries),
        ...(0, (0, parcelRequire("eNXnf")).authenticationSettingRouteEntries),
        ...(0, (0, parcelRequire("7hJUw")).outgoingMailRouteEntries),
        ...(0, (0, parcelRequire("cxMNV")).permissionPageRouteEntries),
        ...(0, (0, parcelRequire("3WKJT")).proformaRouteEntries),
        ...(0, (0, parcelRequire("lscMY")).newIssueFeaturesRouteEntries),
        ...(0, (0, parcelRequire("fxhat")).performanceAndScaleRouteEntries),
        ...(0, (0, parcelRequire("9IRtC")).prioritySchemesRouteEntries),
        ...(0, (0, parcelRequire("iNRWv")).globalPermissionsRouteEntries),
        ...(0, (0, parcelRequire("h6cNv")).systemConfigurationRouteEntries),
        ...(0, (0, parcelRequire("ifqwm")).externalImportRouteEntries),
        ...(0, (0, parcelRequire("aTmw6")).systemConfigurationEmailNotificationsLogRouteEntries)
    ];
});
parcelRegister("6brEB", function(module, exports) {
    $parcel$export(module.exports, "contactAdministratorRouteEntries", ()=>$b98b121482cf4795$export$1ca91576d82f7098);
    var $ffza4;
    var $2BrOV;
    var $2G9Bk;
    var $3RJkv;
    var $4rgjV;
    var $ksIuv;
    const $b98b121482cf4795$export$1ca91576d82f7098 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4rgjV")).globalSettingsContactAdministratorRoute), ()=>({
                ufoName: 'admin.contact-administrator',
                component: (0, (0, parcelRequire("ksIuv")).default),
                layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("ksIuv")).LazyContactAdministratorPage)
                ]
            }))
    ];
});
parcelRegister("4rgjV", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsContactAdministratorRoute", ()=>$e5fa341423bb8a9b$export$146910ddc36bf151);
    var $65Ltd;
    const $e5fa341423bb8a9b$export$146910ddc36bf151 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_CONTACT_ADMINISTRATOR),
        path: '/jira/contact-administrator'
    };
});
parcelRegister("ksIuv", function(module, exports) {
    $parcel$export(module.exports, "LazyContactAdministratorPage", ()=>$817988e9accf1b9b$export$bf75747a931b9a2b);
    $parcel$export(module.exports, "default", ()=>$817988e9accf1b9b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $817988e9accf1b9b$export$bf75747a931b9a2b = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kClDI"))), {
        moduleId: "./src/packages/admin-pages/contact-administrator/src/index.tsx"
    });
    var $817988e9accf1b9b$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $817988e9accf1b9b$export$bf75747a931b9a2b,
            pageId: "jira-admin-pages-contact-administrator",
            shouldShowSpinner: true
        });
});
parcelRegister("kClDI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("9xZgu")
    ]).then(()=>parcelRequire('dnrkU'));
});
parcelRegister("aTmw6", function(module, exports) {
    $parcel$export(module.exports, "systemConfigurationEmailNotificationsLogRouteEntries", ()=>$6fee6dc25a79db2c$export$e3943daecc3985cb);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $lkFvK;
    var $co1wz;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $dmx0y;
    var $1KemU;
    var $hBziA;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $6fee6dc25a79db2c$var$emailNotificationsLogEntryPointPage = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("hBziA")).notificationLogsEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS
    });
    const $6fee6dc25a79db2c$export$b2f1a46be2e3ed3f = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("7Z4b7"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/notification-logs/src/index.tsx"
    });
    const $6fee6dc25a79db2c$var$NotificationLogs = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6fee6dc25a79db2c$export$b2f1a46be2e3ed3f,
            pageId: "Notification Logs",
            shouldShowSpinner: false
        });
    const $6fee6dc25a79db2c$export$e3943daecc3985cb = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1KemU")).emailNotificationsLogAccessRoute), ()=>({
                component: $6fee6dc25a79db2c$var$NotificationLogs,
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("dmx0y")).systemConfigurationGeneralResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $6fee6dc25a79db2c$export$b2f1a46be2e3ed3f
                ],
                pageId: 'admin-settings-email-notifications-log',
                entryPoint () {
                    return (0, (0, parcelRequire("co1wz")).ff)('platform.jlove-pulsar.jlovep-423-jsw-notification-logs-ui') ? $6fee6dc25a79db2c$var$emailNotificationsLogEntryPointPage : undefined;
                }
            }))
    ];
});
parcelRegister("dmx0y", function(module, exports) {
    $parcel$export(module.exports, "systemConfigurationGeneralResource", ()=>$3e822b05b84662f2$export$b622f7400bfafd0d);
    var $dIdda = parcelRequire("dIdda");
    const $3e822b05b84662f2$export$b622f7400bfafd0d = (0, $dIdda.createResource)({
        type: (0, $3d90c62269ed88a0$export$e780b172f774b673),
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("u6D6H"))
    });
});
const $3d90c62269ed88a0$export$e780b172f774b673 = 'RESOURCE_TYPE_SYSTEM_CONFIGURATION_GENERAL';
parcelRegister("u6D6H", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6L998").then(()=>parcelRequire('khTCh'));
});
parcelRegister("1KemU", function(module, exports) {
    $parcel$export(module.exports, "emailNotificationsLogAccessRoute", ()=>$a565fcc59d27b628$export$aed294a4a292b909);
    var $65Ltd;
    const $a565fcc59d27b628$export$aed294a4a292b909 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_ADMIN_HELPER_EMAIL_NOTIFICATIONS_LOG),
        path: '/jira/settings/system/notification-logs',
        exact: true
    };
});
parcelRegister("hBziA", function(module, exports) {
    $parcel$export(module.exports, "notificationLogsEntryPoint", ()=>$e96cd1acff95af13$export$818d841e00bb3749);
    var $aGYm3;
    var $2Ftxm;
    var $ikgNX;
    const $e96cd1acff95af13$export$818d841e00bb3749 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("7Z4b7")), {
            moduleId: "d533cc53"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    notificationLogs: {
                        options: {
                            fetchPolicy: 'network-only'
                        },
                        parameters: (0, parcelRequire("aGYm3")).default,
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectIds: context?.query?.projectId,
                            notificationType: 'INTERNAL_NOTIFICATION',
                            notificationActionType: 'USER_INVITE',
                            recipientId: ''
                        }
                    }
                },
                extraProps: {
                    accountId: tenantContext.atlassianAccountId
                }
            })
    });
});
parcelRegister("aGYm3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$25a34f05175c2102$export$2e2bcd8739ae039);
    const $25a34f05175c2102$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "71e1f26fd67e2af410f2d8354171d8867b0efd6546709fc85bec1419f20e5b6d",
            "metadata": {},
            "name": "uiNotificationLogsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $25a34f05175c2102$export$2e2bcd8739ae039 = $25a34f05175c2102$var$node;
});
parcelRegister("7Z4b7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3HpMo")
    ]).then(()=>parcelRequire('ktpmL'));
});
parcelRegister("ifqwm", function(module, exports) {
    $parcel$export(module.exports, "externalImportRouteEntries", ()=>$19995aa55a23ac9a$export$c535ef4656da2cd9);
    var $ffza4;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $4tu1x;
    var $5ZnBW;
    const $19995aa55a23ac9a$export$c535ef4656da2cd9 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("4tu1x")).externalImportRoute), ()=>({
                component: (0, (0, parcelRequire("5ZnBW")).default),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            }))
    ];
});
parcelRegister("4tu1x", function(module, exports) {
    $parcel$export(module.exports, "externalImportRoute", ()=>$241a7261277af7f6$export$17c79100fc4c65a1);
    var $65Ltd;
    const $241a7261277af7f6$export$17c79100fc4c65a1 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_EXTERNAL_IMPORT),
        path: '/jira/settings/system/external-import'
    };
});
parcelRegister("5ZnBW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7b72a6c6c5d8947e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $7b72a6c6c5d8947e$var$LazyExternalImport = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("hPbJ3")), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/admin-pages/external-import/src/index.tsx"
    });
    var $7b72a6c6c5d8947e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7b72a6c6c5d8947e$var$LazyExternalImport,
            pageId: "external-import-general",
            shouldShowSpinner: false
        });
});
parcelRegister("hPbJ3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jH0q0")
    ]).then(()=>parcelRequire('lBo8Z'));
});
parcelRegister("iNRWv", function(module, exports) {
    $parcel$export(module.exports, "globalPermissionsRouteEntries", ()=>$2a846114d3db2310$export$db45b991e5ee3460);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $cSD7y;
    var $4R6GH;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $kiD5R;
    var $3RJkv;
    var $atU1t;
    var $2FGsL;
    var $5lsNZ;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $2a846114d3db2310$export$a97b1349c011eb4 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lvXmc"))), {
        moduleId: "./src/packages/permissions-administration/pages/global-permissions/src/index.tsx"
    });
    const $2a846114d3db2310$export$a8d149dea7df681c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2a846114d3db2310$export$a97b1349c011eb4,
            pageId: "jira-global-permissions",
            shouldShowSpinner: true
        });
    const $2a846114d3db2310$export$db45b991e5ee3460 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2FGsL")).globalSettingsGlobalPermissionsRoute), ()=>({
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('olympus-global-permissions-fe-modernisation', $2a846114d3db2310$export$a8d149dea7df681c, (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("kiD5R")).globalPermissionsResource)
                ],
                canTransitionIn: ()=>(0, (0, parcelRequire("4R6GH")).fg)('olympus-global-permissions-fe-modernisation'),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $2a846114d3db2310$export$a97b1349c011eb4
                ],
                meta: {
                    reporting: {
                        id: 'GlobalPermissions',
                        packageName: 'jiraAdminPagesGlobalPermissions',
                        teamName: 'olympus'
                    }
                }
            }))
    ];
});
parcelRegister("kiD5R", function(module, exports) {
    $parcel$export(module.exports, "globalPermissionsResource", ()=>$896d1d986bb0ea74$export$9a5d1bc1ff678482);
    var $ao2h1;
    var $5Uo2r;
    const $896d1d986bb0ea74$var$RESOURCE_TYPE_GLOBAL_PERMISSIONS = 'GLOBAL_PERMISSIONS';
    const $896d1d986bb0ea74$export$9a5d1bc1ff678482 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: $896d1d986bb0ea74$var$RESOURCE_TYPE_GLOBAL_PERMISSIONS,
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("5Uo2r")).default),
                variables: {
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'network-only'
                }
            })
    });
});
parcelRegister("5Uo2r", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ed1cca93794a5156$export$2e2bcd8739ae039);
    const $ed1cca93794a5156$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "name"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "main_globalPermissionsAndGrantsQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "alias": "globalPermissionsAndGrants",
                                        "args": v1,
                                        "kind": "LinkedField",
                                        "name": "getGlobalPermissionsAndGrants",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "globalPermissionsTable_globalPermissions"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "grantPermissionDialog_globalPermissions"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.globalPermissionsAndGrants"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "main_globalPermissionsAndGrantsQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "globalPermissionsAndGrants",
                                "args": v1,
                                "kind": "LinkedField",
                                "name": "getGlobalPermissionsAndGrants",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "concreteType": "JiraGlobalPermissionGrants",
                                                "kind": "LinkedField",
                                                "name": "globalPermissionGrants",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraGlobalPermission",
                                                        "kind": "LinkedField",
                                                        "name": "permission",
                                                        "plural": false,
                                                        "selections": [
                                                            v2,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "description"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "key"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isManagedByJira"
                                                    },
                                                    {
                                                        "kind": "ClientExtension",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "__id"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JiraGroup",
                                                        "kind": "LinkedField",
                                                        "name": "groups",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "groupId"
                                                            },
                                                            v2,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "id"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "JiraGlobalPermissionGrantsList"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "5b2ad70438dbcc77ff45c7608ecd4e7382a18aa895a82fd26e83279a282b7ab6",
                "metadata": {},
                "name": "main_globalPermissionsAndGrantsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $ed1cca93794a5156$var$node.hash = "9f1b7eb98b606c41655e4fa1f200a351";
    var $ed1cca93794a5156$export$2e2bcd8739ae039 = $ed1cca93794a5156$var$node;
});
parcelRegister("2FGsL", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsGlobalPermissionsRoute", ()=>$66a7722b5d13dfaf$export$236ce89eb737f752);
    var $65Ltd;
    const $66a7722b5d13dfaf$export$236ce89eb737f752 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_GLOBAL_PERMISSIONS),
        path: '/secure/admin/global-permissions'
    };
});
parcelRegister("lvXmc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("asO3X")
    ]).then(()=>parcelRequire('csGky'));
});
parcelRegister("11c0v", function(module, exports) {
    $parcel$export(module.exports, "issueTypesRouteEntries", ()=>$9d816d99a525ba0f$export$84bb32992a534053);
    var $5uXOq = parcelRequire("5uXOq");
    var $g87MG;
    var $6oOqs;
    var $hjmEZ;
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $eAsaT;
    var $7OYJs;
    var $dKJVX;
    var $eISHy;
    var $d9kjz;
    const $9d816d99a525ba0f$export$84bb32992a534053 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("eAsaT")).globalSettingsIssueHierarchyRoute), ()=>({
                ufoName: 'global-admin.issues.issue-hierarchy-config',
                component: (0, (0, parcelRequire("dKJVX")).default),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("g87MG")).issueHierarchyPageResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("dKJVX")).LazyIssueHierarchyDirectory)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("eAsaT")).globalSettingsIssueHierarchyRedirectRoute), ()=>({
                component: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
                        to: "/jira/settings/issues/issue-hierarchy"
                    }),
                isRedirect: true,
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("g87MG")).issueHierarchyPageResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("dKJVX")).LazyIssueHierarchyDirectory)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("eAsaT")).globalSettingsIssueTypesRoute), ()=>({
                ufoName: 'global-admin.issues.issue-types',
                component: (0, (0, parcelRequire("d9kjz")).default),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("hjmEZ")).issueTypesResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("d9kjz")).LazyIssueTypesDirectory)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("eAsaT")).globalSettingsIssueTypesSchemesRoute), ()=>({
                ufoName: 'global-admin.issues.view-issue-type-schemes',
                component: (0, (0, parcelRequire("eISHy")).default),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("6oOqs")).default)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("eISHy")).LazyIssueTypeSchemesDirectory)
                ]
            }))
    ];
});
parcelRegister("6oOqs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b64e685bc951c633$export$2e2bcd8739ae039);
    var $ebyGx = parcelRequire("ebyGx");
    var $dIdda = parcelRequire("dIdda");
    var $8yNp1;
    const $b64e685bc951c633$var$issueTypeSchemeResource = (0, $dIdda.createResource)({
        type: (0, $e899d40884b470a8$export$1d678052bb5ae54d),
        getKey: ({ query: query })=>`${0, $e899d40884b470a8$export$41cf50ee50d5da20}-${(0, ($parcel$interopDefault($ebyGx))).stringify(query)}`,
        maxAge: 0,
        getData: async ({ query: query })=>(0, (0, parcelRequire("8yNp1")).getIssueTypeSchemes)((0, ($parcel$interopDefault($ebyGx))).stringify(query))
    });
    var $b64e685bc951c633$export$2e2bcd8739ae039 = $b64e685bc951c633$var$issueTypeSchemeResource;
});
parcelRegister("8yNp1", function(module, exports) {
    $parcel$export(module.exports, "getIssueTypeSchemes", ()=>$b3d43746aaf616dc$export$2844cac611eecaa7);
    var $ebyGx = parcelRequire("ebyGx");
    var $jcw0u;
    var $eusud;
    var $7vF3l;
    var $bLpq9;
    const $b3d43746aaf616dc$export$2844cac611eecaa7 = async (qs)=>{
        const filter = (0, (0, parcelRequire("bLpq9")).fromUrlTransformer)((0, ($parcel$interopDefault($ebyGx))).parse(qs));
        const query = (0, ($parcel$interopDefault($ebyGx))).stringify((0, (0, parcelRequire("bLpq9")).toApiUrlTransformer)(filter));
        try {
            return await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/3/issuetypescheme?${query}`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'getIssueTypesRequest',
                    packageName: (0, (0, parcelRequire("7vF3l")).PACKAGE_NAME),
                    teamName: 'morphinecake'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
parcelRegister("7vF3l", function(module, exports) {
    $parcel$export(module.exports, "SOURCE_NAME", ()=>$72a1bf464873d379$export$a3821bc63538b210);
    $parcel$export(module.exports, "ISSUE_TYPE_SCHEMES_TABLE", ()=>$72a1bf464873d379$export$91570d508c93485d);
    $parcel$export(module.exports, "ORDER", ()=>$72a1bf464873d379$export$11e75bce9f7ea886);
    $parcel$export(module.exports, "MAX_RESULTS", ()=>$72a1bf464873d379$export$f6b2881bc1090cea);
    $parcel$export(module.exports, "defaultIssueTypeSchemesFilter", ()=>$72a1bf464873d379$export$625de46796f967ae);
    $parcel$export(module.exports, "EMPTY_PROJECTS_PAGE", ()=>$72a1bf464873d379$export$81a0343467d0e9a9);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$72a1bf464873d379$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "FILTER_CHANGE_ANALYTICS", ()=>$72a1bf464873d379$export$9ac56b2484c2d4e9);
    const $72a1bf464873d379$export$a3821bc63538b210 = 'issueTypeSchemeDirectory';
    const $72a1bf464873d379$export$91570d508c93485d = 'issueTypeSchemesTable';
    const $72a1bf464873d379$export$11e75bce9f7ea886 = Object.freeze({
        ASC: 'asc',
        DESC: 'desc'
    });
    const $72a1bf464873d379$export$f6b2881bc1090cea = 10;
    const $72a1bf464873d379$export$625de46796f967ae = {
        pageNumber: 1,
        pageSize: $72a1bf464873d379$export$f6b2881bc1090cea,
        expand: [
            'projects',
            'issueTypes'
        ],
        orderBy: 'name',
        sortDirection: (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)
    };
    const $72a1bf464873d379$export$52adcbea6a93900f = {
        startAt: 0,
        maxResults: $72a1bf464873d379$export$f6b2881bc1090cea,
        values: [],
        total: 0,
        isLast: true
    };
    const $72a1bf464873d379$export$81a0343467d0e9a9 = {
        startAt: 0,
        maxResults: 10,
        values: [],
        total: 0,
        isLast: true
    };
    const $72a1bf464873d379$export$b8b9d90f9e5bd72b = 'jiraAdminPagesIssueTypeSchemesDirectory';
    const $72a1bf464873d379$export$9ac56b2484c2d4e9 = Object.freeze({
        ACTION: 'changed',
        ACTION_SUBJECT: 'filterSearch'
    });
});
parcelRegister("bLpq9", function(module, exports) {
    $parcel$export(module.exports, "toUrlTransformer", ()=>$90d499beb7e9cb88$export$5b9f8ed2c34be88a);
    $parcel$export(module.exports, "fromUrlTransformer", ()=>$90d499beb7e9cb88$export$bec67ef860c0d0e1);
    $parcel$export(module.exports, "toApiUrlTransformer", ()=>$90d499beb7e9cb88$export$fb15afa686993f11);
    var $dfl35 = parcelRequire("dfl35");
    var $aud83;
    var $7vF3l;
    var $lL6pH;
    const $90d499beb7e9cb88$export$5b9f8ed2c34be88a = (filter)=>{
        const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy } = filter || {};
        return {
            pageNumber: pageNumber,
            searchFilter: searchFilter,
            orderBy: orderBy
        };
    };
    const $90d499beb7e9cb88$export$bec67ef860c0d0e1 = (params)=>{
        const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy } = params;
        const parsedNumber = Number.isNaN((0, (0, parcelRequire("aud83")).number).parse(pageNumber)) ? (0, (0, parcelRequire("7vF3l")).defaultIssueTypeSchemesFilter).pageNumber : (0, (0, parcelRequire("aud83")).number).parse(pageNumber);
        const parsedOrderBy = orderBy === 'name' || orderBy === '-name' ? orderBy : undefined;
        return {
            ...(0, (0, parcelRequire("7vF3l")).defaultIssueTypeSchemesFilter),
            pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
            searchFilter: searchFilter,
            orderBy: parsedOrderBy
        };
    };
    const $90d499beb7e9cb88$export$fb15afa686993f11 = (filter)=>{
        const fullFilter = (0, ($parcel$interopDefault($dfl35)))({}, filter, (0, (0, parcelRequire("7vF3l")).defaultIssueTypeSchemesFilter));
        let requestParams = {
            maxResults: (0, (0, parcelRequire("7vF3l")).MAX_RESULTS),
            startAt: (fullFilter.pageNumber - 1) * (0, (0, parcelRequire("7vF3l")).MAX_RESULTS),
            orderBy: fullFilter.orderBy,
            queryString: (0, (0, parcelRequire("lL6pH")).trimSearchFilter)(fullFilter.searchFilter)
        };
        if (fullFilter.expand != null) requestParams = {
            ...requestParams,
            expand: fullFilter.expand.join(',')
        };
        return requestParams;
    };
});
parcelRegister("dfl35", function(module, exports) {
    var $g7i7g = parcelRequire("g7i7g");
    var $dGT4U = parcelRequire("dGT4U");
    var $4rDUz = parcelRequire("4rDUz");
    var $lbyKY = parcelRequire("lbyKY");
    var $9a4d00e997b9e158$var$objectProto = Object.prototype;
    var $9a4d00e997b9e158$var$hasOwnProperty = $9a4d00e997b9e158$var$objectProto.hasOwnProperty;
    var $9a4d00e997b9e158$var$defaults = $g7i7g(function(object, sources) {
        object = Object(object);
        var index = -1;
        var length = sources.length;
        var guard = length > 2 ? sources[2] : undefined;
        if (guard && $4rDUz(sources[0], sources[1], guard)) length = 1;
        while(++index < length){
            var source = sources[index];
            var props = $lbyKY(source);
            var propsIndex = -1;
            var propsLength = props.length;
            while(++propsIndex < propsLength){
                var key = props[propsIndex];
                var value = object[key];
                if (value === undefined || $dGT4U(value, $9a4d00e997b9e158$var$objectProto[key]) && !$9a4d00e997b9e158$var$hasOwnProperty.call(object, key)) object[key] = source[key];
            }
        }
        return object;
    });
    module.exports = $9a4d00e997b9e158$var$defaults;
});
parcelRegister("aud83", function(module, exports) {
    $parcel$export(module.exports, "string", ()=>$b7c0843f761cef5f$export$22b082955e083ec3);
    $parcel$export(module.exports, "bool", ()=>$b7c0843f761cef5f$export$87b259aa03e3d267);
    $parcel$export(module.exports, "array", ()=>$b7c0843f761cef5f$export$2f23118c22fb2630);
    $parcel$export(module.exports, "multiple", ()=>$b7c0843f761cef5f$export$939ddaa3205df08e);
    $parcel$export(module.exports, "number", ()=>$b7c0843f761cef5f$export$98e628dec113755e);
    var $etyzk = parcelRequire("etyzk");
    const $b7c0843f761cef5f$export$22b082955e083ec3 = {
        stringify: (0, ($parcel$interopDefault($etyzk))),
        parse: (0, ($parcel$interopDefault($etyzk)))
    };
    const $b7c0843f761cef5f$export$87b259aa03e3d267 = {
        stringify: (value)=>String(value),
        parse: (value)=>{
            if (value === 'true') return true;
            if (value === 'false') return false;
            return undefined;
        }
    };
    const $b7c0843f761cef5f$export$2f23118c22fb2630 = {
        stringify: (value)=>value && Array.isArray(value) ? value.join(',') : undefined,
        parse: (value)=>typeof value === 'string' ? value?.split(',') : undefined
    };
    const $b7c0843f761cef5f$export$939ddaa3205df08e = {
        stringify: (value)=>{
            if (!value || !Array.isArray(value)) return undefined;
            return value.length === 1 ? value[0] : value;
        },
        parse: (value)=>value && Array.isArray(value) ? value : [
                String(value)
            ]
    };
    const $b7c0843f761cef5f$export$98e628dec113755e = {
        stringify: (value)=>`${value}`,
        parse: (value)=>Number(value)
    };
});
parcelRegister("lL6pH", function(module, exports) {
    $parcel$export(module.exports, "trimSearchFilter", ()=>$8bfdbd5ef20cefa5$export$ed1722f41c23aaaf);
    const $8bfdbd5ef20cefa5$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
    const $8bfdbd5ef20cefa5$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
    const $8bfdbd5ef20cefa5$export$ed1722f41c23aaaf = (searchFilter)=>{
        if (searchFilter === undefined) return undefined;
        return searchFilter.trim() || undefined;
    };
});
const $e899d40884b470a8$export$1d678052bb5ae54d = 'ISSUE_TYPE_SCHEME_TABLE';
const $e899d40884b470a8$export$41cf50ee50d5da20 = 'ISSUE_TYPE_SCHEME_TABLE_KEY';
parcelRegister("hjmEZ", function(module, exports) {
    $parcel$export(module.exports, "issueTypesResource", ()=>$0c72c798ed369d5b$export$614e9d897c1ef917);
    var $ebyGx = parcelRequire("ebyGx");
    var $dIdda = parcelRequire("dIdda");
    var $kXy4X;
    const $0c72c798ed369d5b$export$614e9d897c1ef917 = (0, $dIdda.createResource)({
        type: 'GLOBAL_ADMIN_ISSUE_TYPES_DIRECTORY',
        getKey: ()=>'issue types',
        getData: async ({ query: query })=>(0, (0, parcelRequire("kXy4X")).getIssueTypes)((0, ($parcel$interopDefault($ebyGx))).stringify(query))
    });
});
parcelRegister("kXy4X", function(module, exports) {
    $parcel$export(module.exports, "getIssueTypes", ()=>$8b29c26e18cf4514$export$4cf4b24b88599615);
    var $ebyGx = parcelRequire("ebyGx");
    var $jcw0u;
    var $7f4tk;
    var $6tPCs;
    const $8b29c26e18cf4514$export$4cf4b24b88599615 = async (qs)=>{
        const filter = (0, (0, parcelRequire("6tPCs")).fromUrlTransformer)((0, ($parcel$interopDefault($ebyGx))).parse(qs));
        const query = (0, ($parcel$interopDefault($ebyGx))).stringify((0, (0, parcelRequire("6tPCs")).toApiUrlTransformer)(filter));
        try {
            return await (0, (0, parcelRequire("7f4tk")).default)(`/rest/internal/3/issuetype/search?${query}`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'getIssueTypesRequest',
                    packageName: (0, $f4edca700b2e0273$export$4adfbb237b083187),
                    teamName: 'morphinecake'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
const $f4edca700b2e0273$export$4adfbb237b083187 = 'jiraAdminPagesIssueTypesResources';
parcelRegister("6tPCs", function(module, exports) {
    $parcel$export(module.exports, "toUrlTransformer", ()=>$ddf87573da5ca99a$export$5b9f8ed2c34be88a);
    $parcel$export(module.exports, "fromUrlTransformer", ()=>$ddf87573da5ca99a$export$bec67ef860c0d0e1);
    $parcel$export(module.exports, "toSearchFilterQsTransformer", ()=>$ddf87573da5ca99a$export$bcd1ab210547e2f5);
    $parcel$export(module.exports, "toSortFieldFilterQsTransformer", ()=>$ddf87573da5ca99a$export$c114848fa733e5c4);
    $parcel$export(module.exports, "toSortDirectionFilterQsTransformer", ()=>$ddf87573da5ca99a$export$c5d2609f8b4048d3);
    $parcel$export(module.exports, "toApiUrlTransformer", ()=>$ddf87573da5ca99a$export$fb15afa686993f11);
    var $dfl35 = parcelRequire("dfl35");
    var $ebyGx = parcelRequire("ebyGx");
    var $aud83;
    var $eou7E;
    var $iPfOK;
    const $ddf87573da5ca99a$var$sortDirectionMap = {
        [(0, $2a9e000a443b1a95$export$1dee026a19752d6b).toLowerCase()]: (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
        [(0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65).toLowerCase()]: (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)
    };
    const $ddf87573da5ca99a$var$sortFieldMap = {
        [(0, $b140ee73c9ccd026$export$3c5e605ca7ade9f2).toLowerCase()]: (0, $b140ee73c9ccd026$export$3c5e605ca7ade9f2),
        [(0, $b140ee73c9ccd026$export$7673664bdc3ae979).toLowerCase()]: (0, $b140ee73c9ccd026$export$7673664bdc3ae979)
    };
    const $ddf87573da5ca99a$export$5b9f8ed2c34be88a = (filter)=>filter ? {
            page: filter.page !== undefined && filter.page >= 1 ? String(filter.page) : undefined,
            sortDirection: (0, (0, parcelRequire("eou7E")).fieldToParam)(filter.sortDirection),
            sortField: (0, (0, parcelRequire("eou7E")).fieldToParam)(filter.sortField),
            searchFilter: (0, (0, parcelRequire("eou7E")).trimSearchFilter)(filter.searchFilter)
        } : {};
    const $ddf87573da5ca99a$export$bec67ef860c0d0e1 = (params)=>({
            page: Math.floor(Number((0, (0, parcelRequire("aud83")).number).parse(params.page))) || undefined,
            searchFilter: (0, (0, parcelRequire("eou7E")).trimSearchFilter)(params.searchFilter),
            sortDirection: (0, (0, parcelRequire("eou7E")).fieldFromParam)($ddf87573da5ca99a$var$sortDirectionMap, params.sortDirection),
            sortField: (0, (0, parcelRequire("eou7E")).fieldFromParam)($ddf87573da5ca99a$var$sortFieldMap, params.sortField)
        });
    const $ddf87573da5ca99a$export$bcd1ab210547e2f5 = (qs)=>{
        const parsed = (0, ($parcel$interopDefault($ebyGx))).parse(qs);
        return parsed.searchFilter ? parsed.searchFilter : '';
    };
    const $ddf87573da5ca99a$export$c114848fa733e5c4 = (qs)=>{
        const parsed = (0, ($parcel$interopDefault($ebyGx))).parse(qs);
        return parsed.sortField && parsed.sortField === 'name' ? (0, $b140ee73c9ccd026$export$3c5e605ca7ade9f2) : (0, $b140ee73c9ccd026$export$7673664bdc3ae979);
    };
    const $ddf87573da5ca99a$export$c5d2609f8b4048d3 = (qs)=>{
        const parsed = (0, ($parcel$interopDefault($ebyGx))).parse(qs);
        return parsed.sortDirection && parsed.sortDirection === 'asc' ? (0, $2a9e000a443b1a95$export$1dee026a19752d6b) : (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65);
    };
    const $ddf87573da5ca99a$var$apiSortByMap = {
        [(0, $2a9e000a443b1a95$export$1dee026a19752d6b)]: '',
        [(0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65)]: '-'
    };
    const $ddf87573da5ca99a$export$fb15afa686993f11 = (filter)=>{
        const fullFilter = (0, ($parcel$interopDefault($dfl35)))({}, filter, (0, (0, parcelRequire("iPfOK")).DEFAULT_FILTER));
        const sortFieldMapping = fullFilter.sortField === 'hierarchy-level' ? 'type' : fullFilter.sortField;
        return {
            maxResults: (0, (0, parcelRequire("iPfOK")).MAX_RESULTS),
            startAt: (fullFilter.page - 1) * (0, (0, parcelRequire("iPfOK")).MAX_RESULTS),
            query: (0, (0, parcelRequire("eou7E")).trimSearchFilter)(fullFilter.searchFilter),
            orderBy: `${$ddf87573da5ca99a$var$apiSortByMap[fullFilter.sortDirection]}${sortFieldMapping}`
        };
    };
});
const $b140ee73c9ccd026$export$3c5e605ca7ade9f2 = 'name';
const $b140ee73c9ccd026$export$d44826c816b5619b = 'description';
const $b140ee73c9ccd026$export$b87f371cbc396fcf = 'type';
const $b140ee73c9ccd026$export$7673664bdc3ae979 = 'hierarchy-level';
const $b140ee73c9ccd026$export$68e97ee499f7c743 = 'related-schemes';
const $b140ee73c9ccd026$export$92a1a3b7554e9387 = 'actions';
const $b140ee73c9ccd026$export$23ba45d5f8d54fed = 'level-number';
const $b140ee73c9ccd026$export$1dc71bc9f1a3749a = 'arrow';
const $b140ee73c9ccd026$export$8be5a31a21d0c723 = 'level-name';
const $b140ee73c9ccd026$export$6ad51af4785d6548 = 'jira-issue-types';
const $b140ee73c9ccd026$export$20068afc6f8c1737 = 'label-space';
parcelRegister("eou7E", function(module, exports) {
    $parcel$export(module.exports, "fieldToParam", ()=>$56517d5895d07b39$export$7341f299e7b93e87);
    $parcel$export(module.exports, "fieldFromParam", ()=>$56517d5895d07b39$export$c876451e094c0060);
    $parcel$export(module.exports, "trimSearchFilter", ()=>$56517d5895d07b39$export$ed1722f41c23aaaf);
    const $56517d5895d07b39$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
    const $56517d5895d07b39$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
    const $56517d5895d07b39$export$ed1722f41c23aaaf = (searchFilter)=>{
        if (searchFilter === undefined) return undefined;
        return searchFilter.trim() || undefined;
    };
});
parcelRegister("iPfOK", function(module, exports) {
    $parcel$export(module.exports, "MAX_RESULTS", ()=>$68af332912f0171f$export$f6b2881bc1090cea);
    $parcel$export(module.exports, "DEFAULT_FILTER", ()=>$68af332912f0171f$export$6deee0e4f2fb784e);
    const $68af332912f0171f$export$f6b2881bc1090cea = 15;
    const $68af332912f0171f$export$6deee0e4f2fb784e = {
        page: 1,
        sortDirection: (0, $2a9e000a443b1a95$export$b6abcf7fa1d94f65),
        sortField: (0, $b140ee73c9ccd026$export$7673664bdc3ae979)
    };
});
parcelRegister("eAsaT", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssueHierarchyRoute", ()=>$f07ed7244cb7546a$export$2c220ed11ae62e14);
    $parcel$export(module.exports, "globalSettingsIssueHierarchyRedirectRoute", ()=>$f07ed7244cb7546a$export$6236a41e09bb858a);
    $parcel$export(module.exports, "globalSettingsIssueTypesRoute", ()=>$f07ed7244cb7546a$export$7358263a3bbb38b1);
    $parcel$export(module.exports, "globalSettingsIssueTypesSchemesRoute", ()=>$f07ed7244cb7546a$export$2aba97aa663f43b3);
    var $65Ltd;
    const $f07ed7244cb7546a$export$2c220ed11ae62e14 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY),
        path: '/jira/settings/issues/issue-hierarchy'
    };
    const $f07ed7244cb7546a$export$6236a41e09bb858a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_HIERARCHY_REDIRECT),
        path: '/secure/PortfolioHierarchy.jspa'
    };
    const $f07ed7244cb7546a$export$7358263a3bbb38b1 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES),
        path: '/jira/settings/issues/issue-types'
    };
    const $f07ed7244cb7546a$export$2aba97aa663f43b3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCHEMES),
        path: '/jira/settings/issues/issue-type-schemes'
    };
});
parcelRegister("dKJVX", function(module, exports) {
    $parcel$export(module.exports, "LazyIssueHierarchyDirectory", ()=>$1c0ab549b6b1a06b$export$1ff7255ab4f7a2dd);
    $parcel$export(module.exports, "default", ()=>$1c0ab549b6b1a06b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $1c0ab549b6b1a06b$export$1ff7255ab4f7a2dd = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("l44QS"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-hierarchy-directory/src/index.tsx"
    });
    var $1c0ab549b6b1a06b$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1c0ab549b6b1a06b$export$1ff7255ab4f7a2dd,
            pageId: "jira-admin-pages-issue-hierarchy-directory",
            shouldShowSpinner: true
        });
});
parcelRegister("l44QS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("6rF46")
    ]).then(()=>parcelRequire('7PW51'));
});
parcelRegister("eISHy", function(module, exports) {
    $parcel$export(module.exports, "LazyIssueTypeSchemesDirectory", ()=>$651db9488b9701c8$export$611728a54ba37830);
    $parcel$export(module.exports, "default", ()=>$651db9488b9701c8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $651db9488b9701c8$export$611728a54ba37830 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("j6iNi"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-type-schemes-directory/src/index.tsx"
    });
    var $651db9488b9701c8$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $651db9488b9701c8$export$611728a54ba37830,
            pageId: "jira-admin-pages-issue-type-schemes-directory",
            shouldShowSpinner: true
        });
});
parcelRegister("j6iNi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cfCwZ").then(()=>parcelRequire('1dsYb'));
});
parcelRegister("d9kjz", function(module, exports) {
    $parcel$export(module.exports, "LazyIssueTypesDirectory", ()=>$3e26a0063e6eb003$export$661e1bf38bb82270);
    $parcel$export(module.exports, "default", ()=>$3e26a0063e6eb003$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $3e26a0063e6eb003$export$661e1bf38bb82270 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6pB0J"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/issue-types/issue-types-directory/src/index.tsx"
    });
    var $3e26a0063e6eb003$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3e26a0063e6eb003$export$661e1bf38bb82270,
            pageId: "jira-admin-pages-issue-types-directory",
            shouldShowSpinner: true
        });
});
parcelRegister("6pB0J", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bg3Kg")
    ]).then(()=>parcelRequire('g8Lpc'));
});
parcelRegister("eNXnf", function(module, exports) {
    $parcel$export(module.exports, "authenticationSettingRouteEntries", ()=>$b7091904c7d6d31b$export$f2cf147a5850af7e);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $jKASa;
    var $3RJkv;
    var $7M7Vd;
    var $1xsZo;
    const $b7091904c7d6d31b$export$f2cf147a5850af7e = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("7M7Vd")).productsJsmAuthenticationSettingsRoute), ()=>({
                ufoName: 'admin.jsm-authentication-settings',
                component: (0, (0, parcelRequire("1xsZo")).default),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("2Fj5v")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                    (0, (0, parcelRequire("jKASa")).jsmCustomerAuthenticationSettingsResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("1xsZo")).LazyAuthenticationSettings)
                ]
            }))
    ];
});
parcelRegister("jKASa", function(module, exports) {
    $parcel$export(module.exports, "jsmCustomerAuthenticationSettingsResource", ()=>$3f20045f00d71d00$export$73134c05a3c27bd);
    var $dIdda = parcelRequire("dIdda");
    var $8Pbm3;
    const $3f20045f00d71d00$export$73134c05a3c27bd = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("8Pbm3")).RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS),
        getKey: ()=>'settings',
        getDataLoader: ()=>(parcelRequire("hmSnU")),
        maxAge: (0, (0, parcelRequire("8Pbm3")).ONE_DAY_IN_MILLIS)
    });
});
parcelRegister("8Pbm3", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_JSM_CUSTOMER_AUTHENTICATION_SETTINGS", ()=>$bbe3b013803e2d85$export$6a2799d78d98b915);
    $parcel$export(module.exports, "ONE_DAY_IN_MILLIS", ()=>$bbe3b013803e2d85$export$5a00268156ea5027);
    const $bbe3b013803e2d85$export$6a2799d78d98b915 = 'JSM_CUSTOMER_AUTHENTICATION_SETTINGS';
    const $bbe3b013803e2d85$export$5a00268156ea5027 = 86400000;
});
parcelRegister("hmSnU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hLF9k").then(()=>parcelRequire('7xEnC'));
});
parcelRegister("7M7Vd", function(module, exports) {
    $parcel$export(module.exports, "productsJsmAuthenticationSettingsRoute", ()=>$f767c9cdabaf9069$export$6395086ce7e72e37);
    var $65Ltd;
    const $f767c9cdabaf9069$export$6395086ce7e72e37 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_AUTHENTICATION_SETTINGS),
        path: '/jira/settings/products/servicedesk/authentication',
        exact: true
    };
});
parcelRegister("1xsZo", function(module, exports) {
    $parcel$export(module.exports, "LazyAuthenticationSettings", ()=>$a330db909964048e$export$6cd59b0135f3fe86);
    $parcel$export(module.exports, "default", ()=>$a330db909964048e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $a330db909964048e$export$6cd59b0135f3fe86 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("k66vx"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/product-jsm-authentication-settings/src/index.tsx"
    });
    var $a330db909964048e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a330db909964048e$export$6cd59b0135f3fe86,
            pageId: "spa-apps/admin-pages/jsm-authentication-settings",
            shouldShowSpinner: false
        });
});
parcelRegister("k66vx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("atQhk")
    ]).then(()=>parcelRequire('8YmLU'));
});
parcelRegister("1UGby", function(module, exports) {
    $parcel$export(module.exports, "customerAccessRouteEntries", ()=>$ea4a7aec6cf36e8a$export$15a1d95a862eb682);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $2Fj5v;
    var $2G9Bk;
    var $6IgbX;
    var $cuwqc;
    var $3RJkv;
    var $k6H7t;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $ea4a7aec6cf36e8a$export$1ae94ce2cc225b3d = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9y0dD"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/customer-access/src/index.tsx"
    });
    const $ea4a7aec6cf36e8a$export$fce5e73f94a6878 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ea4a7aec6cf36e8a$export$1ae94ce2cc225b3d,
            pageId: "spa-apps/admin-pages/customer-access",
            shouldShowSpinner: false
        });
    const $ea4a7aec6cf36e8a$export$15a1d95a862eb682 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("k6H7t")).productsJsmCustomerAccessRoute), ()=>({
                ufoName: 'admin.jsm-customer-access',
                component: $ea4a7aec6cf36e8a$export$fce5e73f94a6878,
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_PRODUCTS_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("2Fj5v")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProductsSettingResource)(),
                    (0, (0, parcelRequire("cuwqc")).jsmGlobalCustomerAccessSettingsResource),
                    (0, (0, parcelRequire("6IgbX")).jsmGlobalCustomerAccessAffectedProjectsResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $ea4a7aec6cf36e8a$export$1ae94ce2cc225b3d
                ]
            }))
    ];
});
parcelRegister("6IgbX", function(module, exports) {
    $parcel$export(module.exports, "jsmGlobalCustomerAccessAffectedProjectsResource", ()=>$da9f8bab48dab68f$export$f27acbd4701f5dfe);
    var $dIdda = parcelRequire("dIdda");
    const $da9f8bab48dab68f$var$ONE_DAY_IN_MILLIS = 86400000;
    const $da9f8bab48dab68f$export$f27acbd4701f5dfe = (0, $dIdda.createResource)({
        type: (0, $700dba149c7972be$export$341f26dde034af5b),
        getKey: ()=>'affected-projects',
        getDataLoader: ()=>(parcelRequire("kaxeY")),
        maxAge: $da9f8bab48dab68f$var$ONE_DAY_IN_MILLIS
    });
});
const $700dba149c7972be$export$341f26dde034af5b = 'JSM_CUSTOMER_ACCESS_AFFECTED_PROJECTS';
const $700dba149c7972be$export$eb7818fb178a80b4 = 'JSM_GLOBAL_CUSTOMER_ACCESS_SETTINGS';
parcelRegister("kaxeY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3iYiJ").then(()=>parcelRequire('8QdIc'));
});
parcelRegister("cuwqc", function(module, exports) {
    $parcel$export(module.exports, "jsmGlobalCustomerAccessSettingsResource", ()=>$ab848c99e9d2daf7$export$b1a50ad717b4ca61);
    var $dIdda = parcelRequire("dIdda");
    const $ab848c99e9d2daf7$var$ONE_DAY_IN_MILLIS = 86400000;
    const $ab848c99e9d2daf7$export$b1a50ad717b4ca61 = (0, $dIdda.createResource)({
        type: (0, $700dba149c7972be$export$eb7818fb178a80b4),
        getKey: ()=>'settings',
        getDataLoader: ()=>(parcelRequire("ikGcK")),
        maxAge: $ab848c99e9d2daf7$var$ONE_DAY_IN_MILLIS
    });
});
parcelRegister("ikGcK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jTKK6").then(()=>parcelRequire('4pG8m'));
});
parcelRegister("k6H7t", function(module, exports) {
    $parcel$export(module.exports, "productsJsmCustomerAccessRoute", ()=>$f9c60351ae5f8e90$export$b97e3b6231be8149);
    var $65Ltd;
    const $f9c60351ae5f8e90$export$b97e3b6231be8149 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PRODUCTS_JSM_CUSTOMER_ACCESS),
        path: '/jira/settings/products/servicedesk/customer-access',
        exact: true
    };
});
parcelRegister("9y0dD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("iTi1A")
    ]).then(()=>parcelRequire('faXQs'));
});
parcelRegister("lscMY", function(module, exports) {
    $parcel$export(module.exports, "newIssueFeaturesRouteEntries", ()=>$f11b5b6d5b73c87f$export$8f3854f8ef3c4116);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $k2ke1;
    var $2FG9c;
    const $f11b5b6d5b73c87f$export$8f3854f8ef3c4116 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("k2ke1")).globalSettingsIssuesNewIssueSearchRoute), ()=>({
                ufoName: 'admin.new-issue-search-transition',
                component: (0, (0, parcelRequire("2FG9c")).default),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("2FG9c")).LazyNewIssueSearchTransition)
                ],
                canTransitionIn: ()=>true
            }))
    ];
});
parcelRegister("k2ke1", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesNewIssueSearchRoute", ()=>$0b0fe41df29a2377$export$774dc60e785b8ae8);
    var $65Ltd;
    const $0b0fe41df29a2377$export$774dc60e785b8ae8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_NEW_ISSUE_SEARCH),
        path: '/jira/settings/issues/new-issue-search-transition'
    };
});
parcelRegister("2FG9c", function(module, exports) {
    $parcel$export(module.exports, "LazyNewIssueSearchTransition", ()=>$4f134f463ddf0416$export$aa5e318abd957ad);
    $parcel$export(module.exports, "default", ()=>$4f134f463ddf0416$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $4f134f463ddf0416$export$aa5e318abd957ad = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("d7PBt"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/new-issue-search-settings/src/index.tsx"
    });
    var $4f134f463ddf0416$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4f134f463ddf0416$export$aa5e318abd957ad,
            pageId: "jira-admin-pages-new-issue-search-transition",
            shouldShowSpinner: true
        });
});
parcelRegister("d7PBt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("9iFSf")
    ]).then(()=>parcelRequire('7sYTD'));
});
parcelRegister("7hJUw", function(module, exports) {
    $parcel$export(module.exports, "outgoingMailRouteEntries", ()=>$aae9f30dff1362f9$export$d16163932c3babaa);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $d8FBC;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $1aAOt;
    var $gASEv;
    var $5FGTk;
    const $aae9f30dff1362f9$export$d16163932c3babaa = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("gASEv")).globalSettingsSystemBulkMailRoute), ()=>({
                component: (0, (0, parcelRequire("5FGTk")).default),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("d8FBC")).SidebarGlobalSettingsSystem)
                },
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("1aAOt")).getOfferingCatalogueFeaturesResource)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("5FGTk")).LazyBulkEmail)
                ]
            }))
    ];
});
parcelRegister("d8FBC", function(module, exports) {
    $parcel$export(module.exports, "SidebarGlobalSettingsSystem", ()=>$6ea6596802956a9d$export$52af3150b9f64726);
    var $5uXOq = parcelRequire("5uXOq");
    var $fobme;
    var $acDan;
    var $hcbSm;
    const $6ea6596802956a9d$export$52af3150b9f64726 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("acDan")).SidebarRenderStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hcbSm")).Menu), null), !false && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("acDan")).SidebarReady), {
            id: (0, (0, parcelRequire("fobme")).SIDEBAR_ID).GLOBAL_SETTINGS_SYSTEM
        }));
});
parcelRegister("fobme", function(module, exports) {
    $parcel$export(module.exports, "SIDEBAR_ID", ()=>$4b9be639c0c7f77b$export$adf978edbdfaf080);
    const $4b9be639c0c7f77b$export$adf978edbdfaf080 = {
        CONNECT: 'CONNECT',
        CORE: 'CORE',
        FILTERS: 'FILTERS',
        FILTERS_GLOBAL: 'FILTERS_GLOBAL',
        FORGE_GLOBAL_PAGE: 'FORGE_GLOBAL_PAGE',
        GLOBAL_SETTINGS_APPS: 'GLOBAL_SETTINGS_APPS',
        GLOBAL_SETTINGS_ISSUES: 'GLOBAL_SETTINGS_ISSUES',
        GLOBAL_SETTINGS_PRODUCTS: 'GLOBAL_SETTINGS_PRODUCTS',
        GLOBAL_SETTINGS_PROJECTS: 'GLOBAL_SETTINGS_PROJECTS',
        GLOBAL_SETTINGS_SYSTEM: 'GLOBAL_SETTINGS_SYSTEM',
        JSM: 'JSM',
        JSW_CLASSIC: 'JSW_CLASSIC',
        JSW_NEXT_GEN: 'JSW_NEXT_GEN',
        PERSONAL_SETTINGS: 'PERSONAL_SETTINGS',
        EOC_OPERATIONS: 'EOC_OPERATIONS',
        POLARIS: 'POLARIS',
        USER: 'USER',
        HELP_CENTER_SETTINGS: 'HELP_CENTER_SETTINGS'
    };
});
parcelRegister("hcbSm", function(module, exports) {
    $parcel$export(module.exports, "Menu", ()=>$e261d6c9e28d2ed4$export$d9b273488cd8ce6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $8g8yQ;
    var $4wOop;
    var $6CJbV;
    var $1e4k3;
    var $5tOuG;
    var $65Ltd;
    var $co1wz;
    var $koVbs;
    var $k0ZZ2;
    var $3OGaE;
    var $juTur;
    var $17bH5;
    var $4OCke;
    var $3tHFY;
    var $6jY6G;
    var $eaZ4X;
    var $jMBA3;
    var $aVTmi;
    var $cip1u;
    var $8wyB3;
    var $230Wm;
    var $je2KE;
    var $iAlf2;
    var $fwlYA;
    var $9O5DC;
    var $1y2CG;
    var $71ORT;
    var $3jrxv;
    const $e261d6c9e28d2ed4$var$calculateStack = (route)=>{
        const routeName = route && route.name || '';
        if ([
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_DASHBOARD),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_HOME),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_MIGRATIONS_FOCUS_PAGE)
        ].includes(routeName)) return [
            (0, (0, parcelRequire("eaZ4X")).SECTION_ID).MIGRATE_TO_CLOUD_SITE
        ];
        if ([
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_METRIC_DETAIL),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_OVERVIEW),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_CLEANUP),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_ROLE_ACTOR),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_CUSTOM_FIELD),
            (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_ISSUE)
        ].includes(routeName)) return [
            (0, (0, parcelRequire("eaZ4X")).SECTION_ID).PERFORMANCE_AND_SCALE
        ];
        return [];
    };
    const $e261d6c9e28d2ed4$export$d9b273488cd8ce6f = ()=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: connectItems } = (0, (0, parcelRequire("jMBA3")).useGlobalSettingsSystemConnectItems)();
        const [stack, setStack] = (0, $5uXOq.useState)($e261d6c9e28d2ed4$var$calculateStack(route));
        (0, $5uXOq.useEffect)(()=>{
            setStack($e261d6c9e28d2ed4$var$calculateStack(route));
        }, [
            route
        ]);
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        const generalConfigurationPath = navigationPath.generalConfiguration;
        if (features == null || connectItems == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), null);
        const navigationContent = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, features.hasGeneralConfiguration && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'general-configuration'
            },
            href: generalConfigurationPath,
            selectedOn: (0, (0, parcelRequire("3jrxv")).isGeneralConfigurationSelected)
        }, formatMessage((0, (0, parcelRequire("iAlf2")).default).generalConfiguration)), features.hasDarkFeatures && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'dark-features'
            },
            href: navigationPath.darkFeatures,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("iAlf2")).default).darkFeatures)), features.hasTroubleshootingAndSupportSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1y2CG")).TroubleshootingAndSupportSection), null), features.hasSecuritySection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fwlYA")).SecuritySection), null), features.hasCollectors && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'collectors'
            },
            href: navigationPath.issueCollectors,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("iAlf2")).default).issueCollectors)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8wyB3")).AutomationSection), null), features.hasUserInterfaceSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("71ORT")).UserInterfaceSection), null), features.hasImportExportSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("230Wm")).ImportExportSection), {
            stack: stack
        }), features.hasMailSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("je2KE")).MailSection), null), features.hasAdminHelperSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aVTmi")).AdminHelperSection), null), features.hasSharedSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9O5DC")).SharedSection), null), features.hasAdvancedSection && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cip1u")).AdvancedSection), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3tHFY")).ConnectMenu), {
            items: connectItems,
            overrides: {
                BackMenuItem: {
                    href: '/jira/settings/system/general-configuration',
                    title: formatMessage((0, (0, parcelRequire("iAlf2")).default).systemGroup)
                }
            }
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juTur")).ContextualAnalyticsData), {
            menuId: "global-settings/system",
            stack: stack
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1e4k3")).default), {
            label: formatMessage((0, (0, parcelRequire("iAlf2")).default).globalSettingsSystemSidebarLabel)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4wOop")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OGaE")).TitleHeader), null, formatMessage((0, (0, parcelRequire("iAlf2")).default).systemGroup))), (0, (0, parcelRequire("co1wz")).ff)('jira-system-settings-cloud-to-cloud-migration') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6CJbV")).default), {
            stack: stack,
            onChange: setStack
        }, navigationContent) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8g8yQ")).default), null, navigationContent)));
    };
});
parcelRegister("8g8yQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2551267fb87d2b4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $gCUkg;
    var $6onh1;
    var $h6CNO;
    const $c2551267fb87d2b4$var$NavigationContent = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { showTopScrollIndicator: showTopScrollIndicator, children: children, testId: testId } = props;
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("6onh1")).useShouldNestedElementRender)();
        const scrollbar = (0, (0, parcelRequire("gCUkg")).default)();
        if (!shouldRender) return children;
        const typedRef = ref;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: typedRef,
            css: (0, (0, parcelRequire("h6CNO")).outerContainerCSS)({
                showTopScrollIndicator: showTopScrollIndicator,
                scrollbarWidth: scrollbar.width
            }),
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: scrollbar.ref,
            css: (0, (0, parcelRequire("h6CNO")).innerContainerCSS)({
                showTopScrollIndicator: showTopScrollIndicator
            })
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: (0, (0, parcelRequire("h6CNO")).containerCSS)({
                showTopScrollIndicator: showTopScrollIndicator
            })
        }, children)));
    });
    var $c2551267fb87d2b4$export$2e2bcd8739ae039 = $c2551267fb87d2b4$var$NavigationContent;
});
parcelRegister("gCUkg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ae3b5e40126c46ab$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $ae3b5e40126c46ab$export$2e2bcd8739ae039() {
        const [scrollbarWidth, setScrollbarWidth] = (0, $5uXOq.useState)(0);
        const elementRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (!elementRef.current) return;
            const width = elementRef.current.offsetWidth - elementRef.current.scrollWidth;
            if (width === scrollbarWidth) return;
            setScrollbarWidth(width);
        });
        return {
            width: scrollbarWidth,
            ref: elementRef
        };
    }
});
parcelRegister("h6CNO", function(module, exports) {
    $parcel$export(module.exports, "outerContainerCSS", ()=>$611f4c9265e19f66$export$3ff462c0176a504f);
    $parcel$export(module.exports, "innerContainerCSS", ()=>$611f4c9265e19f66$export$4d1aec15cfcfc2a4);
    $parcel$export(module.exports, "containerCSS", ()=>$611f4c9265e19f66$export$949392aeaf7d2e3a);
    var $7u8mi;
    const $611f4c9265e19f66$var$scrollIndicatorMaskZIndex = 2;
    const $611f4c9265e19f66$var$scrollIndicatorZIndex = 1;
    const $611f4c9265e19f66$var$scrollIndicatorHeight = 2;
    const $611f4c9265e19f66$var$scrollIndicatorBorderRadius = '1px';
    const $611f4c9265e19f66$var$containerPadding = 8;
    const $611f4c9265e19f66$var$itemHeadingContentHeight = (0, (0, parcelRequire("7u8mi")).headingSizes).h100.lineHeight;
    const $611f4c9265e19f66$var$skeletonHeadingHeight = $611f4c9265e19f66$var$containerPadding;
    const $611f4c9265e19f66$var$skeletonHeadingMarginOffset = 3;
    const $611f4c9265e19f66$var$skeletonHeadingTopMargin = $611f4c9265e19f66$var$containerPadding * 2.5 + ($611f4c9265e19f66$var$itemHeadingContentHeight - $611f4c9265e19f66$var$skeletonHeadingHeight) - $611f4c9265e19f66$var$skeletonHeadingMarginOffset;
    const $611f4c9265e19f66$var$skeletonHeadingBottomMargin = $611f4c9265e19f66$var$containerPadding * 0.75 + $611f4c9265e19f66$var$skeletonHeadingMarginOffset;
    const $611f4c9265e19f66$export$3ff462c0176a504f = (opts)=>({
            display: 'flex',
            height: '100%',
            overflow: 'hidden',
            position: 'relative',
            '&::before': {
                content: "''",
                display: 'block',
                left: "var(--ds-space-100, 8px)",
                right: $611f4c9265e19f66$var$containerPadding + opts.scrollbarWidth,
                height: $611f4c9265e19f66$var$scrollIndicatorHeight,
                borderRadius: `var(--ds-border-radius-050, ${$611f4c9265e19f66$var$scrollIndicatorBorderRadius})`,
                backgroundColor: `var(${0, $c1752cf12d4aca48$export$e8e7f51e033d4cb2}, ${`var(--ds-border, ${0, $5e0c0d4e15efb4a6$export$3e51e8f1440314ba})`})`,
                position: 'absolute',
                zIndex: $611f4c9265e19f66$var$scrollIndicatorZIndex
            },
            '&::after': {
                content: "''",
                position: 'absolute',
                display: 'block',
                borderRadius: `var(--ds-border-radius-050, ${$611f4c9265e19f66$var$scrollIndicatorBorderRadius})`,
                flexShrink: 0,
                height: $611f4c9265e19f66$var$scrollIndicatorHeight,
                left: "var(--ds-space-100, 8px)",
                right: $611f4c9265e19f66$var$containerPadding + opts.scrollbarWidth,
                bottom: 0,
                zIndex: $611f4c9265e19f66$var$scrollIndicatorZIndex,
                backgroundColor: `var(${0, $c1752cf12d4aca48$export$e8e7f51e033d4cb2}, ${`var(--ds-border, ${0, $5e0c0d4e15efb4a6$export$3e51e8f1440314ba})`})`
            }
        });
    const $611f4c9265e19f66$export$4d1aec15cfcfc2a4 = (opts)=>({
            display: 'flex',
            overflow: 'auto',
            width: '100%',
            position: 'relative',
            boxSizing: 'border-box',
            flexDirection: 'column',
            ...!opts.showTopScrollIndicator && {
                '&::before': {
                    borderRadius: `var(--ds-border-radius-050, ${$611f4c9265e19f66$var$scrollIndicatorBorderRadius})`,
                    content: "''",
                    left: 0,
                    right: 0,
                    height: $611f4c9265e19f66$var$scrollIndicatorHeight,
                    backgroundColor: `var(${0, $c1752cf12d4aca48$export$49e4dd5760b312e0}, ${`var(--ds-surface, ${0, $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2})`})`,
                    position: 'absolute',
                    display: 'block',
                    zIndex: $611f4c9265e19f66$var$scrollIndicatorMaskZIndex
                }
            },
            '&::after': {
                borderRadius: `var(--ds-border-radius-050, ${$611f4c9265e19f66$var$scrollIndicatorBorderRadius})`,
                content: "''",
                display: 'block',
                flexShrink: 0,
                height: $611f4c9265e19f66$var$scrollIndicatorHeight,
                marginTop: 'auto',
                position: 'relative',
                zIndex: $611f4c9265e19f66$var$scrollIndicatorMaskZIndex,
                backgroundColor: `var(${0, $c1752cf12d4aca48$export$49e4dd5760b312e0}, ${`var(--ds-surface, ${0, $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2})`})`
            }
        });
    const $611f4c9265e19f66$export$949392aeaf7d2e3a = (opts)=>({
            marginTop: opts.showTopScrollIndicator ? $611f4c9265e19f66$var$scrollIndicatorHeight : 0,
            marginLeft: "var(--ds-space-100, 8px)",
            marginRight: "var(--ds-space-100, 8px)",
            position: 'relative',
            '& [data-ds--menu--heading-item]': {
                marginBottom: "var(--ds-space-075, 6px)",
                marginTop: "var(--ds-space-200, 16px)"
            },
            '& [data-ds--menu--skeleton-heading-item]': {
                marginTop: $611f4c9265e19f66$var$skeletonHeadingTopMargin,
                marginBottom: $611f4c9265e19f66$var$skeletonHeadingBottomMargin
            }
        });
});
const $c1752cf12d4aca48$export$e8e7f51e033d4cb2 = '--ds-menu-seperator-color';
const $c1752cf12d4aca48$export$49e4dd5760b312e0 = '--ds-menu-scroll-indicator-color';
parcelRegister("4wOop", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb9dabc3c2bcc2c3$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $6T4rd;
    var $jJ1Sb;
    const $cb9dabc3c2bcc2c3$var$navigationFooterStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        display: 'block',
        padding: 'space.100',
        paddingBlockStart: 'space.300'
    });
    const $cb9dabc3c2bcc2c3$var$NavigationHeader = (props)=>{
        const { children: children } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $cb9dabc3c2bcc2c3$var$navigationFooterStyles,
            "data-navheader": true
        }, children);
    };
    var $cb9dabc3c2bcc2c3$export$2e2bcd8739ae039 = $cb9dabc3c2bcc2c3$var$NavigationHeader;
});
parcelRegister("6CJbV", function(module, exports) {
    $parcel$export(module.exports, "ROOT_ID", ()=>$31d6469241a609a8$export$ec71a3379b43ae5c);
    $parcel$export(module.exports, "default", ()=>$31d6469241a609a8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dtfx6;
    var $gqLnL;
    var $bk7sl;
    var $6nX2D;
    var $6onh1;
    var $2vwzO;
    function $31d6469241a609a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $31d6469241a609a8$export$ec71a3379b43ae5c = 'ATLASKIT_NESTED_ROOT';
    const $31d6469241a609a8$var$nestableNavigationContentStyles = {
        name: "hxjswn",
        styles: "height:100%;position:relative;outline:none"
    };
    const $31d6469241a609a8$var$nestingRootStyles = {
        name: "1klp5xc",
        styles: "display:flex;width:100%;height:100%;position:absolute;flex-direction:column"
    };
    const $31d6469241a609a8$var$NestableNavigationContent = (props)=>{
        const containerRef = (0, $5uXOq.useRef)(null);
        const { children: children, testId: testId, overrides: overrides, initialStack: initialStack, onChange: onChange, onUnknownNest: onUnknownNest, stack: stack, showTopScrollIndicator: showTopScrollIndicator } = props;
        const [committedStack, setCommittedStack] = (0, $5uXOq.useState)(stack || initialStack || []);
        const controlledStack = stack || undefined;
        const currentStackId = committedStack[committedStack.length - 1] || $31d6469241a609a8$export$ec71a3379b43ae5c;
        const [transition, setTransition] = (0, $5uXOq.useState)('nesting');
        const backTestId = testId && `${testId}--go-back-item`;
        const renderGoBackItem = overrides && overrides.GoBackItem && overrides.GoBackItem.render ? overrides.GoBackItem.render : (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("gqLnL")).default), props, "Go back");
        const { childIdsRef: childIdsRef } = (0, (0, parcelRequire("6nX2D")).useChildIds)(currentStackId, committedStack, onUnknownNest);
        const onNestHandler = (0, $5uXOq.useCallback)((layerId)=>{
            onChange && onChange(committedStack.concat(layerId));
            if (controlledStack) return;
            setTransition('nesting');
            requestAnimationFrame(()=>{
                setCommittedStack((prev)=>{
                    const newStack = prev.concat(layerId);
                    return newStack;
                });
            });
        }, [
            controlledStack,
            onChange,
            committedStack
        ]);
        const onUnNestHandler = (0, $5uXOq.useCallback)(()=>{
            onChange && onChange(committedStack.slice(0, committedStack.length - 1));
            if (controlledStack) return;
            setTransition('unnesting');
            requestAnimationFrame(()=>{
                setCommittedStack((prev)=>{
                    const newStack = prev.slice(0, prev.length - 1);
                    return newStack;
                });
            });
        }, [
            controlledStack,
            onChange,
            committedStack
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!controlledStack) return;
            if (JSON.stringify(committedStack) === JSON.stringify(controlledStack)) return;
            if (controlledStack.length < committedStack.length) setTransition('unnesting');
            else setTransition('nesting');
            requestAnimationFrame(()=>{
                setCommittedStack(controlledStack);
            });
        }, [
            committedStack,
            controlledStack
        ]);
        const backButton = renderGoBackItem({
            onClick: onUnNestHandler,
            testId: backTestId
        });
        const context = (0, $5uXOq.useMemo)(()=>({
                currentStackId: currentStackId,
                backButton: backButton,
                stack: committedStack,
                onNest: onNestHandler,
                onUnNest: onUnNestHandler,
                parentId: $31d6469241a609a8$export$ec71a3379b43ae5c,
                childIds: childIdsRef,
                forceShowTopScrollIndicator: showTopScrollIndicator
            }), [
            currentStackId,
            backButton,
            committedStack,
            onNestHandler,
            onUnNestHandler,
            childIdsRef,
            showTopScrollIndicator
        ]);
        const manageFocus = (event)=>{
            const triggeredByKeyboard = event.nativeEvent.detail === 0;
            if (triggeredByKeyboard) containerRef.current && containerRef.current.focus();
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            css: $31d6469241a609a8$var$nestableNavigationContentStyles,
            ref: containerRef,
            tabIndex: -1,
            onClick: manageFocus
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dtfx6")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2vwzO")).NestingMotion), {
            key: currentStackId,
            enterFrom: transition === 'nesting' ? 'right' : 'left',
            exitTo: transition === 'nesting' ? 'left' : 'right',
            testId: testId && `${testId}-anim`
        }, (motion)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: $31d6469241a609a8$var$nestingRootStyles,
                ...motion
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6onh1")).NestedContext).Provider, {
                value: context
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bk7sl")).default), {
                title: "",
                id: $31d6469241a609a8$export$ec71a3379b43ae5c
            }, children)))))));
    };
    var $31d6469241a609a8$export$2e2bcd8739ae039 = $31d6469241a609a8$var$NestableNavigationContent;
});
parcelRegister("gqLnL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$806b384675d855fa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lItPf;
    var $1D7Ua;
    const $806b384675d855fa$var$GoBackItem = (0, $5uXOq.forwardRef)(({ cssFn: cssFn, iconBefore: iconBefore = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lItPf"))))), {
        color: "currentColor",
        LEGACY_secondaryColor: `var(--ds-surface, ${(0, $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2)})`,
        label: ""
    }), onClick: onClick, isSelected: isSelected, ...rest }, ref)=>{
        const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
        const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
            if (isInteracted) return;
            setIsInteracted(true);
            onClick && onClick(e);
        }, [
            onClick,
            isInteracted
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1D7Ua")).default), {
            isSelected: isSelected,
            cssFn: cssFn,
            iconBefore: iconBefore,
            onClick: onClickHandler,
            ref: ref,
            ...rest
        });
    });
    var $806b384675d855fa$export$2e2bcd8739ae039 = $806b384675d855fa$var$GoBackItem;
});
parcelRegister("lItPf", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fcf4d7c6bc96ea6c$var$_react = $fcf4d7c6bc96ea6c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fcf4d7c6bc96ea6c$var$_arrowLeft = $fcf4d7c6bc96ea6c$var$_interopRequireDefault((parcelRequire("cPeBC")));
    var $fcf4d7c6bc96ea6c$var$_arrowLeftCircle = $fcf4d7c6bc96ea6c$var$_interopRequireDefault((parcelRequire("jEqto")));
    function $fcf4d7c6bc96ea6c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fcf4d7c6bc96ea6c$var$ArrowLeftIcon = (props)=>$fcf4d7c6bc96ea6c$var$_react.default.createElement($fcf4d7c6bc96ea6c$var$_arrowLeft.default, Object.assign({
            LEGACY_fallbackIcon: $fcf4d7c6bc96ea6c$var$_arrowLeftCircle.default
        }, props));
    $fcf4d7c6bc96ea6c$var$ArrowLeftIcon.Name = 'ArrowLeftIconMigration';
    var $fcf4d7c6bc96ea6c$var$_default = module.exports.default = $fcf4d7c6bc96ea6c$var$ArrowLeftIcon;
});
parcelRegister("jEqto", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $e4e649bf4cb6229c$var$_react = $e4e649bf4cb6229c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $kfAhl;
    var $e4e649bf4cb6229c$var$_arrowLeft = $e4e649bf4cb6229c$var$_interopRequireDefault((parcelRequire("cPeBC")));
    function $e4e649bf4cb6229c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $e4e649bf4cb6229c$var$ArrowLeftCircleIcon = (props)=>$e4e649bf4cb6229c$var$_react.default.createElement((0, parcelRequire("kfAhl")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M16 10.995h-5.586l1.272-1.279a1.01 1.01 0 0 0 0-1.421.996.996 0 0 0-1.415 0l-2.978 2.994a1.01 1.01 0 0 0 0 1.423l2.978 2.993a1 1 0 0 0 1.415 0 1.01 1.01 0 0 0 0-1.421l-1.272-1.279H16c.552 0 1-.45 1-1.005s-.448-1.005-1-1.005"/></svg>`
        }, props, {
            newIcon: $e4e649bf4cb6229c$var$_arrowLeft.default
        }));
    $e4e649bf4cb6229c$var$ArrowLeftCircleIcon.displayName = 'ArrowLeftCircleIcon';
    var $e4e649bf4cb6229c$var$_default = module.exports.default = $e4e649bf4cb6229c$var$ArrowLeftCircleIcon;
});
parcelRegister("1D7Ua", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fbaefaba180e4cc8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6PItG;
    var $1WrCb;
    var $6onh1;
    const $fbaefaba180e4cc8$var$ButtonItem = (0, $5uXOq.forwardRef)(({ cssFn: cssFn, ...rest }, ref)=>{
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("6onh1")).useShouldNestedElementRender)();
        if (!shouldRender) return null;
        const cssOverride = (0, (0, parcelRequire("1WrCb")).overrideStyleFunction)((0, (0, parcelRequire("1WrCb")).baseSideNavItemStyle), cssFn);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6PItG")).default), {
            ref: ref,
            cssFn: cssOverride,
            ...rest
        });
    });
    var $fbaefaba180e4cc8$export$2e2bcd8739ae039 = $fbaefaba180e4cc8$var$ButtonItem;
});
parcelRegister("bk7sl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0963e81af44635d7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $bjpEU;
    var $6T4rd;
    var $jJ1Sb;
    var $1WrCb;
    var $1D7Ua;
    var $6nH5y;
    var $8g8yQ;
    var $6CJbV;
    var $6onh1;
    var $6nX2D;
    var $7GNIi;
    const $0963e81af44635d7$var$iconContainerStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        display: 'inline'
    });
    const $0963e81af44635d7$var$NestingItem = (props)=>{
        const { children: children, iconAfter: iconAfter, title: title, onClick: onClick, cssFn: cssFn, isSelected: isSelected, id: id, component: component, testId: testId, ...rest } = props;
        const { currentStackId: currentStackId, onNest: onNest, onUnNest: onUnNest, backButton: contextualBackButton, stack: stack, childIds: childIds, forceShowTopScrollIndicator: forceShowTopScrollIndicator } = (0, (0, parcelRequire("6onh1")).useNestedContext)();
        const mergedStyles = (0, (0, parcelRequire("1WrCb")).overrideStyleFunction)((0, (0, parcelRequire("7GNIi")).nestingItemStyle), cssFn);
        const [isInteracted, setIsInteracted] = (0, $5uXOq.useState)(false);
        const backButton = props.overrides && props.overrides.GoBackItem && props.overrides.GoBackItem.render && props.overrides.GoBackItem.render({
            onClick: onUnNest,
            testId: testId && `${testId}--go-back-item`
        }) || contextualBackButton;
        const context = (0, $5uXOq.useMemo)(()=>({
                stack: stack,
                currentStackId: currentStackId,
                onNest: onNest,
                onUnNest: onUnNest,
                backButton: backButton,
                parentId: id,
                childIds: childIds,
                forceShowTopScrollIndicator: forceShowTopScrollIndicator
            }), [
            stack,
            currentStackId,
            onNest,
            onUnNest,
            backButton,
            id,
            childIds,
            forceShowTopScrollIndicator
        ]);
        (0, (0, parcelRequire("6nX2D")).useChildIdsEffect)(childIds, id);
        const isNormalClick = (e)=>!(e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
        const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
            if (isInteracted) return;
            if (isNormalClick(e)) {
                setIsInteracted(true);
                onNest(id);
            }
            onClick && onClick(e);
        }, [
            isInteracted,
            onClick,
            onNest,
            id
        ]);
        if (currentStackId === id) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6onh1")).NestedContext).Provider, {
            value: context
        }, stack.length >= 1 && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6T4rd")).default), {
            paddingBlock: "space.075",
            paddingInline: "space.100"
        }, backButton), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8g8yQ")).default), {
            testId: testId,
            showTopScrollIndicator: forceShowTopScrollIndicator || stack.length >= 1
        }, children));
        if ([
            (0, (0, parcelRequire("6CJbV")).ROOT_ID),
            ...stack
        ].includes(id)) return children;
        const componentProps = {
            iconAfter: (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, iconAfter ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6T4rd")).default), {
                xcss: $0963e81af44635d7$var$iconContainerStyles,
                "data-custom-icon": true,
                as: "span"
            }, iconAfter) : null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6T4rd")).default), {
                "data-right-arrow": true,
                xcss: $0963e81af44635d7$var$iconContainerStyles,
                as: "span"
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("bjpEU"))))), {
                testId: testId && `${testId}--item--right-arrow`,
                color: "currentColor",
                LEGACY_secondaryColor: `var(--ds-surface, ${(0, $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2)})`,
                label: ""
            }))),
            onClick: onClickHandler,
            isSelected: isSelected,
            testId: testId && `${testId}--item`,
            ...rest,
            children: title,
            cssFn: mergedStyles
        };
        if (component) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6nH5y")).default), {
            ...componentProps,
            component: component
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1D7Ua")).default), componentProps);
    };
    var $0963e81af44635d7$export$2e2bcd8739ae039 = $0963e81af44635d7$var$NestingItem;
});
parcelRegister("bjpEU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $83c55f5f5744e4f9$var$_react = $83c55f5f5744e4f9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $83c55f5f5744e4f9$var$_arrowRight = $83c55f5f5744e4f9$var$_interopRequireDefault((parcelRequire("d38Dj")));
    var $83c55f5f5744e4f9$var$_arrowRightCircle = $83c55f5f5744e4f9$var$_interopRequireDefault((parcelRequire("3KcK3")));
    function $83c55f5f5744e4f9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $83c55f5f5744e4f9$var$ArrowRightIcon = (props)=>$83c55f5f5744e4f9$var$_react.default.createElement($83c55f5f5744e4f9$var$_arrowRight.default, Object.assign({
            LEGACY_fallbackIcon: $83c55f5f5744e4f9$var$_arrowRightCircle.default
        }, props));
    $83c55f5f5744e4f9$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
    var $83c55f5f5744e4f9$var$_default = module.exports.default = $83c55f5f5744e4f9$var$ArrowRightIcon;
});
parcelRegister("d38Dj", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9802408843b21788$var$_react = $9802408843b21788$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $9802408843b21788$var$_UNSAFE_baseNew = $9802408843b21788$var$_interopRequireDefault((parcelRequire("huIZN")));
    function $9802408843b21788$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9802408843b21788$var$ArrowRightIcon = (props)=>$9802408843b21788$var$_react.default.createElement($9802408843b21788$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
        }, props));
    $9802408843b21788$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $9802408843b21788$var$_default = module.exports.default = $9802408843b21788$var$ArrowRightIcon;
});
parcelRegister("3KcK3", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2b9f8d3cf6c73d6e$var$_react = $2b9f8d3cf6c73d6e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $kfAhl;
    var $2b9f8d3cf6c73d6e$var$_arrowRight = $2b9f8d3cf6c73d6e$var$_interopRequireDefault((parcelRequire("d38Dj")));
    function $2b9f8d3cf6c73d6e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2b9f8d3cf6c73d6e$var$ArrowRightCircleIcon = (props)=>$2b9f8d3cf6c73d6e$var$_react.default.createElement((0, parcelRequire("kfAhl")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor" fill-rule="nonzero"/><path fill="inherit" d="M12.314 8.294a1.01 1.01 0 0 0 0 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005S7.447 13.005 8 13.005h5.585l-1.271 1.279a1.01 1.01 0 0 0 0 1.422 1 1 0 0 0 1.415 0l2.978-2.995a1.01 1.01 0 0 0 0-1.422l-2.978-2.995a1 1 0 0 0-1.415 0"/></g></svg>`
        }, props, {
            newIcon: $2b9f8d3cf6c73d6e$var$_arrowRight.default
        }));
    $2b9f8d3cf6c73d6e$var$ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
    var $2b9f8d3cf6c73d6e$var$_default = module.exports.default = $2b9f8d3cf6c73d6e$var$ArrowRightCircleIcon;
});
parcelRegister("6nH5y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$28ffdcd480686033$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $eIm7r;
    var $1WrCb;
    var $6onh1;
    const $28ffdcd480686033$var$CustomItem = (0, $5uXOq.forwardRef)(({ cssFn: cssFn, ...rest }, ref)=>{
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("6onh1")).useShouldNestedElementRender)();
        if (!shouldRender) return null;
        const cssOverride = (0, (0, parcelRequire("1WrCb")).overrideStyleFunction)((0, (0, parcelRequire("1WrCb")).baseSideNavItemStyle), cssFn);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eIm7r")).default), {
            ref: ref,
            cssFn: cssOverride,
            ...rest
        });
    });
    var $28ffdcd480686033$export$2e2bcd8739ae039 = $28ffdcd480686033$var$CustomItem;
});
parcelRegister("6nX2D", function(module, exports) {
    $parcel$export(module.exports, "useChildIds", ()=>$a65aeb841faba024$export$61b3ef4f009a9474);
    $parcel$export(module.exports, "useChildIdsEffect", ()=>$a65aeb841faba024$export$ea18c2b5f0e24612);
    var $5uXOq = parcelRequire("5uXOq");
    var $6CJbV;
    const $a65aeb841faba024$export$61b3ef4f009a9474 = (currentStackId, committedStack, onUnknownNest)=>{
        const childIdsRef = (0, $5uXOq.useRef)(new Set());
        (0, $5uXOq.useEffect)(()=>{
            if (currentStackId === (0, (0, parcelRequire("6CJbV")).ROOT_ID) || !childIdsRef.current.size || childIdsRef.current.has(currentStackId) || !onUnknownNest) return;
            onUnknownNest(committedStack || [
                currentStackId
            ]);
        }, [
            currentStackId,
            committedStack,
            onUnknownNest
        ]);
        return {
            childIdsRef: childIdsRef
        };
    };
    const $a65aeb841faba024$export$ea18c2b5f0e24612 = (childIds, id)=>{
        (0, $5uXOq.useEffect)(()=>{
            if (!childIds || !childIds.current) return;
            if (!childIds.current.has(id)) childIds.current.add(id);
            return ()=>{
                childIds.current.delete(id);
            };
        }, [
            id
        ]);
    };
});
parcelRegister("7GNIi", function(module, exports) {
    $parcel$export(module.exports, "nestingItemStyle", ()=>$91fcb15c15e1bea9$export$38e770f85519b259);
    const $91fcb15c15e1bea9$export$4c36b5b1b67ee1e8 = {
        ['&:hover [data-custom-icon]']: {
            display: 'none'
        },
        ['&:active [data-custom-icon]']: {
            display: 'none'
        },
        ['&:focus [data-custom-icon]']: {
            display: 'none'
        },
        ['& [data-custom-icon]']: {
            display: 'inherit'
        },
        ['&:hover [data-right-arrow]']: {
            display: 'inherit'
        },
        ['&:active [data-right-arrow]']: {
            display: 'inherit'
        },
        ['&:focus [data-right-arrow]']: {
            display: 'inherit'
        },
        ['& [data-right-arrow]']: {
            display: 'none'
        }
    };
    const $91fcb15c15e1bea9$var$disabledCSS = {
        ['[data-item-elem-after]']: {
            opacity: 0
        },
        ['& [data-right-arrow]']: {
            display: 'none'
        }
    };
    const $91fcb15c15e1bea9$export$38e770f85519b259 = (state)=>{
        return {
            ...state.isDisabled ? $91fcb15c15e1bea9$var$disabledCSS : $91fcb15c15e1bea9$export$4c36b5b1b67ee1e8
        };
    };
});
parcelRegister("2vwzO", function(module, exports) {
    $parcel$export(module.exports, "NestingMotion", ()=>$04d82911b73105b9$export$9e743a8c2a6b450e);
    var $f8Sb3;
    var $ggYIC;
    const $04d82911b73105b9$export$9e743a8c2a6b450e = (props)=>{
        const { children: children, enterFrom: enterFrom, exitTo: exitTo, testId: testId } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ggYIC")).default), {
            exitTo: exitTo,
            enterFrom: enterFrom,
            animationTimingFunction: (_)=>(0, $afa89fc5bcc96d10$export$57636bb43b1ccbb0)
        }, (innerProps, direction)=>children({
                'data-enter-from': enterFrom,
                'data-exit-to': exitTo,
                'data-testid': testId && `${testId}-${direction}`,
                ...innerProps
            }));
    };
});
const $afa89fc5bcc96d10$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $afa89fc5bcc96d10$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $afa89fc5bcc96d10$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
parcelRegister("1e4k3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$854b6c68803a91cf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $6SJYd;
    const $854b6c68803a91cf$var$sidebarMinWidth = '240px';
    const $854b6c68803a91cf$var$sideNavStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        width: '100%',
        minWidth: $854b6c68803a91cf$var$sidebarMinWidth,
        height: '100%',
        position: 'relative',
        flexDirection: 'column',
        backgroundColor: `var(--ds-surface, ${(0, $5e0c0d4e15efb4a6$export$e655ef011c4aa1a2)})`,
        color: `var(--ds-text-subtle, ${(0, $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae)})`,
        overflow: 'hidden'
    });
    const $854b6c68803a91cf$var$SideNavigation = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { children: children, testId: testId, label: label } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("nav", {
            ref: ref,
            "data-testid": testId,
            "aria-label": label,
            css: $854b6c68803a91cf$var$sideNavStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6SJYd")).SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "notch"
        }, children));
    });
    var $854b6c68803a91cf$export$2e2bcd8739ae039 = $854b6c68803a91cf$var$SideNavigation;
});
parcelRegister("k0ZZ2", function(module, exports) {
    $parcel$export(module.exports, "MenuItem", ()=>$5e6269ab5deb76fb$export$2ce376c2cc3355c8);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $aZsz6 = parcelRequire("aZsz6");
    var $6nH5y;
    var $dIdda = parcelRequire("dIdda");
    var $fpoBX;
    var $4UcF0;
    var $jvqf4;
    const $5e6269ab5deb76fb$var$WrapperComponent = (0, $5uXOq.forwardRef)(({ children: children, className: className, legacyClassName: legacyClassName, href: href, to: to, target: target, useButtonLink: useButtonLink, ...props }, ref)=>{
        const commonProps = {
            ...props,
            children: children,
            className: `${className ?? ''} ${legacyClassName ?? ''}`
        };
        return href != null || to != null ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Link), {
            ...commonProps,
            href: href,
            to: to,
            target: target,
            ref: ref,
            type: useButtonLink ? 'button' : 'a'
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement($5e6269ab5deb76fb$var$ButtonItem, {
            ...commonProps,
            type: "button",
            ref: ref
        });
    });
    const $5e6269ab5deb76fb$var$customCssFn = (currentState = {})=>({
            '[data-item-title]': {
                lineHeight: 1.2
            },
            ...currentState.isSelected && {
                '& [data-item-title]': {
                    color: "var(--ds-text-selected, rgb(12, 102, 228))"
                }
            },
            '&:focus, &:visited, &:active': {
                textDecoration: 'inherit',
                outline: 0
            },
            '&:active': {
                backgroundColor: "var(--ds-background-selected-pressed, #85B8FF)",
                boxShadow: "var(--ds-shadow-overlay, transparent)",
                '& [data-item-title]': {
                    color: "var(--ds-text, rgb(66, 82, 110))"
                }
            },
            '&:focus': {
                boxShadow: `${`var(--ds-border-focused, ${0, $5e0c0d4e15efb4a6$export$215b7063051591f1})`} 0 0 0 2px inset`
            },
            '&[data-rbd-draggable-id]': {
                cursor: 'pointer'
            }
        });
    const $5e6269ab5deb76fb$export$2ce376c2cc3355c8 = (0, $5uXOq.forwardRef)(({ analytics: analytics, href: href, onClick: onClick, overrides: overrides, selectedOn: selectedOn, cssFn: outsideCssFn, useButtonLink: useButtonLink = false, ...rest }, ref)=>{
        const onClickHandler = (0, (0, parcelRequire("jvqf4")).useOnClick)({
            onClick: onClick,
            analytics: analytics
        });
        const [{ route: route, query: query, location: location }] = (0, $dIdda.useRouter)();
        let isSelected;
        (0, $5uXOq.useEffect)(()=>{
            if (isSelected && ref?.current != null) setTimeout(()=>{
                ref && ref.current != null && ref.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            });
        }, [
            selectedOn,
            ref,
            isSelected
        ]);
        if (typeof selectedOn === 'function') isSelected = route != null && selectedOn({
            ...location,
            query: query
        }, (0, ($parcel$interopDefault($aZsz6)))(href || '/', true));
        else isSelected = Boolean(selectedOn) && route != null && selectedOn != null && selectedOn.includes(route.name);
        const theme = (0, (0, parcelRequire("fpoBX")).useSidebarTheme)();
        const cssFn = (0, $5uXOq.useCallback)((currentState)=>({
                ...outsideCssFn && outsideCssFn(currentState),
                ...$5e6269ab5deb76fb$var$customCssFn(currentState),
                ...(0, (0, parcelRequire("4UcF0")).getCustomThemeCss)(theme)
            }), [
            theme,
            outsideCssFn
        ]);
        const customProps = {
            ...rest,
            component: $5e6269ab5deb76fb$var$WrapperComponent,
            cssFn: cssFn,
            href: href,
            isSelected: isSelected,
            onClick: onClickHandler,
            overrides: overrides,
            ref: ref,
            useButtonLink: useButtonLink,
            'aria-current': isSelected ? 'page' : undefined
        };
        return overrides?.CustomItem?.render(customProps) || (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nH5y")).default), customProps);
    });
    const $5e6269ab5deb76fb$var$ButtonItem = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhk18uv _19itidpf _12ji1r31 _1qu2glyw _12y3idpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bsb1osq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fpoBX", function(module, exports) {
    $parcel$export(module.exports, "SidebarThemeProvider", ()=>$c9116269ddc1accc$export$92cd68117b68bf5f);
    $parcel$export(module.exports, "useSidebarTheme", ()=>$c9116269ddc1accc$export$b1a81b4626bc52c3);
    var $5uXOq = parcelRequire("5uXOq");
    const $c9116269ddc1accc$var$ThemeContext = (0, $5uXOq.createContext)(null);
    const $c9116269ddc1accc$export$92cd68117b68bf5f = ({ theme: theme, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($c9116269ddc1accc$var$ThemeContext.Provider, {
            value: theme
        }, children);
    const $c9116269ddc1accc$export$b1a81b4626bc52c3 = ()=>(0, $5uXOq.useContext)($c9116269ddc1accc$var$ThemeContext);
});
parcelRegister("4UcF0", function(module, exports) {
    $parcel$export(module.exports, "getCustomThemeCss", ()=>$2dc9c92255b2fb1d$export$cc5a98b66b3e9306);
    const $2dc9c92255b2fb1d$export$cc5a98b66b3e9306 = (theme)=>{
        if (theme?.navigation) {
            const { navigation: { item: item, icon: icon } } = theme;
            return {
                backgroundColor: item?.background?.default ?? undefined,
                color: item?.color?.default ?? undefined,
                '& [data-item-title]': {
                    color: item?.color?.default ?? undefined
                },
                '&:hover': {
                    color: item?.color?.hover ?? undefined,
                    backgroundColor: item?.background?.hover ?? undefined
                },
                '&:focus, &:visited': {
                    color: item?.color?.default
                },
                '&:active': {
                    color: item?.color?.active ?? undefined,
                    backgroundColor: item?.background?.active ?? undefined
                },
                '&:active [data-item-title]': {
                    color: item?.color?.active ?? undefined
                },
                '&:active [data-item-elem-before]': {
                    color: item?.color?.active ?? undefined
                },
                '&:focus': {
                    boxShadow: item?.color?.active != null ? `${item?.color?.active} 0 0 0 2px inset` : undefined
                },
                '&[aria-current="page"]': {
                    position: 'relative',
                    backgroundColor: item?.background?.active ?? undefined,
                    color: item?.color?.active ?? undefined
                },
                '&[aria-current="page"]:before': {
                    background: item?.color?.active ?? undefined
                },
                '& [data-item-elem-after]': {
                    color: icon?.secondary?.color?.hover ?? undefined
                }
            };
        }
        return {};
    };
});
parcelRegister("jvqf4", function(module, exports) {
    $parcel$export(module.exports, "useOnClick", ()=>$568e03d72b926f2a$export$a81c45382e7253ac);
    var $8zOmE;
    var $95EVP;
    const $568e03d72b926f2a$export$a81c45382e7253ac = ({ analytics: analytics, onClick: onClick } = {})=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        return (event)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'navigationItem'
            });
            if (analytics) (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'sidebar', analytics);
            else (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'sidebar');
            onClick && onClick(event);
        };
    };
});
parcelRegister("3OGaE", function(module, exports) {
    $parcel$export(module.exports, "TitleHeader", ()=>$09f1bcc415909488$export$de3705f3d2162955);
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $2nKsN;
    var $fpoBX;
    var $7ic3S;
    const $09f1bcc415909488$var$overrideStyles = (currentStyles)=>({
            ...currentStyles,
            '[data-item-title]': {
                ...currentStyles['[data-item-title]'],
                whiteSpace: 'normal',
                lineHeight: 'initial'
            }
        });
    const $09f1bcc415909488$export$de3705f3d2162955 = ({ children: children })=>{
        const theme = (0, (0, parcelRequire("fpoBX")).useSidebarTheme)();
        const cssFn = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($basmW)))([
                (0, (0, parcelRequire("7ic3S")).generateCustomThemeCssFn)(theme),
                $09f1bcc415909488$var$overrideStyles
            ]), [
            theme
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2nKsN")).default), {
            cssFn: cssFn
        }, children);
    };
});
parcelRegister("2nKsN", function(module, exports) {
    $parcel$export(module.exports, "Container", ()=>$65f48a85520f2d10$export$42a852a2b6b56249);
    $parcel$export(module.exports, "default", ()=>$65f48a85520f2d10$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $1WrCb;
    var $6nH5y;
    function $65f48a85520f2d10$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $65f48a85520f2d10$var$containerStyles = {
        name: "4bgdod",
        styles: "display:block;position:relative"
    };
    const $65f48a85520f2d10$export$42a852a2b6b56249 = ({ children: children, 'data-testid': testId, ...props })=>{
        const safeProps = (({ className: className, onClick: onClick, onMouseDown: onMouseDown, onDragStart: onDragStart, draggable: draggable, ref: ref, tabIndex: tabIndex, disabled: disabled })=>({
                className: className,
                onClick: onClick,
                onMouseDown: onMouseDown,
                onDragStart: onDragStart,
                draggable: draggable,
                ref: ref,
                tabIndex: tabIndex,
                disabled: disabled
            }))(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            css: $65f48a85520f2d10$var$containerStyles,
            ...safeProps
        }, children);
    };
    const $65f48a85520f2d10$var$Header = (0, $5uXOq.forwardRef)((props, ref)=>{
        const cssFn = (0, (0, parcelRequire("1WrCb")).overrideStyleFunction)(()=>({
                userSelect: 'auto',
                ['[data-item-title]']: {
                    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    color: `var(--ds-text, ${0, $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`
                },
                'div&:hover': {
                    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
                    cursor: 'default'
                },
                'div&:active': {
                    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
                    color: `var(--ds-text, ${0, $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae})`
                }
            }), props.cssFn);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6nH5y")).default), {
            ...props,
            ref: ref,
            component: props.component || $65f48a85520f2d10$export$42a852a2b6b56249,
            cssFn: cssFn,
            overrides: {
                Title: {
                    render: (_, { children: children, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("h2", props, children)
                }
            }
        });
    });
    var $65f48a85520f2d10$export$2e2bcd8739ae039 = $65f48a85520f2d10$var$Header;
});
parcelRegister("7ic3S", function(module, exports) {
    $parcel$export(module.exports, "generateCustomThemeCssFn", ()=>$6cb72e96c74982ff$export$5ae7d20da3003de);
    var $1UikQ = parcelRequire("1UikQ");
    var $ai0LF;
    const $6cb72e96c74982ff$export$5ae7d20da3003de = (theme)=>(0, (0, parcelRequire("ai0LF")).castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
            if (theme?.navigation) {
                const { navigation: { item: item } } = theme;
                const themeStyles = {
                    backgroundColor: item?.background?.default ?? undefined,
                    color: item?.color?.default ?? undefined,
                    '&:hover': {
                        color: item?.color?.hover ?? undefined,
                        backgroundColor: item?.background?.hover ?? undefined
                    },
                    '[data-item-title]': {
                        color: item?.color?.default ?? undefined
                    }
                };
                return (0, ($parcel$interopDefault($1UikQ)))(currentStyles, themeStyles);
            }
            return currentStyles;
        });
});
parcelRegister("ai0LF", function(module, exports) {
    $parcel$export(module.exports, "castRealCSSFnToWronglyTypedCSSFn", ()=>$2bb346e8dcf8bbae$export$3f662b014fa1806e);
    function $2bb346e8dcf8bbae$export$3f662b014fa1806e(fn) {
        return fn;
    }
    function $2bb346e8dcf8bbae$export$17f32e2573d62daa(fn) {
        return fn;
    }
    const $2bb346e8dcf8bbae$export$91011a0a572ef910 = {
        CONNECTED: 'CONNECTED',
        INCOMPLETE: 'INCOMPLETE',
        INITIAL: 'INITIAL',
        SEEN: 'SEEN',
        UNCONNECTED: 'UNCONNECTED'
    };
});
parcelRegister("juTur", function(module, exports) {
    $parcel$export(module.exports, "ContextualAnalyticsData", ()=>$ffb2d49dc0e79e64$export$198470770171c65);
    $parcel$export(module.exports, "IssuesContextualAnalyticsData", ()=>$ffb2d49dc0e79e64$export$bc7f6eebc16e6127);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $iXVV6;
    var $lpwtK;
    var $3d1up;
    const $ffb2d49dc0e79e64$export$198470770171c65 = ({ attributes: attributes, menuId: menuId, stack: stack = [], ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            ...rest,
            attributes: {
                navVersion: '3',
                viewId: (0, (0, parcelRequire("3d1up")).generateViewId)(menuId, ...stack),
                navigationLayer: 'container',
                ...attributes
            }
        });
    const $ffb2d49dc0e79e64$export$bc7f6eebc16e6127 = ({ attributes: attributes, navigatorScope: navigatorScope, useProject: useProject = (0, (0, parcelRequire("lpwtK")).useProject), ...rest })=>{
        const { data: project } = useProject();
        const projectConfig = (project?.isSimplified ? (0, (0, parcelRequire("2vSU6")).ProjectStyle).NEXT_GEN : (0, (0, parcelRequire("2vSU6")).ProjectStyle).CLASSIC) || undefined;
        const projectType = project?.type || undefined;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            ...rest,
            attributes: {
                ...attributes,
                projectConfig: projectConfig,
                projectType: projectType,
                navigatorScope: navigatorScope
            }
        });
    };
});
parcelRegister("3d1up", function(module, exports) {
    $parcel$export(module.exports, "generateViewId", ()=>$2f6f53381b1f04e0$export$5b5545ed894dc47a);
    const $2f6f53381b1f04e0$export$5b5545ed894dc47a = (...ids)=>ids.join('/');
});
parcelRegister("17bH5", function(module, exports) {
    $parcel$export(module.exports, "getSystemNavigationPaths", ()=>$0ac95c37050f315f$export$76c5f80c8d9bdb0e);
    var $4R6GH;
    const $0ac95c37050f315f$export$76c5f80c8d9bdb0e = ()=>({
            generalConfiguration: '/jira/settings/system/general-configuration',
            darkFeatures: '/secure/admin/SiteDarkFeatures!default.jspa',
            issueCollectors: '/secure/admin/ViewGlobalCollectors!default.jspa',
            globalAutomation: '/jira/settings/automation',
            troubleshootingAuditLog: '/auditing/view',
            troubleshootingPluginViewer: '/plugins/servlet/depview/plugins',
            troubleshootingModulesViewer: '/plugins/servlet/depview/modules',
            troubleshootingSystemInfo: '/secure/admin/ViewSystemInfo.jspa',
            troubleshootingIntegrityChecker: '/secure/admin/IntegrityChecker!default.jspa',
            troubleshootingLoggingProfiling: '/secure/admin/ViewLogging.jspa',
            troubleshootingSchedulerDetails: '/secure/admin/SchedulerAdmin.jspa',
            troubleshootingPerformanceAndScale: '/jira/settings/system/performance/overview',
            securityProjectRoles: '/secure/project/ViewProjectRoles.jspa',
            securityGlobalPermissions: (0, (0, parcelRequire("4R6GH")).fg)('olympus-global-permissions-fe-modernisation') ? '/secure/admin/global-permissions' : '/secure/admin/GlobalPermissions!default.jspa',
            userInterfacesUserDefaults: '/secure/admin/ViewUserDefaultSettings.jspa',
            userInterfacesEditDefaultDashboard: '/secure/admin/EditDefaultDashboard!default.jspa',
            userInterfacesLookAndFeel: '/secure/admin/LookAndFeel!default.jspa',
            userInterfacesPasAdmin: '/plugins/servlet/pas/admin',
            userInterfacesSiteAdmin: '/jira/settings/system/ui/announcement-banner',
            importSectionBackupManager: '/secure/admin/CloudExport.jspa',
            importSectionExternalImport: '/secure/admin/ExternalImport1.jspa',
            importSectionExternalImportNew: '/jira/settings/system/external-import',
            importSectionCloudImport: '/secure/admin/CloudImport!start.jspa?source=import_cloud',
            importSectionServerImport: '/secure/admin/CloudImport!start.jspa?source=import_server',
            importSectionMigrateCloud: '/jira/settings/system/migration/home',
            mailSectionGlobalMailSettings: '/secure/admin/GlobalMailSettings.jspa',
            mailSectionOutgoingMail: '/secure/admin/OutgoingMailServers.jspa',
            mailSectionIncomingMail: '/secure/admin/IncomingMailServers.jspa',
            mailSectionSendMail: '/secure/admin/SendBulkMail!default.jspa',
            adminHelperPermissionHelper: '/secure/admin/PermissionHelperAdmin.jspa',
            adminHelperNotificationHelper: '/secure/admin/NotificationHelperAdmin.jspa',
            adminHelperEmailNotificationsLogHelper: '/jira/settings/system/notification-logs',
            sharedSectionManageFilters: '/secure/admin/filters/ViewSharedFilters.jspa',
            sharedManageDashboards: '/secure/admin/dashboards/ViewSharedDashboards.jspa',
            advancedSectionAttachments: '/secure/admin/ViewAttachmentSettings.jspa',
            advancedSectionEvents: '/secure/admin/ListEventTypes.jspa',
            advancedSectionWebHooks: '/plugins/servlet/webhooks',
            advancedSectionServices: '/secure/admin/ViewServices!default.jspa',
            advancedLexoRankManagement: '/secure/GHLexoRankManage.jspa?decorator=admin'
        });
});
parcelRegister("4OCke", function(module, exports) {
    $parcel$export(module.exports, "matchPathname", ()=>$cf3ce1d2a79b8e17$export$b71b01274a8bb9ec);
    $parcel$export(module.exports, "matchUrlPathname", ()=>$cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c);
    $parcel$export(module.exports, "matchPartialUrlPathname", ()=>$cf3ce1d2a79b8e17$export$9870a2fa97808ed7);
    $parcel$export(module.exports, "matchUrlExact", ()=>$cf3ce1d2a79b8e17$export$422d2a799c6e30b8);
    $parcel$export(module.exports, "matchUrlParams", ()=>$cf3ce1d2a79b8e17$export$63fdecce99465869);
    var $f8l56 = parcelRequire("f8l56");
    const $cf3ce1d2a79b8e17$var$cleanPath = (path)=>path.replace('/secure/', '/').replace(/!\w+\.jspa/, '.jspa');
    const $cf3ce1d2a79b8e17$export$b71b01274a8bb9ec = (currentUrlPath, itemUrlPath)=>$cf3ce1d2a79b8e17$var$cleanPath(currentUrlPath) === $cf3ce1d2a79b8e17$var$cleanPath(itemUrlPath);
    const $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c = ()=>(currentLocation, itemLocation)=>$cf3ce1d2a79b8e17$export$b71b01274a8bb9ec(currentLocation.pathname, itemLocation.pathname);
    const $cf3ce1d2a79b8e17$export$9870a2fa97808ed7 = ()=>(currentLocation, itemLocation)=>currentLocation.pathname.includes(itemLocation.pathname);
    const $cf3ce1d2a79b8e17$export$422d2a799c6e30b8 = ()=>(currentLocation, itemLocation)=>$cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c()(currentLocation, itemLocation) && (0, ($parcel$interopDefault($f8l56)))(currentLocation.query, itemLocation.query);
    const $cf3ce1d2a79b8e17$export$63fdecce99465869 = (withParams, withPathname = true)=>(currentLocation, itemLocation)=>(!withPathname || $cf3ce1d2a79b8e17$export$6bfcf8859d3bc51c()(currentLocation, itemLocation)) && withParams.every((p)=>currentLocation.query[p] && currentLocation.query[p] === itemLocation.query[p]);
});
parcelRegister("3tHFY", function(module, exports) {
    $parcel$export(module.exports, "ConnectMenu", ()=>$1b0be5b9936240ae$export$19d0925d424b864a);
    var $5uXOq = parcelRequire("5uXOq");
    var $au6nA;
    var $fh2pW;
    const $1b0be5b9936240ae$export$19d0925d424b864a = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '' })=>{
        const filteredItems = (0, (0, parcelRequire("au6nA")).useFilteredItems)(items || null, shouldFilter);
        if (filteredItems == null || !filteredItems.length) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, filteredItems.map((item, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fh2pW")).ConnectItem), {
                item: item,
                key: item.id,
                index: index,
                overrides: overrides,
                showIcons: showIcons,
                submenuId: submenuId
            })));
    };
});
parcelRegister("au6nA", function(module, exports) {
    $parcel$export(module.exports, "useFilteredItems", ()=>$cb371d7d8e582719$export$79762159776e61da);
    var $5uXOq = parcelRequire("5uXOq");
    var $kvHKs;
    const $cb371d7d8e582719$export$79762159776e61da = (items, shouldFilter = true)=>(0, $5uXOq.useMemo)(()=>{
            if (!shouldFilter) return items || [];
            return items?.filter((item)=>!(0, (0, parcelRequire("kvHKs")).staticLegacyIds).includes(item.id)) || [];
        }, [
            items,
            shouldFilter
        ]);
});
parcelRegister("fh2pW", function(module, exports) {
    $parcel$export(module.exports, "ConnectItem", ()=>$f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dfL30;
    var $cZXEh;
    var $3TzYp;
    var $iUo88;
    var $jjUR3;
    var $hrlU6;
    var $4R6GH;
    var $k0ZZ2;
    var $eYDk7;
    var $3OGaE;
    var $kZj7F;
    var $4OCke;
    const $f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea = ({ index: index, item: item, overrides: overrides, showIcons: showIcons, submenuId: submenuId = '', isNested: isNested = false })=>{
        const { addNew: addNew } = (0, (0, parcelRequire("jjUR3")).useConnectItemClickHistory)();
        const isDialog = item.styleClass && (0, (0, parcelRequire("hrlU6")).isConnectDialogWebItem)(item.styleClass) && (0, (0, parcelRequire("4R6GH")).fg)('blu-4941-connect-webitem-imperative-api');
        const webItemRef = (0, $5uXOq.useRef)(null);
        const BackMenuItem = {
            ...overrides.BackMenuItem,
            onClick: (ev)=>{
                if (submenuId != null) {
                    const cookieData = (0, (0, parcelRequire("3TzYp")).getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
                    let parsedCookieData = null;
                    try {
                        parsedCookieData = JSON.parse(cookieData);
                    } catch  {
                        parsedCookieData = {
                            submenuActive: false,
                            expanded: false
                        };
                    }
                    const newCookieData = {
                        ...parsedCookieData,
                        submenuActive: false
                    };
                    (0, (0, parcelRequire("iUo88")).setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newCookieData));
                }
                if (overrides?.navigateOnBackMenuItemClick !== true) ev.preventDefault();
                overrides.BackMenuItem?.onClick?.(ev);
            }
        };
        const icon = (0, $5uXOq.useMemo)(()=>{
            if (showIcons !== true) return null;
            return item.iconUrl != null && item.iconUrl.trim().length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$var$ConnectIcon, {
                src: item.iconUrl,
                alt: ""
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dfL30"))))), {
                label: ""
            });
        }, [
            showIcons,
            item.iconUrl
        ]);
        const onItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (overrides?.ParentMenuItem?.onClick && isNested) overrides.ParentMenuItem.onClick(event);
            if (isDialog) (0, (0, parcelRequire("hrlU6")).withConnectHost)((connectHost)=>{
                if (webItemRef.current && item.styleClass && item.url) connectHost.triggerWebItem(webItemRef.current, item.styleClass, item.url);
            });
            else item.url != null && addNew(item.url);
        }, [
            addNew,
            isDialog,
            isNested,
            item.styleClass,
            item.url,
            overrides
        ]);
        const onNestedMenuItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (submenuId != null) {
                const cookieData = (0, (0, parcelRequire("3TzYp")).getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
                if (cookieData != null) (0, (0, parcelRequire("iUo88")).setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify({
                    ...JSON.parse(cookieData),
                    submenuActive: true
                }));
            }
            if (overrides?.ParentMenuItem?.onClick) overrides.ParentMenuItem.onClick(event);
            return ()=>null;
        }, [
            overrides,
            submenuId
        ]);
        if (item.section === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), {
            title: item.name,
            hasSeparator: Boolean(index)
        }, (item.items || []).map((si, idx)=>(0, ($parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea, {
                key: si.id,
                item: si,
                overrides: {
                    ...overrides,
                    BackMenuItem: BackMenuItem
                },
                index: idx,
                isNested: isNested
            })));
        if (item.items) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kZj7F")).NestingMenuItem), {
            id: item.id,
            analytics: {
                itemId: item.id
            },
            iconBefore: icon,
            overrides: {
                ...overrides,
                BackMenuItem: BackMenuItem
            },
            title: item.name,
            onClick: onNestedMenuItemClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eYDk7")).NavigationContentWrapper), {
            submenuActive: true,
            nestedMenuOpen: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OGaE")).TitleHeader), null, item.name), (item.items || []).map((si, nestIndex)=>(0, ($parcel$interopDefault($5uXOq))).createElement($f2bd062d7c8c5e44$export$8bb4bcea44a3c9ea, {
                key: si.id,
                item: si,
                index: nestIndex,
                overrides: {
                    ...overrides,
                    BackMenuItem: {
                        href: item.url,
                        title: si.name,
                        onClick: (ev)=>ev.preventDefault()
                    }
                },
                isNested: true
            })))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: item.id
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlExact)(),
            iconBefore: icon,
            href: isDialog ? undefined : item.url,
            legacyClassName: (0, (0, parcelRequire("4R6GH")).fg)('blu-4941-connect-webitem-imperative-api') ? undefined : item.styleClass,
            onClick: onItemClick,
            ref: (0, (0, parcelRequire("4R6GH")).fg)('blu-4941-connect-webitem-imperative-api') ? webItemRef : (0, $5uXOq.createRef)()
        }, item.name);
    };
    const $f2bd062d7c8c5e44$var$ConnectIcon = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbgktf _4t3igktf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iUo88", function(module, exports) {
    $parcel$export(module.exports, "setStrictlyNecessaryCookie", ()=>$89b5b8a4b358ad27$export$93509ff9a62ee022);
    var $GjM2o;
    const $89b5b8a4b358ad27$export$93509ff9a62ee022 = (key, value, attributes)=>{
        (0, (0, parcelRequire("GjM2o")).setStrictlyNecessaryCookie)(key, value, attributes);
    };
});
parcelRegister("GjM2o", function(module, exports) {
    $parcel$export(module.exports, "setStrictlyNecessaryCookie", ()=>$07f3430601091fbe$export$93509ff9a62ee022);
    var $eYli8 = parcelRequire("eYli8");
    var $294ns;
    var $aGNyr;
    var $cala7;
    const $07f3430601091fbe$export$93509ff9a62ee022 = (key, value, attributes)=>{
        try {
            if ((0, (0, parcelRequire("294ns")).fg)('platform.moonjelly.browser-storage-controls')) (0, (0, parcelRequire("aGNyr")).sendPackageOperationalEvent)({
                action: 'usedSetStrictlyNecessaryCookie',
                attributes: {
                    cookieKey: key
                }
            });
            (0, ($parcel$interopDefault($eYli8))).set(key, value, {
                ...attributes,
                'atl-set-cookie': true
            });
        } catch (e) {
            (0, (0, parcelRequire("cala7")).Logger).errorWithOperationalEvent({
                action: 'usedSetStrictlyNecessaryCookieError',
                attributes: {
                    cookieKey: key
                },
                message: `Failed to use set strictly necessary cookie. ${e.message || ''}`
            });
        }
    };
});
parcelRegister("jjUR3", function(module, exports) {
    $parcel$export(module.exports, "useConnectItemClickHistory", ()=>$c499ec49965fe6fe$export$c251e3fda1cce4a3);
    var $5uXOq = parcelRequire("5uXOq");
    const $c499ec49965fe6fe$var$history = {
        unique: []
    };
    const $c499ec49965fe6fe$export$c251e3fda1cce4a3 = ()=>{
        const addNew = (0, $5uXOq.useCallback)((historyItem)=>{
            if (window.location.href.endsWith(historyItem) === false) $c499ec49965fe6fe$var$history.unique.push(historyItem);
        }, []);
        return (0, $5uXOq.useMemo)(()=>({
                history: $c499ec49965fe6fe$var$history,
                addNew: addNew
            }), [
            addNew
        ]);
    };
    const $c499ec49965fe6fe$export$ef04cd58bebb0345 = ()=>{
        $c499ec49965fe6fe$var$history.unique.length = 0;
    };
});
parcelRegister("hrlU6", function(module, exports) {
    $parcel$export(module.exports, "withConnectHost", ()=>$9316db67541b8a94$export$970e2411dd8601c8);
    $parcel$export(module.exports, "getConnectHost", ()=>$9316db67541b8a94$export$186d423c00af146c);
    $parcel$export(module.exports, "isConnectDialogWebItem", ()=>$9316db67541b8a94$export$920fb4b46d4f2eec);
    var $dJZWD;
    const $9316db67541b8a94$export$970e2411dd8601c8 = async (action)=>{
        const connectHost = await (0, (0, parcelRequire("dJZWD")).setupConnectJs)();
        action(connectHost);
    };
    const $9316db67541b8a94$export$186d423c00af146c = ()=>window.connectHost;
    const $9316db67541b8a94$export$920fb4b46d4f2eec = (classes)=>classes.includes('ap-dialog') || classes.includes('ap-inline-dialog');
});
parcelRegister("dJZWD", function(module, exports) {
    $parcel$export(module.exports, "setupConnectJs", ()=>$762ba9fa524ea8e6$export$891414b605e5f038);
    var $6BZYo;
    var $dH9DT;
    const $762ba9fa524ea8e6$var$installConnectJs = async ()=>{
        await (0, (0, parcelRequire("dH9DT")).waitForJQuery)();
        const loader = await (parcelRequire("gRUhY"));
        await loader.performSideEffects();
        return window.connectHost;
    };
    let $762ba9fa524ea8e6$var$installConnectJsPromise = null;
    const $762ba9fa524ea8e6$export$891414b605e5f038 = async ()=>{
        if (window.__SPA__) {
            if ($762ba9fa524ea8e6$var$installConnectJsPromise === null) $762ba9fa524ea8e6$var$installConnectJsPromise = $762ba9fa524ea8e6$var$installConnectJs();
            return $762ba9fa524ea8e6$var$installConnectJsPromise;
        }
        await (0, (0, parcelRequire("6BZYo")).loadBridge)({
            name: 'ac/create',
            wrmKeys: [
                'wrc!com.atlassian.plugins.atlassian-connect-plugin:jira-atlassian-connect-resources-v5',
                'wrc!com.atlassian.jira.jira-atlaskit-plugin:sidebar'
            ]
        });
        return window.connectHost;
    };
});
parcelRegister("6BZYo", function(module, exports) {
    $parcel$export(module.exports, "loadBridge", ()=>$ce95ee3fd66207c7$export$df8409da353bde5a);
    $parcel$export(module.exports, "loadBridgeStrict", ()=>(parcelRequire("7T84i")).loadBridgeStrict);
    var $fqWWz;
    var $3GASE;
    var $ig88W;
    var $7T84i;
    var $9B86Q;
    var $cQZXC;
    var $8JNtu;
    var $5Ik5Y;
    const $ce95ee3fd66207c7$export$df8409da353bde5a = ({ name: name, wrmKeys: wrmKeys, tentatives: tentatives = (0, (0, parcelRequire("fqWWz")).MAX_RETRIES), timeout: timeout = (0, (0, parcelRequire("fqWWz")).DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR) })=>{
        if (wrmKeys != null) return (0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
            name: name,
            wrmKeys: [].concat(wrmKeys),
            shouldLogError: shouldLogError
        });
        if (tentatives <= 0) return Promise.reject(new Error('Unable to load bridge, zero tentatives never works'));
        if (tentatives <= 1) return (0, (0, parcelRequire("3GASE")).loadBridgeBail)({
            name: name,
            shouldLogError: shouldLogError
        });
        return (0, (0, parcelRequire("ig88W")).loadBridgeRace)({
            name: name,
            shouldLogError: shouldLogError,
            timeout: (tentatives - 1) * timeout
        });
    };
});
parcelRegister("fqWWz", function(module, exports) {
    $parcel$export(module.exports, "safeErrorWithoutCustomerData", ()=>$71bf66166926d1dc$export$f19a2d31722e3428);
    $parcel$export(module.exports, "MAX_RETRIES", ()=>$71bf66166926d1dc$export$1f86472c1374185a);
    $parcel$export(module.exports, "DEFAULT_TIMEOUT", ()=>$71bf66166926d1dc$export$7bd623b29ec8e1eb);
    $parcel$export(module.exports, "SHOULD_LOG_ERROR", ()=>$71bf66166926d1dc$export$37f20f0ff732fcd7);
    var $dJl1T;
    const { safeErrorWithoutCustomerData: $71bf66166926d1dc$export$f19a2d31722e3428, safeInfoWithoutCustomerData: $71bf66166926d1dc$export$ea810ce67e3c8eac } = (0, (0, parcelRequire("dJl1T")).default);
    const $71bf66166926d1dc$export$1f86472c1374185a = 40;
    const $71bf66166926d1dc$export$7bd623b29ec8e1eb = 500;
    const $71bf66166926d1dc$export$37f20f0ff732fcd7 = true;
});
parcelRegister("3GASE", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeBail", ()=>$e512b6cc4a8702e5$export$a036f92c2465504e);
    var $wRU6t;
    var $fqWWz;
    const $e512b6cc4a8702e5$export$a036f92c2465504e = async ({ name: name, shouldLogError: shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR) })=>{
        try {
            return window.require(name);
        } catch (error) {
            if (shouldLogError) (0, (0, parcelRequire("fqWWz")).safeErrorWithoutCustomerData)('common.bridge', `Unable to load bridge "${name}". ${(0, (0, parcelRequire("wRU6t")).safeStringify)(error) ?? ''}`, {
                isSpa: __SPA__,
                name: name,
                error: (0, (0, parcelRequire("wRU6t")).safeStringify)(error)
            });
            throw new Error(`Unable to load bridge "${name}"`, {
                cause: error
            });
        }
    };
});
parcelRegister("wRU6t", function(module, exports) {
    $parcel$export(module.exports, "safeStringify", ()=>$7e2bd894031d4476$export$56831a8b9cb27763);
    const $7e2bd894031d4476$export$56831a8b9cb27763 = (object)=>{
        if (!object) return '';
        if (object instanceof Error) return object.stack || object.message;
        return JSON.stringify(object, Object.getOwnPropertyNames(object));
    };
});
parcelRegister("ig88W", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeRace", ()=>$64f1dbae1ea314ee$export$20c32b4579d78b92);
    var $3GASE;
    var $9B86Q;
    var $fqWWz;
    const $64f1dbae1ea314ee$export$20c32b4579d78b92 = ({ name: name, timeout: timeout = (0, (0, parcelRequire("fqWWz")).DEFAULT_TIMEOUT), shouldLogError: shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR) })=>Promise.race([
            (0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: name
            }),
            new Promise((resolve)=>setTimeout(resolve, timeout)).then(()=>(0, (0, parcelRequire("3GASE")).loadBridgeBail)({
                    name: name,
                    shouldLogError: shouldLogError
                }))
        ]);
});
parcelRegister("9B86Q", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeWeak", ()=>$61b2a5aa3a2a1160$export$3cefda82396756a1);
    var $ifVVd;
    let $61b2a5aa3a2a1160$var$pollingSingleton = null;
    const $61b2a5aa3a2a1160$export$3cefda82396756a1 = ({ name: name })=>{
        const getter = $61b2a5aa3a2a1160$var$pollingSingleton ?? (0, (0, parcelRequire("ifVVd")).createPollingCollection)((v)=>window.require(v), 100);
        $61b2a5aa3a2a1160$var$pollingSingleton = getter;
        return getter(name);
    };
});
parcelRegister("ifVVd", function(module, exports) {
    $parcel$export(module.exports, "createPollingCollection", ()=>$60e6b0d4bc46beac$export$f163446a982a8077);
    var $gKZoD;
    var $aePFs;
    const $60e6b0d4bc46beac$export$f163446a982a8077 = (fn, timeout)=>{
        (0, (0, parcelRequire("gKZoD")).di)(setTimeout);
        let isPolling = false;
        const deferredMap = new Map();
        const promiseMap = new Map();
        const evaluateForKey = (key)=>{
            let result;
            try {
                result = fn(key);
            } catch (error) {
                return;
            }
            const deferred = deferredMap.get(key);
            if (deferred instanceof (0, (0, parcelRequire("aePFs")).default)) {
                deferred.resolve(result);
                deferredMap.delete(key);
            }
        };
        const maybePoll = ()=>{
            if (!isPolling && deferredMap.size > 0) {
                isPolling = true;
                setTimeout(()=>{
                    isPolling = false;
                    [
                        ...deferredMap.keys()
                    ].forEach(evaluateForKey);
                    maybePoll();
                }, timeout);
            }
        };
        const getter = (key)=>{
            if (!promiseMap.has(key)) {
                const deferred = new (0, (0, parcelRequire("aePFs")).default)();
                const promise = deferred.then((v)=>v);
                deferredMap.set(key, deferred);
                promiseMap.set(key, promise);
                evaluateForKey(key);
                maybePoll();
            }
            return promiseMap.get(key);
        };
        return getter;
    };
});
parcelRegister("aePFs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$02f3c6551bf5b1ff$export$2e2bcd8739ae039);
    class $02f3c6551bf5b1ff$export$2e2bcd8739ae039 extends Promise {
        static resolve(v) {
            const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
            instance.resolve(v);
            return instance;
        }
        static reject(e) {
            const instance = new $02f3c6551bf5b1ff$export$2e2bcd8739ae039();
            instance.reject(e);
            return instance;
        }
        constructor(){
            const [fn] = Array.prototype.slice.call(arguments);
            const callbacks = [];
            super(fn ?? callbacks.push.bind(callbacks));
            this.#resolve = callbacks[0];
            this.#reject = callbacks[1];
        }
        #resolve;
        #reject;
        resolve(v) {
            this.#resolve?.(v);
        }
        reject(e) {
            this.#reject?.(e);
        }
    }
});
parcelRegister("7T84i", function(module, exports) {
    $parcel$export(module.exports, "loadBridgeStrict", ()=>$89a95eb8b151782d$export$eba600d28decc4ac);
    var $c56lL;
    var $ig88W;
    var $fVOHM;
    var $fqWWz;
    const $89a95eb8b151782d$export$eba600d28decc4ac = async ({ name: name, wrmKeys: wrmKeys, shouldLogError: shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR) })=>{
        (0, (0, parcelRequire("c56lL")).saveStats)(name, wrmKeys);
        try {
            return window.require(name);
        } catch (error) {
            await (0, (0, parcelRequire("fVOHM")).loadWrmResources)({
                wrmKeys: wrmKeys,
                shouldLogError: shouldLogError
            });
            return (0, (0, parcelRequire("ig88W")).loadBridgeRace)({
                name: name,
                shouldLogError: shouldLogError
            });
        }
    };
});
parcelRegister("c56lL", function(module, exports) {
    $parcel$export(module.exports, "saveStats", ()=>$6c875a5034ae8433$export$9ea3ff7978093559);
    const $6c875a5034ae8433$var$incrementResourceStats = (resource, stats)=>{
        if (stats[resource] == null) stats[resource] = 1;
        else stats[resource] += 1;
    };
    const $6c875a5034ae8433$var$getEmptyLoadBridgeStats = ()=>({
            requests: 0,
            amdModules: {},
            wrmKeys: {}
        });
    const $6c875a5034ae8433$var$initStats = ()=>{
        if (window.__WRM_INTERNAL_STATS__ == null) window.__WRM_INTERNAL_STATS__ = {
            loadBridge: $6c875a5034ae8433$var$getEmptyLoadBridgeStats()
        };
        else if (window.__WRM_INTERNAL_STATS__.loadBridge == null) window.__WRM_INTERNAL_STATS__.loadBridge = $6c875a5034ae8433$var$getEmptyLoadBridgeStats();
        return window.__WRM_INTERNAL_STATS__.loadBridge;
    };
    const $6c875a5034ae8433$var$isPageInteractive = ()=>window.__WRM_INTERNAL_STATS__?.isPageInteractive;
    const $6c875a5034ae8433$export$9ea3ff7978093559 = (amdModuleName, wrmKeys)=>{
        try {
            const stats = $6c875a5034ae8433$var$initStats();
            if ($6c875a5034ae8433$var$isPageInteractive()) return;
            stats.requests += 1;
            $6c875a5034ae8433$var$incrementResourceStats(amdModuleName, stats.amdModules);
            if (Array.isArray(wrmKeys)) wrmKeys.forEach((wrmKey)=>$6c875a5034ae8433$var$incrementResourceStats(wrmKey, stats.wrmKeys));
            else if (wrmKeys != null) $6c875a5034ae8433$var$incrementResourceStats(wrmKeys, stats.wrmKeys);
        } catch (e) {}
    };
});
parcelRegister("fVOHM", function(module, exports) {
    $parcel$export(module.exports, "loadWrmResources", ()=>$0c0552c7bb135144$export$6cda16b6eff75f59);
    var $wRU6t;
    var $294PS;
    var $9B86Q;
    var $fqWWz;
    const $0c0552c7bb135144$export$6cda16b6eff75f59 = async ({ wrmKeys: wrmKeys, shouldLogError: shouldLogError, ...options })=>{
        const isPrefetch = 'batchUrl' in options;
        let newWrmKeys = wrmKeys;
        try {
            const name = isPrefetch ? 'wrm/require-v2' : 'wrm/require';
            const wrmRequireModule = await (0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: name
            });
            const wrmRequire = isPrefetch ? wrmRequireModule.requireWithPrefetch : wrmRequireModule;
            newWrmKeys = (0, (0, parcelRequire("294PS")).prependSuperBatchDepsOnce)(wrmKeys);
            if (isPrefetch) return await new Promise((resolve, reject)=>wrmRequire(newWrmKeys, options.batchUrl)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
            return await new Promise((resolve, reject)=>wrmRequire(newWrmKeys)?.then?.(resolve, reject) ?? reject(new Error('wrmRequire returned non-Deferred result')));
        } catch (error) {
            if (shouldLogError) (0, (0, parcelRequire("fqWWz")).safeErrorWithoutCustomerData)('common.bridge.wrm', 'Unable to load wrm resource', {
                isSpa: __SPA__,
                wrmKeys: JSON.stringify(newWrmKeys),
                error: (0, (0, parcelRequire("wRU6t")).safeStringify)(error)
            });
            throw new Error('Unable to load wrm resource', {
                cause: error
            });
        }
    };
});
parcelRegister("294PS", function(module, exports) {
    $parcel$export(module.exports, "prependSuperBatchDepsOnce", ()=>$a437264dd6b89021$export$93d9db5fbabad1b0);
    var $1r4rO;
    let $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = false;
    const $a437264dd6b89021$var$isOnRapidBoardsPage = ()=>{
        const boardsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*[/]?$/;
        const backlogsRegex = /\/jira\/software\/c\/projects\/[A-Za-z0-9]{1,10}\/boards\/[0-9]*\/backlog[/]?$/;
        const { pathname: pathname } = window.location;
        return boardsRegex.test(pathname) || backlogsRegex.test(pathname) || window.location.href.includes('secure/RapidBoard.jspa');
    };
    const $a437264dd6b89021$export$93d9db5fbabad1b0 = (wrmKeys)=>{
        if ($a437264dd6b89021$var$isSuperBatchDependenciesLoaded || $a437264dd6b89021$var$isOnRapidBoardsPage()) return wrmKeys;
        $a437264dd6b89021$var$isSuperBatchDependenciesLoaded = true;
        return (0, (0, parcelRequire("1r4rO")).jiraSuperBatchDependencies).concat(wrmKeys);
    };
});
parcelRegister("1r4rO", function(module, exports) {
    $parcel$export(module.exports, "jiraSuperBatchDependencies", ()=>$e87d6a02e2466ae8$export$f14a6b583ce9e077);
    const $e87d6a02e2466ae8$export$f14a6b583ce9e077 = [
        'wrc!jira.webresources:skate',
        'wrc!jira.webresources:util-lite',
        'wrc!jira.webresources:util',
        'wrc!jira.webresources:feature-flags',
        'wrc!jira.webresources:dialogs',
        'wrc!jira.webresources:jira-global',
        'wrc!com.atlassian.auiplugin:aui-spinner'
    ];
});
parcelRegister("cQZXC", function(module, exports) {
    $parcel$export(module.exports, "waitForHeritage", ()=>$90def0f7a7aa11d6$export$c61060338d026f78);
    var $aePFs;
    const $90def0f7a7aa11d6$export$c61060338d026f78 = ()=>{
        if (false) return null;
        if (!__SPA__) return Promise.resolve();
        if (!window.__WAIT_FOR_HERITAGE__) window.__WAIT_FOR_HERITAGE__ = new (0, (0, parcelRequire("aePFs")).default)();
        return window.__WAIT_FOR_HERITAGE__;
    };
});
parcelRegister("8JNtu", function(module, exports) {
    $parcel$export(module.exports, "wrmRequire", ()=>$17e2d7d864398bad$export$cc9d8f51375ef66a);
    var $fVOHM;
    var $fqWWz;
    const $17e2d7d864398bad$export$cc9d8f51375ef66a = async (wrmKeys, shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR))=>(0, (0, parcelRequire("fVOHM")).loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError
        });
});
parcelRegister("5Ik5Y", function(module, exports) {
    $parcel$export(module.exports, "wrmRequireWithPrefetch", ()=>$a1df1daee76d40f7$export$e53a5db19a39ed2f);
    var $fVOHM;
    var $fqWWz;
    const $a1df1daee76d40f7$export$e53a5db19a39ed2f = async (wrmKeys, batchUrl, shouldLogError = (0, (0, parcelRequire("fqWWz")).SHOULD_LOG_ERROR))=>(0, (0, parcelRequire("fVOHM")).loadWrmResources)({
            wrmKeys: wrmKeys,
            shouldLogError: shouldLogError,
            batchUrl: batchUrl
        });
});
parcelRegister("dH9DT", function(module, exports) {
    $parcel$export(module.exports, "getMeta", ()=>$a78c52ec7ed5d025$export$c47913ca32a5c6f7);
    $parcel$export(module.exports, "getJQuery", ()=>$a78c52ec7ed5d025$export$7232a6dc780f9887);
    $parcel$export(module.exports, "getGlobalAP", ()=>$a78c52ec7ed5d025$export$fbc82125a6bd8012);
    $parcel$export(module.exports, "isObject", ()=>$a78c52ec7ed5d025$export$a6cdc56e425d0d0a);
    $parcel$export(module.exports, "escapeSelector", ()=>$a78c52ec7ed5d025$export$c8c0ea01c118c2eb);
    $parcel$export(module.exports, "waitForJQuery", ()=>$a78c52ec7ed5d025$export$97214de9c546981c);
    $parcel$export(module.exports, "ErrorDebugAddonKeys", ()=>$a78c52ec7ed5d025$export$d690da9bc8146677);
    var $jcw0u;
    const $a78c52ec7ed5d025$export$c47913ca32a5c6f7 = (key)=>{
        const metaTag = document.querySelector(`meta[name='ajs-${key}']`);
        return metaTag === null ? undefined : metaTag.getAttribute('content') || undefined;
    };
    const $a78c52ec7ed5d025$export$7232a6dc780f9887 = ()=>AJS.$;
    const $a78c52ec7ed5d025$export$fbc82125a6bd8012 = ()=>window._AP;
    const $a78c52ec7ed5d025$export$a6cdc56e425d0d0a = (obj)=>typeof obj === 'function' || typeof obj === 'object' && !!obj;
    const $a78c52ec7ed5d025$export$c8c0ea01c118c2eb = (s)=>{
        if (!s) throw new Error('No selector to escape');
        return s.replace(/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g, '\\$&');
    };
    const $a78c52ec7ed5d025$var$FIVE_MINUTES = 300000;
    const $a78c52ec7ed5d025$export$97214de9c546981c = ()=>new Promise((resolve, reject)=>{
            const interval = setInterval(()=>{
                if (window.AJS?.$) {
                    clearInterval(interval);
                    resolve();
                }
            }, 10);
            setTimeout(()=>{
                clearInterval(interval);
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'connect-jquery-timeout',
                        packageName: 'jiraConnect'
                    },
                    error: new Error('Timeout when waiting for jQuery to be available on the page'),
                    skipSentry: true
                });
                reject();
            }, $a78c52ec7ed5d025$var$FIVE_MINUTES);
        });
    const $a78c52ec7ed5d025$export$7315c38dc71bd41f = 'com.atlassian.servicedesk.embedded-dev';
    const $a78c52ec7ed5d025$export$cb954c21735b28e4 = 'com.atlassian.servicedesk.embedded';
    const $a78c52ec7ed5d025$export$d690da9bc8146677 = [
        $a78c52ec7ed5d025$export$cb954c21735b28e4,
        $a78c52ec7ed5d025$export$7315c38dc71bd41f
    ];
});
parcelRegister("gRUhY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aVR4N").then(()=>parcelRequire('8vJyT'));
});
parcelRegister("eYDk7", function(module, exports) {
    $parcel$export(module.exports, "NavigationHeaderWrapper", ()=>$eea5dc8ebf00d36e$export$bae9b35e967353d5);
    $parcel$export(module.exports, "NavigationExpandableContentWrapper", ()=>$eea5dc8ebf00d36e$export$4e88508e6904469e);
    $parcel$export(module.exports, "NavigationContentWrapper", ()=>$eea5dc8ebf00d36e$export$e7d691a5a9258e1b);
    $parcel$export(module.exports, "NextGenIssueTypesWrapper", ()=>$eea5dc8ebf00d36e$export$f094f7aad76e4268);
    $parcel$export(module.exports, "ExpandableProjectSettingsWrapper", ()=>$eea5dc8ebf00d36e$export$e38bb288d890ec2f);
    $parcel$export(module.exports, "ShortCutsAndAppsWrapper", ()=>$eea5dc8ebf00d36e$export$337add4342ee7986);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $gwIPs;
    const $eea5dc8ebf00d36e$export$bae9b35e967353d5 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationHeaderWrapperContainer, null, props.children);
    const $eea5dc8ebf00d36e$export$4e88508e6904469e = (props)=>{
        const { nestedAppOpen: nestedAppOpen, submenuActive: submenuActive, children: children } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationExpandableContentWrapperContainer, {
            nestedAppOpen: nestedAppOpen,
            submenuActive: submenuActive
        }, children);
    };
    const $eea5dc8ebf00d36e$export$e7d691a5a9258e1b = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NavigationContentWrapperContainer, {
            navModuleLabelsHidden: props.navModuleLabelsHidden,
            nestedAppOpen: props.nestedAppOpen,
            context: props.context,
            submenuActive: props.submenuActive,
            nestedMenuOpen: props.nestedMenuOpen,
            "data-component-selector": "NavigationContentWrapperContainer"
        }, props.children);
    const $eea5dc8ebf00d36e$export$f094f7aad76e4268 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$NextGenIssueTypesWrapperContainer, null, props.children);
    const $eea5dc8ebf00d36e$export$e38bb288d890ec2f = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$ExpandableProjectContainer, null, props.children);
    const $eea5dc8ebf00d36e$export$337add4342ee7986 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($eea5dc8ebf00d36e$var$ShortCutsAndAppsContainer, null, props.children);
    const $eea5dc8ebf00d36e$var$NavigationHeaderWrapperContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc _1s541012 _1lfu1012",
                __cmplp.className
            ])
        });
    });
    const $eea5dc8ebf00d36e$var$NavigationExpandableContentWrapperContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { submenuActive: submenuActive, nestedAppOpen: nestedAppOpen, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_ykp9lh": (0, (0, parcelRequire("lD23V")).default)(__cmplp.nestedAppOpen ? 'auto' : '100%'),
                "--_1qrlsbv": (0, (0, parcelRequire("lD23V")).default)(Math.round((0, (0, parcelRequire("gwIPs")).borderRadius) * 1.333), "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0u2gc _1q1o54a6 _1dul54a6 _ofxb54a6 _179m54a6 _vnu9l52n _19iyl52n _t6kll52n _shi3l52n _15sk1v6z _178k1v6z _18pc1v6z _1bc71v6z _yugv5oil _83u65oil _1ern5oil _rjkj5oil",
                __cmplp.submenuActive && "_4t3i1qw7",
                __cmplp.submenuActive ? "_bq2uyjp0 _1n80yjp0 _di7gyjp0 _1lozyjp0" : "_bq2u1d7o _1n801d7o _di7g1d7o _1loz1d7o",
                __cmplp.className
            ])
        });
    });
    const $eea5dc8ebf00d36e$var$NavigationContentWrapperContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { submenuActive: submenuActive, nestedMenuOpen: nestedMenuOpen, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_6w8gix": (0, (0, parcelRequire("lD23V")).default)(__cmplp.nestedMenuOpen ? 0 : 7.5 * (0, (0, parcelRequire("gwIPs")).gridSize), "px"),
                "--_1qrlsbv": (0, (0, parcelRequire("lD23V")).default)(Math.round((0, (0, parcelRequire("gwIPs")).borderRadius) * 1.333), "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_yugv5oil _83u65oil _1ern5oil _rjkj5oil",
                __cmplp.submenuActive ? "_4t3iu4z3" : "_4t3i1wug",
                __cmplp.submenuActive ? "_vnu91tcg _19iy1tcg _t6kl1tcg _shi31tcg" : "_vnu9l52n _19iyl52n _t6kll52n _shi3l52n",
                __cmplp.nestedMenuOpen && "_1reo1wug _18m91wug _14tk183y",
                __cmplp.className
            ])
        });
    });
    const $eea5dc8ebf00d36e$var$NextGenIssueTypesWrapperContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _vpnr1ejb _14tk72c6 _cb62utpp _1wtp1txs _l9o61txs _f6zi1txs",
                __cmplp.className
            ])
        });
    });
    const $eea5dc8ebf00d36e$var$ExpandableProjectContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wtppxbi _df5vpxbi",
                __cmplp.className
            ])
        });
    });
    const $eea5dc8ebf00d36e$var$ShortCutsAndAppsContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _14tk72c6 _t3zc183y _1so4jjyb _1thc1skh _a6avqslr _dnyv1skh",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kZj7F", function(module, exports) {
    $parcel$export(module.exports, "NestingMenuItem", ()=>$2fbfde7c900477f4$export$4c594f24f8e4128a);
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $1UikQ = parcelRequire("1UikQ");
    var $jEqto;
    var $bk7sl;
    var $5Hj3V;
    var $k0ZZ2;
    var $hg4VT;
    var $kZ5sr;
    var $fpoBX;
    var $ai0LF;
    var $kavsL;
    const $2fbfde7c900477f4$var$customCssFn = (0, (0, parcelRequire("ai0LF")).castRealCSSFnToWronglyTypedCSSFn)((currentStateAndStyles)=>{
        const activeColor = typeof currentStateAndStyles['&:active'] === 'object' ? `${currentStateAndStyles['&:active'].color} !important` : 'inherit';
        const baseColor = typeof currentStateAndStyles['&:hover'] === 'object' ? currentStateAndStyles['&:hover'].color : 'inherit';
        const newStyle = {
            ...(0, (0, parcelRequire("kZ5sr")).cssFn)(currentStateAndStyles),
            '&:visited, &:focus, &:active': {
                textDecoration: 'inherit',
                outline: 0
            },
            '&:active': {
                color: activeColor
            },
            '&:visited, &:focus': {
                color: baseColor
            },
            '& [data-item-title]': {
                color: baseColor
            }
        };
        return (0, ($parcel$interopDefault($1UikQ)))(currentStateAndStyles, newStyle);
    });
    const $2fbfde7c900477f4$var$WrappingLinkComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement("a", props, props.children);
    const $2fbfde7c900477f4$export$4c594f24f8e4128a = (0, $5uXOq.forwardRef)(({ children: children, id: id, reloadOnNavigationToNesting: reloadOnNavigationToNesting, overrides: overrides = {}, title: title, ...rest }, ref)=>{
        const theme = (0, (0, parcelRequire("fpoBX")).useSidebarTheme)();
        const backButtonCssFn = (0, (0, parcelRequire("hg4VT")).generateBackButtonCssFn)(theme);
        const { BackMenuItem: BackMenuItem = {} } = overrides;
        const { title: backTitle = 'Back', wrapper: WrapperComponent = (0, $5uXOq.Fragment), ...backItemProps } = BackMenuItem;
        const renderBackItem = (0, $5uXOq.useCallback)(({ onClick: onClick })=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrapperComponent, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
                ...backItemProps,
                analytics: {
                    itemId: 'back'
                },
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jEqto"))))), {
                    label: ""
                }),
                onClick: (ev)=>{
                    if ((0, (0, parcelRequire("kavsL")).isNormalClick)(ev)) {
                        onClick();
                        backItemProps.onClick?.(ev);
                    }
                },
                cssFn: backButtonCssFn
            }, backTitle)), [
            WrapperComponent,
            backItemProps,
            backButtonCssFn,
            backTitle
        ]);
        const renderCustomItem = (0, $5uXOq.useCallback)(({ children: itemTitle, onClick: onClick, cssFn: customItemCssFn, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bk7sl")).default), {
                ...props,
                id: id,
                component: reloadOnNavigationToNesting ? $2fbfde7c900477f4$var$WrappingLinkComponent : props.component,
                onClick: (ev)=>{
                    if (props.isSelected === true) ev.preventDefault();
                    onClick && onClick(ev);
                },
                overrides: {
                    GoBackItem: {
                        render: renderBackItem
                    }
                },
                title: itemTitle,
                cssFn: customItemCssFn ? (0, ($parcel$interopDefault($basmW)))([
                    customItemCssFn,
                    $2fbfde7c900477f4$var$customCssFn
                ]) : $2fbfde7c900477f4$var$customCssFn
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Hj3V")).SidebarErrorBoundary), {
                id: `${id}Nesting`,
                packageName: "jiraSpaAppsSidebarCommon"
            }, children)), [
            children,
            id,
            reloadOnNavigationToNesting,
            renderBackItem
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            ...rest,
            ref: ref,
            overrides: {
                CustomItem: {
                    render: renderCustomItem
                }
            }
        }, title);
    });
});
parcelRegister("hg4VT", function(module, exports) {
    $parcel$export(module.exports, "generateBackButtonCssFn", ()=>$1e5fb9a53caeb1aa$export$56644251c3f2ea82);
    const $1e5fb9a53caeb1aa$export$56644251c3f2ea82 = (theme)=>()=>{
            if (theme?.navigation) {
                const { icon: icon } = theme.navigation;
                return {
                    '& [data-item-elem-before], &:active span[data-item-elem-before]': {
                        color: icon?.secondary?.color?.active ?? undefined
                    }
                };
            }
            return {};
        };
});
parcelRegister("kZ5sr", function(module, exports) {
    $parcel$export(module.exports, "cssFn", ()=>$399c9dca906145c0$export$d722961e96b459c5);
    var $1UikQ = parcelRequire("1UikQ");
    var $gwIPs;
    var $ai0LF;
    const $399c9dca906145c0$export$d722961e96b459c5 = (0, (0, parcelRequire("ai0LF")).castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
        const newStyle = {
            '[data-item-elem-after] [data-right-arrow]': {
                display: 'none'
            },
            '&:hover [data-item-elem-after]': {
                '& > :not([data-right-arrow])': {
                    display: 'none'
                },
                '& [data-right-arrow]': {
                    display: 'flex'
                }
            },
            height: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 5.5}px`
        };
        return (0, ($parcel$interopDefault($1UikQ)))(currentStyles, newStyle);
    });
});
parcelRegister("kavsL", function(module, exports) {
    $parcel$export(module.exports, "isNormalClick", ()=>$e059487e30c8155a$export$729f3684d5c2b9b9);
    const $e059487e30c8155a$export$729f3684d5c2b9b9 = (e)=>!('button' in e && e.button || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
});
parcelRegister("eaZ4X", function(module, exports) {
    $parcel$export(module.exports, "SECTION_ID", ()=>$b36275c07d465a0e$export$501955bd67991a25);
    const $b36275c07d465a0e$export$501955bd67991a25 = {
        MIGRATE_TO_CLOUD_SITE: 'migrate-to-cloud-site',
        PERFORMANCE_AND_SCALE: 'performance-and-scale'
    };
});
parcelRegister("jMBA3", function(module, exports) {
    $parcel$export(module.exports, "useFeatures", ()=>$4023bf6b28a8dc58$export$4a39035bacc4ed76);
    $parcel$export(module.exports, "useGlobalSettingsSystemConnectItems", ()=>$4023bf6b28a8dc58$export$f601efaceb0636f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $aUDLa;
    var $7OqB4;
    var $awp39;
    var $9OXo1;
    var $gJkov;
    const $4023bf6b28a8dc58$export$4a39035bacc4ed76 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)(()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("aUDLa")).useNavigationGlobalResource)();
        const { isDevMode: isDevMode, isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const extractedData = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("gJkov")).extractData)(data, isDevMode, isAdmin, isSiteAdmin), [
            data,
            isDevMode,
            isAdmin,
            isSiteAdmin
        ]);
        return {
            data: extractedData,
            loading: loading,
            error: error
        };
    });
    const $4023bf6b28a8dc58$export$f601efaceb0636f4 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("awp39")).useGlobalSettingsSystemConnectItems));
});
parcelRegister("7OqB4", function(module, exports) {
    $parcel$export(module.exports, "withThrowOnError", ()=>$f0eadb98e9fdd0d1$export$a018832f2ec4dc91);
    var $gKZoD;
    const $f0eadb98e9fdd0d1$var$isDataEmpty = (data)=>data == null;
    function $f0eadb98e9fdd0d1$export$a018832f2ec4dc91(theHook) {
        return (...args)=>{
            (0, (0, parcelRequire("gKZoD")).di)(theHook);
            const result = theHook(...args);
            if (!false && $f0eadb98e9fdd0d1$var$isDataEmpty(result.data) && !result.loading && result.error) throw result.error;
            return result;
        };
    }
});
parcelRegister("gJkov", function(module, exports) {
    $parcel$export(module.exports, "extractData", ()=>$63e1d07edc3ef769$export$9df5fa0a366163d2);
    var $1WqFo;
    var $co1wz;
    var $83mn0;
    const $63e1d07edc3ef769$export$9df5fa0a366163d2 = (data, isDevMode, isAdmin, isSiteAdmin)=>({
            hasGeneralConfiguration: isAdmin,
            hasDarkFeatures: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'dark_features'),
            hasTroubleshootingAndSupportSection: isAdmin,
            hasViewAuditing: isAdmin,
            hasPluginViewer: isDevMode && isAdmin,
            hasModulesViewer: isDevMode && isAdmin,
            hasSystemInfo: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'system_info'),
            hasIntegrityChecker: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'integrity_checker'),
            hasLoggingProfiling: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'logging_profiling'),
            hasSchedulerDetails: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'scheduler_details'),
            hasSecuritySection: isAdmin,
            hasProjectRoles: isAdmin,
            hasGlobalPermissions: isAdmin,
            hasCollectors: isAdmin,
            hasUserInterfaceSection: isAdmin,
            hasUserDefaults: isAdmin,
            hasEditDefaultDashboard: isAdmin,
            hasLookAndFeel: isAdmin,
            hasPasAdmin: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'com.atlassian.pas:pas-admin-link-jira'),
            hasImportExportSection: isAdmin,
            hasBackupManager: isAdmin,
            hasExternalImport: isAdmin,
            hasRestoreSystem: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'vertigo_import'),
            hasCloudImport: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'vertigo_import_jira_cloud'),
            hasServerImport: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'vertigo_import_jira_server'),
            hasC2CMigration: isSiteAdmin && (0, (0, parcelRequire("co1wz")).ff)('jira-system-settings-cloud-to-cloud-migration') && !(0, (0, parcelRequire("1WqFo")).isFedRamp)(),
            hasMailSection: isAdmin,
            hasGlobalMailSettings: isAdmin,
            hasOutgoingMail: isAdmin,
            hasIncomingMail: isAdmin,
            hasSendMail: isAdmin,
            hasAdminHelperSection: isAdmin,
            hasPermissionHelper: isAdmin,
            hasNotificationHelper: isAdmin && !(0, (0, parcelRequire("co1wz")).ff)('sea-1973-notifications-hub'),
            hasSharedSection: isAdmin,
            hasManageDashboards: isAdmin,
            hasManageFilters: isAdmin,
            hasEmailNotificationsLogHelper: (0, (0, parcelRequire("co1wz")).ff)('platform.jlove-pulsar.jlovep-423-jsw-notification-logs-ui'),
            hasAdvancedSection: isAdmin,
            hasAttachments: isAdmin,
            hasEvents: isAdmin,
            hasWebHooks: isAdmin,
            hasServices: isAdmin,
            hasLexoRankManagement: (0, (0, parcelRequire("83mn0")).hasItemInSidebar)(data, 'greenhopper-lexorank-manage')
        });
});
parcelRegister("aVTmi", function(module, exports) {
    $parcel$export(module.exports, "AdminHelperSection", ()=>$f6a1ba8c0486741e$export$4855b2d78f0d666a);
    var $5uXOq = parcelRequire("5uXOq");
    var $9ARNv;
    var $47htk;
    var $6T4rd;
    var $jJ1Sb;
    var $cZXEh;
    var $5tOuG;
    var $co1wz;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $4OCke;
    var $jMBA3;
    var $3B8mV;
    const $f6a1ba8c0486741e$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY = 'blocking-invitations-log-spotlight';
    const $f6a1ba8c0486741e$export$4855b2d78f0d666a = ()=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), {
            title: formatMessage((0, (0, parcelRequire("3B8mV")).default).adminHelper)
        }, features.hasPermissionHelper && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'permission-helper'
            },
            href: navigationPath.adminHelperPermissionHelper,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("3B8mV")).default).permissionHelper)), features.hasNotificationHelper && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'notification-helper'
            },
            href: navigationPath.adminHelperNotificationHelper,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("3B8mV")).default).notificationHelper)), features.hasEmailNotificationsLogHelper && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("47htk")).default), {
            name: $f6a1ba8c0486741e$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'email-notifications-log'
            },
            href: navigationPath.adminHelperEmailNotificationsLogHelper,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $f6a1ba8c0486741e$var$emailNotificationsLogContainerStyles
        }, (0, (0, parcelRequire("co1wz")).ff)('platform.jlove-pulsar.jlovep-1538-notification-email-log-filters_4p0s1') ? formatMessage((0, (0, parcelRequire("3B8mV")).default).adminEmailAuditNotificationsLog) : formatMessage((0, (0, parcelRequire("3B8mV")).default).emailNotificationsLog))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9ARNv")).EngagementSpotlight), {
            engagementId: $f6a1ba8c0486741e$var$BLOCKING_INVITATIONS_LOG_SPOTLIGHT_KEY
        })));
    };
    const $f6a1ba8c0486741e$var$emailNotificationsLogContainerStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        display: 'flex',
        justifyContent: 'space-between'
    });
});
parcelRegister("3B8mV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82b0a510e0e13823$export$2e2bcd8739ae039);
    var $7VHMR;
    var $82b0a510e0e13823$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        adminHelper: {
            "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.admin-helper",
            "defaultMessage": "Admin helper"
        },
        permissionHelper: {
            "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.permission-helper",
            "defaultMessage": "Permission helper"
        },
        notificationHelper: {
            "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.notification-helper",
            "defaultMessage": "Notification helper"
        },
        emailNotificationsLog: {
            "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.email-notifications-log",
            "defaultMessage": "Unblock user invites"
        },
        adminEmailAuditNotificationsLog: {
            "id": "spa-apps-sidebar-global-settings-system.menu.admin-helper.admin-email-audit-notifications-log",
            "defaultMessage": "Admin email audit"
        }
    });
});
parcelRegister("cip1u", function(module, exports) {
    $parcel$export(module.exports, "AdvancedSection", ()=>$55fa8f6cf375a533$export$32bea920eaad7efb);
    var $5uXOq = parcelRequire("5uXOq");
    var $cZXEh;
    var $5tOuG;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $4OCke;
    var $jMBA3;
    var $68MUk;
    const $55fa8f6cf375a533$export$32bea920eaad7efb = ()=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), {
            title: formatMessage((0, (0, parcelRequire("68MUk")).default).advanced)
        }, features.hasAttachments && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'attachments'
            },
            href: navigationPath.advancedSectionAttachments,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("68MUk")).default).attachments)), features.hasEvents && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'events'
            },
            href: navigationPath.advancedSectionEvents,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("68MUk")).default).events)), features.hasWebHooks && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'webhooks'
            },
            href: navigationPath.advancedSectionWebHooks,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("68MUk")).default).webhooks)), features.hasLexoRankManagement && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'lexorank-management'
            },
            href: navigationPath.advancedLexoRankManagement,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("68MUk")).default).lexorankManagement)));
    };
});
parcelRegister("68MUk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$24a7ac619834e463$export$2e2bcd8739ae039);
    var $7VHMR;
    var $24a7ac619834e463$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        advanced: {
            "id": "spa-apps-sidebar-global-settings-system.menu.advanced.advanced",
            "defaultMessage": "Advanced"
        },
        attachments: {
            "id": "spa-apps-sidebar-global-settings-system.menu.advanced.attachments",
            "defaultMessage": "Attachments"
        },
        events: {
            "id": "spa-apps-sidebar-global-settings-system.menu.advanced.events",
            "defaultMessage": "Events"
        },
        webhooks: {
            "id": "spa-apps-sidebar-global-settings-system.menu.advanced.webhooks",
            "defaultMessage": "WebHooks"
        },
        lexorankManagement: {
            "id": "spa-apps-sidebar-global-settings-system.menu.advanced.lexorank-management",
            "defaultMessage": "LexoRank management"
        }
    });
});
parcelRegister("8wyB3", function(module, exports) {
    $parcel$export(module.exports, "AutomationSection", ()=>$ae233f5e809ec072$export$5fa01e4d25d8e6ec);
    var $5uXOq = parcelRequire("5uXOq");
    var $cZXEh;
    var $65Ltd;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $6tKa8;
    const $ae233f5e809ec072$export$5fa01e4d25d8e6ec = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), {
            title: formatMessage((0, (0, parcelRequire("6tKa8")).default).automationGroup)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'automation'
            },
            href: navigationPath.globalAutomation,
            selectedOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SETTINGS_AUTOMATION)
            ]
        }, formatMessage((0, (0, parcelRequire("6tKa8")).default).globalAutomation)));
    };
});
parcelRegister("6tKa8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b1b0e49ecb7c48dd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b1b0e49ecb7c48dd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        automationGroup: {
            "id": "spa-apps-sidebar-global-settings-system.menu.automation.automation-group",
            "defaultMessage": "Automation"
        },
        globalAutomation: {
            "id": "spa-apps-sidebar-global-settings-system.menu.automation.global-automation",
            "defaultMessage": "Global automation"
        }
    });
});
parcelRegister("230Wm", function(module, exports) {
    $parcel$export(module.exports, "ImportExportSection", ()=>$45f1c30d97953942$export$2e4cb1dc5b398447);
    var $5uXOq = parcelRequire("5uXOq");
    var $cZXEh;
    var $5tOuG;
    var $2vSU6;
    var $co1wz;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $3SzZi;
    var $4OCke;
    var $9OXo1;
    var $eaZ4X;
    var $jMBA3;
    var $8136S;
    var $bK0J9;
    const $45f1c30d97953942$export$2e4cb1dc5b398447 = ({ stack: stack })=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { isSiteAdmin: isSiteAdmin, isAdmin: isAdmin, licensedProducts: licensedProducts } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), null);
        const hasSupportedLicense = licensedProducts[(0, (0, parcelRequire("2vSU6")).projectTypeToCanonicalId)((0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT))] || licensedProducts[(0, (0, parcelRequire("2vSU6")).projectTypeToCanonicalId)((0, (0, parcelRequire("2vSU6")).CORE_PROJECT))];
        const showNewExternalImport = hasSupportedLicense && (isSiteAdmin || !isAdmin || (0, (0, parcelRequire("co1wz")).ff)('enable-product-admin-for-x2c-migration_zmlsv'));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), {
            title: formatMessage((0, (0, parcelRequire("8136S")).default).importExportGroup)
        }, features.hasBackupManager && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'cloud-export'
            },
            href: navigationPath.importSectionBackupManager,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("8136S")).default).backupManager)), features.hasExternalImport && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'external-import'
            },
            href: showNewExternalImport ? navigationPath.importSectionExternalImportNew : navigationPath.importSectionExternalImport,
            selectedOn: (currentLocation, itemLocation)=>(0, (0, parcelRequire("4OCke")).matchUrlExact)()(currentLocation, itemLocation) || showNewExternalImport && currentLocation.pathname.includes(navigationPath.importSectionExternalImport)
        }, formatMessage((0, (0, parcelRequire("8136S")).default).externalImport)), features.hasCloudImport && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'cloud-import'
            },
            href: navigationPath.importSectionCloudImport,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlExact)()
        }, formatMessage((0, (0, parcelRequire("8136S")).default).importJiraCloud)), features.hasServerImport && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'server-import'
            },
            href: navigationPath.importSectionServerImport,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlExact)()
        }, formatMessage((0, (0, parcelRequire("8136S")).default).importJiraServer)), (0, (0, parcelRequire("3SzZi")).shouldRenderNesting)(features.hasC2CMigration, stack, (0, (0, parcelRequire("eaZ4X")).SECTION_ID).MIGRATE_TO_CLOUD_SITE) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bK0J9")).MigrateCloudSiteMenuItem), null));
    };
});
parcelRegister("3SzZi", function(module, exports) {
    $parcel$export(module.exports, "shouldRenderNesting", ()=>$956cef61e43b05f1$export$a35baff1c4efd3da);
    const $956cef61e43b05f1$export$a35baff1c4efd3da = (condition, stack, nestingId)=>condition === true || Boolean(stack && stack.includes(nestingId));
});
parcelRegister("8136S", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e31be53e6f399aac$export$2e2bcd8739ae039);
    var $7VHMR;
    var $e31be53e6f399aac$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        importExportGroup: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-export-group",
            "defaultMessage": "Import and export"
        },
        backupManager: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.backup-manager",
            "defaultMessage": "Backup manager"
        },
        externalImport: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.external-import",
            "defaultMessage": "External System Import"
        },
        restoreSystem: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.restore-system",
            "defaultMessage": "Restore system"
        },
        importJiraCloud: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-jira-cloud",
            "defaultMessage": "Import Jira Cloud"
        },
        importJiraServer: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.import-jira-server",
            "defaultMessage": "Import Jira Server"
        }
    });
});
parcelRegister("bK0J9", function(module, exports) {
    $parcel$export(module.exports, "MigrateCloudSiteMenuItem", ()=>$4c7a6e794a4b89f4$export$48e579c481d74aac);
    var $5uXOq = parcelRequire("5uXOq");
    var $eddAM;
    var $co1wz;
    var $koVbs;
    var $kZj7F;
    var $17bH5;
    var $eaZ4X;
    var $dtw3L;
    var $5wReO;
    var $4gDi8;
    const $4c7a6e794a4b89f4$export$48e579c481d74aac = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { release: release } = (0, (0, parcelRequire("dtw3L")).useReleaseVersion)();
        const BackMenuItem = {
            href: '/jira/settings/system/general-configuration',
            title: formatMessage((0, (0, parcelRequire("5wReO")).messages).itemBack)
        };
        const isBeta = (0, (0, parcelRequire("co1wz")).ff)('jira-frontend-c2c-migrations-ga-release') ? release === 'BETA' : true;
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kZj7F")).NestingMenuItem), {
            analytics: {
                itemId: 'migrate-to-cloud-site'
            },
            href: navigationPath.importSectionMigrateCloud,
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, (0, parcelRequire("5wReO")).messages).migration), ' ', isBeta && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eddAM")).default), {
                appearance: "new"
            }, formatMessage((0, (0, parcelRequire("5wReO")).messages).migrationBetaLabel))),
            overrides: {
                BackMenuItem: BackMenuItem
            },
            id: (0, (0, parcelRequire("eaZ4X")).SECTION_ID).MIGRATE_TO_CLOUD_SITE
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4gDi8")).MigrationsMenu), null));
    };
});
parcelRegister("dtw3L", function(module, exports) {
    $parcel$export(module.exports, "useReleaseVersion", ()=>$c58df78fc0d0b4fc$export$4ea0c46c431d5d34);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $eusud;
    const $c58df78fc0d0b4fc$export$1a5772dc2221d2a5 = ()=>(0, (0, parcelRequire("eusud")).performGetRequest)('/rest/migration/c2c_rollout_phase');
    const $c58df78fc0d0b4fc$export$4ea0c46c431d5d34 = ()=>{
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const [release, setRelease] = (0, $5uXOq.useState)('GA');
        const [error, setError] = (0, $5uXOq.useState)();
        const fetch = async ()=>{
            try {
                setLoading(true);
                setError(undefined);
                const data = await $c58df78fc0d0b4fc$export$1a5772dc2221d2a5();
                setRelease(data.release);
                setLoading(false);
            } catch (apiError) {
                setLoading(false);
                setError(apiError);
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: apiError,
                    meta: {
                        id: 'useReleaseVersion',
                        packageName: 'jiraNavigationAppsSidebarGlobalSettingsSystem',
                        teamName: 'navigation'
                    }
                });
            }
        };
        (0, $5uXOq.useEffect)(()=>{
            fetch();
        }, []);
        return {
            loading: loading,
            release: release,
            error: error
        };
    };
});
parcelRegister("5wReO", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$1058bfeeb1474c8c$export$defe85febe8b728c);
    var $7VHMR;
    const $1058bfeeb1474c8c$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        migration: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migration",
            "defaultMessage": "Migrate cloud site"
        },
        migrationBetaLabel: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migration-beta-label",
            "defaultMessage": "Beta"
        },
        itemBack: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.item-back",
            "defaultMessage": "Back to system"
        }
    });
});
parcelRegister("4gDi8", function(module, exports) {
    $parcel$export(module.exports, "MigrationsMenu", ()=>$c1e3be64f0bee0e2$export$9a2d2cb9bbe36e75);
    var $5uXOq = parcelRequire("5uXOq");
    var $2YFlw;
    var $cZXEh;
    var $1WqFo;
    var $5P4hV;
    var $f9Owr;
    var $koVbs;
    var $k0ZZ2;
    var $3OGaE;
    var $4OCke;
    var $koeKL;
    var $dEAUf;
    const $c1e3be64f0bee0e2$export$9a2d2cb9bbe36e75 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [{ data: data }, { fetchCohortDetails: fetchCohortDetails }] = (0, (0, parcelRequire("5P4hV")).useCohortDetails)();
        const baseMigrateCloudUrl = '/jira/settings/system/migration';
        (0, $5uXOq.useEffect)(()=>{
            fetchCohortDetails(cloudId);
        }, [
            fetchCohortDetails,
            cloudId
        ]);
        if ((0, (0, parcelRequire("1WqFo")).isFedRamp)()) return;
        if (data?.isCohortEnabled && (data?.cohortType === 'NEVER_USED_C2C_JIRA' || data?.cohortType === 'NOT_USED_C2C_JIRA_IN_3_MONTHS' || data?.hasOptedIn || data?.status === 'IN_PROGRESS' || data?.status === 'FAILED' || (0, (0, parcelRequire("f9Owr")).ff)('change-management-cohort-4-ff_4bpld'))) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'migration-home'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `${baseMigrateCloudUrl}/home`
        }, formatMessage((0, (0, parcelRequire("dEAUf")).messages).title));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OGaE")).TitleHeader), null, formatMessage((0, (0, parcelRequire("dEAUf")).messages).title)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'migration-home'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `${baseMigrateCloudUrl}/home`
        }, formatMessage((0, (0, parcelRequire("dEAUf")).messages).migrationOverview)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'plan-your-migration'
            },
            href: "https://support.atlassian.com/migration/docs/cloud-to-cloud-migration/",
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2YFlw"))))), {
                size: "small",
                label: ""
            }),
            target: "_blank"
        }, formatMessage((0, (0, parcelRequire("dEAUf")).messages).planYourMigration)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'manage-migrations'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `${baseMigrateCloudUrl}/dashboard`
        }, formatMessage((0, (0, parcelRequire("dEAUf")).messages).manageMigrations))));
    };
});
parcelRegister("5P4hV", function(module, exports) {
    $parcel$export(module.exports, "useCohortDetails", ()=>$d555d3765bbcba03$export$79c60a355eee7756);
    var $7JoAD = parcelRequire("7JoAD");
    var $e4Ne3;
    var $k0VTl;
    const $d555d3765bbcba03$var$Store = (0, $7JoAD.createStore)({
        initialState: (0, (0, parcelRequire("k0VTl")).COHORT_DETAILS_DEFAULT_STATE),
        actions: (0, parcelRequire("e4Ne3")).default,
        name: 'Migrations - Cohort details'
    });
    const $d555d3765bbcba03$export$79c60a355eee7756 = (0, $7JoAD.createHook)($d555d3765bbcba03$var$Store);
});
parcelRegister("e4Ne3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d5b68a618d6978ef$export$2e2bcd8739ae039);
    var $jcw0u;
    var $eusud;
    var $k0VTl;
    var $kgW7E;
    const $d5b68a618d6978ef$export$343d10549fb4d411 = async (cloudId)=>{
        const fetchUrl = (0, (0, parcelRequire("kgW7E")).getCohortStatusUrl)(cloudId);
        return (0, (0, parcelRequire("eusud")).performGetRequest)(fetchUrl).catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'fetchCohortDetails',
                    packageName: 'jiraC2CMigrationsCommonUtils',
                    teamName: 'jira-c2c-migration'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        });
    };
    const $d5b68a618d6978ef$export$c9cf692e1e990743 = (cloudId)=>{
        return async ({ setState: setState, getState: getState })=>{
            const showOptInButton = (0, (0, parcelRequire("kgW7E")).getOptInModalStatus)();
            setState({
                showOptInButton: showOptInButton
            });
            if (getState().data || getState().loading) return undefined;
            try {
                setState({
                    loading: true
                });
                const data = await $d5b68a618d6978ef$export$343d10549fb4d411(cloudId);
                const derivedOptInButtonStatus = !data.hasOptedIn && data.status !== 'NEVER' || showOptInButton;
                (0, (0, parcelRequire("kgW7E")).setOptInModalStatus)(derivedOptInButtonStatus);
                setState({
                    data: data,
                    loading: false,
                    showOptInButton: derivedOptInButtonStatus
                });
                return {
                    data: data
                };
            } catch (error) {
                setState({
                    error: error,
                    loading: false
                });
                return undefined;
            }
        };
    };
    const $d5b68a618d6978ef$export$e64b646bfdf4078e = (showOptInButton)=>({ setState: setState })=>{
            (0, (0, parcelRequire("kgW7E")).setOptInModalStatus)(showOptInButton);
            setState({
                showOptInButton: showOptInButton
            });
        };
    const $d5b68a618d6978ef$export$aad8462122ac592b = ()=>({ setState: setState })=>{
            setState({
                ...(0, (0, parcelRequire("k0VTl")).COHORT_DETAILS_DEFAULT_STATE),
                data: undefined,
                error: undefined
            });
        };
    var $d5b68a618d6978ef$export$2e2bcd8739ae039 = {
        fetchCohortDetails: $d5b68a618d6978ef$export$c9cf692e1e990743,
        updateShowOptInButton: $d5b68a618d6978ef$export$e64b646bfdf4078e,
        reset: $d5b68a618d6978ef$export$aad8462122ac592b
    };
});
parcelRegister("k0VTl", function(module, exports) {
    $parcel$export(module.exports, "COHORT_DETAILS_DEFAULT_STATE", ()=>$98cc956cfe48207f$export$7108825eea599cbc);
    $parcel$export(module.exports, "SESSION_STORAGE_KEY", ()=>$98cc956cfe48207f$export$5200514808277ba7);
    const $98cc956cfe48207f$export$7108825eea599cbc = {
        loading: false,
        showOptInButton: false
    };
    const $98cc956cfe48207f$export$5200514808277ba7 = 'C2C.MIGRATION.ADMIN.HUB.OPT.IN.BUTTON';
});
parcelRegister("kgW7E", function(module, exports) {
    $parcel$export(module.exports, "getOptInModalStatus", ()=>$3ef4b516c1de88ac$export$e69da0941df3caa9);
    $parcel$export(module.exports, "setOptInModalStatus", ()=>$3ef4b516c1de88ac$export$687080e399c5c65f);
    $parcel$export(module.exports, "getCohortStatusUrl", ()=>$3ef4b516c1de88ac$export$66a62d4e6369f93e);
    var $k0VTl;
    const $3ef4b516c1de88ac$export$e69da0941df3caa9 = ()=>JSON.parse(sessionStorage.getItem((0, (0, parcelRequire("k0VTl")).SESSION_STORAGE_KEY)) || 'false');
    const $3ef4b516c1de88ac$export$687080e399c5c65f = (value)=>sessionStorage.setItem((0, (0, parcelRequire("k0VTl")).SESSION_STORAGE_KEY), String(value));
    const $3ef4b516c1de88ac$export$66a62d4e6369f93e = (cloudId)=>`/gateway/api/migrations/c2c/v1/change-management/cloud-id/${cloudId}/status`;
});
parcelRegister("dEAUf", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$94f7f834fbebc537$export$defe85febe8b728c);
    var $7VHMR;
    const $94f7f834fbebc537$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migrate-to-cloud-site-menu.title",
            "defaultMessage": "Migrate cloud site"
        },
        migrationOverview: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migrate-to-cloud-site-menu.migration-overview",
            "defaultMessage": "Migration overview"
        },
        manageMigrations: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migrate-to-cloud-site-menu.manage-migrations",
            "defaultMessage": "Migration dashboard"
        },
        planYourMigration: {
            "id": "spa-apps-sidebar-global-settings-system.menu.import-export.migrate-to-cloud-site.migrate-to-cloud-site-menu.plan-your-migration",
            "defaultMessage": "Plan your migration"
        }
    });
});
parcelRegister("je2KE", function(module, exports) {
    $parcel$export(module.exports, "MailSection", ()=>$6a76fa07c85a01a9$export$6e0cda39522c0aa7);
    var $5uXOq = parcelRequire("5uXOq");
    var $cZXEh;
    var $5tOuG;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $4OCke;
    var $jMBA3;
    var $1c6JR;
    var $gb7H7;
    const $6a76fa07c85a01a9$export$6e0cda39522c0aa7 = ()=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), {
            title: formatMessage((0, (0, parcelRequire("1c6JR")).default).mailGroup)
        }, features.hasGlobalMailSettings && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'global-mail-settings'
            },
            href: navigationPath.mailSectionGlobalMailSettings,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("1c6JR")).default).globalMailSettings)), features.hasOutgoingMail && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'outgoing-mail'
            },
            href: navigationPath.mailSectionOutgoingMail,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("1c6JR")).default).outgoingMail)), features.hasIncomingMail && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'incoming-mail'
            },
            href: navigationPath.mailSectionIncomingMail,
            selectedOn: (0, (0, parcelRequire("gb7H7")).isIncomingMailSelected)
        }, formatMessage((0, (0, parcelRequire("1c6JR")).default).incomingMail)), features.hasSendMail && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'send-email'
            },
            href: navigationPath.mailSectionSendMail,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("1c6JR")).default).sendEmail)));
    };
});
parcelRegister("1c6JR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fa5900167b5101d6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $fa5900167b5101d6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        mailGroup: {
            "id": "spa-apps-sidebar-global-settings-system.menu.mail.mail-group",
            "defaultMessage": "Mail"
        },
        globalMailSettings: {
            "id": "spa-apps-sidebar-global-settings-system.menu.mail.global-mail-settings",
            "defaultMessage": "Global Mail Settings"
        },
        outgoingMail: {
            "id": "spa-apps-sidebar-global-settings-system.menu.mail.outgoing-mail",
            "defaultMessage": "Outgoing Mail"
        },
        incomingMail: {
            "id": "spa-apps-sidebar-global-settings-system.menu.mail.incoming-mail",
            "defaultMessage": "Incoming Mail"
        },
        sendEmail: {
            "id": "spa-apps-sidebar-global-settings-system.menu.mail.send-email",
            "defaultMessage": "Send email"
        }
    });
});
parcelRegister("gb7H7", function(module, exports) {
    $parcel$export(module.exports, "isIncomingMailSelected", ()=>$d695081436bd6a1d$export$3f53f72603975cb0);
    var $4OCke;
    const $d695081436bd6a1d$var$INCOMING_MAIL_PATH_REGEXP = /\/admin\/(\w+)Pop(Mail)?Server/i;
    const $d695081436bd6a1d$export$3f53f72603975cb0 = (currentLocation, itemLocation)=>(0, (0, parcelRequire("4OCke")).matchUrlExact)()(currentLocation, itemLocation) || $d695081436bd6a1d$var$INCOMING_MAIL_PATH_REGEXP.test(currentLocation.pathname);
});
parcelRegister("iAlf2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$979d16a4bf22949b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $979d16a4bf22949b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        systemGroup: {
            "id": "spa-apps-sidebar-global-settings-system.menu.system-group",
            "defaultMessage": "System"
        },
        generalConfiguration: {
            "id": "spa-apps-sidebar-global-settings-system.menu.general-configuration",
            "defaultMessage": "General configuration"
        },
        darkFeatures: {
            "id": "spa-apps-sidebar-global-settings-system.menu.dark-features",
            "defaultMessage": "Dark features"
        },
        issueCollectors: {
            "id": "spa-apps-sidebar-global-settings-system.menu.issue-collectors",
            "defaultMessage": "Issue collectors"
        },
        globalSettingsSystemSidebarLabel: {
            "id": "spa-apps-sidebar-global-settings-system.menu.global-settings-system-sidebar-label",
            "defaultMessage": "Side"
        }
    });
});
parcelRegister("fwlYA", function(module, exports) {
    $parcel$export(module.exports, "SecuritySection", ()=>$76b3d515542acad4$export$4f16aec1633bed7d);
    var $5uXOq = parcelRequire("5uXOq");
    var $cZXEh;
    var $5tOuG;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $4OCke;
    var $jMBA3;
    var $eTPZ8;
    var $icmgW;
    const $76b3d515542acad4$export$4f16aec1633bed7d = ()=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), null);
        const globalPermissionsPath = navigationPath.securityGlobalPermissions;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), {
            title: formatMessage((0, (0, parcelRequire("eTPZ8")).default).securityGroup)
        }, features.hasProjectRoles && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'project-roles'
            },
            href: navigationPath.securityProjectRoles,
            selectedOn: (0, (0, parcelRequire("icmgW")).isProjectRolesSelected)
        }, formatMessage((0, (0, parcelRequire("eTPZ8")).default).projectRoles)), features.hasGlobalPermissions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'global-permissions'
            },
            href: globalPermissionsPath,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("eTPZ8")).default).globalPermissions)));
    };
});
parcelRegister("eTPZ8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$db51b59205472bbf$export$2e2bcd8739ae039);
    var $7VHMR;
    var $db51b59205472bbf$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        securityGroup: {
            "id": "spa-apps-sidebar-global-settings-system.menu.security.security-group",
            "defaultMessage": "Security"
        },
        projectRoles: {
            "id": "spa-apps-sidebar-global-settings-system.menu.security.project-roles",
            "defaultMessage": "Project roles"
        },
        globalPermissions: {
            "id": "spa-apps-sidebar-global-settings-system.menu.security.global-permissions",
            "defaultMessage": "Global permissions"
        }
    });
});
parcelRegister("icmgW", function(module, exports) {
    $parcel$export(module.exports, "isProjectRolesSelected", ()=>$f6a84fa88243c239$export$ca9501e7fedfce90);
    var $4OCke;
    const $f6a84fa88243c239$var$PROJECT_ROLES_PATH_REGEXP = /\/project\/(\w+)ProjectRole/i;
    const $f6a84fa88243c239$export$ca9501e7fedfce90 = (currentLocation, itemLocation)=>(0, (0, parcelRequire("4OCke")).matchUrlExact)()(currentLocation, itemLocation) || $f6a84fa88243c239$var$PROJECT_ROLES_PATH_REGEXP.test(currentLocation.pathname);
});
parcelRegister("9O5DC", function(module, exports) {
    $parcel$export(module.exports, "SharedSection", ()=>$440640fab2704f98$export$230e518497f06fdc);
    var $5uXOq = parcelRequire("5uXOq");
    var $cZXEh;
    var $5tOuG;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $4OCke;
    var $jMBA3;
    var $hw0ew;
    const $440640fab2704f98$export$230e518497f06fdc = ()=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), {
            title: formatMessage((0, (0, parcelRequire("hw0ew")).default).sharedItems)
        }, features.hasManageFilters && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'manage-filters'
            },
            href: navigationPath.sharedSectionManageFilters,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("hw0ew")).default).filters)), features.hasManageDashboards && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'manage-dashboards'
            },
            href: navigationPath.sharedManageDashboards,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("hw0ew")).default).dashboards)));
    };
});
parcelRegister("hw0ew", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a51482729945d2e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4a51482729945d2e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sharedItems: {
            "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-items",
            "defaultMessage": "Shared Items"
        },
        sharedFilters: {
            "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-filters",
            "defaultMessage": "Shared filters"
        },
        sharedDashboards: {
            "id": "spa-apps-sidebar-global-settings-system.menu.shared.shared-dashboards",
            "defaultMessage": "Shared dashboards"
        },
        filters: {
            "id": "spa-apps-sidebar-global-settings-system.menu.shared.filters",
            "defaultMessage": "Filters"
        },
        dashboards: {
            "id": "spa-apps-sidebar-global-settings-system.menu.shared.dashboards",
            "defaultMessage": "Dashboards"
        }
    });
});
parcelRegister("1y2CG", function(module, exports) {
    $parcel$export(module.exports, "TroubleshootingAndSupportSection", ()=>$5fd448f06aadda25$export$dad01649916e6a2d);
    var $5uXOq = parcelRequire("5uXOq");
    var $cZXEh;
    var $5tOuG;
    var $koVbs;
    var $k0ZZ2;
    var $fRwoF;
    var $17bH5;
    var $4OCke;
    var $jMBA3;
    var $4oL80;
    var $81Iv5;
    var $ie4oV;
    const $5fd448f06aadda25$export$dad01649916e6a2d = ()=>{
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { hasSiteOptimizerEntitlement: hasSiteOptimizerEntitlement } = (0, (0, parcelRequire("fRwoF")).useSiteOptimizerCheck)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), {
            title: formatMessage((0, (0, parcelRequire("4oL80")).default).troubleshootingGroup)
        }, features.hasViewAuditing && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'view-auditing'
            },
            href: navigationPath.troubleshootingAuditLog,
            selectedOn: (0, (0, parcelRequire("ie4oV")).isViewAuditingSelected)
        }, formatMessage((0, (0, parcelRequire("4oL80")).default).auditLog)), features.hasPluginViewer && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'plugin-viewer'
            },
            href: navigationPath.troubleshootingPluginViewer,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("4oL80")).default).pluginViewer)), features.hasModulesViewer && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'modules-viewer'
            },
            href: navigationPath.troubleshootingModulesViewer,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("4oL80")).default).modulesViewer)), features.hasSystemInfo && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'system-info'
            },
            href: navigationPath.troubleshootingSystemInfo,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("4oL80")).default).systemInfo)), features.hasIntegrityChecker && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'integrity-checker'
            },
            href: navigationPath.troubleshootingIntegrityChecker,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("4oL80")).default).integrityChecker)), features.hasLoggingProfiling && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'logging-profiling'
            },
            href: navigationPath.troubleshootingLoggingProfiling,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("4oL80")).default).loggingProfiling)), features.hasSchedulerDetails && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'scheduler-details'
            },
            href: navigationPath.troubleshootingSchedulerDetails,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("4oL80")).default).schedulerDetails)), hasSiteOptimizerEntitlement && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("81Iv5")).PerformanceMenuItem), null));
    };
});
parcelRegister("fRwoF", function(module, exports) {
    $parcel$export(module.exports, "useSiteOptimizerCheck", ()=>$31e8f2ad3b3f051f$export$7df80afc329cd61);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $eusud;
    const $31e8f2ad3b3f051f$export$e9921a980669184 = ()=>(0, (0, parcelRequire("eusud")).performGetRequest)('/rest/internal/psi/latest/licence/check');
    const $31e8f2ad3b3f051f$export$7df80afc329cd61 = ()=>{
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const [hasEntitlement, setHasEntitlement] = (0, $5uXOq.useState)(false);
        const [error, setError] = (0, $5uXOq.useState)();
        const fetch = async ()=>{
            try {
                setLoading(true);
                setError(undefined);
                if ((0, (0, parcelRequire("co1wz")).ff)('override-enable-performance-and-scale-admin-menu')) setHasEntitlement(true);
                else {
                    const data = await $31e8f2ad3b3f051f$export$e9921a980669184();
                    setHasEntitlement(data?.isVisible ?? false);
                }
                setLoading(false);
            } catch (apiError) {
                setLoading(false);
                setError(apiError);
            }
        };
        (0, $5uXOq.useEffect)(()=>{
            fetch();
        }, []);
        return {
            loading: loading,
            hasSiteOptimizerEntitlement: hasEntitlement,
            error: error
        };
    };
});
parcelRegister("4oL80", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ca98bc392d099f0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9ca98bc392d099f0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        troubleshootingGroup: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.troubleshooting-group",
            "defaultMessage": "Troubleshooting and Support"
        },
        auditLog: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.audit-log",
            "defaultMessage": "Audit Log"
        },
        pluginViewer: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.plugin-viewer",
            "defaultMessage": "Plugin Viewer"
        },
        modulesViewer: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.modules-viewer",
            "defaultMessage": "Modules Viewer"
        },
        systemInfo: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.system-info",
            "defaultMessage": "System info"
        },
        integrityChecker: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.integrity-checker",
            "defaultMessage": "Integrity checker"
        },
        loggingProfiling: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.logging-profiling",
            "defaultMessage": "Logging profiling"
        },
        schedulerDetails: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.scheduler-details",
            "defaultMessage": "Scheduler details"
        }
    });
});
parcelRegister("81Iv5", function(module, exports) {
    $parcel$export(module.exports, "PerformanceMenuItem", ()=>$ca611bfc0be59ae0$export$b4e98631ff0b3fb5);
    var $5uXOq = parcelRequire("5uXOq");
    var $eddAM;
    var $hfc8j;
    var $47htk;
    var $5MdCt;
    var $6T4rd;
    var $fHbE4;
    var $koVbs;
    var $kZj7F;
    var $17bH5;
    var $8zOmE;
    var $ehdJY;
    var $90yGq;
    var $eaZ4X;
    var $1ssva;
    var $iWjQg;
    var $fM231;
    const $ca611bfc0be59ae0$export$b4e98631ff0b3fb5 = ()=>{
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isOptimiserSpotlightActive, setIsOptimiserSpotlightActive] = (0, $5uXOq.useState)(false);
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        const BackMenuItem = {
            href: '/jira/settings/system/general-configuration',
            title: formatMessage((0, (0, parcelRequire("1ssva")).default).itemBack)
        };
        const fetchSpotlightState = (0, $5uXOq.useCallback)(async ()=>{
            if (accountId != null) {
                const response = await (0, (0, parcelRequire("fM231")).hasSeenSiteOptimiserSpotlight)(accountId);
                setIsOptimiserSpotlightActive(!response);
            }
        }, [
            accountId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            fetchSpotlightState();
        }, [
            fetchSpotlightState
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hfc8j")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("47htk")).default), {
            name: "site-optimiser-spotlight"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kZj7F")).NestingMenuItem), {
            analytics: {
                itemId: 'performance-and-scale'
            },
            href: navigationPath.troubleshootingPerformanceAndScale,
            title: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fHbE4")).default), {
                gap: "space.050",
                justifyContent: "start",
                alignItems: "center"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), null, formatMessage((0, (0, parcelRequire("1ssva")).default).performanceAndScale)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eddAM")).default), {
                appearance: "new"
            }, formatMessage((0, (0, parcelRequire("1ssva")).default).beta))),
            overrides: {
                BackMenuItem: BackMenuItem
            },
            id: (0, (0, parcelRequire("eaZ4X")).SECTION_ID).PERFORMANCE_AND_SCALE
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iWjQg")).PerformanceAndScaleMenu), null))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5MdCt")).default), null, isOptimiserSpotlightActive && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehdJY")).JiraSpotlight), {
            actions: [
                {
                    onClick: (_, analyticsEvent)=>{
                        setIsOptimiserSpotlightActive(false);
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'performanceMenuItemSpotlightComplete');
                    },
                    text: formatMessage((0, (0, parcelRequire("1ssva")).default).spotlightAction)
                }
            ],
            heading: formatMessage((0, (0, parcelRequire("1ssva")).default).spotlightHeading),
            target: "site-optimiser-spotlight",
            key: "site-optimiser-spotlight",
            targetRadius: 3,
            targetBgColor: `var(--ds-surface, ${(0, $5e0c0d4e15efb4a6$export$29a4f05edc054374)})`,
            dialogPlacement: "right top",
            messageId: "navigation-apps-sidebar-global-settings-system.ui.menu.troubleshooting-and-support.performance-menu-item.jira-spotlight.site-optimiser-spotlight",
            messageType: "engagement"
        }, formatMessage((0, (0, parcelRequire("1ssva")).default).spotlightBody))));
    };
});
parcelRegister("ehdJY", function(module, exports) {
    $parcel$export(module.exports, "JiraSpotlight", ()=>$61a8dc1ff1116911$export$e209c6be9ab8c4f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $3P5hD;
    var $10xFf;
    var $5NHqU;
    const $61a8dc1ff1116911$export$e209c6be9ab8c4f4 = (props)=>{
        if ((0, (0, parcelRequire("10xFf")).shouldBeChoreographed)(props)) {
            const { messageType: messageType, ...rest } = props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5NHqU")).ChoreographerSpotlight), rest);
        }
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3P5hD")).default), rest);
    };
});
parcelRegister("10xFf", function(module, exports) {
    $parcel$export(module.exports, "shouldBeChoreographed", ()=>$36201c75b4df20a7$export$a8ba9111c7eec9ac);
    $parcel$export(module.exports, "environmentToEnvType", ()=>$36201c75b4df20a7$export$e2cf19200849be9e);
    var $bpIMA;
    var $t6tX9;
    function $36201c75b4df20a7$export$a8ba9111c7eec9ac(props) {
        return !!props?.messageType && (0, (0, parcelRequire("t6tX9")).IntegratedChoreographerMessageTypesEnum).includes(props.messageType);
    }
    function $36201c75b4df20a7$export$e2cf19200849be9e(environment) {
        switch(environment){
            case 'dev':
                return (0, (0, parcelRequire("bpIMA")).envType).DEV;
            case 'staging':
                return (0, (0, parcelRequire("bpIMA")).envType).STAGING;
            case 'prod':
                return (0, (0, parcelRequire("bpIMA")).envType).PROD;
            default:
                return (0, (0, parcelRequire("bpIMA")).envType).LOCAL;
        }
    }
});
parcelRegister("t6tX9", function(module, exports) {
    $parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", ()=>$b5642a17fa90b00d$export$dbe9e38c9d6f26d0);
    const $b5642a17fa90b00d$export$94e85cf3348f045a = {
        ENGAGEMENT: 'engagement',
        MARKETING: 'marketing',
        TRANSACTIONAL: 'transactional'
    };
    const $b5642a17fa90b00d$export$dbe9e38c9d6f26d0 = [
        $b5642a17fa90b00d$export$94e85cf3348f045a.ENGAGEMENT,
        $b5642a17fa90b00d$export$94e85cf3348f045a.MARKETING
    ];
});
parcelRegister("5NHqU", function(module, exports) {
    $parcel$export(module.exports, "ChoreographerSpotlight", ()=>$b7d2a49fe3b12822$export$e01943d134357d00);
    var $3P5hD;
    var $cSWNW;
    const $b7d2a49fe3b12822$export$e01943d134357d00 = (0, (0, parcelRequire("cSWNW")).withChoreographedRender)((0, (0, parcelRequire("3P5hD")).default));
});
parcelRegister("cSWNW", function(module, exports) {
    $parcel$export(module.exports, "withChoreographedRender", ()=>$620c1a9f3fec1a68$export$c1160fdac17030e);
    var $5uXOq = parcelRequire("5uXOq");
    var $fG5AJ;
    function $620c1a9f3fec1a68$export$c1160fdac17030e(Component, options) {
        function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, ...props }) {
            const shouldRender = (0, (0, parcelRequire("fG5AJ")).useChoreographedRender)({
                messageId: messageId,
                onMessageDisposition: onMessageDisposition
            });
            if (shouldRender) return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, props);
            if (options && options.toggleableProp) {
                const toggleableComponentProps = {
                    ...props,
                    [options.toggleableProp]: false
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Component, toggleableComponentProps);
            }
            return null;
        }
        ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
        return ChoreographedComponent;
    }
});
parcelRegister("fG5AJ", function(module, exports) {
    $parcel$export(module.exports, "getPendoPlugin", ()=>$596f0fde3f3a2d5a$export$3d3a86b2d636214b);
    $parcel$export(module.exports, "useChoreographer", ()=>$596f0fde3f3a2d5a$export$9f0e2488ffd90f11);
    $parcel$export(module.exports, "ChoreographedStatusContext", ()=>$596f0fde3f3a2d5a$export$3ff96dbefca6b00d);
    $parcel$export(module.exports, "useChoreographedStatusContext", ()=>$596f0fde3f3a2d5a$export$2eb1efa814fe4a);
    $parcel$export(module.exports, "useChoreographedRender", ()=>$596f0fde3f3a2d5a$export$2cfd68294be82811);
    var $5uXOq = parcelRequire("5uXOq");
    var $8WQGU;
    var $1eUaI;
    var $3iMQo;
    var $j8DrX;
    var $7qPn9;
    const $596f0fde3f3a2d5a$var$environment = (0, (0, parcelRequire("7qPn9")).toEnvironment)((0, (0, parcelRequire("j8DrX")).default)('ajs-environment')) ?? 'prod';
    const $596f0fde3f3a2d5a$var$createChoreographerFactory = ()=>{
        if (false) return {
            useChoreographer: (..._)=>({
                    startMessage: ()=>Promise.resolve(''),
                    stopMessage: ()=>{}
                })
        };
        return (0, (0, parcelRequire("8WQGU")).choreographerFactory)((0, (0, parcelRequire("3iMQo")).ProductIds).JIRA, $596f0fde3f3a2d5a$var$environment);
    };
    let $596f0fde3f3a2d5a$var$pendoPlugin;
    function $596f0fde3f3a2d5a$export$3d3a86b2d636214b(env) {
        if (!$596f0fde3f3a2d5a$var$pendoPlugin) $596f0fde3f3a2d5a$var$pendoPlugin = new (0, (0, parcelRequire("1eUaI")).PendoChoreographerPlugin)(env, {
            sourceProductId: (0, (0, parcelRequire("3iMQo")).ProductIds).JIRA
        });
        return $596f0fde3f3a2d5a$var$pendoPlugin;
    }
    const { useChoreographer: $596f0fde3f3a2d5a$export$9f0e2488ffd90f11 } = $596f0fde3f3a2d5a$var$createChoreographerFactory();
    const $596f0fde3f3a2d5a$export$3ff96dbefca6b00d = (0, $5uXOq.createContext)({
        isAlreadyChoreographedAtAncestor: false
    });
    const $596f0fde3f3a2d5a$export$2eb1efa814fe4a = ()=>(0, $5uXOq.useContext)($596f0fde3f3a2d5a$export$3ff96dbefca6b00d);
    const $596f0fde3f3a2d5a$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
        const { isAlreadyChoreographedAtAncestor: isAlreadyChoreographedAtAncestor } = $596f0fde3f3a2d5a$export$2eb1efa814fe4a();
        const [shouldRender, setShouldRender] = (0, $5uXOq.useState)(false);
        const { startMessage: startMessage, stopMessage: stopMessage } = $596f0fde3f3a2d5a$export$9f0e2488ffd90f11(messageId, {
            start: ()=>setShouldRender(true)
        });
        (0, $5uXOq.useEffect)(()=>{
            if (!isAlreadyChoreographedAtAncestor) {
                const startMessageAsync = async ()=>{
                    const disposition = await startMessage();
                    onMessageDisposition?.(disposition);
                };
                startMessageAsync();
                return ()=>{
                    stopMessage();
                };
            }
        }, [
            onMessageDisposition,
            startMessage,
            stopMessage,
            isAlreadyChoreographedAtAncestor
        ]);
        return shouldRender || isAlreadyChoreographedAtAncestor;
    };
});
parcelRegister("1ssva", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$46da0b37092f9f6a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $46da0b37092f9f6a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        performanceAndScale: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale",
            "defaultMessage": "Site optimizer"
        },
        itemBack: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.item-back",
            "defaultMessage": "Back to system"
        },
        spotlightHeading: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-heading",
            "defaultMessage": "Clean up your site"
        },
        spotlightBody: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-body",
            "defaultMessage": "Remove old data that might be slowing down your site in a few clicks."
        },
        spotlightAction: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.spotlight-action",
            "defaultMessage": "Ok"
        },
        beta: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.beta",
            "defaultMessage": "Beta"
        }
    });
});
parcelRegister("iWjQg", function(module, exports) {
    $parcel$export(module.exports, "PerformanceAndScaleMenu", ()=>$4bb22b80a7726eba$export$442d4ccb0d25fc50);
    var $5uXOq = parcelRequire("5uXOq");
    var $47htk;
    var $cZXEh;
    var $lzUDm;
    var $fgWYz;
    var $koVbs;
    var $k0ZZ2;
    var $3OGaE;
    var $4OCke;
    var $etuUp;
    var $jWIOc;
    const $4bb22b80a7726eba$export$442d4ccb0d25fc50 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const basePerformanceUrl = '/jira/settings/system/performance';
        const allVisibleMetrics = (0, (0, parcelRequire("fgWYz")).getAllVisibleMetrics)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OGaE")).TitleHeader), null, formatMessage((0, (0, parcelRequire("etuUp")).default).title)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'performance-overview'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `${basePerformanceUrl}/overview`
        }, formatMessage((0, (0, parcelRequire("etuUp")).default).overview))), allVisibleMetrics.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), {
            title: formatMessage((0, (0, parcelRequire("etuUp")).default).allReports)
        }, allVisibleMetrics.map((metric)=>{
            if (metric.key === (0, (0, parcelRequire("lzUDm")).PROJECT_CLEANUP_KEY)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: "project-cleanup-item"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("47htk")).default), {
                name: (0, (0, parcelRequire("jWIOc")).PROJECT_CLEANUP_SPOTLIGHT_NAME)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
                analytics: {
                    itemId: `performance-metric-${metric.key}`
                },
                href: `${basePerformanceUrl}/metrics/${metric.key}`,
                selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
                key: metric.key
            }, formatMessage(metric.name))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jWIOc")).ProjectCleanupSpotlight), null));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
                analytics: {
                    itemId: `performance-metric-${metric.key}`
                },
                href: `${basePerformanceUrl}/metrics/${metric.key}`,
                selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
                key: metric.key
            }, formatMessage(metric.name));
        })));
    };
});
parcelRegister("lzUDm", function(module, exports) {
    $parcel$export(module.exports, "PROJECT_CLEANUP_KEY", ()=>$3bfe695ee69b7be4$export$4e9bf1d386c2f0c);
    $parcel$export(module.exports, "PROJECT_CLEANUP", ()=>$3bfe695ee69b7be4$export$761acf34bef3a717);
    var $iHO6d;
    const $3bfe695ee69b7be4$export$4e9bf1d386c2f0c = 'projectcleanup';
    const $3bfe695ee69b7be4$export$761acf34bef3a717 = {
        key: $3bfe695ee69b7be4$export$4e9bf1d386c2f0c,
        visible: true,
        name: (0, (0, parcelRequire("iHO6d")).default).nameNonFinal,
        description: (0, (0, parcelRequire("iHO6d")).default).descriptionNonFinal,
        tabLabels: [
            (0, (0, parcelRequire("iHO6d")).default).analysisNonFinal,
            (0, (0, parcelRequire("iHO6d")).default).activityLogNonFinal
        ],
        warningMessage: (0, (0, parcelRequire("iHO6d")).default).warningNonFinal,
        exceededMessage: (0, (0, parcelRequire("iHO6d")).default).exceededNonFinal,
        risks: [],
        mitigations: [],
        currentValueLabel: (0, (0, parcelRequire("iHO6d")).default).currentValueLabel,
        cleanupValueLabel: (0, (0, parcelRequire("iHO6d")).default).cleanupValueLabel,
        graphHeader: (0, (0, parcelRequire("iHO6d")).default).graphHeader,
        recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-the-number-of-projects-in-your-site/',
        recommendationUrlText: (0, (0, parcelRequire("iHO6d")).default).recommendationUrlText
    };
});
parcelRegister("iHO6d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$622f291bdb5f6890$export$2e2bcd8739ae039);
    var $7VHMR;
    const $622f291bdb5f6890$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
    const $622f291bdb5f6890$var$DESCRIPTION_DESC = 'Description of the site optimizer metric.';
    const $622f291bdb5f6890$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
    const $622f291bdb5f6890$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
    const $622f291bdb5f6890$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
    const $622f291bdb5f6890$var$CLEANUP_VALUE_LABEL_DESC = 'Label to be shown next to the cleanup value of the metric.';
    const $622f291bdb5f6890$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
    const $622f291bdb5f6890$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
    var $622f291bdb5f6890$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        nameNonFinal: {
            "id": "admin-pages-performance.common.assets.project-cleanup.name-non-final",
            "defaultMessage": "Projects"
        },
        descriptionNonFinal: {
            "id": "admin-pages-performance.common.assets.project-cleanup.description-non-final",
            "defaultMessage": "Below, we\u2019ve identified company-managed and team-managed projects in your site that can be archived or trashed because they contain no issues. Removing these projects can improve site performance and stability."
        },
        recommendationUrlText: {
            "id": "admin-pages-performance.common.assets.project-cleanup.recommendation-url-text",
            "defaultMessage": "See how we identify these projects."
        },
        analysisNonFinal: {
            "id": "admin-pages-performance.common.assets.project-cleanup.analysis-non-final",
            "defaultMessage": "Analysis"
        },
        activityLogNonFinal: {
            "id": "admin-pages-performance.common.assets.project-cleanup.activity-log-non-final",
            "defaultMessage": "Activity log"
        },
        graphHeader: {
            "id": "admin-pages-performance.common.assets.project-role-actor.graph-header",
            "defaultMessage": "Projects over time"
        },
        warningNonFinal: {
            "id": "admin-pages-performance.common.assets.project-cleanup.warning-non-final",
            "defaultMessage": "The number of projects is nearing our recommended threshold."
        },
        exceededNonFinal: {
            "id": "admin-pages-performance.common.assets.project-cleanup.exceeded-non-final",
            "defaultMessage": "There are some project..."
        },
        currentValueLabel: {
            "id": "admin-pages-performance.common.assets.project-cleanup.current-value-label",
            "defaultMessage": "Projects in your site"
        },
        cleanupValueLabel: {
            "id": "admin-pages-performance.common.assets.project-cleanup.cleanup-value-label",
            "defaultMessage": "Recommended for cleanup"
        }
    });
});
parcelRegister("fgWYz", function(module, exports) {
    $parcel$export(module.exports, "getAllVisibleMetrics", ()=>$2cc6642f29a0adee$export$e6140fda06493d18);
    $parcel$export(module.exports, "getMetric", ()=>$2cc6642f29a0adee$export$ed0dc1178a679c67);
    $parcel$export(module.exports, "getAllVisibleMetricKeys", ()=>$2cc6642f29a0adee$export$1f2abf3e170d35d2);
    $parcel$export(module.exports, "assertNever", ()=>$2cc6642f29a0adee$export$cbadc5a7223772a8);
    var $4R6GH;
    var $8MHQY;
    var $cOrKR;
    var $lzUDm;
    var $3AEMX;
    var $gtb9f;
    class $2cc6642f29a0adee$export$9419457073a1750 {
        constructor(metrics){
            this.metrics = metrics;
        }
        getMetric(key) {
            return this.metrics.find((m)=>m.key === key);
        }
        getAllVisibleMetrics() {
            return this.metrics.filter((metric)=>metric.visible && $2cc6642f29a0adee$export$898df584445641cf(metric.key));
        }
        getAllVisibleMetricsKeys() {
            return $2cc6642f29a0adee$export$e6140fda06493d18().map((m)=>m.key);
        }
    }
    const $2cc6642f29a0adee$var$REGISTRY = new $2cc6642f29a0adee$export$9419457073a1750((0, (0, parcelRequire("gtb9f")).METRICS));
    const $2cc6642f29a0adee$export$ed0dc1178a679c67 = $2cc6642f29a0adee$var$REGISTRY.getMetric.bind($2cc6642f29a0adee$var$REGISTRY);
    const $2cc6642f29a0adee$export$e6140fda06493d18 = $2cc6642f29a0adee$var$REGISTRY.getAllVisibleMetrics.bind($2cc6642f29a0adee$var$REGISTRY);
    const $2cc6642f29a0adee$export$1f2abf3e170d35d2 = $2cc6642f29a0adee$var$REGISTRY.getAllVisibleMetricsKeys.bind($2cc6642f29a0adee$var$REGISTRY);
    const $2cc6642f29a0adee$export$898df584445641cf = (metricKey)=>{
        switch(metricKey){
            case 0, (0, parcelRequire("lzUDm")).PROJECT_CLEANUP_KEY:
                return (0, (0, parcelRequire("4R6GH")).fg)('site-optimizer-project-cleanup');
            case 0, (0, parcelRequire("3AEMX")).PROJECT_ROLE_ACTOR_KEY:
            case 0, (0, parcelRequire("8MHQY")).CUSTOM_FIELDS_KEY:
            case 0, (0, parcelRequire("cOrKR")).ISSUE_KEY:
                return true;
            default:
                return false;
        }
    };
    const $2cc6642f29a0adee$export$cbadc5a7223772a8 = (_, message)=>{
        throw new Error(message);
    };
});
parcelRegister("8MHQY", function(module, exports) {
    $parcel$export(module.exports, "CUSTOM_FIELDS_KEY", ()=>$1dd393ebccb36050$export$d214286a7039b004);
    $parcel$export(module.exports, "CUSTOM_FIELDS", ()=>$1dd393ebccb36050$export$459112111ad5b136);
    var $9TSwz;
    const $1dd393ebccb36050$export$d214286a7039b004 = 'customField';
    const $1dd393ebccb36050$export$459112111ad5b136 = {
        key: $1dd393ebccb36050$export$d214286a7039b004,
        visible: true,
        name: (0, (0, parcelRequire("9TSwz")).default).name,
        description: (0, (0, parcelRequire("9TSwz")).default).description,
        tabLabels: [
            (0, (0, parcelRequire("9TSwz")).default).chart,
            (0, (0, parcelRequire("9TSwz")).default).reviewAndAnalyze
        ],
        warningMessage: (0, (0, parcelRequire("9TSwz")).default).warning,
        exceededMessage: (0, (0, parcelRequire("9TSwz")).default).exceeded,
        risks: [
            (0, (0, parcelRequire("9TSwz")).default).risk1
        ],
        mitigations: [],
        currentValueLabel: (0, (0, parcelRequire("9TSwz")).default).currentValueLabel,
        currentValueAriaLabel: (0, (0, parcelRequire("9TSwz")).default).currentValueAriaLabel,
        thresholdValueLabel: (0, (0, parcelRequire("9TSwz")).default).thresholdValueLabel,
        thresholdValueAriaLabel: (0, (0, parcelRequire("9TSwz")).default).thresholdValueAriaLabel,
        recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-your-custom-fields/',
        recommendationUrlText: (0, (0, parcelRequire("9TSwz")).default).recommendationUrlText,
        graphHeader: (0, (0, parcelRequire("9TSwz")).default).graphHeader
    };
});
parcelRegister("9TSwz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb4cda92a9b67081$export$2e2bcd8739ae039);
    var $7VHMR;
    const $eb4cda92a9b67081$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
    const $eb4cda92a9b67081$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
    const $eb4cda92a9b67081$var$CHART_DESC = 'A tab label of Custom Field Tabs, to show custom fields chart';
    const $eb4cda92a9b67081$var$REVIEW_AND_ANALYZE_DESC = 'A tab label of Custom Field Tabs, to show custom fields review and analyze';
    const $eb4cda92a9b67081$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
    const $eb4cda92a9b67081$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
    const $eb4cda92a9b67081$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
    const $eb4cda92a9b67081$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
    const $eb4cda92a9b67081$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
    const $eb4cda92a9b67081$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
    const $eb4cda92a9b67081$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
    const $eb4cda92a9b67081$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
    var $eb4cda92a9b67081$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        name: {
            "id": "admin-pages-performance.common.assets.custom-fields.name",
            "defaultMessage": "Custom fields"
        },
        description: {
            "id": "admin-pages-performance.common.assets.custom-fields.description",
            "defaultMessage": "Here are the custom fields in your site, including ones we think can be removed because they\u2019re not used. Removing unused fields could improve site performance and stability."
        },
        chart: {
            "id": "admin-pages-performance.common.assets.custom-fields.chart",
            "defaultMessage": "Overview"
        },
        reviewAndAnalyze: {
            "id": "admin-pages-performance.common.assets.custom-fields.review-and-analyze",
            "defaultMessage": "Analysis"
        },
        warning: {
            "id": "admin-pages-performance.common.assets.custom-fields.warning",
            "defaultMessage": "The number of custom fields is nearing our recommended threshold."
        },
        exceeded: {
            "id": "admin-pages-performance.common.assets.custom-fields.exceeded",
            "defaultMessage": "There are more custom fields than our recommended threshold."
        },
        risk1: {
            "id": "admin-pages-performance.common.assets.custom-fields.risk-1",
            "defaultMessage": "Custom fields can make searching for issues (JQL and boards) and creating issues slow."
        },
        mitigation1: {
            "id": "admin-pages-performance.common.assets.custom-fields.mitigation-1",
            "defaultMessage": "Edit the context for the custom field to make it visible only for specific projects."
        },
        mitigation2: {
            "id": "admin-pages-performance.common.assets.custom-fields.mitigation-2",
            "defaultMessage": "Limit the number of custom fields across all projects and use the same custom field in multiple projects."
        },
        currentValueLabel: {
            "id": "admin-pages-performance.common.assets.custom-fields.current-value-label",
            "defaultMessage": "Custom fields in your site"
        },
        thresholdValueLabel: {
            "id": "admin-pages-performance.common.assets.custom-fields.threshold-value-label",
            "defaultMessage": "Recommended maximum number of custom fields"
        },
        currentValueAriaLabel: {
            "id": "admin-pages-performance.common.assets.custom-fields.current-value-aria-label",
            "defaultMessage": "{number} custom fields in your site"
        },
        thresholdValueAriaLabel: {
            "id": "admin-pages-performance.common.assets.custom-fields.threshold-value-aria-label",
            "defaultMessage": "{number} recommended maximum number of custom fields"
        },
        recommendationUrlText: {
            "id": "admin-pages-performance.common.assets.custom-fields.recommendation-url-text",
            "defaultMessage": "See how we identify these fields."
        },
        graphHeader: {
            "id": "admin-pages-performance.common.assets.custom-fields.graph-header",
            "defaultMessage": "Custom fields over time"
        }
    });
});
parcelRegister("cOrKR", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_KEY", ()=>$a0748d951ae09b9b$export$5daa28d10e23592);
    $parcel$export(module.exports, "ISSUE", ()=>$a0748d951ae09b9b$export$76a449e52fa0e1e8);
    var $jWT6h;
    const $a0748d951ae09b9b$export$5daa28d10e23592 = 'issue';
    const $a0748d951ae09b9b$export$76a449e52fa0e1e8 = {
        key: $a0748d951ae09b9b$export$5daa28d10e23592,
        visible: true,
        name: (0, (0, parcelRequire("jWT6h")).default).name,
        description: (0, (0, parcelRequire("jWT6h")).default).description,
        tabLabels: [
            (0, (0, parcelRequire("jWT6h")).default).reviewAndAnalyze,
            (0, (0, parcelRequire("jWT6h")).default).activityLog
        ],
        warningMessage: (0, (0, parcelRequire("jWT6h")).default).warning,
        exceededMessage: (0, (0, parcelRequire("jWT6h")).default).exceeded,
        risks: [
            (0, (0, parcelRequire("jWT6h")).default).risk1
        ],
        mitigations: [
            (0, (0, parcelRequire("jWT6h")).default).mitigation1,
            (0, (0, parcelRequire("jWT6h")).default).mitigation2,
            (0, (0, parcelRequire("jWT6h")).default).mitigation3
        ],
        currentValueLabel: (0, (0, parcelRequire("jWT6h")).default).currentValueLabel,
        currentValueAriaLabel: (0, (0, parcelRequire("jWT6h")).default).currentValueAriaLabel,
        thresholdValueLabel: (0, (0, parcelRequire("jWT6h")).default).thresholdValueLabel,
        thresholdValueAriaLabel: (0, (0, parcelRequire("jWT6h")).default).thresholdValueAriaLabel,
        graphHeader: (0, (0, parcelRequire("jWT6h")).default).graphHeader
    };
});
parcelRegister("jWT6h", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5991724b8695ea5$export$2e2bcd8739ae039);
    var $7VHMR;
    const $a5991724b8695ea5$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
    const $a5991724b8695ea5$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
    const $a5991724b8695ea5$var$CHART_DESC = 'A tab label of Issue Tabs, to show Issue chart';
    const $a5991724b8695ea5$var$REVIEW_AND_ANALYZE_DESC = 'A tab label of Issue Tabs, to show issue review and analyze';
    const $a5991724b8695ea5$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
    const $a5991724b8695ea5$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
    const $a5991724b8695ea5$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
    const $a5991724b8695ea5$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
    const $a5991724b8695ea5$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
    const $a5991724b8695ea5$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
    const $a5991724b8695ea5$var$ACTIVITY_LOG_DESC = 'A tab label of Activity Log Tabs, to show Issue Archival past operations';
    const $a5991724b8695ea5$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
    var $a5991724b8695ea5$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        name: {
            "id": "admin-pages-performance.common.assets.issue.name",
            "defaultMessage": "Issues"
        },
        description: {
            "id": "admin-pages-performance.common.assets.issue.description",
            "defaultMessage": "Here\u2019s a quick snapshot of the total number of issues in your site, including some that we think can be archived. Archiving unused issues can improve performance and stability of your site."
        },
        chart: {
            "id": "admin-pages-performance.common.assets.issue.chart",
            "defaultMessage": "Overview"
        },
        reviewAndAnalyze: {
            "id": "admin-pages-performance.common.assets.issue.review-and-analyze",
            "defaultMessage": "Analysis"
        },
        activityLog: {
            "id": "admin-pages-performance.common.assets.issue.activity-log",
            "defaultMessage": "Activity log"
        },
        warning: {
            "id": "admin-pages-performance.common.assets.issue.warning",
            "defaultMessage": "The number of issues in the system is nearing our recommended threshold."
        },
        exceeded: {
            "id": "admin-pages-performance.common.assets.issue.exceeded",
            "defaultMessage": "There are more issues in the system than our recommended threshold."
        },
        risk1: {
            "id": "admin-pages-performance.common.assets.issue.risk-1",
            "defaultMessage": "If you have too many issues you may find searches, automations, and workflow rules are slower than usual."
        },
        mitigation1: {
            "id": "admin-pages-performance.common.assets.issue.mitigation-1",
            "defaultMessage": "Delete any projects that are no longer required."
        },
        mitigation2: {
            "id": "admin-pages-performance.common.assets.issue.mitigation-2",
            "defaultMessage": "Disable Jira integrations that create issues you don't need."
        },
        mitigation3: {
            "id": "admin-pages-performance.common.assets.issue.mitigation-3",
            "defaultMessage": "Delete old issues that are no longer required. Use a JQL query to find issues older than a year (\u201Ccreated < -365d order by created DESC\u201C)."
        },
        currentValueLabel: {
            "id": "admin-pages-performance.common.assets.issue.current-value-label",
            "defaultMessage": "Total current issues in your site"
        },
        thresholdValueLabel: {
            "id": "admin-pages-performance.common.assets.issue.threshold-value-label",
            "defaultMessage": "Recommended maximum number of issues"
        },
        currentValueAriaLabel: {
            "id": "admin-pages-performance.common.assets.issue.current-value-aria-label",
            "defaultMessage": "{number} total current issues in your site"
        },
        thresholdValueAriaLabel: {
            "id": "admin-pages-performance.common.assets.issue.threshold-value-aria-label",
            "defaultMessage": "{number} recommended maximum number of issues"
        },
        graphHeader: {
            "id": "admin-pages-performance.common.assets.issue.graph-header",
            "defaultMessage": "Issues over time"
        }
    });
});
parcelRegister("3AEMX", function(module, exports) {
    $parcel$export(module.exports, "PROJECT_ROLE_ACTOR_KEY", ()=>$c7627c0e6530f4b1$export$a570ca3f6cc5e280);
    $parcel$export(module.exports, "PROJECT_ROLE_ACTOR", ()=>$c7627c0e6530f4b1$export$fc3d2ee6c3fb3908);
    var $j0D55;
    const $c7627c0e6530f4b1$export$a570ca3f6cc5e280 = 'projectroleactor';
    const $c7627c0e6530f4b1$export$fc3d2ee6c3fb3908 = {
        key: $c7627c0e6530f4b1$export$a570ca3f6cc5e280,
        visible: true,
        name: (0, (0, parcelRequire("j0D55")).default).name,
        description: (0, (0, parcelRequire("j0D55")).default).description,
        tabLabels: [
            (0, (0, parcelRequire("j0D55")).default).analysis,
            (0, (0, parcelRequire("j0D55")).default).activityLog
        ],
        warningMessage: (0, (0, parcelRequire("j0D55")).default).warning,
        exceededMessage: (0, (0, parcelRequire("j0D55")).default).exceeded,
        risks: [
            (0, (0, parcelRequire("j0D55")).default).risk1
        ],
        mitigations: [
            (0, (0, parcelRequire("j0D55")).default).mitigation1,
            (0, (0, parcelRequire("j0D55")).default).mitigation2,
            (0, (0, parcelRequire("j0D55")).default).mitigation3
        ],
        currentValueLabel: (0, (0, parcelRequire("j0D55")).default).currentValueLabel,
        currentValueAriaLabel: (0, (0, parcelRequire("j0D55")).default).currentValueAriaLabel,
        thresholdValueLabel: (0, (0, parcelRequire("j0D55")).default).thresholdValueLabel,
        thresholdValueAriaLabel: (0, (0, parcelRequire("j0D55")).default).thresholdValueAriaLabel,
        recommendationUrl: 'https://support.atlassian.com/jira-cloud-administration/docs/optimize-your-number-of-project-role-memberships/',
        recommendationUrlText: (0, (0, parcelRequire("j0D55")).default).recommendationUrlText,
        graphHeader: (0, (0, parcelRequire("j0D55")).default).graphHeader
    };
});
parcelRegister("j0D55", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6549fa32a8352dcb$export$2e2bcd8739ae039);
    var $7VHMR;
    const $6549fa32a8352dcb$var$NAME_DESC = 'Name of the site optimizer metric that will be used as the title on the page and menu item.';
    const $6549fa32a8352dcb$var$DESCRIPTON_DESC = 'Description of the site optimizer metric.';
    const $6549fa32a8352dcb$var$WARNING_DESC = 'Warning message if metric are getting close to the threshold.';
    const $6549fa32a8352dcb$var$EXCEEDED_DESC = 'Message to show to the user if metric has exceeded the threshold.';
    const $6549fa32a8352dcb$var$RISK_DESC = 'One of the risks when this metric exceeded the threshold.';
    const $6549fa32a8352dcb$var$MITIGATION_DESC = 'One of the mitigation options when this metric exceeded the threshold.';
    const $6549fa32a8352dcb$var$CURRENT_VALUE_LABEL_DESC = 'Label to be shown next to the current value of the metric.';
    const $6549fa32a8352dcb$var$THRESHOLD_VALUE_LABEL_DESC = 'Label to be shown next to the threshold value of the metric.';
    const $6549fa32a8352dcb$var$RECOMMENDATION_URL_TEXT_DESC = 'Text to be shown on the hypertext link to additional documentation.';
    const $6549fa32a8352dcb$var$GRAPH_HEADER_DESC = 'Text to be shown on the header of the metric graph.';
    var $6549fa32a8352dcb$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        name: {
            "id": "admin-pages-performance.common.assets.project-role-actor.name",
            "defaultMessage": "Project role permissions"
        },
        description: {
            "id": "admin-pages-performance.common.assets.project-role-actor.description",
            "defaultMessage": "Here's a quick snapshot of the total number of project role permissions across your site."
        },
        analysis: {
            "id": "admin-pages-performance.common.assets.project-role-actor.analysis",
            "defaultMessage": "Analysis"
        },
        activityLog: {
            "id": "admin-pages-performance.common.assets.project-role-actor.activity-log",
            "defaultMessage": "Activity log"
        },
        warning: {
            "id": "admin-pages-performance.common.assets.project-role-actor.warning",
            "defaultMessage": "Your number of project role memberships is nearing the recommended threshold."
        },
        exceeded: {
            "id": "admin-pages-performance.common.assets.project-role-actor.exceeded",
            "defaultMessage": "Your number of project role memberships is over the recommended threshold."
        },
        risk1: {
            "id": "admin-pages-performance.common.assets.project-role-actor.risk-1",
            "defaultMessage": "When the number of project role memberships (users or groups) increases, viewing, searching, and creating issues becomes slower."
        },
        mitigation1: {
            "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-1",
            "defaultMessage": "Remove users who no longer need access to your site rather than only suspending them. Suspending users removes their permission but not their project role membership."
        },
        mitigation2: {
            "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-2",
            "defaultMessage": "Give memberships to groups of users instead of individual users. Granting membership to a group of 50 users count as 1 membership whereas granting memberships to 50 single users counts as 50 memberships."
        },
        mitigation3: {
            "id": "admin-pages-performance.common.assets.project-role-actor.mitigation-3",
            "defaultMessage": "Use the default project role members in your permission scheme."
        },
        currentValueLabel: {
            "id": "admin-pages-performance.common.assets.project-role-actor.current-value-label",
            "defaultMessage": "Current project role permissions in your site"
        },
        thresholdValueLabel: {
            "id": "admin-pages-performance.common.assets.project-role-actor.threshold-value-label",
            "defaultMessage": "Recommended maximum number of permissions"
        },
        currentValueAriaLabel: {
            "id": "admin-pages-performance.common.assets.project-role-actor.current-value-aria-label",
            "defaultMessage": "{number} current project role permissions in your site"
        },
        thresholdValueAriaLabel: {
            "id": "admin-pages-performance.common.assets.project-role-actor.threshold-value-aria-label",
            "defaultMessage": "{number} recommended maximum number of permissions"
        },
        recommendationUrlText: {
            "id": "admin-pages-performance.common.assets.project-role-actor.recommendation-url-text",
            "defaultMessage": "Learn more about optimizing your project role memberships."
        },
        graphHeader: {
            "id": "admin-pages-performance.common.assets.project-role-actor.graph-header",
            "defaultMessage": "Project role permissions over time"
        }
    });
});
parcelRegister("gtb9f", function(module, exports) {
    $parcel$export(module.exports, "METRICS", ()=>$713364f722667f6e$export$3f0e99ae6e0ec541);
    $parcel$export(module.exports, "RUN_ANALYSIS", ()=>$713364f722667f6e$export$769b1a9477352cf9);
    $parcel$export(module.exports, "DELETE_RECOMMENDATIONS", ()=>$713364f722667f6e$export$e7e31b14c32e055a);
    $parcel$export(module.exports, "DELETE_RECOMMENDATIONS_DROPDOWN", ()=>$713364f722667f6e$export$d96fe00ff2b38bae);
    $parcel$export(module.exports, "DELETE_RECOMMENDATIONS_CONFIRM", ()=>$713364f722667f6e$export$3d4bb5f187c6844e);
    $parcel$export(module.exports, "DELETE_RECOMMENDATIONS_CANCEL", ()=>$713364f722667f6e$export$5c1079e323f5d5bd);
    $parcel$export(module.exports, "TAB_CLICKED", ()=>$713364f722667f6e$export$d358fc12daa9f606);
    $parcel$export(module.exports, "RECOMMENDATIONS_LOADED", ()=>$713364f722667f6e$export$60cc0c61c99a5b81);
    $parcel$export(module.exports, "METRIC_CARD_CLICKED", ()=>$713364f722667f6e$export$71794f4d197278dc);
    $parcel$export(module.exports, "PROJECT_ROLE_ACTOR_FILTER_BY_PROJECT", ()=>$713364f722667f6e$export$9e34afbf86922b4a);
    $parcel$export(module.exports, "projectRoleActorAttributes", ()=>$713364f722667f6e$export$d6761557c91eea50);
    $parcel$export(module.exports, "ARCHIVE_ISSUES_CONFIRM", ()=>$713364f722667f6e$export$4e4b9391f7936ba2);
    $parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES", ()=>$713364f722667f6e$export$70525d18051240f4);
    $parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES_CANCEL", ()=>$713364f722667f6e$export$4951e0e034b50b9c);
    $parcel$export(module.exports, "RESTORE_ARCHIVE_ISSUES_TRY_AGAIN", ()=>$713364f722667f6e$export$108288df7758f60c);
    $parcel$export(module.exports, "VIEW_ISSUES", ()=>$713364f722667f6e$export$972d5a8da0d9f4c3);
    $parcel$export(module.exports, "STOP_ISSUE_ARCHIVAL", ()=>$713364f722667f6e$export$b920363d50bcf753);
    $parcel$export(module.exports, "ISSUE_UNARCHIVAL_COMPLETED", ()=>$713364f722667f6e$export$a84a5210fbad774);
    $parcel$export(module.exports, "JQL_SEARCH", ()=>$713364f722667f6e$export$5c2df36fdd8476f7);
    $parcel$export(module.exports, "DEFAULT_QUERY_SELECTED", ()=>$713364f722667f6e$export$77f23f1b921d5321);
    $parcel$export(module.exports, "issueAnalyticsAttributes", ()=>$713364f722667f6e$export$c62a52f3f7d80ec3);
    $parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH", ()=>$713364f722667f6e$export$8daffc99348bf555);
    $parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH_CONFIRM", ()=>$713364f722667f6e$export$20f13a04bc3e5d74);
    $parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_TRASH_CANCEL", ()=>$713364f722667f6e$export$ed285e0e924b673c);
    $parcel$export(module.exports, "CUSTOM_FIELD_MOVE_TO_SUCCEEDED", ()=>$713364f722667f6e$export$26f5d7eae10db511);
    $parcel$export(module.exports, "customFieldAttributes", ()=>$713364f722667f6e$export$33989f74b6ba0674);
    $parcel$export(module.exports, "METRICS_SPOTLIGHT_STARTED", ()=>$713364f722667f6e$export$d39b24a650c6c79d);
    $parcel$export(module.exports, "METRICS_SPOTLIGHT_DISMISSED", ()=>$713364f722667f6e$export$eca4028936acf763);
    $parcel$export(module.exports, "METRICS_SPOTLIGHT_COMPLETED", ()=>$713364f722667f6e$export$9ba0a5caedb0ff37);
    $parcel$export(module.exports, "RESTORE_ACTIVITY_LOG", ()=>$713364f722667f6e$export$7b6bf63452d40db8);
    $parcel$export(module.exports, "DOWNLOAD_CSV", ()=>$713364f722667f6e$export$efdb93c7210090d1);
    $parcel$export(module.exports, "PROJECT_CLEANUP_FILTERS_CLEARED", ()=>$713364f722667f6e$export$6c650be5c2b4774f);
    $parcel$export(module.exports, "PROJECT_CLEANUP_FILTER_BY_PROJECT", ()=>$713364f722667f6e$export$6493dd0e190d3f58);
    $parcel$export(module.exports, "PROJECT_CLEANUP_FILTER_BY_STALE", ()=>$713364f722667f6e$export$422673ba1cec4aed);
    $parcel$export(module.exports, "PROJECT_CLEAN_UP", ()=>$713364f722667f6e$export$3a7186fc63c9e188);
    $parcel$export(module.exports, "PROJECT_CLEANUP_COMPLETED", ()=>$713364f722667f6e$export$8e0b8859a3cbd9e6);
    $parcel$export(module.exports, "ACTION_TRASH", ()=>$713364f722667f6e$export$342d8b9804e407c7);
    $parcel$export(module.exports, "ACTION_ARCHIVE", ()=>$713364f722667f6e$export$b685f2109baf2b4f);
    $parcel$export(module.exports, "ACTION_UNARCHIVE", ()=>$713364f722667f6e$export$3ac60b381ed426ca);
    var $8MHQY;
    var $cOrKR;
    var $lzUDm;
    var $3AEMX;
    const $713364f722667f6e$export$3f0e99ae6e0ec541 = [
        (0, (0, parcelRequire("8MHQY")).CUSTOM_FIELDS),
        (0, (0, parcelRequire("cOrKR")).ISSUE),
        (0, (0, parcelRequire("3AEMX")).PROJECT_ROLE_ACTOR),
        (0, (0, parcelRequire("lzUDm")).PROJECT_CLEANUP)
    ];
    const $713364f722667f6e$export$769b1a9477352cf9 = 'runAnalysis';
    const $713364f722667f6e$export$e7e31b14c32e055a = 'deleteRecommendations';
    const $713364f722667f6e$export$d96fe00ff2b38bae = 'deleteRecommendationsDropdown';
    const $713364f722667f6e$export$3d4bb5f187c6844e = 'deleteRecommendationsConfirm';
    const $713364f722667f6e$export$5c1079e323f5d5bd = 'deleteRecommendationsCancel';
    const $713364f722667f6e$export$d358fc12daa9f606 = 'psiTab';
    const $713364f722667f6e$export$60cc0c61c99a5b81 = 'recommendations loaded';
    const $713364f722667f6e$export$71794f4d197278dc = 'mitigationMetricCard';
    const $713364f722667f6e$export$9e34afbf86922b4a = 'projectRoleActorFilterByProject';
    const $713364f722667f6e$export$d6761557c91eea50 = {
        metric: (0, (0, parcelRequire("3AEMX")).PROJECT_ROLE_ACTOR_KEY)
    };
    const $713364f722667f6e$export$4e4b9391f7936ba2 = 'archiveIssuesConfirm';
    const $713364f722667f6e$export$70525d18051240f4 = 'restoreIssueArchival';
    const $713364f722667f6e$export$4951e0e034b50b9c = 'restoreIssueCancel';
    const $713364f722667f6e$export$108288df7758f60c = 'restoreIssueTryAgain';
    const $713364f722667f6e$export$972d5a8da0d9f4c3 = 'viewIssues';
    const $713364f722667f6e$export$b920363d50bcf753 = 'stopIssueArchival';
    const $713364f722667f6e$export$a84a5210fbad774 = 'restoreIssueArchival completed';
    const $713364f722667f6e$export$5c2df36fdd8476f7 = 'jqlSearch';
    const $713364f722667f6e$export$77f23f1b921d5321 = 'defaultQuerySelected';
    const $713364f722667f6e$export$c62a52f3f7d80ec3 = {
        metric: (0, (0, parcelRequire("cOrKR")).ISSUE_KEY)
    };
    const $713364f722667f6e$export$8daffc99348bf555 = 'customFieldMoveToTrash';
    const $713364f722667f6e$export$20f13a04bc3e5d74 = 'customFieldMoveToTrashConfirm';
    const $713364f722667f6e$export$ed285e0e924b673c = 'customFieldMoveToTrashCancel';
    const $713364f722667f6e$export$26f5d7eae10db511 = 'customFieldMoveToTrash succeeded';
    const $713364f722667f6e$export$33989f74b6ba0674 = {
        metric: (0, (0, parcelRequire("8MHQY")).CUSTOM_FIELDS).key
    };
    const $713364f722667f6e$export$d39b24a650c6c79d = 'metricPerformanceSpotlight started';
    const $713364f722667f6e$export$eca4028936acf763 = 'metricPerformanceSpotlightDismissed';
    const $713364f722667f6e$export$9ba0a5caedb0ff37 = 'metricPerformanceSpotlight completed';
    const $713364f722667f6e$export$7b6bf63452d40db8 = 'restoreActivityLog';
    const $713364f722667f6e$export$efdb93c7210090d1 = 'downloadActivityLogCsv';
    const $713364f722667f6e$export$6c650be5c2b4774f = 'projectCleanupFiltersCleared';
    const $713364f722667f6e$export$6493dd0e190d3f58 = 'projectCleanupFilterByProjectState';
    const $713364f722667f6e$export$422673ba1cec4aed = 'projectCleanupFilterByStale';
    const $713364f722667f6e$export$3a7186fc63c9e188 = 'projectCleanUp';
    const $713364f722667f6e$export$8e0b8859a3cbd9e6 = 'projectCleanup completed';
    const $713364f722667f6e$export$342d8b9804e407c7 = 'TRASH';
    const $713364f722667f6e$export$b685f2109baf2b4f = 'ARCHIVE';
    const $713364f722667f6e$export$3ac60b381ed426ca = 'UNARCHIVE';
});
parcelRegister("etuUp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df7d950b94f108ee$export$2e2bcd8739ae039);
    var $7VHMR;
    var $df7d950b94f108ee$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.title",
            "defaultMessage": "Site optimizer"
        },
        overview: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.overview",
            "defaultMessage": "Overview"
        },
        allReports: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.all-reports",
            "defaultMessage": "All reports"
        }
    });
});
parcelRegister("jWIOc", function(module, exports) {
    $parcel$export(module.exports, "PROJECT_CLEANUP_SPOTLIGHT_NAME", ()=>$fa0cf627da3f1f38$export$4150c6a7c9be0102);
    $parcel$export(module.exports, "ProjectCleanupSpotlight", ()=>$fa0cf627da3f1f38$export$6dc8afd0c00f9525);
    var $5uXOq = parcelRequire("5uXOq");
    var $5MdCt;
    var $koVbs;
    var $ehdJY;
    var $k43Y2;
    var $8881D;
    const $fa0cf627da3f1f38$export$4150c6a7c9be0102 = 'site-optimiser-project-cleanup-spotlight-nav';
    const $fa0cf627da3f1f38$export$6dc8afd0c00f9525 = (0, $5uXOq.memo)(()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isProjectCleanupSpotlightActive, setIsProjectCleanupSpotlightActive] = (0, (0, parcelRequire("k43Y2")).useProjectCleanupSpotlight)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5MdCt")).default), null, isProjectCleanupSpotlightActive && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehdJY")).JiraSpotlight), {
            actions: [
                {
                    onClick: ()=>setIsProjectCleanupSpotlightActive(false),
                    text: formatMessage((0, (0, parcelRequire("8881D")).default).spotlightAction)
                }
            ],
            heading: formatMessage((0, (0, parcelRequire("8881D")).default).spotlightHeading),
            target: $fa0cf627da3f1f38$export$4150c6a7c9be0102,
            key: $fa0cf627da3f1f38$export$4150c6a7c9be0102,
            targetRadius: 3,
            targetBgColor: "var(--ds-surface, #FFFFFF)",
            dialogPlacement: "right top",
            messageId: "navigation-apps-sidebar-global-settings-system.ui.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.jira-spotlight",
            messageType: "engagement"
        }, formatMessage((0, (0, parcelRequire("8881D")).default).spotlightDescription)));
    });
});
parcelRegister("k43Y2", function(module, exports) {
    $parcel$export(module.exports, "useProjectCleanupSpotlight", ()=>$249ebdaf0c0fc22c$export$780bcf6e3ebf2d12);
    var $5uXOq = parcelRequire("5uXOq");
    var $iyJxC;
    var $90yGq;
    const $249ebdaf0c0fc22c$var$PROPERTY_KEY = 'jira.user.settings.system.project-cleanup-onboarding-spotlight';
    const $249ebdaf0c0fc22c$export$780bcf6e3ebf2d12 = ()=>{
        const accountId = (0, (0, parcelRequire("90yGq")).useAccountId)();
        const [isProjectCleanupSpotlightActive, setIsProjectCleanupSpotlightActive] = (0, $5uXOq.useState)(false);
        const getHasSeenProjectCleanupSpotlight = async (id)=>{
            const response = await (0, (0, parcelRequire("iyJxC")).getUserProperty)({
                accountId: id,
                propertyKey: $249ebdaf0c0fc22c$var$PROPERTY_KEY,
                defaultValue: false
            });
            if (!response.value) {
                await (0, (0, parcelRequire("iyJxC")).setUserProperty)({
                    accountId: id,
                    propertyKey: $249ebdaf0c0fc22c$var$PROPERTY_KEY,
                    propertyValue: true
                });
                return false;
            }
            return true;
        };
        const fetchSpotlightState = (0, $5uXOq.useCallback)(async ()=>{
            if (accountId !== null) {
                const response = await getHasSeenProjectCleanupSpotlight(accountId);
                setIsProjectCleanupSpotlightActive(!response);
            }
        }, [
            accountId
        ]);
        (0, $5uXOq.useEffect)(()=>{
            fetchSpotlightState();
        }, [
            fetchSpotlightState
        ]);
        return [
            isProjectCleanupSpotlightActive,
            setIsProjectCleanupSpotlightActive
        ];
    };
});
parcelRegister("iyJxC", function(module, exports) {
    $parcel$export(module.exports, "getUserProperty", ()=>$5455121d227e33bb$export$b3126db2ef6e34ed);
    $parcel$export(module.exports, "setUserProperty", ()=>$5455121d227e33bb$export$ba821ce5e177c7ef);
    var $jcw0u;
    var $eusud;
    const $5455121d227e33bb$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
    const $5455121d227e33bb$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
        const url = $5455121d227e33bb$var$getUserUrl(accountId, propertyKey);
        try {
            const response = await fetch(url, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.status === 404) return {
                key: propertyKey,
                value: defaultValue
            };
            if (response.ok) return await response.json();
            throw new Error(`Fetching ${propertyKey} user property failed.`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'getUserProperty',
                    packageName: 'jiraAdminPagesPerformance',
                    teamName: 'cherenkov'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return {
                key: propertyKey,
                value: defaultValue
            };
        }
    };
    const $5455121d227e33bb$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
        const url = $5455121d227e33bb$var$getUserUrl(accountId, propertyKey);
        try {
            await (0, (0, parcelRequire("eusud")).performPutRequest)(url, {
                body: JSON.stringify(propertyValue)
            });
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'setUserProperty',
                    packageName: 'jiraAdminPagesPerformance',
                    teamName: 'cherenkov'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
});
parcelRegister("8881D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86d0877c08ff02be$export$2e2bcd8739ae039);
    var $7VHMR;
    var $86d0877c08ff02be$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        spotlightHeading: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-heading",
            "defaultMessage": "Clean out unused projects"
        },
        spotlightDescription: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-description",
            "defaultMessage": "Quickly remove inactive or empty projects to improve your site\u2019s performance. "
        },
        spotlightAction: {
            "id": "spa-apps-sidebar-global-settings-system.menu.troubleshooting-and-support.performance-menu-item.performance-and-scale-menu.spotlight.spotlight-action",
            "defaultMessage": "Ok"
        }
    });
});
parcelRegister("fM231", function(module, exports) {
    $parcel$export(module.exports, "hasSeenSiteOptimiserSpotlight", ()=>$879944d685aae4de$export$3ed4e8541d8ba40);
    var $iyJxC;
    const $879944d685aae4de$var$PROPERTY_KEY = 'jira.user.settings.system.site-optimizer-spotlight';
    const $879944d685aae4de$export$3ed4e8541d8ba40 = async (accountId)=>{
        const response = await (0, (0, parcelRequire("iyJxC")).getUserProperty)({
            accountId: accountId,
            propertyKey: $879944d685aae4de$var$PROPERTY_KEY,
            defaultValue: false
        });
        if (!response.value) {
            await (0, (0, parcelRequire("iyJxC")).setUserProperty)({
                accountId: accountId,
                propertyKey: $879944d685aae4de$var$PROPERTY_KEY,
                propertyValue: true
            });
            return false;
        }
        return true;
    };
});
parcelRegister("ie4oV", function(module, exports) {
    $parcel$export(module.exports, "isViewAuditingSelected", ()=>$84aa4044b145a05a$export$6da8ca04904513f9);
    var $4OCke;
    const $84aa4044b145a05a$var$VIEW_AUDITING_PATH_REGEXP = /\/auditing\/(\w+)/i;
    const $84aa4044b145a05a$export$6da8ca04904513f9 = (currentLocation, itemLocation)=>(0, (0, parcelRequire("4OCke")).matchUrlExact)()(currentLocation, itemLocation) || $84aa4044b145a05a$var$VIEW_AUDITING_PATH_REGEXP.test(currentLocation.pathname);
});
parcelRegister("71ORT", function(module, exports) {
    $parcel$export(module.exports, "UserInterfaceSection", ()=>$4dae17d9419cb38f$export$c4128359313d3f58);
    var $5uXOq = parcelRequire("5uXOq");
    var $cZXEh;
    var $5tOuG;
    var $65Ltd;
    var $koVbs;
    var $k0ZZ2;
    var $17bH5;
    var $4OCke;
    var $itmJb;
    var $jMBA3;
    var $jDUf4;
    const $4dae17d9419cb38f$export$c4128359313d3f58 = ()=>{
        const isJiraAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const { data: features } = (0, (0, parcelRequire("jMBA3")).useFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const navigationPath = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("17bH5")).getSystemNavigationPaths)(), []);
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), {
            title: formatMessage((0, (0, parcelRequire("jDUf4")).default).userInterface)
        }, features.hasUserDefaults && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'user-defaults'
            },
            href: navigationPath.userInterfacesUserDefaults,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("jDUf4")).default).userDefaults)), features.hasEditDefaultDashboard && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'edit-default-dashboard'
            },
            href: navigationPath.userInterfacesEditDefaultDashboard,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("jDUf4")).default).systemDashboard)), features.hasLookAndFeel && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'look-and-feel'
            },
            href: navigationPath.userInterfacesLookAndFeel,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("jDUf4")).default).lookAndFeel)), features.hasPasAdmin && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'pas-admin-link-jira'
            },
            href: navigationPath.userInterfacesPasAdmin,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("jDUf4")).default).pasAdmin)), isJiraAdmin && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'announcement-banner'
            },
            href: navigationPath.userInterfacesSiteAdmin,
            selectedOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_ANNOUNCEMENT_BANNER)
            ]
        }, formatMessage((0, (0, parcelRequire("jDUf4")).default).announcementBanner)));
    };
});
parcelRegister("jDUf4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6f12d9a643fcf4ed$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6f12d9a643fcf4ed$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        userInterface: {
            "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.user-interface",
            "defaultMessage": "User Interface"
        },
        userDefaults: {
            "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.user-defaults",
            "defaultMessage": "Default user preferences"
        },
        systemDashboard: {
            "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.system-dashboard",
            "defaultMessage": "Default dashboard"
        },
        lookAndFeel: {
            "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.look-and-feel",
            "defaultMessage": "Look and feel"
        },
        pasAdmin: {
            "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.pas-admin",
            "defaultMessage": "Public Announcement Service"
        },
        announcementBanner: {
            "id": "spa-apps-sidebar-global-settings-system.menu.user-interface.announcement-banner",
            "defaultMessage": "Announcement banner"
        }
    });
});
parcelRegister("3jrxv", function(module, exports) {
    $parcel$export(module.exports, "isGeneralConfigurationSelected", ()=>$e6139421bb00cae6$export$ba31cfa97c56eefd);
    var $4OCke;
    const $e6139421bb00cae6$var$APPLICATION_PROPERTIES_PATH_REGEXP = /\/admin\/(\w+)ApplicationProperties/i;
    const $e6139421bb00cae6$export$ba31cfa97c56eefd = (currentLocation, itemLocation)=>(0, (0, parcelRequire("4OCke")).matchUrlExact)()(currentLocation, itemLocation) || $e6139421bb00cae6$var$APPLICATION_PROPERTIES_PATH_REGEXP.test(currentLocation.pathname);
});
parcelRegister("gASEv", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemBulkMailRoute", ()=>$0d9145f2b68b8850$export$2b269dcf51f5a4d3);
    var $65Ltd;
    const $0d9145f2b68b8850$export$2b269dcf51f5a4d3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_BULK_MAIL),
        path: '/jira/settings/system/send-email'
    };
});
parcelRegister("5FGTk", function(module, exports) {
    $parcel$export(module.exports, "LazyBulkEmail", ()=>$0240d4f2c2b35825$export$416f8039fbf50bea);
    $parcel$export(module.exports, "default", ()=>$0240d4f2c2b35825$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $0240d4f2c2b35825$export$416f8039fbf50bea = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fg3s6"))), {
        moduleId: "./src/packages/admin-pages/bulk-email/src/index.tsx"
    });
    var $0240d4f2c2b35825$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0240d4f2c2b35825$export$416f8039fbf50bea,
            pageId: "jira-admin-pages-bulk-email",
            shouldShowSpinner: true
        });
});
parcelRegister("fg3s6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("h9UUp").then(()=>parcelRequire('8Z6uP'));
});
parcelRegister("fxhat", function(module, exports) {
    $parcel$export(module.exports, "performanceAndScaleRouteEntries", ()=>$075838c1f3f096db$export$98e757ecbae3f469);
    var $ffza4;
    var $cSD7y;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $clE6J;
    var $fppzq;
    var $5lsNZ;
    var $6kCEi;
    var $2vX6Y;
    var $kxXsG;
    var $7BrHr;
    var $gq1Xn;
    var $408O8;
    const $075838c1f3f096db$export$98e757ecbae3f469 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fppzq")).globalSettingsPerformanceOverviewRoute), ()=>({
                component: (0, (0, parcelRequire("408O8")).default),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("clE6J")).metricsOverviewPageResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("408O8")).LazyOverview)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fppzq")).globalSettingsPerformanceMetricDetailRoute), ()=>({
                component: (0, (0, parcelRequire("gq1Xn")).RedirectToExactMetricRoutes),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fppzq")).globalSettingsPerformanceProjectCleanupRoute), ()=>({
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('site-optimizer-project-cleanup', (0, (0, parcelRequire("kxXsG")).ProjectCleanupMetricDetail), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("kxXsG")).LazyProjectCleanupDetail)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fppzq")).globalSettingsPerformanceCustomFieldRoute), ()=>({
                component: (0, (0, parcelRequire("6kCEi")).CustomFieldMetricDetail),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("6kCEi")).LazyCustomFieldDetail)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fppzq")).globalSettingsPerformanceIssueArchivalRoute), ()=>({
                component: (0, (0, parcelRequire("2vX6Y")).IssueMetricDetail),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("2vX6Y")).LazyIssueDetail)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("fppzq")).globalSettingsPerformanceProjectRoleActorRoute), ()=>({
                component: (0, (0, parcelRequire("7BrHr")).ProjectRoleActorMetricDetail),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("7BrHr")).LazyProjectRoleActorDetail)
                ]
            }))
    ];
});
parcelRegister("clE6J", function(module, exports) {
    $parcel$export(module.exports, "metricsOverviewPageResource", ()=>$624fad9c7a7951b4$export$ac0b4ef4ec4987ae);
    var $ao2h1;
    var $hOOQr;
    const $624fad9c7a7951b4$export$ac0b4ef4ec4987ae = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'ADMIN_PAGES_PERFORMANCE_OVERVIEW',
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("hOOQr")).default),
                variables: {
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'network-only'
                }
            })
    });
});
parcelRegister("hOOQr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69a9f121a9ac63a8$export$2e2bcd8739ae039);
    const $69a9f121a9ac63a8$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "main_adminPagesPerformance_Overview_Query",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v1,
                                        "concreteType": "JiraResourceUsageMetricConnection",
                                        "kind": "LinkedField",
                                        "name": "resourceUsageMetrics",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "main_adminPagesPerformance_OverviewPage"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.resourceUsageMetrics"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "main_adminPagesPerformance_Overview_Query",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "concreteType": "JiraResourceUsageMetricConnection",
                                "kind": "LinkedField",
                                "name": "resourceUsageMetrics",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraResourceUsageMetric",
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "key"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "currentValue"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "warningValue"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "thresholdValue"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "cleanupValue"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "id"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "d2fe73ca0b47245563666951f775b77a3a261da2aeb574c289b15d04a8a13008",
                "metadata": {},
                "name": "main_adminPagesPerformance_Overview_Query",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $69a9f121a9ac63a8$var$node.hash = "65285ab59e67a0f62edb54671f986ddd";
    var $69a9f121a9ac63a8$export$2e2bcd8739ae039 = $69a9f121a9ac63a8$var$node;
});
parcelRegister("fppzq", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsPerformanceOverviewRoute", ()=>$9aee66b3178a7753$export$677fc3a2086479d2);
    $parcel$export(module.exports, "globalSettingsPerformanceMetricDetailRoute", ()=>$9aee66b3178a7753$export$d4f7a24791f8b506);
    $parcel$export(module.exports, "globalSettingsPerformanceCustomFieldRoute", ()=>$9aee66b3178a7753$export$198b0dea5bcb104d);
    $parcel$export(module.exports, "globalSettingsPerformanceIssueArchivalRoute", ()=>$9aee66b3178a7753$export$a615b79ae9fb06e5);
    $parcel$export(module.exports, "globalSettingsPerformanceProjectRoleActorRoute", ()=>$9aee66b3178a7753$export$c81695f590e65a42);
    $parcel$export(module.exports, "globalSettingsPerformanceProjectCleanupRoute", ()=>$9aee66b3178a7753$export$c0d3487a9dc79ff3);
    var $65Ltd;
    const $9aee66b3178a7753$export$677fc3a2086479d2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_OVERVIEW),
        path: '/jira/settings/system/performance/overview'
    };
    const $9aee66b3178a7753$export$d4f7a24791f8b506 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_METRIC_DETAIL),
        path: '/jira/settings/system/performance/metric/:metricKey'
    };
    const $9aee66b3178a7753$export$198b0dea5bcb104d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_CUSTOM_FIELD),
        path: '/jira/settings/system/performance/metrics/customfield'
    };
    const $9aee66b3178a7753$export$a615b79ae9fb06e5 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_ISSUE),
        path: '/jira/settings/system/performance/metrics/issue'
    };
    const $9aee66b3178a7753$export$c81695f590e65a42 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_ROLE_ACTOR),
        path: '/jira/settings/system/performance/metrics/projectroleactor'
    };
    const $9aee66b3178a7753$export$c0d3487a9dc79ff3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERFORMANCE_PROJECT_CLEANUP),
        path: '/jira/settings/system/performance/metrics/projectCleanup'
    };
});
parcelRegister("6kCEi", function(module, exports) {
    $parcel$export(module.exports, "LazyCustomFieldDetail", ()=>$416b07e85e5902e2$export$d323aa888b5be0c2);
    $parcel$export(module.exports, "CustomFieldMetricDetail", ()=>$416b07e85e5902e2$export$446bf9be075b3cb);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $416b07e85e5902e2$export$d323aa888b5be0c2 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6WmO9"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-custom-field/src/index.tsx"
    });
    const $416b07e85e5902e2$export$446bf9be075b3cb = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $416b07e85e5902e2$export$d323aa888b5be0c2,
            pageId: "system-performance-metric-detail-custom-field",
            shouldShowSpinner: true
        });
});
parcelRegister("6WmO9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("kZEdw")
    ]).then(()=>parcelRequire('PZuxA'));
});
parcelRegister("2vX6Y", function(module, exports) {
    $parcel$export(module.exports, "LazyIssueDetail", ()=>$cc878f5a65037830$export$e44cbefb7c57e031);
    $parcel$export(module.exports, "IssueMetricDetail", ()=>$cc878f5a65037830$export$30b22d5292fcd86f);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $cc878f5a65037830$export$e44cbefb7c57e031 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("h0LCj"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-issue/src/index.tsx"
    });
    const $cc878f5a65037830$export$30b22d5292fcd86f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cc878f5a65037830$export$e44cbefb7c57e031,
            pageId: "system-performance-metric-detail-issue",
            shouldShowSpinner: true
        });
});
parcelRegister("h0LCj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("kbq0s")
    ]).then(()=>parcelRequire('9HctW'));
});
parcelRegister("kxXsG", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectCleanupDetail", ()=>$a4333be24d8fdde0$export$a02cb3bfa11d0dc0);
    $parcel$export(module.exports, "ProjectCleanupMetricDetail", ()=>$a4333be24d8fdde0$export$2adb5abd6651c182);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $a4333be24d8fdde0$export$a02cb3bfa11d0dc0 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("jaOdX"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-project-cleanup/src/index.tsx"
    });
    const $a4333be24d8fdde0$export$2adb5abd6651c182 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a4333be24d8fdde0$export$a02cb3bfa11d0dc0,
            pageId: "system-performance-metric-detail-project-cleanup",
            shouldShowSpinner: true
        });
});
parcelRegister("jaOdX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("7gdHv")
    ]).then(()=>parcelRequire('fJoHG'));
});
parcelRegister("7BrHr", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectRoleActorDetail", ()=>$e00517ee35b4ce44$export$41ecfa31d3d81e1c);
    $parcel$export(module.exports, "ProjectRoleActorMetricDetail", ()=>$e00517ee35b4ce44$export$3c58376b89706313);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $e00517ee35b4ce44$export$41ecfa31d3d81e1c = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8bORg"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/performance/metric-detail-project-role-actor/src/index.tsx"
    });
    const $e00517ee35b4ce44$export$3c58376b89706313 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e00517ee35b4ce44$export$41ecfa31d3d81e1c,
            pageId: "system-performance-metric-detail-project-role-actor",
            shouldShowSpinner: true
        });
});
parcelRegister("8bORg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("7u0xh")
    ]).then(()=>parcelRequire('eQgAh'));
});
parcelRegister("gq1Xn", function(module, exports) {
    $parcel$export(module.exports, "RedirectToExactMetricRoutes", ()=>$a9257ec476fbe8e1$export$dda90f06f8afe9ec);
    var $5uXOq = parcelRequire("5uXOq");
    var $95EVP;
    var $8zOmE;
    var $7OYJs;
    var $dIdda = parcelRequire("dIdda");
    const $a9257ec476fbe8e1$export$dda90f06f8afe9ec = ()=>{
        const [{ match: match }] = (0, $dIdda.useRouter)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            if (match?.params?.metricKey) (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'old-metric-detail-route visited', {
                metricKey: match.params.metricKey
            });
        }, [
            match?.params?.metricKey,
            createAnalyticsEvent
        ]);
        if (match == null || match.params == null || match.params.metricKey == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/settings/system/performance/overview"
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: `/jira/settings/system/performance/metrics/${match.params.metricKey}`
        });
    };
});
parcelRegister("408O8", function(module, exports) {
    $parcel$export(module.exports, "LazyOverview", ()=>$53afac4f83d10b4d$export$17b4d4eaede5f445);
    $parcel$export(module.exports, "default", ()=>$53afac4f83d10b4d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $53afac4f83d10b4d$export$17b4d4eaede5f445 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4Vh5b"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/performance/overview/src/index.tsx"
    });
    var $53afac4f83d10b4d$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $53afac4f83d10b4d$export$17b4d4eaede5f445,
            pageId: "system-performance-overview",
            shouldShowSpinner: true
        });
});
parcelRegister("4Vh5b", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8auDC")
    ]).then(()=>parcelRequire('aJlr3'));
});
parcelRegister("cxMNV", function(module, exports) {
    $parcel$export(module.exports, "permissionPageRouteEntries", ()=>$fb84735b34e76986$export$ac0fc473d7d21da1);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $1Sn7L;
    var $bFrLw;
    var $3RJkv;
    var $atU1t;
    var $75hM5;
    var $aVbhY;
    var $j8IEt;
    const $fb84735b34e76986$export$ac0fc473d7d21da1 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("75hM5")).globalSettingsEditPermissionSchemesRoute), ()=>({
                ufoName: 'global-admin.issues.configure-permission-scheme',
                component: (0, (0, parcelRequire("aVbhY")).default),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("1Sn7L")).editPermissionSchemePageResource)
                ],
                canTransitionIn: ()=>true,
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("aVbhY")).LazyEditPermissionSchemePage)
                ],
                meta: {
                    reporting: {
                        id: 'EditPermissionScheme',
                        packageName: 'jiraAdminPagesEditPermissionScheme',
                        teamName: 'olympus'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("75hM5")).globalSettingsPermissionSchemesRoute), ()=>({
                ufoName: 'global-admin.issues.configure-permission-scheme',
                component: (0, (0, parcelRequire("j8IEt")).default),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("bFrLw")).permissionSchemePageResource)
                ],
                canTransitionIn: ()=>true,
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("j8IEt")).LazyPermissionSchemePage)
                ],
                meta: {
                    reporting: {
                        id: 'PermissionScheme',
                        packageName: 'jiraAdminPagesPermissionScheme',
                        teamName: 'olympus'
                    }
                }
            }))
    ];
});
parcelRegister("1Sn7L", function(module, exports) {
    $parcel$export(module.exports, "editPermissionSchemePageResource", ()=>$c133ac01577799ff$export$2b6bb2f543863b53);
    var $ao2h1;
    var $eZzoq;
    const $c133ac01577799ff$var$RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE = 'EDIT_PERMISSION_SCHEME_PAGE';
    const $c133ac01577799ff$export$2b6bb2f543863b53 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: $c133ac01577799ff$var$RESOURCE_TYPE_EDIT_PERMISSION_SCHEME_PAGE,
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("eZzoq")).default),
                variables: {
                    schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${tenantContext.activationId}/${String(match.params.schemeId)}`,
                    first: 50
                },
                options: {
                    fetchPolicy: 'network-only'
                }
            })
    });
});
parcelRegister("eZzoq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$95d709337e778f61$export$2e2bcd8739ae039);
    const $95d709337e778f61$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "schemeId"
        }, v2 = {
            "kind": "Variable",
            "name": "schemeId",
            "variableName": "schemeId"
        }, v3 = [
            v2
        ], v4 = {
            "kind": "ScalarField",
            "name": "isEditable"
        }, v5 = {
            "concreteType": "JiraPermissionSchemeConfiguration",
            "kind": "LinkedField",
            "name": "configuration",
            "plural": false,
            "selections": [
                v4
            ]
        }, v6 = [
            {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
            },
            v2
        ], v7 = {
            "kind": "ScalarField",
            "name": "projectId"
        }, v8 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v9 = {
            "kind": "ScalarField",
            "name": "name"
        }, v10 = {
            "kind": "ScalarField",
            "name": "key"
        }, v11 = {
            "kind": "ScalarField",
            "name": "description"
        }, v12 = {
            "kind": "ScalarField",
            "name": "text"
        }, v13 = {
            "kind": "ScalarField",
            "name": "id"
        }, v14 = [
            v8,
            v9,
            v13
        ], v15 = [
            v9,
            v13
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v3,
                                    "kind": "LinkedField",
                                    "name": "viewPermissionScheme",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "PermissionCategories"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "header_editPermissionScheme"
                                                },
                                                v5
                                            ],
                                            "type": "JiraPermissionSchemeView"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.viewPermissionScheme"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v6,
                                    "concreteType": "JiraProjectConnection",
                                    "kind": "LinkedField",
                                    "name": "getProjectsByPermissionScheme",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "JiraProjectEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v7,
                                                                    "action": "LOG",
                                                                    "path": "jira.getProjectsByPermissionScheme.edges.node.projectId"
                                                                }
                                                            ]
                                                        },
                                                        "action": "LOG",
                                                        "path": "jira.getProjectsByPermissionScheme.edges.node"
                                                    }
                                                ]
                                            },
                                            "action": "LOG",
                                            "path": "jira.getProjectsByPermissionScheme.edges"
                                        }
                                    ]
                                },
                                "action": "LOG",
                                "path": "jira.getProjectsByPermissionScheme"
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "kind": "LinkedField",
                                "name": "viewPermissionScheme",
                                "plural": false,
                                "selections": [
                                    v8,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "concreteType": "JiraPermissionSchemeGrantGroup",
                                                "kind": "LinkedField",
                                                "name": "grantGroups",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraProjectPermissionCategory",
                                                        "kind": "LinkedField",
                                                        "name": "category",
                                                        "plural": false,
                                                        "selections": [
                                                            v9,
                                                            v10
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JiraPermissionGrantHolder",
                                                        "kind": "LinkedField",
                                                        "name": "grantHolders",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraProjectPermission",
                                                                "kind": "LinkedField",
                                                                "name": "permission",
                                                                "plural": false,
                                                                "selections": [
                                                                    v9,
                                                                    v11,
                                                                    v10
                                                                ]
                                                            },
                                                            {
                                                                "concreteType": "JiraPermissionConfiguration",
                                                                "kind": "LinkedField",
                                                                "name": "configuration",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "tag"
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraPermissionMessageExtension",
                                                                        "kind": "LinkedField",
                                                                        "name": "message",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "type"
                                                                            },
                                                                            v12
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraPermissionDocumentationExtension",
                                                                        "kind": "LinkedField",
                                                                        "name": "documentation",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v12,
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "url"
                                                                            }
                                                                        ]
                                                                    },
                                                                    v4
                                                                ]
                                                            },
                                                            {
                                                                "concreteType": "JiraPermissionGrants",
                                                                "kind": "LinkedField",
                                                                "name": "grants",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraGrantTypeKey",
                                                                        "kind": "LinkedField",
                                                                        "name": "grantType",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v10,
                                                                            v9
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraPermissionGrantValue",
                                                                        "kind": "LinkedField",
                                                                        "name": "grantValues",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "value",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v8,
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v9
                                                                                        ],
                                                                                        "type": "JiraDefaultGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "user",
                                                                                                "plural": false,
                                                                                                "selections": v14
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraUserGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraGroup",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "group",
                                                                                                "plural": false,
                                                                                                "selections": v15
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraGroupGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "concreteType": "JiraRole",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "role",
                                                                                                "plural": false,
                                                                                                "selections": v15
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraProjectRoleGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "field",
                                                                                                "plural": false,
                                                                                                "selections": v14
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraIssueFieldGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v13
                                                                                        ],
                                                                                        "type": "Node",
                                                                                        "abstractKey": "__isNode"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v13
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "totalCount"
                                                                    },
                                                                    v8
                                                                ]
                                                            },
                                                            {
                                                                "kind": "ClientExtension",
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "__id"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraPermissionScheme",
                                                "kind": "LinkedField",
                                                "name": "scheme",
                                                "plural": false,
                                                "selections": [
                                                    v9,
                                                    v11,
                                                    v13
                                                ]
                                            },
                                            v5
                                        ],
                                        "type": "JiraPermissionSchemeView"
                                    }
                                ]
                            },
                            {
                                "args": v6,
                                "concreteType": "JiraProjectConnection",
                                "kind": "LinkedField",
                                "name": "getProjectsByPermissionScheme",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraProjectEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "JiraProject",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v7,
                                                    v13
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "8c97cc5e281ea579c44e87ac7f80e5f399b27b3ac304b7267d4210b282a7a4b1",
                "metadata": {},
                "name": "mainJiraEditPermissionSchemeAndGetPermissionSchemeByIdQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $95d709337e778f61$var$node.hash = "9e1e7326d79aae057f4943753d3cd309";
    var $95d709337e778f61$export$2e2bcd8739ae039 = $95d709337e778f61$var$node;
});
parcelRegister("bFrLw", function(module, exports) {
    $parcel$export(module.exports, "permissionSchemePageResource", ()=>$b39d37deff00f918$export$58d9013f694fc9d0);
    var $ao2h1;
    var $kf7Zr;
    const $b39d37deff00f918$var$RESOURCE_TYPE_PERMISSION_SCHEME_PAGE = 'PERMISSION_SCHEME_PAGE';
    const $b39d37deff00f918$export$58d9013f694fc9d0 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: $b39d37deff00f918$var$RESOURCE_TYPE_PERMISSION_SCHEME_PAGE,
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("kf7Zr")).default),
                variables: {
                    schemeId: `ari:cloud:jira:${tenantContext.cloudId}:permission-scheme/activation/${tenantContext.activationId}/${String(match.params.schemeId)}`
                },
                options: {
                    fetchPolicy: 'network-only'
                }
            })
    });
});
parcelRegister("kf7Zr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$667e2dd268ebb83a$export$2e2bcd8739ae039);
    const $667e2dd268ebb83a$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "schemeId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "schemeId",
                "variableName": "schemeId"
            }
        ], v2 = {
            "concreteType": "JiraPermissionSchemeConfiguration",
            "kind": "LinkedField",
            "name": "configuration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEditable"
                }
            ]
        }, v3 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v4 = {
            "kind": "ScalarField",
            "name": "name"
        }, v5 = {
            "kind": "ScalarField",
            "name": "description"
        }, v6 = {
            "kind": "ScalarField",
            "name": "id"
        }, v7 = {
            "kind": "ScalarField",
            "name": "key"
        }, v8 = [
            v3,
            v4,
            v6
        ], v9 = [
            v4,
            v6
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1,
                                    "kind": "LinkedField",
                                    "name": "viewPermissionScheme",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "header_permissionScheme"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "PermissionsTable"
                                                },
                                                v2
                                            ],
                                            "type": "JiraPermissionSchemeView"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.viewPermissionScheme"
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v1,
                                "kind": "LinkedField",
                                "name": "viewPermissionScheme",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "concreteType": "JiraPermissionScheme",
                                                "kind": "LinkedField",
                                                "name": "scheme",
                                                "plural": false,
                                                "selections": [
                                                    v4,
                                                    v5,
                                                    v6
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraPermissionSchemeGrantGroup",
                                                "kind": "LinkedField",
                                                "name": "grantGroups",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraProjectPermissionCategory",
                                                        "kind": "LinkedField",
                                                        "name": "category",
                                                        "plural": false,
                                                        "selections": [
                                                            v4
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "JiraPermissionGrantHolder",
                                                        "kind": "LinkedField",
                                                        "name": "grantHolders",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraProjectPermission",
                                                                "kind": "LinkedField",
                                                                "name": "permission",
                                                                "plural": false,
                                                                "selections": [
                                                                    v7,
                                                                    v4,
                                                                    v5
                                                                ]
                                                            },
                                                            {
                                                                "concreteType": "JiraPermissionGrants",
                                                                "kind": "LinkedField",
                                                                "name": "grants",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraGrantTypeKey",
                                                                        "kind": "LinkedField",
                                                                        "name": "grantType",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v7,
                                                                            v4
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraPermissionGrantValue",
                                                                        "kind": "LinkedField",
                                                                        "name": "grantValues",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "LinkedField",
                                                                                "name": "value",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    v3,
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v6,
                                                                                            v4
                                                                                        ],
                                                                                        "type": "JiraDefaultGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v6,
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "user",
                                                                                                "plural": false,
                                                                                                "selections": v8
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraUserGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v6,
                                                                                            {
                                                                                                "concreteType": "JiraGroup",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "group",
                                                                                                "plural": false,
                                                                                                "selections": v9
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraGroupGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v6,
                                                                                            {
                                                                                                "kind": "LinkedField",
                                                                                                "name": "field",
                                                                                                "plural": false,
                                                                                                "selections": v8
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraIssueFieldGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v6,
                                                                                            {
                                                                                                "concreteType": "JiraRole",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "role",
                                                                                                "plural": false,
                                                                                                "selections": v9
                                                                                            }
                                                                                        ],
                                                                                        "type": "JiraProjectRoleGrantTypeValue"
                                                                                    },
                                                                                    {
                                                                                        "kind": "InlineFragment",
                                                                                        "selections": [
                                                                                            v6
                                                                                        ],
                                                                                        "type": "Node",
                                                                                        "abstractKey": "__isNode"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            v6
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            v2
                                        ],
                                        "type": "JiraPermissionSchemeView"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "b5642572e212db64091380e916543cde0402cdfaa01db716befcdd494efd5feb",
                "metadata": {},
                "name": "mainJiraPermissionSchemeAndGetPermissionSchemeByIdQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $667e2dd268ebb83a$var$node.hash = "41dd09a71a35c8ed416631b02fa73316";
    var $667e2dd268ebb83a$export$2e2bcd8739ae039 = $667e2dd268ebb83a$var$node;
});
parcelRegister("75hM5", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsEditPermissionSchemesRoute", ()=>$f357bbf21d1afc21$export$d57f448badd0561f);
    $parcel$export(module.exports, "globalSettingsPermissionSchemesRoute", ()=>$f357bbf21d1afc21$export$ceade8e040291782);
    var $65Ltd;
    const $f357bbf21d1afc21$export$d57f448badd0561f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_EDIT_PERMISSION_SCHEMES),
        path: '/jira/settings/issues/permission-schemes/:schemeId'
    };
    const $f357bbf21d1afc21$export$ceade8e040291782 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_PERMISSION_SCHEMES),
        path: '/jira/settings/issues/permission-schemes-new/:schemeId'
    };
});
parcelRegister("aVbhY", function(module, exports) {
    $parcel$export(module.exports, "LazyEditPermissionSchemePage", ()=>$9fc866887d4bbe6b$export$4549705b02900c32);
    $parcel$export(module.exports, "default", ()=>$9fc866887d4bbe6b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $9fc866887d4bbe6b$export$4549705b02900c32 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8PQYZ"))), {
        moduleId: "./src/packages/permissions-administration/pages/edit-permission-scheme/src/index.tsx"
    });
    var $9fc866887d4bbe6b$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9fc866887d4bbe6b$export$4549705b02900c32,
            pageId: "jira-edit-permission-scheme",
            shouldShowSpinner: true
        });
});
parcelRegister("8PQYZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("2s3c1")
    ]).then(()=>parcelRequire('hZT3b'));
});
parcelRegister("j8IEt", function(module, exports) {
    $parcel$export(module.exports, "LazyPermissionSchemePage", ()=>$d6d274858940e39c$export$f7fcf8304eb17dda);
    $parcel$export(module.exports, "default", ()=>$d6d274858940e39c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $d6d274858940e39c$export$f7fcf8304eb17dda = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("iqkTm"))), {
        moduleId: "./src/packages/permissions-administration/pages/permission-scheme/src/index.tsx"
    });
    var $d6d274858940e39c$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d6d274858940e39c$export$f7fcf8304eb17dda,
            pageId: "jira-permission-scheme",
            shouldShowSpinner: true
        });
});
parcelRegister("iqkTm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("ibJV0")
    ]).then(()=>parcelRequire('cHxvv'));
});
parcelRegister("9IRtC", function(module, exports) {
    $parcel$export(module.exports, "prioritySchemesRouteEntries", ()=>$8bce8d2114fb1250$export$cd38898806de0f08);
    var $cSD7y;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $bV6im;
    var $5lsNZ;
    var $jE90b;
    var $3qE1A;
    const $8bce8d2114fb1250$export$cd38898806de0f08 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bV6im")).globalSettingsIssuesPrioritiesRoute), ()=>({
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('priorities_page_frontend_statsig', (0, (0, parcelRequire("jE90b")).default), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("jE90b")).LazyPrioritiesPage)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bV6im")).globalSettingsIssuesPrioritySchemesRoute), ()=>({
                component: (0, (0, parcelRequire("3qE1A")).default),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("3qE1A")).LazyPrioritySchemes)
                ]
            }))
    ];
});
parcelRegister("bV6im", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssuesPrioritySchemesRoute", ()=>$712cde19d1c09667$export$185af30f53271c10);
    $parcel$export(module.exports, "globalSettingsIssuesPrioritiesRoute", ()=>$712cde19d1c09667$export$518516cdf6b7cd83);
    var $65Ltd;
    const $712cde19d1c09667$export$185af30f53271c10 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITY_SCHEMES),
        path: '/jira/settings/issues/priority-schemes'
    };
    const $712cde19d1c09667$export$518516cdf6b7cd83 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUES_PRIORITIES),
        path: '/jira/settings/issues/priorities'
    };
});
parcelRegister("jE90b", function(module, exports) {
    $parcel$export(module.exports, "LazyPrioritiesPage", ()=>$bf15af7ed924092e$export$2b5843205130631c);
    $parcel$export(module.exports, "default", ()=>$bf15af7ed924092e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $bf15af7ed924092e$export$2b5843205130631c = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fhPlz"))), {
        moduleId: "./src/packages/admin-pages/priorities/src/index.tsx"
    });
    const $bf15af7ed924092e$var$PrioritiesPage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $bf15af7ed924092e$export$2b5843205130631c,
            pageId: "jira-admin-pages-priorities",
            shouldShowSpinner: true
        });
    var $bf15af7ed924092e$export$2e2bcd8739ae039 = $bf15af7ed924092e$var$PrioritiesPage;
});
parcelRegister("fhPlz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("dRzJO")
    ]).then(()=>parcelRequire('7oC7C'));
});
parcelRegister("3qE1A", function(module, exports) {
    $parcel$export(module.exports, "LazyPrioritySchemes", ()=>$a7002d7e57e81458$export$20bb8a3b40a3add4);
    $parcel$export(module.exports, "default", ()=>$a7002d7e57e81458$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $a7002d7e57e81458$export$20bb8a3b40a3add4 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fKkNZ"))), {
        moduleId: "./src/packages/admin-pages/priority-schemes/src/ui/index.tsx"
    });
    var $a7002d7e57e81458$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $a7002d7e57e81458$export$20bb8a3b40a3add4,
            pageId: "jira-admin-pages-priority-schemes",
            shouldShowSpinner: true
        });
});
parcelRegister("fKkNZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7MbJW")
    ]).then(()=>parcelRequire('4bg9b'));
});
parcelRegister("3WKJT", function(module, exports) {
    $parcel$export(module.exports, "proformaRouteEntries", ()=>$23186b60c86516d6$export$2763334cca1560d7);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $78xBL;
    var $6MVyv;
    const $23186b60c86516d6$export$2763334cca1560d7 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("78xBL")).globalSettingsFormDataConnectionsRoute), ()=>({
                component: (0, (0, parcelRequire("6MVyv")).default),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("6MVyv")).LazyProformaJiraDataConnectionsPage)
                ]
            }))
    ];
});
parcelRegister("78xBL", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsFormDataConnectionsRoute", ()=>$24bfebea6d97ebdb$export$6633247975d81f28);
    var $65Ltd;
    const $24bfebea6d97ebdb$export$6633247975d81f28 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_FORM_DATA_CONNECTIONS),
        path: '/jira/settings/forms/data-connections'
    };
});
parcelRegister("6MVyv", function(module, exports) {
    $parcel$export(module.exports, "LazyProformaJiraDataConnectionsPage", ()=>$013d0419ad26989f$export$a81885366284dc75);
    $parcel$export(module.exports, "default", ()=>$013d0419ad26989f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $013d0419ad26989f$export$a81885366284dc75 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("hKhMf"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/proforma/data-connections/src/index.tsx"
    });
    var $013d0419ad26989f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $013d0419ad26989f$export$a81885366284dc75,
            pageId: "jira-admin-pages-forms-data-connections",
            shouldShowSpinner: true
        });
});
parcelRegister("hKhMf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("jKdTq")
    ]).then(()=>parcelRequire('jSKfU'));
});
parcelRegister("jvuJF", function(module, exports) {
    $parcel$export(module.exports, "screensPageRouteEntries", ()=>$d40f7f84137250be$export$75afafbdb2230f9);
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $8bWYM;
    var $kMjOg;
    var $MjvHI;
    var $P0dqS;
    const $d40f7f84137250be$export$75afafbdb2230f9 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8bWYM")).globalSettingsIssueFieldScreensRoute), ()=>({
                ufoName: 'global-admin.issues.screens',
                component: (0, (0, parcelRequire("P0dqS")).default),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("P0dqS")).LazyScreensPage)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8bWYM")).globalSettingsIssueFieldSchemesRoute), ()=>({
                ufoName: 'global-admin.issues.screen-schemes',
                component: (0, (0, parcelRequire("MjvHI")).default),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("MjvHI")).LazyScreenSchemesPage)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8bWYM")).globalSettingsIssueTypesScreenSchemesRoute), ()=>({
                ufoName: 'global-admin.issues.issue-type-screen-schemes',
                component: (0, (0, parcelRequire("kMjOg")).default),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("kMjOg")).LazyIssueTypeScreenSchemesPage)
                ]
            }))
    ];
});
parcelRegister("8bWYM", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssueFieldScreensRoute", ()=>$614d0e8c921291fb$export$197fd5d0ee709ca4);
    $parcel$export(module.exports, "globalSettingsIssueFieldSchemesRoute", ()=>$614d0e8c921291fb$export$3c5a0cf6ecc1bdf1);
    $parcel$export(module.exports, "globalSettingsIssueTypesScreenSchemesRoute", ()=>$614d0e8c921291fb$export$df93a4addc359237);
    var $65Ltd;
    const $614d0e8c921291fb$export$197fd5d0ee709ca4 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCREENS),
        path: '/jira/settings/issues/screens'
    };
    const $614d0e8c921291fb$export$3c5a0cf6ecc1bdf1 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_FIELD_SCHEMES),
        path: '/jira/settings/issues/screen-schemes'
    };
    const $614d0e8c921291fb$export$df93a4addc359237 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_TYPES_SCREEN_SCHEMES),
        path: '/jira/settings/issues/issue-type-screen-schemes'
    };
});
parcelRegister("kMjOg", function(module, exports) {
    $parcel$export(module.exports, "LazyIssueTypeScreenSchemesPage", ()=>$73b6b725092289e9$export$350edfb57b335a57);
    $parcel$export(module.exports, "default", ()=>$73b6b725092289e9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $73b6b725092289e9$export$350edfb57b335a57 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3itkj"))), {
        moduleId: "./src/packages/admin-pages/screens/issue-type-screen-schemes-page/src/index.tsx"
    });
    var $73b6b725092289e9$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $73b6b725092289e9$export$350edfb57b335a57,
            pageId: "jira-admin-pages-issue-type-screen-schemes-page",
            shouldShowSpinner: true
        });
});
parcelRegister("3itkj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jTAHY")
    ]).then(()=>parcelRequire('5K98P'));
});
parcelRegister("MjvHI", function(module, exports) {
    $parcel$export(module.exports, "LazyScreenSchemesPage", ()=>$3b08a72bf07c6137$export$342ae41503f611f1);
    $parcel$export(module.exports, "default", ()=>$3b08a72bf07c6137$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $3b08a72bf07c6137$export$342ae41503f611f1 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("in6By"))), {
        moduleId: "./src/packages/admin-pages/screens/screen-schemes-page/src/index.tsx"
    });
    var $3b08a72bf07c6137$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3b08a72bf07c6137$export$342ae41503f611f1,
            pageId: "jira-admin-pages-screen-schemes-page",
            shouldShowSpinner: true
        });
});
parcelRegister("in6By", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("FB5JX")
    ]).then(()=>parcelRequire('bwE6o'));
});
parcelRegister("P0dqS", function(module, exports) {
    $parcel$export(module.exports, "LazyScreensPage", ()=>$38a54f3b8a5e1e01$export$f4e6d546d7f2894c);
    $parcel$export(module.exports, "default", ()=>$38a54f3b8a5e1e01$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $38a54f3b8a5e1e01$export$f4e6d546d7f2894c = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3tVs3"))), {
        moduleId: "./src/packages/admin-pages/screens/screens-page/src/index.tsx"
    });
    var $38a54f3b8a5e1e01$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $38a54f3b8a5e1e01$export$f4e6d546d7f2894c,
            pageId: "jira-admin-pages-screens-page",
            shouldShowSpinner: true
        });
});
parcelRegister("3tVs3", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8WK9x")
    ]).then(()=>parcelRequire('lgmh3'));
});
parcelRegister("h6cNv", function(module, exports) {
    $parcel$export(module.exports, "systemConfigurationRouteEntries", ()=>$6e549c8f8c5cff26$export$e8714add09855505);
    var $ffza4;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $dmx0y;
    var $1ZpQo;
    var $j2LKP;
    var $k7R2k;
    const $6e549c8f8c5cff26$export$e8714add09855505 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1ZpQo")).systemConfigurationRoute), ()=>({
                component: (0, (0, parcelRequire("k7R2k")).default),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("dmx0y")).systemConfigurationGeneralResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("k7R2k")).LazySystemConfigurationGeneral)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("1ZpQo")).routeNamesSystemConfigurationRedirectRoute), ()=>({
                component: (0, (0, parcelRequire("j2LKP")).default),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("dmx0y")).systemConfigurationGeneralResource)
                ]
            }))
    ];
});
parcelRegister("1ZpQo", function(module, exports) {
    $parcel$export(module.exports, "systemConfigurationRoute", ()=>$f2ea4006e0777885$export$6823cb5626e61bc7);
    $parcel$export(module.exports, "routeNamesSystemConfigurationRedirectRoute", ()=>$f2ea4006e0777885$export$23418d655258dbfa);
    var $65Ltd;
    const $f2ea4006e0777885$export$6823cb5626e61bc7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SYSTEM_CONFIGURATION),
        path: '/jira/settings/system/general-configuration',
        exact: true
    };
    const $f2ea4006e0777885$export$23418d655258dbfa = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SYSTEM_CONFIGURATION)}-redirect`,
        path: '/secure/admin/ViewApplicationProperties.jspa',
        exact: true
    };
});
parcelRegister("j2LKP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$71a705d1d999c26b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7OYJs;
    var $71a705d1d999c26b$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: "/jira/settings/system/general-configuration"
        });
});
parcelRegister("k7R2k", function(module, exports) {
    $parcel$export(module.exports, "LazySystemConfigurationGeneral", ()=>$ece5afb522908971$export$c452a8c622781ccd);
    $parcel$export(module.exports, "default", ()=>$ece5afb522908971$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $ece5afb522908971$export$c452a8c622781ccd = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("gtlim"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/system-configuration-general/src/index.tsx"
    });
    var $ece5afb522908971$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ece5afb522908971$export$c452a8c622781ccd,
            pageId: "system-configuration-general",
            shouldShowSpinner: false
        });
});
parcelRegister("gtlim", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("aUVUi")
    ]).then(()=>parcelRequire('7S4i0'));
});
parcelRegister("hYrF0", function(module, exports) {
    $parcel$export(module.exports, "systemRouteEntries", ()=>$452e8bb8e23e6c4f$export$7b7dd85536177527);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $cOg46;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $jopzz;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $452e8bb8e23e6c4f$export$3c41e9fc9ec0d170 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lD0Ke"))), {
        moduleId: "./src/packages/spa-apps/admin-pages/system/ui/announcement-banner/src/index.tsx"
    });
    const $452e8bb8e23e6c4f$export$eb84257d269db72c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $452e8bb8e23e6c4f$export$3c41e9fc9ec0d170,
            pageId: "admin-pages-system-ui-announcement-banner",
            shouldShowSpinner: true
        });
    const $452e8bb8e23e6c4f$export$7b7dd85536177527 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jopzz")).globalSettingsSystemUiAnnouncementBannerRoute), ()=>({
                ufoName: 'global-admin.system.ui.announcement-banner',
                component: $452e8bb8e23e6c4f$export$eb84257d269db72c,
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_SYSTEM_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("cOg46")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    $452e8bb8e23e6c4f$export$3c41e9fc9ec0d170
                ]
            }))
    ];
});
parcelRegister("jopzz", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsSystemUiAnnouncementBannerRoute", ()=>$09d3b2ebb43c55a6$export$20631ff3b13dafc0);
    var $65Ltd;
    const $09d3b2ebb43c55a6$export$20631ff3b13dafc0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_SYSTEM_UI_ANNOUNCEMENT_BANNER),
        path: '/jira/settings/system/ui/announcement-banner'
    };
});
parcelRegister("lD0Ke", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1eCvc")
    ]).then(()=>parcelRequire('e7RG2'));
});
parcelRegister("fU2U7", function(module, exports) {
    $parcel$export(module.exports, "workflowPagesRouteEntries", ()=>$5b21375522489812$export$401ea91784469e3a);
    var $3aIZg;
    var $ffza4;
    var $ibkIl;
    var $lmyls;
    var $78U7j;
    var $2G9Bk;
    var $3RJkv;
    var $atU1t;
    var $cGspy;
    var $c7jVr;
    var $i6RvY;
    const $5b21375522489812$export$401ea91784469e3a = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cGspy")).globalSettingsIssueWorkflowEditRoute), ()=>({
                ufoName: 'global-admin.issues.edit-workflow',
                component: (0, (0, parcelRequire("c7jVr")).default),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("c7jVr")).LazyEditWorkflow)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cGspy")).globalSettingsIssueWorkflow1Route), ()=>({
                ufoName: 'global-admin.issues.view-workflows',
                component: (0, (0, parcelRequire("i6RvY")).default),
                layout: (0, (0, parcelRequire("ibkIl")).globalSettingsLayout),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).GLOBAL_ISSUES_SETTINGS,
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).SETTINGS,
                    sidebar: (0, (0, parcelRequire("78U7j")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("atU1t")).navigationSidebarGlobalResource),
                    (0, (0, parcelRequire("3aIZg")).default)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("i6RvY")).LazyListWorkflows)
                ]
            }))
    ];
});
parcelRegister("3aIZg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9146315a1662307e$export$2e2bcd8739ae039);
    var $ebyGx = parcelRequire("ebyGx");
    var $dIdda = parcelRequire("dIdda");
    var $AdkCT;
    const $9146315a1662307e$var$workFlowsResource = (0, $dIdda.createResource)({
        type: (0, $5c95bdf76715894f$export$b11854972ecaecc7),
        getKey: ({ query: query })=>`${0, $5c95bdf76715894f$export$6602c5404301813f}-${(0, ($parcel$interopDefault($ebyGx))).stringify(query)}`,
        maxAge: 0,
        getData: async ({ query: query })=>(0, (0, parcelRequire("AdkCT")).getListWorkFlows)((0, ($parcel$interopDefault($ebyGx))).stringify(query))
    });
    var $9146315a1662307e$export$2e2bcd8739ae039 = $9146315a1662307e$var$workFlowsResource;
});
parcelRegister("AdkCT", function(module, exports) {
    $parcel$export(module.exports, "getListWorkFlows", ()=>$bd8703d90d89a06c$export$952f5d693c3c0d4e);
    var $ebyGx = parcelRequire("ebyGx");
    var $jcw0u;
    var $eusud;
    var $lNKJm;
    var $9KDge;
    const $bd8703d90d89a06c$export$952f5d693c3c0d4e = async (qs)=>{
        const filter = (0, (0, parcelRequire("9KDge")).fromUrlTransformer)((0, ($parcel$interopDefault($ebyGx))).parse(qs));
        const query = (0, ($parcel$interopDefault($ebyGx))).stringify((0, (0, parcelRequire("9KDge")).toApiUrlTransformer)(filter));
        try {
            return await (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/api/3/workflow/search?${query}`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'getWorkflowsSearchAPI',
                    packageName: (0, (0, parcelRequire("lNKJm")).PACKAGE_NAME),
                    teamName: 'helix'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
parcelRegister("lNKJm", function(module, exports) {
    $parcel$export(module.exports, "SOURCE_NAME", ()=>$51adf94ab22e1863$export$a3821bc63538b210);
    $parcel$export(module.exports, "WORKFLOW_NAME", ()=>$51adf94ab22e1863$export$a69699c3acbd94ca);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$51adf94ab22e1863$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "WORKFLOWS_ACTIONS", ()=>$51adf94ab22e1863$export$f3ab46ae5f3c01ad);
    $parcel$export(module.exports, "WORKFLOWS_SCHEME", ()=>$51adf94ab22e1863$export$81c9aaf617cb2f01);
    $parcel$export(module.exports, "SYSTEM_WORKFLOW_JIRA_NAME", ()=>$51adf94ab22e1863$export$615f1d8b29794ae);
    $parcel$export(module.exports, "SYSTEM_WORKFLOW_BUILDS_WORKFLOWS_NAME", ()=>$51adf94ab22e1863$export$fccd4c1ce5f0896f);
    $parcel$export(module.exports, "DEFAULT_PAGE_SIZE", ()=>$51adf94ab22e1863$export$5716e8bcb003888d);
    $parcel$export(module.exports, "defaultListWorkFlowsFilter", ()=>$51adf94ab22e1863$export$dc5aae53031515c);
    $parcel$export(module.exports, "ORDER", ()=>$51adf94ab22e1863$export$11e75bce9f7ea886);
    $parcel$export(module.exports, "FILTER_CHANGE_ANALYTICS", ()=>$51adf94ab22e1863$export$9ac56b2484c2d4e9);
    $parcel$export(module.exports, "PAGE_SIZE_CHANGE_ANALYTICS", ()=>$51adf94ab22e1863$export$e6613a3c77896936);
    $parcel$export(module.exports, "API_PREFIX", ()=>$51adf94ab22e1863$export$a3f6840410eb0571);
    const $51adf94ab22e1863$export$a3821bc63538b210 = 'listWorkflows';
    const $51adf94ab22e1863$export$a69699c3acbd94ca = 'workflowName';
    const $51adf94ab22e1863$export$b8b9d90f9e5bd72b = 'jira-admin-pages-list-workflows';
    const $51adf94ab22e1863$export$f3ab46ae5f3c01ad = 'workflowsActions';
    const $51adf94ab22e1863$export$81c9aaf617cb2f01 = 'workflowScheme';
    const $51adf94ab22e1863$export$615f1d8b29794ae = 'jira';
    const $51adf94ab22e1863$export$fccd4c1ce5f0896f = 'Builds Workflow';
    const $51adf94ab22e1863$export$5716e8bcb003888d = 10;
    const $51adf94ab22e1863$export$f6e7f4d903fd7165 = 'ADD_WORKFLOWS';
    const $51adf94ab22e1863$export$dc5aae53031515c = {
        pageNumber: 1,
        pageSize: $51adf94ab22e1863$export$5716e8bcb003888d,
        expand: [
            'default',
            'hasDraftWorkflow',
            'schemes',
            'operations',
            'projects'
        ],
        orderBy: 'name',
        sortDirection: (0, $2a9e000a443b1a95$export$1dee026a19752d6b),
        isActive: true
    };
    const $51adf94ab22e1863$export$11e75bce9f7ea886 = Object.freeze({
        ASC: 'asc',
        DESC: 'desc'
    });
    const $51adf94ab22e1863$export$3c5e605ca7ade9f2 = 'NAME';
    const $51adf94ab22e1863$export$b87f371cbc396fcf = 'TYPE';
    const $51adf94ab22e1863$export$9ac56b2484c2d4e9 = Object.freeze({
        ACTION: 'changed',
        ACTION_SUBJECT: 'filterSearch'
    });
    const $51adf94ab22e1863$export$e6613a3c77896936 = Object.freeze({
        ACTION: 'changed',
        ACTION_SUBJECT: 'pageSize'
    });
    const $51adf94ab22e1863$export$a3f6840410eb0571 = 'gateway/api/jira/project-configuration';
});
parcelRegister("9KDge", function(module, exports) {
    $parcel$export(module.exports, "toUrlTransformer", ()=>$f0642d0f1e447d39$export$5b9f8ed2c34be88a);
    $parcel$export(module.exports, "fromUrlTransformer", ()=>$f0642d0f1e447d39$export$bec67ef860c0d0e1);
    $parcel$export(module.exports, "toApiUrlTransformer", ()=>$f0642d0f1e447d39$export$fb15afa686993f11);
    var $aud83;
    var $lNKJm;
    var $lgmUP;
    const $f0642d0f1e447d39$export$5b9f8ed2c34be88a = (filter)=>{
        const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy, isActive: isActive, pageSize: pageSize } = filter || {};
        return {
            pageNumber: pageNumber,
            searchFilter: searchFilter,
            orderBy: orderBy,
            isActive: isActive,
            pageSize: pageSize
        };
    };
    const $f0642d0f1e447d39$export$bec67ef860c0d0e1 = (params)=>{
        const { pageNumber: pageNumber, searchFilter: searchFilter, orderBy: orderBy, isActive: isActive, pageSize: pageSize } = params;
        const parsedNumber = Number.isNaN((0, (0, parcelRequire("aud83")).number).parse(pageNumber)) ? (0, (0, parcelRequire("lNKJm")).defaultListWorkFlowsFilter).pageNumber : (0, (0, parcelRequire("aud83")).number).parse(pageNumber);
        const parsedSize = Number.isNaN((0, (0, parcelRequire("aud83")).number).parse(pageSize)) ? (0, (0, parcelRequire("lNKJm")).defaultListWorkFlowsFilter).pageSize : (0, (0, parcelRequire("aud83")).number).parse(pageSize);
        const parsedOrderBy = orderBy === 'name' || orderBy === '-name' || orderBy === 'updated' || orderBy === '-updated' ? orderBy : undefined;
        const isActiveFinal = isActive != null ? isActive === 'true' : (0, (0, parcelRequire("lNKJm")).defaultListWorkFlowsFilter).isActive;
        return {
            ...(0, (0, parcelRequire("lNKJm")).defaultListWorkFlowsFilter),
            pageNumber: parsedNumber != null ? Number(parsedNumber) : undefined,
            pageSize: parsedSize != null ? Number(parsedSize) : undefined,
            searchFilter: searchFilter,
            orderBy: parsedOrderBy,
            isActive: isActiveFinal
        };
    };
    const $f0642d0f1e447d39$export$fb15afa686993f11 = (filter)=>{
        const fullFilter = {
            ...(0, (0, parcelRequire("lNKJm")).defaultListWorkFlowsFilter),
            ...filter
        };
        const { pageNumber: pageNumber = 1, pageSize: pageSize = (0, (0, parcelRequire("lNKJm")).DEFAULT_PAGE_SIZE) } = fullFilter;
        let requestParams = {
            maxResults: pageSize,
            startAt: (pageNumber - 1) * pageSize,
            orderBy: fullFilter.orderBy,
            queryString: (0, (0, parcelRequire("lgmUP")).trimSearchFilter)(fullFilter.searchFilter),
            isActive: fullFilter.isActive
        };
        if (fullFilter.expand != null) requestParams = {
            ...requestParams,
            expand: fullFilter.expand.join(',')
        };
        return requestParams;
    };
});
parcelRegister("lgmUP", function(module, exports) {
    $parcel$export(module.exports, "trimSearchFilter", ()=>$d92ccc09aa62d68e$export$ed1722f41c23aaaf);
    const $d92ccc09aa62d68e$export$7341f299e7b93e87 = (field)=>field !== undefined ? field.toLowerCase() : undefined;
    const $d92ccc09aa62d68e$export$c876451e094c0060 = (map, param)=>map[param] !== undefined ? map[param] : undefined;
    const $d92ccc09aa62d68e$export$ed1722f41c23aaaf = (searchFilter)=>{
        if (searchFilter === undefined) return undefined;
        return searchFilter.trim() || undefined;
    };
});
const $5c95bdf76715894f$export$b11854972ecaecc7 = 'WORKFLOWS_TABLE';
const $5c95bdf76715894f$export$6602c5404301813f = 'WORKFLOWS_TABLE_KEY';
parcelRegister("cGspy", function(module, exports) {
    $parcel$export(module.exports, "globalSettingsIssueWorkflowEditRoute", ()=>$129e81677ea4bebe$export$9d533f08a4447cc);
    $parcel$export(module.exports, "globalSettingsIssueWorkflow1Route", ()=>$129e81677ea4bebe$export$f8f2a617a2f4d53);
    var $65Ltd;
    const $129e81677ea4bebe$export$9d533f08a4447cc = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW_EDIT),
        path: '/jira/settings/issues/workflows/:workflowId'
    };
    const $129e81677ea4bebe$export$f8f2a617a2f4d53 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_GLOBAL_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_GLOBAL_SETTINGS_ISSUE_WORKFLOW),
        path: '/jira/settings/issues/workflows'
    };
});
parcelRegister("c7jVr", function(module, exports) {
    $parcel$export(module.exports, "LazyEditWorkflow", ()=>$793ac7f9af5a2945$export$cb79ebb337a95317);
    $parcel$export(module.exports, "default", ()=>$793ac7f9af5a2945$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $793ac7f9af5a2945$export$cb79ebb337a95317 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("atF3J"))), {
        moduleId: "./src/packages/admin-pages/workflows/edit-workflow/src/index.tsx"
    });
    var $793ac7f9af5a2945$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $793ac7f9af5a2945$export$cb79ebb337a95317,
            pageId: "jira-admin-pages-edit-workflow",
            shouldShowSpinner: true
        });
});
parcelRegister("atF3J", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1hdHP")
    ]).then(()=>parcelRequire('c8ahc'));
});
parcelRegister("i6RvY", function(module, exports) {
    $parcel$export(module.exports, "LazyListWorkflows", ()=>$fe432a8ece476800$export$4c64b4f1ecf22fc8);
    $parcel$export(module.exports, "default", ()=>$fe432a8ece476800$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $fe432a8ece476800$export$4c64b4f1ecf22fc8 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9VrFM"))), {
        moduleId: "./src/packages/admin-pages/workflows/list-workflows/src/index.tsx"
    });
    var $fe432a8ece476800$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $fe432a8ece476800$export$4c64b4f1ecf22fc8,
            pageId: "jira-admin-pages-list-workflows",
            shouldShowSpinner: true
        });
});
parcelRegister("9VrFM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9Lhq3").then(()=>parcelRequire('b9R9h'));
});
parcelRegister("8ni4m", function(module, exports) {
    $parcel$export(module.exports, "helpCenterSettingsRouteEntries", ()=>$39416b69d8da58fe$export$633933bacdaefead);
    var $8oDke;
    const $39416b69d8da58fe$export$633933bacdaefead = [
        (0, (0, parcelRequire("8oDke")).helpCenterSettingsRedirectRouteEntry),
        (0, (0, parcelRequire("8oDke")).helpCenterSettingsKbRouteEntry),
        (0, (0, parcelRequire("8oDke")).helpCenterSettingsCustomerNotificationsRouteEntry),
        (0, (0, parcelRequire("8oDke")).helpCenterSettingsEmailRouteEntry),
        (0, (0, parcelRequire("8oDke")).helpCenterSettingsFormsRouteEntry),
        (0, (0, parcelRequire("8oDke")).helpCenterSettingsFormEditRouteEntry)
    ];
});
parcelRegister("8oDke", function(module, exports) {
    $parcel$export(module.exports, "helpCenterSettingsRedirectRouteEntry", ()=>$58e6269847de16de$export$c4a6a8e840f7c6b1);
    $parcel$export(module.exports, "helpCenterSettingsKbRouteEntry", ()=>$58e6269847de16de$export$caf568619a621961);
    $parcel$export(module.exports, "helpCenterSettingsCustomerNotificationsRouteEntry", ()=>$58e6269847de16de$export$4e4f38417d267cf6);
    $parcel$export(module.exports, "helpCenterSettingsEmailRouteEntry", ()=>$58e6269847de16de$export$f95717dac47e4db3);
    $parcel$export(module.exports, "helpCenterSettingsFormsRouteEntry", ()=>$58e6269847de16de$export$9a67aaae787c9f40);
    $parcel$export(module.exports, "helpCenterSettingsFormEditRouteEntry", ()=>$58e6269847de16de$export$1750cfcab794a07d);
    var $ffza4;
    var $cSD7y;
    var $4R6GH;
    var $lmyls;
    var $fBTqh;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $7D8h0;
    var $5lsNZ;
    var $lKJB5;
    var $6Z2mh;
    var $jp5Vz;
    var $lUb7T;
    var $7VD4g;
    var $uu31h;
    var $81LME;
    var $jHo3E;
    var $rAcxJ;
    const $58e6269847de16de$var$navigation = {
        sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).HELP_CENTER_SETTINGS,
        menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HELP_CENTER_SETTINGS,
        sidebar: (0, (0, parcelRequire("fBTqh")).default)
    };
    const $58e6269847de16de$export$c4a6a8e840f7c6b1 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lKJB5")).helpCenterSettingsRoute), ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: $58e6269847de16de$var$navigation,
            component: (0, (0, parcelRequire("rAcxJ")).Redirect),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ],
            resources: [
                ...(0, (0, parcelRequire("jHo3E")).getSettingsNavigationResources)((0, (0, parcelRequire("jHo3E")).SERVICE_DESK_PRODUCT))
            ]
        }));
    const $58e6269847de16de$export$caf568619a621961 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lKJB5")).helpCenterSettingsKbRoute), ()=>({
            perfMetricKey: 'help-center-settings.kb',
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: $58e6269847de16de$var$navigation,
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jcs_master_flag', (0, (0, parcelRequire("81LME")).HelpCenterSettingsKnowledgeBase), (0, (0, parcelRequire("5lsNZ")).default)),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("81LME")).LazyHelpCenterSettingsKnowledgeBase)
            ],
            resources: [
                ...(0, (0, parcelRequire("jHo3E")).getSettingsNavigationResources)((0, (0, parcelRequire("jHo3E")).SERVICE_DESK_PRODUCT)),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        }));
    const $58e6269847de16de$export$4e4f38417d267cf6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lKJB5")).helpCenterSettingsCustomerNotificationsRoute), ()=>({
            perfMetricKey: 'help-center-settings.customer-notifications',
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: $58e6269847de16de$var$navigation,
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jcs_master_flag', (0, (0, parcelRequire("jp5Vz")).HelpCenterSettingsCustomerNotifications), (0, (0, parcelRequire("5lsNZ")).default)),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("jp5Vz")).LazyHelpCenterSettingsCustomerNotifications)
            ],
            resources: [
                ...(0, (0, parcelRequire("jHo3E")).getSettingsNavigationResources)((0, (0, parcelRequire("jHo3E")).SERVICE_DESK_PRODUCT))
            ]
        }));
    const $58e6269847de16de$export$f95717dac47e4db3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lKJB5")).helpCenterSettingsEmailRoute), ()=>({
            perfMetricKey: 'help-center-settings.email',
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: $58e6269847de16de$var$navigation,
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('jcs_master_flag', (0, (0, parcelRequire("lUb7T")).HelpCenterSettingsEmail), (0, (0, parcelRequire("5lsNZ")).default)),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("lUb7T")).LazyHelpCenterSettingsEmail)
            ],
            resources: [
                ...(0, (0, parcelRequire("jHo3E")).getSettingsNavigationResources)((0, (0, parcelRequire("jHo3E")).SERVICE_DESK_PRODUCT))
            ]
        }));
    const $58e6269847de16de$export$9a67aaae787c9f40 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lKJB5")).helpCenterSettingsFormsRoute), ()=>({
            perfMetricKey: 'help-center-settings.forms',
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: $58e6269847de16de$var$navigation,
            component: (0, (0, parcelRequire("5lsNZ")).default),
            entryPoint () {
                return (0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag') ? (0, (0, parcelRequire("uu31h")).helpCenterSettingFormsAppPageEntryPoint) : undefined;
            },
            resources: [
                ...(0, (0, parcelRequire("jHo3E")).getSettingsNavigationResources)((0, (0, parcelRequire("jHo3E")).SERVICE_DESK_PRODUCT)),
                (0, (0, parcelRequire("7D8h0")).formsResource)
            ]
        }));
    const $58e6269847de16de$export$1750cfcab794a07d = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("lKJB5")).helpCenterSettingsFormEditRoute), ()=>({
            perfMetricKey: 'help-center-settings.form-edit',
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: $58e6269847de16de$var$navigation,
            component: (0, (0, parcelRequire("5lsNZ")).default),
            entryPoint () {
                return (0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag') ? (0, (0, parcelRequire("7VD4g")).helpCenterSettingFormEditAppPageEntryPoint) : undefined;
            },
            resources: [
                ...(0, (0, parcelRequire("jHo3E")).getSettingsNavigationResources)((0, (0, parcelRequire("jHo3E")).SERVICE_DESK_PRODUCT))
            ]
        }));
});
parcelRegister("fBTqh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$43189553e9fc21a2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $hPtZI;
    const $43189553e9fc21a2$export$ea77f88c1b841127 = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("dbmHR")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/help-center-settings/src/index.tsx"
    });
    const $43189553e9fc21a2$var$HelpCenterSettingsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "servicedeskProject"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($43189553e9fc21a2$export$ea77f88c1b841127, null)));
    $43189553e9fc21a2$var$HelpCenterSettingsSidebar.displayName = 'HelpCenterSettingsSidebar';
    var $43189553e9fc21a2$export$2e2bcd8739ae039 = $43189553e9fc21a2$var$HelpCenterSettingsSidebar;
});
parcelRegister("dbmHR", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fQbJ3").then(()=>parcelRequire('5NHpB'));
});
parcelRegister("7D8h0", function(module, exports) {
    $parcel$export(module.exports, "formsResource", ()=>$8beb5bc3f227e13c$export$dbd8dbd978e7427);
    $parcel$export(module.exports, "useFormsResource", ()=>$8beb5bc3f227e13c$export$efd3ca9d66f19a97);
    var $dK8AG;
    var $dIdda = parcelRequire("dIdda");
    const $8beb5bc3f227e13c$var$getDataLoader = ()=>(parcelRequire("4ewnA"));
    const $8beb5bc3f227e13c$export$dbd8dbd978e7427 = (0, $dIdda.createResource)({
        type: 'HELP_CENTER_FORMS_RESOURCE',
        getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
        getDataLoader: $8beb5bc3f227e13c$var$getDataLoader
    });
    const $8beb5bc3f227e13c$export$efd3ca9d66f19a97 = ()=>(0, $dIdda.useResource)($8beb5bc3f227e13c$export$dbd8dbd978e7427);
});
parcelRegister("4ewnA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("gphZc").then(()=>parcelRequire('bEbHX'));
});
parcelRegister("lKJB5", function(module, exports) {
    $parcel$export(module.exports, "helpCenterSettingsRoute", ()=>$2937f4e9b4a14692$export$f544881b6385f520);
    $parcel$export(module.exports, "helpCenterSettingsKbRoute", ()=>$2937f4e9b4a14692$export$8a784299dc7faaff);
    $parcel$export(module.exports, "helpCenterSettingsCustomerNotificationsRoute", ()=>$2937f4e9b4a14692$export$88fcb9acf40a0827);
    $parcel$export(module.exports, "helpCenterSettingsEmailRoute", ()=>$2937f4e9b4a14692$export$4515288a48c62087);
    $parcel$export(module.exports, "helpCenterSettingsFormsRoute", ()=>$2937f4e9b4a14692$export$45b14c3ed47b2b3a);
    $parcel$export(module.exports, "helpCenterSettingsFormEditRoute", ()=>$2937f4e9b4a14692$export$31bd3e10c42460dc);
    var $65Ltd;
    const $2937f4e9b4a14692$var$HELP_CENTER_SETTINGS_URL = '/jira/helpcenter/projects/:projectKey/settings';
    const $2937f4e9b4a14692$export$f544881b6385f520 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HELP_CENTER_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HELP_CENTER_SETTINGS),
        path: $2937f4e9b4a14692$var$HELP_CENTER_SETTINGS_URL,
        exact: true
    };
    const $2937f4e9b4a14692$export$8a784299dc7faaff = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HELP_CENTER_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HELP_CENTER_SETTINGS_KNOWLEDGE_BASE),
        path: `${$2937f4e9b4a14692$var$HELP_CENTER_SETTINGS_URL}/kb`,
        exact: true
    };
    const $2937f4e9b4a14692$export$88fcb9acf40a0827 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HELP_CENTER_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HELP_CENTER_SETTINGS_CUSTOMER_NOTIFICATIONS),
        path: `${$2937f4e9b4a14692$var$HELP_CENTER_SETTINGS_URL}/customer-notifications`
    };
    const $2937f4e9b4a14692$export$4515288a48c62087 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HELP_CENTER_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HELP_CENTER_SETTINGS_EMAIL),
        path: `${$2937f4e9b4a14692$var$HELP_CENTER_SETTINGS_URL}/email`,
        exact: true
    };
    const $2937f4e9b4a14692$export$45b14c3ed47b2b3a = {
        exact: true,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HELP_CENTER_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HELP_CENTER_SETTINGS_FORMS),
        path: `${$2937f4e9b4a14692$var$HELP_CENTER_SETTINGS_URL}/forms`
    };
    const $2937f4e9b4a14692$export$31bd3e10c42460dc = {
        exact: true,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_HELP_CENTER_SETTINGS),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_HELP_CENTER_SETTINGS_FORM_EDIT),
        path: `${$2937f4e9b4a14692$var$HELP_CENTER_SETTINGS_URL}/forms/:formId`
    };
});
parcelRegister("jp5Vz", function(module, exports) {
    $parcel$export(module.exports, "LazyHelpCenterSettingsCustomerNotifications", ()=>$ce252471da0db8c1$export$b2b6550dec008a98);
    $parcel$export(module.exports, "HelpCenterSettingsCustomerNotifications", ()=>$ce252471da0db8c1$export$2f2f18f57014444a);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $ce252471da0db8c1$export$b2b6550dec008a98 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9czCW"))), {
        moduleId: "./src/packages/spa-apps/help-center-settings/customer-notifications/src/index.tsx"
    });
    const $ce252471da0db8c1$export$2f2f18f57014444a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ce252471da0db8c1$export$b2b6550dec008a98,
            pageId: "help-center-settings-customer-notifications",
            shouldShowSpinner: true
        });
});
parcelRegister("9czCW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("1Aiz0")
    ]).then(()=>parcelRequire('7QYfj'));
});
parcelRegister("lUb7T", function(module, exports) {
    $parcel$export(module.exports, "LazyHelpCenterSettingsEmail", ()=>$6353b69d503ce9ba$export$e090cd3a62343249);
    $parcel$export(module.exports, "HelpCenterSettingsEmail", ()=>$6353b69d503ce9ba$export$962f20e752738967);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $6353b69d503ce9ba$export$e090cd3a62343249 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("dB8mZ")), {
        moduleId: "./src/packages/spa-apps/help-center-settings/email/src/index.tsx"
    });
    const $6353b69d503ce9ba$export$962f20e752738967 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6353b69d503ce9ba$export$e090cd3a62343249,
            pageId: "help-center-settings-email",
            shouldShowSpinner: true
        });
});
parcelRegister("dB8mZ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("aUqEr")
    ]).then(()=>parcelRequire('7r8zn'));
});
parcelRegister("7VD4g", function(module, exports) {
    $parcel$export(module.exports, "helpCenterSettingFormEditAppPageEntryPoint", ()=>$73a7c9331a7a621d$export$2792cba2387cbc5c);
    var $lkFvK;
    var $lmyls;
    var $aXX0d;
    const $73a7c9331a7a621d$export$2792cba2387cbc5c = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, parcelRequire("aXX0d")).helpCenterSettingFormEditAppEntryPoint,
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HELP_CENTER_SETTINGS
    });
});
parcelRegister("aXX0d", function(module, exports) {
    $parcel$export(module.exports, "helpCenterSettingFormEditAppEntryPoint", ()=>$dcaafae9dc3cdb4f$export$262512d610e494f8);
    var $2Ftxm;
    var $ikgNX;
    const $dcaafae9dc3cdb4f$export$262512d610e494f8 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("acxar")), {
            moduleId: "d82eb4d8"
        }),
        getPreloadProps: ()=>{
            return {};
        }
    });
});
parcelRegister("acxar", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("f3edP")
    ]).then(()=>parcelRequire('3XNgZ'));
});
parcelRegister("uu31h", function(module, exports) {
    $parcel$export(module.exports, "helpCenterSettingFormsAppPageEntryPoint", ()=>$cf39360ee106b7b5$export$b50d944f3be2457f);
    var $lkFvK;
    var $lmyls;
    var $UvMAc;
    const $cf39360ee106b7b5$export$b50d944f3be2457f = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, parcelRequire("UvMAc")).helpCenterSettingFormsAppEntryPoint,
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).HELP_CENTER_SETTINGS
    });
});
parcelRegister("UvMAc", function(module, exports) {
    $parcel$export(module.exports, "helpCenterSettingFormsAppEntryPoint", ()=>$dbea87a49a7edd6e$export$ce8253ab16579f12);
    var $2Ftxm;
    var $ikgNX;
    const $dbea87a49a7edd6e$export$ce8253ab16579f12 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("iB2rz")), {
            moduleId: "c7a4dbb9"
        }),
        getPreloadProps: ()=>{
            return {};
        }
    });
});
parcelRegister("iB2rz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gZjef")
    ]).then(()=>parcelRequire('a6kDH'));
});
parcelRegister("81LME", function(module, exports) {
    $parcel$export(module.exports, "LazyHelpCenterSettingsKnowledgeBase", ()=>$d84b744908886ed8$export$92983043c677b1b1);
    $parcel$export(module.exports, "HelpCenterSettingsKnowledgeBase", ()=>$d84b744908886ed8$export$c1d58cf9dc0a2ed3);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $d84b744908886ed8$export$92983043c677b1b1 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4Ftk1"))), {
        moduleId: "./src/packages/spa-apps/help-center-settings/knowledge-settings/src/index.tsx"
    });
    const $d84b744908886ed8$export$c1d58cf9dc0a2ed3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d84b744908886ed8$export$92983043c677b1b1,
            pageId: "help-center-settings-knowledge-base",
            shouldShowSpinner: true
        });
});
parcelRegister("4Ftk1", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7gB9a")
    ]).then(()=>parcelRequire('5bGBK'));
});
parcelRegister("jHo3E", function(module, exports) {
    $parcel$export(module.exports, "SERVICE_DESK_PRODUCT", ()=>$dd054b5fe69a76d6$export$5575497f0592ee94);
    $parcel$export(module.exports, "getSettingsNavigationResources", ()=>$dd054b5fe69a76d6$export$586756e5c0542a50);
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    const $dd054b5fe69a76d6$export$b7262fe486f4b412 = 'core';
    const $dd054b5fe69a76d6$export$2954328f6207617a = 'software';
    const $dd054b5fe69a76d6$export$5575497f0592ee94 = 'servicedesk';
    const $dd054b5fe69a76d6$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $dd054b5fe69a76d6$export$586756e5c0542a50 = (product)=>{
        if (product === $dd054b5fe69a76d6$export$5575497f0592ee94) return (0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)();
        if (product === $dd054b5fe69a76d6$export$b7262fe486f4b412) return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
        ];
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
    };
});
parcelRegister("rAcxJ", function(module, exports) {
    $parcel$export(module.exports, "Redirect", ()=>$44cb5391898ae9e8$export$2d8d895a0a0f636e);
    var $5uXOq = parcelRequire("5uXOq");
    var $5lsNZ;
    var $lKJB5;
    var $7OYJs;
    var $dIdda = parcelRequire("dIdda");
    const $44cb5391898ae9e8$export$2d8d895a0a0f636e = ()=>{
        const [projectKey = ''] = (0, $dIdda.usePathParam)('projectKey');
        const helpCenterSettingsEmail = (0, (0, parcelRequire("lKJB5")).helpCenterSettingsEmailRoute).path.replace(':projectKey', projectKey);
        return projectKey ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: helpCenterSettingsEmail,
            persistSearchParams: true
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5lsNZ")).default), null);
    };
});
parcelRegister("igDdP", function(module, exports) {
    $parcel$export(module.exports, "projectSettingsRouteEntries", ()=>$512b517449862f9e$export$fd0ef3739cde76c1);
    var $ivkjS;
    var $5x9Js;
    var $2D9P9;
    const $512b517449862f9e$export$fd0ef3739cde76c1 = [
        ...(0, (0, parcelRequire("2D9P9")).softwareRouteEntries),
        ...(0, (0, parcelRequire("5x9Js")).serviceDeskRouteEntries),
        ...(0, (0, parcelRequire("ivkjS")).projectSettingsCoreRouteEntries)
    ];
});
parcelRegister("ivkjS", function(module, exports) {
    $parcel$export(module.exports, "projectSettingsCoreRouteEntries", ()=>$f037ab3fb0896e94$export$4bad3905623f839b);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $18N1t;
    var $lkFvK;
    var $cSD7y;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $loy04;
    var $ggg5j;
    var $iEUaw;
    var $8rIQt;
    var $2G9Bk;
    var $lNicp;
    var $3RJkv;
    var $kJQXA;
    var $eOlBz;
    var $dxCvy;
    var $e7C7O;
    var $5lsNZ;
    var $8yaXd;
    var $d0oNj;
    var $ljyNx;
    var $femMW;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $dIdda = parcelRequire("dIdda");
    var $7dO7c;
    const $f037ab3fb0896e94$var$approvalsProjectSettingsPageEntryPoint = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("ljyNx")).approvalsProjectSettingsEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $f037ab3fb0896e94$var$emailNotificationsLogEntryPointPage = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("femMW")).notificationsIssueLogsEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $f037ab3fb0896e94$var$getNavigationSidebarProjectResource = ()=>[
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource)
        ];
    const $f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource = ()=>[
            (0, (0, parcelRequire("eOlBz")).newIssueViewTransitionLockInStatusResource),
            (0, (0, parcelRequire("kJQXA")).navigationSidebarAutomationLegacyEnabledResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache),
            (0, (0, parcelRequire("5bkvv")).forgeProjectSettingsModuleResource),
            (0, (0, parcelRequire("loy04")).staticProjectSettingsSidebarConnectAddonsNavigationResource)
        ];
    const $f037ab3fb0896e94$var$LazyIssueTypeSettings = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("61LFA"))), {
        moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$b6450e98f3b2e500 = ({ match: match })=>{
        const { issueTypeId: issueTypeId } = match.params;
        const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyIssueTypeSettings,
            pageId: pageId,
            shouldShowSpinner: false
        });
    };
    const $f037ab3fb0896e94$var$LazyFieldsSettings = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("NWARb"))), {
        moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$642e36be5f0881cd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyFieldsSettings,
            pageId: "project-settings-fields",
            shouldShowSpinner: true
        });
    const $f037ab3fb0896e94$var$LazyWorkflowNavigationSettings = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("l00Ww"))), {
        moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$2fc344606596921e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyWorkflowNavigationSettings,
            pageId: "project-settings-workflow-navigation",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$var$LazyConnectAppsSettings = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("RJn1w"))), {
        moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$a9e7f90b84deda9f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyConnectAppsSettings,
            pageId: "project-settings-connect-apps",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$var$LazyConnectAppControlsSettings = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9RXCH"))), {
        moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$ceddc4fc7b9c0729 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyConnectAppControlsSettings,
            pageId: "project-settings-connect-app-controls",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$var$LazyDetailsSettings = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kVevk"))), {
        moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$3e8048d3cf2ba3fd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyDetailsSettings,
            pageId: "project-settings-details",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$var$LazyPeopleSettings = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("b3T21"))), {
        moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$3026e5a52c747d2c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyPeopleSettings,
            pageId: "project-settings-people",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$var$LazyProjectSettingsProformaProjectForms = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("2Js68")), {
        moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$4963607e49ab309f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyProjectSettingsProformaProjectForms,
            pageId: "project-settings-proforma-project-forms",
            shouldShowSpinner: true
        });
    const $f037ab3fb0896e94$var$LazyProjectSettingsProformaJiraFormBuilder = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("9Saqg")), {
        moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$c32892afcc1da510 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyProjectSettingsProformaJiraFormBuilder,
            pageId: "project-settings-proforma-jira-form-builder",
            shouldShowSpinner: true
        });
    const $f037ab3fb0896e94$var$LazyProjectSettingsJiraAutomation = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("c32Mm")), {
        moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$132a1e91790bf469 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyProjectSettingsJiraAutomation,
            pageId: "project-settings-jira-automation",
            shouldShowSpinner: true
        });
    const $f037ab3fb0896e94$var$LazyDataClassificationsSettings = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2igd7"))), {
        moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$a325b082c894541b = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyDataClassificationsSettings,
            pageId: "project-settings-data-classifications",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$var$LazyNotificationsSettings = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3oy92"))), {
        moduleId: "./src/packages/spa-apps/project-settings/software-notifications/src/index.tsx"
    });
    const $f037ab3fb0896e94$var$LazyNotificationsIssueLogs = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1Nsfq"))), {
        moduleId: "./src/packages/spa-apps/project-settings/software-notifications-issue-logs/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$36ba2f559d49a8f6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyNotificationsSettings,
            pageId: "project-settings-software-notifications",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$export$361bca0a4a18e111 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyNotificationsIssueLogs,
            pageId: "project-settings-software-notifications-issue-logs",
            shouldShowSpinner: false
        });
    const $f037ab3fb0896e94$var$LazyProjectSettingsNotificationEmail = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("bm5Zl"))), {
        moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$90c2f52b54888c20 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyProjectSettingsNotificationEmail,
            pageId: "project-settings-email-notifications",
            shouldShowSpinner: true
        });
    const $f037ab3fb0896e94$var$LazyForgeProjectSettingsPage = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("3kJhU")), {
        moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
    });
    const $f037ab3fb0896e94$export$b943f48844c671a5 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f037ab3fb0896e94$var$LazyForgeProjectSettingsPage,
            pageId: "forge-spa-project-settings",
            shouldShowSpinner: true
        });
    const $f037ab3fb0896e94$export$df1c02c3f28b7a95 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8yaXd")).projectSettingsCoreDefaultRedirectRoute), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: (0, (0, parcelRequire("7dO7c")).ProjectSettingsRedirect),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    const $f037ab3fb0896e94$export$95ecbacf0120fcfd = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8yaXd")).projectSettingsCoreIssueTypesRoute), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$b6450e98f3b2e500,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyIssueTypeSettings
            ]
        }));
    const $f037ab3fb0896e94$export$8d8dff75124dcebc = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8yaXd")).projectSettingsCoreFieldsRoute), ()=>({
            ufoName: 'project-settings.fields.jwm-tmp',
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)(),
                (0, (0, parcelRequire("e7C7O")).fieldSettingsRelayResource)
            ],
            component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('project_fields_page_for_tmp_-_mvp', $f037ab3fb0896e94$export$642e36be5f0881cd, (0, (0, parcelRequire("5lsNZ")).default)),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyFieldsSettings
            ]
        }));
    const $f037ab3fb0896e94$export$1dfd4811b9065dd6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8yaXd")).projectSettingsCoreIssueTypesWorkflowRoute), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$2fc344606596921e,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyWorkflowNavigationSettings
            ]
        }));
    const $f037ab3fb0896e94$export$c038a2892f34f1a9 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8yaXd")).projectSettingsCoreAppsRoute), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$a9e7f90b84deda9f,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyConnectAppsSettings
            ]
        }));
    const $f037ab3fb0896e94$export$7870a0b1630a504e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8yaXd")).projectSettingsCoreAppsFieldsRoute), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$ceddc4fc7b9c0729,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyConnectAppControlsSettings
            ]
        }));
    const $f037ab3fb0896e94$export$438a330ccc1e7a91 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8yaXd")).projectSettingsCoreDetailsRoute), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$3e8048d3cf2ba3fd,
            skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsDetailsSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyDetailsSettings
            ]
        }));
    const $f037ab3fb0896e94$export$8188648c76953df0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8yaXd")).projectSettingsCoreAccessRoute), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$3026e5a52c747d2c,
            skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsAccessSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyPeopleSettings
            ],
            ufoName: 'project-settings.access'
        }));
    const $f037ab3fb0896e94$export$36e1851c22975fc0 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8yaXd")).projectSettingsCoreAccessRedirectRoute), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                    to: `/jira/core/projects/${String(match.params.projectKey)}/settings/access`,
                    push: false
                }),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyPeopleSettings
            ]
        }));
    const $f037ab3fb0896e94$export$5e9e27f116094fdf = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8yaXd")).projectSettingsCoreProformaProjectFormsRoute), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$4963607e49ab309f,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyProjectSettingsProformaProjectForms
            ],
            perfMetricKey: 'forms-settings'
        }));
    const $f037ab3fb0896e94$export$46d6b55ebf21ccc = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8yaXd")).projectSettingsCoreProformaJiraFormBuilderRoute), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$c32892afcc1da510,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyProjectSettingsProformaJiraFormBuilder
            ],
            perfMetricKey: 'form-builder'
        }));
    const $f037ab3fb0896e94$export$a244870e56f5c9a3 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8yaXd")).projectSettingsCoreAutomationRoute), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$132a1e91790bf469,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyProjectSettingsJiraAutomation
            ],
            ufoName: 'project-settings-automation-core'
        }));
    const $f037ab3fb0896e94$export$a2c8a6767edeeaed = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8yaXd")).projectSettingsCoreAutomationV2Route), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$132a1e91790bf469,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyProjectSettingsJiraAutomation
            ]
        }));
    const $f037ab3fb0896e94$export$cf5194c476e8bcdb = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8yaXd")).projectSettingsCoreDataClassificationsRoute), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$a325b082c894541b,
            skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsDetailsSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
    const $f037ab3fb0896e94$export$ed481b03aa858542 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8yaXd")).projectSettingsCoreNotificationsRoute), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$36ba2f559d49a8f6,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyNotificationsSettings
            ]
        }));
    const $f037ab3fb0896e94$export$e562140c482cb0c = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8yaXd")).projectSettingsCoreNotificationsIssueLogsRoute), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$361bca0a4a18e111,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyNotificationsIssueLogs
            ],
            entryPoint () {
                return $f037ab3fb0896e94$var$emailNotificationsLogEntryPointPage;
            }
        }));
    const $f037ab3fb0896e94$export$da36a1671d868927 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8yaXd")).projectSettingsCoreNotificationsEmailRoute), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$90c2f52b54888c20,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyProjectSettingsNotificationEmail
            ]
        }));
    const $f037ab3fb0896e94$export$1006fd9f5f02b1c2 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8yaXd")).projectSettingsCoreForgeAppsRoute), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            component: $f037ab3fb0896e94$export$b943f48844c671a5,
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $f037ab3fb0896e94$var$LazyForgeProjectSettingsPage
            ]
        }));
    const $f037ab3fb0896e94$export$728033a86ab68014 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8yaXd")).projectSettingsCoreApprovalsRoute), ()=>({
            navigation: {
                horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("8rIQt")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            layout: (0, (0, parcelRequire("18N1t")).coreProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectResource(),
                ...$f037ab3fb0896e94$var$getNavigationSidebarProjectSettingsResource(),
                ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
            ],
            entryPoint () {
                return $f037ab3fb0896e94$var$approvalsProjectSettingsPageEntryPoint;
            }
        }));
    const $f037ab3fb0896e94$export$4bad3905623f839b = [
        $f037ab3fb0896e94$export$95ecbacf0120fcfd,
        $f037ab3fb0896e94$export$8d8dff75124dcebc,
        $f037ab3fb0896e94$export$1dfd4811b9065dd6,
        $f037ab3fb0896e94$export$7870a0b1630a504e,
        $f037ab3fb0896e94$export$c038a2892f34f1a9,
        $f037ab3fb0896e94$export$438a330ccc1e7a91,
        $f037ab3fb0896e94$export$8188648c76953df0,
        $f037ab3fb0896e94$export$36e1851c22975fc0,
        $f037ab3fb0896e94$export$5e9e27f116094fdf,
        $f037ab3fb0896e94$export$46d6b55ebf21ccc,
        $f037ab3fb0896e94$export$a2c8a6767edeeaed,
        $f037ab3fb0896e94$export$cf5194c476e8bcdb,
        $f037ab3fb0896e94$export$a244870e56f5c9a3,
        $f037ab3fb0896e94$export$ed481b03aa858542,
        $f037ab3fb0896e94$export$e562140c482cb0c,
        $f037ab3fb0896e94$export$da36a1671d868927,
        $f037ab3fb0896e94$export$1006fd9f5f02b1c2,
        $f037ab3fb0896e94$export$728033a86ab68014,
        $f037ab3fb0896e94$export$df1c02c3f28b7a95
    ];
});
parcelRegister("8rIQt", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$17427f16dde00e98$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fobme;
    var $acDan;
    var $8snXd;
    var $hFFWh;
    const $17427f16dde00e98$var$MultiProjectSidebarCore = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("acDan")).SidebarRenderStart), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8snXd")).PerformanceMark), {
            id: (0, (0, parcelRequire("8snXd")).RENDER_START_MARK)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hFFWh")).default), null), !false && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("acDan")).SidebarReady), {
            id: (0, (0, parcelRequire("fobme")).SIDEBAR_ID).CORE
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8snXd")).PerformanceMark), {
            id: (0, (0, parcelRequire("8snXd")).RENDER_END_MARK)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8snXd")).PerformanceReport), null)));
    var $17427f16dde00e98$export$2e2bcd8739ae039 = $17427f16dde00e98$var$MultiProjectSidebarCore;
});
parcelRegister("8snXd", function(module, exports) {
    $parcel$export(module.exports, "RENDER_START_MARK", ()=>$5e4f397416a402e4$export$8f8203e04f80aed);
    $parcel$export(module.exports, "RENDER_END_MARK", ()=>$5e4f397416a402e4$export$dc795f9b21e2778a);
    $parcel$export(module.exports, "PerformanceMark", ()=>$5e4f397416a402e4$export$b8228db3a01d9a76);
    $parcel$export(module.exports, "PerformanceReport", ()=>$5e4f397416a402e4$export$c97ab321326d29f7);
    var $5uXOq = parcelRequire("5uXOq");
    var $cHBMC;
    const $5e4f397416a402e4$var$JWM_SIDEBAR_SEGMENT_NAME = 'jwm.sidebar';
    const $5e4f397416a402e4$export$8f8203e04f80aed = `${$5e4f397416a402e4$var$JWM_SIDEBAR_SEGMENT_NAME}.render.start`;
    const $5e4f397416a402e4$export$dc795f9b21e2778a = `${$5e4f397416a402e4$var$JWM_SIDEBAR_SEGMENT_NAME}.render.end`;
    const $5e4f397416a402e4$var$segment = (0, (0, parcelRequire("cHBMC")).metrics).pageSegmentLoad({
        key: $5e4f397416a402e4$var$JWM_SIDEBAR_SEGMENT_NAME,
        timings: [
            {
                key: 'tti',
                endMark: $5e4f397416a402e4$export$dc795f9b21e2778a
            }
        ]
    });
    const $5e4f397416a402e4$export$b8228db3a01d9a76 = ({ id: id })=>{
        const startedRef = (0, $5uXOq.useRef)(false);
        if (!false && !startedRef.current) {
            $5e4f397416a402e4$var$segment.startFromPageLoad();
            startedRef.current = true;
        }
        (0, $5uXOq.useEffect)(()=>$5e4f397416a402e4$var$segment.mark(id), [
            id
        ]);
        return null;
    };
    const $5e4f397416a402e4$export$c97ab321326d29f7 = ()=>{
        (0, $5uXOq.useEffect)(()=>{
            $5e4f397416a402e4$var$segment.stop();
        }, []);
        return null;
    };
});
parcelRegister("hFFWh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af0c023251a98909$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8e8QT;
    var $4R6GH;
    var $koVbs;
    var $cE2Qr;
    var $8zOmE;
    var $95EVP;
    var $iNzEe;
    var $cZpsT;
    var $dIdda = parcelRequire("dIdda");
    var $6tzEU;
    var $aueMW;
    var $iZNik;
    var $NCdt4;
    var $dCGEg;
    var $6KeQr;
    var $k5gug;
    const $af0c023251a98909$var$MultiProjectMenu = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        const { currentProject: currentProject, recents: recents, favorites: favorites, hasMoreFavorite: hasMoreFavorite, onFavoriteToggle: onFavoriteToggle, overviews: overviews, overviewsError: overviewsError, shouldHideOverviews: shouldHideOverviews, loading: loading } = (0, (0, parcelRequire("6tzEU")).useSidebarData)();
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        const isPremiumUserSeat = (0, (0, parcelRequire("iNzEe")).useIsPremiumUserSeat)();
        const [projectState] = (0, (0, parcelRequire("cE2Qr")).useProjectState)();
        const [{ match: { params: { projectKey: projectKey } } }] = (0, $dIdda.useRouter)();
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'sidebar viewed', {
                starredProjectsCount: favorites.length,
                recentProjectsCount: recents.length,
                overviewsCount: overviews.length
            });
        }, []);
        const currentProjectKey = projectKey ?? currentProject?.key;
        const shouldDisplayOverviews = isPremiumUserSeat && !isAnonymous && !shouldHideOverviews;
        const projectsContent = (0, ($parcel$interopDefault($5uXOq))).createElement("section", null, favorites.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6KeQr")).default), {
            sectionId: "starred",
            projects: favorites,
            onFavoriteToggle: onFavoriteToggle,
            currentProjectKey: currentProjectKey,
            showViewAllProjects: hasMoreFavorite,
            viewAllProjectsLabel: formatMessage((0, (0, parcelRequire("NCdt4")).default).viewAllStarred)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6KeQr")).default), {
            sectionId: "recent",
            projects: recents,
            onFavoriteToggle: onFavoriteToggle,
            currentProjectKey: currentProjectKey,
            showViewAllProjects: true
        }));
        const isShowingCTA = projectState?.isSampleProject === true;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SidebarWrapper, {
            "aria-label": formatMessage((0, (0, parcelRequire("NCdt4")).default).navigationLabel),
            isCrossProjectView: true
        }, shouldDisplayOverviews && (loading ? (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$OverviewsSkeleton, null) : (0, ($parcel$interopDefault($5uXOq))).createElement("section", {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dCGEg")).default), {
            overviews: overviews,
            hasError: Boolean(overviewsError)
        }))), loading ? (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ProjectsSkeleton, null) : (0, ($parcel$interopDefault($5uXOq))).createElement("section", {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.projects"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k5gug")).default), null), projectsContent), !loading && isShowingCTA && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aueMW")).CreateProjectCta), null)), (0, (0, parcelRequire("4R6GH")).fg)('jwm_mobile_discovery') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8e8QT")).AsyncMobileDownloadPrompt), null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$Footer, {
            hasMargin: true
        }, currentProject != null && (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$Type, {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.project-type"
        }, currentProject.isSimplified ? formatMessage((0, (0, parcelRequire("NCdt4")).default).teamManagedProject) : formatMessage((0, (0, parcelRequire("NCdt4")).default).companyManagedProject)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iZNik")).default), null)));
    };
    const $af0c023251a98909$var$ItemSkeleton = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeletonWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemAvatarSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SkeletonBase, null));
    const $af0c023251a98909$var$OverviewsSkeleton = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SkeletonSection, null, (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SectionHeaderSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null));
    const $af0c023251a98909$var$ProjectsSkeleton = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SkeletonSection, null, (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$SectionHeaderSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$CollapsibleHeaderSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$CollapsibleHeaderSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null), (0, ($parcel$interopDefault($5uXOq))).createElement($af0c023251a98909$var$ItemSkeleton, null));
    const $af0c023251a98909$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _11q7vuon",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$SidebarWrapper = (0, $5uXOq.forwardRef)(({ as: C = "nav", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isCrossProjectView: isCrossProjectView, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_n3tdpxbi _19bvpxbi _u5f3pxbi _19pkr5cr _otyridpf _18u0idpf _2hwxidpf _1reo1wug _18m91wug _16jlkb7n _1o9zkb7n _i0dlf1ug _11q71mi8 _12vemgnk _1lrwy1fe _qmxj4ebz _qjkj6grs _azbnu2gc",
                __cmplp.isCrossProjectView ? "_ca0qpxbi" : "_ca0q1b66",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$SkeletonBase = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11q7iw92 _4t3i1crf _1bsbqkoa _2rko1y44 _otyrutpp",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$SkeletonSection = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pk1ejb",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$SectionHeaderSkeleton = (0, $5uXOq.forwardRef)(({ as: C = $af0c023251a98909$var$SkeletonBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb68cl _4t3i7vkz",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$ItemSkeletonWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$ItemAvatarSkeleton = (0, $5uXOq.forwardRef)(({ as: C = $af0c023251a98909$var$SkeletonBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1tcg _4t3i1tcg _18u0utpp _2hwxutpp",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$CollapsibleHeaderSkeleton = (0, $5uXOq.forwardRef)(({ as: C = $af0c023251a98909$var$SkeletonBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbys9h _18u0u2gc _19pkutpp",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$Footer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { hasMargin: hasMargin, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o",
                __cmplp.hasMargin && "_18s8u2gc",
                __cmplp.className
            ])
        });
    });
    const $af0c023251a98909$var$Type = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81vlj _y3gn1h6o _18s8swc3 _1tke7vkz _syaz1rc1",
                __cmplp.className
            ])
        });
    });
    var $af0c023251a98909$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($af0c023251a98909$var$MultiProjectMenu);
});
parcelRegister("8e8QT", function(module, exports) {
    $parcel$export(module.exports, "AsyncMobileDownloadPrompt", ()=>$7f26c5865794a560$export$64ca7d64bb703770);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $12nJ9;
    const $7f26c5865794a560$var$runtimeProps = {};
    const $7f26c5865794a560$var$entryPointParams = {};
    const $7f26c5865794a560$export$64ca7d64bb703770 = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("12nJ9")).downloadMobilePromptEntryPoint), $7f26c5865794a560$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "jiraBusinessDownloadMobilePrompt",
            packageName: (0, $244834d5fcf707c7$export$b8b9d90f9e5bd72b),
            teamName: "frontier",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: $7f26c5865794a560$var$runtimeProps,
            errorFallback: "unmount"
        });
    };
});
const $244834d5fcf707c7$export$b8b9d90f9e5bd72b = 'jiraBusinessMobileDownloadPrompt';
parcelRegister("12nJ9", function(module, exports) {
    $parcel$export(module.exports, "downloadMobilePromptEntryPoint", ()=>$15bca80131d9ba79$export$66f4c5613c7e964);
    var $2Ftxm;
    var $ikgNX;
    const $15bca80131d9ba79$export$66f4c5613c7e964 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("jyTpt")), {
            moduleId: "c94481ab"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("jyTpt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kpbiP").then(()=>parcelRequire('2ea9U'));
});
parcelRegister("cE2Qr", function(module, exports) {
    $parcel$export(module.exports, "useJswOnboarding", ()=>$796be817ff5bbbfa$export$7d91c0af4772787a);
    $parcel$export(module.exports, "useOpenTask", ()=>$796be817ff5bbbfa$export$594f006fa6a1b2e5);
    $parcel$export(module.exports, "useNudgeStep", ()=>$796be817ff5bbbfa$export$c5e63e44ad178ae8);
    $parcel$export(module.exports, "useQuickstartActions", ()=>$796be817ff5bbbfa$export$2c3cd14fff9d6e43);
    $parcel$export(module.exports, "useShouldShowNudge", ()=>$796be817ff5bbbfa$export$b0db7e46e369e1d9);
    $parcel$export(module.exports, "useInviteToProject", ()=>$796be817ff5bbbfa$export$71de79653346a1ea);
    $parcel$export(module.exports, "useShowVideoCards", ()=>$796be817ff5bbbfa$export$61185a9266f1f57a);
    $parcel$export(module.exports, "useProjectState", ()=>$796be817ff5bbbfa$export$ef4747ba36826d6a);
    $parcel$export(module.exports, "useQuickstartUiStatus", ()=>$796be817ff5bbbfa$export$522993b46d9f8266);
    $parcel$export(module.exports, "useIsLoaded", ()=>$796be817ff5bbbfa$export$aa4ba29241532382);
    $parcel$export(module.exports, "useIsFocusedOn", ()=>$796be817ff5bbbfa$export$ed5c755b733bf2b1);
    $parcel$export(module.exports, "useIsDismissed", ()=>$796be817ff5bbbfa$export$35fe0366802512dd);
    $parcel$export(module.exports, "useCompletedTaskList", ()=>$796be817ff5bbbfa$export$a41ee0d3b6938099);
    $parcel$export(module.exports, "useAllTasksCompleted", ()=>$796be817ff5bbbfa$export$4ae7b465b076be9);
    $parcel$export(module.exports, "useMountedNudges", ()=>$796be817ff5bbbfa$export$bf6e646c0476acad);
    $parcel$export(module.exports, "useHasEverSeen", ()=>$796be817ff5bbbfa$export$6b706bff94798d11);
    $parcel$export(module.exports, "useRoadmapState", ()=>$796be817ff5bbbfa$export$c98db656edc5b3e1);
    $parcel$export(module.exports, "useShouldShowScrumOnboardingExperience", ()=>$796be817ff5bbbfa$export$a823278ac9d1112b);
    $parcel$export(module.exports, "useShouldShowOnboardingKanbanTour", ()=>$796be817ff5bbbfa$export$cb9e0e8fe4df8490);
    $parcel$export(module.exports, "useHasNudgeActive", ()=>$796be817ff5bbbfa$export$521909e3dc7ab811);
    $parcel$export(module.exports, "QUICKSTART_UI_STATUS", ()=>(parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS);
    var $58GFP;
    var $4R6GH;
    var $7JoAD = parcelRequire("7JoAD");
    var $8Bc5A;
    var $6RAg1;
    var $ieqoN;
    var $cGE52;
    var $3B5jO;
    var $4ji4w;
    const $796be817ff5bbbfa$export$390f32400eaf98c9 = (0, $7JoAD.createStore)({
        name: 'jsw-onboarding-quickstart',
        initialState: (0, parcelRequire("cGE52")).initialState,
        actions: (0, parcelRequire("6RAg1"))
    });
    const $796be817ff5bbbfa$export$1cbc60d8dd921852 = (0, $7JoAD.createSubscriber)($796be817ff5bbbfa$export$390f32400eaf98c9);
    const $796be817ff5bbbfa$export$7d91c0af4772787a = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9);
    const $796be817ff5bbbfa$export$638bfcfce1254bb8 = (0, $7JoAD.createContainer)($796be817ff5bbbfa$export$390f32400eaf98c9, {});
    const $796be817ff5bbbfa$export$9d731f44f82af09f = (state, { itemNames: itemNames })=>{
        const commonConditionsToShowNudge = state.shouldRenderComponent && state.visibility[(0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state)] === (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN && itemNames.includes(state.openTask);
        return commonConditionsToShowNudge && state.hasNudgeActive;
    };
    const $796be817ff5bbbfa$export$ea14030920a5d8e6 = (state)=>state.openTask;
    const $796be817ff5bbbfa$export$594f006fa6a1b2e5 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: $796be817ff5bbbfa$export$ea14030920a5d8e6
    });
    const $796be817ff5bbbfa$export$a943afa434e9487a = (state)=>state.nudgeStep;
    const $796be817ff5bbbfa$export$c5e63e44ad178ae8 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: $796be817ff5bbbfa$export$a943afa434e9487a
    });
    const $796be817ff5bbbfa$export$2c3cd14fff9d6e43 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: null
    });
    const $796be817ff5bbbfa$export$b0db7e46e369e1d9 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: $796be817ff5bbbfa$export$9d731f44f82af09f
    });
    const $796be817ff5bbbfa$export$71de79653346a1ea = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>Boolean(state.projectState && state.projectState.canInvitePeopleToProject)
    });
    const $796be817ff5bbbfa$export$61185a9266f1f57a = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>{
            if (!state.projectState) return false;
            const { isNextGen: isNextGen, userRole: userRole, isProjectAdmin: isProjectAdmin } = state.projectState;
            return Boolean(isNextGen && (userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).JIRA_ADMIN || userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).SITE_ADMIN || isProjectAdmin));
        }
    });
    const $796be817ff5bbbfa$export$ef4747ba36826d6a = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.projectState
    });
    const $796be817ff5bbbfa$export$522993b46d9f8266 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>{
            const quickstartType = (0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state);
            if (state.shouldRenderComponent === false) return (0, (0, parcelRequire("4ji4w")).getLocalStorageItem)(`${quickstartType}.visibility`) ?? (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).NOT_LOADED;
            return state.visibility[quickstartType];
        }
    });
    const $796be817ff5bbbfa$export$aa4ba29241532382 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.isQuickstartLoaded
    });
    const $796be817ff5bbbfa$export$ed5c755b733bf2b1 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.isFocusedOn
    });
    const $796be817ff5bbbfa$export$35fe0366802512dd = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>{
            const visibility = state.visibility[(0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state)];
            return visibility === (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).DISMISSED || visibility === (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).NOT_LOADED && (0, (0, parcelRequire("4R6GH")).fg)('jsw-perf-async-add-people-modal-load');
        }
    });
    const $796be817ff5bbbfa$export$a41ee0d3b6938099 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.completedTaskList
    });
    const $796be817ff5bbbfa$export$4ae7b465b076be9 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>{
            if (!state.tasks) return null;
            return state.tasks.items.every((task)=>state.completedTaskList.includes(task));
        }
    });
    const $796be817ff5bbbfa$export$bf6e646c0476acad = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.mountedNudges
    });
    const $796be817ff5bbbfa$export$6b706bff94798d11 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.hasEverSeenRoute
    });
    const $796be817ff5bbbfa$export$c98db656edc5b3e1 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>({
                roadmapIsCreateEnabled: state.roadmapIsCreateEnabled,
                roadmapIsListEmpty: state.roadmapIsListEmpty
            })
    });
    const $796be817ff5bbbfa$export$a823278ac9d1112b = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>Boolean(state.isQuickstartLoaded && !state.isDevOpsProject && state.selectedProjectTemplateKeyFromOnboarding === (0, (0, parcelRequire("58GFP")).SCRUM_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).SITE_ADMIN)
    });
    const $796be817ff5bbbfa$export$cb9e0e8fe4df8490 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>Boolean(state.isQuickstartLoaded && !state.isDevOpsProject && state.selectedProjectTemplateKeyFromOnboarding === (0, (0, parcelRequire("58GFP")).KANBAN_TEAM_MANAGED_KEY) && state.projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).SITE_ADMIN && !state.completedTaskList.includes((0, (0, parcelRequire("8Bc5A")).KANBAN_ONBOARDING_TASK)))
    });
    const $796be817ff5bbbfa$export$521909e3dc7ab811 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.hasNudgeActive
    });
    const $796be817ff5bbbfa$export$f4a2be940259bf95 = (0, $7JoAD.createHook)($796be817ff5bbbfa$export$390f32400eaf98c9, {
        selector: (state)=>state.selectedProjectTemplateKeyFromOnboarding
    });
});
parcelRegister("58GFP", function(module, exports) {
    $parcel$export(module.exports, "KANBAN_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$f40a08fc76eb112d);
    $parcel$export(module.exports, "KANBAN_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$e3844688f2693533);
    $parcel$export(module.exports, "SCRUM_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$e3cec071fcb2fbd3);
    $parcel$export(module.exports, "SCRUM_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$21783d461e3ef6d);
    $parcel$export(module.exports, "BUG_TRACKING_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$6cd1c1b2ba0f6e2d);
    $parcel$export(module.exports, "CROSS_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$57d877f2e01e0029);
    $parcel$export(module.exports, "CROSS_TEAM_PLANNING_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$6f4213a3addc3fdb);
    $parcel$export(module.exports, "JWM_TEMPLATE_PREFIX", ()=>$c364c398187f9175$export$7492b6cc3ef89883);
    $parcel$export(module.exports, "PROJECT_MANAGEMENT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$7d9a4e0ef5194fe1);
    $parcel$export(module.exports, "PROJECT_MANAGEMENT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$477ca3550da12e43);
    $parcel$export(module.exports, "BLANK_TEMPLATE_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$b5ab111fb8825075);
    $parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$14139f0ec41d437e);
    $parcel$export(module.exports, "CAMPAIGN_MANAGEMENT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$ebf7af45376deb8b);
    $parcel$export(module.exports, "CONTENT_MANAGEMENT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$7b6945581ccdab4a);
    $parcel$export(module.exports, "CONTENT_MANAGEMENT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$310a9ac5c28d65f6);
    $parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$4d29ee0c00eb5df4);
    $parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$6278b41164dbde6c);
    $parcel$export(module.exports, "IT_SERVICE_MANAGEMENT_BASIC_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$17a2f771efabf02f);
    $parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$bd14946bcde77195);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_TEMPLATE_KEY", ()=>$c364c398187f9175$export$e8df553a3f519284);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_COMPANY_MANAGED_TEMPLATE_KEY", ()=>$c364c398187f9175$export$97fc32bd703bb4d1);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_IT_TEMPLATE_KEY", ()=>$c364c398187f9175$export$8eecdf6acea9494);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_BUSINESS_COMPANY_MANAGED_TEMPLATE_KEY", ()=>$c364c398187f9175$export$ff16be7794ed4222);
    $parcel$export(module.exports, "BLANK_SERVICE_MANAGEMENT_PROJECT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$9917830b560a2f4);
    $parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$b0928b02ffab3875);
    $parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_COMPANY_MANAGED_KEY", ()=>$c364c398187f9175$export$fd75f6abc7861439);
    $parcel$export(module.exports, "GENERAL_SERVICE_PROJECT_FOR_IT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$fb658bddae7f81bb);
    $parcel$export(module.exports, "HR_SERVICE_PROJECT_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$2bc7db2da3df8313);
    $parcel$export(module.exports, "INITIAL_PROJECT_TEMPLATE_PROJECT_PROPERTY_KEY", ()=>$c364c398187f9175$export$87a8fff98b5bc81);
    $parcel$export(module.exports, "PRODUCT_DISCOVERY_TEAM_MANAGED_KEY", ()=>$c364c398187f9175$export$7c567eb725bd36f);
    $parcel$export(module.exports, "getIsJsmBlankProjectTemplate", ()=>$c364c398187f9175$export$73fd025e86012868);
    $parcel$export(module.exports, "getGeneralITOrBusinessProjectTemplateMap", ()=>$c364c398187f9175$export$a062badd78c9993);
    const $c364c398187f9175$export$f40a08fc76eb112d = 'com.pyxis.greenhopper.jira:gh-simplified-agility-kanban';
    const $c364c398187f9175$export$e3844688f2693533 = 'com.pyxis.greenhopper.jira:gh-simplified-kanban-classic';
    const $c364c398187f9175$export$e3cec071fcb2fbd3 = 'com.pyxis.greenhopper.jira:gh-simplified-agility-scrum';
    const $c364c398187f9175$export$21783d461e3ef6d = 'com.pyxis.greenhopper.jira:gh-simplified-scrum-classic';
    const $c364c398187f9175$export$6cd1c1b2ba0f6e2d = 'com.pyxis.greenhopper.jira:gh-simplified-basic';
    const $c364c398187f9175$export$57d877f2e01e0029 = 'com.pyxis.greenhopper.jira:gh-cross-team-template';
    const $c364c398187f9175$export$6f4213a3addc3fdb = 'com.pyxis.greenhopper.jira:gh-cross-team-planning-template';
    const $c364c398187f9175$export$7492b6cc3ef89883 = 'com.atlassian.jira-core-project-templates';
    const $c364c398187f9175$export$7d9a4e0ef5194fe1 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-project-management`;
    const $c364c398187f9175$export$477ca3550da12e43 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-project-management-team-managed`;
    const $c364c398187f9175$export$7c0307155b744916 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project`;
    const $c364c398187f9175$export$b5ab111fb8825075 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-blank-project-team-managed`;
    const $c364c398187f9175$export$14139f0ec41d437e = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management`;
    const $c364c398187f9175$export$ebf7af45376deb8b = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-campaign-management-team-managed`;
    const $c364c398187f9175$export$7b6945581ccdab4a = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-core-simplified-content-management`;
    const $c364c398187f9175$export$310a9ac5c28d65f6 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-content-management-team-managed`;
    const $c364c398187f9175$export$136d17feb2f4285d = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-task-tracking-team-managed`;
    const $c364c398187f9175$export$e288f4758e94a8cc = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-document-approval-team-managed`;
    const $c364c398187f9175$export$4e9ac1417ba54bba = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-process-control-team-managed`;
    const $c364c398187f9175$export$560c9f6765bf9af4 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-policy-management-team-managed`;
    const $c364c398187f9175$export$14d4c6dbbb62a127 = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-sales-pipeline-team-managed`;
    const $c364c398187f9175$export$1367ee12532c525f = `${$c364c398187f9175$export$7492b6cc3ef89883}:jira-work-management-procurement-team-managed`;
    const $c364c398187f9175$export$4d29ee0c00eb5df4 = 'com.atlassian.servicedesk:simplified-it-service-management';
    const $c364c398187f9175$export$6278b41164dbde6c = 'com.atlassian.servicedesk:next-gen-it-service-desk';
    const $c364c398187f9175$export$17a2f771efabf02f = 'com.atlassian.servicedesk:simplified-it-service-management-basic';
    const $c364c398187f9175$export$bd14946bcde77195 = 'com.atlassian.jcs:customer-service-management';
    const $c364c398187f9175$export$e8df553a3f519284 = 'jsm.blank-project-business-cmp-only';
    const $c364c398187f9175$export$97fc32bd703bb4d1 = 'com.atlassian.servicedesk:simplified-blank-project-it';
    const $c364c398187f9175$export$8eecdf6acea9494 = 'jsm.blank-project-it-cmp-only';
    const $c364c398187f9175$export$ff16be7794ed4222 = 'com.atlassian.servicedesk:simplified-blank-project-business';
    const $c364c398187f9175$export$9e38ad41d19608ee = 'jsm.blank-service-management';
    const $c364c398187f9175$export$9917830b560a2f4 = 'com.atlassian.servicedesk:company-managed-blank-service-project';
    const $c364c398187f9175$export$b95641716115e7f9 = 'com.atlassian.servicedesk:team-managed-blank-service-project';
    const $c364c398187f9175$export$e87297d5e9fa3d43 = 'com.atlassian.servicedesk:simplified-legal-service-desk';
    const $c364c398187f9175$export$3f1f11fb5d08da21 = 'com.atlassian.servicedesk:next-gen-legal-service-desk';
    const $c364c398187f9175$export$2b90912656e0b76b = 'com.atlassian.servicedesk:simplified-general-service-desk';
    const $c364c398187f9175$export$e8fdad132bc6d342 = 'com.atlassian.servicedesk:next-gen-general-service-desk';
    const $c364c398187f9175$export$b0928b02ffab3875 = 'com.atlassian.servicedesk:company-managed-general-service-project';
    const $c364c398187f9175$export$50478ee5ecbf7a4d = 'com.atlassian.servicedesk:team-managed-general-service-project';
    const $c364c398187f9175$export$fd75f6abc7861439 = 'com.atlassian.servicedesk:simplified-general-service-desk-it';
    const $c364c398187f9175$export$fb658bddae7f81bb = 'com.atlassian.servicedesk:next-gen-general-it-service-desk';
    const $c364c398187f9175$export$e82092c4fb277f9b = 'com.atlassian.servicedesk:simplified-general-service-desk-business';
    const $c364c398187f9175$export$5eddf3b31dd1858f = 'com.atlassian.servicedesk:next-gen-general-business-service-desk';
    const $c364c398187f9175$export$bc3e0c6bccecee38 = 'com.atlassian.servicedesk:simplified-external-service-desk';
    const $c364c398187f9175$export$feb6dd6f9d18a640 = 'com.atlassian.servicedesk:next-gen-external-service-desk';
    const $c364c398187f9175$export$f3c5f5a180797f04 = 'com.atlassian.servicedesk:simplified-hr-service-desk';
    const $c364c398187f9175$export$2bc7db2da3df8313 = 'com.atlassian.servicedesk:next-gen-hr-service-desk';
    const $c364c398187f9175$export$a1a1f02e9f561918 = 'com.atlassian.servicedesk:simplified-facilities-service-desk';
    const $c364c398187f9175$export$17a955064ab71480 = 'com.atlassian.servicedesk:next-gen-facilities-service-desk';
    const $c364c398187f9175$export$d66326f3f6b558b = 'com.atlassian.servicedesk:simplified-analytics-service-desk';
    const $c364c398187f9175$export$6c5416b0177f2ef3 = 'com.atlassian.servicedesk:next-gen-analytics-service-desk';
    const $c364c398187f9175$export$ea36fb35725fc554 = 'com.atlassian.servicedesk:simplified-finance-service-desk';
    const $c364c398187f9175$export$e7038c17e9311de9 = 'com.atlassian.servicedesk:next-gen-finance-service-desk';
    const $c364c398187f9175$export$38d7bc62a093e5a3 = 'com.atlassian.servicedesk:simplified-marketing-service-desk';
    const $c364c398187f9175$export$fa06d276537993ce = 'com.atlassian.servicedesk:next-gen-marketing-service-desk';
    const $c364c398187f9175$export$9801b8ec713d3079 = 'com.atlassian.servicedesk:simplified-sales-service-desk';
    const $c364c398187f9175$export$a9f0e6470e3b6147 = 'com.atlassian.servicedesk:next-gen-sales-service-desk';
    const $c364c398187f9175$export$aeedd4330ac1268c = 'com.atlassian.servicedesk:simplified-design-service-desk';
    const $c364c398187f9175$export$c0e4ffe74102f756 = 'com.atlassian.servicedesk:next-gen-design-service-desk';
    const $c364c398187f9175$export$87a8fff98b5bc81 = 'initial.project.template.name';
    const $c364c398187f9175$export$7c567eb725bd36f = 'jira.polaris:discovery';
    const $c364c398187f9175$export$b0eec2c6558182ca = 'jira.polaris:blank-project';
    const $c364c398187f9175$export$f9776303073903dd = 'jira.polaris:roadmap';
    const $c364c398187f9175$export$b7c4ca557ac2074e = 'jira.polaris:prioritization';
    const $c364c398187f9175$export$73fd025e86012868 = (T4JTemplateKey)=>T4JTemplateKey === $c364c398187f9175$export$e8df553a3f519284 || T4JTemplateKey === $c364c398187f9175$export$8eecdf6acea9494 || T4JTemplateKey === $c364c398187f9175$export$9e38ad41d19608ee;
    const $c364c398187f9175$export$a062badd78c9993 = {
        [$c364c398187f9175$export$e82092c4fb277f9b]: $c364c398187f9175$export$b0928b02ffab3875,
        [$c364c398187f9175$export$fd75f6abc7861439]: $c364c398187f9175$export$b0928b02ffab3875,
        [$c364c398187f9175$export$5eddf3b31dd1858f]: $c364c398187f9175$export$50478ee5ecbf7a4d,
        [$c364c398187f9175$export$fb658bddae7f81bb]: $c364c398187f9175$export$50478ee5ecbf7a4d
    };
});
parcelRegister("8Bc5A", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$5f07ce956337ba8b$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "PACKAGE_TEAM_NAME", ()=>$5f07ce956337ba8b$export$2b3151a089bc8780);
    $parcel$export(module.exports, "DEFAULT_NUDGE_WIDTH", ()=>$5f07ce956337ba8b$export$6826d33e9a2c0119);
    $parcel$export(module.exports, "ROOT_TASK", ()=>$5f07ce956337ba8b$export$b580da85daad7757);
    $parcel$export(module.exports, "REVERSE_TRIAL_ROOT_TASK", ()=>$5f07ce956337ba8b$export$5eef19b26a4bbe70);
    $parcel$export(module.exports, "QUICKSTART_TYPE", ()=>$5f07ce956337ba8b$export$c57d251ae83aff51);
    $parcel$export(module.exports, "getBackendVisibilityKey", ()=>$5f07ce956337ba8b$export$d9df7fd23ab00c49);
    $parcel$export(module.exports, "KEY_OPEN", ()=>$5f07ce956337ba8b$export$93a67c1026e8cb7c);
    $parcel$export(module.exports, "KEY_DISMISSED", ()=>$5f07ce956337ba8b$export$a7dcb0b5013e932b);
    $parcel$export(module.exports, "KEY_TASK_GROUP", ()=>$5f07ce956337ba8b$export$f962b14e410d598f);
    $parcel$export(module.exports, "KEY_OPEN_TASK", ()=>$5f07ce956337ba8b$export$21e8355b28449456);
    $parcel$export(module.exports, "KEY_HAS_EVER_SEEN_ROUTE", ()=>$5f07ce956337ba8b$export$536a90031123e004);
    $parcel$export(module.exports, "KEY_PREMIUM_TRIAL_REOPENED", ()=>$5f07ce956337ba8b$export$3ccd291a1a3a4f6d);
    $parcel$export(module.exports, "KEY_IS_DEVOPS_PROJECT", ()=>$5f07ce956337ba8b$export$e5b557e3bbb7ec52);
    $parcel$export(module.exports, "ACTION_SUBJECT_ID", ()=>$5f07ce956337ba8b$export$9957974f8b4d8f74);
    $parcel$export(module.exports, "SOURCE", ()=>$5f07ce956337ba8b$export$83c8d7110915321e);
    $parcel$export(module.exports, "KEY_JSW_ONBOARDING", ()=>$5f07ce956337ba8b$export$8b9bd2a9275b0187);
    $parcel$export(module.exports, "convertToHaveSeenItTask", ()=>$5f07ce956337ba8b$export$ec43e7bf5973b10f);
    $parcel$export(module.exports, "ADD_COLUMNS_TASK", ()=>$5f07ce956337ba8b$export$cbeb719208f32c8a);
    $parcel$export(module.exports, "CREATE_PROJECT_TASK", ()=>$5f07ce956337ba8b$export$88c918f2cfaff86);
    $parcel$export(module.exports, "CREATE_ISSUE_TASK", ()=>$5f07ce956337ba8b$export$abbbea7c37c93cb5);
    $parcel$export(module.exports, "CREATE_ISSUE_TASK_SIMPLIFIED", ()=>$5f07ce956337ba8b$export$2a0253cb20f48a8);
    $parcel$export(module.exports, "INVITE_TEAMMATES_TASK", ()=>$5f07ce956337ba8b$export$f97428bb4b1991ec);
    $parcel$export(module.exports, "INVITE_TEAMMATES_VIDEO_TASK", ()=>$5f07ce956337ba8b$export$45eaf4204fcc7);
    $parcel$export(module.exports, "CAPTURE_INTEGRATIONS_TASK", ()=>$5f07ce956337ba8b$export$af57685e201438e8);
    $parcel$export(module.exports, "FIND_HELP_TASK", ()=>$5f07ce956337ba8b$export$d6c67e9aab4e2b26);
    $parcel$export(module.exports, "SET_UP_BOARD_TASK", ()=>$5f07ce956337ba8b$export$3de8c242d2b82f26);
    $parcel$export(module.exports, "GET_MOBILE_APP_TASK", ()=>$5f07ce956337ba8b$export$a01fa44f793dbfac);
    $parcel$export(module.exports, "MAP_OUT_YOUR_PROJECT_GOALS_TASK", ()=>$5f07ce956337ba8b$export$6a4507e462fd41da);
    $parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK", ()=>$5f07ce956337ba8b$export$e64c1dced6ac4458);
    $parcel$export(module.exports, "IDENTIFY_SMALL_CHUNKS_OF_WORK_KANBAN_TASK", ()=>$5f07ce956337ba8b$export$63b0e55f9c6454ac);
    $parcel$export(module.exports, "MONITOR_MANAGE_RISK_TASK", ()=>$5f07ce956337ba8b$export$c1effb1c8979fe22);
    $parcel$export(module.exports, "PREMIUM_REVERSE_TRIAL_TASK", ()=>$5f07ce956337ba8b$export$d97d31d934dbb194);
    $parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK", ()=>$5f07ce956337ba8b$export$cafb5bd13b02056b);
    $parcel$export(module.exports, "PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN", ()=>$5f07ce956337ba8b$export$e55c18b809946e72);
    $parcel$export(module.exports, "STANDARD_EDITION_OVERVIEW_TASK", ()=>$5f07ce956337ba8b$export$de5640b9ae8140a7);
    $parcel$export(module.exports, "ADVANCED_ROADMAPS_TASK", ()=>$5f07ce956337ba8b$export$540b5c3c4b6ce459);
    $parcel$export(module.exports, "CHANGE_CONTROL_TASK", ()=>$5f07ce956337ba8b$export$6f71dff531ff592);
    $parcel$export(module.exports, "AUTOMATIONS_TASK", ()=>$5f07ce956337ba8b$export$83255ab79e45f34f);
    $parcel$export(module.exports, "SITE_ADMINISTRATIONS_TASK", ()=>$5f07ce956337ba8b$export$b57d172af9ad7647);
    $parcel$export(module.exports, "USER_MANAGEMENT_TASK", ()=>$5f07ce956337ba8b$export$ff4c933c1fe90b68);
    $parcel$export(module.exports, "SCRUM_ONBOARDING_TASK", ()=>$5f07ce956337ba8b$export$3e2776d61f3662dc);
    $parcel$export(module.exports, "CUSTOMIZE_SITE_NAME_TASK", ()=>$5f07ce956337ba8b$export$9048315f2c03fd9d);
    $parcel$export(module.exports, "GET_TO_KNOW_YOUR_TEMPLATE_TASK", ()=>$5f07ce956337ba8b$export$a333714599f14a6);
    $parcel$export(module.exports, "CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK", ()=>$5f07ce956337ba8b$export$4145c2cec2da6f9b);
    $parcel$export(module.exports, "TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK", ()=>$5f07ce956337ba8b$export$4957a1ad203cf6dd);
    $parcel$export(module.exports, "CALENDAR_VIEW_TASK", ()=>$5f07ce956337ba8b$export$190b5dd0a1322552);
    $parcel$export(module.exports, "JWM_PROJECT_SUMMARY_TASK", ()=>$5f07ce956337ba8b$export$501166b25f254aab);
    $parcel$export(module.exports, "JWM_CREATE_SAMPLE_PROJECT_TASK", ()=>$5f07ce956337ba8b$export$94ad6507a703f4eb);
    $parcel$export(module.exports, "JWM_BACKGROUND_COLOR_TASK", ()=>$5f07ce956337ba8b$export$be1c522400a1bd7c);
    $parcel$export(module.exports, "JWM_CALENDAR_TASK", ()=>$5f07ce956337ba8b$export$2aa6e7b6e24a04f5);
    $parcel$export(module.exports, "JWM_TIMELINE_TASK", ()=>$5f07ce956337ba8b$export$f3b53199b07af2a1);
    $parcel$export(module.exports, "JWM_BUILD_FORM_TASK", ()=>$5f07ce956337ba8b$export$d37415ffddcf2142);
    $parcel$export(module.exports, "JWM_FEEDBACK_TASK", ()=>$5f07ce956337ba8b$export$2ae00586da7cb606);
    $parcel$export(module.exports, "JWM_FEEDBACK_SAMPLE_PROJECT_TASK", ()=>$5f07ce956337ba8b$export$b86266e6594a97bb);
    $parcel$export(module.exports, "JWM_CREATE_YOUR_OWN_PROJECT_TASK", ()=>$5f07ce956337ba8b$export$20bc3dc137ac1c38);
    $parcel$export(module.exports, "JWM_CREATE_PROJECT_TASK", ()=>$5f07ce956337ba8b$export$77071b77e2801b18);
    $parcel$export(module.exports, "JWM_SHARE_PROJECT_TASK", ()=>$5f07ce956337ba8b$export$9c89f946f05d884a);
    $parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_IMPORT", ()=>$5f07ce956337ba8b$export$b52a7c936684cfc5);
    $parcel$export(module.exports, "JWM_SUMMARY_AND_REPORTS_TASK", ()=>$5f07ce956337ba8b$export$b5555f24061f9fb);
    $parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK", ()=>$5f07ce956337ba8b$export$ff25449f34b8abf);
    $parcel$export(module.exports, "JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES", ()=>$5f07ce956337ba8b$export$3380e677209260fe);
    $parcel$export(module.exports, "GET_STARTED_LIST_TASK", ()=>$5f07ce956337ba8b$export$7a2fcaad1564e6b7);
    $parcel$export(module.exports, "OPS_JTBD_1_LIST", ()=>$5f07ce956337ba8b$export$da23b72d32bfad9e);
    $parcel$export(module.exports, "OPS_JTBD_2_BOARD", ()=>$5f07ce956337ba8b$export$4b064659282e0238);
    $parcel$export(module.exports, "OPS_JTBD_2_FORMS", ()=>$5f07ce956337ba8b$export$3ab51851f6d823e);
    $parcel$export(module.exports, "OPS_JTBD_2_SUMMARY", ()=>$5f07ce956337ba8b$export$e4a1a37a9a1350ad);
    $parcel$export(module.exports, "OPS_JTBD_3_LIST", ()=>$5f07ce956337ba8b$export$b7f7da5e795f0327);
    $parcel$export(module.exports, "OPS_JTBD_3_CALENDAR", ()=>$5f07ce956337ba8b$export$80a401c1aa47a377);
    $parcel$export(module.exports, "OPS_JTBD_3_PAGES", ()=>$5f07ce956337ba8b$export$934ac7a251b26dc7);
    $parcel$export(module.exports, "OPS_JTBD_4_LIST", ()=>$5f07ce956337ba8b$export$4634f6395df3ebbe);
    $parcel$export(module.exports, "OPS_JTBD_4_CALENDAR", ()=>$5f07ce956337ba8b$export$768fb41107a1e8d7);
    $parcel$export(module.exports, "OPS_JTBD_4_TIMELINE", ()=>$5f07ce956337ba8b$export$d797a81bace17184);
    $parcel$export(module.exports, "OPS_JTBD_4_SUMMARY", ()=>$5f07ce956337ba8b$export$746102c94db9df1f);
    $parcel$export(module.exports, "OPS_JTBD_5_LIST", ()=>$5f07ce956337ba8b$export$5f1efd797d65e349);
    $parcel$export(module.exports, "OPS_JTBD_5_TIMELINE", ()=>$5f07ce956337ba8b$export$cccc812ccafbf11f);
    $parcel$export(module.exports, "OPS_JTBD_5_PAGES", ()=>$5f07ce956337ba8b$export$64822db87abd8a47);
    $parcel$export(module.exports, "OPS_JTBD_6_PAGES", ()=>$5f07ce956337ba8b$export$64f764d8be495c82);
    $parcel$export(module.exports, "OPS_JTBD_7_LIST", ()=>$5f07ce956337ba8b$export$24eae23dc1c68bbd);
    $parcel$export(module.exports, "OPS_JTBD_7_CALENDAR", ()=>$5f07ce956337ba8b$export$50fa92eba6f82feb);
    $parcel$export(module.exports, "OPS_JTBD_0_LIST", ()=>$5f07ce956337ba8b$export$4155d22fe3f14cd6);
    $parcel$export(module.exports, "OPS_JTBD_0_TIMELINE", ()=>$5f07ce956337ba8b$export$76813cbead887191);
    $parcel$export(module.exports, "OPS_JTBD_0_PAGES", ()=>$5f07ce956337ba8b$export$90aab2ff89daf770);
    $parcel$export(module.exports, "OPS_JTBD_DEFAULT_LIST", ()=>$5f07ce956337ba8b$export$a2bc0cbad2e6e605);
    $parcel$export(module.exports, "OPS_JTBD_DEFAULT_BOARD", ()=>$5f07ce956337ba8b$export$f90872a1280728bb);
    $parcel$export(module.exports, "OPS_JTBD_DEFAULT_INVITES", ()=>$5f07ce956337ba8b$export$bce644e96518cbd2);
    $parcel$export(module.exports, "MKT_JTBD_1_LIST", ()=>$5f07ce956337ba8b$export$241aaebffac0a3e5);
    $parcel$export(module.exports, "MKT_JTBD_1_CALENDAR", ()=>$5f07ce956337ba8b$export$f9dfc43b5b31c4b7);
    $parcel$export(module.exports, "MKT_JTBD_1_TIMELINE", ()=>$5f07ce956337ba8b$export$79759e9e62fb9312);
    $parcel$export(module.exports, "MKT_JTBD_2_CALENDAR", ()=>$5f07ce956337ba8b$export$992d1e0dce255d19);
    $parcel$export(module.exports, "MKT_JTBD_2_PAGES", ()=>$5f07ce956337ba8b$export$d28c1b0e5b3e768);
    $parcel$export(module.exports, "MKT_JTBD_3_PAGES", ()=>$5f07ce956337ba8b$export$ca714ee197bed4ec);
    $parcel$export(module.exports, "MKT_JTBD_3_TIMELINE", ()=>$5f07ce956337ba8b$export$faae55ceea4b6073);
    $parcel$export(module.exports, "MKT_JTBD_4_LIST", ()=>$5f07ce956337ba8b$export$200bc24cd120667e);
    $parcel$export(module.exports, "MKT_JTBD_4_SUMMARY", ()=>$5f07ce956337ba8b$export$a0d784a48b4e886c);
    $parcel$export(module.exports, "MKT_JTBD_4_PAGES", ()=>$5f07ce956337ba8b$export$baf5bd09b4b33b8a);
    $parcel$export(module.exports, "MKT_JTBD_5_TIMELINE", ()=>$5f07ce956337ba8b$export$4702007eedbca8ab);
    $parcel$export(module.exports, "MKT_JTBD_5_SUMMARY", ()=>$5f07ce956337ba8b$export$aa9d2d635ea63898);
    $parcel$export(module.exports, "MKT_JTBD_6_FORMS", ()=>$5f07ce956337ba8b$export$2ea449225c1f6cac);
    $parcel$export(module.exports, "MKT_JTBD_0_LIST", ()=>$5f07ce956337ba8b$export$deb8b557e735e26a);
    $parcel$export(module.exports, "MKT_JTBD_0_CALENDAR", ()=>$5f07ce956337ba8b$export$d45754df44e4c309);
    $parcel$export(module.exports, "MKT_JTBD_0_TIMELINE", ()=>$5f07ce956337ba8b$export$78b2913b550edbb);
    $parcel$export(module.exports, "MKT_JTBD_0_SUMMARY", ()=>$5f07ce956337ba8b$export$71243272608c58ab);
    $parcel$export(module.exports, "MKT_JTBD_DEFAULT_LIST", ()=>$5f07ce956337ba8b$export$39a08f215c33bc39);
    $parcel$export(module.exports, "MKT_JTBD_DEFAULT_BOARD", ()=>$5f07ce956337ba8b$export$d2377f6a6fa3b49c);
    $parcel$export(module.exports, "MKT_JTBD_DEFAULT_PROJECT", ()=>$5f07ce956337ba8b$export$befa8f6533309779);
    $parcel$export(module.exports, "MKT_JTBD_DEFAULT_INVITES", ()=>$5f07ce956337ba8b$export$736b40db8701ba6c);
    $parcel$export(module.exports, "JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK", ()=>$5f07ce956337ba8b$export$99b0e09ff6f00490);
    $parcel$export(module.exports, "JSM_REVIEW_YOUR_CHANNELS_TASK", ()=>$5f07ce956337ba8b$export$2a82344eb273eeff);
    $parcel$export(module.exports, "JSM_INVITE_YOUR_TEAM_TASK", ()=>$5f07ce956337ba8b$export$1de5766b7e640d6b);
    $parcel$export(module.exports, "DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK", ()=>$5f07ce956337ba8b$export$8ab0859f5b30b013);
    $parcel$export(module.exports, "DEVOPS_GET_TO_KNOW_JIRA_TASK", ()=>$5f07ce956337ba8b$export$d1f6d18c6698104c);
    $parcel$export(module.exports, "DEVOPS_NAVIGATE_YOUR_TOOLS_TASK", ()=>$5f07ce956337ba8b$export$e6ee159eee7adc1c);
    $parcel$export(module.exports, "DEVOPS_CAPTURE_INTEGRATIONS_TASK", ()=>$5f07ce956337ba8b$export$dd267ca1e3cd3bad);
    $parcel$export(module.exports, "DEVOPS_CREATE_AUTOMATION_RULES_TASK", ()=>$5f07ce956337ba8b$export$f14c8bffc35200d3);
    $parcel$export(module.exports, "DEVOPS_INVITE_TEAMMATES_TASK", ()=>$5f07ce956337ba8b$export$36cc22c9997d92a);
    $parcel$export(module.exports, "DEVOPS_FIND_HELP_TASK", ()=>$5f07ce956337ba8b$export$d651cc94a46ff383);
    $parcel$export(module.exports, "KEY_HAS_NAVIGATED_FROM_LINK", ()=>$5f07ce956337ba8b$export$11c0696d49e68c93);
    $parcel$export(module.exports, "ACCOUNT_ID", ()=>$5f07ce956337ba8b$export$c8ab6996f562d0db);
    $parcel$export(module.exports, "KANBAN_ONBOARDING_TASK", ()=>$5f07ce956337ba8b$export$2b5f951ad8e70cfe);
    $parcel$export(module.exports, "QUICKSTART_UI_STATUS", ()=>$5f07ce956337ba8b$export$5703447487aaccdf);
    $parcel$export(module.exports, "BACKLOG_CREATE_SPRINT_NUDGE_ID", ()=>$5f07ce956337ba8b$export$e0197e09cccd4e50);
    $parcel$export(module.exports, "PROJECT_SETTING_PAGES", ()=>$5f07ce956337ba8b$export$f779bbfe667acddc);
    $parcel$export(module.exports, "JSM_BUSINESS_TASKS", ()=>$5f07ce956337ba8b$export$38fbac7a5bf4aa33);
    $parcel$export(module.exports, "allTasksExcludingJSMBusinessTasks", ()=>$5f07ce956337ba8b$export$7578902c7f420a3);
    var $65Ltd;
    var $g5X3G;
    const $5f07ce956337ba8b$var$completeJwmTaskName = (taskId)=>`jwm-onboarding-checklist.${taskId}`;
    const $5f07ce956337ba8b$var$completeJswTaskName = (taskId)=>`jsw-onboarding-checklist.${taskId}`;
    const $5f07ce956337ba8b$var$completeJsmTaskName = (taskId)=>`jsm-onboarding-checklist.${taskId}`;
    const $5f07ce956337ba8b$var$completeDevopsTaskName = (taskId)=>`devops-onboarding-checklist.${taskId}`;
    const $5f07ce956337ba8b$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingQuickstart';
    const $5f07ce956337ba8b$export$2b3151a089bc8780 = 'jlove-makkuro';
    const $5f07ce956337ba8b$export$6826d33e9a2c0119 = 320;
    const $5f07ce956337ba8b$export$b580da85daad7757 = 'root';
    const $5f07ce956337ba8b$export$5eef19b26a4bbe70 = 'reverseTrialRoot';
    const $5f07ce956337ba8b$export$c57d251ae83aff51 = {
        JSM_BUSINESS_QUICKSTART_KEY: 'jsm-business-checklist',
        OLD_GLOBAL_QUICKSTART_KEY: 'jsw-onboarding-checklist'
    };
    const $5f07ce956337ba8b$export$d9df7fd23ab00c49 = (type)=>`${type}.visibility`;
    const $5f07ce956337ba8b$export$93a67c1026e8cb7c = 'jsw-onboarding-checklist.open';
    const $5f07ce956337ba8b$export$a7dcb0b5013e932b = 'jsw-onboarding-checklist.dismissed';
    const $5f07ce956337ba8b$export$f962b14e410d598f = 'jsw-onboarding-checklist.task-group';
    const $5f07ce956337ba8b$export$21e8355b28449456 = 'jsw-onboarding-checklist.open-task';
    const $5f07ce956337ba8b$export$536a90031123e004 = 'jsw-onboarding-checklist.has-ever-seen-route';
    const $5f07ce956337ba8b$export$3ccd291a1a3a4f6d = 'jsw-onboarding-checklist.reopened-on-premium-trial';
    const $5f07ce956337ba8b$export$e5b557e3bbb7ec52 = 'isDevopsProject';
    const $5f07ce956337ba8b$export$9957974f8b4d8f74 = 'nuxOnboardingQuickstart';
    const $5f07ce956337ba8b$export$83c8d7110915321e = 'nuxOnboardingQuickstart';
    const $5f07ce956337ba8b$export$8b9bd2a9275b0187 = 'jsw.onboarding';
    const $5f07ce956337ba8b$export$ec43e7bf5973b10f = (taskId)=>`${taskId}.have-seenit`;
    const $5f07ce956337ba8b$export$cbeb719208f32c8a = $5f07ce956337ba8b$var$completeJswTaskName('add-columns-task');
    const $5f07ce956337ba8b$export$88c918f2cfaff86 = $5f07ce956337ba8b$var$completeJswTaskName('create-project-task');
    const $5f07ce956337ba8b$export$abbbea7c37c93cb5 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task');
    const $5f07ce956337ba8b$export$2a0253cb20f48a8 = $5f07ce956337ba8b$var$completeJswTaskName('create-issue-task-simplified');
    const $5f07ce956337ba8b$export$f97428bb4b1991ec = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-task');
    const $5f07ce956337ba8b$export$45eaf4204fcc7 = $5f07ce956337ba8b$var$completeJswTaskName('invite-teammates-video-task');
    const $5f07ce956337ba8b$export$af57685e201438e8 = $5f07ce956337ba8b$var$completeJswTaskName('capture-integrations-task');
    const $5f07ce956337ba8b$export$d6c67e9aab4e2b26 = $5f07ce956337ba8b$var$completeJswTaskName('find-help-task');
    const $5f07ce956337ba8b$export$3de8c242d2b82f26 = $5f07ce956337ba8b$var$completeJswTaskName('set-up-board-task');
    const $5f07ce956337ba8b$export$a01fa44f793dbfac = $5f07ce956337ba8b$var$completeJswTaskName('get-mobile-app-task');
    const $5f07ce956337ba8b$export$6a4507e462fd41da = $5f07ce956337ba8b$var$completeJswTaskName('map-out-your-project-goals');
    const $5f07ce956337ba8b$export$e64c1dced6ac4458 = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work');
    const $5f07ce956337ba8b$export$63b0e55f9c6454ac = $5f07ce956337ba8b$var$completeJswTaskName('identify-small-chunks-of-work-kanban');
    const $5f07ce956337ba8b$export$c1effb1c8979fe22 = $5f07ce956337ba8b$var$completeJswTaskName('monitor-manage-risk');
    const $5f07ce956337ba8b$export$d97d31d934dbb194 = $5f07ce956337ba8b$var$completeJswTaskName('premium-reverse-trial-task');
    const $5f07ce956337ba8b$export$cafb5bd13b02056b = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task');
    const $5f07ce956337ba8b$export$e55c18b809946e72 = $5f07ce956337ba8b$var$completeJswTaskName('premium-edition-overview-task-non-admin');
    const $5f07ce956337ba8b$export$de5640b9ae8140a7 = $5f07ce956337ba8b$var$completeJswTaskName('standard-edition-overview-task');
    const $5f07ce956337ba8b$export$540b5c3c4b6ce459 = $5f07ce956337ba8b$var$completeJswTaskName('advanced-roadmaps-task');
    const $5f07ce956337ba8b$export$6f71dff531ff592 = $5f07ce956337ba8b$var$completeJswTaskName('change-control-task');
    const $5f07ce956337ba8b$export$83255ab79e45f34f = $5f07ce956337ba8b$var$completeJswTaskName('automations-task');
    const $5f07ce956337ba8b$export$b57d172af9ad7647 = $5f07ce956337ba8b$var$completeJswTaskName('site-administrations-task');
    const $5f07ce956337ba8b$export$ff4c933c1fe90b68 = $5f07ce956337ba8b$var$completeJswTaskName('user-management-task');
    const $5f07ce956337ba8b$export$3e2776d61f3662dc = $5f07ce956337ba8b$var$completeJswTaskName('scrum-onboarding-task');
    const $5f07ce956337ba8b$export$9048315f2c03fd9d = $5f07ce956337ba8b$var$completeJswTaskName('customize-site-name-task');
    const $5f07ce956337ba8b$export$a333714599f14a6 = $5f07ce956337ba8b$var$completeJswTaskName('get-to-know-your-template-task');
    const $5f07ce956337ba8b$export$4145c2cec2da6f9b = $5f07ce956337ba8b$var$completeJswTaskName('create-business-project-from-jsw-quickstart-task');
    const $5f07ce956337ba8b$export$4957a1ad203cf6dd = $5f07ce956337ba8b$var$completeJswTaskName('try-atlassian-university-task');
    const $5f07ce956337ba8b$export$190b5dd0a1322552 = $5f07ce956337ba8b$var$completeJswTaskName('calendar-view-task');
    const $5f07ce956337ba8b$export$501166b25f254aab = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-project-summary-task');
    const $5f07ce956337ba8b$export$94ad6507a703f4eb = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-sample-project-task');
    const $5f07ce956337ba8b$export$be1c522400a1bd7c = $5f07ce956337ba8b$var$completeJwmTaskName('background-color-task');
    const $5f07ce956337ba8b$export$2aa6e7b6e24a04f5 = $5f07ce956337ba8b$var$completeJwmTaskName('calendar-task');
    const $5f07ce956337ba8b$export$f3b53199b07af2a1 = $5f07ce956337ba8b$var$completeJwmTaskName('timeline-task');
    const $5f07ce956337ba8b$export$d37415ffddcf2142 = $5f07ce956337ba8b$var$completeJwmTaskName('build-form-task');
    const $5f07ce956337ba8b$export$2ae00586da7cb606 = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-task');
    const $5f07ce956337ba8b$export$b86266e6594a97bb = $5f07ce956337ba8b$var$completeJwmTaskName('feedback-sample-project-task');
    const $5f07ce956337ba8b$export$20bc3dc137ac1c38 = $5f07ce956337ba8b$var$completeJwmTaskName('create-your-own-project-task');
    const $5f07ce956337ba8b$export$77071b77e2801b18 = $5f07ce956337ba8b$var$completeJwmTaskName('jwm-create-project-task');
    const $5f07ce956337ba8b$export$9c89f946f05d884a = $5f07ce956337ba8b$var$completeJwmTaskName('share-project-task');
    const $5f07ce956337ba8b$export$ce8b25442735839a = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-boards');
    const $5f07ce956337ba8b$export$31015cf4e430c94d = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-cards');
    const $5f07ce956337ba8b$export$b52a7c936684cfc5 = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-import');
    const $5f07ce956337ba8b$export$b5555f24061f9fb = $5f07ce956337ba8b$var$completeJwmTaskName('summary-and-reports-task');
    const $5f07ce956337ba8b$export$ff25449f34b8abf = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-calendar-and-timeline');
    const $5f07ce956337ba8b$export$3380e677209260fe = $5f07ce956337ba8b$var$completeJwmTaskName('trello-crossflow-key-differences');
    const $5f07ce956337ba8b$export$7a2fcaad1564e6b7 = $5f07ce956337ba8b$var$completeJwmTaskName('get-started-list-task');
    const $5f07ce956337ba8b$export$da23b72d32bfad9e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_1_LIST');
    const $5f07ce956337ba8b$export$4b064659282e0238 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_BOARD');
    const $5f07ce956337ba8b$export$3ab51851f6d823e = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_FORMS');
    const $5f07ce956337ba8b$export$e4a1a37a9a1350ad = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_2_SUMMARY');
    const $5f07ce956337ba8b$export$b7f7da5e795f0327 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_LIST');
    const $5f07ce956337ba8b$export$80a401c1aa47a377 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_CALENDAR');
    const $5f07ce956337ba8b$export$934ac7a251b26dc7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_3_PAGES');
    const $5f07ce956337ba8b$export$4634f6395df3ebbe = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_LIST');
    const $5f07ce956337ba8b$export$768fb41107a1e8d7 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_CALENDAR');
    const $5f07ce956337ba8b$export$d797a81bace17184 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_TIMELINE');
    const $5f07ce956337ba8b$export$746102c94db9df1f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_4_SUMMARY');
    const $5f07ce956337ba8b$export$5f1efd797d65e349 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_LIST');
    const $5f07ce956337ba8b$export$cccc812ccafbf11f = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_TIMELINE');
    const $5f07ce956337ba8b$export$64822db87abd8a47 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_5_PAGES');
    const $5f07ce956337ba8b$export$64f764d8be495c82 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_6_PAGES');
    const $5f07ce956337ba8b$export$24eae23dc1c68bbd = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_LIST');
    const $5f07ce956337ba8b$export$50fa92eba6f82feb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_7_CALENDAR');
    const $5f07ce956337ba8b$export$4155d22fe3f14cd6 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_LIST');
    const $5f07ce956337ba8b$export$76813cbead887191 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_TIMELINE');
    const $5f07ce956337ba8b$export$90aab2ff89daf770 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_0_PAGES');
    const $5f07ce956337ba8b$export$a2bc0cbad2e6e605 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_LIST');
    const $5f07ce956337ba8b$export$f90872a1280728bb = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_BOARD');
    const $5f07ce956337ba8b$export$bce644e96518cbd2 = $5f07ce956337ba8b$var$completeJwmTaskName('OPS_JTBD_DEFAULT_INVITES');
    const $5f07ce956337ba8b$export$241aaebffac0a3e5 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_LIST');
    const $5f07ce956337ba8b$export$f9dfc43b5b31c4b7 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_CALENDAR');
    const $5f07ce956337ba8b$export$79759e9e62fb9312 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_1_TIMELINE');
    const $5f07ce956337ba8b$export$992d1e0dce255d19 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_CALENDAR');
    const $5f07ce956337ba8b$export$d28c1b0e5b3e768 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_2_PAGES');
    const $5f07ce956337ba8b$export$ca714ee197bed4ec = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_PAGES');
    const $5f07ce956337ba8b$export$faae55ceea4b6073 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_3_TIMELINE');
    const $5f07ce956337ba8b$export$200bc24cd120667e = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_LIST');
    const $5f07ce956337ba8b$export$a0d784a48b4e886c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_SUMMARY');
    const $5f07ce956337ba8b$export$baf5bd09b4b33b8a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_4_PAGES');
    const $5f07ce956337ba8b$export$4702007eedbca8ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_TIMELINE');
    const $5f07ce956337ba8b$export$aa9d2d635ea63898 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_5_SUMMARY');
    const $5f07ce956337ba8b$export$2ea449225c1f6cac = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_6_FORMS');
    const $5f07ce956337ba8b$export$deb8b557e735e26a = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_LIST');
    const $5f07ce956337ba8b$export$d45754df44e4c309 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_CALENDAR');
    const $5f07ce956337ba8b$export$78b2913b550edbb = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_TIMELINE');
    const $5f07ce956337ba8b$export$71243272608c58ab = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_0_SUMMARY');
    const $5f07ce956337ba8b$export$39a08f215c33bc39 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_LIST');
    const $5f07ce956337ba8b$export$d2377f6a6fa3b49c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_BOARD');
    const $5f07ce956337ba8b$export$befa8f6533309779 = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_PROJECT');
    const $5f07ce956337ba8b$export$736b40db8701ba6c = $5f07ce956337ba8b$var$completeJwmTaskName('MKT_JTBD_DEFAULT_INVITES');
    const $5f07ce956337ba8b$export$99b0e09ff6f00490 = $5f07ce956337ba8b$var$completeJsmTaskName('customize-your-request-types-task');
    const $5f07ce956337ba8b$export$2a82344eb273eeff = $5f07ce956337ba8b$var$completeJsmTaskName('review-your-channels-task');
    const $5f07ce956337ba8b$export$1de5766b7e640d6b = $5f07ce956337ba8b$var$completeJsmTaskName('invite-your-team-task');
    const $5f07ce956337ba8b$export$8ab0859f5b30b013 = $5f07ce956337ba8b$var$completeDevopsTaskName('welcome-to-your-project-task');
    const $5f07ce956337ba8b$export$d1f6d18c6698104c = $5f07ce956337ba8b$var$completeDevopsTaskName('get-to-know-jira-task');
    const $5f07ce956337ba8b$export$e6ee159eee7adc1c = $5f07ce956337ba8b$var$completeDevopsTaskName('navigate-your-tools-task');
    const $5f07ce956337ba8b$export$dd267ca1e3cd3bad = $5f07ce956337ba8b$var$completeDevopsTaskName('capture-integrations-task');
    const $5f07ce956337ba8b$export$f14c8bffc35200d3 = $5f07ce956337ba8b$var$completeDevopsTaskName('create-automation-rules-task');
    const $5f07ce956337ba8b$export$36cc22c9997d92a = $5f07ce956337ba8b$var$completeDevopsTaskName('invite-teammates-task');
    const $5f07ce956337ba8b$export$d651cc94a46ff383 = $5f07ce956337ba8b$var$completeDevopsTaskName('find-help-task');
    const $5f07ce956337ba8b$export$11c0696d49e68c93 = 'jsw-onboarding-checklist.has.navigated.from.link';
    const $5f07ce956337ba8b$export$c8ab6996f562d0db = (0, (0, parcelRequire("g5X3G")).toAccountId)('accountId');
    const $5f07ce956337ba8b$export$2b5f951ad8e70cfe = $5f07ce956337ba8b$var$completeJswTaskName('kanban-onboarding-task');
    const $5f07ce956337ba8b$export$5703447487aaccdf = {
        NOT_LOADED: 'NOT_LOADED',
        OPEN: 'OPEN',
        MINIMIZED: 'MINIMIZED',
        DISMISSED: 'DISMISSED'
    };
    const $5f07ce956337ba8b$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
    const $5f07ce956337ba8b$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
    const $5f07ce956337ba8b$export$f779bbfe667acddc = [
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ACCESS)
    ];
    const $5f07ce956337ba8b$export$38fbac7a5bf4aa33 = [
        $5f07ce956337ba8b$export$2a82344eb273eeff,
        $5f07ce956337ba8b$export$99b0e09ff6f00490,
        $5f07ce956337ba8b$export$1de5766b7e640d6b
    ];
    const $5f07ce956337ba8b$export$7578902c7f420a3 = [
        $5f07ce956337ba8b$export$88c918f2cfaff86,
        $5f07ce956337ba8b$export$6a4507e462fd41da,
        $5f07ce956337ba8b$export$e64c1dced6ac4458,
        $5f07ce956337ba8b$export$63b0e55f9c6454ac,
        $5f07ce956337ba8b$export$c1effb1c8979fe22,
        $5f07ce956337ba8b$export$cbeb719208f32c8a,
        $5f07ce956337ba8b$export$abbbea7c37c93cb5,
        $5f07ce956337ba8b$export$2a0253cb20f48a8,
        $5f07ce956337ba8b$export$f97428bb4b1991ec,
        $5f07ce956337ba8b$export$d6c67e9aab4e2b26,
        $5f07ce956337ba8b$export$3de8c242d2b82f26,
        $5f07ce956337ba8b$export$a01fa44f793dbfac,
        $5f07ce956337ba8b$export$45eaf4204fcc7,
        $5f07ce956337ba8b$export$af57685e201438e8,
        $5f07ce956337ba8b$export$d97d31d934dbb194,
        $5f07ce956337ba8b$export$cafb5bd13b02056b,
        $5f07ce956337ba8b$export$e55c18b809946e72,
        $5f07ce956337ba8b$export$de5640b9ae8140a7,
        $5f07ce956337ba8b$export$540b5c3c4b6ce459,
        $5f07ce956337ba8b$export$6f71dff531ff592,
        $5f07ce956337ba8b$export$83255ab79e45f34f,
        $5f07ce956337ba8b$export$b57d172af9ad7647,
        $5f07ce956337ba8b$export$ff4c933c1fe90b68,
        $5f07ce956337ba8b$export$77071b77e2801b18,
        $5f07ce956337ba8b$export$94ad6507a703f4eb,
        $5f07ce956337ba8b$export$501166b25f254aab,
        $5f07ce956337ba8b$export$be1c522400a1bd7c,
        $5f07ce956337ba8b$export$2aa6e7b6e24a04f5,
        $5f07ce956337ba8b$export$f3b53199b07af2a1,
        $5f07ce956337ba8b$export$d37415ffddcf2142,
        $5f07ce956337ba8b$export$2ae00586da7cb606,
        $5f07ce956337ba8b$export$9c89f946f05d884a,
        $5f07ce956337ba8b$export$20bc3dc137ac1c38,
        $5f07ce956337ba8b$export$b52a7c936684cfc5,
        $5f07ce956337ba8b$export$b5555f24061f9fb,
        $5f07ce956337ba8b$export$ff25449f34b8abf,
        $5f07ce956337ba8b$export$3380e677209260fe,
        $5f07ce956337ba8b$export$b86266e6594a97bb,
        $5f07ce956337ba8b$export$8ab0859f5b30b013,
        $5f07ce956337ba8b$export$d1f6d18c6698104c,
        $5f07ce956337ba8b$export$e6ee159eee7adc1c,
        $5f07ce956337ba8b$export$dd267ca1e3cd3bad,
        $5f07ce956337ba8b$export$f14c8bffc35200d3,
        $5f07ce956337ba8b$export$36cc22c9997d92a,
        $5f07ce956337ba8b$export$d651cc94a46ff383,
        $5f07ce956337ba8b$export$3e2776d61f3662dc,
        $5f07ce956337ba8b$export$2b5f951ad8e70cfe,
        $5f07ce956337ba8b$export$9048315f2c03fd9d,
        $5f07ce956337ba8b$export$a333714599f14a6,
        $5f07ce956337ba8b$export$4145c2cec2da6f9b,
        $5f07ce956337ba8b$export$4957a1ad203cf6dd,
        $5f07ce956337ba8b$export$7a2fcaad1564e6b7,
        $5f07ce956337ba8b$export$190b5dd0a1322552,
        $5f07ce956337ba8b$export$da23b72d32bfad9e,
        $5f07ce956337ba8b$export$4b064659282e0238,
        $5f07ce956337ba8b$export$3ab51851f6d823e,
        $5f07ce956337ba8b$export$e4a1a37a9a1350ad,
        $5f07ce956337ba8b$export$b7f7da5e795f0327,
        $5f07ce956337ba8b$export$80a401c1aa47a377,
        $5f07ce956337ba8b$export$934ac7a251b26dc7,
        $5f07ce956337ba8b$export$4634f6395df3ebbe,
        $5f07ce956337ba8b$export$768fb41107a1e8d7,
        $5f07ce956337ba8b$export$d797a81bace17184,
        $5f07ce956337ba8b$export$746102c94db9df1f,
        $5f07ce956337ba8b$export$5f1efd797d65e349,
        $5f07ce956337ba8b$export$cccc812ccafbf11f,
        $5f07ce956337ba8b$export$64822db87abd8a47,
        $5f07ce956337ba8b$export$64f764d8be495c82,
        $5f07ce956337ba8b$export$24eae23dc1c68bbd,
        $5f07ce956337ba8b$export$50fa92eba6f82feb,
        $5f07ce956337ba8b$export$4155d22fe3f14cd6,
        $5f07ce956337ba8b$export$76813cbead887191,
        $5f07ce956337ba8b$export$90aab2ff89daf770,
        $5f07ce956337ba8b$export$a2bc0cbad2e6e605,
        $5f07ce956337ba8b$export$f90872a1280728bb,
        $5f07ce956337ba8b$export$bce644e96518cbd2,
        $5f07ce956337ba8b$export$241aaebffac0a3e5,
        $5f07ce956337ba8b$export$f9dfc43b5b31c4b7,
        $5f07ce956337ba8b$export$79759e9e62fb9312,
        $5f07ce956337ba8b$export$992d1e0dce255d19,
        $5f07ce956337ba8b$export$d28c1b0e5b3e768,
        $5f07ce956337ba8b$export$ca714ee197bed4ec,
        $5f07ce956337ba8b$export$faae55ceea4b6073,
        $5f07ce956337ba8b$export$200bc24cd120667e,
        $5f07ce956337ba8b$export$a0d784a48b4e886c,
        $5f07ce956337ba8b$export$baf5bd09b4b33b8a,
        $5f07ce956337ba8b$export$4702007eedbca8ab,
        $5f07ce956337ba8b$export$aa9d2d635ea63898,
        $5f07ce956337ba8b$export$2ea449225c1f6cac,
        $5f07ce956337ba8b$export$deb8b557e735e26a,
        $5f07ce956337ba8b$export$d45754df44e4c309,
        $5f07ce956337ba8b$export$78b2913b550edbb,
        $5f07ce956337ba8b$export$71243272608c58ab,
        $5f07ce956337ba8b$export$39a08f215c33bc39,
        $5f07ce956337ba8b$export$d2377f6a6fa3b49c,
        $5f07ce956337ba8b$export$befa8f6533309779,
        $5f07ce956337ba8b$export$736b40db8701ba6c
    ];
});
parcelRegister("6RAg1", function(module, exports) {
    $parcel$export(module.exports, "changeTaskGroupParent", ()=>(parcelRequire("6fSBR")).nextChangeTaskGroupParent);
    $parcel$export(module.exports, "goBackToPreviousTaskGroup", ()=>(parcelRequire("6fSBR")).nextGoBackToPreviousTaskGroup);
    $parcel$export(module.exports, "setIsOpen", ()=>(parcelRequire("j6wxT")).setIsOpen);
    $parcel$export(module.exports, "refreshAppState", ()=>(parcelRequire("7mZ3t")).refreshAppState);
    $parcel$export(module.exports, "setNudgeStep", ()=>(parcelRequire("8UXiA")).setNudgeStep);
    $parcel$export(module.exports, "addMountedNudge", ()=>(parcelRequire("3iEb4")).addMountedNudge);
    $parcel$export(module.exports, "removeMountedNudge", ()=>(parcelRequire("3iEb4")).removeMountedNudge);
    $parcel$export(module.exports, "setShouldRenderComponent", ()=>(parcelRequire("7yDu9")).setShouldRenderComponent);
    $parcel$export(module.exports, "setProjectState", ()=>(parcelRequire("5UBG2")).setProjectState);
    $parcel$export(module.exports, "setHasNudgeActive", ()=>(parcelRequire("lHcRB")).setHasNudgeActive);
    $parcel$export(module.exports, "forceHideNudge", ()=>(parcelRequire("eiyXc")).forceHideNudge);
    $parcel$export(module.exports, "setHasEverSeenRoute", ()=>(parcelRequire("jZvbN")).setHasEverSeenRoute);
    $parcel$export(module.exports, "setRoadmapIsCreateEnabled", ()=>(parcelRequire("azcAL")).setRoadmapIsCreateEnabled);
    $parcel$export(module.exports, "setRoadmapIsListEmpty", ()=>(parcelRequire("azcAL")).setRoadmapIsListEmpty);
    $parcel$export(module.exports, "openNextTask", ()=>(parcelRequire("gbXQ5")).openNextTask);
    $parcel$export(module.exports, "resetIsQuickstartLoaded", ()=>(parcelRequire("iZuFy")).resetIsQuickstartLoaded);
    $parcel$export(module.exports, "refreshAppStateUiStatusOnly", ()=>(parcelRequire("70Fss")).refreshAppStateUiStatusOnly);
    $parcel$export(module.exports, "nextMarkAsCompletedTask", ()=>(parcelRequire("erLQY")).nextMarkAsCompletedTask);
    $parcel$export(module.exports, "nextSetChecklistItemSeen", ()=>(parcelRequire("dQPsy")).nextSetChecklistItemSeen);
    $parcel$export(module.exports, "nextSetChecklistIsDismissed", ()=>(parcelRequire("abQXL")).nextSetChecklistIsDismissed);
    $parcel$export(module.exports, "nextSetChecklistIsOpen", ()=>(parcelRequire("4VXxO")).nextSetChecklistIsOpen);
    $parcel$export(module.exports, "nextOpenTask", ()=>(parcelRequire("cUGWT")).nextOpenTask);
    $parcel$export(module.exports, "nextAutoExpand", ()=>(parcelRequire("boV1S")).nextAutoExpand);
    $parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", ()=>(parcelRequire("4Viq4")).nextShouldShowNudgeAfterNavigation);
    $parcel$export(module.exports, "nextGetTasks", ()=>(parcelRequire("jIoq4")).nextGetTasks);
    $parcel$export(module.exports, "syncVisibilityWithLocal", ()=>(parcelRequire("75A1x")).syncVisibilityWithLocal);
    var $6fSBR;
    var $j6wxT;
    var $7mZ3t;
    var $8UXiA;
    var $3iEb4;
    var $7yDu9;
    var $5UBG2;
    var $lHcRB;
    var $eiyXc;
    var $jZvbN;
    var $azcAL;
    var $gbXQ5;
    var $iZuFy;
    var $70Fss;
    var $erLQY;
    var $dQPsy;
    var $abQXL;
    var $4VXxO;
    var $cUGWT;
    var $boV1S;
    var $4Viq4;
    var $jIoq4;
    var $75A1x;
});
parcelRegister("6fSBR", function(module, exports) {
    $parcel$export(module.exports, "nextChangeTaskGroupParent", ()=>$0f1566e1d3fc2987$export$76708cce5888039a);
    $parcel$export(module.exports, "nextGoBackToPreviousTaskGroup", ()=>$0f1566e1d3fc2987$export$57534cbc400a434c);
    var $8Bc5A;
    var $1ftPQ;
    const $0f1566e1d3fc2987$var$setTaskGroup = (taskGroup)=>({ setState: setState })=>{
            setState({
                ...taskGroup,
                openTask: ''
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP),
                value: {
                    taskGroup: taskGroup
                }
            });
        };
    const $0f1566e1d3fc2987$export$76708cce5888039a = (newCurrentTaskGroupParent)=>({ getState: getState, dispatch: dispatch })=>{
            const { previousTaskGroupParents: previousTaskGroupParents, currentTaskGroupParent: currentTaskGroupParent } = getState();
            if (previousTaskGroupParents.includes(newCurrentTaskGroupParent)) return;
            previousTaskGroupParents.push(currentTaskGroupParent);
            const taskGroup = {
                previousTaskGroupParents: previousTaskGroupParents,
                currentTaskGroupParent: newCurrentTaskGroupParent
            };
            dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup));
        };
    const $0f1566e1d3fc2987$export$57534cbc400a434c = ()=>({ dispatch: dispatch, getState: getState })=>{
            const { previousTaskGroupParents: previousTaskGroupParents } = getState();
            const newTaskGroupParent = previousTaskGroupParents.length === 0 ? (0, (0, parcelRequire("8Bc5A")).ROOT_TASK) : previousTaskGroupParents.pop();
            const taskGroup = {
                previousTaskGroupParents: previousTaskGroupParents,
                currentTaskGroupParent: newTaskGroupParent
            };
            dispatch($0f1566e1d3fc2987$var$setTaskGroup(taskGroup));
        };
});
parcelRegister("1ftPQ", function(module, exports) {
    $parcel$export(module.exports, "pushToBackend", ()=>$d3dd40bf54ad27bf$export$583b2d2422a6757f);
    var $89SaW;
    var $4Pf62;
    var $jcw0u;
    var $jJZqs;
    const $d3dd40bf54ad27bf$var$getAccountId = ()=>{
        const { atlassianAccountId: atlassianAccountId } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        if (atlassianAccountId === null) throw new Error('Atlassian Account Id is empty');
        return atlassianAccountId;
    };
    const $d3dd40bf54ad27bf$var$setRemoteUserProperties = async ({ key: key, value: value })=>(0, (0, parcelRequire("89SaW")).setUserProperties)($d3dd40bf54ad27bf$var$getAccountId(), key, JSON.stringify(value)).then((response)=>{
            if (!response.ok) throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, response.statusText);
        });
    const $d3dd40bf54ad27bf$var$trySetUserProperties = async (props, attemptCount)=>{
        try {
            await $d3dd40bf54ad27bf$var$setRemoteUserProperties(props);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'pushToBackend',
                    packageName: 'jiraOnboardingQuickstartCore',
                    teamName: 'jlove-makkuro'
                },
                attributes: {
                    action: 'pushToBackend',
                    actionSubject: 'jiraOnboardingChecklistCore',
                    attemptCount: attemptCount,
                    key: props.key,
                    reason: error && error.message
                },
                error: error
            });
            return false;
        }
        return true;
    };
    const $d3dd40bf54ad27bf$export$583b2d2422a6757f = async (props)=>{
        const success = await $d3dd40bf54ad27bf$var$trySetUserProperties(props, 1);
        if (!success) await $d3dd40bf54ad27bf$var$trySetUserProperties(props, 2);
    };
});
parcelRegister("j6wxT", function(module, exports) {
    $parcel$export(module.exports, "setIsOpen", ()=>$eefde484654068e9$export$dcf23146e0a40195);
    var $8Bc5A;
    var $1ftPQ;
    var $3B5jO;
    const $eefde484654068e9$export$dcf23146e0a40195 = (isOpen)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const quickstartType = (0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state);
            const currentIsOpen = state.visibility[quickstartType] === (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN;
            if (isOpen === currentIsOpen) return;
            const quickstartStatus = isOpen ? (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN : (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).MINIMIZED;
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: quickstartStatus
                }
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(quickstartType),
                value: quickstartStatus
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_OPEN),
                value: isOpen
            });
        };
    var $eefde484654068e9$export$2e2bcd8739ae039 = $eefde484654068e9$export$dcf23146e0a40195;
});
parcelRegister("3B5jO", function(module, exports) {
    $parcel$export(module.exports, "getQuickstartTypeSelector", ()=>$47424244d57f6abc$export$eae834ce0286017a);
    var $2vSU6;
    var $8Bc5A;
    const $47424244d57f6abc$export$6f17f2cb816105eb = (state)=>state.projectState?.projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT);
    const $47424244d57f6abc$export$eae834ce0286017a = (state)=>{
        if ($47424244d57f6abc$export$6f17f2cb816105eb(state)) return (0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY;
        return (0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY;
    };
});
parcelRegister("7mZ3t", function(module, exports) {
    $parcel$export(module.exports, "refreshAppState", ()=>$ecf6e94ad9c4f8d6$export$797c35e2e1d0d014);
    var $4R6GH;
    var $8fqy8;
    var $8zOmE;
    var $bfWlw;
    var $ldyPw;
    var $8Bc5A;
    var $6yhDy;
    var $1ftPQ;
    var $52Vcw;
    var $ljzlb;
    var $3ORcf;
    var $6ypzr;
    var $4ji4w;
    var $abQXL;
    var $4VXxO;
    var $erLQY;
    var $6fSBR;
    const $ecf6e94ad9c4f8d6$var$allTasks = [
        ...(0, (0, parcelRequire("8Bc5A")).allTasksExcludingJSMBusinessTasks),
        ...(0, (0, parcelRequire("8Bc5A")).JSM_BUSINESS_TASKS)
    ];
    const $ecf6e94ad9c4f8d6$export$797c35e2e1d0d014 = ({ atlassianAccountId: atlassianAccountId, cloudId: cloudId, appEditions: appEditions, isAdmin: isAdmin, canEditPlans: canEditPlans, isAdvancedRoadmapsTrial: isAdvancedRoadmapsTrial, isTargetedForReverseTrials: isTargetedForReverseTrials, createAnalyticsEvent: createAnalyticsEvent, projectType: projectType })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const updatedState = {};
            const hasSeenTasks = [
                (0, (0, parcelRequire("8Bc5A")).convertToHaveSeenItTask)((0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK)),
                (0, (0, parcelRequire("8Bc5A")).convertToHaveSeenItTask)((0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)),
                (0, (0, parcelRequire("8Bc5A")).convertToHaveSeenItTask)((0, (0, parcelRequire("8Bc5A")).STANDARD_EDITION_OVERVIEW_TASK))
            ];
            const { projectState: projectState = null } = getState();
            updatedState.isOpen = true;
            updatedState.isDismissed = false;
            updatedState.quickstartStateProjectType = projectType;
            let backendVisibilityKeys = [];
            let jsmTaskProjectKeys = [];
            updatedState.visibility = Object.values((0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE)).reduce((acc, type)=>{
                acc[type] = (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN;
                return acc;
            }, {});
            backendVisibilityKeys = Object.values((0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE)).map((type)=>(0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(type));
            if (projectState?.projectId) jsmTaskProjectKeys = (0, (0, parcelRequire("8Bc5A")).JSM_BUSINESS_TASKS).map((task)=>`${task}.${projectState?.projectId}`);
            const backendState = await (0, (0, parcelRequire("6yhDy")).pollBackend)({
                keys: [
                    (0, (0, parcelRequire("8Bc5A")).KEY_OPEN),
                    (0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED),
                    (0, (0, parcelRequire("8Bc5A")).KEY_OPEN_TASK),
                    (0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP),
                    (0, (0, parcelRequire("8Bc5A")).KEY_HAS_EVER_SEEN_ROUTE),
                    (0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING),
                    (0, (0, parcelRequire("8Bc5A")).KEY_PREMIUM_TRIAL_REOPENED),
                    ...$ecf6e94ad9c4f8d6$var$allTasks,
                    ...hasSeenTasks,
                    ...backendVisibilityKeys,
                    ...jsmTaskProjectKeys
                ]
            });
            if (projectState && projectState.projectKey) updatedState.isDevOpsProject = await (0, (0, parcelRequire("3ORcf")).getIsDevOpsProject)(projectState.projectKey);
            const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
            if (backendStateExists) {
                updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                        ...(0, (0, parcelRequire("8Bc5A")).allTasksExcludingJSMBusinessTasks),
                        ...jsmTaskProjectKeys
                    ].includes(key) && backendState[key] === true);
                updatedState.hasSeenTasks = hasSeenTasks.filter((key)=>backendState[key] === true);
                Object.values((0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE)).forEach((type)=>{
                    if ((0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(type)];
                    else if ((0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED) in backendState && backendState[0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED]) updatedState.visibility[type] = (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).DISMISSED;
                    else if ((0, (0, parcelRequire("8Bc5A")).KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, (0, parcelRequire("8Bc5A")).KEY_OPEN] ? (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN : (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).MINIMIZED;
                    (0, (0, parcelRequire("4ji4w")).setLocalStorageItem)(`${type}.visibility`, updatedState.visibility[type]);
                });
                if ((0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, (0, parcelRequire("8Bc5A")).KEY_OPEN];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, (0, parcelRequire("8Bc5A")).KEY_OPEN_TASK];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, (0, parcelRequire("8Bc5A")).KEY_HAS_EVER_SEEN_ROUTE];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP) in backendState) {
                    updatedState.currentTaskGroupParent = backendState[0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                    updatedState.previousTaskGroupParents = backendState[0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
                }
                if ((0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING) in backendState) {
                    if (typeof backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING] === 'object' && backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING] !== null && (0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe) in backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING][0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe];
                }
            }
            setState(updatedState);
            if ((updatedState.currentTaskGroupParent === (0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, (0, parcelRequire("8Bc5A")).PREMIUM_REVERSE_TRIAL_TASK)) && !canEditPlans || (updatedState.currentTaskGroupParent === (0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK) || updatedState.currentTaskGroupParent === (0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN) || updatedState.currentTaskGroupParent === (0, (0, parcelRequire("8Bc5A")).PREMIUM_REVERSE_TRIAL_TASK)) && appEditions.software !== (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION)) {
                dispatch((0, (0, parcelRequire("6fSBR")).nextGoBackToPreviousTaskGroup)());
                const analyticsEvent = createAnalyticsEvent({});
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'refreshAppState premiumCardPermissionsRevoked');
            }
            if (!(backendStateExists && (0, (0, parcelRequire("8Bc5A")).KEY_OPEN) in backendState)) try {
                const skipApplicationProperty = await (0, (0, parcelRequire("6ypzr")).getOnboardingSkipApplicationProperty)();
                if (skipApplicationProperty.quickstart) dispatch((0, (0, parcelRequire("abQXL")).nextSetChecklistIsDismissed)(true));
            } catch (error) {
                (0, (0, parcelRequire("52Vcw")).fireAPIErrorAnalytics)(error, 'skipOnboarding');
            }
            const jswTrackDeferSitenameSiteTrait = await (0, (0, parcelRequire("8fqy8")).getJswTrackDeferSitenameSiteTrait)(cloudId, {
                packageName: (0, (0, parcelRequire("8Bc5A")).PACKAGE_NAME),
                teamName: (0, (0, parcelRequire("8Bc5A")).PACKAGE_TEAM_NAME)
            });
            setState({
                isEligibleToUpdateSitename: jswTrackDeferSitenameSiteTrait?.value === 'experiment-generated-site-name'
            });
            const setPremiumCardAudienceTrait = async (accountId)=>{
                if (accountId === null) return;
                const trait = await (0, (0, parcelRequire("ljzlb")).getCrossProjectBoardTrait)(createAnalyticsEvent, cloudId, accountId);
                setState({
                    isCrossProjectBoardToPlanUpsell: trait?.value === true || false
                });
            };
            if (appEditions.software === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION) && !isAdmin) await setPremiumCardAudienceTrait(atlassianAccountId);
            const { isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell } = getState();
            let isReverseTrialForJSW;
            if (isTargetedForReverseTrials && (0, (0, parcelRequire("4R6GH")).fg)('jsw_reverse_trials_feature_gate')) {
                const isOnboardingPremiumTrial = await (0, (0, parcelRequire("bfWlw")).getOnboardingPremiumTrial)();
                isReverseTrialForJSW = isOnboardingPremiumTrial?.premiumTrialOnSignup;
            }
            if (!isReverseTrialForJSW && appEditions.software === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION) && isAdvancedRoadmapsTrial && (isAdmin || isCrossProjectBoardToPlanUpsell) && atlassianAccountId != null && !backendState[0, (0, parcelRequire("8Bc5A")).KEY_PREMIUM_TRIAL_REOPENED]) {
                dispatch((0, (0, parcelRequire("4VXxO")).nextSetChecklistIsOpen)(true));
                dispatch((0, (0, parcelRequire("abQXL")).nextSetChecklistIsDismissed)(false));
                const taskToDispatch = isAdmin ? (0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK) : (0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN);
                dispatch((0, (0, parcelRequire("erLQY")).nextMarkAsCompletedTask)(taskToDispatch));
                dispatch((0, (0, parcelRequire("6fSBR")).nextChangeTaskGroupParent)(taskToDispatch));
                await (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                    key: (0, (0, parcelRequire("8Bc5A")).KEY_PREMIUM_TRIAL_REOPENED),
                    value: true
                });
                const analyticsEvent = createAnalyticsEvent({});
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'advancedRoadmapsTask reopened', {
                    isAdmin: isAdmin
                });
            }
            setState({
                canEditPlans: canEditPlans
            });
            setState({
                isQuickstartLoaded: true
            });
        };
});
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$eaf6b96a17b6476c = 'can-enroll-in-select-initial-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
parcelRegister("8fqy8", function(module, exports) {
    $parcel$export(module.exports, "getSignupTrackDeferSitenameUserTrait", ()=>$77364531dfabe700$export$686752df505238be);
    $parcel$export(module.exports, "getJswTrackDeferSitenameSiteTrait", ()=>$77364531dfabe700$export$6da79f996c267010);
    var $jcw0u;
    var $eusud;
    const $77364531dfabe700$var$PERSONALIZATION_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
    const $77364531dfabe700$var$SITE_PERSONALIZATION_ENDPOINT = `${$77364531dfabe700$var$PERSONALIZATION_ENDPOINT}/site/`;
    const $77364531dfabe700$var$USER_PERSONALIZATION_ENDPOINT = `${$77364531dfabe700$var$PERSONALIZATION_ENDPOINT}/user/`;
    const $77364531dfabe700$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT = 'marketing-signup_track_deferred-sitename_signup_server_enrollment';
    const $77364531dfabe700$var$JSW_TRACK_DEFER_SITENAME_TRAIT = 'jira_track_instance_created_server_defer_site_rename_cohort';
    const $77364531dfabe700$var$fetchPersonalization = (endpoint, subject)=>async (id, meta)=>{
            try {
                const url = endpoint + id;
                return await (0, (0, parcelRequire("eusud")).performGetRequest)(url);
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'onboarding',
                        teamName: 'jlove-makkuro',
                        ...meta
                    },
                    attributes: {
                        subject: subject
                    },
                    error: error
                });
                return undefined;
            }
        };
    const $77364531dfabe700$var$getTraits = (fetch, traitName)=>async (id, meta)=>{
            const personalization = await fetch(id, meta);
            return personalization?.attributes?.find((att)=>att.name === traitName);
        };
    const $77364531dfabe700$export$686752df505238be = $77364531dfabe700$var$getTraits($77364531dfabe700$var$fetchPersonalization($77364531dfabe700$var$USER_PERSONALIZATION_ENDPOINT, 'fetchUserPersonalization'), $77364531dfabe700$var$SIGNUP_TRACK_DEFER_SITENAME_USER_TRAIT);
    const $77364531dfabe700$export$6da79f996c267010 = $77364531dfabe700$var$getTraits($77364531dfabe700$var$fetchPersonalization($77364531dfabe700$var$SITE_PERSONALIZATION_ENDPOINT, 'fetchSitePersonalization'), $77364531dfabe700$var$JSW_TRACK_DEFER_SITENAME_TRAIT);
});
parcelRegister("bfWlw", function(module, exports) {
    $parcel$export(module.exports, "getOnboardingPremiumTrialWithRethrow", ()=>$a55f3307b43c0521$export$d9a9dd6206da5bef);
    $parcel$export(module.exports, "getOnboardingPremiumTrial", ()=>$a55f3307b43c0521$export$ef676f7f369f74fe);
    var $jcw0u;
    var $eusud;
    var $6c7t9;
    const $a55f3307b43c0521$var$endpoint = '/rest/onboarding/1.0/premium-trial';
    const $a55f3307b43c0521$export$d9a9dd6206da5bef = async ()=>{
        try {
            const localStorageOnboardingPremiumTrial = (0, (0, parcelRequire("6c7t9")).localStorageGetOnboardingPremiumTrial)();
            const localStorageOnboardingPremiumTrialCohort = (0, (0, parcelRequire("6c7t9")).localStorageGetOnboardingPremiumTrialCohort)();
            if (typeof localStorageOnboardingPremiumTrial === 'boolean' && typeof localStorageOnboardingPremiumTrialCohort === 'string') return {
                premiumTrialOnSignup: localStorageOnboardingPremiumTrial,
                reverseTrialCohort: localStorageOnboardingPremiumTrialCohort
            };
            const response = await (0, (0, parcelRequire("eusud")).performGetRequestWithRetry)($a55f3307b43c0521$var$endpoint);
            const premiumTrialOnSignup = response?.premiumTrialOnSignup;
            const reverseTrialCohort = response?.reverseTrialCohort;
            if (typeof premiumTrialOnSignup === 'boolean' && typeof reverseTrialCohort === 'string') {
                (0, (0, parcelRequire("6c7t9")).localStorageSetOnboardingPremiumTrial)(premiumTrialOnSignup);
                (0, (0, parcelRequire("6c7t9")).localStorageSetOnboardingPremiumTrialCohort)(reverseTrialCohort);
                return {
                    premiumTrialOnSignup: premiumTrialOnSignup,
                    reverseTrialCohort: reverseTrialCohort
                };
            }
            throw new Error('response?.premiumTrialOnSignup or response?.reverseTrialCohort is undefined');
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'getOnboardingPremiumTrialWithRethrow',
                    packageName: 'jiraReverseTrialUtils'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
    const $a55f3307b43c0521$export$ef676f7f369f74fe = async ()=>{
        try {
            return await $a55f3307b43c0521$export$d9a9dd6206da5bef();
        } catch (e) {}
    };
});
parcelRegister("6c7t9", function(module, exports) {
    $parcel$export(module.exports, "localStorageGetOnboardingPremiumTrial", ()=>$fab9df2877e9db77$export$782df5489e5cfd1e);
    $parcel$export(module.exports, "localStorageGetOnboardingPremiumTrialCohort", ()=>$fab9df2877e9db77$export$c3378895d06b5528);
    $parcel$export(module.exports, "localStorageSetOnboardingPremiumTrial", ()=>$fab9df2877e9db77$export$f83a7a49524e74ad);
    $parcel$export(module.exports, "localStorageSetOnboardingPremiumTrialCohort", ()=>$fab9df2877e9db77$export$f389f8ca168b4a3a);
    var $bSSG7;
    var $jcw0u;
    const $fab9df2877e9db77$export$3538ee3f5c6c8b5c = 'premiumTrialOnSignup';
    const $fab9df2877e9db77$export$2f93fdc3330233dc = 'reverseTrialCohort';
    const $fab9df2877e9db77$var$localStorage = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('jsw-onboarding-premium-reverse-trial');
    const $fab9df2877e9db77$export$782df5489e5cfd1e = ()=>{
        try {
            const value = $fab9df2877e9db77$var$localStorage.get($fab9df2877e9db77$export$3538ee3f5c6c8b5c);
            return value;
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'localStorageGetOnboardingPremiumTrial',
                    packageName: 'jiraReverseTrialUtils'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return undefined;
        }
    };
    const $fab9df2877e9db77$export$c3378895d06b5528 = ()=>{
        try {
            const value = $fab9df2877e9db77$var$localStorage.get($fab9df2877e9db77$export$2f93fdc3330233dc);
            return value;
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'localStorageGetOnboardingPremiumTrial',
                    packageName: 'jiraReverseTrialUtils'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return undefined;
        }
    };
    const $fab9df2877e9db77$export$f83a7a49524e74ad = (premiumTrialOnSignup)=>{
        try {
            $fab9df2877e9db77$var$localStorage.set($fab9df2877e9db77$export$3538ee3f5c6c8b5c, premiumTrialOnSignup);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'localStorageSetOnboardingPremiumTrial',
                    packageName: 'jiraReverseTrialUtils'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
    const $fab9df2877e9db77$export$f389f8ca168b4a3a = (reverseTrialCohort)=>{
        try {
            $fab9df2877e9db77$var$localStorage.set($fab9df2877e9db77$export$2f93fdc3330233dc, reverseTrialCohort);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'localStorageSetOnboardingPremiumTrial',
                    packageName: 'jiraReverseTrialUtils'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
});
parcelRegister("6yhDy", function(module, exports) {
    $parcel$export(module.exports, "pollBackend", ()=>$760653e5a4f27459$export$8420ef0cee98de);
    var $1sYcL;
    var $g5X3G;
    var $8Bc5A;
    const $760653e5a4f27459$export$8420ef0cee98de = async ({ keys: keys })=>{
        const { user: user } = await (0, (0, parcelRequire("1sYcL")).get)((0, (0, parcelRequire("g5X3G")).toBaseUrl)(''), {
            userProperties: keys,
            consumerMeta: {
                id: 'fetchUserProperties',
                packageName: (0, (0, parcelRequire("8Bc5A")).PACKAGE_NAME),
                teamName: (0, (0, parcelRequire("8Bc5A")).PACKAGE_TEAM_NAME)
            }
        });
        return user;
    };
});
parcelRegister("1sYcL", function(module, exports) {
    $parcel$export(module.exports, "get", ()=>$7fc92c544211ac93$export$3988ae62b71be9a3);
    var $lbWm4 = parcelRequire("lbWm4");
    var $3T6Xo = parcelRequire("3T6Xo");
    var $jcw0u;
    var $4R6GH;
    var $fZneA;
    var $eusud;
    var $fjcgS;
    var $hNAhd;
    var $d3cxT;
    let $7fc92c544211ac93$var$ufoExperiencesMap = {};
    const $7fc92c544211ac93$var$getUfoExperience = (key)=>{
        if (!$7fc92c544211ac93$var$ufoExperiencesMap[key]) $7fc92c544211ac93$var$ufoExperiencesMap[key] = new (0, (0, parcelRequire("d3cxT")).UFOExperience)(key, {
            type: (0, (0, parcelRequire("hNAhd")).ExperienceTypes).Operation,
            performanceType: (0, (0, parcelRequire("hNAhd")).ExperiencePerformanceTypes).Custom
        });
        return $7fc92c544211ac93$var$ufoExperiencesMap[key];
    };
    const $7fc92c544211ac93$export$c907f169d33b2e25 = ()=>{
        $7fc92c544211ac93$var$ufoExperiencesMap = {};
    };
    const $7fc92c544211ac93$export$a5b7a8c3b1c6e775 = (baseUrl, { userProperties: userProperties, projectId: projectId, projectProperties: projectProperties, instanceProperties: instanceProperties })=>{
        const params = new URLSearchParams();
        userProperties && params.append('user', userProperties.join(','));
        projectId !== undefined && params.append('projectId', projectId);
        projectProperties && params.append('project', projectProperties.join(','));
        instanceProperties && params.append('instance', instanceProperties.join(','));
        return `/rest/internal/latest/frontendconfig/properties?${params.toString()}`;
    };
    const $7fc92c544211ac93$var$patchProperties = (response, propertiesPath)=>((0, (0, parcelRequire("4R6GH")).fg)('handle_null_response_for_fe_config_properties_call') ? response : true) && (0, ($parcel$interopDefault($lbWm4)))(response[propertiesPath], (value, prop)=>{
            try {
                response[propertiesPath][prop] = JSON.parse(value);
            } catch (error) {
                if (prop === 'initial.project.template.name') response[propertiesPath][prop] = value;
                else throw error;
            }
        });
    const $7fc92c544211ac93$export$3988ae62b71be9a3 = async (baseUrl, options)=>{
        const ufoExperience = $7fc92c544211ac93$var$getUfoExperience(`${(0, ($parcel$interopDefault($3T6Xo)))(options.consumerMeta.packageName)}.${(0, ($parcel$interopDefault($3T6Xo)))(options.consumerMeta.id)}`);
        try {
            ufoExperience?.start();
            const url = $7fc92c544211ac93$export$a5b7a8c3b1c6e775(baseUrl, options);
            const response = await (0, (0, parcelRequire("eusud")).performGetRequest)(url);
            if (response === null) (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
                const payload = {
                    action: 'succeeded',
                    actionSubject: 'jiraCommonRestInternalLatest.getConfigProperties',
                    source: 'frontendConfigProperties',
                    attributes: {
                        package: consumerMeta.packageName,
                        id: consumerMeta.id,
                        isNullResponse: true
                    }
                };
                client.getInstance().sendOperationalEvent(payload);
            });
            $7fc92c544211ac93$var$patchProperties(response, 'user');
            $7fc92c544211ac93$var$patchProperties(response, 'instance');
            $7fc92c544211ac93$var$patchProperties(response, 'project');
            const { consumerMeta: consumerMeta } = options;
            (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
                const payload = {
                    source: 'frontendConfigProperties',
                    action: 'success',
                    actionSubject: `${consumerMeta.packageName}.${consumerMeta.id}`
                };
                client.getInstance().sendOperationalEvent(payload);
            });
            ufoExperience?.success();
            return (0, (0, parcelRequire("4R6GH")).fg)('handle_null_response_for_fe_config_properties_call') ? response || {
                user: {},
                instance: {},
                project: {}
            } : response;
        } catch (error) {
            const { consumerMeta: consumerMeta } = options;
            !(0, (0, parcelRequire("fZneA")).isClientFetchError)(error) && (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: consumerMeta.id,
                    packageName: consumerMeta.packageName,
                    teamName: consumerMeta.teamName
                },
                sendToPrivacyUnsafeSplunk: true
            });
            ufoExperience?.failure();
            throw error;
        }
    };
});
parcelRegister("52Vcw", function(module, exports) {
    $parcel$export(module.exports, "fireAnalyticsOnQuickstartClose", ()=>$5dab66e6da9554ae$export$c98a6ee6aadb8055);
    $parcel$export(module.exports, "fireAnalyticsOnQuickstartDismiss", ()=>$5dab66e6da9554ae$export$45d8c76e0490b3ec);
    $parcel$export(module.exports, "fireAnalyticsOnQuickstartBack", ()=>$5dab66e6da9554ae$export$b1be4ae35a43115d);
    $parcel$export(module.exports, "fireAnalyticsOnQuickstartExperienceComplete", ()=>$5dab66e6da9554ae$export$fa4f266bd2444d14);
    $parcel$export(module.exports, "fireAnalyticsOnChecklistItemCompleted", ()=>$5dab66e6da9554ae$export$a68a2e5a69c8cd74);
    $parcel$export(module.exports, "fireAPIErrorAnalytics", ()=>$5dab66e6da9554ae$export$a4d7f1a52677d339);
    $parcel$export(module.exports, "fireAnalyticsOnOpenRightHandSidebar", ()=>$5dab66e6da9554ae$export$160bb78a3b11a5a9);
    $parcel$export(module.exports, "fireAnalyticsOnMinimiseRightHandSidebar", ()=>$5dab66e6da9554ae$export$6ccbe54cd3a5a12);
    $parcel$export(module.exports, "fireAnalyticsOnCloseRightHandSidebar", ()=>$5dab66e6da9554ae$export$6c39ca65ca354e59);
    var $jcw0u;
    var $8zOmE;
    var $8Bc5A;
    var $izv86;
    const $5dab66e6da9554ae$export$c98a6ee6aadb8055 = (analyticsEvent, attributes)=>{
        analyticsEvent.update({
            action: 'closed',
            actionSubject: 'button'
        });
        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'button closed', (0, (0, parcelRequire("8Bc5A")).ACTION_SUBJECT_ID), attributes);
    };
    const $5dab66e6da9554ae$export$45d8c76e0490b3ec = (analyticsEvent, attributes, source)=>{
        if (source === 'button') (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstartButton', attributes);
        else if (source === 'checklist') (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'button clicked', 'dismissQuickstart', attributes);
    };
    const $5dab66e6da9554ae$export$b1be4ae35a43115d = (analyticsEvent)=>{
        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'button clicked', 'backButton');
    };
    const $5dab66e6da9554ae$export$fa4f266bd2444d14 = (createAnalyticsEvent, attributes)=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'experience completed', (0, (0, parcelRequire("8Bc5A")).ACTION_SUBJECT_ID), {
            ...attributes
        });
    };
    const $5dab66e6da9554ae$export$a68a2e5a69c8cd74 = (createAnalyticsEvent, completedTaskId)=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'checklistItem completed', (0, (0, parcelRequire("izv86")).convertTaskIdToActionSubjectId)(completedTaskId), {
            taskId: completedTaskId
        });
    };
    const $5dab66e6da9554ae$export$a4d7f1a52677d339 = (error, endpointSource)=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            error: error,
            meta: {
                id: 'quickstartApiError',
                packageName: 'jiraOnboardingQuickstartCore',
                teamName: 'jlove-makkuro'
            },
            attributes: {
                error: error.message,
                endpointSource: endpointSource
            }
        });
    };
    const $5dab66e6da9554ae$export$160bb78a3b11a5a9 = (createAnalyticsEvent, attributes)=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart openRightSidebar', (0, (0, parcelRequire("8Bc5A")).ACTION_SUBJECT_ID), {
            ...attributes
        });
    };
    const $5dab66e6da9554ae$export$6ccbe54cd3a5a12 = (createAnalyticsEvent, attributes)=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart minimiseRightSidebar', (0, (0, parcelRequire("8Bc5A")).ACTION_SUBJECT_ID), {
            ...attributes
        });
    };
    const $5dab66e6da9554ae$export$6c39ca65ca354e59 = (createAnalyticsEvent, attributes)=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'nuxOnboardingQuickstart closeRightSidebar', (0, (0, parcelRequire("8Bc5A")).ACTION_SUBJECT_ID), {
            ...attributes
        });
    };
});
parcelRegister("izv86", function(module, exports) {
    $parcel$export(module.exports, "getProductType", ()=>$4725f5ccfabd2231$export$27e53caf66bae1d);
    $parcel$export(module.exports, "convertTaskIdToActionSubjectId", ()=>$4725f5ccfabd2231$export$3b914201960fa7a6);
    var $e4eHl = parcelRequire("e4eHl");
    var $2vSU6;
    const $4725f5ccfabd2231$export$d64a7dd8c7cd80e0 = {
        [(0, (0, parcelRequire("2vSU6")).CORE_PROJECT)]: 'workManagement',
        [(0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)]: 'software',
        [(0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)]: 'serviceManagement'
    };
    const $4725f5ccfabd2231$export$27e53caf66bae1d = (projectType)=>{
        if (projectType) return $4725f5ccfabd2231$export$d64a7dd8c7cd80e0[projectType] || (0, ($parcel$interopDefault($e4eHl)))(projectType);
        return null;
    };
    const $4725f5ccfabd2231$export$3b914201960fa7a6 = (taskId)=>{
        if (!taskId) return '';
        return (0, ($parcel$interopDefault($e4eHl)))(taskId.split('.').pop());
    };
});
parcelRegister("ljzlb", function(module, exports) {
    $parcel$export(module.exports, "getCrossProjectBoardTrait", ()=>$9217b5bb53dd29c2$export$7f2186c37a3d095d);
    var $jcw0u;
    var $co1wz;
    var $eusud;
    var $8zOmE;
    var $8Bc5A;
    var $k9OK8;
    const $9217b5bb53dd29c2$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT = 'segment_jsw_cross_project_board_trait_siteuser';
    const $9217b5bb53dd29c2$var$TAP_DELIVERY_PROXY_ENDPOINT = '/gateway/api/tap-delivery/api/v3/personalization';
    const $9217b5bb53dd29c2$var$ONE_DAY = 86400000;
    const $9217b5bb53dd29c2$export$88f2f25e1418caf1 = async (createAnalyticsEvent, siteId, userId)=>{
        try {
            const url = `${$9217b5bb53dd29c2$var$TAP_DELIVERY_PROXY_ENDPOINT}/site/${siteId}/user/${userId}`;
            const result = await (0, (0, parcelRequire("eusud")).performGetRequest)(url);
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait personalizationApi', {
                synthetic: (0, (0, parcelRequire("co1wz")).ff)('jsw.pollinator.tenants')
            });
            return result;
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                error: error,
                meta: {
                    id: 'quickstartApiError',
                    packageName: (0, (0, parcelRequire("8Bc5A")).PACKAGE_NAME),
                    teamName: (0, (0, parcelRequire("8Bc5A")).PACKAGE_TEAM_NAME)
                },
                attributes: {
                    error: error.message,
                    endpointSource: 'getJSWCrossProjectBoardTrait',
                    synthetic: (0, (0, parcelRequire("co1wz")).ff)('jsw.pollinator.tenants')
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return {
                attributes: []
            };
        }
    };
    const $9217b5bb53dd29c2$export$7f2186c37a3d095d = async (createAnalyticsEvent, siteId, userId)=>{
        const { get: get, persist: persist } = (0, (0, parcelRequire("k9OK8")).crossProjectBoardTraitSessionStorageProvider)();
        const sessionStorage = get();
        if (sessionStorage && userId === sessionStorage.userId && siteId === sessionStorage.siteId && Date.now() - sessionStorage.date < $9217b5bb53dd29c2$var$ONE_DAY) {
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, 'getJSWCrossProjectBoardTrait sessionStorage', {
                synthetic: (0, (0, parcelRequire("co1wz")).ff)('jsw.pollinator.tenants')
            });
            return sessionStorage.attribute;
        }
        const personalization = await $9217b5bb53dd29c2$export$88f2f25e1418caf1(createAnalyticsEvent, siteId, userId);
        const attribute = personalization.attributes.find((att)=>att.name === $9217b5bb53dd29c2$var$CROSS_PROJECT_BOARD_TO_PLAN_UPSELL_TRAIT);
        if (attribute !== undefined) persist({
            attribute: attribute,
            date: Date.now(),
            userId: userId,
            siteId: siteId
        });
        return attribute;
    };
});
parcelRegister("k9OK8", function(module, exports) {
    $parcel$export(module.exports, "crossProjectBoardTraitSessionStorageProvider", ()=>$ee27e8acf854e0ab$export$99f3e48748c2a8c3);
    var $eNf8a;
    const $ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider = (0, (0, parcelRequire("eNf8a")).createSessionExpirableStorageProvider)((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a));
    const $ee27e8acf854e0ab$export$99f3e48748c2a8c3 = ()=>{
        const persist = (toPersist)=>{
            $ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider.set((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a), toPersist);
        };
        const get = ()=>$ee27e8acf854e0ab$var$crossProjectBoardTraitSessionProvider.get((0, $111ca51573c84ae8$export$fac14ff24e5b1e7a));
        return {
            get: get,
            persist: persist
        };
    };
});
parcelRegister("eNf8a", function(module, exports) {
    $parcel$export(module.exports, "createSessionStorageProvider", ()=>$b98f887ad675a269$export$a922b987e648d2fa);
    $parcel$export(module.exports, "createSessionExpirableStorageProvider", ()=>$b98f887ad675a269$export$e0a2e9a062c6a695);
    var $gJBT6 = parcelRequire("gJBT6");
    var $fNVZf;
    var $j9Vq5;
    const $b98f887ad675a269$export$a922b987e648d2fa = (0, ($parcel$interopDefault($gJBT6)))((appPrefix)=>(0, (0, parcelRequire("fNVZf")).createStorageProvider)(appPrefix, (0, (0, parcelRequire("j9Vq5")).makeSessionStore)()));
    const $b98f887ad675a269$export$e0a2e9a062c6a695 = (0, ($parcel$interopDefault($gJBT6)))((appPrefix)=>{
        if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
        const store = (0, (0, parcelRequire("j9Vq5")).makeSessionExpirableStore)();
        return store.namespace(appPrefix);
    });
});
parcelRegister("j9Vq5", function(module, exports) {
    $parcel$export(module.exports, "makeSessionStore", ()=>$93ac2abe604287b3$export$fb690882d627b3b5);
    $parcel$export(module.exports, "makeSessionExpirableStore", ()=>$93ac2abe604287b3$export$a8f626c8ded9a06c);
    var $fKgem = parcelRequire("fKgem");
    var $kzObv = parcelRequire("kzObv");
    var $c4CII = parcelRequire("c4CII");
    var $2NjNT = parcelRequire("2NjNT");
    var $c74za = parcelRequire("c74za");
    var $fNVZf;
    const $93ac2abe604287b3$export$fb690882d627b3b5 = ()=>(0, ($parcel$interopDefault($c4CII))).createStore([
            (0, ($parcel$interopDefault($c74za))),
            (0, ($parcel$interopDefault($2NjNT)))
        ], (0, (0, parcelRequire("fNVZf")).plugins));
    const $93ac2abe604287b3$export$a8f626c8ded9a06c = ()=>(0, ($parcel$interopDefault($c4CII))).createStore([
            (0, ($parcel$interopDefault($c74za))),
            (0, ($parcel$interopDefault($2NjNT)))
        ], [
            (0, ($parcel$interopDefault($fKgem))),
            (0, ($parcel$interopDefault($kzObv)))
        ]);
});
const $111ca51573c84ae8$export$fac14ff24e5b1e7a = 'jira-user-cross-project-board-trait';
parcelRegister("3ORcf", function(module, exports) {
    $parcel$export(module.exports, "getIsDevOpsProject", ()=>$d5d39abfab8df073$export$88ee873472aa9bb7);
    var $8Bc5A;
    const $d5d39abfab8df073$var$projectPropertyUrl = (projectKey)=>`/rest/api/2/project/${projectKey}/properties/${0, (0, parcelRequire("8Bc5A")).KEY_IS_DEVOPS_PROJECT}`;
    const $d5d39abfab8df073$export$88ee873472aa9bb7 = async (projectKey)=>{
        const url = $d5d39abfab8df073$var$projectPropertyUrl(projectKey);
        const response = await fetch(url);
        if (response.ok) {
            const result = await response.json();
            return result.value;
        }
        return false;
    };
});
parcelRegister("6ypzr", function(module, exports) {
    $parcel$export(module.exports, "getOnboardingSkipApplicationProperty", ()=>$98fe78eb4dc2e758$export$980c26b6f100081d);
    var $eusud;
    const $98fe78eb4dc2e758$export$980c26b6f100081d = ()=>(0, (0, parcelRequire("eusud")).performGetRequest)('/rest/onboarding/1.0/skip');
});
parcelRegister("4ji4w", function(module, exports) {
    $parcel$export(module.exports, "getNextNonCompleteTask", ()=>$af696889329ec63a$export$b61dc70e2ed3fae3);
    $parcel$export(module.exports, "getNextTask", ()=>$af696889329ec63a$export$404421ce8f3cbf9a);
    $parcel$export(module.exports, "setLocalStorageItem", ()=>$af696889329ec63a$export$5aa524d86254b4f);
    $parcel$export(module.exports, "getLocalStorageItem", ()=>$af696889329ec63a$export$93d719890ad66653);
    var $bSSG7;
    var $aFsRe;
    const $af696889329ec63a$export$b61dc70e2ed3fae3 = (tasks, completed, openTask)=>{
        const taskPosition = (0, (0, parcelRequire("aFsRe")).getTaskIndex)(tasks, openTask);
        const start = taskPosition === -1 ? 0 : taskPosition;
        const len = tasks.length;
        for(let i = start; i < start + len; i += 1){
            const ind = i % len;
            if (!completed.includes(tasks[ind])) return tasks[ind];
        }
        return null;
    };
    const $af696889329ec63a$export$404421ce8f3cbf9a = (tasks, openTask)=>{
        const taskPosition = (0, (0, parcelRequire("aFsRe")).getTaskIndex)(tasks, openTask);
        const ind = taskPosition === -1 ? 0 : taskPosition;
        return tasks[ind] ? tasks[ind] : null;
    };
    const $af696889329ec63a$var$store = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('quickstart');
    const $af696889329ec63a$export$5aa524d86254b4f = (key, value)=>{
        $af696889329ec63a$var$store.set(key, value);
    };
    const $af696889329ec63a$export$93d719890ad66653 = (key)=>$af696889329ec63a$var$store.get(key);
});
parcelRegister("aFsRe", function(module, exports) {
    $parcel$export(module.exports, "getTaskIndex", ()=>$856e0575daef172f$export$9ba3adcb1954c00);
    $parcel$export(module.exports, "convertTaskIdToActionSubjectIdForShowMe", ()=>$856e0575daef172f$export$9711f11998d5795c);
    $parcel$export(module.exports, "convertTaskIdToActionSubjectIdForLink", ()=>$856e0575daef172f$export$995248f3b43d8505);
    $parcel$export(module.exports, "convertTaskIdToActionSubjectIdForCta", ()=>$856e0575daef172f$export$293f6b2affa6ea5a);
    var $izv86;
    const $856e0575daef172f$export$9ba3adcb1954c00 = (taskList, taskId)=>{
        if (!taskList || taskId === null) return -1;
        return taskList.indexOf(taskId) + 1;
    };
    const $856e0575daef172f$export$9711f11998d5795c = (taskId)=>`${(0, (0, parcelRequire("izv86")).convertTaskIdToActionSubjectId)(taskId)}ShowMe`;
    const $856e0575daef172f$export$995248f3b43d8505 = (taskId)=>`${(0, (0, parcelRequire("izv86")).convertTaskIdToActionSubjectId)(taskId)}Link`;
    const $856e0575daef172f$export$293f6b2affa6ea5a = (taskId)=>`${(0, (0, parcelRequire("izv86")).convertTaskIdToActionSubjectId)(taskId)}Cta`;
});
parcelRegister("abQXL", function(module, exports) {
    $parcel$export(module.exports, "nextSetChecklistIsDismissed", ()=>$dc09dffee9419aae$export$f24c05f83b880547);
    var $8Bc5A;
    var $1ftPQ;
    var $3B5jO;
    var $4ji4w;
    const $dc09dffee9419aae$export$f24c05f83b880547 = (isDismissed)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const quickstartType = (0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state);
            const currentIsDismissed = state.visibility[quickstartType] === (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).DISMISSED;
            if (isDismissed === currentIsDismissed) return;
            const quickstartStatus = isDismissed ? (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).DISMISSED : (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN;
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: quickstartStatus
                },
                isFocusedOn: !isDismissed
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(quickstartType),
                value: quickstartStatus
            });
            (0, (0, parcelRequire("4ji4w")).setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
            if (isDismissed === false) (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_OPEN),
                value: true
            });
            else (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_OPEN),
                value: false
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED),
                value: isDismissed
            });
        };
});
parcelRegister("4VXxO", function(module, exports) {
    $parcel$export(module.exports, "nextSetChecklistIsOpen", ()=>$7815e3bf96163d46$export$4249eabbb34e2e69);
    var $8Bc5A;
    var $1ftPQ;
    var $3B5jO;
    var $4ji4w;
    const $7815e3bf96163d46$export$4249eabbb34e2e69 = (isOpen)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const quickstartType = (0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state);
            const currentIsOpen = state.visibility[quickstartType] === (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN;
            const currentIsMinimised = state.visibility[quickstartType] === (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).MINIMIZED;
            if (currentIsOpen && isOpen || currentIsMinimised && !isOpen) return;
            const quickstartStatus = isOpen ? (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN : (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).MINIMIZED;
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: quickstartStatus
                },
                hasNudgeActive: false,
                isFocusedOn: isOpen
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(quickstartType),
                value: quickstartStatus
            });
            (0, (0, parcelRequire("4ji4w")).setLocalStorageItem)(`${quickstartType}.visibility`, quickstartStatus);
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_OPEN),
                value: isOpen
            });
        };
});
parcelRegister("erLQY", function(module, exports) {
    $parcel$export(module.exports, "nextMarkAsCompletedTask", ()=>$f082da41253fd664$export$d6628d41a3bec42d);
    var $1ftPQ;
    const $f082da41253fd664$export$d6628d41a3bec42d = (taskId)=>({ getState: getState, setState: setState })=>{
            const { completedTaskList: completedTaskList } = getState();
            if (completedTaskList.includes(taskId)) return;
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: taskId,
                value: true
            });
            setState({
                completedTaskList: [
                    ...completedTaskList,
                    taskId
                ]
            });
        };
});
parcelRegister("8UXiA", function(module, exports) {
    $parcel$export(module.exports, "setNudgeStep", ()=>$2d15900fae273e3c$export$4debc323813b6997);
    const $2d15900fae273e3c$export$4debc323813b6997 = (nudge)=>({ getState: getState, setState: setState })=>{
            const { nudgeStep: nudgeStep } = getState();
            if (nudge === nudgeStep) return;
            setState({
                nudgeStep: nudge
            });
        };
    var $2d15900fae273e3c$export$2e2bcd8739ae039 = $2d15900fae273e3c$export$4debc323813b6997;
});
parcelRegister("3iEb4", function(module, exports) {
    $parcel$export(module.exports, "addMountedNudge", ()=>$d23aba2b0749d2be$export$92a89c32d0ea3943);
    $parcel$export(module.exports, "removeMountedNudge", ()=>$d23aba2b0749d2be$export$748f4cda8ab98c91);
    const $d23aba2b0749d2be$export$92a89c32d0ea3943 = (nudge)=>({ getState: getState, setState: setState })=>{
            const { mountedNudges: mountedNudges } = getState();
            if (mountedNudges.includes(nudge)) return;
            setState({
                mountedNudges: [
                    ...mountedNudges,
                    nudge
                ]
            });
        };
    const $d23aba2b0749d2be$export$748f4cda8ab98c91 = (nudge)=>({ getState: getState, setState: setState })=>{
            const { mountedNudges: mountedNudges } = getState();
            if (!mountedNudges.includes(nudge)) return;
            setState({
                mountedNudges: mountedNudges.filter((mountedNudge)=>mountedNudge !== nudge)
            });
        };
});
parcelRegister("7yDu9", function(module, exports) {
    $parcel$export(module.exports, "setShouldRenderComponent", ()=>$e7988e1b8f7782bd$export$1f9c6770ed938b6e);
    const $e7988e1b8f7782bd$export$1f9c6770ed938b6e = (shouldRenderComponent)=>({ getState: getState, setState: setState })=>{
            const { shouldRenderComponent: currentShouldRenderComponent } = getState();
            if (shouldRenderComponent === currentShouldRenderComponent) return;
            setState({
                shouldRenderComponent: shouldRenderComponent
            });
        };
    var $e7988e1b8f7782bd$export$2e2bcd8739ae039 = $e7988e1b8f7782bd$export$1f9c6770ed938b6e;
});
parcelRegister("5UBG2", function(module, exports) {
    $parcel$export(module.exports, "setProjectState", ()=>$72dc29ca0b198f0e$export$1ba498e440c0a1e4);
    const $72dc29ca0b198f0e$export$1ba498e440c0a1e4 = (projectState)=>({ setState: setState })=>{
            setState({
                projectState: projectState
            });
        };
    var $72dc29ca0b198f0e$export$2e2bcd8739ae039 = $72dc29ca0b198f0e$export$1ba498e440c0a1e4;
});
parcelRegister("lHcRB", function(module, exports) {
    $parcel$export(module.exports, "setHasNudgeActive", ()=>$4ecbca1b06d3bc5e$export$497c281e6eb0786e);
    const $4ecbca1b06d3bc5e$export$497c281e6eb0786e = (hasNudgeActive, itemName = '')=>({ getState: getState, setState: setState })=>{
            const { hasNudgeActive: currentHasNudgeActive, openTask: openTask } = getState();
            if (hasNudgeActive === currentHasNudgeActive) return;
            if (hasNudgeActive === false && itemName !== openTask) return;
            setState({
                hasNudgeActive: hasNudgeActive
            });
        };
    var $4ecbca1b06d3bc5e$export$2e2bcd8739ae039 = $4ecbca1b06d3bc5e$export$497c281e6eb0786e;
});
parcelRegister("eiyXc", function(module, exports) {
    $parcel$export(module.exports, "forceHideNudge", ()=>$7ab5d12e3e83c16f$export$6d1ed97b83a62e8e);
    const $7ab5d12e3e83c16f$export$6d1ed97b83a62e8e = ()=>({ setState: setState })=>{
            setState({
                hasNudgeActive: false
            });
        };
});
parcelRegister("jZvbN", function(module, exports) {
    $parcel$export(module.exports, "setHasEverSeenRoute", ()=>$bde38543b00c29f3$export$28e0a4314a1ce52f);
    var $8Bc5A;
    var $1ftPQ;
    const $bde38543b00c29f3$export$28e0a4314a1ce52f = (update)=>({ getState: getState, setState: setState })=>{
            const { hasEverSeenRoute: currentHasEverSeenRoute } = getState();
            const somethingHasBeenUpdated = Object.keys(update).some((key)=>update[key] !== currentHasEverSeenRoute[key]);
            if (!somethingHasBeenUpdated) return;
            const newHasEverSeenRoute = {
                ...currentHasEverSeenRoute,
                ...update
            };
            setState({
                hasEverSeenRoute: newHasEverSeenRoute
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_HAS_EVER_SEEN_ROUTE),
                value: newHasEverSeenRoute
            });
        };
    var $bde38543b00c29f3$export$2e2bcd8739ae039 = $bde38543b00c29f3$export$28e0a4314a1ce52f;
});
parcelRegister("azcAL", function(module, exports) {
    $parcel$export(module.exports, "setRoadmapIsCreateEnabled", ()=>$f19987e3027503ab$export$35ea35d1a8e07307);
    $parcel$export(module.exports, "setRoadmapIsListEmpty", ()=>$f19987e3027503ab$export$932967764e7a0b31);
    const $f19987e3027503ab$export$35ea35d1a8e07307 = (roadmapIsCreateEnabled)=>({ getState: getState, setState: setState })=>{
            const { roadmapIsCreateEnabled: currentRoadmapIsCreateEnabled } = getState();
            if (currentRoadmapIsCreateEnabled === roadmapIsCreateEnabled) return;
            setState({
                roadmapIsCreateEnabled: roadmapIsCreateEnabled
            });
        };
    const $f19987e3027503ab$export$932967764e7a0b31 = (roadmapIsListEmpty)=>({ getState: getState, setState: setState })=>{
            const { roadmapIsListEmpty: currentRoadmapIsListEmpty } = getState();
            if (currentRoadmapIsListEmpty === roadmapIsListEmpty) return;
            setState({
                roadmapIsListEmpty: roadmapIsListEmpty
            });
        };
});
parcelRegister("gbXQ5", function(module, exports) {
    $parcel$export(module.exports, "openNextTask", ()=>$460159056a360dfc$export$867dbb6d61569ae9);
    var $4ji4w;
    var $cUGWT;
    const $460159056a360dfc$export$867dbb6d61569ae9 = ()=>({ getState: getState, dispatch: dispatch })=>{
            const { openTask: openTask, tasks: tasks } = getState();
            if (!tasks) return;
            const { items: items } = tasks;
            const taskIdToExpand = (0, (0, parcelRequire("4ji4w")).getNextTask)(items, openTask);
            if (taskIdToExpand === null) return;
            dispatch((0, (0, parcelRequire("cUGWT")).nextOpenTask)(taskIdToExpand));
        };
});
parcelRegister("cUGWT", function(module, exports) {
    $parcel$export(module.exports, "nextOpenTask", ()=>$f8b3135a172025f8$export$5deb889489d2f989);
    $parcel$export(module.exports, "nextAutoOpenTask", ()=>$f8b3135a172025f8$export$cc5f3544a6cb2922);
    var $8Bc5A;
    var $1ftPQ;
    var $8UXiA;
    var $lHcRB;
    const $f8b3135a172025f8$var$openTask = (taskId)=>({ setState: setState })=>{
            setState({
                openTask: taskId
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).KEY_OPEN_TASK),
                value: taskId
            });
        };
    const $f8b3135a172025f8$export$5deb889489d2f989 = (taskId, { closeNudge: closeNudge } = {})=>({ dispatch: dispatch, getState: getState })=>{
            dispatch($f8b3135a172025f8$var$openTask(taskId));
            const { completedTaskList: completedTaskList } = getState();
            const taskIsCompleted = completedTaskList.includes(taskId);
            const taskIdExistsAndIsNotCompleted = !(taskId === '' || taskId === null) && !taskIsCompleted;
            if (closeNudge) dispatch((0, (0, parcelRequire("lHcRB")).setHasNudgeActive)(false, taskId));
            else dispatch((0, (0, parcelRequire("lHcRB")).setHasNudgeActive)(taskIdExistsAndIsNotCompleted, taskId));
            if (taskIdExistsAndIsNotCompleted && taskId === (0, (0, parcelRequire("8Bc5A")).SCRUM_ONBOARDING_TASK)) dispatch((0, (0, parcelRequire("8UXiA")).setNudgeStep)((0, $6784cbc7d62e5d7c$export$b1a6ab17737f33e)));
            else if (taskIdExistsAndIsNotCompleted && taskId === (0, (0, parcelRequire("8Bc5A")).KANBAN_ONBOARDING_TASK)) dispatch((0, (0, parcelRequire("8UXiA")).setNudgeStep)((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112)));
            else if (taskIdExistsAndIsNotCompleted && taskId === (0, (0, parcelRequire("8Bc5A")).ADD_COLUMNS_TASK)) dispatch((0, (0, parcelRequire("8UXiA")).setNudgeStep)((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112)));
            else dispatch((0, (0, parcelRequire("8UXiA")).setNudgeStep)(''));
        };
    const $f8b3135a172025f8$export$cc5f3544a6cb2922 = (taskId)=>({ dispatch: dispatch })=>{
            dispatch($f8b3135a172025f8$var$openTask(taskId));
            dispatch((0, (0, parcelRequire("lHcRB")).setHasNudgeActive)(false, taskId));
            dispatch((0, (0, parcelRequire("8UXiA")).setNudgeStep)(''));
        };
});
parcelRegister("iZuFy", function(module, exports) {
    $parcel$export(module.exports, "resetIsQuickstartLoaded", ()=>$b50ce46f86d3e3d7$export$bda085a823763e5a);
    var $8Bc5A;
    var $3B5jO;
    const $b50ce46f86d3e3d7$export$bda085a823763e5a = ()=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const quickstartType = (0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state);
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).NOT_LOADED
                },
                hasNudgeActive: false,
                isQuickstartLoaded: false
            });
        };
});
parcelRegister("70Fss", function(module, exports) {
    $parcel$export(module.exports, "refreshAppStateUiStatusOnly", ()=>$f0fdda8951af3bde$export$87fe8079a4ed9766);
    var $8Bc5A;
    var $6yhDy;
    var $52Vcw;
    var $6ypzr;
    var $abQXL;
    const $f0fdda8951af3bde$export$87fe8079a4ed9766 = ({ taskList: taskList })=>async ({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const updatedState = {};
            const { projectState: projectState } = getState();
            if (!projectState) return;
            updatedState.isOpen = true;
            updatedState.isDismissed = false;
            updatedState.quickstartStateProjectType = projectState.projectType;
            let backendVisibilityKeys = [];
            updatedState.visibility = Object.values((0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE)).reduce((acc, type)=>{
                acc[type] = (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN;
                return acc;
            }, {});
            backendVisibilityKeys = Object.values((0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE)).map((type)=>(0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(type));
            const backendState = await (0, (0, parcelRequire("6yhDy")).pollBackend)({
                keys: [
                    (0, (0, parcelRequire("8Bc5A")).KEY_OPEN),
                    (0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED),
                    (0, (0, parcelRequire("8Bc5A")).KEY_OPEN_TASK),
                    (0, (0, parcelRequire("8Bc5A")).KEY_HAS_EVER_SEEN_ROUTE),
                    (0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING),
                    ...(0, (0, parcelRequire("8Bc5A")).allTasksExcludingJSMBusinessTasks),
                    ...backendVisibilityKeys
                ]
            });
            const backendStateExists = backendState !== undefined && Object.keys(backendState).length > 0;
            if (backendStateExists) {
                updatedState.completedTaskList = Object.keys(backendState).filter((key)=>[
                        ...(0, (0, parcelRequire("8Bc5A")).allTasksExcludingJSMBusinessTasks)
                    ].includes(key) && backendState[key] === true);
                Object.values((0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE)).forEach((type)=>{
                    if ((0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(type) in backendState) updatedState.visibility[type] = backendState[(0, (0, parcelRequire("8Bc5A")).getBackendVisibilityKey)(type)];
                    else if ((0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED) in backendState && backendState[0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED]) updatedState.visibility[type] = (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).DISMISSED;
                    else if ((0, (0, parcelRequire("8Bc5A")).KEY_OPEN) in backendState) updatedState.visibility[type] = backendState[0, (0, parcelRequire("8Bc5A")).KEY_OPEN] ? (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).OPEN : (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).MINIMIZED;
                });
                if ((0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED) in backendState) updatedState.isDismissed = backendState[0, (0, parcelRequire("8Bc5A")).KEY_DISMISSED];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_OPEN) in backendState) updatedState.isOpen = backendState[0, (0, parcelRequire("8Bc5A")).KEY_OPEN];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_OPEN_TASK) in backendState) updatedState.openTask = backendState[0, (0, parcelRequire("8Bc5A")).KEY_OPEN_TASK];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_HAS_EVER_SEEN_ROUTE) in backendState) updatedState.hasEverSeenRoute = backendState[0, (0, parcelRequire("8Bc5A")).KEY_HAS_EVER_SEEN_ROUTE];
                if ((0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP) in backendState) {
                    updatedState.currentTaskGroupParent = backendState[0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP].taskGroup.currentTaskGroupParent;
                    updatedState.previousTaskGroupParents = backendState[0, (0, parcelRequire("8Bc5A")).KEY_TASK_GROUP].taskGroup.previousTaskGroupParents;
                }
                if ((0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING) in backendState) {
                    if (typeof backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING] === 'object' && backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING] !== null && (0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe) in backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING]) updatedState.selectedProjectTemplateKeyFromOnboarding = backendState[0, (0, parcelRequire("8Bc5A")).KEY_JSW_ONBOARDING][0, $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe];
                }
            }
            setState(updatedState);
            if (!(backendStateExists && (0, (0, parcelRequire("8Bc5A")).KEY_OPEN) in backendState)) try {
                const skipApplicationProperty = await (0, (0, parcelRequire("6ypzr")).getOnboardingSkipApplicationProperty)();
                if (skipApplicationProperty.quickstart) dispatch((0, (0, parcelRequire("abQXL")).nextSetChecklistIsDismissed)(true));
            } catch (error) {
                (0, (0, parcelRequire("52Vcw")).fireAPIErrorAnalytics)(error, 'skipOnboarding');
            }
            setState({
                taskList: taskList
            });
            setState({
                isQuickstartLoaded: true
            });
        };
});
parcelRegister("dQPsy", function(module, exports) {
    $parcel$export(module.exports, "nextSetChecklistItemSeen", ()=>$82a74350685dcd25$export$4eac017dcde0be8f);
    var $8Bc5A;
    var $1ftPQ;
    const $82a74350685dcd25$export$4eac017dcde0be8f = (taskId)=>({ getState: getState, setState: setState })=>{
            const hasSeenTaskId = (0, (0, parcelRequire("8Bc5A")).convertToHaveSeenItTask)(taskId);
            const { hasSeenTasks: hasSeenTasks } = getState();
            if (hasSeenTasks.includes(hasSeenTaskId)) return;
            setState({
                hasSeenTasks: [
                    ...hasSeenTasks,
                    hasSeenTaskId
                ]
            });
            (0, (0, parcelRequire("1ftPQ")).pushToBackend)({
                key: (0, (0, parcelRequire("8Bc5A")).convertToHaveSeenItTask)(taskId),
                value: true
            });
        };
});
parcelRegister("boV1S", function(module, exports) {
    $parcel$export(module.exports, "nextAutoExpand", ()=>$35a410a5fb89f79b$export$3d24e97d30cfd09e);
    var $8Bc5A;
    var $984bX;
    var $4ji4w;
    var $cUGWT;
    const $35a410a5fb89f79b$export$3d24e97d30cfd09e = ()=>({ getState: getState, dispatch: dispatch })=>{
            const hasNudgeToShowAfterNavigation = (0, (0, parcelRequire("984bX")).localStorageProvider)().get({
                accountId: (0, (0, parcelRequire("8Bc5A")).ACCOUNT_ID),
                key: (0, (0, parcelRequire("8Bc5A")).KEY_HAS_NAVIGATED_FROM_LINK)
            });
            if (hasNudgeToShowAfterNavigation) return;
            const { openTask: openTask, completedTaskList: completedTaskList, tasks: tasks } = getState();
            if (!tasks) return;
            const { items: items } = tasks;
            if (items.includes(openTask) && !completedTaskList.includes(openTask)) return;
            const taskIdToExpand = (0, (0, parcelRequire("4ji4w")).getNextNonCompleteTask)(items, completedTaskList, openTask);
            if (taskIdToExpand === null) return;
            dispatch((0, (0, parcelRequire("cUGWT")).nextAutoOpenTask)(taskIdToExpand));
        };
});
parcelRegister("984bX", function(module, exports) {
    $parcel$export(module.exports, "localStorageProvider", ()=>$a6d0a6873aa6f7aa$export$aa821bfb3308a1f5);
    $parcel$export(module.exports, "setLocalStorageHasNavigatedFromLink", ()=>$a6d0a6873aa6f7aa$export$f2666fae743fa5f);
    var $eNf8a;
    var $jcw0u;
    var $8Bc5A;
    const $a6d0a6873aa6f7aa$var$DAYS_BEFORE_EXPIRY = 1;
    const $a6d0a6873aa6f7aa$var$DAY = 86400000;
    const $a6d0a6873aa6f7aa$var$getKey = ({ accountId: accountId, key: key })=>`${accountId}.${key}`;
    const $a6d0a6873aa6f7aa$var$getExpiryTime = ()=>{
        const now = Date.now();
        return now + $a6d0a6873aa6f7aa$var$DAYS_BEFORE_EXPIRY * $a6d0a6873aa6f7aa$var$DAY;
    };
    let $a6d0a6873aa6f7aa$var$localStorage;
    const $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5 = ()=>{
        if ($a6d0a6873aa6f7aa$var$localStorage) return $a6d0a6873aa6f7aa$var$localStorage;
        const provider = (0, (0, parcelRequire("eNf8a")).createSessionExpirableStorageProvider)('jsw-onboarding-checklist');
        try {
            provider.removeExpiredKeys();
        } catch (e) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'localStorageProviderKeyRemoval',
                    packageName: 'jiraOnboardingQuickstartCore'
                },
                error: e
            });
        }
        const get = ({ accountId: accountId, key: key })=>provider.get($a6d0a6873aa6f7aa$var$getKey({
                accountId: accountId,
                key: key
            }));
        const set = ({ accountId: accountId, key: key, value: value })=>provider.set($a6d0a6873aa6f7aa$var$getKey({
                accountId: accountId,
                key: key
            }), value, $a6d0a6873aa6f7aa$var$getExpiryTime());
        const remove = ({ accountId: accountId, key: key })=>provider.remove($a6d0a6873aa6f7aa$var$getKey({
                accountId: accountId,
                key: key
            }));
        $a6d0a6873aa6f7aa$var$localStorage = {
            provider: provider,
            remove: remove,
            get: get,
            set: set
        };
        return $a6d0a6873aa6f7aa$var$localStorage;
    };
    const $a6d0a6873aa6f7aa$export$f2666fae743fa5f = (value)=>{
        $a6d0a6873aa6f7aa$export$aa821bfb3308a1f5().set({
            accountId: (0, (0, parcelRequire("8Bc5A")).ACCOUNT_ID),
            key: (0, (0, parcelRequire("8Bc5A")).KEY_HAS_NAVIGATED_FROM_LINK),
            value: value
        });
    };
});
parcelRegister("4Viq4", function(module, exports) {
    $parcel$export(module.exports, "nextShouldShowNudgeAfterNavigation", ()=>$0d74d0b8a43d2c5f$export$6f336ccb6432fcd0);
    var $8Bc5A;
    var $984bX;
    var $lHcRB;
    const $0d74d0b8a43d2c5f$export$6f336ccb6432fcd0 = (taskId)=>({ dispatch: dispatch })=>{
            const nudgeToShowAfterNavigationKeyPair = {
                accountId: (0, (0, parcelRequire("8Bc5A")).ACCOUNT_ID),
                key: (0, (0, parcelRequire("8Bc5A")).KEY_HAS_NAVIGATED_FROM_LINK)
            };
            const shouldShowNudge = (0, (0, parcelRequire("984bX")).localStorageProvider)().get(nudgeToShowAfterNavigationKeyPair) === taskId;
            if (shouldShowNudge) {
                dispatch((0, (0, parcelRequire("lHcRB")).setHasNudgeActive)(true));
                (0, (0, parcelRequire("984bX")).localStorageProvider)().remove(nudgeToShowAfterNavigationKeyPair);
            }
        };
});
parcelRegister("jIoq4", function(module, exports) {
    $parcel$export(module.exports, "nextGetTasks", ()=>$034f263b888956c9$export$15d877e1f3abf489);
    var $ikZFc;
    const $034f263b888956c9$export$15d877e1f3abf489 = (props)=>({ getState: getState, setState: setState })=>{
            const { taskList: taskList } = getState();
            const tasks = (0, (0, parcelRequire("ikZFc")).getAllTasks)({
                ...props,
                taskList: taskList
            });
            setState({
                tasks: tasks
            });
        };
});
parcelRegister("ikZFc", function(module, exports) {
    $parcel$export(module.exports, "getAllTasks", ()=>$cb6c1b1dc7b1b225$export$d1f442602a91e7cc);
    var $1WqFo;
    var $65Ltd;
    var $co1wz;
    var $4R6GH;
    var $ldyPw;
    var $8Bc5A;
    var $1ffS1;
    var $ieqoN;
    var $h3PyW;
    var $3Iaiu;
    var $aHo1U;
    var $5yUqp;
    var $5zzQl;
    var $jJca1;
    const $cb6c1b1dc7b1b225$var$getTaskListItem = ({ variants: variants, taskVariants: taskVariants, taskList: taskList, taskGroupParent: taskGroupParent })=>{
        if (variants.includes((0, (0, parcelRequire("aHo1U")).JSW).experiment.jswReverseTrial)) {
            const { title: title, items: items } = taskList[taskGroupParent === (0, (0, parcelRequire("8Bc5A")).ROOT_TASK) ? (0, (0, parcelRequire("8Bc5A")).REVERSE_TRIAL_ROOT_TASK) : taskGroupParent] ?? taskList[0, (0, parcelRequire("8Bc5A")).REVERSE_TRIAL_ROOT_TASK];
            return {
                title: title,
                items: (0, (0, parcelRequire("5zzQl")).getTasks)(variants, taskVariants, items)
            };
        }
        const { title: title, items: items } = taskList[taskGroupParent] ?? taskList[0, (0, parcelRequire("8Bc5A")).ROOT_TASK];
        return {
            title: title,
            items: (0, (0, parcelRequire("5zzQl")).getTasks)(variants, taskVariants, items)
        };
    };
    const $cb6c1b1dc7b1b225$var$createJswTasks = (projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup)=>{
        const variants = new Set();
        const isTmpScrumWithSprintPermission = mountedNudges.includes((0, (0, parcelRequire("8Bc5A")).BACKLOG_CREATE_SPRINT_NUDGE_ID));
        const isEligibleForKanbanTour = mountedNudges.includes((0, $6784cbc7d62e5d7c$export$3366ddefe77d5112));
        if ((0, (0, parcelRequire("1WqFo")).isFedRamp)()) variants.add((0, (0, parcelRequire("aHo1U")).JSW).experience.fedRamp);
        if (premiumTrialOnSignup && (0, (0, parcelRequire("4R6GH")).fg)('jsw_reverse_trials_feature_gate')) variants.add((0, (0, parcelRequire("aHo1U")).JSW).experiment.jswReverseTrial);
        if (isCustomerTemplateProject) variants.add((0, (0, parcelRequire("aHo1U")).JSW).projectProperties.isCreatedFromCustomerTemplate);
        if (shouldShowScrumOnboardingExperience && isTmpScrumWithSprintPermission) variants.add((0, (0, parcelRequire("aHo1U")).JSW).experiment.scrumOnboarding);
        if (isCrossProjectBoardToPlanUpsell) variants.add((0, (0, parcelRequire("aHo1U")).JSW).trait.crossProjectBoardToPlanUpsell);
        if (canEditPlans) variants.add((0, (0, parcelRequire("aHo1U")).JSW).permissions.hasPlanEditPermissions);
        if (isEligibleForKanbanTour || routeName !== (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BOARDS)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).experience.kanbanOnboarding);
        if (canCreateProject === false) variants.add((0, (0, parcelRequire("aHo1U")).JSW).permissions.notCanCreateProject);
        if (projectState?.isNextGen) variants.add((0, (0, parcelRequire("aHo1U")).JSW).projectStyle.teamManaged);
        else variants.add((0, (0, parcelRequire("aHo1U")).JSW).projectStyle.companyManaged);
        if (projectState?.isProjectAdmin) variants.add((0, (0, parcelRequire("aHo1U")).JSW).userRole.projectAdmin);
        if (projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).JIRA_ADMIN) {
            variants.add((0, (0, parcelRequire("aHo1U")).JSW).userRole.jiraAdmin);
            variants.add((0, (0, parcelRequire("aHo1U")).JSW).userRole.admin);
        }
        if (projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).SITE_ADMIN) {
            variants.add((0, (0, parcelRequire("aHo1U")).JSW).userRole.siteAdmin);
            variants.add((0, (0, parcelRequire("aHo1U")).JSW).userRole.admin);
        }
        if (projectState?.edition === (0, (0, parcelRequire("ldyPw")).FREE_EDITION)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).edition.free);
        else if (projectState?.edition === (0, (0, parcelRequire("ldyPw")).STANDARD_EDITION)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).edition.standard);
        else if (projectState?.edition === (0, (0, parcelRequire("ldyPw")).PREMIUM_EDITION)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).edition.premium);
        if ((0, (0, parcelRequire("1ffS1")).isRoadmapRoute)(routeName)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).route.softwareRoadmap);
        else if (routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BACKLOG)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).route.softwareBacklog);
        else if (routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_BOARDS)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).route.softwareBoard);
        else if (routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST_CLASSIC)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).route.softwareList);
        else if (routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_ACCESS)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).route.projectSettingsSoftwareAccess);
        else if (routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_ISSUE)) variants.add((0, (0, parcelRequire("aHo1U")).JSW).route.issue);
        else if ((0, (0, parcelRequire("co1wz")).ff)('jsw-calendar-view-onboarding_q3bvy') && (routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_CALENDAR_CLASSIC))) variants.add((0, (0, parcelRequire("aHo1U")).JSW).route.softwareCalendar);
        if (isEligibleToUpdateSitename) variants.add((0, (0, parcelRequire("aHo1U")).JSW).experiment.customizeSiteName);
        return $cb6c1b1dc7b1b225$var$getTaskListItem({
            variants: Array.from(variants.values()),
            taskVariants: (0, (0, parcelRequire("aHo1U")).JSW).taskVariants,
            taskList: (0, (0, parcelRequire("aHo1U")).JSW).taskList,
            taskGroupParent: taskGroupParent
        });
    };
    const $cb6c1b1dc7b1b225$var$createJwmTasks = (projectState, taskGroupParent, taskList = (0, (0, parcelRequire("5yUqp")).JWM).taskList)=>{
        const variants = [];
        variants.push((0, (0, parcelRequire("5yUqp")).JWM).experiments.projectTheming);
        if (projectState?.isProjectAdmin) variants.push((0, (0, parcelRequire("5yUqp")).JWM).userRole.projectAdmin);
        if (projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).JIRA_ADMIN) variants.push((0, (0, parcelRequire("5yUqp")).JWM).userRole.jiraAdmin);
        if (projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).SITE_ADMIN) variants.push((0, (0, parcelRequire("5yUqp")).JWM).userRole.siteAdmin);
        if (projectState?.isSampleProject) variants.push((0, (0, parcelRequire("5yUqp")).JWM).experiments.isSampleProject);
        else variants.push((0, (0, parcelRequire("5yUqp")).JWM).experiments.isNotSampleProject);
        if (projectState?.isTrelloCrossflow) variants.push((0, (0, parcelRequire("5yUqp")).JWM).experiments.trelloCrossflow);
        return $cb6c1b1dc7b1b225$var$getTaskListItem({
            variants: variants,
            taskVariants: (0, (0, parcelRequire("5yUqp")).JWM).taskVariants,
            taskList: taskList,
            taskGroupParent: taskGroupParent
        });
    };
    const $cb6c1b1dc7b1b225$var$createJsmTasks = (projectState, taskGroupParent)=>{
        const variants = [];
        variants.push((0, (0, parcelRequire("3Iaiu")).JSM).experiments.projectTheming);
        if (projectState?.isProjectAdmin) variants.push((0, (0, parcelRequire("3Iaiu")).JSM).userRole.projectAdmin);
        if (projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).JIRA_ADMIN) variants.push((0, (0, parcelRequire("3Iaiu")).JSM).userRole.jiraAdmin);
        if (projectState?.userRole === (0, (0, parcelRequire("ieqoN")).USER_ROLE).SITE_ADMIN) variants.push((0, (0, parcelRequire("3Iaiu")).JSM).userRole.siteAdmin);
        return $cb6c1b1dc7b1b225$var$getTaskListItem({
            variants: variants,
            taskVariants: (0, (0, parcelRequire("3Iaiu")).JSM).taskVariants,
            taskList: (0, (0, parcelRequire("3Iaiu")).JSM).taskList,
            taskGroupParent: taskGroupParent
        });
    };
    const $cb6c1b1dc7b1b225$var$createDevopsTasks = (taskGroupParent)=>{
        const variants = [];
        return $cb6c1b1dc7b1b225$var$getTaskListItem({
            variants: variants,
            taskVariants: (0, (0, parcelRequire("h3PyW")).DEVOPS).taskVariants,
            taskList: (0, (0, parcelRequire("h3PyW")).DEVOPS).taskList,
            taskGroupParent: taskGroupParent
        });
    };
    const $cb6c1b1dc7b1b225$export$d1f442602a91e7cc = ({ projectState: projectState, isDevOpsProject: isDevOpsProject, taskGroupParent: taskGroupParent, routeName: routeName, shouldShowScrumOnboardingExperience: shouldShowScrumOnboardingExperience, mountedNudges: mountedNudges, canCreateProject: canCreateProject, isEligibleToUpdateSitename: isEligibleToUpdateSitename, isCustomerTemplateProject: isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell: isCrossProjectBoardToPlanUpsell, canEditPlans: canEditPlans, premiumTrialOnSignup: premiumTrialOnSignup, taskList: taskList })=>{
        if ((0, (0, parcelRequire("jJca1")).isJwmProject)(projectState)) return $cb6c1b1dc7b1b225$var$createJwmTasks(projectState, taskGroupParent, taskList);
        if ((0, (0, parcelRequire("jJca1")).isJsmProject)(projectState)) return $cb6c1b1dc7b1b225$var$createJsmTasks(projectState, taskGroupParent);
        if (isDevOpsProject) return $cb6c1b1dc7b1b225$var$createDevopsTasks(taskGroupParent);
        return $cb6c1b1dc7b1b225$var$createJswTasks(projectState, taskGroupParent, routeName, shouldShowScrumOnboardingExperience, mountedNudges, canCreateProject, isEligibleToUpdateSitename, isCustomerTemplateProject, isCrossProjectBoardToPlanUpsell, canEditPlans, premiumTrialOnSignup);
    };
});
parcelRegister("1ffS1", function(module, exports) {
    $parcel$export(module.exports, "isRoadmapRoute", ()=>$ee93e5dd18635f6d$export$d1fa67c1ffb68871);
    var $65Ltd;
    const $ee93e5dd18635f6d$export$d1fa67c1ffb68871 = (routeName)=>{
        if (routeName === undefined) return false;
        return routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE) || routeName === (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_TIMELINE_CLASSIC);
    };
});
parcelRegister("ieqoN", function(module, exports) {
    $parcel$export(module.exports, "USER_ROLE", ()=>$353950c3dd35bbc6$export$8eeb199b23203523);
    const $353950c3dd35bbc6$export$8eeb199b23203523 = {
        END_USER: 'end-user',
        SITE_ADMIN: 'site-admin',
        JIRA_ADMIN: 'jira-admin'
    };
});
parcelRegister("h3PyW", function(module, exports) {
    $parcel$export(module.exports, "DEVOPS", ()=>$866b9189a2842e55$export$bb75b6064c92010c);
    var $j6cCw;
    const $866b9189a2842e55$export$bb75b6064c92010c = {
        taskList: (0, (0, parcelRequire("j6cCw")).TASK_LIST),
        taskVariants: (0, (0, parcelRequire("j6cCw")).TASK_VARIANTS),
        experiment: (0, (0, parcelRequire("j6cCw")).Experiment)
    };
});
parcelRegister("j6cCw", function(module, exports) {
    $parcel$export(module.exports, "Experiment", ()=>$7149b1f98b73c1fd$export$4e0ab25c8a7e4009);
    $parcel$export(module.exports, "TASK_LIST", ()=>$7149b1f98b73c1fd$export$601c8c0f45aeb0a0);
    $parcel$export(module.exports, "TASK_VARIANTS", ()=>$7149b1f98b73c1fd$export$36f4d47dfe11b613);
    var $8Bc5A;
    var $1AiUr;
    const $7149b1f98b73c1fd$export$4e0ab25c8a7e4009 = {};
    const $7149b1f98b73c1fd$export$601c8c0f45aeb0a0 = Object.freeze({
        root: {
            title: (0, (0, parcelRequire("1AiUr")).messages).rootTitle,
            items: [
                (0, (0, parcelRequire("8Bc5A")).DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK),
                (0, (0, parcelRequire("8Bc5A")).DEVOPS_GET_TO_KNOW_JIRA_TASK),
                (0, (0, parcelRequire("8Bc5A")).DEVOPS_NAVIGATE_YOUR_TOOLS_TASK),
                (0, (0, parcelRequire("8Bc5A")).DEVOPS_CAPTURE_INTEGRATIONS_TASK),
                (0, (0, parcelRequire("8Bc5A")).DEVOPS_CREATE_AUTOMATION_RULES_TASK),
                (0, (0, parcelRequire("8Bc5A")).DEVOPS_INVITE_TEAMMATES_TASK),
                (0, (0, parcelRequire("8Bc5A")).DEVOPS_FIND_HELP_TASK)
            ]
        }
    });
    const $7149b1f98b73c1fd$export$36f4d47dfe11b613 = {
        [(0, (0, parcelRequire("8Bc5A")).DEVOPS_WELCOME_TO_YOUR_PROJECT_TASK)]: {
            position: {
                default: 0
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).DEVOPS_GET_TO_KNOW_JIRA_TASK)]: {
            position: {
                default: 100
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).DEVOPS_NAVIGATE_YOUR_TOOLS_TASK)]: {
            position: {
                default: 200
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).DEVOPS_CAPTURE_INTEGRATIONS_TASK)]: {
            position: {
                default: 300
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).DEVOPS_CREATE_AUTOMATION_RULES_TASK)]: {
            position: {
                default: 400
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).DEVOPS_INVITE_TEAMMATES_TASK)]: {
            position: {
                default: 500
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).DEVOPS_FIND_HELP_TASK)]: {
            position: {
                default: 600
            },
            visibility: {
                default: true
            }
        }
    };
});
parcelRegister("1AiUr", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$6eae5132e152d792$export$defe85febe8b728c);
    var $7VHMR;
    const $6eae5132e152d792$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rootTitle: {
            "id": "software-onboarding-quickstart.services.tasks.config.devops.root-title.no-translate",
            "defaultMessage": "Quickstart"
        }
    });
});
parcelRegister("3Iaiu", function(module, exports) {
    $parcel$export(module.exports, "JSM", ()=>$56a077523ddf70fb$export$63f289f2da861d35);
    var $58IQc;
    const $56a077523ddf70fb$export$63f289f2da861d35 = {
        taskList: (0, (0, parcelRequire("58IQc")).JSM_TASK_LIST),
        taskVariants: (0, (0, parcelRequire("58IQc")).JSM_TASK_VARIANTS),
        userRole: (0, (0, parcelRequire("58IQc")).UserRole),
        experiments: (0, (0, parcelRequire("58IQc")).Experiments)
    };
});
parcelRegister("58IQc", function(module, exports) {
    $parcel$export(module.exports, "JSM_TASK_LIST", ()=>$3c13225c81ad4b5c$export$6c6c561944d49bcb);
    $parcel$export(module.exports, "Experiments", ()=>$3c13225c81ad4b5c$export$c8d6ffd15214553a);
    $parcel$export(module.exports, "UserRole", ()=>$3c13225c81ad4b5c$export$eb3485a690c2f0b8);
    $parcel$export(module.exports, "JSM_TASK_VARIANTS", ()=>$3c13225c81ad4b5c$export$5b68aef408c932d9);
    var $8Bc5A;
    var $kTSRm;
    const $3c13225c81ad4b5c$export$6c6c561944d49bcb = Object.freeze({
        root: {
            title: (0, (0, parcelRequire("kTSRm")).messages).rootTitle,
            items: [
                (0, (0, parcelRequire("8Bc5A")).JSM_REVIEW_YOUR_CHANNELS_TASK),
                (0, (0, parcelRequire("8Bc5A")).JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK),
                (0, (0, parcelRequire("8Bc5A")).JSM_INVITE_YOUR_TEAM_TASK)
            ]
        }
    });
    const $3c13225c81ad4b5c$export$c8d6ffd15214553a = {
        projectTheming: 'projectTheming'
    };
    const $3c13225c81ad4b5c$export$eb3485a690c2f0b8 = {
        projectAdmin: 'projectAdmin',
        jiraAdmin: 'jiraAdmin',
        siteAdmin: 'siteAdmin'
    };
    const $3c13225c81ad4b5c$export$5b68aef408c932d9 = {
        [(0, (0, parcelRequire("8Bc5A")).JSM_REVIEW_YOUR_CHANNELS_TASK)]: {
            position: {
                default: 0
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JSM_CUSTOMIZE_YOUR_REQUEST_TYPES_TASK)]: {
            position: {
                default: 1
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JSM_INVITE_YOUR_TEAM_TASK)]: {
            position: {
                default: 2
            },
            visibility: {
                default: true
            }
        }
    };
});
parcelRegister("kTSRm", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$f1f6142c4170f38e$export$defe85febe8b728c);
    var $7VHMR;
    const $f1f6142c4170f38e$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rootTitle: {
            "id": "software-onboarding-quickstart.services.tasks.config.jsm.root-title.no-translate",
            "defaultMessage": "Quickstart"
        }
    });
});
parcelRegister("aHo1U", function(module, exports) {
    $parcel$export(module.exports, "JSW", ()=>$563027753d017a60$export$4cfe6e52f2e72a54);
    var $8VfDj;
    const $563027753d017a60$export$4cfe6e52f2e72a54 = {
        taskList: (0, (0, parcelRequire("8VfDj")).TASK_LIST),
        taskVariants: (0, (0, parcelRequire("8VfDj")).TASK_VARIANTS),
        experiment: (0, (0, parcelRequire("8VfDj")).Experiment),
        experience: (0, (0, parcelRequire("8VfDj")).Experience),
        projectStyle: (0, (0, parcelRequire("8VfDj")).ProjectStyle),
        projectProperties: (0, (0, parcelRequire("8VfDj")).ProjectProperties),
        userRole: (0, (0, parcelRequire("8VfDj")).UserRole),
        edition: (0, (0, parcelRequire("8VfDj")).Edition),
        route: (0, (0, parcelRequire("8VfDj")).Route),
        permissions: (0, (0, parcelRequire("8VfDj")).Permissions),
        trait: (0, (0, parcelRequire("8VfDj")).Trait)
    };
});
parcelRegister("8VfDj", function(module, exports) {
    $parcel$export(module.exports, "Experiment", ()=>$ea3903bb15047c3b$export$4e0ab25c8a7e4009);
    $parcel$export(module.exports, "Experience", ()=>$ea3903bb15047c3b$export$c90b54e658fc4d7c);
    $parcel$export(module.exports, "ProjectStyle", ()=>$ea3903bb15047c3b$export$1f66f9f05afa05a8);
    $parcel$export(module.exports, "ProjectProperties", ()=>$ea3903bb15047c3b$export$543c19ee8dba9252);
    $parcel$export(module.exports, "UserRole", ()=>$ea3903bb15047c3b$export$eb3485a690c2f0b8);
    $parcel$export(module.exports, "Edition", ()=>$ea3903bb15047c3b$export$6f4a0f769e61929);
    $parcel$export(module.exports, "Route", ()=>$ea3903bb15047c3b$export$e7b0ac011bb776c6);
    $parcel$export(module.exports, "Permissions", ()=>$ea3903bb15047c3b$export$2d41982586bbb6be);
    $parcel$export(module.exports, "Trait", ()=>$ea3903bb15047c3b$export$2d08cfa40d69142e);
    $parcel$export(module.exports, "TASK_LIST", ()=>$ea3903bb15047c3b$export$601c8c0f45aeb0a0);
    $parcel$export(module.exports, "TASK_VARIANTS", ()=>$ea3903bb15047c3b$export$36f4d47dfe11b613);
    var $8Bc5A;
    var $ciLFO;
    const $ea3903bb15047c3b$export$4e0ab25c8a7e4009 = {
        scrumOnboarding: 'experiment.scrumOnboarding',
        customizeSiteName: 'experiment.customizeSiteName',
        jswReverseTrial: 'experiment.jswReverseTrial'
    };
    const $ea3903bb15047c3b$export$c90b54e658fc4d7c = {
        kanbanOnboarding: 'experience.kanbanOnboarding',
        fedRamp: 'experience.fedRamp'
    };
    const $ea3903bb15047c3b$export$1f66f9f05afa05a8 = {
        teamManaged: 'projectStyle.teamManaged',
        companyManaged: 'projectStyle.companyManaged'
    };
    const $ea3903bb15047c3b$export$543c19ee8dba9252 = {
        isCreatedFromCustomerTemplate: 'projectProperties.isCreatedFromCustomerTemplate'
    };
    const $ea3903bb15047c3b$export$eb3485a690c2f0b8 = {
        siteAdmin: 'userRole.siteAdmin',
        jiraAdmin: 'userRole.jiraAdmin',
        admin: 'userRole.admin',
        projectAdmin: 'userRole.projectAdmin'
    };
    const $ea3903bb15047c3b$export$6f4a0f769e61929 = {
        free: 'productEdition.free',
        standard: 'productEdition.standard',
        premium: 'productEdition.premium'
    };
    const $ea3903bb15047c3b$export$e7b0ac011bb776c6 = {
        softwareRoadmap: 'route.softwareRoadmap',
        softwareBacklog: 'route.softwareBacklog',
        softwareBoard: 'route.softwareBoard',
        softwareList: 'route.softwareList',
        projectSettingsSoftwareAccess: 'route.projectSettingsSoftwareAccess',
        issue: 'route.issue',
        softwareCalendar: 'route.softwareCalendar'
    };
    const $ea3903bb15047c3b$export$2d41982586bbb6be = {
        notCanCreateProject: 'permissions.notCanCreateProject',
        hasPlanEditPermissions: 'permissions.hasPlanEditPermissions'
    };
    const $ea3903bb15047c3b$export$2d08cfa40d69142e = {
        crossProjectBoardToPlanUpsell: 'trait.crossProjectBoardToPlanUpsell'
    };
    const $ea3903bb15047c3b$var$DEFAULT_TASK_LIST = [
        (0, (0, parcelRequire("8Bc5A")).ADD_COLUMNS_TASK),
        (0, (0, parcelRequire("8Bc5A")).CREATE_PROJECT_TASK),
        (0, (0, parcelRequire("8Bc5A")).CREATE_ISSUE_TASK),
        (0, (0, parcelRequire("8Bc5A")).CREATE_ISSUE_TASK_SIMPLIFIED),
        (0, (0, parcelRequire("8Bc5A")).TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK),
        (0, (0, parcelRequire("8Bc5A")).INVITE_TEAMMATES_TASK),
        (0, (0, parcelRequire("8Bc5A")).INVITE_TEAMMATES_VIDEO_TASK),
        (0, (0, parcelRequire("8Bc5A")).CAPTURE_INTEGRATIONS_TASK),
        (0, (0, parcelRequire("8Bc5A")).FIND_HELP_TASK),
        (0, (0, parcelRequire("8Bc5A")).SET_UP_BOARD_TASK),
        (0, (0, parcelRequire("8Bc5A")).GET_MOBILE_APP_TASK),
        (0, (0, parcelRequire("8Bc5A")).PREMIUM_REVERSE_TRIAL_TASK),
        (0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK),
        (0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN),
        (0, (0, parcelRequire("8Bc5A")).STANDARD_EDITION_OVERVIEW_TASK),
        (0, (0, parcelRequire("8Bc5A")).MAP_OUT_YOUR_PROJECT_GOALS_TASK),
        (0, (0, parcelRequire("8Bc5A")).IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK),
        (0, (0, parcelRequire("8Bc5A")).MONITOR_MANAGE_RISK_TASK),
        (0, (0, parcelRequire("8Bc5A")).SCRUM_ONBOARDING_TASK),
        (0, (0, parcelRequire("8Bc5A")).CUSTOMIZE_SITE_NAME_TASK),
        (0, (0, parcelRequire("8Bc5A")).GET_TO_KNOW_YOUR_TEMPLATE_TASK),
        (0, (0, parcelRequire("8Bc5A")).CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK),
        (0, (0, parcelRequire("8Bc5A")).GET_STARTED_LIST_TASK),
        (0, (0, parcelRequire("8Bc5A")).CALENDAR_VIEW_TASK)
    ];
    const $ea3903bb15047c3b$export$601c8c0f45aeb0a0 = Object.freeze({
        root: {
            title: (0, (0, parcelRequire("ciLFO")).messages).rootTitle,
            items: $ea3903bb15047c3b$var$DEFAULT_TASK_LIST
        },
        reverseTrialRoot: {
            title: (0, (0, parcelRequire("ciLFO")).messages).reverseTrialRootTitle,
            items: $ea3903bb15047c3b$var$DEFAULT_TASK_LIST
        },
        [(0, (0, parcelRequire("8Bc5A")).PREMIUM_REVERSE_TRIAL_TASK)]: {
            title: (0, (0, parcelRequire("ciLFO")).messages).reverseTrialCardTitle,
            items: [
                (0, (0, parcelRequire("8Bc5A")).ADVANCED_ROADMAPS_TASK),
                (0, (0, parcelRequire("8Bc5A")).CHANGE_CONTROL_TASK),
                (0, (0, parcelRequire("8Bc5A")).AUTOMATIONS_TASK),
                (0, (0, parcelRequire("8Bc5A")).SITE_ADMINISTRATIONS_TASK),
                (0, (0, parcelRequire("8Bc5A")).USER_MANAGEMENT_TASK)
            ]
        },
        [(0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK)]: {
            title: (0, (0, parcelRequire("ciLFO")).messages).premiumPlanTitle,
            items: [
                (0, (0, parcelRequire("8Bc5A")).ADVANCED_ROADMAPS_TASK),
                (0, (0, parcelRequire("8Bc5A")).CHANGE_CONTROL_TASK),
                (0, (0, parcelRequire("8Bc5A")).AUTOMATIONS_TASK),
                (0, (0, parcelRequire("8Bc5A")).SITE_ADMINISTRATIONS_TASK),
                (0, (0, parcelRequire("8Bc5A")).USER_MANAGEMENT_TASK)
            ]
        },
        [(0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
            title: (0, (0, parcelRequire("ciLFO")).messages).premiumPlanTitle,
            items: [
                (0, (0, parcelRequire("8Bc5A")).ADVANCED_ROADMAPS_TASK),
                (0, (0, parcelRequire("8Bc5A")).AUTOMATIONS_TASK)
            ]
        },
        [(0, (0, parcelRequire("8Bc5A")).STANDARD_EDITION_OVERVIEW_TASK)]: {
            title: (0, (0, parcelRequire("ciLFO")).messages).standardPlanTitle,
            items: [
                (0, (0, parcelRequire("8Bc5A")).AUTOMATIONS_TASK),
                (0, (0, parcelRequire("8Bc5A")).USER_MANAGEMENT_TASK),
                (0, (0, parcelRequire("8Bc5A")).SITE_ADMINISTRATIONS_TASK)
            ]
        }
    });
    const $ea3903bb15047c3b$var$PLAN_ONBOARDING_TASKS = {
        [(0, (0, parcelRequire("8Bc5A")).PREMIUM_REVERSE_TRIAL_TASK)]: {
            position: {
                default: 900
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK)]: {
            position: {
                default: 900
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).PREMIUM_EDITION_OVERVIEW_TASK_NON_ADMIN)]: {
            position: {
                default: 900
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$4e0ab25c8a7e4009.jswReverseTrial,
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                        ],
                        value: true
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                            $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).STANDARD_EDITION_OVERVIEW_TASK)]: {
            position: {
                default: 900
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).ADVANCED_ROADMAPS_TASK)]: {
            position: {
                default: 105
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                            $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                        ],
                        value: true
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).AUTOMATIONS_TASK)]: {
            position: {
                default: 110
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$2d08cfa40d69142e.crossProjectBoardToPlanUpsell,
                            $ea3903bb15047c3b$export$2d41982586bbb6be.hasPlanEditPermissions
                        ],
                        value: true
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: true
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).USER_MANAGEMENT_TASK)]: {
            position: {
                default: 115
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: true
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).CHANGE_CONTROL_TASK)]: {
            position: {
                default: 120
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).SITE_ADMINISTRATIONS_TASK)]: {
            position: {
                default: 125
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.premium,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                        ],
                        value: true
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$6f4a0f769e61929.standard,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                        ],
                        value: true
                    }
                ]
            }
        }
    };
    const $ea3903bb15047c3b$var$CUSTOMER_TEMPLATE_ONBOARDING_TASKS = {
        [(0, (0, parcelRequire("8Bc5A")).GET_TO_KNOW_YOUR_TEMPLATE_TASK)]: {
            position: {
                default: 0
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$543c19ee8dba9252.isCreatedFromCustomerTemplate,
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin
                        ],
                        value: true
                    }
                ]
            }
        }
    };
    const $ea3903bb15047c3b$export$36f4d47dfe11b613 = {
        ...$ea3903bb15047c3b$var$PLAN_ONBOARDING_TASKS,
        ...$ea3903bb15047c3b$var$CUSTOMER_TEMPLATE_ONBOARDING_TASKS,
        [(0, (0, parcelRequire("8Bc5A")).CREATE_PROJECT_TASK)]: {
            position: {
                default: 0
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$2d41982586bbb6be.notCanCreateProject
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$543c19ee8dba9252.isCreatedFromCustomerTemplate
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).CUSTOMIZE_SITE_NAME_TASK)]: {
            position: {
                default: 50
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin,
                            $ea3903bb15047c3b$export$4e0ab25c8a7e4009.customizeSiteName
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).CALENDAR_VIEW_TASK)]: {
            position: {
                default: 100
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        value: true,
                        condition: [
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareCalendar
                        ]
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).SCRUM_ONBOARDING_TASK)]: {
            position: {
                default: 150
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.siteAdmin,
                            $ea3903bb15047c3b$export$4e0ab25c8a7e4009.scrumOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBacklog
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MAP_OUT_YOUR_PROJECT_GOALS_TASK)]: {
            position: {
                default: 150
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).IDENTIFY_SMALL_CHUNKS_OF_WORK_TASK)]: {
            position: {
                default: 151
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MONITOR_MANAGE_RISK_TASK)]: {
            position: {
                default: 152
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareRoadmap
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).SET_UP_BOARD_TASK)]: {
            position: {
                default: 200
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                            $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).CREATE_ISSUE_TASK)]: {
            position: {
                default: 300
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).CREATE_ISSUE_TASK_SIMPLIFIED)]: {
            position: {
                default: 300
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).ADD_COLUMNS_TASK)]: {
            position: {
                default: 310
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).GET_STARTED_LIST_TASK)]: {
            position: {
                default: 320
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareList
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).TRY_ATLASSIAN_UNIVERSITY_ONBOARDING_TASK)]: {
            position: {
                default: 350
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).INVITE_TEAMMATES_TASK)]: {
            position: {
                default: 400
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                            $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                            $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).INVITE_TEAMMATES_VIDEO_TASK)]: {
            position: {
                default: 400,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: 600
                    }
                ]
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.projectAdmin,
                            $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                        ],
                        value: true
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$eb3485a690c2f0b8.admin,
                            $ea3903bb15047c3b$export$1f66f9f05afa05a8.teamManaged
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).CAPTURE_INTEGRATIONS_TASK)]: {
            position: {
                default: 500
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.fedRamp
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).GET_MOBILE_APP_TASK)]: {
            position: {
                default: 600
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.fedRamp
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).FIND_HELP_TASK)]: {
            position: {
                default: 700
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).CREATE_BUSINESS_PROJECT_FROM_JSW_QUICKSTART_TASK)]: {
            position: {
                default: 800
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            $ea3903bb15047c3b$export$2d41982586bbb6be.notCanCreateProject
                        ],
                        value: false
                    },
                    {
                        condition: [
                            $ea3903bb15047c3b$export$c90b54e658fc4d7c.kanbanOnboarding,
                            $ea3903bb15047c3b$export$e7b0ac011bb776c6.softwareBoard
                        ],
                        value: false
                    }
                ]
            }
        }
    };
});
parcelRegister("ciLFO", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$609e253829546460$export$defe85febe8b728c);
    var $7VHMR;
    const $609e253829546460$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rootTitle: {
            "id": "software-onboarding-quickstart.services.tasks.config.jsw.root-title.no-translate",
            "defaultMessage": "Quickstart"
        },
        premiumPlanTitle: {
            "id": "onboarding-quickstart-core.services.tasks.config.jsw.premium-plan-title",
            "defaultMessage": "Included in your Premium plan"
        },
        standardPlanTitle: {
            "id": "onboarding-quickstart-core.services.tasks.config.jsw.standard-plan-title",
            "defaultMessage": "Your Standard plan"
        },
        reverseTrialRootTitle: {
            "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-root-title",
            "defaultMessage": "Your 30-day Premium trial"
        },
        reverseTrialCardTitle: {
            "id": "onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-card-title",
            "defaultMessage": "Included in your Premium trial"
        }
    });
});
parcelRegister("5yUqp", function(module, exports) {
    $parcel$export(module.exports, "JWM", ()=>$80382801c7786de6$export$3ff26c80cb588e12);
    var $82B5j;
    var $8jC8d;
    var $5PFhq;
    const $80382801c7786de6$export$3ff26c80cb588e12 = {
        taskList: (0, (0, parcelRequire("82B5j")).TASK_LIST),
        taskVariants: (0, (0, parcelRequire("82B5j")).TASK_VARIANTS),
        userRole: (0, (0, parcelRequire("5PFhq")).UserRole),
        experiments: (0, (0, parcelRequire("8jC8d")).Experiments)
    };
});
parcelRegister("82B5j", function(module, exports) {
    $parcel$export(module.exports, "TASK_LIST", ()=>$3b1179694682c8c8$export$601c8c0f45aeb0a0);
    $parcel$export(module.exports, "TASK_VARIANTS", ()=>$3b1179694682c8c8$export$36f4d47dfe11b613);
    var $8Bc5A;
    var $8jC8d;
    var $aQMWP;
    var $5PFhq;
    const $3b1179694682c8c8$export$601c8c0f45aeb0a0 = Object.freeze({
        root: {
            title: (0, (0, parcelRequire("aQMWP")).messages).rootTitle,
            items: [
                (0, (0, parcelRequire("8Bc5A")).JWM_CREATE_PROJECT_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_TRELLO_CROSSFLOW_TASK_IMPORT),
                (0, (0, parcelRequire("8Bc5A")).JWM_SUMMARY_AND_REPORTS_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES),
                (0, (0, parcelRequire("8Bc5A")).JWM_CREATE_SAMPLE_PROJECT_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_PROJECT_SUMMARY_TASK),
                (0, (0, parcelRequire("8Bc5A")).GET_STARTED_LIST_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_CALENDAR_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_TIMELINE_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_BUILD_FORM_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_BACKGROUND_COLOR_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_FEEDBACK_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_FEEDBACK_SAMPLE_PROJECT_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_SHARE_PROJECT_TASK),
                (0, (0, parcelRequire("8Bc5A")).JWM_CREATE_YOUR_OWN_PROJECT_TASK)
            ]
        }
    });
    const $3b1179694682c8c8$export$db06b8e338ba9c65 = {
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_3_LIST)]: {
            position: {
                default: 100
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_3_CALENDAR)]: {
            position: {
                default: 200
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_3_PAGES)]: {
            position: {
                default: 300
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_4_LIST)]: {
            position: {
                default: 400
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_4_CALENDAR)]: {
            position: {
                default: 500
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_4_TIMELINE)]: {
            position: {
                default: 600
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_4_SUMMARY)]: {
            position: {
                default: 700
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_5_LIST)]: {
            position: {
                default: 800
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_5_TIMELINE)]: {
            position: {
                default: 900
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_5_PAGES)]: {
            position: {
                default: 1000
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_7_LIST)]: {
            position: {
                default: 1100
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_7_CALENDAR)]: {
            position: {
                default: 1200
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_2_BOARD)]: {
            position: {
                default: 1300
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_2_FORMS)]: {
            position: {
                default: 1400
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_2_SUMMARY)]: {
            position: {
                default: 1500
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_1_LIST)]: {
            position: {
                default: 1600
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_6_PAGES)]: {
            position: {
                default: 1700
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_0_LIST)]: {
            position: {
                default: 1800
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_0_TIMELINE)]: {
            position: {
                default: 1900
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_0_PAGES)]: {
            position: {
                default: 2000
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_DEFAULT_LIST)]: {
            position: {
                default: 2100
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_DEFAULT_BOARD)]: {
            position: {
                default: 2200
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).OPS_JTBD_DEFAULT_INVITES)]: {
            position: {
                default: 2300
            }
        }
    };
    const $3b1179694682c8c8$export$bda7075f98246874 = {
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_1_LIST)]: {
            position: {
                default: 100
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_1_CALENDAR)]: {
            position: {
                default: 200
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_1_TIMELINE)]: {
            position: {
                default: 300
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_2_CALENDAR)]: {
            position: {
                default: 400
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_2_PAGES)]: {
            position: {
                default: 500
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_3_PAGES)]: {
            position: {
                default: 600
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_3_TIMELINE)]: {
            position: {
                default: 700
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_4_LIST)]: {
            position: {
                default: 800
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_4_SUMMARY)]: {
            position: {
                default: 900
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_4_PAGES)]: {
            position: {
                default: 1000
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_5_TIMELINE)]: {
            position: {
                default: 1100
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_5_SUMMARY)]: {
            position: {
                default: 1200
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_6_FORMS)]: {
            position: {
                default: 1300
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_0_LIST)]: {
            position: {
                default: 1400
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_0_CALENDAR)]: {
            position: {
                default: 1500
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_0_TIMELINE)]: {
            position: {
                default: 1600
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_0_SUMMARY)]: {
            position: {
                default: 1700
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_DEFAULT_LIST)]: {
            position: {
                default: 1800
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_DEFAULT_BOARD)]: {
            position: {
                default: 1900
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_DEFAULT_PROJECT)]: {
            position: {
                default: 2000
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).MKT_JTBD_DEFAULT_INVITES)]: {
            position: {
                default: 2100
            }
        }
    };
    const $3b1179694682c8c8$export$36f4d47dfe11b613 = {
        ...$3b1179694682c8c8$export$db06b8e338ba9c65,
        ...$3b1179694682c8c8$export$bda7075f98246874,
        [(0, (0, parcelRequire("8Bc5A")).JWM_CREATE_PROJECT_TASK)]: {
            position: {
                default: 0
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_TRELLO_CROSSFLOW_TASK_KEY_DIFFERENCES)]: {
            position: {
                default: 15
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isNotSampleProject,
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_CREATE_SAMPLE_PROJECT_TASK)]: {
            position: {
                default: 40
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_PROJECT_SUMMARY_TASK)]: {
            position: {
                default: 50
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).GET_STARTED_LIST_TASK)]: {
            position: {
                default: 100
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: true
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_CALENDAR_TASK)]: {
            position: {
                default: 200
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: true
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_TIMELINE_TASK)]: {
            position: {
                default: 300
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: true
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_BUILD_FORM_TASK)]: {
            position: {
                default: 400
            },
            visibility: {
                default: true
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_TRELLO_CROSSFLOW_CALENDAR_AND_TIMELINE_TASK)]: {
            position: {
                default: 425
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isNotSampleProject,
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_SUMMARY_AND_REPORTS_TASK)]: {
            position: {
                default: 450
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isNotSampleProject,
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_BACKGROUND_COLOR_TASK)]: {
            position: {
                default: 500
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).projectTheming,
                            (0, (0, parcelRequire("5PFhq")).UserRole).jiraAdmin
                        ],
                        value: true
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).projectTheming,
                            (0, (0, parcelRequire("5PFhq")).UserRole).siteAdmin
                        ],
                        value: true
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).projectTheming,
                            (0, (0, parcelRequire("5PFhq")).UserRole).projectAdmin
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_SHARE_PROJECT_TASK)]: {
            position: {
                default: 600
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_TRELLO_CROSSFLOW_TASK_IMPORT)]: {
            position: {
                default: 650
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isNotSampleProject,
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow,
                            (0, (0, parcelRequire("5PFhq")).UserRole).siteAdmin
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_FEEDBACK_TASK)]: {
            position: {
                default: 700
            },
            visibility: {
                default: true,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: false
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).trelloCrossflow
                        ],
                        value: false
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_FEEDBACK_SAMPLE_PROJECT_TASK)]: {
            position: {
                default: 700
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject
                        ],
                        value: true
                    }
                ]
            }
        },
        [(0, (0, parcelRequire("8Bc5A")).JWM_CREATE_YOUR_OWN_PROJECT_TASK)]: {
            position: {
                default: 800
            },
            visibility: {
                default: false,
                conditional: [
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject,
                            (0, (0, parcelRequire("5PFhq")).UserRole).jiraAdmin
                        ],
                        value: true
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject,
                            (0, (0, parcelRequire("5PFhq")).UserRole).siteAdmin
                        ],
                        value: true
                    },
                    {
                        condition: [
                            (0, (0, parcelRequire("8jC8d")).Experiments).isSampleProject,
                            (0, (0, parcelRequire("5PFhq")).UserRole).projectAdmin
                        ],
                        value: true
                    }
                ]
            }
        }
    };
});
parcelRegister("8jC8d", function(module, exports) {
    $parcel$export(module.exports, "Experiments", ()=>$6cd173da51fb2ca8$export$c8d6ffd15214553a);
    const $6cd173da51fb2ca8$export$c8d6ffd15214553a = {
        projectTheming: 'projectTheming',
        isSampleProject: 'isSampleProject',
        isNotSampleProject: 'isNotSampleProject',
        trelloCrossflow: 'trelloCrossflow'
    };
});
parcelRegister("aQMWP", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$40755a70921f89dd$export$defe85febe8b728c);
    var $7VHMR;
    const $40755a70921f89dd$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rootTitle: {
            "id": "software-onboarding-quickstart.services.tasks.config.jwm.root-title.no-translate",
            "defaultMessage": "Quickstart"
        }
    });
});
parcelRegister("5PFhq", function(module, exports) {
    $parcel$export(module.exports, "UserRole", ()=>$637dacd99a3a1727$export$eb3485a690c2f0b8);
    const $637dacd99a3a1727$export$eb3485a690c2f0b8 = {
        projectAdmin: 'projectAdmin',
        jiraAdmin: 'jiraAdmin',
        siteAdmin: 'siteAdmin'
    };
});
parcelRegister("5zzQl", function(module, exports) {
    $parcel$export(module.exports, "getTasks", ()=>$f17c108f7b3045ad$export$20b82b4a32771893);
    var $fNtu3;
    const $f17c108f7b3045ad$var$getTaskVisibility = (variants, visibility)=>visibility !== undefined ? (0, (0, parcelRequire("fNtu3")).getConditional)(visibility, variants) : true;
    const $f17c108f7b3045ad$var$getTaskPosition = (variants, position)=>(0, (0, parcelRequire("fNtu3")).getConditional)(position, variants);
    const $f17c108f7b3045ad$export$20b82b4a32771893 = (variants, taskVariants, taskList)=>taskList.filter((task)=>$f17c108f7b3045ad$var$getTaskVisibility(variants, taskVariants[task].visibility)).sort((taskA, taskB)=>$f17c108f7b3045ad$var$getTaskPosition(variants, taskVariants[taskA].position) - $f17c108f7b3045ad$var$getTaskPosition(variants, taskVariants[taskB].position));
});
parcelRegister("fNtu3", function(module, exports) {
    $parcel$export(module.exports, "getConditional", ()=>$8978a3b25f57d9ac$export$fe3161cde0106bba);
    const $8978a3b25f57d9ac$export$fe3161cde0106bba = ({ conditional: conditions, default: defaultValue }, variants)=>{
        if (conditions === undefined) return defaultValue;
        const variantsIncludesCondition = (c)=>variants.includes(c);
        const conditionObj = conditions.find(({ condition: condition })=>condition.every(variantsIncludesCondition));
        return conditionObj ? conditionObj.value : defaultValue;
    };
});
parcelRegister("jJca1", function(module, exports) {
    $parcel$export(module.exports, "isJwmProject", ()=>$6249819f9bc2846f$export$ea2e5a5c1a1a6748);
    $parcel$export(module.exports, "isJsmProject", ()=>$6249819f9bc2846f$export$a972ed853ed1d469);
    var $2vSU6;
    const $6249819f9bc2846f$export$ea2e5a5c1a1a6748 = (projectState)=>projectState?.projectType === (0, (0, parcelRequire("2vSU6")).CORE_PROJECT);
    const $6249819f9bc2846f$export$a972ed853ed1d469 = (projectState)=>projectState?.projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT);
});
parcelRegister("75A1x", function(module, exports) {
    $parcel$export(module.exports, "syncVisibilityWithLocal", ()=>$f9427b1514e1931c$export$4aab9a98fc53b894);
    var $3B5jO;
    var $4ji4w;
    const $f9427b1514e1931c$export$4aab9a98fc53b894 = ()=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const quickstartType = (0, (0, parcelRequire("3B5jO")).getQuickstartTypeSelector)(state);
            const visibilityLocal = (0, (0, parcelRequire("4ji4w")).getLocalStorageItem)(`${quickstartType}.visibility`);
            if (visibilityLocal === state.visibility[quickstartType]) return;
            setState({
                visibility: {
                    ...state.visibility,
                    [quickstartType]: visibilityLocal
                }
            });
        };
});
parcelRegister("cGE52", function(module, exports) {
    $parcel$export(module.exports, "initialState", ()=>$d175a7a443e10f6d$export$d4c72bab9d6cc13a);
    var $8Bc5A;
    const $d175a7a443e10f6d$export$d4c72bab9d6cc13a = {
        shouldRenderComponent: false,
        completedTaskList: [],
        hasSeenTasks: [],
        isDismissed: true,
        isOpen: false,
        isFocusedOn: false,
        openTask: '',
        projectState: null,
        hasNudgeActive: false,
        isQuickstartLoaded: false,
        isDevOpsProject: false,
        nudgeStep: '',
        mountedNudges: [],
        hasEverSeenRoute: {
            'jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap': false
        },
        roadmapIsCreateEnabled: false,
        roadmapIsListEmpty: true,
        previousTaskGroupParents: [],
        currentTaskGroupParent: (0, (0, parcelRequire("8Bc5A")).ROOT_TASK),
        selectedProjectTemplateKeyFromOnboarding: undefined,
        isEligibleToUpdateSitename: false,
        isCrossProjectBoardToPlanUpsell: false,
        canEditPlans: false,
        visibility: {
            [(0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE).JSM_BUSINESS_QUICKSTART_KEY]: (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).NOT_LOADED,
            [(0, (0, parcelRequire("8Bc5A")).QUICKSTART_TYPE).OLD_GLOBAL_QUICKSTART_KEY]: (0, (0, parcelRequire("8Bc5A")).QUICKSTART_UI_STATUS).NOT_LOADED
        }
    };
});
parcelRegister("6tzEU", function(module, exports) {
    $parcel$export(module.exports, "useSidebarData", ()=>$530d739908e5dec3$export$f9257874e114985c);
    var $5uXOq = parcelRequire("5uXOq");
    var $gccSB = parcelRequire("gccSB");
    var $hecDf;
    var $4041n;
    var $iNzEe;
    var $4fCE7;
    const $530d739908e5dec3$export$f9257874e114985c = ()=>{
        const { project: currentProject } = (0, (0, parcelRequire("hecDf")).useNavigationProject)();
        const { data: data, update: update, refresh: refresh, loading: loading } = (0, (0, parcelRequire("iNzEe")).useNavigationResource)();
        const { changeFavorite: changeFavorite, items: { projects: changedItems } } = (0, (0, parcelRequire("4041n")).useChangeFavorite)();
        const isRefreshingFavorites = (0, $5uXOq.useRef)(false);
        const hasRefreshedOnce = (0, $5uXOq.useRef)(false);
        const onFavoriteToggle = (0, $5uXOq.useCallback)((project)=>{
            changeFavorite({
                id: String(project.id),
                type: 'projects',
                value: !project.isFavorite
            });
        }, [
            changeFavorite
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, ($parcel$interopDefault($gccSB)))(changedItems) && !Object.values(changedItems).some(({ pending: pending })=>pending)) {
                isRefreshingFavorites.current = true;
                refresh();
            }
        }, [
            changedItems,
            refresh
        ]);
        (0, $5uXOq.useEffect)(()=>{
            isRefreshingFavorites.current = false;
        }, [
            data
        ]);
        let recents;
        let favorites;
        let hasMoreFavorite;
        let overviews;
        let overviewsError;
        let isPremiumUserSeat;
        let showPlansOnboarding;
        let shouldHideOverviews;
        if (data == null || data === (0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71)) {
            if (data === (0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71) && !hasRefreshedOnce.current) {
                hasRefreshedOnce.current = true;
                refresh();
            }
            recents = [];
            favorites = [];
            hasMoreFavorite = false;
            overviews = [];
            overviewsError = null;
            isPremiumUserSeat = false;
            showPlansOnboarding = false;
            shouldHideOverviews = false;
        } else {
            recents = data.recents;
            favorites = data.favorites;
            hasMoreFavorite = data.hasMoreFavorite;
            overviews = data.overviews;
            overviewsError = data.overviewsError;
            isPremiumUserSeat = data.isPremiumUserSeat;
            showPlansOnboarding = data.showPlansOnboarding;
            shouldHideOverviews = data.shouldHideOverviews;
        }
        if (currentProject != null && !recents.some((project)=>project.id === currentProject.id) && !favorites.some((project)=>project.id === currentProject.id)) {
            recents = (0, (0, parcelRequire("4fCE7")).prependProject)(currentProject, recents);
            const newRecents = recents;
            update(()=>({
                    recents: newRecents,
                    favorites: favorites,
                    hasMoreFavorite: hasMoreFavorite,
                    overviews: overviews,
                    overviewsError: overviewsError,
                    isPremiumUserSeat: isPremiumUserSeat,
                    showPlansOnboarding: showPlansOnboarding,
                    shouldHideOverviews: shouldHideOverviews
                }));
        }
        if (!(0, ($parcel$interopDefault($gccSB)))(changedItems)) {
            recents = recents.map((project)=>(0, (0, parcelRequire("4fCE7")).mapProjectChanges)(project, changedItems));
            favorites = favorites.map((project)=>(0, (0, parcelRequire("4fCE7")).mapProjectChanges)(project, changedItems));
        }
        return {
            currentProject: currentProject,
            recents: recents,
            favorites: favorites,
            hasMoreFavorite: hasMoreFavorite,
            onFavoriteToggle: onFavoriteToggle,
            overviews: overviews,
            overviewsError: overviewsError,
            shouldHideOverviews: shouldHideOverviews,
            loading: loading && !isRefreshingFavorites.current
        };
    };
});
parcelRegister("hecDf", function(module, exports) {
    $parcel$export(module.exports, "useNavigationProject", ()=>$46378552d09cbbed$export$befd5d7ebc77f264);
    var $iNzEe;
    var $l2N2a;
    var $dIdda = parcelRequire("dIdda");
    const $46378552d09cbbed$export$befd5d7ebc77f264 = ()=>{
        const { data: currentProject, loading: currentProjectLoading } = (0, (0, parcelRequire("l2N2a")).useProject)();
        const { data: navigationData, loading: navigationDataLoading } = (0, (0, parcelRequire("iNzEe")).useNavigationResource)();
        const [{ match: { params: { projectKey: projectKey } } }] = (0, $dIdda.useRouter)();
        if (currentProject != null) return {
            project: currentProject,
            loading: currentProjectLoading
        };
        if (projectKey != null && navigationData != null && navigationData !== (0, $4ee2cfa1c76e72ed$export$e8958a6508ec5b71)) {
            const project = navigationData.favorites.find((proj)=>proj.key === projectKey) ?? navigationData.recents.find((proj)=>proj.key === projectKey) ?? null;
            return {
                project: project,
                loading: navigationDataLoading
            };
        }
        return {
            project: null,
            loading: currentProjectLoading || navigationDataLoading
        };
    };
});
const $4ee2cfa1c76e72ed$export$3349219a88ac77cd = 10;
const $4ee2cfa1c76e72ed$export$e8958a6508ec5b71 = 'NOT_APPLICABLE';
parcelRegister("4041n", function(module, exports) {
    $parcel$export(module.exports, "FavoriteChangeContext", ()=>$e574e5c3227b76f4$export$a5d258b9665ce94b);
    $parcel$export(module.exports, "FavoriteChangeProvider", ()=>$e574e5c3227b76f4$export$b06b5ce59fd5e408);
    $parcel$export(module.exports, "FavoriteChangeConsumer", ()=>$e574e5c3227b76f4$export$f227cdfbb355444a);
    $parcel$export(module.exports, "useChangeFavorite", ()=>$e574e5c3227b76f4$export$cfa169f3278459e8);
    var $kZupY;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $8Uumt = parcelRequire("8Uumt");
    var $eiowN = parcelRequire("eiowN");
    var $jcw0u;
    var $dXq4S;
    var $8zOmE;
    var $koeKL;
    var $e73oS;
    var $j6ttF;
    var $7lK06;
    var $eXQym;
    var $5c9oS;
    var $7SIuT;
    const $e574e5c3227b76f4$export$4fe337ef5f0ceb74 = (item)=>(state)=>({
                ...state,
                [item.type]: {
                    ...state[item.type],
                    [item.id]: item
                }
            });
    const $e574e5c3227b76f4$export$72b8c6d38aa6195b = (item)=>(state)=>({
                ...state,
                items: {
                    ...state.items,
                    [item.type]: {
                        ...state.items[item.type],
                        [item.id]: item
                    }
                }
            });
    const $e574e5c3227b76f4$export$b212ddc707077772 = {
        items: {
            boards: {},
            filters: {},
            issues: {},
            dashboards: {},
            projects: {},
            queues: {},
            plans: {}
        },
        changeFavorite: ()=>new Promise((0, ($parcel$interopDefault($8Rkzz)))),
        changeFavoriteMutation: (0, ($parcel$interopDefault($8Rkzz))),
        emitChangedFavorite: (0, ($parcel$interopDefault($8Rkzz))),
        emitChangedFavoriteMutation: (0, ($parcel$interopDefault($8Rkzz))),
        updateFavoriteState: (0, ($parcel$interopDefault($8Rkzz)))
    };
    const $e574e5c3227b76f4$export$a5d258b9665ce94b = (0, $5uXOq.createContext)($e574e5c3227b76f4$export$b212ddc707077772);
    const $e574e5c3227b76f4$var$useRelayFavoriteUpdate = ()=>{
        const environment = (0, $8Uumt.useRelayEnvironment)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const commitUpdate = (0, $5uXOq.useCallback)(({ id: id, type: type, value: value })=>{
            if (type === (0, (0, parcelRequire("eXQym")).PROJECTS_ITEM_TYPE)) (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
                const ari = (0, (0, parcelRequire("dXq4S")).createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'project',
                    resourceId: id,
                    cloudId: cloudId
                });
                const projectRecordId = (0, (0, parcelRequire("e73oS")).default)({
                    id: ari
                }, 'JiraProject');
                if (projectRecordId) {
                    const projectRecord = store.get(projectRecordId);
                    const favoriteRecord = projectRecord?.getLinkedRecord('favouriteValue');
                    favoriteRecord?.setValue(value, 'isFavourite');
                }
            });
        }, [
            cloudId,
            environment
        ]);
        return {
            commitUpdate: commitUpdate
        };
    };
    const $e574e5c3227b76f4$export$b06b5ce59fd5e408 = ({ onShowFlag: onShowFlag, children: children })=>{
        const { commitUpdate: commitUpdate } = $e574e5c3227b76f4$var$useRelayFavoriteUpdate();
        const [items, setItems] = (0, $5uXOq.useState)({
            boards: {},
            filters: {},
            dashboards: {},
            issues: {},
            projects: {},
            queues: {},
            plans: {}
        });
        const onChangeStart = (0, $5uXOq.useCallback)((item)=>{
            setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
                ...item,
                pending: true
            }));
        }, []);
        const onChangeSuccess = (0, $5uXOq.useCallback)((item, analyticsEvent)=>{
            setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
                ...item,
                pending: false
            }));
            if (analyticsEvent) (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `${item.type.slice(0, item.type.length - 1)} ${item.value ? 'starred' : 'unstarred'}`, `${item.id}`);
        }, []);
        const onChangeFail = (0, $5uXOq.useCallback)((item, analyticsId, error)=>{
            setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
                ...item,
                value: !item.value,
                pending: false
            }));
            if (onShowFlag) onShowFlag((0, (0, parcelRequire("7SIuT")).errorFlag)());
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: analyticsId,
                    packageName: 'jiraFavouriteChangeProvider',
                    teamName: 'empanada'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }, [
            onShowFlag
        ]);
        const changeFavorite = (0, $5uXOq.useCallback)(async (item, analyticsEvent)=>{
            const performChange = async ()=>{
                onChangeStart(item);
                try {
                    commitUpdate({
                        type: item.type,
                        id: item.id,
                        value: item.value
                    });
                    await (0, (0, parcelRequire("5c9oS")).default)(item);
                    const typename = (0, (0, parcelRequire("j6ttF")).favoriteTypeToTypename)(item.type, item.id);
                    if (typename) (0, (0, parcelRequire("7lK06")).publishFavorite)(typename, {
                        type: 'REST',
                        entityId: item.id,
                        isFavourite: item.value
                    });
                    onChangeSuccess(item, analyticsEvent);
                } catch (error) {
                    commitUpdate({
                        type: item.type,
                        id: item.id,
                        value: !item.value
                    });
                    onChangeFail(item, 'changeFavourite', error instanceof Error ? error : undefined);
                }
            };
            return performChange();
        }, [
            commitUpdate,
            onChangeStart,
            onChangeSuccess,
            onChangeFail
        ]);
        const [commitMutation] = (0, $8Uumt.useMutation)((0, (0, parcelRequire("kZupY")).default));
        const changeFavoriteMutation = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
            const dataId = (0, (0, parcelRequire("e73oS")).default)({
                id: payload.id
            }, payload.typename);
            const restItem = (0, (0, parcelRequire("j6ttF")).favoriteMutationToRestPayload)(payload);
            const onUpdate = (store, isOptimistic)=>{
                if (!dataId) return;
                (0, (0, parcelRequire("7lK06")).publishFavorite)(payload.typename, {
                    type: 'MUTATION',
                    store: store,
                    dataId: dataId,
                    entityId: payload.id,
                    isFavourite: payload.value,
                    isOptimistic: isOptimistic
                });
                const record = store.get(dataId);
                if (record) {
                    if (typeof record.getValue('isFavourite') === 'boolean') record.setValue(payload.value, 'isFavourite');
                    if (isOptimistic) {
                        const favoriteRecord = record.getLinkedRecord('favouriteValue');
                        favoriteRecord?.setValue(payload.value, 'isFavourite');
                    }
                }
            };
            onChangeStart(restItem);
            commitMutation({
                variables: {
                    input: {
                        entityId: payload.id,
                        isFavourite: payload.value,
                        beforeEntityId: payload.beforeEntity?.id ?? null
                    }
                },
                optimisticUpdater: (store)=>{
                    onUpdate(store, true);
                },
                updater: (store, response)=>{
                    if (response?.jira?.setEntityIsFavourite?.success) onUpdate(store, false);
                },
                onCompleted: (response)=>{
                    if (response?.jira?.setEntityIsFavourite?.success) onChangeSuccess(restItem, analyticsEvent);
                    else onChangeFail(restItem, 'changeFavoriteMutation');
                },
                onError: (error)=>onChangeFail(restItem, 'changeFavouriteMutation', error)
            });
        }, [
            commitMutation,
            onChangeStart,
            onChangeSuccess,
            onChangeFail
        ]);
        const updateFavoriteState = (0, $5uXOq.useCallback)((item)=>{
            setItems($e574e5c3227b76f4$export$4fe337ef5f0ceb74({
                ...item,
                pending: false
            }));
        }, []);
        const emitChangedFavorite = (0, $5uXOq.useCallback)((payload, analyticsEvent)=>{
            onChangeSuccess(payload, analyticsEvent);
            const typeName = (0, (0, parcelRequire("j6ttF")).favoriteTypeToTypename)(payload.type, payload.id);
            if (typeName) (0, (0, parcelRequire("7lK06")).publishFavorite)(typeName, {
                type: 'REST',
                entityId: payload.id,
                isFavourite: payload.value
            });
        }, [
            onChangeSuccess
        ]);
        const emitChangedFavoriteMutation = (0, $5uXOq.useCallback)((payload, store, analyticsEvent)=>{
            const dataId = (0, (0, parcelRequire("e73oS")).default)({
                id: payload.id
            }, payload.typename) ?? '';
            const restItem = (0, (0, parcelRequire("j6ttF")).favoriteMutationToRestPayload)(payload);
            onChangeSuccess(restItem, analyticsEvent);
            (0, (0, parcelRequire("7lK06")).publishFavorite)(payload.typename, {
                type: 'MUTATION',
                store: store,
                dataId: dataId,
                entityId: payload.id,
                isFavourite: payload.value,
                isOptimistic: false
            });
        }, [
            onChangeSuccess
        ]);
        const providerValue = (0, $5uXOq.useMemo)(()=>({
                items: items,
                changeFavorite: changeFavorite,
                changeFavoriteMutation: changeFavoriteMutation,
                emitChangedFavorite: emitChangedFavorite,
                emitChangedFavoriteMutation: emitChangedFavoriteMutation,
                updateFavoriteState: updateFavoriteState
            }), [
            items,
            changeFavorite,
            changeFavoriteMutation,
            emitChangedFavorite,
            emitChangedFavoriteMutation,
            updateFavoriteState
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$a5d258b9665ce94b.Provider, {
            value: providerValue
        }, children);
    };
    const $e574e5c3227b76f4$export$f227cdfbb355444a = $e574e5c3227b76f4$export$a5d258b9665ce94b.Consumer;
    const $e574e5c3227b76f4$export$61944ffe37754ff2 = (WrappedComponent)=>{
        const WithFavoriteChangeConsumer = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($e574e5c3227b76f4$export$f227cdfbb355444a, null, (favoriteChangeContext)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...props,
                    favoriteChangeContext: favoriteChangeContext
                }));
        const wrappedDisplayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        WithFavoriteChangeConsumer.displayName = `WithFavoriteChangeConsumer(${wrappedDisplayName})`;
        return WithFavoriteChangeConsumer;
    };
    const $e574e5c3227b76f4$export$cfa169f3278459e8 = ()=>(0, $5uXOq.useContext)($e574e5c3227b76f4$export$a5d258b9665ce94b);
});
parcelRegister("kZupY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d64781493fbfe6b0$export$2e2bcd8739ae039);
    const $d64781493fbfe6b0$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "input"
            }
        ], v1 = [
            {
                "concreteType": "JiraMutation",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "input",
                                "variableName": "input"
                            }
                        ],
                        "concreteType": "JiraSetIsFavouritePayload",
                        "kind": "LinkedField",
                        "name": "setEntityIsFavourite",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "success"
                            },
                            {
                                "concreteType": "JiraFavouriteValue",
                                "kind": "LinkedField",
                                "name": "favouriteValue",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "isFavourite"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "viewSetFavouriteMutation",
                "selections": v1,
                "type": "Mutation"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "viewSetFavouriteMutation",
                "selections": v1
            },
            "params": {
                "id": "55cc4316f34f570b5daad61eb737e9475face6fd2ceb7b85de1040658ff30d9f",
                "metadata": {},
                "name": "viewSetFavouriteMutation",
                "operationKind": "mutation",
                "text": null
            }
        };
    }();
    $d64781493fbfe6b0$var$node.hash = "af74e48c451986374e11a5b801d5009f";
    var $d64781493fbfe6b0$export$2e2bcd8739ae039 = $d64781493fbfe6b0$var$node;
});
parcelRegister("j6ttF", function(module, exports) {
    $parcel$export(module.exports, "favoriteTypeToTypename", ()=>$b9c3378eb0d73712$export$b98f76d96728a853);
    $parcel$export(module.exports, "favoriteMutationToRestPayload", ()=>$b9c3378eb0d73712$export$717886a1047f1287);
    var $1zWF7;
    var $k24Fu;
    var $7sE1A;
    var $axGKd;
    var $fByX6;
    var $ljMDN;
    function $b9c3378eb0d73712$var$assertUnreachable(_) {
        throw new Error('Unexpected entity type');
    }
    const $b9c3378eb0d73712$var$isSystemFilter = (filterId)=>/^-\d+$/.test(filterId);
    const $b9c3378eb0d73712$export$b98f76d96728a853 = (type, resourceId)=>{
        switch(type){
            case 'projects':
                return 'JiraProject';
            case 'filters':
                return $b9c3378eb0d73712$var$isSystemFilter(resourceId) ? 'JiraSystemFilter' : 'JiraCustomFilter';
            case 'dashboards':
                return 'JiraDashboard';
            case 'plans':
                return 'JiraPlan';
            case 'boards':
                return 'JiraBoard';
            case 'queues':
                return 'JiraServiceManagementQueue';
            default:
                return undefined;
        }
    };
    const $b9c3378eb0d73712$var$favoriteAriToId = (typename, ari)=>{
        switch(typename){
            case 'JiraProject':
                return (0, (0, parcelRequire("ljMDN")).JiraProjectAri).parse(ari).projectId;
            case 'JiraCustomFilter':
            case 'JiraSystemFilter':
                return (0, (0, parcelRequire("axGKd")).JiraFilterAri).parse(ari).filterId;
            case 'JiraDashboard':
                return (0, (0, parcelRequire("7sE1A")).JiraDashboardAri).parse(ari).dashboardId;
            case 'JiraPlan':
                return (0, (0, parcelRequire("fByX6")).JiraPlanAri).parse(ari).planId;
            case 'JiraBoard':
                return (0, (0, parcelRequire("k24Fu")).JiraSoftwareBoardAri).parse(ari).boardId;
            case 'JiraServiceManagementQueue':
                return (0, (0, parcelRequire("1zWF7")).JiraServicedeskQueueAri).parse(ari).queueId;
            default:
                $b9c3378eb0d73712$var$assertUnreachable(typename);
        }
    };
    const $b9c3378eb0d73712$var$favoriteTypenameToType = (typename)=>{
        switch(typename){
            case 'JiraProject':
                return 'projects';
            case 'JiraCustomFilter':
            case 'JiraSystemFilter':
                return 'filters';
            case 'JiraDashboard':
                return 'dashboards';
            case 'JiraPlan':
                return 'plans';
            case 'JiraBoard':
                return 'boards';
            case 'JiraServiceManagementQueue':
                return 'queues';
            default:
                $b9c3378eb0d73712$var$assertUnreachable(typename);
        }
    };
    const $b9c3378eb0d73712$export$717886a1047f1287 = ({ id: id, typename: typename, value: value, beforeEntity: beforeEntity })=>({
            id: $b9c3378eb0d73712$var$favoriteAriToId(typename, id),
            type: $b9c3378eb0d73712$var$favoriteTypenameToType(typename),
            value: value,
            beforeEntity: beforeEntity ? {
                id: $b9c3378eb0d73712$var$favoriteAriToId(beforeEntity.typename, beforeEntity.id),
                type: $b9c3378eb0d73712$var$favoriteTypenameToType(beforeEntity.typename)
            } : undefined
        });
});
parcelRegister("7lK06", function(module, exports) {
    $parcel$export(module.exports, "publishFavorite", ()=>$703ce7b9c2eadfdd$export$229a24253fb568e1);
    $parcel$export(module.exports, "useSubscribeToFavorite", ()=>$703ce7b9c2eadfdd$export$eb04bf805f6b8fb2);
    var $5uXOq = parcelRequire("5uXOq");
    class $703ce7b9c2eadfdd$var$FavoritePubSub {
        constructor(){
            this.subscribers = {};
            this.subscribe = (typename, subscriber)=>{
                this.subscribers[typename] = [
                    ...this.subscribers[typename] ?? [],
                    subscriber
                ];
                return ()=>{
                    this.subscribers[typename] = this.subscribers[typename]?.filter((sub)=>sub !== subscriber) ?? [];
                };
            };
            this.publish = (typename, payload)=>{
                this.subscribers[typename]?.forEach((subscriber)=>subscriber(payload));
            };
        }
    }
    const $703ce7b9c2eadfdd$var$favoritePubSub = new $703ce7b9c2eadfdd$var$FavoritePubSub();
    const $703ce7b9c2eadfdd$export$229a24253fb568e1 = $703ce7b9c2eadfdd$var$favoritePubSub.publish;
    const $703ce7b9c2eadfdd$export$eb04bf805f6b8fb2 = (typename, subscriber)=>{
        (0, $5uXOq.useEffect)(()=>{
            const typenames = Array.isArray(typename) ? typename : [
                typename
            ];
            const unsubscribes = typenames.map((val)=>$703ce7b9c2eadfdd$var$favoritePubSub.subscribe(val, subscriber));
            return ()=>unsubscribes.forEach((unsubscribe)=>unsubscribe());
        }, [
            typename,
            subscriber
        ]);
    };
});
parcelRegister("eXQym", function(module, exports) {
    $parcel$export(module.exports, "BOARDS_ITEM_TYPE", ()=>$6c76a5a290814989$export$aade82542e73ffc8);
    $parcel$export(module.exports, "FILTERS_ITEM_TYPE", ()=>$6c76a5a290814989$export$a448ebfa10cebc74);
    $parcel$export(module.exports, "DASHBOARDS_ITEM_TYPE", ()=>$6c76a5a290814989$export$f8099f229527572c);
    $parcel$export(module.exports, "ISSUES_ITEM_TYPE", ()=>$6c76a5a290814989$export$8e58083dcbb878d);
    $parcel$export(module.exports, "PLANS_ITEM_TYPE", ()=>$6c76a5a290814989$export$2fd44a6cb58b66cb);
    $parcel$export(module.exports, "PROJECTS_ITEM_TYPE", ()=>$6c76a5a290814989$export$8e2cd98172988d7e);
    $parcel$export(module.exports, "QUEUES_ITEM_TYPE", ()=>$6c76a5a290814989$export$6b0c8e47d2c7f1d9);
    $parcel$export(module.exports, "VALID_ITEM_TYPES", ()=>$6c76a5a290814989$export$9c8cfad65800ddfb);
    $parcel$export(module.exports, "VALID_ITEM_TYPENAMES", ()=>$6c76a5a290814989$export$2d63a9c2e78633c8);
    const $6c76a5a290814989$export$aade82542e73ffc8 = 'boards';
    const $6c76a5a290814989$export$a448ebfa10cebc74 = 'filters';
    const $6c76a5a290814989$export$f8099f229527572c = 'dashboards';
    const $6c76a5a290814989$export$8e58083dcbb878d = 'issues';
    const $6c76a5a290814989$export$2fd44a6cb58b66cb = 'plans';
    const $6c76a5a290814989$export$8e2cd98172988d7e = 'projects';
    const $6c76a5a290814989$export$6b0c8e47d2c7f1d9 = 'queues';
    const $6c76a5a290814989$export$9c8cfad65800ddfb = [
        $6c76a5a290814989$export$aade82542e73ffc8,
        $6c76a5a290814989$export$f8099f229527572c,
        $6c76a5a290814989$export$a448ebfa10cebc74,
        $6c76a5a290814989$export$8e58083dcbb878d,
        $6c76a5a290814989$export$2fd44a6cb58b66cb,
        $6c76a5a290814989$export$8e2cd98172988d7e,
        $6c76a5a290814989$export$6b0c8e47d2c7f1d9
    ];
    const $6c76a5a290814989$export$2d63a9c2e78633c8 = [
        'JiraProject',
        'JiraCustomFilter',
        'JiraSystemFilter',
        'JiraDashboard',
        'JiraPlan',
        'JiraBoard',
        'JiraServiceManagementQueue'
    ];
});
parcelRegister("5c9oS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f9559749111f2eca$export$2e2bcd8739ae039);
    var $7eYK2;
    var $f9559749111f2eca$export$2e2bcd8739ae039 = async (request)=>(0, (0, parcelRequire("7eYK2")).updateFavorite)(request);
});
parcelRegister("7eYK2", function(module, exports) {
    $parcel$export(module.exports, "updateFavorite", ()=>$16085bb5bdb7219b$export$8c2f00130cc945dc);
    var $eusud;
    const $16085bb5bdb7219b$export$8c2f00130cc945dc = async (request)=>{
        if (request.value) return (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/internal/2/favourites', {
            body: JSON.stringify({
                entity: {
                    id: request.id,
                    type: request.type
                },
                beforeEntityPosition: request.beforeEntity || null
            })
        });
        return (0, (0, parcelRequire("eusud")).performDeleteRequest)(`/rest/internal/2/favourites/${request.type}/${request.id}`);
    };
});
parcelRegister("7SIuT", function(module, exports) {
    $parcel$export(module.exports, "errorFlag", ()=>$7252fdcfc0e15292$export$b9a7f1ebeaa76953);
    var $0YlRJ;
    const $7252fdcfc0e15292$export$b9a7f1ebeaa76953 = ()=>({
            type: 'error',
            ...(0, (0, parcelRequire("0YlRJ")).default)
        });
});
parcelRegister("0YlRJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87ad72b3da53041c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $87ad72b3da53041c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.title",
            "defaultMessage": "Something\u2019s gone wrong"
        },
        description: {
            "id": "platform.ui.favouriting.favourite-change-provider.flags.failure.description",
            "defaultMessage": "You cannot star items right now due to an error."
        }
    });
});
parcelRegister("4fCE7", function(module, exports) {
    $parcel$export(module.exports, "prependProject", ()=>$5da6154530b9fc4e$export$9e33a1a4f95ad56f);
    $parcel$export(module.exports, "mapProjectChanges", ()=>$5da6154530b9fc4e$export$6cb16ed8ac180dfc);
    const $5da6154530b9fc4e$export$9e33a1a4f95ad56f = (project, projects)=>[
            project,
            ...projects
        ].slice(0, (0, $4ee2cfa1c76e72ed$export$3349219a88ac77cd));
    const $5da6154530b9fc4e$export$6cb16ed8ac180dfc = (project, changedItems)=>project.id in changedItems ? {
            ...project,
            isFavorite: changedItems[project.id].value
        } : project;
});
parcelRegister("aueMW", function(module, exports) {
    $parcel$export(module.exports, "CreateProjectCta", ()=>$a1b8ae763ebf57fa$export$f49a4235d24dbad0);
    var $5uXOq = parcelRequire("5uXOq");
    var $4RjZC;
    var $7XluA;
    var $4mO32;
    const $a1b8ae763ebf57fa$var$runtimeProps = {};
    const $a1b8ae763ebf57fa$var$entryPointParams = {};
    const $a1b8ae763ebf57fa$export$f49a4235d24dbad0 = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("4RjZC")).createProjectCtaEntryPoint), $a1b8ae763ebf57fa$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "jira-business-create-project-cta-entrypoint",
            packageName: "@atlassian/jira-business-create-project-cta",
            teamName: "jira-werewolves",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: $a1b8ae763ebf57fa$var$runtimeProps,
            errorFallback: "unmount"
        });
    };
});
parcelRegister("4RjZC", function(module, exports) {
    $parcel$export(module.exports, "createProjectCtaEntryPoint", ()=>$877fbe84ca72e3fe$export$7dadecc7d161da03);
    var $2Ftxm;
    var $ikgNX;
    const $877fbe84ca72e3fe$export$7dadecc7d161da03 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("lEuJq")), {
            moduleId: "0c73c6d1"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("lEuJq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hlxM5")
    ]).then(()=>parcelRequire('3u5Rs'));
});
parcelRegister("iZNik", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$17c51fb57bea1a65$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $89thI;
    var $9ORsp;
    var $1m92z;
    var $jPxJ7;
    var $koVbs;
    var $g8I5C;
    var $ajOhG;
    var $Fmgai;
    const $17c51fb57bea1a65$var$FEEDBACK_GROUP_ID = 'jbus-feedback';
    const $17c51fb57bea1a65$var$FeedbackButton = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const openFeedbackModal = (0, (0, parcelRequire("jPxJ7")).useFeedbackCollector)();
        const buttonRef = (0, $5uXOq.useRef)(null);
        const renderNudgeWrapper = (0, $5uXOq.useCallback)((children)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ajOhG")).FeedbackNudgeAsync), null, children), []);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            openFeedbackModal($17c51fb57bea1a65$var$FEEDBACK_GROUP_ID, (0, ($parcel$interopDefault($8Rkzz))), buttonRef);
        }, [
            openFeedbackModal
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g8I5C")).QuickstartNudge), {
            renderWrapper: renderNudgeWrapper
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("89thI")).default), {
            ref: buttonRef,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9ORsp"))))), {
                label: "",
                size: "small"
            }),
            appearance: "subtle-link",
            onClick: onClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1m92z")).default), {
            as: "span",
            size: "UNSAFE_small",
            weight: "medium",
            color: "color.text.subtle"
        }, formatMessage((0, (0, parcelRequire("Fmgai")).default).feedback))));
    };
    var $17c51fb57bea1a65$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($17c51fb57bea1a65$var$FeedbackButton);
});
parcelRegister("9ORsp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7262400a4f2e21fe$var$_react = $7262400a4f2e21fe$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $kfAhl;
    var $7262400a4f2e21fe$var$_feedback = $7262400a4f2e21fe$var$_interopRequireDefault((parcelRequire("3NWt2")));
    function $7262400a4f2e21fe$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7262400a4f2e21fe$var$EditorFeedbackIcon = (props)=>$7262400a4f2e21fe$var$_react.default.createElement((0, parcelRequire("kfAhl")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M10.922 14.517 5.87 12.68l-.932-.339C4.418 12.151 4 11.552 4 11c0-.556.42-1.153.938-1.341l9.124-3.318c.52-.19.938.105.938.654v8.01c0 .54-.42.842-.938.654zM6 14.227l2 .728V17c0 .552-.405 1.202-.895 1.447l-.21.106C6.4 18.8 6 18.549 6 18.009zm11.224-4.78a.5.5 0 1 1-.448-.894l2-1a.5.5 0 1 1 .448.894zm-.448 4a.5.5 0 0 1 .448-.894l2 1a.5.5 0 0 1-.448.894zM17 11.5a.5.5 0 1 1 0-1h3a.5.5 0 1 1 0 1z"/></svg>`
        }, props, {
            newIcon: $7262400a4f2e21fe$var$_feedback.default
        }));
    $7262400a4f2e21fe$var$EditorFeedbackIcon.displayName = 'EditorFeedbackIcon';
    var $7262400a4f2e21fe$var$_default = module.exports.default = $7262400a4f2e21fe$var$EditorFeedbackIcon;
});
parcelRegister("3NWt2", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2c534d1ac0734625$var$_react = $2c534d1ac0734625$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2c534d1ac0734625$var$_UNSAFE_baseNew = $2c534d1ac0734625$var$_interopRequireDefault((parcelRequire("huIZN")));
    function $2c534d1ac0734625$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2c534d1ac0734625$var$FeedbackIcon = (props)=>$2c534d1ac0734625$var$_react.default.createElement($2c534d1ac0734625$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9.5V15L6 12.25h7c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2.75C1.75 6.44 2.31 7 3 7h6.75m-2-2.5 2.5 2.5-2.5 2.5"/>`
        }, props));
    $2c534d1ac0734625$var$FeedbackIcon.displayName = 'FeedbackIcon';
    var $2c534d1ac0734625$var$_default = module.exports.default = $2c534d1ac0734625$var$FeedbackIcon;
});
parcelRegister("jPxJ7", function(module, exports) {
    $parcel$export(module.exports, "useFeedbackCollector", ()=>$11c0bec8448c2614$export$4be696be8a3bff13);
    var $5uXOq = parcelRequire("5uXOq");
    var $7iULw;
    var $dseDh;
    var $koVbs;
    var $6jY6G;
    var $dAfqg;
    var $itmJb;
    var $9OXo1;
    var $5XRYo;
    var $5Dn32;
    const $11c0bec8448c2614$export$698ff856156a88fe = (0, $5uXOq.memo)(()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("5XRYo")).default).canContactPrompt), ' ', (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            href: "https://www.atlassian.com/legal/privacy-policy",
            target: "_blank",
            rel: "noopener noreferrer"
        }, formatMessage((0, (0, parcelRequire("5XRYo")).default).canContactPromptLink)));
    });
    const $11c0bec8448c2614$export$4f77effad9540593 = (0, $5uXOq.memo)(()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("5XRYo")).default).enrollInResearchPrompt, {
            link: (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
                href: "https://www.atlassian.com/research-group",
                target: "_blank",
                rel: "noopener noreferrer"
            }, formatMessage((0, (0, parcelRequire("5XRYo")).default).enrollInResearchLink))
        }));
    });
    const $11c0bec8448c2614$export$4be696be8a3bff13 = ({ projectType: projectType = 'business' } = {})=>{
        const { openFeedbackCollector: openFeedbackCollector } = (0, (0, parcelRequire("dseDh")).useFeedbackCollectorActions)();
        const { licensedProducts: licensedProducts } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: project } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const getFeedbackContext = (0, $5uXOq.useCallback)((feedbackGroupId)=>{
            const baseFeedbackContext = [
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).INLINE_FEEDBACK_ID,
                    value: feedbackGroupId
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).ROUTE_NAME,
                    value: route.name ?? 'unknown'
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).ROUTE_GROUP,
                    value: route.group ?? 'unknown'
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).IS_ADMIN,
                    value: isAdmin
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).PROJECT_TYPE,
                    value: project?.projectType || projectType
                },
                {
                    id: (0, (0, parcelRequire("7iULw")).EntryKeys).SUPPORTED_PROJECT_TYPES,
                    value: (0, (0, parcelRequire("5Dn32")).licensedProductsToString)(licensedProducts)
                }
            ];
            if (project) baseFeedbackContext.push({
                id: (0, (0, parcelRequire("7iULw")).EntryKeys).IS_SIMPLIFIED_PROJECT,
                value: project.simplified
            });
            return baseFeedbackContext;
        }, [
            isAdmin,
            licensedProducts,
            project,
            projectType,
            route.group,
            route.name
        ]);
        return (0, $5uXOq.useCallback)((feedbackGroupId, onClose, triggerRef)=>{
            const feedbackContext = getFeedbackContext(feedbackGroupId);
            openFeedbackCollector({
                entrypointId: (0, (0, parcelRequire("7iULw")).ENTRYPOINT_ID_JIRA_PLATFORM),
                feedbackGroupId: feedbackGroupId,
                canBeContactedLabel: (0, ($parcel$interopDefault($5uXOq))).createElement($11c0bec8448c2614$export$698ff856156a88fe, null),
                enrolInResearchLabel: (0, ($parcel$interopDefault($5uXOq))).createElement($11c0bec8448c2614$export$4f77effad9540593, null),
                feedbackContext: feedbackContext,
                onClose: onClose,
                ...triggerRef != null ? {
                    triggerRef: triggerRef
                } : {}
            });
        }, [
            getFeedbackContext,
            openFeedbackCollector
        ]);
    };
});
parcelRegister("dAfqg", function(module, exports) {
    $parcel$export(module.exports, "useProjectContext", ()=>$0baaa0dcf730951a$export$8f31c2503e1efa93);
    $parcel$export(module.exports, "useIsSimplifiedProject", ()=>$0baaa0dcf730951a$export$524ef4f6102ed540);
    $parcel$export(module.exports, "ProjectContextProvider", ()=>$0baaa0dcf730951a$export$a85f6b5857d2176);
    var $5uXOq = parcelRequire("5uXOq");
    var $324W5;
    var $dxCvy;
    const $0baaa0dcf730951a$export$8f31c2503e1efa93 = (customContext)=>{
        const { data: data, error: error, loading: loading, update: update, key: key } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)((0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache), customContext);
        const updateCache = (0, $5uXOq.useCallback)((d)=>update(()=>d), [
            update
        ]);
        return {
            data: data,
            error: error,
            loading: loading,
            updateCache: updateCache,
            key: key
        };
    };
    const $0baaa0dcf730951a$export$524ef4f6102ed540 = ()=>{
        const { data: data } = $0baaa0dcf730951a$export$8f31c2503e1efa93();
        return data?.simplified || false;
    };
    const $0baaa0dcf730951a$export$a85f6b5857d2176 = ({ children: children })=>{
        const projectContext = $0baaa0dcf730951a$export$8f31c2503e1efa93();
        return children(projectContext);
    };
});
parcelRegister("5XRYo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c924dc8de5075ae$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6c924dc8de5075ae$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        canContactPrompt: {
            "id": "business-feedback-collector.can-contact-prompt",
            "defaultMessage": "Atlassian may contact me about this feedback."
        },
        canContactPromptLink: {
            "id": "business-feedback-collector.can-contact-prompt-link",
            "defaultMessage": "Privacy policy"
        },
        enrollInResearchPrompt: {
            "id": "business-feedback-collector.enroll-in-research-prompt",
            "defaultMessage": "I'd like to help improve Atlassian products by joining the {link}"
        },
        enrollInResearchLink: {
            "id": "business-feedback-collector.enroll-in-research-link",
            "defaultMessage": "Atlassian Research Group"
        }
    });
});
parcelRegister("5Dn32", function(module, exports) {
    $parcel$export(module.exports, "licensedProductsToString", ()=>$0dd3b476597799f0$export$f57a7f1d32485807);
    const $0dd3b476597799f0$export$f57a7f1d32485807 = (licensedProducts)=>Object.keys(licensedProducts).map((productKey)=>licensedProducts[productKey] ? productKey : '').join(', ');
});
parcelRegister("g8I5C", function(module, exports) {
    $parcel$export(module.exports, "QuickstartNudge", ()=>$0174d522ba9dfb06$export$bd61ee610c74db6c);
    var $5uXOq = parcelRequire("5uXOq");
    var $6OJ73;
    var $axUP7;
    const $0174d522ba9dfb06$export$bd61ee610c74db6c = (0, (0, parcelRequire("axUP7")).withNestingOptimisation)(({ renderWrapper: renderWrapper, children: children })=>{
        const isFullyExpanded = (0, (0, parcelRequire("6OJ73")).useIsFullyExpanded)();
        return isFullyExpanded ? renderWrapper(children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    });
});
parcelRegister("6OJ73", function(module, exports) {
    $parcel$export(module.exports, "useIsFullyExpanded", ()=>$c20291d4f7970c77$export$7212b6b01271f5d1);
    var $5uXOq = parcelRequire("5uXOq");
    var $gPQRI;
    const $c20291d4f7970c77$var$TIMEOUT = 500;
    const $c20291d4f7970c77$export$7212b6b01271f5d1 = ()=>{
        const [ready, setReady] = (0, $5uXOq.useState)(false);
        const { isCollapsed: isCollapsed } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        (0, $5uXOq.useLayoutEffect)(()=>{
            const timeoutId = setTimeout(()=>{
                setReady(!isCollapsed);
            }, $c20291d4f7970c77$var$TIMEOUT);
            return ()=>clearTimeout(timeoutId);
        }, [
            isCollapsed
        ]);
        return ready && !isCollapsed;
    };
});
parcelRegister("gPQRI", function(module, exports) {
    $parcel$export(module.exports, "useLeftSidebarState", ()=>$b19712b3cdd78134$export$610d81e163a897b3);
    $parcel$export(module.exports, "useLeftSidebarController", ()=>$b19712b3cdd78134$export$900f29014a48fb23);
    var $5uXOq = parcelRequire("5uXOq");
    var $iqLcb;
    var $7JoAD = parcelRequire("7JoAD");
    var $5e5zm;
    const $b19712b3cdd78134$var$useSweetStateLeftSidebarState = (0, $7JoAD.createHook)((0, (0, parcelRequire("5e5zm")).layoutStore), {
        selector: (state)=>({
                ...state.content.leftSidebar,
                shouldRender: !state.isChromeless
            })
    });
    const $b19712b3cdd78134$export$610d81e163a897b3 = ()=>{
        const [leftSidebar] = $b19712b3cdd78134$var$useSweetStateLeftSidebarState();
        return leftSidebar;
    };
    const $b19712b3cdd78134$export$900f29014a48fb23 = ()=>{
        const { expandLeftSidebar: expandLeftSidebar, collapseLeftSidebar: collapseLeftSidebar } = (0, (0, parcelRequire("iqLcb")).usePageLayoutResize)();
        return (0, $5uXOq.useMemo)(()=>({
                collapseLeftSidebar: collapseLeftSidebar,
                expandLeftSidebar: expandLeftSidebar
            }), [
            collapseLeftSidebar,
            expandLeftSidebar
        ]);
    };
});
parcelRegister("iqLcb", function(module, exports) {
    $parcel$export(module.exports, "PageLayout", ()=>$3d7d84f3bc65155e$export$6d1402fb58384e4f);
    $parcel$export(module.exports, "Banner", ()=>$3d7d84f3bc65155e$export$3b4e64e77073e307);
    $parcel$export(module.exports, "TopNavigation", ()=>$3d7d84f3bc65155e$export$8a421bddecb2bf5b);
    $parcel$export(module.exports, "LeftPanel", ()=>$3d7d84f3bc65155e$export$110709f040143804);
    $parcel$export(module.exports, "LeftSidebarWithoutResize", ()=>$3d7d84f3bc65155e$export$43ae342508cf8cc9);
    $parcel$export(module.exports, "LeftSidebar", ()=>$3d7d84f3bc65155e$export$3cabf771c4f2de);
    $parcel$export(module.exports, "Main", ()=>$3d7d84f3bc65155e$export$861edd1ccea2f746);
    $parcel$export(module.exports, "Content", ()=>$3d7d84f3bc65155e$export$7c6e2c02157bb7d2);
    $parcel$export(module.exports, "RightSidebar", ()=>$3d7d84f3bc65155e$export$84d58c19c21f637f);
    $parcel$export(module.exports, "RightPanel", ()=>$3d7d84f3bc65155e$export$364a989a35814102);
    $parcel$export(module.exports, "useCustomSkipLink", ()=>$3d7d84f3bc65155e$export$ee6b12c2613bdf8e);
    $parcel$export(module.exports, "useLeftSidebarFlyoutLock", ()=>$3d7d84f3bc65155e$export$94561f6055639ef7);
    $parcel$export(module.exports, "usePageLayoutResize", ()=>$3d7d84f3bc65155e$export$10c7104037a7af62);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_BANNER_HEIGHT", ()=>$3d7d84f3bc65155e$export$991ef8098f87814a);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_PANEL_WIDTH", ()=>$3d7d84f3bc65155e$export$7eaf986ecb4d5cac);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_LEFT_SIDEBAR_WIDTH", ()=>$3d7d84f3bc65155e$export$e95b388ca8c92019);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_PANEL_WIDTH", ()=>$3d7d84f3bc65155e$export$2ab8b83eed76656c);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_RIGHT_SIDEBAR_WIDTH", ()=>$3d7d84f3bc65155e$export$ac017575d43f5da);
    $parcel$export(module.exports, "UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT", ()=>$3d7d84f3bc65155e$export$d697087c06fd5e25);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $cfCYJ;
    var $fHYEP;
    var $8uxcu;
    var $lPKVQ;
    var $9HvD6;
    var $1xtlh;
    var $8T5bc;
    var $igz9V;
    var $9800U;
    var $lHa8m;
    var $1IJrV;
    var $cVRge;
    var $jEQgO;
    var $4R6GH;
    var $3HwlS;
    var $lX64V;
    var $fIr6F;
    var $jL8aY;
    var $gFfbI;
    var $gN1lH;
    var $a2MWg;
    var $7CyGM;
    function $3d7d84f3bc65155e$export$6d1402fb58384e4f(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gN1lH")).Root), {
            UNSAFE_dangerouslyHoistSlotSizes: true,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("igz9V")).default), props);
    }
    function $3d7d84f3bc65155e$export$3b4e64e77073e307(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fIr6F")).Banner), {
            UNSAFE_height: props.height,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cfCYJ")).default), props);
    }
    function $3d7d84f3bc65155e$export$8a421bddecb2bf5b(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7CyGM")).TopBar), {
            UNSAFE_height: props.height,
            testId: props.testId,
            UNSAFE_theme: (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_theming') ? props.theme : undefined
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1IJrV")).default), props);
    }
    function $3d7d84f3bc65155e$export$110709f040143804(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lPKVQ")).default), props);
    }
    function $3d7d84f3bc65155e$export$43ae342508cf8cc9(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a2MWg")).SideNav), {
            defaultWidth: props.width,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1xtlh")).default), props);
    }
    function $3d7d84f3bc65155e$export$3cabf771c4f2de(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a2MWg")).SideNav), {
            defaultCollapsed: props.collapsedState === 'collapsed',
            defaultWidth: props.width,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9HvD6")).default), props);
    }
    function $3d7d84f3bc65155e$export$861edd1ccea2f746(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jL8aY")).Main), {
            isFixed: props.isFixed,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8T5bc")).default), props);
    }
    function $3d7d84f3bc65155e$export$7c6e2c02157bb7d2(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? props.children : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8uxcu")).default), props);
    }
    function $3d7d84f3bc65155e$export$84d58c19c21f637f(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lX64V")).Aside), {
            isFixed: props.isFixed,
            defaultWidth: props.width,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lHa8m")).default), props);
    }
    function $3d7d84f3bc65155e$export$364a989a35814102(props) {
        return (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gFfbI")).Panel), {
            xcss: $3d7d84f3bc65155e$var$rightPanelStyles.root,
            defaultWidth: props.width,
            testId: props.testId
        }, props.children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9800U")).default), props);
    }
    const $3d7d84f3bc65155e$export$ee6b12c2613bdf8e = (id, title, index)=>(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? {} : (0, (0, parcelRequire("cVRge")).useCustomSkipLink)(id, title, index);
    const $3d7d84f3bc65155e$export$94561f6055639ef7 = ()=>(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? {} : (0, (0, parcelRequire("jEQgO")).useLeftSidebarFlyoutLock)();
    const $3d7d84f3bc65155e$var$mockPageLayoutResize = {
        isLeftSidebarCollapsed: false,
        expandLeftSidebar: (0, ($parcel$interopDefault($8Rkzz))),
        collapseLeftSidebar: (0, ($parcel$interopDefault($8Rkzz))),
        leftSidebarState: {
            isFlyoutOpen: false,
            isResizing: false,
            isLeftSidebarCollapsed: false,
            leftSidebarWidth: 0,
            lastLeftSidebarWidth: 0,
            flyoutLockCount: 0,
            isFixed: true
        },
        setLeftSidebarState: (0, ($parcel$interopDefault($8Rkzz))),
        toggleLeftSidebar: (0, ($parcel$interopDefault($8Rkzz)))
    };
    const $3d7d84f3bc65155e$export$10c7104037a7af62 = ()=>(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? $3d7d84f3bc65155e$var$mockPageLayoutResize : (0, (0, parcelRequire("jEQgO")).usePageLayoutResize)();
    const $3d7d84f3bc65155e$var$rightPanelStyles = {
        root: "_bfhk1bhr"
    };
    const $3d7d84f3bc65155e$export$991ef8098f87814a = (0, (0, parcelRequire("fHYEP")).BANNER_HEIGHT);
    const $3d7d84f3bc65155e$export$7eaf986ecb4d5cac = (0, (0, parcelRequire("fHYEP")).LEFT_PANEL_WIDTH);
    const $3d7d84f3bc65155e$export$e95b388ca8c92019 = (0, (0, parcelRequire("fHYEP")).LEFT_SIDEBAR_WIDTH);
    const $3d7d84f3bc65155e$export$2ab8b83eed76656c = (0, (0, parcelRequire("fHYEP")).RIGHT_PANEL_WIDTH);
    const $3d7d84f3bc65155e$export$ac017575d43f5da = (0, (0, parcelRequire("fHYEP")).RIGHT_SIDEBAR_WIDTH);
    const $3d7d84f3bc65155e$export$d697087c06fd5e25 = (0, (0, parcelRequire("fHYEP")).TOP_NAVIGATION_HEIGHT);
});
parcelRegister("cfCYJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b81cf2afa91c85f0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $fHYEP;
    var $cezmR;
    var $1nim3;
    var $4wf0T;
    var $2uhGC;
    var $39rJx;
    const $b81cf2afa91c85f0$var$bannerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        height: (0, (0, parcelRequire("fHYEP")).BANNER_HEIGHT),
        gridArea: (0, (0, parcelRequire("fHYEP")).BANNER)
    });
    const $b81cf2afa91c85f0$var$bannerFixedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'fixed',
        zIndex: 2,
        insetBlockStart: 0,
        insetInlineEnd: (0, (0, parcelRequire("fHYEP")).RIGHT_PANEL_WIDTH),
        insetInlineStart: (0, (0, parcelRequire("fHYEP")).LEFT_PANEL_WIDTH)
    });
    const $b81cf2afa91c85f0$var$Banner = (props)=>{
        const { children: children, height: height = (0, (0, parcelRequire("fHYEP")).DEFAULT_BANNER_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, skipLinkTitle: skipLinkTitle, id: id } = props;
        const bannerHeight = (0, (0, parcelRequire("cezmR")).resolveDimension)((0, (0, parcelRequire("fHYEP")).VAR_BANNER_HEIGHT), height, shouldPersistHeight);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("1nim3")).default)({
                [(0, (0, parcelRequire("fHYEP")).VAR_BANNER_HEIGHT)]: bannerHeight
            });
            return ()=>{
                (0, (0, parcelRequire("1nim3")).default)({
                    [(0, (0, parcelRequire("fHYEP")).VAR_BANNER_HEIGHT)]: 0
                });
            };
        }, [
            bannerHeight
        ]);
        (0, (0, parcelRequire("4wf0T")).useSkipLink)(id, skipLinkTitle);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2uhGC")).default), null, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $b81cf2afa91c85f0$var$bannerStyles,
                    isFixed && $b81cf2afa91c85f0$var$bannerFixedStyles
                ],
                className: className,
                "data-testid": testId,
                id: id,
                ...(0, (0, parcelRequire("cezmR")).getPageLayoutSlotSelector)('banner')
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("39rJx")).default), {
                variableName: (0, (0, parcelRequire("fHYEP")).VAR_BANNER_HEIGHT),
                value: bannerHeight
            }), children));
    };
    var $b81cf2afa91c85f0$export$2e2bcd8739ae039 = $b81cf2afa91c85f0$var$Banner;
});
parcelRegister("cezmR", function(module, exports) {
    $parcel$export(module.exports, "mergeGridStateIntoStorage", ()=>$501fc56a4b4bf5c5$export$f8355a2df0f4a946);
    $parcel$export(module.exports, "getGridStateFromStorage", ()=>$501fc56a4b4bf5c5$export$d95e99d8116d17dc);
    $parcel$export(module.exports, "removeFromGridStateInStorage", ()=>$501fc56a4b4bf5c5$export$17e3760e0b35f1cd);
    $parcel$export(module.exports, "resolveDimension", ()=>$501fc56a4b4bf5c5$export$74732e47915c7839);
    $parcel$export(module.exports, "getLeftPanelWidth", ()=>$501fc56a4b4bf5c5$export$b089e01213f07bd);
    $parcel$export(module.exports, "getLeftSidebarPercentage", ()=>$501fc56a4b4bf5c5$export$2bca58b6ee823bf7);
    $parcel$export(module.exports, "getPageLayoutSlotSelector", ()=>$501fc56a4b4bf5c5$export$e895e3e8b708ae2a);
    $parcel$export(module.exports, "getPageLayoutSlotCSSSelector", ()=>$501fc56a4b4bf5c5$export$218ece2c32b7db0e);
    var $fHYEP;
    var $irz8j;
    const $501fc56a4b4bf5c5$export$576dabd404a1ed99 = (0, (0, parcelRequire("fHYEP")).DIMENSIONS).reduce((acc, currentValue)=>({
            ...acc,
            [currentValue]: 0
        }), {});
    const $501fc56a4b4bf5c5$export$f8355a2df0f4a946 = (key, value)=>{
        const storageValue = JSON.parse((0, (0, parcelRequire("irz8j")).default)().getItem((0, (0, parcelRequire("fHYEP")).PAGE_LAYOUT_LS_KEY)) || '{}');
        if (value !== null && typeof value === 'object') storageValue[key] = {
            ...storageValue[key],
            ...value
        };
        else storageValue[key] = value;
        (0, (0, parcelRequire("irz8j")).default)().setItem((0, (0, parcelRequire("fHYEP")).PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
    };
    const $501fc56a4b4bf5c5$export$d95e99d8116d17dc = (key)=>{
        const storageValue = JSON.parse((0, (0, parcelRequire("irz8j")).default)().getItem((0, (0, parcelRequire("fHYEP")).PAGE_LAYOUT_LS_KEY)) || '{}');
        return storageValue[key];
    };
    const $501fc56a4b4bf5c5$export$17e3760e0b35f1cd = (key, secondKey)=>{
        const storageValue = JSON.parse((0, (0, parcelRequire("irz8j")).default)().getItem((0, (0, parcelRequire("fHYEP")).PAGE_LAYOUT_LS_KEY)) || '{}');
        if (secondKey && storageValue[key]) delete storageValue[key][secondKey];
        else delete storageValue[key];
        (0, (0, parcelRequire("irz8j")).default)().setItem((0, (0, parcelRequire("fHYEP")).PAGE_LAYOUT_LS_KEY), JSON.stringify(storageValue));
    };
    const $501fc56a4b4bf5c5$export$74732e47915c7839 = (key, dimension = 0, shouldPersist = false)=>{
        if (shouldPersist) {
            const cachedGridState = $501fc56a4b4bf5c5$export$d95e99d8116d17dc('gridState');
            return cachedGridState && Object.keys(cachedGridState).length > 0 && cachedGridState[key] ? cachedGridState[key] : dimension;
        }
        return dimension;
    };
    const $501fc56a4b4bf5c5$export$b089e01213f07bd = ()=>{
        if (typeof window === 'undefined') return 0;
        return parseInt(window.getComputedStyle(document.documentElement).getPropertyValue(`--${(0, (0, parcelRequire("fHYEP")).LEFT_PANEL_WIDTH)}`), 10) || 0;
    };
    const $501fc56a4b4bf5c5$export$2bca58b6ee823bf7 = (currentWidth, maxWidth)=>{
        const total = (currentWidth - (0, (0, parcelRequire("fHYEP")).DEFAULT_LEFT_SIDEBAR_WIDTH)) / (maxWidth - (0, (0, parcelRequire("fHYEP")).DEFAULT_LEFT_SIDEBAR_WIDTH));
        if (total < 0) return 0;
        if (total > 1) return 100;
        return Math.floor(total * 100);
    };
    const $501fc56a4b4bf5c5$export$e895e3e8b708ae2a = (slotName)=>({
            [(0, (0, parcelRequire("fHYEP")).PAGE_LAYOUT_SLOT_SELECTOR)]: slotName
        });
    const $501fc56a4b4bf5c5$export$218ece2c32b7db0e = (slotName)=>`[${0, (0, parcelRequire("fHYEP")).PAGE_LAYOUT_SLOT_SELECTOR}='${slotName}']`;
});
parcelRegister("irz8j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$51f99cd313853dda$export$2e2bcd8739ae039);
    const $51f99cd313853dda$var$isLocalStorageSupported = ()=>{
        try {
            const testKey = `__test_${Date.now()}__`;
            localStorage.setItem(testKey, testKey);
            localStorage.removeItem(testKey);
            return true;
        } catch (e) {
            return false;
        }
    };
    const $51f99cd313853dda$var$safeLocalStorage = ()=>{
        if ($51f99cd313853dda$var$isLocalStorageSupported()) return localStorage;
        if (typeof window === 'undefined') return {
            getItem: (_key)=>null,
            setItem: (_key, _value)=>null,
            removeItem: (_key)=>null,
            clear: ()=>null,
            key: (_index)=>null,
            get length () {
                return 0;
            }
        };
        if (window.__localStorageFallback && Object.keys(window.__localStorageFallback).length !== 0) return window.__localStorageFallback;
        const storageAPI = {
            getItem: (key)=>{
                if (window.__localStorageFallback.hasOwnProperty(key)) return window.__localStorageFallback[key];
                return null;
            },
            setItem: (key, value)=>{
                window.__localStorageFallback[key] = String(value);
            },
            removeItem: (key)=>{
                delete window.__localStorageFallback[key];
            },
            clear: ()=>{
                for(const key in window.__localStorageFallback)if (window.__localStorageFallback.hasOwnProperty(key)) delete window.__localStorageFallback[key];
            },
            get length () {
                if (!window.__localStorageFallback) return 0;
                return Object.keys(window.__localStorageFallback).length;
            }
        };
        window.__localStorageFallback = Object.create(storageAPI);
        return window.__localStorageFallback;
    };
    var $51f99cd313853dda$export$2e2bcd8739ae039 = $51f99cd313853dda$var$safeLocalStorage;
});
parcelRegister("1nim3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$386b617815bbd84b$export$2e2bcd8739ae039);
    var $cezmR;
    const $386b617815bbd84b$var$publishGridState = (gridState)=>{
        Object.entries(gridState).forEach(([slotName, value])=>{
            if (!value) {
                document.documentElement.style.removeProperty(`--${slotName}`);
                (0, (0, parcelRequire("cezmR")).removeFromGridStateInStorage)('gridState', slotName);
                return;
            }
            document.documentElement.style.setProperty(`--${slotName}`, `${value}px`);
            (0, (0, parcelRequire("cezmR")).mergeGridStateIntoStorage)('gridState', {
                [slotName]: value
            });
        });
    };
    var $386b617815bbd84b$export$2e2bcd8739ae039 = $386b617815bbd84b$var$publishGridState;
});
parcelRegister("4wf0T", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksContext", ()=>$17ec4eb8b6ed1c39$export$4c5cc3b14c7678a);
    $parcel$export(module.exports, "useSkipLinks", ()=>$17ec4eb8b6ed1c39$export$c9d9cb2ee9590f87);
    $parcel$export(module.exports, "useSkipLink", ()=>$17ec4eb8b6ed1c39$export$89d9323301efc7d6);
    var $5uXOq = parcelRequire("5uXOq");
    var $ePBXU;
    const $17ec4eb8b6ed1c39$export$4c5cc3b14c7678a = (0, $5uXOq.createContext)({
        skipLinksData: [],
        registerSkipLink: (0, (0, parcelRequire("ePBXU")).default),
        unregisterSkipLink: (0, (0, parcelRequire("ePBXU")).default)
    });
    const $17ec4eb8b6ed1c39$export$c9d9cb2ee9590f87 = ()=>(0, $5uXOq.useContext)($17ec4eb8b6ed1c39$export$4c5cc3b14c7678a);
    const $17ec4eb8b6ed1c39$export$89d9323301efc7d6 = (id, skipLinkTitle)=>{
        const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $17ec4eb8b6ed1c39$export$c9d9cb2ee9590f87();
        (0, $5uXOq.useEffect)(()=>{
            if (id && skipLinkTitle) registerSkipLink({
                id: id,
                skipLinkTitle: skipLinkTitle
            });
            return ()=>{
                unregisterSkipLink(id);
            };
        }, [
            id,
            skipLinkTitle,
            registerSkipLink,
            unregisterSkipLink
        ]);
    };
});
parcelRegister("2uhGC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4aa20b477f6bd127$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $4aa20b477f6bd127$var$focusStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        ':focus': {
            outline: 'none',
            '> div': {
                boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a)})`}`,
                outline: 'none'
            }
        }
    });
    const $4aa20b477f6bd127$var$sidebarFocusStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        ':focus': {
            outline: 'none',
            '> div > div': {
                boxShadow: `0px 0px 0px 2px inset ${`var(--ds-border-focused, ${(0, $5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a)})`}`,
                outline: 'none'
            }
        }
    });
    const $4aa20b477f6bd127$var$SlotFocusRing = ({ children: children, isSidebar: isSidebar = false })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f8Sb3")).ClassNames), null, ({ css: css })=>children({
                className: isSidebar ? css($4aa20b477f6bd127$var$sidebarFocusStyles) : css($4aa20b477f6bd127$var$focusStyles)
            }));
    };
    var $4aa20b477f6bd127$export$2e2bcd8739ae039 = $4aa20b477f6bd127$var$SlotFocusRing;
});
parcelRegister("39rJx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2e09b5d68ea1b26$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2MVcM;
    const $c2e09b5d68ea1b26$var$SlotDimensions = ({ variableName: variableName, value: value, mobileValue: mobileValue })=>{
        let style = `:root{--${variableName}:${value}px;}`;
        if (mobileValue) style += ` ${(0, (0, parcelRequire("2MVcM")).UNSAFE_media).below.sm} { :root{--${variableName}:${mobileValue}px;} }`;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("style", null, style));
    };
    var $c2e09b5d68ea1b26$export$2e2bcd8739ae039 = $c2e09b5d68ea1b26$var$SlotDimensions;
});
parcelRegister("8uxcu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e4dcb98281fe0a59$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $fHYEP;
    const $e4dcb98281fe0a59$var$contentStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        height: '100%',
        position: 'relative',
        gridArea: (0, (0, parcelRequire("fHYEP")).CONTENT)
    });
    const $e4dcb98281fe0a59$var$Content = (props)=>{
        const { children: children, testId: testId } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            css: $e4dcb98281fe0a59$var$contentStyles
        }, children);
    };
    var $e4dcb98281fe0a59$export$2e2bcd8739ae039 = $e4dcb98281fe0a59$var$Content;
});
parcelRegister("lPKVQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f19c2ab4a354af2e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $fHYEP;
    var $cezmR;
    var $1nim3;
    var $4wf0T;
    var $2uhGC;
    var $39rJx;
    const $f19c2ab4a354af2e$var$leftPanelStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        gridArea: (0, (0, parcelRequire("fHYEP")).LEFT_PANEL)
    });
    const $f19c2ab4a354af2e$var$leftPanelFixedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("fHYEP")).LEFT_PANEL_WIDTH),
        position: 'fixed',
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineStart: 0
    });
    const $f19c2ab4a354af2e$var$LeftPanel = (props)=>{
        const { children: children, isFixed: isFixed, width: width = (0, (0, parcelRequire("fHYEP")).DEFAULT_LEFT_PANEL_WIDTH), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
        const leftPanelWidth = (0, (0, parcelRequire("cezmR")).resolveDimension)((0, (0, parcelRequire("fHYEP")).VAR_LEFT_PANEL_WIDTH), width, shouldPersistWidth);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("1nim3")).default)({
                [(0, (0, parcelRequire("fHYEP")).VAR_LEFT_PANEL_WIDTH)]: leftPanelWidth
            });
            return ()=>{
                (0, (0, parcelRequire("1nim3")).default)({
                    [(0, (0, parcelRequire("fHYEP")).VAR_LEFT_PANEL_WIDTH)]: 0
                });
            };
        }, [
            leftPanelWidth
        ]);
        (0, (0, parcelRequire("4wf0T")).useSkipLink)(id, skipLinkTitle);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2uhGC")).default), null, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $f19c2ab4a354af2e$var$leftPanelStyles,
                    isFixed && $f19c2ab4a354af2e$var$leftPanelFixedStyles
                ],
                className: className,
                "data-testid": testId,
                id: id,
                ...(0, (0, parcelRequire("cezmR")).getPageLayoutSlotSelector)('left-panel')
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("39rJx")).default), {
                variableName: (0, (0, parcelRequire("fHYEP")).VAR_LEFT_PANEL_WIDTH),
                value: leftPanelWidth
            }), children));
    };
    var $f19c2ab4a354af2e$export$2e2bcd8739ae039 = $f19c2ab4a354af2e$var$LeftPanel;
});
parcelRegister("9HvD6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1d826355a643a81f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $fwDV7;
    var $d4KoR;
    var $fHYEP;
    var $cezmR;
    var $1nim3;
    var $jEQgO;
    var $4wf0T;
    var $8CFQF;
    var $i9c1D;
    var $03HQf;
    var $exbKs;
    var $39rJx;
    const $1d826355a643a81f$var$openBackdropStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: '100%',
        height: '100%',
        position: 'absolute',
        background: `var(--ds-blanket, ${(0, $5e0c0d4e15efb4a6$export$486ab785e4bac3c6)})`,
        opacity: 1
    });
    const $1d826355a643a81f$var$hiddenBackdropStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        opacity: 0,
        transition: `opacity ${(0, (0, parcelRequire("fHYEP")).TRANSITION_DURATION)}ms ${(0, $afa89fc5bcc96d10$export$57636bb43b1ccbb0)} 0s`
    });
    const $1d826355a643a81f$var$LeftSidebar = (props)=>{
        const { children: children, width: width, isFixed: isFixed = true, valueTextLabel: valueTextLabel, resizeButtonLabel: resizeButtonLabel, resizeGrabAreaLabel: resizeGrabAreaLabel, overrides: overrides, onResizeStart: onResizeStart, onResizeEnd: onResizeEnd, onFlyoutExpand: onFlyoutExpand, onFlyoutCollapse: onFlyoutCollapse, testId: testId, id: id, skipLinkTitle: skipLinkTitle, collapsedState: collapsedState } = props;
        const flyoutTimerRef = (0, $5uXOq.useRef)();
        const mouseOverEventRef = (0, $5uXOq.useRef)();
        const leftSideBarRef = (0, $5uXOq.useRef)(null);
        const { leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)((0, (0, parcelRequire("jEQgO")).SidebarResizeContext));
        const { isFlyoutOpen: isFlyoutOpen, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isLeftSidebarCollapsed: isLeftSidebarCollapsed, leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth } = leftSidebarState;
        const isLocked = flyoutLockCount > 0;
        const isLockedRef = (0, $5uXOq.useRef)(isLocked);
        const mouseXRef = (0, $5uXOq.useRef)(0);
        const handlerRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            isLockedRef.current = isLocked;
            if (isLocked && !handlerRef.current) {
                handlerRef.current = (event)=>{
                    mouseXRef.current = event.clientX;
                };
                document.addEventListener('mousemove', handlerRef.current);
            }
            if (!isLocked && handlerRef.current) {
                if (mouseXRef.current >= lastLeftSidebarWidth) setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: false
                    }));
                document.removeEventListener('mousemove', handlerRef.current);
                handlerRef.current = null;
            }
            return ()=>{
                if (handlerRef.current) document.removeEventListener('mousemove', handlerRef.current);
            };
        }, [
            isLocked,
            lastLeftSidebarWidth,
            setLeftSidebarState
        ]);
        const _width = Math.max(width || 0, (0, (0, parcelRequire("fHYEP")).DEFAULT_LEFT_SIDEBAR_WIDTH));
        const collapsedStateOverrideOpen = collapsedState === 'expanded';
        let leftSidebarWidthOnMount;
        if (collapsedStateOverrideOpen) leftSidebarWidthOnMount = (0, (0, parcelRequire("cezmR")).resolveDimension)((0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_FLYOUT), _width, !width);
        else if (isLeftSidebarCollapsed || collapsedState === 'collapsed') leftSidebarWidthOnMount = (0, (0, parcelRequire("fHYEP")).COLLAPSED_LEFT_SIDEBAR_WIDTH);
        else leftSidebarWidthOnMount = (0, (0, parcelRequire("cezmR")).resolveDimension)((0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_WIDTH), _width, !width || !collapsedStateOverrideOpen && (0, (0, parcelRequire("cezmR")).getGridStateFromStorage)('isLeftSidebarCollapsed'));
        (0, $5uXOq.useEffect)(()=>{
            const cachedCollapsedState = !collapsedStateOverrideOpen && (collapsedState === 'collapsed' || (0, (0, parcelRequire("cezmR")).getGridStateFromStorage)('isLeftSidebarCollapsed') || false);
            const cachedGridState = (0, (0, parcelRequire("cezmR")).getGridStateFromStorage)('gridState') || {};
            let leftSidebarWidth = !width && cachedGridState[0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_FLYOUT] ? Math.max(cachedGridState[0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_FLYOUT], (0, (0, parcelRequire("fHYEP")).DEFAULT_LEFT_SIDEBAR_WIDTH)) : _width;
            const lastLeftSidebarWidth = !width && cachedGridState[0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_FLYOUT] ? Math.max(cachedGridState[0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_FLYOUT], (0, (0, parcelRequire("fHYEP")).DEFAULT_LEFT_SIDEBAR_WIDTH)) : _width;
            if (cachedCollapsedState) leftSidebarWidth = (0, (0, parcelRequire("fHYEP")).COLLAPSED_LEFT_SIDEBAR_WIDTH);
            setLeftSidebarState({
                isFlyoutOpen: false,
                isResizing: isResizing,
                isLeftSidebarCollapsed: cachedCollapsedState,
                leftSidebarWidth: leftSidebarWidth,
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                flyoutLockCount: 0,
                isFixed: isFixed
            });
        }, []);
        const notFirstRun = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (notFirstRun.current) {
                (0, (0, parcelRequire("1nim3")).default)({
                    [(0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_WIDTH)]: leftSidebarWidth || leftSidebarWidthOnMount,
                    [(0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_FLYOUT)]: lastLeftSidebarWidth
                });
                (0, (0, parcelRequire("cezmR")).mergeGridStateIntoStorage)('isLeftSidebarCollapsed', isLeftSidebarCollapsed);
            }
            if (!notFirstRun.current) notFirstRun.current = true;
            return ()=>{
                removeMouseOverListener();
            };
        }, [
            isLeftSidebarCollapsed,
            leftSidebarWidth,
            id
        ]);
        const onMouseOver = (event)=>{
            const isMouseOnResizeButton = event.target.matches(`[${(0, (0, parcelRequire("fHYEP")).RESIZE_BUTTON_SELECTOR)}]`) || event.target.matches(`[${(0, (0, parcelRequire("fHYEP")).RESIZE_BUTTON_SELECTOR)}] *`);
            if (isFlyoutOpen || isMouseOnResizeButton || !isLeftSidebarCollapsed) return;
            event.persist();
            flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
            if (!mouseOverEventRef.current) mouseOverEventRef.current = (event)=>{
                const leftSidebar = leftSideBarRef.current;
                if (leftSidebar === null || isLockedRef.current) return;
                if (!leftSidebar.contains(event.target)) {
                    flyoutTimerRef.current && clearTimeout(flyoutTimerRef.current);
                    onFlyoutCollapse && onFlyoutCollapse();
                    setLeftSidebarState((current)=>({
                            ...current,
                            isFlyoutOpen: false
                        }));
                    removeMouseOverListener();
                }
            };
            document.addEventListener('mouseover', mouseOverEventRef.current, {
                capture: true,
                passive: true
            });
            flyoutTimerRef.current = setTimeout(()=>{
                setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: true
                    }));
                onFlyoutExpand && onFlyoutExpand();
            }, (0, (0, parcelRequire("fHYEP")).FLYOUT_DELAY));
        };
        const removeMouseOverListener = ()=>{
            mouseOverEventRef.current && document.removeEventListener('mouseover', mouseOverEventRef.current, {
                capture: true,
                passive: true
            });
        };
        (0, (0, parcelRequire("4wf0T")).useSkipLink)(id, skipLinkTitle);
        const onMouseLeave = (event)=>{
            const isMouseOnResizeButton = event.target.matches(`[${(0, (0, parcelRequire("fHYEP")).RESIZE_BUTTON_SELECTOR)}]`) || event.target.matches(`[${(0, (0, parcelRequire("fHYEP")).RESIZE_BUTTON_SELECTOR)}] *`);
            if (isMouseOnResizeButton || !isLeftSidebarCollapsed || flyoutLockCount > 0) return;
            onFlyoutCollapse && onFlyoutCollapse();
            setTimeout(()=>{
                setLeftSidebarState((current)=>({
                        ...current,
                        isFlyoutOpen: false
                    }));
            }, (0, (0, parcelRequire("fHYEP")).FLYOUT_DELAY));
        };
        const mobileMediaQuery = (0, (0, parcelRequire("d4KoR")).UNSAFE_useMediaQuery)('below.sm');
        const openMobileFlyout = (0, $5uXOq.useCallback)(()=>{
            if (!mobileMediaQuery?.matches) return;
            setLeftSidebarState((current)=>{
                if (current.isFlyoutOpen) return current;
                return {
                    ...current,
                    isFlyoutOpen: true
                };
            });
        }, [
            setLeftSidebarState,
            mobileMediaQuery
        ]);
        const closeMobileFlyout = (0, $5uXOq.useCallback)(()=>{
            if (!mobileMediaQuery?.matches) return;
            setLeftSidebarState((current)=>{
                if (!current.isFlyoutOpen) return current;
                return {
                    ...current,
                    isFlyoutOpen: false
                };
            });
        }, [
            setLeftSidebarState,
            mobileMediaQuery
        ]);
        (0, (0, parcelRequire("d4KoR")).UNSAFE_useMediaQuery)('below.sm', (event)=>{
            setLeftSidebarState((current)=>{
                if (event.matches && !current.isLeftSidebarCollapsed) return {
                    ...current,
                    isResizing: false,
                    isLeftSidebarCollapsed: true,
                    leftSidebarWidth: (0, (0, parcelRequire("fHYEP")).COLLAPSED_LEFT_SIDEBAR_WIDTH),
                    lastLeftSidebarWidth: current.leftSidebarWidth,
                    isFlyoutOpen: true
                };
                else if (!event.matches && current.isFlyoutOpen) return {
                    ...current,
                    isResizing: false,
                    isLeftSidebarCollapsed: false,
                    leftSidebarWidth: Math.max(current.lastLeftSidebarWidth, (0, (0, parcelRequire("fHYEP")).DEFAULT_LEFT_SIDEBAR_WIDTH)),
                    isFlyoutOpen: false
                };
                return current;
            });
        });
        (0, (0, parcelRequire("fwDV7")).default)({
            onClose: closeMobileFlyout,
            isDisabled: !isFlyoutOpen
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, mobileMediaQuery?.matches && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $1d826355a643a81f$var$hiddenBackdropStyles,
                isFlyoutOpen && $1d826355a643a81f$var$openBackdropStyles
            ],
            onClick: closeMobileFlyout
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("03HQf")).default), {
            ref: leftSideBarRef,
            testId: testId,
            onMouseOver: !mobileMediaQuery?.matches ? onMouseOver : undefined,
            onMouseLeave: !mobileMediaQuery?.matches ? onMouseLeave : undefined,
            onClick: mobileMediaQuery?.matches ? openMobileFlyout : undefined,
            id: id,
            isFixed: isFixed
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("39rJx")).default), {
            variableName: (0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_WIDTH),
            value: notFirstRun.current ? leftSidebarWidth : leftSidebarWidthOnMount,
            mobileValue: (0, (0, parcelRequire("fHYEP")).MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("i9c1D")).default), {
            isFixed: isFixed,
            isFlyoutOpen: isFlyoutOpen
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("exbKs")).default), {
            isFlyoutOpen: isFlyoutOpen,
            isLeftSidebarCollapsed: isLeftSidebarCollapsed,
            hasCollapsedState: !notFirstRun.current && collapsedState === 'collapsed',
            testId: testId && `${testId}-resize-children-wrapper`
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8CFQF")).default), {
            testId: testId,
            valueTextLabel: valueTextLabel,
            resizeGrabAreaLabel: resizeGrabAreaLabel,
            resizeButtonLabel: resizeButtonLabel,
            overrides: overrides,
            onResizeStart: onResizeStart,
            onResizeEnd: onResizeEnd
        }))));
    };
    var $1d826355a643a81f$export$2e2bcd8739ae039 = $1d826355a643a81f$var$LeftSidebar;
});
parcelRegister("jEQgO", function(module, exports) {
    $parcel$export(module.exports, "SidebarResizeContext", ()=>$2ecce56b620b84bc$export$aa5a712eea4c2ae8);
    $parcel$export(module.exports, "usePageLayoutResize", ()=>$2ecce56b620b84bc$export$10c7104037a7af62);
    $parcel$export(module.exports, "useLeftSidebarFlyoutLock", ()=>$2ecce56b620b84bc$export$94561f6055639ef7);
    var $5uXOq = parcelRequire("5uXOq");
    var $ePBXU;
    const $2ecce56b620b84bc$var$leftSidebarState = {
        isFlyoutOpen: false,
        isResizing: false,
        isLeftSidebarCollapsed: false,
        leftSidebarWidth: 0,
        lastLeftSidebarWidth: 0,
        flyoutLockCount: 0,
        isFixed: true
    };
    const $2ecce56b620b84bc$export$aa5a712eea4c2ae8 = (0, $5uXOq.createContext)({
        isLeftSidebarCollapsed: false,
        expandLeftSidebar: (0, (0, parcelRequire("ePBXU")).default),
        collapseLeftSidebar: (0, (0, parcelRequire("ePBXU")).default),
        leftSidebarState: $2ecce56b620b84bc$var$leftSidebarState,
        setLeftSidebarState: (0, (0, parcelRequire("ePBXU")).default),
        toggleLeftSidebar: (0, (0, parcelRequire("ePBXU")).default)
    });
    const $2ecce56b620b84bc$export$10c7104037a7af62 = ()=>{
        const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $5uXOq.useContext)($2ecce56b620b84bc$export$aa5a712eea4c2ae8);
        return context;
    };
    const $2ecce56b620b84bc$export$94561f6055639ef7 = ()=>{
        const { setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)($2ecce56b620b84bc$export$aa5a712eea4c2ae8);
        (0, $5uXOq.useEffect)(()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount + 1
                }));
            return ()=>{
                setLeftSidebarState((current)=>({
                        ...current,
                        flyoutLockCount: current.flyoutLockCount - 1
                    }));
            };
        }, [
            setLeftSidebarState
        ]);
    };
});
parcelRegister("8CFQF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d9ccc20e4ce17cbe$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $cBeZP;
    var $7nRxN;
    var $d4KoR;
    var $fHYEP;
    var $cezmR;
    var $jEQgO;
    var $d2Ug1;
    var $dVGMm;
    var $ll1kD;
    function $d9ccc20e4ce17cbe$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d9ccc20e4ce17cbe$var$cssSelector = {
        [(0, (0, parcelRequire("fHYEP")).RESIZE_CONTROL_SELECTOR)]: true
    };
    const $d9ccc20e4ce17cbe$var$resizeControlStyles = {
        name: "ow3ovp",
        styles: "position:absolute;inset-block-end:0;inset-block-start:0;inset-inline-start:100%;outline:none"
    };
    const $d9ccc20e4ce17cbe$var$showResizeButtonStyles = {
        name: "1a6byq5",
        styles: "--ds--resize-button--opacity:1"
    };
    const $d9ccc20e4ce17cbe$var$globalResizingStyles = {
        name: "e4avm6",
        styles: "*{cursor:ew-resize !important;user-select:none !important;}iframe{pointer-events:none !important;}"
    };
    const $d9ccc20e4ce17cbe$var$ResizeControl = ({ testId: testId, overrides: overrides, resizeButtonLabel: resizeButtonLabel = 'Current project sidebar', valueTextLabel: valueTextLabel = 'Width', resizeGrabAreaLabel: resizeGrabAreaLabel = 'Resize Current Project Sidebar', onResizeStart: onResizeStart, onResizeEnd: onResizeEnd })=>{
        const { toggleLeftSidebar: toggleLeftSidebar, collapseLeftSidebar: collapseLeftSidebar, leftSidebarState: leftSidebarState, setLeftSidebarState: setLeftSidebarState } = (0, $5uXOq.useContext)((0, (0, parcelRequire("jEQgO")).SidebarResizeContext));
        const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = leftSidebarState;
        const sidebarWidth = (0, $5uXOq.useRef)(leftSidebarState[0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_WIDTH]);
        const offset = (0, $5uXOq.useRef)(0);
        const keyboardEventTimeout = (0, $5uXOq.useRef)();
        const [isGrabAreaFocused, setIsGrabAreaFocused] = (0, $5uXOq.useState)(false);
        const unbindEvents = (0, $5uXOq.useRef)(null);
        const mobileMediaQuery = (0, (0, parcelRequire("d4KoR")).UNSAFE_useMediaQuery)('below.sm');
        const stableSidebarState = (0, $5uXOq.useRef)(leftSidebarState);
        (0, $5uXOq.useEffect)(()=>{
            stableSidebarState.current = leftSidebarState;
        }, [
            leftSidebarState
        ]);
        const toggleSideBar = (0, $5uXOq.useCallback)((event)=>{
            event?.stopPropagation();
            toggleLeftSidebar();
        }, [
            toggleLeftSidebar
        ]);
        const onMouseDown = (event)=>{
            if (isLeftSidebarCollapsed) return;
            if (event.button !== 0) return;
            if (leftSidebarState.isResizing) return;
            offset.current = event.clientX - leftSidebarState[0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_WIDTH] - (0, (0, parcelRequire("cezmR")).getLeftPanelWidth)();
            unbindEvents.current = (0, (0, parcelRequire("cBeZP")).bindAll)(window, [
                {
                    type: 'mousemove',
                    listener: function(event) {
                        onUpdateResize({
                            clientX: event.clientX
                        });
                    }
                },
                {
                    type: 'mouseup',
                    listener: onFinishResizing
                },
                {
                    type: 'mousedown',
                    listener: (()=>{
                        let hasFramePassed = false;
                        requestAnimationFrame(()=>{
                            hasFramePassed = true;
                        });
                        return function listener() {
                            if (hasFramePassed) onFinishResizing();
                        };
                    })()
                },
                {
                    type: 'visibilitychange',
                    listener: onFinishResizing
                },
                {
                    type: 'click',
                    listener: onFinishResizing
                },
                {
                    type: 'keydown',
                    listener: (event)=>{
                        if (event.key === 'Escape') {
                            sidebarWidth.current = Math.max(leftSidebarState.lastLeftSidebarWidth, (0, (0, parcelRequire("fHYEP")).COLLAPSED_LEFT_SIDEBAR_WIDTH));
                            document.documentElement.style.setProperty(`--${(0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_WIDTH)}`, `${sidebarWidth.current}px`);
                            onFinishResizing();
                        }
                    }
                }
            ]);
            document.documentElement.setAttribute((0, (0, parcelRequire("fHYEP")).IS_SIDEBAR_DRAGGING), 'true');
            const newLeftbarState = {
                ...leftSidebarState,
                isResizing: true
            };
            setLeftSidebarState(newLeftbarState);
            onResizeStart && onResizeStart(newLeftbarState);
        };
        const onResizeOffLeftOfScreen = ()=>{
            onUpdateResize.cancel();
            unbindEvents.current?.();
            unbindEvents.current = null;
            document.documentElement.removeAttribute((0, (0, parcelRequire("fHYEP")).IS_SIDEBAR_DRAGGING));
            offset.current = 0;
            collapseLeftSidebar(undefined, true);
        };
        const [onUpdateResize] = (0, $5uXOq.useState)(()=>(0, (0, parcelRequire("7nRxN")).default)(({ clientX: clientX })=>{
                const maxWidth = Math.round(window.innerWidth / 2);
                const leftPanelWidth = (0, (0, parcelRequire("cezmR")).getLeftPanelWidth)();
                const leftSidebarWidth = stableSidebarState.current.leftSidebarWidth;
                const hasResizedOffLeftOfScreen = clientX < 0;
                if (hasResizedOffLeftOfScreen) {
                    onResizeOffLeftOfScreen();
                    return;
                }
                const delta = Math.max(Math.min(clientX - leftSidebarWidth - leftPanelWidth, maxWidth - leftSidebarWidth - leftPanelWidth), (0, (0, parcelRequire("fHYEP")).COLLAPSED_LEFT_SIDEBAR_WIDTH) - leftSidebarWidth - leftPanelWidth);
                sidebarWidth.current = Math.max(leftSidebarWidth + delta - offset.current, (0, (0, parcelRequire("fHYEP")).COLLAPSED_LEFT_SIDEBAR_WIDTH));
                document.documentElement.style.setProperty(`--${(0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_WIDTH)}`, `${sidebarWidth.current}px`);
            }));
        const onFinishResizing = ()=>{
            if (isLeftSidebarCollapsed) return;
            document.documentElement.removeAttribute((0, (0, parcelRequire("fHYEP")).IS_SIDEBAR_DRAGGING));
            let updatedLeftSidebarState = null;
            if (sidebarWidth.current < (0, (0, parcelRequire("fHYEP")).MIN_LEFT_SIDEBAR_DRAG_THRESHOLD)) {
                document.documentElement.style.setProperty(`--${(0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, (0, parcelRequire("fHYEP")).COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`);
                collapseLeftSidebar(undefined, true);
            } else if (sidebarWidth.current > (0, (0, parcelRequire("fHYEP")).MIN_LEFT_SIDEBAR_DRAG_THRESHOLD) && sidebarWidth.current < (0, (0, parcelRequire("fHYEP")).DEFAULT_LEFT_SIDEBAR_WIDTH)) {
                document.documentElement.style.setProperty(`--${(0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, (0, parcelRequire("fHYEP")).DEFAULT_LEFT_SIDEBAR_WIDTH)}px`);
                updatedLeftSidebarState = {
                    ...leftSidebarState,
                    isResizing: false,
                    [(0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_WIDTH)]: (0, (0, parcelRequire("fHYEP")).DEFAULT_LEFT_SIDEBAR_WIDTH),
                    lastLeftSidebarWidth: (0, (0, parcelRequire("fHYEP")).DEFAULT_LEFT_SIDEBAR_WIDTH)
                };
                setLeftSidebarState(updatedLeftSidebarState);
            } else {
                updatedLeftSidebarState = {
                    ...leftSidebarState,
                    isResizing: false,
                    [(0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_WIDTH)]: sidebarWidth.current,
                    lastLeftSidebarWidth: sidebarWidth.current
                };
                setLeftSidebarState(updatedLeftSidebarState);
            }
            unbindEvents.current?.();
            unbindEvents.current = null;
            onUpdateResize.cancel();
            sidebarWidth.current = 0;
            offset.current = 0;
            requestAnimationFrame(()=>{
                setIsGrabAreaFocused(false);
                onResizeEnd?.(updatedLeftSidebarState ?? stableSidebarState.current);
            });
        };
        const onKeyDown = (event)=>{
            if (isLeftSidebarCollapsed || !isGrabAreaFocused) return false;
            const { key: key } = event;
            const isLeftOrTopArrow = key === 'ArrowLeft' || key === 'ArrowUp' || key === 'Left' || key === 'Up';
            const isRightOrBottomArrow = key === 'ArrowRight' || key === 'ArrowDown' || key === 'Right' || key === 'Down';
            const isSpaceOrEnter = key === 'Enter' || key === 'Spacebar' || key === ' ';
            if (isSpaceOrEnter) {
                toggleSideBar(event);
                event.preventDefault();
            }
            if (isLeftOrTopArrow || isRightOrBottomArrow) {
                event.preventDefault();
                onResizeStart && onResizeStart(leftSidebarState);
                const step = 10;
                const stepValue = isLeftOrTopArrow ? -step : step;
                const { leftSidebarWidth: leftSidebarWidth } = leftSidebarState;
                const maxWidth = Math.round(window.innerWidth / 2) - (0, (0, parcelRequire("cezmR")).getLeftPanelWidth)();
                const hasModifierKey = event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
                let width = leftSidebarWidth + stepValue;
                if (width <= (0, (0, parcelRequire("fHYEP")).DEFAULT_LEFT_SIDEBAR_WIDTH)) {
                    width = (0, (0, parcelRequire("fHYEP")).DEFAULT_LEFT_SIDEBAR_WIDTH);
                    document.documentElement.style.setProperty(`--${(0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_WIDTH)}`, `${(0, (0, parcelRequire("fHYEP")).DEFAULT_LEFT_SIDEBAR_WIDTH) - 20}px`);
                } else if (width > maxWidth) {
                    width = maxWidth;
                    document.documentElement.style.setProperty(`--${(0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_WIDTH)}`, `${maxWidth + 20}px`);
                } else if (hasModifierKey) width = isRightOrBottomArrow ? maxWidth : (0, (0, parcelRequire("fHYEP")).DEFAULT_LEFT_SIDEBAR_WIDTH);
                requestAnimationFrame(()=>{
                    keyboardEventTimeout.current = window.setTimeout(()=>{
                        keyboardEventTimeout.current && clearTimeout(keyboardEventTimeout.current);
                        document.documentElement.style.setProperty(`--${(0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_WIDTH)}`, `${width}px`);
                        const updatedLeftSidebarState = {
                            ...leftSidebarState,
                            [(0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_WIDTH)]: width,
                            lastLeftSidebarWidth: width
                        };
                        setLeftSidebarState(updatedLeftSidebarState);
                        onResizeEnd && onResizeEnd(updatedLeftSidebarState);
                    }, 50);
                });
            }
        };
        const onFocus = (0, $5uXOq.useCallback)(()=>{
            setIsGrabAreaFocused(true);
        }, []);
        const onBlur = (0, $5uXOq.useCallback)(()=>{
            setIsGrabAreaFocused(false);
        }, []);
        const resizeButton = {
            render: (Component, props)=>(0, (0, parcelRequire("f8Sb3")).jsx)(Component, props),
            ...overrides && overrides.ResizeButton
        };
        const maxAriaWidth = (0, $5uXOq.useMemo)(()=>{
            const innerWidth = typeof window === 'undefined' ? 0 : window.innerWidth;
            return Math.round(innerWidth / 2) - (0, (0, parcelRequire("cezmR")).getLeftPanelWidth)();
        }, []);
        const leftSidebarPercentageExpanded = (0, (0, parcelRequire("cezmR")).getLeftSidebarPercentage)(leftSidebarState.leftSidebarWidth, maxAriaWidth);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...$d9ccc20e4ce17cbe$var$cssSelector,
            css: [
                $d9ccc20e4ce17cbe$var$resizeControlStyles,
                (isGrabAreaFocused || isLeftSidebarCollapsed) && $d9ccc20e4ce17cbe$var$showResizeButtonStyles
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ll1kD")).default), {
            testId: testId && `${testId}-shadow`
        }), !mobileMediaQuery?.matches && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("d2Ug1")).default), {
            isDisabled: isLeftSidebarCollapsed,
            isLeftSidebarCollapsed: isLeftSidebarCollapsed,
            label: resizeGrabAreaLabel,
            valueTextLabel: valueTextLabel,
            leftSidebarPercentageExpanded: leftSidebarPercentageExpanded,
            onBlur: onBlur,
            onFocus: onFocus,
            onKeyDown: onKeyDown,
            onMouseDown: onMouseDown,
            testId: testId && `${testId}-grab-area`
        }), resizeButton.render((0, (0, parcelRequire("dVGMm")).default), {
            isLeftSidebarCollapsed: mobileMediaQuery?.matches ? !leftSidebarState.isFlyoutOpen : isLeftSidebarCollapsed,
            label: resizeButtonLabel,
            onClick: toggleSideBar,
            testId: testId && `${testId}-resize-button`
        })), leftSidebarState.isResizing ? (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("f8Sb3")).Global), {
            styles: $d9ccc20e4ce17cbe$var$globalResizingStyles
        }) : null);
    };
    var $d9ccc20e4ce17cbe$export$2e2bcd8739ae039 = $d9ccc20e4ce17cbe$var$ResizeControl;
});
parcelRegister("d2Ug1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5a006b6a5e7920b1$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $fHYEP;
    function $5a006b6a5e7920b1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5a006b6a5e7920b1$var$varLineColor = '--ds-line';
    const $5a006b6a5e7920b1$var$grabAreaStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: "var(--ds-space-200, 16px)",
        height: '100%',
        padding: 0,
        backgroundColor: 'transparent',
        border: 0,
        cursor: 'ew-resize',
        '&::-moz-focus-inner': {
            border: 0
        },
        '&:focus': {
            outline: 0
        },
        '&:enabled:hover, &:enabled:focus, &:enabled:active': {
            [$5a006b6a5e7920b1$var$varLineColor]: `var(--ds-border-selected, ${(0, $5e0c0d4e15efb4a6$export$215b7063051591f1)})`
        }
    });
    const $5a006b6a5e7920b1$var$grabAreaCollapsedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        height: `calc(100% - ${"var(--ds-space-600, 3rem)"} * 2)`,
        padding: 0,
        position: 'absolute',
        backgroundColor: 'transparent',
        border: 0,
        cursor: 'default',
        insetBlockEnd: 0
    });
    const $5a006b6a5e7920b1$var$lineStyles = {
        name: "w4swnc",
        styles: "display:block;width:var(--ds-border-width-outline, 2px);height:100%;background-color:var(--ds-line);transition:background-color 200ms"
    };
    const $5a006b6a5e7920b1$var$grabAreaLineSelector = {
        [(0, (0, parcelRequire("fHYEP")).GRAB_AREA_LINE_SELECTOR)]: true
    };
    const $5a006b6a5e7920b1$var$grabAreaSelector = {
        [(0, (0, parcelRequire("fHYEP")).GRAB_AREA_SELECTOR)]: true
    };
    const $5a006b6a5e7920b1$var$GrabArea = ({ testId: testId, valueTextLabel: valueTextLabel = 'Width', isDisabled: isDisabled, isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, leftSidebarPercentageExpanded: leftSidebarPercentageExpanded, onKeyDown: onKeyDown, onMouseDown: onMouseDown, onBlur: onBlur, onFocus: onFocus, ref: ref, ...rest })=>(0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            ...$5a006b6a5e7920b1$var$grabAreaSelector,
            "aria-label": label,
            "data-testid": testId,
            disabled: isDisabled,
            "aria-hidden": isLeftSidebarCollapsed,
            type: "button",
            role: "slider",
            css: [
                $5a006b6a5e7920b1$var$grabAreaStyles,
                isLeftSidebarCollapsed && $5a006b6a5e7920b1$var$grabAreaCollapsedStyles
            ],
            "aria-orientation": "vertical",
            "aria-valuenow": leftSidebarPercentageExpanded,
            "aria-valuemin": 0,
            "aria-valuemax": 100,
            "aria-valuetext": `${valueTextLabel} ${leftSidebarPercentageExpanded}%`,
            onKeyDown: onKeyDown,
            onMouseDown: onMouseDown,
            onFocus: onFocus,
            onBlur: onBlur,
            ...rest
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $5a006b6a5e7920b1$var$lineStyles,
            ...$5a006b6a5e7920b1$var$grabAreaLineSelector
        }));
    var $5a006b6a5e7920b1$export$2e2bcd8739ae039 = $5a006b6a5e7920b1$var$GrabArea;
});
parcelRegister("dVGMm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$52762aaa575fcf8d$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $c6iVP;
    var $5RJ99;
    var $2MVcM;
    var $fHYEP;
    function $52762aaa575fcf8d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $52762aaa575fcf8d$var$increaseHitAreaStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'absolute',
        insetBlockEnd: `${"var(--ds-space-negative-300, -24px)"}`,
        insetBlockStart: `${"var(--ds-space-negative-300, -24px)"}`,
        insetInlineEnd: `${"var(--ds-space-negative-150, -12px)"}`,
        insetInlineStart: `${"var(--ds-space-negative-100, -8px)"}`
    });
    const $52762aaa575fcf8d$var$mobileStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [(0, (0, parcelRequire("2MVcM")).UNSAFE_media).below.sm]: {
            opacity: 1
        }
    });
    const $52762aaa575fcf8d$var$resizeIconButtonStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 24,
        height: 24,
        padding: "var(--ds-space-0, 0px)",
        position: 'absolute',
        backgroundColor: `var(--ds-surface-overlay, ${(0, $5e0c0d4e15efb4a6$export$29a4f05edc054374)})`,
        border: 0,
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        boxShadow: `0 0 0 1px ${(0, $5e0c0d4e15efb4a6$export$920c0d5c49070351)}, 0 2px 4px 1px ${(0, $5e0c0d4e15efb4a6$export$920c0d5c49070351)}`,
        color: `var(--ds-text-subtle, ${(0, $5e0c0d4e15efb4a6$export$f563ee71e9ee74cd)})`,
        cursor: 'pointer',
        insetBlockStart: "var(--ds-space-400, 32px)",
        insetInlineStart: 0,
        opacity: `var(--ds--resize-button--opacity,0)`,
        outline: 0,
        transform: 'translateX(-50%)',
        transition: `
    background-color ${(0, (0, parcelRequire("5RJ99")).smallDurationMs)}ms linear,
    color ${(0, (0, parcelRequire("5RJ99")).smallDurationMs)}ms linear,
    opacity ${(0, (0, parcelRequire("5RJ99")).mediumDurationMs)}ms ${(0, $afa89fc5bcc96d10$export$57636bb43b1ccbb0)}
  `,
        ':hover': {
            backgroundColor: `var(--ds-background-selected-bold, ${(0, $5e0c0d4e15efb4a6$export$ecfc1dff386a3e7a)})`,
            color: `var(--ds-text-inverse, ${(0, $5e0c0d4e15efb4a6$export$29a4f05edc054374)})`,
            opacity: 1
        },
        ':active, :focus': {
            backgroundColor: `var(--ds-background-selected-bold-hovered, ${(0, $5e0c0d4e15efb4a6$export$215b7063051591f1)})`,
            color: `var(--ds-text-inverse, ${(0, $5e0c0d4e15efb4a6$export$29a4f05edc054374)})`,
            opacity: 1
        }
    });
    const $52762aaa575fcf8d$var$resizeIconButtonExpandedStyles = {
        name: "1bl2513",
        styles: "transform:rotate(180deg);transform-origin:7px"
    };
    const $52762aaa575fcf8d$var$preventDefault = (event)=>event.preventDefault();
    const $52762aaa575fcf8d$var$cssSelector = {
        [(0, (0, parcelRequire("fHYEP")).RESIZE_BUTTON_SELECTOR)]: true
    };
    const $52762aaa575fcf8d$var$ResizeButton = ({ isLeftSidebarCollapsed: isLeftSidebarCollapsed, label: label, testId: testId, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("button", {
            ...$52762aaa575fcf8d$var$cssSelector,
            "aria-expanded": !isLeftSidebarCollapsed,
            "aria-label": label,
            type: "button",
            css: [
                $52762aaa575fcf8d$var$resizeIconButtonStyles,
                $52762aaa575fcf8d$var$mobileStyles,
                !isLeftSidebarCollapsed && $52762aaa575fcf8d$var$resizeIconButtonExpandedStyles
            ],
            "data-testid": testId,
            onMouseDown: $52762aaa575fcf8d$var$preventDefault,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("c6iVP"))))), {
            label: "",
            color: "currentColor"
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $52762aaa575fcf8d$var$increaseHitAreaStyles
        }));
    var $52762aaa575fcf8d$export$2e2bcd8739ae039 = $52762aaa575fcf8d$var$ResizeButton;
});
parcelRegister("ll1kD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e5cbbcb4c02eeb9$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $3pYaK;
    const $7e5cbbcb4c02eeb9$var$colorStops = `
    rgba(0, 0, 0, 0.2) 0px,
    rgba(0, 0, 0, 0.2) 1px,
    rgba(0, 0, 0, 0.1) 1px,
    rgba(0, 0, 0, 0) 100%
  `;
    const $7e5cbbcb4c02eeb9$var$direction = 'to left';
    const $7e5cbbcb4c02eeb9$var$transitionDuration = '0.22s';
    const $7e5cbbcb4c02eeb9$var$shadowStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 3,
        position: 'absolute',
        background: `var(--ds-border, ${`linear-gradient(${$7e5cbbcb4c02eeb9$var$direction}, ${$7e5cbbcb4c02eeb9$var$colorStops})`})`,
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineStart: -1,
        opacity: 0.5,
        pointerEvents: 'none',
        transitionDuration: $7e5cbbcb4c02eeb9$var$transitionDuration,
        transitionProperty: 'left, opacity, width',
        transitionTimingFunction: (0, $afa89fc5bcc96d10$export$57636bb43b1ccbb0)
    });
    const $7e5cbbcb4c02eeb9$var$draggingStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 6,
        background: `var(--ds-background-neutral-subtle, ${`linear-gradient(${$7e5cbbcb4c02eeb9$var$direction}, ${$7e5cbbcb4c02eeb9$var$colorStops})`})`,
        insetInlineStart: "var(--ds-space-negative-075, -6px)",
        opacity: 0.8
    });
    const $7e5cbbcb4c02eeb9$var$Shadow = ({ testId: testId })=>{
        const isDragging = (0, (0, parcelRequire("3pYaK")).default)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            "data-testid": testId,
            css: [
                $7e5cbbcb4c02eeb9$var$shadowStyles,
                isDragging && $7e5cbbcb4c02eeb9$var$draggingStyles
            ]
        });
    };
    var $7e5cbbcb4c02eeb9$export$2e2bcd8739ae039 = $7e5cbbcb4c02eeb9$var$Shadow;
});
parcelRegister("3pYaK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c93633963fcd60ba$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fHYEP;
    const $c93633963fcd60ba$var$getIsDragging = ()=>{
        if (typeof document === 'undefined') return false;
        return document.documentElement.getAttribute((0, (0, parcelRequire("fHYEP")).IS_SIDEBAR_DRAGGING)) === 'true';
    };
    const $c93633963fcd60ba$var$useIsSidebarDragging = ()=>{
        const [isDragging, setIsDragging] = (0, $5uXOq.useState)($c93633963fcd60ba$var$getIsDragging);
        (0, $5uXOq.useEffect)(()=>{
            const observer = new MutationObserver(()=>{
                setIsDragging($c93633963fcd60ba$var$getIsDragging);
            });
            observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, (0, parcelRequire("fHYEP")).IS_SIDEBAR_DRAGGING)
                ]
            });
            return ()=>{
                observer.disconnect();
            };
        }, []);
        return isDragging;
    };
    var $c93633963fcd60ba$export$2e2bcd8739ae039 = $c93633963fcd60ba$var$useIsSidebarDragging;
});
parcelRegister("i9c1D", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dacbf872371c79ba$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $e6DOJ;
    var $2MVcM;
    var $fHYEP;
    var $3pYaK;
    function $dacbf872371c79ba$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $dacbf872371c79ba$var$prefersReducedMotionStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("e6DOJ")).prefersReducedMotion)());
    const $dacbf872371c79ba$var$mobileStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [(0, (0, parcelRequire("2MVcM")).UNSAFE_media).below.sm]: {
            width: `${(0, (0, parcelRequire("fHYEP")).MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH)}px`,
            position: 'fixed',
            insetBlockEnd: 0,
            insetBlockStart: `calc(${(0, (0, parcelRequire("fHYEP")).BANNER_HEIGHT)} + ${(0, (0, parcelRequire("fHYEP")).TOP_NAVIGATION_HEIGHT)})`,
            insetInlineStart: `${(0, (0, parcelRequire("fHYEP")).LEFT_PANEL_WIDTH)}`,
            transition: `width ${(0, (0, parcelRequire("fHYEP")).TRANSITION_DURATION)}ms ${(0, $afa89fc5bcc96d10$export$57636bb43b1ccbb0)} 0s`
        }
    });
    const $dacbf872371c79ba$var$mobileInnerFlyoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [(0, (0, parcelRequire("2MVcM")).UNSAFE_media).below.sm]: {
            width: `min(90vw, ${(0, (0, parcelRequire("fHYEP")).MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH)}px)`,
            maxWidth: (0, (0, parcelRequire("fHYEP")).MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
            transition: `width ${(0, (0, parcelRequire("fHYEP")).TRANSITION_DURATION)}ms ${(0, $afa89fc5bcc96d10$export$57636bb43b1ccbb0)} 0s, box-shadow ${(0, (0, parcelRequire("fHYEP")).TRANSITION_DURATION)}ms ${(0, $afa89fc5bcc96d10$export$57636bb43b1ccbb0)} 0s`
        }
    });
    const $dacbf872371c79ba$var$fixedInnerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: `${(0, (0, parcelRequire("fHYEP")).LEFT_SIDEBAR_WIDTH)}`,
        position: 'fixed',
        insetBlockEnd: 0,
        insetBlockStart: `calc(${(0, (0, parcelRequire("fHYEP")).BANNER_HEIGHT)} + ${(0, (0, parcelRequire("fHYEP")).TOP_NAVIGATION_HEIGHT)})`,
        insetInlineStart: `${(0, (0, parcelRequire("fHYEP")).LEFT_PANEL_WIDTH)}`,
        transition: `width ${(0, (0, parcelRequire("fHYEP")).TRANSITION_DURATION)}ms ${(0, $afa89fc5bcc96d10$export$57636bb43b1ccbb0)} 0s`
    });
    const $dacbf872371c79ba$var$fixedInnerFlyoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("fHYEP")).LEFT_SIDEBAR_FLYOUT_WIDTH)
    });
    const $dacbf872371c79ba$var$staticInnerStyles = {
        name: "13udsys",
        styles: "height:100%"
    };
    const $dacbf872371c79ba$var$draggingStyles = {
        name: "jlx54q",
        styles: "cursor:ew-resize;transition:none"
    };
    const $dacbf872371c79ba$var$LeftSidebarInner = ({ children: children, isFixed: isFixed = false, isFlyoutOpen: isFlyoutOpen = false })=>{
        const isDragging = (0, (0, parcelRequire("3pYaK")).default)();
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $dacbf872371c79ba$var$mobileStyles,
                isFlyoutOpen && $dacbf872371c79ba$var$mobileInnerFlyoutStyles,
                !isFixed && $dacbf872371c79ba$var$staticInnerStyles,
                isFixed && $dacbf872371c79ba$var$fixedInnerStyles,
                isFixed && isFlyoutOpen && $dacbf872371c79ba$var$fixedInnerFlyoutStyles,
                isDragging && $dacbf872371c79ba$var$draggingStyles,
                $dacbf872371c79ba$var$prefersReducedMotionStyles
            ]
        }, children);
    };
    var $dacbf872371c79ba$export$2e2bcd8739ae039 = $dacbf872371c79ba$var$LeftSidebarInner;
});
parcelRegister("03HQf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8277002fa69fcc34$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $e6DOJ;
    var $2MVcM;
    var $fHYEP;
    var $3pYaK;
    var $cezmR;
    var $jEQgO;
    var $2uhGC;
    function $8277002fa69fcc34$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $8277002fa69fcc34$var$prefersReducedMotionStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("e6DOJ")).prefersReducedMotion)());
    const $8277002fa69fcc34$var$mobileStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [(0, (0, parcelRequire("2MVcM")).UNSAFE_media).below.sm]: {
            width: (0, (0, parcelRequire("fHYEP")).MOBILE_COLLAPSED_LEFT_SIDEBAR_WIDTH),
            cursor: 'pointer',
            opacity: 1,
            transition: `width ${(0, (0, parcelRequire("fHYEP")).TRANSITION_DURATION)}ms ${(0, $afa89fc5bcc96d10$export$57636bb43b1ccbb0)} 0s`,
            '&::after': {
                display: 'inline-block',
                maxWidth: (0, (0, parcelRequire("fHYEP")).MAX_MOBILE_SIDEBAR_FLYOUT_WIDTH),
                content: "''"
            }
        }
    });
    const $8277002fa69fcc34$var$mobileFlyoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [(0, (0, parcelRequire("2MVcM")).UNSAFE_media).below.sm]: {
            cursor: 'revert'
        }
    });
    const $8277002fa69fcc34$var$outerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("fHYEP")).LEFT_SIDEBAR_WIDTH),
        position: 'relative',
        zIndex: 1,
        marginInlineStart: "var(--ds-space-0, 0px)",
        transition: `width ${(0, (0, parcelRequire("fHYEP")).TRANSITION_DURATION)}ms ${(0, $afa89fc5bcc96d10$export$57636bb43b1ccbb0)} 0s`,
        ':hover': {
            '--ds--resize-button--opacity': 1
        }
    });
    const $8277002fa69fcc34$var$draggingStyles = {
        name: "jlx54q",
        styles: "cursor:ew-resize;transition:none"
    };
    const $8277002fa69fcc34$var$fixedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '::after': {
            display: 'inline-block',
            width: `${(0, (0, parcelRequire("fHYEP")).LEFT_SIDEBAR_WIDTH)}`,
            content: "''"
        }
    });
    const $8277002fa69fcc34$var$flyoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("fHYEP")).LEFT_SIDEBAR_FLYOUT_WIDTH)
    });
    const $8277002fa69fcc34$var$flyoutFixedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("fHYEP")).COLLAPSED_LEFT_SIDEBAR_WIDTH)
    });
    const $8277002fa69fcc34$var$selector = (0, (0, parcelRequire("cezmR")).getPageLayoutSlotSelector)('left-sidebar');
    const $8277002fa69fcc34$var$LeftSidebarOuterComponent = ({ children: children, isFixed: isFixed = false, testId: testId, onMouseLeave: onMouseLeave, onMouseOver: onMouseOver, onClick: onClick, id: id }, ref)=>{
        const isDragging = (0, (0, parcelRequire("3pYaK")).default)();
        const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen } } = (0, $5uXOq.useContext)((0, (0, parcelRequire("jEQgO")).SidebarResizeContext));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2uhGC")).default), {
            isSidebar: true
        }, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $8277002fa69fcc34$var$mobileStyles,
                    isFlyoutOpen && $8277002fa69fcc34$var$mobileFlyoutStyles,
                    $8277002fa69fcc34$var$outerStyles,
                    isFixed && $8277002fa69fcc34$var$fixedStyles,
                    isFlyoutOpen && $8277002fa69fcc34$var$flyoutStyles,
                    isFlyoutOpen && isFixed && $8277002fa69fcc34$var$flyoutFixedStyles,
                    isDragging && $8277002fa69fcc34$var$draggingStyles,
                    $8277002fa69fcc34$var$prefersReducedMotionStyles
                ],
                className: className,
                "data-testid": testId,
                id: id,
                onMouseOver: onMouseOver,
                onMouseLeave: onMouseLeave,
                onClick: onClick,
                ref: ref,
                ...$8277002fa69fcc34$var$selector
            }, children));
    };
    const $8277002fa69fcc34$var$LeftSidebarOuter = (0, $5uXOq.forwardRef)($8277002fa69fcc34$var$LeftSidebarOuterComponent);
    var $8277002fa69fcc34$export$2e2bcd8739ae039 = $8277002fa69fcc34$var$LeftSidebarOuter;
});
parcelRegister("exbKs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d41ea2d5e544073e$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $e6DOJ;
    var $fHYEP;
    var $5gMp4;
    function $d41ea2d5e544073e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $d41ea2d5e544073e$var$prefersReducedMotionStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("e6DOJ")).prefersReducedMotion)());
    const $d41ea2d5e544073e$var$hideLeftSidebarContentsStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        opacity: 0,
        transition: `opacity 0ms linear, visibility 0ms linear`,
        transitionDelay: `${(0, (0, parcelRequire("fHYEP")).TRANSITION_DURATION) - 100}ms`,
        visibility: 'hidden'
    });
    const $d41ea2d5e544073e$var$resizableChildrenWrapperStyles = {
        name: "xz78rr",
        styles: "height:100%;opacity:1;overflow:hidden auto;transition:none;visibility:visible"
    };
    const $d41ea2d5e544073e$var$fixedChildrenWrapperStyles = {
        name: "ax3w45",
        styles: "min-width:240px;height:100%"
    };
    const $d41ea2d5e544073e$var$ResizableChildrenWrapper = ({ children: children, isLeftSidebarCollapsed: isLeftSidebarCollapsed = false, hasCollapsedState: hasCollapsedState = false, isFlyoutOpen: isFlyoutOpen = false, testId: testId })=>{
        const isCollapsing = (0, (0, parcelRequire("5gMp4")).default)();
        const isCollapsed = isLeftSidebarCollapsed || hasCollapsedState;
        const isHidden = isCollapsing || isCollapsed && !isFlyoutOpen;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $d41ea2d5e544073e$var$resizableChildrenWrapperStyles,
                isHidden && $d41ea2d5e544073e$var$hideLeftSidebarContentsStyles,
                $d41ea2d5e544073e$var$prefersReducedMotionStyles
            ],
            "aria-hidden": isHidden,
            "data-testid": testId
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $d41ea2d5e544073e$var$fixedChildrenWrapperStyles
        }, children));
    };
    var $d41ea2d5e544073e$export$2e2bcd8739ae039 = $d41ea2d5e544073e$var$ResizableChildrenWrapper;
});
parcelRegister("5gMp4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$230994ef23fd627e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $fHYEP;
    const $230994ef23fd627e$var$getIsCollapsing = ()=>{
        if (typeof document === 'undefined') return false;
        return document.documentElement.getAttribute((0, (0, parcelRequire("fHYEP")).IS_SIDEBAR_COLLAPSING)) === 'true';
    };
    const $230994ef23fd627e$var$useIsSidebarCollapsing = ()=>{
        const [isCollapsing, setIsCollapsing] = (0, $5uXOq.useState)($230994ef23fd627e$var$getIsCollapsing);
        (0, $5uXOq.useEffect)(()=>{
            const observer = new MutationObserver(()=>{
                setIsCollapsing($230994ef23fd627e$var$getIsCollapsing);
            });
            observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, (0, parcelRequire("fHYEP")).IS_SIDEBAR_COLLAPSING)
                ]
            });
            return ()=>{
                observer.disconnect();
            };
        }, []);
        return isCollapsing;
    };
    var $230994ef23fd627e$export$2e2bcd8739ae039 = $230994ef23fd627e$var$useIsSidebarCollapsing;
});
parcelRegister("1xtlh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3e9403394cdada4c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $fHYEP;
    var $cezmR;
    var $1nim3;
    var $4wf0T;
    var $i9c1D;
    var $03HQf;
    var $39rJx;
    const $3e9403394cdada4c$var$LeftSidebarWithoutResize = (props)=>{
        const { children: children, id: id, width: width, isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, skipLinkTitle: skipLinkTitle } = props;
        const leftSidebarWidth = (0, (0, parcelRequire("cezmR")).resolveDimension)((0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_WIDTH), width, shouldPersistWidth);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("1nim3")).default)({
                [(0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_WIDTH)]: leftSidebarWidth
            });
            return ()=>{
                (0, (0, parcelRequire("1nim3")).default)({
                    [(0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_WIDTH)]: 0
                });
            };
        }, [
            leftSidebarWidth
        ]);
        (0, (0, parcelRequire("4wf0T")).useSkipLink)(id, skipLinkTitle);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("03HQf")).default), {
            id: id,
            testId: testId,
            isFixed: isFixed
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("39rJx")).default), {
            variableName: (0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_WIDTH),
            value: leftSidebarWidth
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("i9c1D")).default), {
            isFixed: isFixed
        }, children));
    };
    var $3e9403394cdada4c$export$2e2bcd8739ae039 = $3e9403394cdada4c$var$LeftSidebarWithoutResize;
});
parcelRegister("8T5bc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$da057397424da789$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $e6DOJ;
    var $fHYEP;
    var $3pYaK;
    var $cezmR;
    var $jEQgO;
    var $4wf0T;
    var $2uhGC;
    function $da057397424da789$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $da057397424da789$var$prefersReducedMotionStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("e6DOJ")).prefersReducedMotion)());
    const $da057397424da789$var$mainStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: 0,
        flexGrow: 1,
        marginInlineStart: 0,
        transition: `margin-left ${(0, (0, parcelRequire("fHYEP")).TRANSITION_DURATION)}ms ${(0, $afa89fc5bcc96d10$export$57636bb43b1ccbb0)} 0s`
    });
    const $da057397424da789$var$draggingStyles = {
        name: "1wx2bp",
        styles: "transition:none"
    };
    const $da057397424da789$var$flyoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        marginInlineStart: `calc(-1 * var(--${(0, (0, parcelRequire("fHYEP")).VAR_LEFT_SIDEBAR_FLYOUT)}, ${(0, (0, parcelRequire("fHYEP")).DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH)}px) + ${(0, (0, parcelRequire("fHYEP")).COLLAPSED_LEFT_SIDEBAR_WIDTH)}px)`
    });
    const $da057397424da789$var$Main = (props)=>{
        const { children: children, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
        (0, (0, parcelRequire("4wf0T")).useSkipLink)(id, skipLinkTitle);
        const isDragging = (0, (0, parcelRequire("3pYaK")).default)();
        const { leftSidebarState: { isFlyoutOpen: isFlyoutOpen, isFixed: isFixed } } = (0, $5uXOq.useContext)((0, (0, parcelRequire("jEQgO")).SidebarResizeContext));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2uhGC")).default), null, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("main", {
                "data-testid": testId,
                css: [
                    $da057397424da789$var$mainStyles,
                    isDragging && $da057397424da789$var$draggingStyles,
                    isFlyoutOpen && !isFixed && $da057397424da789$var$flyoutStyles,
                    $da057397424da789$var$prefersReducedMotionStyles
                ],
                className: className,
                id: id,
                ...(0, (0, parcelRequire("cezmR")).getPageLayoutSlotSelector)('main')
            }, children));
    };
    var $da057397424da789$export$2e2bcd8739ae039 = $da057397424da789$var$Main;
});
parcelRegister("igz9V", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e95ccfcb16cd9018$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2MVcM;
    var $fHYEP;
    var $fZnoJ;
    var $5bkGh;
    var $14nIg;
    const $e95ccfcb16cd9018$var$pageLayoutSelector = {
        [(0, (0, parcelRequire("fHYEP")).PAGE_LAYOUT_CONTAINER_SELECTOR)]: true
    };
    const $e95ccfcb16cd9018$var$gridTemplateAreasMobile = `
${''}
  "${(0, (0, parcelRequire("fHYEP")).LEFT_PANEL)} ${(0, (0, parcelRequire("fHYEP")).BANNER)}"
  ${''}
  "${(0, (0, parcelRequire("fHYEP")).LEFT_PANEL)} ${(0, (0, parcelRequire("fHYEP")).TOP_NAVIGATION)}"
  ${''}
  "${(0, (0, parcelRequire("fHYEP")).LEFT_PANEL)} ${(0, (0, parcelRequire("fHYEP")).CONTENT)}"
 `;
    const $e95ccfcb16cd9018$var$gridTemplateAreas = `
${''}
  "${(0, (0, parcelRequire("fHYEP")).LEFT_PANEL)} ${(0, (0, parcelRequire("fHYEP")).BANNER)} ${(0, (0, parcelRequire("fHYEP")).RIGHT_PANEL)}"
  ${''}
  "${(0, (0, parcelRequire("fHYEP")).LEFT_PANEL)} ${(0, (0, parcelRequire("fHYEP")).TOP_NAVIGATION)} ${(0, (0, parcelRequire("fHYEP")).RIGHT_PANEL)}"
${''}
  "${(0, (0, parcelRequire("fHYEP")).LEFT_PANEL)} ${(0, (0, parcelRequire("fHYEP")).CONTENT)} ${(0, (0, parcelRequire("fHYEP")).RIGHT_PANEL)}"
 `;
    const $e95ccfcb16cd9018$var$gridStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'grid',
        height: '100%',
        gridTemplateAreas: $e95ccfcb16cd9018$var$gridTemplateAreas,
        gridTemplateColumns: `${(0, (0, parcelRequire("fHYEP")).LEFT_PANEL_WIDTH)} minmax(0, 1fr) ${(0, (0, parcelRequire("fHYEP")).RIGHT_PANEL_WIDTH)}`,
        gridTemplateRows: `${(0, (0, parcelRequire("fHYEP")).BANNER_HEIGHT)} ${(0, (0, parcelRequire("fHYEP")).TOP_NAVIGATION_HEIGHT)} auto`,
        outline: 'none'
    });
    const $e95ccfcb16cd9018$var$gridStylesMobileStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        [(0, (0, parcelRequire("2MVcM")).UNSAFE_media).below.sm]: {
            gridTemplateAreas: $e95ccfcb16cd9018$var$gridTemplateAreasMobile,
            gridTemplateColumns: `${(0, (0, parcelRequire("fHYEP")).LEFT_PANEL_WIDTH)} minmax(0, 1fr)`
        }
    });
    const $e95ccfcb16cd9018$var$PageLayout = ({ skipLinksLabel: skipLinksLabel = (0, (0, parcelRequire("fHYEP")).DEFAULT_I18N_PROPS_SKIP_LINKS), children: children, testId: testId, onLeftSidebarExpand: onLeftSidebarExpand, onLeftSidebarCollapse: onLeftSidebarCollapse })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("5bkGh")).SkipLinksController), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("14nIg")).SkipLinkWrapper), {
            skipLinksLabel: skipLinksLabel
        }), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...$e95ccfcb16cd9018$var$pageLayoutSelector,
            "data-testid": testId,
            css: [
                $e95ccfcb16cd9018$var$gridStyles,
                $e95ccfcb16cd9018$var$gridStylesMobileStyles
            ],
            tabIndex: -1,
            "data-vc": "page-layout"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fZnoJ")).SidebarResizeController), {
            onLeftSidebarCollapse: onLeftSidebarCollapse,
            onLeftSidebarExpand: onLeftSidebarExpand
        }, children))));
    };
    var $e95ccfcb16cd9018$export$2e2bcd8739ae039 = $e95ccfcb16cd9018$var$PageLayout;
});
parcelRegister("fZnoJ", function(module, exports) {
    $parcel$export(module.exports, "SidebarResizeController", ()=>$3275a4cd359e24d9$export$850bd1bba41f1448);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $ePBXU;
    var $e6DOJ;
    var $d4KoR;
    var $fHYEP;
    var $cezmR;
    var $jEQgO;
    const $3275a4cd359e24d9$var$handleDataAttributesAndCb = (callback = (0, (0, parcelRequire("ePBXU")).default), leftSidebarState)=>{
        document.documentElement.removeAttribute((0, (0, parcelRequire("fHYEP")).IS_SIDEBAR_COLLAPSING));
        callback(leftSidebarState);
    };
    const $3275a4cd359e24d9$var$leftSidebarSelector = (0, (0, parcelRequire("cezmR")).getPageLayoutSlotCSSSelector)('left-sidebar');
    const $3275a4cd359e24d9$export$850bd1bba41f1448 = ({ children: children, onLeftSidebarExpand: onExpand, onLeftSidebarCollapse: onCollapse })=>{
        const [leftSidebarState, setLeftSidebarState] = (0, $5uXOq.useState)({
            isFlyoutOpen: false,
            isResizing: false,
            isLeftSidebarCollapsed: false,
            leftSidebarWidth: 0,
            lastLeftSidebarWidth: 0,
            flyoutLockCount: 0,
            isFixed: true
        });
        const { leftSidebarWidth: leftSidebarWidth, lastLeftSidebarWidth: lastLeftSidebarWidth, isResizing: isResizing, flyoutLockCount: flyoutLockCount, isFixed: isFixed, isLeftSidebarCollapsed: isLeftSidebarCollapsed, isFlyoutOpen: isFlyoutOpen } = leftSidebarState;
        const stableRef = (0, $5uXOq.useRef)({
            onExpand: onExpand,
            onCollapse: onCollapse
        });
        (0, $5uXOq.useEffect)(()=>{
            stableRef.current = {
                onExpand: onExpand,
                onCollapse: onCollapse
            };
        }, [
            onExpand,
            onCollapse
        ]);
        const transition = (0, $5uXOq.useRef)(null);
        const mobileMediaQuery = (0, (0, parcelRequire("d4KoR")).UNSAFE_useMediaQuery)('below.sm');
        const isOpen = mobileMediaQuery?.matches ? isFlyoutOpen : !isLeftSidebarCollapsed;
        const expandLeftSidebar = (0, $5uXOq.useCallback)(()=>{
            if (isOpen) return;
            if (mobileMediaQuery?.matches) {
                const flyoutOpenSidebarState = {
                    isResizing: false,
                    isLeftSidebarCollapsed: true,
                    leftSidebarWidth: (0, (0, parcelRequire("fHYEP")).COLLAPSED_LEFT_SIDEBAR_WIDTH),
                    lastLeftSidebarWidth: leftSidebarWidth,
                    isFlyoutOpen: true,
                    flyoutLockCount: 0,
                    isFixed: isFixed
                };
                setLeftSidebarState(flyoutOpenSidebarState);
                transition.current?.complete();
                $3275a4cd359e24d9$var$handleDataAttributesAndCb(stableRef.current.onExpand, flyoutOpenSidebarState);
                return;
            }
            if (isResizing || !isLeftSidebarCollapsed || transition.current?.action === 'expand') return;
            transition.current?.complete();
            const width = Math.max(lastLeftSidebarWidth, (0, (0, parcelRequire("fHYEP")).DEFAULT_LEFT_SIDEBAR_WIDTH));
            const updatedLeftSidebarState = {
                isLeftSidebarCollapsed: false,
                isFlyoutOpen: false,
                leftSidebarWidth: width,
                lastLeftSidebarWidth: lastLeftSidebarWidth,
                isResizing: isResizing,
                flyoutLockCount: flyoutLockCount,
                isFixed: isFixed
            };
            setLeftSidebarState(updatedLeftSidebarState);
            function finish() {
                $3275a4cd359e24d9$var$handleDataAttributesAndCb(stableRef.current.onExpand, updatedLeftSidebarState);
            }
            const sidebar = document.querySelector($3275a4cd359e24d9$var$leftSidebarSelector);
            if ((0, (0, parcelRequire("e6DOJ")).isReducedMotion)() || !sidebar) {
                finish();
                return;
            }
            const unbindEvent = (0, (0, parcelRequire("cBeZP")).bind)(sidebar, {
                type: 'transitionend',
                listener (event) {
                    if (event.target === sidebar && event.propertyName === 'width') transition.current?.complete();
                }
            });
            const value = {
                action: 'expand',
                complete: ()=>{
                    value.abort();
                    finish();
                },
                abort: ()=>{
                    unbindEvent();
                    transition.current = null;
                }
            };
            transition.current = value;
        }, [
            isOpen,
            mobileMediaQuery,
            isResizing,
            isLeftSidebarCollapsed,
            lastLeftSidebarWidth,
            flyoutLockCount,
            isFixed,
            leftSidebarWidth
        ]);
        const collapseLeftSidebar = (0, $5uXOq.useCallback)((event, collapseWithoutTransition)=>{
            if (!isOpen) return;
            if (mobileMediaQuery?.matches) {
                const flyoutCloseSidebarState = {
                    isResizing: false,
                    isLeftSidebarCollapsed: true,
                    leftSidebarWidth: (0, (0, parcelRequire("fHYEP")).COLLAPSED_LEFT_SIDEBAR_WIDTH),
                    lastLeftSidebarWidth: lastLeftSidebarWidth,
                    isFlyoutOpen: false,
                    flyoutLockCount: 0,
                    isFixed: isFixed
                };
                setLeftSidebarState(flyoutCloseSidebarState);
                transition.current?.complete();
                $3275a4cd359e24d9$var$handleDataAttributesAndCb(stableRef.current.onCollapse, flyoutCloseSidebarState);
                return;
            }
            if (isResizing || isLeftSidebarCollapsed || transition.current?.action === 'collapse') return;
            transition.current?.complete();
            document.documentElement.setAttribute((0, (0, parcelRequire("fHYEP")).IS_SIDEBAR_COLLAPSING), 'true');
            const updatedLeftSidebarState = {
                isLeftSidebarCollapsed: true,
                isFlyoutOpen: false,
                leftSidebarWidth: (0, (0, parcelRequire("fHYEP")).COLLAPSED_LEFT_SIDEBAR_WIDTH),
                lastLeftSidebarWidth: leftSidebarWidth,
                isResizing: isResizing,
                flyoutLockCount: flyoutLockCount,
                isFixed: isFixed
            };
            setLeftSidebarState(updatedLeftSidebarState);
            function finish() {
                $3275a4cd359e24d9$var$handleDataAttributesAndCb(stableRef.current.onCollapse, updatedLeftSidebarState);
            }
            const sidebar = document.querySelector($3275a4cd359e24d9$var$leftSidebarSelector);
            if (collapseWithoutTransition || (0, (0, parcelRequire("e6DOJ")).isReducedMotion)() || !sidebar) {
                finish();
                return;
            }
            const unbindEvent = (0, (0, parcelRequire("cBeZP")).bind)(sidebar, {
                type: 'transitionend',
                listener (event) {
                    if (sidebar === event.target && event.propertyName === 'width') transition.current?.complete();
                }
            });
            const value = {
                action: 'collapse',
                complete: ()=>{
                    value.abort();
                    finish();
                },
                abort: ()=>{
                    unbindEvent();
                    transition.current = null;
                }
            };
            transition.current = value;
        }, [
            isOpen,
            mobileMediaQuery,
            isResizing,
            isLeftSidebarCollapsed,
            leftSidebarWidth,
            flyoutLockCount,
            isFixed,
            lastLeftSidebarWidth
        ]);
        const toggleLeftSidebar = (0, $5uXOq.useCallback)((event, collapseWithoutTransition)=>{
            if (isOpen) collapseLeftSidebar(event, collapseWithoutTransition);
            else expandLeftSidebar();
        }, [
            isOpen,
            expandLeftSidebar,
            collapseLeftSidebar
        ]);
        (0, $5uXOq.useEffect)(function mount() {
            return function unmount() {
                transition.current?.abort();
            };
        }, []);
        const context = (0, $5uXOq.useMemo)(()=>({
                isLeftSidebarCollapsed: !isOpen,
                expandLeftSidebar: expandLeftSidebar,
                collapseLeftSidebar: collapseLeftSidebar,
                leftSidebarState: leftSidebarState,
                setLeftSidebarState: setLeftSidebarState,
                toggleLeftSidebar: toggleLeftSidebar
            }), [
            isOpen,
            expandLeftSidebar,
            collapseLeftSidebar,
            leftSidebarState,
            toggleLeftSidebar
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jEQgO")).SidebarResizeContext).Provider, {
            value: context
        }, children);
    };
});
parcelRegister("5bkGh", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksController", ()=>$2e6857b15e75d8a1$export$da7be99d6a868f3d);
    var $5uXOq = parcelRequire("5uXOq");
    var $fHYEP;
    var $4wf0T;
    const $2e6857b15e75d8a1$var$byDOMOrder = (a, b)=>{
        const elems = Array.from(document.querySelectorAll(`[${(0, (0, parcelRequire("fHYEP")).PAGE_LAYOUT_SLOT_SELECTOR)}]`));
        const elemA = document.getElementById(a.id);
        const elemB = document.getElementById(b.id);
        const indexA = a.listIndex ?? elems.indexOf(elemA);
        const indexB = b.listIndex ?? elems.indexOf(elemB);
        if (indexA === indexB) {
            if (a.listIndex !== undefined) return -1;
            else return 1;
        }
        return indexA - indexB;
    };
    const $2e6857b15e75d8a1$export$da7be99d6a868f3d = ({ children: children })=>{
        const [links, setLinks] = (0, $5uXOq.useState)([]);
        const registerSkipLink = (0, $5uXOq.useRef)((skipLinkData)=>{
            setLinks((oldLinks)=>{
                if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
                return [
                    ...oldLinks,
                    skipLinkData
                ].sort($2e6857b15e75d8a1$var$byDOMOrder);
            });
        });
        const unregisterSkipLink = (0, $5uXOq.useRef)((id)=>{
            setLinks((links)=>links.filter((link)=>link.id !== id));
        });
        const context = {
            registerSkipLink: registerSkipLink.current,
            skipLinksData: links,
            unregisterSkipLink: unregisterSkipLink.current
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4wf0T")).SkipLinksContext).Provider, {
            value: context
        }, children);
    };
});
parcelRegister("14nIg", function(module, exports) {
    $parcel$export(module.exports, "SkipLinkWrapper", ()=>$54e4f25ac46ca1ab$export$4241a460557ba901);
    var $f8Sb3;
    var $29ctK;
    var $e6DOJ;
    var $fHYEP;
    var $4wf0T;
    function $54e4f25ac46ca1ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $54e4f25ac46ca1ab$var$prefersReducedMotionStyles = (0, (0, parcelRequire("f8Sb3")).css)((0, (0, parcelRequire("e6DOJ")).prefersReducedMotion)());
    const $54e4f25ac46ca1ab$var$skipLinkStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: "var(--ds-space-250, 10px)",
        padding: '0.8rem 1rem',
        position: 'fixed',
        zIndex: -1,
        background: "var(--ds-surface-overlay, white)",
        border: 'none',
        borderRadius: "var(--ds-border-radius, 3px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $5e0c0d4e15efb4a6$export$920c0d5c49070351)}, 0 2px 10px ${(0, $5e0c0d4e15efb4a6$export$920c0d5c49070351)}, 0 0 20px -4px ${(0, $5e0c0d4e15efb4a6$export$d2d3bedfb276cac0)}`})`,
        insetInlineStart: -999999,
        opacity: 0,
        transform: 'translateY(-50%)',
        transition: `transform 0.3s ${(0, $afa89fc5bcc96d10$export$57636bb43b1ccbb0)}`,
        '&:focus-within': {
            zIndex: 2147483640,
            insetInlineStart: 0,
            opacity: 1,
            transform: 'translateY(0%)'
        }
    });
    const $54e4f25ac46ca1ab$var$skipLinkHeadingStyles = {
        name: "16ceglb",
        styles: "font-weight:600"
    };
    const $54e4f25ac46ca1ab$var$skipLinkListStyles = {
        name: "1xay72g",
        styles: "list-style-position:outside;list-style-type:none;margin-block-start:var(--ds-space-050, 4px);padding-inline-start:0"
    };
    const $54e4f25ac46ca1ab$var$skipLinkListItemStyles = {
        name: "19m435s",
        styles: "margin-block-start:0"
    };
    const $54e4f25ac46ca1ab$var$assignIndex = (num, arr)=>{
        if (!arr.includes(num)) return num;
        return $54e4f25ac46ca1ab$var$assignIndex(num + 1, arr);
    };
    const $54e4f25ac46ca1ab$export$4241a460557ba901 = ({ skipLinksLabel: skipLinksLabel })=>{
        const { skipLinksData: skipLinksData } = (0, (0, parcelRequire("4wf0T")).useSkipLinks)();
        if (skipLinksData.length === 0) return null;
        const sortSkipLinks = (arr)=>{
            const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
            if (customLinks.length === 0) return arr;
            const usedIndexes = customLinks.map((a)=>a.listIndex);
            const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx, currArr)=>{
                const listIndex = $54e4f25ac46ca1ab$var$assignIndex(idx, usedIndexes);
                usedIndexes.push(listIndex);
                return {
                    ...link,
                    listIndex: listIndex
                };
            });
            return [
                ...customLinks,
                ...regularLinksWithIdx
            ].sort((a, b)=>a.listIndex - b.listIndex);
        };
        const escapeHandler = (event)=>{
            if (event.keyCode === 27) {
                const container = document.querySelector(`[${(0, (0, parcelRequire("fHYEP")).PAGE_LAYOUT_CONTAINER_SELECTOR)}="true"]`);
                if (container !== null) container.focus();
            }
        };
        const attachEscHandler = ()=>window.addEventListener('keydown', escapeHandler, false);
        const removeEscHandler = ()=>window.removeEventListener('keydown', escapeHandler, false);
        const emptyLabelOverride = !!skipLinksLabel?.match(/^\s+$/);
        const label = skipLinksLabel || (0, (0, parcelRequire("fHYEP")).DEFAULT_I18N_PROPS_SKIP_LINKS);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            onFocus: attachEscHandler,
            onBlur: removeEscHandler,
            css: [
                $54e4f25ac46ca1ab$var$skipLinkStyles,
                $54e4f25ac46ca1ab$var$prefersReducedMotionStyles
            ],
            "data-skip-link-wrapper": true
        }, emptyLabelOverride ? null : (0, (0, parcelRequire("f8Sb3")).jsx)("p", {
            css: $54e4f25ac46ca1ab$var$skipLinkHeadingStyles
        }, label), (0, (0, parcelRequire("f8Sb3")).jsx)("ol", {
            css: $54e4f25ac46ca1ab$var$skipLinkListStyles
        }, sortSkipLinks(skipLinksData).map(({ id: id, skipLinkTitle: skipLinkTitle })=>(0, (0, parcelRequire("f8Sb3")).jsx)($54e4f25ac46ca1ab$export$ef95c37428582a65, {
                key: id,
                href: `#${id}`,
                isFocusable: true
            }, skipLinkTitle))));
    };
    const $54e4f25ac46ca1ab$var$handleBlur = (event)=>{
        event.target.removeAttribute('tabindex');
        event.target.removeEventListener('blur', $54e4f25ac46ca1ab$var$handleBlur);
    };
    const $54e4f25ac46ca1ab$var$focusTargetRef = (href)=>(event)=>{
            event.preventDefault();
            const targetRef = document.querySelector(href);
            const key = event.which || event.keycode;
            if (key && key !== 13 && key !== 32) return;
            if (targetRef) {
                targetRef.setAttribute('tabindex', '-1');
                targetRef.addEventListener('blur', $54e4f25ac46ca1ab$var$handleBlur);
                targetRef.focus();
                document.activeElement && document.activeElement.scrollIntoView({
                    behavior: 'smooth'
                });
                window.scrollTo(0, 0);
            }
            return false;
        };
    const $54e4f25ac46ca1ab$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("li", {
            css: $54e4f25ac46ca1ab$var$skipLinkListItemStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("29ctK")).default), {
            tabIndex: isFocusable ? 0 : -1,
            href: href,
            onClick: $54e4f25ac46ca1ab$var$focusTargetRef(href)
        }, children));
    };
});
parcelRegister("9800U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b9470a4b9309396$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $fHYEP;
    var $cezmR;
    var $1nim3;
    var $4wf0T;
    var $2uhGC;
    var $39rJx;
    const $2b9470a4b9309396$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        gridArea: (0, (0, parcelRequire("fHYEP")).RIGHT_PANEL)
    });
    const $2b9470a4b9309396$var$fixedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("fHYEP")).RIGHT_PANEL_WIDTH),
        position: 'fixed',
        insetBlockEnd: 0,
        insetBlockStart: 0,
        insetInlineEnd: 0
    });
    const $2b9470a4b9309396$var$RightPanel = (props)=>{
        const { children: children, isFixed: isFixed, width: width = (0, (0, parcelRequire("fHYEP")).DEFAULT_RIGHT_PANEL_WIDTH), shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
        const rightPanelWidth = (0, (0, parcelRequire("cezmR")).resolveDimension)((0, (0, parcelRequire("fHYEP")).VAR_RIGHT_PANEL_WIDTH), width, shouldPersistWidth);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("1nim3")).default)({
                [(0, (0, parcelRequire("fHYEP")).VAR_RIGHT_PANEL_WIDTH)]: rightPanelWidth
            });
            return ()=>{
                (0, (0, parcelRequire("1nim3")).default)({
                    [(0, (0, parcelRequire("fHYEP")).VAR_RIGHT_PANEL_WIDTH)]: 0
                });
            };
        }, [
            rightPanelWidth
        ]);
        (0, (0, parcelRequire("4wf0T")).useSkipLink)(id, skipLinkTitle);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2uhGC")).default), null, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $2b9470a4b9309396$var$baseStyles,
                    isFixed && $2b9470a4b9309396$var$fixedStyles
                ],
                className: className,
                "data-testid": testId,
                id: id,
                ...(0, (0, parcelRequire("cezmR")).getPageLayoutSlotSelector)('right-panel')
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("39rJx")).default), {
                variableName: (0, (0, parcelRequire("fHYEP")).VAR_RIGHT_PANEL_WIDTH),
                value: rightPanelWidth
            }), children));
    };
    var $2b9470a4b9309396$export$2e2bcd8739ae039 = $2b9470a4b9309396$var$RightPanel;
});
parcelRegister("lHa8m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$350de914b14992a8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $fHYEP;
    var $cezmR;
    var $1nim3;
    var $4wf0T;
    var $2uhGC;
    var $39rJx;
    function $350de914b14992a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $350de914b14992a8$var$fixedInnerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("fHYEP")).RIGHT_SIDEBAR_WIDTH),
        position: 'fixed',
        insetBlockEnd: 0,
        insetBlockStart: `calc(${(0, (0, parcelRequire("fHYEP")).BANNER_HEIGHT)} + ${(0, (0, parcelRequire("fHYEP")).TOP_NAVIGATION_HEIGHT)})`,
        insetInlineEnd: `calc(${(0, (0, parcelRequire("fHYEP")).RIGHT_PANEL_WIDTH)})`
    });
    const $350de914b14992a8$var$staticInnerStyles = {
        name: "13udsys",
        styles: "height:100%"
    };
    const $350de914b14992a8$var$outerStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: (0, (0, parcelRequire("fHYEP")).RIGHT_SIDEBAR_WIDTH)
    });
    const $350de914b14992a8$var$fixedOuterStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&::after': {
            display: 'inline-block',
            width: (0, (0, parcelRequire("fHYEP")).RIGHT_SIDEBAR_WIDTH),
            content: "''"
        }
    });
    const $350de914b14992a8$var$RightSidebar = (props)=>{
        const { children: children, width: width = (0, (0, parcelRequire("fHYEP")).DEFAULT_RIGHT_SIDEBAR_WIDTH), isFixed: isFixed, shouldPersistWidth: shouldPersistWidth, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
        const rightSidebarWidth = (0, (0, parcelRequire("cezmR")).resolveDimension)((0, (0, parcelRequire("fHYEP")).VAR_RIGHT_SIDEBAR_WIDTH), width, shouldPersistWidth);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("1nim3")).default)({
                [(0, (0, parcelRequire("fHYEP")).VAR_RIGHT_SIDEBAR_WIDTH)]: rightSidebarWidth
            });
            return ()=>{
                (0, (0, parcelRequire("1nim3")).default)({
                    [(0, (0, parcelRequire("fHYEP")).VAR_RIGHT_SIDEBAR_WIDTH)]: 0
                });
            };
        }, [
            rightSidebarWidth,
            id
        ]);
        (0, (0, parcelRequire("4wf0T")).useSkipLink)(id, skipLinkTitle);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2uhGC")).default), {
            isSidebar: true
        }, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                "data-testid": testId,
                css: [
                    $350de914b14992a8$var$outerStyles,
                    isFixed && $350de914b14992a8$var$fixedOuterStyles
                ],
                className: className,
                id: id,
                ...(0, (0, parcelRequire("cezmR")).getPageLayoutSlotSelector)('right-sidebar')
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("39rJx")).default), {
                variableName: (0, (0, parcelRequire("fHYEP")).VAR_RIGHT_SIDEBAR_WIDTH),
                value: rightSidebarWidth
            }), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    isFixed && $350de914b14992a8$var$fixedInnerStyles,
                    !isFixed && $350de914b14992a8$var$staticInnerStyles
                ]
            }, children)));
    };
    var $350de914b14992a8$export$2e2bcd8739ae039 = $350de914b14992a8$var$RightSidebar;
});
parcelRegister("1IJrV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f30e03fdd568b623$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $fHYEP;
    var $cezmR;
    var $1nim3;
    var $4wf0T;
    var $2uhGC;
    var $39rJx;
    const $f30e03fdd568b623$var$topNavigationStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        height: (0, (0, parcelRequire("fHYEP")).TOP_NAVIGATION_HEIGHT),
        gridArea: (0, (0, parcelRequire("fHYEP")).TOP_NAVIGATION)
    });
    const $f30e03fdd568b623$var$fixedStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'fixed',
        zIndex: 2,
        insetBlockStart: (0, (0, parcelRequire("fHYEP")).BANNER_HEIGHT),
        insetInlineEnd: (0, (0, parcelRequire("fHYEP")).RIGHT_PANEL_WIDTH),
        insetInlineStart: (0, (0, parcelRequire("fHYEP")).LEFT_PANEL_WIDTH)
    });
    const $f30e03fdd568b623$var$TopNavigation = (props)=>{
        const { children: children, height: height = (0, (0, parcelRequire("fHYEP")).DEFAULT_TOP_NAVIGATION_HEIGHT), isFixed: isFixed = true, shouldPersistHeight: shouldPersistHeight, testId: testId, id: id, skipLinkTitle: skipLinkTitle } = props;
        const topNavigationHeight = (0, (0, parcelRequire("cezmR")).resolveDimension)((0, (0, parcelRequire("fHYEP")).VAR_TOP_NAVIGATION_HEIGHT), height, shouldPersistHeight);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("1nim3")).default)({
                [(0, (0, parcelRequire("fHYEP")).VAR_TOP_NAVIGATION_HEIGHT)]: topNavigationHeight
            });
            return ()=>{
                (0, (0, parcelRequire("1nim3")).default)({
                    [(0, (0, parcelRequire("fHYEP")).VAR_TOP_NAVIGATION_HEIGHT)]: 0
                });
            };
        }, [
            topNavigationHeight
        ]);
        (0, (0, parcelRequire("4wf0T")).useSkipLink)(id, skipLinkTitle);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2uhGC")).default), null, ({ className: className })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
                css: [
                    $f30e03fdd568b623$var$topNavigationStyles,
                    isFixed && $f30e03fdd568b623$var$fixedStyles
                ],
                className: className,
                "data-testid": testId,
                id: id,
                ...(0, (0, parcelRequire("cezmR")).getPageLayoutSlotSelector)('top-navigation')
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("39rJx")).default), {
                variableName: (0, (0, parcelRequire("fHYEP")).VAR_TOP_NAVIGATION_HEIGHT),
                value: topNavigationHeight
            }), children));
    };
    var $f30e03fdd568b623$export$2e2bcd8739ae039 = $f30e03fdd568b623$var$TopNavigation;
});
parcelRegister("cVRge", function(module, exports) {
    $parcel$export(module.exports, "useCustomSkipLink", ()=>$b4eed31ad1efab09$export$ee6b12c2613bdf8e);
    var $5uXOq = parcelRequire("5uXOq");
    var $4wf0T;
    const $b4eed31ad1efab09$export$ee6b12c2613bdf8e = (id, skipLinkTitle, listIndex = 0)=>{
        const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = (0, (0, parcelRequire("4wf0T")).useSkipLinks)();
        (0, $5uXOq.useEffect)(()=>{
            registerSkipLink({
                id: id,
                skipLinkTitle: skipLinkTitle,
                listIndex: listIndex
            });
            return ()=>{
                unregisterSkipLink(id);
            };
        }, [
            id,
            listIndex,
            skipLinkTitle,
            registerSkipLink,
            unregisterSkipLink
        ]);
    };
});
parcelRegister("lX64V", function(module, exports) {
    $parcel$export(module.exports, "Aside", ()=>$fe726f0c3e6ea02d$export$ac3bdfe4cb17f64e);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $jHB2D;
    var $2MVcM;
    var $1xpqK;
    var $58Ftb;
    var $2Nqjv;
    var $a7W7J;
    var $fFBU4;
    var $jL4ZA;
    const $fe726f0c3e6ea02d$var$panelSplitterResizingVar = '--n_asdRsz';
    const $fe726f0c3e6ea02d$var$asideWidthSlotBounds = {
        min: '0px',
        max: '50vw'
    };
    const $fe726f0c3e6ea02d$var$asideWidthResizeBounds = {
        min: '120px',
        max: '50vw'
    };
    const $fe726f0c3e6ea02d$var$styles = {
        root: "_nd5lns35 _vchhusvi _kqswh2mm _glte1kzp _ndwch9n0",
        fixedContentArea: "_152t1l7u _1reo1wug _18m91wug _165t1run _13wn1if8"
    };
    function $fe726f0c3e6ea02d$export$ac3bdfe4cb17f64e({ children: children, xcss: xcss, isFixed: isFixed, defaultWidth: defaultWidth = 330, label: label = 'Aside', testId: testId, id: id }) {
        const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, (0, parcelRequire("2Nqjv")).DangerouslyHoistSlotSizes));
        const UID = (0, (0, parcelRequire("jL4ZA")).usePrefixedUID)();
        const CID = id ? id : UID;
        (0, (0, parcelRequire("1xpqK")).useSkipLink)(CID, label);
        const ref = (0, $5uXOq.useRef)(null);
        const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
        const previousWidthProp = (0, (0, parcelRequire("jHB2D")).default)(defaultWidth);
        (0, $5uXOq.useEffect)(()=>{
            setWidth(defaultWidth);
        }, [
            defaultWidth
        ]);
        (0, $5uXOq.useEffect)(()=>{}, [
            defaultWidth,
            previousWidthProp
        ]);
        const asideVariableWidth = `clamp(${$fe726f0c3e6ea02d$var$asideWidthSlotBounds.min}, ${width}px, ${$fe726f0c3e6ea02d$var$asideWidthSlotBounds.max})`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("aside", {
            id: CID,
            "data-layout-slot": true,
            "aria-label": label,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $fe726f0c3e6ea02d$var$styles.root,
                xcss
            ]),
            style: {
                [(0, (0, parcelRequire("58Ftb")).asideVar)]: asideVariableWidth
            },
            "data-testid": testId,
            ref: ref
        }, dangerouslyHoistSlotSizes && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a7W7J")).DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, (0, parcelRequire("58Ftb")).UNSAFE_asideLayoutVar),
            value: "0px",
            mediaQuery: (0, (0, parcelRequire("2MVcM")).media).above.md,
            responsiveValue: asideVariableWidth
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fFBU4")).PanelSplitterProvider), {
            panelRef: ref,
            panelWidth: width,
            onCompleteResize: setWidth,
            resizeBounds: $fe726f0c3e6ea02d$var$asideWidthResizeBounds,
            resizingCssVar: $fe726f0c3e6ea02d$var$panelSplitterResizingVar,
            position: "start"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                isFixed && $fe726f0c3e6ea02d$var$styles.fixedContentArea
            ])
        }, children)));
    }
});
parcelRegister("1xpqK", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksContext", ()=>$f7995ac9d81a3de9$export$4c5cc3b14c7678a);
    $parcel$export(module.exports, "useSkipLink", ()=>$f7995ac9d81a3de9$export$89d9323301efc7d6);
    var $5uXOq = parcelRequire("5uXOq");
    var $ePBXU;
    const $f7995ac9d81a3de9$export$4c5cc3b14c7678a = (0, $5uXOq.createContext)({
        registerSkipLink: (0, (0, parcelRequire("ePBXU")).default),
        unregisterSkipLink: (0, (0, parcelRequire("ePBXU")).default)
    });
    const $f7995ac9d81a3de9$export$c9d9cb2ee9590f87 = ()=>(0, $5uXOq.useContext)($f7995ac9d81a3de9$export$4c5cc3b14c7678a);
    const $f7995ac9d81a3de9$export$89d9323301efc7d6 = (id, label, listIndex)=>{
        const { registerSkipLink: registerSkipLink, unregisterSkipLink: unregisterSkipLink } = $f7995ac9d81a3de9$export$c9d9cb2ee9590f87();
        (0, $5uXOq.useEffect)(()=>{
            registerSkipLink({
                id: id,
                label: label,
                listIndex: listIndex
            });
            return ()=>{
                unregisterSkipLink(id);
            };
        }, [
            id,
            label,
            listIndex,
            registerSkipLink,
            unregisterSkipLink
        ]);
    };
});
parcelRegister("58Ftb", function(module, exports) {
    $parcel$export(module.exports, "sideNavVar", ()=>$eb0b0c3b770ec5a3$export$951bf5156e86d974);
    $parcel$export(module.exports, "asideVar", ()=>$eb0b0c3b770ec5a3$export$594e6a30db7c057e);
    $parcel$export(module.exports, "panelVar", ()=>$eb0b0c3b770ec5a3$export$db0c2e1d744fb281);
    $parcel$export(module.exports, "bannerMountedVar", ()=>$eb0b0c3b770ec5a3$export$515a0b1baafe906c);
    $parcel$export(module.exports, "topBarMountedVar", ()=>$eb0b0c3b770ec5a3$export$a96e934b2a1eeee);
    $parcel$export(module.exports, "UNSAFE_topBarVar", ()=>$eb0b0c3b770ec5a3$export$f4afb213f937404c);
    $parcel$export(module.exports, "UNSAFE_bannerVar", ()=>$eb0b0c3b770ec5a3$export$26354f9814213292);
    $parcel$export(module.exports, "UNSAFE_sideNavLayoutVar", ()=>$eb0b0c3b770ec5a3$export$6bfc931a04ec5741);
    $parcel$export(module.exports, "UNSAFE_asideLayoutVar", ()=>$eb0b0c3b770ec5a3$export$bbbace2ff0c7ae1b);
    $parcel$export(module.exports, "UNSAFE_panelLayoutVar", ()=>$eb0b0c3b770ec5a3$export$753bf7651b25db91);
    $parcel$export(module.exports, "UNSAFE_MAIN_BLOCK_START_FOR_LEGACY_PAGES_ONLY", ()=>$eb0b0c3b770ec5a3$export$6460bd6a2446260);
    $parcel$export(module.exports, "UNSAFE_MAIN_INLINE_START_FOR_LEGACY_PAGES_ONLY", ()=>$eb0b0c3b770ec5a3$export$3055529fab2b4edf);
    $parcel$export(module.exports, "UNSAFE_MAIN_INLINE_END_FOR_LEGACY_PAGES_ONLY", ()=>$eb0b0c3b770ec5a3$export$166d8fd766c3eb92);
    const $eb0b0c3b770ec5a3$export$951bf5156e86d974 = '--n_sNvw';
    const $eb0b0c3b770ec5a3$export$594e6a30db7c057e = '--n_asDw';
    const $eb0b0c3b770ec5a3$export$db0c2e1d744fb281 = '--n_pnlW';
    const $eb0b0c3b770ec5a3$export$515a0b1baafe906c = '--n_bnrM';
    const $eb0b0c3b770ec5a3$export$a96e934b2a1eeee = '--n_tbrM';
    const $eb0b0c3b770ec5a3$export$2874e68531ce3163 = `calc(100vh - var(--n_bnrM, 0px) - var(--n_tbrM, 0px))`;
    const $eb0b0c3b770ec5a3$export$bfabd8c2c572ad29 = `calc(var(--n_bnrM, 0px) + var(--n_tbrM, 0px))`;
    const $eb0b0c3b770ec5a3$export$f4afb213f937404c = '--topNavigationHeight';
    const $eb0b0c3b770ec5a3$export$26354f9814213292 = '--bannerHeight';
    const $eb0b0c3b770ec5a3$export$6bfc931a04ec5741 = '--leftSidebarWidth';
    const $eb0b0c3b770ec5a3$export$bbbace2ff0c7ae1b = '--rightSidebarWidth';
    const $eb0b0c3b770ec5a3$export$753bf7651b25db91 = '--rightPanelWidth';
    const $eb0b0c3b770ec5a3$export$6460bd6a2446260 = `calc(var(${$eb0b0c3b770ec5a3$export$26354f9814213292}, 0px) + var(${$eb0b0c3b770ec5a3$export$f4afb213f937404c}, 0px))`;
    const $eb0b0c3b770ec5a3$export$3055529fab2b4edf = `var(${$eb0b0c3b770ec5a3$export$6bfc931a04ec5741}, 0px)`;
    const $eb0b0c3b770ec5a3$export$166d8fd766c3eb92 = `calc(var(${$eb0b0c3b770ec5a3$export$bbbace2ff0c7ae1b}, 0px) + var(${$eb0b0c3b770ec5a3$export$753bf7651b25db91}, 0px))`;
    const $eb0b0c3b770ec5a3$export$61156ceb1a99f6a0 = {
        topBar: 4,
        banner: 4,
        topBarBorder: 3,
        sideNav: 2,
        contentBlockBorder: 2,
        contentInlineBorder: 1,
        panelSmallViewports: 1
    };
});
parcelRegister("2Nqjv", function(module, exports) {
    $parcel$export(module.exports, "DangerouslyHoistSlotSizes", ()=>$b8d0df244836ddb5$export$66e2c1a0115af861);
    var $5uXOq = parcelRequire("5uXOq");
    const $b8d0df244836ddb5$export$66e2c1a0115af861 = (0, $5uXOq.createContext)(false);
});
parcelRegister("a7W7J", function(module, exports) {
    $parcel$export(module.exports, "HoistCssVarToLocalGrid", ()=>$28b9bee07f7b5fc3$export$cfa3cd08d675e56e);
    $parcel$export(module.exports, "DangerouslyHoistCssVarToDocumentRoot", ()=>$28b9bee07f7b5fc3$export$9f45a1325e3cdfb8);
    var $5uXOq = parcelRequire("5uXOq");
    var $gN1lH;
    const $28b9bee07f7b5fc3$export$cfa3cd08d675e56e = ({ variableName: variableName, value: value })=>(0, ($parcel$interopDefault($5uXOq))).createElement("style", null, `#${(0, (0, parcelRequire("gN1lH")).gridRootId)} { ${variableName}: ${value}px }`);
    const $28b9bee07f7b5fc3$var$getCssStringValue = (value)=>typeof value === 'number' ? `${value}px` : value;
    const $28b9bee07f7b5fc3$export$9f45a1325e3cdfb8 = ({ variableName: variableName, value: value, mediaQuery: mediaQuery, responsiveValue: responsiveValue })=>{
        let style = `:root { ${variableName}: ${$28b9bee07f7b5fc3$var$getCssStringValue(value)} }`;
        if (mediaQuery && responsiveValue) style += ` ${mediaQuery} { :root { ${variableName}: ${$28b9bee07f7b5fc3$var$getCssStringValue(responsiveValue)} } }`;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("style", null, style));
    };
});
parcelRegister("gN1lH", function(module, exports) {
    $parcel$export(module.exports, "gridRootId", ()=>$bcb77598b1c4bc8d$export$a6d827031bcb31d1);
    $parcel$export(module.exports, "Root", ()=>$bcb77598b1c4bc8d$export$be92b6f5f03c0fe9);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $484W1;
    var $gzwkb;
    var $gqfF2;
    var $2Nqjv;
    var $k8jbZ;
    var $gSbmP;
    var $j5Yjf;
    const $bcb77598b1c4bc8d$export$a6d827031bcb31d1 = 'unsafe-design-system-page-layout-root';
    const $bcb77598b1c4bc8d$var$styles = {
        root: "_1e0c11p5 _1tke1kxc _1lmcq9em _yv0ei47z _2z0516ab _1ciragmp _12fkuz0r _12qzrxre _1rqt70if _xkmgbaui _jbc7rxre _tyve1jg8"
    };
    function $bcb77598b1c4bc8d$export$be92b6f5f03c0fe9({ children: children, xcss: xcss, UNSAFE_dangerouslyHoistSlotSizes: UNSAFE_dangerouslyHoistSlotSizes = false, skipLinksLabel: skipLinksLabel = 'Skip to:', testId: testId }) {
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            var child;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j5Yjf")).SideNavVisibilityProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSbmP")).SideNavToggleButtonProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k8jbZ")).SideNavFlyoutLockProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gzwkb")).HomeActionsProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Nqjv")).DangerouslyHoistSlotSizes).Provider, {
            value: UNSAFE_dangerouslyHoistSlotSizes
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gqfF2")).SkipLinksProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("484W1")).SkipLinksContainer), {
            label: skipLinksLabel
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $bcb77598b1c4bc8d$var$styles.root,
                xcss
            ]),
            id: $bcb77598b1c4bc8d$export$a6d827031bcb31d1,
            "data-testid": testId
        }, children)))))));
    }
});
parcelRegister("484W1", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksContainer", ()=>$1aa5a4e46ae06437$export$fce25a0c32fbc1e1);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1m92z;
    var $imUhA;
    var $bFWKo;
    const $1aa5a4e46ae06437$var$styles = {
        root: "_18s8v47k _1rjcu2gc _18zr12x7 _kqsw1n9t _1pby1mrw _bfhk1bhr _2rkoglpi _16qs1cd0 _1e02qkuk _tzy4idpf _t9ec1i34 _1digjh3g _gtjaze3t _1mygkb7n _66dk1kli",
        skipLinkList: "_1x8w11lx _2mzuglyw _1pfh1b66 _bozgze3t"
    };
    const $1aa5a4e46ae06437$var$handleBlur = (event)=>{
        if (!(event.target instanceof Element)) return;
        event.target.removeAttribute('tabindex');
        event.target.removeEventListener('blur', $1aa5a4e46ae06437$var$handleBlur);
    };
    const $1aa5a4e46ae06437$var$escapeHandler = (event)=>{
        if (event.key === 'Escape') {
            const activeElement = document.activeElement;
            if (activeElement !== null) activeElement.blur();
        }
    };
    const $1aa5a4e46ae06437$var$attachEscHandler = ()=>window.addEventListener('keydown', $1aa5a4e46ae06437$var$escapeHandler, false);
    const $1aa5a4e46ae06437$var$removeEscHandler = ()=>window.removeEventListener('keydown', $1aa5a4e46ae06437$var$escapeHandler, false);
    const $1aa5a4e46ae06437$export$fce25a0c32fbc1e1 = ({ label: label })=>{
        const sortedSkipLinks = (0, (0, parcelRequire("imUhA")).useSortedSkipLinks)();
        if (sortedSkipLinks.length === 0) return null;
        const emptyLabelOverride = !!label?.match(/^\s+$/);
        return $5uXOq.createElement("div", {
            onFocus: $1aa5a4e46ae06437$var$attachEscHandler,
            onBlur: $1aa5a4e46ae06437$var$removeEscHandler,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $1aa5a4e46ae06437$var$styles.root
            ])
        }, emptyLabelOverride ? null : $5uXOq.createElement((0, (0, parcelRequire("1m92z")).default), {
            weight: "medium"
        }, label), $5uXOq.createElement("ol", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $1aa5a4e46ae06437$var$styles.skipLinkList
            ])
        }, sortedSkipLinks.map(({ id: id, label: label })=>$5uXOq.createElement((0, (0, parcelRequire("bFWKo")).SkipLink), {
                key: id,
                href: `#${id}`,
                isFocusable: true
            }, label))));
    };
});
parcelRegister("imUhA", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksDataContext", ()=>$7511e944df648245$export$e9ab38ce6147d3d2);
    $parcel$export(module.exports, "useSortedSkipLinks", ()=>$7511e944df648245$export$b0b0d4fc1b356759);
    var $5uXOq = parcelRequire("5uXOq");
    const $7511e944df648245$export$e9ab38ce6147d3d2 = (0, $5uXOq.createContext)([]);
    const $7511e944df648245$var$assignIndex = (num, arr)=>{
        if (!arr.includes(num)) return num;
        return $7511e944df648245$var$assignIndex(num + 1, arr);
    };
    const $7511e944df648245$var$sortSkipLinks = (arr)=>{
        const customLinks = arr.filter((link)=>Number.isInteger(link.listIndex));
        if (customLinks.length === 0) return arr;
        const usedIndexes = customLinks.map((a)=>a.listIndex);
        const regularLinksWithIdx = arr.filter((link)=>link.listIndex === undefined).map((link, idx)=>{
            const listIndex = $7511e944df648245$var$assignIndex(idx, usedIndexes);
            usedIndexes.push(listIndex);
            return {
                ...link,
                listIndex: listIndex
            };
        });
        return [
            ...customLinks,
            ...regularLinksWithIdx
        ].sort((a, b)=>a.listIndex - b.listIndex);
    };
    const $7511e944df648245$export$b0b0d4fc1b356759 = ()=>{
        const skipLinksData = (0, $5uXOq.useContext)($7511e944df648245$export$e9ab38ce6147d3d2);
        return (0, $5uXOq.useMemo)(()=>{
            return $7511e944df648245$var$sortSkipLinks(skipLinksData);
        }, [
            skipLinksData
        ]);
    };
});
parcelRegister("bFWKo", function(module, exports) {
    $parcel$export(module.exports, "SkipLink", ()=>$d803c71eaf8c6bfe$export$ef95c37428582a65);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $kDFVt;
    const $d803c71eaf8c6bfe$var$styles = {
        skipLinkListItem: "_1pfhze3t"
    };
    const $d803c71eaf8c6bfe$var$assignIndex = (num, arr)=>{
        if (!arr.includes(num)) return num;
        return $d803c71eaf8c6bfe$var$assignIndex(num + 1, arr);
    };
    const $d803c71eaf8c6bfe$var$handleBlur = (event)=>{
        event.target.removeAttribute('tabindex');
        event.target.removeEventListener('blur', $d803c71eaf8c6bfe$var$handleBlur);
    };
    const $d803c71eaf8c6bfe$var$focusTargetRef = (href)=>(event)=>{
            event.preventDefault();
            const targetRef = document.querySelector(href);
            const key = event.which || event.keycode;
            if (key && key !== 13 && key !== 32) return;
            if (targetRef) {
                targetRef.setAttribute('tabindex', '-1');
                targetRef.addEventListener('blur', $d803c71eaf8c6bfe$var$handleBlur);
                targetRef.focus();
                document.activeElement && document.activeElement.scrollIntoView({
                    behavior: 'smooth'
                });
                window.scrollTo(0, 0);
            }
            return false;
        };
    const $d803c71eaf8c6bfe$export$ef95c37428582a65 = ({ href: href, children: children, isFocusable: isFocusable })=>{
        return $5uXOq.createElement("li", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $d803c71eaf8c6bfe$var$styles.skipLinkListItem
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("kDFVt")).default), {
            tabIndex: isFocusable ? 0 : -1,
            href: href,
            onClick: $d803c71eaf8c6bfe$var$focusTargetRef(href)
        }, children));
    };
});
parcelRegister("gzwkb", function(module, exports) {
    $parcel$export(module.exports, "HomeActionsProvider", ()=>$b41ecb60127769a7$export$8b9089606266983e);
    var $5uXOq = parcelRequire("5uXOq");
    var $chAiF;
    const $b41ecb60127769a7$export$8b9089606266983e = ({ children: children })=>{
        const [element, setElement] = (0, $5uXOq.useState)(null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("chAiF")).HomeActionsElement).Provider, {
            value: element
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("chAiF")).HomeActionsAttachRef).Provider, {
            value: setElement
        }, children));
    };
});
parcelRegister("chAiF", function(module, exports) {
    $parcel$export(module.exports, "HomeActionsElement", ()=>$5f8bdd474bea0a16$export$4128169e0878a41d);
    $parcel$export(module.exports, "HomeActionsAttachRef", ()=>$5f8bdd474bea0a16$export$762fcfeaa67873eb);
    var $5uXOq = parcelRequire("5uXOq");
    var $ePBXU;
    const $5f8bdd474bea0a16$export$4128169e0878a41d = (0, $5uXOq.createContext)(null);
    const $5f8bdd474bea0a16$export$762fcfeaa67873eb = (0, $5uXOq.createContext)((0, (0, parcelRequire("ePBXU")).default));
});
parcelRegister("gqfF2", function(module, exports) {
    $parcel$export(module.exports, "SkipLinksProvider", ()=>$151b06aba89ba3e5$export$fe514f9f7b03d46f);
    var $5uXOq = parcelRequire("5uXOq");
    var $1xpqK;
    var $imUhA;
    const $151b06aba89ba3e5$var$getByDomOrderSortFunction = ()=>{
        const layoutSlots = Array.from(document.querySelectorAll(`[data-layout-slot]`));
        return (a, b)=>{
            const indexA = a.listIndex ?? layoutSlots.indexOf(document.getElementById(a.id));
            const indexB = b.listIndex ?? layoutSlots.indexOf(document.getElementById(b.id));
            if (indexA === indexB) {
                if (a.listIndex !== undefined) return -1;
                else return 1;
            }
            return indexA - indexB;
        };
    };
    const $151b06aba89ba3e5$export$fe514f9f7b03d46f = ({ children: children })=>{
        const [links, setLinks] = (0, $5uXOq.useState)([]);
        const registerSkipLink = (0, $5uXOq.useCallback)((skipLinkData)=>{
            setLinks((oldLinks)=>{
                if (oldLinks.some(({ id: id })=>id === skipLinkData.id)) return oldLinks;
                return [
                    ...oldLinks,
                    skipLinkData
                ].sort($151b06aba89ba3e5$var$getByDomOrderSortFunction());
            });
        }, []);
        const unregisterSkipLink = (0, $5uXOq.useCallback)((id)=>{
            setLinks((links)=>links.filter((link)=>link.id !== id));
        }, []);
        const contextValue = (0, $5uXOq.useMemo)(()=>{
            const data = {
                registerSkipLink: registerSkipLink,
                unregisterSkipLink: unregisterSkipLink
            };
            return data;
        }, [
            registerSkipLink,
            unregisterSkipLink
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1xpqK")).SkipLinksContext).Provider, {
            value: contextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imUhA")).SkipLinksDataContext).Provider, {
            value: links
        }, children));
    };
});
parcelRegister("k8jbZ", function(module, exports) {
    $parcel$export(module.exports, "SideNavFlyoutLockProvider", ()=>$07cc85f17163c700$export$7003dd76deb92ad);
    var $5uXOq = parcelRequire("5uXOq");
    var $ckN3t;
    const $07cc85f17163c700$export$7003dd76deb92ad = ({ children: children })=>{
        const [flyoutLock, setFlyoutLock] = (0, $5uXOq.useState)(0);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ckN3t")).FlyoutLockCount).Provider, {
            value: flyoutLock
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ckN3t")).SetFlyoutLockCount).Provider, {
            value: setFlyoutLock
        }, children));
    };
});
parcelRegister("ckN3t", function(module, exports) {
    $parcel$export(module.exports, "FlyoutLockCount", ()=>$bf54ba24a0460bde$export$962eb1e8d553c86f);
    $parcel$export(module.exports, "SetFlyoutLockCount", ()=>$bf54ba24a0460bde$export$52e873d56b3942a3);
    var $5uXOq = parcelRequire("5uXOq");
    var $ePBXU;
    const $bf54ba24a0460bde$export$962eb1e8d553c86f = (0, $5uXOq.createContext)(0);
    const $bf54ba24a0460bde$export$52e873d56b3942a3 = (0, $5uXOq.createContext)((0, (0, parcelRequire("ePBXU")).default));
});
parcelRegister("gSbmP", function(module, exports) {
    $parcel$export(module.exports, "SideNavToggleButtonProvider", ()=>$f64cf34224013511$export$ceb8e60e9790fc0f);
    var $5uXOq = parcelRequire("5uXOq");
    var $gNxdD;
    const $f64cf34224013511$export$ceb8e60e9790fc0f = ({ children: children })=>{
        const [element, setElement] = (0, $5uXOq.useState)(null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gNxdD")).SideNavToggleButtonElement).Provider, {
            value: element
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gNxdD")).SideNavToggleButtonAttachRef).Provider, {
            value: setElement
        }, children));
    };
});
parcelRegister("gNxdD", function(module, exports) {
    $parcel$export(module.exports, "SideNavToggleButtonElement", ()=>$4230efd6f2a14f47$export$9c1768094bef896);
    $parcel$export(module.exports, "SideNavToggleButtonAttachRef", ()=>$4230efd6f2a14f47$export$fb8fa9a80240785e);
    var $5uXOq = parcelRequire("5uXOq");
    var $ePBXU;
    const $4230efd6f2a14f47$export$9c1768094bef896 = (0, $5uXOq.createContext)(null);
    const $4230efd6f2a14f47$export$fb8fa9a80240785e = (0, $5uXOq.createContext)((0, (0, parcelRequire("ePBXU")).default));
});
parcelRegister("j5Yjf", function(module, exports) {
    $parcel$export(module.exports, "SideNavVisibilityProvider", ()=>$508dd7708f45b568$export$aac8e996360f6ad9);
    var $5uXOq = parcelRequire("5uXOq");
    var $4HAIT;
    const $508dd7708f45b568$export$aac8e996360f6ad9 = ({ children: children })=>{
        const [visibleOnDesktop, setVisibleOnDesktop] = (0, $5uXOq.useState)(null);
        const [visibleOnMobile, setVisibleOnMobile] = (0, $5uXOq.useState)(false);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4HAIT")).SideNavDesktopVisibility).Provider, {
            value: visibleOnDesktop
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4HAIT")).SetSideNavDesktopVisibility).Provider, {
            value: setVisibleOnDesktop
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4HAIT")).SideNavMobileVisibility).Provider, {
            value: visibleOnMobile
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4HAIT")).SetSideNavMobileVisibility).Provider, {
            value: setVisibleOnMobile
        }, children))));
    };
});
parcelRegister("4HAIT", function(module, exports) {
    $parcel$export(module.exports, "SideNavDesktopVisibility", ()=>$f13873e7637a47e7$export$1771e3b63861d206);
    $parcel$export(module.exports, "SideNavMobileVisibility", ()=>$f13873e7637a47e7$export$c5f483eeea865395);
    $parcel$export(module.exports, "SetSideNavDesktopVisibility", ()=>$f13873e7637a47e7$export$5edca135c5bde4af);
    $parcel$export(module.exports, "SetSideNavMobileVisibility", ()=>$f13873e7637a47e7$export$64be6ca751606276);
    var $5uXOq = parcelRequire("5uXOq");
    var $ePBXU;
    const $f13873e7637a47e7$export$1771e3b63861d206 = (0, $5uXOq.createContext)(null);
    const $f13873e7637a47e7$export$c5f483eeea865395 = (0, $5uXOq.createContext)(false);
    const $f13873e7637a47e7$export$5edca135c5bde4af = (0, $5uXOq.createContext)((0, (0, parcelRequire("ePBXU")).default));
    const $f13873e7637a47e7$export$64be6ca751606276 = (0, $5uXOq.createContext)((0, (0, parcelRequire("ePBXU")).default));
});
parcelRegister("fFBU4", function(module, exports) {
    $parcel$export(module.exports, "PanelSplitterProvider", ()=>$f0397f3ae11d7a5c$export$f662bfb764348932);
    var $5uXOq = parcelRequire("5uXOq");
    var $cbdZQ;
    const $f0397f3ae11d7a5c$export$f662bfb764348932 = ({ panelWidth: panelWidth, onCompleteResize: onCompleteResize, resizeBounds: resizeBounds, resizingCssVar: resizingCssVar, panelRef: panelRef, position: position = 'end', isEnabled: isEnabled = true, children: children })=>{
        const portalRef = (0, $5uXOq.useRef)(null);
        const context = (0, $5uXOq.useMemo)(()=>({
                panelWidth: panelWidth,
                onCompleteResize: onCompleteResize,
                resizeBounds: resizeBounds,
                portalRef: portalRef,
                resizingCssVar: resizingCssVar,
                position: position,
                panelRef: panelRef,
                isEnabled: isEnabled
            }), [
            isEnabled,
            onCompleteResize,
            panelRef,
            panelWidth,
            position,
            resizeBounds,
            resizingCssVar
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cbdZQ")).PanelSplitterContext).Provider, {
            value: context
        }, children), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: portalRef
        }));
    };
});
parcelRegister("cbdZQ", function(module, exports) {
    $parcel$export(module.exports, "PanelSplitterContext", ()=>$a665e3ecb48681a7$export$7a4054f2c546f2cd);
    var $5uXOq = parcelRequire("5uXOq");
    const $a665e3ecb48681a7$export$7a4054f2c546f2cd = (0, $5uXOq.createContext)(null);
});
parcelRegister("jL4ZA", function(module, exports) {
    $parcel$export(module.exports, "usePrefixedUID", ()=>$f19c054b64d8e86b$export$86433d4fd18455f4);
    var $3QrEQ;
    const $f19c054b64d8e86b$export$86433d4fd18455f4 = (prefix = 'element')=>`${prefix}-${(0, (0, parcelRequire("3QrEQ")).useId)()}`;
});
parcelRegister("fIr6F", function(module, exports) {
    $parcel$export(module.exports, "Banner", ()=>$1d7089496b4c2cdd$export$3b4e64e77073e307);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $1xpqK;
    var $58Ftb;
    var $2Nqjv;
    var $a7W7J;
    var $jL4ZA;
    const $1d7089496b4c2cdd$var$styles = {
        root: "_nd5ldkfm _4t3iutvi _152tidpf _kqsw1if8 _1pbyegat _1reo15vq _18m915vq"
    };
    function $1d7089496b4c2cdd$export$3b4e64e77073e307({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 64, label: label = 'Banner', testId: testId, id: id }) {
        const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, (0, parcelRequire("2Nqjv")).DangerouslyHoistSlotSizes));
        const UID = (0, (0, parcelRequire("jL4ZA")).usePrefixedUID)();
        const CID = id ? id : UID;
        (0, (0, parcelRequire("1xpqK")).useSkipLink)(CID, label);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            id: CID,
            role: "banner",
            "data-layout-slot": true,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $1d7089496b4c2cdd$var$styles.root,
                xcss
            ]),
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a7W7J")).HoistCssVarToLocalGrid), {
            variableName: (0, (0, parcelRequire("58Ftb")).bannerMountedVar),
            value: UNSAFE_height
        }), dangerouslyHoistSlotSizes && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a7W7J")).DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, (0, parcelRequire("58Ftb")).UNSAFE_bannerVar),
            value: UNSAFE_height
        }), children);
    }
});
parcelRegister("jL8aY", function(module, exports) {
    $parcel$export(module.exports, "Main", ()=>$6fbd163e4566860b$export$861edd1ccea2f746);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $1xpqK;
    var $jL4ZA;
    var $9NQDr;
    const $6fbd163e4566860b$var$conditionalCurvedBorderRadiusCSSSelector = 'html:not(:has([data-private-do-not-show-curved-border-on-main="true"])):has([data-private-request-curved-border-on-main="true"]) &';
    const $6fbd163e4566860b$var$conditionalBorderInlineStartCSSSelector = 'html:has([data-private-show-inline-start-border-on-main="true"]) &';
    const $6fbd163e4566860b$var$mainElementStyles = {
        root: "_nd5l1gzg _19121cl4 _qwfh1wug",
        mainCurvedCorner: "_z0yti2wt",
        fixedContentArea: "_152t1l7u _1reo1wug _18m91wug _165t1run _13wn1if8"
    };
    const $6fbd163e4566860b$var$contentBorderStyles = {
        largeViewportTop: "_vchhusvi _h7aloyrj _mqm2zgxb _p3z31gzg _18911gzg _14611gzg _f0zu1mrw _4t3i1run _152t1l7u _lcxvglyw _kqsw1if8 _1pbycs5v _1e0cglyw _jnn7i2wt _dm2518uv",
        largeViewportLeft: "_vchhusvi _izbqoyrj _p3z31gzg _18911gzg _14611gzg _f0zu1mrw _4t3i1run _152t1l7u _lcxvglyw _kqsw1if8 _1pbykb7n _1e0cglyw _jnn7i2wt _ml4lzgxb _dm2518uv"
    };
    function $6fbd163e4566860b$export$861edd1ccea2f746({ children: children, isFixed: isFixed, xcss: xcss, label: label = 'Main Content', testId: testId, id: id }) {
        const UID = (0, (0, parcelRequire("jL4ZA")).usePrefixedUID)();
        const CID = id ? id : UID;
        (0, (0, parcelRequire("1xpqK")).useSkipLink)(CID, label);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            id: CID,
            "data-layout-slot": true,
            "aria-label": label,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $6fbd163e4566860b$var$mainElementStyles.root,
                $6fbd163e4566860b$var$mainElementStyles.mainCurvedCorner,
                isFixed && $6fbd163e4566860b$var$mainElementStyles.fixedContentArea,
                xcss
            ]),
            role: "main",
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NQDr")).MainStickyContext).Provider, {
            value: Boolean(isFixed)
        }, children)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-layout-slot": true,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $6fbd163e4566860b$var$contentBorderStyles.largeViewportLeft
            ])
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-layout-slot": true,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $6fbd163e4566860b$var$contentBorderStyles.largeViewportTop
            ])
        }));
    }
});
parcelRegister("9NQDr", function(module, exports) {
    $parcel$export(module.exports, "MainStickyContext", ()=>$fb798a8ea0fd4a96$export$3b369e2c6c1ec840);
    var $5uXOq = parcelRequire("5uXOq");
    const $fb798a8ea0fd4a96$export$3b369e2c6c1ec840 = (0, $5uXOq.createContext)(false);
});
parcelRegister("gFfbI", function(module, exports) {
    $parcel$export(module.exports, "Panel", ()=>$f9b09597701b4b66$export$2ddb90ad54e5f587);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $2MVcM;
    var $1xpqK;
    var $58Ftb;
    var $2Nqjv;
    var $a7W7J;
    var $fFBU4;
    var $jL4ZA;
    const $f9b09597701b4b66$var$panelSplitterResizingVar = '--n_pnlRsz';
    const $f9b09597701b4b66$var$panelWidthSlotBounds = {
        min: '0px',
        max: '50vw'
    };
    const $f9b09597701b4b66$var$panelWidthResizeBounds = {
        min: '120px',
        max: '50vw'
    };
    const $f9b09597701b4b66$var$styles = {
        root: "_nd5l1b6c _10fph9n0 _vchhusvi _1pbykb7n _4t3i1run _kqsw1if8 _152t1l7u _1bsb1adv _14b54rrg _1dhy1c6w _9sns1wug",
        scrollContainer: "_1reo1wug _18m91wug _4t3i1osq",
        hidden: "_1e0cglyw"
    };
    function $f9b09597701b4b66$export$2ddb90ad54e5f587({ children: children, defaultWidth: defaultWidth = 365, label: label = 'Panel', testId: testId, id: id, xcss: xcss }) {
        const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, (0, parcelRequire("2Nqjv")).DangerouslyHoistSlotSizes));
        const UID = (0, (0, parcelRequire("jL4ZA")).usePrefixedUID)();
        const CID = id ? id : UID;
        (0, (0, parcelRequire("1xpqK")).useSkipLink)(CID, label);
        const ref = (0, $5uXOq.useRef)(null);
        const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
        const defaultWidthRef = (0, $5uXOq.useRef)(defaultWidth);
        (0, $5uXOq.useEffect)(()=>{
            if (defaultWidthRef.current === defaultWidth) return;
            defaultWidthRef.current = defaultWidth;
            setWidth(defaultWidth);
        }, [
            defaultWidth
        ]);
        const panelVariableWidth = `clamp(${$f9b09597701b4b66$var$panelWidthSlotBounds.min}, ${width}px, ${$f9b09597701b4b66$var$panelWidthSlotBounds.max})`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("section", {
            id: CID,
            "data-layout-slot": true,
            "aria-label": label,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $f9b09597701b4b66$var$styles.root,
                defaultWidth === 0 && $f9b09597701b4b66$var$styles.hidden,
                xcss
            ]),
            style: {
                [(0, (0, parcelRequire("58Ftb")).panelVar)]: panelVariableWidth
            },
            "data-testid": testId,
            ref: ref
        }, dangerouslyHoistSlotSizes && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a7W7J")).DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, (0, parcelRequire("58Ftb")).UNSAFE_panelLayoutVar),
            value: "0px",
            mediaQuery: (0, (0, parcelRequire("2MVcM")).media).above.lg,
            responsiveValue: panelVariableWidth
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fFBU4")).PanelSplitterProvider), {
            panelRef: ref,
            panelWidth: width,
            onCompleteResize: setWidth,
            resizeBounds: $f9b09597701b4b66$var$panelWidthResizeBounds,
            resizingCssVar: $f9b09597701b4b66$var$panelSplitterResizingVar,
            position: "start"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $f9b09597701b4b66$var$styles.scrollContainer
            ])
        }, children)));
    }
});
parcelRegister("a2MWg", function(module, exports) {
    $parcel$export(module.exports, "SideNav", ()=>$7b8748fc6fafcb65$export$1a35787d6353cf6a);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $6svox;
    var $954h0;
    var $2MVcM;
    var $chAiF;
    var $1xpqK;
    var $58Ftb;
    var $2Nqjv;
    var $a7W7J;
    var $fFBU4;
    var $jL4ZA;
    var $gNxdD;
    var $linOU;
    var $lh842;
    var $cgx9p;
    const $7b8748fc6fafcb65$var$panelSplitterResizingVar = '--n_snvRsz';
    const $7b8748fc6fafcb65$var$widthResizeBounds = {
        min: '240px',
        max: '50vw'
    };
    const $7b8748fc6fafcb65$var$sideNavFlyoutCloseDelayMs = 400;
    const $7b8748fc6fafcb65$var$getSideNavState = ({ visibleOnDesktop: visibleOnDesktop, visibleOnMobile: visibleOnMobile, isFlyoutVisible: isFlyoutVisible })=>{
        if (visibleOnDesktop && visibleOnMobile) return 'visible-all';
        if (!visibleOnMobile && visibleOnDesktop) return 'hidden-mobile-only';
        if (!visibleOnDesktop && isFlyoutVisible) return 'flyout';
        if (visibleOnMobile && !visibleOnDesktop) return 'hidden-desktop-only';
        return 'hidden-mobile-and-desktop';
    };
    const $7b8748fc6fafcb65$var$styles = {
        root: "_bfhk1bhr _16qs1cd0 _nd5l1b6c _4t3i1run _152t1l7u _kqsw1if8 _1bsb1ego _1pbycs5v _14b5hc79 _4ap3vuon _scbpglyw _qilnk0mc",
        flyout: "_4ap31bhr _scbp1cd0 _qiln1gzg",
        interactionSurface: "_1bsb1osq _4t3i1osq",
        flexContainer: "_4t3i1osq _1e0c1txw _2lx21bp4 _1bah1yb4",
        hiddenMobileAndDesktop: "_1e0cglyw",
        hiddenMobileOnly: "_1e0cglyw _dm2518uv",
        hiddenDesktopOnly: "_dm25glyw"
    };
    function $7b8748fc6fafcb65$var$SideNavInternal({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label = 'Side Navigation', onExpand: onExpand, onCollapse: onCollapse, id: id }) {
        const UID = (0, (0, parcelRequire("jL4ZA")).usePrefixedUID)();
        const CID = id ? id : UID;
        (0, (0, parcelRequire("1xpqK")).useSkipLink)(CID, label);
        const { visibleOnDesktop: visibleOnDesktop, visibleOnMobile: visibleOnMobile, setVisibleOnDesktop: setVisibleOnDesktop } = (0, (0, parcelRequire("linOU")).useSideNavVisibility)({
            defaultCollapsed: defaultCollapsed
        });
        const [width, setWidth] = (0, $5uXOq.useState)(defaultWidth);
        const clampedWidth = `clamp(${$7b8748fc6fafcb65$var$widthResizeBounds.min}, ${width}px, ${$7b8748fc6fafcb65$var$widthResizeBounds.max})`;
        const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, (0, parcelRequire("2Nqjv")).DangerouslyHoistSlotSizes));
        const navRef = (0, $5uXOq.useRef)(null);
        const toggleButtonElement = (0, $5uXOq.useContext)((0, (0, parcelRequire("gNxdD")).SideNavToggleButtonElement));
        const homeActionsElement = (0, $5uXOq.useContext)((0, (0, parcelRequire("chAiF")).HomeActionsElement));
        const devTimeOnlyAttributes = {};
        const [isFlyoutVisible, setIsFlyoutVisible] = (0, $5uXOq.useState)(false);
        const openLayerObserver = (0, (0, parcelRequire("954h0")).useOpenLayerObserver)();
        const flyoutStateRef = (0, $5uXOq.useRef)({
            type: 'not-active'
        });
        const sideNavState = $7b8748fc6fafcb65$var$getSideNavState({
            visibleOnDesktop: visibleOnDesktop,
            visibleOnMobile: visibleOnMobile,
            isFlyoutVisible: isFlyoutVisible
        });
        const updateFlyoutState = (0, $5uXOq.useCallback)((action)=>{
            if (action === 'open') {
                if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
                flyoutStateRef.current = {
                    type: 'open'
                };
                setIsFlyoutVisible(true);
                return;
            }
            if (action === 'waiting-for-close') {
                if (flyoutStateRef.current.type === 'waiting-for-close') return;
                const timeout = setTimeout(()=>{
                    updateFlyoutState('ready-to-close');
                }, $7b8748fc6fafcb65$var$sideNavFlyoutCloseDelayMs);
                flyoutStateRef.current = {
                    type: 'waiting-for-close',
                    abort () {
                        clearTimeout(timeout);
                    }
                };
                return;
            }
            if (action === 'ready-to-close') {
                flyoutStateRef.current = {
                    type: 'ready-to-close'
                };
                if (openLayerObserver.getCount() === 0) {
                    flyoutStateRef.current = {
                        type: 'not-active'
                    };
                    setIsFlyoutVisible(false);
                }
                return;
            }
            if (action === 'force-close') {
                flyoutStateRef.current = {
                    type: 'not-active'
                };
                setIsFlyoutVisible(false);
                return;
            }
        }, [
            openLayerObserver
        ]);
        const toggleVisibility = (0, (0, parcelRequire("cgx9p")).useToggleSideNav)();
        (0, $5uXOq.useEffect)(()=>{
            setVisibleOnDesktop(visibleOnDesktop);
        }, [
            setVisibleOnDesktop,
            visibleOnDesktop
        ]);
        const handleExpand = (0, $5uXOq.useCallback)(({ screen: screen })=>{
            onExpand?.({
                screen: screen
            });
            updateFlyoutState('force-close');
        }, [
            onExpand,
            updateFlyoutState
        ]);
        const handleCollapse = (0, $5uXOq.useCallback)(({ screen: screen })=>{
            onCollapse?.({
                screen: screen
            });
            updateFlyoutState('force-close');
        }, [
            onCollapse,
            updateFlyoutState
        ]);
        (0, (0, parcelRequire("lh842")).useSideNavVisibilityCallbacks)({
            onExpand: handleExpand,
            onCollapse: handleCollapse,
            visibleOnDesktop: visibleOnDesktop,
            visibleOnMobile: visibleOnMobile
        });
        (0, $5uXOq.useEffect)(()=>{
            const mediaQueryList = window.matchMedia('(min-width: 64rem)');
            return (0, (0, parcelRequire("cBeZP")).bind)(mediaQueryList, {
                type: 'change',
                listener () {
                    if (mediaQueryList.matches) {
                        if (visibleOnMobile && !visibleOnDesktop) toggleVisibility();
                    }
                }
            });
        }, [
            toggleVisibility,
            visibleOnDesktop,
            visibleOnMobile
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!toggleButtonElement) return;
            return (0, (0, parcelRequire("cBeZP")).bind)(toggleButtonElement, {
                type: 'mouseenter',
                listener () {
                    if (visibleOnDesktop) return;
                    const { matches: matches } = window.matchMedia('(min-width: 64rem)');
                    if (matches) updateFlyoutState('open');
                }
            });
        }, [
            updateFlyoutState,
            toggleButtonElement,
            visibleOnDesktop
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!toggleButtonElement) return;
            return (0, (0, parcelRequire("cBeZP")).bind)(toggleButtonElement, {
                type: 'mouseleave',
                listener () {
                    if (!isFlyoutVisible) return;
                    updateFlyoutState('waiting-for-close');
                }
            });
        }, [
            isFlyoutVisible,
            toggleButtonElement,
            updateFlyoutState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!navRef.current) return;
            return (0, (0, parcelRequire("cBeZP")).bind)(navRef.current, {
                type: 'mouseenter',
                listener () {
                    if (visibleOnDesktop || !isFlyoutVisible) return;
                    updateFlyoutState('open');
                }
            });
        }, [
            isFlyoutVisible,
            updateFlyoutState,
            visibleOnDesktop
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!navRef.current) return;
            return (0, (0, parcelRequire("cBeZP")).bind)(navRef.current, {
                type: 'mouseleave',
                listener () {
                    if (!isFlyoutVisible) return;
                    updateFlyoutState('waiting-for-close');
                }
            });
        }, [
            isFlyoutVisible,
            updateFlyoutState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!homeActionsElement || !toggleButtonElement) return;
            return (0, (0, parcelRequire("cBeZP")).bind)(homeActionsElement, {
                type: 'mouseover',
                listener (event) {
                    if (visibleOnDesktop || !isFlyoutVisible) return;
                    if (event.target === homeActionsElement) {
                        updateFlyoutState('open');
                        return;
                    }
                    if (event.target instanceof Element && toggleButtonElement.contains(event.target)) return;
                    updateFlyoutState('waiting-for-close');
                }
            });
        }, [
            homeActionsElement,
            isFlyoutVisible,
            toggleButtonElement,
            visibleOnDesktop,
            updateFlyoutState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!homeActionsElement) return;
            return (0, (0, parcelRequire("cBeZP")).bind)(homeActionsElement, {
                type: 'mouseleave',
                listener () {
                    if (!isFlyoutVisible) return;
                    updateFlyoutState('waiting-for-close');
                }
            });
        }, [
            homeActionsElement,
            isFlyoutVisible,
            updateFlyoutState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            return openLayerObserver.onChange(function onChange({ count: count }) {
                if (flyoutStateRef.current.type === 'ready-to-close' && count === 0) {
                    setIsFlyoutVisible(false);
                    flyoutStateRef.current = {
                        type: 'not-active'
                    };
                }
            });
        }, [
            openLayerObserver,
            updateFlyoutState
        ]);
        (0, $5uXOq.useEffect)(()=>{
            return function cleanupPendingFlyoutClose() {
                if (flyoutStateRef.current.type === 'waiting-for-close') flyoutStateRef.current.abort();
            };
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("nav", {
            id: CID,
            ...devTimeOnlyAttributes,
            "data-layout-slot": true,
            "data-private-request-curved-border-on-main": sideNavState === 'visible-all' || sideNavState === 'hidden-mobile-only' ? true : undefined,
            "data-private-show-inline-start-border-on-main": sideNavState === 'visible-all' || sideNavState === 'hidden-mobile-only' ? true : undefined,
            "aria-label": label,
            style: {
                [(0, (0, parcelRequire("58Ftb")).sideNavVar)]: clampedWidth
            },
            ref: navRef,
            "data-testid": testId,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $7b8748fc6fafcb65$var$styles.root,
                sideNavState === 'hidden-mobile-only' && $7b8748fc6fafcb65$var$styles.hiddenMobileOnly,
                sideNavState === 'hidden-desktop-only' && $7b8748fc6fafcb65$var$styles.hiddenDesktopOnly,
                sideNavState === 'hidden-mobile-and-desktop' && $7b8748fc6fafcb65$var$styles.hiddenMobileAndDesktop,
                sideNavState === 'flyout' && $7b8748fc6fafcb65$var$styles.flyout
            ])
        }, dangerouslyHoistSlotSizes && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a7W7J")).DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, (0, parcelRequire("58Ftb")).UNSAFE_sideNavLayoutVar),
            value: "0px",
            mediaQuery: (0, (0, parcelRequire("2MVcM")).media).above.md,
            responsiveValue: visibleOnDesktop ? clampedWidth : 0
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fFBU4")).PanelSplitterProvider), {
            panelRef: navRef,
            panelWidth: width,
            onCompleteResize: setWidth,
            resizeBounds: $7b8748fc6fafcb65$var$widthResizeBounds,
            resizingCssVar: $7b8748fc6fafcb65$var$panelSplitterResizingVar,
            isEnabled: sideNavState === 'visible-all' || sideNavState === 'hidden-mobile-only'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $7b8748fc6fafcb65$var$styles.flexContainer
            ])
        }, children)));
    }
    function $7b8748fc6fafcb65$export$1a35787d6353cf6a({ children: children, defaultCollapsed: defaultCollapsed, defaultWidth: defaultWidth = 320, testId: testId, label: label = 'Side Navigation', onExpand: onExpand, onCollapse: onCollapse, id: id }) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6svox")).OpenLayerObserver), null, (0, ($parcel$interopDefault($5uXOq))).createElement($7b8748fc6fafcb65$var$SideNavInternal, {
            defaultCollapsed: defaultCollapsed,
            defaultWidth: defaultWidth,
            testId: testId,
            label: label,
            onExpand: onExpand,
            onCollapse: onCollapse,
            id: id
        }, children));
    }
});
parcelRegister("6svox", function(module, exports) {
    $parcel$export(module.exports, "OpenLayerObserver", ()=>$6ecd140dad1159dc$export$97afddda23bcd287);
    var $5uXOq = parcelRequire("5uXOq");
    var $ipYZs;
    function $6ecd140dad1159dc$var$createInternalAPI() {
        let count = 0;
        const registry = new Set();
        function onChange(listener) {
            function wrapped(...args) {
                listener(...args);
            }
            registry.add(wrapped);
            return function unsubscribe() {
                registry.delete(wrapped);
            };
        }
        function increment() {
            count += 1;
            Array.from(registry).forEach((listener)=>listener({
                    count: count
                }));
        }
        function decrement() {
            count -= 1;
            Array.from(registry).forEach((listener)=>listener({
                    count: count
                }));
        }
        return {
            getCount () {
                return count;
            },
            onChange: onChange,
            increment: increment,
            decrement: decrement
        };
    }
    function $6ecd140dad1159dc$export$97afddda23bcd287({ children: children }) {
        const [internalAPI] = (0, $5uXOq.useState)(()=>$6ecd140dad1159dc$var$createInternalAPI());
        const parentContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("ipYZs")).OpenLayerObserverContext));
        const increment = (0, $5uXOq.useCallback)(()=>{
            internalAPI.increment();
            if (parentContext !== null) parentContext.increment();
        }, [
            internalAPI,
            parentContext
        ]);
        const decrement = (0, $5uXOq.useCallback)(()=>{
            internalAPI.decrement();
            if (parentContext !== null) parentContext.decrement();
        }, [
            internalAPI,
            parentContext
        ]);
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                getCount: internalAPI.getCount,
                onChange: internalAPI.onChange,
                increment: increment,
                decrement: decrement
            }), [
            decrement,
            increment,
            internalAPI.getCount,
            internalAPI.onChange
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ipYZs")).OpenLayerObserverContext).Provider, {
            value: contextValue
        }, children);
    }
});
parcelRegister("954h0", function(module, exports) {
    $parcel$export(module.exports, "useOpenLayerObserver", ()=>$16e4cf755c94ca95$export$750f5b0d6c51617e);
    var $5uXOq = parcelRequire("5uXOq");
    var $3joPi = parcelRequire("3joPi");
    var $ipYZs;
    function $16e4cf755c94ca95$export$750f5b0d6c51617e() {
        const context = (0, $5uXOq.useContext)((0, (0, parcelRequire("ipYZs")).OpenLayerObserverContext));
        (0, $3joPi.default)(context, 'useOpenLayerObserver must be used within an OpenLayerObserver');
        const publicAPI = (0, $5uXOq.useMemo)(()=>({
                getCount: context.getCount,
                onChange: context.onChange
            }), [
            context.getCount,
            context.onChange
        ]);
        return publicAPI;
    }
});
parcelRegister("linOU", function(module, exports) {
    $parcel$export(module.exports, "useSideNavVisibility", ()=>$35aa6d67937a9622$export$4a602ad7e09bdb2c);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $4HAIT;
    const $35aa6d67937a9622$export$4a602ad7e09bdb2c = ({ defaultCollapsed: defaultCollapsed = false } = {})=>{
        const visibleOnDesktop = (0, $5uXOq.useContext)((0, (0, parcelRequire("4HAIT")).SideNavDesktopVisibility));
        const setVisibleOnDesktop = (0, $5uXOq.useContext)((0, (0, parcelRequire("4HAIT")).SetSideNavDesktopVisibility));
        const visibleOnMobile = (0, $5uXOq.useContext)((0, (0, parcelRequire("4HAIT")).SideNavMobileVisibility));
        const setVisibleOnMobile = (0, $5uXOq.useContext)((0, (0, parcelRequire("4HAIT")).SetSideNavMobileVisibility));
        const [isSideNavVisible, setIsSideNavVisible] = (0, $5uXOq.useState)(!defaultCollapsed);
        (0, $5uXOq.useEffect)(()=>{
            const isSideNavVisibleOnDesktop = visibleOnDesktop === null ? !defaultCollapsed : visibleOnDesktop;
            const mediaQueryList = window.matchMedia('(min-width: 64rem)');
            setIsSideNavVisible(mediaQueryList.matches ? isSideNavVisibleOnDesktop : visibleOnMobile);
            return (0, (0, parcelRequire("cBeZP")).bind)(mediaQueryList, {
                type: 'change',
                listener () {
                    setIsSideNavVisible(mediaQueryList.matches ? isSideNavVisibleOnDesktop : visibleOnMobile);
                }
            });
        }, [
            defaultCollapsed,
            visibleOnDesktop,
            visibleOnMobile
        ]);
        const showSideNav = (0, $5uXOq.useCallback)(()=>{
            const { matches: matches } = window.matchMedia('(min-width: 64rem)');
            matches ? setVisibleOnDesktop(true) : setVisibleOnMobile(true);
        }, [
            setVisibleOnDesktop,
            setVisibleOnMobile
        ]);
        return {
            visibleOnDesktop: visibleOnDesktop === null ? !defaultCollapsed : visibleOnDesktop,
            visibleOnMobile: visibleOnMobile,
            setVisibleOnDesktop: setVisibleOnDesktop,
            setVisibleOnMobile: setVisibleOnMobile,
            isSideNavVisible: isSideNavVisible,
            showSideNav: showSideNav
        };
    };
});
parcelRegister("lh842", function(module, exports) {
    $parcel$export(module.exports, "useSideNavVisibilityCallbacks", ()=>$ddc775853d0385ea$export$1904b8f2577aba9a);
    var $5uXOq = parcelRequire("5uXOq");
    var $jHB2D;
    function $ddc775853d0385ea$export$1904b8f2577aba9a({ onExpand: onExpand, onCollapse: onCollapse, visibleOnDesktop: visibleOnDesktop, visibleOnMobile: visibleOnMobile }) {
        const onExpandRef = (0, $5uXOq.useRef)(onExpand);
        const onCollapseRef = (0, $5uXOq.useRef)(onCollapse);
        (0, $5uXOq.useEffect)(()=>{
            onExpandRef.current = onExpand;
            onCollapseRef.current = onCollapse;
        }, [
            onExpand,
            onCollapse
        ]);
        const previousVisibleOnDesktop = (0, (0, parcelRequire("jHB2D")).default)(visibleOnDesktop);
        (0, $5uXOq.useEffect)(()=>{
            if (previousVisibleOnDesktop === undefined || previousVisibleOnDesktop === visibleOnDesktop) return;
            if (visibleOnDesktop) onExpandRef.current?.({
                screen: 'desktop'
            });
            else onCollapseRef.current?.({
                screen: 'desktop'
            });
        }, [
            previousVisibleOnDesktop,
            visibleOnDesktop
        ]);
        const previousVisibleOnMobile = (0, (0, parcelRequire("jHB2D")).default)(visibleOnMobile);
        (0, $5uXOq.useEffect)(()=>{
            if (previousVisibleOnMobile === undefined || previousVisibleOnMobile === visibleOnMobile) return;
            if (visibleOnMobile) onExpandRef.current?.({
                screen: 'mobile'
            });
            else onCollapseRef.current?.({
                screen: 'mobile'
            });
        }, [
            previousVisibleOnMobile,
            visibleOnMobile
        ]);
    }
});
parcelRegister("cgx9p", function(module, exports) {
    $parcel$export(module.exports, "useToggleSideNav", ()=>$eed403a60ed11ec8$export$477ee35601a0a8ce);
    var $5uXOq = parcelRequire("5uXOq");
    var $4HAIT;
    function $eed403a60ed11ec8$export$477ee35601a0a8ce() {
        const setVisibleOnDesktop = (0, $5uXOq.useContext)((0, (0, parcelRequire("4HAIT")).SetSideNavDesktopVisibility));
        const setVisibleOnMobile = (0, $5uXOq.useContext)((0, (0, parcelRequire("4HAIT")).SetSideNavMobileVisibility));
        const toggleSideNav = (0, $5uXOq.useCallback)(()=>{
            const { matches: matches } = window.matchMedia('(min-width: 64rem)');
            if (matches) setVisibleOnDesktop((prev)=>!prev);
            else setVisibleOnMobile((prev)=>!prev);
        }, [
            setVisibleOnDesktop,
            setVisibleOnMobile
        ]);
        return toggleSideNav;
    }
});
parcelRegister("7CyGM", function(module, exports) {
    $parcel$export(module.exports, "TopBar", ()=>$e3c7bce3ae49009c$export$c4e96258f3b6511);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $1xpqK;
    var $h1WO9;
    var $dw4hG;
    var $58Ftb;
    var $2Nqjv;
    var $a7W7J;
    var $jL4ZA;
    const $e3c7bce3ae49009c$var$styles = {
        root: "_1e0c11p5 _yv0e1mfv _zulpu2gc _nd5l8cbt _18zrutpp _4cvr1h6o _bfhkvuon _vchhusvi _4t3i2mmk _152t1nws _kqsw1if8 _1pbyegat _d6vu1bgi _1rqtc57g"
    };
    const $e3c7bce3ae49009c$var$contentBorderStyles = {
        smallViewportTop: "_nd5l8cbt _179rzgxb _152t1nws _lcxvglyw _kqsw1if8 _t9ec2nsj _1pby11wp _dm25glyw"
    };
    function $e3c7bce3ae49009c$export$c4e96258f3b6511({ children: children, xcss: xcss, UNSAFE_height: UNSAFE_height = 48, label: label = 'Top Bar', testId: testId, id: id, UNSAFE_theme: UNSAFE_theme }) {
        const dangerouslyHoistSlotSizes = (0, $5uXOq.useContext)((0, (0, parcelRequire("2Nqjv")).DangerouslyHoistSlotSizes));
        const UID = (0, (0, parcelRequire("jL4ZA")).usePrefixedUID)();
        const CID = id ? id : UID;
        (0, (0, parcelRequire("1xpqK")).useSkipLink)(CID, label);
        const customTheme = (0, (0, parcelRequire("dw4hG")).useCustomTheme)(UNSAFE_theme);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h1WO9")).HasCustomThemeContext).Provider, {
            value: customTheme.isEnabled
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("header", {
            id: CID,
            "data-layout-slot": true,
            "data-private-do-not-show-curved-border-on-main": customTheme.isEnabled ? true : undefined,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $e3c7bce3ae49009c$var$styles.root,
                xcss
            ]),
            "data-testid": testId,
            style: customTheme.isEnabled ? customTheme.style : undefined
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a7W7J")).HoistCssVarToLocalGrid), {
            variableName: (0, (0, parcelRequire("58Ftb")).topBarMountedVar),
            value: UNSAFE_height
        }), dangerouslyHoistSlotSizes && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a7W7J")).DangerouslyHoistCssVarToDocumentRoot), {
            variableName: (0, (0, parcelRequire("58Ftb")).UNSAFE_topBarVar),
            value: UNSAFE_height
        }), children), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-layout-slot": true,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                $e3c7bce3ae49009c$var$contentBorderStyles.smallViewportTop
            ])
        }));
    }
});
parcelRegister("dw4hG", function(module, exports) {
    $parcel$export(module.exports, "useCustomTheme", ()=>$aa9f8dfa4bbb7a42$export$c0c5f5b297b77726);
    var $5uXOq = parcelRequire("5uXOq");
    var $294ns;
    var $e0eCt;
    function $aa9f8dfa4bbb7a42$export$c0c5f5b297b77726(theme) {
        const value = (0, $5uXOq.useMemo)(()=>{
            if (!(0, (0, parcelRequire("294ns")).fg)('platform_design_system_nav4_top_bar_theming')) return {
                isEnabled: false
            };
            if (!theme?.backgroundColor || !theme?.highlightColor) return {
                isEnabled: false
            };
            const value = {
                backgroundColor: theme.backgroundColor,
                highlightColor: theme.highlightColor
            };
            const style = (0, (0, parcelRequire("e0eCt")).getCustomThemeStyles)(value);
            return {
                isEnabled: true,
                style: style
            };
        }, [
            theme?.backgroundColor,
            theme?.highlightColor
        ]);
        return value;
    }
});
parcelRegister("e0eCt", function(module, exports) {
    $parcel$export(module.exports, "getCustomThemeStyles", ()=>$8191210ddd7c7b0b$export$3986d75fe2da3239);
    var $7ELI2;
    var $hWj1T;
    var $f0LsZ;
    var $7DhNr;
    var $70glb;
    const $8191210ddd7c7b0b$var$buttonStyles = {
        light: {
            [(0, (0, parcelRequire("hWj1T")).themedButtonBackground)]: 'transparent',
            [(0, (0, parcelRequire("hWj1T")).themedButtonBackgroundHovered)]: (0, (0, parcelRequire("7DhNr")).palette).Neutral200A,
            [(0, (0, parcelRequire("hWj1T")).themedButtonBackgroundPressed)]: (0, (0, parcelRequire("7DhNr")).palette).Neutral300A,
            [(0, (0, parcelRequire("hWj1T")).themedButtonBorder)]: (0, (0, parcelRequire("7DhNr")).palette).Neutral300A,
            [(0, (0, parcelRequire("hWj1T")).themedButtonSelectedBackground)]: (0, (0, parcelRequire("7DhNr")).palette).Neutral300A,
            [(0, (0, parcelRequire("hWj1T")).themedButtonSelectedBackgroundHovered)]: (0, (0, parcelRequire("7DhNr")).palette).Neutral400A,
            [(0, (0, parcelRequire("hWj1T")).themedButtonSelectedBackgroundPressed)]: (0, (0, parcelRequire("7DhNr")).palette).Neutral500A,
            [(0, (0, parcelRequire("hWj1T")).themedButtonDisabledText)]: (0, (0, parcelRequire("7DhNr")).palette).Neutral400A,
            [(0, (0, parcelRequire("hWj1T")).themedButtonDisabledBackground)]: (0, (0, parcelRequire("7DhNr")).palette).Neutral100A
        },
        dark: {
            [(0, (0, parcelRequire("hWj1T")).themedButtonBackground)]: 'transparent',
            [(0, (0, parcelRequire("hWj1T")).themedButtonBackgroundHovered)]: (0, (0, parcelRequire("7DhNr")).palette).DarkNeutral200A,
            [(0, (0, parcelRequire("hWj1T")).themedButtonBackgroundPressed)]: (0, (0, parcelRequire("7DhNr")).palette).DarkNeutral300A,
            [(0, (0, parcelRequire("hWj1T")).themedButtonBorder)]: (0, (0, parcelRequire("7DhNr")).palette).DarkNeutral300A,
            [(0, (0, parcelRequire("hWj1T")).themedButtonSelectedBackground)]: (0, (0, parcelRequire("7DhNr")).palette).DarkNeutral300A,
            [(0, (0, parcelRequire("hWj1T")).themedButtonSelectedBackgroundHovered)]: (0, (0, parcelRequire("7DhNr")).palette).DarkNeutral400A,
            [(0, (0, parcelRequire("hWj1T")).themedButtonSelectedBackgroundPressed)]: (0, (0, parcelRequire("7DhNr")).palette).DarkNeutral500A,
            [(0, (0, parcelRequire("hWj1T")).themedButtonDisabledText)]: (0, (0, parcelRequire("7DhNr")).palette).DarkNeutral400A,
            [(0, (0, parcelRequire("hWj1T")).themedButtonDisabledBackground)]: (0, (0, parcelRequire("7DhNr")).palette).DarkNeutral100A
        }
    };
    const $8191210ddd7c7b0b$var$logoStyles = {
        light: {
            [(0, (0, parcelRequire("7ELI2")).themedLogoIcon)]: (0, (0, parcelRequire("7DhNr")).palette).DarkNeutral0,
            [(0, (0, parcelRequire("7ELI2")).themedLogoText)]: (0, (0, parcelRequire("7DhNr")).palette).DarkNeutral0
        },
        dark: {
            [(0, (0, parcelRequire("7ELI2")).themedLogoIcon)]: (0, (0, parcelRequire("7DhNr")).palette).Neutral0,
            [(0, (0, parcelRequire("7ELI2")).themedLogoText)]: (0, (0, parcelRequire("7DhNr")).palette).Neutral0
        }
    };
    function $8191210ddd7c7b0b$export$3986d75fe2da3239({ backgroundColor: backgroundColor, highlightColor: highlightColor }) {
        const backgroundRgb = (0, (0, parcelRequire("f0LsZ")).hexToRGB)(backgroundColor);
        const highlightRgb = (0, (0, parcelRequire("f0LsZ")).hexToRGB)(highlightColor);
        const textColor = (0, (0, parcelRequire("f0LsZ")).getTextColor)(backgroundRgb);
        const colorMode = (0, (0, parcelRequire("f0LsZ")).getColorMode)(backgroundRgb);
        const highlightTextColor = (0, (0, parcelRequire("f0LsZ")).getTextColor)(highlightRgb);
        return {
            backgroundColor: backgroundColor,
            color: textColor.hex,
            ...$8191210ddd7c7b0b$var$buttonStyles[colorMode],
            ...$8191210ddd7c7b0b$var$logoStyles[colorMode],
            ...$8191210ddd7c7b0b$var$getSelectedStyles({
                backgroundColor: backgroundRgb,
                colorMode: colorMode
            }),
            [(0, (0, parcelRequire("70glb")).themedSearchBorder)]: (0, (0, parcelRequire("f0LsZ")).toRGBAString)({
                ...textColor.rgb,
                a: 0.5
            }),
            [(0, (0, parcelRequire("70glb")).themedSearchBorderFocused)]: (0, (0, parcelRequire("f0LsZ")).toRGBAString)({
                ...highlightRgb,
                a: 0.8
            }),
            [(0, (0, parcelRequire("hWj1T")).themedButtonPrimaryBackground)]: highlightColor,
            [(0, (0, parcelRequire("hWj1T")).themedButtonPrimaryBackgroundHovered)]: (0, (0, parcelRequire("f0LsZ")).toRGBAString)({
                ...highlightRgb,
                a: 0.8
            }),
            [(0, (0, parcelRequire("hWj1T")).themedButtonPrimaryBackgroundPressed)]: (0, (0, parcelRequire("f0LsZ")).toRGBAString)({
                ...highlightRgb,
                a: 0.65
            }),
            [(0, (0, parcelRequire("hWj1T")).themedButtonPrimaryText)]: highlightTextColor.hex
        };
    }
    const $8191210ddd7c7b0b$var$selectedBackgroundRGBA = {
        light: (0, (0, parcelRequire("f0LsZ")).hexToRGBA)($8191210ddd7c7b0b$var$buttonStyles.light[0, (0, parcelRequire("hWj1T")).themedButtonSelectedBackground]),
        dark: (0, (0, parcelRequire("f0LsZ")).hexToRGBA)($8191210ddd7c7b0b$var$buttonStyles.dark[0, (0, parcelRequire("hWj1T")).themedButtonSelectedBackground])
    };
    function $8191210ddd7c7b0b$var$getSelectedStyles({ backgroundColor: backgroundColor, colorMode: colorMode }) {
        const foregroundColor = $8191210ddd7c7b0b$var$selectedBackgroundRGBA[colorMode];
        const blendedBackground = (0, (0, parcelRequire("f0LsZ")).simpleAlphaComposite)({
            background: backgroundColor,
            foreground: foregroundColor
        });
        return {
            [(0, (0, parcelRequire("hWj1T")).themedButtonSelectedText)]: (0, (0, parcelRequire("f0LsZ")).getTextColor)(blendedBackground).hex,
            [(0, (0, parcelRequire("hWj1T")).themedButtonSelectedBorder)]: (0, (0, parcelRequire("f0LsZ")).isLight)(blendedBackground) ? (0, (0, parcelRequire("7DhNr")).palette).Neutral1100 : (0, (0, parcelRequire("7DhNr")).palette).DarkNeutral1100
        };
    }
});
parcelRegister("f0LsZ", function(module, exports) {
    $parcel$export(module.exports, "toRGBAString", ()=>$e9c3606b2b455aa6$export$b597d7418f37d50a);
    $parcel$export(module.exports, "hexToRGBA", ()=>$e9c3606b2b455aa6$export$7229be6d7219ee6a);
    $parcel$export(module.exports, "hexToRGB", ()=>$e9c3606b2b455aa6$export$848d71df1f759bc);
    $parcel$export(module.exports, "isLight", ()=>$e9c3606b2b455aa6$export$44af652f4cca9039);
    $parcel$export(module.exports, "getColorMode", ()=>$e9c3606b2b455aa6$export$5573a5bab3e074b5);
    $parcel$export(module.exports, "getTextColor", ()=>$e9c3606b2b455aa6$export$5357fe757c335c0d);
    $parcel$export(module.exports, "simpleAlphaComposite", ()=>$e9c3606b2b455aa6$export$e5e64c30bee1469b);
    const $e9c3606b2b455aa6$var$isValidHex = (hex)=>/^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
    const $e9c3606b2b455aa6$var$isValidHexNoAlpha = (hex)=>/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex);
    function $e9c3606b2b455aa6$export$b597d7418f37d50a({ r: r, g: g, b: b, a: a }) {
        return `rgba(${r}, ${g}, ${b}, ${a})`;
    }
    function $e9c3606b2b455aa6$export$7229be6d7219ee6a(hex) {
        if (!$e9c3606b2b455aa6$var$isValidHex(hex)) throw new Error('Invalid HEX');
        let channels;
        if (hex.length <= 5) channels = {
            r: hex[1].repeat(2),
            g: hex[2].repeat(2),
            b: hex[3].repeat(2),
            a: hex[4]?.repeat(2) ?? 'FF'
        };
        else channels = {
            r: hex.slice(1, 3),
            g: hex.slice(3, 5),
            b: hex.slice(5, 7),
            a: hex.slice(7, 9) || 'FF'
        };
        return {
            r: parseInt(channels.r, 16),
            g: parseInt(channels.g, 16),
            b: parseInt(channels.b, 16),
            a: parseInt(channels.a, 16) / 255
        };
    }
    function $e9c3606b2b455aa6$export$848d71df1f759bc(hex) {
        if (!$e9c3606b2b455aa6$var$isValidHexNoAlpha(hex)) throw new Error('Invalid HEX');
        const { r: r, g: g, b: b } = $e9c3606b2b455aa6$export$7229be6d7219ee6a(hex);
        return {
            r: r,
            g: g,
            b: b
        };
    }
    function $e9c3606b2b455aa6$var$linearizeRGBChannel(channel) {
        return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }
    function $e9c3606b2b455aa6$var$relativeLuminanceW3C({ r: r, g: g, b: b }) {
        const normal = {
            r: r / 255,
            g: g / 255,
            b: b / 255
        };
        const linear = {
            r: $e9c3606b2b455aa6$var$linearizeRGBChannel(normal.r),
            g: $e9c3606b2b455aa6$var$linearizeRGBChannel(normal.g),
            b: $e9c3606b2b455aa6$var$linearizeRGBChannel(normal.b)
        };
        const L = 0.2126 * linear.r + 0.7152 * linear.g + 0.0722 * linear.b;
        return L;
    }
    function $e9c3606b2b455aa6$export$d061e26956a60b0a({ background: background, foreground: foreground }) {
        const foregroundLuminance = $e9c3606b2b455aa6$var$relativeLuminanceW3C(foreground);
        const backgroundLuminance = $e9c3606b2b455aa6$var$relativeLuminanceW3C(background);
        const brightest = Math.max(foregroundLuminance, backgroundLuminance);
        const darkest = Math.min(foregroundLuminance, backgroundLuminance);
        return (brightest + 0.05) / (darkest + 0.05);
    }
    const $e9c3606b2b455aa6$var$flipLuminance = 0.179129;
    function $e9c3606b2b455aa6$export$44af652f4cca9039(color) {
        return $e9c3606b2b455aa6$var$relativeLuminanceW3C(color) >= $e9c3606b2b455aa6$var$flipLuminance;
    }
    function $e9c3606b2b455aa6$export$5573a5bab3e074b5(backgroundColor) {
        if ($e9c3606b2b455aa6$var$relativeLuminanceW3C(backgroundColor) >= $e9c3606b2b455aa6$var$flipLuminance) return 'light';
        return 'dark';
    }
    const $e9c3606b2b455aa6$var$textColor = {
        light: {
            hex: '#000',
            rgb: {
                r: 0,
                g: 0,
                b: 0
            }
        },
        dark: {
            hex: '#FFF',
            rgb: {
                r: 255,
                g: 255,
                b: 255
            }
        }
    };
    function $e9c3606b2b455aa6$export$5357fe757c335c0d(backgroundColor) {
        const colorMode = $e9c3606b2b455aa6$export$5573a5bab3e074b5(backgroundColor);
        return $e9c3606b2b455aa6$var$textColor[colorMode];
    }
    function $e9c3606b2b455aa6$export$e5e64c30bee1469b({ background: background, foreground: foreground }) {
        return {
            r: foreground.a * foreground.r + background.r * (1 - foreground.a),
            g: foreground.a * foreground.g + background.g * (1 - foreground.a),
            b: foreground.a * foreground.b + background.b * (1 - foreground.a)
        };
    }
});
parcelRegister("7DhNr", function(module, exports) {
    $parcel$export(module.exports, "palette", ()=>$85eb0cc4e457e6ab$export$eaad8caa32d2521d);
    const $85eb0cc4e457e6ab$export$eaad8caa32d2521d = {
        'DarkNeutral-100': '#111213',
        'DarkNeutral-100A': '#01040475',
        DarkNeutral0: '#18191A',
        DarkNeutral100: '#1F1F21',
        DarkNeutral100A: '#BDBDBD0A',
        DarkNeutral200: '#242528',
        DarkNeutral200A: '#CECED912',
        DarkNeutral250: '#2B2C2F',
        DarkNeutral250A: '#D9DAE71A',
        DarkNeutral300: '#303134',
        DarkNeutral300A: '#E3E4F21F',
        DarkNeutral350: '#3D3F43',
        DarkNeutral350A: '#E8EDFD2E',
        DarkNeutral400: '#4B4D51',
        DarkNeutral400A: '#E5E9F640',
        DarkNeutral500: '#63666B',
        DarkNeutral500A: '#E9F0FB5C',
        DarkNeutral600: '#7E8188',
        DarkNeutral700: '#96999E',
        DarkNeutral800: '#A9ABAF',
        DarkNeutral900: '#BFC1C4',
        DarkNeutral1000: '#CECFD2',
        DarkNeutral1100: '#E2E3E4',
        Neutral0: '#FFFFFF',
        Neutral100: '#F8F8F8',
        Neutral100A: '#17171708',
        Neutral200: '#F0F1F2',
        Neutral200A: '#0515240F',
        Neutral300: '#DDDEE1',
        Neutral300A: '#0B120E24',
        Neutral400: '#B7B9BE',
        Neutral400A: '#080F214A',
        Neutral500: '#8C8F97',
        Neutral500A: '#050C1F75',
        Neutral600: '#7D818A',
        Neutral700: '#6B6E76',
        Neutral800: '#505258',
        Neutral900: '#3B3D42',
        Neutral1000: '#292A2E',
        Neutral1100: '#1E1F21'
    };
});
parcelRegister("5e5zm", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_LEFT_SIDEBAR_WIDTH", ()=>$0c99a19d69d506cf$export$539e68c09584883a);
    $parcel$export(module.exports, "layoutStore", ()=>$0c99a19d69d506cf$export$b8cdfd44cddaf07);
    $parcel$export(module.exports, "useLayoutStoreActions", ()=>$0c99a19d69d506cf$export$6136bc3b9858cff4);
    $parcel$export(module.exports, "useDetailPanelWidth", ()=>$0c99a19d69d506cf$export$95fd7b6da3b9bbb0);
    $parcel$export(module.exports, "useDetailPanelActions", ()=>$0c99a19d69d506cf$export$99e05a60cac05e86);
    var $7JoAD = parcelRequire("7JoAD");
    var $8CM3x;
    const $0c99a19d69d506cf$export$539e68c09584883a = 240;
    const $0c99a19d69d506cf$export$b92df8810d2fcd01 = 0;
    const $0c99a19d69d506cf$var$initialState = {
        isChromeless: false,
        isFullscreen: false,
        banner: {
            height: 0,
            activeBanner: null
        },
        topNavigation: {
            isVisible: true
        },
        leftPanel: {
            isVisible: true,
            width: 0
        },
        rightPanel: {
            isVisible: true,
            width: 0
        },
        bottomRightCorner: {
            container: undefined,
            portals: []
        },
        content: {
            leftSidebar: {
                width: $0c99a19d69d506cf$export$539e68c09584883a,
                isCollapsed: true,
                isVisible: true,
                isFlyoutOpen: false
            },
            rightSidebar: {
                stackState: []
            }
        }
    };
    const $0c99a19d69d506cf$export$b8cdfd44cddaf07 = (0, $7JoAD.createStore)({
        initialState: $0c99a19d69d506cf$var$initialState,
        actions: (0, parcelRequire("8CM3x")).actions,
        name: 'JiraLayoutStore'
    });
    const $0c99a19d69d506cf$export$6136bc3b9858cff4 = (0, $7JoAD.createHook)($0c99a19d69d506cf$export$b8cdfd44cddaf07, {
        selector: null
    });
    const $0c99a19d69d506cf$var$detailPanelWidthStore = (0, $7JoAD.createStore)({
        name: 'detailPanelWidth',
        initialState: {
            width: 0
        },
        actions: {
            setWidth: (value)=>({ setState: setState })=>{
                    setState({
                        width: value
                    });
                }
        }
    });
    const $0c99a19d69d506cf$export$95fd7b6da3b9bbb0 = (0, $7JoAD.createHook)($0c99a19d69d506cf$var$detailPanelWidthStore);
    const $0c99a19d69d506cf$export$99e05a60cac05e86 = (0, $7JoAD.createActionsHook)($0c99a19d69d506cf$var$detailPanelWidthStore);
});
parcelRegister("8CM3x", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$939ad82f8ddcb8d9$export$e324594224ef24da);
    var $4oU0I;
    var $flhve;
    var $f5TQt;
    var $hPsAX;
    var $gqQUV;
    var $byk51;
    const $939ad82f8ddcb8d9$export$e324594224ef24da = {
        setIsChromeless: (0, parcelRequire("f5TQt")).setIsChromeless,
        setIsFullscreen: (0, parcelRequire("hPsAX")).setIsFullscreen,
        showBanner: (0, parcelRequire("4oU0I")).showBanner,
        dismissCurrentBanner: (0, parcelRequire("4oU0I")).dismissCurrentBanner,
        setLeftSidebarState: (0, parcelRequire("gqQUV")).setLeftSidebarState,
        setRightSidebarState: (0, parcelRequire("byk51")).setRightSidebarState,
        openRightSidebar: (0, parcelRequire("byk51")).openRightSidebar,
        closeRightSidebar: (0, parcelRequire("byk51")).closeRightSidebar,
        closeAllRightSidebar: (0, parcelRequire("byk51")).closeAllRightSidebar,
        closeCurrentRightSidebar: (0, parcelRequire("byk51")).closeCurrentRightSidebar,
        minimiseRightSidebar: (0, parcelRequire("byk51")).minimiseRightSidebar,
        registerBottomRightCornerContainer: (0, parcelRequire("flhve")).registerBottomRightCornerContainer,
        insertBottomRightCornerPortal: (0, parcelRequire("flhve")).insertBottomRightCornerPortal,
        removeBottomRightCornerPortal: (0, parcelRequire("flhve")).removeBottomRightCornerPortal
    };
});
parcelRegister("4oU0I", function(module, exports) {
    $parcel$export(module.exports, "showBanner", ()=>$820929f36789bf81$export$f5c0eb035ef26e87);
    $parcel$export(module.exports, "dismissCurrentBanner", ()=>$820929f36789bf81$export$a45bccc0cc9ac424);
    const $820929f36789bf81$export$f5c0eb035ef26e87 = (newState)=>({ setState: setState })=>{
            setState({
                banner: newState
            });
        };
    const $820929f36789bf81$export$a45bccc0cc9ac424 = ()=>({ dispatch: dispatch })=>{
            dispatch($820929f36789bf81$export$f5c0eb035ef26e87({
                height: 0,
                activeBanner: null
            }));
        };
});
parcelRegister("flhve", function(module, exports) {
    $parcel$export(module.exports, "registerBottomRightCornerContainer", ()=>$560ff4740e75fa9e$export$2992ecf780497763);
    $parcel$export(module.exports, "insertBottomRightCornerPortal", ()=>$560ff4740e75fa9e$export$3ed25a6bee272520);
    $parcel$export(module.exports, "removeBottomRightCornerPortal", ()=>$560ff4740e75fa9e$export$928bf7e228ce06d2);
    const $560ff4740e75fa9e$export$2992ecf780497763 = (ref)=>({ setState: setState, getState: getState })=>{
            const { bottomRightCorner: bottomRightCorner } = getState();
            setState({
                bottomRightCorner: {
                    ...bottomRightCorner,
                    container: ref ?? undefined
                }
            });
        };
    const $560ff4740e75fa9e$export$3ed25a6bee272520 = (item)=>({ setState: setState, getState: getState })=>{
            const { bottomRightCorner: bottomRightCorner } = getState();
            const { portals: portals } = bottomRightCorner;
            const sorted = [
                item,
                ...portals
            ].sort((a, b)=>b.orderFromRight - a.orderFromRight);
            const index = sorted.findIndex((portal)=>portal.id === item.id);
            setState({
                bottomRightCorner: {
                    ...bottomRightCorner,
                    portals: sorted
                }
            });
            return index;
        };
    const $560ff4740e75fa9e$export$928bf7e228ce06d2 = (id)=>({ setState: setState, getState: getState })=>{
            const { bottomRightCorner: bottomRightCorner } = getState();
            const { portals: portals } = bottomRightCorner;
            setState({
                bottomRightCorner: {
                    ...bottomRightCorner,
                    portals: portals.filter((portal)=>portal.id !== id)
                }
            });
        };
});
parcelRegister("f5TQt", function(module, exports) {
    $parcel$export(module.exports, "setIsChromeless", ()=>$0389a2d5715d1f25$export$1998c4816ad37edb);
    const $0389a2d5715d1f25$export$1998c4816ad37edb = (isChromeless)=>({ setState: setState })=>{
            setState({
                isChromeless: isChromeless
            });
        };
});
parcelRegister("hPsAX", function(module, exports) {
    $parcel$export(module.exports, "setIsFullscreen", ()=>$e3c9e6899dc6b3f0$export$9c73b2f282069160);
    const $e3c9e6899dc6b3f0$export$9c73b2f282069160 = (isFullscreen)=>({ setState: setState })=>{
            setState({
                isFullscreen: isFullscreen
            });
        };
});
parcelRegister("gqQUV", function(module, exports) {
    $parcel$export(module.exports, "setLeftSidebarState", ()=>$54ca906cbb882b25$export$3e0fd2d894ef83c8);
    const $54ca906cbb882b25$export$3e0fd2d894ef83c8 = (newState)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            setState({
                content: {
                    ...content,
                    leftSidebar: {
                        ...content.leftSidebar,
                        ...newState
                    }
                }
            });
        };
});
parcelRegister("byk51", function(module, exports) {
    $parcel$export(module.exports, "selectCurrentRightSidebar", ()=>$4dabd377b098e1a2$export$57758d0cfaeec2c);
    $parcel$export(module.exports, "setRightSidebarState", ()=>$4dabd377b098e1a2$export$f5584170a8c1db02);
    $parcel$export(module.exports, "closeAllRightSidebar", ()=>$4dabd377b098e1a2$export$d91a6e55d52aa3e9);
    $parcel$export(module.exports, "closeCurrentRightSidebar", ()=>$4dabd377b098e1a2$export$a9a5075d3d1b2165);
    $parcel$export(module.exports, "closeRightSidebar", ()=>$4dabd377b098e1a2$export$d7149233c76efb32);
    $parcel$export(module.exports, "minimiseRightSidebar", ()=>$4dabd377b098e1a2$export$4eedf7fa26a2749a);
    $parcel$export(module.exports, "openRightSidebar", ()=>$4dabd377b098e1a2$export$c8dafe074328c4ca);
    var $ajpes = parcelRequire("ajpes");
    const $4dabd377b098e1a2$var$arrayMove = (array, oldIndex, newIndex)=>{
        const arrayCopy = [
            ...array
        ];
        const f = arrayCopy.splice(oldIndex, 1)[0];
        arrayCopy.splice(newIndex, 0, f);
        return arrayCopy;
    };
    const $4dabd377b098e1a2$var$dedupe = (stackState = [])=>{
        const visited = {};
        return stackState.filter((item)=>{
            if (visited[item.panelId]) return false;
            visited[item.panelId] = true;
            return true;
        });
    };
    const $4dabd377b098e1a2$export$57758d0cfaeec2c = (state)=>{
        if (state.stackState.length === 1) return state.stackState[0];
        return state.stackState.find((sidebar)=>!sidebar.isCollapsed && !sidebar.isMinimised) || null;
    };
    const $4dabd377b098e1a2$export$f5584170a8c1db02 = (newState)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: $4dabd377b098e1a2$var$dedupe(newState.stackState)
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$d91a6e55d52aa3e9 = ()=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: []
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$a9a5075d3d1b2165 = ()=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const currentStack = content.rightSidebar.stackState || [];
            if (!currentStack.length) return;
            const currentRightSidebar = $4dabd377b098e1a2$export$57758d0cfaeec2c(content.rightSidebar);
            if (!currentRightSidebar) return;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: content.rightSidebar.stackState.filter((item)=>item !== currentRightSidebar)
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$d7149233c76efb32 = (panelId)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const currentStack = content.rightSidebar.stackState || [];
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: currentStack.filter((item)=>item.panelId !== panelId)
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$4eedf7fa26a2749a = (panelId)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const currentStack = content.rightSidebar.stackState || [];
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: currentStack.map((item)=>{
                            if (item.panelId !== panelId) return item;
                            return {
                                ...item,
                                isMinimised: true
                            };
                        })
                    }
                }
            });
        };
    const $4dabd377b098e1a2$export$c8dafe074328c4ca = (panelId, width, isMinimised = false, toTop = false)=>({ getState: getState, setState: setState })=>{
            const { content: content } = getState();
            const tempRightSidebarStackStateValue = content.rightSidebar.stackState ? [
                ...content.rightSidebar.stackState.map((item)=>{
                    if (item.panelId === panelId) return {
                        ...item,
                        isMinimised: isMinimised,
                        width: width
                    };
                    return item;
                })
            ] : [];
            const matchedPanelIndex = tempRightSidebarStackStateValue.findIndex((obj)=>obj.panelId === panelId);
            if (matchedPanelIndex >= 0) {
                const nextIdx = toTop ? 0 : tempRightSidebarStackStateValue.length - 1;
                tempRightSidebarStackStateValue[matchedPanelIndex].isCollapsed = false;
                tempRightSidebarStackStateValue[matchedPanelIndex].isMinimised = isMinimised;
                const newRightSidebarStackStateValue = $4dabd377b098e1a2$var$arrayMove(tempRightSidebarStackStateValue, matchedPanelIndex, nextIdx);
                newRightSidebarStackStateValue[nextIdx].width = width;
                setState({
                    content: {
                        ...content,
                        rightSidebar: {
                            stackState: newRightSidebarStackStateValue
                        }
                    }
                });
                return;
            }
            const newRightSidebarStackStateValue = toTop ? [
                {
                    panelId: panelId,
                    width: width,
                    isCollapsed: false,
                    isMinimised: isMinimised
                },
                ...tempRightSidebarStackStateValue
            ] : [
                ...tempRightSidebarStackStateValue,
                {
                    panelId: panelId,
                    width: width,
                    isCollapsed: false,
                    isMinimised: isMinimised
                }
            ];
            if ((0, ($parcel$interopDefault($ajpes)))(newRightSidebarStackStateValue, content.rightSidebar.stackState)) return;
            setState({
                content: {
                    ...content,
                    rightSidebar: {
                        stackState: newRightSidebarStackStateValue
                    }
                }
            });
        };
});
parcelRegister("axUP7", function(module, exports) {
    $parcel$export(module.exports, "withNestingOptimisation", ()=>$c861ce2b697701b9$export$ee1cb2a8280d8710);
    var $5uXOq = parcelRequire("5uXOq");
    var $6onh1;
    var $9sGI6;
    const $c861ce2b697701b9$export$ee1cb2a8280d8710 = (Component)=>{
        const WithNestingOptimisation = (0, $5uXOq.forwardRef)((props, ref)=>{
            const children = typeof props === 'object' && props != null ? props.children : null;
            return (0, (0, parcelRequire("6onh1")).useShouldNestedElementRender)().shouldRender && !false ? (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                ref: ref
            }) : children;
        });
        WithNestingOptimisation.displayName = `withNestingOptimisation(${(0, (0, parcelRequire("9sGI6")).getDisplayName)(Component)})`;
        return WithNestingOptimisation;
    };
});
parcelRegister("9sGI6", function(module, exports) {
    $parcel$export(module.exports, "getDisplayName", ()=>$0d4ebae82d1d47ab$export$be63e0664592e141);
    $parcel$export(module.exports, "default", ()=>$0d4ebae82d1d47ab$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $0d4ebae82d1d47ab$export$be63e0664592e141 = (WrappedComponent)=>{
        if (WrappedComponent.displayName != null && WrappedComponent.displayName !== '') return WrappedComponent.displayName;
        if (WrappedComponent.name != null && WrappedComponent.name !== '') return WrappedComponent.name;
        return 'Component';
    };
    const $0d4ebae82d1d47ab$var$withInjectedProps = (WrappedComponent, injectedProps)=>{
        const WithInjectedProps = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...injectedProps,
                ...props
            });
        WithInjectedProps.displayName = `withInjectedProps(${$0d4ebae82d1d47ab$export$be63e0664592e141(WrappedComponent)})`;
        return WithInjectedProps;
    };
    var $0d4ebae82d1d47ab$export$2e2bcd8739ae039 = $0d4ebae82d1d47ab$var$withInjectedProps;
});
parcelRegister("ajOhG", function(module, exports) {
    $parcel$export(module.exports, "FeedbackNudgeAsync", ()=>$9b3ebbbcc2dff472$export$be3f2958452e7be9);
    var $5uXOq = parcelRequire("5uXOq");
    var $bBbEG;
    var $lfTZh;
    var $hPtZI;
    const $9b3ebbbcc2dff472$var$FeedbackNudgeLazy = (0, (0, parcelRequire("hPtZI")).lazyAfterPaint)(()=>(parcelRequire("7u4Dj")).then((exportedModule)=>exportedModule.FeedbackNudge), {
        ssr: false,
        moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-feedback/index.tsx"
    });
    const $9b3ebbbcc2dff472$export$be3f2958452e7be9 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bBbEG")).OnboardingNudgeErrorBoundary), {
            id: (0, $dbbf68c32d8c4308$export$e9e47a7ad42e71f5),
            fallback: children,
            attributes: {
                nudgeId: (0, $dbbf68c32d8c4308$export$e9e47a7ad42e71f5)
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "feedback-onboarding-nudge",
            fallback: children
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9b3ebbbcc2dff472$var$FeedbackNudgeLazy, null, children)));
    $9b3ebbbcc2dff472$export$be3f2958452e7be9.displayName = 'FeedbackNudgeAsync';
});
parcelRegister("bBbEG", function(module, exports) {
    $parcel$export(module.exports, "OnboardingNudgeErrorBoundary", ()=>$383be1d115a6551b$export$3915a8814b99f0b);
    var $5uXOq = parcelRequire("5uXOq");
    var $lkem5;
    var $8Bc5A;
    const $383be1d115a6551b$export$3915a8814b99f0b = (props)=>{
        const { id: id, attributes: attributes, fallback: fallback, children: children } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lkem5")).ErrorBoundaryWithChunkErrorLogging), {
            id: id,
            packageName: (0, (0, parcelRequire("8Bc5A")).PACKAGE_NAME),
            render: ()=>fallback,
            attributes: attributes
        }, children);
    };
});
parcelRegister("lkem5", function(module, exports) {
    $parcel$export(module.exports, "ErrorBoundaryWithChunkErrorLogging", ()=>$3df8b034ebbd68e5$export$9171acf2e93b7d4d);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $30rnQ;
    const $3df8b034ebbd68e5$export$9171acf2e93b7d4d = (props)=>{
        const { attributes: attributes, children: children, ...rest } = props;
        const addErrorBoundaryAnalyticsAttributes = (0, (0, parcelRequire("30rnQ")).useAddErrorBoundaryAnalyticsAttributes)(attributes);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            ...rest,
            attributes: addErrorBoundaryAnalyticsAttributes
        }, children);
    };
});
parcelRegister("30rnQ", function(module, exports) {
    $parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", ()=>$53c68ff9a9edd0fe$export$94ee0b5fca1e74d2);
    $parcel$export(module.exports, "useAddErrorBoundaryAnalyticsAttributes", ()=>$53c68ff9a9edd0fe$export$807be5f3f1ea996);
    var $5uXOq = parcelRequire("5uXOq");
    var $7NJFp;
    const $53c68ff9a9edd0fe$export$94ee0b5fca1e74d2 = (error)=>({
            chunkLoadError: (0, (0, parcelRequire("7NJFp")).isLoaderError)(error)
        });
    const $53c68ff9a9edd0fe$export$807be5f3f1ea996 = (attributes = {})=>(0, $5uXOq.useCallback)((error)=>({
                ...attributes,
                ...$53c68ff9a9edd0fe$export$94ee0b5fca1e74d2(error)
            }), [
            attributes
        ]);
});
const $dbbf68c32d8c4308$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $dbbf68c32d8c4308$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $dbbf68c32d8c4308$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $dbbf68c32d8c4308$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $dbbf68c32d8c4308$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $dbbf68c32d8c4308$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $dbbf68c32d8c4308$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $dbbf68c32d8c4308$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $dbbf68c32d8c4308$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $dbbf68c32d8c4308$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $dbbf68c32d8c4308$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $dbbf68c32d8c4308$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $dbbf68c32d8c4308$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $dbbf68c32d8c4308$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $dbbf68c32d8c4308$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $dbbf68c32d8c4308$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $dbbf68c32d8c4308$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $dbbf68c32d8c4308$export$f8bf435a6066832c = 'button clicked';
const $dbbf68c32d8c4308$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $dbbf68c32d8c4308$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $dbbf68c32d8c4308$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $dbbf68c32d8c4308$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $dbbf68c32d8c4308$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $dbbf68c32d8c4308$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $dbbf68c32d8c4308$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $dbbf68c32d8c4308$export$5908fa8acd2c0739 = 'filterListNudge';
const $dbbf68c32d8c4308$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $dbbf68c32d8c4308$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $dbbf68c32d8c4308$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $dbbf68c32d8c4308$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $dbbf68c32d8c4308$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $dbbf68c32d8c4308$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $dbbf68c32d8c4308$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $dbbf68c32d8c4308$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $dbbf68c32d8c4308$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $dbbf68c32d8c4308$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $dbbf68c32d8c4308$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $dbbf68c32d8c4308$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $dbbf68c32d8c4308$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $dbbf68c32d8c4308$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $dbbf68c32d8c4308$export$a1be34032ee24f78 = 'shareProjectNudge';
const $dbbf68c32d8c4308$export$29fe6611cc093756 = 'summaryTabNudge';
const $dbbf68c32d8c4308$export$f107c06c0830f09d = 'reportsTabNudge';
const $dbbf68c32d8c4308$export$9749a972a54ad7ba = 'boardContainerNudge';
parcelRegister("7u4Dj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("eSNL6").then(()=>parcelRequire('5YJ1A'));
});
parcelRegister("Fmgai", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c642b7880215349a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c642b7880215349a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        feedback: {
            "id": "spa-apps-sidebar-core.multi-project-menu.feedback-button.feedback",
            "defaultMessage": "Give feedback"
        }
    });
});
parcelRegister("NCdt4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b005747d8914d3b0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b005747d8914d3b0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        companyManagedProject: {
            "id": "spa-apps-sidebar-core.multi-project-menu.company-managed-project",
            "defaultMessage": "You're in a company-managed project"
        },
        navigationLabel: {
            "id": "spa-apps-sidebar-core.multi-project-menu.navigation-label",
            "defaultMessage": "Side"
        },
        teamManagedProject: {
            "id": "spa-apps-sidebar-core.multi-project-menu.team-managed-project",
            "defaultMessage": "You're in a team-managed project"
        },
        viewAllStarred: {
            "id": "spa-apps-sidebar-core.multi-project-menu.view-all-starred",
            "defaultMessage": "View all starred projects"
        }
    });
});
parcelRegister("dCGEg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$230ddc65e16732f3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $89thI;
    var $lkDqR;
    var $i5shE;
    var $7yUJn;
    var $N0aCi;
    var $koVbs;
    var $8zOmE;
    var $95EVP;
    var $iNzEe;
    var $dIdda = parcelRequire("dIdda");
    var $gb5lQ;
    var $iuAuR;
    var $6hYaZ;
    var $2kAEg;
    var $imgTm;
    const $230ddc65e16732f3$var$Overviews = ({ overviews: overviews, hasError: hasError })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        const refresh = (0, $5uXOq.useCallback)(()=>typeof window !== 'undefined' && window.location.reload(), []);
        const [{ match: match, route: route }] = (0, $dIdda.useRouter)();
        const routeOverviewId = match.params?.overviewId;
        const [isCreateModalOpen, setIsCreateModalOpen] = (0, $5uXOq.useState)(false);
        const openCreateModal = (0, $5uXOq.useCallback)(()=>{
            setIsCreateModalOpen(true);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createOverview');
        }, [
            createAnalyticsEvent
        ]);
        const closeCreateModal = (0, $5uXOq.useCallback)(()=>setIsCreateModalOpen(false), []);
        const showOverviewChangeboarding = (0, (0, parcelRequire("iNzEe")).useTriggerOverviewChangeboarding)();
        if (showOverviewChangeboarding) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iuAuR")).default), {
            title: formatMessage((0, (0, parcelRequire("2kAEg")).default).overviewsHeader)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("N0aCi")).AsyncMigrationMessage), null));
        let content;
        if (hasError) content = (0, ($parcel$interopDefault($5uXOq))).createElement($230ddc65e16732f3$var$ErrorWrapper, {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews.overviews-error"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($230ddc65e16732f3$var$ErrorMessage, null, formatMessage((0, (0, parcelRequire("2kAEg")).default).errorMessage)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("89thI")).default), {
            appearance: "link",
            onClick: refresh
        }, formatMessage((0, (0, parcelRequire("2kAEg")).default).refreshPage)));
        else if (overviews.length === 0) content = (0, ($parcel$interopDefault($5uXOq))).createElement($230ddc65e16732f3$var$EmptyState, {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews.empty-state"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("89thI")).default), {
            appearance: "subtle-link",
            onClick: openCreateModal
        }, formatMessage((0, (0, parcelRequire("2kAEg")).default).createOverview)));
        else content = (0, ($parcel$interopDefault($5uXOq))).createElement($230ddc65e16732f3$var$List, {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.overviews.overviews-list"
        }, overviews.map((overview)=>(0, ($parcel$interopDefault($5uXOq))).createElement("li", {
                key: overview.id
            }, routeOverviewId === overview.id ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imgTm")).default), {
                overview: overview,
                to: (0, (0, parcelRequire("i5shE")).getOverviewUrl)(overview),
                isActive: true
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("imgTm")).default), {
                overview: overview,
                to: (0, (0, parcelRequire("i5shE")).getOverviewUrl)(overview, route)
            }))));
        const hasReachedLimit = overviews?.length >= (0, (0, parcelRequire("gb5lQ")).OVERVIEW_MAX_LIMIT);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iuAuR")).default), {
            title: formatMessage((0, (0, parcelRequire("2kAEg")).default).overviewsHeader)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6hYaZ")).default), {
            onClick: openCreateModal,
            hasReachedLimit: hasReachedLimit
        })), content, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lkDqR")).default), null, isCreateModalOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7yUJn")).default), {
            onClose: closeCreateModal
        })));
    };
    var $230ddc65e16732f3$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($230ddc65e16732f3$var$Overviews);
    const $230ddc65e16732f3$var$EmptyState = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o",
                __cmplp.className
            ])
        });
    });
    const $230ddc65e16732f3$var$List = (0, $5uXOq.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw",
                __cmplp.className
            ])
        });
    });
    const $230ddc65e16732f3$var$ErrorWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $230ddc65e16732f3$var$ErrorMessage = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s85axq _y3gn1h6o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("i5shE", function(module, exports) {
    $parcel$export(module.exports, "getOverviewUrl", ()=>$b5027b2ddff99a4d$export$e314405e3f098e61);
    var $65Ltd;
    const $b5027b2ddff99a4d$export$e314405e3f098e61 = (overview, currentRoute)=>{
        switch(currentRoute?.name){
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_SUMMARY:
                return `/jira/core/overviews/${overview.id}/summary`;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR:
                return `/jira/core/overviews/${overview.id}/calendar`;
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE:
            case 0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE:
                return `/jira/core/overviews/${overview.id}/timeline`;
            default:
                return `/jira/core/overviews/${overview.id}`;
        }
    };
});
parcelRegister("7yUJn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2eb121a7f5478dbf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cm8b5;
    var $lfTZh;
    var $hPtZI;
    var $bTIks;
    const $2eb121a7f5478dbf$var$LazyCreateOverviewModal = (0, (0, parcelRequire("hPtZI")).lazy)(()=>(parcelRequire("fmp5H")), {
        ssr: false,
        moduleId: "./src/packages/business/entity/overview/src/ui/create-overview-modal/main.tsx"
    });
    var $2eb121a7f5478dbf$export$2e2bcd8739ae039 = ({ onClose: onClose })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceErrorBoundary), {
            experience: (0, (0, parcelRequire("bTIks")).CREATE_OVERVIEW_EXPERIENCE),
            fallback: "unmount",
            shouldStartExperience: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "overview-modal",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2eb121a7f5478dbf$var$LazyCreateOverviewModal, {
            onClose: onClose
        })));
});
parcelRegister("cm8b5", function(module, exports) {
    $parcel$export(module.exports, "useExperienceStart", ()=>$aca94fc714dddc77$export$675e0d25df38d426);
    $parcel$export(module.exports, "useExperienceAbort", ()=>$aca94fc714dddc77$export$cc92b7ce453f4403);
    $parcel$export(module.exports, "useExperienceSuccess", ()=>$aca94fc714dddc77$export$e94f0da4fc0603c6);
    $parcel$export(module.exports, "useExperienceFail", ()=>$aca94fc714dddc77$export$606da7704d8eaf06);
    $parcel$export(module.exports, "useQueryBasedViewAutomaticTracking", ()=>$aca94fc714dddc77$export$8ca25d6ff1437be3);
    $parcel$export(module.exports, "ExperienceStart", ()=>$aca94fc714dddc77$export$f20b867e738a222c);
    $parcel$export(module.exports, "ExperienceFailed", ()=>$aca94fc714dddc77$export$ae65a9e09c4516b3);
    $parcel$export(module.exports, "ExperienceErrorBoundary", ()=>$aca94fc714dddc77$export$139c4a4ad101c3c5);
    $parcel$export(module.exports, "ExperienceSuccess", ()=>$aca94fc714dddc77$export$4962f3898bd5c829);
    $parcel$export(module.exports, "ExperienceAbort", ()=>$aca94fc714dddc77$export$c9b6bcd70239a39c);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Wswo;
    var $8UpTw;
    var $39xOx;
    var $jcw0u;
    var $8dXDG;
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $4R6GH;
    var $jJZqs;
    const $aca94fc714dddc77$export$675e0d25df38d426 = ({ experience: experience, experienceId: experienceId, packageName: packageName })=>(0, (0, parcelRequire("kaHBi")).useExperienceStart)({
            experience: experience,
            experienceId: experienceId,
            analyticsSource: packageName
        });
    const $aca94fc714dddc77$export$cc92b7ce453f4403 = ({ experience: experience }, attributes)=>(0, (0, parcelRequire("8dXDG")).useExperienceAbort)({
            experience: experience,
            attributes: attributes
        });
    const $aca94fc714dddc77$export$e94f0da4fc0603c6 = ({ experience: experience })=>(0, (0, parcelRequire("3bQtK")).useExperienceSuccess)({
            experience: experience
        });
    const $aca94fc714dddc77$export$606da7704d8eaf06 = ({ experience: experience, experienceId: experienceId, packageName: packageName, teamName: teamName })=>{
        const onExperienceFail = (0, (0, parcelRequire("93jKl")).useExperienceFail)({
            experience: experience
        });
        const onFail = (0, $5uXOq.useCallback)((location, error, extraAttributes)=>{
            const relevantError = error?.networkError ?? error;
            if ((0, (0, parcelRequire("4R6GH")).fg)('fun-1253_fix_error_message_failed_experience') && relevantError instanceof (0, (0, parcelRequire("jJZqs")).ValidationError) && relevantError.message === '' && relevantError.errors.length) relevantError.message = relevantError.errors[0].error;
            extraAttributes !== undefined ? onExperienceFail(location, relevantError, extraAttributes) : onExperienceFail(location, relevantError);
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: `experience-tracker-${experienceId ?? experience}`,
                    packageName: packageName,
                    teamName: teamName
                },
                attributes: {
                    location: location
                },
                error: relevantError,
                sendToPrivacyUnsafeSplunk: true
            });
        }, [
            onExperienceFail,
            experienceId,
            experience,
            packageName,
            teamName
        ]);
        return onFail;
    };
    const $aca94fc714dddc77$export$8ca25d6ff1437be3 = (experience, { loading: loading, error: error, shouldStartExperience: shouldStartExperience })=>{
        const [hasStarted, setHasStarted] = (0, $5uXOq.useState)(loading);
        const [hasCompleted, setHasCompleted] = (0, $5uXOq.useState)(false);
        const [hasExperienceBeenTracked, setHasExperienceBeenTracked] = (0, $5uXOq.useState)(false);
        const startExperience = $aca94fc714dddc77$export$675e0d25df38d426(experience);
        const onFail = $aca94fc714dddc77$export$606da7704d8eaf06(experience);
        const onSuccess = $aca94fc714dddc77$export$e94f0da4fc0603c6(experience);
        (0, $5uXOq.useEffect)(()=>{
            if (shouldStartExperience === true) startExperience();
        }, [
            shouldStartExperience
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (hasStarted === false && loading === true) setHasStarted(true);
            if (hasStarted === true && loading === false) {
                setHasCompleted(true);
                setHasExperienceBeenTracked(false);
            }
        }, [
            hasStarted,
            loading
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (hasCompleted && !hasExperienceBeenTracked) {
                setHasExperienceBeenTracked(true);
                if (typeof error !== 'undefined') {
                    onFail(`${experience.experience} ${experience.experienceId || ''} useEffect error handling`, error, (0, (0, parcelRequire("8Wswo")).getGraphqlErrorAttributes)(error));
                    return;
                }
                onSuccess({
                    loaded: true
                });
            }
        }, [
            error,
            experience,
            hasCompleted,
            hasExperienceBeenTracked,
            onFail,
            onSuccess
        ]);
    };
    const $aca94fc714dddc77$export$f20b867e738a222c = (0, $5uXOq.memo)(({ experience: experience })=>{
        const start = $aca94fc714dddc77$export$675e0d25df38d426(experience);
        (0, $5uXOq.useEffect)(()=>{
            start();
        }, [
            start
        ]);
        return null;
    });
    const $aca94fc714dddc77$export$ae65a9e09c4516b3 = (0, $5uXOq.memo)(({ experience: experience, error: error, attributes: attributes })=>{
        const onFail = $aca94fc714dddc77$export$606da7704d8eaf06(experience);
        (0, $5uXOq.useEffect)(()=>{
            onFail(experience.experience, error, attributes);
        }, [
            attributes,
            error,
            experience,
            onFail
        ]);
        return null;
    });
    const $aca94fc714dddc77$export$139c4a4ad101c3c5 = ({ experience: experience, shouldStartExperience: shouldStartExperience, fallback: fallback = (0, (0, parcelRequire("8UpTw")).ErrorPage), children: children })=>{
        const onFail = $aca94fc714dddc77$export$606da7704d8eaf06(experience);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            packageName: experience.packageName,
            teamName: experience.teamName,
            id: experience.experience,
            onError: onFail,
            fallback: fallback
        }, shouldStartExperience === true && (0, ($parcel$interopDefault($5uXOq))).createElement($aca94fc714dddc77$export$f20b867e738a222c, {
            experience: experience
        }), children);
    };
    const $aca94fc714dddc77$export$4962f3898bd5c829 = (0, $5uXOq.memo)(({ experience: experience, attributes: attributes })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bQtK")).ExperienceSuccess), {
            experience: experience.experience,
            attributes: {
                ...experience.experienceId == null ? undefined : {
                    experienceId: experience.experienceId
                },
                ...attributes
            }
        }));
    const $aca94fc714dddc77$export$c9b6bcd70239a39c = (0, $5uXOq.memo)(({ experience: experience, error: error })=>{
        const onAbort = $aca94fc714dddc77$export$cc92b7ce453f4403(experience);
        (0, $5uXOq.useEffect)(()=>{
            onAbort(experience.experience, {
                error: error.message
            });
        }, [
            error,
            experience,
            onAbort
        ]);
        return null;
    });
});
parcelRegister("8Wswo", function(module, exports) {
    $parcel$export(module.exports, "shouldHandleTheError", ()=>$6f94bc39289ec711$export$47770c8b6d645cdb);
    $parcel$export(module.exports, "getGraphqlErrorAttributes", ()=>$6f94bc39289ec711$export$b19e649eafc62480);
    var $e3a3O;
    const $6f94bc39289ec711$var$errorWhitelist = [
        'EXPERIENCE_UNAVAILABLE',
        'FIELD_UNAVAILABLE'
    ];
    const $6f94bc39289ec711$export$47770c8b6d645cdb = (error)=>{
        if (error?.networkError) return true;
        const filterIssueLinksDisabledErrors = (graphQLError)=>{
            const isWhitelisted = $6f94bc39289ec711$var$errorWhitelist.includes(graphQLError?.extensions?.errorType);
            return !isWhitelisted;
        };
        const errorsToShow = (error?.graphQLErrors || []).filter(filterIssueLinksDisabledErrors);
        return errorsToShow.length > 0;
    };
    const $6f94bc39289ec711$export$b19e649eafc62480 = (error)=>{
        const isApolloError = error instanceof (0, (0, parcelRequire("e3a3O")).ApolloError);
        if (!isApolloError) return {};
        const getErrorAttribute = (graphQLErrors, errorAttribute)=>{
            const errors = graphQLErrors.map((graphQLError)=>graphQLError?.extensions?.[errorAttribute]).filter(Boolean);
            return JSON.stringify(errors);
        };
        return {
            statusCodes: getErrorAttribute(error?.graphQLErrors || [], 'statusCode'),
            errorTypes: getErrorAttribute(error?.graphQLErrors || [], 'errorType')
        };
    };
});
parcelRegister("e3a3O", function(module, exports) {
    $parcel$export(module.exports, "NetworkStatus", ()=>$02a3c2aebc919401$export$bd096ddbd246c79c);
    $parcel$export(module.exports, "ApolloError", ()=>$02a3c2aebc919401$export$26a337512320b8c6);
    $parcel$export(module.exports, "ApolloClient", ()=>$02a3c2aebc919401$export$13f5a5f0f1dbab88);
    $parcel$export(module.exports, "default", ()=>$02a3c2aebc919401$export$2e2bcd8739ae039);
    var $3VFsf;
    var $jojW6;
    var $bqMzA = parcelRequire("bqMzA");
    var $clSzL;
    var $aS6b9;
    var $ebaCz = parcelRequire("ebaCz");
    var $1DiV8 = parcelRequire("1DiV8");
    var $12QNw;
    var $02a3c2aebc919401$export$bd096ddbd246c79c;
    (function(NetworkStatus) {
        NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
        NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
        NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
        NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
        NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
        NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
        NetworkStatus[NetworkStatus["error"] = 8] = "error";
    })($02a3c2aebc919401$export$bd096ddbd246c79c || ($02a3c2aebc919401$export$bd096ddbd246c79c = {}));
    function $02a3c2aebc919401$var$isNetworkRequestInFlight(networkStatus) {
        return networkStatus < 7;
    }
    var $02a3c2aebc919401$var$Observable = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(Observable, _super);
        function Observable() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Observable.prototype[0, $ebaCz.default] = function() {
            return this;
        };
        Observable.prototype['@@observable'] = function() {
            return this;
        };
        return Observable;
    }((0, (0, parcelRequire("aS6b9")).default));
    function $02a3c2aebc919401$var$isNonEmptyArray(value) {
        return Array.isArray(value) && value.length > 0;
    }
    function $02a3c2aebc919401$export$17f5e6bd290bb15d(err) {
        return err.hasOwnProperty('graphQLErrors');
    }
    var $02a3c2aebc919401$var$generateErrorMessage = function(err) {
        var message = '';
        if ($02a3c2aebc919401$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
            var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
            message += "GraphQL error: " + errorMessage + "\n";
        });
        if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
        message = message.replace(/\n$/, '');
        return message;
    };
    var $02a3c2aebc919401$export$26a337512320b8c6 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ApolloError, _super);
        function ApolloError(_a) {
            var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
            var _this = _super.call(this, errorMessage) || this;
            _this.graphQLErrors = graphQLErrors || [];
            _this.networkError = networkError || null;
            if (!errorMessage) _this.message = $02a3c2aebc919401$var$generateErrorMessage(_this);
            else _this.message = errorMessage;
            _this.extraInfo = extraInfo;
            _this.__proto__ = ApolloError.prototype;
            return _this;
        }
        return ApolloError;
    }(Error);
    var $02a3c2aebc919401$export$160bafb6ac1e0641;
    (function(FetchType) {
        FetchType[FetchType["normal"] = 1] = "normal";
        FetchType[FetchType["refetch"] = 2] = "refetch";
        FetchType[FetchType["poll"] = 3] = "poll";
    })($02a3c2aebc919401$export$160bafb6ac1e0641 || ($02a3c2aebc919401$export$160bafb6ac1e0641 = {}));
    var $02a3c2aebc919401$var$hasError = function(storeValue, policy) {
        if (policy === void 0) policy = 'none';
        return storeValue && (storeValue.networkError || policy === 'none' && $02a3c2aebc919401$var$isNonEmptyArray(storeValue.graphQLErrors));
    };
    var $02a3c2aebc919401$export$6c1b56eac59c9584 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ObservableQuery, _super);
        function ObservableQuery(_a) {
            var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
            var _this = _super.call(this, function(observer) {
                return _this.onSubscribe(observer);
            }) || this;
            _this.observers = new Set();
            _this.subscriptions = new Set();
            _this.isTornDown = false;
            _this.options = options;
            _this.variables = options.variables || {};
            _this.queryId = queryManager.generateQueryId();
            _this.shouldSubscribe = shouldSubscribe;
            var opDef = (0, (0, parcelRequire("jojW6")).getOperationDefinition)(options.query);
            _this.queryName = opDef && opDef.name && opDef.name.value;
            _this.queryManager = queryManager;
            return _this;
        }
        ObservableQuery.prototype.result = function() {
            var _this = this;
            return new Promise(function(resolve, reject) {
                var observer = {
                    next: function(result) {
                        resolve(result);
                        _this.observers.delete(observer);
                        if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                        setTimeout(function() {
                            subscription.unsubscribe();
                        }, 0);
                    },
                    error: reject
                };
                var subscription = _this.subscribe(observer);
            });
        };
        ObservableQuery.prototype.currentResult = function() {
            var result = this.getCurrentResult();
            if (result.data === undefined) result.data = {};
            return result;
        };
        ObservableQuery.prototype.getCurrentResult = function() {
            if (this.isTornDown) {
                var lastResult = this.lastResult;
                return {
                    data: !this.lastError && lastResult && lastResult.data || void 0,
                    error: this.lastError,
                    loading: false,
                    networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.error
                };
            }
            var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
            var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
            var result;
            var fetchPolicy = this.options.fetchPolicy;
            var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
            if (queryStoreValue) {
                var networkStatus = queryStoreValue.networkStatus;
                if ($02a3c2aebc919401$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                    data: void 0,
                    loading: false,
                    networkStatus: networkStatus,
                    error: new $02a3c2aebc919401$export$26a337512320b8c6({
                        graphQLErrors: queryStoreValue.graphQLErrors,
                        networkError: queryStoreValue.networkError
                    })
                };
                if (queryStoreValue.variables) {
                    this.options.variables = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.options.variables), queryStoreValue.variables);
                    this.variables = this.options.variables;
                }
                result = {
                    data: data,
                    loading: $02a3c2aebc919401$var$isNetworkRequestInFlight(networkStatus),
                    networkStatus: networkStatus
                };
                if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
            } else {
                var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
                result = {
                    data: data,
                    loading: loading,
                    networkStatus: loading ? $02a3c2aebc919401$export$bd096ddbd246c79c.loading : $02a3c2aebc919401$export$bd096ddbd246c79c.ready
                };
            }
            if (!partial) this.updateLastResult((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, result), {
                stale: false
            }));
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, result), {
                partial: partial
            });
        };
        ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
            var snapshot = this.lastResultSnapshot;
            return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $bqMzA.equal)(snapshot.data, newResult.data));
        };
        ObservableQuery.prototype.getLastResult = function() {
            return this.lastResult;
        };
        ObservableQuery.prototype.getLastError = function() {
            return this.lastError;
        };
        ObservableQuery.prototype.resetLastResults = function() {
            delete this.lastResult;
            delete this.lastResultSnapshot;
            delete this.lastError;
            this.isTornDown = false;
        };
        ObservableQuery.prototype.resetQueryStoreErrors = function() {
            var queryStore = this.queryManager.queryStore.get(this.queryId);
            if (queryStore) {
                queryStore.networkError = null;
                queryStore.graphQLErrors = [];
            }
        };
        ObservableQuery.prototype.refetch = function(variables) {
            var fetchPolicy = this.options.fetchPolicy;
            if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $1DiV8.InvariantError)(1));
            if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
            if (!(0, $bqMzA.equal)(this.variables, variables)) this.variables = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.variables), variables);
            if (!(0, $bqMzA.equal)(this.options.variables, this.variables)) this.options.variables = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.options.variables), this.variables);
            return this.queryManager.fetchQuery(this.queryId, (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.options), {
                fetchPolicy: fetchPolicy
            }), $02a3c2aebc919401$export$160bafb6ac1e0641.refetch);
        };
        ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
            var _this = this;
            (0, $1DiV8.invariant)(fetchMoreOptions.updateQuery, 2);
            var combinedOptions = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.options), fetchMoreOptions), {
                variables: (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.variables), fetchMoreOptions.variables)
            })), {
                fetchPolicy: 'network-only'
            });
            var qid = this.queryManager.generateQueryId();
            return this.queryManager.fetchQuery(qid, combinedOptions, $02a3c2aebc919401$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
                _this.updateQuery(function(previousResult) {
                    return fetchMoreOptions.updateQuery(previousResult, {
                        fetchMoreResult: fetchMoreResult.data,
                        variables: combinedOptions.variables
                    });
                });
                _this.queryManager.stopQuery(qid);
                return fetchMoreResult;
            }, function(error) {
                _this.queryManager.stopQuery(qid);
                throw error;
            });
        };
        ObservableQuery.prototype.subscribeToMore = function(options) {
            var _this = this;
            var subscription = this.queryManager.startGraphQLSubscription({
                query: options.document,
                variables: options.variables
            }).subscribe({
                next: function(subscriptionData) {
                    var updateQuery = options.updateQuery;
                    if (updateQuery) _this.updateQuery(function(previous, _a) {
                        var variables = _a.variables;
                        return updateQuery(previous, {
                            subscriptionData: subscriptionData,
                            variables: variables
                        });
                    });
                },
                error: function(err) {
                    if (options.onError) {
                        options.onError(err);
                        return;
                    }
                }
            });
            this.subscriptions.add(subscription);
            return function() {
                if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
            };
        };
        ObservableQuery.prototype.setOptions = function(opts) {
            var oldFetchPolicy = this.options.fetchPolicy;
            this.options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.options), opts);
            if (opts.pollInterval) this.startPolling(opts.pollInterval);
            else if (opts.pollInterval === 0) this.stopPolling();
            var fetchPolicy = opts.fetchPolicy;
            return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
        };
        ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
            if (tryFetch === void 0) tryFetch = false;
            if (fetchResults === void 0) fetchResults = true;
            this.isTornDown = false;
            variables = variables || this.variables;
            if (!tryFetch && (0, $bqMzA.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
            this.variables = this.options.variables = variables;
            if (!this.observers.size) return Promise.resolve();
            return this.queryManager.fetchQuery(this.queryId, this.options);
        };
        ObservableQuery.prototype.updateQuery = function(mapFn) {
            var queryManager = this.queryManager;
            var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
            var newResult = (0, (0, parcelRequire("jojW6")).tryFunctionOrLogError)(function() {
                return mapFn(previousResult, {
                    variables: variables
                });
            });
            if (newResult) {
                queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
                queryManager.broadcastQueries();
            }
        };
        ObservableQuery.prototype.stopPolling = function() {
            this.queryManager.stopPollingQuery(this.queryId);
            this.options.pollInterval = undefined;
        };
        ObservableQuery.prototype.startPolling = function(pollInterval) {
            $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(this);
            this.options.pollInterval = pollInterval;
            this.queryManager.startPollingQuery(this.options, this.queryId);
        };
        ObservableQuery.prototype.updateLastResult = function(newResult) {
            var previousResult = this.lastResult;
            this.lastResult = newResult;
            this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, (0, parcelRequire("jojW6")).cloneDeep)(newResult);
            return previousResult;
        };
        ObservableQuery.prototype.onSubscribe = function(observer) {
            var _this = this;
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) subObserver.error = $02a3c2aebc919401$var$defaultSubscriptionObserverErrorCallback;
            } catch (_a) {}
            var first = !this.observers.size;
            this.observers.add(observer);
            if (observer.next && this.lastResult) observer.next(this.lastResult);
            if (observer.error && this.lastError) observer.error(this.lastError);
            if (first) this.setUpQuery();
            return function() {
                if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
            };
        };
        ObservableQuery.prototype.setUpQuery = function() {
            var _this = this;
            var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
            if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
            if (this.options.pollInterval) {
                $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(this);
                queryManager.startPollingQuery(this.options, queryId);
            }
            var onError = function(error) {
                _this.updateLastResult((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, _this.lastResult), {
                    errors: error.graphQLErrors,
                    networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.error,
                    loading: false
                }));
                $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
            };
            queryManager.observeQuery(queryId, this.options, {
                next: function(result) {
                    if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                        var previousResult_1 = _this.updateLastResult(result);
                        var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                        if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                            var previousVariables = _this.variables;
                            _this.variables = _this.options.variables = variables;
                            if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $bqMzA.equal)(previousVariables, variables)) _this.refetch();
                            else $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'next', result);
                        });
                        else $02a3c2aebc919401$var$iterateObserversSafely(_this.observers, 'next', result);
                    }
                },
                error: onError
            }).catch(onError);
        };
        ObservableQuery.prototype.tearDownQuery = function() {
            var queryManager = this.queryManager;
            this.isTornDown = true;
            queryManager.stopPollingQuery(this.queryId);
            this.subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            this.subscriptions.clear();
            queryManager.removeObservableQuery(this.queryId);
            queryManager.stopQuery(this.queryId);
            this.observers.clear();
        };
        return ObservableQuery;
    }($02a3c2aebc919401$var$Observable);
    function $02a3c2aebc919401$var$defaultSubscriptionObserverErrorCallback(error) {}
    function $02a3c2aebc919401$var$iterateObserversSafely(observers, method, argument) {
        var observersWithMethod = [];
        observers.forEach(function(obs) {
            return obs[method] && observersWithMethod.push(obs);
        });
        observersWithMethod.forEach(function(obs) {
            return obs[method](argument);
        });
    }
    function $02a3c2aebc919401$var$assertNotCacheFirstOrOnly(obsQuery) {
        var fetchPolicy = obsQuery.options.fetchPolicy;
        (0, $1DiV8.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
    }
    var $02a3c2aebc919401$var$MutationStore = function() {
        function MutationStore() {
            this.store = {};
        }
        MutationStore.prototype.getStore = function() {
            return this.store;
        };
        MutationStore.prototype.get = function(mutationId) {
            return this.store[mutationId];
        };
        MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
            this.store[mutationId] = {
                mutation: mutation,
                variables: variables || {},
                loading: true,
                error: null
            };
        };
        MutationStore.prototype.markMutationError = function(mutationId, error) {
            var mutation = this.store[mutationId];
            if (mutation) {
                mutation.loading = false;
                mutation.error = error;
            }
        };
        MutationStore.prototype.markMutationResult = function(mutationId) {
            var mutation = this.store[mutationId];
            if (mutation) {
                mutation.loading = false;
                mutation.error = null;
            }
        };
        MutationStore.prototype.reset = function() {
            this.store = {};
        };
        return MutationStore;
    }();
    var $02a3c2aebc919401$var$QueryStore = function() {
        function QueryStore() {
            this.store = {};
        }
        QueryStore.prototype.getStore = function() {
            return this.store;
        };
        QueryStore.prototype.get = function(queryId) {
            return this.store[queryId];
        };
        QueryStore.prototype.initQuery = function(query) {
            var previousQuery = this.store[query.queryId];
            (0, $1DiV8.invariant)(!previousQuery || previousQuery.document === query.document || (0, $bqMzA.equal)(previousQuery.document, query.document), 19);
            var isSetVariables = false;
            var previousVariables = null;
            if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.loading) {
                if (!(0, $bqMzA.equal)(previousQuery.variables, query.variables)) {
                    isSetVariables = true;
                    previousVariables = previousQuery.variables;
                }
            }
            var networkStatus;
            if (isSetVariables) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.setVariables;
            else if (query.isPoll) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.poll;
            else if (query.isRefetch) networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.refetch;
            else networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.loading;
            var graphQLErrors = [];
            if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
            this.store[query.queryId] = {
                document: query.document,
                variables: query.variables,
                previousVariables: previousVariables,
                networkError: null,
                graphQLErrors: graphQLErrors,
                networkStatus: networkStatus,
                metadata: query.metadata
            };
            if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.fetchMore;
        };
        QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
            if (!this.store || !this.store[queryId]) return;
            this.store[queryId].networkError = null;
            this.store[queryId].graphQLErrors = $02a3c2aebc919401$var$isNonEmptyArray(result.errors) ? result.errors : [];
            this.store[queryId].previousVariables = null;
            this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
            if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
        };
        QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
            if (!this.store || !this.store[queryId]) return;
            this.store[queryId].networkError = error;
            this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.error;
            if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
        };
        QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
            var storeValue = this.store && this.store[queryId];
            if (storeValue) {
                storeValue.networkError = null;
                storeValue.previousVariables = null;
                if (complete) storeValue.networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.ready;
            }
        };
        QueryStore.prototype.stopQuery = function(queryId) {
            delete this.store[queryId];
        };
        QueryStore.prototype.reset = function(observableQueryIds) {
            var _this = this;
            Object.keys(this.store).forEach(function(queryId) {
                if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
                else _this.store[queryId].networkStatus = $02a3c2aebc919401$export$bd096ddbd246c79c.loading;
            });
        };
        return QueryStore;
    }();
    function $02a3c2aebc919401$var$capitalizeFirstLetter(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
    var $02a3c2aebc919401$var$LocalState = function() {
        function LocalState(_a) {
            var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
            this.cache = cache;
            if (client) this.client = client;
            if (resolvers) this.addResolvers(resolvers);
            if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
        }
        LocalState.prototype.addResolvers = function(resolvers) {
            var _this = this;
            this.resolvers = this.resolvers || {};
            if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
                _this.resolvers = (0, (0, parcelRequire("jojW6")).mergeDeep)(_this.resolvers, resolverGroup);
            });
            else this.resolvers = (0, (0, parcelRequire("jojW6")).mergeDeep)(this.resolvers, resolvers);
        };
        LocalState.prototype.setResolvers = function(resolvers) {
            this.resolvers = {};
            this.addResolvers(resolvers);
        };
        LocalState.prototype.getResolvers = function() {
            return this.resolvers || {};
        };
        LocalState.prototype.runResolvers = function(_a) {
            var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_c) {
                    if (document) return [
                        2,
                        this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, remoteResult), {
                                data: localResult.result
                            });
                        })
                    ];
                    return [
                        2,
                        remoteResult
                    ];
                });
            });
        };
        LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
            this.fragmentMatcher = fragmentMatcher;
        };
        LocalState.prototype.getFragmentMatcher = function() {
            return this.fragmentMatcher;
        };
        LocalState.prototype.clientQuery = function(document) {
            if ((0, (0, parcelRequire("jojW6")).hasDirectives)([
                'client'
            ], document)) {
                if (this.resolvers) return document;
            }
            return null;
        };
        LocalState.prototype.serverQuery = function(document) {
            return this.resolvers ? (0, (0, parcelRequire("jojW6")).removeClientSetsFromDocument)(document) : document;
        };
        LocalState.prototype.prepareContext = function(context) {
            if (context === void 0) context = {};
            var cache = this.cache;
            var newContext = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, context), {
                cache: cache,
                getCacheKey: function(obj) {
                    if (cache.config) return cache.config.dataIdFromObject(obj);
                    else (0, $1DiV8.invariant)(false, 6);
                }
            });
            return newContext;
        };
        LocalState.prototype.addExportedVariables = function(document, variables, context) {
            if (variables === void 0) variables = {};
            if (context === void 0) context = {};
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_a) {
                    if (document) return [
                        2,
                        this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, variables), data.exportedVariables);
                        })
                    ];
                    return [
                        2,
                        (0, (0, parcelRequire("3VFsf")).__assign)({}, variables)
                    ];
                });
            });
        };
        LocalState.prototype.shouldForceResolvers = function(document) {
            var forceResolvers = false;
            (0, (0, parcelRequire("12QNw")).visit)(document, {
                Directive: {
                    enter: function(node) {
                        if (node.name.value === 'client' && node.arguments) {
                            forceResolvers = node.arguments.some(function(arg) {
                                return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                            });
                            if (forceResolvers) return 0, (0, parcelRequire("12QNw")).BREAK;
                        }
                    }
                }
            });
            return forceResolvers;
        };
        LocalState.prototype.buildRootValueFromCache = function(document, variables) {
            return this.cache.diff({
                query: (0, (0, parcelRequire("jojW6")).buildQueryFromSelectionSet)(document),
                variables: variables,
                returnPartialData: true,
                optimistic: false
            }).result;
        };
        LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
            if (context === void 0) context = {};
            if (variables === void 0) variables = {};
            if (fragmentMatcher === void 0) fragmentMatcher = function() {
                return true;
            };
            if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_b) {
                    mainDefinition = (0, (0, parcelRequire("jojW6")).getMainDefinition)(document);
                    fragments = (0, (0, parcelRequire("jojW6")).getFragmentDefinitions)(document);
                    fragmentMap = (0, (0, parcelRequire("jojW6")).createFragmentMap)(fragments);
                    definitionOperation = mainDefinition.operation;
                    defaultOperationType = definitionOperation ? $02a3c2aebc919401$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                    _a = this, cache = _a.cache, client = _a.client;
                    execContext = {
                        fragmentMap: fragmentMap,
                        context: (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, context), {
                            cache: cache,
                            client: client
                        }),
                        variables: variables,
                        fragmentMatcher: fragmentMatcher,
                        defaultOperationType: defaultOperationType,
                        exportedVariables: {},
                        onlyRunForcedResolvers: onlyRunForcedResolvers
                    };
                    return [
                        2,
                        this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                            return {
                                result: result,
                                exportedVariables: execContext.exportedVariables
                            };
                        })
                    ];
                });
            });
        };
        LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                var fragmentMap, context, variables, resultsToMerge, execute;
                var _this = this;
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_a) {
                    fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                    resultsToMerge = [
                        rootValue
                    ];
                    execute = function(selection) {
                        return (0, (0, parcelRequire("3VFsf")).__awaiter)(_this, void 0, void 0, function() {
                            var fragment, typeCondition;
                            return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_a) {
                                if (!(0, (0, parcelRequire("jojW6")).shouldInclude)(selection, variables)) return [
                                    2
                                ];
                                if ((0, (0, parcelRequire("jojW6")).isField)(selection)) return [
                                    2,
                                    this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                        var _a;
                                        if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(selection)] = fieldResult, _a));
                                    })
                                ];
                                if ((0, (0, parcelRequire("jojW6")).isInlineFragment)(selection)) fragment = selection;
                                else {
                                    fragment = fragmentMap[selection.name.value];
                                    (0, $1DiV8.invariant)(fragment, 7);
                                }
                                if (fragment && fragment.typeCondition) {
                                    typeCondition = fragment.typeCondition.name.value;
                                    if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                        2,
                                        this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                            resultsToMerge.push(fragmentResult);
                                        })
                                    ];
                                }
                                return [
                                    2
                                ];
                            });
                        });
                    };
                    return [
                        2,
                        Promise.all(selectionSet.selections.map(execute)).then(function() {
                            return (0, (0, parcelRequire("jojW6")).mergeDeepArray)(resultsToMerge);
                        })
                    ];
                });
            });
        };
        LocalState.prototype.resolveField = function(field, rootValue, execContext) {
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
                var _this = this;
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_a) {
                    variables = execContext.variables;
                    fieldName = field.name.value;
                    aliasedFieldName = (0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(field);
                    aliasUsed = fieldName !== aliasedFieldName;
                    defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                    resultPromise = Promise.resolve(defaultResult);
                    if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                        resolverType = rootValue.__typename || execContext.defaultOperationType;
                        resolverMap = this.resolvers && this.resolvers[resolverType];
                        if (resolverMap) {
                            resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                            if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, (0, parcelRequire("jojW6")).argumentsObjectFromField)(field, variables), execContext.context, {
                                field: field,
                                fragmentMap: execContext.fragmentMap
                            }));
                        }
                    }
                    return [
                        2,
                        resultPromise.then(function(result) {
                            if (result === void 0) result = defaultResult;
                            if (field.directives) field.directives.forEach(function(directive) {
                                if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                    if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                                });
                            });
                            if (!field.selectionSet) return result;
                            if (result == null) return result;
                            if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                        })
                    ];
                });
            });
        };
        LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
            var _this = this;
            return Promise.all(result.map(function(item) {
                if (item === null) return null;
                if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
                if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
            }));
        };
        return LocalState;
    }();
    function $02a3c2aebc919401$var$multiplex(inner) {
        var observers = new Set();
        var sub = null;
        return new $02a3c2aebc919401$var$Observable(function(observer) {
            observers.add(observer);
            sub = sub || inner.subscribe({
                next: function(value) {
                    observers.forEach(function(obs) {
                        return obs.next && obs.next(value);
                    });
                },
                error: function(error) {
                    observers.forEach(function(obs) {
                        return obs.error && obs.error(error);
                    });
                },
                complete: function() {
                    observers.forEach(function(obs) {
                        return obs.complete && obs.complete();
                    });
                }
            });
            return function() {
                if (observers.delete(observer) && !observers.size && sub) {
                    sub.unsubscribe();
                    sub = null;
                }
            };
        });
    }
    function $02a3c2aebc919401$var$asyncMap(observable, mapFn) {
        return new $02a3c2aebc919401$var$Observable(function(observer) {
            var next = observer.next, error = observer.error, complete = observer.complete;
            var activeNextCount = 0;
            var completed = false;
            var handler = {
                next: function(value) {
                    ++activeNextCount;
                    new Promise(function(resolve) {
                        resolve(mapFn(value));
                    }).then(function(result) {
                        --activeNextCount;
                        next && next.call(observer, result);
                        completed && handler.complete();
                    }, function(e) {
                        --activeNextCount;
                        error && error.call(observer, e);
                    });
                },
                error: function(e) {
                    error && error.call(observer, e);
                },
                complete: function() {
                    completed = true;
                    if (!activeNextCount) complete && complete.call(observer);
                }
            };
            var sub = observable.subscribe(handler);
            return function() {
                return sub.unsubscribe();
            };
        });
    }
    var $02a3c2aebc919401$var$hasOwnProperty = Object.prototype.hasOwnProperty;
    var $02a3c2aebc919401$var$QueryManager = function() {
        function QueryManager(_a) {
            var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
                return undefined;
            } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
            this.mutationStore = new $02a3c2aebc919401$var$MutationStore();
            this.queryStore = new $02a3c2aebc919401$var$QueryStore();
            this.clientAwareness = {};
            this.idCounter = 1;
            this.queries = new Map();
            this.fetchQueryRejectFns = new Map();
            this.transformCache = new ((0, (0, parcelRequire("jojW6")).canUseWeakMap) ? WeakMap : Map)();
            this.inFlightLinkObservables = new Map();
            this.pollingInfoByQueryId = new Map();
            this.link = link;
            this.queryDeduplication = queryDeduplication;
            this.dataStore = store;
            this.onBroadcast = onBroadcast;
            this.clientAwareness = clientAwareness;
            this.localState = localState || new $02a3c2aebc919401$var$LocalState({
                cache: store.getCache()
            });
            this.ssrMode = ssrMode;
            this.assumeImmutableResults = !!assumeImmutableResults;
        }
        QueryManager.prototype.stop = function() {
            var _this = this;
            this.queries.forEach(function(_info, queryId) {
                _this.stopQueryNoBroadcast(queryId);
            });
            this.fetchQueryRejectFns.forEach(function(reject) {
                reject(new (0, $1DiV8.InvariantError)(8));
            });
        };
        QueryManager.prototype.mutate = function(_a) {
            var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                var mutationId, generateUpdateQueriesInfo, self;
                var _this = this;
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_f) {
                    switch(_f.label){
                        case 0:
                            (0, $1DiV8.invariant)(mutation, 9);
                            (0, $1DiV8.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                            mutationId = this.generateQueryId();
                            mutation = this.transform(mutation).document;
                            this.setQuery(mutationId, function() {
                                return {
                                    document: mutation
                                };
                            });
                            variables = this.getVariables(mutation, variables);
                            if (!this.transform(mutation).hasClientExports) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                this.localState.addExportedVariables(mutation, variables, context)
                            ];
                        case 1:
                            variables = _f.sent();
                            _f.label = 2;
                        case 2:
                            generateUpdateQueriesInfo = function() {
                                var ret = {};
                                if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                    var observableQuery = _a.observableQuery;
                                    if (observableQuery) {
                                        var queryName = observableQuery.queryName;
                                        if (queryName && $02a3c2aebc919401$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                            updater: updateQueriesByName[queryName],
                                            query: _this.queryStore.get(queryId)
                                        };
                                    }
                                });
                                return ret;
                            };
                            this.mutationStore.initMutation(mutationId, mutation, variables);
                            this.dataStore.markMutationInit({
                                mutationId: mutationId,
                                document: mutation,
                                variables: variables,
                                updateQueries: generateUpdateQueriesInfo(),
                                update: updateWithProxyFn,
                                optimisticResponse: optimisticResponse
                            });
                            this.broadcastQueries();
                            self = this;
                            return [
                                2,
                                new Promise(function(resolve, reject) {
                                    var storeResult;
                                    var error;
                                    self.getObservableFromLink(mutation, (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, context), {
                                        optimisticResponse: optimisticResponse
                                    }), variables, false).subscribe({
                                        next: function(result) {
                                            if ((0, (0, parcelRequire("jojW6")).graphQLResultHasError)(result) && errorPolicy === 'none') {
                                                error = new $02a3c2aebc919401$export$26a337512320b8c6({
                                                    graphQLErrors: result.errors
                                                });
                                                return;
                                            }
                                            self.mutationStore.markMutationResult(mutationId);
                                            if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                                mutationId: mutationId,
                                                result: result,
                                                document: mutation,
                                                variables: variables,
                                                updateQueries: generateUpdateQueriesInfo(),
                                                update: updateWithProxyFn
                                            });
                                            storeResult = result;
                                        },
                                        error: function(err) {
                                            self.mutationStore.markMutationError(mutationId, err);
                                            self.dataStore.markMutationComplete({
                                                mutationId: mutationId,
                                                optimisticResponse: optimisticResponse
                                            });
                                            self.broadcastQueries();
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            reject(new $02a3c2aebc919401$export$26a337512320b8c6({
                                                networkError: err
                                            }));
                                        },
                                        complete: function() {
                                            if (error) self.mutationStore.markMutationError(mutationId, error);
                                            self.dataStore.markMutationComplete({
                                                mutationId: mutationId,
                                                optimisticResponse: optimisticResponse
                                            });
                                            self.broadcastQueries();
                                            if (error) {
                                                reject(error);
                                                return;
                                            }
                                            if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                            var refetchQueryPromises = [];
                                            if ($02a3c2aebc919401$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                                if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                    var observableQuery = _a.observableQuery;
                                                    if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                                });
                                                else {
                                                    var queryOptions = {
                                                        query: refetchQuery.query,
                                                        variables: refetchQuery.variables,
                                                        fetchPolicy: 'network-only'
                                                    };
                                                    if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                    refetchQueryPromises.push(self.query(queryOptions));
                                                }
                                            });
                                            Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                                self.setQuery(mutationId, function() {
                                                    return {
                                                        document: null
                                                    };
                                                });
                                                if (errorPolicy === 'ignore' && storeResult && (0, (0, parcelRequire("jojW6")).graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                                resolve(storeResult);
                                            });
                                        }
                                    });
                                })
                            ];
                    }
                });
            });
        };
        QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
            return (0, (0, parcelRequire("3VFsf")).__awaiter)(this, void 0, void 0, function() {
                var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
                var _this = this;
                return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                            query = this.transform(options.query).document;
                            variables = this.getVariables(query, options.variables);
                            if (!this.transform(query).hasClientExports) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                this.localState.addExportedVariables(query, variables, context)
                            ];
                        case 1:
                            variables = _e.sent();
                            _e.label = 2;
                        case 2:
                            options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                                variables: variables
                            });
                            isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                            needToFetch = isNetworkOnly;
                            if (!isNetworkOnly) {
                                _d = this.dataStore.getCache().diff({
                                    query: query,
                                    variables: variables,
                                    returnPartialData: true,
                                    optimistic: false
                                }), complete = _d.complete, result = _d.result;
                                needToFetch = !complete || fetchPolicy === 'cache-and-network';
                                storeResult = result;
                            }
                            shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                            if ((0, (0, parcelRequire("jojW6")).hasDirectives)([
                                'live'
                            ], query)) shouldFetch = true;
                            requestId = this.idCounter++;
                            cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                            this.setQuery(queryId, function() {
                                return {
                                    document: query,
                                    lastRequestId: requestId,
                                    invalidated: true,
                                    cancel: cancel
                                };
                            });
                            this.invalidate(fetchMoreForQueryId);
                            this.queryStore.initQuery({
                                queryId: queryId,
                                document: query,
                                storePreviousVariables: shouldFetch,
                                variables: variables,
                                isPoll: fetchType === $02a3c2aebc919401$export$160bafb6ac1e0641.poll,
                                isRefetch: fetchType === $02a3c2aebc919401$export$160bafb6ac1e0641.refetch,
                                metadata: metadata,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            });
                            this.broadcastQueries();
                            if (shouldFetch) {
                                networkResult = this.fetchRequest({
                                    requestId: requestId,
                                    queryId: queryId,
                                    document: query,
                                    options: options,
                                    fetchMoreForQueryId: fetchMoreForQueryId
                                }).catch(function(error) {
                                    if ($02a3c2aebc919401$export$17f5e6bd290bb15d(error)) throw error;
                                    else {
                                        if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                            _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                            _this.invalidate(queryId);
                                            _this.invalidate(fetchMoreForQueryId);
                                            _this.broadcastQueries();
                                        }
                                        throw new $02a3c2aebc919401$export$26a337512320b8c6({
                                            networkError: error
                                        });
                                    }
                                });
                                if (fetchPolicy !== 'cache-and-network') return [
                                    2,
                                    networkResult
                                ];
                                networkResult.catch(function() {});
                            }
                            this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                            this.invalidate(queryId);
                            this.invalidate(fetchMoreForQueryId);
                            if (this.transform(query).hasForcedResolvers) return [
                                2,
                                this.localState.runResolvers({
                                    document: query,
                                    remoteResult: {
                                        data: storeResult
                                    },
                                    context: context,
                                    variables: variables,
                                    onlyRunForcedResolvers: true
                                }).then(function(result) {
                                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                    _this.broadcastQueries();
                                    return result;
                                })
                            ];
                            this.broadcastQueries();
                            return [
                                2,
                                {
                                    data: storeResult
                                }
                            ];
                    }
                });
            });
        };
        QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
            var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
            if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
                return {
                    newData: {
                        result: result.data,
                        complete: true
                    }
                };
            });
            else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
        };
        QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
            var _this = this;
            function invoke(method, argument) {
                if (observer[method]) try {
                    observer[method](argument);
                } catch (e) {}
                else method;
            }
            return function(queryStoreValue, newData) {
                _this.invalidate(queryId, false);
                if (!queryStoreValue) return;
                var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
                var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
                if (fetchPolicy === 'standby') return;
                var loading = $02a3c2aebc919401$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
                var lastResult = observableQuery && observableQuery.getLastResult();
                var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
                var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
                if (loading && !shouldNotifyIfLoading) return;
                var hasGraphQLErrors = $02a3c2aebc919401$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
                var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
                if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $02a3c2aebc919401$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                }));
                try {
                    var data = void 0;
                    var isMissing = void 0;
                    if (newData) {
                        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                            return {
                                newData: null
                            };
                        });
                        data = newData.result;
                        isMissing = !newData.complete;
                    } else {
                        var lastError = observableQuery && observableQuery.getLastError();
                        var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                        if (lastResult && lastResult.data && !errorStatusChanged) {
                            data = lastResult.data;
                            isMissing = false;
                        } else {
                            var diffResult = _this.dataStore.getCache().diff({
                                query: document,
                                variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                                returnPartialData: true,
                                optimistic: true
                            });
                            data = diffResult.result;
                            isMissing = !diffResult.complete;
                        }
                    }
                    var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                    var resultFromStore = {
                        data: stale ? lastResult && lastResult.data : data,
                        loading: loading,
                        networkStatus: queryStoreValue.networkStatus,
                        stale: stale
                    };
                    if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                    invoke('next', resultFromStore);
                } catch (networkError) {
                    invoke('error', new $02a3c2aebc919401$export$26a337512320b8c6({
                        networkError: networkError
                    }));
                }
            };
        };
        QueryManager.prototype.transform = function(document) {
            var transformCache = this.transformCache;
            if (!transformCache.has(document)) {
                var cache = this.dataStore.getCache();
                var transformed = cache.transformDocument(document);
                var forLink = (0, (0, parcelRequire("jojW6")).removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
                var clientQuery = this.localState.clientQuery(transformed);
                var serverQuery = this.localState.serverQuery(forLink);
                var cacheEntry_1 = {
                    document: transformed,
                    hasClientExports: (0, (0, parcelRequire("jojW6")).hasClientExports)(transformed),
                    hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                    clientQuery: clientQuery,
                    serverQuery: serverQuery,
                    defaultVars: (0, (0, parcelRequire("jojW6")).getDefaultValues)((0, (0, parcelRequire("jojW6")).getOperationDefinition)(transformed))
                };
                var add = function(doc) {
                    if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
                };
                add(document);
                add(transformed);
                add(clientQuery);
                add(serverQuery);
            }
            return transformCache.get(document);
        };
        QueryManager.prototype.getVariables = function(document, variables) {
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.transform(document).defaultVars), variables);
        };
        QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
            if (shouldSubscribe === void 0) shouldSubscribe = true;
            (0, $1DiV8.invariant)(options.fetchPolicy !== 'standby', 11);
            options.variables = this.getVariables(options.query, options.variables);
            if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
            var transformedOptions = (0, (0, parcelRequire("3VFsf")).__assign)({}, options);
            return new $02a3c2aebc919401$export$6c1b56eac59c9584({
                queryManager: this,
                options: transformedOptions,
                shouldSubscribe: shouldSubscribe
            });
        };
        QueryManager.prototype.query = function(options) {
            var _this = this;
            (0, $1DiV8.invariant)(options.query, 12);
            (0, $1DiV8.invariant)(options.query.kind === 'Document', 13);
            (0, $1DiV8.invariant)(!options.returnPartialData, 14);
            (0, $1DiV8.invariant)(!options.pollInterval, 15);
            return new Promise(function(resolve, reject) {
                var watchedQuery = _this.watchQuery(options, false);
                _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
                watchedQuery.result().then(resolve, reject).then(function() {
                    return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
                });
            });
        };
        QueryManager.prototype.generateQueryId = function() {
            return String(this.idCounter++);
        };
        QueryManager.prototype.stopQueryInStore = function(queryId) {
            this.stopQueryInStoreNoBroadcast(queryId);
            this.broadcastQueries();
        };
        QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
            this.stopPollingQuery(queryId);
            this.queryStore.stopQuery(queryId);
            this.invalidate(queryId);
        };
        QueryManager.prototype.addQueryListener = function(queryId, listener) {
            this.setQuery(queryId, function(_a) {
                var listeners = _a.listeners;
                listeners.add(listener);
                return {
                    invalidated: false
                };
            });
        };
        QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
            var _this = this;
            var cancel = this.getQuery(queryId).cancel;
            if (cancel) cancel();
            var previousResult = function() {
                var previousResult = null;
                var observableQuery = _this.getQuery(queryId).observableQuery;
                if (observableQuery) {
                    var lastResult = observableQuery.getLastResult();
                    if (lastResult) previousResult = lastResult.data;
                }
                return previousResult;
            };
            return this.dataStore.getCache().watch({
                query: document,
                variables: options.variables,
                optimistic: true,
                previousResult: previousResult,
                callback: function(newData) {
                    _this.setQuery(queryId, function() {
                        return {
                            invalidated: true,
                            newData: newData
                        };
                    });
                }
            });
        };
        QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
            this.setQuery(queryId, function() {
                return {
                    observableQuery: observableQuery
                };
            });
        };
        QueryManager.prototype.removeObservableQuery = function(queryId) {
            var cancel = this.getQuery(queryId).cancel;
            this.setQuery(queryId, function() {
                return {
                    observableQuery: null
                };
            });
            if (cancel) cancel();
        };
        QueryManager.prototype.clearStore = function() {
            this.fetchQueryRejectFns.forEach(function(reject) {
                reject(new (0, $1DiV8.InvariantError)(16));
            });
            var resetIds = [];
            this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                if (observableQuery) resetIds.push(queryId);
            });
            this.queryStore.reset(resetIds);
            this.mutationStore.reset();
            return this.dataStore.reset();
        };
        QueryManager.prototype.resetStore = function() {
            var _this = this;
            return this.clearStore().then(function() {
                return _this.reFetchObservableQueries();
            });
        };
        QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
            var _this = this;
            if (includeStandby === void 0) includeStandby = false;
            var observableQueryPromises = [];
            this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                if (observableQuery) {
                    var fetchPolicy = observableQuery.options.fetchPolicy;
                    observableQuery.resetLastResults();
                    if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                    _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    _this.invalidate(queryId);
                }
            });
            this.broadcastQueries();
            return Promise.all(observableQueryPromises);
        };
        QueryManager.prototype.observeQuery = function(queryId, options, observer) {
            this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
            return this.fetchQuery(queryId, options);
        };
        QueryManager.prototype.startQuery = function(queryId, options, listener) {
            this.addQueryListener(queryId, listener);
            this.fetchQuery(queryId, options).catch(function() {
                return undefined;
            });
            return queryId;
        };
        QueryManager.prototype.startGraphQLSubscription = function(_a) {
            var _this = this;
            var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
            query = this.transform(query).document;
            variables = this.getVariables(query, variables);
            var makeObservable = function(variables) {
                return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                    if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                        _this.dataStore.markSubscriptionResult(result, query, variables);
                        _this.broadcastQueries();
                    }
                    if ((0, (0, parcelRequire("jojW6")).graphQLResultHasError)(result)) throw new $02a3c2aebc919401$export$26a337512320b8c6({
                        graphQLErrors: result.errors
                    });
                    return result;
                });
            };
            if (this.transform(query).hasClientExports) {
                var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
                return new $02a3c2aebc919401$var$Observable(function(observer) {
                    var sub = null;
                    observablePromise_1.then(function(observable) {
                        return sub = observable.subscribe(observer);
                    }, observer.error);
                    return function() {
                        return sub && sub.unsubscribe();
                    };
                });
            }
            return makeObservable(variables);
        };
        QueryManager.prototype.stopQuery = function(queryId) {
            this.stopQueryNoBroadcast(queryId);
            this.broadcastQueries();
        };
        QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
            this.stopQueryInStoreNoBroadcast(queryId);
            this.removeQuery(queryId);
        };
        QueryManager.prototype.removeQuery = function(queryId) {
            this.fetchQueryRejectFns.delete("query:" + queryId);
            this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
            this.getQuery(queryId).subscriptions.forEach(function(x) {
                return x.unsubscribe();
            });
            this.queries.delete(queryId);
        };
        QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
            if (optimistic === void 0) optimistic = true;
            var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
            var lastResult = observableQuery.getLastResult();
            var newData = this.getQuery(observableQuery.queryId).newData;
            if (newData && newData.complete) return {
                data: newData.result,
                partial: false
            };
            if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
                data: undefined,
                partial: false
            };
            var _b = this.dataStore.getCache().diff({
                query: query,
                variables: variables,
                previousResult: lastResult ? lastResult.data : undefined,
                returnPartialData: true,
                optimistic: optimistic
            }), result = _b.result, complete = _b.complete;
            return {
                data: complete || returnPartialData ? result : void 0,
                partial: !complete
            };
        };
        QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
            var observableQuery;
            if (typeof queryIdOrObservable === 'string') {
                var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
                (0, $1DiV8.invariant)(foundObserveableQuery, 17);
                observableQuery = foundObserveableQuery;
            } else observableQuery = queryIdOrObservable;
            var _a = observableQuery.options, variables = _a.variables, query = _a.query;
            return {
                previousResult: this.getCurrentQueryResult(observableQuery, false).data,
                variables: variables,
                document: query
            };
        };
        QueryManager.prototype.broadcastQueries = function() {
            var _this = this;
            this.onBroadcast();
            this.queries.forEach(function(info, id) {
                if (info.invalidated) info.listeners.forEach(function(listener) {
                    if (listener) listener(_this.queryStore.get(id), info.newData);
                });
            });
        };
        QueryManager.prototype.getLocalState = function() {
            return this.localState;
        };
        QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
            var _this = this;
            if (deduplication === void 0) deduplication = this.queryDeduplication;
            var observable;
            var serverQuery = this.transform(query).serverQuery;
            if (serverQuery) {
                var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
                var operation = {
                    query: serverQuery,
                    variables: variables,
                    operationName: (0, (0, parcelRequire("jojW6")).getOperationName)(serverQuery) || void 0,
                    context: this.prepareContext((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, context), {
                        forceFetch: !deduplication
                    }))
                };
                context = operation.context;
                if (deduplication) {
                    var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                    inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                    var varJson_1 = JSON.stringify(variables);
                    observable = byVariables_1.get(varJson_1);
                    if (!observable) {
                        byVariables_1.set(varJson_1, observable = $02a3c2aebc919401$var$multiplex((0, (0, parcelRequire("clSzL")).execute)(link, operation)));
                        var cleanup = function() {
                            byVariables_1.delete(varJson_1);
                            if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                            cleanupSub_1.unsubscribe();
                        };
                        var cleanupSub_1 = observable.subscribe({
                            next: cleanup,
                            error: cleanup,
                            complete: cleanup
                        });
                    }
                } else observable = $02a3c2aebc919401$var$multiplex((0, (0, parcelRequire("clSzL")).execute)(link, operation));
            } else {
                observable = $02a3c2aebc919401$var$Observable.of({
                    data: {}
                });
                context = this.prepareContext(context);
            }
            var clientQuery = this.transform(query).clientQuery;
            if (clientQuery) observable = $02a3c2aebc919401$var$asyncMap(observable, function(result) {
                return _this.localState.runResolvers({
                    document: clientQuery,
                    remoteResult: result,
                    context: context,
                    variables: variables
                });
            });
            return observable;
        };
        QueryManager.prototype.fetchRequest = function(_a) {
            var _this = this;
            var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
            var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
            var resultFromStore;
            var errorsFromStore;
            return new Promise(function(resolve, reject) {
                var observable = _this.getObservableFromLink(document, options.context, variables);
                var fqrfId = "fetchRequest:" + queryId;
                _this.fetchQueryRejectFns.set(fqrfId, reject);
                var cleanup = function() {
                    _this.fetchQueryRejectFns.delete(fqrfId);
                    _this.setQuery(queryId, function(_a) {
                        var subscriptions = _a.subscriptions;
                        subscriptions.delete(subscription);
                    });
                };
                var subscription = observable.map(function(result) {
                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                        _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                        _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                        _this.invalidate(queryId);
                        _this.invalidate(fetchMoreForQueryId);
                        _this.broadcastQueries();
                    }
                    if (errorPolicy === 'none' && $02a3c2aebc919401$var$isNonEmptyArray(result.errors)) return reject(new $02a3c2aebc919401$export$26a337512320b8c6({
                        graphQLErrors: result.errors
                    }));
                    if (errorPolicy === 'all') errorsFromStore = result.errors;
                    if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                    else {
                        var _a = _this.dataStore.getCache().diff({
                            variables: variables,
                            query: document,
                            optimistic: false,
                            returnPartialData: true
                        }), result_1 = _a.result, complete = _a.complete;
                        if (complete || options.returnPartialData) resultFromStore = result_1;
                    }
                }).subscribe({
                    error: function(error) {
                        cleanup();
                        reject(error);
                    },
                    complete: function() {
                        cleanup();
                        resolve({
                            data: resultFromStore,
                            errors: errorsFromStore,
                            loading: false,
                            networkStatus: $02a3c2aebc919401$export$bd096ddbd246c79c.ready,
                            stale: false
                        });
                    }
                });
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.add(subscription);
                });
            });
        };
        QueryManager.prototype.getQuery = function(queryId) {
            return this.queries.get(queryId) || {
                listeners: new Set(),
                invalidated: false,
                document: null,
                newData: null,
                lastRequestId: 1,
                observableQuery: null,
                subscriptions: new Set()
            };
        };
        QueryManager.prototype.setQuery = function(queryId, updater) {
            var prev = this.getQuery(queryId);
            var newInfo = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, prev), updater(prev));
            this.queries.set(queryId, newInfo);
        };
        QueryManager.prototype.invalidate = function(queryId, invalidated) {
            if (invalidated === void 0) invalidated = true;
            if (queryId) this.setQuery(queryId, function() {
                return {
                    invalidated: invalidated
                };
            });
        };
        QueryManager.prototype.prepareContext = function(context) {
            if (context === void 0) context = {};
            var newContext = this.localState.prepareContext(context);
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, newContext), {
                clientAwareness: this.clientAwareness
            });
        };
        QueryManager.prototype.checkInFlight = function(queryId) {
            var query = this.queryStore.get(queryId);
            return query && query.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.ready && query.networkStatus !== $02a3c2aebc919401$export$bd096ddbd246c79c.error;
        };
        QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
            var _this = this;
            var pollInterval = options.pollInterval;
            (0, $1DiV8.invariant)(pollInterval, 18);
            if (!this.ssrMode) {
                var info = this.pollingInfoByQueryId.get(queryId);
                if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
                info.interval = pollInterval;
                info.options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                    fetchPolicy: 'network-only'
                });
                var maybeFetch_1 = function() {
                    var info = _this.pollingInfoByQueryId.get(queryId);
                    if (info) {
                        if (_this.checkInFlight(queryId)) poll_1();
                        else _this.fetchQuery(queryId, info.options, $02a3c2aebc919401$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                    }
                };
                var poll_1 = function() {
                    var info = _this.pollingInfoByQueryId.get(queryId);
                    if (info) {
                        clearTimeout(info.timeout);
                        info.timeout = setTimeout(maybeFetch_1, info.interval);
                    }
                };
                if (listener) this.addQueryListener(queryId, listener);
                poll_1();
            }
            return queryId;
        };
        QueryManager.prototype.stopPollingQuery = function(queryId) {
            this.pollingInfoByQueryId.delete(queryId);
        };
        return QueryManager;
    }();
    var $02a3c2aebc919401$var$DataStore = function() {
        function DataStore(initialCache) {
            this.cache = initialCache;
        }
        DataStore.prototype.getCache = function() {
            return this.cache;
        };
        DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
            if (ignoreErrors === void 0) ignoreErrors = false;
            var writeWithErrors = !(0, (0, parcelRequire("jojW6")).graphQLResultHasError)(result);
            if (ignoreErrors && (0, (0, parcelRequire("jojW6")).graphQLResultHasError)(result) && result.data) writeWithErrors = true;
            if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
                result: result.data,
                dataId: 'ROOT_QUERY',
                query: document,
                variables: variables
            });
        };
        DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
            if (!(0, (0, parcelRequire("jojW6")).graphQLResultHasError)(result)) this.cache.write({
                result: result.data,
                dataId: 'ROOT_SUBSCRIPTION',
                query: document,
                variables: variables
            });
        };
        DataStore.prototype.markMutationInit = function(mutation) {
            var _this = this;
            if (mutation.optimisticResponse) {
                var optimistic_1;
                if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
                else optimistic_1 = mutation.optimisticResponse;
                this.cache.recordOptimisticTransaction(function(c) {
                    var orig = _this.cache;
                    _this.cache = c;
                    try {
                        _this.markMutationResult({
                            mutationId: mutation.mutationId,
                            result: {
                                data: optimistic_1
                            },
                            document: mutation.document,
                            variables: mutation.variables,
                            updateQueries: mutation.updateQueries,
                            update: mutation.update
                        });
                    } finally{
                        _this.cache = orig;
                    }
                }, mutation.mutationId);
            }
        };
        DataStore.prototype.markMutationResult = function(mutation) {
            var _this = this;
            if (!(0, (0, parcelRequire("jojW6")).graphQLResultHasError)(mutation.result)) {
                var cacheWrites_1 = [
                    {
                        result: mutation.result.data,
                        dataId: 'ROOT_MUTATION',
                        query: mutation.document,
                        variables: mutation.variables
                    }
                ];
                var updateQueries_1 = mutation.updateQueries;
                if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                    var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                    var _b = _this.cache.diff({
                        query: query.document,
                        variables: query.variables,
                        returnPartialData: true,
                        optimistic: false
                    }), currentQueryResult = _b.result, complete = _b.complete;
                    if (complete) {
                        var nextQueryResult = (0, (0, parcelRequire("jojW6")).tryFunctionOrLogError)(function() {
                            return updater(currentQueryResult, {
                                mutationResult: mutation.result,
                                queryName: (0, (0, parcelRequire("jojW6")).getOperationName)(query.document) || undefined,
                                queryVariables: query.variables
                            });
                        });
                        if (nextQueryResult) cacheWrites_1.push({
                            result: nextQueryResult,
                            dataId: 'ROOT_QUERY',
                            query: query.document,
                            variables: query.variables
                        });
                    }
                });
                this.cache.performTransaction(function(c) {
                    cacheWrites_1.forEach(function(write) {
                        return c.write(write);
                    });
                    var update = mutation.update;
                    if (update) (0, (0, parcelRequire("jojW6")).tryFunctionOrLogError)(function() {
                        return update(c, mutation.result);
                    });
                });
            }
        };
        DataStore.prototype.markMutationComplete = function(_a) {
            var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
            if (optimisticResponse) this.cache.removeOptimistic(mutationId);
        };
        DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
            this.cache.write({
                result: newResult,
                dataId: 'ROOT_QUERY',
                variables: variables,
                query: document
            });
        };
        DataStore.prototype.reset = function() {
            return this.cache.reset();
        };
        return DataStore;
    }();
    var $02a3c2aebc919401$var$version = "2.6.10";
    var $02a3c2aebc919401$var$hasSuggestedDevtools = false;
    var $02a3c2aebc919401$export$13f5a5f0f1dbab88 = function() {
        function ApolloClient(options) {
            var _this = this;
            this.defaultOptions = {};
            this.resetStoreCallbacks = [];
            this.clearStoreCallbacks = [];
            var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
            var link = options.link;
            if (!link && resolvers) link = (0, (0, parcelRequire("clSzL")).ApolloLink).empty();
            if (!link || !cache) throw new (0, $1DiV8.InvariantError)(4);
            this.link = link;
            this.cache = cache;
            this.store = new $02a3c2aebc919401$var$DataStore(cache);
            this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
            this.queryDeduplication = queryDeduplication;
            this.defaultOptions = defaultOptions || {};
            this.typeDefs = typeDefs;
            if (ssrForceFetchDelay) setTimeout(function() {
                return _this.disableNetworkFetches = false;
            }, ssrForceFetchDelay);
            this.watchQuery = this.watchQuery.bind(this);
            this.query = this.query.bind(this);
            this.mutate = this.mutate.bind(this);
            this.resetStore = this.resetStore.bind(this);
            this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
            var defaultConnectToDevTools = false;
            if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
            this.version = $02a3c2aebc919401$var$version;
            this.localState = new $02a3c2aebc919401$var$LocalState({
                cache: cache,
                client: this,
                resolvers: resolvers,
                fragmentMatcher: fragmentMatcher
            });
            this.queryManager = new $02a3c2aebc919401$var$QueryManager({
                link: this.link,
                store: this.store,
                queryDeduplication: queryDeduplication,
                ssrMode: ssrMode,
                clientAwareness: {
                    name: clientAwarenessName,
                    version: clientAwarenessVersion
                },
                localState: this.localState,
                assumeImmutableResults: assumeImmutableResults,
                onBroadcast: function() {
                    if (_this.devToolsHookCb) _this.devToolsHookCb({
                        action: {},
                        state: {
                            queries: _this.queryManager.queryStore.getStore(),
                            mutations: _this.queryManager.mutationStore.getStore()
                        },
                        dataWithOptimisticResults: _this.cache.extract(true)
                    });
                }
            });
        }
        ApolloClient.prototype.stop = function() {
            this.queryManager.stop();
        };
        ApolloClient.prototype.watchQuery = function(options) {
            if (this.defaultOptions.watchQuery) options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.defaultOptions.watchQuery), options);
            if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                fetchPolicy: 'cache-first'
            });
            return this.queryManager.watchQuery(options);
        };
        ApolloClient.prototype.query = function(options) {
            if (this.defaultOptions.query) options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.defaultOptions.query), options);
            (0, $1DiV8.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
            if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                fetchPolicy: 'cache-first'
            });
            return this.queryManager.query(options);
        };
        ApolloClient.prototype.mutate = function(options) {
            if (this.defaultOptions.mutate) options = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.defaultOptions.mutate), options);
            return this.queryManager.mutate(options);
        };
        ApolloClient.prototype.subscribe = function(options) {
            return this.queryManager.startGraphQLSubscription(options);
        };
        ApolloClient.prototype.readQuery = function(options, optimistic) {
            if (optimistic === void 0) optimistic = false;
            return this.cache.readQuery(options, optimistic);
        };
        ApolloClient.prototype.readFragment = function(options, optimistic) {
            if (optimistic === void 0) optimistic = false;
            return this.cache.readFragment(options, optimistic);
        };
        ApolloClient.prototype.writeQuery = function(options) {
            var result = this.cache.writeQuery(options);
            this.queryManager.broadcastQueries();
            return result;
        };
        ApolloClient.prototype.writeFragment = function(options) {
            var result = this.cache.writeFragment(options);
            this.queryManager.broadcastQueries();
            return result;
        };
        ApolloClient.prototype.writeData = function(options) {
            var result = this.cache.writeData(options);
            this.queryManager.broadcastQueries();
            return result;
        };
        ApolloClient.prototype.__actionHookForDevTools = function(cb) {
            this.devToolsHookCb = cb;
        };
        ApolloClient.prototype.__requestRaw = function(payload) {
            return (0, (0, parcelRequire("clSzL")).execute)(this.link, payload);
        };
        ApolloClient.prototype.initQueryManager = function() {
            return this.queryManager;
        };
        ApolloClient.prototype.resetStore = function() {
            var _this = this;
            return Promise.resolve().then(function() {
                return _this.queryManager.clearStore();
            }).then(function() {
                return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                    return fn();
                }));
            }).then(function() {
                return _this.reFetchObservableQueries();
            });
        };
        ApolloClient.prototype.clearStore = function() {
            var _this = this;
            return Promise.resolve().then(function() {
                return _this.queryManager.clearStore();
            }).then(function() {
                return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                    return fn();
                }));
            });
        };
        ApolloClient.prototype.onResetStore = function(cb) {
            var _this = this;
            this.resetStoreCallbacks.push(cb);
            return function() {
                _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                    return c !== cb;
                });
            };
        };
        ApolloClient.prototype.onClearStore = function(cb) {
            var _this = this;
            this.clearStoreCallbacks.push(cb);
            return function() {
                _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                    return c !== cb;
                });
            };
        };
        ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
            return this.queryManager.reFetchObservableQueries(includeStandby);
        };
        ApolloClient.prototype.extract = function(optimistic) {
            return this.cache.extract(optimistic);
        };
        ApolloClient.prototype.restore = function(serializedState) {
            return this.cache.restore(serializedState);
        };
        ApolloClient.prototype.addResolvers = function(resolvers) {
            this.localState.addResolvers(resolvers);
        };
        ApolloClient.prototype.setResolvers = function(resolvers) {
            this.localState.setResolvers(resolvers);
        };
        ApolloClient.prototype.getResolvers = function() {
            return this.localState.getResolvers();
        };
        ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
            this.localState.setFragmentMatcher(fragmentMatcher);
        };
        return ApolloClient;
    }();
    var $02a3c2aebc919401$export$2e2bcd8739ae039 = $02a3c2aebc919401$export$13f5a5f0f1dbab88;
});
parcelRegister("jojW6", function(module, exports) {
    $parcel$export(module.exports, "storeKeyNameFromField", ()=>$e1dfb923a27ca793$export$54be8689c65f3b56);
    $parcel$export(module.exports, "getStoreKeyName", ()=>$e1dfb923a27ca793$export$3cdb6c178b88cabe);
    $parcel$export(module.exports, "argumentsObjectFromField", ()=>$e1dfb923a27ca793$export$3f5a60fb6a781b4f);
    $parcel$export(module.exports, "resultKeyNameFromField", ()=>$e1dfb923a27ca793$export$7d1ad22471852218);
    $parcel$export(module.exports, "isField", ()=>$e1dfb923a27ca793$export$fb56ad75dd311c12);
    $parcel$export(module.exports, "isInlineFragment", ()=>$e1dfb923a27ca793$export$22a1cdafaf27bcff);
    $parcel$export(module.exports, "isIdValue", ()=>$e1dfb923a27ca793$export$e33b89a9aa87695);
    $parcel$export(module.exports, "toIdValue", ()=>$e1dfb923a27ca793$export$b124f125e34d720a);
    $parcel$export(module.exports, "isJsonValue", ()=>$e1dfb923a27ca793$export$226c1c6d1a5b660a);
    $parcel$export(module.exports, "getDirectiveInfoFromField", ()=>$e1dfb923a27ca793$export$2a7f471142984a91);
    $parcel$export(module.exports, "shouldInclude", ()=>$e1dfb923a27ca793$export$3dc388a5f013b4a5);
    $parcel$export(module.exports, "hasDirectives", ()=>$e1dfb923a27ca793$export$2dafb573e282fe8d);
    $parcel$export(module.exports, "hasClientExports", ()=>$e1dfb923a27ca793$export$8d1e9e5bbfa5d09a);
    $parcel$export(module.exports, "getFragmentQueryDocument", ()=>$e1dfb923a27ca793$export$abbf37c7cf644e41);
    $parcel$export(module.exports, "assign", ()=>$e1dfb923a27ca793$export$e6e34fd1f2686227);
    $parcel$export(module.exports, "checkDocument", ()=>$e1dfb923a27ca793$export$a7d0d8111d2386df);
    $parcel$export(module.exports, "getOperationDefinition", ()=>$e1dfb923a27ca793$export$7a5b1fa979d2c158);
    $parcel$export(module.exports, "getOperationName", ()=>$e1dfb923a27ca793$export$41bca9dc6871dd4e);
    $parcel$export(module.exports, "getFragmentDefinitions", ()=>$e1dfb923a27ca793$export$5320a7ba9466a3df);
    $parcel$export(module.exports, "getQueryDefinition", ()=>$e1dfb923a27ca793$export$d96b2213c1b9d3a9);
    $parcel$export(module.exports, "getMainDefinition", ()=>$e1dfb923a27ca793$export$f431198736b7f96d);
    $parcel$export(module.exports, "createFragmentMap", ()=>$e1dfb923a27ca793$export$193789b4c8246dd4);
    $parcel$export(module.exports, "getDefaultValues", ()=>$e1dfb923a27ca793$export$84c19026e616569e);
    $parcel$export(module.exports, "removeDirectivesFromDocument", ()=>$e1dfb923a27ca793$export$e5ae0530da5fe96c);
    $parcel$export(module.exports, "addTypenameToDocument", ()=>$e1dfb923a27ca793$export$43b332f87950a467);
    $parcel$export(module.exports, "removeConnectionDirectiveFromDocument", ()=>$e1dfb923a27ca793$export$74985f3324559867);
    $parcel$export(module.exports, "buildQueryFromSelectionSet", ()=>$e1dfb923a27ca793$export$57c368c23873f32b);
    $parcel$export(module.exports, "removeClientSetsFromDocument", ()=>$e1dfb923a27ca793$export$8eae69e876ee321e);
    $parcel$export(module.exports, "canUseWeakMap", ()=>$e1dfb923a27ca793$export$772fbc04a0ad4ce9);
    $parcel$export(module.exports, "cloneDeep", ()=>$e1dfb923a27ca793$export$629a2bd3f5a49ecc);
    $parcel$export(module.exports, "isProduction", ()=>$e1dfb923a27ca793$export$f15d00aa73aafac4);
    $parcel$export(module.exports, "isTest", ()=>$e1dfb923a27ca793$export$410cbc2864fa25b5);
    $parcel$export(module.exports, "tryFunctionOrLogError", ()=>$e1dfb923a27ca793$export$50a91acae4904909);
    $parcel$export(module.exports, "graphQLResultHasError", ()=>$e1dfb923a27ca793$export$b4df399e879e53ab);
    $parcel$export(module.exports, "mergeDeep", ()=>$e1dfb923a27ca793$export$dd702b3c8240390c);
    $parcel$export(module.exports, "mergeDeepArray", ()=>$e1dfb923a27ca793$export$160070228be94b08);
    var $12QNw;
    var $1DiV8 = parcelRequire("1DiV8");
    var $3VFsf;
    var $fkrBp = parcelRequire("fkrBp");
    var $bqMzA = parcelRequire("bqMzA");
    var $6cAn5 = parcelRequire("6cAn5");
    function $e1dfb923a27ca793$export$dc071f102752d0eb(value) {
        return [
            'StringValue',
            'BooleanValue',
            'EnumValue'
        ].indexOf(value.kind) > -1;
    }
    function $e1dfb923a27ca793$export$3ff5e9927c3257c6(value) {
        return [
            'IntValue',
            'FloatValue'
        ].indexOf(value.kind) > -1;
    }
    function $e1dfb923a27ca793$var$isStringValue(value) {
        return value.kind === 'StringValue';
    }
    function $e1dfb923a27ca793$var$isBooleanValue(value) {
        return value.kind === 'BooleanValue';
    }
    function $e1dfb923a27ca793$var$isIntValue(value) {
        return value.kind === 'IntValue';
    }
    function $e1dfb923a27ca793$var$isFloatValue(value) {
        return value.kind === 'FloatValue';
    }
    function $e1dfb923a27ca793$var$isVariable(value) {
        return value.kind === 'Variable';
    }
    function $e1dfb923a27ca793$var$isObjectValue(value) {
        return value.kind === 'ObjectValue';
    }
    function $e1dfb923a27ca793$var$isListValue(value) {
        return value.kind === 'ListValue';
    }
    function $e1dfb923a27ca793$var$isEnumValue(value) {
        return value.kind === 'EnumValue';
    }
    function $e1dfb923a27ca793$var$isNullValue(value) {
        return value.kind === 'NullValue';
    }
    function $e1dfb923a27ca793$export$a1dab82d368d6525(argObj, name, value, variables) {
        if ($e1dfb923a27ca793$var$isIntValue(value) || $e1dfb923a27ca793$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
        else if ($e1dfb923a27ca793$var$isBooleanValue(value) || $e1dfb923a27ca793$var$isStringValue(value)) argObj[name.value] = value.value;
        else if ($e1dfb923a27ca793$var$isObjectValue(value)) {
            var nestedArgObj_1 = {};
            value.fields.map(function(obj) {
                return $e1dfb923a27ca793$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
            });
            argObj[name.value] = nestedArgObj_1;
        } else if ($e1dfb923a27ca793$var$isVariable(value)) {
            var variableValue = (variables || {})[value.name.value];
            argObj[name.value] = variableValue;
        } else if ($e1dfb923a27ca793$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
            var nestedArgArrayObj = {};
            $e1dfb923a27ca793$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
        else if ($e1dfb923a27ca793$var$isEnumValue(value)) argObj[name.value] = value.value;
        else if ($e1dfb923a27ca793$var$isNullValue(value)) argObj[name.value] = null;
        else throw new (0, $1DiV8.InvariantError)(17);
    }
    function $e1dfb923a27ca793$export$54be8689c65f3b56(field, variables) {
        var directivesObj = null;
        if (field.directives) {
            directivesObj = {};
            field.directives.forEach(function(directive) {
                directivesObj[directive.name.value] = {};
                if (directive.arguments) directive.arguments.forEach(function(_a) {
                    var name = _a.name, value = _a.value;
                    return $e1dfb923a27ca793$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
                });
            });
        }
        var argObj = null;
        if (field.arguments && field.arguments.length) {
            argObj = {};
            field.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $e1dfb923a27ca793$export$a1dab82d368d6525(argObj, name, value, variables);
            });
        }
        return $e1dfb923a27ca793$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
    }
    var $e1dfb923a27ca793$var$KNOWN_DIRECTIVES = [
        'connection',
        'include',
        'skip',
        'client',
        'rest',
        'export'
    ];
    function $e1dfb923a27ca793$export$3cdb6c178b88cabe(fieldName, args, directives) {
        if (directives && directives['connection'] && directives['connection']['key']) {
            if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
                var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
                filterKeys.sort();
                var queryArgs_1 = args;
                var filteredArgs_1 = {};
                filterKeys.forEach(function(key) {
                    filteredArgs_1[key] = queryArgs_1[key];
                });
                return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
            } else return directives['connection']['key'];
        }
        var completeFieldName = fieldName;
        if (args) {
            var stringifiedArgs = (0, ($parcel$interopDefault($fkrBp)))(args);
            completeFieldName += "(" + stringifiedArgs + ")";
        }
        if (directives) Object.keys(directives).forEach(function(key) {
            if ($e1dfb923a27ca793$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
            if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
            else completeFieldName += "@" + key;
        });
        return completeFieldName;
    }
    function $e1dfb923a27ca793$export$3f5a60fb6a781b4f(field, variables) {
        if (field.arguments && field.arguments.length) {
            var argObj_1 = {};
            field.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $e1dfb923a27ca793$export$a1dab82d368d6525(argObj_1, name, value, variables);
            });
            return argObj_1;
        }
        return null;
    }
    function $e1dfb923a27ca793$export$7d1ad22471852218(field) {
        return field.alias ? field.alias.value : field.name.value;
    }
    function $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) {
        return selection.kind === 'Field';
    }
    function $e1dfb923a27ca793$export$22a1cdafaf27bcff(selection) {
        return selection.kind === 'InlineFragment';
    }
    function $e1dfb923a27ca793$export$e33b89a9aa87695(idObject) {
        return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
    }
    function $e1dfb923a27ca793$export$b124f125e34d720a(idConfig, generated) {
        if (generated === void 0) generated = false;
        return (0, (0, parcelRequire("3VFsf")).__assign)({
            type: 'id',
            generated: generated
        }, typeof idConfig === 'string' ? {
            id: idConfig,
            typename: undefined
        } : idConfig);
    }
    function $e1dfb923a27ca793$export$226c1c6d1a5b660a(jsonObject) {
        return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
    }
    function $e1dfb923a27ca793$var$defaultValueFromVariable(node) {
        throw new (0, $1DiV8.InvariantError)(18);
    }
    function $e1dfb923a27ca793$export$b3db129ed867b445(node, onVariable) {
        if (onVariable === void 0) onVariable = $e1dfb923a27ca793$var$defaultValueFromVariable;
        switch(node.kind){
            case 'Variable':
                return onVariable(node);
            case 'NullValue':
                return null;
            case 'IntValue':
                return parseInt(node.value, 10);
            case 'FloatValue':
                return parseFloat(node.value);
            case 'ListValue':
                return node.values.map(function(v) {
                    return $e1dfb923a27ca793$export$b3db129ed867b445(v, onVariable);
                });
            case 'ObjectValue':
                var value = {};
                for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                    var field = _a[_i];
                    value[field.name.value] = $e1dfb923a27ca793$export$b3db129ed867b445(field.value, onVariable);
                }
                return value;
            default:
                return node.value;
        }
    }
    function $e1dfb923a27ca793$export$2a7f471142984a91(field, variables) {
        if (field.directives && field.directives.length) {
            var directiveObj_1 = {};
            field.directives.forEach(function(directive) {
                directiveObj_1[directive.name.value] = $e1dfb923a27ca793$export$3f5a60fb6a781b4f(directive, variables);
            });
            return directiveObj_1;
        }
        return null;
    }
    function $e1dfb923a27ca793$export$3dc388a5f013b4a5(selection, variables) {
        if (variables === void 0) variables = {};
        return $e1dfb923a27ca793$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
            var directive = _a.directive, ifArgument = _a.ifArgument;
            var evaledValue = false;
            if (ifArgument.value.kind === 'Variable') {
                evaledValue = variables[ifArgument.value.name.value];
                (0, $1DiV8.invariant)(evaledValue !== void 0, 13);
            } else evaledValue = ifArgument.value.value;
            return directive.name.value === 'skip' ? !evaledValue : evaledValue;
        });
    }
    function $e1dfb923a27ca793$export$1b217de6ce18b9a(doc) {
        var names = [];
        (0, (0, parcelRequire("12QNw")).visit)(doc, {
            Directive: function(node) {
                names.push(node.name.value);
            }
        });
        return names;
    }
    function $e1dfb923a27ca793$export$2dafb573e282fe8d(names, doc) {
        return $e1dfb923a27ca793$export$1b217de6ce18b9a(doc).some(function(name) {
            return names.indexOf(name) > -1;
        });
    }
    function $e1dfb923a27ca793$export$8d1e9e5bbfa5d09a(document) {
        return document && $e1dfb923a27ca793$export$2dafb573e282fe8d([
            'client'
        ], document) && $e1dfb923a27ca793$export$2dafb573e282fe8d([
            'export'
        ], document);
    }
    function $e1dfb923a27ca793$var$isInclusionDirective(_a) {
        var value = _a.name.value;
        return value === 'skip' || value === 'include';
    }
    function $e1dfb923a27ca793$export$b7bdffb7e6f1ef53(directives) {
        return directives ? directives.filter($e1dfb923a27ca793$var$isInclusionDirective).map(function(directive) {
            var directiveArguments = directive.arguments;
            var directiveName = directive.name.value;
            (0, $1DiV8.invariant)(directiveArguments && directiveArguments.length === 1, 14);
            var ifArgument = directiveArguments[0];
            (0, $1DiV8.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
            var ifValue = ifArgument.value;
            (0, $1DiV8.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
            return {
                directive: directive,
                ifArgument: ifArgument
            };
        }) : [];
    }
    function $e1dfb923a27ca793$export$abbf37c7cf644e41(document, fragmentName) {
        var actualFragmentName = fragmentName;
        var fragments = [];
        document.definitions.forEach(function(definition) {
            if (definition.kind === 'OperationDefinition') throw new (0, $1DiV8.InvariantError)(11);
            if (definition.kind === 'FragmentDefinition') fragments.push(definition);
        });
        if (typeof actualFragmentName === 'undefined') {
            (0, $1DiV8.invariant)(fragments.length === 1, 12);
            actualFragmentName = fragments[0].name.value;
        }
        var query = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, document), {
            definitions: (0, (0, parcelRequire("3VFsf")).__spreadArrays)([
                {
                    kind: 'OperationDefinition',
                    operation: 'query',
                    selectionSet: {
                        kind: 'SelectionSet',
                        selections: [
                            {
                                kind: 'FragmentSpread',
                                name: {
                                    kind: 'Name',
                                    value: actualFragmentName
                                }
                            }
                        ]
                    }
                }
            ], document.definitions)
        });
        return query;
    }
    function $e1dfb923a27ca793$export$e6e34fd1f2686227(target) {
        var sources = [];
        for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
        sources.forEach(function(source) {
            if (typeof source === 'undefined' || source === null) return;
            Object.keys(source).forEach(function(key) {
                target[key] = source[key];
            });
        });
        return target;
    }
    function $e1dfb923a27ca793$export$a92e7a440b22bdf0(doc) {
        $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
        var mutationDef = doc.definitions.filter(function(definition) {
            return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
        })[0];
        (0, $1DiV8.invariant)(mutationDef, 1);
        return mutationDef;
    }
    function $e1dfb923a27ca793$export$a7d0d8111d2386df(doc) {
        (0, $1DiV8.invariant)(doc && doc.kind === 'Document', 2);
        var operations = doc.definitions.filter(function(d) {
            return d.kind !== 'FragmentDefinition';
        }).map(function(definition) {
            if (definition.kind !== 'OperationDefinition') throw new (0, $1DiV8.InvariantError)(3);
            return definition;
        });
        (0, $1DiV8.invariant)(operations.length <= 1, 4);
        return doc;
    }
    function $e1dfb923a27ca793$export$7a5b1fa979d2c158(doc) {
        $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
        return doc.definitions.filter(function(definition) {
            return definition.kind === 'OperationDefinition';
        })[0];
    }
    function $e1dfb923a27ca793$export$78a8e95d8d43ad7f(document) {
        var def = $e1dfb923a27ca793$export$7a5b1fa979d2c158(document);
        (0, $1DiV8.invariant)(def, 5);
        return def;
    }
    function $e1dfb923a27ca793$export$41bca9dc6871dd4e(doc) {
        return doc.definitions.filter(function(definition) {
            return definition.kind === 'OperationDefinition' && definition.name;
        }).map(function(x) {
            return x.name.value;
        })[0] || null;
    }
    function $e1dfb923a27ca793$export$5320a7ba9466a3df(doc) {
        return doc.definitions.filter(function(definition) {
            return definition.kind === 'FragmentDefinition';
        });
    }
    function $e1dfb923a27ca793$export$d96b2213c1b9d3a9(doc) {
        var queryDef = $e1dfb923a27ca793$export$7a5b1fa979d2c158(doc);
        (0, $1DiV8.invariant)(queryDef && queryDef.operation === 'query', 6);
        return queryDef;
    }
    function $e1dfb923a27ca793$export$772111caef41b3f5(doc) {
        (0, $1DiV8.invariant)(doc.kind === 'Document', 7);
        (0, $1DiV8.invariant)(doc.definitions.length <= 1, 8);
        var fragmentDef = doc.definitions[0];
        (0, $1DiV8.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
        return fragmentDef;
    }
    function $e1dfb923a27ca793$export$f431198736b7f96d(queryDoc) {
        $e1dfb923a27ca793$export$a7d0d8111d2386df(queryDoc);
        var fragmentDefinition;
        for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
            var definition = _a[_i];
            if (definition.kind === 'OperationDefinition') {
                var operation = definition.operation;
                if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
            }
            if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
        }
        if (fragmentDefinition) return fragmentDefinition;
        throw new (0, $1DiV8.InvariantError)(10);
    }
    function $e1dfb923a27ca793$export$193789b4c8246dd4(fragments) {
        if (fragments === void 0) fragments = [];
        var symTable = {};
        fragments.forEach(function(fragment) {
            symTable[fragment.name.value] = fragment;
        });
        return symTable;
    }
    function $e1dfb923a27ca793$export$84c19026e616569e(definition) {
        if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
            var defaultValues = definition.variableDefinitions.filter(function(_a) {
                var defaultValue = _a.defaultValue;
                return defaultValue;
            }).map(function(_a) {
                var variable = _a.variable, defaultValue = _a.defaultValue;
                var defaultValueObj = {};
                $e1dfb923a27ca793$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
                return defaultValueObj;
            });
            return $e1dfb923a27ca793$export$e6e34fd1f2686227.apply(void 0, (0, (0, parcelRequire("3VFsf")).__spreadArrays)([
                {}
            ], defaultValues));
        }
        return {};
    }
    function $e1dfb923a27ca793$export$55ead6c9e4eac970(operation) {
        var names = new Set();
        if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
            var definition = _a[_i];
            names.add(definition.variable.name.value);
        }
        return names;
    }
    function $e1dfb923a27ca793$var$filterInPlace(array, test, context) {
        var target = 0;
        array.forEach(function(elem, i) {
            if (test.call(this, elem, i, array)) array[target++] = elem;
        }, context);
        array.length = target;
        return array;
    }
    var $e1dfb923a27ca793$var$TYPENAME_FIELD = {
        kind: 'Field',
        name: {
            kind: 'Name',
            value: '__typename'
        }
    };
    function $e1dfb923a27ca793$var$isEmpty(op, fragments) {
        return op.selectionSet.selections.every(function(selection) {
            return selection.kind === 'FragmentSpread' && $e1dfb923a27ca793$var$isEmpty(fragments[selection.name.value], fragments);
        });
    }
    function $e1dfb923a27ca793$var$nullIfDocIsEmpty(doc) {
        return $e1dfb923a27ca793$var$isEmpty($e1dfb923a27ca793$export$7a5b1fa979d2c158(doc) || $e1dfb923a27ca793$export$772111caef41b3f5(doc), $e1dfb923a27ca793$export$193789b4c8246dd4($e1dfb923a27ca793$export$5320a7ba9466a3df(doc))) ? null : doc;
    }
    function $e1dfb923a27ca793$var$getDirectiveMatcher(directives) {
        return function directiveMatcher(directive) {
            return directives.some(function(dir) {
                return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
            });
        };
    }
    function $e1dfb923a27ca793$export$e5ae0530da5fe96c(directives, doc) {
        var variablesInUse = Object.create(null);
        var variablesToRemove = [];
        var fragmentSpreadsInUse = Object.create(null);
        var fragmentSpreadsToRemove = [];
        var modifiedDoc = $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, (0, parcelRequire("12QNw")).visit)(doc, {
            Variable: {
                enter: function(node, _key, parent) {
                    if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
                }
            },
            Field: {
                enter: function(node) {
                    if (directives && node.directives) {
                        var shouldRemoveField = directives.some(function(directive) {
                            return directive.remove;
                        });
                        if (shouldRemoveField && node.directives && node.directives.some($e1dfb923a27ca793$var$getDirectiveMatcher(directives))) {
                            if (node.arguments) node.arguments.forEach(function(arg) {
                                if (arg.value.kind === 'Variable') variablesToRemove.push({
                                    name: arg.value.name.value
                                });
                            });
                            if (node.selectionSet) $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                                fragmentSpreadsToRemove.push({
                                    name: frag.name.value
                                });
                            });
                            return null;
                        }
                    }
                }
            },
            FragmentSpread: {
                enter: function(node) {
                    fragmentSpreadsInUse[node.name.value] = true;
                }
            },
            Directive: {
                enter: function(node) {
                    if ($e1dfb923a27ca793$var$getDirectiveMatcher(directives)(node)) return null;
                }
            }
        }));
        if (modifiedDoc && $e1dfb923a27ca793$var$filterInPlace(variablesToRemove, function(v) {
            return !variablesInUse[v.name];
        }).length) modifiedDoc = $e1dfb923a27ca793$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
        if (modifiedDoc && $e1dfb923a27ca793$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
            return !fragmentSpreadsInUse[fs.name];
        }).length) modifiedDoc = $e1dfb923a27ca793$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
        return modifiedDoc;
    }
    function $e1dfb923a27ca793$export$43b332f87950a467(doc) {
        return (0, (0, parcelRequire("12QNw")).visit)($e1dfb923a27ca793$export$a7d0d8111d2386df(doc), {
            SelectionSet: {
                enter: function(node, _key, parent) {
                    if (parent && parent.kind === 'OperationDefinition') return;
                    var selections = node.selections;
                    if (!selections) return;
                    var skip = selections.some(function(selection) {
                        return $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                    });
                    if (skip) return;
                    var field = parent;
                    if ($e1dfb923a27ca793$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                        return d.name.value === 'export';
                    })) return;
                    return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, node), {
                        selections: (0, (0, parcelRequire("3VFsf")).__spreadArrays)(selections, [
                            $e1dfb923a27ca793$var$TYPENAME_FIELD
                        ])
                    });
                }
            }
        });
    }
    var $e1dfb923a27ca793$var$connectionRemoveConfig = {
        test: function(directive) {
            var willRemove = directive.name.value === 'connection';
            if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
                return arg.name.value === 'key';
            });
            return willRemove;
        }
    };
    function $e1dfb923a27ca793$export$74985f3324559867(doc) {
        return $e1dfb923a27ca793$export$e5ae0530da5fe96c([
            $e1dfb923a27ca793$var$connectionRemoveConfig
        ], $e1dfb923a27ca793$export$a7d0d8111d2386df(doc));
    }
    function $e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
        if (nestedCheck === void 0) nestedCheck = true;
        return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
            return $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection, nestedCheck);
        });
    }
    function $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
        if (nestedCheck === void 0) nestedCheck = true;
        if (!$e1dfb923a27ca793$export$fb56ad75dd311c12(selection)) return true;
        if (!selection.directives) return false;
        return selection.directives.some($e1dfb923a27ca793$var$getDirectiveMatcher(directives)) || nestedCheck && $e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
    }
    function $e1dfb923a27ca793$export$deed3420cb5d2e1d(directives, doc) {
        $e1dfb923a27ca793$export$a7d0d8111d2386df(doc);
        var parentPath;
        return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, (0, parcelRequire("12QNw")).visit)(doc, {
            SelectionSet: {
                enter: function(node, _key, _parent, path) {
                    var currentPath = path.join('-');
                    if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                        if (node.selections) {
                            var selectionsWithDirectives = node.selections.filter(function(selection) {
                                return $e1dfb923a27ca793$var$hasDirectivesInSelection(directives, selection);
                            });
                            if ($e1dfb923a27ca793$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, node), {
                                selections: selectionsWithDirectives
                            });
                        } else return null;
                    }
                }
            }
        }));
    }
    function $e1dfb923a27ca793$var$getArgumentMatcher(config) {
        return function argumentMatcher(argument) {
            return config.some(function(aConfig) {
                return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
            });
        };
    }
    function $e1dfb923a27ca793$export$ecd5bb739c4a8b38(config, doc) {
        var argMatcher = $e1dfb923a27ca793$var$getArgumentMatcher(config);
        return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, (0, parcelRequire("12QNw")).visit)(doc, {
            OperationDefinition: {
                enter: function(node) {
                    return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, node), {
                        variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                            return !config.some(function(arg) {
                                return arg.name === varDef.variable.name.value;
                            });
                        })
                    });
                }
            },
            Field: {
                enter: function(node) {
                    var shouldRemoveField = config.some(function(argConfig) {
                        return argConfig.remove;
                    });
                    if (shouldRemoveField) {
                        var argMatchCount_1 = 0;
                        node.arguments.forEach(function(arg) {
                            if (argMatcher(arg)) argMatchCount_1 += 1;
                        });
                        if (argMatchCount_1 === 1) return null;
                    }
                }
            },
            Argument: {
                enter: function(node) {
                    if (argMatcher(node)) return null;
                }
            }
        }));
    }
    function $e1dfb923a27ca793$export$7c9d17c333033c13(config, doc) {
        function enter(node) {
            if (config.some(function(def) {
                return def.name === node.name.value;
            })) return null;
        }
        return $e1dfb923a27ca793$var$nullIfDocIsEmpty((0, (0, parcelRequire("12QNw")).visit)(doc, {
            FragmentSpread: {
                enter: enter
            },
            FragmentDefinition: {
                enter: enter
            }
        }));
    }
    function $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
        var allFragments = [];
        selectionSet.selections.forEach(function(selection) {
            if (($e1dfb923a27ca793$export$fb56ad75dd311c12(selection) || $e1dfb923a27ca793$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $e1dfb923a27ca793$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
                return allFragments.push(frag);
            });
            else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
        });
        return allFragments;
    }
    function $e1dfb923a27ca793$export$57c368c23873f32b(document) {
        var definition = $e1dfb923a27ca793$export$f431198736b7f96d(document);
        var definitionOperation = definition.operation;
        if (definitionOperation === 'query') return document;
        var modifiedDoc = (0, (0, parcelRequire("12QNw")).visit)(document, {
            OperationDefinition: {
                enter: function(node) {
                    return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, node), {
                        operation: 'query'
                    });
                }
            }
        });
        return modifiedDoc;
    }
    function $e1dfb923a27ca793$export$8eae69e876ee321e(document) {
        $e1dfb923a27ca793$export$a7d0d8111d2386df(document);
        var modifiedDoc = $e1dfb923a27ca793$export$e5ae0530da5fe96c([
            {
                test: function(directive) {
                    return directive.name.value === 'client';
                },
                remove: true
            }
        ], document);
        if (modifiedDoc) modifiedDoc = (0, (0, parcelRequire("12QNw")).visit)(modifiedDoc, {
            FragmentDefinition: {
                enter: function(node) {
                    if (node.selectionSet) {
                        var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                            return $e1dfb923a27ca793$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                        });
                        if (isTypenameOnly) return null;
                    }
                }
            }
        });
        return modifiedDoc;
    }
    var $e1dfb923a27ca793$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
    var $e1dfb923a27ca793$var$toString = Object.prototype.toString;
    function $e1dfb923a27ca793$export$629a2bd3f5a49ecc(value) {
        return $e1dfb923a27ca793$var$cloneDeepHelper(value, new Map());
    }
    function $e1dfb923a27ca793$var$cloneDeepHelper(val, seen) {
        switch($e1dfb923a27ca793$var$toString.call(val)){
            case "[object Array]":
                if (seen.has(val)) return seen.get(val);
                var copy_1 = val.slice(0);
                seen.set(val, copy_1);
                copy_1.forEach(function(child, i) {
                    copy_1[i] = $e1dfb923a27ca793$var$cloneDeepHelper(child, seen);
                });
                return copy_1;
            case "[object Object]":
                if (seen.has(val)) return seen.get(val);
                var copy_2 = Object.create(Object.getPrototypeOf(val));
                seen.set(val, copy_2);
                Object.keys(val).forEach(function(key) {
                    copy_2[key] = $e1dfb923a27ca793$var$cloneDeepHelper(val[key], seen);
                });
                return copy_2;
            default:
                return val;
        }
    }
    function $e1dfb923a27ca793$export$4bd44a2aa29d3d6e() {
        if (typeof $6cAn5 !== 'undefined' && "production") return "production";
        return 'development';
    }
    function $e1dfb923a27ca793$export$f0cb0fda19c18b37(env) {
        return $e1dfb923a27ca793$export$4bd44a2aa29d3d6e() === env;
    }
    function $e1dfb923a27ca793$export$f15d00aa73aafac4() {
        return $e1dfb923a27ca793$export$f0cb0fda19c18b37('production') === true;
    }
    function $e1dfb923a27ca793$export$df77466336fe5355() {
        return $e1dfb923a27ca793$export$f0cb0fda19c18b37('development') === true;
    }
    function $e1dfb923a27ca793$export$410cbc2864fa25b5() {
        return $e1dfb923a27ca793$export$f0cb0fda19c18b37('test') === true;
    }
    function $e1dfb923a27ca793$export$50a91acae4904909(f) {
        try {
            return f();
        } catch (e) {
            if (console.error) console.error(e);
        }
    }
    function $e1dfb923a27ca793$export$b4df399e879e53ab(result) {
        return result.errors && result.errors.length;
    }
    function $e1dfb923a27ca793$var$deepFreeze(o) {
        Object.freeze(o);
        Object.getOwnPropertyNames(o).forEach(function(prop) {
            if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $e1dfb923a27ca793$var$deepFreeze(o[prop]);
        });
        return o;
    }
    function $e1dfb923a27ca793$export$7f9c177735b71f18(obj) {
        if ($e1dfb923a27ca793$export$df77466336fe5355() || $e1dfb923a27ca793$export$410cbc2864fa25b5()) {
            var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
            if (!symbolIsPolyfilled) return $e1dfb923a27ca793$var$deepFreeze(obj);
        }
        return obj;
    }
    var $e1dfb923a27ca793$var$hasOwnProperty = Object.prototype.hasOwnProperty;
    function $e1dfb923a27ca793$export$dd702b3c8240390c() {
        var sources = [];
        for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
        return $e1dfb923a27ca793$export$160070228be94b08(sources);
    }
    function $e1dfb923a27ca793$export$160070228be94b08(sources) {
        var target = sources[0] || {};
        var count = sources.length;
        if (count > 1) {
            var pastCopies = [];
            target = $e1dfb923a27ca793$var$shallowCopyForMerge(target, pastCopies);
            for(var i = 1; i < count; ++i)target = $e1dfb923a27ca793$var$mergeHelper(target, sources[i], pastCopies);
        }
        return target;
    }
    function $e1dfb923a27ca793$var$isObject(obj) {
        return obj !== null && typeof obj === 'object';
    }
    function $e1dfb923a27ca793$var$mergeHelper(target, source, pastCopies) {
        if ($e1dfb923a27ca793$var$isObject(source) && $e1dfb923a27ca793$var$isObject(target)) {
            if (Object.isExtensible && !Object.isExtensible(target)) target = $e1dfb923a27ca793$var$shallowCopyForMerge(target, pastCopies);
            Object.keys(source).forEach(function(sourceKey) {
                var sourceValue = source[sourceKey];
                if ($e1dfb923a27ca793$var$hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (sourceValue !== targetValue) target[sourceKey] = $e1dfb923a27ca793$var$mergeHelper($e1dfb923a27ca793$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
                } else target[sourceKey] = sourceValue;
            });
            return target;
        }
        return source;
    }
    function $e1dfb923a27ca793$var$shallowCopyForMerge(value, pastCopies) {
        if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
            if (Array.isArray(value)) value = value.slice(0);
            else value = (0, (0, parcelRequire("3VFsf")).__assign)({
                __proto__: Object.getPrototypeOf(value)
            }, value);
            pastCopies.push(value);
        }
        return value;
    }
    var $e1dfb923a27ca793$var$haveWarned = Object.create({});
    function $e1dfb923a27ca793$export$49d47c8e549bfaf9(msg, type) {
        if (type === void 0) type = 'warn';
        if (!$e1dfb923a27ca793$export$f15d00aa73aafac4() && !$e1dfb923a27ca793$var$haveWarned[msg]) {
            if (!$e1dfb923a27ca793$export$410cbc2864fa25b5()) $e1dfb923a27ca793$var$haveWarned[msg] = true;
            if (type === 'error') console.error(msg);
            else console.warn(msg);
        }
    }
    function $e1dfb923a27ca793$export$c54efeba029d4fe8(data) {
        return JSON.parse(JSON.stringify(data));
    }
});
parcelRegister("1DiV8", function(module, exports) {
    $parcel$export(module.exports, "InvariantError", ()=>$13081c324be1f9ab$export$cea12affaee22fe8);
    $parcel$export(module.exports, "invariant", ()=>$13081c324be1f9ab$export$f5708dca728d7177);
    var $3VFsf;
    var $6cAn5 = parcelRequire("6cAn5");
    var $13081c324be1f9ab$var$genericMessage = "Invariant Violation";
    var $13081c324be1f9ab$var$_a = Object.setPrototypeOf, $13081c324be1f9ab$var$setPrototypeOf = $13081c324be1f9ab$var$_a === void 0 ? function(obj, proto) {
        obj.__proto__ = proto;
        return obj;
    } : $13081c324be1f9ab$var$_a;
    var $13081c324be1f9ab$export$cea12affaee22fe8 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(InvariantError, _super);
        function InvariantError(message) {
            if (message === void 0) message = $13081c324be1f9ab$var$genericMessage;
            var _this = _super.call(this, typeof message === "number" ? $13081c324be1f9ab$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
            _this.framesToPop = 1;
            _this.name = $13081c324be1f9ab$var$genericMessage;
            $13081c324be1f9ab$var$setPrototypeOf(_this, InvariantError.prototype);
            return _this;
        }
        return InvariantError;
    }(Error);
    function $13081c324be1f9ab$export$f5708dca728d7177(condition, message) {
        if (!condition) throw new $13081c324be1f9ab$export$cea12affaee22fe8(message);
    }
    function $13081c324be1f9ab$var$wrapConsoleMethod(method) {
        return function() {
            return console[method].apply(console, arguments);
        };
    }
    (function(invariant) {
        invariant.warn = $13081c324be1f9ab$var$wrapConsoleMethod("warn");
        invariant.error = $13081c324be1f9ab$var$wrapConsoleMethod("error");
    })($13081c324be1f9ab$export$f5708dca728d7177 || ($13081c324be1f9ab$export$f5708dca728d7177 = {}));
    var $13081c324be1f9ab$export$e54fe5b0f43758f7 = {
        env: {}
    };
    if (typeof $6cAn5 === "object") $13081c324be1f9ab$export$e54fe5b0f43758f7 = $6cAn5;
    else try {
        Function("stub", "process = stub")($13081c324be1f9ab$export$e54fe5b0f43758f7);
    } catch (atLeastWeTried) {}
    var $13081c324be1f9ab$var$invariant$1 = $13081c324be1f9ab$export$f5708dca728d7177;
    var $13081c324be1f9ab$export$2e2bcd8739ae039 = $13081c324be1f9ab$var$invariant$1;
});
parcelRegister("fkrBp", function(module, exports) {
    'use strict';
    module.exports = function(data, opts) {
        if (!opts) opts = {};
        if (typeof opts === 'function') opts = {
            cmp: opts
        };
        var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
        var cmp = opts.cmp && function(f) {
            return function(node) {
                return function(a, b) {
                    var aobj = {
                        key: a,
                        value: node[a]
                    };
                    var bobj = {
                        key: b,
                        value: node[b]
                    };
                    return f(aobj, bobj);
                };
            };
        }(opts.cmp);
        var seen = [];
        return function stringify(node) {
            if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
            if (node === undefined) return;
            if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
            if (typeof node !== 'object') return JSON.stringify(node);
            var i, out;
            if (Array.isArray(node)) {
                out = '[';
                for(i = 0; i < node.length; i++){
                    if (i) out += ',';
                    out += stringify(node[i]) || 'null';
                }
                return out + ']';
            }
            if (node === null) return 'null';
            if (seen.indexOf(node) !== -1) {
                if (cycles) return JSON.stringify('__cycle__');
                throw new TypeError('Converting circular structure to JSON');
            }
            var seenIndex = seen.push(node) - 1;
            var keys = Object.keys(node).sort(cmp && cmp(node));
            out = '';
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                var value = stringify(node[key]);
                if (!value) continue;
                if (out) out += ',';
                out += JSON.stringify(key) + ':' + value;
            }
            seen.splice(seenIndex, 1);
            return '{' + out + '}';
        }(data);
    };
});
parcelRegister("bqMzA", function(module, exports) {
    $parcel$export(module.exports, "equal", ()=>$8527cd05038b1b96$export$411ce8e5a71e3069);
    var $8527cd05038b1b96$var$_a = Object.prototype, $8527cd05038b1b96$var$toString = $8527cd05038b1b96$var$_a.toString, $8527cd05038b1b96$var$hasOwnProperty = $8527cd05038b1b96$var$_a.hasOwnProperty;
    var $8527cd05038b1b96$var$previousComparisons = new Map();
    function $8527cd05038b1b96$export$411ce8e5a71e3069(a, b) {
        try {
            return $8527cd05038b1b96$var$check(a, b);
        } finally{
            $8527cd05038b1b96$var$previousComparisons.clear();
        }
    }
    function $8527cd05038b1b96$var$check(a, b) {
        if (a === b) return true;
        var aTag = $8527cd05038b1b96$var$toString.call(a);
        var bTag = $8527cd05038b1b96$var$toString.call(b);
        if (aTag !== bTag) return false;
        switch(aTag){
            case '[object Array]':
                if (a.length !== b.length) return false;
            case '[object Object]':
                if ($8527cd05038b1b96$var$previouslyCompared(a, b)) return true;
                var aKeys = Object.keys(a);
                var bKeys = Object.keys(b);
                var keyCount = aKeys.length;
                if (keyCount !== bKeys.length) return false;
                for(var k = 0; k < keyCount; ++k){
                    if (!$8527cd05038b1b96$var$hasOwnProperty.call(b, aKeys[k])) return false;
                }
                for(var k = 0; k < keyCount; ++k){
                    var key = aKeys[k];
                    if (!$8527cd05038b1b96$var$check(a[key], b[key])) return false;
                }
                return true;
            case '[object Error]':
                return a.name === b.name && a.message === b.message;
            case '[object Number]':
                if (a !== a) return b !== b;
            case '[object Boolean]':
            case '[object Date]':
                return +a === +b;
            case '[object RegExp]':
            case '[object String]':
                return a == "" + b;
            case '[object Map]':
            case '[object Set]':
                if (a.size !== b.size) return false;
                if ($8527cd05038b1b96$var$previouslyCompared(a, b)) return true;
                var aIterator = a.entries();
                var isMap = aTag === '[object Map]';
                while(true){
                    var info = aIterator.next();
                    if (info.done) break;
                    var _a = info.value, aKey = _a[0], aValue = _a[1];
                    if (!b.has(aKey)) return false;
                    if (isMap && !$8527cd05038b1b96$var$check(aValue, b.get(aKey))) return false;
                }
                return true;
        }
        return false;
    }
    function $8527cd05038b1b96$var$previouslyCompared(a, b) {
        var bSet = $8527cd05038b1b96$var$previousComparisons.get(a);
        if (bSet) {
            if (bSet.has(b)) return true;
        } else $8527cd05038b1b96$var$previousComparisons.set(a, bSet = new Set);
        bSet.add(b);
        return false;
    }
    var $8527cd05038b1b96$export$2e2bcd8739ae039 = $8527cd05038b1b96$export$411ce8e5a71e3069;
});
parcelRegister("clSzL", function(module, exports) {
    $parcel$export(module.exports, "makePromise", ()=>makePromise);
    $parcel$export(module.exports, "fromError", ()=>fromError);
    $parcel$export(module.exports, "ApolloLink", ()=>ApolloLink);
    $parcel$export(module.exports, "from", ()=>from);
    $parcel$export(module.exports, "split", ()=>split);
    $parcel$export(module.exports, "execute", ()=>execute);
    $parcel$export(module.exports, "Observable", ()=>(parcelRequire("aS6b9")).default);
    var $aS6b9;
    var $1DiV8 = parcelRequire("1DiV8");
    var $3VFsf;
    var $jojW6;
    function validateOperation(operation) {
        var OPERATION_FIELDS = [
            'query',
            'operationName',
            'variables',
            'extensions',
            'context'
        ];
        for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
            var key = _a[_i];
            if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $1DiV8.InvariantError)(2);
        }
        return operation;
    }
    var LinkError = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(LinkError, _super);
        function LinkError(message, link) {
            var _this = _super.call(this, message) || this;
            _this.link = link;
            return _this;
        }
        return LinkError;
    }(Error);
    function isTerminating(link) {
        return link.request.length <= 1;
    }
    function toPromise(observable) {
        var completed = false;
        return new Promise(function(resolve, reject) {
            observable.subscribe({
                next: function(data) {
                    if (completed) ;
                    else {
                        completed = true;
                        resolve(data);
                    }
                },
                error: reject
            });
        });
    }
    var makePromise = toPromise;
    function fromPromise(promise) {
        return new (0, (0, parcelRequire("aS6b9")).default)(function(observer) {
            promise.then(function(value) {
                observer.next(value);
                observer.complete();
            }).catch(observer.error.bind(observer));
        });
    }
    function fromError(errorValue) {
        return new (0, (0, parcelRequire("aS6b9")).default)(function(observer) {
            observer.error(errorValue);
        });
    }
    function transformOperation(operation) {
        var transformedOperation = {
            variables: operation.variables || {},
            extensions: operation.extensions || {},
            operationName: operation.operationName,
            query: operation.query
        };
        if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, (0, parcelRequire("jojW6")).getOperationName)(transformedOperation.query) : '';
        return transformedOperation;
    }
    function createOperation(starting, operation) {
        var context = (0, (0, parcelRequire("3VFsf")).__assign)({}, starting);
        var setContext = function(next) {
            if (typeof next === 'function') context = (0, (0, parcelRequire("3VFsf")).__assign)({}, context, next(context));
            else context = (0, (0, parcelRequire("3VFsf")).__assign)({}, context, next);
        };
        var getContext = function() {
            return (0, (0, parcelRequire("3VFsf")).__assign)({}, context);
        };
        Object.defineProperty(operation, 'setContext', {
            enumerable: false,
            value: setContext
        });
        Object.defineProperty(operation, 'getContext', {
            enumerable: false,
            value: getContext
        });
        Object.defineProperty(operation, 'toKey', {
            enumerable: false,
            value: function() {
                return getKey(operation);
            }
        });
        return operation;
    }
    function getKey(operation) {
        var query = operation.query, variables = operation.variables, operationName = operation.operationName;
        return JSON.stringify([
            operationName,
            query,
            variables
        ]);
    }
    function passthrough(op, forward) {
        return forward ? forward(op) : (0, (0, parcelRequire("aS6b9")).default).of();
    }
    function toLink(handler) {
        return typeof handler === 'function' ? new ApolloLink(handler) : handler;
    }
    function empty() {
        return new ApolloLink(function() {
            return (0, (0, parcelRequire("aS6b9")).default).of();
        });
    }
    function from(links) {
        if (links.length === 0) return empty();
        return links.map(toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    }
    function split(test, left, right) {
        var leftLink = toLink(left);
        var rightLink = toLink(right || new ApolloLink(passthrough));
        if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, (0, parcelRequire("aS6b9")).default).of() : rightLink.request(operation) || (0, (0, parcelRequire("aS6b9")).default).of();
        });
        else return new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, (0, parcelRequire("aS6b9")).default).of() : rightLink.request(operation, forward) || (0, (0, parcelRequire("aS6b9")).default).of();
        });
    }
    var concat = function(first, second) {
        var firstLink = toLink(first);
        if (isTerminating(firstLink)) return firstLink;
        var nextLink = toLink(second);
        if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, (0, parcelRequire("aS6b9")).default).of();
            }) || (0, (0, parcelRequire("aS6b9")).default).of();
        });
        else return new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, (0, parcelRequire("aS6b9")).default).of();
            }) || (0, (0, parcelRequire("aS6b9")).default).of();
        });
    };
    var ApolloLink = function() {
        function ApolloLink(request) {
            if (request) this.request = request;
        }
        ApolloLink.prototype.split = function(test, left, right) {
            return this.concat(split(test, left, right || new ApolloLink(passthrough)));
        };
        ApolloLink.prototype.concat = function(next) {
            return concat(this, next);
        };
        ApolloLink.prototype.request = function(operation, forward) {
            throw new (0, $1DiV8.InvariantError)(1);
        };
        ApolloLink.empty = empty;
        ApolloLink.from = from;
        ApolloLink.split = split;
        ApolloLink.execute = execute;
        return ApolloLink;
    }();
    function execute(link, operation) {
        return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, (0, parcelRequire("aS6b9")).default).of();
    }
});
parcelRegister("aS6b9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7ea3bd7f736c1eb4$export$2e2bcd8739ae039);
    var $4osjv = parcelRequire("4osjv");
    var $7ea3bd7f736c1eb4$export$77cea355fa80b5f4 = (0, ($parcel$interopDefault($4osjv)));
    var $7ea3bd7f736c1eb4$export$2e2bcd8739ae039 = $7ea3bd7f736c1eb4$export$77cea355fa80b5f4;
});
parcelRegister("4osjv", function(module, exports) {
    module.exports = (parcelRequire("k0hXK")).Observable;
});
parcelRegister("k0hXK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Observable = void 0;
    function $e901bdc1c9a5edd7$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $e901bdc1c9a5edd7$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function $e901bdc1c9a5edd7$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $e901bdc1c9a5edd7$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $e901bdc1c9a5edd7$var$_defineProperties(Constructor, staticProps);
        return Constructor;
    }
    var $e901bdc1c9a5edd7$var$hasSymbols = function() {
        return typeof Symbol === 'function';
    };
    var $e901bdc1c9a5edd7$var$hasSymbol = function(name) {
        return $e901bdc1c9a5edd7$var$hasSymbols() && Boolean(Symbol[name]);
    };
    var $e901bdc1c9a5edd7$var$getSymbol = function(name) {
        return $e901bdc1c9a5edd7$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
    };
    if ($e901bdc1c9a5edd7$var$hasSymbols() && !$e901bdc1c9a5edd7$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
    var $e901bdc1c9a5edd7$var$SymbolIterator = $e901bdc1c9a5edd7$var$getSymbol('iterator');
    var $e901bdc1c9a5edd7$var$SymbolObservable = $e901bdc1c9a5edd7$var$getSymbol('observable');
    var $e901bdc1c9a5edd7$var$SymbolSpecies = $e901bdc1c9a5edd7$var$getSymbol('species');
    function $e901bdc1c9a5edd7$var$getMethod(obj, key) {
        var value = obj[key];
        if (value == null) return undefined;
        if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
        return value;
    }
    function $e901bdc1c9a5edd7$var$getSpecies(obj) {
        var ctor = obj.constructor;
        if (ctor !== undefined) {
            ctor = ctor[$e901bdc1c9a5edd7$var$SymbolSpecies];
            if (ctor === null) ctor = undefined;
        }
        return ctor !== undefined ? ctor : $e901bdc1c9a5edd7$var$Observable;
    }
    function $e901bdc1c9a5edd7$var$isObservable(x) {
        return x instanceof $e901bdc1c9a5edd7$var$Observable;
    }
    function $e901bdc1c9a5edd7$var$hostReportError(e) {
        if ($e901bdc1c9a5edd7$var$hostReportError.log) $e901bdc1c9a5edd7$var$hostReportError.log(e);
        else setTimeout(function() {
            throw e;
        });
    }
    function $e901bdc1c9a5edd7$var$enqueue(fn) {
        Promise.resolve().then(function() {
            try {
                fn();
            } catch (e) {
                $e901bdc1c9a5edd7$var$hostReportError(e);
            }
        });
    }
    function $e901bdc1c9a5edd7$var$cleanupSubscription(subscription) {
        var cleanup = subscription._cleanup;
        if (cleanup === undefined) return;
        subscription._cleanup = undefined;
        if (!cleanup) return;
        try {
            if (typeof cleanup === 'function') cleanup();
            else {
                var unsubscribe = $e901bdc1c9a5edd7$var$getMethod(cleanup, 'unsubscribe');
                if (unsubscribe) unsubscribe.call(cleanup);
            }
        } catch (e) {
            $e901bdc1c9a5edd7$var$hostReportError(e);
        }
    }
    function $e901bdc1c9a5edd7$var$closeSubscription(subscription) {
        subscription._observer = undefined;
        subscription._queue = undefined;
        subscription._state = 'closed';
    }
    function $e901bdc1c9a5edd7$var$flushSubscription(subscription) {
        var queue = subscription._queue;
        if (!queue) return;
        subscription._queue = undefined;
        subscription._state = 'ready';
        for(var i = 0; i < queue.length; ++i){
            $e901bdc1c9a5edd7$var$notifySubscription(subscription, queue[i].type, queue[i].value);
            if (subscription._state === 'closed') break;
        }
    }
    function $e901bdc1c9a5edd7$var$notifySubscription(subscription, type, value) {
        subscription._state = 'running';
        var observer = subscription._observer;
        try {
            var m = $e901bdc1c9a5edd7$var$getMethod(observer, type);
            switch(type){
                case 'next':
                    if (m) m.call(observer, value);
                    break;
                case 'error':
                    $e901bdc1c9a5edd7$var$closeSubscription(subscription);
                    if (m) m.call(observer, value);
                    else throw value;
                    break;
                case 'complete':
                    $e901bdc1c9a5edd7$var$closeSubscription(subscription);
                    if (m) m.call(observer);
                    break;
            }
        } catch (e) {
            $e901bdc1c9a5edd7$var$hostReportError(e);
        }
        if (subscription._state === 'closed') $e901bdc1c9a5edd7$var$cleanupSubscription(subscription);
        else if (subscription._state === 'running') subscription._state = 'ready';
    }
    function $e901bdc1c9a5edd7$var$onNotify(subscription, type, value) {
        if (subscription._state === 'closed') return;
        if (subscription._state === 'buffering') {
            subscription._queue.push({
                type: type,
                value: value
            });
            return;
        }
        if (subscription._state !== 'ready') {
            subscription._state = 'buffering';
            subscription._queue = [
                {
                    type: type,
                    value: value
                }
            ];
            $e901bdc1c9a5edd7$var$enqueue(function() {
                return $e901bdc1c9a5edd7$var$flushSubscription(subscription);
            });
            return;
        }
        $e901bdc1c9a5edd7$var$notifySubscription(subscription, type, value);
    }
    var $e901bdc1c9a5edd7$var$Subscription = function() {
        function Subscription(observer, subscriber) {
            $e901bdc1c9a5edd7$var$_classCallCheck(this, Subscription);
            this._cleanup = undefined;
            this._observer = observer;
            this._queue = undefined;
            this._state = 'initializing';
            var subscriptionObserver = new $e901bdc1c9a5edd7$var$SubscriptionObserver(this);
            try {
                this._cleanup = subscriber.call(undefined, subscriptionObserver);
            } catch (e) {
                subscriptionObserver.error(e);
            }
            if (this._state === 'initializing') this._state = 'ready';
        }
        $e901bdc1c9a5edd7$var$_createClass(Subscription, [
            {
                key: "unsubscribe",
                value: function unsubscribe() {
                    if (this._state !== 'closed') {
                        $e901bdc1c9a5edd7$var$closeSubscription(this);
                        $e901bdc1c9a5edd7$var$cleanupSubscription(this);
                    }
                }
            },
            {
                key: "closed",
                get: function() {
                    return this._state === 'closed';
                }
            }
        ]);
        return Subscription;
    }();
    var $e901bdc1c9a5edd7$var$SubscriptionObserver = function() {
        function SubscriptionObserver(subscription) {
            $e901bdc1c9a5edd7$var$_classCallCheck(this, SubscriptionObserver);
            this._subscription = subscription;
        }
        $e901bdc1c9a5edd7$var$_createClass(SubscriptionObserver, [
            {
                key: "next",
                value: function next(value) {
                    $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'next', value);
                }
            },
            {
                key: "error",
                value: function error(value) {
                    $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'error', value);
                }
            },
            {
                key: "complete",
                value: function complete() {
                    $e901bdc1c9a5edd7$var$onNotify(this._subscription, 'complete');
                }
            },
            {
                key: "closed",
                get: function() {
                    return this._subscription._state === 'closed';
                }
            }
        ]);
        return SubscriptionObserver;
    }();
    var $e901bdc1c9a5edd7$var$Observable = function() {
        function Observable(subscriber) {
            $e901bdc1c9a5edd7$var$_classCallCheck(this, Observable);
            if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
            if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
            this._subscriber = subscriber;
        }
        $e901bdc1c9a5edd7$var$_createClass(Observable, [
            {
                key: "subscribe",
                value: function subscribe(observer) {
                    if (typeof observer !== 'object' || observer === null) observer = {
                        next: observer,
                        error: arguments[1],
                        complete: arguments[2]
                    };
                    return new $e901bdc1c9a5edd7$var$Subscription(observer, this._subscriber);
                }
            },
            {
                key: "forEach",
                value: function forEach(fn) {
                    var _this = this;
                    return new Promise(function(resolve, reject) {
                        if (typeof fn !== 'function') {
                            reject(new TypeError(fn + ' is not a function'));
                            return;
                        }
                        function done() {
                            subscription.unsubscribe();
                            resolve();
                        }
                        var subscription = _this.subscribe({
                            next: function(value) {
                                try {
                                    fn(value, done);
                                } catch (e) {
                                    reject(e);
                                    subscription.unsubscribe();
                                }
                            },
                            error: reject,
                            complete: resolve
                        });
                    });
                }
            },
            {
                key: "map",
                value: function map(fn) {
                    var _this2 = this;
                    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                    var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                    return new C(function(observer) {
                        return _this2.subscribe({
                            next: function(value) {
                                try {
                                    value = fn(value);
                                } catch (e) {
                                    return observer.error(e);
                                }
                                observer.next(value);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                observer.complete();
                            }
                        });
                    });
                }
            },
            {
                key: "filter",
                value: function filter(fn) {
                    var _this3 = this;
                    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                    var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                    return new C(function(observer) {
                        return _this3.subscribe({
                            next: function(value) {
                                try {
                                    if (!fn(value)) return;
                                } catch (e) {
                                    return observer.error(e);
                                }
                                observer.next(value);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                observer.complete();
                            }
                        });
                    });
                }
            },
            {
                key: "reduce",
                value: function reduce(fn) {
                    var _this4 = this;
                    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                    var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                    var hasSeed = arguments.length > 1;
                    var hasValue = false;
                    var seed = arguments[1];
                    var acc = seed;
                    return new C(function(observer) {
                        return _this4.subscribe({
                            next: function(value) {
                                var first = !hasValue;
                                hasValue = true;
                                if (!first || hasSeed) try {
                                    acc = fn(acc, value);
                                } catch (e) {
                                    return observer.error(e);
                                }
                                else acc = value;
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                                observer.next(acc);
                                observer.complete();
                            }
                        });
                    });
                }
            },
            {
                key: "concat",
                value: function concat() {
                    var _this5 = this;
                    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                    var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                    return new C(function(observer) {
                        var subscription;
                        var index = 0;
                        function startNext(next) {
                            subscription = next.subscribe({
                                next: function(v) {
                                    observer.next(v);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    if (index === sources.length) {
                                        subscription = undefined;
                                        observer.complete();
                                    } else startNext(C.from(sources[index++]));
                                }
                            });
                        }
                        startNext(_this5);
                        return function() {
                            if (subscription) {
                                subscription.unsubscribe();
                                subscription = undefined;
                            }
                        };
                    });
                }
            },
            {
                key: "flatMap",
                value: function flatMap(fn) {
                    var _this6 = this;
                    if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                    var C = $e901bdc1c9a5edd7$var$getSpecies(this);
                    return new C(function(observer) {
                        var subscriptions = [];
                        var outer = _this6.subscribe({
                            next: function(value) {
                                if (fn) try {
                                    value = fn(value);
                                } catch (e) {
                                    return observer.error(e);
                                }
                                var inner = C.from(value).subscribe({
                                    next: function(value) {
                                        observer.next(value);
                                    },
                                    error: function(e) {
                                        observer.error(e);
                                    },
                                    complete: function() {
                                        var i = subscriptions.indexOf(inner);
                                        if (i >= 0) subscriptions.splice(i, 1);
                                        completeIfDone();
                                    }
                                });
                                subscriptions.push(inner);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                completeIfDone();
                            }
                        });
                        function completeIfDone() {
                            if (outer.closed && subscriptions.length === 0) observer.complete();
                        }
                        return function() {
                            subscriptions.forEach(function(s) {
                                return s.unsubscribe();
                            });
                            outer.unsubscribe();
                        };
                    });
                }
            },
            {
                key: $e901bdc1c9a5edd7$var$SymbolObservable,
                value: function() {
                    return this;
                }
            }
        ], [
            {
                key: "from",
                value: function from(x) {
                    var C = typeof this === 'function' ? this : Observable;
                    if (x == null) throw new TypeError(x + ' is not an object');
                    var method = $e901bdc1c9a5edd7$var$getMethod(x, $e901bdc1c9a5edd7$var$SymbolObservable);
                    if (method) {
                        var observable = method.call(x);
                        if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                        if ($e901bdc1c9a5edd7$var$isObservable(observable) && observable.constructor === C) return observable;
                        return new C(function(observer) {
                            return observable.subscribe(observer);
                        });
                    }
                    if ($e901bdc1c9a5edd7$var$hasSymbol('iterator')) {
                        method = $e901bdc1c9a5edd7$var$getMethod(x, $e901bdc1c9a5edd7$var$SymbolIterator);
                        if (method) return new C(function(observer) {
                            $e901bdc1c9a5edd7$var$enqueue(function() {
                                if (observer.closed) return;
                                var _iteratorNormalCompletion = true;
                                var _didIteratorError = false;
                                var _iteratorError = undefined;
                                try {
                                    for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _item = _step.value;
                                        observer.next(_item);
                                        if (observer.closed) return;
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                    } finally{
                                        if (_didIteratorError) throw _iteratorError;
                                    }
                                }
                                observer.complete();
                            });
                        });
                    }
                    if (Array.isArray(x)) return new C(function(observer) {
                        $e901bdc1c9a5edd7$var$enqueue(function() {
                            if (observer.closed) return;
                            for(var i = 0; i < x.length; ++i){
                                observer.next(x[i]);
                                if (observer.closed) return;
                            }
                            observer.complete();
                        });
                    });
                    throw new TypeError(x + ' is not observable');
                }
            },
            {
                key: "of",
                value: function of() {
                    for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                    var C = typeof this === 'function' ? this : Observable;
                    return new C(function(observer) {
                        $e901bdc1c9a5edd7$var$enqueue(function() {
                            if (observer.closed) return;
                            for(var i = 0; i < items.length; ++i){
                                observer.next(items[i]);
                                if (observer.closed) return;
                            }
                            observer.complete();
                        });
                    });
                }
            },
            {
                key: $e901bdc1c9a5edd7$var$SymbolSpecies,
                get: function() {
                    return this;
                }
            }
        ]);
        return Observable;
    }();
    module.exports.Observable = $e901bdc1c9a5edd7$var$Observable;
    if ($e901bdc1c9a5edd7$var$hasSymbols()) Object.defineProperty($e901bdc1c9a5edd7$var$Observable, Symbol('extensions'), {
        value: {
            symbol: $e901bdc1c9a5edd7$var$SymbolObservable,
            hostReportError: $e901bdc1c9a5edd7$var$hostReportError
        },
        configurable: true
    });
});
parcelRegister("8UpTw", function(module, exports) {
    $parcel$export(module.exports, "ErrorPage", ()=>$5a72c35b5a5b98e9$export$c120a0e80fd44ca6);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $beRD7;
    const $5a72c35b5a5b98e9$export$c120a0e80fd44ca6 = ({ error: error })=>(0, ($parcel$interopDefault($5uXOq))).createElement($5a72c35b5a5b98e9$var$ErrorWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("beRD7")).JSErrorPageAsync), {
            error: error
        }));
    const $5a72c35b5a5b98e9$var$ErrorWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkvuon _syaz1fxt",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8dXDG", function(module, exports) {
    $parcel$export(module.exports, "useExperienceAbort", ()=>$2df1decadd95b490$export$cc92b7ce453f4403);
    var $5uXOq = parcelRequire("5uXOq");
    var $l9g16;
    const $2df1decadd95b490$export$cc92b7ce453f4403 = ({ experience: experience, attributes: attributes })=>{
        const experienceTracker = (0, (0, parcelRequire("l9g16")).useExperienceContext)();
        const self = (0, $5uXOq.useRef)({
            name: experience,
            attributes: attributes,
            experienceTracker: experienceTracker
        });
        self.current.name = experience;
        self.current.attributes = attributes;
        self.current.experienceTracker = experienceTracker;
        return (0, $5uXOq.useCallback)((reason, extraAttributes = {})=>{
            const { current: current } = self;
            current.experienceTracker.abort({
                name: current.name,
                reason: reason,
                attributes: {
                    ...current.attributes,
                    ...extraAttributes
                }
            });
        }, [
            self
        ]);
    };
});
parcelRegister("bTIks", function(module, exports) {
    $parcel$export(module.exports, "CREATE_OVERVIEW_EXPERIENCE", ()=>$43e56627abfe9003$export$9b5e8e07ff330ef2);
    $parcel$export(module.exports, "EDIT_OVERVIEW_EXPERIENCE", ()=>$43e56627abfe9003$export$a58227116ceb8b81);
    $parcel$export(module.exports, "DELETE_OVERVIEW_EXPERIENCE", ()=>$43e56627abfe9003$export$e17a11e4247a14f7);
    $parcel$export(module.exports, "MODAL_WIDTH", ()=>$43e56627abfe9003$export$3d931b64f46140b3);
    var $gwIPs;
    const $43e56627abfe9003$export$b8b9d90f9e5bd72b = 'jiraBusinessEntityOverview';
    const $43e56627abfe9003$export$9b5e8e07ff330ef2 = {
        experience: 'create-overview',
        packageName: $43e56627abfe9003$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $43e56627abfe9003$export$a58227116ceb8b81 = {
        experience: 'edit-overview',
        packageName: $43e56627abfe9003$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $43e56627abfe9003$export$e17a11e4247a14f7 = {
        experience: 'delete-overview',
        packageName: $43e56627abfe9003$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $43e56627abfe9003$export$d03d4e78ea5b909a = (0, (0, parcelRequire("gwIPs")).gridSize) * 2;
    const $43e56627abfe9003$export$57ee5df6bad94642 = 400;
    const $43e56627abfe9003$export$5785b84269e3e763 = 340;
    const $43e56627abfe9003$export$7c9c92ba6b198ac4 = (0, (0, parcelRequire("gwIPs")).gridSize) * 3;
    const $43e56627abfe9003$export$c4232794452dc6e3 = 480;
    const $43e56627abfe9003$export$3d931b64f46140b3 = $43e56627abfe9003$export$c4232794452dc6e3 + $43e56627abfe9003$export$57ee5df6bad94642 + $43e56627abfe9003$export$7c9c92ba6b198ac4 * 2 + $43e56627abfe9003$export$d03d4e78ea5b909a * 2;
    const $43e56627abfe9003$var$MODAL_DIALOG_MARGIN = 120;
    const $43e56627abfe9003$export$68bc124b0fa13de0 = $43e56627abfe9003$export$3d931b64f46140b3 + $43e56627abfe9003$var$MODAL_DIALOG_MARGIN;
});
parcelRegister("fmp5H", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7Thkj")
    ]).then(()=>parcelRequire('6gB2z'));
});
parcelRegister("N0aCi", function(module, exports) {
    $parcel$export(module.exports, "AsyncMigrationMessage", ()=>$5d4d7ee59ef3aa52$export$93794b6cb00009c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $7EVVm;
    const $5d4d7ee59ef3aa52$var$runtimeProps = {};
    const $5d4d7ee59ef3aa52$var$entryPointParams = {};
    const $5d4d7ee59ef3aa52$export$93794b6cb00009c5 = ()=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("7EVVm")).migrationMessageEntrypoint), $5d4d7ee59ef3aa52$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "overviews-plans-onboarding-migration-message",
            packageName: "jiraBusinessOnboarding",
            entryPointReferenceSubject: entryPointReferenceSubject,
            runtimeProps: $5d4d7ee59ef3aa52$var$runtimeProps
        });
    };
});
parcelRegister("7EVVm", function(module, exports) {
    $parcel$export(module.exports, "migrationMessageEntrypoint", ()=>$7918607ddc510d1a$export$2dea5f3fdc0ae86);
    var $2Ftxm;
    var $ikgNX;
    const $7918607ddc510d1a$export$2dea5f3fdc0ae86 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("d2RL6")).then((module)=>module.MigrationMessage), {
            moduleId: "cb473cb0"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("d2RL6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8GMFE")
    ]).then(()=>parcelRequire('h5qXI'));
});
parcelRegister("gb5lQ", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$3a1993d4527e7f44$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "MENU_ID", ()=>$3a1993d4527e7f44$export$d4cd258d01c03112);
    $parcel$export(module.exports, "SECTION_ID", ()=>$3a1993d4527e7f44$export$501955bd67991a25);
    $parcel$export(module.exports, "REPORTS_ROUTES_SET", ()=>$3a1993d4527e7f44$export$f746f9acd7a66bdb);
    $parcel$export(module.exports, "SETTINGS_ROUTES_SET", ()=>$3a1993d4527e7f44$export$e8d6319ab0eb2a27);
    $parcel$export(module.exports, "ISSUES_ROUTES_SET", ()=>$3a1993d4527e7f44$export$6ca9a18cdf1b5a79);
    $parcel$export(module.exports, "FORGE_ROUTES_SET", ()=>$3a1993d4527e7f44$export$6ad6f0faae6ab404);
    $parcel$export(module.exports, "JIRA_AUTOMATION_ADDON_KEY", ()=>$3a1993d4527e7f44$export$75d31ae45b00712c);
    $parcel$export(module.exports, "LOCATION", ()=>$3a1993d4527e7f44$export$87d0ca22edb7493a);
    $parcel$export(module.exports, "OVERVIEW_MAX_LIMIT", ()=>$3a1993d4527e7f44$export$96f465f51836d3a2);
    var $65Ltd;
    var $gwIPs;
    const $3a1993d4527e7f44$export$b8b9d90f9e5bd72b = 'jira.navigation.sidebar.core';
    const $3a1993d4527e7f44$export$d4cd258d01c03112 = 'project/core';
    const $3a1993d4527e7f44$export$501955bd67991a25 = {
        ISSUES: 'issues',
        REPORTS: 'reports',
        SETTINGS: 'settings',
        ISSUE_TYPES: 'issuetypes'
    };
    const $3a1993d4527e7f44$export$f746f9acd7a66bdb = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_ALL_REPORTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_CONFIG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_AVERAGE_AGE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_CREATED_VS_RESOLVED),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_PIE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_RECENTLY_CREATED),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_RESOLUTION_TIME),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_SINGLE_LEVEL_GROUP_BY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_TIME_SINCE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_TIME_TRACKING_REPORT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_DEVELOPER_WORKLOAD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_VERSION_WORKLOAD),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_REPORTS_WORKLOAD_PIE)
    ]);
    const $3a1993d4527e7f44$export$e8d6319ab0eb2a27 = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CORE_PROFORMA_FORMS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_ISSUE_LAYOUT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_EDIT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_CONFIG),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DATA_CLASSIFICATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_FIELDS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_LAYOUT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_SECURITY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_ISSUE_TYPES),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_NOTIFICATIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_OPSGENIE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PERMISSIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SCREENS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_WORKFLOWS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_PEOPLE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_DEV)
    ]);
    const $3a1993d4527e7f44$export$6ca9a18cdf1b5a79 = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PIN),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_ISSUE_NAVIGATOR_CORE)
    ]);
    const $3a1993d4527e7f44$export$6ad6f0faae6ab404 = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_FORGE_APPS)
    ]);
    const $3a1993d4527e7f44$export$75d31ae45b00712c = 'com.codebarrel.addons.automation';
    const $3a1993d4527e7f44$export$33abecf3eb4ba30b = (0, (0, parcelRequire("gwIPs")).gridSize) * 5;
    const $3a1993d4527e7f44$export$76ca6e18b275dcad = 24;
    const $3a1993d4527e7f44$export$87d0ca22edb7493a = 'jwmNavigationCreateProject';
    const $3a1993d4527e7f44$export$96f465f51836d3a2 = 10;
});
parcelRegister("iuAuR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eeba495724dfd3ed$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $eeba495724dfd3ed$var$SectionHeader = ({ children: children, title: title })=>(0, ($parcel$interopDefault($5uXOq))).createElement($eeba495724dfd3ed$export$960a49cc3d27a090, null, (0, ($parcel$interopDefault($5uXOq))).createElement($eeba495724dfd3ed$export$8b251419efc915eb, null, title), children);
    var $eeba495724dfd3ed$export$2e2bcd8739ae039 = $eeba495724dfd3ed$var$SectionHeader;
    const $eeba495724dfd3ed$export$960a49cc3d27a090 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4zamj _1e0c1txw _1bah1yb4 _zulpu2gc _4cvr1h6o _1tke1tcg _vchhusvi",
                __cmplp.className
            ])
        });
    });
    const $eeba495724dfd3ed$export$8b251419efc915eb = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1kw7 _19pkidpf _11c81bk4",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6hYaZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c7b20fc56e6a13a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lm9d2;
    var $koVbs;
    var $3MXKI;
    var $8ltGH;
    var $9rljV;
    const $5c7b20fc56e6a13a$var$CREATE_BUTTON_TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.overviews.create-overview';
    const $5c7b20fc56e6a13a$var$CreateOverview = ({ onClick: onClick, hasReachedLimit: hasReachedLimit })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [isWarningOpen, setIsWarningOpen] = (0, $5uXOq.useState)(false);
        if (hasReachedLimit) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lm9d2")).default), {
            placement: "bottom-start",
            isOpen: isWarningOpen,
            onClose: ()=>setIsWarningOpen(false),
            trigger: ({ ref: ref, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3MXKI")).default), {
                    ...triggerProps,
                    onClick: ()=>setIsWarningOpen((isOpen)=>!isOpen),
                    label: formatMessage((0, (0, parcelRequire("8ltGH")).default).createOverviewLabel),
                    testId: $5c7b20fc56e6a13a$var$CREATE_BUTTON_TEST_ID,
                    ref: ref
                }),
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9rljV")).default), null)
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3MXKI")).default), {
            onClick: onClick,
            label: formatMessage((0, (0, parcelRequire("8ltGH")).default).createOverviewLabel),
            testId: $5c7b20fc56e6a13a$var$CREATE_BUTTON_TEST_ID
        });
    };
    var $5c7b20fc56e6a13a$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($5c7b20fc56e6a13a$var$CreateOverview);
});
parcelRegister("3MXKI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cdc099922ed453c2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $e0OK7;
    var $jY1Ee;
    var $3XLJP;
    var $MGmIU;
    var $dCm1o;
    var $fQ7LC;
    const $cdc099922ed453c2$var$RoundCreateButton = (0, $5uXOq.forwardRef)(({ label: label, onClick: onClick, testId: testId, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("MGmIU")).default), {
            content: label,
            hideTooltipOnClick: true
        }, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0OK7")).default), {
            testId: testId,
            onClick: onClick,
            spacing: "compact",
            appearance: "default",
            shape: "circle",
            label: label,
            icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("3XLJP"))))), {
                    label: "",
                    color: "var(--ds-text, #172B4D)"
                })
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fQ7LC")).StyledButton), {
            ...props,
            ref: ref,
            testId: testId,
            spacing: "compact",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jY1Ee"))))), {
                label: label,
                primaryColor: "var(--ds-text, #172B4D)",
                size: "small"
            }),
            onClick: onClick
        })));
    var $cdc099922ed453c2$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($cdc099922ed453c2$var$RoundCreateButton);
});
parcelRegister("3XLJP", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $2e2be9966957eca0$var$_react = $2e2be9966957eca0$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $2e2be9966957eca0$var$_UNSAFE_baseNew = $2e2be9966957eca0$var$_interopRequireDefault((parcelRequire("huIZN")));
    function $2e2be9966957eca0$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $2e2be9966957eca0$var$AddIcon = (props)=>$2e2be9966957eca0$var$_react.default.createElement($2e2be9966957eca0$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M6 6h5M6 6H1m5 0V1m0 5v5"/>`,
            type: 'utility'
        }, props));
    $2e2be9966957eca0$var$AddIcon.displayName = 'AddIcon';
    var $2e2be9966957eca0$var$_default = module.exports.default = $2e2be9966957eca0$var$AddIcon;
});
parcelRegister("fQ7LC", function(module, exports) {
    $parcel$export(module.exports, "StyledButton", ()=>$fe56d18bd5b0d04a$export$2d5d2ba3c7c8c40b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $89thI;
    const $fe56d18bd5b0d04a$export$2d5d2ba3c7c8c40b = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("89thI")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1njd _1pbykb7n",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8ltGH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5eb84096f9d3de7a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5eb84096f9d3de7a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createOverviewLabel: {
            "id": "spa-apps-sidebar-core.multi-project-menu.overviews.create-overview.create-overview-label",
            "defaultMessage": "Create overview"
        }
    });
});
parcelRegister("9rljV", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$724e26e8635dbe63$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dyTTI;
    var $1m92z;
    var $koVbs;
    var $gb5lQ;
    var $6h1VX;
    const $724e26e8635dbe63$var$OverviewLimitPopup = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($724e26e8635dbe63$export$e6dfd72ab29f8598, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dyTTI"))))), {
            label: "",
            color: "var(--ds-icon-warning, #ffab00)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1m92z")).default), null, formatMessage((0, (0, parcelRequire("6h1VX")).default).overviewLimitReached, {
            overviewMaxLimit: (0, (0, parcelRequire("gb5lQ")).OVERVIEW_MAX_LIMIT)
        })));
    };
    var $724e26e8635dbe63$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($724e26e8635dbe63$var$OverviewLimitPopup);
    const $724e26e8635dbe63$export$e6dfd72ab29f8598 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _zulpu2gc _1yt44ar7",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6h1VX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a804cbdeb9da3577$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a804cbdeb9da3577$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        overviewLimitReached: {
            "id": "spa-apps-sidebar-core.multi-project-menu.overviews.create-overview.overview-limit-popup.overview-limit-reached",
            "defaultMessage": "You've reached the limit of {overviewMaxLimit, plural, one {# overview} other {# overviews}}"
        }
    });
});
parcelRegister("2kAEg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$882af03f312c51f3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $882af03f312c51f3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createOverview: {
            "id": "spa-apps-sidebar-core.multi-project-menu.overviews.create-overview",
            "defaultMessage": "Create an overview"
        },
        overviewsHeader: {
            "id": "spa-apps-sidebar-core.multi-project-menu.overviews.overviews-header",
            "defaultMessage": "Overviews"
        },
        errorMessage: {
            "id": "spa-apps-sidebar-core.multi-project-menu.overviews.error-message",
            "defaultMessage": "We couldn't load overviews"
        },
        refreshPage: {
            "id": "spa-apps-sidebar-core.multi-project-menu.overviews.refresh-page",
            "defaultMessage": "Refresh page"
        }
    });
});
parcelRegister("imgTm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5a3e3fe210dbf9b0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $5TTho;
    var $8zOmE;
    var $95EVP;
    var $eEqSc;
    var $e1jn1;
    var $jzhSN;
    const $5a3e3fe210dbf9b0$var$OverviewLink = ({ overview: overview, to: to, isActive: isActive = false })=>{
        const { name: name, theme: theme } = overview;
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jzhSN")).default), {
            to: to,
            isActive: isActive,
            prefetch: "hover",
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'overviewLink')
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5a3e3fe210dbf9b0$export$399e54fcdf2a48ec, {
            size: "small",
            themeName: theme
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e1jn1")).default), null, name));
        return isActive ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eEqSc")).default), null, content) : content;
    };
    var $5a3e3fe210dbf9b0$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($5a3e3fe210dbf9b0$var$OverviewLink);
    const $5a3e3fe210dbf9b0$export$399e54fcdf2a48ec = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("5TTho")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwx1crf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("5TTho", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3ece6799ec0a6037$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cx0MQ;
    var $6cG4N;
    var $52Mvi;
    const $3ece6799ec0a6037$var$OverviewIcon = ({ size: size = 'medium', className: className, themeName: themeName })=>{
        const theme = themeName ?? (0, (0, parcelRequire("6cG4N")).DEFAULT_BACKGROUND_CONFIG).name;
        const Wrapper = (0, (0, parcelRequire("52Mvi")).WRAPPER)[size][theme];
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Wrapper, {
            className: className,
            "data-testid": "business-entity-overview.common.ui.overview-icon"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("cx0MQ"))))), {
            label: "",
            LEGACY_size: size,
            color: "currentColor"
        }));
    };
    var $3ece6799ec0a6037$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($3ece6799ec0a6037$var$OverviewIcon);
});
parcelRegister("cx0MQ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $91f92d53fce0d9df$var$_react = $91f92d53fce0d9df$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $91f92d53fce0d9df$var$_globe = $91f92d53fce0d9df$var$_interopRequireDefault((parcelRequire("oNPTN")));
    var $91f92d53fce0d9df$var$_world = $91f92d53fce0d9df$var$_interopRequireDefault((parcelRequire("aMBiU")));
    function $91f92d53fce0d9df$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $91f92d53fce0d9df$var$GlobeIcon = (props)=>$91f92d53fce0d9df$var$_react.default.createElement($91f92d53fce0d9df$var$_globe.default, Object.assign({
            LEGACY_fallbackIcon: $91f92d53fce0d9df$var$_world.default
        }, props));
    $91f92d53fce0d9df$var$GlobeIcon.Name = 'GlobeIconMigration';
    var $91f92d53fce0d9df$var$_default = module.exports.default = $91f92d53fce0d9df$var$GlobeIcon;
});
parcelRegister("oNPTN", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $04a8e669bf87bdba$var$_react = $04a8e669bf87bdba$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $04a8e669bf87bdba$var$_UNSAFE_baseNew = $04a8e669bf87bdba$var$_interopRequireDefault((parcelRequire("huIZN")));
    function $04a8e669bf87bdba$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $04a8e669bf87bdba$var$GlobeIcon = (props)=>$04a8e669bf87bdba$var$_react.default.createElement($04a8e669bf87bdba$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 8A7.25 7.25 0 0 1 8 15.25M15.25 8A7.25 7.25 0 0 0 8 .75M15.25 8H.75M8 15.25A7.25 7.25 0 0 1 .75 8M8 15.25c1.657 0 3-3.246 3-7.25S9.657.75 8 .75m0 14.5c-1.657 0-3-3.246-3-7.25S6.343.75 8 .75M.75 8A7.25 7.25 0 0 1 8 .75"/>`
        }, props));
    $04a8e669bf87bdba$var$GlobeIcon.displayName = 'GlobeIcon';
    var $04a8e669bf87bdba$var$_default = module.exports.default = $04a8e669bf87bdba$var$GlobeIcon;
});
parcelRegister("aMBiU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7d9b52dd43b65f4e$var$_react = $7d9b52dd43b65f4e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $kfAhl;
    var $7d9b52dd43b65f4e$var$_globe = $7d9b52dd43b65f4e$var$_interopRequireDefault((parcelRequire("oNPTN")));
    function $7d9b52dd43b65f4e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7d9b52dd43b65f4e$var$WorldIcon = (props)=>$7d9b52dd43b65f4e$var$_react.default.createElement((0, parcelRequire("kfAhl")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18m-.9-1.863A7.19 7.19 0 0 1 4.8 12c0-.558.072-1.089.189-1.611L9.3 14.7v.9c0 .99.81 1.8 1.8 1.8zm6.21-2.286A1.79 1.79 0 0 0 15.6 15.6h-.9v-2.7c0-.495-.405-.9-.9-.9H8.4v-1.8h1.8c.495 0 .9-.405.9-.9V7.5h1.8c.99 0 1.8-.81 1.8-1.8v-.369c2.637 1.071 4.5 3.654 4.5 6.669 0 1.872-.72 3.573-1.89 4.851"/></svg>`
        }, props, {
            newIcon: $7d9b52dd43b65f4e$var$_globe.default
        }));
    $7d9b52dd43b65f4e$var$WorldIcon.displayName = 'WorldIcon';
    var $7d9b52dd43b65f4e$var$_default = module.exports.default = $7d9b52dd43b65f4e$var$WorldIcon;
});
parcelRegister("52Mvi", function(module, exports) {
    $parcel$export(module.exports, "WRAPPER", ()=>$02db9db1e823edfb$export$20b8431be300f03e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $gwIPs;
    const $02db9db1e823edfb$var$iconWrapperStyles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizing: 'border-box',
        borderRadius: `${(0, (0, parcelRequire("gwIPs")).borderRadius)}px`,
        border: `1px solid ${`var(--ds-border, ${(0, $5e0c0d4e15efb4a6$exports).N20A})`}`
    };
    const $02db9db1e823edfb$var$smallIconWrapperStyles = {
        ...$02db9db1e823edfb$var$iconWrapperStyles,
        width: '24px',
        height: '24px'
    };
    const $02db9db1e823edfb$var$mediumIconWrapperStyles = {
        ...$02db9db1e823edfb$var$iconWrapperStyles,
        width: '32px',
        height: '32px'
    };
    const $02db9db1e823edfb$var$WhiteSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1d6j _bfhk4zhb",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightPurpleSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazhbpo _bfhk63rr",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightBlueSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazynhg _bfhk1mdm",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightTealSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazig9t _bfhk16io",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightGreenSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz15qz _bfhkuuj7",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightLimeSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazz2ec _bfhktde4",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightYellowSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz13jf _bfhk1v42",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightRedSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz58wa _bfhkr8k0",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightMagentaSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz5ct2 _bfhku2x1",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightOrangeSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazmfbj _bfhkdpo0",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$DarkSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1d6j _bfhk4zhb",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$PurpleSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz63rr _bfhkhbpo",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$BlueSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1mdm _bfhkynhg",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$TealSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz16io _bfhkig9t",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$GreenSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazuuj7 _bfhk15qz",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LimeSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaztde4 _bfhkz2ec",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$YellowSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syaz1v42 _bfhk13jf",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$RedSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazr8k0 _bfhk58wa",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$MagentaSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazu2x1 _bfhk5ct2",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$OrangeSmallIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsb1tcg _4t3i1tcg _syazdpo0 _bfhkmfbj",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$WhiteMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1d6j _bfhk4zhb",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightPurpleMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazhbpo _bfhk63rr",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightBlueMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazynhg _bfhk1mdm",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightTealMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazig9t _bfhk16io",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightGreenMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz15qz _bfhkuuj7",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightLimeMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazz2ec _bfhktde4",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightYellowMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz13jf _bfhk1v42",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightRedMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz58wa _bfhkr8k0",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightMagentaMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz5ct2 _bfhku2x1",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LightOrangeMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazmfbj _bfhkdpo0",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$DarkMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1d6j _bfhk4zhb",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$PurpleMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz63rr _bfhkhbpo",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$BlueMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1mdm _bfhkynhg",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$TealMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz16io _bfhkig9t",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$GreenMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazuuj7 _bfhk15qz",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$LimeMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaztde4 _bfhkz2ec",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$YellowMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syaz1v42 _bfhk13jf",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$RedMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazr8k0 _bfhk58wa",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$MagentaMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazu2x1 _bfhk5ct2",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$var$OrangeMediumIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _2rko1l7b _19it1l5u _1bsbzwfg _4t3izwfg _syazdpo0 _bfhkmfbj",
                __cmplp.className
            ])
        });
    });
    const $02db9db1e823edfb$export$20b8431be300f03e = {
        small: {
            white: $02db9db1e823edfb$var$WhiteSmallIconWrapper,
            'light-purple': $02db9db1e823edfb$var$LightPurpleSmallIconWrapper,
            'light-blue': $02db9db1e823edfb$var$LightBlueSmallIconWrapper,
            'light-teal': $02db9db1e823edfb$var$LightTealSmallIconWrapper,
            'light-green': $02db9db1e823edfb$var$LightGreenSmallIconWrapper,
            'light-yellow': $02db9db1e823edfb$var$LightYellowSmallIconWrapper,
            'light-red': $02db9db1e823edfb$var$LightRedSmallIconWrapper,
            'light-magenta': $02db9db1e823edfb$var$LightMagentaSmallIconWrapper,
            'light-orange': $02db9db1e823edfb$var$LightOrangeSmallIconWrapper,
            dark: $02db9db1e823edfb$var$DarkSmallIconWrapper,
            purple: $02db9db1e823edfb$var$PurpleSmallIconWrapper,
            blue: $02db9db1e823edfb$var$BlueSmallIconWrapper,
            teal: $02db9db1e823edfb$var$TealSmallIconWrapper,
            green: $02db9db1e823edfb$var$GreenSmallIconWrapper,
            yellow: $02db9db1e823edfb$var$YellowSmallIconWrapper,
            red: $02db9db1e823edfb$var$RedSmallIconWrapper,
            magenta: $02db9db1e823edfb$var$MagentaSmallIconWrapper,
            orange: $02db9db1e823edfb$var$OrangeSmallIconWrapper,
            'lightest-gray': $02db9db1e823edfb$var$WhiteSmallIconWrapper,
            'lightest-purple': $02db9db1e823edfb$var$LightPurpleSmallIconWrapper,
            'lightest-blue': $02db9db1e823edfb$var$LightBlueSmallIconWrapper,
            'lightest-teal': $02db9db1e823edfb$var$LightTealSmallIconWrapper,
            'lightest-green': $02db9db1e823edfb$var$LightGreenSmallIconWrapper,
            'lightest-lime': $02db9db1e823edfb$var$LightLimeSmallIconWrapper,
            'lightest-yellow': $02db9db1e823edfb$var$LightYellowSmallIconWrapper,
            'lightest-orange': $02db9db1e823edfb$var$LightOrangeSmallIconWrapper,
            'lightest-red': $02db9db1e823edfb$var$LightRedSmallIconWrapper,
            'lightest-magenta': $02db9db1e823edfb$var$LightMagentaSmallIconWrapper,
            'lighter-gray': $02db9db1e823edfb$var$WhiteSmallIconWrapper,
            'lighter-purple': $02db9db1e823edfb$var$LightPurpleSmallIconWrapper,
            'lighter-blue': $02db9db1e823edfb$var$LightBlueSmallIconWrapper,
            'lighter-teal': $02db9db1e823edfb$var$LightTealSmallIconWrapper,
            'lighter-green': $02db9db1e823edfb$var$LightGreenSmallIconWrapper,
            'lighter-lime': $02db9db1e823edfb$var$LightLimeSmallIconWrapper,
            'lighter-yellow': $02db9db1e823edfb$var$LightYellowSmallIconWrapper,
            'lighter-orange': $02db9db1e823edfb$var$LightOrangeSmallIconWrapper,
            'lighter-red': $02db9db1e823edfb$var$LightRedSmallIconWrapper,
            'lighter-magenta': $02db9db1e823edfb$var$LightMagentaSmallIconWrapper,
            'darker-gray': $02db9db1e823edfb$var$DarkSmallIconWrapper,
            'darker-purple': $02db9db1e823edfb$var$PurpleSmallIconWrapper,
            'darker-blue': $02db9db1e823edfb$var$BlueSmallIconWrapper,
            'darker-teal': $02db9db1e823edfb$var$TealSmallIconWrapper,
            'darker-green': $02db9db1e823edfb$var$GreenSmallIconWrapper,
            'darker-lime': $02db9db1e823edfb$var$LimeSmallIconWrapper,
            'darker-yellow': $02db9db1e823edfb$var$YellowSmallIconWrapper,
            'darker-orange': $02db9db1e823edfb$var$OrangeSmallIconWrapper,
            'darker-red': $02db9db1e823edfb$var$RedSmallIconWrapper,
            'darker-magenta': $02db9db1e823edfb$var$MagentaSmallIconWrapper,
            'darkest-gray': $02db9db1e823edfb$var$DarkSmallIconWrapper,
            'darkest-purple': $02db9db1e823edfb$var$PurpleSmallIconWrapper,
            'darkest-blue': $02db9db1e823edfb$var$BlueSmallIconWrapper,
            'darkest-teal': $02db9db1e823edfb$var$TealSmallIconWrapper,
            'darkest-green': $02db9db1e823edfb$var$GreenSmallIconWrapper,
            'darkest-lime': $02db9db1e823edfb$var$LimeSmallIconWrapper,
            'darkest-yellow': $02db9db1e823edfb$var$YellowSmallIconWrapper,
            'darkest-orange': $02db9db1e823edfb$var$OrangeSmallIconWrapper,
            'darkest-red': $02db9db1e823edfb$var$RedSmallIconWrapper,
            'darkest-magenta': $02db9db1e823edfb$var$MagentaSmallIconWrapper,
            'no-background': $02db9db1e823edfb$var$WhiteSmallIconWrapper
        },
        medium: {
            white: $02db9db1e823edfb$var$WhiteMediumIconWrapper,
            'light-purple': $02db9db1e823edfb$var$LightPurpleMediumIconWrapper,
            'light-blue': $02db9db1e823edfb$var$LightBlueMediumIconWrapper,
            'light-teal': $02db9db1e823edfb$var$LightTealMediumIconWrapper,
            'light-green': $02db9db1e823edfb$var$LightGreenMediumIconWrapper,
            'light-yellow': $02db9db1e823edfb$var$LightYellowMediumIconWrapper,
            'light-red': $02db9db1e823edfb$var$LightRedMediumIconWrapper,
            'light-magenta': $02db9db1e823edfb$var$LightMagentaMediumIconWrapper,
            'light-orange': $02db9db1e823edfb$var$LightOrangeMediumIconWrapper,
            dark: $02db9db1e823edfb$var$DarkMediumIconWrapper,
            purple: $02db9db1e823edfb$var$PurpleMediumIconWrapper,
            blue: $02db9db1e823edfb$var$BlueMediumIconWrapper,
            teal: $02db9db1e823edfb$var$TealMediumIconWrapper,
            green: $02db9db1e823edfb$var$GreenMediumIconWrapper,
            yellow: $02db9db1e823edfb$var$YellowMediumIconWrapper,
            red: $02db9db1e823edfb$var$RedMediumIconWrapper,
            magenta: $02db9db1e823edfb$var$MagentaMediumIconWrapper,
            orange: $02db9db1e823edfb$var$OrangeMediumIconWrapper,
            'lightest-gray': $02db9db1e823edfb$var$WhiteMediumIconWrapper,
            'lightest-purple': $02db9db1e823edfb$var$LightPurpleMediumIconWrapper,
            'lightest-blue': $02db9db1e823edfb$var$LightBlueMediumIconWrapper,
            'lightest-teal': $02db9db1e823edfb$var$LightTealMediumIconWrapper,
            'lightest-green': $02db9db1e823edfb$var$LightGreenMediumIconWrapper,
            'lightest-lime': $02db9db1e823edfb$var$LightLimeMediumIconWrapper,
            'lightest-yellow': $02db9db1e823edfb$var$LightYellowMediumIconWrapper,
            'lightest-orange': $02db9db1e823edfb$var$LightOrangeMediumIconWrapper,
            'lightest-red': $02db9db1e823edfb$var$LightRedMediumIconWrapper,
            'lightest-magenta': $02db9db1e823edfb$var$LightMagentaMediumIconWrapper,
            'lighter-gray': $02db9db1e823edfb$var$WhiteMediumIconWrapper,
            'lighter-purple': $02db9db1e823edfb$var$LightPurpleMediumIconWrapper,
            'lighter-blue': $02db9db1e823edfb$var$LightBlueMediumIconWrapper,
            'lighter-teal': $02db9db1e823edfb$var$LightTealMediumIconWrapper,
            'lighter-green': $02db9db1e823edfb$var$LightGreenMediumIconWrapper,
            'lighter-lime': $02db9db1e823edfb$var$LightLimeMediumIconWrapper,
            'lighter-yellow': $02db9db1e823edfb$var$LightYellowMediumIconWrapper,
            'lighter-orange': $02db9db1e823edfb$var$LightOrangeMediumIconWrapper,
            'lighter-red': $02db9db1e823edfb$var$LightRedMediumIconWrapper,
            'lighter-magenta': $02db9db1e823edfb$var$LightMagentaMediumIconWrapper,
            'darker-gray': $02db9db1e823edfb$var$DarkMediumIconWrapper,
            'darker-purple': $02db9db1e823edfb$var$PurpleMediumIconWrapper,
            'darker-blue': $02db9db1e823edfb$var$BlueMediumIconWrapper,
            'darker-teal': $02db9db1e823edfb$var$TealMediumIconWrapper,
            'darker-green': $02db9db1e823edfb$var$GreenMediumIconWrapper,
            'darker-lime': $02db9db1e823edfb$var$LimeMediumIconWrapper,
            'darker-yellow': $02db9db1e823edfb$var$YellowMediumIconWrapper,
            'darker-orange': $02db9db1e823edfb$var$OrangeMediumIconWrapper,
            'darker-red': $02db9db1e823edfb$var$RedMediumIconWrapper,
            'darker-magenta': $02db9db1e823edfb$var$MagentaMediumIconWrapper,
            'darkest-gray': $02db9db1e823edfb$var$DarkMediumIconWrapper,
            'darkest-purple': $02db9db1e823edfb$var$PurpleMediumIconWrapper,
            'darkest-blue': $02db9db1e823edfb$var$BlueMediumIconWrapper,
            'darkest-teal': $02db9db1e823edfb$var$TealMediumIconWrapper,
            'darkest-green': $02db9db1e823edfb$var$GreenMediumIconWrapper,
            'darkest-lime': $02db9db1e823edfb$var$LimeMediumIconWrapper,
            'darkest-yellow': $02db9db1e823edfb$var$YellowMediumIconWrapper,
            'darkest-orange': $02db9db1e823edfb$var$OrangeMediumIconWrapper,
            'darkest-red': $02db9db1e823edfb$var$RedMediumIconWrapper,
            'darkest-magenta': $02db9db1e823edfb$var$MagentaMediumIconWrapper,
            'no-background': $02db9db1e823edfb$var$WhiteMediumIconWrapper
        }
    };
});
parcelRegister("eEqSc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eade14dd496994be$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $eade14dd496994be$var$ActiveItem = ({ children: children, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement($eade14dd496994be$var$ActiveItemWrapper, {
            "data-testid": testId
        }, children);
    const $eade14dd496994be$var$ActiveItemWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2rko1sit _bfhkiw92",
                __cmplp.className
            ])
        });
    });
    var $eade14dd496994be$export$2e2bcd8739ae039 = $eade14dd496994be$var$ActiveItem;
});
parcelRegister("e1jn1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a1030b7620e8fb1d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $a1030b7620e8fb1d$var$LinkLabel = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1e5h _1e0c1ule _o5721q9c _1reo15vq _18m915vq _1bto1l2s _k48p1wq8 _16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.className
            ])
        });
    });
    var $a1030b7620e8fb1d$export$2e2bcd8739ae039 = $a1030b7620e8fb1d$var$LinkLabel;
});
parcelRegister("jzhSN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90049e6de285b9de$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $dIdda = parcelRequire("dIdda");
    const $90049e6de285b9de$var$SidebarLink = ({ children: children, elemAfter: elemAfter, className: className, testId: testId, isActive: isActive = false, ...other })=>(0, ($parcel$interopDefault($5uXOq))).createElement($90049e6de285b9de$var$Wrapper, {
            isActive: isActive,
            className: className,
            "data-testid": testId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($90049e6de285b9de$var$StyledLink, {
            "aria-current": isActive ? 'page' : undefined,
            ...other
        }, children), elemAfter && (0, ($parcel$interopDefault($5uXOq))).createElement($90049e6de285b9de$var$ElementAfterWrapper, {
            "data-component-selector": "sidebar-link-elem-after"
        }, elemAfter));
    const $90049e6de285b9de$var$showElementAfter = {
        width: 'inherit !important',
        opacity: 1
    };
    const $90049e6de285b9de$var$ElementAfterWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlidpf _1o9zidpf _i0dl1wug _1bsbgrf3 _tzy4idpf _2hwxu2gc _195pjdj5 _1mygkb7n",
                __cmplp.className
            ])
        });
    });
    const $90049e6de285b9de$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isActive: isActive, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1b30gsy": (0, (0, parcelRequire("lD23V")).default)(!__cmplp.isActive && `var(--ds-background-neutral, ${(0, $5e0c0d4e15efb4a6$exports).N20A})`),
                "--_dpi1qg": (0, (0, parcelRequire("lD23V")).default)(!__cmplp.isActive && `var(--ds-background-neutral, ${(0, $5e0c0d4e15efb4a6$exports).N20A})`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _2rko1sit _4t3i1ylp _v5649dqc _1bqoyh40 _rhjqnqa1 _boy0v77o _i9oi194a _ylp5tjc1 _irr3tjc1 _7gg8jdj5 _7ih6kb7n _gnguyh40 _1bv6nqa1 _ygb3v77o _1qtp194a _sbojjewh",
                __cmplp.className
            ])
        });
    });
    const $90049e6de285b9de$var$StyledLink = (0, $5uXOq.forwardRef)(({ as: C = (0, $dIdda.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _1yt4u2gc _1e0c1txw _4cvr1h6o _syazjjyb _1q5t1r31 _nt751r31 _mizu1r31 _1dit1r31 _1ohyglyw _49pcglyw _ra3xglyw _ksodglyw _1r9x1o36 _1hvw1o36 _128m1o36 _4hz81o36 _180dglyw _7ehiglyw _1ejjglyw _1dbzglyw _1nrm18uv _1a3b18uv _vjfr18uv _9oik18uv _c2waglyw _4fprglyw _10xfglyw _1bnxglyw _1iohnqa1 _5goinqa1 _1w0vnqa1 _jf4cnqa1 _9h8h1fxt _f8pj1fxt _v0vw1fxt _30l31fxt",
                __cmplp.className
            ])
        });
    });
    var $90049e6de285b9de$export$2e2bcd8739ae039 = $90049e6de285b9de$var$SidebarLink;
});
parcelRegister("6KeQr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7979212ccba7a92c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $89thI;
    var $eSI7k;
    var $dWvae;
    var $koVbs;
    var $8zOmE;
    var $95EVP;
    var $dCm1o;
    var $1zqLm;
    var $hVL5W;
    var $1tFZj;
    var $cUsQ8;
    const $7979212ccba7a92c$var$PROJECT_LINK_TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.project-link';
    const $7979212ccba7a92c$var$getDefaultProjectUrl = (project)=>project.defaultView ? `/jira/core/projects/${project.key}/${project.defaultView}` : `/jira/core/projects/${project.key}`;
    const $7979212ccba7a92c$var$ProjectGroup = ({ sectionId: sectionId, projects: projects, onFavoriteToggle: onFavoriteToggle, currentProjectKey: currentProjectKey, showViewAllProjects: showViewAllProjects = false, viewAllProjectsLabel: viewAllProjectsLabel })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        const title = sectionId === 'starred' ? formatMessage((0, (0, parcelRequire("1tFZj")).default).favorites) : formatMessage((0, (0, parcelRequire("1tFZj")).default).recents);
        const [isExpanded, setIsExpanded] = (0, $5uXOq.useState)(true);
        const onToggleExpand = (0, $5uXOq.useCallback)(()=>{
            setIsExpanded(!isExpanded);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'section toggled', 'sidebar', {
                sectionId: sectionId,
                collapse: isExpanded
            });
        }, [
            createAnalyticsEvent,
            isExpanded,
            sectionId
        ]);
        const chevronIcon = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement($7979212ccba7a92c$var$IconWrapper, {
                isExpanded: isExpanded,
                visualRefresh: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("eSI7k"))))), {
                label: formatMessage(isExpanded ? (0, (0, parcelRequire("1tFZj")).default).collapseSection : (0, (0, parcelRequire("1tFZj")).default).expandSection, {
                    section: title
                }),
                color: "var(--ds-text-subtlest, #626F86)"
            })), [
            formatMessage,
            isExpanded,
            title
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($7979212ccba7a92c$export$7d436a88869873b5, {
            "data-testid": `navigation-apps-sidebar-core.ui.multi-project-menu.project-group.${sectionId}`
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7979212ccba7a92c$export$dca3dbf057c88c5f, {
            "aria-expanded": isExpanded,
            "aria-controls": `multi-project-menu-project-group-${sectionId}`,
            onClick: onToggleExpand,
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.project-group.toggle"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("89thI")).default), {
            appearance: "subtle",
            spacing: "none",
            iconBefore: chevronIcon
        }), title), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dWvae")).Collapsible), {
            id: `multi-project-menu-project-group-${sectionId}`,
            isExpanded: isExpanded
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7979212ccba7a92c$export$99bffacbdbcb5195, null, projects.map((project)=>project.key === currentProjectKey ? (0, ($parcel$interopDefault($5uXOq))).createElement("li", {
                key: project.key
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hVL5W")).default), {
                project: project,
                to: $7979212ccba7a92c$var$getDefaultProjectUrl(project),
                onFavoriteToggle: ()=>onFavoriteToggle(project)
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement("li", {
                key: project.key
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1zqLm")).default), {
                project: project,
                to: $7979212ccba7a92c$var$getDefaultProjectUrl(project),
                onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jwmProjectLink', {
                        projectId: project.id,
                        starred: project.isFavorite,
                        current: false
                    }),
                onFavoriteToggle: ()=>onFavoriteToggle(project),
                prefetch: "hover",
                testId: $7979212ccba7a92c$var$PROJECT_LINK_TEST_ID
            }))), showViewAllProjects && (0, ($parcel$interopDefault($5uXOq))).createElement("li", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cUsQ8")).default), {
            label: viewAllProjectsLabel
        })))));
    };
    var $7979212ccba7a92c$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($7979212ccba7a92c$var$ProjectGroup);
    const $7979212ccba7a92c$var$IconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isExpanded: isExpanded, visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_v5641b1u _k8m01e03",
                __cmplp.isExpanded ? "_t9ec1ul7" : "_t9ec2i46",
                __cmplp.visualRefresh && "_1yt412x7",
                __cmplp.className
            ])
        });
    });
    const $7979212ccba7a92c$export$7d436a88869873b5 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _18s83l1n _onzypxbi",
                __cmplp.className
            ])
        });
    });
    const $7979212ccba7a92c$export$dca3dbf057c88c5f = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1rc1 _1e0c1txw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt4otz2 _4cvr1h6o _80omtlke _1p1dangw _11c816g6 _zulptij8",
                __cmplp.className
            ])
        });
    });
    const $7979212ccba7a92c$export$99bffacbdbcb5195 = (0, $5uXOq.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt41b66 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dWvae", function(module, exports) {
    $parcel$export(module.exports, "Collapsible", ()=>$fa509c31ea2f76e0$export$6eb0f7ddcda6131f);
    var $5uXOq = parcelRequire("5uXOq");
    var $eNZwU;
    const $fa509c31ea2f76e0$export$6eb0f7ddcda6131f = ({ children: children, id: id, isExpanded: isExpanded, animationDuration: animationDuration = 250 })=>{
        const didMountRef = (0, $5uXOq.useRef)(false);
        const [containerHeight, setContainerHeight] = (0, $5uXOq.useState)(isExpanded ? null : 0);
        const [isRendered, setIsRendered] = (0, $5uXOq.useState)(isExpanded);
        const wrapperRef = (0, $5uXOq.useRef)(null);
        const contentRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!didMountRef.current) {
                didMountRef.current = true;
                return;
            }
            if (isExpanded) {
                setIsRendered(true);
                requestAnimationFrame(()=>{
                    setContainerHeight(contentRef.current?.offsetHeight ?? null);
                    Promise.all(wrapperRef.current?.getAnimations().map((animation)=>animation.finished) ?? []).then(()=>{
                        setContainerHeight(null);
                    });
                });
            } else {
                setContainerHeight(contentRef.current?.offsetHeight ?? null);
                requestAnimationFrame(()=>{
                    setContainerHeight(0);
                    Promise.all(wrapperRef.current?.getAnimations().map((animation)=>animation.finished) ?? []).then(()=>{
                        setIsRendered(false);
                    });
                });
            }
        }, [
            contentRef,
            isExpanded
        ]);
        if (!isRendered) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eNZwU")).CollapsibleWrapper), {
            animationDuration: animationDuration,
            containerHeight: containerHeight,
            id: id,
            ref: wrapperRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: contentRef
        }, children));
    };
});
parcelRegister("eNZwU", function(module, exports) {
    $parcel$export(module.exports, "CollapsibleWrapper", ()=>$da05f67abbfb4827$export$417956c58046108f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $da05f67abbfb4827$export$417956c58046108f = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { animationDuration: animationDuration, containerHeight: containerHeight, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_3opy9g": (0, (0, parcelRequire("lD23V")).default)(`max-height ${__cmplp.animationDuration}ms ease-in-out`),
                "--_3k6n1g": (0, (0, parcelRequire("lD23V")).default)(__cmplp.containerHeight, "px")
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq _v564plo1",
                __cmplp.containerHeight != null ? "_c71ld5na" : "_c71ln7od",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("1zqLm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$47f581e43f4f1b3b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $bVfxn;
    var $jzhSN;
    const $47f581e43f4f1b3b$var$ProjectItem = ({ project: project, onClick: onClick, onFavoriteToggle: onFavoriteToggle, to: to, isActive: isActive, className: className, testId: testId, prefetch: prefetch })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jzhSN")).default), {
            to: to,
            onClick: onClick,
            isActive: isActive,
            elemAfter: project.permissions.viewIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bVfxn")).default), {
                project: project,
                onToggle: onFavoriteToggle
            }),
            className: className,
            testId: testId,
            prefetch: prefetch
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($47f581e43f4f1b3b$var$Avatar, {
            src: project.avatarUrl,
            alt: ""
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($47f581e43f4f1b3b$var$ProjectName, null, project.name));
    var $47f581e43f4f1b3b$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($47f581e43f4f1b3b$var$ProjectItem);
    const $47f581e43f4f1b3b$var$ProjectName = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _y3gn1e5h _1e0c1ule _o5721q9c _1bto1l2s _k48p1wq8",
                __cmplp.className
            ])
        });
    });
    const $47f581e43f4f1b3b$var$Avatar = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlidpf _1o9zidpf _i0dl1wug _vchhusvi _4t3i1tcg _1bsb1tcg _2hwxutpp _2rko1l7b",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bVfxn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b5957c6a2c0f9f04$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lGkqX;
    var $b0Mpg;
    var $6T4rd;
    var $MGmIU;
    var $koVbs;
    var $8zOmE;
    var $95EVP;
    var $79Jog;
    var $bDKMx;
    const $b5957c6a2c0f9f04$var$FavoriteButton = ({ project: project, onToggle: onToggle })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        const label = project.isFavorite ? formatMessage((0, (0, parcelRequire("79Jog")).default).unstar) : formatMessage((0, (0, parcelRequire("79Jog")).default).star);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            const star = !project.isFavorite;
            onToggle(star);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'project starred', 'sidebar', {
                projectId: project.id,
                star: star
            });
        }, [
            project,
            onToggle,
            createAnalyticsEvent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            padding: "space.025"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("MGmIU")).default), {
            content: label,
            hideTooltipOnClick: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bDKMx")).Button), {
            isFavorite: project.isFavorite ?? false,
            onClick: onClick,
            "data-testid": "navigation-apps-sidebar-core.common.ui.favorite-button"
        }, project.isFavorite ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lGkqX"))))), {
            color: "currentColor",
            label: label
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("b0Mpg"))))), {
            color: "currentColor",
            label: label
        }))));
    };
    var $b5957c6a2c0f9f04$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b5957c6a2c0f9f04$var$FavoriteButton);
});
parcelRegister("lGkqX", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fc8d5eee378a3177$var$_react = $fc8d5eee378a3177$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fc8d5eee378a3177$var$_starStarred = $fc8d5eee378a3177$var$_interopRequireDefault((parcelRequire("3pdIy")));
    var $fc8d5eee378a3177$var$_starFilled = $fc8d5eee378a3177$var$_interopRequireDefault((parcelRequire("2z7BY")));
    function $fc8d5eee378a3177$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fc8d5eee378a3177$var$StarStarredIcon = (props)=>$fc8d5eee378a3177$var$_react.default.createElement($fc8d5eee378a3177$var$_starStarred.default, Object.assign({
            LEGACY_fallbackIcon: $fc8d5eee378a3177$var$_starFilled.default
        }, props));
    $fc8d5eee378a3177$var$StarStarredIcon.Name = 'StarStarredIconMigration';
    var $fc8d5eee378a3177$var$_default = module.exports.default = $fc8d5eee378a3177$var$StarStarredIcon;
});
parcelRegister("b0Mpg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $80453e543c5d0970$var$_react = $80453e543c5d0970$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $80453e543c5d0970$var$_starUnstarred = $80453e543c5d0970$var$_interopRequireDefault((parcelRequire("2PONs")));
    var $80453e543c5d0970$var$_star = $80453e543c5d0970$var$_interopRequireDefault((parcelRequire("jWahG")));
    function $80453e543c5d0970$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $80453e543c5d0970$var$StarUnstarredIcon = (props)=>$80453e543c5d0970$var$_react.default.createElement($80453e543c5d0970$var$_starUnstarred.default, Object.assign({
            LEGACY_fallbackIcon: $80453e543c5d0970$var$_star.default
        }, props));
    $80453e543c5d0970$var$StarUnstarredIcon.Name = 'StarUnstarredIconMigration';
    var $80453e543c5d0970$var$_default = module.exports.default = $80453e543c5d0970$var$StarUnstarredIcon;
});
parcelRegister("79Jog", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2dbb204157c9a073$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2dbb204157c9a073$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        star: {
            "id": "spa-apps-sidebar-core.common.favorite-button.star",
            "defaultMessage": "Add to Starred"
        },
        unstar: {
            "id": "spa-apps-sidebar-core.common.favorite-button.unstar",
            "defaultMessage": "Remove from Starred"
        }
    });
});
parcelRegister("bDKMx", function(module, exports) {
    $parcel$export(module.exports, "Button", ()=>$d9386e07e1778b0a$export$353f5b6fc5456de1);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $d9386e07e1778b0a$export$e6dfd72ab29f8598 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4v77o _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $d9386e07e1778b0a$export$353f5b6fc5456de1 = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isFavorite: isFavorite, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _11q7glyw _80omtlke _2rko1sit _1spjglyw _157zglyw",
                __cmplp.isFavorite ? "_syazkizl" : "_syazjjyb",
                __cmplp.isFavorite ? "_f8pj1ov0 _30l31ov0 _17051ov0" : "_f8pj1wmz _30l31wmz _17051wmz",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hVL5W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e4b65956d11fea1d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $95EVP;
    var $eEqSc;
    var $1zqLm;
    var $fqbZF;
    const $e4b65956d11fea1d$var$TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.current-project';
    const $e4b65956d11fea1d$var$ActiveProject = ({ project: project, to: to, onFavoriteToggle: onFavoriteToggle })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        const onClick = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jwmProjectLink', {
                projectId: project.id,
                starred: project.isFavorite,
                current: true
            });
        }, [
            createAnalyticsEvent,
            project
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eEqSc")).default), {
            testId: $e4b65956d11fea1d$var$TEST_ID
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1zqLm")).default), {
            project: project,
            to: to,
            isActive: true,
            onClick: onClick,
            onFavoriteToggle: onFavoriteToggle
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fqbZF")).default), null));
    };
    var $e4b65956d11fea1d$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($e4b65956d11fea1d$var$ActiveProject);
});
parcelRegister("fqbZF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$44c9fe648224cdc5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $65Ltd;
    var $k0iPT;
    var $juTur;
    var $231OU;
    var $6jY6G;
    var $gb5lQ;
    var $lPApw;
    var $74Yye;
    var $iCrgB;
    var $2U3dG;
    var $boE05;
    var $chejP;
    var $9nNLl;
    const $44c9fe648224cdc5$var$calculateStack = (route, connectStack, forgeStack)=>{
        const routeName = route && route.name || '';
        if ((0, (0, parcelRequire("gb5lQ")).FORGE_ROUTES_SET).has(routeName) && forgeStack) return forgeStack;
        if ((0, (0, parcelRequire("k0iPT")).CONNECT_ROUTES_SET).has(routeName) && connectStack) return connectStack;
        return [];
    };
    const $44c9fe648224cdc5$var$ProjectMenu = ()=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: project } = (0, (0, parcelRequire("74Yye")).default)();
        const { data: features, loading: isFeaturesLoading } = (0, (0, parcelRequire("lPApw")).useFeatures)();
        const { stack: connectProjectStack } = (0, (0, parcelRequire("lPApw")).useProjectConnectItems)();
        const { stack: connectReportsStack } = (0, (0, parcelRequire("lPApw")).useProjectReportsConnectItems)();
        const { stack: connectSettingsStack } = (0, (0, parcelRequire("lPApw")).useProjectSettingsConnectItems)();
        const connectStack = connectProjectStack || connectReportsStack || connectSettingsStack;
        const { loading: projectForgeAppsLoading, stack: forgeStack } = (0, (0, parcelRequire("231OU")).useProjectForgeApps)((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT));
        const [stack, setStack] = (0, $5uXOq.useState)(()=>$44c9fe648224cdc5$var$calculateStack(route, connectStack, forgeStack));
        (0, $5uXOq.useEffect)(()=>{
            setStack($44c9fe648224cdc5$var$calculateStack(route, connectStack, forgeStack));
        }, [
            route,
            connectStack,
            forgeStack
        ]);
        if (project == null || isFeaturesLoading || features == null || projectForgeAppsLoading) return null;
        let content = null;
        if ((0, (0, parcelRequire("gb5lQ")).ISSUES_ROUTES_SET).has(route.name)) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("boE05")).default), {
            project: project
        });
        else if ((0, (0, parcelRequire("gb5lQ")).REPORTS_ROUTES_SET).has(route.name) || connectReportsStack) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("chejP")).default), null);
        else if ((0, (0, parcelRequire("gb5lQ")).SETTINGS_ROUTES_SET).has(route.name) || route?.group === (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE) || connectSettingsStack) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9nNLl")).default), {
            project: project
        });
        else if ((0, (0, parcelRequire("gb5lQ")).FORGE_ROUTES_SET).has(route.name) || forgeStack) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2U3dG")).default), null);
        else if ((0, (0, parcelRequire("k0iPT")).CONNECT_ROUTES_SET).has(route.name) || connectProjectStack) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iCrgB")).default), {
            stack: stack,
            onStackChange: setStack,
            project: project
        });
        else return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juTur")).ContextualAnalyticsData), {
            menuId: (0, (0, parcelRequire("gb5lQ")).MENU_ID),
            stack: stack
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($44c9fe648224cdc5$export$42a852a2b6b56249, null, content));
    };
    const $44c9fe648224cdc5$export$42a852a2b6b56249 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _1e0c1txw _2lx21bp4 _fshqh2mm _10p2glyw",
                __cmplp.className
            ])
        });
    });
    var $44c9fe648224cdc5$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($44c9fe648224cdc5$var$ProjectMenu);
});
parcelRegister("k0iPT", function(module, exports) {
    $parcel$export(module.exports, "JWM_OVERVIEWS_ROUTE_SET", ()=>$c82776b15970ab04$export$a8aac2ba4dc1f57);
    $parcel$export(module.exports, "CONNECT_ROUTES_SET", ()=>$c82776b15970ab04$export$c47bf667d3008c53);
    var $65Ltd;
    const $c82776b15970ab04$export$a8aac2ba4dc1f57 = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_SUMMARY),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_CALENDAR),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_TIMELINE),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_OVERVIEW_REDIRECT)
    ]);
    const $c82776b15970ab04$export$c47bf667d3008c53 = new Set([
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CONNECT_GENERAL_SERVICE_DESK_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_PROJECT),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_CONNECT_GENERAL)
    ]);
});
parcelRegister("231OU", function(module, exports) {
    $parcel$export(module.exports, "useProjectForgeApps", ()=>$1a247d2d1d6e7cdf$export$338edd25edcf3648);
    $parcel$export(module.exports, "useProjectForgeAppsNav4", ()=>$1a247d2d1d6e7cdf$export$80e84933a3e2f677);
    var $5uXOq = parcelRequire("5uXOq");
    var $e5wyW;
    var $4R6GH;
    var $awp3q;
    var $dvdr4;
    var $5cmSg;
    var $5bkvv;
    var $dAfqg;
    var $324W5;
    var $kKdpt;
    const $1a247d2d1d6e7cdf$var$useProjectForgeAppsV1 = (routeName, projectKey)=>{
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)(projectKey ? {
            matchParams: {
                projectKey: projectKey
            }
        } : undefined);
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)((0, (0, parcelRequire("5bkvv")).forgeProjectModuleV1Resource), projectKey ? {
            matchParams: {
                projectKey: projectKey
            }
        } : undefined);
        const projectData = (0, $5uXOq.useMemo)(()=>data?.extensions || null, [
            data
        ]);
        const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.accessNarrowedExtensions || null, [
            data
        ]);
        const stack = (0, (0, parcelRequire("kKdpt")).useForgeItemStack)(projectData, routeName);
        const context = (0, $5uXOq.useMemo)(()=>projectContext ? {
                projectKey: projectContext.projectKey,
                projectId: projectContext.projectId,
                projectName: projectContext.projectName,
                projectType: projectContext.projectType,
                isProjectAdmin: projectContext.isProjectAdmin,
                isProjectArchived: projectContext.isProjectArchived
            } : {}, [
            projectContext
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: projectData ? projectData.filter((extension)=>(0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(extension, context)) : null,
                accessNarrowedData: accessNarrowedData,
                loading: loading,
                error: error,
                stack: stack
            }), [
            projectData,
            accessNarrowedData,
            loading,
            error,
            stack,
            context
        ]);
    };
    const $1a247d2d1d6e7cdf$var$useProjectForgeAppsV2 = (routeName, projectKey)=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)((0, (0, parcelRequire("5bkvv")).forgeProjectModuleV2Resource), projectKey ? {
            matchParams: {
                projectKey: projectKey
            }
        } : undefined);
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)(projectKey ? {
            matchParams: {
                projectKey: projectKey
            }
        } : undefined);
        const context = (0, $5uXOq.useMemo)(()=>projectContext ? {
                projectKey: projectContext.projectKey,
                projectId: projectContext.projectId,
                projectName: projectContext.projectName,
                projectType: projectContext.projectType,
                isProjectAdmin: projectContext.isProjectAdmin,
                isProjectArchived: projectContext.isProjectArchived
            } : {}, [
            projectContext
        ]);
        (0, (0, parcelRequire("dvdr4")).useDisplayConditionsConsistencyCheck)(data, context, 'project-forge-apps-hook');
        const projectData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, (0, parcelRequire("5cmSg")).isExtensionVisible)) || null, [
            data
        ]);
        const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, (0, parcelRequire("5cmSg")).isExtensionHiddenByAppAccessRules)) || null, [
            data
        ]);
        const stack = (0, (0, parcelRequire("kKdpt")).useForgeItemStack)(projectData, routeName);
        return (0, $5uXOq.useMemo)(()=>({
                data: projectData,
                accessNarrowedData: accessNarrowedData,
                loading: loading,
                error: error,
                stack: stack
            }), [
            projectData,
            accessNarrowedData,
            loading,
            error,
            stack
        ]);
    };
    const $1a247d2d1d6e7cdf$export$338edd25edcf3648 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $1a247d2d1d6e7cdf$var$useProjectForgeAppsV2, $1a247d2d1d6e7cdf$var$useProjectForgeAppsV1);
    const $1a247d2d1d6e7cdf$export$80e84933a3e2f677 = (projectKey)=>$1a247d2d1d6e7cdf$export$338edd25edcf3648(undefined, projectKey);
});
parcelRegister("awp3q", function(module, exports) {
    $parcel$export(module.exports, "useDoesExtensionMeetConditions", ()=>$bd52741229b769de$export$642911220fb6609f);
    $parcel$export(module.exports, "doesExtensionMeetConditions", ()=>$bd52741229b769de$export$b1e4ed7044e85aa3);
    var $5uXOq = parcelRequire("5uXOq");
    var $kvQVg = parcelRequire("kvQVg");
    var $4Pf62;
    var $daoB1;
    var $9OXo1;
    const $bd52741229b769de$export$642911220fb6609f = ()=>{
        const { isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { hasCoreAccess: hasCoreAccess, hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceManagementAccess } = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        return (0, $5uXOq.useCallback)((extension, extraContext)=>{
            const { displayConditions: displayConditions } = extension.properties;
            if (displayConditions == null) return true;
            const context = {
                ...extraContext,
                isAdmin: isAdmin,
                isLoggedIn: !isAnonymous,
                isSiteAdmin: isSiteAdmin,
                hasCoreAccess: hasCoreAccess,
                hasServiceManagementAccess: hasServiceManagementAccess,
                hasSoftwareAccess: hasSoftwareAccess
            };
            return (0, $kvQVg.doesMeetConditions)(displayConditions, context);
        }, [
            hasCoreAccess,
            hasServiceManagementAccess,
            hasSoftwareAccess,
            isAdmin,
            isAnonymous,
            isSiteAdmin
        ]);
    };
    const $bd52741229b769de$export$b1e4ed7044e85aa3 = (extension, extraContext)=>{
        const { displayConditions: displayConditions } = extension.properties;
        const { appPermissions: { hasSoftwareAccess: hasSoftwareAccess, hasServiceDeskAccess: hasServiceDeskAccess, hasCoreAccess: hasCoreAccess }, isAdmin: isAdmin, isAnonymous: isAnonymous, isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("4Pf62")).getTenantContext_DEPRECATED_DO_NOT_USE)();
        const context = {
            ...extraContext,
            isAdmin: isAdmin,
            isLoggedIn: !isAnonymous,
            isSiteAdmin: isSiteAdmin,
            hasSoftwareAccess: hasSoftwareAccess,
            hasServiceManagementAccess: hasServiceDeskAccess,
            hasCoreAccess: hasCoreAccess
        };
        return displayConditions ? (0, $kvQVg.doesMeetConditions)(displayConditions, context) : true;
    };
});
parcelRegister("daoB1", function(module, exports) {
    $parcel$export(module.exports, "ApplicationPermissionsSubscriber", ()=>$77add4b5420e5058$export$d8c76f7e52d0a856);
    $parcel$export(module.exports, "useApplicationPermissions", ()=>$77add4b5420e5058$export$4d9cadb4042acc1b);
    var $dGvGJ = parcelRequire("dGvGJ");
    var $7JoAD = parcelRequire("7JoAD");
    var $2gywT;
    var $9OXo1;
    const $77add4b5420e5058$var$selector = (0, $dGvGJ.createSelector)((state)=>state.tenantContext.appPermissions, (applicationPermissions)=>({
            data: {
                applicationPermissions: applicationPermissions
            }
        }));
    const $77add4b5420e5058$export$d8c76f7e52d0a856 = (0, $7JoAD.createSubscriber)((0, (0, parcelRequire("2gywT")).default), {
        displayName: 'ApplicationPermissionsSubscriber',
        selector: $77add4b5420e5058$var$selector
    });
    const $77add4b5420e5058$export$4d9cadb4042acc1b = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.appPermissions;
    };
});
parcelRegister("dvdr4", function(module, exports) {
    $parcel$export(module.exports, "useDisplayConditionsConsistencyCheck", ()=>$79a96011350576c4$export$cd62caf01a15f56b);
    $parcel$export(module.exports, "checkDisplayConditionsConsistency", ()=>$79a96011350576c4$export$4169695e1a68bda7);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $dJl1T;
    var $4R6GH;
    var $awp3q;
    var $5cmSg;
    const $79a96011350576c4$export$cd62caf01a15f56b = (data, context = {}, consumer)=>{
        const memoizedContext = $79a96011350576c4$var$useMemoizedStateObject(context);
        const memoizedData = $79a96011350576c4$var$useMemoizedStateObject(data);
        (0, $5uXOq.useEffect)(()=>{
            $79a96011350576c4$export$4169695e1a68bda7(memoizedData, memoizedContext, consumer);
        }, [
            memoizedContext,
            memoizedData,
            consumer
        ]);
    };
    const $79a96011350576c4$export$4169695e1a68bda7 = (data, context = {}, consumer)=>{
        if (data == null) return;
        if ((0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules')) {
            if ('extensions' in data) {
                (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData('forge.display-conditions-transition', 'checkDisplayConditionsConsistency is called with a data from the old query', {
                    consumer: consumer
                });
                return;
            }
        } else {
            (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData('forge.display-conditions-transition', 'checkDisplayConditionsConsistency is called while the FG is being turned off', {
                consumer: consumer
            });
            return;
        }
        const falsePositives = new Set();
        const falseNegatives = new Set();
        data.forEach((extension)=>{
            const perClient = (0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(extension, context);
            const perServer = !(0, (0, parcelRequire("5cmSg")).isExtensionHiddenByDisplayConditions)(extension);
            if (perClient !== perServer) {
                if (perServer) falsePositives.add(extension);
                else falseNegatives.add(extension);
            }
        });
        if (falsePositives.size || falseNegatives.size) (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData('forge.display-conditions-transition', 'Display conditions evaluation is not consistent', {
            consumer: consumer,
            context: JSON.stringify(context),
            falsePositives_count: falsePositives.size,
            falsePositives_data: falsePositives.size ? JSON.stringify(Array.from(falsePositives).map((ext)=>({
                    id: ext.id,
                    type: ext.type,
                    displayConditions: ext.properties.displayConditions
                }))) : null,
            falseNegatives_count: falseNegatives.size,
            falseNegatives_data: falseNegatives.size ? JSON.stringify(Array.from(falseNegatives).map((ext)=>({
                    id: ext.id,
                    type: ext.type,
                    displayConditions: ext.properties.displayConditions
                }))) : null
        });
    };
    const $79a96011350576c4$var$useMemoizedStateObject = (data, equalityCheck = (0, ($parcel$interopDefault($ajpes))))=>{
        const memoizedData = (0, $5uXOq.useRef)(data);
        return (0, $5uXOq.useMemo)(()=>{
            if (!equalityCheck(data, memoizedData.current)) {
                memoizedData.current = data;
                return data;
            }
            return memoizedData.current;
        }, [
            data,
            equalityCheck
        ]);
    };
});
parcelRegister("5cmSg", function(module, exports) {
    $parcel$export(module.exports, "isExtensionVisible", ()=>$30771269db74e480$export$41e48b53c2cc2013);
    $parcel$export(module.exports, "isExtensionHidden", ()=>$30771269db74e480$export$3f5b3e61d567ef3);
    $parcel$export(module.exports, "isExtensionHiddenByAppAccessRules", ()=>$30771269db74e480$export$5c38dfa9d1f96e61);
    $parcel$export(module.exports, "isExtensionHiddenByDisplayConditions", ()=>$30771269db74e480$export$3cc53b8cca25d64);
    const $30771269db74e480$export$41e48b53c2cc2013 = (extension)=>!extension.hiddenBy;
    const $30771269db74e480$export$3f5b3e61d567ef3 = (extension)=>!!extension.hiddenBy;
    const $30771269db74e480$export$5c38dfa9d1f96e61 = (extension)=>extension.hiddenBy === 'AppAccessRules';
    const $30771269db74e480$export$3cc53b8cca25d64 = (extension)=>extension.hiddenBy === 'DisplayConditions';
});
parcelRegister("kKdpt", function(module, exports) {
    $parcel$export(module.exports, "useForgeItemStack", ()=>$dac9c7c54c5ccbb1$export$462f82a278743d46);
    var $5uXOq = parcelRequire("5uXOq");
    var $c70gQ;
    var $dIdda = parcelRequire("dIdda");
    var $7Tlti;
    const $dac9c7c54c5ccbb1$export$462f82a278743d46 = (modules, routeName, parentStack)=>{
        const [{ match: match, route: route }] = (0, $dIdda.useRouter)();
        const matchedExtension = (0, (0, parcelRequire("c70gQ")).useMatchedExtension)({
            modules: modules,
            match: match
        });
        return (0, $5uXOq.useMemo)(()=>{
            if (route.name !== routeName) return null;
            if (matchedExtension && (0, (0, parcelRequire("7Tlti")).toSections)(matchedExtension).length) {
                const stackId = `${matchedExtension.id}-subpages`;
                return parentStack ? [
                    ...parentStack,
                    stackId
                ] : [
                    stackId
                ];
            }
            if (matchedExtension && parentStack) return parentStack;
            return null;
        }, [
            matchedExtension,
            parentStack,
            route.name,
            routeName
        ]);
    };
});
parcelRegister("c70gQ", function(module, exports) {
    $parcel$export(module.exports, "useMatchedExtension", ()=>$b661f1f04cec9385$export$13375c0abccaf6f6);
    $parcel$export(module.exports, "useExtensionBasePath", ()=>$b661f1f04cec9385$export$25abed85383f0fbb);
    var $5uXOq = parcelRequire("5uXOq");
    var $e0AC8;
    const $b661f1f04cec9385$export$13375c0abccaf6f6 = ({ modules: modules, match: match })=>(0, $5uXOq.useMemo)(()=>(modules || []).find((app)=>{
                const parsedExtensionId = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(app.id);
                return parsedExtensionId.appId === match.params.appId && parsedExtensionId.envId === match.params.envId;
            }), [
            modules,
            match.params.appId,
            match.params.envId
        ]);
    const $b661f1f04cec9385$export$25abed85383f0fbb = (baseUrl, route)=>route !== undefined ? baseUrl.replace(/\/?$/, '').slice(0, -route.length - 1) : baseUrl.replace(/\/?$/, '');
});
parcelRegister("7Tlti", function(module, exports) {
    $parcel$export(module.exports, "toSections", ()=>$25b31557e9750c03$export$29678d1e04c0e8c4);
    var $8QpSo;
    const $25b31557e9750c03$var$normalizeSection = (section)=>({
            header: section?.header,
            pages: Array.isArray(section?.pages) ? section.pages.map((page)=>({
                    icon: page?.icon,
                    route: page?.route,
                    title: page?.title
                })) : []
        });
    const $25b31557e9750c03$export$29678d1e04c0e8c4 = (0, (0, parcelRequire("8QpSo")).default)((extension)=>{
        const { properties: properties } = extension;
        if (typeof properties.resource !== 'string') return [];
        if (typeof properties.pages !== 'undefined' && properties.pages?.length) return [
            {
                pages: properties.pages
            }
        ].map($25b31557e9750c03$var$normalizeSection);
        if (typeof properties.sections !== 'undefined' && properties.sections?.length) return properties.sections.map($25b31557e9750c03$var$normalizeSection);
        return [];
    });
});
parcelRegister("lPApw", function(module, exports) {
    $parcel$export(module.exports, "useFeatures", ()=>$fd44cc0bd2bece63$export$4a39035bacc4ed76);
    $parcel$export(module.exports, "useProjectConnectItems", ()=>$fd44cc0bd2bece63$export$f23d0c24c77d7608);
    $parcel$export(module.exports, "useProjectReportsConnectItems", ()=>$fd44cc0bd2bece63$export$a1c75c386c088992);
    $parcel$export(module.exports, "useProjectSettingsConnectItems", ()=>$fd44cc0bd2bece63$export$41a50100db18b578);
    $parcel$export(module.exports, "useProjectSettingsForgeItems", ()=>$fd44cc0bd2bece63$export$84761bbf25a4f51f);
    var $18FbX;
    var $7OqB4;
    var $hWtQt;
    var $jfqNX;
    var $gZbSF;
    var $6hMYg;
    var $bkw8F;
    const $fd44cc0bd2bece63$export$4a39035bacc4ed76 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("bkw8F")).useFeatures));
    const $fd44cc0bd2bece63$export$f23d0c24c77d7608 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("gZbSF")).useProjectConnectItems));
    const $fd44cc0bd2bece63$export$a1c75c386c088992 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("hWtQt")).useProjectReportsConnectItems));
    const $fd44cc0bd2bece63$export$41a50100db18b578 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("jfqNX")).useProjectSettingsConnectItems));
    const $fd44cc0bd2bece63$export$84761bbf25a4f51f = (0, (0, parcelRequire("6hMYg")).useProjectSettingsForgeAppsForMenu);
    const $fd44cc0bd2bece63$export$96e8a0c1f4717705 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("18FbX")).useJiraWorkManagementProjectPagesLink));
});
parcelRegister("18FbX", function(module, exports) {
    $parcel$export(module.exports, "useJiraSoftwareProjectPagesLink", ()=>$066b0551287c1b35$export$50628ae0ad1a35f2);
    $parcel$export(module.exports, "useJiraWorkManagementProjectPagesLink", ()=>$066b0551287c1b35$export$96e8a0c1f4717705);
    var $5uXOq = parcelRequire("5uXOq");
    var $eusud;
    var $1J3t1;
    const $066b0551287c1b35$var$pagesLinkBaseUrl = (baseUrl, projectKey)=>`${baseUrl}/rest/projects/1.0/pageslink/${projectKey}`;
    const $066b0551287c1b35$var$enablePagesLinkUrl = (baseUrl, projectKey)=>`${$066b0551287c1b35$var$pagesLinkBaseUrl(baseUrl, projectKey)}/enable`;
    const $066b0551287c1b35$var$disablePagesLinkUrl = (baseUrl, projectKey)=>`${$066b0551287c1b35$var$pagesLinkBaseUrl(baseUrl, projectKey)}/disable`;
    const $066b0551287c1b35$var$setPagesLinkService = ({ baseUrl: baseUrl, projectKey: projectKey, enable: enable })=>enable ? (0, (0, parcelRequire("eusud")).performPutRequest)($066b0551287c1b35$var$enablePagesLinkUrl(baseUrl, projectKey)) : (0, (0, parcelRequire("eusud")).performPutRequest)($066b0551287c1b35$var$disablePagesLinkUrl(baseUrl, projectKey));
    const $066b0551287c1b35$var$isProjectOrJiraAdmin = (permissionInfo)=>permissionInfo.isAdmin || permissionInfo.projectPermissionsQueried.ADMINISTER_PROJECTS === true;
    const $066b0551287c1b35$export$50628ae0ad1a35f2 = ()=>{
        const { data: data, loading: loading, refresh: refresh, error: error } = (0, (0, parcelRequire("1J3t1")).useJiraSoftwareProjectNavigation)();
        const setPagesLink = (0, $5uXOq.useCallback)(async (...args)=>{
            await $066b0551287c1b35$var$setPagesLinkService(...args);
            await refresh();
        }, [
            refresh
        ]);
        return {
            data: {
                isEnabled: data?.hasPages === true,
                canEdit: data?.permissionInfo != null && $066b0551287c1b35$var$isProjectOrJiraAdmin(data.permissionInfo),
                pending: loading,
                setPagesLink: setPagesLink
            },
            loading: loading,
            error: error
        };
    };
    const $066b0551287c1b35$export$96e8a0c1f4717705 = ()=>{
        const { loading: loading, refresh: refresh, error: error } = (0, (0, parcelRequire("1J3t1")).useJiraWorkmanagementProjectNavigation)();
        const setPagesLink = (0, $5uXOq.useCallback)(async (...args)=>{
            await $066b0551287c1b35$var$setPagesLinkService(...args);
            await refresh();
        }, [
            refresh
        ]);
        return {
            data: {
                isEnabled: true,
                canEdit: false,
                pending: loading,
                setPagesLink: setPagesLink
            },
            loading: loading,
            error: error
        };
    };
});
parcelRegister("hWtQt", function(module, exports) {
    $parcel$export(module.exports, "useProjectReportsConnectItems", ()=>$a740427f233367ba$export$a1c75c386c088992);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $1J3t1;
    var $dIdda = parcelRequire("dIdda");
    var $7tsV0;
    var $5W6pd;
    const $a740427f233367ba$var$findItemAndStackMemo = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("7tsV0")).findItemAndStack));
    const $a740427f233367ba$export$a1c75c386c088992 = ()=>{
        const [{ route: route, location: location }] = (0, $dIdda.useRouter)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useProjectReportsSidebarConnectNavigation)();
        const items = (0, $5uXOq.useMemo)(()=>data != null ? data.map((0, (0, parcelRequire("5W6pd")).transformLinkV4)).filter(Boolean) : [], [
            data
        ]);
        const found = (0, $5uXOq.useMemo)(()=>route && items && $a740427f233367ba$var$findItemAndStackMemo(items, route.name, location, [
                'reports'
            ]), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            error: error,
            loading: loading,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("7tsV0", function(module, exports) {
    $parcel$export(module.exports, "findItemAndStack", ()=>$93fa8c16baad19b1$export$751e2e6237002565);
    var $ajpes = parcelRequire("ajpes");
    var $k0iPT;
    const $93fa8c16baad19b1$var$splitRelevantQs = (s)=>s.replace('?', '').split('&').filter((v)=>v && !/^(ac\.|project|board|user|servicedesk)/.test(v));
    const $93fa8c16baad19b1$var$isSameQuery = (locationQuery, itemQuery)=>(0, ($parcel$interopDefault($ajpes)))(locationQuery, itemQuery) || !locationQuery.some((q)=>q.startsWith('s=')) && (0, ($parcel$interopDefault($ajpes)))(itemQuery.filter((q)=>!q.startsWith('s=')), locationQuery);
    const $93fa8c16baad19b1$export$751e2e6237002565 = (items, routeName, location, parentStack = [])=>{
        let found = null;
        if (!(0, (0, parcelRequire("k0iPT")).CONNECT_ROUTES_SET).has(routeName)) return found;
        const locationQuery = $93fa8c16baad19b1$var$splitRelevantQs(location.search);
        items.some((item)=>{
            const [itemPath, itemQs = ''] = (item.url || '').split('#')[0].split('?');
            const itemQuery = $93fa8c16baad19b1$var$splitRelevantQs(itemQs);
            const sameQuery = $93fa8c16baad19b1$var$isSameQuery(locationQuery, itemQuery);
            if (item.section !== true && itemPath === location.pathname && sameQuery) {
                found = {
                    stack: parentStack,
                    selected: item
                };
                return true;
            }
            if (item.items) {
                const stack = item.section === true ? parentStack : parentStack.concat(item.id);
                found = $93fa8c16baad19b1$export$751e2e6237002565(item.items, routeName, location, stack);
            }
            return Boolean(found);
        });
        return found;
    };
});
parcelRegister("5W6pd", function(module, exports) {
    $parcel$export(module.exports, "transformLink", ()=>$1efacbf40a7b73c8$export$5a32dc366b1d641f);
    $parcel$export(module.exports, "transformLinkV4", ()=>$1efacbf40a7b73c8$export$27267b6b6650eaa5);
    const $1efacbf40a7b73c8$export$5a32dc366b1d641f = (link)=>{
        const items = link.links && link.links.length ? link.links.map($1efacbf40a7b73c8$export$5a32dc366b1d641f).filter(Boolean) : undefined;
        if (link.section === true) {
            if (!items || !items.length) return null;
            if (items.length === 1 && items[0]?.section === true) return {
                ...items[0],
                name: items[0].name || String(link.name)
            };
            return {
                id: link.id,
                name: String(link.name),
                section: !!link.section,
                items: items
            };
        }
        return {
            id: link.id,
            name: String(link.name),
            url: link.url,
            iconUrl: link.iconUrl || '',
            styleClass: link.styleClass || '',
            items: items
        };
    };
    const $1efacbf40a7b73c8$export$27267b6b6650eaa5 = (data)=>{
        const items = data.links && data.links.length ? data.links.map($1efacbf40a7b73c8$export$27267b6b6650eaa5).filter(Boolean) : undefined;
        if (data.section === true) {
            if (!items || !items.length) return null;
            if (items.length === 1 && items[0]?.section === true) return {
                ...items[0],
                name: items[0].name || String(data.name)
            };
            return {
                id: data.id,
                name: String(data.name),
                section: !!data.section,
                items: items
            };
        }
        return {
            id: data.id,
            name: String(data.name),
            url: data.url,
            iconUrl: data.iconUrl || '',
            styleClass: data.styleClass || '',
            items: items
        };
    };
});
parcelRegister("jfqNX", function(module, exports) {
    $parcel$export(module.exports, "useProjectSettingsConnectItems", ()=>$662340ab1e9d2787$export$41a50100db18b578);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $1J3t1;
    var $dIdda = parcelRequire("dIdda");
    var $7tsV0;
    var $5W6pd;
    const $662340ab1e9d2787$var$findItemAndStackMemo = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("7tsV0")).findItemAndStack));
    const $662340ab1e9d2787$export$41a50100db18b578 = ()=>{
        const [{ route: route, location: location }] = (0, $dIdda.useRouter)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useProjectSettingsSidebarConnectNavigation)();
        const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, (0, parcelRequire("5W6pd")).transformLinkV4)).filter(Boolean), [
            data
        ]);
        const found = (0, $5uXOq.useMemo)(()=>route && items && $662340ab1e9d2787$var$findItemAndStackMemo(items, route.name, location, [
                'settings'
            ]), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            loading: loading,
            error: error,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("gZbSF", function(module, exports) {
    $parcel$export(module.exports, "useProjectConnectItems", ()=>$fcf7bc53994ae8f3$export$f23d0c24c77d7608);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $1J3t1;
    var $dIdda = parcelRequire("dIdda");
    var $7tsV0;
    var $5W6pd;
    const $fcf7bc53994ae8f3$var$findItemAndStackMemo = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("7tsV0")).findItemAndStack));
    const $fcf7bc53994ae8f3$export$f23d0c24c77d7608 = ()=>{
        const [{ route: route, location: location }] = (0, $dIdda.useRouter)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useProjectSidebarConnectNavigation)();
        const items = (0, $5uXOq.useMemo)(()=>data && data.map((0, (0, parcelRequire("5W6pd")).transformLinkV4)).filter(Boolean), [
            data
        ]);
        const found = (0, $5uXOq.useMemo)(()=>route && items && $fcf7bc53994ae8f3$var$findItemAndStackMemo(items, route.name, location), [
            items,
            route,
            location
        ]);
        return {
            data: items,
            loading: loading,
            error: error,
            selected: found && found.selected,
            stack: found && found.stack
        };
    };
});
parcelRegister("6hMYg", function(module, exports) {
    $parcel$export(module.exports, "useProjectSettingsForgeApps", ()=>$2106846b1818d2e6$export$bef2e514007d2f07);
    $parcel$export(module.exports, "useProjectSettingsForgeAppsForMenu", ()=>$2106846b1818d2e6$export$b741e3e3cfb39b82);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $e5wyW;
    var $4R6GH;
    var $k2DRb;
    var $e0AC8;
    var $awp3q;
    var $dvdr4;
    var $5cmSg;
    var $5bkvv;
    var $dAfqg;
    var $itmJb;
    var $cNd4s;
    var $9OXo1;
    var $dIdda = parcelRequire("dIdda");
    var $kKdpt;
    var $7Tlti;
    const $2106846b1818d2e6$export$3c509d6dc1f63bbe = ()=>{
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)((0, (0, parcelRequire("5bkvv")).forgeProjectSettingsModuleV1Resource));
        const projectSettingsData = (0, $5uXOq.useMemo)(()=>data?.extensions || null, [
            data
        ]);
        const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.accessNarrowedExtensions || null, [
            data
        ]);
        const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const hasPermissions = (0, $5uXOq.useMemo)(()=>(projectContext?.isProjectAdmin || isAdmin || isSiteAdmin) === true, [
            isAdmin,
            isSiteAdmin,
            projectContext?.isProjectAdmin
        ]);
        const context = (0, $5uXOq.useMemo)(()=>projectContext ? {
                projectKey: projectContext.projectKey,
                projectId: projectContext.projectId,
                projectName: projectContext.projectName,
                projectType: projectContext.projectType
            } : {}, [
            projectContext
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: projectSettingsData ? projectSettingsData.filter((extension)=>hasPermissions && (0, (0, parcelRequire("awp3q")).doesExtensionMeetConditions)(extension, context)) : null,
                accessNarrowedData: accessNarrowedData,
                loading: loading,
                error: error
            }), [
            projectSettingsData,
            accessNarrowedData,
            loading,
            error,
            hasPermissions,
            context
        ]);
    };
    const $2106846b1818d2e6$export$5aac3b333ac18e0d = ()=>{
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)((0, (0, parcelRequire("5bkvv")).forgeProjectSettingsModuleV2Resource));
        const projectSettingsData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, (0, parcelRequire("5cmSg")).isExtensionVisible)) || null, [
            data
        ]);
        const accessNarrowedData = (0, $5uXOq.useMemo)(()=>data?.filter?.((0, (0, parcelRequire("5cmSg")).isExtensionHiddenByAppAccessRules)) || null, [
            data
        ]);
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const isSiteAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const hasPermissions = (0, $5uXOq.useMemo)(()=>(projectContext?.isProjectAdmin || isAdmin || isSiteAdmin) === true, [
            isAdmin,
            isSiteAdmin,
            projectContext?.isProjectAdmin
        ]);
        const context = (0, $5uXOq.useMemo)(()=>projectContext ? {
                projectKey: projectContext.projectKey,
                projectId: projectContext.projectId,
                projectName: projectContext.projectName,
                projectType: projectContext.projectType
            } : {}, [
            projectContext
        ]);
        (0, (0, parcelRequire("dvdr4")).useDisplayConditionsConsistencyCheck)(data, context, 'project-settings-forge-apps-hook');
        return (0, $5uXOq.useMemo)(()=>({
                data: projectSettingsData ? hasPermissions && projectSettingsData || [] : null,
                accessNarrowedData: accessNarrowedData,
                loading: loading,
                error: error
            }), [
            projectSettingsData,
            accessNarrowedData,
            loading,
            error,
            hasPermissions
        ]);
    };
    const $2106846b1818d2e6$export$bef2e514007d2f07 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $2106846b1818d2e6$export$5aac3b333ac18e0d, $2106846b1818d2e6$export$3c509d6dc1f63bbe);
    const $2106846b1818d2e6$var$appsProjectTypeRouteMap = {
        tmp: {
            [(0, (0, parcelRequire("2vSU6")).CORE_PROJECT)]: 'core',
            [(0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)]: 'software',
            [(0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)]: 'servicedesk',
            [(0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)]: undefined,
            [(0, (0, parcelRequire("2vSU6")).CUSTOMER_SERVICE_PROJECT)]: undefined
        },
        cmp: {
            [(0, (0, parcelRequire("2vSU6")).CORE_PROJECT)]: 'core',
            [(0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)]: 'software/c',
            [(0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)]: 'servicedesk',
            [(0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)]: undefined,
            [(0, (0, parcelRequire("2vSU6")).CUSTOMER_SERVICE_PROJECT)]: undefined
        }
    };
    const $2106846b1818d2e6$export$ed6342e0e28465a6 = (extension, projectType, projectKey, isSimplified)=>{
        const { appId: appId, envId: envId } = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(extension.id);
        return `/jira/${$2106846b1818d2e6$var$appsProjectTypeRouteMap[isSimplified ? 'tmp' : 'cmp'][projectType]}/projects/${projectKey}/settings/apps/${appId}/${envId}`;
    };
    const $2106846b1818d2e6$export$b741e3e3cfb39b82 = (routeName, parentStack)=>{
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const { data: data, loading: loading, error: error } = $2106846b1818d2e6$export$bef2e514007d2f07();
        const stack = (0, (0, parcelRequire("kKdpt")).useForgeItemStack)(data, routeName, parentStack);
        const { projectType: projectType, projectKey: projectKey, simplified: isSimplified } = projectContext || {};
        return (0, $5uXOq.useMemo)(()=>({
                data: data ? data.map((extension)=>({
                        id: extension.id,
                        url: $2106846b1818d2e6$export$ed6342e0e28465a6(extension, projectType, projectKey, isSimplified),
                        name: extension.properties.title,
                        iconUrl: extension.properties.icon,
                        environmentType: extension.environmentType,
                        environmentKey: extension.environmentKey,
                        moduleName: (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE),
                        sections: (0, (0, parcelRequire("7Tlti")).toSections)(extension)
                    })) : null,
                loading: loading,
                error: error,
                stack: stack
            }), [
            data,
            loading,
            error,
            stack,
            projectType,
            projectKey,
            isSimplified
        ]);
    };
});
parcelRegister("cNd4s", function(module, exports) {
    $parcel$export(module.exports, "useIsSiteAdmin", ()=>$3ad4a3e53b34f026$export$f9f8a5cdb0c565ef);
    var $9OXo1;
    const $3ad4a3e53b34f026$export$f9f8a5cdb0c565ef = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.isSiteAdmin || false;
    };
});
parcelRegister("bkw8F", function(module, exports) {
    $parcel$export(module.exports, "useFeatures", ()=>$7fc2f0545f0a83ac$export$4a39035bacc4ed76);
    $parcel$export(module.exports, "useSettingFeatures", ()=>$7fc2f0545f0a83ac$export$56022a3b83c8ed6a);
    $parcel$export(module.exports, "useReportFeatures", ()=>$7fc2f0545f0a83ac$export$4adaea9828b7ff13);
    var $5uXOq = parcelRequire("5uXOq");
    var $1J3t1;
    var $jIwth;
    var $iNzEe;
    var $daoB1;
    var $d4FZj;
    const $7fc2f0545f0a83ac$export$4a39035bacc4ed76 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useJiraWorkmanagementProjectNavigation)();
        const isPremiumUserSeat = (0, (0, parcelRequire("iNzEe")).useIsPremiumUserSeat)();
        const transformedData = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("d4FZj")).getExtraData)(data, isPremiumUserSeat), [
            data,
            isPremiumUserSeat
        ]);
        return {
            data: transformedData,
            loading: loading,
            error: error
        };
    };
    const $7fc2f0545f0a83ac$export$56022a3b83c8ed6a = ()=>{
        const hasActiveSoftwareAccess = (0, (0, parcelRequire("jIwth")).useHasActiveSoftwareAccess)();
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useJiraWorkmanagementProjectNavigation)();
        const transformedData = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("d4FZj")).getExtraSettingsData)(data, hasActiveSoftwareAccess), [
            data,
            hasActiveSoftwareAccess
        ]);
        return {
            data: transformedData,
            loading: loading,
            error: error
        };
    };
    const $7fc2f0545f0a83ac$export$4adaea9828b7ff13 = ()=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1J3t1")).useJiraWorkmanagementProjectNavigation)();
        const { hasSoftwareAccess: hasSoftwareAccess } = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        const transformedData = (0, $5uXOq.useMemo)(()=>data && (0, (0, parcelRequire("d4FZj")).getExtraReportData)(hasSoftwareAccess), [
            data,
            hasSoftwareAccess
        ]);
        return {
            data: transformedData,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("jIwth", function(module, exports) {
    $parcel$export(module.exports, "useHasActiveSoftwareAccess", ()=>$c3adde43a433f1b5$export$895f9b38ce00671e);
    var $k9JTq;
    var $daoB1;
    const $c3adde43a433f1b5$export$895f9b38ce00671e = ()=>{
        const { software: software } = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const { hasSoftwareAccess: hasSoftwareAccess } = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        return software !== 'UNLICENSED' && hasSoftwareAccess === true;
    };
});
parcelRegister("k9JTq", function(module, exports) {
    $parcel$export(module.exports, "useAppEditions", ()=>$dde261c9da85268a$export$92ed15881fc090d7);
    var $9OXo1;
    const $dde261c9da85268a$export$92ed15881fc090d7 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.appEditions;
    };
});
parcelRegister("d4FZj", function(module, exports) {
    $parcel$export(module.exports, "getExtraData", ()=>$acf9418ce967848e$export$6c55c6c980ed2046);
    $parcel$export(module.exports, "getExtraSettingsData", ()=>$acf9418ce967848e$export$b77a5597b7177cfb);
    $parcel$export(module.exports, "getExtraReportData", ()=>$acf9418ce967848e$export$be58a1e7b06d1d3);
    var $co1wz;
    const $acf9418ce967848e$export$6c55c6c980ed2046 = (data, isPremium)=>{
        const { permissionInfo: permissionInfo, hasComponents: hasComponents = false, project: project } = data;
        const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = permissionInfo;
        const isProjectOrJiraAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true || isAdmin;
        const isSimplifiedProject = project.simplified;
        const hasSettings = isAdmin || projectPermissionsQueried.ADMINISTER_PROJECTS || projectPermissionsQueried.EDIT_ISSUE_LAYOUT || projectPermissionsQueried.EDIT_WORKFLOW;
        return {
            hasVersions: true,
            hasSettings: (0, (0, parcelRequire("co1wz")).ff)('olympus-da-157-enable-project-settings-navigation_zxaq5') ? hasSettings : isProjectOrJiraAdmin,
            hasBoard: true,
            hasReports: true,
            hasAddItem: isProjectOrJiraAdmin,
            hasComponents: hasComponents,
            hasIssues: true,
            hasSummary: true,
            hasPages: true,
            hasChangeTheme: isProjectOrJiraAdmin,
            hasApprovals: isSimplifiedProject && (isPremium || isProjectOrJiraAdmin)
        };
    };
    const $acf9418ce967848e$export$b77a5597b7177cfb = (data, hasActiveSoftwareAccess)=>{
        const { isAdmin: isAdmin, projectPermissionsQueried: projectPermissionsQueried } = data.permissionInfo;
        const isProjectAdmin = projectPermissionsQueried.ADMINISTER_PROJECTS === true;
        const isProjectOrJiraAdmin = isProjectAdmin || isAdmin;
        const hasEditWorkflowPermissions = projectPermissionsQueried.EDIT_WORKFLOW === true;
        const hasIssueLayoutPermissions = projectPermissionsQueried.EDIT_ISSUE_LAYOUT === true;
        const hasDetails = isProjectOrJiraAdmin;
        const hasPeople = isProjectOrJiraAdmin;
        const hasIssueTypes = isAdmin;
        let hasAutomation = true;
        let hasSummary = true;
        let hasWorkflows = true;
        let hasScreens = true;
        let hasFields = true;
        let hasVersions = true;
        let hasComponents = true;
        let hasPermissions = true;
        let hasIssueSecurity = true;
        let hasNotifications = true;
        let hasIssueCollectors = true;
        let hasIssueLayout = true;
        const hasDevtools = isProjectAdmin && hasActiveSoftwareAccess;
        if ((0, (0, parcelRequire("co1wz")).ff)('olympus-da-157-enable-project-settings-navigation_zxaq5')) {
            hasAutomation = isProjectOrJiraAdmin;
            hasSummary = isProjectOrJiraAdmin;
            hasWorkflows = hasEditWorkflowPermissions || isProjectOrJiraAdmin;
            hasScreens = isProjectOrJiraAdmin;
            hasFields = isProjectOrJiraAdmin;
            hasVersions = isProjectOrJiraAdmin;
            hasComponents = isProjectOrJiraAdmin;
            hasPermissions = isProjectOrJiraAdmin;
            hasIssueSecurity = isProjectOrJiraAdmin;
            hasNotifications = isProjectOrJiraAdmin;
            hasIssueCollectors = isProjectOrJiraAdmin;
            hasIssueLayout = hasIssueLayoutPermissions || isProjectOrJiraAdmin;
        }
        return {
            hasAutomation: hasAutomation,
            hasProjectGroupOneSection: hasDetails || hasPeople || hasSummary,
            hasIssueConfigSection: hasIssueTypes,
            hasProjectGroupTwoSection: hasWorkflows || hasScreens || hasFields,
            hasProjectGroupThreeSection: hasVersions || hasComponents,
            hasProjectGroupFourSection: hasPermissions || hasIssueSecurity || hasNotifications,
            hasgetIssueCollectorSection: hasIssueCollectors,
            hasComponents: hasComponents,
            hasDetails: hasDetails,
            hasFields: hasFields,
            hasIssueCollectors: hasIssueCollectors,
            hasIssueSecurity: hasIssueSecurity,
            hasIssueTypes: hasIssueTypes,
            hasNotifications: hasNotifications,
            hasPeople: hasPeople,
            hasPermissions: hasPermissions,
            hasScreens: hasScreens,
            hasSummary: hasSummary,
            hasVersions: hasVersions,
            hasWorkflows: hasWorkflows,
            hasDevtools: hasDevtools,
            hasIssueLayout: hasIssueLayout
        };
    };
    const $acf9418ce967848e$export$be58a1e7b06d1d3 = (hasSoftwareAccess)=>({
            hasDeveloperWorkload: true,
            hasForcastSection: true,
            hasTimeTracking: true,
            hasVersionWorkloadReport: hasSoftwareAccess
        });
});
parcelRegister("74Yye", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d2a068828302038$export$2e2bcd8739ae039);
    var $lpwtK;
    var $7OqB4;
    const $3d2a068828302038$var$useProject = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("lpwtK")).useProject));
    var $3d2a068828302038$export$2e2bcd8739ae039 = $3d2a068828302038$var$useProject;
});
parcelRegister("iCrgB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$116dde1e3871ac6a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6CJbV;
    var $cZXEh;
    var $koVbs;
    var $3tHFY;
    var $gZbSF;
    var $8yg0C;
    var $cqRWX;
    const $116dde1e3871ac6a$var$ConnectAppMenu = ({ stack: stack, project: project, onStackChange: onStackChange })=>{
        (0, (0, parcelRequire("8yg0C")).default)();
        const { data: connectItems, stack: connectStack, selected: selectedConnectApp } = (0, (0, parcelRequire("gZbSF")).useProjectConnectItems)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const projectKey = String(project?.key);
        const getBackMenuItem = (0, $5uXOq.useCallback)(()=>({
                href: `/jira/core/projects/${projectKey}`,
                title: formatMessage((0, (0, parcelRequire("cqRWX")).messages).itemBack)
            }), [
            formatMessage,
            projectKey
        ]);
        if (connectStack != null && connectStack.length > 0 && selectedConnectApp != null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6CJbV")).default), {
            stack: stack,
            onChange: onStackChange
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3tHFY")).ConnectMenu), {
            items: connectItems,
            showIcons: true,
            overrides: {
                BackMenuItem: getBackMenuItem(),
                navigateOnBackMenuItemClick: true
            }
        })));
        return null;
    };
    var $116dde1e3871ac6a$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($116dde1e3871ac6a$var$ConnectAppMenu);
});
parcelRegister("8yg0C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$389170a5379f53c2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $gPQRI;
    const $389170a5379f53c2$var$useAutoExpandSidebar = ()=>{
        const { expandLeftSidebar: expandLeftSidebar } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarController)();
        const { isCollapsed: isCollapsed } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        const sidebarExpandedRef = (0, $5uXOq.useRef)(!isCollapsed);
        (0, $5uXOq.useEffect)(()=>{
            if (!sidebarExpandedRef.current && isCollapsed) {
                expandLeftSidebar();
                sidebarExpandedRef.current = true;
            }
        }, [
            expandLeftSidebar,
            isCollapsed
        ]);
    };
    var $389170a5379f53c2$export$2e2bcd8739ae039 = $389170a5379f53c2$var$useAutoExpandSidebar;
});
parcelRegister("cqRWX", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$dd966ae40fe1732a$export$defe85febe8b728c);
    var $7VHMR;
    const $dd966ae40fe1732a$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        itemBack: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.connect-app-menu.item-back",
            "defaultMessage": "Back to project"
        }
    });
});
parcelRegister("2U3dG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$46153d687d6c578f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $65Ltd;
    var $7XYc4;
    var $4R6GH;
    var $5cmSg;
    var $5bkvv;
    var $ih1Yr;
    var $231OU;
    var $8zgGo;
    var $6jY6G;
    var $dIdda = parcelRequire("dIdda");
    var $8yg0C;
    const $46153d687d6c578f$var$ForgeMenuV1 = ()=>{
        (0, (0, parcelRequire("8yg0C")).default)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: forgeResourceData } = (0, $dIdda.useResource)((0, (0, parcelRequire("5bkvv")).forgeProjectModuleV1Resource));
        const projectData = (0, $5uXOq.useMemo)(()=>forgeResourceData?.extensions || null, [
            forgeResourceData
        ]);
        const selectedForgeApp = (0, (0, parcelRequire("ih1Yr")).useForgeSelectedApp)(projectData, route.name);
        const { stack: forgeStack } = (0, (0, parcelRequire("231OU")).useProjectForgeApps)((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT));
        if (selectedForgeApp != null && forgeStack != null && forgeStack.length > 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8zgGo")).ForgeProjectSection), {
            overrides: {
                showSelectedAppMenuOnly: true,
                selectedApp: selectedForgeApp
            }
        });
        return null;
    };
    const $46153d687d6c578f$var$ForgeMenuV2 = ()=>{
        (0, (0, parcelRequire("8yg0C")).default)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: forgeResourceData } = (0, $dIdda.useResource)((0, (0, parcelRequire("5bkvv")).forgeProjectModuleV2Resource));
        const projectData = (0, $5uXOq.useMemo)(()=>forgeResourceData?.filter?.((0, (0, parcelRequire("5cmSg")).isExtensionVisible)) || null, [
            forgeResourceData
        ]);
        const selectedForgeApp = (0, (0, parcelRequire("ih1Yr")).useForgeSelectedApp)(projectData, route.name);
        const { stack: forgeStack } = (0, (0, parcelRequire("231OU")).useProjectForgeApps)((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_FORGE_PROJECT));
        if (selectedForgeApp != null && forgeStack != null && forgeStack.length > 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8zgGo")).ForgeProjectSection), {
            overrides: {
                showSelectedAppMenuOnly: true,
                selectedApp: selectedForgeApp
            }
        });
        return null;
    };
    const $46153d687d6c578f$var$ForgeMenu = (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('new_graphql_endpoint_for_fetching_forge_modules'), $46153d687d6c578f$var$ForgeMenuV2, $46153d687d6c578f$var$ForgeMenuV1);
    var $46153d687d6c578f$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($46153d687d6c578f$var$ForgeMenu);
});
parcelRegister("ih1Yr", function(module, exports) {
    $parcel$export(module.exports, "useForgeSelectedApp", ()=>$b1393ffdd951bcc8$export$e6dee8b777476118);
    var $c70gQ;
    var $dIdda = parcelRequire("dIdda");
    const $b1393ffdd951bcc8$export$e6dee8b777476118 = (modules, routeName)=>{
        const [{ match: match, route: route }] = (0, $dIdda.useRouter)();
        const matchedExtension = (0, (0, parcelRequire("c70gQ")).useMatchedExtension)({
            modules: modules,
            match: match
        });
        if (route.name !== routeName || matchedExtension == null) return null;
        return matchedExtension;
    };
});
parcelRegister("8zgGo", function(module, exports) {
    $parcel$export(module.exports, "ForgeProjectSection", ()=>$4cec53abbd9c3c33$export$fb7da191295a7e22);
    var $5uXOq = parcelRequire("5uXOq");
    var $cZXEh;
    var $2vSU6;
    var $1rTGO;
    var $bXK4r;
    var $k2DRb;
    var $e0AC8;
    var $koVbs;
    var $dAfqg;
    var $k51JQ;
    var $7Tlti;
    var $231OU;
    var $kBPYs;
    const $4cec53abbd9c3c33$var$projectTypeRouteMap = {
        [(0, (0, parcelRequire("2vSU6")).CORE_PROJECT)]: 'core',
        [(0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)]: 'software',
        [(0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)]: 'servicedesk'
    };
    const $4cec53abbd9c3c33$export$ed6342e0e28465a6 = (extension, projectType, projectKey)=>{
        const { appId: appId, envId: envId } = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(extension.id);
        return `/jira/${$4cec53abbd9c3c33$var$projectTypeRouteMap[projectType]}/projects/${projectKey}/apps/${appId}/${envId}`;
    };
    const $4cec53abbd9c3c33$export$fb7da191295a7e22 = ({ nestedMenuActive: nestedMenuActive, overrides: overrides })=>{
        const { data: data } = (0, (0, parcelRequire("231OU")).useProjectForgeApps)();
        const { data: projectContextData } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const filteredForgeAppsData = (0, $5uXOq.useMemo)(()=>overrides?.showSelectedAppMenuOnly && overrides?.selectedApp != null ? [
                overrides.selectedApp
            ] : data || [], [
            data,
            overrides
        ]);
        if (!data?.length || !projectContextData) return null;
        const { projectKey: projectKey, projectType: projectType } = projectContextData;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bXK4r")).TriggerAnalyticsWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), {
            title: overrides?.showSelectedAppMenuOnly ? undefined : formatMessage((0, (0, parcelRequire("kBPYs")).messages).forgeSectionTitle)
        }, filteredForgeAppsData.map((extension)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k51JQ")).ForgeItem), {
                key: extension.id,
                id: extension.id,
                environmentType: extension.environmentType,
                environmentKey: extension.environmentKey,
                url: $4cec53abbd9c3c33$export$ed6342e0e28465a6(extension, projectType, projectKey),
                name: extension.properties.title,
                sections: (0, (0, parcelRequire("7Tlti")).toSections)(extension),
                moduleName: (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE),
                iconUrl: extension.properties.icon,
                showIcon: true,
                nestedMenuActive: nestedMenuActive,
                overrides: overrides
            })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeScreenEvent), {
            attributes: {
                moduleType: (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE)
            }
        })));
    };
});
parcelRegister("1rTGO", function(module, exports) {
    $parcel$export(module.exports, "ForgeScreenEvent", ()=>$abbdb580491d9d09$export$92d758d83665314b);
    $parcel$export(module.exports, "ForgeOperationaFailedEvent", ()=>$abbdb580491d9d09$export$a238c3c13f29c134);
    $parcel$export(module.exports, "ForgeErrorBoundary", ()=>$abbdb580491d9d09$export$ac7e7464cefab440);
    $parcel$export(module.exports, "ForgeAnalyticsWrapper", ()=>$abbdb580491d9d09$export$ad2a5d9127152fb8);
    $parcel$export(module.exports, "withMetrics", ()=>$abbdb580491d9d09$export$14e56d7f5d3f917c);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $k2DRb;
    var $3mOWa;
    var $eOGyv;
    var $iXVV6;
    var $8zOmE;
    var $5oFIy;
    var $isuse;
    var $hBuqR;
    var $9BrHy;
    var $6MtPV;
    var $dd7Uh;
    var $2RhPB;
    var $8kVg1;
    const $abbdb580491d9d09$export$92d758d83665314b = ({ attributes: attributes })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), {
            attributes: (0, (0, parcelRequire("6MtPV")).createAttributes)(attributes)
        });
    const $abbdb580491d9d09$export$a238c3c13f29c134 = ({ eventId: eventId, attributes: attributes })=>{
        (0, (0, parcelRequire("dd7Uh")).fireOperationalFailedEvent)({
            eventId: eventId,
            attributes: attributes
        });
        return null;
    };
    const $abbdb580491d9d09$export$4c46624a93517c10 = ({ eventId: eventId, action: action, attributes: attributes })=>{
        const hasForgeAccess = (0, (0, parcelRequire("eOGyv")).useHasForgeAccess)();
        const analyticsAttributes = (0, (0, parcelRequire("6MtPV")).createAttributes)({
            ...attributes,
            hasForgeAccess: hasForgeAccess
        });
        const fireEvent = (0, $5uXOq.useCallback)((analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(analyticsEvent, (0, (0, parcelRequire("9BrHy")).getEventActionName)(eventId, action), analyticsAttributes);
        }, [
            eventId,
            action,
            analyticsAttributes
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("isuse")).MountEvent), {
            onMount: fireEvent
        });
    };
    const $abbdb580491d9d09$export$f461e628d5e73fa0 = ({ children: children, eventId: eventId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: `${(0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3)}.${eventId}`
        }, children);
    const $abbdb580491d9d09$export$ac7e7464cefab440 = ({ children: children, eventId: eventId, attributes: attributes, onError: onError, errorFallback: errorFallback, resetCaughtError: resetCaughtError })=>{
        const fallback = (0, $5uXOq.useMemo)(()=>errorFallback || 'unmount', [
            errorFallback
        ]);
        const getAttributes = (0, $5uXOq.useCallback)((error)=>(0, (0, parcelRequire("6MtPV")).createAttributes)({
                ...attributes,
                error: error
            }), [
            attributes
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: eventId,
            packageName: (0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3),
            teamName: "smite",
            fallback: fallback,
            attributes: getAttributes,
            onError: onError,
            resetCaughtError: resetCaughtError
        }, children);
    };
    const $abbdb580491d9d09$export$ad2a5d9127152fb8 = ({ children: children, module: module, entryPoint: entryPoint, attributes: attributes, moduleType: moduleType = (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_EXTENSION), errorFallback: errorFallback = 'unmount', shouldFireInitializedEvent: shouldFireInitializedEvent = false, resetCaughtError: resetCaughtError })=>{
        const eventId = (0, (0, parcelRequire("9BrHy")).getEventId)({
            module: module,
            moduleType: moduleType,
            entryPoint: entryPoint
        });
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("6MtPV")).createAttributes)(attributes), [
            attributes
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$f461e628d5e73fa0, {
            eventId: eventId
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$ac7e7464cefab440, {
            eventId: eventId,
            attributes: analyticsAttributes,
            errorFallback: errorFallback,
            resetCaughtError: resetCaughtError
        }, shouldFireInitializedEvent && (0, ($parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$4c46624a93517c10, {
            eventId: eventId,
            action: "initialized",
            attributes: analyticsAttributes
        }), children));
    };
    function $abbdb580491d9d09$var$isExtensionTimeMeasuredFromTriggerClick(extensionModule, entryPoint, attributes) {
        if ((extensionModule === (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE) || extensionModule === (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE)) && (entryPoint !== 'edit' || attributes.renderContext === 'issue-create')) return false;
        if (extensionModule === (0, (0, parcelRequire("k2DRb")).ISSUE_PANEL_MODULE) && !attributes?.isNewToIssue) return false;
        return [
            (0, (0, parcelRequire("k2DRb")).GLOBAL_PAGE_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_ACTION_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_ACTIVITY_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_GLANCE_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_CONTEXT_MODULE),
            (0, (0, parcelRequire("k2DRb")).ISSUE_PANEL_MODULE),
            (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_MODULE),
            (0, (0, parcelRequire("k2DRb")).CUSTOM_FIELD_TYPE_MODULE),
            (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE),
            (0, (0, parcelRequire("k2DRb")).ADMIN_PAGE_MODULE),
            (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE)
        ].includes(extensionModule);
    }
    const $abbdb580491d9d09$export$14e56d7f5d3f917c = (Component)=>(props)=>{
            const startTime = (0, $5uXOq.useRef)(performance.now());
            const isCustomUI = (0, (0, parcelRequire("3mOWa")).isCustomUIExtension)(props.extension, props.entryPoint);
            const [isExtensionRendered, setExtensionRendered] = (0, $5uXOq.useState)(false);
            const { module: module, entryPoint: entryPoint, analyticsAttributes: analyticsAttributes, localId: localId = '', onInitialRender: onInitialRender, onLoad: onLoad, extension: extension } = props;
            const extensionId = props.extension?.id;
            const eventId = (0, (0, parcelRequire("9BrHy")).getEventId)({
                module: module,
                entryPoint: entryPoint
            });
            const browserMetricsEventId = (0, (0, parcelRequire("9BrHy")).getBrowserMetricsEventId)({
                module: module,
                entryPoint: entryPoint,
                forgeUiType: (0, (0, parcelRequire("3mOWa")).getForgeUIType)(extension, entryPoint)
            });
            const attributes = (0, $5uXOq.useMemo)(()=>({
                    ...analyticsAttributes,
                    ...(0, (0, parcelRequire("2RhPB")).getAnalyticsAttributesFromExtension)(extension, entryPoint)
                }), [
                analyticsAttributes,
                entryPoint,
                extension.id,
                isCustomUI
            ]);
            (0, $5uXOq.useEffect)(()=>{
                if (!$abbdb580491d9d09$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId) (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(extensionId).start({
                    startTime: startTime.current
                });
            }, []);
            const onError = (0, $5uXOq.useCallback)(()=>{
                extensionId && (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(extensionId).cancel();
            }, [
                extensionId
            ]);
            const onInitialRenderUiKitWithMetrics = (0, $5uXOq.useCallback)((payload)=>{
                onInitialRender && onInitialRender(payload);
                if (payload?.error == null) {
                    const stopTimeDeduction = payload?.appTime || 0;
                    setExtensionRendered(true);
                    extensionId && (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(extensionId).stop({
                        stopTime: performance.now() - stopTimeDeduction,
                        customData: {
                            eventId: browserMetricsEventId
                        }
                    });
                } else {
                    onError();
                    (0, (0, parcelRequire("dd7Uh")).fireOperationalFailedEvent)({
                        eventId: eventId,
                        attributes: {
                            error: new Error(payload.error),
                            ...attributes
                        }
                    });
                }
            }, [
                onInitialRender,
                extensionId,
                browserMetricsEventId,
                onError,
                eventId,
                attributes
            ]);
            const onLoadCustomUiWithMetrics = (0, $5uXOq.useCallback)(()=>{
                onLoad && onLoad();
                setExtensionRendered(true);
                extensionId && (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(extensionId).stop({
                    stopTime: performance.now(),
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
            }, [
                analyticsAttributes,
                extensionId,
                localId,
                onLoad
            ]);
            return (0, ($parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$f461e628d5e73fa0, {
                eventId: eventId
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(Component, {
                ...props,
                ...isCustomUI ? {
                    onLoad: onLoadCustomUiWithMetrics
                } : {
                    onInitialRender: onInitialRenderUiKitWithMetrics
                }
            }), isExtensionRendered && (0, ($parcel$interopDefault($5uXOq))).createElement($abbdb580491d9d09$export$92d758d83665314b, {
                attributes: attributes
            }));
        };
});
parcelRegister("3mOWa", function(module, exports) {
    $parcel$export(module.exports, "getForgeUIType", ()=>$e79bbc527e600bd1$export$aed4d8a86badbf61);
    $parcel$export(module.exports, "isCustomUIExtension", ()=>$e79bbc527e600bd1$export$edb00cfe4962b026);
    $parcel$export(module.exports, "isNativeUiExtension", ()=>$e79bbc527e600bd1$export$2ecba06e617fea0a);
    $parcel$export(module.exports, "overrideExtension", ()=>$e79bbc527e600bd1$export$42b85bc9b386c977);
    var $gccSB = parcelRequire("gccSB");
    const $e79bbc527e600bd1$export$aed4d8a86badbf61 = (extension, entryPoint = '')=>{
        const { render: render, resource: resource } = extension.properties;
        if (entryPoint && extension.properties[entryPoint]) {
            const { resource: entryPointResource, render: entryPointRender } = extension.properties[entryPoint];
            if (entryPointResource == null) return 'ui-kit';
            if (entryPointRender === 'native') return 'native-ui';
            return 'custom-ui';
        }
        if (resource == null) return 'ui-kit';
        if (render === 'native') return 'native-ui';
        return 'custom-ui';
    };
    const $e79bbc527e600bd1$export$edb00cfe4962b026 = (extension, entryPoint = '')=>$e79bbc527e600bd1$export$aed4d8a86badbf61(extension, entryPoint) === 'custom-ui';
    const $e79bbc527e600bd1$export$2ecba06e617fea0a = (extension, entryPoint = '')=>$e79bbc527e600bd1$export$aed4d8a86badbf61(extension, entryPoint) === 'native-ui';
    const $e79bbc527e600bd1$export$42b85bc9b386c977 = (extension, propsToOverride)=>{
        if (extension == null) return extension;
        if ((0, ($parcel$interopDefault($gccSB)))(propsToOverride)) return extension;
        const { resource: resource, requiresUserConsent: requiresUserConsent } = propsToOverride;
        const extensionCopy = {
            ...extension,
            properties: {
                ...extension.properties
            },
            requiresUserConsent: requiresUserConsent
        };
        if (resource != null) extensionCopy.properties.resource = resource;
        return extensionCopy;
    };
});
parcelRegister("eOGyv", function(module, exports) {
    $parcel$export(module.exports, "useHasForgeAccess", ()=>$5bef20cd08fcb4ca$export$fd7f94d3d2bac7f2);
    var $cZpsT;
    const $5bef20cd08fcb4ca$export$fd7f94d3d2bac7f2 = ()=>{
        const isAnonymous = (0, (0, parcelRequire("cZpsT")).useIsAnonymous)();
        return !isAnonymous;
    };
});
parcelRegister("isuse", function(module, exports) {
    $parcel$export(module.exports, "MountEvent", ()=>$1df0619a43ad69d9$export$2c6963927dbc68f1);
    var $5uXOq = parcelRequire("5uXOq");
    var $fpTxz;
    class $1df0619a43ad69d9$var$MountEventComponent extends (0, $5uXOq.Component) {
        componentDidMount() {
            const analyticsEvent = this.props.createAnalyticsEvent({
                action: 'mounted'
            });
            if (this.props.onMount) this.props.onMount(analyticsEvent);
        }
        render() {
            return null;
        }
    }
    const $1df0619a43ad69d9$export$2c6963927dbc68f1 = (0, (0, parcelRequire("fpTxz")).default)()($1df0619a43ad69d9$var$MountEventComponent);
});
parcelRegister("9BrHy", function(module, exports) {
    $parcel$export(module.exports, "getEventId", ()=>$10bc2a9e37d5a5bb$export$5639f6a927500d9);
    $parcel$export(module.exports, "getBrowserMetricsEventId", ()=>$10bc2a9e37d5a5bb$export$25830fc7d037f0f2);
    $parcel$export(module.exports, "getEventActionName", ()=>$10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1);
    var $k2DRb;
    var $6yg2S;
    var $hBuqR;
    const $10bc2a9e37d5a5bb$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
    const $10bc2a9e37d5a5bb$var$prepareModuleMode = (entryPoint)=>`${$10bc2a9e37d5a5bb$var$capitalizeFirstLetter(entryPoint)}`;
    const $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
    const $10bc2a9e37d5a5bb$var$prepareModuleName = (moduleName)=>(0, (0, parcelRequire("k2DRb")).SUPPORTED_MODULES).includes(moduleName) ? $10bc2a9e37d5a5bb$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
    const $10bc2a9e37d5a5bb$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
        const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
        return (0, (0, parcelRequire("6yg2S")).toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
    };
    const $10bc2a9e37d5a5bb$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>(0, (0, parcelRequire("6yg2S")).toEventId)(`${$10bc2a9e37d5a5bb$var$prepareModuleName(module)}${$10bc2a9e37d5a5bb$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
    const $10bc2a9e37d5a5bb$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, (0, parcelRequire("hBuqR")).PACKAGE_NAME_GASV3}.${eventId} ${action}`;
});
parcelRegister("dd7Uh", function(module, exports) {
    $parcel$export(module.exports, "fireOperationalFailedEvent", ()=>$7d829a81d29f9e72$export$add44f896fb31ba3);
    var $hBuqR;
    var $8uOa6;
    const $7d829a81d29f9e72$export$add44f896fb31ba3 = ({ eventId: eventId, attributes: attributes })=>{
        (0, (0, parcelRequire("8uOa6")).fireOperationalEvent)((0, (0, parcelRequire("hBuqR")).OPERATIONAL_ACTIONS).FAILED, {
            id: eventId,
            attributes: attributes
        });
    };
});
parcelRegister("2RhPB", function(module, exports) {
    $parcel$export(module.exports, "getAnalyticsAttributesFromExtension", ()=>$3fba0b567cec1fe0$export$5d3b06ab08af139e);
    var $3mOWa;
    var $e0AC8;
    const $3fba0b567cec1fe0$export$5d3b06ab08af139e = (extension, entryPoint)=>{
        const { appId: appId, envId: envId } = (0, (0, parcelRequire("e0AC8")).parseExtensionId)(extension.id);
        return {
            appId: appId,
            envId: envId,
            forgeType: (0, (0, parcelRequire("3mOWa")).getForgeUIType)(extension, entryPoint),
            envType: extension?.environmentType
        };
    };
});
parcelRegister("bXK4r", function(module, exports) {
    $parcel$export(module.exports, "ViewAnalyticsWrapper", ()=>$488beba58e0bb189$export$c794eb4124961145);
    $parcel$export(module.exports, "TriggerAnalyticsWrapper", ()=>$488beba58e0bb189$export$e1a79e3d472c925a);
    var $5uXOq = parcelRequire("5uXOq");
    var $k2DRb;
    var $1rTGO;
    var $hBuqR;
    const $488beba58e0bb189$export$c794eb4124961145 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeAnalyticsWrapper), {
            module: (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE),
            shouldFireInitializedEvent: true,
            ...props
        });
    const $488beba58e0bb189$export$e1a79e3d472c925a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeAnalyticsWrapper), {
            module: (0, (0, parcelRequire("k2DRb")).PROJECT_PAGE_MODULE),
            moduleType: (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_TRIGGER),
            ...props
        });
});
parcelRegister("k51JQ", function(module, exports) {
    $parcel$export(module.exports, "ForgeSubpagesView", ()=>$b3f0da209e047dcf$export$9711365f685f75c0);
    $parcel$export(module.exports, "ForgeItem", ()=>$b3f0da209e047dcf$export$26a5287439a1d287);
    var $5uXOq = parcelRequire("5uXOq");
    var $dfL30;
    var $cZXEh;
    var $gwIPs;
    var $8kVg1;
    var $fl3Yy;
    var $k0ZZ2;
    var $jv9Yy;
    var $8iQMc;
    var $kZj7F;
    var $4OCke;
    var $6ucD2;
    const $b3f0da209e047dcf$export$9ffb311b483a1e2b = (extensionBaseUrl, route)=>route ? `${extensionBaseUrl}/${String(route).trim().replace(/^\/+/, '')}` : extensionBaseUrl;
    const $b3f0da209e047dcf$export$f04a61298a47a40f = ({ url: url })=>url != null && String(url).trim().length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6ucD2")).ForgeIcon), {
            alt: "",
            src: url
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("dfL30"))))), {
            label: ""
        });
    const $b3f0da209e047dcf$export$df3259e43d89ee7b = (props)=>{
        const { showIcon: showIcon, id: itemId, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, url: url, name: name, moduleName: moduleName, overrides: overrides } = props;
        if (overrides?.showSelectedAppMenuOnly) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            iconBefore: showIcon ? (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$f04a61298a47a40f, {
                url: iconUrl
            }) : null,
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fl3Yy")).EnvironmentLozenge), {
                environmentType: environmentType
            }),
            href: url,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchPartialUrlPathname)(),
            analytics: {
                itemId: itemId,
                itemType: 'forge',
                module: moduleName
            },
            onClick: ()=>{
                (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(itemId).start({
                    startTime: performance.now()
                });
            }
        }, (0, (0, parcelRequire("fl3Yy")).nameWithCustomEnvironment)(name, environmentType, environmentKey));
    };
    const $b3f0da209e047dcf$var$nestedHeaderAlignmentFix = ()=>({
            paddingLeft: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 2.625}px`
        });
    const $b3f0da209e047dcf$export$961eebe0deda9ad3 = ({ ForgePageHeader: ForgePageHeader = (0, (0, parcelRequire("8iQMc")).ForgePageHeader), iconUrl: iconUrl, name: name, environmentType: environmentType, environmentKey: environmentKey, nestedMenuActive: nestedMenuActive })=>(0, ($parcel$interopDefault($5uXOq))).createElement(ForgePageHeader, {
            avatarUrl: iconUrl || '',
            name: name,
            environmentType: environmentType,
            environmentKey: environmentKey,
            cssFn: typeof nestedMenuActive === 'boolean' && Boolean(nestedMenuActive) ? $b3f0da209e047dcf$var$nestedHeaderAlignmentFix : undefined
        });
    const $b3f0da209e047dcf$export$9711365f685f75c0 = (props)=>{
        const { showIcon: showIcon, id: itemId, url: url, sections: sections, moduleName: moduleName } = props;
        const selectedOn = (0, $5uXOq.useCallback)((route)=>[
                '',
                '/'
            ].includes(String(route || '').trim()) ? (currentLocation, itemLocation)=>currentLocation.pathname.replace(/\/$/, '') === itemLocation.pathname.replace(/\/$/, '') : (0, (0, parcelRequire("4OCke")).matchPartialUrlPathname)(), []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6ucD2")).ForgeSubpagesContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$961eebe0deda9ad3, props), sections?.map((section, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), {
                key: index
            }, typeof section.header === 'string' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jv9Yy")).SectionHeader), null, section.header) : null, section.pages.map((page)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
                    key: page.route,
                    iconBefore: showIcon ? (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$f04a61298a47a40f, {
                        url: page.icon
                    }) : null,
                    href: $b3f0da209e047dcf$export$9ffb311b483a1e2b(url, page.route),
                    selectedOn: selectedOn(page.route),
                    analytics: {
                        itemId: itemId,
                        itemType: 'forge',
                        module: moduleName
                    },
                    onClick: ()=>{
                        (0, (0, parcelRequire("8kVg1")).forgeModulesConcurrentLoadTime)(itemId).start({
                            startTime: performance.now()
                        });
                    }
                }, page.title)))));
    };
    const $b3f0da209e047dcf$export$26a5287439a1d287 = (props)=>{
        const { showIcon: showIcon, id: itemId, url: url, iconUrl: iconUrl, environmentType: environmentType, environmentKey: environmentKey, name: name, sections: sections, overrides: overrides } = props;
        const selectedOn = (0, $5uXOq.useCallback)((currentLocation)=>currentLocation.pathname.includes(url), [
            url
        ]);
        const onNestedMenuItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (overrides?.ParentMenuItem?.onClick) overrides.ParentMenuItem.onClick(event);
        }, [
            overrides
        ]);
        if (!sections?.length) return (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$df3259e43d89ee7b, props);
        if (overrides?.showSelectedAppMenuOnly) return (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$9711365f685f75c0, props);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kZj7F")).NestingMenuItem), {
            analytics: {
                itemId: 'subpages'
            },
            id: `${itemId}-subpages`,
            iconBefore: showIcon ? (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$f04a61298a47a40f, {
                url: iconUrl
            }) : null,
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fl3Yy")).EnvironmentLozenge), {
                environmentType: environmentType
            }),
            title: (0, (0, parcelRequire("fl3Yy")).nameWithCustomEnvironment)(name, environmentType, environmentKey),
            selectedOn: selectedOn,
            onClick: onNestedMenuItemClick,
            overrides: overrides
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($b3f0da209e047dcf$export$9711365f685f75c0, props));
    };
});
parcelRegister("fl3Yy", function(module, exports) {
    $parcel$export(module.exports, "EnvironmentLozenge", ()=>$730173a4987fa3e4$export$278f8e01799d0418);
    $parcel$export(module.exports, "nameWithCustomEnvironment", ()=>$730173a4987fa3e4$export$f9338c21ba7c7334);
    var $5uXOq = parcelRequire("5uXOq");
    var $eddAM;
    var $k2DRb;
    var $ousew;
    var $8Je4V;
    const $730173a4987fa3e4$export$50589a87e4fb3dae = (environmentType)=>{
        switch(environmentType){
            case 0, (0, parcelRequire("k2DRb")).DEVELOPMENT_ENVIRONMENT:
                return (0, (0, parcelRequire("8Je4V")).messages).developmentEnvironmentLozenge;
            case 0, (0, parcelRequire("k2DRb")).STAGING_ENVIRONMENT:
                return (0, (0, parcelRequire("8Je4V")).messages).stagingEnvironmentLozenge;
            default:
                return null;
        }
    };
    const $730173a4987fa3e4$export$278f8e01799d0418 = (props)=>{
        const { environmentType: environmentType } = props;
        const labelKey = $730173a4987fa3e4$export$50589a87e4fb3dae(environmentType);
        return labelKey ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eddAM")).default), {
            testId: "forge-ui-extension-title.ui.environment-lozenge.lozenge",
            appearance: environmentType === (0, (0, parcelRequire("k2DRb")).DEVELOPMENT_ENVIRONMENT) ? 'default' : 'moved'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), labelKey)) : null;
    };
    const $730173a4987fa3e4$export$f9338c21ba7c7334 = (name, environmentType, environmentKey)=>{
        if (environmentType === (0, (0, parcelRequire("k2DRb")).DEVELOPMENT_ENVIRONMENT) && environmentKey && environmentKey !== (0, (0, parcelRequire("k2DRb")).DEFAULT_ENVIRONMENT_KEY)) return `${name} - ${environmentKey}`;
        return name;
    };
});
parcelRegister("8Je4V", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$838ac71f7259b5ef$export$defe85febe8b728c);
    var $7VHMR;
    const $838ac71f7259b5ef$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        developmentEnvironmentLozenge: {
            "id": "forge-ui-extension-title.environment-lozenge.development-environment-lozenge",
            "defaultMessage": "DEV"
        },
        stagingEnvironmentLozenge: {
            "id": "forge-ui-extension-title.environment-lozenge.staging-environment-lozenge",
            "defaultMessage": "STG"
        }
    });
});
parcelRegister("jv9Yy", function(module, exports) {
    $parcel$export(module.exports, "SectionHeader", ()=>$c634a42deba697de$export$8adb256d999cd5a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $j2rAW;
    var $fpoBX;
    var $2WgzA;
    const $c634a42deba697de$export$8adb256d999cd5a0 = ({ children: children })=>{
        const theme = (0, (0, parcelRequire("fpoBX")).useSidebarTheme)();
        const cssFn = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("2WgzA")).generateCustomThemeCssFn)(theme), [
            theme
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j2rAW")).default), {
            cssFn: cssFn
        }, children);
    };
});
parcelRegister("j2rAW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eca05d12f251c3e5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6OAh1;
    var $1WrCb;
    var $6onh1;
    const $eca05d12f251c3e5$var$HeadingItem = (props)=>{
        const { shouldRender: shouldRender } = (0, (0, parcelRequire("6onh1")).useShouldNestedElementRender)();
        if (!shouldRender) return null;
        const cssFn = (0, (0, parcelRequire("1WrCb")).overrideStyleFunction)((0, (0, parcelRequire("1WrCb")).sectionHeaderSpacingStyles), props.cssFn);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6OAh1")).default), {
            ...props,
            cssFn: cssFn
        });
    };
    var $eca05d12f251c3e5$export$2e2bcd8739ae039 = $eca05d12f251c3e5$var$HeadingItem;
});
parcelRegister("2WgzA", function(module, exports) {
    $parcel$export(module.exports, "generateCustomThemeCssFn", ()=>$e23e3f934bc5813e$export$5ae7d20da3003de);
    var $1UikQ = parcelRequire("1UikQ");
    var $ai0LF;
    const $e23e3f934bc5813e$export$5ae7d20da3003de = (theme)=>(0, (0, parcelRequire("ai0LF")).castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
            if (theme?.navigation) {
                const { navigation: { item: item } } = theme;
                const themeStyles = {
                    color: item?.color?.default,
                    opacity: item?.opacity
                };
                return (0, ($parcel$interopDefault($1UikQ)))(currentStyles, themeStyles);
            }
            return currentStyles;
        });
});
parcelRegister("8iQMc", function(module, exports) {
    $parcel$export(module.exports, "ForgePageHeader", ()=>$5bbfd34eb4e2a6d6$export$a4f83f6df17decd4);
    var $5uXOq = parcelRequire("5uXOq");
    var $basmW = parcelRequire("basmW");
    var $7GpiS;
    var $dfL30;
    var $2nKsN;
    var $fl3Yy;
    var $fpoBX;
    var $2gYaQ;
    var $146Nh;
    const $5bbfd34eb4e2a6d6$export$a4f83f6df17decd4 = ({ Avatar: Avatar = (0, (0, parcelRequire("7GpiS")).default), AddonIcon: AddonIcon = (0, ($parcel$interopDefault((0, parcelRequire("dfL30"))))), CssFixContainer: CssFixContainer = (0, (0, parcelRequire("146Nh")).CssFixContainerDI), Header: Header = (0, (0, parcelRequire("2nKsN")).default), cssFn: cssFn, EnvironmentLozenge: EnvironmentLozenge = (0, (0, parcelRequire("fl3Yy")).EnvironmentLozenge), avatarUrl: avatarUrl, environmentType: environmentType, environmentKey: environmentKey, name: name })=>{
        const theme = (0, (0, parcelRequire("fpoBX")).useSidebarTheme)();
        const headerCssFn = (0, $5uXOq.useMemo)(()=>cssFn ? (0, ($parcel$interopDefault($basmW)))([
                cssFn,
                (0, (0, parcelRequire("2gYaQ")).generateCustomThemeCssFn)(theme)
            ]) : (0, (0, parcelRequire("2gYaQ")).generateCustomThemeCssFn)(theme), [
            cssFn,
            theme
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(CssFixContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement(Header, {
            cssFn: headerCssFn,
            iconBefore: avatarUrl?.length ? (0, ($parcel$interopDefault($5uXOq))).createElement(Avatar, {
                appearance: "square",
                borderColor: "transparent",
                size: "small",
                src: `${avatarUrl}?size=xxlarge`
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(AddonIcon, {
                label: "",
                size: "medium"
            }),
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement(EnvironmentLozenge, {
                environmentType: environmentType
            })
        }, (0, (0, parcelRequire("fl3Yy")).nameWithCustomEnvironment)(name, environmentType, environmentKey)));
    };
});
parcelRegister("2gYaQ", function(module, exports) {
    $parcel$export(module.exports, "generateCustomThemeCssFn", ()=>$8e94d1e3a18b3b00$export$5ae7d20da3003de);
    var $1UikQ = parcelRequire("1UikQ");
    var $ai0LF;
    const $8e94d1e3a18b3b00$export$5ae7d20da3003de = (theme)=>(0, (0, parcelRequire("ai0LF")).castRealCSSFnToWronglyTypedCSSFn)((currentStyles)=>{
            if (theme?.navigation) {
                const { navigation: { item: item } } = theme;
                const themeStyles = {
                    backgroundColor: item?.background?.default ?? undefined,
                    color: item?.color?.default ?? undefined,
                    '[data-item-title]': {
                        color: item?.color?.default ?? undefined
                    },
                    '[data-item-description]': {
                        color: item?.color?.default ?? undefined
                    }
                };
                return (0, ($parcel$interopDefault($1UikQ)))(currentStyles, themeStyles);
            }
            return currentStyles;
        });
});
parcelRegister("146Nh", function(module, exports) {
    $parcel$export(module.exports, "CssFixContainerDI", ()=>$839ef628ec3ac6e5$export$eee12c3955319ddc);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $839ef628ec3ac6e5$export$eee12c3955319ddc = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1lfu1kw7",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6ucD2", function(module, exports) {
    $parcel$export(module.exports, "ForgeIcon", ()=>$8f7b3d92c79c1fad$export$fe0464db4dc93ab4);
    $parcel$export(module.exports, "ForgeSubpagesContainer", ()=>$8f7b3d92c79c1fad$export$682ee8eb4890e553);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $8f7b3d92c79c1fad$export$fe0464db4dc93ab4 = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbgktf _4t3igktf",
                __cmplp.className
            ])
        });
    });
    const $8f7b3d92c79c1fad$export$682ee8eb4890e553 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_14tkpxbi _t3zcv47k _1so4jjyb",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kBPYs", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$3e1e8355c24b18f2$export$defe85febe8b728c);
    var $7VHMR;
    const $3e1e8355c24b18f2$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        forgeSectionTitle: {
            "id": "navigation-apps-sidebar-forge.project-section.forge-section-title",
            "defaultMessage": "Apps"
        }
    });
});
parcelRegister("boE05", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e8fbdf556ad4d3a9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6CJbV;
    var $cZXEh;
    var $koVbs;
    var $juTur;
    var $jsI7v;
    var $8yg0C;
    var $k6yFu;
    const $e8fbdf556ad4d3a9$var$EMPTY_STACK = [];
    const $e8fbdf556ad4d3a9$var$IssuesMenu = ({ project: project })=>{
        (0, (0, parcelRequire("8yg0C")).default)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6CJbV")).default), {
            initialStack: $e8fbdf556ad4d3a9$var$EMPTY_STACK
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("juTur")).IssuesContextualAnalyticsData), {
            navigatorScope: "project"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jsI7v")).Issues), {
            projectKey: project.key,
            pinUrl: `/jira/core/projects/${project.key}/issues/?filter=`,
            titleHeaderText: formatMessage((0, (0, parcelRequire("k6yFu")).default).issues)
        }))));
    };
    var $e8fbdf556ad4d3a9$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($e8fbdf556ad4d3a9$var$IssuesMenu);
});
parcelRegister("jsI7v", function(module, exports) {
    $parcel$export(module.exports, "Issues", ()=>$e89a82dba74cf1ac$export$1cb51167b20548a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $ebyGx = parcelRequire("ebyGx");
    var $cZXEh;
    var $5tOuG;
    var $bwLf9;
    var $39xOx;
    var $6s1PB;
    var $co1wz;
    var $koVbs;
    var $dIdda = parcelRequire("dIdda");
    var $kvHKs;
    var $k0ZZ2;
    var $iL2Ly;
    var $6KxGW;
    var $3OGaE;
    var $8kM72;
    var $4OCke;
    var $5w5Kh;
    var $2q4IS;
    var $hnmuM;
    var $4KUQv;
    const $e89a82dba74cf1ac$var$IssuesNew = ({ projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
        const { data: features } = (0, (0, parcelRequire("8kM72")).useDefaultPinFilters)();
        if (features === null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), null);
        const hasFilters = features.hasAllIssues || features.hasMyOpenIssues;
        const StyleOverrideWrapper = (0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8') ? $e89a82dba74cf1ac$var$CompiledWrapper : (0, $5uXOq.Fragment);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(StyleOverrideWrapper, {
            renderDividerBefore: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5w5Kh")).DefaultFilters), {
            pinUrl: pinUrl,
            projectKey: projectKey,
            features: features,
            titleHeaderText: titleHeaderText
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            packageName: "jira-navigation-apps-sidebar-common",
            id: "issues.starred-filters-section",
            fallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6KxGW")).StarredFiltersErrorFallback), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(StyleOverrideWrapper, {
            renderDividerAfter: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iL2Ly")).StarredFiltersContainer), {
            pinUrl: pinUrl,
            projectKey: projectKey
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement(StyleOverrideWrapper, {
            renderDividerBefore: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hnmuM")).FiltersFooter), {
            hasFilters: hasFilters
        })));
    };
    const $e89a82dba74cf1ac$export$9bf0cad7d37c4925 = ({ projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ match: match, location: location }] = (0, $dIdda.useRouter)();
        const { jql: jql } = (0, $ebyGx.parse)(location.search, {
            arrayFormat: 'comma'
        });
        const { data: features } = (0, (0, parcelRequire("8kM72")).useDefaultPinFilters)();
        if (features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), null);
        const isOnLegacyPinRoute = !!match.url.match(/^\/projects.*$/);
        const shouldUseNinLayout = !isOnLegacyPinRoute;
        const pinUrlPrefix = pinUrl === null || pinUrl === undefined || isOnLegacyPinRoute ? `/projects/${projectKey}/issues/?filter=` : pinUrl;
        const hasSomeFilters = features.hasAllIssues || features.hasMyOpenIssues;
        const allOpenIssuesSelector = !shouldUseNinLayout ? (currentLocation, itemLocation)=>(0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false)(currentLocation, itemLocation) || !currentLocation.query.filter && currentLocation.pathname.includes(`/projects/${projectKey}/issues`) : (0, (0, parcelRequire("4OCke")).matchUrlParams)([
            'filter'
        ], false);
        const shouldIgnoreJqlUrlParam = shouldUseNinLayout;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OGaE")).TitleHeader), null, isOnLegacyPinRoute || titleHeaderText === null || titleHeaderText === undefined ? formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4KUQv")).messages).issuesIssueTermRefresh : (0, (0, parcelRequire("4KUQv")).messages).issues) : titleHeaderText), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), null, shouldUseNinLayout && features.hasAllIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
            },
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (...args)=>(0, (0, parcelRequire("2q4IS")).isInAllFiltersState)(undefined, '') || (!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false)(...args) : false),
            href: `${pinUrlPrefix}allissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4KUQv")).messages).allIssuesIssueTermRefresh : (0, (0, parcelRequire("4KUQv")).messages).allIssues)), features.hasMyOpenIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES)}`
            },
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : !jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : ()=>false,
            href: `${pinUrlPrefix}myopenissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4KUQv")).messages).myOpenIssuesIssueTermRefresh : (0, (0, parcelRequire("4KUQv")).messages).myOpenIssues)), features.hasReportedByMe && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES)}`
            },
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : !jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : ()=>false,
            href: `${pinUrlPrefix}reportedbyme`
        }, formatMessage((0, (0, parcelRequire("4KUQv")).messages).reportedByMe)), !shouldUseNinLayout && features.hasAllIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
            },
            selectedOn: !jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : ()=>false,
            href: `${pinUrlPrefix}allissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4KUQv")).messages).allIssuesIssueTermRefresh : (0, (0, parcelRequire("4KUQv")).messages).allIssues)), features.hasAllOpenIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES)}`
            },
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : !jql ? allOpenIssuesSelector : ()=>false,
            href: `${pinUrlPrefix}allopenissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4KUQv")).messages).allOpenIssuesIssueTermRefresh : (0, (0, parcelRequire("4KUQv")).messages).allOpenIssues)), features.hasDoneIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES)}`
            },
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : !jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : ()=>false,
            href: `${pinUrlPrefix}doneissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4KUQv")).messages).doneIssuesIssueTermRefresh : (0, (0, parcelRequire("4KUQv")).messages).doneIssues)), features.hasViewedRecently && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES)}`
            },
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : !jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : ()=>false,
            href: `${pinUrlPrefix}recentlyviewed`
        }, formatMessage((0, (0, parcelRequire("4KUQv")).messages).viewedRecently)), !shouldUseNinLayout && features.hasCreatedRecently && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES)}`
            },
            selectedOn: !jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : ()=>false,
            href: `${pinUrlPrefix}addedrecently`
        }, formatMessage((0, (0, parcelRequire("4KUQv")).messages).createdRecently)), features.hasResolvedRecently && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES)}`
            },
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : !jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : ()=>false,
            href: `${pinUrlPrefix}resolvedrecently`
        }, formatMessage((0, (0, parcelRequire("4KUQv")).messages).resolvedRecently)), features.hasUpdatedRecently && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES)}`
            },
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : !jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : ()=>false,
            href: `${pinUrlPrefix}updatedrecently`
        }, formatMessage((0, (0, parcelRequire("4KUQv")).messages).updatedRecently))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), {
            hasSeparator: hasSomeFilters
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'pin-manage-filters'
            },
            selectedOn: !jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : ()=>false,
            href: "/secure/ManageFilters.jspa"
        }, formatMessage((0, (0, parcelRequire("4KUQv")).messages).viewAllFilters))));
    };
    const $e89a82dba74cf1ac$export$1cb51167b20548a0 = (0, (0, parcelRequire("bwLf9")).default)(()=>(0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8'), $e89a82dba74cf1ac$var$IssuesNew, $e89a82dba74cf1ac$export$9bf0cad7d37c4925);
    const $e89a82dba74cf1ac$var$CompiledWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { renderDividerBefore: renderDividerBefore, renderDividerAfter: renderDividerAfter, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1xlv12x7 _1rqn1fxt",
                __cmplp.renderDividerBefore && "_175u1crf",
                __cmplp.renderDividerAfter && "_1we51crf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iL2Ly", function(module, exports) {
    $parcel$export(module.exports, "StarredFiltersContainer", ()=>$1ec2742e0426c5a8$export$f5b4503a4a7ca418);
    var $59JDz;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $5tOuG;
    var $co1wz;
    var $VILOn;
    var $a3OKn;
    var $lfTZh;
    var $ao2h1;
    var $59JDz;
    var $bATyw;
    var $koeKL;
    var $dIdda = parcelRequire("dIdda");
    var $aV2yn;
    var $8Jljs;
    const $1ec2742e0426c5a8$export$3be6ba2fb4838e7e = ({ onFavouritesChanged: onFavouritesChanged, queryReference: queryReference, projectKey: projectKey, pinUrl: pinUrl })=>{
        const [localStorageData] = (0, $5uXOq.useState)((0, (0, parcelRequire("VILOn")).getIsGlobalScopeEnrolmentEnabledFromLocalStorage)());
        const { data: resourceData } = (0, $dIdda.useResource)((0, (0, parcelRequire("bATyw")).isNinGlobalScopeEnrolmentEnabledResource));
        let isNinGlobalScopeEnrolmentEnabled;
        if (localStorageData !== null && localStorageData !== undefined) isNinGlobalScopeEnrolmentEnabled = !!localStorageData;
        else isNinGlobalScopeEnrolmentEnabled = !!resourceData;
        const baseHref = (0, (0, parcelRequire("aV2yn")).getStarredFilterLink)({
            projectKey: projectKey,
            pinUrl: pinUrl,
            shouldStayProjectScope: (0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8') && isNinGlobalScopeEnrolmentEnabled
        });
        const data = (0, $8Uumt.usePreloadedQuery)((0, (0, parcelRequire("59JDz")).default), queryReference);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Jljs")).StarredFiltersList), {
            baseHref: baseHref,
            jiraQuery: data.jira,
            onFavouritesChanged: onFavouritesChanged
        });
    };
    const $1ec2742e0426c5a8$export$f5b4503a4a7ca418 = ({ projectKey: projectKey, pinUrl: pinUrl })=>{
        const { queryReference: resourceQueryRef } = (0, (0, parcelRequire("ao2h1")).useRelayResource)((0, (0, parcelRequire("a3OKn")).sidebarProjectIssuesResource));
        const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, (0, parcelRequire("59JDz")).default), resourceQueryRef);
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const loadSidebarData = (0, $5uXOq.useCallback)(()=>{
            loadQuery({
                cloudId: cloudId
            }, {
                fetchPolicy: 'store-and-network'
            });
        }, [
            cloudId,
            loadQuery
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!queryReference) loadSidebarData();
        }, [
            loadSidebarData,
            queryReference
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "starred-filters",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), null)
        }, queryReference ? (0, ($parcel$interopDefault($5uXOq))).createElement($1ec2742e0426c5a8$export$3be6ba2fb4838e7e, {
            queryReference: queryReference,
            onFavouritesChanged: loadSidebarData,
            pinUrl: pinUrl,
            projectKey: projectKey
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), null));
    };
});
parcelRegister("aV2yn", function(module, exports) {
    $parcel$export(module.exports, "getStarredFilterLink", ()=>$a754d4f1af7bcc7d$export$7082c02465d0ecd4);
    const $a754d4f1af7bcc7d$export$7082c02465d0ecd4 = ({ projectKey: projectKey, pinUrl: pinUrl, shouldStayProjectScope: shouldStayProjectScope })=>{
        if (!projectKey) throw new Error(`Expected projectKey to be a valid string, got: ${projectKey}`);
        const craftedPinUrl = !pinUrl ? `/projects/${projectKey}/issues` : pinUrl.replace(/\?.*$/, '');
        return shouldStayProjectScope ? craftedPinUrl : '/issues/';
    };
});
parcelRegister("8Jljs", function(module, exports) {
    $parcel$export(module.exports, "StarredFiltersList", ()=>$0208f837fc89d8ec$export$b7f4b26a8737eee0);
    var $47bDC = parcelRequire("47bDC");
    var $jUReQ;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $cZXEh;
    var $co1wz;
    var $koVbs;
    var $b2GBS;
    var $kZDjT;
    var $4ABV3;
    var $0208f837fc89d8ec$var$_StyledSection = (0, $47bDC.default)((0, (0, parcelRequire("cZXEh")).default)).withConfig({
        componentId: "sc-8ugvpc-0"
    })`${(p)=>p._css}`;
    const $0208f837fc89d8ec$export$b7f4b26a8737eee0 = ({ baseHref: baseHref, jiraQuery: jiraQuery, onFavouritesChanged: onFavouritesChanged, sectionCustomCss: sectionCustomCss })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const data = (0, $8Uumt.useFragment)((0, (0, parcelRequire("jUReQ")).default), jiraQuery);
        (0, (0, parcelRequire("b2GBS")).useFavoritesChangeEffect)('filters', (hasPendingChanges, previousHasPendingChanges)=>{
            if (previousHasPendingChanges && !hasPendingChanges) onFavouritesChanged();
        });
        const starredFilterEdges = data.favouriteFilters?.edges || [];
        if (!starredFilterEdges.length) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($0208f837fc89d8ec$var$_StyledSection, {
            title: formatMessage((0, (0, parcelRequire("co1wz")).ff)('nin.global-scope_aqec8') ? (0, (0, parcelRequire("4ABV3")).messages).newStarredFiltersHeader : (0, (0, parcelRequire("4ABV3")).messages).starredFiltersHeader),
            _css: sectionCustomCss
        }, starredFilterEdges.map((edge)=>edge?.node ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kZDjT")).FilterItem), {
                key: edge.node.filterId,
                baseHref: baseHref,
                filter: edge.node,
                customAnalytics: {
                    isStarred: true
                }
            }) : null));
    };
});
parcelRegister("jUReQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9363fe5268fd6910$export$2e2bcd8739ae039);
    const $9363fe5268fd6910$var$node = {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ],
        "kind": "Fragment",
        "name": "starredFiltersList_navigationAppsSidebarCommon",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "cloudId",
                        "variableName": "cloudId"
                    }
                ],
                "concreteType": "JiraFilterConnection",
                "kind": "LinkedField",
                "name": "favouriteFilters",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraFilterEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "filterId"
                                    },
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "filterItem_navigationAppsSidebarCommon"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraQuery"
    };
    $9363fe5268fd6910$var$node.hash = "a0c4e11d2fa2d823ad4cac3d7e350cb3";
    var $9363fe5268fd6910$export$2e2bcd8739ae039 = $9363fe5268fd6910$var$node;
});
parcelRegister("b2GBS", function(module, exports) {
    $parcel$export(module.exports, "useFavoritesChangeEffect", ()=>$0fca8b6d7b43f931$export$659f59218fc5dd14);
    var $5uXOq = parcelRequire("5uXOq");
    var $4f8Oj = parcelRequire("4f8Oj");
    var $4041n;
    var $1XJ20;
    const $0fca8b6d7b43f931$export$659f59218fc5dd14 = (type, effect)=>{
        const { items: items } = (0, $5uXOq.useContext)((0, (0, parcelRequire("4041n")).FavoriteChangeContext));
        const typeItems = items[type];
        const pendingChanges = (0, ($parcel$interopDefault($4f8Oj)))(typeItems, (item)=>item.pending);
        const hasPendingChanges = Boolean(Object.keys(pendingChanges).length);
        const previousHasPendingChanges = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(hasPendingChanges);
        (0, $5uXOq.useEffect)(()=>{
            effect(hasPendingChanges, previousHasPendingChanges);
        }, [
            effect,
            hasPendingChanges,
            previousHasPendingChanges
        ]);
    };
});
parcelRegister("1XJ20", function(module, exports) {
    $parcel$export(module.exports, "usePrevious", ()=>$011794d66b906d20$export$5cae361ad82dce8b);
    $parcel$export(module.exports, "usePreviousWithInitial", ()=>$011794d66b906d20$export$23fbbb2e62c4a911);
    var $5uXOq = parcelRequire("5uXOq");
    const $011794d66b906d20$export$5cae361ad82dce8b = (value)=>{
        const ref = (0, $5uXOq.useRef)();
        (0, $5uXOq.useEffect)(()=>{
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    const $011794d66b906d20$export$23fbbb2e62c4a911 = (value)=>{
        const ref = (0, $5uXOq.useRef)(value);
        (0, $5uXOq.useEffect)(()=>{
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
});
parcelRegister("kZDjT", function(module, exports) {
    $parcel$export(module.exports, "FilterItem", ()=>$f981c975abc56594$export$3cf161fcd24b6b4f);
    var $lE53e;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $k0ZZ2;
    const $f981c975abc56594$var$selectedOn = (currentLocation, itemLocation)=>itemLocation.query.filter === (currentLocation.query.filterId || currentLocation.query.filter);
    const $f981c975abc56594$export$3cf161fcd24b6b4f = ({ baseHref: baseHref, filter: filter, customAnalytics: customAnalytics })=>{
        const { filterId: filterId, name: name } = (0, $8Uumt.useFragment)((0, (0, parcelRequire("lE53e")).default), filter);
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
                ...customAnalytics || {},
                itemId: `filter-${filterId}`
            }), [
            customAnalytics,
            filterId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            key: filterId,
            analytics: analyticsAttributes,
            selectedOn: $f981c975abc56594$var$selectedOn,
            href: `${baseHref}?filter=${filterId}`
        }, name);
    };
});
parcelRegister("lE53e", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$251d70d9349441ea$export$2e2bcd8739ae039);
    const $251d70d9349441ea$var$node = {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "filterItem_navigationAppsSidebarCommon",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "filterId"
            },
            {
                "kind": "ScalarField",
                "name": "isFavourite"
            },
            {
                "kind": "ScalarField",
                "name": "jql"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    }
                ],
                "type": "JiraCustomFilter"
            }
        ],
        "type": "JiraFilter",
        "abstractKey": "__isJiraFilter"
    };
    $251d70d9349441ea$var$node.hash = "31464d108113d7084e471c226c3fe0aa";
    var $251d70d9349441ea$export$2e2bcd8739ae039 = $251d70d9349441ea$var$node;
});
parcelRegister("4ABV3", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$f94c0f775539d45d$export$defe85febe8b728c);
    var $7VHMR;
    const $f94c0f775539d45d$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        starredFiltersHeader: {
            "id": "spa-apps-sidebar-common.common.starred-filters-list.starred-filters-header",
            "defaultMessage": "Starred global filters"
        },
        newStarredFiltersHeader: {
            "id": "spa-apps-sidebar-common.common.starred-filters-list.new-starred-filters-header",
            "defaultMessage": "Starred filters"
        }
    });
});
parcelRegister("6KxGW", function(module, exports) {
    $parcel$export(module.exports, "StarredFiltersErrorFallback", ()=>$48c59f757828f109$export$70765d6359132b82);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $89thI;
    var $dvl5H;
    var $cZXEh;
    var $koVbs;
    var $b1xML;
    const $48c59f757828f109$export$70765d6359132b82 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($48c59f757828f109$var$SectionWrapper, {
            title: formatMessage((0, (0, parcelRequire("b1xML")).default).starredFiltersHeader)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dvl5H")).default), {
            appearance: "warning"
        }, formatMessage((0, (0, parcelRequire("b1xML")).default).errorMessage, {
            link: (linkText)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("89thI")).default), {
                    appearance: "link",
                    spacing: "none",
                    onClick: ()=>window.location.reload()
                }, linkText)
        })));
    };
    const $48c59f757828f109$var$SectionWrapper = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("cZXEh")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt3i2wt _euf41fxt _1qdg1crf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dvl5H", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$52cff1673b03893e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $53KbV;
    var $6T4rd;
    var $dsFR3;
    var $iaTnv;
    var $jJ1Sb;
    var $i40Sw;
    const $52cff1673b03893e$var$containerStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        wordBreak: 'break-word',
        borderRadius: 'border.radius'
    });
    const $52cff1673b03893e$var$bleedStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        display: 'flex',
        marginBlock: 'space.negative.025'
    });
    const $52cff1673b03893e$var$contentStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        color: 'color.text',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $52cff1673b03893e$var$SectionMessage = (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
        const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, (0, parcelRequire("i40Sw")).getAppearanceIconStyles)(appearance, icon);
        const actionElements = actions && actions.type === (0, ($parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
        const actionsArray = (0, ($parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            as: "section",
            backgroundColor: $52cff1673b03893e$var$appearanceMap[appearance],
            padding: "space.200",
            testId: testId,
            ref: ref,
            xcss: $52cff1673b03893e$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dsFR3")).default), {
            space: "space.200",
            alignBlock: "stretch"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $52cff1673b03893e$var$bleedStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
            size: "medium",
            primaryColor: primaryColor,
            secondaryColor: secondaryColor
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iaTnv")).default), {
            space: "space.100",
            testId: testId && `${testId}--content`
        }, !!title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("53KbV")).default), {
            as: "h2",
            size: "small"
        }, title), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $52cff1673b03893e$var$contentStyles
        }, children), actionsArray.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dsFR3")).default), {
            shouldWrap: true,
            testId: testId && `${testId}--actions`,
            separator: "\xb7",
            space: "space.100",
            rowSpace: "space.0",
            role: "list"
        }, actionsArray.map((action, id)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dsFR3")).default), {
                role: "listitem",
                key: id
            }, action))))));
    });
    const $52cff1673b03893e$var$appearanceMap = {
        information: 'color.background.information',
        warning: 'color.background.warning',
        error: 'color.background.danger',
        success: 'color.background.success',
        discovery: 'color.background.discovery'
    };
    $52cff1673b03893e$var$SectionMessage.displayName = 'SectionMessage';
    var $52cff1673b03893e$export$2e2bcd8739ae039 = $52cff1673b03893e$var$SectionMessage;
});
parcelRegister("i40Sw", function(module, exports) {
    $parcel$export(module.exports, "getAppearanceIconStyles", ()=>$ae4ed74f4b29039c$export$e9b82d2e21ac0c1f);
    var $5uXOq = parcelRequire("5uXOq");
    var $8j2nA;
    var $2OiHg;
    var $itVjj;
    var $dyIJ3;
    var $iz6Nv;
    const $ae4ed74f4b29039c$export$faa35441caff5bb6 = {
        information: {
            backgroundColor: `var(--ds-background-information, ${(0, $5e0c0d4e15efb4a6$export$226de0355ed012f8)})`,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("itVjj"))))),
            primaryIconColor: `var(--ds-icon-information, ${(0, $5e0c0d4e15efb4a6$export$a6ee3d71bc067634)})`
        },
        warning: {
            backgroundColor: `var(--ds-background-warning, ${(0, $5e0c0d4e15efb4a6$export$8d9596b529bbb9cf)})`,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("iz6Nv"))))),
            primaryIconColor: `var(--ds-icon-warning, ${(0, $5e0c0d4e15efb4a6$export$874739ea9e379ab6)})`
        },
        error: {
            backgroundColor: `var(--ds-background-danger, ${(0, $5e0c0d4e15efb4a6$export$4b84fd0e2c617bd)})`,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("2OiHg"))))),
            primaryIconColor: `var(--ds-icon-danger, ${(0, $5e0c0d4e15efb4a6$export$2837b5a1a71d5c02)})`
        },
        success: {
            backgroundColor: `var(--ds-background-success, ${(0, $5e0c0d4e15efb4a6$export$8a6341c32b6a3ee6)})`,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("8j2nA"))))),
            primaryIconColor: `var(--ds-icon-success, ${(0, $5e0c0d4e15efb4a6$export$6fa04827ac68a4fb)})`
        },
        discovery: {
            backgroundColor: `var(--ds-background-discovery, ${(0, $5e0c0d4e15efb4a6$export$363e4475840015bb)})`,
            Icon: (0, ($parcel$interopDefault((0, parcelRequire("dyIJ3"))))),
            primaryIconColor: `var(--ds-icon-discovery, ${(0, $5e0c0d4e15efb4a6$export$147899de772240ec)})`
        }
    };
    function $ae4ed74f4b29039c$export$e9b82d2e21ac0c1f(appearance, icon) {
        const appearanceIconStyles = $ae4ed74f4b29039c$export$faa35441caff5bb6[appearance] || $ae4ed74f4b29039c$export$faa35441caff5bb6.information;
        const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>(0, ($parcel$interopDefault($5uXOq))).createElement(appearanceIconStyles.Icon, {
                size: size,
                primaryColor: primaryColor,
                secondaryColor: secondaryColor,
                label: appearance
            });
        const Icon = icon || AppearanceIcon;
        return {
            ...appearanceIconStyles,
            Icon: Icon
        };
    }
});
parcelRegister("8j2nA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $018f83e56d6ef7d1$var$_react = $018f83e56d6ef7d1$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $kfAhl;
    var $018f83e56d6ef7d1$var$_success = $018f83e56d6ef7d1$var$_interopRequireDefault((parcelRequire("6K6ZN")));
    function $018f83e56d6ef7d1$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $018f83e56d6ef7d1$var$CheckCircleIcon = (props)=>$018f83e56d6ef7d1$var$_react.default.createElement((0, parcelRequire("kfAhl")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
        }, props, {
            newIcon: $018f83e56d6ef7d1$var$_success.default
        }));
    $018f83e56d6ef7d1$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
    var $018f83e56d6ef7d1$var$_default = module.exports.default = $018f83e56d6ef7d1$var$CheckCircleIcon;
});
parcelRegister("6K6ZN", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4e8c772aea92ac0c$var$_react = $4e8c772aea92ac0c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $4e8c772aea92ac0c$var$_UNSAFE_baseNew = $4e8c772aea92ac0c$var$_interopRequireDefault((parcelRequire("huIZN")));
    function $4e8c772aea92ac0c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4e8c772aea92ac0c$var$SuccessIcon = (props)=>$4e8c772aea92ac0c$var$_react.default.createElement($4e8c772aea92ac0c$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
        }, props));
    $4e8c772aea92ac0c$var$SuccessIcon.displayName = 'SuccessIcon';
    var $4e8c772aea92ac0c$var$_default = module.exports.default = $4e8c772aea92ac0c$var$SuccessIcon;
});
parcelRegister("b1xML", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dc624d55e9cb181d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $dc624d55e9cb181d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorMessage: {
            "id": "spa-apps-sidebar-common.common.starred-filters-error-fallback.error-message",
            "defaultMessage": "We couldn't load your starred filters. <link>Refresh the page</link> to try again."
        },
        starredFiltersHeader: {
            "id": "spa-apps-sidebar-common.common.starred-filters-error-fallback.starred-filters-header",
            "defaultMessage": "Starred filters"
        }
    });
});
parcelRegister("8kM72", function(module, exports) {
    $parcel$export(module.exports, "useDefaultPinFilters", ()=>$42363ac07745a31e$export$3c69152f8409a017);
    var $5uXOq = parcelRequire("5uXOq");
    var $1b36n;
    var $dIdda = parcelRequire("dIdda");
    const $42363ac07745a31e$export$3c69152f8409a017 = ()=>{
        const { data: data, loading: loading, refresh: refresh, error: error } = (0, $dIdda.useResource)((0, (0, parcelRequire("1b36n")).staticSidebarDefaultPINFiltersResource));
        (0, $5uXOq.useEffect)(()=>{
            if (data == null && error == null && loading === false) refresh();
        }, [
            data,
            error,
            loading,
            refresh
        ]);
        return {
            data: data,
            loading: loading
        };
    };
});
parcelRegister("5w5Kh", function(module, exports) {
    $parcel$export(module.exports, "DefaultFilters", ()=>$68067cb39e642d05$export$5df36bcfaa4d1f9d);
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $cZXEh;
    var $6s1PB;
    var $koVbs;
    var $dIdda = parcelRequire("dIdda");
    var $k0ZZ2;
    var $4OCke;
    var $irHAa;
    var $2q4IS;
    const $68067cb39e642d05$export$5df36bcfaa4d1f9d = ({ features: features, projectKey: projectKey, pinUrl: pinUrl, titleHeaderText: titleHeaderText })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ match: match, location: location }] = (0, $dIdda.useRouter)();
        const { jql: jql } = (0, $ebyGx.parse)(location.search, {
            arrayFormat: 'comma'
        });
        const isOnLegacyPinRoute = !!match.url.match(/^\/projects.*$/);
        const shouldUseNinLayout = !isOnLegacyPinRoute;
        const pinUrlPrefix = pinUrl === null || pinUrl === undefined || isOnLegacyPinRoute ? `/projects/${projectKey}/issues/?filter=` : pinUrl;
        const title = isOnLegacyPinRoute || titleHeaderText == null ? formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("irHAa")).messages).issuesIssueTermRefresh : (0, (0, parcelRequire("irHAa")).messages).issues) : titleHeaderText;
        const allOpenIssuesSelector = !shouldUseNinLayout ? (currentLocation, itemLocation)=>(0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false)(currentLocation, itemLocation) || !currentLocation.query.filter && currentLocation.pathname.includes(`/projects/${projectKey}/issues`) : (0, (0, parcelRequire("4OCke")).matchUrlParams)([
            'filter'
        ], false);
        const shouldIgnoreJqlUrlParam = shouldUseNinLayout;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), {
            title: title
        }, shouldUseNinLayout && features.hasAllIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).ninLayoutAllIssues.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).ninLayoutAllIssues.selectedOn(jql),
            href: `${pinUrlPrefix}allissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("irHAa")).messages).allIssuesIssueTermRefresh : (0, (0, parcelRequire("irHAa")).messages).allIssues)), features.hasMyOpenIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).myOpenIssues.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).myOpenIssues.selectedOn(jql),
            href: `${pinUrlPrefix}myopenissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("irHAa")).messages).myOpenIssuesIssueTermRefresh : (0, (0, parcelRequire("irHAa")).messages).myOpenIssues)), features.hasReportedByMe && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).reportedByMe.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).reportedByMe.selectedOn(jql),
            href: `${pinUrlPrefix}reportedbyme`
        }, formatMessage((0, (0, parcelRequire("irHAa")).messages).reportedByMe)), !shouldUseNinLayout && features.hasAllIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).notNinLayoutAllIssues.analytics,
            selectedOn: (0, (0, parcelRequire("2q4IS")).itemMap).notNinLayoutAllIssues.selectedOn(jql),
            href: `${pinUrlPrefix}allissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("irHAa")).messages).allIssuesIssueTermRefresh : (0, (0, parcelRequire("irHAa")).messages).allIssues)), features.hasAllOpenIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).allOpenIssues.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).allOpenIssues.selectedOn(jql, allOpenIssuesSelector),
            href: `${pinUrlPrefix}allopenissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("irHAa")).messages).allOpenIssuesIssueTermRefresh : (0, (0, parcelRequire("irHAa")).messages).allOpenIssues)), features.hasDoneIssues && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).doneIssues.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).doneIssues.selectedOn(jql),
            href: `${pinUrlPrefix}doneissues`
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("irHAa")).messages).doneIssuesIssueTermRefresh : (0, (0, parcelRequire("irHAa")).messages).doneIssues)), features.hasViewedRecently && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).viewedRecently.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).viewedRecently.selectedOn(jql),
            href: `${pinUrlPrefix}recentlyviewed`
        }, formatMessage((0, (0, parcelRequire("irHAa")).messages).viewedRecently)), !shouldUseNinLayout && features.hasCreatedRecently && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).createdRecently.analytics,
            selectedOn: (0, (0, parcelRequire("2q4IS")).itemMap).createdRecently.selectedOn(jql),
            href: `${pinUrlPrefix}addedrecently`
        }, formatMessage((0, (0, parcelRequire("irHAa")).messages).createdRecently)), features.hasResolvedRecently && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).resolvedRecently.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).resolvedRecently.selectedOn(jql),
            href: `${pinUrlPrefix}resolvedrecently`
        }, formatMessage((0, (0, parcelRequire("irHAa")).messages).resolvedRecently)), features.hasUpdatedRecently && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: (0, (0, parcelRequire("2q4IS")).itemMap).updatedRecently.analytics,
            selectedOn: shouldIgnoreJqlUrlParam ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                'filter'
            ], false) : (0, (0, parcelRequire("2q4IS")).itemMap).updatedRecently.selectedOn(jql),
            href: `${pinUrlPrefix}updatedrecently`
        }, formatMessage((0, (0, parcelRequire("irHAa")).messages).updatedRecently)));
    };
});
parcelRegister("irHAa", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$87feacba5b057fbf$export$defe85febe8b728c);
    var $7VHMR;
    const $87feacba5b057fbf$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issues: {
            "id": "spa-apps-sidebar-common.issues.default-filters.issues",
            "defaultMessage": "Issues and filters"
        },
        issuesFilters: {
            "id": "spa-apps-sidebar-common.issues.default-filters.issues-filters",
            "defaultMessage": "Issues and Filters"
        },
        myOpenIssues: {
            "id": "spa-apps-sidebar-common.issues.default-filters.my-open-issues",
            "defaultMessage": "My open issues"
        },
        reportedByMe: {
            "id": "spa-apps-sidebar-common.issues.default-filters.reported-by-me",
            "defaultMessage": "Reported by me"
        },
        allIssues: {
            "id": "spa-apps-sidebar-common.issues.default-filters.all-issues",
            "defaultMessage": "All issues"
        },
        allOpenIssues: {
            "id": "spa-apps-sidebar-common.issues.default-filters.all-open-issues",
            "defaultMessage": "Open issues"
        },
        doneIssues: {
            "id": "spa-apps-sidebar-common.issues.default-filters.done-issues",
            "defaultMessage": "Done issues"
        },
        viewedRecently: {
            "id": "spa-apps-sidebar-common.issues.default-filters.viewed-recently",
            "defaultMessage": "Viewed recently"
        },
        createdRecently: {
            "id": "spa-apps-sidebar-common.issues.default-filters.created-recently",
            "defaultMessage": "Created recently"
        },
        resolvedRecently: {
            "id": "spa-apps-sidebar-common.issues.default-filters.resolved-recently",
            "defaultMessage": "Resolved recently"
        },
        updatedRecently: {
            "id": "spa-apps-sidebar-common.issues.default-filters.updated-recently",
            "defaultMessage": "Updated recently"
        },
        issuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.default-filters.issues-issue-term-refresh",
            "defaultMessage": "Issues and filters"
        },
        issuesFiltersIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.default-filters.issues-filters-issue-term-refresh",
            "defaultMessage": "Issues and Filters"
        },
        myOpenIssuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.default-filters.my-open-issues-issue-term-refresh",
            "defaultMessage": "My open issues"
        },
        allIssuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.default-filters.all-issues-issue-term-refresh",
            "defaultMessage": "All issues"
        },
        allOpenIssuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.default-filters.all-open-issues-issue-term-refresh",
            "defaultMessage": "Open issues"
        },
        doneIssuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.default-filters.done-issues-issue-term-refresh",
            "defaultMessage": "Done issues"
        }
    });
});
parcelRegister("2q4IS", function(module, exports) {
    $parcel$export(module.exports, "isInAllFiltersState", ()=>$414ee2dbecb9ba58$export$1596c397510d46b1);
    $parcel$export(module.exports, "itemMap", ()=>$414ee2dbecb9ba58$export$1072457701b9918d);
    var $kvHKs;
    var $4OCke;
    const $414ee2dbecb9ba58$export$1596c397510d46b1 = (filter, jql)=>{
        if ((typeof filter === 'undefined' || !filter.length) && typeof jql === 'undefined') return true;
        if (filter != null && filter !== 'allissues') return false;
        if (typeof jql === 'string' && jql.match(/^project = ".*" ORDER BY created (?:DESC|ASC)$/)) return true;
        return false;
    };
    const $414ee2dbecb9ba58$export$1072457701b9918d = {
        ninLayoutAllIssues: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
            },
            selectedOn: (jql)=>(...args)=>$414ee2dbecb9ba58$export$1596c397510d46b1(undefined, '') || (!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                        'filter'
                    ], false)(...args) : false)
        },
        myOpenIssues: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_MY_OPEN_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        },
        reportedByMe: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_REPORTED_BY_ME_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        },
        notNinLayoutAllIssues: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_ALL_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        },
        allOpenIssues: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_ALL_OPEN_ISSUES)}`
            },
            selectedOn: (jql, allOpenIssuesSelector)=>!jql && allOpenIssuesSelector ? allOpenIssuesSelector : ()=>false
        },
        doneIssues: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_DONE_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        },
        viewedRecently: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_RECENTLY_VIEWED_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        },
        createdRecently: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_ADDED_RECENTLY_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        },
        resolvedRecently: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_RESOLVED_RECENTLY_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        },
        updatedRecently: {
            analytics: {
                itemId: `pin-${(0, (0, parcelRequire("kvHKs")).PROJECT_ISSUE_NAVIGATOR_UPDATED_RECENTLY_ISSUES)}`
            },
            selectedOn: (jql)=>!jql ? (0, (0, parcelRequire("4OCke")).matchUrlParams)([
                    'filter'
                ], false) : ()=>false
        }
    };
});
parcelRegister("hnmuM", function(module, exports) {
    $parcel$export(module.exports, "FiltersFooter", ()=>$ca4a87e5b79a11b5$export$c131ccfc44bcd85c);
    var $5uXOq = parcelRequire("5uXOq");
    var $cZXEh;
    var $koVbs;
    var $k0ZZ2;
    var $fcEY2;
    const $ca4a87e5b79a11b5$var$analyticsPayload = {
        itemId: 'pin-manage-filters'
    };
    const $ca4a87e5b79a11b5$export$c131ccfc44bcd85c = ({ hasFilters: hasFilters })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), {
            hasSeparator: hasFilters
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: $ca4a87e5b79a11b5$var$analyticsPayload,
            href: "/jira/filters"
        }, formatMessage((0, (0, parcelRequire("fcEY2")).messages).viewAllFilters)));
    };
});
parcelRegister("fcEY2", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$905189d98c72b841$export$defe85febe8b728c);
    var $7VHMR;
    const $905189d98c72b841$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        viewAllFilters: {
            "id": "spa-apps-sidebar-common.issues.filters-footer.view-all-filters",
            "defaultMessage": "View all filters"
        }
    });
});
parcelRegister("4KUQv", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$4304d3acdfe7b54a$export$defe85febe8b728c);
    var $7VHMR;
    const $4304d3acdfe7b54a$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issues: {
            "id": "spa-apps-sidebar-common.issues.issues",
            "defaultMessage": "Issues and filters"
        },
        issuesFilters: {
            "id": "spa-apps-sidebar-common.issues.issues-filters",
            "defaultMessage": "Issues and Filters"
        },
        myOpenIssues: {
            "id": "spa-apps-sidebar-common.issues.my-open-issues",
            "defaultMessage": "My open issues"
        },
        reportedByMe: {
            "id": "spa-apps-sidebar-common.issues.reported-by-me",
            "defaultMessage": "Reported by me"
        },
        allIssues: {
            "id": "spa-apps-sidebar-common.issues.all-issues",
            "defaultMessage": "All issues"
        },
        allOpenIssues: {
            "id": "spa-apps-sidebar-common.issues.all-open-issues",
            "defaultMessage": "Open issues"
        },
        doneIssues: {
            "id": "spa-apps-sidebar-common.issues.done-issues",
            "defaultMessage": "Done issues"
        },
        viewedRecently: {
            "id": "spa-apps-sidebar-common.issues.viewed-recently",
            "defaultMessage": "Viewed recently"
        },
        createdRecently: {
            "id": "spa-apps-sidebar-common.issues.created-recently",
            "defaultMessage": "Created recently"
        },
        resolvedRecently: {
            "id": "spa-apps-sidebar-common.issues.resolved-recently",
            "defaultMessage": "Resolved recently"
        },
        updatedRecently: {
            "id": "spa-apps-sidebar-common.issues.updated-recently",
            "defaultMessage": "Updated recently"
        },
        viewAllFilters: {
            "id": "spa-apps-sidebar-common.issues.view-all-filters",
            "defaultMessage": "View all filters"
        },
        issuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.issues-issue-term-refresh",
            "defaultMessage": "Issues and filters"
        },
        issuesFiltersIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.issues-filters-issue-term-refresh",
            "defaultMessage": "Issues and Filters"
        },
        myOpenIssuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.my-open-issues-issue-term-refresh",
            "defaultMessage": "My open issues"
        },
        allIssuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.all-issues-issue-term-refresh",
            "defaultMessage": "All issues"
        },
        allOpenIssuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.all-open-issues-issue-term-refresh",
            "defaultMessage": "Open issues"
        },
        doneIssuesIssueTermRefresh: {
            "id": "spa-apps-sidebar-common.issues.done-issues-issue-term-refresh",
            "defaultMessage": "Done issues"
        }
    });
});
parcelRegister("k6yFu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$073d14daf21d9ee8$export$2e2bcd8739ae039);
    var $7VHMR;
    const $073d14daf21d9ee8$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issues: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.issues-menu.issues",
            "defaultMessage": "Issues"
        }
    });
    var $073d14daf21d9ee8$export$2e2bcd8739ae039 = $073d14daf21d9ee8$var$messages;
});
parcelRegister("chejP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5de49251f2394688$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6CJbV;
    var $cZXEh;
    var $k0iPT;
    var $6jY6G;
    var $gb5lQ;
    var $lPApw;
    var $8yg0C;
    var $jxrFe;
    const $5de49251f2394688$var$calculateStack = (route, connectStack)=>{
        if ((0, (0, parcelRequire("k0iPT")).CONNECT_ROUTES_SET).has(route.name) && connectStack) {
            const [first, ...other] = connectStack;
            if ((0, (0, parcelRequire("gb5lQ")).SECTION_ID).REPORTS === first) return other;
            return connectStack;
        }
        return [];
    };
    const $5de49251f2394688$var$ReportsMenu = ()=>{
        (0, (0, parcelRequire("8yg0C")).default)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: connectItems, stack: connectStack } = (0, (0, parcelRequire("lPApw")).useProjectReportsConnectItems)();
        const [stack, setStack] = (0, $5uXOq.useState)(()=>$5de49251f2394688$var$calculateStack(route, connectStack));
        (0, $5uXOq.useEffect)(()=>{
            setStack($5de49251f2394688$var$calculateStack(route, connectStack));
        }, [
            route,
            connectStack
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6CJbV")).default), {
            stack: stack,
            onChange: setStack
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jxrFe")).Reports), {
            connectItems: connectItems
        })));
    };
    var $5de49251f2394688$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($5de49251f2394688$var$ReportsMenu);
});
parcelRegister("jxrFe", function(module, exports) {
    $parcel$export(module.exports, "Reports", ()=>$345de988b64525a0$export$883262dc952d8f59);
    var $5uXOq = parcelRequire("5uXOq");
    var $cZXEh;
    var $5tOuG;
    var $koVbs;
    var $k0ZZ2;
    var $jv9Yy;
    var $lpwtK;
    var $7OqB4;
    var $4OCke;
    var $3tHFY;
    var $9h6Pc;
    var $eA5Jb;
    var $bkw8F;
    var $9GoDt;
    const $345de988b64525a0$var$useThrowDefaultReportItemsDI = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("eA5Jb")).useDefaultReportItems));
    const $345de988b64525a0$var$useThrowProjectDI = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("lpwtK")).useProject));
    const $345de988b64525a0$var$useThrowReportFeaturesDI = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("bkw8F")).useReportFeatures));
    const $345de988b64525a0$export$883262dc952d8f59 = ({ ConnectMenu: ConnectMenu = (0, (0, parcelRequire("3tHFY")).ConnectMenu), MenuItem: MenuItem = (0, (0, parcelRequire("k0ZZ2")).MenuItem), Section: Section = (0, (0, parcelRequire("cZXEh")).default), SkeletonItem: SkeletonItem = (0, (0, parcelRequire("5tOuG")).default), connectItems: connectItems, SectionHeader: SectionHeader = (0, (0, parcelRequire("jv9Yy")).SectionHeader), matchUrlParams: matchUrlParams = (0, (0, parcelRequire("4OCke")).matchUrlParams), useDefaultReportItems: useDefaultReportItems = $345de988b64525a0$var$useThrowDefaultReportItemsDI, useIntl: useIntl = (0, (0, parcelRequire("koVbs")).default), useProject: useProject = $345de988b64525a0$var$useThrowProjectDI, useReportFeatures: useReportFeatures = $345de988b64525a0$var$useThrowReportFeaturesDI })=>{
        const baseUrl = '';
        const { data: defaultItems } = useDefaultReportItems();
        const { data: features } = useReportFeatures();
        const { formatMessage: formatMessage } = useIntl();
        const { data: project } = useProject();
        if (project == null || features == null) return (0, ($parcel$interopDefault($5uXOq))).createElement(SkeletonItem, null);
        const createReportUrl = (0, (0, parcelRequire("9h6Pc")).createReportUrlFunc)({
            baseUrl: baseUrl,
            project: project
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, defaultItems && defaultItems.items.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement(Section, {
            id: defaultItems.id,
            key: defaultItems.id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(SectionHeader, null, defaultItems.name), defaultItems.items && defaultItems.items.map((item)=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
                key: item.id,
                analytics: {
                    itemId: item.id
                },
                selectedOn: matchUrlParams([
                    'reportKey'
                ]),
                href: item.url
            }, item.name != null ? item.name : null))), features && features.hasForcastSection && (0, ($parcel$interopDefault($5uXOq))).createElement(Section, null, (0, ($parcel$interopDefault($5uXOq))).createElement(SectionHeader, null, formatMessage((0, (0, parcelRequire("9GoDt")).default).forecastAndManagement)), features.hasTimeTracking && (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'time-tracking'
            },
            href: createReportUrl('com.atlassian.jira.plugin.system.reports:time-tracking'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("9GoDt")).default).timeTracking)), features.hasDeveloperWorkload && (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'developer-workload'
            },
            href: createReportUrl('com.atlassian.jira.plugin.system.reports:developer-workload'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("9GoDt")).default).userWorkload)), features.hasVersionWorkloadReport && (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'version-workload'
            },
            href: createReportUrl('com.atlassian.jira.plugins.jira-software-plugin:version-workload-report'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("9GoDt")).default).versionWorkload))), (0, ($parcel$interopDefault($5uXOq))).createElement(Section, null, (0, ($parcel$interopDefault($5uXOq))).createElement(SectionHeader, null, formatMessage((0, (0, parcelRequire("9GoDt")).default).other)), (0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
            analytics: {
                itemId: 'workloadpie'
            },
            href: createReportUrl('com.atlassian.jira.ext.charting:workloadpie-report'),
            selectedOn: matchUrlParams([
                'reportKey'
            ])
        }, formatMessage((0, (0, parcelRequire("9GoDt")).default).workloadPieChart)), (0, ($parcel$interopDefault($5uXOq))).createElement(ConnectMenu, {
            items: connectItems,
            overrides: {
                BackMenuItem: {
                    href: `/projects/${project.key}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`,
                    title: formatMessage((0, (0, parcelRequire("9GoDt")).default).itemBack)
                }
            }
        })));
    };
});
parcelRegister("9h6Pc", function(module, exports) {
    $parcel$export(module.exports, "createReportUrlFunc", ()=>$14ad3153b403c86e$export$fe91ad5e718e4335);
    const $14ad3153b403c86e$export$fe91ad5e718e4335 = ({ baseUrl: baseUrl, project: project })=>(reportKey)=>`${baseUrl}/secure/ConfigureReport!default.jspa?selectedProjectId=${project.id}&projectOrFilterId=project-${project.id}&projectOrFilterName=${project.name}&reportKey=${reportKey}`;
});
parcelRegister("eA5Jb", function(module, exports) {
    $parcel$export(module.exports, "useDefaultReportItems", ()=>$b47a0bfc5b0d2f58$export$ab2e8832e8916e83);
    var $koVbs;
    var $lpwtK;
    var $9h6Pc;
    var $cnn8W;
    const $b47a0bfc5b0d2f58$export$ab2e8832e8916e83 = ()=>{
        const baseUrl = '';
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: project, loading: loading, error: error } = (0, (0, parcelRequire("lpwtK")).useProject)();
        let defaultIssueAnalysisSection = null;
        if (project) {
            const createReportUrl = (0, (0, parcelRequire("9h6Pc")).createReportUrlFunc)({
                baseUrl: baseUrl,
                project: project
            });
            defaultIssueAnalysisSection = {
                name: formatMessage((0, (0, parcelRequire("cnn8W")).default).issueAnalysis),
                id: 'issue-analysis-sidebar-links',
                items: [
                    {
                        id: 'averageage-report',
                        url: createReportUrl('com.atlassian.jira.plugin.system.reports:averageage-report'),
                        name: formatMessage((0, (0, parcelRequire("cnn8W")).default).averageAgeReport)
                    },
                    {
                        id: 'createdvsresolved-report',
                        url: createReportUrl('com.atlassian.jira.plugin.system.reports:createdvsresolved-report'),
                        name: formatMessage((0, (0, parcelRequire("cnn8W")).default).createdResolvedIssuesReport)
                    },
                    {
                        id: 'pie-report',
                        url: createReportUrl('com.atlassian.jira.plugin.system.reports:pie-report'),
                        name: formatMessage((0, (0, parcelRequire("cnn8W")).default).pieChart)
                    },
                    {
                        id: 'recentlycreated-report',
                        url: createReportUrl('com.atlassian.jira.plugin.system.reports:recentlycreated-report'),
                        name: formatMessage((0, (0, parcelRequire("cnn8W")).default).recentlyCreatedIssues)
                    },
                    {
                        id: 'resolutiontime-report',
                        url: createReportUrl('com.atlassian.jira.plugin.system.reports:resolutiontime-report'),
                        name: formatMessage((0, (0, parcelRequire("cnn8W")).default).resolutionTime)
                    },
                    {
                        id: 'singlelevelgroupby',
                        url: createReportUrl('com.atlassian.jira.plugin.system.reports:singlelevelgroupby'),
                        name: formatMessage((0, (0, parcelRequire("cnn8W")).default).singleLevelGroup)
                    },
                    {
                        id: 'timesince-report',
                        url: createReportUrl('com.atlassian.jira.plugin.system.reports:timesince-report'),
                        name: formatMessage((0, (0, parcelRequire("cnn8W")).default).timeSinceIssues)
                    }
                ]
            };
        }
        return {
            data: defaultIssueAnalysisSection,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("cnn8W", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7f93c3dbd2e4c3a6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7f93c3dbd2e4c3a6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueAnalysis: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.issue-analysis",
            "defaultMessage": "Issue analysis"
        },
        averageAgeReport: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.average-age-report",
            "defaultMessage": "Average Age Report"
        },
        createdResolvedIssuesReport: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.created-resolved-issues-report",
            "defaultMessage": "Created vs Resolved Issues Report"
        },
        pieChart: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.pie-chart",
            "defaultMessage": "Pie Chart Report"
        },
        recentlyCreatedIssues: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.recently-created-issues",
            "defaultMessage": "Recently Created Issues Report"
        },
        resolutionTime: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.resolution-time",
            "defaultMessage": "Resolution Time Report"
        },
        singleLevelGroup: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.single-level-group",
            "defaultMessage": "Single Level Group By Report"
        },
        timeSinceIssues: {
            "id": "spa-apps-sidebar-core.controllers.default-report-items.time-since-issues",
            "defaultMessage": "Time Since Issues Report"
        }
    });
});
parcelRegister("9GoDt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$98779022895d106f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $98779022895d106f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        forecastAndManagement: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.forecast-and-management",
            "defaultMessage": "Forecast & management"
        },
        timeTracking: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.time-tracking",
            "defaultMessage": "Time Tracking Report"
        },
        userWorkload: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.user-workload",
            "defaultMessage": "User Workload Report"
        },
        versionWorkload: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.version-workload",
            "defaultMessage": "Version Workload Report"
        },
        workloadPieChart: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.workload-pie-chart",
            "defaultMessage": "Workload Pie Chart Report"
        },
        other: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.other",
            "defaultMessage": "Other"
        },
        itemBack: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.reports-menu.reports.item-back",
            "defaultMessage": "Back to reports"
        }
    });
});
parcelRegister("9nNLl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$90a0ff13f8a11c35$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6CJbV;
    var $cZXEh;
    var $65Ltd;
    var $k0iPT;
    var $6jY6G;
    var $gb5lQ;
    var $lPApw;
    var $8yg0C;
    var $3wt3Q;
    var $4rn3K;
    const $90a0ff13f8a11c35$var$EMPTY_STACK = [];
    const $90a0ff13f8a11c35$var$adjustAppStack = (appStack)=>{
        const [first, ...other] = appStack;
        if ((0, (0, parcelRequire("gb5lQ")).SECTION_ID).SETTINGS === first) return other;
        return appStack;
    };
    const $90a0ff13f8a11c35$var$calculateStack = (route, connectStack, forgeStack)=>{
        if ((0, (0, parcelRequire("gb5lQ")).FORGE_ROUTES_SET).has(route.name) && forgeStack) return $90a0ff13f8a11c35$var$adjustAppStack(forgeStack);
        if (route.name.includes((0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE))) {
            const [view] = route.name.replace(`${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE)}-`, '').split('-');
            return view === 'issuetypes' ? [
                view
            ] : $90a0ff13f8a11c35$var$EMPTY_STACK;
        }
        if ((0, (0, parcelRequire("k0iPT")).CONNECT_ROUTES_SET).has(route.name) && connectStack) return $90a0ff13f8a11c35$var$adjustAppStack(connectStack);
        return $90a0ff13f8a11c35$var$EMPTY_STACK;
    };
    const $90a0ff13f8a11c35$var$SettingsMenu = ({ project: project })=>{
        (0, (0, parcelRequire("8yg0C")).default)();
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const { data: connectItems, stack: connectStack } = (0, (0, parcelRequire("lPApw")).useProjectSettingsConnectItems)();
        const { data: forgeItems, stack: forgeStack } = (0, (0, parcelRequire("lPApw")).useProjectSettingsForgeItems)((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_FORGE_APPS), $90a0ff13f8a11c35$var$EMPTY_STACK);
        const ecosystemItems = (0, $5uXOq.useMemo)(()=>({
                forge: forgeItems,
                connect: connectItems
            }), [
            forgeItems,
            connectItems
        ]);
        const [stack, setStack] = (0, $5uXOq.useState)(()=>$90a0ff13f8a11c35$var$calculateStack(route, connectStack, forgeStack));
        (0, $5uXOq.useEffect)(()=>{
            setStack($90a0ff13f8a11c35$var$calculateStack(route, connectStack, forgeStack));
        }, [
            route,
            connectStack,
            forgeStack
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6CJbV")).default), {
            stack: stack,
            onChange: setStack
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), null, project.isSimplified ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3wt3Q")).SettingsMenu), {
            stack: stack
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4rn3K")).Settings), {
            ecosystemItems: ecosystemItems
        }))));
    };
    var $90a0ff13f8a11c35$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($90a0ff13f8a11c35$var$SettingsMenu);
});
parcelRegister("3wt3Q", function(module, exports) {
    $parcel$export(module.exports, "SettingsMenu", ()=>$26eff467887b13fc$export$1d7840d5cdc861d5);
    var $5uXOq = parcelRequire("5uXOq");
    var $cZXEh;
    var $5tOuG;
    var $2vSU6;
    var $co1wz;
    var $4R6GH;
    var $koVbs;
    var $xc3fY;
    var $k0ZZ2;
    var $3OGaE;
    var $lpwtK;
    var $kZj7F;
    var $71bFU;
    var $3SzZi;
    var $7OqB4;
    var $4OCke;
    var $02Psx;
    var $j9iVo;
    var $iNzEe;
    var $daoB1;
    var $6EZeH;
    var $gb5lQ;
    var $bkw8F;
    var $9DEd8;
    var $7OvX8;
    var $1tmBf;
    var $17zko;
    const $26eff467887b13fc$export$a4007dc4843ca7f6 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("lpwtK")).useProject));
    const $26eff467887b13fc$var$DisplayNotificationsOptions = ({ hasCoreAccess: hasCoreAccess, formatMessage: formatMessage, baseSettingsUrl: baseSettingsUrl, projectId: projectId })=>{
        if (!hasCoreAccess) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("xc3fY")).ExpandableSubmenuItem), {
            analytics: {
                itemId: 'notifications'
            },
            menuItemLabel: formatMessage((0, (0, parcelRequire("17zko")).messages).itemNotifications),
            forceExpand: true,
            submenuId: "core-notifications-settings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("71bFU")).NotificationsSubMenu), {
            settingsUrl: `${baseSettingsUrl}/notifications`,
            issueLogsUrl: `${baseSettingsUrl}/notifications/issue-logs?projectId=${projectId}`
        }));
    };
    const $26eff467887b13fc$export$c72f6eaae7b9adff = ({ stack: stack })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: project } = $26eff467887b13fc$export$a4007dc4843ca7f6();
        const { hasCoreAccess: hasCoreAccess } = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        const hasDlpEnabled = (0, (0, parcelRequire("6EZeH")).useDlpEntitlement)();
        const isPremiumUserSeat = (0, (0, parcelRequire("iNzEe")).useIsPremiumUserSeat)();
        const { data: settingFeatures } = (0, (0, parcelRequire("bkw8F")).useSettingFeatures)();
        const [{ data: connectAppsData }, { fetch: fetchConnectApps }] = (0, (0, parcelRequire("j9iVo")).useConnectApps)();
        (0, $5uXOq.useEffect)(()=>{
            if (project && !connectAppsData) fetchConnectApps(project.key);
        }, [
            connectAppsData,
            fetchConnectApps,
            project
        ]);
        if (project == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), null);
        const baseSettingsUrl = (0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).CORE_PROJECT), project.key);
        const showCoreForms = (0, (0, parcelRequire("co1wz")).ff)('proforma-mvp-jwm-project-settings_5edja') && hasCoreAccess;
        const BackMenuItem = {
            href: baseSettingsUrl,
            title: formatMessage((0, (0, parcelRequire("17zko")).messages).title)
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OGaE")).TitleHeader), null, formatMessage((0, (0, parcelRequire("17zko")).messages).title)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'details'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `${baseSettingsUrl}/details`
        }, formatMessage((0, (0, parcelRequire("17zko")).messages).itemDetails)), hasCoreAccess && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'access'
            },
            href: `${baseSettingsUrl}/access`,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("17zko")).messages).itemAccess)), (0, ($parcel$interopDefault($5uXOq))).createElement($26eff467887b13fc$var$DisplayNotificationsOptions, {
            hasCoreAccess: hasCoreAccess,
            formatMessage: formatMessage,
            baseSettingsUrl: baseSettingsUrl,
            projectId: project.id
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'automation'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `${baseSettingsUrl}/automation`
        }, formatMessage((0, (0, parcelRequire("17zko")).messages).automation)), hasCoreAccess && settingFeatures?.hasFields && (0, (0, parcelRequire("4R6GH")).fg)('project_fields_page_for_tmp_-_mvp') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'fields'
            },
            href: `${baseSettingsUrl}/fields`,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("17zko")).messages).itemFieldsNonFinal)), (0, (0, parcelRequire("3SzZi")).shouldRenderNesting)(hasCoreAccess, stack, (0, (0, parcelRequire("gb5lQ")).SECTION_ID).ISSUE_TYPES) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kZj7F")).NestingMenuItem), {
            analytics: {
                itemId: 'issuetypes'
            },
            href: `${baseSettingsUrl}/issuetypes`,
            id: (0, (0, parcelRequire("gb5lQ")).SECTION_ID).ISSUE_TYPES,
            overrides: {
                BackMenuItem: BackMenuItem
            },
            title: formatMessage((0, (0, parcelRequire("17zko")).messages).itemIssueTypes)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1tmBf")).IssueTypes), null)), isPremiumUserSeat && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'approvals'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `${baseSettingsUrl}/approvals`
        }, formatMessage((0, (0, parcelRequire("17zko")).messages).itemApprovals)), showCoreForms && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'proforma-forms'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `${baseSettingsUrl}/forms`
        }, formatMessage((0, (0, parcelRequire("17zko")).messages).itemAdvancedForms)), (0, (0, parcelRequire("3SzZi")).shouldRenderNesting)(hasCoreAccess, stack, 'apps') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("xc3fY")).ExpandableSubmenuItem), {
            analytics: {
                itemId: 'apps'
            },
            menuItemLabel: formatMessage((0, (0, parcelRequire("7OvX8")).messages).apps),
            forceExpand: true,
            submenuId: "nextgen-apps-settings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9DEd8")).EcosystemAppsMenu), null)), hasDlpEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'data-classification'
            },
            href: `${baseSettingsUrl}/data-classifications`,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("17zko")).messages).dataClassificationNonFinal))));
    };
    const $26eff467887b13fc$export$1d7840d5cdc861d5 = (props)=>{
        const { data: project } = $26eff467887b13fc$export$a4007dc4843ca7f6();
        if (project == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), null);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j9iVo")).ConnectAppsContainer), {
            onError: undefined,
            scope: project.key
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($26eff467887b13fc$export$c72f6eaae7b9adff, props)));
    };
});
parcelRegister("xc3fY", function(module, exports) {
    $parcel$export(module.exports, "ExpandableSubmenuItem", ()=>$dec8d2ea50472f86$export$16ba9a3b96f3ac6d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $3TzYp;
    var $iUo88;
    var $4R6GH;
    var $8zOmE;
    var $95EVP;
    var $fXJBp;
    var $k0ZZ2;
    const $dec8d2ea50472f86$var$defaultExpandMenuState = {
        submenuActive: false,
        expanded: false
    };
    const $dec8d2ea50472f86$export$e5a6b8291f2460bc = ()=>{
        const getExpandableState = (submenuId)=>{
            const cookieData = (0, (0, parcelRequire("3TzYp")).getCookie)(`jira.navigation.expandableMenuStates.${submenuId}`);
            let parsedCookieData = null;
            try {
                parsedCookieData = JSON.parse(cookieData);
            } catch  {
                parsedCookieData = $dec8d2ea50472f86$var$defaultExpandMenuState;
            }
            return parsedCookieData;
        };
        const setExpandedState = (submenuId, newExpandedState)=>{
            if (submenuId != null) (0, (0, parcelRequire("iUo88")).setStrictlyNecessaryCookie)(`jira.navigation.expandableMenuStates.${submenuId}`, JSON.stringify(newExpandedState));
        };
        return {
            getExpandableState: getExpandableState,
            setExpandedState: setExpandedState
        };
    };
    const $dec8d2ea50472f86$export$16ba9a3b96f3ac6d = ({ children: children, analytics: analytics, iconBefore: iconBefore = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null), menuItemLabel: menuItemLabel, expandButtonLabel: expandButtonLabel = 'expand', href: href, useButtonLink: useButtonLink = false, forceExpand: forceExpand = false, noListStyle: noListStyle = false, submenuId: submenuId = '', testId: testId = '' })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        const { getExpandableState: getExpandableState, setExpandedState: setExpandedState } = $dec8d2ea50472f86$export$e5a6b8291f2460bc();
        const [subMenuActive, setSubMenuActive] = (0, $5uXOq.useState)(false);
        const [currentCookieData] = (0, $5uXOq.useState)(getExpandableState(submenuId));
        const expandButtonId = menuItemLabel.replace(/ /g, '-').toLowerCase();
        const [expanded, setExpanded] = (0, $5uXOq.useState)(currentCookieData?.expanded || (0, (0, parcelRequire("4R6GH")).fg)('jsm_simplified_project_settings_navigation') ? forceExpand : false);
        const expandableMenuItemRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("4R6GH")).fg)('jsm_simplified_project_settings_navigation') && forceExpand) setExpanded(true);
        }, [
            forceExpand
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (currentCookieData?.expanded) {
                setExpanded(currentCookieData.expanded);
                setSubMenuActive(currentCookieData.submenuActive);
            }
        }, [
            currentCookieData
        ]);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            if (submenuId != null) setExpandedState(submenuId, {
                submenuActive: false,
                expanded: !expanded
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'expandButton changed', 'projectSettings', {
                expandMenuId: analytics?.itemId,
                expanded: !expanded
            });
            setExpanded(!expanded);
            requestAnimationFrame(()=>{
                expandableMenuItemRef?.current?.focus();
            });
        }, [
            analytics,
            createAnalyticsEvent,
            expanded,
            setExpandedState,
            submenuId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($dec8d2ea50472f86$var$ExpandableSubmenuWrapper, {
            isExpanded: subMenuActive
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: analytics,
            href: href,
            useButtonLink: useButtonLink,
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fXJBp")).ExpandButton), {
                id: expandButtonId,
                label: expandButtonLabel,
                isActive: true,
                isExpanded: expanded,
                size: "medium"
            }), iconBefore),
            onClick: onClick,
            "data-test-id": testId,
            ref: expandableMenuItemRef,
            tabIndex: -1
        }, menuItemLabel), expanded && (0, ($parcel$interopDefault($5uXOq))).createElement($dec8d2ea50472f86$var$ExpandableSubmenuItemWrapper, {
            noListStyle: noListStyle
        }, children));
    };
    const $dec8d2ea50472f86$var$ExpandableSubmenuWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isExpanded: isExpanded, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_hstcidpf _11lvidpf _44p6idpf _l7mvidpf _1gid5cnj _1t1q5cnj _qmbb5cnj _130y5cnj _cyds5cnj _wpy85cnj _da5j5cnj _14p45cnj _r3xj5cnj _1p1m5cnj _12kz5cnj _67om5cnj _1gw75cnj _1rnb5cnj _vxqc5cnj _1ve95cnj _1qslpxbi _16khpxbi _ek7jpxbi _1mdfpxbi _1mp8pxbi _40k9pxbi _15e4pxbi _3hrxpxbi _erbmpxbi _5vm1pxbi _1e43pxbi _f4s1pxbi _1fabpxbi _da52pxbi _1aolpxbi _qdxopxbi _zyjmqslr _4rtsqslr _1bb1qslr _gis0qslr _19ixqslr _qbnnqslr _ii9vqslr _176zqslr _qylaqslr _1xqvqslr _uzbcqslr _1ifwqslr _i6ubqslr _1u1wqslr _1ks5qslr _329dqslr _fe5pidpf _kywyt94y",
                __cmplp.isExpanded && "_4t3i1osq",
                __cmplp.className
            ])
        });
    });
    const $dec8d2ea50472f86$var$ExpandableSubmenuItemWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _18u0r5cr _ujmh1osq _1nx0u2gc _hstcidpf _fgl3wgn3 _fl8b12x7 _9b588aae _14tk72c6 _1u1didpf _1thcforw _19as19el _kk3x126e _14o4107n",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fXJBp", function(module, exports) {
    $parcel$export(module.exports, "ExpandButton", ()=>$a3120c1c485e5e18$export$5663c8f5aeb8c1c4);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $9ed83;
    var $2xkq3;
    var $68lfN;
    var $cSFUi;
    var $6T4rd;
    var $dCm1o;
    const $a3120c1c485e5e18$export$5663c8f5aeb8c1c4 = ({ id: id, label: label, isActive: isActive, isExpanded: isExpanded, onClick: onClick = ()=>null, size: size, isVisible: isVisible = true, removeCaret: removeCaret = false, tabIndex: tabIndex = null })=>{
        const ChevronOld = isExpanded ? (0, ($parcel$interopDefault((0, parcelRequire("9ed83"))))) : (0, ($parcel$interopDefault((0, parcelRequire("2xkq3")))));
        const ChevronIcon = isExpanded ? (0, ($parcel$interopDefault((0, parcelRequire("68lfN"))))) : (0, ($parcel$interopDefault((0, parcelRequire("cSFUi")))));
        const onKeydown = (0, $5uXOq.useCallback)((event)=>{
            if ([
                13,
                32
            ].includes(event.keyCode)) {
                event.preventDefault();
                onClick();
            }
        }, [
            onClick
        ]);
        const chevronElement = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            padding: "space.075",
            paddingBlockStart: "space.025"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(ChevronIcon, {
            testId: `sidebar.expand-button.container-${id}`,
            color: "var(--ds-icon, #44546F)",
            label: label
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement(ChevronOld, {
            testId: `sidebar.expand-button.container-${id}`,
            primaryColor: `var(--ds-icon, ${(0, $5e0c0d4e15efb4a6$export$c39c0fe0f26207ae)})`,
            label: label,
            size: size
        });
        if (!isActive) return chevronElement;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a3120c1c485e5e18$var$Container, {
            role: "button",
            "aria-expanded": isExpanded,
            onClick: onClick,
            onKeyDown: onKeydown,
            isVisible: isVisible,
            removeCaret: removeCaret,
            size: size,
            tabIndex: tabIndex
        }, chevronElement);
    };
    const $a3120c1c485e5e18$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isVisible: isVisible, removeCaret: removeCaret, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _4t3i1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _bfhk18uv _80omtlke _16jlidpf _1o9zidpf _i0dl1wug _12ji1r31 _1qu2glyw _12y31o36 _v5641mqx _1spjglyw _1ejj12vo _19lvkb7n",
                __cmplp.size === 'medium' ? "_154imyb0" : "_154iidpf",
                __cmplp.isVisible ? "_tzy4kb7n" : "_tzy4idpf",
                __cmplp.removeCaret ? "_1e0cglyw" : "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("71bFU", function(module, exports) {
    $parcel$export(module.exports, "NotificationsSubMenu", ()=>$4606ea7b05b7e72d$export$f80567459a5e304a);
    var $5uXOq = parcelRequire("5uXOq");
    var $9ARNv;
    var $eddAM;
    var $47htk;
    var $6T4rd;
    var $jJ1Sb;
    var $5tOuG;
    var $aWse0;
    var $k0ZZ2;
    var $lpwtK;
    var $7OqB4;
    var $4OCke;
    var $icKiA;
    const $4606ea7b05b7e72d$export$51b1383ef8844a7 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("lpwtK")).useProject));
    const $4606ea7b05b7e72d$var$ISSUE_EMAIL_LOG_SPOTLIGHT_KEY = 'issue-email-log-spotlight';
    const $4606ea7b05b7e72d$export$f80567459a5e304a = ({ settingsUrl: settingsUrl, issueLogsUrl: issueLogsUrl, displayLozenge: displayLozenge = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const { data: project, loading: projectLoading } = $4606ea7b05b7e72d$export$51b1383ef8844a7();
        if (projectLoading || !project) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), null);
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'notifications-settings'
            },
            href: settingsUrl,
            ref: (0, $5uXOq.createRef)(),
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("icKiA")).messages).itemSettings)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("47htk")).default), {
            name: $4606ea7b05b7e72d$var$ISSUE_EMAIL_LOG_SPOTLIGHT_KEY
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'notifications-issue-logs'
            },
            href: issueLogsUrl,
            ref: (0, $5uXOq.createRef)(),
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            xcss: $4606ea7b05b7e72d$var$issueLogsContainerStyles
        }, formatMessage((0, (0, parcelRequire("icKiA")).messages).itemProjectEmailAuditLogs), displayLozenge && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eddAM")).default), {
            appearance: "new"
        }, formatMessage((0, (0, parcelRequire("icKiA")).messages).newLozenge)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9ARNv")).EngagementSpotlight), {
            engagementId: $4606ea7b05b7e72d$var$ISSUE_EMAIL_LOG_SPOTLIGHT_KEY
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, content);
    };
    const $4606ea7b05b7e72d$var$issueLogsContainerStyles = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        display: 'flex',
        justifyContent: 'space-between'
    });
});
parcelRegister("aWse0", function(module, exports) {
    $parcel$export(module.exports, "useIntlV2", ()=>$6b28e3c9e1c89fbd$export$d82607073b68786);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    const $6b28e3c9e1c89fbd$export$d82607073b68786 = ()=>{
        const { messages: messages, locale: locale, formats: formats, formatDate: formatDate, formatMessage: formatMessage, formatNumber: formatNumber, formatPlural: formatPlural, formatTime: formatTime } = (0, (0, parcelRequire("koVbs")).default)();
        const memoisedIntl = (0, $5uXOq.useMemo)(()=>{
            const modifiedIntl = {
                messages: messages,
                locale: locale,
                formats: formats,
                formatDate: formatDate,
                formatMessage: formatMessage,
                formatNumber: formatNumber,
                formatPlural: formatPlural,
                formatTime: formatTime
            };
            return modifiedIntl;
        }, [
            formatDate,
            formatMessage,
            formatPlural,
            formatTime,
            formatNumber,
            formats,
            locale,
            messages
        ]);
        return memoisedIntl;
    };
});
parcelRegister("icKiA", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$0ac4b8c96850fb1d$export$defe85febe8b728c);
    var $7VHMR;
    const $0ac4b8c96850fb1d$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        itemSettings: {
            "id": "spa-apps-sidebar-common.notifications-sub-menu.item-settings",
            "defaultMessage": "Settings"
        },
        itemProjectEmailAuditLogs: {
            "id": "spa-apps-sidebar-common.notifications-sub-menu.item-project-email-audit-logs",
            "defaultMessage": "Project email audit"
        },
        newLozenge: {
            "id": "spa-apps-sidebar-common.notifications-sub-menu.new-lozenge",
            "defaultMessage": "New"
        }
    });
});
parcelRegister("02Psx", function(module, exports) {
    $parcel$export(module.exports, "getNextgenSettingsUrl", ()=>$a59737cd16881573$export$26432406821aa7bf);
    $parcel$export(module.exports, "getNextgenSettingsIssueTypesUrl", ()=>$a59737cd16881573$export$defee92e506aa306);
    $parcel$export(module.exports, "getNextgenSettingsWorkflowUrl", ()=>$a59737cd16881573$export$9133e09a98a043dc);
    $parcel$export(module.exports, "getNextgenSettingsJSDAutomationUrl", ()=>$a59737cd16881573$export$b0d20d18e0230e83);
    $parcel$export(module.exports, "getClassicJSWSettingsUrl", ()=>$a59737cd16881573$export$ff0a17aa36a000df);
    $parcel$export(module.exports, "getProjectSettingsDetailsUrl", ()=>$a59737cd16881573$export$16d52b9357bb73ab);
    $parcel$export(module.exports, "getClassicIssueLayoutSettingsUrl", ()=>$a59737cd16881573$export$d531a9788343348f);
    $parcel$export(module.exports, "getClassicRequestTypeLayoutSettingsUrl", ()=>$a59737cd16881573$export$dad567762dae162e);
    $parcel$export(module.exports, "getJcsRequestTypeLayoutSettingsUrl", ()=>$a59737cd16881573$export$8b304050f4836b59);
    var $2vSU6;
    var $3XO6n;
    var $gl0PU;
    var $1RLjE;
    const $a59737cd16881573$export$26432406821aa7bf = (projectType, projectKey)=>{
        const products = {
            [(0, (0, parcelRequire("2vSU6")).CORE_PROJECT)]: 'core',
            [(0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)]: 'servicedesk',
            [(0, (0, parcelRequire("2vSU6")).CUSTOMER_SERVICE_PROJECT)]: 'customerservice',
            [(0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT)]: 'software',
            [(0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)]: 'polaris'
        };
        const product = products[projectType];
        if (!product) {
            (0, (0, parcelRequire("1RLjE")).logError)((0, (0, parcelRequire("3XO6n")).PACKAGE_NAME), (0, (0, parcelRequire("gl0PU")).toErrorId)('urls'), (0, (0, parcelRequire("gl0PU")).toErrorMessage)(`Can't build default project settings url for project type: ${projectType}`), new Error(`Unexpected project type: ${projectType}`));
            return `/projects/${projectKey}/settings`;
        }
        if (projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)) return `/jira/${product}/projects/${projectKey}/ideas/settings`;
        return `/jira/${product}/projects/${projectKey}/settings`;
    };
    const $a59737cd16881573$var$serializeBackLink = (backLink)=>{
        if (backLink == null) return '';
        const { url: url, title: title } = backLink;
        return `#backLinkUrl=${encodeURIComponent(url)}&backLinkTitle=${encodeURIComponent(title)}`;
    };
    const $a59737cd16881573$export$defee92e506aa306 = (projectType, projectKey, issueTypeId, backLink)=>{
        if (projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)) return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}`;
        return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/issuetypes${issueTypeId ? `/${issueTypeId}` : ''}${$a59737cd16881573$var$serializeBackLink(backLink)}`;
    };
    const $a59737cd16881573$export$9133e09a98a043dc = (projectType, projectKey, issueTypeId)=>{
        if (projectType === (0, (0, parcelRequire("2vSU6")).PRODUCT_DISCOVERY_PROJECT)) return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/workflow`;
        return `${$a59737cd16881573$export$26432406821aa7bf(projectType, projectKey)}/issuetypes/${issueTypeId}/workflow`;
    };
    const $a59737cd16881573$export$b0d20d18e0230e83 = (projectKey)=>`${$a59737cd16881573$export$26432406821aa7bf((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), projectKey)}/automation`;
    const $a59737cd16881573$export$ff0a17aa36a000df = (projectKey)=>`/jira/software/c/projects/${projectKey}/settings`;
    const $a59737cd16881573$export$16d52b9357bb73ab = (projectType, projectKey, isSimplified)=>{
        const urlBase = projectType === (0, (0, parcelRequire("2vSU6")).SOFTWARE_PROJECT) && !isSimplified ? $a59737cd16881573$export$ff0a17aa36a000df(projectKey) : $a59737cd16881573$export$26432406821aa7bf(projectType, projectKey);
        return `${urlBase}/details`;
    };
    const $a59737cd16881573$export$d531a9788343348f = ({ projectKey: projectKey, viewScreenId: viewScreenId, backLink: backLink })=>`/plugins/servlet/project-config/${projectKey}/issuelayout?screenId=${viewScreenId}${$a59737cd16881573$var$serializeBackLink(backLink)}`;
    const $a59737cd16881573$export$dad567762dae162e = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/servicedesk/projects/${projectKey}/settings/request-types/request-type/${requestTypeId}${$a59737cd16881573$var$serializeBackLink(backLink)}`;
    const $a59737cd16881573$export$8b304050f4836b59 = ({ projectKey: projectKey, requestTypeId: requestTypeId, backLink: backLink })=>`/jira/helpcenter/projects/${projectKey}/settings/request-types/unassigned/request-type/${requestTypeId}${$a59737cd16881573$var$serializeBackLink(backLink)}`;
});
parcelRegister("3XO6n", function(module, exports) {
    $parcel$export(module.exports, "TASK", ()=>$594ec5369f29a734$export$9355e489ad16f98e);
    $parcel$export(module.exports, "BUG", ()=>$594ec5369f29a734$export$bcf558c186108044);
    $parcel$export(module.exports, "STORY", ()=>$594ec5369f29a734$export$1ea39a3ae330045);
    $parcel$export(module.exports, "EPIC", ()=>$594ec5369f29a734$export$3cb4a99a332e4186);
    $parcel$export(module.exports, "SUB_TASK", ()=>$594ec5369f29a734$export$a06f889861f6537d);
    $parcel$export(module.exports, "CUSTOM", ()=>$594ec5369f29a734$export$952581bc40160893);
    $parcel$export(module.exports, "TEMPLATES_WHITELIST", ()=>$594ec5369f29a734$export$dff1da4a9bab6d3e);
    $parcel$export(module.exports, "TEXT_AREA_CF_TYPE", ()=>$594ec5369f29a734$export$39cd48613b53ce2f);
    $parcel$export(module.exports, "DESCRIPTION_FIELD_TYPE", ()=>$594ec5369f29a734$export$56eae1056efd4899);
    $parcel$export(module.exports, "ENVIRONMENT_FIELD_TYPE", ()=>$594ec5369f29a734$export$ca61f05d869b2ea3);
    $parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_NAME", ()=>$594ec5369f29a734$export$2ec42920a0df6b9a);
    $parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_ANALYTIC_TYPE", ()=>$594ec5369f29a734$export$40c10ba35ceb5c6b);
    $parcel$export(module.exports, "JIRA_SERVICE_MANAGEMENT_APP_NAME", ()=>$594ec5369f29a734$export$a11dccbf88784c62);
    $parcel$export(module.exports, "JIRA_PRODUCT_DISCOVERY_APP_NAME", ()=>$594ec5369f29a734$export$f35dc2e6deb1692e);
    $parcel$export(module.exports, "JIRA_APP_NAME", ()=>$594ec5369f29a734$export$ec5d0e43836cb3c7);
    $parcel$export(module.exports, "toPackageName", ()=>$594ec5369f29a734$export$f31a652635bd75fe);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$594ec5369f29a734$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "NEW_FIELD_OPTION_PREFIX", ()=>$594ec5369f29a734$export$a2231d79966e0ccc);
    $parcel$export(module.exports, "RADIO_FIELD_TYPE", ()=>$594ec5369f29a734$export$28a4bdf7d9b6f9);
    $parcel$export(module.exports, "USERPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$9d758b3e8c6e0ed1);
    $parcel$export(module.exports, "MULTIUSERPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$b0e37d421e006913);
    $parcel$export(module.exports, "SELECT_FIELD_TYPE", ()=>$594ec5369f29a734$export$d77765147749db6b);
    $parcel$export(module.exports, "CASCADINGSELECT_FIELD_TYPE", ()=>$594ec5369f29a734$export$42ef68d6bd555a8d);
    $parcel$export(module.exports, "MULTISELECT_FIELD_TYPE", ()=>$594ec5369f29a734$export$4db6eb15b3c529cf);
    $parcel$export(module.exports, "CHECKBOX_FIELD_TYPE", ()=>$594ec5369f29a734$export$ee975373b7797e8a);
    $parcel$export(module.exports, "TEXT_FIELD_TYPE", ()=>$594ec5369f29a734$export$aa99342cc6a8ced5);
    $parcel$export(module.exports, "NUMBER_FIELD_TYPE", ()=>$594ec5369f29a734$export$6f327bf99e20320);
    $parcel$export(module.exports, "DATETIME_FIELD_TYPE", ()=>$594ec5369f29a734$export$dc64bdfdf9660a05);
    $parcel$export(module.exports, "PROJECTPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$e6d73ed745b9a04);
    $parcel$export(module.exports, "DATE_FIELD_TYPE", ()=>$594ec5369f29a734$export$d8b50f59220c7580);
    $parcel$export(module.exports, "ASSETSPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$3a6f0a44478f1d2);
    $parcel$export(module.exports, "LABELPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$68b76ef93df5a880);
    $parcel$export(module.exports, "GROUPPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$e7773fccbeec45e6);
    $parcel$export(module.exports, "MULTIGROUPPICKER_FIELD_TYPE", ()=>$594ec5369f29a734$export$b45487b145c52a37);
    $parcel$export(module.exports, "VERSION_FIELD_TYPE", ()=>$594ec5369f29a734$export$48548129a6d117f5);
    $parcel$export(module.exports, "MULTIVERSION_FIELD_TYPE", ()=>$594ec5369f29a734$export$722c271a9e11cb94);
    $parcel$export(module.exports, "TEXTAREA_FIELD_TYPE", ()=>$594ec5369f29a734$export$33dbe2a903610aa1);
    $parcel$export(module.exports, "emptyTenantContext", ()=>$594ec5369f29a734$export$ac655f5b3ff7b929);
    var $lzeFL;
    var $5fc53;
    var $ldyPw;
    var $g5X3G;
    var $ef5Xn;
    var $7qPn9;
    const $594ec5369f29a734$export$9355e489ad16f98e = 'task';
    const $594ec5369f29a734$export$bcf558c186108044 = 'bug';
    const $594ec5369f29a734$export$1ea39a3ae330045 = 'story';
    const $594ec5369f29a734$export$3cb4a99a332e4186 = 'epic';
    const $594ec5369f29a734$export$a06f889861f6537d = 'subtask';
    const $594ec5369f29a734$export$952581bc40160893 = 'custom';
    const $594ec5369f29a734$export$dff1da4a9bab6d3e = [
        $594ec5369f29a734$export$9355e489ad16f98e,
        $594ec5369f29a734$export$bcf558c186108044,
        $594ec5369f29a734$export$1ea39a3ae330045,
        $594ec5369f29a734$export$3cb4a99a332e4186
    ];
    const $594ec5369f29a734$export$39cd48613b53ce2f = (0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE);
    const $594ec5369f29a734$export$56eae1056efd4899 = (0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE);
    const $594ec5369f29a734$export$ca61f05d869b2ea3 = (0, (0, parcelRequire("5fc53")).ENVIRONMENT_TYPE);
    const $594ec5369f29a734$export$2ec42920a0df6b9a = 'Story point estimate';
    const $594ec5369f29a734$export$40c10ba35ceb5c6b = 'storyPointEstimate';
    const $594ec5369f29a734$export$a4d3702d4c7481d6 = 44;
    const $594ec5369f29a734$export$8a6a961f6caf7a8b = [
        $594ec5369f29a734$export$56eae1056efd4899,
        $594ec5369f29a734$export$39cd48613b53ce2f,
        $594ec5369f29a734$export$ca61f05d869b2ea3
    ];
    const $594ec5369f29a734$export$e27914436cc13e3c = 'Jira Software';
    const $594ec5369f29a734$export$a11dccbf88784c62 = 'Jira Service Management';
    const $594ec5369f29a734$export$9f4aa232cbb6be46 = 'Jira Work Management';
    const $594ec5369f29a734$export$b3c4739240716eb6 = 'Jira Ops';
    const $594ec5369f29a734$export$f35dc2e6deb1692e = 'Jira Product Discovery';
    const $594ec5369f29a734$export$ec5d0e43836cb3c7 = 'Jira';
    const $594ec5369f29a734$export$f31a652635bd75fe = (packageName)=>packageName;
    const $594ec5369f29a734$export$b8b9d90f9e5bd72b = $594ec5369f29a734$export$f31a652635bd75fe('jiraProjectSettingsAppsCommon');
    const $594ec5369f29a734$export$a2231d79966e0ccc = 'NEW_';
    const $594ec5369f29a734$export$13dc44d2a9a248a4 = 'swift_openAddIssueTypeModal';
    const $594ec5369f29a734$export$28a4bdf7d9b6f9 = 'radio';
    const $594ec5369f29a734$export$9d758b3e8c6e0ed1 = 'userpicker';
    const $594ec5369f29a734$export$b0e37d421e006913 = 'multiuserpicker';
    const $594ec5369f29a734$export$d77765147749db6b = 'select';
    const $594ec5369f29a734$export$42ef68d6bd555a8d = 'cascadingselect';
    const $594ec5369f29a734$export$4db6eb15b3c529cf = 'multiselect';
    const $594ec5369f29a734$export$ee975373b7797e8a = 'checkbox';
    const $594ec5369f29a734$export$aa99342cc6a8ced5 = 'text';
    const $594ec5369f29a734$export$6f327bf99e20320 = 'number';
    const $594ec5369f29a734$export$dc64bdfdf9660a05 = 'datetime';
    const $594ec5369f29a734$export$e6d73ed745b9a04 = 'projectpicker';
    const $594ec5369f29a734$export$d8b50f59220c7580 = 'date';
    const $594ec5369f29a734$export$3a6f0a44478f1d2 = 'assetspicker';
    const $594ec5369f29a734$export$68b76ef93df5a880 = 'labelpicker';
    const $594ec5369f29a734$export$e7773fccbeec45e6 = 'grouppicker';
    const $594ec5369f29a734$export$b45487b145c52a37 = 'multigrouppicker';
    const $594ec5369f29a734$export$48548129a6d117f5 = 'version';
    const $594ec5369f29a734$export$722c271a9e11cb94 = 'multiversion';
    const $594ec5369f29a734$export$33dbe2a903610aa1 = 'textarea';
    const $594ec5369f29a734$export$ac655f5b3ff7b929 = ()=>({
            appEditions: (0, (0, parcelRequire("ldyPw")).populateApplicationEditions)(),
            appPermissions: (0, (0, parcelRequire("7qPn9")).populateApplicationPermissions)(),
            applicationKey: null,
            areProductSuggestionsEnabled: false,
            appUpdatesAvailable: null,
            atlassianAccountId: null,
            baseUrl: (0, (0, parcelRequire("g5X3G")).toBaseUrl)(''),
            cloudId: (0, (0, parcelRequire("g5X3G")).toCloudId)(''),
            activationId: (0, (0, parcelRequire("g5X3G")).toActivationId)(''),
            cloudName: (0, (0, parcelRequire("g5X3G")).toCloudName)(''),
            devopsProjectSignupSource: (0, (0, parcelRequire("g5X3G")).toDevopsProjectSignupSource)(''),
            environment: null,
            fabricActivityUrl: null,
            fabricNotificationLogUrl: null,
            fabricPfDirUrl: null,
            firstActivationDateMs: null,
            isAdmin: false,
            isAnonymous: false,
            isDevMode: false,
            isDevopsProjectCreationScenario: false,
            isMarketingOptOut: false,
            isSiteAdmin: false,
            languageTag: null,
            licenseStates: (0, (0, parcelRequire("ef5Xn")).populateApplicationLicenseStates)(),
            licensedProducts: {},
            locale: (0, (0, parcelRequire("lzeFL")).defaultLocale),
            loggedInUser: null,
            productCrossSellConfig: 'unknown',
            productEntitlementDetails: null,
            productPermissionGated: {
                core: false,
                software: false,
                serviceDesk: false,
                productDiscovery: false
            },
            siteAdminStatus: 'unknown',
            userFullname: null,
            xsrfToken: null,
            hasDlpEnabled: false,
            avpWorkspaceId: null
        });
});
parcelRegister("5fc53", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_LINK_SEARCH", ()=>$81f079589240b9b7$export$b144116dae474c88);
    $parcel$export(module.exports, "ISSUE_FIELD_NUMBER_CF_TYPE", ()=>$81f079589240b9b7$export$bc917bc699b25f75);
    $parcel$export(module.exports, "ISSUE_FIELD_STRING_CF_TYPE", ()=>$81f079589240b9b7$export$5f26ca419fdffbe7);
    $parcel$export(module.exports, "ISSUE_FIELD_DATETIME_CF_TYPE", ()=>$81f079589240b9b7$export$ce9bfd823c7e1a6d);
    $parcel$export(module.exports, "ISSUE_FIELD_DATE_CF_TYPE", ()=>$81f079589240b9b7$export$346b72b1f7cd6d5a);
    $parcel$export(module.exports, "ISSUE_FIELD_SINGLE_SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$b20fbcacd7942c2a);
    $parcel$export(module.exports, "ISSUE_FIELD_ANY_CF_TYPE", ()=>$81f079589240b9b7$export$a2e8554bffc61ece);
    $parcel$export(module.exports, "ISSUE_FIELD_MULTI_SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$f25cd4907cbb25b9);
    $parcel$export(module.exports, "ISSUE_FIELD_USER_CF_TYPE", ()=>$81f079589240b9b7$export$5600354b43577e17);
    $parcel$export(module.exports, "ISSUE_FIELD_SINGLE_GROUP_CF_TYPE", ()=>$81f079589240b9b7$export$5dbc9917f72d0d2a);
    $parcel$export(module.exports, "ISSUE_FIELD_OBJECT_CF_TYPE", ()=>$81f079589240b9b7$export$253649f07fb55948);
    $parcel$export(module.exports, "ISSUE_FIELD_GROUPS_CF_TYPE", ()=>$81f079589240b9b7$export$eb39592ba5247ee7);
    $parcel$export(module.exports, "ISSUE_FIELD_STRINGS_CF_TYPE", ()=>$81f079589240b9b7$export$f48a9be226105736);
    $parcel$export(module.exports, "ISSUE_FIELD_VERSION_CF_TYPE", ()=>$81f079589240b9b7$export$42e2e93fc721df5d);
    $parcel$export(module.exports, "APPROVALS_PANEL_TYPE", ()=>$81f079589240b9b7$export$7773375e72c953ed);
    $parcel$export(module.exports, "ISSUE_FIELD_PROJECT_CF_TYPE", ()=>$81f079589240b9b7$export$80ad0037098f3919);
    $parcel$export(module.exports, "AFFECTED_SERVICES_GQL_FIELD", ()=>$81f079589240b9b7$export$6875c7efa3a5e380);
    $parcel$export(module.exports, "ASSIGNEE_GQL_FIELD", ()=>$81f079589240b9b7$export$7c1a5c7d37b8f968);
    $parcel$export(module.exports, "ATLASSIAN_TEAM_GQL_FIELD", ()=>$81f079589240b9b7$export$c5931a5d7dbfb40b);
    $parcel$export(module.exports, "BOOLEAN_GQL_FIELD", ()=>$81f079589240b9b7$export$c979d9c548c05133);
    $parcel$export(module.exports, "CASCADING_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$ff25e7412c4ae9c7);
    $parcel$export(module.exports, "CHECKBOX_GQL_FIELD", ()=>$81f079589240b9b7$export$16dbdf57e34e8d63);
    $parcel$export(module.exports, "CHILDREN_EXCEEDING_LIMIT_GQL_FIELD", ()=>$81f079589240b9b7$export$1bf8bec92e6e84df);
    $parcel$export(module.exports, "CHILDREN_WITHIN_LIMIT_GQL_FIELD", ()=>$81f079589240b9b7$export$c32f5d822fe5ea95);
    $parcel$export(module.exports, "CMDB_GQL_FIELD", ()=>$81f079589240b9b7$export$b0deb225eed90fbd);
    $parcel$export(module.exports, "COLOR_GQL_FIELD", ()=>$81f079589240b9b7$export$add3775cfea8fde3);
    $parcel$export(module.exports, "COMPONENTS_GQL_FIELD", ()=>$81f079589240b9b7$export$9631d4098abab3eb);
    $parcel$export(module.exports, "CONNECT_DATE_TIME_GQL_FIELD", ()=>$81f079589240b9b7$export$ee42bc16c09ee564);
    $parcel$export(module.exports, "CONNECT_NUMBER_GQL_FIELD", ()=>$81f079589240b9b7$export$fbcebbdce821f712);
    $parcel$export(module.exports, "CONNECT_MULTI_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$41dd2eb1f33d3042);
    $parcel$export(module.exports, "CONNECT_RICH_TEXT_GQL_FIELD", ()=>$81f079589240b9b7$export$f4e3e72a3be84e5b);
    $parcel$export(module.exports, "CONNECT_SINGLE_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$d6738c8a6d1a735d);
    $parcel$export(module.exports, "CONNECT_TEXT_GQL_FIELD", ()=>$81f079589240b9b7$export$79a75502a3f0c4c4);
    $parcel$export(module.exports, "DATE_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$ed2eabcf0931df31);
    $parcel$export(module.exports, "DATE_TIME_GQL_FIELD", ()=>$81f079589240b9b7$export$1f17904e959f2f0b);
    $parcel$export(module.exports, "EPIC_LINK_GQL_FIELD", ()=>$81f079589240b9b7$export$6d8da4497234455);
    $parcel$export(module.exports, "FLAG_GQL_FIELD", ()=>$81f079589240b9b7$export$9bcfac568e4fa59c);
    $parcel$export(module.exports, "ISSUE_RESTRICTION_GQL_FIELD", ()=>$81f079589240b9b7$export$dd84cd6c957c6f5e);
    $parcel$export(module.exports, "ISSUE_TYPE_GQL_FIELD", ()=>$81f079589240b9b7$export$5cc7c39d7d1cf6d5);
    $parcel$export(module.exports, "LABEL_GQL_FIELD", ()=>$81f079589240b9b7$export$810709f0c5c2e9db);
    $parcel$export(module.exports, "MULTI_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$82cb6735134c23a2);
    $parcel$export(module.exports, "MULTI_USER_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$85e04e9a3a81ee1);
    $parcel$export(module.exports, "MULTI_VERSION_GQL_FIELD", ()=>$81f079589240b9b7$export$24c916a8a33ed20c);
    $parcel$export(module.exports, "MULTI_GROUP_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$c049920d930c3b8a);
    $parcel$export(module.exports, "NUMBER_GQL_FIELD", ()=>$81f079589240b9b7$export$3b6d7fc1833bf7da);
    $parcel$export(module.exports, "ORIGINAL_ESTIMATE_GQL_FIELD", ()=>$81f079589240b9b7$export$bd3e2fe853319c13);
    $parcel$export(module.exports, "PARENT_GQL_FIELD", ()=>$81f079589240b9b7$export$6dfd3fc78bc751a0);
    $parcel$export(module.exports, "PEOPLE_GQL_FIELD", ()=>$81f079589240b9b7$export$31aea7548807c6b5);
    $parcel$export(module.exports, "PRIORITY_GQL_FIELD", ()=>$81f079589240b9b7$export$e89fbbf3983c0219);
    $parcel$export(module.exports, "PROFORMA_FORMS_GQL_FIELD", ()=>$81f079589240b9b7$export$f5e2fb1022ff7912);
    $parcel$export(module.exports, "PROJECT_GQL_FIELD", ()=>$81f079589240b9b7$export$12f54499c6252188);
    $parcel$export(module.exports, "RADIO_GQL_FIELD", ()=>$81f079589240b9b7$export$8e4293d806f435e0);
    $parcel$export(module.exports, "REPORTER_GQL_FIELD", ()=>$81f079589240b9b7$export$c69486dd643dfb69);
    $parcel$export(module.exports, "RESOLUTION_GQL_FIELD", ()=>$81f079589240b9b7$export$1e4faa0d6dc58a81);
    $parcel$export(module.exports, "RICH_TEXT_GQL_FIELD", ()=>$81f079589240b9b7$export$37f4daaa7b409554);
    $parcel$export(module.exports, "SECURITY_GQL_FIELD", ()=>$81f079589240b9b7$export$ca57cccd6d7bf97c);
    $parcel$export(module.exports, "SINGLE_GROUP_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$bea889616fd5bdab);
    $parcel$export(module.exports, "SINGLE_SELECT_GQL_FIELD", ()=>$81f079589240b9b7$export$ab5cecc580898d1c);
    $parcel$export(module.exports, "SPRINT_GQL_FIELD", ()=>$81f079589240b9b7$export$bb63813d13e8eaf7);
    $parcel$export(module.exports, "STATUS_GQL_FIELD", ()=>$81f079589240b9b7$export$e40f819979b3881d);
    $parcel$export(module.exports, "TEAM_GQL_FIELD", ()=>$81f079589240b9b7$export$6c243704a22baffe);
    $parcel$export(module.exports, "TEAM_VIEW_GQL_FIELD", ()=>$81f079589240b9b7$export$6c32429bac235203);
    $parcel$export(module.exports, "TEXT_GQL_FIELD", ()=>$81f079589240b9b7$export$61b514b470cbbf07);
    $parcel$export(module.exports, "TIME_TRACKING_GQL_FIELD", ()=>$81f079589240b9b7$export$e4bcb1729da5683);
    $parcel$export(module.exports, "URL_GQL_FIELD", ()=>$81f079589240b9b7$export$37ccd11f08a93ccb);
    $parcel$export(module.exports, "USER_PICKER_GQL_FIELD", ()=>$81f079589240b9b7$export$abf1bf8c1106ba7d);
    $parcel$export(module.exports, "VERSION_GQL_FIELD", ()=>$81f079589240b9b7$export$b55604041ae7179e);
    $parcel$export(module.exports, "VOTES_GQL_FIELD", ()=>$81f079589240b9b7$export$c8bf66d62e74cdd2);
    $parcel$export(module.exports, "WATCHES_GQL_FIELD", ()=>$81f079589240b9b7$export$aa815aaa741ae18);
    $parcel$export(module.exports, "JSM_ASSETS_GQL_FIELD", ()=>$81f079589240b9b7$export$e805f89b15d2abf4);
    $parcel$export(module.exports, "JSM_PEOPLE_GQL_FIELD", ()=>$81f079589240b9b7$export$5bfd36acd96f04c2);
    $parcel$export(module.exports, "JSM_ORGANIZATION_GQL_FIELD", ()=>$81f079589240b9b7$export$695423a2bc8a9ac4);
    $parcel$export(module.exports, "FORGE_STRING_GQL_FIELD", ()=>$81f079589240b9b7$export$d29b0ba0d80bc129);
    $parcel$export(module.exports, "FORGE_STRINGS_GQL_FIELD", ()=>$81f079589240b9b7$export$ac6c7b30703608d6);
    $parcel$export(module.exports, "FORGE_NUMBER_GQL_FIELD", ()=>$81f079589240b9b7$export$478b546dccd33e1e);
    $parcel$export(module.exports, "FORGE_DATETIME_GQL_FIELD", ()=>$81f079589240b9b7$export$f90c042e9eb983e7);
    $parcel$export(module.exports, "FORGE_DATE_GQL_FIELD", ()=>$81f079589240b9b7$export$753ca4fb34ff3f2b);
    $parcel$export(module.exports, "FORGE_OBJECT_GQL_FIELD", ()=>$81f079589240b9b7$export$b7aed9efb4a9154b);
    $parcel$export(module.exports, "FORGE_GROUP_GQL_FIELD", ()=>$81f079589240b9b7$export$1763713d718f7ef0);
    $parcel$export(module.exports, "FORGE_USER_GQL_FIELD", ()=>$81f079589240b9b7$export$ebb0caa2a98dcf9e);
    $parcel$export(module.exports, "FORGE_GROUPS_GQL_FIELD", ()=>$81f079589240b9b7$export$671131ba12d94144);
    $parcel$export(module.exports, "FORGE_USERS_GQL_FIELD", ()=>$81f079589240b9b7$export$c48132adab502d6b);
    $parcel$export(module.exports, "JSM_APPROVAL_GQL_FIELD", ()=>$81f079589240b9b7$export$6cd83226f31c7072);
    $parcel$export(module.exports, "JSM_USER_APPROVER_PRINCIPAL_FIELD", ()=>$81f079589240b9b7$export$7de726bd6d97a9a7);
    $parcel$export(module.exports, "JSM_GROUP_APPROVER_PRINCIPAL_FIELD", ()=>$81f079589240b9b7$export$8e4b538f77340a05);
    $parcel$export(module.exports, "JSM_REQUEST_FEEDBACK_GQL_FIELD", ()=>$81f079589240b9b7$export$10ba8c0d74470907);
    $parcel$export(module.exports, "JSM_REQUEST_LANGUAGE_GQL_FIELD", ()=>$81f079589240b9b7$export$1756bb4eff1cc3c6);
    $parcel$export(module.exports, "JSM_REQUEST_TYPE_GQL_FIELD", ()=>$81f079589240b9b7$export$5876b4be3c4407b);
    $parcel$export(module.exports, "JSM_RESPONDERS_GQL_FIELD", ()=>$81f079589240b9b7$export$e7fe49e6f36c7154);
    $parcel$export(module.exports, "JSM_USER_RESPONDER_GQL_FIELD", ()=>$81f079589240b9b7$export$aeed3395a6bca18b);
    $parcel$export(module.exports, "JSM_ENTITLEMENTS_GQL_FIELD", ()=>$81f079589240b9b7$export$9b725a1eafd02e4f);
    $parcel$export(module.exports, "JSM_SENTIMENT_GQL_FIELD", ()=>$81f079589240b9b7$export$699805cbca2c41d);
    $parcel$export(module.exports, "JSM_TEAM_RESPONDER_FIELD", ()=>$81f079589240b9b7$export$f658d5c0f0b5dbc2);
    $parcel$export(module.exports, "JSM_MAJOR_INCIDENT_FIELD", ()=>$81f079589240b9b7$export$e469bcb2060000af);
    $parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", ()=>$81f079589240b9b7$export$f10e53e8928b61bd);
    $parcel$export(module.exports, "GOALS_GQL_FIELD", ()=>$81f079589240b9b7$export$bfcb1a91094f113a);
    $parcel$export(module.exports, "DURATION_GQL_FIELD", ()=>$81f079589240b9b7$export$db0bd6c04eb7d04a);
    $parcel$export(module.exports, "FORGE_CUSTOM_FIELD_TYPE", ()=>$81f079589240b9b7$export$798d2f5814884447);
    $parcel$export(module.exports, "TEAMS_PLATFORM_CF_TYPE", ()=>$81f079589240b9b7$export$269d70c1b1c9fb80);
    $parcel$export(module.exports, "APPROVALS_CF_TYPE", ()=>$81f079589240b9b7$export$f0f17ef462331df4);
    $parcel$export(module.exports, "CATEGORY_TYPE", ()=>$81f079589240b9b7$export$3c7d8923295a5199);
    $parcel$export(module.exports, "PEOPLE_CF_TYPE", ()=>$81f079589240b9b7$export$fb431e758c9252df);
    $parcel$export(module.exports, "NUMBER_CF_TYPE", ()=>$81f079589240b9b7$export$c7faa96db185cfc6);
    $parcel$export(module.exports, "STORY_POINT_ESTIMATE_CF_TYPE", ()=>$81f079589240b9b7$export$492b0fa4fe201a22);
    $parcel$export(module.exports, "URL_CF_TYPE", ()=>$81f079589240b9b7$export$60f0bd6e4b582fe6);
    $parcel$export(module.exports, "TEXT_CF_TYPE", ()=>$81f079589240b9b7$export$68c7e01d5460d298);
    $parcel$export(module.exports, "TEXT_AREA_CF_TYPE", ()=>$81f079589240b9b7$export$39cd48613b53ce2f);
    $parcel$export(module.exports, "TEXT_READONLY_CF_TYPE", ()=>$81f079589240b9b7$export$977db5973ce73e44);
    $parcel$export(module.exports, "LABELS_CF_TYPE", ()=>$81f079589240b9b7$export$ad4eb83f78528e13);
    $parcel$export(module.exports, "DATE_CF_TYPE", ()=>$81f079589240b9b7$export$ff745f432984005d);
    $parcel$export(module.exports, "DATETIME_CF_TYPE", ()=>$81f079589240b9b7$export$42d097f7b1622ef1);
    $parcel$export(module.exports, "RADIO_BUTTONS_CF_TYPE", ()=>$81f079589240b9b7$export$65524be5675e57e6);
    $parcel$export(module.exports, "MULTI_CHECKBOXES_CF_TYPE", ()=>$81f079589240b9b7$export$5280e5501a801dc0);
    $parcel$export(module.exports, "MULTI_SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$c5d13ea26562d57a);
    $parcel$export(module.exports, "SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$22ac48a51c014e4b);
    $parcel$export(module.exports, "EPIC_STATUS_TYPE", ()=>$81f079589240b9b7$export$6769c2c97b828e11);
    $parcel$export(module.exports, "MULTI_VERSION_CF_TYPE", ()=>$81f079589240b9b7$export$39866626496bbfc8);
    $parcel$export(module.exports, "VERSION_CF_TYPE", ()=>$81f079589240b9b7$export$24382b4e8c58336b);
    $parcel$export(module.exports, "GROUP_CF_TYPE", ()=>$81f079589240b9b7$export$b075907882e80160);
    $parcel$export(module.exports, "MULTI_GROUP_CF_TYPE", ()=>$81f079589240b9b7$export$b600addfa3355c57);
    $parcel$export(module.exports, "USER_CF_TYPE", ()=>$81f079589240b9b7$export$c491a4b98394028e);
    $parcel$export(module.exports, "MULTI_USER_CF_TYPE", ()=>$81f079589240b9b7$export$5365f2d3fac5261a);
    $parcel$export(module.exports, "PARTICIPANTS_CF_TYPE", ()=>$81f079589240b9b7$export$cc8ffff49170b0f4);
    $parcel$export(module.exports, "FLAGGED_CF_TYPE", ()=>$81f079589240b9b7$export$b7178f601d7373f9);
    $parcel$export(module.exports, "TEAM_CF_TYPE", ()=>$81f079589240b9b7$export$eb1f1dca13a0f02d);
    $parcel$export(module.exports, "PARENT_CF_TYPE", ()=>$81f079589240b9b7$export$3e71e11f80203acb);
    $parcel$export(module.exports, "BASELINE_START_CF_TYPE", ()=>$81f079589240b9b7$export$d10d66823a65e688);
    $parcel$export(module.exports, "BASELINE_END_CF_TYPE", ()=>$81f079589240b9b7$export$dfc6da4a9963d5dc);
    $parcel$export(module.exports, "COLOR_CF_TYPE", ()=>$81f079589240b9b7$export$b4a1fbc1cf0059cf);
    $parcel$export(module.exports, "EPIC_COLOR_TYPE", ()=>$81f079589240b9b7$export$4838a8a8d62a64fd);
    $parcel$export(module.exports, "ASSETS_CF_TYPE", ()=>$81f079589240b9b7$export$ed2de20ab8b7ad3d);
    $parcel$export(module.exports, "SERVICE_ENTITY_CF_TYPE", ()=>$81f079589240b9b7$export$b755e97dbfa92610);
    $parcel$export(module.exports, "REQUEST_PARTICIPANTS_CF_TYPE", ()=>$81f079589240b9b7$export$1be1ecd4dfc06fab);
    $parcel$export(module.exports, "ORGANIZATIONS_CF_TYPE", ()=>$81f079589240b9b7$export$34317c2d84a93553);
    $parcel$export(module.exports, "ORGANIZATION_CF_TYPE", ()=>$81f079589240b9b7$export$c1e26582406f77ec);
    $parcel$export(module.exports, "REQUEST_LANGUAGE_CF_TYPE", ()=>$81f079589240b9b7$export$555b4f35f98a3210);
    $parcel$export(module.exports, "REQUEST_FEEDBACK_CF_TYPE", ()=>$81f079589240b9b7$export$1f2859a3ef701a14);
    $parcel$export(module.exports, "REQUEST_FEEDBACK_DATE_CF_TYPE", ()=>$81f079589240b9b7$export$68f62eb762e4157f);
    $parcel$export(module.exports, "REQUEST_TYPE_CF_TYPE", ()=>$81f079589240b9b7$export$6da975fce1fbd38e);
    $parcel$export(module.exports, "APPROVERS_LIST_CF_TYPE", ()=>$81f079589240b9b7$export$c6dd874aae21e51f);
    $parcel$export(module.exports, "CASCADING_SELECT_CF_TYPE", ()=>$81f079589240b9b7$export$c3c9f8a8a8dc0b30);
    $parcel$export(module.exports, "RANK_CF_TYPE", ()=>$81f079589240b9b7$export$af89c0396aaf23e3);
    $parcel$export(module.exports, "CMDB_OBJECT_CF_TYPE", ()=>$81f079589240b9b7$export$3b5a62bb34372404);
    $parcel$export(module.exports, "READ_ONLY_CF_TYPE", ()=>$81f079589240b9b7$export$247829aef464243f);
    $parcel$export(module.exports, "PROJECT_PICKER_CF_TYPE", ()=>$81f079589240b9b7$export$65a6076c0927d413);
    $parcel$export(module.exports, "RESPONDERS_CF_TYPE", ()=>$81f079589240b9b7$export$bcf83e1d934501c9);
    $parcel$export(module.exports, "MAJOR_INCIDENT_CF_TYPE", ()=>$81f079589240b9b7$export$ae0eeec12e90a01e);
    $parcel$export(module.exports, "ENTITLEMENT_CF_TYPE", ()=>$81f079589240b9b7$export$c23f6b40da18371a);
    $parcel$export(module.exports, "SENTIMENT_CF_TYPE", ()=>$81f079589240b9b7$export$c23cfbdf83daa90d);
    $parcel$export(module.exports, "MESSAGE_VIEW_CF_TYPE", ()=>$81f079589240b9b7$export$21dda64db57e4883);
    $parcel$export(module.exports, "MESSAGE_EDIT_CF_TYPE", ()=>$81f079589240b9b7$export$45700f3bf92a003a);
    $parcel$export(module.exports, "LAST_UPDATER_OR_COMMENTER_CF_TYPE", ()=>$81f079589240b9b7$export$2d75b47d12efc812);
    $parcel$export(module.exports, "USER_PROPERTY_CF_TYPE", ()=>$81f079589240b9b7$export$7b79405842547ccb);
    $parcel$export(module.exports, "TIME_IN_STATUS_CF_TYPE", ()=>$81f079589240b9b7$export$96201d0ae03ca323);
    $parcel$export(module.exports, "FIRST_RESPONSE_DATE_CF_TYPE", ()=>$81f079589240b9b7$export$fc276d6ccf118a14);
    $parcel$export(module.exports, "DEV_SUMMARY_CF_TYPE", ()=>$81f079589240b9b7$export$8b0718167d092603);
    $parcel$export(module.exports, "CHILDREN_ISSUES_CF_TYPE", ()=>$81f079589240b9b7$export$904b40dd2afd17a2);
    $parcel$export(module.exports, "GOALS_CF_TYPE", ()=>$81f079589240b9b7$export$2bbb7f69c97ea279);
    $parcel$export(module.exports, "ASSIGNEE_TYPE", ()=>$81f079589240b9b7$export$fba8634fd401ba8b);
    $parcel$export(module.exports, "REPORTER_TYPE", ()=>$81f079589240b9b7$export$a91aea2438afcce8);
    $parcel$export(module.exports, "DUE_DATE_TYPE", ()=>$81f079589240b9b7$export$b159f8b8f27aae4c);
    $parcel$export(module.exports, "PRIORITY_TYPE", ()=>$81f079589240b9b7$export$34740f8d07d23ac0);
    $parcel$export(module.exports, "LABELS_TYPE", ()=>$81f079589240b9b7$export$43b6e33ec70f2272);
    $parcel$export(module.exports, "CREATED", ()=>$81f079589240b9b7$export$ff39ebd4bb12b718);
    $parcel$export(module.exports, "UPDATED", ()=>$81f079589240b9b7$export$cd8e68094cb5c3cb);
    $parcel$export(module.exports, "RESOLUTION_DATE", ()=>$81f079589240b9b7$export$6a052efb0b4ec5d2);
    $parcel$export(module.exports, "COMPONENTS_TYPE", ()=>$81f079589240b9b7$export$37abf56f13f61ec5);
    $parcel$export(module.exports, "SERVICEDESK_APPROVAL_TYPE", ()=>$81f079589240b9b7$export$aef0c22aecd16996);
    $parcel$export(module.exports, "SERVICEDESK_PRACTICES_TYPE", ()=>$81f079589240b9b7$export$cff5b6d1e7135679);
    $parcel$export(module.exports, "SERVICEDESK_INCIDENT_MANAGEMENT_TYPE", ()=>$81f079589240b9b7$export$791007408faf42f4);
    $parcel$export(module.exports, "DEV_SUMMARY_TYPE", ()=>$81f079589240b9b7$export$827a1c600bac12a3);
    $parcel$export(module.exports, "RELEASES_TYPE", ()=>$81f079589240b9b7$export$e9ba671d077969f8);
    $parcel$export(module.exports, "SPRINT_TYPE", ()=>$81f079589240b9b7$export$3d37701ba6fb68ec);
    $parcel$export(module.exports, "STORY_POINTS_TYPE", ()=>$81f079589240b9b7$export$36fd22f47020f37b);
    $parcel$export(module.exports, "EPIC_TYPE", ()=>$81f079589240b9b7$export$9f2fedcd916d2a79);
    $parcel$export(module.exports, "EPIC_NAME_TYPE", ()=>$81f079589240b9b7$export$dfc63737b8c0150d);
    $parcel$export(module.exports, "FIX_VERSIONS_TYPE", ()=>$81f079589240b9b7$export$a5c9f63aadcb220);
    $parcel$export(module.exports, "AFFECTS_VERSIONS_TYPE", ()=>$81f079589240b9b7$export$94009605902e4fe5);
    $parcel$export(module.exports, "DESCRIPTION_TYPE", ()=>$81f079589240b9b7$export$5e7324042f1d6b31);
    $parcel$export(module.exports, "ENVIRONMENT_TYPE", ()=>$81f079589240b9b7$export$113281d03e6830ef);
    $parcel$export(module.exports, "WATCHES_TYPE", ()=>$81f079589240b9b7$export$5ff798870a3dffbf);
    $parcel$export(module.exports, "SUMMARY_TYPE", ()=>$81f079589240b9b7$export$907219511d14ba3d);
    $parcel$export(module.exports, "PROFORMA_FORMS", ()=>$81f079589240b9b7$export$d09aa6a4f3538063);
    $parcel$export(module.exports, "RESOLUTION_TYPE", ()=>$81f079589240b9b7$export$3aca8c91b58a42e2);
    $parcel$export(module.exports, "TIME_TRACKING_TYPE", ()=>$81f079589240b9b7$export$ccb5ffefbf8b987c);
    $parcel$export(module.exports, "TIME_ESTIMATE_TYPE", ()=>$81f079589240b9b7$export$c8bedad98a5e7f5f);
    $parcel$export(module.exports, "STATUS_TYPE", ()=>$81f079589240b9b7$export$358267065be1e);
    $parcel$export(module.exports, "STATUS_CATEGORY_TYPE", ()=>$81f079589240b9b7$export$dcaa788c7ada56de);
    $parcel$export(module.exports, "ISSUE_TYPE", ()=>$81f079589240b9b7$export$ebb48b08205007c5);
    $parcel$export(module.exports, "ISSUE_KEY_TYPE", ()=>$81f079589240b9b7$export$5e91047fe9955d0e);
    $parcel$export(module.exports, "CHILDREN_ISSUES", ()=>$81f079589240b9b7$export$3b3d0889022c85b3);
    $parcel$export(module.exports, "HIERARCHY_LEVEL_BELOW", ()=>$81f079589240b9b7$export$335851d83a79891);
    $parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_BELOW", ()=>$81f079589240b9b7$export$7b76bbcb87d41695);
    $parcel$export(module.exports, "HIERARCHY_LEVEL_ABOVE", ()=>$81f079589240b9b7$export$297b67ac63f09f72);
    $parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_ABOVE", ()=>$81f079589240b9b7$export$ae87161126086be);
    $parcel$export(module.exports, "HIERARCHY_LEVEL_SAME_LEVEL", ()=>$81f079589240b9b7$export$6a88420fc2f6901d);
    $parcel$export(module.exports, "GRAPHQL_HIERARCHY_LEVEL_SAME_LEVEL", ()=>$81f079589240b9b7$export$ef1a0421bd42c0e4);
    $parcel$export(module.exports, "CUSTOMER_CONTEXT_TYPE", ()=>$81f079589240b9b7$export$dd695c8c5ab62f9d);
    $parcel$export(module.exports, "SLA_PANEL_TYPE", ()=>$81f079589240b9b7$export$7b3d247435a784fa);
    $parcel$export(module.exports, "LINKED_ALERTS_TYPE", ()=>$81f079589240b9b7$export$17b7080ed1fe8cfd);
    $parcel$export(module.exports, "CHAT_CHANNEL_TYPE", ()=>$81f079589240b9b7$export$29fe745131dad7ba);
    $parcel$export(module.exports, "MSTEAMS_CHANNEL_TYPE", ()=>$81f079589240b9b7$export$9c245100c3091ec3);
    $parcel$export(module.exports, "ZOOM_MEETING_TYPE", ()=>$81f079589240b9b7$export$51eb15cea47a37ba);
    $parcel$export(module.exports, "MANAGE_STAKEHOLDERS_TYPE", ()=>$81f079589240b9b7$export$c7ae0622b0bd5d56);
    $parcel$export(module.exports, "CONFERENCE_CALL_TYPE", ()=>$81f079589240b9b7$export$f7dcde9e9e88aff2);
    $parcel$export(module.exports, "KNOWLEDGE_BASE_TYPE", ()=>$81f079589240b9b7$export$b5358afda8ff335e);
    $parcel$export(module.exports, "ASSET_ONBOARDING_TYPE", ()=>$81f079589240b9b7$export$63cf6f392da16c25);
    $parcel$export(module.exports, "SIMILAR_ISSUES_TYPE", ()=>$81f079589240b9b7$export$22f61ccc2730431f);
    $parcel$export(module.exports, "SUBTASKS_TYPE", ()=>$81f079589240b9b7$export$8bbb446f57294715);
    $parcel$export(module.exports, "VOTES_TYPE", ()=>$81f079589240b9b7$export$34fcd7cb291a1e4d);
    $parcel$export(module.exports, "PARENT_TYPE", ()=>$81f079589240b9b7$export$5e93f2a57cc4ca3a);
    $parcel$export(module.exports, "PROJECT_TYPE", ()=>$81f079589240b9b7$export$91a9dba2d38d9a6f);
    $parcel$export(module.exports, "TIME_SPENT_TYPE", ()=>$81f079589240b9b7$export$ede0a4c20124ec85);
    $parcel$export(module.exports, "DATA_CLASSIFICATION_TYPE", ()=>$81f079589240b9b7$export$3eeb79d48fb5f667);
    $parcel$export(module.exports, "SENTIMENT_TYPE", ()=>$81f079589240b9b7$export$45e72c9a63ab61ab);
    $parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", ()=>$81f079589240b9b7$export$99ad62164189f781);
    $parcel$export(module.exports, "FORGE_GLANCE_TYPE", ()=>$81f079589240b9b7$export$7719ef6e9283671);
    $parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", ()=>$81f079589240b9b7$export$bfebea5ce2e1887a);
    $parcel$export(module.exports, "ISSUE_RESTRICTION_TYPE", ()=>$81f079589240b9b7$export$84e5674890d55030);
    $parcel$export(module.exports, "SECURITY_LEVEL_TYPE", ()=>$81f079589240b9b7$export$326a5522a485e43d);
    $parcel$export(module.exports, "SECURITY_LEVEL_TYPE_OVERRIDE", ()=>$81f079589240b9b7$export$c9f3f01e2c535302);
    $parcel$export(module.exports, "TEAM_TYPE", ()=>$81f079589240b9b7$export$66519f3bbff1796a);
    $parcel$export(module.exports, "ESTIMATE_TYPE", ()=>$81f079589240b9b7$export$a4ee0bca77cc8463);
    $parcel$export(module.exports, "DUE_DATE_PORTFOLIO_TYPE", ()=>$81f079589240b9b7$export$fed53408e89e0497);
    $parcel$export(module.exports, "TARGET_START_TYPE", ()=>$81f079589240b9b7$export$d53c26f9ce31f56b);
    $parcel$export(module.exports, "TARGET_END_TYPE", ()=>$81f079589240b9b7$export$48f82d653f85e459);
    $parcel$export(module.exports, "START_DATE_TYPE", ()=>$81f079589240b9b7$export$ea5a888f39f722c7);
    $parcel$export(module.exports, "COLOR_TYPE", ()=>$81f079589240b9b7$export$f245bbec12cc0e40);
    $parcel$export(module.exports, "ATTACHMENT_TYPE", ()=>$81f079589240b9b7$export$aed630b4b7114a59);
    $parcel$export(module.exports, "ISSUE_LINKS_TYPE", ()=>$81f079589240b9b7$export$b50c1a8fef07104);
    $parcel$export(module.exports, "TIME_ESTIMATE_CONFIG_TYPE", ()=>$81f079589240b9b7$export$ea3d72f4bb7738ba);
    $parcel$export(module.exports, "COMMENT_TYPE", ()=>$81f079589240b9b7$export$a4cab0124760d860);
    $parcel$export(module.exports, "WORK_LOG_TYPE", ()=>$81f079589240b9b7$export$734929aef118d7e2);
    $parcel$export(module.exports, "PARENT_FIELD_TYPE", ()=>$81f079589240b9b7$export$ffbacacb07c1d46d);
    $parcel$export(module.exports, "getLayoutFieldTypes", ()=>$81f079589240b9b7$export$3c3e26aadbfa2c32);
    var $8QpSo;
    var $4R6GH;
    const $81f079589240b9b7$export$b144116dae474c88 = 'issue-link-search';
    const $81f079589240b9b7$export$bc917bc699b25f75 = 'number';
    const $81f079589240b9b7$export$5f26ca419fdffbe7 = 'string';
    const $81f079589240b9b7$export$ce9bfd823c7e1a6d = 'datetime';
    const $81f079589240b9b7$export$346b72b1f7cd6d5a = 'date';
    const $81f079589240b9b7$export$b20fbcacd7942c2a = 'option2';
    const $81f079589240b9b7$export$20737ab0ca5fa93f = 'option';
    const $81f079589240b9b7$export$a2e8554bffc61ece = 'any';
    const $81f079589240b9b7$export$f25cd4907cbb25b9 = 'array';
    const $81f079589240b9b7$export$5600354b43577e17 = 'user';
    const $81f079589240b9b7$export$5dbc9917f72d0d2a = 'group';
    const $81f079589240b9b7$export$253649f07fb55948 = 'object';
    const $81f079589240b9b7$export$eb39592ba5247ee7 = 'group-list';
    const $81f079589240b9b7$export$f48a9be226105736 = 'array-string';
    const $81f079589240b9b7$export$42e2e93fc721df5d = 'version';
    const $81f079589240b9b7$export$a603eef6fee2a5f0 = 'parent-issues';
    const $81f079589240b9b7$export$7773375e72c953ed = 'approval-panel';
    const $81f079589240b9b7$export$80ad0037098f3919 = 'project';
    const $81f079589240b9b7$export$6875c7efa3a5e380 = 'JiraAffectedServicesField';
    const $81f079589240b9b7$export$7c1a5c7d37b8f968 = 'JiraAssigneeField';
    const $81f079589240b9b7$export$d74e2f14098ef8f6 = 'JiraAttachmentsField';
    const $81f079589240b9b7$export$c5931a5d7dbfb40b = 'JiraAtlassianTeamField';
    const $81f079589240b9b7$export$c979d9c548c05133 = 'JiraBooleanField';
    const $81f079589240b9b7$export$ff25e7412c4ae9c7 = 'JiraCascadingSelectField';
    const $81f079589240b9b7$export$16dbdf57e34e8d63 = 'JiraCheckboxesField';
    const $81f079589240b9b7$export$1bf8bec92e6e84df = 'JiraChildIssuesExceedingLimit';
    const $81f079589240b9b7$export$c32f5d822fe5ea95 = 'JiraChildIssuesWithinLimit';
    const $81f079589240b9b7$export$b0deb225eed90fbd = 'JiraCMDBField';
    const $81f079589240b9b7$export$add3775cfea8fde3 = 'JiraColorField';
    const $81f079589240b9b7$export$9631d4098abab3eb = 'JiraComponentsField';
    const $81f079589240b9b7$export$ee42bc16c09ee564 = 'JiraConnectDateTimeField';
    const $81f079589240b9b7$export$fbcebbdce821f712 = 'JiraConnectNumberField';
    const $81f079589240b9b7$export$41dd2eb1f33d3042 = 'JiraConnectMultipleSelectField';
    const $81f079589240b9b7$export$f4e3e72a3be84e5b = 'JiraConnectRichTextField';
    const $81f079589240b9b7$export$d6738c8a6d1a735d = 'JiraConnectSingleSelectField';
    const $81f079589240b9b7$export$79a75502a3f0c4c4 = 'JiraConnectTextField';
    const $81f079589240b9b7$export$ed2eabcf0931df31 = 'JiraDatePickerField';
    const $81f079589240b9b7$export$1f17904e959f2f0b = 'JiraDateTimePickerField';
    const $81f079589240b9b7$export$6d8da4497234455 = 'JiraEpicLinkField';
    const $81f079589240b9b7$export$9bcfac568e4fa59c = 'JiraFlagField';
    const $81f079589240b9b7$export$ff2e58d499eebe1d = 'JiraIssueLinkField';
    const $81f079589240b9b7$export$dd84cd6c957c6f5e = 'JiraIssueRestrictionField';
    const $81f079589240b9b7$export$5cc7c39d7d1cf6d5 = 'JiraIssueTypeField';
    const $81f079589240b9b7$export$810709f0c5c2e9db = 'JiraLabelsField';
    const $81f079589240b9b7$export$82cb6735134c23a2 = 'JiraMultipleSelectField';
    const $81f079589240b9b7$export$85e04e9a3a81ee1 = 'JiraMultipleSelectUserPickerField';
    const $81f079589240b9b7$export$24c916a8a33ed20c = 'JiraMultipleVersionPickerField';
    const $81f079589240b9b7$export$c049920d930c3b8a = 'JiraMultipleGroupPickerField';
    const $81f079589240b9b7$export$3b6d7fc1833bf7da = 'JiraNumberField';
    const $81f079589240b9b7$export$bd3e2fe853319c13 = 'JiraOriginalTimeEstimateField';
    const $81f079589240b9b7$export$6dfd3fc78bc751a0 = 'JiraParentIssueField';
    const $81f079589240b9b7$export$31aea7548807c6b5 = 'JiraPeopleField';
    const $81f079589240b9b7$export$e89fbbf3983c0219 = 'JiraPriorityField';
    const $81f079589240b9b7$export$f5e2fb1022ff7912 = 'JiraProformaFormsField';
    const $81f079589240b9b7$export$12f54499c6252188 = 'JiraProjectField';
    const $81f079589240b9b7$export$8e4293d806f435e0 = 'JiraRadioSelectField';
    const $81f079589240b9b7$export$c69486dd643dfb69 = 'JiraReporterField';
    const $81f079589240b9b7$export$1e18a858257aca2f = 'JiraRequestTypeField';
    const $81f079589240b9b7$export$1e4faa0d6dc58a81 = 'JiraResolutionField';
    const $81f079589240b9b7$export$37f4daaa7b409554 = 'JiraRichTextField';
    const $81f079589240b9b7$export$ca57cccd6d7bf97c = 'JiraSecurityLevelField';
    const $81f079589240b9b7$export$bea889616fd5bdab = 'JiraSingleGroupPickerField';
    const $81f079589240b9b7$export$ab5cecc580898d1c = 'JiraSingleSelectField';
    const $81f079589240b9b7$export$bb63813d13e8eaf7 = 'JiraSprintField';
    const $81f079589240b9b7$export$e40f819979b3881d = 'JiraStatusField';
    const $81f079589240b9b7$export$6c243704a22baffe = 'JiraTeamField';
    const $81f079589240b9b7$export$6c32429bac235203 = 'JiraTeamViewField';
    const $81f079589240b9b7$export$61b514b470cbbf07 = 'JiraSingleLineTextField';
    const $81f079589240b9b7$export$e4bcb1729da5683 = 'JiraTimeTrackingField';
    const $81f079589240b9b7$export$37ccd11f08a93ccb = 'JiraUrlField';
    const $81f079589240b9b7$export$abf1bf8c1106ba7d = 'JiraSingleSelectUserPickerField';
    const $81f079589240b9b7$export$b55604041ae7179e = 'JiraSingleVersionPickerField';
    const $81f079589240b9b7$export$c8bf66d62e74cdd2 = 'JiraVotesField';
    const $81f079589240b9b7$export$aa815aaa741ae18 = 'JiraWatchesField';
    const $81f079589240b9b7$export$e805f89b15d2abf4 = 'JiraAssetField';
    const $81f079589240b9b7$export$5bfd36acd96f04c2 = 'JiraServiceManagementPeopleField';
    const $81f079589240b9b7$export$695423a2bc8a9ac4 = 'JiraServiceManagementOrganizationField';
    const $81f079589240b9b7$export$d29b0ba0d80bc129 = 'JiraForgeStringField';
    const $81f079589240b9b7$export$ac6c7b30703608d6 = 'JiraForgeStringsField';
    const $81f079589240b9b7$export$478b546dccd33e1e = 'JiraForgeNumberField';
    const $81f079589240b9b7$export$f90c042e9eb983e7 = 'JiraForgeDatetimeField';
    const $81f079589240b9b7$export$753ca4fb34ff3f2b = 'JiraForgeDateField';
    const $81f079589240b9b7$export$b7aed9efb4a9154b = 'JiraForgeObjectField';
    const $81f079589240b9b7$export$1763713d718f7ef0 = 'JiraForgeGroupField';
    const $81f079589240b9b7$export$ebb0caa2a98dcf9e = 'JiraForgeUserField';
    const $81f079589240b9b7$export$671131ba12d94144 = 'JiraForgeGroupsField';
    const $81f079589240b9b7$export$c48132adab502d6b = 'JiraForgeUsersField';
    const $81f079589240b9b7$export$6cd83226f31c7072 = 'JiraServiceManagementApprovalField';
    const $81f079589240b9b7$export$7de726bd6d97a9a7 = 'JiraServiceManagementUserApproverPrincipal';
    const $81f079589240b9b7$export$8e4b538f77340a05 = 'JiraServiceManagementGroupApproverPrincipal';
    const $81f079589240b9b7$export$10ba8c0d74470907 = 'JiraServiceManagementRequestFeedbackField';
    const $81f079589240b9b7$export$1756bb4eff1cc3c6 = 'JiraServiceManagementRequestLanguageField';
    const $81f079589240b9b7$export$5876b4be3c4407b = 'JiraServiceManagementRequestTypeField';
    const $81f079589240b9b7$export$e7fe49e6f36c7154 = 'JiraServiceManagementRespondersField';
    const $81f079589240b9b7$export$aeed3395a6bca18b = 'JiraServiceManagementUserResponder';
    const $81f079589240b9b7$export$9b725a1eafd02e4f = 'JiraServiceManagementEntitlementField';
    const $81f079589240b9b7$export$699805cbca2c41d = 'JiraServiceManagementSentimentField';
    const $81f079589240b9b7$export$f658d5c0f0b5dbc2 = 'JiraServiceManagementTeamResponder';
    const $81f079589240b9b7$export$e469bcb2060000af = 'JiraServiceManagementMajorIncidentField';
    const $81f079589240b9b7$export$f10e53e8928b61bd = 'JiraDataClassificationField';
    const $81f079589240b9b7$export$bfcb1a91094f113a = 'JiraGoalsField';
    const $81f079589240b9b7$export$db0bd6c04eb7d04a = 'JiraDurationField';
    const $81f079589240b9b7$export$798d2f5814884447 = 'forgeCustomField';
    const $81f079589240b9b7$export$269d70c1b1c9fb80 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';
    const $81f079589240b9b7$export$f0f17ef462331df4 = 'com.atlassian.servicedesk.approvals-plugin:sd-approvals';
    const $81f079589240b9b7$export$3c7d8923295a5199 = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
    const $81f079589240b9b7$export$fb431e758c9252df = 'com.atlassian.jira.plugin.system.customfieldtypes:people';
    const $81f079589240b9b7$export$c7faa96db185cfc6 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
    const $81f079589240b9b7$export$492b0fa4fe201a22 = 'com.pyxis.greenhopper.jira:jsw-story-points';
    const $81f079589240b9b7$export$60f0bd6e4b582fe6 = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
    const $81f079589240b9b7$export$68c7e01d5460d298 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
    const $81f079589240b9b7$export$39cd48613b53ce2f = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
    const $81f079589240b9b7$export$977db5973ce73e44 = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
    const $81f079589240b9b7$export$ad4eb83f78528e13 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
    const $81f079589240b9b7$export$ff745f432984005d = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
    const $81f079589240b9b7$export$42d097f7b1622ef1 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
    const $81f079589240b9b7$export$65524be5675e57e6 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
    const $81f079589240b9b7$export$5280e5501a801dc0 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
    const $81f079589240b9b7$export$c5d13ea26562d57a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
    const $81f079589240b9b7$export$22ac48a51c014e4b = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
    const $81f079589240b9b7$export$6769c2c97b828e11 = 'com.pyxis.greenhopper.jira:gh-epic-status';
    const $81f079589240b9b7$export$39866626496bbfc8 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiversion';
    const $81f079589240b9b7$export$24382b4e8c58336b = 'com.atlassian.jira.plugin.system.customfieldtypes:version';
    const $81f079589240b9b7$export$b075907882e80160 = 'com.atlassian.jira.plugin.system.customfieldtypes:grouppicker';
    const $81f079589240b9b7$export$b600addfa3355c57 = 'com.atlassian.jira.plugin.system.customfieldtypes:multigrouppicker';
    const $81f079589240b9b7$export$c491a4b98394028e = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
    const $81f079589240b9b7$export$5365f2d3fac5261a = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
    const $81f079589240b9b7$export$cc8ffff49170b0f4 = 'com.atlassian.jira.toolkit:participants';
    const $81f079589240b9b7$export$b7178f601d7373f9 = 'com.atlassian.jira.plugin.system.customfieldtypes:flagged';
    const $81f079589240b9b7$export$eb1f1dca13a0f02d = 'com.atlassian.teams:rm-teams-custom-field-team';
    const $81f079589240b9b7$export$3e71e11f80203acb = 'com.atlassian.jpo:jpo-custom-field-parent';
    const $81f079589240b9b7$export$9f47a86016048ac3 = 'com.atlassian.graphql:parent-issues';
    const $81f079589240b9b7$export$d10d66823a65e688 = 'com.atlassian.jpo:jpo-custom-field-baseline-start';
    const $81f079589240b9b7$export$dfc6da4a9963d5dc = 'com.atlassian.jpo:jpo-custom-field-baseline-end';
    const $81f079589240b9b7$export$b4a1fbc1cf0059cf = 'com.pyxis.greenhopper.jira:jsw-issue-color';
    const $81f079589240b9b7$export$4838a8a8d62a64fd = 'com.pyxis.greenhopper.jira:gh-epic-color';
    const $81f079589240b9b7$export$ed2de20ab8b7ad3d = 'com.atlassian.servicedesk.assets-plugin:assetfield';
    const $81f079589240b9b7$export$b755e97dbfa92610 = 'com.atlassian.jira.plugins.service-entity:service-entity-field-cftype';
    const $81f079589240b9b7$export$1be1ecd4dfc06fab = 'com.atlassian.servicedesk:sd-request-participants';
    const $81f079589240b9b7$export$34317c2d84a93553 = 'com.atlassian.servicedesk:sd-customer-organizations';
    const $81f079589240b9b7$export$c1e26582406f77ec = 'com.atlassian.servicedesk.customer-context:sd-csm-organization';
    const $81f079589240b9b7$export$555b4f35f98a3210 = 'com.atlassian.servicedesk.servicedesk-lingo-integration-plugin:sd-request-language';
    const $81f079589240b9b7$export$1f2859a3ef701a14 = 'com.atlassian.servicedesk:sd-request-feedback';
    const $81f079589240b9b7$export$68f62eb762e4157f = 'com.atlassian.servicedesk:sd-request-feedback-date';
    const $81f079589240b9b7$export$6da975fce1fbd38e = 'com.atlassian.servicedesk:vp-origin';
    const $81f079589240b9b7$export$c6dd874aae21e51f = 'com.atlassian.jira.plugin.system.customfieldtypes:servicedesk-approvers-list';
    const $81f079589240b9b7$export$c3c9f8a8a8dc0b30 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
    const $81f079589240b9b7$export$af89c0396aaf23e3 = 'com.pyxis.greenhopper.jira:gh-lexo-rank';
    const $81f079589240b9b7$export$3b5a62bb34372404 = 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype';
    const $81f079589240b9b7$export$247829aef464243f = 'com.atlassian.jira.plugin.system.customfieldtypes:readonlyfield';
    const $81f079589240b9b7$export$65a6076c0927d413 = 'com.atlassian.jira.plugin.system.customfieldtypes:project';
    const $81f079589240b9b7$export$bcf83e1d934501c9 = 'com.atlassian.jira.modules.servicemanagement.responders-entity:responders-entity-field-cftype';
    const $81f079589240b9b7$export$ae0eeec12e90a01e = 'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype';
    const $81f079589240b9b7$export$f94696506ee781f9 = 'com.atlassian.jira.plugins.jim-plugin:bug-importid';
    const $81f079589240b9b7$export$8ba6ed64df1ce64a = 'com.atlassian.jira.plugin.system.customfieldtypes:importid';
    const $81f079589240b9b7$export$e90ce947f06b085d = 'com.atlassian.jconnect.jconnect-plugin:uuid';
    const $81f079589240b9b7$export$c23f6b40da18371a = 'com.atlassian.servicedesk.customer-context:sd-csm-entitlement';
    const $81f079589240b9b7$export$c23cfbdf83daa90d = 'com.atlassian.servicedesk.sentiment:sd-sentiment';
    const $81f079589240b9b7$export$21dda64db57e4883 = 'com.atlassian.jira.toolkit:viewmessage';
    const $81f079589240b9b7$export$45700f3bf92a003a = 'com.atlassian.jira.toolkit:message';
    const $81f079589240b9b7$export$2d75b47d12efc812 = 'com.atlassian.jira.toolkit:lastupdaterorcommenter';
    const $81f079589240b9b7$export$36500b2821f7114f = 'com.atlassian.jira.toolkit:attachments';
    const $81f079589240b9b7$export$37dc91333ba7a96 = 'com.atlassian.jira.toolkit:LastCommentDate';
    const $81f079589240b9b7$export$7b79405842547ccb = 'com.atlassian.jira.toolkit:userproperty';
    const $81f079589240b9b7$export$ac9f7d2dfc7c6826 = 'com.atlassian.jira.toolkit:assigneedomain';
    const $81f079589240b9b7$export$a3d9c149d737aa78 = 'com.atlassian.jira.toolkit:reporterdomain';
    const $81f079589240b9b7$export$4745e551386233a5 = 'com.atlassian.jira.toolkit:comments';
    const $81f079589240b9b7$export$5ee213d6fd4c9b2b = 'com.atlassian.jira.toolkit:dayslastcommented';
    const $81f079589240b9b7$export$fb0b6a2e098e1fe2 = 'com.atlassian.jira.toolkit:lastusercommented';
    const $81f079589240b9b7$export$fe1291c40f590f35 = 'com.atlassian.servicedesk:sd-sla-field';
    const $81f079589240b9b7$export$e9c81bef34f2c86c = 'sd-servicelevelagreement';
    const $81f079589240b9b7$export$96201d0ae03ca323 = 'com.atlassian.jira.ext.charting:timeinstatus';
    const $81f079589240b9b7$export$fc276d6ccf118a14 = 'com.atlassian.jira.ext.charting:firstresponsedate';
    const $81f079589240b9b7$export$8b0718167d092603 = 'com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf';
    const $81f079589240b9b7$export$904b40dd2afd17a2 = 'com.atlassian.graphql:children-issues';
    const $81f079589240b9b7$export$4063d93c74c89472 = 'com.atlassian.graphql:epic-issues';
    const $81f079589240b9b7$export$f0eeb5dcfbc42177 = 'com.atlassian.graphql:portfolio-child-issues';
    const $81f079589240b9b7$export$2bbb7f69c97ea279 = 'com.atlassian.jira.plugin.system.customfieldtypes:goals';
    const $81f079589240b9b7$export$fba8634fd401ba8b = 'assignee';
    const $81f079589240b9b7$export$a91aea2438afcce8 = 'reporter';
    const $81f079589240b9b7$export$b159f8b8f27aae4c = 'duedate';
    const $81f079589240b9b7$export$34740f8d07d23ac0 = 'priority';
    const $81f079589240b9b7$export$43b6e33ec70f2272 = 'labels';
    const $81f079589240b9b7$export$ff39ebd4bb12b718 = 'created';
    const $81f079589240b9b7$export$cd8e68094cb5c3cb = 'updated';
    const $81f079589240b9b7$export$6a052efb0b4ec5d2 = 'resolutiondate';
    const $81f079589240b9b7$export$37abf56f13f61ec5 = 'components';
    const $81f079589240b9b7$export$aef0c22aecd16996 = 'servicedesk-approvals';
    const $81f079589240b9b7$export$cff5b6d1e7135679 = 'servicedesk-practices';
    const $81f079589240b9b7$export$d925edcf818f4885 = 'servicedesk-incident-linking';
    const $81f079589240b9b7$export$e7c590d96ed1c7fa = 'servicedesk-incident-escalate';
    const $81f079589240b9b7$export$791007408faf42f4 = 'servicedesk-incident-management';
    const $81f079589240b9b7$export$827a1c600bac12a3 = 'devSummary';
    const $81f079589240b9b7$export$e9ba671d077969f8 = 'releases';
    const $81f079589240b9b7$export$3d37701ba6fb68ec = 'com.pyxis.greenhopper.jira:gh-sprint';
    const $81f079589240b9b7$export$36fd22f47020f37b = 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint';
    const $81f079589240b9b7$export$9f2fedcd916d2a79 = 'com.pyxis.greenhopper.jira:gh-epic-link';
    const $81f079589240b9b7$export$dfc63737b8c0150d = 'com.pyxis.greenhopper.jira:gh-epic-label';
    const $81f079589240b9b7$export$a5c9f63aadcb220 = 'fixVersions';
    const $81f079589240b9b7$export$94009605902e4fe5 = 'versions';
    const $81f079589240b9b7$export$5e7324042f1d6b31 = 'description';
    const $81f079589240b9b7$export$113281d03e6830ef = 'environment';
    const $81f079589240b9b7$export$5ff798870a3dffbf = 'watches';
    const $81f079589240b9b7$export$907219511d14ba3d = 'summary';
    const $81f079589240b9b7$export$d09aa6a4f3538063 = 'proforma-forms';
    const $81f079589240b9b7$export$3aca8c91b58a42e2 = 'resolution';
    const $81f079589240b9b7$export$ccb5ffefbf8b987c = 'timetracking';
    const $81f079589240b9b7$export$c8bedad98a5e7f5f = 'timeoriginalestimate';
    const $81f079589240b9b7$export$358267065be1e = 'status';
    const $81f079589240b9b7$export$dcaa788c7ada56de = 'statusCategory';
    const $81f079589240b9b7$export$ebb48b08205007c5 = 'issuetype';
    const $81f079589240b9b7$export$5e91047fe9955d0e = 'issuekey';
    const $81f079589240b9b7$export$3b3d0889022c85b3 = 'children-issues';
    const $81f079589240b9b7$export$aba22e09a66f6826 = 'portfolio-child-issues';
    const $81f079589240b9b7$export$8fe3d5be8cb17459 = 'epic-issues';
    const $81f079589240b9b7$export$335851d83a79891 = 'hierarchy-level-below';
    const $81f079589240b9b7$export$7b76bbcb87d41695 = 'com.atlassian.graphql:hierarchy-level-below';
    const $81f079589240b9b7$export$297b67ac63f09f72 = 'hierarchy-level-above';
    const $81f079589240b9b7$export$ae87161126086be = 'com.atlassian.graphql:hierarchy-level-above';
    const $81f079589240b9b7$export$6a88420fc2f6901d = 'hierarchy-level-same-level';
    const $81f079589240b9b7$export$ef1a0421bd42c0e4 = 'com.atlassian.graphql:hierarchy-level-same-level';
    const $81f079589240b9b7$export$dd695c8c5ab62f9d = 'CUSTOMER_CONTEXT';
    const $81f079589240b9b7$export$7b3d247435a784fa = 'SLA_PANEL';
    const $81f079589240b9b7$export$17b7080ed1fe8cfd = 'LINKED_ALERTS';
    const $81f079589240b9b7$export$29fe745131dad7ba = 'CHAT_CHANNEL';
    const $81f079589240b9b7$export$9c245100c3091ec3 = 'MSTEAMS_CHANNEL';
    const $81f079589240b9b7$export$51eb15cea47a37ba = 'ZOOM_MEETING';
    const $81f079589240b9b7$export$c7ae0622b0bd5d56 = 'MANAGE_STAKEHOLDERS';
    const $81f079589240b9b7$export$f7dcde9e9e88aff2 = 'CONFERENCE_CALL';
    const $81f079589240b9b7$export$b5358afda8ff335e = 'KNOWLEDGE_BASE';
    const $81f079589240b9b7$export$63cf6f392da16c25 = 'ASSET_ONBOARDING';
    const $81f079589240b9b7$export$22f61ccc2730431f = 'similar-issues';
    const $81f079589240b9b7$export$8bbb446f57294715 = 'subtasks';
    const $81f079589240b9b7$export$34fcd7cb291a1e4d = 'votes';
    const $81f079589240b9b7$export$5e93f2a57cc4ca3a = 'parent';
    const $81f079589240b9b7$export$be3891c8b47ab821 = 'parent-issue';
    const $81f079589240b9b7$export$91a9dba2d38d9a6f = 'project';
    const $81f079589240b9b7$export$df36fc05622c402 = 'worklog';
    const $81f079589240b9b7$export$ede0a4c20124ec85 = 'timespent';
    const $81f079589240b9b7$export$3eeb79d48fb5f667 = 'dataclassification';
    const $81f079589240b9b7$export$45e72c9a63ab61ab = 'SENTIMENT';
    const $81f079589240b9b7$export$99ad62164189f781 = 'ecosystemGlance';
    const $81f079589240b9b7$export$7719ef6e9283671 = 'forgeGlance';
    const $81f079589240b9b7$export$bfebea5ce2e1887a = 'ecosystemContext';
    const $81f079589240b9b7$export$be8e68fb1aed253e = 'forgeContext';
    const $81f079589240b9b7$export$84e5674890d55030 = 'issuerestriction';
    const $81f079589240b9b7$export$326a5522a485e43d = 'security';
    const $81f079589240b9b7$export$c9f3f01e2c535302 = 'securitylevel';
    const $81f079589240b9b7$export$35e5652f764785bd = 'creator';
    const $81f079589240b9b7$export$66519f3bbff1796a = 'team';
    const $81f079589240b9b7$export$a4ee0bca77cc8463 = 'estimate';
    const $81f079589240b9b7$export$fed53408e89e0497 = 'dueDate';
    const $81f079589240b9b7$export$d53c26f9ce31f56b = 'targetStart';
    const $81f079589240b9b7$export$48f82d653f85e459 = 'targetEnd';
    const $81f079589240b9b7$export$ea5a888f39f722c7 = 'startDate';
    const $81f079589240b9b7$export$f245bbec12cc0e40 = 'color';
    const $81f079589240b9b7$export$aed630b4b7114a59 = 'attachment';
    const $81f079589240b9b7$export$b50c1a8fef07104 = 'issuelinks';
    const $81f079589240b9b7$export$ea3d72f4bb7738ba = 'timeestimate';
    const $81f079589240b9b7$export$a4cab0124760d860 = 'comment';
    const $81f079589240b9b7$export$734929aef118d7e2 = 'worklog';
    const $81f079589240b9b7$export$ffbacacb07c1d46d = 'parent';
    const $81f079589240b9b7$export$871661506c0a91ea = 'aggregatetimeoriginalestimate';
    const $81f079589240b9b7$export$278c072e2f9176ab = 'aggregatetimespent';
    const $81f079589240b9b7$export$4a7ecfe931ab6c07 = 'aggregatetimeestimate';
    const $81f079589240b9b7$export$fbc5ebe2e580bf8b = 'progress';
    const $81f079589240b9b7$export$aa3b37e271efd578 = 'aggregateprogress';
    const $81f079589240b9b7$export$444bffe6526fb5f2 = 'workratio';
    const $81f079589240b9b7$var$getLayoutFieldTypesNonMemoized = ()=>{
        const types = {
            ASSIGNEE_TYPE: $81f079589240b9b7$export$fba8634fd401ba8b,
            DUE_DATE_TYPE: $81f079589240b9b7$export$b159f8b8f27aae4c,
            PRIORITY_TYPE: $81f079589240b9b7$export$34740f8d07d23ac0,
            REPORTER_TYPE: $81f079589240b9b7$export$a91aea2438afcce8,
            DESCRIPTION_TYPE: $81f079589240b9b7$export$5e7324042f1d6b31,
            LABELS_TYPE: $81f079589240b9b7$export$43b6e33ec70f2272,
            COMPONENTS_TYPE: $81f079589240b9b7$export$37abf56f13f61ec5,
            SPRINT_TYPE: $81f079589240b9b7$export$3d37701ba6fb68ec,
            STORY_POINTS_TYPE: $81f079589240b9b7$export$36fd22f47020f37b,
            TEAMS_PLATFORM_CF_TYPE: $81f079589240b9b7$export$269d70c1b1c9fb80,
            FIX_VERSIONS_TYPE: $81f079589240b9b7$export$a5c9f63aadcb220,
            AFFECTS_VERSIONS_TYPE: $81f079589240b9b7$export$94009605902e4fe5,
            TIME_ESTIMATE_TYPE: $81f079589240b9b7$export$c8bedad98a5e7f5f,
            TIME_TRACKING_TYPE: $81f079589240b9b7$export$ccb5ffefbf8b987c,
            ENVIRONMENT_TYPE: $81f079589240b9b7$export$113281d03e6830ef,
            DEV_SUMMARY_TYPE: $81f079589240b9b7$export$827a1c600bac12a3,
            APPROVALS_PANEL_TYPE: $81f079589240b9b7$export$7773375e72c953ed,
            KNOWLEDGE_BASE_TYPE: $81f079589240b9b7$export$b5358afda8ff335e,
            SLA_PANEL_TYPE: $81f079589240b9b7$export$7b3d247435a784fa,
            LINKED_ALERTS_TYPE: $81f079589240b9b7$export$17b7080ed1fe8cfd,
            CHAT_CHANNEL_TYPE: $81f079589240b9b7$export$29fe745131dad7ba,
            MSTEAMS_CHANNEL_TYPE: $81f079589240b9b7$export$9c245100c3091ec3,
            ZOOM_MEETING_TYPE: $81f079589240b9b7$export$51eb15cea47a37ba,
            MANAGE_STAKEHOLDERS_TYPE: $81f079589240b9b7$export$c7ae0622b0bd5d56,
            CONFERENCE_CALL_TYPE: $81f079589240b9b7$export$f7dcde9e9e88aff2,
            ASSETS_CF_TYPE: $81f079589240b9b7$export$ed2de20ab8b7ad3d,
            RESPONDERS_CF_TYPE: $81f079589240b9b7$export$bcf83e1d934501c9,
            MAJOR_INCIDENT_CF_TYPE: $81f079589240b9b7$export$ae0eeec12e90a01e,
            COLOR_CF_TYPE: $81f079589240b9b7$export$b4a1fbc1cf0059cf,
            EPIC_COLOR_TYPE: $81f079589240b9b7$export$4838a8a8d62a64fd,
            RELEASES_TYPE: $81f079589240b9b7$export$e9ba671d077969f8,
            BASELINE_START_CF_TYPE: $81f079589240b9b7$export$d10d66823a65e688,
            BASELINE_END_CF_TYPE: $81f079589240b9b7$export$dfc6da4a9963d5dc,
            LABELS_CF_TYPE: $81f079589240b9b7$export$ad4eb83f78528e13,
            TEXT_CF_TYPE: $81f079589240b9b7$export$68c7e01d5460d298,
            MULTI_USER_CF_TYPE: $81f079589240b9b7$export$5365f2d3fac5261a,
            PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$cc8ffff49170b0f4,
            URL_CF_TYPE: $81f079589240b9b7$export$60f0bd6e4b582fe6,
            NUMBER_CF_TYPE: $81f079589240b9b7$export$c7faa96db185cfc6,
            STORY_POINT_ESTIMATE_CF_TYPE: $81f079589240b9b7$export$492b0fa4fe201a22,
            SELECT_CF_TYPE: $81f079589240b9b7$export$22ac48a51c014e4b,
            EPIC_STATUS_TYPE: $81f079589240b9b7$export$6769c2c97b828e11,
            MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$c5d13ea26562d57a,
            ECOSYSTEM_GLANCE_TYPE: $81f079589240b9b7$export$99ad62164189f781,
            FORGE_CUSTOM_FIELD_TYPE: $81f079589240b9b7$export$798d2f5814884447,
            ISSUE_FIELD_USER_CF_TYPE: $81f079589240b9b7$export$5600354b43577e17,
            ISSUE_FIELD_GROUPS_CF_TYPE: $81f079589240b9b7$export$eb39592ba5247ee7,
            ISSUE_FIELD_STRINGS_CF_TYPE: $81f079589240b9b7$export$f48a9be226105736,
            FORGE_GLANCE_TYPE: $81f079589240b9b7$export$7719ef6e9283671,
            TEXT_AREA_CF_TYPE: $81f079589240b9b7$export$39cd48613b53ce2f,
            MULTI_VERSION_CF_TYPE: $81f079589240b9b7$export$39866626496bbfc8,
            VERSION_CF_TYPE: $81f079589240b9b7$export$24382b4e8c58336b,
            DATE_CF_TYPE: $81f079589240b9b7$export$ff745f432984005d,
            GROUP_CF_TYPE: $81f079589240b9b7$export$b075907882e80160,
            MULTI_GROUP_CF_TYPE: $81f079589240b9b7$export$b600addfa3355c57,
            USER_CF_TYPE: $81f079589240b9b7$export$c491a4b98394028e,
            DATETIME_CF_TYPE: $81f079589240b9b7$export$42d097f7b1622ef1,
            MULTI_CHECKBOXES_CF_TYPE: $81f079589240b9b7$export$5280e5501a801dc0,
            RADIO_BUTTONS_CF_TYPE: $81f079589240b9b7$export$65524be5675e57e6,
            TEAM_CF_TYPE: $81f079589240b9b7$export$eb1f1dca13a0f02d,
            ISSUE_FIELD_NUMBER_CF_TYPE: $81f079589240b9b7$export$bc917bc699b25f75,
            ISSUE_FIELD_DATETIME_CF_TYPE: $81f079589240b9b7$export$ce9bfd823c7e1a6d,
            ISSUE_FIELD_STRING_CF_TYPE: $81f079589240b9b7$export$5f26ca419fdffbe7,
            ISSUE_FIELD_SINGLE_SELECT_CF_TYPE: $81f079589240b9b7$export$b20fbcacd7942c2a,
            ISSUE_FIELD_MULTI_SELECT_CF_TYPE: $81f079589240b9b7$export$f25cd4907cbb25b9,
            REQUEST_TYPE_CF_TYPE: $81f079589240b9b7$export$6da975fce1fbd38e,
            SERVICE_ENTITY_CF_TYPE: $81f079589240b9b7$export$b755e97dbfa92610,
            REQUEST_PARTICIPANTS_CF_TYPE: $81f079589240b9b7$export$1be1ecd4dfc06fab,
            ORGANIZATIONS_CF_TYPE: $81f079589240b9b7$export$34317c2d84a93553,
            REQUEST_FEEDBACK_CF_TYPE: $81f079589240b9b7$export$1f2859a3ef701a14,
            PEOPLE_CF_TYPE: $81f079589240b9b7$export$fb431e758c9252df,
            REQUEST_LANGUAGE_CF_TYPE: $81f079589240b9b7$export$555b4f35f98a3210,
            ASSET_ONBOARDING_TYPE: $81f079589240b9b7$export$63cf6f392da16c25,
            APPROVERS_LIST_CF_TYPE: $81f079589240b9b7$export$c6dd874aae21e51f,
            CASCADING_SELECT_CF_TYPE: $81f079589240b9b7$export$c3c9f8a8a8dc0b30,
            PROJECT_PICKER_CF_TYPE: $81f079589240b9b7$export$65a6076c0927d413,
            CMDB_OBJECT_CF_TYPE: $81f079589240b9b7$export$3b5a62bb34372404,
            READ_ONLY_CF_TYPE: $81f079589240b9b7$export$247829aef464243f,
            MESSAGE_VIEW_CF_TYPE: $81f079589240b9b7$export$21dda64db57e4883,
            MESSAGE_EDIT_CF_TYPE: $81f079589240b9b7$export$45700f3bf92a003a,
            EPIC_NAME_TYPE: $81f079589240b9b7$export$dfc63737b8c0150d,
            ECOSYSTEM_CONTEXT_TYPE: $81f079589240b9b7$export$bfebea5ce2e1887a,
            CATEGORY_TYPE: $81f079589240b9b7$export$3c7d8923295a5199,
            ENTITLEMENT_CF_TYPE: $81f079589240b9b7$export$c23f6b40da18371a,
            GOALS_CF_TYPE: $81f079589240b9b7$export$2bbb7f69c97ea279,
            PARENT_TYPE: $81f079589240b9b7$export$5e93f2a57cc4ca3a
        };
        Object.assign(types, {
            FORGE_CONTEXT_TYPE: $81f079589240b9b7$export$be8e68fb1aed253e
        });
        if ((0, (0, parcelRequire("4R6GH")).fg)('jsm-sentiment-analysis')) Object.assign(types, {
            SENTIMENT_TYPE: $81f079589240b9b7$export$45e72c9a63ab61ab
        });
        Object.assign(types, {
            SENTIMENT_CF_TYPE: $81f079589240b9b7$export$c23cfbdf83daa90d
        });
        if (!(0, (0, parcelRequire("4R6GH")).fg)('remove_epic_link_and_parent_link_from_issue_view')) {
            Object.assign(types, {
                EPIC_TYPE: $81f079589240b9b7$export$9f2fedcd916d2a79
            });
            Object.assign(types, {
                PARENT_CF_TYPE: $81f079589240b9b7$export$3e71e11f80203acb
            });
        }
        if ((0, (0, parcelRequire("4R6GH")).fg)('jcs_issue_layout_eap')) Object.assign(types, {
            ORGANIZATION_CF_TYPE: $81f079589240b9b7$export$c1e26582406f77ec
        });
        return types;
    };
    const $81f079589240b9b7$export$3c3e26aadbfa2c32 = (0, (0, parcelRequire("8QpSo")).default)($81f079589240b9b7$var$getLayoutFieldTypesNonMemoized);
});
parcelRegister("gl0PU", function(module, exports) {
    $parcel$export(module.exports, "toErrorId", ()=>$b5e194c6e2cc34cd$export$706bbe4209d93dfe);
    $parcel$export(module.exports, "toErrorMessage", ()=>$b5e194c6e2cc34cd$export$95506c204c060a3);
    const $b5e194c6e2cc34cd$export$706bbe4209d93dfe = (id)=>id;
    const $b5e194c6e2cc34cd$export$95506c204c060a3 = (message)=>message;
});
parcelRegister("1RLjE", function(module, exports) {
    $parcel$export(module.exports, "logError", ()=>$b0fc9ceb76f86c8e$export$58da9968c3170cb1);
    var $dJl1T;
    var $jcw0u;
    const $b0fc9ceb76f86c8e$export$58da9968c3170cb1 = (packageName, errorId, message, error, attributes)=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                packageName: packageName,
                id: errorId,
                teamName: 'morphinecake'
            },
            attributes: {
                ...attributes,
                message: message
            },
            error: error
        });
        const location = `${packageName}.${errorId}`;
        (0, (0, parcelRequire("dJl1T")).default).unsafeErrorWithCustomerData(location, message, error);
    };
});
parcelRegister("j9iVo", function(module, exports) {
    $parcel$export(module.exports, "ConnectAppsSubscriber", ()=>$1d2a37fb0b2cedf7$export$2646f920b0e2e4de);
    $parcel$export(module.exports, "useConnectApps", ()=>$1d2a37fb0b2cedf7$export$4864478dcab77643);
    $parcel$export(module.exports, "ConnectAppsContainer", ()=>$1d2a37fb0b2cedf7$export$ac845603c8c91acd);
    var $7JoAD = parcelRequire("7JoAD");
    var $7YSUx;
    const $1d2a37fb0b2cedf7$export$2646f920b0e2e4de = (0, $7JoAD.createSubscriber)((0, (0, parcelRequire("7YSUx")).default), {
        displayName: 'ConnectAppsSubscriber'
    });
    const $1d2a37fb0b2cedf7$export$4864478dcab77643 = (0, $7JoAD.createHook)((0, (0, parcelRequire("7YSUx")).default));
    const $1d2a37fb0b2cedf7$export$ac845603c8c91acd = (0, $7JoAD.createContainer)((0, (0, parcelRequire("7YSUx")).default));
});
parcelRegister("7YSUx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3bdb3f5fb2a260df$export$2e2bcd8739ae039);
    var $7JoAD = parcelRequire("7JoAD");
    var $76t3Y;
    const $3bdb3f5fb2a260df$export$d4c72bab9d6cc13a = {
        data: null,
        loading: false,
        error: null,
        hasFirstError: false
    };
    var $3bdb3f5fb2a260df$export$2e2bcd8739ae039 = (0, $7JoAD.createStore)({
        name: 'connect-apps',
        initialState: $3bdb3f5fb2a260df$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("76t3Y")).actions
    });
});
parcelRegister("76t3Y", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$183a508abf4e51e7$export$e324594224ef24da);
    var $8VvCU;
    const $183a508abf4e51e7$export$e324594224ef24da = {
        fetch: (0, parcelRequire("8VvCU")).default
    };
});
parcelRegister("8VvCU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3b005bb27151e101$export$2e2bcd8739ae039);
    var $2FYaA;
    var $3b005bb27151e101$export$2e2bcd8739ae039 = (projectKey)=>async ({ setState: setState, getState: getState }, { onError: onError })=>{
            const currentState = getState();
            if (!projectKey || currentState.loading) return;
            setState({
                loading: true,
                error: null
            });
            try {
                const data = await (0, (0, parcelRequire("2FYaA")).default)(projectKey);
                setState({
                    data: data,
                    loading: false,
                    error: null
                });
            } catch (err) {
                const { hasFirstError: hasFirstError, data: data } = getState();
                const isFirstError = !hasFirstError && data === null;
                setState({
                    error: err,
                    loading: false,
                    hasFirstError: hasFirstError || isFirstError
                });
                if (onError) onError(isFirstError);
            }
        };
});
parcelRegister("2FYaA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$27cd0e7e45645bce$export$2e2bcd8739ae039);
    var $7f4tk;
    var $gl0PU;
    var $koFzm;
    var $lVlV8;
    const $27cd0e7e45645bce$export$43bc37ac3360968f = (projectKey)=>`/rest/internal/2/connectprojectconfig/${projectKey}`;
    var $27cd0e7e45645bce$export$2e2bcd8739ae039 = (projectKey)=>{
        const fetchPromise = (0, (0, parcelRequire("koFzm")).famaCatchAndLogFetchError)((0, (0, parcelRequire("7f4tk")).default)($27cd0e7e45645bce$export$43bc37ac3360968f(projectKey)), (0, (0, parcelRequire("lVlV8")).PACKAGE_NAME), (0, (0, parcelRequire("gl0PU")).toErrorId)('getConnectApps'), (0, (0, parcelRequire("gl0PU")).toErrorMessage)('Failed to fetch connect apps for a project'));
        return fetchPromise.then((response)=>response.map((app)=>{
                const options = JSON.parse(app.iframe.options);
                const myApp = {
                    title: app.title,
                    id: options.uniqueKey,
                    connectIframeProps: {
                        addon_key: app.iframe.addonKey,
                        key: app.iframe.moduleKey,
                        url: options.url,
                        options: {
                            ...options,
                            productContext: JSON.parse(options.productCtx),
                            structuredContext: JSON.parse(options.structuredContext),
                            user: {
                                uid: options.uid,
                                ukey: options.ukey,
                                timeZone: options.timeZone
                            }
                        }
                    }
                };
                return myApp;
            }));
    };
});
parcelRegister("koFzm", function(module, exports) {
    $parcel$export(module.exports, "famaCatchAndLogFetchError", ()=>$eb8b95f475174133$export$c3948fffb56ff7bb);
    $parcel$export(module.exports, "default", ()=>$eb8b95f475174133$export$2e2bcd8739ae039);
    var $dJl1T;
    var $jJZqs;
    var $1RLjE;
    const $eb8b95f475174133$var$HTTP_LOCATION = 'project-settings-apps.http.catch-and-log-fetch-error';
    const $eb8b95f475174133$var$getStatusCodeGroup = (error)=>{
        if (error instanceof (0, (0, parcelRequire("jJZqs")).default)) {
            const { statusCode: statusCode } = error;
            if (statusCode >= 100 && statusCode <= 199) return '1xx';
            if (statusCode >= 300 && statusCode <= 399) return '3xx';
            if (statusCode >= 400 && statusCode <= 499) return '4xx';
            if (statusCode >= 500 && statusCode <= 599) return '5xx';
        }
        if (error instanceof (0, (0, parcelRequire("jJZqs")).ValidationError)) return '4xx';
        return 'unknown';
    };
    const $eb8b95f475174133$var$catchAndLogFetchError = (promise, message)=>promise.catch((error)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($eb8b95f475174133$var$HTTP_LOCATION, message, error);
            throw error;
        });
    const $eb8b95f475174133$export$c3948fffb56ff7bb = (promise, packageName, errorId, message)=>promise.catch((error)=>{
            const statusCodeGroup = $eb8b95f475174133$var$getStatusCodeGroup(error);
            (0, (0, parcelRequire("1RLjE")).logError)(packageName, errorId, message, error, {
                http: true,
                statusCodeGroup: statusCodeGroup
            });
            throw error;
        });
    var $eb8b95f475174133$export$2e2bcd8739ae039 = $eb8b95f475174133$var$catchAndLogFetchError;
});
parcelRegister("lVlV8", function(module, exports) {
    $parcel$export(module.exports, "APP_ID", ()=>$418c76e16c63cf92$export$d76071d5de2774fc);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$418c76e16c63cf92$export$b8b9d90f9e5bd72b);
    var $3XO6n;
    const $418c76e16c63cf92$export$d76071d5de2774fc = 'project-settings/connect-apps';
    const $418c76e16c63cf92$export$b8b9d90f9e5bd72b = (0, (0, parcelRequire("3XO6n")).toPackageName)('jiraProjectSettingsAppsConnectApps');
});
parcelRegister("6EZeH", function(module, exports) {
    $parcel$export(module.exports, "useDlpEntitlement", ()=>$c4c8661954b324b0$export$4472465702535e7);
    var $9OXo1;
    const $c4c8661954b324b0$export$4472465702535e7 = ()=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        return tenantContext && tenantContext.hasDlpEnabled || false;
    };
});
parcelRegister("9DEd8", function(module, exports) {
    $parcel$export(module.exports, "EcosystemAppsMenu", ()=>$865dc24bed436cec$export$e583660e6ee09caf);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tOuG;
    var $2vSU6;
    var $1rTGO;
    var $aHv3X;
    var $k2DRb;
    var $koVbs;
    var $k0ZZ2;
    var $lpwtK;
    var $4OCke;
    var $k51JQ;
    var $6hMYg;
    var $02Psx;
    var $j9iVo;
    var $gb5lQ;
    var $7OvX8;
    const $865dc24bed436cec$export$c62cfdba33f43c7e = ({ baseSettingsUrl: baseSettingsUrl = '', projectKey: projectKey })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ data: connectAppsData, loading: connectLoading }] = (0, (0, parcelRequire("j9iVo")).useConnectApps)();
        const { data: forgeApps, loading: forgeLoading } = (0, (0, parcelRequire("6hMYg")).useProjectSettingsForgeAppsForMenu)();
        const filteredConnectAppsData = (0, $5uXOq.useMemo)(()=>connectAppsData?.filter((app)=>app?.connectIframeProps?.addon_key !== (0, (0, parcelRequire("gb5lQ")).JIRA_AUTOMATION_ADDON_KEY)), [
            connectAppsData
        ]);
        const sortedApps = (0, $5uXOq.useMemo)(()=>[
                ...(forgeApps || []).map((app)=>({
                        type: 'forge',
                        name: app.name,
                        app: app
                    })),
                ...(filteredConnectAppsData || []).map((app)=>({
                        type: 'connect',
                        name: app.title,
                        app: app
                    }))
            ].sort((a, b)=>a.name.localeCompare(b.name)), [
            forgeApps,
            filteredConnectAppsData
        ]);
        const overrides = (0, $5uXOq.useMemo)(()=>({
                BackMenuItem: {
                    href: `/jira/core/projects/${projectKey}/settings`,
                    title: formatMessage((0, (0, parcelRequire("7OvX8")).messages).backItem),
                    onClick: (ev)=>ev.preventDefault()
                }
            }), [
            projectKey,
            formatMessage
        ]);
        if (connectLoading || forgeLoading) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'app-fields'
            },
            href: `${baseSettingsUrl}/apps/app-fields`,
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
        }, formatMessage((0, (0, parcelRequire("7OvX8")).messages).appFields)), sortedApps.map((ecosystemItem)=>{
            const { type: type, app: app } = ecosystemItem;
            if (type === 'forge') {
                const item = app;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k51JQ")).ForgeItem), {
                    key: item.id,
                    ...item,
                    showIcon: false,
                    overrides: overrides
                });
            }
            const connectApp = app;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
                analytics: {
                    itemId: connectApp.id
                },
                key: connectApp.id,
                href: `${baseSettingsUrl}/apps/${connectApp.id}`,
                selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)()
            }, connectApp.title);
        }), forgeApps?.length ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeScreenEvent), {
            attributes: {
                moduleType: (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE)
            }
        }) : null);
    };
    const $865dc24bed436cec$export$e583660e6ee09caf = (props)=>{
        const { children: children } = props;
        const { data: project } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const projectKey = project && project.key || '';
        const baseSettingsUrl = (0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).CORE_PROJECT), projectKey);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aHv3X")).TriggerAnalyticsWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j9iVo")).ConnectAppsContainer), {
            onError: undefined,
            scope: projectKey
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($865dc24bed436cec$export$c62cfdba33f43c7e, {
            baseSettingsUrl: baseSettingsUrl,
            projectKey: projectKey
        }), children != null && children));
    };
});
parcelRegister("aHv3X", function(module, exports) {
    $parcel$export(module.exports, "ViewAnalyticsWrapper", ()=>$de4af379e202f62d$export$c794eb4124961145);
    $parcel$export(module.exports, "TriggerAnalyticsWrapper", ()=>$de4af379e202f62d$export$e1a79e3d472c925a);
    var $5uXOq = parcelRequire("5uXOq");
    var $k2DRb;
    var $1rTGO;
    var $hBuqR;
    const $de4af379e202f62d$export$c794eb4124961145 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeAnalyticsWrapper), {
            module: (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE),
            shouldFireInitializedEvent: true,
            ...props
        });
    const $de4af379e202f62d$export$e1a79e3d472c925a = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeAnalyticsWrapper), {
            module: (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE),
            moduleType: (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_TRIGGER),
            ...props
        });
});
parcelRegister("7OvX8", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$43a11d7b95b850bb$export$defe85febe8b728c);
    var $7VHMR;
    const $43a11d7b95b850bb$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        apps: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.apps",
            "defaultMessage": "Apps"
        },
        appFields: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.app-fields",
            "defaultMessage": "App fields"
        },
        backItem: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.ecosystem-apps.back-item",
            "defaultMessage": "Back"
        }
    });
});
parcelRegister("1tmBf", function(module, exports) {
    $parcel$export(module.exports, "IssueTypes", ()=>$b746059f9b32cf5c$export$15fef796fc6acc30);
    var $5uXOq = parcelRequire("5uXOq");
    var $gxncq;
    var $cZXEh;
    var $MGmIU;
    var $2vSU6;
    var $koVbs;
    var $k0ZZ2;
    var $3OGaE;
    var $lpwtK;
    var $h9XlT;
    var $lGo7j;
    var $7OqB4;
    var $4ya5m;
    var $02Psx;
    var $kIafm;
    var $afIXj;
    const $b746059f9b32cf5c$export$a4007dc4843ca7f6 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("lpwtK")).useProject));
    const $b746059f9b32cf5c$export$15fef796fc6acc30 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ asyncState: asyncState, topLevel: topLevel, baseLevel: baseLevel, bottomLevel: bottomLevel, addIssueTypeTooltip: addIssueTypeTooltip, isAddIssueTypeDisabled: isAddIssueTypeDisabled }] = (0, (0, parcelRequire("kIafm")).useIssueTypesNavigationItems)();
        const [, addIssueTypesContextActions] = (0, (0, parcelRequire("4ya5m")).useAddIssueTypeContext)();
        const { data: project } = $b746059f9b32cf5c$export$a4007dc4843ca7f6();
        let baseSettingsUrl = '';
        if (project !== null) baseSettingsUrl = (0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).CORE_PROJECT), project.key);
        const hasAnyIssueTypes = topLevel.length > 0 || baseLevel.length > 0 || bottomLevel.length > 0;
        const isReady = asyncState === 'SUCCESS' || hasAnyIssueTypes;
        if (!project || !isReady) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lGo7j")).Skeleton), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OGaE")).TitleHeader), null, formatMessage((0, (0, parcelRequire("afIXj")).default).issueTypes)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h9XlT")).IssueTypesGroup), {
            baseSettingsUrl: baseSettingsUrl,
            hasSeparator: false,
            navigationItems: topLevel
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h9XlT")).IssueTypesGroup), {
            baseSettingsUrl: baseSettingsUrl,
            hasSeparator: true,
            navigationItems: baseLevel
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h9XlT")).IssueTypesGroup), {
            baseSettingsUrl: baseSettingsUrl,
            hasSeparator: true,
            navigationItems: bottomLevel
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), null, (()=>{
            const addItem = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
                analytics: {
                    itemId: 'add-issue-type'
                },
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gxncq"))))), {
                    label: formatMessage((0, (0, parcelRequire("afIXj")).default).addIssueType)
                }),
                isDisabled: isAddIssueTypeDisabled,
                onClick: isAddIssueTypeDisabled ? undefined : addIssueTypesContextActions.openAddIssueTypeModal
            }, formatMessage((0, (0, parcelRequire("afIXj")).default).addIssueType));
            return addIssueTypeTooltip ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("MGmIU")).default), {
                content: addIssueTypeTooltip
            }, addItem) : addItem;
        })()));
    };
});
parcelRegister("gxncq", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c0a1b95a67ec40d2$var$_react = $c0a1b95a67ec40d2$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $kfAhl;
    var $c0a1b95a67ec40d2$var$_add = $c0a1b95a67ec40d2$var$_interopRequireDefault((parcelRequire("hBUeM")));
    function $c0a1b95a67ec40d2$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c0a1b95a67ec40d2$var$AddIcon = (props)=>$c0a1b95a67ec40d2$var$_react.default.createElement((0, parcelRequire("kfAhl")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
        }, props, {
            newIcon: $c0a1b95a67ec40d2$var$_add.default
        }));
    $c0a1b95a67ec40d2$var$AddIcon.displayName = 'AddIcon';
    var $c0a1b95a67ec40d2$var$_default = module.exports.default = $c0a1b95a67ec40d2$var$AddIcon;
});
parcelRegister("h9XlT", function(module, exports) {
    $parcel$export(module.exports, "IssueTypesGroup", ()=>$f4e999d453ca906b$export$5bc39a07c26525ad);
    var $5uXOq = parcelRequire("5uXOq");
    var $7GpiS;
    var $cZXEh;
    var $k0ZZ2;
    var $4OCke;
    const $f4e999d453ca906b$export$5bc39a07c26525ad = ({ MenuItem: MenuItem = (0, (0, parcelRequire("k0ZZ2")).MenuItem), Section: Section = (0, (0, parcelRequire("cZXEh")).default), baseSettingsUrl: baseSettingsUrl, hasSeparator: hasSeparator, navigationItems: navigationItems })=>{
        if (!navigationItems.length) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Section, {
            hasSeparator: hasSeparator
        }, navigationItems.map((issueType)=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuItem, {
                key: String(issueType.id),
                analytics: {
                    itemId: String(issueType.id)
                },
                selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
                href: `${baseSettingsUrl}/issuetypes/${issueType.id}`,
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7GpiS")).default), {
                    appearance: "square",
                    size: "small",
                    src: issueType.icon,
                    borderColor: "transparent"
                })
            }, issueType.name)));
    };
});
parcelRegister("4ya5m", function(module, exports) {
    $parcel$export(module.exports, "useAddIssueTypeContext", ()=>$018a92cfc5e17302$export$40493c3e9059110a);
    var $7JoAD = parcelRequire("7JoAD");
    const $018a92cfc5e17302$var$initialState = {
        isActive: false
    };
    const $018a92cfc5e17302$var$openAddIssueTypeModal = ()=>({ setState: setState })=>{
            setState({
                isActive: true
            });
        };
    const $018a92cfc5e17302$var$closeAddIssueTypeModal = ()=>({ setState: setState })=>{
            setState({
                isActive: false
            });
        };
    const $018a92cfc5e17302$var$actions = {
        openAddIssueTypeModal: $018a92cfc5e17302$var$openAddIssueTypeModal,
        closeAddIssueTypeModal: $018a92cfc5e17302$var$closeAddIssueTypeModal
    };
    const $018a92cfc5e17302$var$STORE_NAME = 'jira-project-settings-apps-add-issue-type-context';
    const $018a92cfc5e17302$var$Store = (0, $7JoAD.createStore)({
        name: $018a92cfc5e17302$var$STORE_NAME,
        initialState: $018a92cfc5e17302$var$initialState,
        actions: $018a92cfc5e17302$var$actions
    });
    const $018a92cfc5e17302$export$40493c3e9059110a = (0, $7JoAD.createHook)($018a92cfc5e17302$var$Store);
    const $018a92cfc5e17302$export$a0f296f941567e3d = (0, $7JoAD.createSubscriber)($018a92cfc5e17302$var$Store);
    const $018a92cfc5e17302$var$storeInstance = {
        state: $018a92cfc5e17302$var$initialState,
        actions: null
    };
    const $018a92cfc5e17302$export$f1a20ca23c90093e = ()=>{
        const [issueTypeContextState, issueTypeContextActions] = $018a92cfc5e17302$export$40493c3e9059110a();
        $018a92cfc5e17302$var$storeInstance.state = issueTypeContextState;
        $018a92cfc5e17302$var$storeInstance.actions = issueTypeContextActions;
        return null;
    };
    const $018a92cfc5e17302$export$605f542240ea8e19 = ()=>$018a92cfc5e17302$var$storeInstance.actions;
});
parcelRegister("kIafm", function(module, exports) {
    $parcel$export(module.exports, "useIssueTypesNavigationItems", ()=>$117ff49c1fb0e68b$export$8facf5695da03580);
    $parcel$export(module.exports, "useIssueTypesNavigationItemsActions", ()=>$117ff49c1fb0e68b$export$502d4d04702890ce);
    var $6wesA;
    var $7JoAD = parcelRequire("7JoAD");
    var $kXBJP;
    var $bI4Ju;
    const $117ff49c1fb0e68b$export$d4c72bab9d6cc13a = {
        projectId: null,
        asyncState: (0, (0, parcelRequire("6wesA")).INIT),
        data: {
            limitPerProject: null,
            issueTypes: []
        },
        addIssueTypeTooltipMessage: ''
    };
    const $117ff49c1fb0e68b$var$load = (projectId, productFeatures, intl)=>async ({ setState: setState, getState: getState })=>{
            try {
                const currentState = getState();
                if (currentState.asyncState === (0, (0, parcelRequire("6wesA")).LOADING) && projectId === currentState.projectId) return;
                setState({
                    ...projectId === currentState.projectId ? currentState : $117ff49c1fb0e68b$export$d4c72bab9d6cc13a,
                    projectId: projectId,
                    asyncState: (0, (0, parcelRequire("6wesA")).LOADING)
                });
                const result = await (0, (0, parcelRequire("kXBJP")).queryIssueTypesNavigationItems)(projectId, productFeatures);
                if (getState().projectId !== projectId) return;
                const { limitPerProject: limitPerProject, data: data } = result.data.simplifiedProject.issueTypeCollection;
                setState({
                    projectId: projectId,
                    asyncState: (0, (0, parcelRequire("6wesA")).SUCCESS),
                    data: {
                        limitPerProject: limitPerProject,
                        issueTypes: data
                    },
                    addIssueTypeTooltipMessage: intl.formatMessage(productFeatures.navigationMessages.addIssueTypeDisabledTooltip, {
                        limit: limitPerProject
                    })
                });
            } catch (error) {
                setState({
                    asyncState: (0, (0, parcelRequire("6wesA")).FAILURE)
                });
            }
        };
    const $117ff49c1fb0e68b$var$remove = (issueTypeId)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            if (state.asyncState !== (0, (0, parcelRequire("6wesA")).SUCCESS)) return;
            setState({
                ...state,
                data: {
                    ...state.data,
                    issueTypes: state.data.issueTypes.filter(({ id: id })=>id !== issueTypeId)
                }
            });
        };
    const $117ff49c1fb0e68b$var$update = (layoutOwners)=>async ({ setState: setState, getState: getState })=>{
            const state = getState();
            if (state.asyncState !== (0, (0, parcelRequire("6wesA")).SUCCESS)) return;
            const newDataById = {};
            for(let i = 0; i < layoutOwners.length; i += 1){
                const { data: data } = layoutOwners[i];
                newDataById[data.id] = {
                    name: data.name,
                    avatarId: data.avatarId,
                    icon: data.iconUrl
                };
            }
            const issueTypes = state.data.issueTypes.map((issueType)=>{
                if (!newDataById[issueType.id]) return issueType;
                const { name: name, avatarId: avatarId } = newDataById[issueType.id];
                return {
                    ...issueType,
                    name: name,
                    avatarId: avatarId || issueType.avatarId
                };
            });
            setState({
                ...state,
                data: {
                    ...state.data,
                    issueTypes: issueTypes
                }
            });
        };
    const $117ff49c1fb0e68b$export$e324594224ef24da = {
        load: $117ff49c1fb0e68b$var$load,
        remove: $117ff49c1fb0e68b$var$remove,
        update: $117ff49c1fb0e68b$var$update
    };
    const $117ff49c1fb0e68b$export$94d3eea6047656ad = ({ projectId: projectId, asyncState: asyncState, data: data, addIssueTypeTooltipMessage: addIssueTypeTooltipMessage })=>{
        const { issueTypes: issueTypes, limitPerProject: limitPerProject } = data;
        const { topLevel: topLevel, baseLevel: baseLevel, bottomLevel: bottomLevel } = (0, (0, parcelRequire("bI4Ju")).getIssueTypeNavigationItemsLevels)(issueTypes);
        const isIssueTypeLimitReached = (0, (0, parcelRequire("bI4Ju")).getIsIssueTypeLimitReached)(limitPerProject, issueTypes.length);
        const addIssueTypeTooltip = isIssueTypeLimitReached ? addIssueTypeTooltipMessage : '';
        return {
            asyncState: asyncState,
            projectId: projectId,
            isAddIssueTypeDisabled: asyncState !== (0, (0, parcelRequire("6wesA")).SUCCESS) || isIssueTypeLimitReached,
            addIssueTypeTooltip: addIssueTypeTooltip,
            topLevel: topLevel,
            baseLevel: baseLevel,
            bottomLevel: bottomLevel
        };
    };
    const $117ff49c1fb0e68b$var$STORE_NAME = 'issue-type-page-navigation-items-new';
    const $117ff49c1fb0e68b$var$Store = (0, $7JoAD.createStore)({
        name: $117ff49c1fb0e68b$var$STORE_NAME,
        initialState: $117ff49c1fb0e68b$export$d4c72bab9d6cc13a,
        actions: $117ff49c1fb0e68b$export$e324594224ef24da
    });
    const $117ff49c1fb0e68b$export$8facf5695da03580 = (0, $7JoAD.createHook)($117ff49c1fb0e68b$var$Store, {
        selector: $117ff49c1fb0e68b$export$94d3eea6047656ad
    });
    const $117ff49c1fb0e68b$export$502d4d04702890ce = (0, $7JoAD.createActionsHook)($117ff49c1fb0e68b$var$Store);
    const $117ff49c1fb0e68b$export$313f907c8e339d1b = (0, $7JoAD.createSubscriber)($117ff49c1fb0e68b$var$Store, {
        selector: $117ff49c1fb0e68b$export$94d3eea6047656ad
    });
});
parcelRegister("6wesA", function(module, exports) {
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$a553a914b9b6f7c9$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "INACTIVE_LIST", ()=>$a553a914b9b6f7c9$export$d7fec05af6b928f7);
    $parcel$export(module.exports, "FIELD_TYPE_LIST", ()=>$a553a914b9b6f7c9$export$de26d0d1ef96d0ed);
    $parcel$export(module.exports, "DELETE_DROPPABLE_ID", ()=>$a553a914b9b6f7c9$export$a155cb9d82798d65);
    $parcel$export(module.exports, "IGNORE_CLICK_OUTSIDE_CLASS_NAME", ()=>$a553a914b9b6f7c9$export$8191ccc97ff9885c);
    $parcel$export(module.exports, "DO_NOT_ANIMATE_WIDTH", ()=>$a553a914b9b6f7c9$export$c77ecc59e9e91e60);
    $parcel$export(module.exports, "JSD_FIELD_HELPTEXT", ()=>$a553a914b9b6f7c9$export$663476c4863d5014);
    $parcel$export(module.exports, "ID_REQUEST_OWNER_PROPERTY_KEY", ()=>$a553a914b9b6f7c9$export$9be9f574874c9a2f);
    $parcel$export(module.exports, "NAME_REQUEST_OWNER_PROPERTY_KEY", ()=>$a553a914b9b6f7c9$export$b320c6b352dcb101);
    $parcel$export(module.exports, "SUGGESTED_GROUP", ()=>$a553a914b9b6f7c9$export$e66b34cc29932bbf);
    $parcel$export(module.exports, "ASSETS_GROUP", ()=>$a553a914b9b6f7c9$export$c87c7df18254969e);
    $parcel$export(module.exports, "DATES_GROUP", ()=>$a553a914b9b6f7c9$export$fa8c310a8ac47d47);
    $parcel$export(module.exports, "LABELS_GROUP", ()=>$a553a914b9b6f7c9$export$5b2dd1b457037e13);
    $parcel$export(module.exports, "NUMBER_GROUP", ()=>$a553a914b9b6f7c9$export$2c2f344ca2ba1c03);
    $parcel$export(module.exports, "PEOPLE_GROUP", ()=>$a553a914b9b6f7c9$export$1441c9d524a8c0f2);
    $parcel$export(module.exports, "SELECT_GROUP", ()=>$a553a914b9b6f7c9$export$d3e4788fc90e5f8f);
    $parcel$export(module.exports, "SYSTEM_GROUP", ()=>$a553a914b9b6f7c9$export$724e0d23ac7e9b03);
    $parcel$export(module.exports, "TEXT_GROUP", ()=>$a553a914b9b6f7c9$export$bd76d204d15f4c6a);
    $parcel$export(module.exports, "VERSION_GROUP", ()=>$a553a914b9b6f7c9$export$33d3fa5e989ba460);
    $parcel$export(module.exports, "ADVANCED_GROUP", ()=>$a553a914b9b6f7c9$export$c58a10f3e3456974);
    $parcel$export(module.exports, "OTHER_GROUP", ()=>$a553a914b9b6f7c9$export$591e195d295fd27e);
    $parcel$export(module.exports, "RESTRICTED_GROUP", ()=>$a553a914b9b6f7c9$export$14785d7afcf55619);
    $parcel$export(module.exports, "AI_SUGGESTED_GROUP", ()=>$a553a914b9b6f7c9$export$df593ebd3e7c9c2d);
    $parcel$export(module.exports, "INIT", ()=>$a553a914b9b6f7c9$export$d788bc089976c004);
    $parcel$export(module.exports, "LOADING", ()=>$a553a914b9b6f7c9$export$26d55645375ca9a);
    $parcel$export(module.exports, "SUCCESS", ()=>$a553a914b9b6f7c9$export$638cc6e36b2a737a);
    $parcel$export(module.exports, "FAILURE", ()=>$a553a914b9b6f7c9$export$5b1e245d5eac107);
    $parcel$export(module.exports, "classicFieldTypesMap", ()=>$a553a914b9b6f7c9$export$369c1f8ac37104ce);
    $parcel$export(module.exports, "ngFieldTypesMap", ()=>$a553a914b9b6f7c9$export$b361664c16c2ea91);
    $parcel$export(module.exports, "SWIFT_VERSION_M2", ()=>$a553a914b9b6f7c9$export$527472231e0f6045);
    var $5fc53;
    var $3XO6n;
    const $a553a914b9b6f7c9$export$b8b9d90f9e5bd72b = (0, (0, parcelRequire("3XO6n")).toPackageName)('jiraProjectSettingsAppsIssueTypePageProductFeatures');
    const $a553a914b9b6f7c9$export$d7fec05af6b928f7 = 'inactive-list';
    const $a553a914b9b6f7c9$export$de26d0d1ef96d0ed = 'field-type-list';
    const $a553a914b9b6f7c9$export$a155cb9d82798d65 = 'delete-droppable-id';
    const $a553a914b9b6f7c9$export$8191ccc97ff9885c = '9|.^=*D(riA_=lUv787iQ7hwW5HIz=}t/OdJy%q';
    const $a553a914b9b6f7c9$export$c77ecc59e9e91e60 = 'DO_NOT_ANIMATE_WIDTH';
    const $a553a914b9b6f7c9$export$88ecd73c50643906 = 'swift_searchPreviouslyCreatedFields';
    const $a553a914b9b6f7c9$export$663476c4863d5014 = 'jsd.field.helpText';
    const $a553a914b9b6f7c9$export$aefba859678f04a = 'jsm.issue.type.associated.screen.id';
    const $a553a914b9b6f7c9$export$9be9f574874c9a2f = 'jsm.issue.type.id';
    const $a553a914b9b6f7c9$export$b320c6b352dcb101 = 'jsm.issue.type.name';
    const $a553a914b9b6f7c9$export$97bca9c51480133e = 'jsm.issue.type.icon.id';
    const $a553a914b9b6f7c9$export$b540ee71bad36b8b = 'jsm.issue.type.icon.url';
    const $a553a914b9b6f7c9$export$27366eb417850f7c = [
        $a553a914b9b6f7c9$export$aefba859678f04a,
        $a553a914b9b6f7c9$export$b320c6b352dcb101,
        $a553a914b9b6f7c9$export$97bca9c51480133e,
        $a553a914b9b6f7c9$export$b540ee71bad36b8b
    ];
    const $a553a914b9b6f7c9$export$e66b34cc29932bbf = 'suggestedGroup';
    const $a553a914b9b6f7c9$export$c87c7df18254969e = 'assetsGroup';
    const $a553a914b9b6f7c9$export$fa8c310a8ac47d47 = 'datesGroup';
    const $a553a914b9b6f7c9$export$5b2dd1b457037e13 = 'labelsGroup';
    const $a553a914b9b6f7c9$export$2c2f344ca2ba1c03 = 'numberGroup';
    const $a553a914b9b6f7c9$export$1441c9d524a8c0f2 = 'peopleGroup';
    const $a553a914b9b6f7c9$export$d3e4788fc90e5f8f = 'selectGroup';
    const $a553a914b9b6f7c9$export$724e0d23ac7e9b03 = 'systemGroup';
    const $a553a914b9b6f7c9$export$bd76d204d15f4c6a = 'textGroup';
    const $a553a914b9b6f7c9$export$33d3fa5e989ba460 = 'versionGroup';
    const $a553a914b9b6f7c9$export$c58a10f3e3456974 = 'advancedGroup';
    const $a553a914b9b6f7c9$export$591e195d295fd27e = 'otherGroup';
    const $a553a914b9b6f7c9$export$14785d7afcf55619 = 'restrictedGroup';
    const $a553a914b9b6f7c9$export$df593ebd3e7c9c2d = 'aiSuggestedGroup';
    const $a553a914b9b6f7c9$export$d788bc089976c004 = 'INIT';
    const $a553a914b9b6f7c9$export$26d55645375ca9a = 'LOADING';
    const $a553a914b9b6f7c9$export$638cc6e36b2a737a = 'SUCCESS';
    const $a553a914b9b6f7c9$export$5b1e245d5eac107 = 'FAILURE';
    const $a553a914b9b6f7c9$export$369c1f8ac37104ce = {
        assetspicker: $a553a914b9b6f7c9$export$c58a10f3e3456974,
        date: $a553a914b9b6f7c9$export$fa8c310a8ac47d47,
        datetime: $a553a914b9b6f7c9$export$fa8c310a8ac47d47,
        labelpicker: $a553a914b9b6f7c9$export$5b2dd1b457037e13,
        number: $a553a914b9b6f7c9$export$2c2f344ca2ba1c03,
        multiuserpicker: $a553a914b9b6f7c9$export$1441c9d524a8c0f2,
        userpicker: $a553a914b9b6f7c9$export$1441c9d524a8c0f2,
        checkbox: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        radio: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        cascadingselect: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        multiselect: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        select: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        attachment: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        text: $a553a914b9b6f7c9$export$bd76d204d15f4c6a,
        textarea: $a553a914b9b6f7c9$export$bd76d204d15f4c6a
    };
    const $a553a914b9b6f7c9$export$b361664c16c2ea91 = {
        [(0, (0, parcelRequire("5fc53")).ASSETS_CF_TYPE)]: $a553a914b9b6f7c9$export$c58a10f3e3456974,
        [(0, (0, parcelRequire("5fc53")).DATE_CF_TYPE)]: $a553a914b9b6f7c9$export$fa8c310a8ac47d47,
        [(0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE)]: $a553a914b9b6f7c9$export$fa8c310a8ac47d47,
        [(0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE)]: $a553a914b9b6f7c9$export$5b2dd1b457037e13,
        [(0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE)]: $a553a914b9b6f7c9$export$2c2f344ca2ba1c03,
        people: $a553a914b9b6f7c9$export$1441c9d524a8c0f2,
        [(0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)]: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)]: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        [(0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE)]: $a553a914b9b6f7c9$export$d3e4788fc90e5f8f,
        [(0, (0, parcelRequire("5fc53")).ATTACHMENT_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE)]: $a553a914b9b6f7c9$export$bd76d204d15f4c6a,
        [(0, (0, parcelRequire("5fc53")).TEXT_AREA_CF_TYPE)]: $a553a914b9b6f7c9$export$bd76d204d15f4c6a,
        text: $a553a914b9b6f7c9$export$bd76d204d15f4c6a,
        [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)]: $a553a914b9b6f7c9$export$c58a10f3e3456974,
        [(0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)]: $a553a914b9b6f7c9$export$c58a10f3e3456974,
        [(0, (0, parcelRequire("5fc53")).SUMMARY_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).DESCRIPTION_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).LABELS_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE)]: $a553a914b9b6f7c9$export$1441c9d524a8c0f2,
        [(0, (0, parcelRequire("5fc53")).PRIORITY_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).REPORTER_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03,
        [(0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)]: $a553a914b9b6f7c9$export$724e0d23ac7e9b03
    };
    const $a553a914b9b6f7c9$export$8e333612d4b83b0e = 'M1';
    const $a553a914b9b6f7c9$export$527472231e0f6045 = 'M2';
});
parcelRegister("kXBJP", function(module, exports) {
    $parcel$export(module.exports, "queryIssueTypesNavigationItems", ()=>$e8107a8cce63320f$export$d7f9b965a8cdf6ce);
    var $7f4tk;
    var $1JUEq;
    const $e8107a8cce63320f$var$getIssueTypesNavigationItemsQuery = (projectId)=>`query IssueTypesNavigationItems {
    simplifiedProject(projectId: ${projectId}) {
        issueTypeCollection {
            limitPerProject
            data {
                id
                name
                avatarId
                hierarchyLevel
                operations {
                    deletable
                    editable
                }
            }
        }
    }
  }`;
    const $e8107a8cce63320f$var$getIssueTypesNavigationItemsWithPropertiesQuery = (projectId, keys)=>`query IssueTypesNavigationItemsWithProperties {
    simplifiedProject(projectId: ${projectId}) {
        issueTypeCollection {
            limitPerProject
            data {
                id
                name
                avatarId
                hierarchyLevel
                operations {
                    deletable
                    editable
                }
                properties(keys: ${JSON.stringify(keys)})
            }
        }
    }
  }`;
    const $e8107a8cce63320f$export$d7f9b965a8cdf6ce = (projectId, productFeatures)=>{
        const propertyKeys = (0, (0, parcelRequire("1JUEq")).getAllPropertiesKeys)(productFeatures);
        const query = propertyKeys.length ? $e8107a8cce63320f$var$getIssueTypesNavigationItemsWithPropertiesQuery(projectId, propertyKeys) : $e8107a8cce63320f$var$getIssueTypesNavigationItemsQuery(projectId);
        return (0, (0, parcelRequire("7f4tk")).default)('/rest/gira/latest/?issue-type-page-navigation', {
            method: 'POST',
            body: JSON.stringify({
                query: query
            })
        });
    };
});
parcelRegister("1JUEq", function(module, exports) {
    $parcel$export(module.exports, "getAllPropertiesKeys", ()=>$fec81b5fddfaba4b$export$481a21941383de83);
    const $fec81b5fddfaba4b$export$481a21941383de83 = (features)=>{
        const { issueTypeHelpText: issueTypeHelpText } = features;
        const allPropertiesKeys = [
            (0, $052efe0fea3c4d67$export$97806a3c861a8076),
            (0, $052efe0fea3c4d67$export$5a53542e76b69730)
        ];
        return issueTypeHelpText ? allPropertiesKeys : [];
    };
});
const $052efe0fea3c4d67$export$5a53542e76b69730 = 'jsd.simplified.issue.type.helpText';
const $052efe0fea3c4d67$export$97806a3c861a8076 = 'jsd.simplified.issue.type.isEmail';
const $052efe0fea3c4d67$export$ffd77ce47de6d72c = 'jsd.field.displayName';
const $052efe0fea3c4d67$export$663476c4863d5014 = 'jsd.field.helpText';
const $052efe0fea3c4d67$export$dc7a7283bd7cd216 = 'jsd.field.approval.config';
const $052efe0fea3c4d67$export$79bc253bc6964b1 = 'jsd.field.approval.all.configs';
parcelRegister("bI4Ju", function(module, exports) {
    $parcel$export(module.exports, "getIssueTypeNavigationItemsLevels", ()=>$a611b4a47ee97f87$export$fcf99cb11372431f);
    $parcel$export(module.exports, "getIsIssueTypeLimitReached", ()=>$a611b4a47ee97f87$export$f9ef03d331bca3e6);
    var $g4tDr;
    var $4cS2K;
    const $a611b4a47ee97f87$var$JSD_IS_EMAIL_REQUEST_TYPE = 'jsd.simplified.issue.type.isEmail';
    const $a611b4a47ee97f87$export$fcf99cb11372431f = (issueTypes)=>issueTypes.reduce((acc, issueType)=>{
            const { id: id, avatarId: avatarId, name: name, hierarchyLevel: hierarchyLevel, properties: properties, operations: operations } = issueType;
            const issueTypeNavigationItem = {
                id: id,
                name: name,
                avatarId: avatarId,
                operations: operations,
                icon: (0, (0, parcelRequire("4cS2K")).getProjectAvatarUrl)(avatarId)
            };
            if ((0, (0, parcelRequire("g4tDr")).isEpicHierarchyLevel)(hierarchyLevel) || properties && properties[$a611b4a47ee97f87$var$JSD_IS_EMAIL_REQUEST_TYPE]) acc.topLevel.push(issueTypeNavigationItem);
            else if ((0, (0, parcelRequire("g4tDr")).isBaseHierarchyLevel)(hierarchyLevel)) acc.baseLevel.push(issueTypeNavigationItem);
            else if ((0, (0, parcelRequire("g4tDr")).isSubtaskHierarchyLevel)(hierarchyLevel)) acc.bottomLevel.push(issueTypeNavigationItem);
            return acc;
        }, {
            topLevel: [],
            baseLevel: [],
            bottomLevel: []
        });
    const $a611b4a47ee97f87$export$f9ef03d331bca3e6 = (limitPerProject, numberOfIssueTypes)=>limitPerProject !== null && limitPerProject > 0 && numberOfIssueTypes >= limitPerProject;
});
parcelRegister("g4tDr", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_GOAL", ()=>$03dd5f7faa501890$export$2294cfc7730248df);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_STRATEGY", ()=>$03dd5f7faa501890$export$961a1d6da881600c);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_INITIATIVE", ()=>$03dd5f7faa501890$export$e11dea67b88ee556);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_EPIC", ()=>$03dd5f7faa501890$export$9ad20e435294162a);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_BASE", ()=>$03dd5f7faa501890$export$a454b3474c5ee5f5);
    $parcel$export(module.exports, "ISSUE_HIERARCHY_LEVEL_SUBTASK", ()=>$03dd5f7faa501890$export$b69c1b48ce8f83de);
    $parcel$export(module.exports, "BASE_HIERARCHY_TYPE", ()=>$03dd5f7faa501890$export$ba7c785763a2a58f);
    $parcel$export(module.exports, "CHILD_HIERARCHY_TYPE", ()=>$03dd5f7faa501890$export$e09d07f2dcff2603);
    $parcel$export(module.exports, "PARENT_HIERARCHY_TYPE", ()=>$03dd5f7faa501890$export$1165245f61159842);
    $parcel$export(module.exports, "EPIC_PARENT_HIERARCHY_TYPE", ()=>$03dd5f7faa501890$export$8a96a83b3f957e58);
    $parcel$export(module.exports, "toHierarchyLevel", ()=>$03dd5f7faa501890$export$c0c893ca5ccae9dd);
    $parcel$export(module.exports, "isBaseHierarchyLevel", ()=>$03dd5f7faa501890$export$bcf91a9d8c5b0f58);
    $parcel$export(module.exports, "isEpicHierarchyLevel", ()=>$03dd5f7faa501890$export$e415cf60723c7aae);
    $parcel$export(module.exports, "isSubtaskHierarchyLevel", ()=>$03dd5f7faa501890$export$41f00a40e2ebd6e8);
    $parcel$export(module.exports, "getHierarchyLevelType", ()=>$03dd5f7faa501890$export$556b686fea6fb229);
    $parcel$export(module.exports, "getHierarchyLevelTypeSplitEpicFromCustom", ()=>$03dd5f7faa501890$export$638ac52227e67c8);
    const $03dd5f7faa501890$export$2294cfc7730248df = 4;
    const $03dd5f7faa501890$export$961a1d6da881600c = 3;
    const $03dd5f7faa501890$export$e11dea67b88ee556 = 2;
    const $03dd5f7faa501890$export$9ad20e435294162a = 1;
    const $03dd5f7faa501890$export$a454b3474c5ee5f5 = 0;
    const $03dd5f7faa501890$export$b69c1b48ce8f83de = -1;
    const $03dd5f7faa501890$export$ba7c785763a2a58f = 'BASE';
    const $03dd5f7faa501890$export$e09d07f2dcff2603 = 'CHILD';
    const $03dd5f7faa501890$export$1165245f61159842 = 'PARENT';
    const $03dd5f7faa501890$export$8a96a83b3f957e58 = 'EPIC';
    const $03dd5f7faa501890$export$c0c893ca5ccae9dd = (level)=>level;
    const $03dd5f7faa501890$export$bcf91a9d8c5b0f58 = (level)=>{
        const numericLevel = Number(level);
        if (Number.isNaN(numericLevel)) return true;
        return numericLevel === $03dd5f7faa501890$export$a454b3474c5ee5f5;
    };
    const $03dd5f7faa501890$export$e415cf60723c7aae = (level)=>{
        const numericLevel = Number(level);
        if (Number.isNaN(numericLevel)) return false;
        return numericLevel === $03dd5f7faa501890$export$9ad20e435294162a;
    };
    const $03dd5f7faa501890$export$41f00a40e2ebd6e8 = (level)=>{
        const numericLevel = Number(level);
        if (Number.isNaN(numericLevel)) return false;
        return numericLevel === $03dd5f7faa501890$export$b69c1b48ce8f83de;
    };
    const $03dd5f7faa501890$export$556b686fea6fb229 = (hierarchyLevel)=>{
        if (Number(hierarchyLevel) > 0) return $03dd5f7faa501890$export$1165245f61159842;
        if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
        return $03dd5f7faa501890$export$ba7c785763a2a58f;
    };
    const $03dd5f7faa501890$export$638ac52227e67c8 = (hierarchyLevel)=>{
        if (Number(hierarchyLevel) === 1) return $03dd5f7faa501890$export$8a96a83b3f957e58;
        if (Number(hierarchyLevel) > 1) return $03dd5f7faa501890$export$1165245f61159842;
        if (Number(hierarchyLevel) < 0) return $03dd5f7faa501890$export$e09d07f2dcff2603;
        return $03dd5f7faa501890$export$ba7c785763a2a58f;
    };
});
parcelRegister("4cS2K", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9a2a115a4d046ac6$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "getProjectAvatarUrl", ()=>$9a2a115a4d046ac6$export$65a50dd1fe88e116);
    $parcel$export(module.exports, "normaliseSavedAvatar", ()=>$9a2a115a4d046ac6$export$b11f6166803b3fff);
    var $9a2a115a4d046ac6$export$2e2bcd8739ae039 = (rawAvatars)=>rawAvatars.system.concat(rawAvatars.custom).map((raw)=>({
                id: Number(raw.id),
                uri: raw.urls['48x48'],
                fileName: raw.fileName
            }));
    const $9a2a115a4d046ac6$export$65a50dd1fe88e116 = (avatarId)=>`/secure/viewavatar?avatarId=${avatarId}&avatarType=issuetype`;
    const $9a2a115a4d046ac6$export$b11f6166803b3fff = (avatar)=>({
            id: parseInt(avatar.id, 10),
            uri: $9a2a115a4d046ac6$export$65a50dd1fe88e116(parseInt(avatar.id, 10)),
            fileName: avatar.fileName
        });
});
parcelRegister("afIXj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b52c5d7d436e6cd4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b52c5d7d436e6cd4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        issueTypes: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.issue-types.issue-types",
            "defaultMessage": "Issue types"
        },
        addIssueType: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.issue-types.add-issue-type",
            "defaultMessage": "Add issue type"
        }
    });
});
parcelRegister("17zko", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$333939f1c0a6953d$export$defe85febe8b728c);
    var $7VHMR;
    const $333939f1c0a6953d$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.title",
            "defaultMessage": "Project settings"
        },
        itemDetails: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-details",
            "defaultMessage": "Details"
        },
        itemAccess: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-access",
            "defaultMessage": "Access"
        },
        itemFieldsNonFinal: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-fields-non-final",
            "defaultMessage": "Fields"
        },
        itemIssueTypes: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-issue-types",
            "defaultMessage": "Issue types"
        },
        itemAdvancedForms: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-advanced-forms",
            "defaultMessage": "Advanced Forms"
        },
        newLozenge: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.new-lozenge",
            "defaultMessage": "New"
        },
        automation: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.automation",
            "defaultMessage": "Automation"
        },
        itemNotifications: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-notifications",
            "defaultMessage": "Notifications"
        },
        itemApprovals: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.item-approvals",
            "defaultMessage": "Approvals"
        },
        dataClassificationNonFinal: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings-nextgen.data-classification-non-final",
            "defaultMessage": "Data classification"
        }
    });
});
parcelRegister("4rn3K", function(module, exports) {
    $parcel$export(module.exports, "useThrowSettingFeatures", ()=>$d5d4618f8b440044$export$154ecbb867fd48f0);
    $parcel$export(module.exports, "Settings", ()=>$d5d4618f8b440044$export$c72f6eaae7b9adff);
    var $5uXOq = parcelRequire("5uXOq");
    var $cZXEh;
    var $5tOuG;
    var $gOS29;
    var $2vSU6;
    var $65Ltd;
    var $co1wz;
    var $k2DRb;
    var $koVbs;
    var $2MtwW;
    var $xc3fY;
    var $2Uv55;
    var $k0ZZ2;
    var $2gP8z;
    var $3OGaE;
    var $lpwtK;
    var $71bFU;
    var $7OqB4;
    var $4OCke;
    var $5xslo;
    var $eOlBz;
    var $g5X3G;
    var $6EZeH;
    var $bkw8F;
    var $69lKq;
    const $d5d4618f8b440044$export$a4007dc4843ca7f6 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("lpwtK")).useProject));
    const $d5d4618f8b440044$export$154ecbb867fd48f0 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("bkw8F")).useSettingFeatures));
    const $d5d4618f8b440044$export$17eaab3b8c213998 = (0, (0, parcelRequire("7OqB4")).withThrowOnError)((0, (0, parcelRequire("eOlBz")).useNewIssueViewLockedInStatus));
    const $d5d4618f8b440044$var$DisplayNotificationsOptions = ({ hasNotifications: hasNotifications, formatMessage: formatMessage, project: project })=>{
        if (!hasNotifications) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("xc3fY")).ExpandableSubmenuItem), {
            analytics: {
                itemId: 'notifications'
            },
            menuItemLabel: formatMessage((0, (0, parcelRequire("69lKq")).default).notifications),
            forceExpand: true,
            submenuId: "core-notifications-settings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("71bFU")).NotificationsSubMenu), {
            settingsUrl: `/plugins/servlet/project-config/${project.key}/notifications`,
            issueLogsUrl: `/jira/core/projects/${project.key}/settings/notifications/issue-logs?projectId=${project.id}`
        }));
    };
    const $d5d4618f8b440044$var$IssueLayoutOption = ({ isNewIssueViewLockedIn: isNewIssueViewLockedIn, hasIssueLayout: hasIssueLayout, formatMessage: formatMessage, project: project })=>{
        if ((0, (0, parcelRequire("co1wz")).ff)('olympus-da-157-enable-project-settings-navigation_zxaq5')) return hasIssueLayout && isNewIssueViewLockedIn && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'issue-layout'
            },
            href: `/plugins/servlet/project-config/${project.key}/issuelayout`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).issueLayout));
        return isNewIssueViewLockedIn && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'issue-layout'
            },
            href: `/plugins/servlet/project-config/${project.key}/issuelayout`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).issueLayout));
    };
    const $d5d4618f8b440044$export$c72f6eaae7b9adff = ({ ecosystemItems: ecosystemItems })=>{
        const { data: features } = $d5d4618f8b440044$export$154ecbb867fd48f0();
        const { data: status } = $d5d4618f8b440044$export$17eaab3b8c213998();
        const isNewIssueViewLockedIn = status?.newIssueViewTransitionLockingStatus !== (0, (0, parcelRequire("eOlBz")).DEFAULT_TO_OLD_ISSUE_VIEW);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: project } = $d5d4618f8b440044$export$a4007dc4843ca7f6();
        const hasDlpEnabled = (0, (0, parcelRequire("6EZeH")).useDlpEntitlement)();
        if (features == null || project == null) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5tOuG")).default), null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3OGaE")).TitleHeader), null, formatMessage((0, (0, parcelRequire("69lKq")).default).projectSettings)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), null, features.hasDetails && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'details'
            },
            selectedOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_DETAILS)
            ],
            href: `/jira/core/projects/${project.key}/settings/details`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).details)), features.hasPeople && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'people'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `/plugins/servlet/project-config/${project.key}/people`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).people)), features.hasAutomation && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2gP8z")).SpotlightTarget), {
            name: "spotlight-sidebar-project-automation"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'automation'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: (0, (0, parcelRequire("gOS29")).getBaseAutomationUrl)({
                isSimplified: project.isSimplified,
                projectKey: (0, (0, parcelRequire("g5X3G")).toProjectKey)(project.key),
                projectType: (0, (0, parcelRequire("2vSU6")).CORE_PROJECT)
            })
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).automation))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2MtwW")).EngagementSpotlight), {
            engagementId: "spotlight-sidebar-project-automation"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Uv55")).FireUiAnalytics), {
            actionSubject: "automationNavigationItem",
            action: "viewed"
        })), features.hasSummary && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'summary'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `/plugins/servlet/project-config/${project.key}/summary`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).summary))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), {
            hasSeparator: features.hasIssueConfigSection || isNewIssueViewLockedIn || (0, (0, parcelRequire("co1wz")).ff)('proforma-mvp-jwm-project-settings_5edja')
        }, features.hasIssueTypes && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'issue-types'
            },
            href: `/plugins/servlet/project-config/${project.key}/issuetypes`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).issueTypes)), (0, ($parcel$interopDefault($5uXOq))).createElement($d5d4618f8b440044$var$IssueLayoutOption, {
            isNewIssueViewLockedIn: isNewIssueViewLockedIn,
            hasIssueLayout: features.hasIssueLayout,
            formatMessage: formatMessage,
            project: project
        }), (0, (0, parcelRequire("co1wz")).ff)('proforma-mvp-jwm-project-settings_5edja') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'proforma-forms'
            },
            href: `/jira/core/projects/${project.key}/settings/forms`,
            selectedOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_CORE_PROFORMA_FORMS)
            ]
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).forms))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), {
            hasSeparator: features.hasProjectGroupTwoSection
        }, features.hasWorkflows && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'workflows'
            },
            href: `/plugins/servlet/project-config/${project.key}/workflows`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).workflows)), features.hasScreens && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'screens'
            },
            href: `/plugins/servlet/project-config/${project.key}/screens`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).screens)), features.hasFields && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'fields'
            },
            href: `/plugins/servlet/project-config/${project.key}/fields`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).fields))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), {
            hasSeparator: features.hasProjectGroupThreeSection
        }, features.hasVersions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_VERSIONS)
            ],
            analytics: {
                itemId: 'versions'
            },
            href: `/plugins/servlet/project-config/${project.key}/administer-versions`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).versions)), features.hasComponents && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_COMPONENTS)
            ],
            analytics: {
                itemId: 'components'
            },
            href: `/plugins/servlet/project-config/${project.key}/administer-components`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).components))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), {
            hasSeparator: features.hasProjectGroupFourSection
        }, features.hasPermissions && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'permissions'
            },
            href: `/plugins/servlet/project-config/${project.key}/permissions`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).permissions)), features.hasIssueSecurity && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'issue-security'
            },
            href: `/plugins/servlet/project-config/${project.key}/issuesecurity`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).issueSecurity)), (0, ($parcel$interopDefault($5uXOq))).createElement($d5d4618f8b440044$var$DisplayNotificationsOptions, {
            hasNotifications: features.hasNotifications,
            formatMessage: formatMessage,
            project: project
        }), features.hasDevtools && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            analytics: {
                itemId: 'devtools'
            },
            href: `/secure/ConfigureDevStatus.jspa?projectKey=${project.key}`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).devtools))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), {
            hasSeparator: features.hasgetIssueCollectorSection
        }, features.hasIssueCollectors && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            selectedOn: [
                (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_SETTINGS_COLLECTORS)
            ],
            analytics: {
                itemId: 'issue-collectors'
            },
            href: `/secure/ViewCollectors!default.jspa?projectKey=${project.key}`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).issueCollectors))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5xslo")).default), {
            hasSeparator: true,
            items: ecosystemItems,
            forgeModule: (0, (0, parcelRequire("k2DRb")).PROJECT_SETTINGS_PAGE_MODULE),
            overrides: {
                BackMenuItem: {
                    href: `/plugins/servlet/project-config/${project.key}`,
                    title: formatMessage((0, (0, parcelRequire("69lKq")).default).itemBack)
                }
            }
        }), hasDlpEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZXEh")).default), {
            hasSeparator: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0ZZ2")).MenuItem), {
            analytics: {
                itemId: 'data-classifications'
            },
            selectedOn: (0, (0, parcelRequire("4OCke")).matchUrlPathname)(),
            href: `/plugins/servlet/project-config/${project.key}/data-classifications`
        }, formatMessage((0, (0, parcelRequire("69lKq")).default).dataClassificationsNonFinal))));
    };
});
parcelRegister("gOS29", function(module, exports) {
    $parcel$export(module.exports, "getBaseAutomationUrl", ()=>$b61a7afc01657dc2$export$8e479e490e1e69bc);
    const $b61a7afc01657dc2$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
        if (projectType === 'service_desk') return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        if (projectType === 'business') return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    };
});
parcelRegister("2MtwW", function(module, exports) {
    $parcel$export(module.exports, "EngagementSpotlight", ()=>$0e9acf1f50def63d$export$f14689466e4eca7a);
    var $5uXOq = parcelRequire("5uXOq");
    var $9ARNv;
    var $6OJ73;
    var $axUP7;
    const $0e9acf1f50def63d$export$f14689466e4eca7a = (0, (0, parcelRequire("axUP7")).withNestingOptimisation)(({ engagementId: engagementId })=>{
        const isFullyExpanded = (0, (0, parcelRequire("6OJ73")).useIsFullyExpanded)();
        return isFullyExpanded && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9ARNv")).EngagementSpotlight), {
            engagementId: engagementId
        });
    });
});
parcelRegister("2Uv55", function(module, exports) {
    $parcel$export(module.exports, "FireUiAnalytics", ()=>$c81bbbeeb609506c$export$5a67e7291fd4569e);
    var $5oFIy;
    var $axUP7;
    const $c81bbbeeb609506c$export$5a67e7291fd4569e = (0, (0, parcelRequire("axUP7")).withNestingOptimisation)((0, (0, parcelRequire("5oFIy")).FireUiAnalytics));
});
parcelRegister("2gP8z", function(module, exports) {
    $parcel$export(module.exports, "SpotlightTarget", ()=>$bac5b90628bba66f$export$e29577842f211e22);
    var $5uXOq = parcelRequire("5uXOq");
    var $47htk;
    var $axUP7;
    const $bac5b90628bba66f$var$SpotlightTargetWrapper = ({ children: children, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("47htk")).default), props, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "data-test-id": `ak-spotlight-target-${props.name}`
        }, children));
    const $bac5b90628bba66f$export$e29577842f211e22 = (0, (0, parcelRequire("axUP7")).withNestingOptimisation)($bac5b90628bba66f$var$SpotlightTargetWrapper);
});
parcelRegister("5xslo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f574dcd99762a8d6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1rTGO;
    var $hBuqR;
    var $au6nA;
    var $fh2pW;
    var $k51JQ;
    const $f574dcd99762a8d6$export$66569e9b4a285b16 = ({ items: items, overrides: overrides, showIcons: showIcons = false, shouldFilter: shouldFilter = true, submenuId: submenuId = '', nestedMenuActive: nestedMenuActive = true })=>{
        const forgeItems = (0, $5uXOq.useMemo)(()=>items.forge || [], [
            items.forge
        ]);
        const connectItems = (0, (0, parcelRequire("au6nA")).useFilteredItems)(items.connect, shouldFilter);
        const sortedItems = (0, $5uXOq.useMemo)(()=>[
                ...forgeItems.map((item)=>({
                        type: 'forge',
                        item: item
                    })),
                ...connectItems.map((item)=>({
                        type: 'connect',
                        item: item
                    }))
            ].sort((a, b)=>a.item.name.localeCompare(b.item.name)), [
            connectItems,
            forgeItems
        ]);
        if (!sortedItems.length) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, sortedItems.map(({ type: type, item: item }, index)=>{
            if (type === 'forge') {
                const forgeItem = item;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k51JQ")).ForgeItem), {
                    key: forgeItem.id,
                    ...forgeItem,
                    overrides: overrides,
                    showIcon: showIcons,
                    nestedMenuActive: nestedMenuActive
                });
            }
            const connectItem = item;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fh2pW")).ConnectItem), {
                item: connectItem,
                key: connectItem.id,
                index: index,
                overrides: overrides,
                showIcons: showIcons,
                submenuId: submenuId
            });
        }), forgeItems.length ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeScreenEvent), null) : null);
    };
    var $f574dcd99762a8d6$export$2e2bcd8739ae039 = ({ forgeModule: forgeModule, ...restProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1rTGO")).ForgeAnalyticsWrapper), {
            module: forgeModule,
            moduleType: (0, (0, parcelRequire("hBuqR")).MODULE_TYPE_TRIGGER)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f574dcd99762a8d6$export$66569e9b4a285b16, restProps));
});
parcelRegister("69lKq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$40a05b6299fc545f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $40a05b6299fc545f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectSettings: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.project-settings",
            "defaultMessage": "Project settings"
        },
        details: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.details",
            "defaultMessage": "Details"
        },
        people: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.people",
            "defaultMessage": "People"
        },
        summary: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.summary",
            "defaultMessage": "Summary"
        },
        deleteProject: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.delete-project",
            "defaultMessage": "Delete project"
        },
        issueTypes: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-types",
            "defaultMessage": "Issue types"
        },
        issueLayout: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-layout",
            "defaultMessage": "Issue layout"
        },
        workflows: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.workflows",
            "defaultMessage": "Workflows"
        },
        screens: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.screens",
            "defaultMessage": "Screens"
        },
        fields: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.fields",
            "defaultMessage": "Fields"
        },
        versions: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.versions",
            "defaultMessage": "Versions"
        },
        components: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.components",
            "defaultMessage": "Components"
        },
        permissions: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.permissions",
            "defaultMessage": "Permissions"
        },
        issueSecurity: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-security",
            "defaultMessage": "Issue security"
        },
        notifications: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.notifications",
            "defaultMessage": "Notifications"
        },
        notificationsEmail: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.notifications-email",
            "defaultMessage": "Notification email"
        },
        hipChat: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.hip-chat",
            "defaultMessage": "HipChat integration"
        },
        issueCollectors: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.issue-collectors",
            "defaultMessage": "Issue collectors"
        },
        new: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.new",
            "defaultMessage": "New"
        },
        itemBack: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.item-back",
            "defaultMessage": "Back to project settings"
        },
        automation: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.automation",
            "defaultMessage": "Automation"
        },
        devtools: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.devtools",
            "defaultMessage": "Development tools"
        },
        forms: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.forms",
            "defaultMessage": "Advanced Forms"
        },
        dataClassificationsNonFinal: {
            "id": "spa-apps-sidebar-core.multi-project-menu.active-project.project-menu.settings-menu.settings.data-classifications-non-final",
            "defaultMessage": "Data classification"
        }
    });
});
parcelRegister("1tFZj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bdfaa99512e485c7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bdfaa99512e485c7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        favorites: {
            "id": "spa-apps-sidebar-core.multi-project-menu.project-group.favorites",
            "defaultMessage": "Starred"
        },
        recents: {
            "id": "spa-apps-sidebar-core.multi-project-menu.project-group.recents",
            "defaultMessage": "Recent"
        },
        expandSection: {
            "id": "spa-apps-sidebar-core.multi-project-menu.project-group.expand-section",
            "defaultMessage": "Expand {section} projects"
        },
        collapseSection: {
            "id": "spa-apps-sidebar-core.multi-project-menu.project-group.collapse-section",
            "defaultMessage": "Collapse {section} projects"
        }
    });
});
parcelRegister("cUsQ8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$898e57801e4e297c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6T4rd;
    var $jJ1Sb;
    var $koVbs;
    var $8zOmE;
    var $95EVP;
    var $jzhSN;
    var $dPLwL;
    const $898e57801e4e297c$var$TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.view-all-projects';
    const $898e57801e4e297c$var$ViewAllProjects = ({ label: label })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jzhSN")).default), {
            href: "/jira/projects?selectedProjectType=business",
            testId: $898e57801e4e297c$var$TEST_ID,
            onClick: ()=>(0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'link clicked', 'jwmViewAllProjectsLink')
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6T4rd")).default), {
            as: "span",
            xcss: $898e57801e4e297c$var$textStyle
        }, label ?? formatMessage((0, (0, parcelRequire("dPLwL")).messages).viewAllProjectsLabel)));
    };
    var $898e57801e4e297c$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($898e57801e4e297c$var$ViewAllProjects);
    const $898e57801e4e297c$var$textStyle = (0, (0, parcelRequire("jJ1Sb")).xcss)({
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontWeight: "var(--ds-font-weight-regular, 400)"
    });
});
parcelRegister("dPLwL", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$2a9ab6de28c59d3b$export$defe85febe8b728c);
    var $7VHMR;
    const $2a9ab6de28c59d3b$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        viewAllProjectsLabel: {
            "id": "spa-apps-sidebar-core.multi-project-menu.project-group.view-all-projects.view-all-projects-label",
            "defaultMessage": "View all projects"
        }
    });
});
parcelRegister("k5gug", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a74810dab45a4db8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $bKCrm;
    var $aFVvc;
    var $iuAuR;
    var $ekH8d;
    var $dcvwL;
    const $a74810dab45a4db8$var$ProjectsHeader = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: data } = (0, (0, parcelRequire("aFVvc")).useProjectCreatePermissionsResource)();
        const canCreateProject = Boolean(data?.canCreateProject);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iuAuR")).default), {
            title: formatMessage((0, (0, parcelRequire("ekH8d")).messages).projectsHeader)
        }, canCreateProject && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bKCrm")).ProjectCreateDrawerConsumer), null, ({ methods: { open: open } })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dcvwL")).default), {
                openProjectCreateDrawer: open
            })));
    };
    var $a74810dab45a4db8$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($a74810dab45a4db8$var$ProjectsHeader);
});
parcelRegister("bKCrm", function(module, exports) {
    $parcel$export(module.exports, "ProjectCreateDrawerProvider", ()=>$645a52f2fa143509$export$9a1c5dbd93c42bca);
    $parcel$export(module.exports, "ProjectCreateDrawerConsumer", ()=>$645a52f2fa143509$export$9a8662cd60931de1);
    $parcel$export(module.exports, "useProjectCreateDrawer", ()=>$645a52f2fa143509$export$8172ff4ed0f75a1e);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $58GFP;
    var $8YEE2;
    var $dIdda = parcelRequire("dIdda");
    var $gL2cg;
    const $645a52f2fa143509$var$Context = (0, $5uXOq.createContext)({
        data: {
            shouldRenderDrawer: false,
            isOpen: false,
            isNextGen: false,
            showExperienceSelection: true,
            recommendedTemplate: undefined,
            defaultSelectedTemplateKey: '',
            source: '',
            isTemplatePickerOpenInitially: false,
            isImportProjectOpenInitially: false,
            selectedProjectType: null,
            recommendationSessionId: undefined
        },
        methods: {
            open: (0, ($parcel$interopDefault($8Rkzz))),
            close: (0, ($parcel$interopDefault($8Rkzz))),
            onSuccess: (0, ($parcel$interopDefault($8Rkzz))),
            onCreateStarted: (0, ($parcel$interopDefault($8Rkzz))),
            setOnCloseCallback: (0, ($parcel$interopDefault($8Rkzz))),
            clearOnCloseCallback: (0, ($parcel$interopDefault($8Rkzz)))
        }
    });
    const $645a52f2fa143509$export$839a70d8fbc9d356 = class ProjectCreateDrawerProvider extends (0, $5uXOq.Component) {
        render() {
            const { children: children } = this.props;
            const { isOpen: isOpen, isNextGen: isNextGen, source: source, showExperienceSelection: showExperienceSelection, shouldRenderDrawer: shouldRenderDrawer, recommendedTemplate: recommendedTemplate, defaultSelectedTemplateKey: defaultSelectedTemplateKey, isTemplatePickerOpenInitially: isTemplatePickerOpenInitially, isImportProjectOpenInitially: isImportProjectOpenInitially, selectedProjectType: selectedProjectType, recommendationSessionId: recommendationSessionId } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($645a52f2fa143509$var$Context.Provider, {
                value: {
                    data: {
                        isOpen: isOpen,
                        isNextGen: isNextGen,
                        source: source,
                        showExperienceSelection: showExperienceSelection,
                        shouldRenderDrawer: shouldRenderDrawer,
                        recommendedTemplate: recommendedTemplate,
                        defaultSelectedTemplateKey: defaultSelectedTemplateKey,
                        isTemplatePickerOpenInitially: isTemplatePickerOpenInitially,
                        isImportProjectOpenInitially: isImportProjectOpenInitially,
                        selectedProjectType: selectedProjectType,
                        recommendationSessionId: recommendationSessionId
                    },
                    methods: {
                        open: this.open,
                        close: this.close,
                        onSuccess: this.onSuccess,
                        onCreateStarted: this.onCreateStarted,
                        setOnCloseCallback: this.setOnCloseCallback,
                        clearOnCloseCallback: this.clearOnCloseCallback
                    }
                }
            }, children);
        }
        constructor(...args){
            super(...args);
            this.state = {
                isOpen: false,
                shouldRenderDrawer: false,
                isNextGen: false,
                showExperienceSelection: true,
                recommendedTemplate: undefined,
                defaultSelectedTemplateKey: '',
                source: '',
                isTemplatePickerOpenInitially: false,
                isImportProjectOpenInitially: false,
                selectedProjectType: null,
                recommendationSessionId: undefined,
                onCloseCallback: (0, ($parcel$interopDefault($8Rkzz)))
            };
            this.onSuccess = (projectKey)=>{
                if (projectKey) {
                    this.props.setLocation(projectKey.returnUrl);
                    this.close(true);
                } else this.close(false);
            };
            this.setOnCloseCallback = (callback)=>{
                this.setState({
                    onCloseCallback: callback
                });
            };
            this.clearOnCloseCallback = ()=>{
                this.setState({
                    onCloseCallback: (0, ($parcel$interopDefault($8Rkzz)))
                });
            };
            this.open = (attributes = {})=>{
                this.setState({
                    isOpen: true,
                    shouldRenderDrawer: true,
                    ...attributes
                });
            };
            this.close = (projectCreated)=>{
                const callOnCloseCallBack = this.state.source === 'navigationNext' || !projectCreated;
                this.setState({
                    isOpen: false,
                    isNextGen: false,
                    showExperienceSelection: true,
                    recommendedTemplate: undefined,
                    defaultSelectedTemplateKey: '',
                    source: '',
                    isTemplatePickerOpenInitially: false,
                    isImportProjectOpenInitially: false,
                    selectedProjectType: null,
                    recommendationSessionId: undefined
                });
                if (callOnCloseCallBack) this.state.onCloseCallback();
            };
            this.closeOld = ()=>{
                this.setState({
                    isOpen: false,
                    isNextGen: false,
                    showExperienceSelection: true,
                    recommendedTemplate: undefined,
                    defaultSelectedTemplateKey: '',
                    source: '',
                    isTemplatePickerOpenInitially: false,
                    selectedProjectType: null,
                    recommendationSessionId: undefined
                });
                this.state.onCloseCallback();
            };
            this.onCreateStarted = (projectKey, templateKey)=>{
                if ((0, (0, parcelRequire("58GFP")).getIsJsmBlankProjectTemplate)(templateKey)) (0, (0, parcelRequire("8YEE2")).LazyComponent).preload();
                (0, (0, parcelRequire("gL2cg")).clearResourcesAssociatedWithProjectKey)(projectKey);
            };
        }
    };
    const $645a52f2fa143509$export$9a1c5dbd93c42bca = (props)=>{
        const { push: push } = (0, $dIdda.useRouterActions)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($645a52f2fa143509$export$839a70d8fbc9d356, {
            ...props,
            setLocation: push
        });
    };
    const { Consumer: $645a52f2fa143509$export$9a8662cd60931de1 } = $645a52f2fa143509$var$Context;
    $645a52f2fa143509$var$Context.displayName = 'ProjectCreateDrawerConsumer';
    const $645a52f2fa143509$export$8172ff4ed0f75a1e = ()=>{
        const projectCreateDrawer = (0, $5uXOq.useContext)($645a52f2fa143509$var$Context);
        if (!projectCreateDrawer) throw new Error('useProjectCreateDrawer must be used within a ProjectCreateDrawerProvider');
        return projectCreateDrawer;
    };
});
parcelRegister("8YEE2", function(module, exports) {
    $parcel$export(module.exports, "LazyComponent", ()=>$300188a98a9fded7$export$31f1740ae531af94);
    $parcel$export(module.exports, "AsyncProjectBuilderDrawer", ()=>$300188a98a9fded7$export$54a4eade9eae9473);
    $parcel$export(module.exports, "canUseProjectBuilder", ()=>$300188a98a9fded7$export$ff317c5d87147a19);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $9noxX;
    var $hPtZI;
    const $300188a98a9fded7$export$31f1740ae531af94 = (0, (0, parcelRequire("hPtZI")).lazy)(()=>(parcelRequire("ikHTf")), {
        ssr: false,
        moduleId: "./src/packages/servicedesk/project-builder/src/ui/index.tsx"
    });
    const $300188a98a9fded7$export$54a4eade9eae9473 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "bundle-async-project-builder",
            packageName: "jira-servicedesk-project-builder",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            fallback: null,
            name: "jsm-project-builder"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9noxX")).ServiceDeskAnalyticsContext), null, (0, ($parcel$interopDefault($5uXOq))).createElement($300188a98a9fded7$export$31f1740ae531af94, {
            isOpenInitial: !!props.isOpenInitial,
            ...props
        }))));
    const $300188a98a9fded7$export$ff317c5d87147a19 = (isAdmin)=>isAdmin;
});
parcelRegister("9noxX", function(module, exports) {
    $parcel$export(module.exports, "ServiceDeskAnalyticsContext", ()=>$12b9024f66e7ef57$export$ac31f8f3368d6881);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXVV6;
    var $4DPZY;
    var $8H3A4;
    const $12b9024f66e7ef57$export$ac31f8f3368d6881 = ({ useContainerContext: useContainerContext, useServiceDeskAnalyticsContext: useServiceDeskAnalyticsContext, children: children, forceRenderWhileLoading: forceRenderWhileLoading })=>{
        const [{ data: containerContextData, loading: containerContextLoading }] = useContainerContext();
        const { data: analyticsContextAttributes, error: analyticsContextError, loading: analyticsContextLoading } = useServiceDeskAnalyticsContext();
        if ((0, $5uXOq.Children).count(children) > 0) {
            const loading = containerContextLoading || analyticsContextLoading;
            const shouldRenderChildren = !loading || loading && forceRenderWhileLoading || !!analyticsContextError;
            if (!shouldRenderChildren) return null;
            const context = {};
            if (containerContextData && containerContextData.project) {
                const { id: id, type: type } = containerContextData.project;
                context.containerType = 'project';
                context.containerId = `${id}`;
                context.containers = {
                    project: {
                        id: `${id}`,
                        type: type
                    }
                };
                if (analyticsContextAttributes && !analyticsContextError) context.attributes = analyticsContextAttributes;
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), context, children);
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
    };
    $12b9024f66e7ef57$export$ac31f8f3368d6881.defaultProps = {
        forceRenderWhileLoading: false,
        useServiceDeskAnalyticsContext: (0, (0, parcelRequire("8H3A4")).useServiceDeskAnalyticsContext),
        useContainerContext: (0, (0, parcelRequire("4DPZY")).useContainerContext)
    };
});
parcelRegister("ikHTf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("kWrFZ"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("92sUi"),
        $6fhBS("i5RRW"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("c8LNs")
    ]).then(()=>parcelRequire('c9lEE'));
});
parcelRegister("gL2cg", function(module, exports) {
    $parcel$export(module.exports, "clearResourcesAssociatedWithProjectKey", ()=>$e1d0138bae1db723$export$c0c81c1828c7638c);
    var $jcw0u;
    var $dIdda = parcelRequire("dIdda");
    const $e1d0138bae1db723$export$c0c81c1828c7638c = (projectKey)=>{
        try {
            const { storeState: storeState } = (0, $dIdda.getResourceStore)();
            const prevState = storeState.getState();
            storeState.setState({
                ...prevState,
                data: Object.fromEntries(Object.entries(prevState?.data).map(([resourceType, value])=>{
                    const { [projectKey]: _, ...rest } = value;
                    return [
                        resourceType,
                        rest
                    ];
                }))
            });
        } catch (e) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'clearResourcesAssociatedWithProjectKey',
                    packageName: 'jiraProjectCreateDrawerContext',
                    teamName: 'helix'
                },
                sendToPrivacyUnsafeSplunk: true,
                error: e instanceof Error ? e : new Error('Error occured in clearResourcesAssociatedWithProjectKey')
            });
        }
    };
});
parcelRegister("ekH8d", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$de5b805401f88067$export$defe85febe8b728c);
    var $7VHMR;
    const $de5b805401f88067$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        projectsHeader: {
            "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.projects-header",
            "defaultMessage": "Projects"
        }
    });
});
parcelRegister("dcvwL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$38d1fe81a75f8a8e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $hPtZI;
    var $5jbF3;
    var $hJE3l;
    const $38d1fe81a75f8a8e$export$ef99f99721eacc0f = (0, (0, parcelRequire("hPtZI")).lazy)(()=>Promise.resolve((parcelRequire("hJE3l"))), {
        ssr: false,
        moduleId: "./src/packages/business/navigation/sidebar/src/ui/multi-project-menu/projects-header/one-click-project/template-picker/index.tsx"
    });
    const $38d1fe81a75f8a8e$var$OneClickProject = ({ openProjectCreateDrawer: openProjectCreateDrawer })=>{
        const renderContent = (0, $5uXOq.useCallback)((data, loading)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
                name: "sidebar-template-picker",
                fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hJE3l")).TemplatePickerFallback), null)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($38d1fe81a75f8a8e$export$ef99f99721eacc0f, {
                data: data,
                loading: loading,
                openProjectCreateDrawer: openProjectCreateDrawer
            })), [
            openProjectCreateDrawer
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5jbF3")).default), {
            renderContent: renderContent,
            openProjectCreateDrawer: openProjectCreateDrawer
        });
    };
    var $38d1fe81a75f8a8e$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($38d1fe81a75f8a8e$var$OneClickProject);
});
parcelRegister("5jbF3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c00fe391b3045d6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lm9d2;
    var $172CC;
    var $gPQRI;
    var $gb5lQ;
    var $3BbwT;
    var $8MKpg;
    const $5c00fe391b3045d6$var$OneClickProjectButton = ({ renderContent: renderContent, openProjectCreateDrawer: openProjectCreateDrawer })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const { data: data, loading: loading, error: error, fetch: fetchJwmTemplates } = (0, (0, parcelRequire("3BbwT")).useProjectTemplates)();
        const { isCollapsed: isLeftSidebarCollapsed } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        const { templates: templates, recommendationSessionId: recommendationSessionId } = data;
        const wasFetched = templates != null || loading || error != null;
        const onClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
        (0, $5uXOq.useEffect)(()=>{
            if (isOpen && !wasFetched) fetchJwmTemplates();
        }, [
            isOpen,
            wasFetched,
            fetchJwmTemplates
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isLeftSidebarCollapsed && isOpen) onClose();
        }, [
            isLeftSidebarCollapsed,
            isOpen,
            onClose
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (error && isOpen) {
                openProjectCreateDrawer((0, (0, parcelRequire("172CC")).getJwmCreateProjectDrawerOptions)((0, (0, parcelRequire("gb5lQ")).LOCATION), recommendationSessionId));
                setIsOpen(false);
            }
        }, [
            error,
            isOpen,
            openProjectCreateDrawer,
            recommendationSessionId
        ]);
        const content = (0, $5uXOq.useCallback)(()=>renderContent(data, loading), [
            renderContent,
            data,
            loading
        ]);
        const trigger = (0, $5uXOq.useCallback)((triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", triggerProps, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8MKpg")).default), {
                onClick: ()=>setIsOpen(!isOpen)
            })), [
            isOpen
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lm9d2")).default), {
            isOpen: isOpen,
            placement: "right-start",
            onClose: onClose,
            content: content,
            trigger: trigger
        });
    };
    var $5c00fe391b3045d6$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($5c00fe391b3045d6$var$OneClickProjectButton);
});
parcelRegister("172CC", function(module, exports) {
    $parcel$export(module.exports, "getJwmCreateProjectDrawerOptions", ()=>$30b27d3ea79ff2d5$export$c1785414279ee192);
    var $2vSU6;
    const $30b27d3ea79ff2d5$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED = 'com.atlassian.jira-core-project-templates:jira-work-management-blank-project-team-managed';
    const $30b27d3ea79ff2d5$export$c1785414279ee192 = (source, recommendationSessionId)=>({
            isNextGen: true,
            selectedProjectType: (0, (0, parcelRequire("2vSU6")).CORE_PROJECT),
            showExperienceSelection: false,
            defaultSelectedTemplateKey: $30b27d3ea79ff2d5$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED,
            recommendedTemplate: {
                templateKey: $30b27d3ea79ff2d5$var$TEMPLATE_BLANK_PROJECT_TEAM_MANAGED,
                isSimplified: false
            },
            source: source,
            recommendationSessionId: recommendationSessionId
        });
});
parcelRegister("3BbwT", function(module, exports) {
    $parcel$export(module.exports, "useProjectTemplates", ()=>$f58c037e2d918746$export$45e810e42086790f);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $6s1PB;
    var $4R6GH;
    var $7f4tk;
    var $gb5lQ;
    var $annwf;
    const $f58c037e2d918746$var$initialState = {
        data: {
            templates: null
        },
        loading: false,
        error: null
    };
    const $f58c037e2d918746$export$45e810e42086790f = ()=>{
        const [{ loading: loading, data: data, error: error }, setState] = (0, $5uXOq.useState)($f58c037e2d918746$var$initialState);
        const fetch = (0, $5uXOq.useCallback)(async ()=>{
            setState({
                data: {
                    templates: null
                },
                loading: true,
                error: null
            });
            try {
                const url = (0, (0, parcelRequire("4R6GH")).fg)('grw-529_srtpmfy_experiment_kill_switch') ? '/rest/simplified/2.0/project-templates?recommendations&templateGallery' : '/rest/simplified/2.0/project-templates?recommendations';
                const response = await (0, (0, parcelRequire("7f4tk")).default)(url);
                const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('cb_jira_template_recs_with_for_all_products');
                const shouldUseNewRecommendations = expConfig.get('useNewRecommendations', false);
                const jwmTemplates = shouldUseNewRecommendations ? (0, (0, parcelRequire("annwf")).getFilteredTemplatesNew)(response) : (0, (0, parcelRequire("annwf")).getFilteredTemplates)(response);
                setState({
                    data: {
                        templates: jwmTemplates,
                        recommendationSessionId: response.recommendationSessionId
                    },
                    loading: false,
                    error: null
                });
            } catch (err) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'useProjectTemplates',
                        packageName: (0, (0, parcelRequire("gb5lQ")).PACKAGE_NAME),
                        teamName: 'jira-warepil'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    data: {
                        templates: null
                    },
                    loading: false,
                    error: err
                });
            }
        }, []);
        return {
            data: data,
            loading: loading,
            error: error,
            fetch: fetch
        };
    };
});
parcelRegister("annwf", function(module, exports) {
    $parcel$export(module.exports, "getFilteredTemplates", ()=>$1ee17a992e26086f$export$e9643d22c03c3a30);
    $parcel$export(module.exports, "getFilteredTemplatesNew", ()=>$1ee17a992e26086f$export$126495c59883efa);
    const $1ee17a992e26086f$var$NUM_TEMPLATES_TO_DISPLAY = 4;
    const $1ee17a992e26086f$var$NUM_TEMPLATES_TO_DISPLAY_NEW = 5;
    const $1ee17a992e26086f$var$MADE_FOR_YOU_CATEGORY = 'made-for-you-category';
    const $1ee17a992e26086f$var$TEMPLATE_KEYS = new Set([
        'jwm.blank-project',
        'jwm.project-management',
        'jwm.personal-task-planner',
        'jwm.task-tracking'
    ]);
    const $1ee17a992e26086f$export$e9643d22c03c3a30 = (response)=>{
        const { templates: templates, lastUsedTemplate: lastUsedTemplateKey, recommendedTemplate: recommendedTemplateKey } = response;
        const lastUsedTemplates = [];
        const recommendedTemplates = [];
        const additionalTemplates = [];
        templates.forEach((template)=>{
            const { projectTypeTemplates: projectTypeTemplates, key: key, categoryTypes: categoryTypes } = template;
            if (lastUsedTemplateKey != null && (projectTypeTemplates?.teamManaged?.key === lastUsedTemplateKey || projectTypeTemplates?.companyManaged?.key === lastUsedTemplateKey)) lastUsedTemplates.push({
                ...template,
                isLastUsed: true
            });
            else if (recommendedTemplateKey != null && (projectTypeTemplates?.teamManaged?.key === recommendedTemplateKey || projectTypeTemplates?.companyManaged?.key === recommendedTemplateKey || categoryTypes.includes($1ee17a992e26086f$var$MADE_FOR_YOU_CATEGORY))) recommendedTemplates.push({
                ...template,
                isRecommended: true
            });
            else if ($1ee17a992e26086f$var$TEMPLATE_KEYS.has(key)) additionalTemplates.push(template);
        });
        const filteredTemplates = [
            ...lastUsedTemplates,
            ...recommendedTemplates,
            ...additionalTemplates
        ].slice(0, $1ee17a992e26086f$var$NUM_TEMPLATES_TO_DISPLAY);
        return filteredTemplates;
    };
    const $1ee17a992e26086f$export$126495c59883efa = (response)=>{
        const { templates: templates, lastUsedTemplate: lastUsedTemplateKey, recommendedTemplate: recommendedTemplateKey, recommendedTemplates: recommendedTemplateKeys } = response;
        const lastUsedTemplates = [];
        const recommendedTemplates = [];
        const additionalTemplates = [];
        recommendedTemplateKeys?.forEach((key, index)=>{
            const template = templates.find((t)=>t.key === key);
            if (template) {
                const { projectTypeTemplates: projectTypeTemplates } = template;
                if (index === 0 && lastUsedTemplateKey) {
                    const isLastUsed = lastUsedTemplateKey && (projectTypeTemplates?.teamManaged?.key === lastUsedTemplateKey || projectTypeTemplates?.companyManaged?.key === lastUsedTemplateKey);
                    lastUsedTemplates.push({
                        ...template,
                        ...isLastUsed && {
                            isLastUsed: isLastUsed
                        }
                    });
                    return;
                }
                const isRecommended = recommendedTemplateKey && (projectTypeTemplates?.teamManaged?.key === recommendedTemplateKey || projectTypeTemplates?.companyManaged?.key === recommendedTemplateKey);
                recommendedTemplates.push({
                    ...template,
                    ...isRecommended && {
                        isRecommended: isRecommended
                    }
                });
            }
        });
        if (lastUsedTemplates.length + recommendedTemplates.length < $1ee17a992e26086f$var$NUM_TEMPLATES_TO_DISPLAY) {
            const placeholderTemplateKeys = Array.from($1ee17a992e26086f$var$TEMPLATE_KEYS).filter((key)=>!lastUsedTemplates.some((t)=>t.key === key) && !recommendedTemplates.some((t)=>t.key === key));
            templates.forEach((template)=>{
                if (placeholderTemplateKeys.includes(template.key)) additionalTemplates.push(template);
            });
        }
        const filteredTemplates = [
            ...lastUsedTemplates,
            ...recommendedTemplates,
            ...additionalTemplates
        ].slice(0, $1ee17a992e26086f$var$NUM_TEMPLATES_TO_DISPLAY_NEW);
        return filteredTemplates;
    };
});
parcelRegister("8MKpg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1f7880bbb09ab94b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $8zOmE;
    var $gb5lQ;
    var $3MXKI;
    var $acCqn;
    const $1f7880bbb09ab94b$var$TEST_ID = 'navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.create-project-button';
    const $1f7880bbb09ab94b$var$CreateProjectButton = ({ onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3MXKI")).default), {
            label: formatMessage((0, (0, parcelRequire("acCqn")).default).createProjectLabel),
            testId: $1f7880bbb09ab94b$var$TEST_ID,
            onClick: (_, analyticsEvent)=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, (0, (0, parcelRequire("gb5lQ")).LOCATION));
                onClick();
            }
        });
    };
    var $1f7880bbb09ab94b$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($1f7880bbb09ab94b$var$CreateProjectButton);
});
parcelRegister("acCqn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f0808b9a7f055d1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9f0808b9a7f055d1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createProjectLabel: {
            "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.create-project-button.create-project-label",
            "defaultMessage": "Create project"
        }
    });
});
parcelRegister("hJE3l", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "TemplatePickerFallback", ()=>$47229cd857e246da$export$675ac63e0637d34d);
    $parcel$export(module.exports, "default", ()=>$47229cd857e246da$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $eddAM;
    var $6PItG;
    var $4SsZC;
    var $Hi7fY;
    var $9MjbF;
    var $1WqFo;
    var $6s1PB;
    var $co1wz;
    var $koVbs;
    var $8zOmE;
    var $95EVP;
    var $itmJb;
    var $cNd4s;
    var $gb5lQ;
    var $2H5YM;
    const $47229cd857e246da$var$POPUP_WIDTH = 272;
    const $47229cd857e246da$export$675ac63e0637d34d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($47229cd857e246da$var$SpinnerWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9MjbF")).default), {
            size: "medium"
        }));
    const $47229cd857e246da$var$TemplatePicker = ({ data: { templates: templates, recommendationSessionId: recommendationSessionId }, loading: loading, openProjectCreateDrawer: openProjectCreateDrawer })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        const isSiteAdmin = (0, (0, parcelRequire("cNd4s")).useIsSiteAdmin)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('cb_jira_template_recs_with_for_all_products');
        const shouldUseNewRecommendations = expConfig.get('useNewRecommendations', false);
        const handleTemplateClick = (0, $5uXOq.useCallback)((projectTypeTemplates, isLastUsed, isRecommended, templateType)=>()=>{
                openProjectCreateDrawer({
                    isNextGen: true,
                    selectedProjectType: 'business',
                    showExperienceSelection: false,
                    defaultSelectedTemplateKey: projectTypeTemplates?.teamManaged?.key || projectTypeTemplates?.companyManaged?.key,
                    source: (0, (0, parcelRequire("gb5lQ")).LOCATION),
                    ...shouldUseNewRecommendations && {
                        recommendationSessionId: recommendationSessionId
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'leftNavOneClickProjectCreateTemplate', {
                    selectedTemplateKey: projectTypeTemplates?.teamManaged?.key || projectTypeTemplates?.companyManaged?.key,
                    isLastUsed: isLastUsed,
                    isRecommended: isRecommended,
                    templateType: templateType,
                    recommendationSessionId: recommendationSessionId
                });
            }, [
            createAnalyticsEvent,
            openProjectCreateDrawer,
            recommendationSessionId,
            shouldUseNewRecommendations
        ]);
        const handleMoreTemplatesClick = (0, $5uXOq.useCallback)(()=>{
            openProjectCreateDrawer({
                isNextGen: true,
                showExperienceSelection: false,
                source: (0, (0, parcelRequire("gb5lQ")).LOCATION)
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'leftNavOneClickProjectCreateMoreTemplates');
        }, [
            createAnalyticsEvent,
            openProjectCreateDrawer
        ]);
        const handleImportButtonClick = (0, $5uXOq.useCallback)(()=>{
            openProjectCreateDrawer({
                isNextGen: true,
                showExperienceSelection: false,
                source: (0, (0, parcelRequire("gb5lQ")).LOCATION),
                isImportProjectOpenInitially: true
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'leftNavOneClickProjectCreateImport');
        }, [
            createAnalyticsEvent,
            openProjectCreateDrawer
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4SsZC")).default), {
            minWidth: $47229cd857e246da$var$POPUP_WIDTH,
            testId: "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.popup-menu-group"
        }, loading ? (0, ($parcel$interopDefault($5uXOq))).createElement($47229cd857e246da$export$675ac63e0637d34d, null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Hi7fY")).default), {
            title: formatMessage((0, (0, parcelRequire("2H5YM")).default).sectionTitle)
        }, Array.isArray(templates) && templates.map(({ iconUrl: iconUrl, key: key, projectTypeTemplates: projectTypeTemplates, title: title, isLastUsed: isLastUsed = false, isRecommended: isRecommended = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6PItG")).default), {
                testId: "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.button-item",
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement($47229cd857e246da$var$StyledImage, {
                    src: iconUrl,
                    alt: `${title.label} icon`
                }),
                key: key,
                onClick: handleTemplateClick(projectTypeTemplates, isLastUsed, isRecommended, key)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($47229cd857e246da$var$ButtonText, null, title.label), isLastUsed && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eddAM")).default), null, formatMessage((0, (0, parcelRequire("2H5YM")).default).lastCreated))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Hi7fY")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6PItG")).default), {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.more-templates-button",
            onClick: handleMoreTemplatesClick
        }, formatMessage((0, (0, parcelRequire("2H5YM")).default).moreTemplatesButtonText)), (isSiteAdmin || isAdmin && (0, (0, parcelRequire("co1wz")).ff)('enable-product-admin-for-x2c-migration_zmlsv') || !isAdmin) && !(0, (0, parcelRequire("1WqFo")).isFedRamp)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6PItG")).default), {
            "data-testid": "navigation-apps-sidebar-core.ui.multi-project-menu.projects-header.one-click-project.template-picker.import-button",
            onClick: handleImportButtonClick
        }, formatMessage((0, (0, parcelRequire("2H5YM")).default).importButtonText)))));
    };
    var $47229cd857e246da$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($47229cd857e246da$var$TemplatePicker);
    const $47229cd857e246da$var$StyledImage = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1tcg _1bsbzwfg _5ral1dfr",
                __cmplp.className
            ])
        });
    });
    const $47229cd857e246da$var$SpinnerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbclpc _1e0c1txw _4cvr1h6o _1bah1h6o _1yt4zu5n",
                __cmplp.className
            ])
        });
    });
    const $47229cd857e246da$var$ButtonText = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwxutpp",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("4SsZC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a362e5b788829972$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $7df7o;
    const $a362e5b788829972$var$PopupMenuGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, ...rest })=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7df7o")).default), {
            maxWidth: maxWidth,
            minWidth: minWidth,
            ...rest
        });
    var $a362e5b788829972$export$2e2bcd8739ae039 = $a362e5b788829972$var$PopupMenuGroup;
});
parcelRegister("2H5YM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ad55b7f9c6c06ab$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6ad55b7f9c6c06ab$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sectionTitle: {
            "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.section-title",
            "defaultMessage": "Start a new project"
        },
        moreTemplatesButtonText: {
            "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.more-templates-button-text",
            "defaultMessage": "More templates"
        },
        importButtonText: {
            "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.import-button-text",
            "defaultMessage": "Import"
        },
        lastCreated: {
            "id": "spa-apps-sidebar-core.multi-project-menu.projects-header.one-click-project.template-picker.last-created",
            "defaultMessage": "Last created"
        }
    });
});
parcelRegister("e7C7O", function(module, exports) {
    $parcel$export(module.exports, "fieldSettingsRelayResource", ()=>$424e18beff0a1aec$export$68b4e700e00bad7a);
    var $ao2h1;
    var $gF6UW;
    var $1nb22;
    const $424e18beff0a1aec$var$RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS = 'PROJECT_SETTINGS_FIELDS';
    const $424e18beff0a1aec$export$68b4e700e00bad7a = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: $424e18beff0a1aec$var$RESOURCE_TYPE_PROJECT_SETTINGS_FIELDS,
        getQuery: ({ match: match, query: query }, { tenantContext: tenantContext })=>{
            const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            return {
                parameters: (0, (0, parcelRequire("gF6UW")).default),
                variables: {
                    projectKey: projectKey ?? '',
                    cloudId: tenantContext.cloudId ?? ''
                },
                options: {
                    fetchPolicy: 'network-only'
                }
            };
        }
    });
});
parcelRegister("gF6UW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e41b4fca86430f4d$export$2e2bcd8739ae039);
    var $eiowN = parcelRequire("eiowN");
    const $e41b4fca86430f4d$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        }, v2 = {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }, v3 = [
            v2,
            {
                "kind": "Variable",
                "name": "projectKey",
                "variableName": "projectKey"
            }
        ], v4 = [
            v2,
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
            }
        ], v5 = {
            "kind": "ScalarField",
            "name": "isExplicitFieldAssociationsEnabled"
        }, v6 = {
            "kind": "ScalarField",
            "name": "name"
        }, v7 = {
            "concreteType": "JiraAvatar",
            "kind": "LinkedField",
            "name": "avatar",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "xsmall"
                }
            ]
        }, v8 = {
            "kind": "ScalarField",
            "name": "issueTypeId"
        }, v9 = {
            "kind": "ScalarField",
            "name": "id"
        }, v10 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 30
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "uiFieldsPageQuery",
                "selections": [
                    {
                        "args": v3,
                        "kind": "FragmentSpread",
                        "name": "fieldsTable_projectFields"
                    },
                    {
                        "args": v3,
                        "kind": "FragmentSpread",
                        "name": "pageHeader_projectFields_Header"
                    },
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v4,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    v5
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "uiFieldsPageQuery",
                "selections": [
                    {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "args": v4,
                                "concreteType": "JiraProject",
                                "kind": "LinkedField",
                                "name": "jiraProjectByKey",
                                "plural": false,
                                "selections": [
                                    v6,
                                    v7,
                                    {
                                        "concreteType": "JiraIssueTypeConnection",
                                        "kind": "LinkedField",
                                        "name": "issueTypes",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraIssueTypeEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueType",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v8,
                                                            v6,
                                                            v7,
                                                            v9
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "key"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "projectId"
                                    },
                                    {
                                        "concreteType": "JiraProjectWithIssueTypeIds",
                                        "kind": "LinkedField",
                                        "name": "projectWithVisibleIssueTypeIds",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "args": v10,
                                                "concreteType": "JiraFieldAssociationWithIssueTypesConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldAssociationWithIssueTypes",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraFieldAssociationWithIssueTypesEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraFieldAssociationWithIssueTypes",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraField",
                                                                        "kind": "LinkedField",
                                                                        "name": "field",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "fieldId"
                                                                            },
                                                                            v9,
                                                                            v6,
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "scope"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "typeKey"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "typeName"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "description"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "JiraIssueTypeConnection",
                                                                        "kind": "LinkedField",
                                                                        "name": "issueTypes",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "JiraIssueTypeEdge",
                                                                                "kind": "LinkedField",
                                                                                "name": "edges",
                                                                                "plural": true,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "JiraIssueType",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            v6,
                                                                                            v7,
                                                                                            v9,
                                                                                            v8
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    },
                                                                    v9,
                                                                    {
                                                                        "concreteType": "JiraFieldOperation",
                                                                        "kind": "LinkedField",
                                                                        "name": "fieldOperation",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "canRemove"
                                                                            },
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "canAssociateInSettings"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "__typename"
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "cursor"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "concreteType": "PageInfo",
                                                        "kind": "LinkedField",
                                                        "name": "pageInfo",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "hasNextPage"
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "endCursor"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "ClientExtension",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "__id"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldAssociationWithIssueTypes(first:30)"
                                            },
                                            {
                                                "args": v10,
                                                "handle": "connection",
                                                "key": "fieldsTable_fieldAssociationWithIssueTypes",
                                                "kind": "LinkedHandle",
                                                "name": "fieldAssociationWithIssueTypes"
                                            }
                                        ]
                                    },
                                    v9,
                                    v5
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "31816b85a02e829f10efc97bdf585dcc27b5df92d9423ab67e54ec85079b9006",
                "metadata": {},
                "name": "uiFieldsPageQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $e41b4fca86430f4d$var$node.hash = "72c7746a41a19b203b9890c0bf92671f";
    (0, $eiowN.PreloadableQueryRegistry).set($e41b4fca86430f4d$var$node.params.id, $e41b4fca86430f4d$var$node);
    var $e41b4fca86430f4d$export$2e2bcd8739ae039 = $e41b4fca86430f4d$var$node;
});
parcelRegister("8yaXd", function(module, exports) {
    $parcel$export(module.exports, "projectSettingsCoreDefaultRedirectRoute", ()=>$f4a2c58264a33355$export$322fe16ec991f12);
    $parcel$export(module.exports, "projectSettingsCoreIssueTypesRoute", ()=>$f4a2c58264a33355$export$c3a32433c580b9ff);
    $parcel$export(module.exports, "projectSettingsCoreFieldsRoute", ()=>$f4a2c58264a33355$export$7c4ee74641923239);
    $parcel$export(module.exports, "projectSettingsCoreIssueTypesWorkflowRoute", ()=>$f4a2c58264a33355$export$9e79ee307216071b);
    $parcel$export(module.exports, "projectSettingsCoreAppsRoute", ()=>$f4a2c58264a33355$export$c7ac65fb0bbe767f);
    $parcel$export(module.exports, "projectSettingsCoreAppsFieldsRoute", ()=>$f4a2c58264a33355$export$1c7e75ffaa491922);
    $parcel$export(module.exports, "projectSettingsCoreDetailsRoute", ()=>$f4a2c58264a33355$export$14535b40530c8690);
    $parcel$export(module.exports, "projectSettingsCoreAccessRoute", ()=>$f4a2c58264a33355$export$fe93051d5b7385a1);
    $parcel$export(module.exports, "projectSettingsCoreAccessRedirectRoute", ()=>$f4a2c58264a33355$export$59e3323ba0cc224a);
    $parcel$export(module.exports, "projectSettingsCoreProformaProjectFormsRoute", ()=>$f4a2c58264a33355$export$57fe8c5107a9c0de);
    $parcel$export(module.exports, "projectSettingsCoreProformaJiraFormBuilderRoute", ()=>$f4a2c58264a33355$export$4e7ce7e6ced0f291);
    $parcel$export(module.exports, "projectSettingsCoreAutomationRoute", ()=>$f4a2c58264a33355$export$65a4d727336c49f4);
    $parcel$export(module.exports, "projectSettingsCoreAutomationV2Route", ()=>$f4a2c58264a33355$export$5437af2650f645e0);
    $parcel$export(module.exports, "projectSettingsCoreDataClassificationsRoute", ()=>$f4a2c58264a33355$export$7aae1006c82a79c0);
    $parcel$export(module.exports, "projectSettingsCoreNotificationsRoute", ()=>$f4a2c58264a33355$export$a1ee80066685b98d);
    $parcel$export(module.exports, "projectSettingsCoreNotificationsIssueLogsRoute", ()=>$f4a2c58264a33355$export$56a8a0b88329b044);
    $parcel$export(module.exports, "projectSettingsCoreNotificationsEmailRoute", ()=>$f4a2c58264a33355$export$b546589f1b048dc);
    $parcel$export(module.exports, "projectSettingsCoreForgeAppsRoute", ()=>$f4a2c58264a33355$export$b34160f55b6104e9);
    $parcel$export(module.exports, "projectSettingsCoreApprovalsRoute", ()=>$f4a2c58264a33355$export$ba11c8f378a2c121);
    var $65Ltd;
    const $f4a2c58264a33355$export$322fe16ec991f12 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_DEFAULT_REDIRECT),
        path: '/jira/core/projects/:projectKey/settings'
    };
    const $f4a2c58264a33355$export$c3a32433c580b9ff = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES),
        path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId?',
        exact: true
    };
    const $f4a2c58264a33355$export$7c4ee74641923239 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_FIELDS),
        path: '/jira/core/projects/:projectKey/settings/fields',
        exact: true
    };
    const $f4a2c58264a33355$export$9e79ee307216071b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_ISSUE_TYPES_WORKFLOW),
        path: '/jira/core/projects/:projectKey/settings/issuetypes/:issueTypeId/:initialSection(workflow)',
        exact: true
    };
    const $f4a2c58264a33355$export$c7ac65fb0bbe767f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS),
        path: '/jira/core/projects/:projectKey/settings/apps/:appId?',
        exact: true
    };
    const $f4a2c58264a33355$export$1c7e75ffaa491922 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPS_FIELDS),
        path: '/jira/core/projects/:projectKey/settings/apps/app-fields',
        exact: true
    };
    const $f4a2c58264a33355$export$14535b40530c8690 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_DETAILS),
        path: '/jira/core/projects/:projectKey/settings/details',
        exact: true
    };
    const $f4a2c58264a33355$export$fe93051d5b7385a1 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS),
        path: '/jira/core/projects/:projectKey/settings/access',
        exact: true
    };
    const $f4a2c58264a33355$export$59e3323ba0cc224a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_ACCESS_REDIRECT),
        path: '/jira/core/projects/:projectKey/settings/people',
        exact: true
    };
    const $f4a2c58264a33355$export$57fe8c5107a9c0de = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_PROJECT_FORMS),
        path: '/jira/core/projects/:projectKey/settings/forms',
        exact: true
    };
    const $f4a2c58264a33355$export$4e7ce7e6ced0f291 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_PROFORMA_JIRA_FORM_BUILDER),
        path: '/jira/core/projects/:projectKey/settings/forms/form/:templateFormId/edit',
        exact: true
    };
    const $f4a2c58264a33355$export$65a4d727336c49f4 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_AUTOMATION),
        path: '/jira/core/projects/:projectKey/settings/automation'
    };
    const $f4a2c58264a33355$export$5437af2650f645e0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_AUTOMATION),
        path: '/jira/core/projects/:projectKey/settings/automate'
    };
    const $f4a2c58264a33355$export$7aae1006c82a79c0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_DATA_CLASSIFICATIONS),
        path: '/jira/core/projects/:projectKey/settings/data-classifications',
        exact: true
    };
    const $f4a2c58264a33355$export$a1ee80066685b98d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS),
        path: '/jira/core/projects/:projectKey/settings/notifications',
        exact: true
    };
    const $f4a2c58264a33355$export$56a8a0b88329b044 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATIONS_ISSUE_LOGS),
        path: '/jira/core/projects/:projectKey/settings/notifications/issue-logs',
        exact: true
    };
    const $f4a2c58264a33355$export$b546589f1b048dc = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_NOTIFICATION_EMAIL),
        path: '/jira/core/projects/:projectKey/settings/notifications/notification-email',
        exact: true
    };
    const $f4a2c58264a33355$export$b34160f55b6104e9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_FORGE_APPS),
        path: '/jira/core/projects/:projectKey/settings/apps/:appId/:envId/:route?'
    };
    const $f4a2c58264a33355$export$ba11c8f378a2c121 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_CORE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_CORE_APPROVALS),
        path: '/jira/core/projects/:projectKey/settings/approvals',
        exact: true
    };
});
parcelRegister("d0oNj", function(module, exports) {
    $parcel$export(module.exports, "ProjectSettingsAccessSkeleton", ()=>$0aa0180a4506ead8$export$e6cc5ccd52c7fd63);
    $parcel$export(module.exports, "ProjectSettingsDetailsSkeleton", ()=>$0aa0180a4506ead8$export$bd7fd4005b84aec9);
    $parcel$export(module.exports, "ProjectSettingsFeaturesSkeleton", ()=>$0aa0180a4506ead8$export$ec1cdd0c8335373c);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $7TlNQ = parcelRequire("7TlNQ");
    var $jTu83 = parcelRequire("jTu83");
    var $l6s4f = parcelRequire("l6s4f");
    const $0aa0180a4506ead8$var$customCssStyles = null;
    const $0aa0180a4506ead8$var$listOnlyStyles = null;
    const $0aa0180a4506ead8$export$e6cc5ccd52c7fd63 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($7TlNQ))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s85ogf _p12f1qe4 _11y7oza4"
            ])
        });
    const $0aa0180a4506ead8$export$bd7fd4005b84aec9 = ({ isListOnly: isListOnly = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($jTu83))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                isListOnly ? "_1wgmglyw _rcuj1bdq" : "_18s85ogf _p12f1qe4 _11y7oza4"
            ])
        });
    const $0aa0180a4506ead8$export$ec1cdd0c8335373c = ({ isListOnly: isListOnly = false })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($l6s4f))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                isListOnly ? "_1wgmglyw _rcuj1bdq" : "_18s85ogf _p12f1qe4 _11y7oza4"
            ])
        });
});
parcelRegister("7TlNQ", function(module, exports) {
    module.exports = new URL("project-settings-access-app-skeleton.tpl.21bb94b1.svg", import.meta.url).toString();
});
parcelRegister("jTu83", function(module, exports) {
    module.exports = new URL("project-settings-details-app-skeleton.tpl.c4ebc2fd.svg", import.meta.url).toString();
});
parcelRegister("l6s4f", function(module, exports) {
    module.exports = new URL("project-settings-features-app-skeleton.tpl.b8e7f249.svg", import.meta.url).toString();
});
parcelRegister("ljyNx", function(module, exports) {
    $parcel$export(module.exports, "approvalsProjectSettingsEntryPoint", ()=>$d1b68aa40690ad89$export$1389a6ddf34f642e);
    var $2Ftxm;
    var $ikgNX;
    const $d1b68aa40690ad89$export$1389a6ddf34f642e = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("kXKUX")), {
            moduleId: "83e2f2c2"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("kXKUX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1lXo2")
    ]).then(()=>parcelRequire('8gPdF'));
});
parcelRegister("femMW", function(module, exports) {
    $parcel$export(module.exports, "notificationsIssueLogsEntryPoint", ()=>$6adcc3494d7c3774$export$97bbdefcbe0571ac);
    var $9Cf70;
    var $2Ftxm;
    var $ikgNX;
    const $6adcc3494d7c3774$export$97bbdefcbe0571ac = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("1Nsfq")), {
            moduleId: "b2136a4d"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    notificationLogs: {
                        options: {
                            fetchPolicy: 'network-only'
                        },
                        parameters: (0, parcelRequire("9Cf70")).default,
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectId: Number(context?.query?.projectId ?? 0),
                            notificationType: 'INTERNAL_NOTIFICATION_ISSUE'
                        }
                    }
                },
                extraProps: {
                    accountId: tenantContext.atlassianAccountId,
                    cloudId: tenantContext.cloudId,
                    projectIds: context?.query?.projectId,
                    projectKey: context?.match.params.projectKey
                }
            })
    });
});
parcelRegister("9Cf70", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$baebbc2289a2b843$export$2e2bcd8739ae039);
    const $baebbc2289a2b843$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "28e1d1e9657c726eca51c9d02a4b718874ec12653eea9e5bfcfef82047676924",
            "metadata": {},
            "name": "uiIssueNotificationLogsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $baebbc2289a2b843$export$2e2bcd8739ae039 = $baebbc2289a2b843$var$node;
});
parcelRegister("1Nsfq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("k7BTo")
    ]).then(()=>parcelRequire('6ZR0a'));
});
parcelRegister("7dO7c", function(module, exports) {
    $parcel$export(module.exports, "ProjectSettingsRedirect", ()=>$646d86edb6dba940$export$72130cf40a3c3778);
    var $5uXOq = parcelRequire("5uXOq");
    var $9QpK7;
    var $1J3t1;
    var $dIdda = parcelRequire("dIdda");
    const $646d86edb6dba940$var$ProjectSettingsRedirectNew = ({ match: match })=>{
        const { data: data } = (0, (0, parcelRequire("1J3t1")).useJiraWorkmanagementProjectNavigation)();
        const { projectKey: projectKey } = match.params;
        if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/jira/core/projects/${String(projectKey)}/settings/details`
        });
        if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
        });
        if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/jira/core/projects/${String(match.params.projectKey)}/settings/details`
        });
    };
    const $646d86edb6dba940$var$ProjectSettingsRedirectOld = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/jira/core/projects/${String(match.params.projectKey)}/settings/details`
        });
    const $646d86edb6dba940$export$72130cf40a3c3778 = (0, (0, parcelRequire("9QpK7")).componentWithFF)('olympus-da-157-enable-project-settings-navigation_zxaq5', $646d86edb6dba940$var$ProjectSettingsRedirectNew, $646d86edb6dba940$var$ProjectSettingsRedirectOld);
});
parcelRegister("NWARb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("eNxsN")
    ]).then(()=>parcelRequire('aRrWI'));
});
parcelRegister("l00Ww", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4a74D")
    ]).then(()=>parcelRequire('fEx2J'));
});
parcelRegister("RJn1w", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cYKQ3").then(()=>parcelRequire('79qwo'));
});
parcelRegister("9RXCH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("7gKdX")
    ]).then(()=>parcelRequire('kO3mB'));
});
parcelRegister("kVevk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7Jjzg")
    ]).then(()=>parcelRequire('9vEjY'));
});
parcelRegister("b3T21", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gP6jR")
    ]).then(()=>parcelRequire('7N8D9'));
});
parcelRegister("2Js68", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("dWKlO")
    ]).then(()=>parcelRequire('ciDU2'));
});
parcelRegister("9Saqg", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iwPab")
    ]).then(()=>parcelRequire('1XLXC'));
});
parcelRegister("c32Mm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("e61bl").then(()=>parcelRequire('ieTY5'));
});
parcelRegister("3oy92", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("1gaf4")
    ]).then(()=>parcelRequire('giI7i'));
});
parcelRegister("bm5Zl", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("kn4Lg")
    ]).then(()=>parcelRequire('d6iMp'));
});
parcelRegister("3kJhU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("414RV").then(()=>parcelRequire('ln9R3'));
});
parcelRegister("5x9Js", function(module, exports) {
    $parcel$export(module.exports, "serviceDeskRouteEntries", ()=>$c40db1734fa3af79$export$37a8204dc4094049);
    var $ffza4;
    var $65Ltd;
    var $co1wz;
    var $cSD7y;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $gmE3I;
    var $2pT4g;
    var $dxCvy;
    var $e7C7O;
    var $cAofY;
    var $10cgn;
    var $8CwPO;
    var $6sNnq;
    var $gNStA;
    var $5lsNZ;
    var $l6GNN;
    var $2VkCP;
    var $6iHHm;
    var $dIqTX;
    var $dDDPP;
    var $1Mp6D;
    var $d2Ahj;
    var $6SYRe;
    var $hbKGe;
    var $ah1WQ;
    var $bqXcd;
    var $6Z2mh;
    var $ejiWA;
    var $e9YVH;
    var $7Txnp;
    var $k7tsS;
    var $f8FqB;
    var $d0oNj;
    var $j9RuP;
    var $hKH9R;
    var $cp0du;
    var $6h9hV;
    var $bYT90;
    var $3sOmz;
    var $bUhjF;
    var $5EbkJ;
    var $01Poo;
    var $6T6BC;
    var $p09kb;
    var $01LdL;
    var $aPBt5;
    var $6RowE;
    var $eHnlx;
    var $3egqP;
    var $6ybDD;
    var $5qwUl;
    var $34BDN;
    var $aZDos;
    var $tQ1zW;
    var $3VKX1;
    var $vzOOJ;
    var $aV9OB;
    var $7zcmB;
    var $3uo46;
    var $jNJyR;
    var $e8N9g;
    var $bz1sy;
    var $6xGbx;
    var $lAfKa;
    var $k1jvb;
    var $hJD3V;
    var $c0aPe;
    var $b0cvA;
    var $b2cnG;
    var $3i9aq;
    const $c40db1734fa3af79$var$ufoNamesMap = {
        'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
        'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp'
    };
    const $c40db1734fa3af79$var$getUFOName = (name)=>$c40db1734fa3af79$var$ufoNamesMap[name] || name;
    const $c40db1734fa3af79$var$commonRouteEntries = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskIssuetypesRoute), ()=>({
                ufoName: $c40db1734fa3af79$var$getUFOName(`${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-issuetypes`),
                component: (0, (0, parcelRequire("5EbkJ")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("5EbkJ")).LazyIssueTypeSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskIssuetypesWorkflowRoute), ()=>({
                component: (0, (0, parcelRequire("3i9aq")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("5EbkJ")).LazyIssueTypeSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskFieldsRoute), ()=>({
                ufoName: 'project-settings.fields.jsm-tmp',
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('project_fields_page_for_tmp_-_mvp', (0, (0, parcelRequire("3sOmz")).default), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                    (0, (0, parcelRequire("e7C7O")).fieldSettingsRelayResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("3sOmz")).LazyFieldsSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskAppsFieldsRoute), ()=>({
                component: (0, (0, parcelRequire("j9RuP")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("j9RuP")).LazyConnectAppControlsSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskApps1Route), ()=>({
                component: (0, (0, parcelRequire("cp0du")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("cp0du")).LazyConnectAppsSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskDetailsRoute), ()=>({
                component: (0, (0, parcelRequire("bYT90")).default),
                skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsDetailsSkeleton),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("bYT90")).LazyDetailsSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskAccessRoute), ()=>({
                skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsAccessSkeleton),
                component: (0, (0, parcelRequire("p09kb")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("p09kb")).LazyPeopleSettings)
                ],
                ufoName: 'project-settings.access'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskAccessRedirectRoute), ()=>({
                component: (0, (0, parcelRequire("p09kb")).peopleAccessRedirect)(`/jira/${(0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)}`),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("p09kb")).LazyPeopleSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskProformaProjectFormsRoute), ()=>({
                component: (0, (0, parcelRequire("6RowE")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("6RowE")).LazyProjectSettingsProformaProjectForms)
                ],
                perfMetricKey: 'forms-settings'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskProformaJiraFormBuilderRoute), ()=>({
                component: (0, (0, parcelRequire("aPBt5")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("aPBt5")).LazyProjectSettingsProformaJiraFormBuilder)
                ],
                perfMetricKey: 'form-builder'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).projectSettingsServicedeskAutomationRoute), ()=>({
                ufoName: `project-settings-automation-${0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT}`,
                component: (0, (0, parcelRequire("01Poo")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("01Poo")).LazyProjectSettingsJiraAutomation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskDataClassificationsRoute), ()=>({
                component: (0, (0, parcelRequire("6h9hV")).default),
                skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsDetailsSkeleton),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("6h9hV")).LazyDataClassificationsSettings)
                ]
            }))
    ];
    const $c40db1734fa3af79$export$37a8204dc4094049 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskClassicAppsRoute), ()=>({
                ufoName: 'service-management.app-discovery',
                component: (0, (0, parcelRequire("j9RuP")).ConnectAppsRedirect)(`/jira/${(0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)}`),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                isRedirect: true,
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("hKH9R")).LazyAppDiscoverySettings)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).APP_DISCOVERY,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).APP_DISCOVERY),
                        teamName: 'it-solutions-hermes'
                    }
                }
            })),
        ...$c40db1734fa3af79$var$commonRouteEntries,
        ...(0, (0, parcelRequire("1Mp6D")).knowledgeSettingsRouteEntries),
        ...(0, (0, parcelRequire("6SYRe")).ticketTypeFieldsRouteEntries),
        ...(0, (0, parcelRequire("hbKGe")).ticketTypesConfigRouteEntries),
        ...(0, (0, parcelRequire("6iHHm")).legacyAutomationRouteEntries),
        ...(0, (0, parcelRequire("dIqTX")).customerNotificationsSettingsRouteEntries),
        ...(0, (0, parcelRequire("ah1WQ")).virtualAgentRouteEntries),
        ...(0, (0, parcelRequire("l6GNN")).playbooksRouteEntries),
        ...(0, (0, parcelRequire("dDDPP")).journeysRouteEntries),
        (0, (0, parcelRequire("bqXcd")).servicedeskWorkflowConfigRouteEntry),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskItsmFeaturesRoute), ()=>({
                ufoName: 'jsm-features-settings',
                component: (0, (0, parcelRequire("bz1sy")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("6sNnq")).featuresResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("bz1sy")).LazyProjectSettingsServiceDeskItsmFeatures)
                ],
                perfMetricKey: 'jsm-features-settings'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskNotificationsInternalNotificationsRoute), ()=>({
                ufoName: 'service-management.internal-notifications',
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('update_jsm_project_settings_pages_urls', (0, (0, parcelRequire("e8N9g")).serviceDeskInternalNotificationsNextGenRedirect), (0, (0, parcelRequire("jNJyR")).default)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("jNJyR")).LazyProjectSettingsServiceDeskInternalNotifications),
                    (0, (0, parcelRequire("f8FqB")).LazyInternalNotificationSettingsPage)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute), ()=>({
                ufoName: 'service-management.internal-notifications',
                component: (0, (0, parcelRequire("jNJyR")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("jNJyR")).LazyProjectSettingsServiceDeskInternalNotifications),
                    (0, (0, parcelRequire("f8FqB")).LazyInternalNotificationSettingsPage)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).projectSettingsServicedeskNotificationsNotificationEmailRoute), ()=>({
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('update_jsm_project_settings_pages_urls', (0, (0, parcelRequire("k1jvb")).ServiceDeskNotificationEmailNextGenRedirect), (0, (0, parcelRequire("6T6BC")).default)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("6T6BC")).LazyProjectSettingsNotificationEmail)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).projectSettingsServicedeskNotificationsEmailRoute), ()=>({
                component: (0, (0, parcelRequire("6T6BC")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("6T6BC")).LazyProjectSettingsNotificationEmail)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).projectSettingsServicedeskNotifications1Route), ()=>({
                component: (0, (0, parcelRequire("hJD3V")).notificationsRedirect)('customer-notifications'),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskLanguageKeyRoute), ()=>({
                ufoName: 'service-management.translations',
                component: (0, (0, parcelRequire("lAfKa")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                    (0, (0, parcelRequire("k7tsS")).languageTranslationsResource),
                    (0, (0, parcelRequire("k7tsS")).outgoingEmailStateModelResource)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).LANGUAGE_SETTINGS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).LANGUAGE_SETTINGS),
                        teamName: 'jsm-banana'
                    }
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("lAfKa")).LazyProjectSettingsServiceDeskLanguageTranslations)
                ],
                perfMetricKey: 'jsm-language-translations'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskLanguage1Route), ()=>({
                ufoName: 'service-management.languages',
                component: (0, (0, parcelRequire("6xGbx")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("lAfKa")).LazyProjectSettingsServiceDeskLanguageTranslations)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsPermissionsNextGenRoute), ()=>({
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('update_jsm_project_settings_pages_urls', (0, (0, parcelRequire("tQ1zW")).customerPermissionsRedirect), (0, (0, parcelRequire("aZDos")).default)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("10cgn")).customerPermissionsPageDataResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("aZDos")).LazyProjectSettingsServiceDeskCustomerPermissions)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_PERMISSIONS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_PERMISSIONS),
                        teamName: 'jsd-flux-capacitors'
                    }
                },
                perfMetricKey: 'jsm-customer-permissions'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskCustomerPermissionsRoute), ()=>({
                component: (0, (0, parcelRequire("aZDos")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("10cgn")).customerPermissionsPageDataResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("aZDos")).LazyProjectSettingsServiceDeskCustomerPermissions)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_PERMISSIONS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_PERMISSIONS),
                        teamName: 'jsd-flux-capacitors'
                    }
                },
                perfMetricKey: 'jsm-customer-permissions'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsEmailNextGenRoute), ()=>({
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('update_jsm_project_settings_pages_urls', (0, (0, parcelRequire("vzOOJ")).serviceDeskEmailNextGenRedirect), (0, (0, parcelRequire("3VKX1")).default)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("3VKX1")).LazyProjectSettingsServiceDeskEmail)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskEmailRoute), ()=>({
                ufoName: 'service-management.settings.email-channels',
                component: (0, (0, parcelRequire("3VKX1")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("3VKX1")).LazyProjectSettingsServiceDeskEmail)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskPortalSettingsRoute), ()=>({
                component: (0, (0, parcelRequire("34BDN")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("34BDN")).LazyProjectSettingsServiceDeskClassicPortalSettings)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).PORTAL_SETTINGS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).PORTAL_SETTINGS),
                        teamName: 'jsd-shield'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsPortalRoute), ()=>({
                component: (0, (0, parcelRequire("c0aPe")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("8CwPO")).portalSettingsContextResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("c0aPe")).LazyProjectSettingsServiceDeskPortalSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskExternalLinksRoute), ()=>({
                component: (0, (0, parcelRequire("aV9OB")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("6sNnq")).featuresResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("aV9OB")).LazyProjectSettingsServiceDeskExternalLinks)
                ],
                perfMetricKey: 'jsm-external-resources'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsWidgetRoute), ()=>({
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('update_jsm_project_settings_pages_urls', (0, (0, parcelRequire("b0cvA")).widgetsNextGenRedirect), (0, (0, parcelRequire("b2cnG")).default)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("b2cnG")).LazyProjectSettingsServiceDeskWidgetSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskWidgetRoute), ()=>({
                component: (0, (0, parcelRequire("b2cnG")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("b2cnG")).LazyProjectSettingsServiceDeskWidgetSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChangeManagementRoute), ()=>({
                ufoName: 'service-management.change-management-settings',
                component: (0, (0, parcelRequire("eHnlx")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("cAofY")).serviceDeskContextResource),
                    (0, (0, parcelRequire("ejiWA")).changeManagementSettingsProjectConfigurationResource),
                    (0, (0, parcelRequire("gmE3I")).jsmChangeManagementSettingsGitLabGatingResource),
                    (0, (0, parcelRequire("6sNnq")).featuresResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                    (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('enable_jsm_repackaging_changes_vtwk9'), (0, (0, parcelRequire("2pT4g")).jsmRepackagingBannerResource))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("eHnlx")).LazyProjectSettingsServiceDeskChangeManagement)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskIncidentManagementRoute), ()=>({
                component: (0, (0, parcelRequire("3uo46")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("cAofY")).serviceDeskContextResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("3uo46")).LazyProjectSettingsServiceDeskIncidentManagement)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannelsChatRoute), ()=>({
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('update_jsm_project_settings_pages_urls', (0, (0, parcelRequire("6ybDD")).serviceDeskChatNextGenRedirect), (0, (0, parcelRequire("5qwUl")).default)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("5qwUl")).LazyProjectSettingsServiceDeskChatSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChatRoute), ()=>({
                component: (0, (0, parcelRequire("5qwUl")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("5qwUl")).LazyProjectSettingsServiceDeskChatSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskChannels5Route), ()=>({
                component: (0, (0, parcelRequire("3egqP")).channelsRedirect)('customer-permissions'),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        ...(0, (0, parcelRequire("d2Ahj")).slaSettingsRouteEntries),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskFeedbackRoute), ()=>({
                component: (0, (0, parcelRequire("7zcmB")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("7zcmB")).LazyProjectSettingsServiceDeskFeedbackSettings),
                    (0, (0, parcelRequire("7Txnp")).LazyCsatSettingsPage)
                ],
                perfMetricKey: 'jsm-feedback-settings',
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).CSAT_CONFIG,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CSAT_CONFIG),
                        teamName: 'jsm-request-intake'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).projectSettingsServicedeskForgeAppsRoute), ()=>({
                component: (0, (0, parcelRequire("bUhjF")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    ...(0, (0, parcelRequire("bUhjF")).forgeProjectSettingsPageResources),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("bUhjF")).LazyForgeProjectSettingsPage)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2VkCP")).routeGroupsProjectSettingsServicedeskRedirectRoute), ()=>({
                component: (0, (0, parcelRequire("01LdL")).defaultRedirectForSettings)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$9ab1d1d726b36319),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("01LdL")).getSettingsNavigationResources)((0, (0, parcelRequire("01LdL")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            }))
    ];
});
parcelRegister("gmE3I", function(module, exports) {
    $parcel$export(module.exports, "jsmChangeManagementSettingsGitLabGatingResource", ()=>$ff8ead4f49d1e745$export$315b6278d34861b4);
    $parcel$export(module.exports, "useGitLabGatingResource", ()=>$ff8ead4f49d1e745$export$dd3715dce02ee460);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $dIdda = parcelRequire("dIdda");
    const $ff8ead4f49d1e745$var$getDataLoader = ()=>(parcelRequire("7Hzl8"));
    const $ff8ead4f49d1e745$export$315b6278d34861b4 = (0, $dIdda.createResource)({
        type: 'JSM_CHANGE_MANAGEMENT_SETTINGS_GITLAB_GATING_RESOURCE',
        getKey: ()=>'JSM_CHANGE_MANAGEMENT_SETTINGS_GITLAB_GATING_RESOURCE',
        getDataLoader: $ff8ead4f49d1e745$var$getDataLoader,
        maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
        isBrowserOnly: true
    });
    const $ff8ead4f49d1e745$export$dd3715dce02ee460 = ()=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, $dIdda.useResource)($ff8ead4f49d1e745$export$315b6278d34861b4);
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, (0, parcelRequire("co1wz")).ff)('enable-gitlab-gating-frontend_k8rha')) return;
            if (!data && !loading && !error) refresh();
        }, [
            data,
            loading,
            error,
            refresh
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: data?.data,
                pending: loading,
                error: data?.error || error
            }), [
            data,
            loading,
            error
        ]);
    };
});
parcelRegister("7Hzl8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hzh3H").then(()=>parcelRequire('4y3Yq'));
});
parcelRegister("2pT4g", function(module, exports) {
    $parcel$export(module.exports, "jsmRepackagingBannerResource", ()=>$f325ae4fdb8711ab$export$760ca885f96dacb6);
    $parcel$export(module.exports, "useJsmRepackagingBannerResource", ()=>$f325ae4fdb8711ab$export$f1444ccc5653a5cb);
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    var $daiqe;
    const $f325ae4fdb8711ab$var$getDataLoader = ()=>(parcelRequire("bjdPq"));
    const $f325ae4fdb8711ab$export$760ca885f96dacb6 = (0, $dIdda.createResource)({
        type: 'JSM_REPACKAGING_BANNER',
        getKey: ()=>'JSM_REPACKAGING_BANNER',
        getDataLoader: $f325ae4fdb8711ab$var$getDataLoader,
        maxAge: false ? 0 : Number.MAX_SAFE_INTEGER,
        isBrowserOnly: true
    });
    const $f325ae4fdb8711ab$export$f1444ccc5653a5cb = (workCategory, accountId)=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, $dIdda.useResource)($f325ae4fdb8711ab$export$760ca885f96dacb6);
        (0, $5uXOq.useEffect)(()=>{
            if (!data && !loading && !error) refresh();
        }, [
            data,
            loading,
            refresh,
            error
        ]);
        return (0, $5uXOq.useMemo)(()=>{
            if (error || loading || !data || !accountId) return {
                show: false
            };
            const { bannerMeta: bannerMeta, bannerDismissState: bannerDismissState } = data;
            const workCategoryDismissState = bannerDismissState?.[workCategory];
            if (!bannerMeta.show || !(bannerMeta.type === 'info' || bannerMeta.type === 'warning')) return {
                show: false
            };
            if (!workCategoryDismissState) return {
                ...bannerDismissState,
                ...bannerMeta,
                refresh: refresh
            };
            if (workCategoryDismissState.packagingChangeDate !== bannerMeta.data.packagingChangeDate) {
                (0, (0, parcelRequire("daiqe")).deleteBannerDismissState)({
                    accountId: accountId
                });
                return {
                    ...bannerMeta,
                    refresh: refresh
                };
            }
            if (workCategoryDismissState.bannerHiddenUntil > Date.now()) return {
                show: false
            };
            return {
                ...bannerMeta,
                ...bannerDismissState,
                refresh: refresh
            };
        }, [
            data,
            loading,
            error,
            workCategory,
            accountId,
            refresh
        ]);
    };
});
parcelRegister("daiqe", function(module, exports) {
    $parcel$export(module.exports, "deleteBannerDismissState", ()=>$00907b0f6d0c25ed$export$e21bb99d98e8c8b4);
    var $jcw0u;
    var $eusud;
    async function $00907b0f6d0c25ed$export$e21bb99d98e8c8b4({ accountId: accountId }) {
        try {
            await (0, (0, parcelRequire("eusud")).performDeleteRequest)(`/rest/api/3/user/properties/jsm-repackaging-banners-dismiss-state?accountId=${accountId}`);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'deleteBannerDismissState',
                    packageName: 'jiraRouterResourcesJsmRepackagingBanner',
                    teamName: 'jenga'
                },
                error: error
            });
        }
    }
});
parcelRegister("bjdPq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cVV3d").then(()=>parcelRequire('iKQCz'));
});
parcelRegister("10cgn", function(module, exports) {
    $parcel$export(module.exports, "customerPermissionsPageDataResource", ()=>$35508436fc3abfb3$export$ae3446385906310c);
    var $dIdda = parcelRequire("dIdda");
    const $35508436fc3abfb3$export$ae3446385906310c = (0, $dIdda.createResource)({
        type: (0, $9cf87aec7862b8b9$export$34a89f9aaa677bb5),
        getKey: ({ match: match })=>match.params.projectKey || '',
        getDataLoader: ()=>(parcelRequire("6gDxz")),
        maxAge: Infinity
    });
});
const $9cf87aec7862b8b9$export$34a89f9aaa677bb5 = 'CUSTOMER_PERMISSIONS';
parcelRegister("6gDxz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3ygSW").then(()=>parcelRequire('i9zBn'));
});
parcelRegister("8CwPO", function(module, exports) {
    $parcel$export(module.exports, "portalSettingsContextResource", ()=>$9dfc351c3ebf85b6$export$4a3e29f235f3320c);
    var $dIdda = parcelRequire("dIdda");
    const $9dfc351c3ebf85b6$var$RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT = 'PORTAL_SETTINGS_CONTEXT';
    const $9dfc351c3ebf85b6$export$4a3e29f235f3320c = (0, $dIdda.createResource)({
        type: $9dfc351c3ebf85b6$var$RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT,
        getKey: ()=>'state',
        getDataLoader: ()=>(parcelRequire("iwaKU"))
    });
});
parcelRegister("iwaKU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kQRxS").then(()=>parcelRequire('7wy1U'));
});
parcelRegister("l6GNN", function(module, exports) {
    $parcel$export(module.exports, "playbooksRouteEntries", ()=>$89f595ea28ec651e$export$89ee08578c593726);
    var $e4eHl = parcelRequire("e4eHl");
    var $65Ltd;
    var $lkFvK;
    var $4R6GH;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $5lsNZ;
    var $2WHzH;
    var $6Z2mh;
    var $lusKj;
    var $lk01G;
    const $89f595ea28ec651e$var$listEntryPoint = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("lk01G")).default),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $89f595ea28ec651e$var$editEntryPoint = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("lusKj")).default),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $89f595ea28ec651e$var$getServiceDeskRoutesCommon = ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            }
        });
    const $89f595ea28ec651e$export$89ee08578c593726 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2WHzH")).servicedeskPlaybooksListRoute), ()=>({
                ...$89f595ea28ec651e$var$getServiceDeskRoutesCommon(),
                entryPoint () {
                    return (0, (0, parcelRequire("4R6GH")).fg)('playbooks-in-jsm') ? $89f595ea28ec651e$var$listEntryPoint : undefined;
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: 'project-settings.playbooks.admin-list-view',
                        packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLAYBOOKS_LIST)),
                        teamName: 'ITOps Phantom'
                    }
                },
                component: (0, (0, parcelRequire("5lsNZ")).default),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                ufoName: 'playbook-list'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2WHzH")).servicedeskPlaybooksEditRoute), ()=>({
                ...$89f595ea28ec651e$var$getServiceDeskRoutesCommon(),
                entryPoint () {
                    return (0, (0, parcelRequire("4R6GH")).fg)('playbooks-in-jsm') ? $89f595ea28ec651e$var$editEntryPoint : undefined;
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: 'project-settings.playbooks.admin-edit-view',
                        packageName: (0, ($parcel$interopDefault($e4eHl)))((0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLAYBOOKS_EDIT)),
                        teamName: 'ITOps Phantom'
                    }
                },
                component: (0, (0, parcelRequire("5lsNZ")).default),
                navigation: {
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                ufoName: 'playbook-edit'
            }))
    ];
});
parcelRegister("2WHzH", function(module, exports) {
    $parcel$export(module.exports, "servicedeskPlaybooksListRoute", ()=>$8e576e4dd5841bdc$export$cbed08b5b0671f5f);
    $parcel$export(module.exports, "servicedeskPlaybooksEditRoute", ()=>$8e576e4dd5841bdc$export$5920ce3a2ccf6e2b);
    var $65Ltd;
    const $8e576e4dd5841bdc$var$getProjectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $8e576e4dd5841bdc$export$5575497f0592ee94 = 'servicedesk';
    const $8e576e4dd5841bdc$export$cbed08b5b0671f5f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLAYBOOKS_LIST),
        path: `${$8e576e4dd5841bdc$var$getProjectSettingsUrl($8e576e4dd5841bdc$export$5575497f0592ee94)}/playbooks`,
        exact: true
    };
    const $8e576e4dd5841bdc$export$5920ce3a2ccf6e2b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PLAYBOOKS_EDIT),
        path: `${$8e576e4dd5841bdc$var$getProjectSettingsUrl($8e576e4dd5841bdc$export$5575497f0592ee94)}/playbooks/:id`,
        exact: true
    };
});
parcelRegister("lusKj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7c46caae51932151$export$2e2bcd8739ae039);
    var $2Ftxm;
    var $ikgNX;
    const $7c46caae51932151$var$playbookEditViewEntryPoint = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("hfX5a")), {
            moduleId: "15e5be42"
        }),
        getPreloadProps: ({ context: context })=>{
            const { projectKey: projectKey } = context.match.params;
            if (!projectKey) throw new Error('projectKey is required');
            return {
                extraProps: {
                    playbookId: context?.match.params.id || '__new__',
                    projectKey: projectKey
                },
                queries: {}
            };
        }
    });
    var $7c46caae51932151$export$2e2bcd8739ae039 = $7c46caae51932151$var$playbookEditViewEntryPoint;
});
parcelRegister("hfX5a", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9YF2g")
    ]).then(()=>parcelRequire('79e1o'));
});
parcelRegister("lk01G", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$787278c10397c75e$export$2e2bcd8739ae039);
    var $8fDOc;
    var $6YEEX;
    var $2Ftxm;
    var $ikgNX;
    const $787278c10397c75e$var$playbookListViewEntryPoint = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("8RxBf")), {
            moduleId: "a498670b"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
            const { projectKey: projectKey } = context.match.params;
            const { tab: tab = 'list' } = context.query;
            if (!projectKey) throw new Error('projectKey is required');
            const entryPoints = tab === 'logs' ? {
                preloadedPlaybookLogsEntryPoint: {
                    entryPoint: (0, (0, parcelRequire("6YEEX")).playbookLogsEntryPoint),
                    entryPointParams: {
                        cloudId: tenantContext.cloudId
                    }
                }
            } : {
                preloadedPlaybookListEntryPoint: {
                    entryPoint: (0, (0, parcelRequire("8fDOc")).playbookListEntryPoint),
                    entryPointParams: {
                        cloudId: tenantContext.cloudId
                    }
                }
            };
            return {
                extraProps: {
                    accountId: tenantContext.atlassianAccountId,
                    cloudId: tenantContext.cloudId,
                    projectId: context.query.projectId,
                    projectKey: context.match.params.projectKey
                },
                entryPoints: entryPoints
            };
        }
    });
    var $787278c10397c75e$export$2e2bcd8739ae039 = $787278c10397c75e$var$playbookListViewEntryPoint;
});
parcelRegister("8fDOc", function(module, exports) {
    $parcel$export(module.exports, "playbookListEntryPoint", ()=>$d77fb854f7f8e8b8$export$d7be5d3b24f1d526);
    var $2Ftxm;
    var $ikgNX;
    const $d77fb854f7f8e8b8$export$d7be5d3b24f1d526 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("jCfPa")), {
            moduleId: "97555e42"
        }),
        getPreloadProps: ({ cloudId: cloudId })=>({
                extraProps: {
                    cloudId: cloudId
                }
            })
    });
});
parcelRegister("jCfPa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lVFAL").then(()=>parcelRequire('iT2g5'));
});
parcelRegister("6YEEX", function(module, exports) {
    $parcel$export(module.exports, "playbookLogsEntryPoint", ()=>$60633bec6dffe3a8$export$7ebe0f850472ea07);
    var $2Ftxm;
    var $ikgNX;
    const $60633bec6dffe3a8$export$7ebe0f850472ea07 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("dOnuK")), {
            moduleId: "1ddad45d"
        }),
        getPreloadProps: ({ cloudId: cloudId })=>({
                extraProps: {
                    cloudId: cloudId
                }
            })
    });
});
parcelRegister("dOnuK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9ctOi").then(()=>parcelRequire('arpva'));
});
parcelRegister("8RxBf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("la2ji").then(()=>parcelRequire('6o22p'));
});
parcelRegister("6iHHm", function(module, exports) {
    $parcel$export(module.exports, "legacyAutomationRouteEntries", ()=>$da7bdd95981ae4d9$export$8521f0867b2d52e4);
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $6pIRW;
    var $6Z2mh;
    var $7aDxF;
    var $9zLHs;
    var $cNpXW;
    var $2sKYo;
    var $6g6uF;
    var $5G6Zw;
    var $i7FI3;
    const $da7bdd95981ae4d9$var$getLegacyAutomationRoutesCommon = ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("7aDxF")).getSettingsNavigationResources)((0, (0, parcelRequire("7aDxF")).SERVICE_DESK_PRODUCT)),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)
        });
    const $da7bdd95981ae4d9$var$getOldAutomationRouteRedirectRoute = (pageType)=>({
            ...$da7bdd95981ae4d9$var$getLegacyAutomationRoutesCommon(),
            name: `${0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK}-automation-redirect-${pageType}`,
            path: `/projects/:projectKey/settings/automation/${(0, (0, parcelRequire("6g6uF")).oldAutomationPathFragment)(pageType)}`,
            forPaint: [],
            component: (0, (0, parcelRequire("6g6uF")).automationRedirect)(pageType)
        });
    const $da7bdd95981ae4d9$export$8521f0867b2d52e4 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6pIRW")).routeGroupsProjectSettingsServicedeskAutomationEditRuleRoute), ()=>({
                ...$da7bdd95981ae4d9$var$getLegacyAutomationRoutesCommon(),
                ufoName: 'service-management.automation.edit-rule',
                component: (0, (0, parcelRequire("2sKYo")).default),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("2sKYo")).LazyProjectSettingsServiceDeskAutomationEditRule)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6pIRW")).routeGroupsProjectSettingsServicedeskAutomationCopyRuleRoute), ()=>({
                ...$da7bdd95981ae4d9$var$getLegacyAutomationRoutesCommon(),
                ufoName: 'service-management.automation.copy-rule',
                component: (0, (0, parcelRequire("9zLHs")).default),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("9zLHs")).LazyProjectSettingsServiceDeskAutomationCopyRule)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6pIRW")).routeGroupsProjectSettingsServicedeskAutomationCreateRoute), ()=>({
                ...$da7bdd95981ae4d9$var$getLegacyAutomationRoutesCommon(),
                ufoName: 'service-management.automation.create-rule',
                component: (0, (0, parcelRequire("cNpXW")).default),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("cNpXW")).LazyProjectSettingsServiceDeskAutomationCreateRule)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6pIRW")).routeGroupsProjectSettingsServicedeskAutomationViewLogRoute), ()=>({
                ...$da7bdd95981ae4d9$var$getLegacyAutomationRoutesCommon(),
                ufoName: 'service-management.automation.log',
                component: (0, (0, parcelRequire("i7FI3")).default),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("i7FI3")).LazyProjectSettingsServiceDeskAutomationViewLog)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("6pIRW")).routeGroupsProjectSettingsServicedeskAutomationSummaryRoute), ()=>({
                ...$da7bdd95981ae4d9$var$getLegacyAutomationRoutesCommon(),
                ufoName: 'service-management.automation.summary',
                component: (0, (0, parcelRequire("5G6Zw")).default),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("5G6Zw")).LazyProjectSettingsServiceDeskAutomationSummary)
                ]
            })),
        $da7bdd95981ae4d9$var$getOldAutomationRouteRedirectRoute('summary'),
        $da7bdd95981ae4d9$var$getOldAutomationRouteRedirectRoute('create'),
        $da7bdd95981ae4d9$var$getOldAutomationRouteRedirectRoute('edit'),
        $da7bdd95981ae4d9$var$getOldAutomationRouteRedirectRoute('copy'),
        $da7bdd95981ae4d9$var$getOldAutomationRouteRedirectRoute('viewlog')
    ];
});
parcelRegister("6pIRW", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAutomationEditRuleRoute", ()=>$f11e25be7747a3f0$export$c581a12a4f58fa26);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAutomationCopyRuleRoute", ()=>$f11e25be7747a3f0$export$5b3aca7bf312c9a3);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAutomationCreateRoute", ()=>$f11e25be7747a3f0$export$3b8691f4e10340a9);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAutomationViewLogRoute", ()=>$f11e25be7747a3f0$export$e0ddfe5d87fb5601);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskAutomationSummaryRoute", ()=>$f11e25be7747a3f0$export$3e9315c24fe609c3);
    var $65Ltd;
    const $f11e25be7747a3f0$export$5575497f0592ee94 = 'servicedesk';
    const $f11e25be7747a3f0$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $f11e25be7747a3f0$export$c581a12a4f58fa26 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation-edit-rule`,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        path: `${$f11e25be7747a3f0$var$projectSettingsUrl($f11e25be7747a3f0$export$5575497f0592ee94)}/automation/ruleset/:ruleId`
    };
    const $f11e25be7747a3f0$export$5b3aca7bf312c9a3 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation-copy-rule`,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        path: `${$f11e25be7747a3f0$var$projectSettingsUrl($f11e25be7747a3f0$export$5575497f0592ee94)}/automation/copy/:ruleId`
    };
    const $f11e25be7747a3f0$export$3b8691f4e10340a9 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation-create`,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        path: `${$f11e25be7747a3f0$var$projectSettingsUrl($f11e25be7747a3f0$export$5575497f0592ee94)}/automation/blueprint/:blueprintKey`
    };
    const $f11e25be7747a3f0$export$e0ddfe5d87fb5601 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation-view-log`,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        path: `${$f11e25be7747a3f0$var$projectSettingsUrl($f11e25be7747a3f0$export$5575497f0592ee94)}/automation/log/:ruleId`
    };
    const $f11e25be7747a3f0$export$3e9315c24fe609c3 = {
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-automation-summary`,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        path: `${$f11e25be7747a3f0$var$projectSettingsUrl($f11e25be7747a3f0$export$5575497f0592ee94)}/automation`
    };
});
parcelRegister("7aDxF", function(module, exports) {
    $parcel$export(module.exports, "SERVICE_DESK_PRODUCT", ()=>$799409f8e61f9f67$export$5575497f0592ee94);
    $parcel$export(module.exports, "getSettingsNavigationResources", ()=>$799409f8e61f9f67$export$586756e5c0542a50);
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    const $799409f8e61f9f67$export$b7262fe486f4b412 = 'core';
    const $799409f8e61f9f67$export$2954328f6207617a = 'software';
    const $799409f8e61f9f67$export$5575497f0592ee94 = 'servicedesk';
    const $799409f8e61f9f67$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $799409f8e61f9f67$export$586756e5c0542a50 = (product)=>{
        if (product === $799409f8e61f9f67$export$5575497f0592ee94) return (0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)();
        if (product === $799409f8e61f9f67$export$b7262fe486f4b412) return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
        ];
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
    };
});
parcelRegister("9zLHs", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationCopyRule", ()=>$10ca54f4f21ea64a$export$4a3b5f6370555dbc);
    $parcel$export(module.exports, "default", ()=>$10ca54f4f21ea64a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $10ca54f4f21ea64a$export$4a3b5f6370555dbc = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("9oaeI")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-copy-rule/src/index.tsx"
    });
    var $10ca54f4f21ea64a$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $10ca54f4f21ea64a$export$4a3b5f6370555dbc,
            pageId: "project-settings-automation-copy-rule",
            shouldShowSpinner: true
        });
});
parcelRegister("9oaeI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kkgDQ")
    ]).then(()=>parcelRequire('9Qg7T'));
});
parcelRegister("cNpXW", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationCreateRule", ()=>$2a5fc816810cf307$export$5b197b51eb5ad982);
    $parcel$export(module.exports, "default", ()=>$2a5fc816810cf307$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $2a5fc816810cf307$export$5b197b51eb5ad982 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("jN2C0")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-create-rule/src/index.tsx"
    });
    var $2a5fc816810cf307$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2a5fc816810cf307$export$5b197b51eb5ad982,
            pageId: "project-settings-automation-create-rule",
            shouldShowSpinner: true
        });
});
parcelRegister("jN2C0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7C5bc")
    ]).then(()=>parcelRequire('7uVkM'));
});
parcelRegister("2sKYo", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationEditRule", ()=>$0645e13982e9c11f$export$c1c9a68738a9ab36);
    $parcel$export(module.exports, "default", ()=>$0645e13982e9c11f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $0645e13982e9c11f$export$c1c9a68738a9ab36 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("gZF9U")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-edit-rule/src/index.tsx"
    });
    var $0645e13982e9c11f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0645e13982e9c11f$export$c1c9a68738a9ab36,
            pageId: "project-settings-automation-edit-rule",
            shouldShowSpinner: true
        });
});
parcelRegister("gZF9U", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1PFOk")
    ]).then(()=>parcelRequire('44UJy'));
});
parcelRegister("6g6uF", function(module, exports) {
    $parcel$export(module.exports, "oldAutomationPathFragment", ()=>$69d1eaf61634b750$export$39684840f773be1e);
    $parcel$export(module.exports, "automationRedirect", ()=>$69d1eaf61634b750$export$d6674bfa636b8090);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $02Psx;
    var $g5X3G;
    var $dIdda = parcelRequire("dIdda");
    const $69d1eaf61634b750$export$39684840f773be1e = (pageType)=>{
        switch(pageType){
            case 'edit':
                return 'ruleset/:ruleId';
            case 'copy':
                return 'copy/:ruleId';
            case 'create':
                return 'blueprint/:blueprintKey';
            case 'viewlog':
                return 'log/:ruleId';
            default:
                return '';
        }
    };
    const $69d1eaf61634b750$var$newAutomationUrl = (baseUrl, { match: match }, pageType)=>{
        const { projectKey: projectKey } = match.params;
        if (pageType === 'edit') {
            const { ruleId: ruleId } = match.params;
            return `${(0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), String(projectKey))}/automation/ruleset/${ruleId || ''}`;
        }
        if (pageType === 'copy') {
            const { ruleId: ruleId } = match.params;
            return `${(0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), String(projectKey))}/automation/copy/${ruleId || ''}`;
        }
        if (pageType === 'viewlog') {
            const { ruleId: ruleId } = match.params;
            return `${(0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), String(projectKey))}/automation/log/${ruleId || ''}`;
        }
        if (pageType === 'create') {
            const { blueprintKey: blueprintKey } = match.params;
            return `${(0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), String(projectKey))}/automation/blueprint/${blueprintKey || ''}`;
        }
        return `${(0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), String(projectKey))}/automation`;
    };
    const $69d1eaf61634b750$export$d6674bfa636b8090 = (pageType)=>(routeContext)=>{
            const emptyBaseUrl = (0, (0, parcelRequire("g5X3G")).toBaseUrl)('');
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: $69d1eaf61634b750$var$newAutomationUrl(emptyBaseUrl, routeContext, pageType),
                push: false
            });
        };
});
parcelRegister("5G6Zw", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationSummary", ()=>$8a03171b9122a104$export$2fc8c3fcbb365b89);
    $parcel$export(module.exports, "default", ()=>$8a03171b9122a104$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $8a03171b9122a104$export$2fc8c3fcbb365b89 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("eer4p")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-summary/src/index.tsx"
    });
    var $8a03171b9122a104$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8a03171b9122a104$export$2fc8c3fcbb365b89,
            pageId: "project-settings-automation-summary",
            shouldShowSpinner: true
        });
});
parcelRegister("eer4p", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9udti")
    ]).then(()=>parcelRequire('6kXBX'));
});
parcelRegister("i7FI3", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskAutomationViewLog", ()=>$6f8757b068912193$export$db6c5cdbc65b2b4a);
    $parcel$export(module.exports, "default", ()=>$6f8757b068912193$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $6f8757b068912193$export$db6c5cdbc65b2b4a = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("7zSGd")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-automation-view-log/src/index.tsx"
    });
    var $6f8757b068912193$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6f8757b068912193$export$db6c5cdbc65b2b4a,
            pageId: "project-settings-automation-view-log",
            shouldShowSpinner: true
        });
});
parcelRegister("7zSGd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hKaWl")
    ]).then(()=>parcelRequire('5jbPW'));
});
parcelRegister("dIqTX", function(module, exports) {
    $parcel$export(module.exports, "customerNotificationsSettingsRouteEntries", ()=>$6cda2c2384bf3147$export$d6bb339f4d05f5c5);
    var $ffza4;
    var $cSD7y;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $bOhA4;
    var $6Z2mh;
    var $425fT;
    var $hASB6;
    var $kFrbC;
    const $6cda2c2384bf3147$export$d6bb339f4d05f5c5 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bOhA4")).routeGroupsProjectSettingsServicedeskCustomerNotificationsRoute), ()=>({
                component: (0, (0, parcelRequire("hASB6")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("425fT")).getSettingsNavigationResources)((0, (0, parcelRequire("425fT")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("hASB6")).LazyProjectSettingsServiceDeskCustomerNotifications)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("bOhA4")).routeGroupsProjectSettingsServicedeskNotificationsCustomerNotificationsRoute), ()=>({
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('update_jsm_project_settings_pages_urls', (0, (0, parcelRequire("kFrbC")).ServiceDeskCustomerNotificationsNextGenRedirect), (0, (0, parcelRequire("hASB6")).default)),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("425fT")).getSettingsNavigationResources)((0, (0, parcelRequire("425fT")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("hASB6")).LazyProjectSettingsServiceDeskCustomerNotifications)
                ]
            }))
    ];
});
parcelRegister("425fT", function(module, exports) {
    $parcel$export(module.exports, "SERVICE_DESK_PRODUCT", ()=>$b4e8a3bb22e234a5$export$5575497f0592ee94);
    $parcel$export(module.exports, "getSettingsNavigationResources", ()=>$b4e8a3bb22e234a5$export$586756e5c0542a50);
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    const $b4e8a3bb22e234a5$export$b7262fe486f4b412 = 'core';
    const $b4e8a3bb22e234a5$export$2954328f6207617a = 'software';
    const $b4e8a3bb22e234a5$export$5575497f0592ee94 = 'servicedesk';
    const $b4e8a3bb22e234a5$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $b4e8a3bb22e234a5$export$586756e5c0542a50 = (product)=>{
        if (product === $b4e8a3bb22e234a5$export$5575497f0592ee94) return (0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)();
        if (product === $b4e8a3bb22e234a5$export$b7262fe486f4b412) return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
        ];
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
    };
});
parcelRegister("hASB6", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskCustomerNotifications", ()=>$6081b8204512e323$export$c763ea321ade5f68);
    $parcel$export(module.exports, "default", ()=>$6081b8204512e323$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kKHTt;
    var $5j7Th;
    var $hPtZI;
    const $6081b8204512e323$export$c763ea321ade5f68 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("4fGkE")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-customer-notifications/src/index.tsx"
    });
    var $6081b8204512e323$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kKHTt")).HelpCenterSettingsRedirect), {
            page: "customer-notifications"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6081b8204512e323$export$c763ea321ade5f68,
            pageId: "project-settings-customer-notifications",
            shouldShowSpinner: true
        }));
});
parcelRegister("kKHTt", function(module, exports) {
    $parcel$export(module.exports, "HelpCenterSettingsRedirect", ()=>$ebd0dfae741c0d7b$export$a24ec33acfeae48d);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $95EVP;
    var $7OYJs;
    var $dIdda = parcelRequire("dIdda");
    var $8WSu7;
    var $aTz47;
    var $jEJ7g;
    const $ebd0dfae741c0d7b$export$c224e724e933fbea = (page, pathname)=>{
        if (page === 'customer-notifications') {
            const customerNotificationsPage = pathname.split('/settings/customer-notifications')[1];
            if (customerNotificationsPage === '/template') return 'customer-notifications-template';
            if (customerNotificationsPage === '/account-notification/invite-customer') return 'customer-notifications-invite-customer';
            if (/rule\/\d+/.test(customerNotificationsPage)) return 'customer-notifications-rule';
        }
        return page;
    };
    const $ebd0dfae741c0d7b$export$2d1034e371a567c6 = (page, pathname)=>{
        switch(page){
            case 'kb':
                return (0, (0, parcelRequire("8WSu7")).getSettingsPath)(pathname.replace('/confluence-kb', '/kb'), true);
            default:
                return (0, (0, parcelRequire("8WSu7")).getSettingsPath)(pathname, true);
        }
    };
    const $ebd0dfae741c0d7b$export$a24ec33acfeae48d = ({ page: page, children: children })=>{
        const [{ location: location }] = (0, $dIdda.useRouter)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        const isJCS = (0, (0, parcelRequire("jEJ7g")).useIsJCS)();
        (0, $5uXOq.useEffect)(()=>{
            if (isJCS && !(0, (0, parcelRequire("aTz47")).isHelpCenterSettingsPath)()) (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'projectSettingsToHelpCenterSettings redirected', {
                page: $ebd0dfae741c0d7b$export$c224e724e933fbea(page, location.pathname)
            });
        }, [
            createAnalyticsEvent,
            isJCS,
            location.pathname,
            page
        ]);
        if (isJCS && !(0, (0, parcelRequire("aTz47")).isHelpCenterSettingsPath)()) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7OYJs")).ScreenRedirect), {
            to: $ebd0dfae741c0d7b$export$2d1034e371a567c6(page, location.pathname),
            persistSearchParams: true
        });
        return children;
    };
});
parcelRegister("8WSu7", function(module, exports) {
    $parcel$export(module.exports, "getSettingsPath", ()=>$b4b4e7a1fd793539$export$67417cd3aaee582d);
    const $b4b4e7a1fd793539$export$67417cd3aaee582d = (path, isJCS)=>isJCS ? path.replace('/jira/servicedesk/', '/jira/helpcenter/') : path;
});
parcelRegister("aTz47", function(module, exports) {
    $parcel$export(module.exports, "isHelpCenterSettingsPath", ()=>$1e0d45f36b27f85a$export$bf8b98b87d485657);
    var $4R6GH;
    const $1e0d45f36b27f85a$export$bf8b98b87d485657 = ()=>{
        if (!(0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag')) return false;
        if (!false) return window.location.pathname.includes('jira/helpcenter/');
        return false;
    };
});
parcelRegister("jEJ7g", function(module, exports) {
    $parcel$export(module.exports, "useIsJCS", ()=>$db67bf04078e8532$export$927b5354181b3adf);
    $parcel$export(module.exports, "useAsyncIsJCS", ()=>$db67bf04078e8532$export$3894a8f24b665478);
    $parcel$export(module.exports, "isJCSTemplate", ()=>$db67bf04078e8532$export$afee907b7a66ef2b);
    var $e5wyW;
    var $4R6GH;
    var $O4MMs;
    const $db67bf04078e8532$var$useIsJCSUnderFF = ()=>{
        const { 'initial.project.template.name': initialProjectTemplate } = (0, (0, parcelRequire("O4MMs")).useProjectProperties)([
            'initial.project.template.name'
        ]);
        return initialProjectTemplate === 'com.atlassian.jcs:customer-service-management';
    };
    const $db67bf04078e8532$export$927b5354181b3adf = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag'), $db67bf04078e8532$var$useIsJCSUnderFF, ()=>false);
    const $db67bf04078e8532$var$useAsyncIsJCSUnderFF = ()=>{
        const { 'initial.project.template.name': initialProjectTemplate } = (0, (0, parcelRequire("O4MMs")).useProjectProperties)([
            'initial.project.template.name'
        ]);
        return initialProjectTemplate ? initialProjectTemplate === 'com.atlassian.jcs:customer-service-management' : undefined;
    };
    const $db67bf04078e8532$export$3894a8f24b665478 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag'), $db67bf04078e8532$var$useAsyncIsJCSUnderFF, ()=>false);
    const $db67bf04078e8532$var$isJCSTemplateUnderFF = (template)=>template === 'com.atlassian.jcs:customer-service-management';
    const $db67bf04078e8532$var$isJCSTemplateFallback = (template)=>false;
    const $db67bf04078e8532$export$afee907b7a66ef2b = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jcs_master_flag'), $db67bf04078e8532$var$isJCSTemplateUnderFF, $db67bf04078e8532$var$isJCSTemplateFallback);
});
parcelRegister("O4MMs", function(module, exports) {
    $parcel$export(module.exports, "useProjectProperties", ()=>$eccdf8f1b49d4032$export$58be98885c2d686a);
    var $5uXOq = parcelRequire("5uXOq");
    var $74ySO = parcelRequire("74ySO");
    var $ajpes = parcelRequire("ajpes");
    var $4f8Oj = parcelRequire("4f8Oj");
    var $lpwtK;
    var $1XJ20;
    var $8zOmE;
    var $95EVP;
    var $7JoAD = parcelRequire("7JoAD");
    var $dYZ0w;
    const $eccdf8f1b49d4032$export$d4c72bab9d6cc13a = {};
    const $eccdf8f1b49d4032$var$Store = (0, $7JoAD.createStore)({
        name: 'project-properties',
        initialState: $eccdf8f1b49d4032$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("dYZ0w")).actions
    });
    const $eccdf8f1b49d4032$export$eebf791068e870dd = (0, $7JoAD.createHook)($eccdf8f1b49d4032$var$Store);
    const $eccdf8f1b49d4032$export$58be98885c2d686a = (propertyKeys, projectIdOverride)=>{
        const { data: data } = (0, (0, parcelRequire("lpwtK")).useProject)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("95EVP")).useAnalyticsEvents)();
        const projectId = projectIdOverride !== undefined ? projectIdOverride : data?.id && `${data.id}`;
        const [state, { get: get }] = $eccdf8f1b49d4032$export$eebf791068e870dd();
        const prevPropertyKeys = (0, (0, parcelRequire("1XJ20")).usePrevious)(propertyKeys);
        (0, $5uXOq.useEffect)(()=>{
            if (projectId === undefined) (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraProjectPropertiesServices undefinedProjectId');
            if ((0, ($parcel$interopDefault($ajpes)))(propertyKeys, prevPropertyKeys) && !projectIdOverride) return;
            if (projectId) get(projectId, propertyKeys);
        }, [
            projectId,
            propertyKeys,
            prevPropertyKeys,
            get,
            createAnalyticsEvent,
            projectIdOverride
        ]);
        return projectId !== undefined ? (0, ($parcel$interopDefault($4f8Oj)))(state[projectId], (_, key)=>(0, ($parcel$interopDefault($74ySO)))(propertyKeys, key)) : {};
    };
});
parcelRegister("74ySO", function(module, exports) {
    var $2wwA6 = parcelRequire("2wwA6");
    var $hTJwX = parcelRequire("hTJwX");
    var $agVdz = parcelRequire("agVdz");
    var $kPZpS = parcelRequire("kPZpS");
    var $dMEgP = parcelRequire("dMEgP");
    var $5263f72d78aeaf9c$var$nativeMax = Math.max;
    function $5263f72d78aeaf9c$var$includes(collection, value, fromIndex, guard) {
        collection = $hTJwX(collection) ? collection : $dMEgP(collection);
        fromIndex = fromIndex && !guard ? $kPZpS(fromIndex) : 0;
        var length = collection.length;
        if (fromIndex < 0) fromIndex = $5263f72d78aeaf9c$var$nativeMax(length + fromIndex, 0);
        return $agVdz(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $2wwA6(collection, value, fromIndex) > -1;
    }
    module.exports = $5263f72d78aeaf9c$var$includes;
});
parcelRegister("agVdz", function(module, exports) {
    var $beQoo = parcelRequire("beQoo");
    var $8LQ84 = parcelRequire("8LQ84");
    var $fC1Kz = parcelRequire("fC1Kz");
    var $77a7c84c5ee0b808$var$stringTag = '[object String]';
    function $77a7c84c5ee0b808$var$isString(value) {
        return typeof value == 'string' || !$8LQ84(value) && $fC1Kz(value) && $beQoo(value) == $77a7c84c5ee0b808$var$stringTag;
    }
    module.exports = $77a7c84c5ee0b808$var$isString;
});
parcelRegister("dYZ0w", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$d36e01b4b5883936$export$e324594224ef24da);
    var $9Tr6m;
    const $d36e01b4b5883936$export$e324594224ef24da = {
        get: (0, parcelRequire("9Tr6m")).get
    };
});
parcelRegister("9Tr6m", function(module, exports) {
    $parcel$export(module.exports, "get", ()=>$52dc90cc0afc52f4$export$3988ae62b71be9a3);
    var $k8IPx = parcelRequire("k8IPx");
    var $cjFoH = parcelRequire("cjFoH");
    var $66FNL = parcelRequire("66FNL");
    var $fUPWG;
    const $52dc90cc0afc52f4$export$3988ae62b71be9a3 = (projectId, properties)=>({ getState: getState, setState: setState })=>{
            const currentProperties = getState()[projectId] || {};
            const missingProperties = (0, ($parcel$interopDefault($k8IPx)))(properties, (0, ($parcel$interopDefault($66FNL)))(currentProperties));
            missingProperties.length && (0, (0, parcelRequire("fUPWG")).default)({
                baseUrl: '',
                projectId: projectId,
                properties: missingProperties
            }).then((fetchedProperties)=>{
                const latestProperties = getState()[projectId] || {};
                setState({
                    [projectId]: {
                        ...latestProperties,
                        ...missingProperties.reduce((result, name)=>{
                            const reducedResult = result;
                            const fetchedProperty = fetchedProperties[name];
                            reducedResult[name] = (0, ($parcel$interopDefault($cjFoH)))(fetchedProperty) ? null : fetchedProperty;
                            return reducedResult;
                        }, {})
                    }
                });
            });
        };
});
parcelRegister("k8IPx", function(module, exports) {
    var $55pzo = parcelRequire("55pzo");
    var $ekcP3 = parcelRequire("ekcP3");
    var $g7i7g = parcelRequire("g7i7g");
    var $f3SOL = parcelRequire("f3SOL");
    var $ea975459f1938a58$var$difference = $g7i7g(function(array, values) {
        return $f3SOL(array) ? $55pzo(array, $ekcP3(values, 1, $f3SOL, true)) : [];
    });
    module.exports = $ea975459f1938a58$var$difference;
});
parcelRegister("55pzo", function(module, exports) {
    var $ijRUK = parcelRequire("ijRUK");
    var $fUP98 = parcelRequire("fUP98");
    var $dA3tP = parcelRequire("dA3tP");
    var $1nIHN = parcelRequire("1nIHN");
    var $cW28x = parcelRequire("cW28x");
    var $40I25 = parcelRequire("40I25");
    var $3b41410a547f22d2$var$LARGE_ARRAY_SIZE = 200;
    function $3b41410a547f22d2$var$baseDifference(array, values, iteratee, comparator) {
        var index = -1, includes = $fUP98, isCommon = true, length = array.length, result = [], valuesLength = values.length;
        if (!length) return result;
        if (iteratee) values = $1nIHN(values, $cW28x(iteratee));
        if (comparator) {
            includes = $dA3tP;
            isCommon = false;
        } else if (values.length >= $3b41410a547f22d2$var$LARGE_ARRAY_SIZE) {
            includes = $40I25;
            isCommon = false;
            values = new $ijRUK(values);
        }
        outer: while(++index < length){
            var value = array[index], computed = iteratee == null ? value : iteratee(value);
            value = comparator || value !== 0 ? value : 0;
            if (isCommon && computed === computed) {
                var valuesIndex = valuesLength;
                while(valuesIndex--){
                    if (values[valuesIndex] === computed) continue outer;
                }
                result.push(value);
            } else if (!includes(values, computed, comparator)) result.push(value);
        }
        return result;
    }
    module.exports = $3b41410a547f22d2$var$baseDifference;
});
parcelRegister("fUPWG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$573d8b462e0e2ec6$export$2e2bcd8739ae039);
    var $1sYcL;
    var $573d8b462e0e2ec6$export$2e2bcd8739ae039 = async ({ baseUrl: baseUrl, projectId: projectId, properties: properties })=>{
        const { project: project } = await (0, (0, parcelRequire("1sYcL")).get)(baseUrl, {
            projectId: projectId,
            projectProperties: properties,
            consumerMeta: {
                id: 'remoteGet',
                packageName: 'jiraProjectPropertiesServices',
                teamName: 'jsd-shield'
            }
        });
        return project;
    };
});
parcelRegister("4fGkE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("lxzGu")
    ]).then(()=>parcelRequire('jp5Rx'));
});
parcelRegister("kFrbC", function(module, exports) {
    $parcel$export(module.exports, "ServiceDeskCustomerNotificationsNextGenRedirect", ()=>$aa137e884608085b$export$8249a46a710af6da);
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    const $aa137e884608085b$export$8249a46a710af6da = ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/customer-notifications`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: url
        });
    };
});
parcelRegister("dDDPP", function(module, exports) {
    $parcel$export(module.exports, "journeysRouteEntries", ()=>$6ffe646ddf6221b0$export$5dfc85c70e03c102);
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $fpjJX;
    var $3Yq3S;
    var $6Z2mh;
    var $8LFLY;
    var $g2OFQ;
    const $6ffe646ddf6221b0$export$5dfc85c70e03c102 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("3Yq3S")).routeGroupsProjectSettingsServicedeskJourneysRoute), ()=>({
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)()
                ],
                entryPoint: ()=>(0, (0, parcelRequire("g2OFQ")).journeysPageEntryPoint)
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("3Yq3S")).routeGroupsProjectSettingsServicedeskJourneyConfigurationRoute), ()=>({
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)()
                ],
                entryPoint: ()=>(0, (0, parcelRequire("8LFLY")).journeyConfigPageEntryPoint)
            }))
    ];
});
parcelRegister("3Yq3S", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskJourneysRoute", ()=>$a2dea3b6266893e0$export$94adf8e91b84b806);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskJourneyConfigurationRoute", ()=>$a2dea3b6266893e0$export$c0d493d5e7c848d0);
    var $65Ltd;
    const $a2dea3b6266893e0$export$94adf8e91b84b806 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-journeys`,
        path: '/jira/servicedesk/projects/:projectKey/settings/journeys',
        exact: true
    };
    const $a2dea3b6266893e0$export$c0d493d5e7c848d0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-journey-configuration`,
        path: '/jira/servicedesk/projects/:projectKey/settings/journeys/:journeyId',
        exact: true
    };
});
parcelRegister("8LFLY", function(module, exports) {
    $parcel$export(module.exports, "journeyConfigPageEntryPoint", ()=>$e2e16678033c3122$export$35537410b0bf07ea);
    var $lkFvK;
    var $lmyls;
    var $3HGnZ;
    const $e2e16678033c3122$export$35537410b0bf07ea = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("3HGnZ")).journeyConfigEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
});
parcelRegister("3HGnZ", function(module, exports) {
    $parcel$export(module.exports, "journeyConfigEntryPoint", ()=>$1dfcd84f3f61c84b$export$26f82de7820f0c3);
    var $lyoHt;
    var $2Ftxm;
    var $ikgNX;
    const $1dfcd84f3f61c84b$export$26f82de7820f0c3 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("gw7Fm")), {
            moduleId: "6bffb775",
            moduleName: "JourneyConfigurationPage"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    jiraJourneyConfiguration: {
                        parameters: (0, parcelRequire("lyoHt")).default,
                        variables: {
                            cloudId: tenantContext.cloudId,
                            journeyId: context.match.params.journeyId ?? ''
                        }
                    }
                },
                entryPoints: {},
                extraProps: {}
            })
    });
});
parcelRegister("lyoHt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c24657e8d4ddd13$export$2e2bcd8739ae039);
    const $5c24657e8d4ddd13$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "fad9602cc939abe026957eedfb3768d995afeda6dc5cbfbcc894fd0a905f9013",
            "metadata": {},
            "name": "JourneyConfigurationPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $5c24657e8d4ddd13$export$2e2bcd8739ae039 = $5c24657e8d4ddd13$var$node;
});
parcelRegister("gw7Fm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iUjK0")
    ]).then(()=>parcelRequire('aG5pa'));
});
parcelRegister("g2OFQ", function(module, exports) {
    $parcel$export(module.exports, "journeysPageEntryPoint", ()=>$afecb2c38eb0ad75$export$3b90f0eb27bdd52f);
    var $lkFvK;
    var $lmyls;
    var $bbmu4;
    const $afecb2c38eb0ad75$export$3b90f0eb27bdd52f = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("bbmu4")).journeysEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
});
parcelRegister("bbmu4", function(module, exports) {
    $parcel$export(module.exports, "journeysEntryPoint", ()=>$1cbf56bd5b792bd0$export$4ded7f93dbe6eb63);
    var $8FYy8;
    var $2Ftxm;
    var $ikgNX;
    const $1cbf56bd5b792bd0$export$4ded7f93dbe6eb63 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("aUjwY")), {
            moduleId: "ab11e2ef",
            moduleName: "JourneysPage"
        }),
        getPreloadProps: ({ tenantContext: tenantContext })=>({
                queries: {
                    journeysPageQueryRef: {
                        parameters: (0, parcelRequire("8FYy8")).default,
                        variables: {
                            cloudId: tenantContext.cloudId
                        },
                        options: {
                            fetchPolicy: 'store-and-network'
                        }
                    }
                },
                entryPoints: {},
                extraProps: {}
            })
    });
});
parcelRegister("8FYy8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0dab8bc029613fb5$export$2e2bcd8739ae039);
    const $0dab8bc029613fb5$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "01d7368c8332fa867381fbc1eea031a9ef14755e419494004bebb62080c64710",
            "metadata": {},
            "name": "JourneysPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $0dab8bc029613fb5$export$2e2bcd8739ae039 = $0dab8bc029613fb5$var$node;
});
parcelRegister("aUjwY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("g2xfa")
    ]).then(()=>parcelRequire('iSwlg'));
});
parcelRegister("1Mp6D", function(module, exports) {
    $parcel$export(module.exports, "knowledgeSettingsRouteEntries", ()=>$62c3d1c204167743$export$f90c0f16cffd8883);
    var $ffza4;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $2nb5R;
    var $6Z2mh;
    var $7PBJj;
    var $gw09t;
    const $62c3d1c204167743$export$f90c0f16cffd8883 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2nb5R")).routeGroupsProjectSettingsServicedeskKbRoute), ()=>({
                perfMetricKey: 'service-management.kb-settings',
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                component: (0, (0, parcelRequire("gw09t")).ServiceDeskKnowledgeBaseV2),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("gw09t")).LazyProjectSettingsServiceDeskKnowledgeBaseV2)
                ],
                resources: [
                    ...(0, (0, parcelRequire("7PBJj")).getSettingsNavigationResources)((0, (0, parcelRequire("7PBJj")).SERVICE_DESK_PRODUCT)),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ]
            }))
    ];
});
parcelRegister("7PBJj", function(module, exports) {
    $parcel$export(module.exports, "SERVICE_DESK_PRODUCT", ()=>$2275cc324bd22d3c$export$5575497f0592ee94);
    $parcel$export(module.exports, "getSettingsNavigationResources", ()=>$2275cc324bd22d3c$export$586756e5c0542a50);
    var $5bkvv;
    var $8uKLe;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    const $2275cc324bd22d3c$export$b7262fe486f4b412 = 'core';
    const $2275cc324bd22d3c$export$2954328f6207617a = 'software';
    const $2275cc324bd22d3c$export$5575497f0592ee94 = 'servicedesk';
    const $2275cc324bd22d3c$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $2275cc324bd22d3c$export$586756e5c0542a50 = (product)=>{
        if (product === $2275cc324bd22d3c$export$5575497f0592ee94) return (0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)();
        if (product === $2275cc324bd22d3c$export$b7262fe486f4b412) return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
        ];
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            (0, (0, parcelRequire("8uKLe")).staticSoftwareProjectHorizontalNavResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
    };
});
parcelRegister("gw09t", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskKnowledgeBaseV2", ()=>$0bf88a8d63415148$export$7c7186fdd8c56428);
    $parcel$export(module.exports, "ServiceDeskKnowledgeBaseV2", ()=>$0bf88a8d63415148$export$6d92735e249274bb);
    var $5uXOq = parcelRequire("5uXOq");
    var $kKHTt;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $0bf88a8d63415148$export$3fac45fa34d00981 = 'project/service-desk/settings/index';
    const $0bf88a8d63415148$export$1aa47348ef6dbdda = 'project/service-desk/settings';
    const $0bf88a8d63415148$export$583a442626bd3345 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("8G8Xo")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-knowledge-base/src/index.tsx"
    });
    const $0bf88a8d63415148$export$7c7186fdd8c56428 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("ippoi"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-settings/src/index.tsx"
    });
    const $0bf88a8d63415148$export$6d92735e249274bb = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kKHTt")).HelpCenterSettingsRedirect), {
            page: "kb"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0bf88a8d63415148$export$7c7186fdd8c56428,
            pageId: "project-settings-knowledge-base",
            shouldShowSpinner: true
        }));
    var $0bf88a8d63415148$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0bf88a8d63415148$export$583a442626bd3345,
            pageId: "project-settings-knowledge-base",
            shouldShowSpinner: true
        });
});
parcelRegister("8G8Xo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("84U6s").then(()=>parcelRequire('2fak7'));
});
parcelRegister("ippoi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("2IJUz")
    ]).then(()=>parcelRequire('gCbsh'));
});
parcelRegister("d2Ahj", function(module, exports) {
    $parcel$export(module.exports, "slaSettingsRouteEntries", ()=>$e00888b39cabebc3$export$fd1a58e6255623a);
    var $ffza4;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $dxCvy;
    var $4wBwP;
    var $040pa;
    var $6Z2mh;
    var $e9YVH;
    var $58sBT;
    var $1CEnL;
    const $e00888b39cabebc3$export$fd1a58e6255623a = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("040pa")).servicedeskSlaSettingsRoute), ()=>({
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).SLA_SETTINGS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).SLA_SETTINGS),
                        teamName: 'bumblebee'
                    }
                },
                perfMetricKey: 'jsm-sla-settings',
                component: (0, (0, parcelRequire("1CEnL")).ServiceDeskSlaSettings),
                resources: [
                    ...(0, (0, parcelRequire("58sBT")).getSettingsNavigationResources)((0, (0, parcelRequire("58sBT")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("4wBwP")).slaMetricsDataResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("1CEnL")).LazyProjectSettingsServiceDeskSlaSettings)
                ]
            }))
    ];
});
parcelRegister("4wBwP", function(module, exports) {
    $parcel$export(module.exports, "slaMetricsDataResource", ()=>$5bd842d236781a2e$export$6cdfca3e816e9661);
    var $dIdda = parcelRequire("dIdda");
    const $5bd842d236781a2e$export$c5fa03c9ad8df0e2 = 'SLA_METRICS';
    const $5bd842d236781a2e$export$6cdfca3e816e9661 = (0, $dIdda.createResource)({
        type: $5bd842d236781a2e$export$c5fa03c9ad8df0e2,
        getKey: ({ match: match })=>match.params.projectKey || '',
        getDataLoader: ()=>(parcelRequire("c7Qcd")),
        maxAge: Infinity
    });
});
parcelRegister("c7Qcd", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("g759n").then(()=>parcelRequire('dxWU3'));
});
parcelRegister("58sBT", function(module, exports) {
    $parcel$export(module.exports, "SERVICE_DESK_PRODUCT", ()=>$43aedf68164f3e5b$export$5575497f0592ee94);
    $parcel$export(module.exports, "getSettingsNavigationResources", ()=>$43aedf68164f3e5b$export$586756e5c0542a50);
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    const $43aedf68164f3e5b$export$b7262fe486f4b412 = 'core';
    const $43aedf68164f3e5b$export$2954328f6207617a = 'software';
    const $43aedf68164f3e5b$export$5575497f0592ee94 = 'servicedesk';
    const $43aedf68164f3e5b$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $43aedf68164f3e5b$export$586756e5c0542a50 = (product)=>{
        if (product === $43aedf68164f3e5b$export$5575497f0592ee94) return (0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)();
        if (product === $43aedf68164f3e5b$export$b7262fe486f4b412) return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
        ];
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
    };
});
parcelRegister("1CEnL", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskSlaSettings", ()=>$45b508c287c9b763$export$a6694c07cb5be8c1);
    $parcel$export(module.exports, "ServiceDeskSlaSettings", ()=>$45b508c287c9b763$export$c56fde3803c5a1a3);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $l8ruj;
    var $hPtZI;
    const $45b508c287c9b763$export$a6694c07cb5be8c1 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("h3FVt"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-sla-settings/src/index.tsx"
    });
    const $45b508c287c9b763$export$c56fde3803c5a1a3 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "project-settings-service-desk-sla-settings"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $45b508c287c9b763$export$a6694c07cb5be8c1,
            pageId: "project-settings-service-desk-sla-settings",
            shouldShowSpinner: true
        }));
});
parcelRegister("h3FVt", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("gUg0Z")
    ]).then(()=>parcelRequire('1rjw0'));
});
parcelRegister("6SYRe", function(module, exports) {
    $parcel$export(module.exports, "ticketTypeFieldsRouteEntries", ()=>$26c11c644324b9a1$export$caa50198aadcf21c);
    var $ffza4;
    var $65Ltd;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $eUvlM;
    var $9tsFE;
    var $6Z2mh;
    var $e9YVH;
    var $9lqH7;
    var $bO6K2;
    const $26c11c644324b9a1$var$getTicketTypeFieldsRoutesCommon = ()=>({
            group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
            component: (0, (0, parcelRequire("bO6K2")).default),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...(0, (0, parcelRequire("9lqH7")).getSettingsNavigationResources)((0, (0, parcelRequire("9lqH7")).SERVICE_DESK_PRODUCT)),
                (0, (0, parcelRequire("eUvlM")).servicedeskPracticesResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("bO6K2")).LazyProjectSettingsServiceDeskTicketTypeFields)
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).REQUEST_TYPE_FIELDS,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).REQUEST_TYPE_FIELDS),
                    teamName: 'jsd-shield'
                }
            },
            ufoName: `${0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK}-ticket-type-fields`
        });
    const $26c11c644324b9a1$export$caa50198aadcf21c = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9tsFE")).routeGroupsProjectSettingsServicedeskUnassignedTicketTypeFieldsRoute), ()=>({
                ...$26c11c644324b9a1$var$getTicketTypeFieldsRoutesCommon(),
                component: (0, (0, parcelRequire("bO6K2")).default)
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9tsFE")).routeGroupsProjectSettingsServicedeskItsmTicketTypeFieldsRoute), ()=>({
                ...$26c11c644324b9a1$var$getTicketTypeFieldsRoutesCommon()
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9tsFE")).routeGroupsProjectSettingsServicedeskTicketTypeFieldsRoute), ()=>({
                ...$26c11c644324b9a1$var$getTicketTypeFieldsRoutesCommon()
            }))
    ];
});
parcelRegister("9tsFE", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskUnassignedTicketTypeFieldsRoute", ()=>$128fa6baf87c0ab7$export$eeb615fb989a6e4d);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskItsmTicketTypeFieldsRoute", ()=>$128fa6baf87c0ab7$export$50e6baca5c1f7a5b);
    $parcel$export(module.exports, "routeGroupsProjectSettingsServicedeskTicketTypeFieldsRoute", ()=>$128fa6baf87c0ab7$export$51c2cd63e9954ab7);
    var $65Ltd;
    const $128fa6baf87c0ab7$export$5575497f0592ee94 = 'servicedesk';
    const $128fa6baf87c0ab7$export$eeb615fb989a6e4d = {
        exact: true,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-unassigned-ticket-type-fields`,
        path: `/jira/${$128fa6baf87c0ab7$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/unassigned/request-type/:requestTypeId/:tabKey?`
    };
    const $128fa6baf87c0ab7$export$50e6baca5c1f7a5b = {
        exact: true,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-itsm-ticket-type-fields`,
        path: `/jira/${$128fa6baf87c0ab7$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/category/:practice/request-type/:requestTypeId/:tabKey?`
    };
    const $128fa6baf87c0ab7$export$51c2cd63e9954ab7 = {
        exact: true,
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-ticket-type-fields`,
        path: `/jira/${$128fa6baf87c0ab7$export$5575497f0592ee94}/projects/:projectKey/settings/request-types/request-type/:requestTypeId/:tabKey?`
    };
});
parcelRegister("9lqH7", function(module, exports) {
    $parcel$export(module.exports, "SERVICE_DESK_PRODUCT", ()=>$94cdffc93223c5bd$export$5575497f0592ee94);
    $parcel$export(module.exports, "getSettingsNavigationResources", ()=>$94cdffc93223c5bd$export$586756e5c0542a50);
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    const $94cdffc93223c5bd$export$b7262fe486f4b412 = 'core';
    const $94cdffc93223c5bd$export$2954328f6207617a = 'software';
    const $94cdffc93223c5bd$export$5575497f0592ee94 = 'servicedesk';
    const $94cdffc93223c5bd$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $94cdffc93223c5bd$export$586756e5c0542a50 = (product)=>{
        if (product === $94cdffc93223c5bd$export$5575497f0592ee94) return (0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)();
        if (product === $94cdffc93223c5bd$export$b7262fe486f4b412) return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
        ];
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
    };
});
parcelRegister("bO6K2", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskTicketTypeFields", ()=>$e9f2572a89172526$export$471040ce01e559fc);
    $parcel$export(module.exports, "default", ()=>$e9f2572a89172526$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kKHTt;
    var $5j7Th;
    var $hPtZI;
    const $e9f2572a89172526$export$471040ce01e559fc = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("9isaY")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-ticket-type-fields/src/index.tsx"
    });
    var $e9f2572a89172526$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kKHTt")).HelpCenterSettingsRedirect), {
            page: "ticket-type-fields"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e9f2572a89172526$export$471040ce01e559fc,
            pageId: "project-settings-ticket-type-fields",
            shouldShowSpinner: true
        }));
});
parcelRegister("9isaY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("9pCQy")
    ]).then(()=>parcelRequire('73hU9'));
});
parcelRegister("hbKGe", function(module, exports) {
    $parcel$export(module.exports, "ticketTypesConfigRouteEntries", ()=>$7e5adb0871ecbbba$export$fa9d0db1668a0662);
    var $ffza4;
    var $co1wz;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $2pT4g;
    var $dxCvy;
    var $k8jl5;
    var $1cpsA;
    var $eUvlM;
    var $gNStA;
    var $YXuQ6;
    var $6Z2mh;
    var $e9YVH;
    var $fiVsS;
    var $4stgq;
    const $7e5adb0871ecbbba$var$commonTicketTypesConfigRouteEntry = {
        component: (0, (0, parcelRequire("4stgq")).default),
        layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
        navigation: {
            menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
            sidebar: (0, (0, parcelRequire("h0bZU")).default),
            sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
        },
        resources: [
            ...(0, (0, parcelRequire("fiVsS")).getSettingsNavigationResources)((0, (0, parcelRequire("fiVsS")).SERVICE_DESK_PRODUCT)),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("eUvlM")).servicedeskPracticesResource),
            (0, (0, parcelRequire("k8jl5")).servicedeskIssueTypesResource),
            (0, (0, parcelRequire("1cpsA")).servicedeskPortalGroupsResource),
            (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
            (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('enable_jsm_repackaging_changes_vtwk9'), (0, (0, parcelRequire("2pT4g")).jsmRepackagingBannerResource))
        ],
        forPaint: [
            (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
            (0, (0, parcelRequire("4stgq")).LazyProjectSettingsServiceDeskTicketTypesConfig)
        ],
        meta: {
            reporting: {
                id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).REQUEST_TYPES_CONFIG,
                packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).REQUEST_TYPES_CONFIG),
                teamName: 'jsd-shield'
            }
        },
        perfMetricKey: 'jsm-request-types-configuration',
        ufoName: 'jsm-request-types-configuration'
    };
    const $7e5adb0871ecbbba$export$fa9d0db1668a0662 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("YXuQ6")).routeGroupsProjectSettingsServicedeskUnassignedTicketTypesConfigRoute), ()=>({
                ...$7e5adb0871ecbbba$var$commonTicketTypesConfigRouteEntry,
                component: (0, (0, parcelRequire("4stgq")).default)
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("YXuQ6")).routeGroupsProjectSettingsServicedeskItsmTicketTypesConfigRoute), ()=>({
                ...$7e5adb0871ecbbba$var$commonTicketTypesConfigRouteEntry
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("YXuQ6")).routeGroupsProjectSettingsServicedeskTicketTypesConfigRoute), ()=>({
                ...$7e5adb0871ecbbba$var$commonTicketTypesConfigRouteEntry
            }))
    ];
});
parcelRegister("k8jl5", function(module, exports) {
    $parcel$export(module.exports, "servicedeskIssueTypesResource", ()=>$8b723afc89fdf36c$export$191ce50629f40dbe);
    var $dIdda = parcelRequire("dIdda");
    const $8b723afc89fdf36c$var$getDataLoader = ()=>(parcelRequire("7Al2u"));
    const $8b723afc89fdf36c$export$191ce50629f40dbe = (0, $dIdda.createResource)({
        type: (0, $30e9f90f7be7696a$export$1ed713fe52212251),
        getKey: ({ match: { params: params } })=>params.projectKey || '',
        getDataLoader: $8b723afc89fdf36c$var$getDataLoader
    });
});
const $30e9f90f7be7696a$export$1ed713fe52212251 = 'SERVICEDESK_ISSUE_TYPES';
parcelRegister("7Al2u", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("lJYdj").then(()=>parcelRequire('lWPKX'));
});
parcelRegister("1cpsA", function(module, exports) {
    $parcel$export(module.exports, "servicedeskPortalGroupsResource", ()=>$2ddee7630453f9bc$export$c7fb28234b909b2f);
    var $dIdda = parcelRequire("dIdda");
    const $2ddee7630453f9bc$var$getDataLoader = ()=>(parcelRequire("hyupy"));
    const $2ddee7630453f9bc$var$ONE_DAY_IN_MILLIS = 86400000;
    const $2ddee7630453f9bc$export$c7fb28234b909b2f = (0, $dIdda.createResource)({
        type: (0, $1e9c4adda1725c92$export$4160f2c498fcd32e),
        getKey: ({ match: { params: params } })=>params.projectKey || '',
        getDataLoader: $2ddee7630453f9bc$var$getDataLoader,
        maxAge: $2ddee7630453f9bc$var$ONE_DAY_IN_MILLIS
    });
});
const $1e9c4adda1725c92$export$4160f2c498fcd32e = 'SERVICEDESK_PORTAL_GROUPS';
parcelRegister("hyupy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4lrTa").then(()=>parcelRequire('7sMSo'));
});
parcelRegister("fiVsS", function(module, exports) {
    $parcel$export(module.exports, "SERVICE_DESK_PRODUCT", ()=>$5f297064983232af$export$5575497f0592ee94);
    $parcel$export(module.exports, "getSettingsNavigationResources", ()=>$5f297064983232af$export$586756e5c0542a50);
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    const $5f297064983232af$export$b7262fe486f4b412 = 'core';
    const $5f297064983232af$export$2954328f6207617a = 'software';
    const $5f297064983232af$export$5575497f0592ee94 = 'servicedesk';
    const $5f297064983232af$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $5f297064983232af$export$586756e5c0542a50 = (product)=>{
        if (product === $5f297064983232af$export$5575497f0592ee94) return (0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)();
        if (product === $5f297064983232af$export$b7262fe486f4b412) return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
        ];
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
    };
});
parcelRegister("4stgq", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskTicketTypesConfig", ()=>$d4145a6e3aeb3bbb$export$c26e63f8b7d3b52c);
    $parcel$export(module.exports, "default", ()=>$d4145a6e3aeb3bbb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kKHTt;
    var $5j7Th;
    var $hPtZI;
    const $d4145a6e3aeb3bbb$export$c26e63f8b7d3b52c = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("i88kG")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-ticket-types-config/src/index.tsx"
    });
    var $d4145a6e3aeb3bbb$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kKHTt")).HelpCenterSettingsRedirect), {
            page: "ticket-types-config"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d4145a6e3aeb3bbb$export$c26e63f8b7d3b52c,
            pageId: "project-settings-ticket-types-config",
            shouldShowSpinner: true
        }));
});
parcelRegister("i88kG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("b1kaE")
    ]).then(()=>parcelRequire('7wKb0'));
});
parcelRegister("ah1WQ", function(module, exports) {
    $parcel$export(module.exports, "virtualAgentRouteEntries", ()=>$8b897edada5ca041$export$cf02bed1953597cb);
    var $1WqFo;
    var $lkFvK;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $iqD7H;
    var $6Z2mh;
    var $e9YVH;
    var $lgNzP;
    var $3OE6f;
    var $ewTwY;
    var $h9iy1;
    var $ktfxB;
    var $fNwAu;
    var $c25Ed;
    var $g3CgC;
    var $2IBFQ;
    var $cNMs5;
    var $8HI9m;
    var $8cTxW;
    var $7j28R;
    var $lSSsm;
    var $hFluH;
    var $3AXtK;
    const $8b897edada5ca041$var$browseConversationsPageEntryPoint = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("2IBFQ")).browseConversationsEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$browseIntentsPageEntryPoint = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("cNMs5")).browseIntentsEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$browseStandardFlowsPageEntryPoint = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("8HI9m")).browseStandardFlowsEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$landingPageEntryPoint = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("8cTxW")).landingEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$settingsPageEntryPoint = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("7j28R")).settingsEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$viewStandardFlowPageEntryPoint = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("hFluH")).viewStandardFlowEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$viewIntentPageEntryPoint = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("lSSsm")).viewIntentEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $8b897edada5ca041$var$getVirtualAgentRoutesCommon = ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            }
        });
    const $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings = (0, (0, parcelRequire("3AXtK")).defaultRedirectForSettings)((0, (0, parcelRequire("3AXtK")).SERVICE_DESK_PRODUCT));
    const $8b897edada5ca041$export$cf02bed1953597cb = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iqD7H")).landingPageRoute), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("1WqFo")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$landingPageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                skeleton: (0, (0, parcelRequire("ktfxB")).VirtualAgentLandingSkeleton),
                resources: [
                    ...(0, (0, parcelRequire("3AXtK")).getSettingsNavigationResources)((0, (0, parcelRequire("3AXtK")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_SETTINGS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_SETTINGS),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iqD7H")).browseIntentsRoute), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("1WqFo")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$browseIntentsPageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                layout: (0, (0, parcelRequire("lgNzP")).browseIntentsLayout),
                skeleton: (0, (0, parcelRequire("ewTwY")).VirtualAgentBrowseIntentsSkeleton),
                resources: [
                    ...(0, (0, parcelRequire("3AXtK")).getSettingsNavigationResources)((0, (0, parcelRequire("3AXtK")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_BROWSE_INTENTS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_BROWSE_INTENTS),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iqD7H")).viewIntentRoute), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("1WqFo")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$viewIntentPageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                skeleton: (0, (0, parcelRequire("c25Ed")).VirtualAgentViewIntentSkeleton),
                resources: [
                    ...(0, (0, parcelRequire("3AXtK")).getSettingsNavigationResources)((0, (0, parcelRequire("3AXtK")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_VIEW_INTENT,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_VIEW_INTENT),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iqD7H")).browseStandardFlowsRoute), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("1WqFo")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$browseStandardFlowsPageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                skeleton: (0, (0, parcelRequire("h9iy1")).VirtualAgentBrowseStandardFlowsSkeleton),
                resources: [
                    ...(0, (0, parcelRequire("3AXtK")).getSettingsNavigationResources)((0, (0, parcelRequire("3AXtK")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_BROWSE_STANDARD_FLOWS),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iqD7H")).viewStandardFlowRoute), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("1WqFo")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$viewStandardFlowPageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                skeleton: (0, (0, parcelRequire("g3CgC")).VirtualAgentViewStandardFlowSkeleton),
                resources: [
                    ...(0, (0, parcelRequire("3AXtK")).getSettingsNavigationResources)((0, (0, parcelRequire("3AXtK")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_VIEW_STANDARD_FLOW,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_VIEW_STANDARD_FLOW),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iqD7H")).browseConversationsRoute), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("1WqFo")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$browseConversationsPageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                skeleton: (0, (0, parcelRequire("3OE6f")).VirtualAgentBrowseConversationsSkeleton),
                resources: [
                    ...(0, (0, parcelRequire("3AXtK")).getSettingsNavigationResources)((0, (0, parcelRequire("3AXtK")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_BROWSE_CONVERSATIONS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_BROWSE_CONVERSATIONS),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iqD7H")).settingsRoute), ()=>({
                ...$8b897edada5ca041$var$getVirtualAgentRoutesCommon(),
                entryPoint () {
                    if ((0, (0, parcelRequire("1WqFo")).isFedRamp)()) return undefined;
                    return $8b897edada5ca041$var$settingsPageEntryPoint;
                },
                component: $8b897edada5ca041$var$FedRAMPFallbackRedirectToProjectSettings,
                skeleton: (0, (0, parcelRequire("fNwAu")).VirtualAgentSettingsSkeleton),
                resources: [
                    ...(0, (0, parcelRequire("3AXtK")).getSettingsNavigationResources)((0, (0, parcelRequire("3AXtK")).SERVICE_DESK_PRODUCT)),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_SETTINGS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).VIRTUAL_AGENT_SETTINGS),
                        teamName: 'jsd-flux-capacitors'
                    }
                }
            }))
    ];
});
parcelRegister("iqD7H", function(module, exports) {
    $parcel$export(module.exports, "landingPageRoute", ()=>$ee375367f69d39dc$export$8c051c399fd812a5);
    $parcel$export(module.exports, "browseIntentsRoute", ()=>$ee375367f69d39dc$export$3e227412713bc57f);
    $parcel$export(module.exports, "viewIntentRoute", ()=>$ee375367f69d39dc$export$bf8131fb060d0e73);
    $parcel$export(module.exports, "browseStandardFlowsRoute", ()=>$ee375367f69d39dc$export$fd091ba8fa858397);
    $parcel$export(module.exports, "viewStandardFlowRoute", ()=>$ee375367f69d39dc$export$c74dca8be49046ea);
    $parcel$export(module.exports, "browseConversationsRoute", ()=>$ee375367f69d39dc$export$c8ff4cf64e5540ec);
    $parcel$export(module.exports, "settingsRoute", ()=>$ee375367f69d39dc$export$847a7c378c11c645);
    var $65Ltd;
    const $ee375367f69d39dc$export$5575497f0592ee94 = 'servicedesk';
    const $ee375367f69d39dc$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $ee375367f69d39dc$export$8c051c399fd812a5 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagentonboarding`,
        exact: true,
        path: `${$ee375367f69d39dc$var$projectSettingsUrl($ee375367f69d39dc$export$5575497f0592ee94)}/virtual-agent`
    };
    const $ee375367f69d39dc$export$3e227412713bc57f = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-browse-intents`,
        exact: true,
        path: `${$ee375367f69d39dc$var$projectSettingsUrl($ee375367f69d39dc$export$5575497f0592ee94)}/virtual-agent/intents`
    };
    const $ee375367f69d39dc$export$bf8131fb060d0e73 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-view-intent`,
        exact: true,
        path: `${$ee375367f69d39dc$var$projectSettingsUrl($ee375367f69d39dc$export$5575497f0592ee94)}/virtual-agent/intents/:intentId/:tab(flow|training|settings)?`
    };
    const $ee375367f69d39dc$export$fd091ba8fa858397 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-standard-flows`,
        exact: true,
        path: `${$ee375367f69d39dc$var$projectSettingsUrl($ee375367f69d39dc$export$5575497f0592ee94)}/virtual-agent/standard-flows`
    };
    const $ee375367f69d39dc$export$c74dca8be49046ea = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-view-standard-flow`,
        exact: true,
        path: `${$ee375367f69d39dc$var$projectSettingsUrl($ee375367f69d39dc$export$5575497f0592ee94)}/virtual-agent/standard-flows/:flowId/:tab(flow|settings)?`
    };
    const $ee375367f69d39dc$export$c8ff4cf64e5540ec = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-browseconversations`,
        exact: true,
        path: `${$ee375367f69d39dc$var$projectSettingsUrl($ee375367f69d39dc$export$5575497f0592ee94)}/virtual-agent/conversations`
    };
    const $ee375367f69d39dc$export$847a7c378c11c645 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SERVICEDESK)}-virtualagent-settings`,
        exact: true,
        path: `${$ee375367f69d39dc$var$projectSettingsUrl($ee375367f69d39dc$export$5575497f0592ee94)}/virtual-agent/settings/:tab(basic|channels)?`
    };
});
parcelRegister("lgNzP", function(module, exports) {
    $parcel$export(module.exports, "browseIntentsLayout", ()=>$3f16128d6d3a9eb8$export$6659f41b213bad05);
    var $2vSU6;
    var $1XrjK;
    var $6Z2mh;
    var $epSYp;
    const $3f16128d6d3a9eb8$var$withServiceProjectContext = (Component)=>(0, (0, parcelRequire("1XrjK")).withProjectContext)(Component, {
            project: {
                style: 'any',
                type: (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT)
            }
        });
    const $3f16128d6d3a9eb8$export$6659f41b213bad05 = (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), {
        rightSidebars: [
            $3f16128d6d3a9eb8$var$withServiceProjectContext((0, (0, parcelRequire("epSYp")).default))
        ]
    });
});
parcelRegister("epSYp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cdb5ff159e084339$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7XluA;
    var $4mO32;
    var $hsmeR;
    var $dAfqg;
    var $iwtyI;
    var $av9sZ;
    var $8bDAQ;
    var $koeKL;
    const $cdb5ff159e084339$var$runtimeProps = {};
    const $cdb5ff159e084339$export$36ad24b9ac79bdc8 = ()=>{
        const rightSidebarCurrentState = (0, (0, parcelRequire("hsmeR")).useActiveRightSidebarState)();
        const panelId = rightSidebarCurrentState?.panelId ?? '';
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { data: projectContextData } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const entryPointParams = (0, $5uXOq.useMemo)(()=>({
                cloudId: cloudId,
                key: projectContextData?.projectKey ?? ''
            }), [
            cloudId,
            projectContextData
        ]);
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("iwtyI")).virtualAgentCreateIntentTemplateSidebarEntryPoint), entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            if (panelId === 'intentTemplate') entryPointActions.load();
            else entryPointActions.unload();
        }, [
            entryPointActions,
            panelId
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            id: "createIntentTemplatesSidebar",
            packageName: "jiraServicedeskSettingsVirtualAgentCreateIntentTemplates",
            entryPointReferenceSubject: entryPointReferenceSubject,
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8bDAQ")).VirtualAgentIntentTemplateSidebarSkeleton), null),
            errorFallback: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($cdb5ff159e084339$var$SideBarWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("av9sZ")).ErrorDisplay), {
                    refetch: ()=>window.location.reload()
                })),
            runtimeProps: $cdb5ff159e084339$var$runtimeProps
        });
    };
    const $cdb5ff159e084339$var$SideBarWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _11q71bhr _1kl7wsm2 _vchhusvi _1p57u2gc _4t3i1osq _18m91wug",
                __cmplp.className
            ])
        });
    });
    var $cdb5ff159e084339$export$2e2bcd8739ae039 = $cdb5ff159e084339$export$36ad24b9ac79bdc8;
});
parcelRegister("iwtyI", function(module, exports) {
    $parcel$export(module.exports, "virtualAgentCreateIntentTemplateSidebarEntryPoint", ()=>$6713c6429155461a$export$2b1d9dc27ee42f8f);
    var $aHrkz;
    var $2Ftxm;
    var $ikgNX;
    const $6713c6429155461a$export$2b1d9dc27ee42f8f = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("1kwFV")), {
            moduleId: "a4e9afeb"
        }),
        getPreloadProps: ({ cloudId: cloudId, key: key })=>({
                queries: {
                    intentTemplateQueryReference: {
                        options: {
                            fetchPolicy: 'store-or-network'
                        },
                        parameters: (0, (0, parcelRequire("aHrkz")).default),
                        variables: {
                            cloudId: cloudId,
                            key: key
                        }
                    }
                },
                entryPoints: {},
                extraProps: {}
            })
    });
});
parcelRegister("aHrkz", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e2036dd19a3f68c8$export$2e2bcd8739ae039);
    const $e2036dd19a3f68c8$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "125329b9d4e888d6fdabbfee72c3e68f14cb83b841b09ddce260b26dc8ea5dce",
            "metadata": {},
            "name": "uiVirtualAgentIntentTemplatesQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $e2036dd19a3f68c8$export$2e2bcd8739ae039 = $e2036dd19a3f68c8$var$node;
});
parcelRegister("1kwFV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("bTdk8")
    ]).then(()=>parcelRequire('dMvBS'));
});
parcelRegister("av9sZ", function(module, exports) {
    $parcel$export(module.exports, "ErrorDisplay", ()=>$09828373404eee09$export$d56b0569bceb92ae);
    var $5uXOq = parcelRequire("5uXOq");
    var $89thI;
    var $4hGw3;
    var $7q5TP;
    var $iVgQf;
    var $koVbs;
    var $2zwTA;
    const $09828373404eee09$export$d56b0569bceb92ae = ({ refetch: refetch })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4hGw3")).default), {
            header: formatMessage((0, (0, parcelRequire("2zwTA")).default).errorDisplayHeading),
            description: formatMessage((0, (0, parcelRequire("2zwTA")).default).errorDisplayDescription),
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("7q5TP")).default)),
            imageWidth: 160,
            maxImageHeight: 220,
            primaryAction: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("89thI")).default), {
                onClick: refetch,
                appearance: "link"
            }, formatMessage((0, (0, parcelRequire("2zwTA")).default).reloadNowButtonText))
        });
    };
});
parcelRegister("iVgQf", function(module, exports) {
    $parcel$export(module.exports, "getAkEmptyStateRenderImageFn", ()=>$7affac5c7e698fc8$export$ebf64b9217c1b2a3);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $4Bpvs;
    function $7affac5c7e698fc8$export$ebf64b9217c1b2a3(JiraIllustration = (0, (0, parcelRequire("4Bpvs")).default)) {
        return ({ maxImageWidth: maxImageWidth = 160, maxImageHeight: maxImageHeight = 160, imageWidth: imageWidth, imageHeight: imageHeight })=>{
            const Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
                return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
                    ...__cmplp,
                    style: {
                        ...__cmpls,
                        "--_yv3y2x": (0, (0, parcelRequire("lD23V")).default)(maxImageWidth, "px"),
                        "--_nq7wev": (0, (0, parcelRequire("lD23V")).default)(maxImageHeight, "px")
                    },
                    ref: __cmplr,
                    className: (0, (0, parcelRequire("bwpsq")).default)([
                        "_1e0c1ule _p12f1x6a _c71lc3ce _18s81ixx",
                        __cmplp.className
                    ])
                });
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Wrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement(JiraIllustration, {
                alt: "",
                role: "presentation",
                width: imageWidth || 'auto',
                height: imageHeight || 'auto'
            }));
        };
    }
});
parcelRegister("4Bpvs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$029e22a35a3f42f7$export$2e2bcd8739ae039);
    var $dCLgq;
    var $kbo4z = parcelRequire("kbo4z");
    var $3uP2Y = parcelRequire("3uP2Y");
    const $029e22a35a3f42f7$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($3uP2Y)),
        srcDark: ($parcel$interopDefault($kbo4z))
    });
    var $029e22a35a3f42f7$export$2e2bcd8739ae039 = $029e22a35a3f42f7$var$Illustration;
    const $029e22a35a3f42f7$export$a179c88182cb9d56 = [
        0,
        0,
        235,
        210
    ];
});
parcelRegister("kbo4z", function(module, exports) {
    module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();
});
parcelRegister("3uP2Y", function(module, exports) {
    module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();
});
parcelRegister("2zwTA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b2ecc7c5e37557c1$export$2e2bcd8739ae039);
    var $7VHMR;
    var $b2ecc7c5e37557c1$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorDisplayHeading: {
            "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-heading",
            "defaultMessage": "We couldn\u2019t load intent templates"
        },
        errorDisplayDescription: {
            "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.error-display-description",
            "defaultMessage": "Wait a moment and then try reloading."
        },
        reloadNowButtonText: {
            "id": "servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.error-display.reload-now-button-text",
            "defaultMessage": "Reload"
        }
    });
});
parcelRegister("8bDAQ", function(module, exports) {
    $parcel$export(module.exports, "VirtualAgentIntentTemplateSidebarSkeleton", ()=>$637244f673c8e430$export$fa68b26760d5b66f);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $5tRSi = parcelRequire("5tRSi");
    const $637244f673c8e430$var$customCssStyles = null;
    const $637244f673c8e430$export$fa68b26760d5b66f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($5tRSi))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
});
parcelRegister("5tRSi", function(module, exports) {
    module.exports = new URL("virtual-agent-intent-template-sidebar-app-skeleton.tpl.e2ff8557.svg", import.meta.url).toString();
});
parcelRegister("3OE6f", function(module, exports) {
    $parcel$export(module.exports, "VirtualAgentBrowseConversationsSkeleton", ()=>$31e71d146f719961$export$4a6267fad85ca589);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $eRGJ4 = parcelRequire("eRGJ4");
    const $31e71d146f719961$var$customStyles = null;
    const $31e71d146f719961$export$4a6267fad85ca589 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($eRGJ4))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
});
parcelRegister("eRGJ4", function(module, exports) {
    module.exports = new URL("virtual-agent-browse-conversations-app-skeleton.tpl.9f030add.svg", import.meta.url).toString();
});
parcelRegister("ewTwY", function(module, exports) {
    $parcel$export(module.exports, "VirtualAgentBrowseIntentsSkeleton", ()=>$31edb55767749c70$export$444026e4d4f156e4);
    $parcel$export(module.exports, "VirtualAgentIntentsTableSkeleton", ()=>$31edb55767749c70$export$9dca41144a6398d2);
    $parcel$export(module.exports, "VirtualAgentStatisticsSkeleton", ()=>$31edb55767749c70$export$538762e63d6466fe);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $eTe4L = parcelRequire("eTe4L");
    var $5IeeQ = parcelRequire("5IeeQ");
    var $8v6ku = parcelRequire("8v6ku");
    const $31edb55767749c70$var$customCssStyles = null;
    const $31edb55767749c70$export$444026e4d4f156e4 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($eTe4L))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
    const $31edb55767749c70$export$9dca41144a6398d2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($5IeeQ))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
    const $31edb55767749c70$export$538762e63d6466fe = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($8v6ku))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
});
parcelRegister("eTe4L", function(module, exports) {
    module.exports = new URL("virtual-agent-browse-intents-app-skeleton.tpl.1eeb33c1.svg", import.meta.url).toString();
});
parcelRegister("5IeeQ", function(module, exports) {
    module.exports = new URL("virtual-agent-intents-table-app-skeleton.tpl.e28c55f7.svg", import.meta.url).toString();
});
parcelRegister("8v6ku", function(module, exports) {
    module.exports = new URL("virtual-agent-virtual-agent-statistics-app-skeleton.tpl.19ee5056.svg", import.meta.url).toString();
});
parcelRegister("h9iy1", function(module, exports) {
    $parcel$export(module.exports, "VirtualAgentBrowseStandardFlowsSkeleton", ()=>$cab5351b0cab7245$export$c2bd83dd149452bd);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $6OP2Q = parcelRequire("6OP2Q");
    const $cab5351b0cab7245$var$customCssStyles = null;
    const $cab5351b0cab7245$export$c2bd83dd149452bd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($6OP2Q))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
});
parcelRegister("6OP2Q", function(module, exports) {
    module.exports = new URL("virtual-agent-browse-standard-flows-app-skeleton.tpl.51e6e95a.svg", import.meta.url).toString();
});
parcelRegister("ktfxB", function(module, exports) {
    $parcel$export(module.exports, "VirtualAgentLandingSkeleton", ()=>$b789e8c1efa50dd2$export$f4b71d7b732df8a7);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $gU5cD = parcelRequire("gU5cD");
    const $b789e8c1efa50dd2$var$customStyles = null;
    const $b789e8c1efa50dd2$export$f4b71d7b732df8a7 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($gU5cD))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
});
parcelRegister("gU5cD", function(module, exports) {
    module.exports = new URL("virtual-agent-landing-app-skeleton.tpl.e8a7897b.svg", import.meta.url).toString();
});
parcelRegister("fNwAu", function(module, exports) {
    $parcel$export(module.exports, "VirtualAgentSettingsSkeleton", ()=>$ffc145e88af958a4$export$429c43ddcb09c14c);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $e41HZ = parcelRequire("e41HZ");
    const $ffc145e88af958a4$var$customCssStyles = null;
    const $ffc145e88af958a4$export$429c43ddcb09c14c = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($e41HZ))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
});
parcelRegister("e41HZ", function(module, exports) {
    module.exports = new URL("virtual-agent-settings-app-skeleton.tpl.1a9c03fe.svg", import.meta.url).toString();
});
parcelRegister("c25Ed", function(module, exports) {
    $parcel$export(module.exports, "VirtualAgentViewIntentSkeleton", ()=>$2174f34b723f2aa4$export$72b20c10a0f18a2f);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $b1zT3 = parcelRequire("b1zT3");
    const $2174f34b723f2aa4$var$customCssStyles = null;
    const $2174f34b723f2aa4$export$72b20c10a0f18a2f = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($b1zT3))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
});
parcelRegister("b1zT3", function(module, exports) {
    module.exports = new URL("virtual-agent-view-intent-app-skeleton.tpl.5dd31cbb.svg", import.meta.url).toString();
});
parcelRegister("g3CgC", function(module, exports) {
    $parcel$export(module.exports, "VirtualAgentViewStandardFlowSkeleton", ()=>$68dba50d060b4784$export$c6d3f04e6931e3f6);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $aEqL3 = parcelRequire("aEqL3");
    const $68dba50d060b4784$var$customCssStyles = null;
    const $68dba50d060b4784$export$c6d3f04e6931e3f6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($aEqL3))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f4tsx"
            ])
        });
});
parcelRegister("aEqL3", function(module, exports) {
    module.exports = new URL("virtual-agent-view-standard-flow-app-skeleton.tpl.ec3b149b.svg", import.meta.url).toString();
});
parcelRegister("2IBFQ", function(module, exports) {
    $parcel$export(module.exports, "browseConversationsEntryPoint", ()=>$d5456be03cb88be5$export$38549013d5d5a440);
    var $iAqTc;
    var $2Ftxm;
    var $ikgNX;
    const $d5456be03cb88be5$var$DEFAULT_RANGE_DAYS = 14;
    const $d5456be03cb88be5$export$38549013d5d5a440 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("7HjzY")), {
            moduleId: "1bf85952"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>{
            const end = new Date();
            const start = new Date(end);
            start.setDate(start.getDate() - $d5456be03cb88be5$var$DEFAULT_RANGE_DAYS);
            return {
                extraProps: {
                    initialDateRange: {
                        start: start,
                        end: end
                    }
                },
                queries: {
                    page: {
                        parameters: (0, (0, parcelRequire("iAqTc")).default),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey ?? '',
                            startDate: start.toISOString(),
                            endDate: end.toISOString()
                        }
                    }
                }
            };
        }
    });
});
parcelRegister("iAqTc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6a4522a333dd4135$export$2e2bcd8739ae039);
    var $d4rfp;
    var $7oHmH;
    const $6a4522a333dd4135$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "9d72b5513735b93097e24be9918ee2d9d52369f5b250d43277ed25b5ec6cddbe",
            "metadata": {},
            "name": "srcVirtualAgentBrowseConversationsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisconversationfilterenabledrelayprovider": (0, (0, parcelRequire("d4rfp")).default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $6a4522a333dd4135$export$2e2bcd8739ae039 = $6a4522a333dd4135$var$node;
});
parcelRegister("d4rfp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2b78ba3d71d6b015$export$2e2bcd8739ae039);
    var $4R6GH;
    var $2b78ba3d71d6b015$export$2e2bcd8739ae039 = {
        get () {
            return (0, (0, parcelRequire("4R6GH")).fg)('expose_channels_on_va_conversation_history');
        }
    };
});
parcelRegister("7HjzY", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7F9PY")
    ]).then(()=>parcelRequire('azR8x'));
});
parcelRegister("cNMs5", function(module, exports) {
    $parcel$export(module.exports, "browseIntentsEntryPoint", ()=>$0c1a3d6ae6de7f87$export$f19c213ae2d7940f);
    var $2VZl9;
    var $ae5pE;
    var $2Ftxm;
    var $ikgNX;
    const $0c1a3d6ae6de7f87$var$DEFAULT_TIME_RANGE_MS = 604800000;
    const $0c1a3d6ae6de7f87$var$formatFetchDate = (date)=>date.toISOString().substring(0, 10);
    const $0c1a3d6ae6de7f87$export$f19c213ae2d7940f = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("b2GCz")), {
            moduleId: "85089c8d"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    page: {
                        parameters: (0, (0, parcelRequire("2VZl9")).default),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey ?? ''
                        }
                    },
                    statistics: {
                        parameters: (0, (0, parcelRequire("ae5pE")).default),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey ?? '',
                            startDate: $0c1a3d6ae6de7f87$var$formatFetchDate(new Date(Date.now() - $0c1a3d6ae6de7f87$var$DEFAULT_TIME_RANGE_MS)),
                            endDate: $0c1a3d6ae6de7f87$var$formatFetchDate(new Date())
                        }
                    }
                }
            })
    });
});
parcelRegister("2VZl9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$84af76b2b1eda3ac$export$2e2bcd8739ae039);
    var $7oHmH;
    const $84af76b2b1eda3ac$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "b01f9fcabc3aee56bbd34937601e0f469fa19b8352f84444c4e984055d229188",
            "metadata": {},
            "name": "srcVirtualAgentBrowseIntentsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $84af76b2b1eda3ac$export$2e2bcd8739ae039 = $84af76b2b1eda3ac$var$node;
});
parcelRegister("ae5pE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3c21345417f9f8e$export$2e2bcd8739ae039);
    const $d3c21345417f9f8e$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "88cc4583a28f5f918e666724a2636a3b4534c49a8641fe00c526853b754f57f5",
            "metadata": {},
            "name": "srcVirtualAgentBrowseIntentsStatisticsQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $d3c21345417f9f8e$export$2e2bcd8739ae039 = $d3c21345417f9f8e$var$node;
});
parcelRegister("b2GCz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("dt4qH")
    ]).then(()=>parcelRequire('9r2hQ'));
});
parcelRegister("8HI9m", function(module, exports) {
    $parcel$export(module.exports, "browseStandardFlowsEntryPoint", ()=>$32e48f8946c41f01$export$f7de8593c7455f1);
    var $iARRY;
    var $2Ftxm;
    var $ikgNX;
    const $32e48f8946c41f01$export$f7de8593c7455f1 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("l7tra")), {
            moduleId: "c2d13204"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    page: {
                        parameters: (0, (0, parcelRequire("iARRY")).default),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey ?? ''
                        }
                    }
                }
            })
    });
});
parcelRegister("iARRY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4e33e127e8847987$export$2e2bcd8739ae039);
    var $7oHmH;
    const $4e33e127e8847987$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "2e51c3ce04647514550bfd30a24273f1ec78c1e9f29b4cc8e2d0ea31f4eb36b7",
            "metadata": {},
            "name": "srcVirtualAgentBrowseStandardFlowsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $4e33e127e8847987$export$2e2bcd8739ae039 = $4e33e127e8847987$var$node;
});
parcelRegister("l7tra", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("kiA0q")
    ]).then(()=>parcelRequire('exMWS'));
});
parcelRegister("8cTxW", function(module, exports) {
    $parcel$export(module.exports, "landingEntryPoint", ()=>$0f9dae747ed8bf8a$export$ad927ca7512a3a01);
    var $9uqwu;
    var $2Ftxm;
    var $ikgNX;
    const $0f9dae747ed8bf8a$export$ad927ca7512a3a01 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("e1IHq")), {
            moduleId: "06d84010"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    page: {
                        parameters: (0, (0, parcelRequire("9uqwu")).default),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey ?? ''
                        }
                    }
                }
            })
    });
});
parcelRegister("9uqwu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$588c29ffd4ee84e7$export$2e2bcd8739ae039);
    var $7oHmH;
    const $588c29ffd4ee84e7$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "a7f141f3b031fac8f81706fc45ecc08cdad9187b6897af87cfe378c09e62bbc4",
            "metadata": {},
            "name": "srcVirtualAgentLandingQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $588c29ffd4ee84e7$export$2e2bcd8739ae039 = $588c29ffd4ee84e7$var$node;
});
parcelRegister("e1IHq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("atp96")
    ]).then(()=>parcelRequire('52WYW'));
});
parcelRegister("7j28R", function(module, exports) {
    $parcel$export(module.exports, "settingsEntryPoint", ()=>$a9827913d0401124$export$d34e7816b7ac181a);
    var $1I4lD;
    var $2Ftxm;
    var $ikgNX;
    const $a9827913d0401124$export$d34e7816b7ac181a = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("iEX30")), {
            moduleId: "ed4de71b"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    page: {
                        parameters: (0, (0, parcelRequire("1I4lD")).default),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey ?? ''
                        }
                    }
                }
            })
    });
});
parcelRegister("1I4lD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a14dfc5f3ce71c58$export$2e2bcd8739ae039);
    var $7oHmH;
    const $a14dfc5f3ce71c58$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "0af3d831d6845961020ffbd5836b5c31aee474f150bcc79c33eedce8c8f88fc4",
            "metadata": {},
            "name": "srcVirtualAgentSettingsQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $a14dfc5f3ce71c58$export$2e2bcd8739ae039 = $a14dfc5f3ce71c58$var$node;
});
parcelRegister("iEX30", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("7SEHL")
    ]).then(()=>parcelRequire('byLJY'));
});
parcelRegister("lSSsm", function(module, exports) {
    $parcel$export(module.exports, "viewIntentEntryPoint", ()=>$ac6810a67c998d50$export$f51df662bd71ce39);
    var $iD8EQ;
    var $2Ftxm;
    var $ikgNX;
    const $ac6810a67c998d50$export$f51df662bd71ce39 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("83kJ4")), {
            moduleId: "bc04de30"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    page: {
                        parameters: (0, (0, parcelRequire("iD8EQ")).default),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey ?? '',
                            intentId: context.match.params.intentId ?? ''
                        }
                    }
                }
            })
    });
});
parcelRegister("iD8EQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$45ed8bfdfee83271$export$2e2bcd8739ae039);
    var $7oHmH;
    const $45ed8bfdfee83271$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "e7767aeff6aef92ebf766bcc5caf7c51a370d482f8b894d49e716f084cbc2e0d",
            "metadata": {},
            "name": "srcVirtualAgentViewIntentQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $45ed8bfdfee83271$export$2e2bcd8739ae039 = $45ed8bfdfee83271$var$node;
});
parcelRegister("83kJ4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("jVj7l")
    ]).then(()=>parcelRequire('01RYz'));
});
parcelRegister("hFluH", function(module, exports) {
    $parcel$export(module.exports, "viewStandardFlowEntryPoint", ()=>$8d05ca45dd1a7906$export$4fd7bf09308d4abd);
    var $3sOht;
    var $2Ftxm;
    var $ikgNX;
    const $8d05ca45dd1a7906$export$4fd7bf09308d4abd = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("e6BUU")), {
            moduleId: "8e1cdfbd"
        }),
        getPreloadProps: ({ context: context, tenantContext: tenantContext })=>({
                queries: {
                    page: {
                        parameters: (0, (0, parcelRequire("3sOht")).default),
                        variables: {
                            cloudId: tenantContext.cloudId,
                            projectKey: context.match.params.projectKey ?? '',
                            flowId: context.match.params.flowId ?? ''
                        }
                    }
                }
            })
    });
});
parcelRegister("3sOht", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1bc956e6a804d466$export$2e2bcd8739ae039);
    var $7oHmH;
    const $1bc956e6a804d466$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "e99c84d3af08be34f82c9f5371a5d21d166aa134a461ace14c61e3ec2151810c",
            "metadata": {},
            "name": "srcVirtualAgentViewStandardFlowQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaisrequireaienabledrelayprovider": (0, (0, parcelRequire("7oHmH")).default)
            }
        }
    };
    var $1bc956e6a804d466$export$2e2bcd8739ae039 = $1bc956e6a804d466$var$node;
});
parcelRegister("e6BUU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("8avJm")
    ]).then(()=>parcelRequire('16gIP'));
});
parcelRegister("3AXtK", function(module, exports) {
    $parcel$export(module.exports, "SERVICE_DESK_PRODUCT", ()=>$a6392627f74f3006$export$5575497f0592ee94);
    $parcel$export(module.exports, "getSettingsNavigationResources", ()=>$a6392627f74f3006$export$586756e5c0542a50);
    $parcel$export(module.exports, "defaultRedirectForSettings", ()=>$a6392627f74f3006$export$c9b0516439c55d7a);
    var $5uXOq = parcelRequire("5uXOq");
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    var $dIdda = parcelRequire("dIdda");
    const $a6392627f74f3006$export$b7262fe486f4b412 = 'core';
    const $a6392627f74f3006$export$2954328f6207617a = 'software';
    const $a6392627f74f3006$export$5575497f0592ee94 = 'servicedesk';
    const $a6392627f74f3006$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $a6392627f74f3006$export$586756e5c0542a50 = (product)=>{
        if (product === $a6392627f74f3006$export$5575497f0592ee94) return (0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)();
        if (product === $a6392627f74f3006$export$b7262fe486f4b412) return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
        ];
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
    };
    const $a6392627f74f3006$export$c9b0516439c55d7a = (product)=>({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
            });
});
parcelRegister("bqXcd", function(module, exports) {
    $parcel$export(module.exports, "servicedeskWorkflowConfigRouteEntry", ()=>$0043ec7f595129fa$export$212f7f79630d5adc);
    var $lkFvK;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $iQZ89;
    var $6Z2mh;
    var $j3pH1;
    const $0043ec7f595129fa$var$workflowSchemeConfigPageEntrypoint = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("j3pH1")).workflowSchemeConfigEntrypoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $0043ec7f595129fa$var$CORE_PRODUCT = 'core';
    const $0043ec7f595129fa$var$SERVICE_DESK_PRODUCT = 'servicedesk';
    const $0043ec7f595129fa$export$586756e5c0542a50 = (product)=>{
        if (product === $0043ec7f595129fa$var$SERVICE_DESK_PRODUCT) return (0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)();
        const resources = [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectResource)(),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
        if (product === $0043ec7f595129fa$var$CORE_PRODUCT) return [
            ...resources,
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
        ];
        return resources;
    };
    const $0043ec7f595129fa$export$212f7f79630d5adc = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("iQZ89")).routeGroupsProjectSettingsWorkflowSchemeConfigRoute), ()=>({
            entryPoint () {
                return $0043ec7f595129fa$var$workflowSchemeConfigPageEntrypoint;
            },
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
            },
            resources: [
                ...$0043ec7f595129fa$export$586756e5c0542a50($0043ec7f595129fa$var$SERVICE_DESK_PRODUCT),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ],
            meta: {
                reporting: {
                    id: 'project-settings.workflow-scheme-config',
                    packageName: 'projectSettingsWorkflowSchemeConfig',
                    teamName: 'jsd-shield'
                }
            },
            ufoName: 'project-settings-workflow-scheme-config'
        }));
});
parcelRegister("j3pH1", function(module, exports) {
    $parcel$export(module.exports, "workflowSchemeConfigEntrypoint", ()=>$5e46ff6da5ce3455$export$12ccdf1d30de8ac);
    var $2Ftxm;
    var $ikgNX;
    const $5e46ff6da5ce3455$export$12ccdf1d30de8ac = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("hQKui")), {
            moduleId: "6be3e66b"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("hQKui", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("c6xj7")
    ]).then(()=>parcelRequire('3STzC'));
});
parcelRegister("ejiWA", function(module, exports) {
    $parcel$export(module.exports, "changeManagementSettingsProjectConfigurationResource", ()=>$53ebb72294d46a1c$export$2413ba18ec38282d);
    var $dIdda = parcelRequire("dIdda");
    const $53ebb72294d46a1c$export$c0636b6062501e0b = 'CHANGE_MANAGEMENT_SETTINGS_PROJECT_CONFIG';
    const $53ebb72294d46a1c$var$getDataLoader = ()=>(parcelRequire("kWcpx"));
    const $53ebb72294d46a1c$var$getKey = ({ match: match })=>typeof match.params.projectKey === 'string' ? match.params.projectKey : '';
    const $53ebb72294d46a1c$export$2413ba18ec38282d = (0, $dIdda.createResource)({
        type: $53ebb72294d46a1c$export$c0636b6062501e0b,
        getKey: $53ebb72294d46a1c$var$getKey,
        getDataLoader: $53ebb72294d46a1c$var$getDataLoader,
        maxAge: Infinity
    });
});
parcelRegister("kWcpx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fIejC").then(()=>parcelRequire('k9qTQ'));
});
parcelRegister("7Txnp", function(module, exports) {
    $parcel$export(module.exports, "LoadingComponent", ()=>$42f73bbf4237dc1b$export$7db30d367db7d20a);
    $parcel$export(module.exports, "LazyCsatSettingsPage", ()=>$42f73bbf4237dc1b$export$32eb62914bae0e84);
    var $5uXOq = parcelRequire("5uXOq");
    var $9MjbF;
    var $hPtZI;
    var $2RMCX;
    const $42f73bbf4237dc1b$export$7db30d367db7d20a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2RMCX")).SpinnerContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9MjbF")).default), {
            size: "large"
        }));
    const $42f73bbf4237dc1b$export$32eb62914bae0e84 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("hFEiH")), {
        moduleId: "./src/packages/servicedesk/csat/src/index.tsx"
    });
});
parcelRegister("2RMCX", function(module, exports) {
    $parcel$export(module.exports, "SpinnerContainer", ()=>$9b09872937243424$export$a5e06607a5ac6158);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $9b09872937243424$export$a5e06607a5ac6158 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i68cl",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("hFEiH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("jT1Vf").then(()=>parcelRequire('hX8BJ'));
});
parcelRegister("k7tsS", function(module, exports) {
    $parcel$export(module.exports, "languageTranslationsResource", ()=>$ffad7a39054feef3$export$f51887e33895eab9);
    $parcel$export(module.exports, "outgoingEmailStateModelResource", ()=>$ffad7a39054feef3$export$c460156a7e6b85b2);
    var $dIdda = parcelRequire("dIdda");
    const $ffad7a39054feef3$export$9f529be3aeae01ea = 'JSM Language Translations';
    const $ffad7a39054feef3$export$ecd381e388e8c56f = "Language Support Customer Notification's Outgoing Email State";
    const $ffad7a39054feef3$export$f51887e33895eab9 = (0, $dIdda.createResource)({
        type: 'Language Translations',
        getKey: ({ match: { params: { projectKey: projectKey, languageKey: languageKey } } })=>`${$ffad7a39054feef3$export$9f529be3aeae01ea}-${projectKey}-${languageKey}`,
        getDataLoader: ()=>(parcelRequire("1gRMI")),
        maxAge: Infinity
    });
    const $ffad7a39054feef3$export$c460156a7e6b85b2 = (0, $dIdda.createResource)({
        type: 'Outgoing Email State Model',
        getKey: ()=>`${$ffad7a39054feef3$export$ecd381e388e8c56f}`,
        getDataLoader: ()=>(parcelRequire("aL9AA")),
        maxAge: Infinity
    });
});
parcelRegister("1gRMI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4BYvo").then(()=>parcelRequire('3m5cp'));
});
parcelRegister("aL9AA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("hn2iP").then(()=>parcelRequire('49aS0'));
});
parcelRegister("f8FqB", function(module, exports) {
    $parcel$export(module.exports, "LazyInternalNotificationSettingsPage", ()=>$c99d86239fe70688$export$501979bd6d492c43);
    var $hPtZI;
    const $c99d86239fe70688$export$501979bd6d492c43 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("asdjb")), {
        moduleId: "./src/packages/servicedesk/notification-internal/src/ui/index.tsx"
    });
});
parcelRegister("asdjb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("dBkhA")
    ]).then(()=>parcelRequire('ZHF20'));
});
parcelRegister("j9RuP", function(module, exports) {
    $parcel$export(module.exports, "LazyConnectAppControlsSettings", ()=>$3f52008d1cdfa258$export$246ec9cdadd2a163);
    $parcel$export(module.exports, "ConnectAppsRedirect", ()=>$3f52008d1cdfa258$export$cc3414a2d9daf70d);
    $parcel$export(module.exports, "default", ()=>$3f52008d1cdfa258$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $dAfqg;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $dIdda = parcelRequire("dIdda");
    var $hKH9R;
    const $3f52008d1cdfa258$export$246ec9cdadd2a163 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9RXCH"))), {
        moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
    });
    const $3f52008d1cdfa258$var$ConnectAppsRedirectInner = ({ match: match, basePath: basePath })=>{
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const shouldRedirect = projectContext != null && projectContext.simplified && projectContext.projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT);
        return shouldRedirect ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `${basePath}/projects/${String(match.params.projectKey)}/settings/apps/app-fields`,
            push: false
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hKH9R")).default), null);
    };
    const $3f52008d1cdfa258$export$cc3414a2d9daf70d = (basePath)=>({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement($3f52008d1cdfa258$var$ConnectAppsRedirectInner, {
                match: match,
                basePath: basePath
            });
    var $3f52008d1cdfa258$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3f52008d1cdfa258$export$246ec9cdadd2a163,
            pageId: "project-settings-connect-app-controls",
            shouldShowSpinner: false
        });
});
parcelRegister("hKH9R", function(module, exports) {
    $parcel$export(module.exports, "LazyAppDiscoverySettings", ()=>$d7e52a3e5f45b58f$export$fa3bc297af95f169);
    $parcel$export(module.exports, "default", ()=>$d7e52a3e5f45b58f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $d7e52a3e5f45b58f$export$fa3bc297af95f169 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("ghg5c"))), {
        moduleId: "./src/packages/spa-apps/project-settings/app-discovery-settings/src/index.tsx"
    });
    var $d7e52a3e5f45b58f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d7e52a3e5f45b58f$export$fa3bc297af95f169,
            pageId: "project-settings-app-discovery-settings",
            shouldShowSpinner: false
        });
});
parcelRegister("ghg5c", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7mkmU")
    ]).then(()=>parcelRequire('jgXd4'));
});
parcelRegister("cp0du", function(module, exports) {
    $parcel$export(module.exports, "LazyConnectAppsSettings", ()=>$841a04425f045e7e$export$3633e017e520a1c2);
    $parcel$export(module.exports, "default", ()=>$841a04425f045e7e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $841a04425f045e7e$export$3633e017e520a1c2 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("RJn1w"))), {
        moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
    });
    var $841a04425f045e7e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $841a04425f045e7e$export$3633e017e520a1c2,
            pageId: "project-settings-connect-apps",
            shouldShowSpinner: false
        });
});
parcelRegister("6h9hV", function(module, exports) {
    $parcel$export(module.exports, "LazyDataClassificationsSettings", ()=>$953aed1c2ae3d2f5$export$b8abcf8aa8f4df56);
    $parcel$export(module.exports, "default", ()=>$953aed1c2ae3d2f5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $953aed1c2ae3d2f5$export$b8abcf8aa8f4df56 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2igd7"))), {
        moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
    });
    var $953aed1c2ae3d2f5$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $953aed1c2ae3d2f5$export$b8abcf8aa8f4df56,
            pageId: "project-settings-data-classifications",
            shouldShowSpinner: false
        });
});
parcelRegister("bYT90", function(module, exports) {
    $parcel$export(module.exports, "LazyDetailsSettings", ()=>$3746e6592757d8dd$export$6f16b5efddd5c646);
    $parcel$export(module.exports, "default", ()=>$3746e6592757d8dd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $3746e6592757d8dd$export$6f16b5efddd5c646 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kVevk"))), {
        moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
    });
    var $3746e6592757d8dd$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3746e6592757d8dd$export$6f16b5efddd5c646,
            pageId: "project-settings-details",
            shouldShowSpinner: false
        });
});
parcelRegister("3sOmz", function(module, exports) {
    $parcel$export(module.exports, "LazyFieldsSettings", ()=>$c77ac9be273e47d5$export$e309780f520d125a);
    $parcel$export(module.exports, "default", ()=>$c77ac9be273e47d5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $c77ac9be273e47d5$export$e309780f520d125a = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("NWARb"))), {
        moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
    });
    var $c77ac9be273e47d5$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c77ac9be273e47d5$export$e309780f520d125a,
            pageId: "project-settings-fields",
            shouldShowSpinner: true
        });
});
parcelRegister("bUhjF", function(module, exports) {
    $parcel$export(module.exports, "LazyForgeProjectSettingsPage", ()=>$d4e28d950e086fee$export$ef66d3f49a9953d8);
    $parcel$export(module.exports, "forgeProjectSettingsPageResources", ()=>$d4e28d950e086fee$export$33d85a1b2211b38);
    $parcel$export(module.exports, "default", ()=>$d4e28d950e086fee$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5bkvv;
    var $dxCvy;
    var $5j7Th;
    var $hPtZI;
    const $d4e28d950e086fee$export$ef66d3f49a9953d8 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("3kJhU")), {
        moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
    });
    const $d4e28d950e086fee$export$33d85a1b2211b38 = [
        (0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache),
        (0, (0, parcelRequire("5bkvv")).forgeProjectSettingsModuleResource)
    ];
    const $d4e28d950e086fee$export$b943f48844c671a5 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d4e28d950e086fee$export$ef66d3f49a9953d8,
            pageId: "forge-spa-project-settings",
            shouldShowSpinner: true
        });
    var $d4e28d950e086fee$export$2e2bcd8739ae039 = $d4e28d950e086fee$export$b943f48844c671a5;
});
parcelRegister("5EbkJ", function(module, exports) {
    $parcel$export(module.exports, "LazyIssueTypeSettings", ()=>$9d365377dbe2cbf1$export$36dcfb52d47cb93a);
    $parcel$export(module.exports, "default", ()=>$9d365377dbe2cbf1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $9d365377dbe2cbf1$export$36dcfb52d47cb93a = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("61LFA"))), {
        moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
    });
    var $9d365377dbe2cbf1$export$2e2bcd8739ae039 = ({ match: match })=>{
        const { issueTypeId: issueTypeId } = match.params;
        const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9d365377dbe2cbf1$export$36dcfb52d47cb93a,
            pageId: pageId,
            shouldShowSpinner: false
        });
    };
});
parcelRegister("01Poo", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsJiraAutomation", ()=>$f62e804ec9c6d7ed$export$dea5ad7e8eac12ae);
    $parcel$export(module.exports, "default", ()=>$f62e804ec9c6d7ed$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $f62e804ec9c6d7ed$export$dea5ad7e8eac12ae = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("c32Mm")), {
        moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
    });
    var $f62e804ec9c6d7ed$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f62e804ec9c6d7ed$export$dea5ad7e8eac12ae,
            pageId: "project-settings-jira-automation",
            shouldShowSpinner: true
        });
});
parcelRegister("6T6BC", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsNotificationEmail", ()=>$6229d9dc67e508de$export$ea7d73c94d9369f4);
    $parcel$export(module.exports, "default", ()=>$6229d9dc67e508de$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $6229d9dc67e508de$export$ea7d73c94d9369f4 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("bm5Zl"))), {
        moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
    });
    var $6229d9dc67e508de$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6229d9dc67e508de$export$ea7d73c94d9369f4,
            pageId: "project-settings-email-notifications",
            shouldShowSpinner: true
        });
});
parcelRegister("p09kb", function(module, exports) {
    $parcel$export(module.exports, "LazyPeopleSettings", ()=>$3a1472a535e1ea00$export$7eee4f97b7a1273);
    $parcel$export(module.exports, "peopleAccessRedirect", ()=>$3a1472a535e1ea00$export$45346ed2aa24e3f3);
    $parcel$export(module.exports, "default", ()=>$3a1472a535e1ea00$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $dIdda = parcelRequire("dIdda");
    const $3a1472a535e1ea00$export$7eee4f97b7a1273 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("b3T21"))), {
        moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
    });
    const $3a1472a535e1ea00$var$PeopleAccessRedirectInner = ({ match: match, basePath: basePath })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `${basePath}/projects/${String(match.params.projectKey)}/settings/access`,
            push: false
        });
    const $3a1472a535e1ea00$export$45346ed2aa24e3f3 = (basePath)=>({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement($3a1472a535e1ea00$var$PeopleAccessRedirectInner, {
                match: match,
                basePath: basePath
            });
    var $3a1472a535e1ea00$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3a1472a535e1ea00$export$7eee4f97b7a1273,
            pageId: "project-settings-people",
            shouldShowSpinner: false
        });
});
parcelRegister("01LdL", function(module, exports) {
    $parcel$export(module.exports, "SERVICE_DESK_PRODUCT", ()=>$a51e57eb3887507b$export$5575497f0592ee94);
    $parcel$export(module.exports, "getSettingsNavigationResources", ()=>$a51e57eb3887507b$export$586756e5c0542a50);
    $parcel$export(module.exports, "defaultRedirectForSettings", ()=>$a51e57eb3887507b$export$c9b0516439c55d7a);
    var $5uXOq = parcelRequire("5uXOq");
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    var $dIdda = parcelRequire("dIdda");
    const $a51e57eb3887507b$export$b7262fe486f4b412 = 'core';
    const $a51e57eb3887507b$export$2954328f6207617a = 'software';
    const $a51e57eb3887507b$export$5575497f0592ee94 = 'servicedesk';
    const $a51e57eb3887507b$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $a51e57eb3887507b$export$586756e5c0542a50 = (product)=>{
        if (product === $a51e57eb3887507b$export$5575497f0592ee94) return (0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)();
        if (product === $a51e57eb3887507b$export$b7262fe486f4b412) return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
        ];
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
    };
    const $a51e57eb3887507b$export$c9b0516439c55d7a = (product)=>({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `/jira/${product}/projects/${String(match.params.projectKey)}/settings/details`
            });
});
parcelRegister("aPBt5", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsProformaJiraFormBuilder", ()=>$5cc0224f486155a9$export$a7d63246a10aedd);
    $parcel$export(module.exports, "default", ()=>$5cc0224f486155a9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $5cc0224f486155a9$export$a7d63246a10aedd = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("9Saqg")), {
        moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
    });
    var $5cc0224f486155a9$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5cc0224f486155a9$export$a7d63246a10aedd,
            pageId: "project-settings-proforma-jira-form-builder",
            shouldShowSpinner: true
        });
});
parcelRegister("6RowE", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsProformaProjectForms", ()=>$7c82c5f708d0cd7e$export$38414b624a749cec);
    $parcel$export(module.exports, "default", ()=>$7c82c5f708d0cd7e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $7c82c5f708d0cd7e$export$38414b624a749cec = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("2Js68")), {
        moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
    });
    var $7c82c5f708d0cd7e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7c82c5f708d0cd7e$export$38414b624a749cec,
            pageId: "project-settings-proforma-project-forms",
            shouldShowSpinner: true
        });
});
parcelRegister("eHnlx", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskChangeManagement", ()=>$8fbb06494113daae$export$e674d93688e620b3);
    $parcel$export(module.exports, "default", ()=>$8fbb06494113daae$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $8fbb06494113daae$export$e674d93688e620b3 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4q0cm"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-change-management-settings/src/index.tsx"
    });
    var $8fbb06494113daae$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8fbb06494113daae$export$e674d93688e620b3,
            pageId: "project-settings-change-management",
            shouldShowSpinner: true
        });
});
parcelRegister("4q0cm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("d1IdH")
    ]).then(()=>parcelRequire('eh7Vf'));
});
parcelRegister("3egqP", function(module, exports) {
    $parcel$export(module.exports, "channelsRedirect", ()=>$73d598aaa606ce09$export$c7e6c0ac0abe2336);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $02Psx;
    var $dIdda = parcelRequire("dIdda");
    const $73d598aaa606ce09$export$c7e6c0ac0abe2336 = (pageUrlFragment)=>({ match: match })=>{
            const { projectKey: projectKey } = match.params;
            const url = `${(0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), String(projectKey))}/channels/${pageUrlFragment}`;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: url,
                push: false
            });
        };
});
parcelRegister("6ybDD", function(module, exports) {
    $parcel$export(module.exports, "serviceDeskChatNextGenRedirect", ()=>$7c240e4106c097e5$export$22c86ddb04b1359a);
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    const $7c240e4106c097e5$export$22c86ddb04b1359a = ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/chat`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: url
        });
    };
});
parcelRegister("5qwUl", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskChatSettings", ()=>$955f7623ed5daf83$export$971347f9ac02f862);
    $parcel$export(module.exports, "default", ()=>$955f7623ed5daf83$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $955f7623ed5daf83$export$971347f9ac02f862 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("kXpVf")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-chat-settings/src/index.tsx"
    });
    var $955f7623ed5daf83$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $955f7623ed5daf83$export$971347f9ac02f862,
            pageId: "project-settings-widget-settings",
            shouldShowSpinner: true
        });
});
parcelRegister("kXpVf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cYnLU").then(()=>parcelRequire('k9vj7'));
});
parcelRegister("34BDN", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskClassicPortalSettings", ()=>$2f67c1468e19aedd$export$eb662b618d6247be);
    $parcel$export(module.exports, "default", ()=>$2f67c1468e19aedd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $2f67c1468e19aedd$export$eb662b618d6247be = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("bixEU"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-classic-portal-settings/src/index.tsx"
    });
    var $2f67c1468e19aedd$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2f67c1468e19aedd$export$eb662b618d6247be,
            pageId: "project-settings-classic-portal-settings",
            shouldShowSpinner: true
        });
});
parcelRegister("bixEU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("35rMy")
    ]).then(()=>parcelRequire('giHe4'));
});
parcelRegister("aZDos", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskCustomerPermissions", ()=>$8d9798e9d24a9632$export$5367e40a24f0bd54);
    $parcel$export(module.exports, "default", ()=>$8d9798e9d24a9632$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $8d9798e9d24a9632$export$5367e40a24f0bd54 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9J1LU"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-customer-permissions/src/index.tsx"
    });
    var $8d9798e9d24a9632$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8d9798e9d24a9632$export$5367e40a24f0bd54,
            pageId: "project-settings-customer-permissions",
            shouldShowSpinner: true
        });
});
parcelRegister("9J1LU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("gNC9e")
    ]).then(()=>parcelRequire('3eQYY'));
});
parcelRegister("tQ1zW", function(module, exports) {
    $parcel$export(module.exports, "customerPermissionsRedirect", ()=>$467404e10c7e501f$export$59eedcca37dbbafd);
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    const $467404e10c7e501f$export$59eedcca37dbbafd = ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/customer-permissions`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: url
        });
    };
});
parcelRegister("3VKX1", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskEmail", ()=>$881ebeec1a2867ea$export$66d0c668045080de);
    $parcel$export(module.exports, "default", ()=>$881ebeec1a2867ea$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kKHTt;
    var $5j7Th;
    var $hPtZI;
    const $881ebeec1a2867ea$export$66d0c668045080de = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("1iNvP")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-email/src/index.tsx"
    });
    var $881ebeec1a2867ea$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kKHTt")).HelpCenterSettingsRedirect), {
            page: "email"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $881ebeec1a2867ea$export$66d0c668045080de,
            pageId: "project-settings-email",
            shouldShowSpinner: true
        }));
});
parcelRegister("1iNvP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("7XRy3")
    ]).then(()=>parcelRequire('gu2ky'));
});
parcelRegister("vzOOJ", function(module, exports) {
    $parcel$export(module.exports, "serviceDeskEmailNextGenRedirect", ()=>$f10a7d047f1802a3$export$86c8da903fb97c4f);
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    const $f10a7d047f1802a3$export$86c8da903fb97c4f = ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/email`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: url
        });
    };
});
parcelRegister("aV9OB", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskExternalLinks", ()=>$15bcce9a01d18cfd$export$28482a53859ec466);
    $parcel$export(module.exports, "default", ()=>$15bcce9a01d18cfd$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $15bcce9a01d18cfd$export$28482a53859ec466 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("lsb3L"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-external-links/src/index.tsx"
    });
    var $15bcce9a01d18cfd$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $15bcce9a01d18cfd$export$28482a53859ec466,
            pageId: "project-settings-external-links",
            shouldShowSpinner: true
        });
});
parcelRegister("lsb3L", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("kEacZ")
    ]).then(()=>parcelRequire('7iBoV'));
});
parcelRegister("7zcmB", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskFeedbackSettings", ()=>$4b8db06fa1ed7bd1$export$ff54bec6c7cb7d47);
    $parcel$export(module.exports, "default", ()=>$4b8db06fa1ed7bd1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $4b8db06fa1ed7bd1$export$3fac45fa34d00981 = 'project/service-desk/settings/index';
    const $4b8db06fa1ed7bd1$export$1aa47348ef6dbdda = 'project/service-desk/settings';
    const $4b8db06fa1ed7bd1$export$ff54bec6c7cb7d47 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("1824v")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-feedback-settings/src/index.tsx"
    });
    var $4b8db06fa1ed7bd1$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4b8db06fa1ed7bd1$export$ff54bec6c7cb7d47,
            pageId: "project-settings-feedback-settings",
            shouldShowSpinner: true
        });
});
parcelRegister("1824v", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("k8jhA").then(()=>parcelRequire('d3uR0'));
});
parcelRegister("3uo46", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskIncidentManagement", ()=>$74652d26314b4bbc$export$7796b6d080b8c187);
    $parcel$export(module.exports, "default", ()=>$74652d26314b4bbc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $74652d26314b4bbc$export$7796b6d080b8c187 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3z8Kq"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-incident-management-settings/src/index.tsx"
    });
    var $74652d26314b4bbc$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $74652d26314b4bbc$export$7796b6d080b8c187,
            pageId: "project-settings-incident-management",
            shouldShowSpinner: true
        });
});
parcelRegister("3z8Kq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("d8OHn")
    ]).then(()=>parcelRequire('gZiIg'));
});
parcelRegister("jNJyR", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskInternalNotifications", ()=>$1956b65a2446b925$export$9c9d293dc6de29d0);
    $parcel$export(module.exports, "default", ()=>$1956b65a2446b925$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $1956b65a2446b925$export$9c9d293dc6de29d0 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5WlEn"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-internal-notifications/src/index.tsx"
    });
    var $1956b65a2446b925$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $1956b65a2446b925$export$9c9d293dc6de29d0,
            pageId: "project-settings-internal-notifications",
            shouldShowSpinner: true
        });
});
parcelRegister("5WlEn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("cYiLE").then(()=>parcelRequire('apjAt'));
});
parcelRegister("e8N9g", function(module, exports) {
    $parcel$export(module.exports, "serviceDeskInternalNotificationsNextGenRedirect", ()=>$68a880eb92a707c3$export$49625f83fe7ecc69);
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    const $68a880eb92a707c3$export$49625f83fe7ecc69 = ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/internal-notifications`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: url
        });
    };
});
parcelRegister("bz1sy", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskItsmFeatures", ()=>$402e11ff5e131d95$export$562be1021beb9882);
    $parcel$export(module.exports, "default", ()=>$402e11ff5e131d95$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $402e11ff5e131d95$export$562be1021beb9882 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5EQvM"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-itsm-features/src/index.tsx"
    });
    var $402e11ff5e131d95$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $402e11ff5e131d95$export$562be1021beb9882,
            pageId: "project-settings-itsm-features",
            shouldShowSpinner: true
        });
});
parcelRegister("5EQvM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("ay8u5")
    ]).then(()=>parcelRequire('dWAhE'));
});
parcelRegister("6xGbx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4c45ee4ab52677ce$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $4c45ee4ab52677ce$export$213b8279037c9d98 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5UxQx"))), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-language-support/src/index.tsx"
    });
    var $4c45ee4ab52677ce$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4c45ee4ab52677ce$export$213b8279037c9d98,
            pageId: "project-settings-language-support",
            shouldShowSpinner: true
        });
});
parcelRegister("5UxQx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3JNwJ").then(()=>parcelRequire('4yiYq'));
});
parcelRegister("lAfKa", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskLanguageTranslations", ()=>$818bcbaaddc8bfd3$export$c029d3f514c7b3e0);
    $parcel$export(module.exports, "default", ()=>$818bcbaaddc8bfd3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $818bcbaaddc8bfd3$export$c029d3f514c7b3e0 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("bmBIM")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-language-translations/src/index.tsx"
    });
    var $818bcbaaddc8bfd3$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $818bcbaaddc8bfd3$export$c029d3f514c7b3e0,
            pageId: "project-settings-language-translations",
            shouldShowSpinner: true
        });
});
parcelRegister("bmBIM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("7tltX")
    ]).then(()=>parcelRequire('kG5x5'));
});
parcelRegister("k1jvb", function(module, exports) {
    $parcel$export(module.exports, "ServiceDeskNotificationEmailNextGenRedirect", ()=>$060e0b1586db8e82$export$735e58642f560ddc);
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    const $060e0b1586db8e82$export$735e58642f560ddc = ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/notification-email`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: url
        });
    };
});
parcelRegister("hJD3V", function(module, exports) {
    $parcel$export(module.exports, "notificationsRedirect", ()=>$d3615143cfedd2aa$export$59144dd4441639fa);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $02Psx;
    var $dIdda = parcelRequire("dIdda");
    const $d3615143cfedd2aa$export$59144dd4441639fa = (pageUrlFragment)=>({ match: match })=>{
            const { projectKey: projectKey } = match.params;
            const url = projectKey !== null && projectKey !== undefined ? `${(0, (0, parcelRequire("02Psx")).getNextgenSettingsUrl)((0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT), projectKey)}/notifications/${pageUrlFragment}` : `/projects/${String(projectKey)}/settings/notifications/${pageUrlFragment}`;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: url,
                push: false
            });
        };
});
parcelRegister("c0aPe", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskPortalSettings", ()=>$9da321ff59a70829$export$fdbd4b1e5ae0e422);
    $parcel$export(module.exports, "default", ()=>$9da321ff59a70829$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $9da321ff59a70829$export$fdbd4b1e5ae0e422 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("coLKx")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-portal-settings/src/index.tsx"
    });
    var $9da321ff59a70829$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9da321ff59a70829$export$fdbd4b1e5ae0e422,
            pageId: "project-settings-portal-settings",
            shouldShowSpinner: true
        });
});
parcelRegister("coLKx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("6XeFg")
    ]).then(()=>parcelRequire('jQFbr'));
});
parcelRegister("b0cvA", function(module, exports) {
    $parcel$export(module.exports, "widgetsNextGenRedirect", ()=>$1ae3adbbf5c00734$export$8ba256148f9b998f);
    var $5uXOq = parcelRequire("5uXOq");
    var $dIdda = parcelRequire("dIdda");
    const $1ae3adbbf5c00734$export$8ba256148f9b998f = ({ match: match })=>{
        const { projectKey: projectKey } = match.params;
        const url = `/jira/servicedesk/projects/${String(projectKey)}/settings/widget`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: url
        });
    };
});
parcelRegister("b2cnG", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsServiceDeskWidgetSettings", ()=>$bf4d9e5ccdf213aa$export$216a049c4d917b0);
    $parcel$export(module.exports, "default", ()=>$bf4d9e5ccdf213aa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $bf4d9e5ccdf213aa$export$216a049c4d917b0 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("ba8Ho")), {
        moduleId: "./src/packages/spa-apps/project-settings/service-desk-widget-settings/src/index.tsx"
    });
    var $bf4d9e5ccdf213aa$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $bf4d9e5ccdf213aa$export$216a049c4d917b0,
            pageId: "project-settings-widget-settings",
            shouldShowSpinner: true
        });
});
parcelRegister("ba8Ho", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("7Qhcd")
    ]).then(()=>parcelRequire('dO6p9'));
});
parcelRegister("3i9aq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55da4849dbdf5d52$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $55da4849dbdf5d52$export$cb608e3696682e76 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("l00Ww"))), {
        moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
    });
    var $55da4849dbdf5d52$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $55da4849dbdf5d52$export$cb608e3696682e76,
            pageId: "project-settings-workflow-navigation",
            shouldShowSpinner: false
        });
});
parcelRegister("2D9P9", function(module, exports) {
    $parcel$export(module.exports, "softwareRouteEntries", ()=>$0acb8447d437de85$export$792d387b9973c378);
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $ffza4;
    var $1xZqw;
    var $65Ltd;
    var $bwLf9;
    var $co1wz;
    var $cSD7y;
    var $lmyls;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $hBv66;
    var $koWFd;
    var $9s3j1;
    var $cD3jo;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $dxCvy;
    var $b5AbL;
    var $e7C7O;
    var $35Wvp;
    var $2FXLN;
    var $7GnDe;
    var $5lsNZ;
    var $5Q4Uy;
    var $d0oNj;
    var $kfztd;
    var $e7bC3;
    var $dIdda = parcelRequire("dIdda");
    var $5GDQc;
    var $jwbRB;
    var $aA5DA;
    var $dtjqc;
    var $gqIYW;
    var $ejqjx;
    var $cYgMq;
    var $kwZwx;
    var $dBDdA;
    var $6UFDl;
    var $kdqX9;
    var $1KQBW;
    var $eNw6s;
    var $9T2qH;
    var $8ODWq;
    var $1XdKx;
    var $lN3Iw;
    var $aXcNG;
    var $8JnjW;
    var $gyEpf;
    var $8Z6ZD;
    var $14B4q;
    var $cNuJO;
    var $4glor;
    const $0acb8447d437de85$var$BoardSettingsRedirectToCSM = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(match.params.boardId)}/columns`,
            push: false
        });
    const $0acb8447d437de85$var$RoadmapSettingsRedirectToTimelineSettings = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/jira/software/projects/${String(match.params.projectKey)}/settings/boards/${String(match.params.boardId)}/timeline`,
            push: false
        });
    const $0acb8447d437de85$var$SpaReleaseNoteRedirectToVersionDetails = ({ query: query })=>{
        const { version: versionId } = query;
        const { loading: loading, error: error, projectKey: projectKey } = (0, (0, parcelRequire("b5AbL")).useProjectKeyByProjectResource)();
        if (loading === false && error) return null;
        if (loading) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: {
                pathname: `/projects/${projectKey}/versions/${versionId}/tab/release-report-all-issues`,
                hash: '',
                search: (0, ($parcel$interopDefault($ebyGx))).stringify({
                    isReleaseNoteModalOpen: true
                })
            }
        });
    };
    const $0acb8447d437de85$var$LegacyFrontendReleaseNoteRedirect = ({ query: query })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: {
                pathname: '/secure/ReleaseNote.jspa',
                hash: '',
                search: (0, ($parcel$interopDefault($ebyGx))).stringify({
                    ...query,
                    isRedirectedFromLegacy: true
                })
            }
        });
    const $0acb8447d437de85$var$ufoNamesMap = {
        'project-settings-software-issuetypes': 'project-settings.issue-type.jsw-tmp',
        'project-settings-servicedesk-issuetypes': 'project-settings.issue-type.jsm-tmp'
    };
    const $0acb8447d437de85$var$getUFOName = (name)=>$0acb8447d437de85$var$ufoNamesMap[name] || name;
    const $0acb8447d437de85$var$commonRouteEntries = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).routeGroupsProjectSettingsSoftwareIssuetypesRoute), ()=>({
                ufoName: $0acb8447d437de85$var$getUFOName(`${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-issuetypes`),
                component: (0, (0, parcelRequire("6UFDl")).default),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("6UFDl")).LazyIssueTypeSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).routeGroupsProjectSettingsSoftwareIssuetypesWorkflowRoute), ()=>({
                component: (0, (0, parcelRequire("cNuJO")).default),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("6UFDl")).LazyIssueTypeSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).routeGroupsProjectSettingsSoftwareAppsFieldsRoute), ()=>({
                component: (0, (0, parcelRequire("5GDQc")).default),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("5GDQc")).LazyConnectAppControlsSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).routeGroupsProjectSettingsSoftwareApps1Route), ()=>({
                component: (0, (0, parcelRequire("jwbRB")).default),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("jwbRB")).LazyConnectAppsSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).routeGroupsProjectSettingsSoftwareDetailsRoute), ()=>({
                component: (0, (0, parcelRequire("cYgMq")).default),
                skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsDetailsSkeleton),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("cYgMq")).LazyDetailsSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).routeGroupsProjectSettingsSoftwareFieldsRoute), ()=>({
                ufoName: 'project-settings.fields.jsw-tmp',
                component: (0, (0, parcelRequire("cSD7y")).componentWithFG)('project_fields_page_for_tmp_-_mvp', (0, (0, parcelRequire("kwZwx")).default), (0, (0, parcelRequire("5lsNZ")).default)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT)),
                    (0, (0, parcelRequire("e7C7O")).fieldSettingsRelayResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("kwZwx")).LazyFieldsSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).routeGroupsProjectSettingsSoftwareAccessRoute), ()=>({
                skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsAccessSkeleton),
                component: (0, (0, parcelRequire("8ODWq")).default),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("8ODWq")).LazyPeopleSettings)
                ],
                ufoName: 'project-settings.access'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).routeGroupsProjectSettingsSoftwareAccessRedirectRoute), ()=>({
                component: (0, (0, parcelRequire("8ODWq")).peopleAccessRedirect)(`/jira/${(0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT)}`),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("8ODWq")).LazyPeopleSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).routeGroupsProjectSettingsSoftwareProformaProjectFormsRoute), ()=>({
                component: (0, (0, parcelRequire("gyEpf")).default),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("gyEpf")).LazyProjectSettingsProformaProjectForms)
                ],
                perfMetricKey: 'forms-settings'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).routeGroupsProjectSettingsSoftwareProformaJiraFormBuilderRoute), ()=>({
                component: (0, (0, parcelRequire("8JnjW")).default),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("8JnjW")).LazyProjectSettingsProformaJiraFormBuilder)
                ],
                perfMetricKey: 'form-builder'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).projectSettingsSoftwareAutomationRoute), ()=>({
                ufoName: `project-settings-automation-${0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT}`,
                component: (0, (0, parcelRequire("kdqX9")).default),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("kdqX9")).LazyProjectSettingsJiraAutomation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).routeGroupsProjectSettingsSoftwareDataClassificationsRoute), ()=>({
                component: (0, (0, parcelRequire("ejqjx")).default),
                skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsDetailsSkeleton),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("ejqjx")).LazyDataClassificationsSettings)
                ]
            }))
    ];
    const $0acb8447d437de85$export$792d387b9973c378 = [
        ...$0acb8447d437de85$var$commonRouteEntries,
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).classicProjectSettingsDetailsRoute), ()=>({
                component: (0, (0, parcelRequire("cYgMq")).default),
                skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsDetailsSkeleton),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("cYgMq")).LazyDetailsSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).routeGroupsProjectSettingsSoftwareNextGenFeaturesRoute), ()=>({
                ufoName: 'project-settings.next-gen-features',
                component: (0, (0, parcelRequire("eNw6s")).default),
                skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsFeaturesSkeleton),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("eNw6s")).LazyFeaturesSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).projectSettingsSoftwareNotificationsRoute), ()=>({
                ufoName: 'project-settings.software.notifications',
                component: (0, (0, parcelRequire("8Z6ZD")).default),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("8Z6ZD")).LazySoftwareNotificationsSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).projectSettingsSoftwareNotificationsIssueLogsRoute), ()=>({
                ufoName: 'project-settings.software.notifications.issue-logs',
                component: (0, (0, parcelRequire("14B4q")).SoftwareNotificationsIssueLogs),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("14B4q")).LazySoftwareNotificationsIssueLogs)
                ],
                entryPoint () {
                    return (0, (0, parcelRequire("co1wz")).ff)('jlovep-692-changes-to-project-settings-notifications-page_jqk18') ? (0, (0, parcelRequire("14B4q")).emailNotificationsLogEntryPointPage) : undefined;
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).projectSettingsOpsgenieRoute), ()=>({
                component: (0, (0, parcelRequire("bwLf9")).default)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, (0, parcelRequire("1KQBW")).default)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("1KQBW")).LazyLinkOpsgeniePage)
                ],
                ufoName: 'project-settings.link-opsgenie'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).classicProjectSettingsOpsgenieRoute), ()=>({
                component: (0, (0, parcelRequire("bwLf9")).default)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, (0, parcelRequire("1KQBW")).default)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("1KQBW")).LazyLinkOpsgeniePage)
                ],
                ufoName: 'project-settings.link-opsgenie'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).projectSettingsToolchainRoute), ()=>({
                component: (0, (0, parcelRequire("bwLf9")).default)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, (0, parcelRequire("aA5DA")).default)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT)),
                    (0, (0, parcelRequire("35Wvp")).projectSettingsToolchainResource)
                ],
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("aA5DA")).LazyDevOpsConnectionsSettings)
                ],
                ufoName: 'project-settings.devops-connections'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).classicProjectSettingsToolchainRoute), ()=>({
                component: (0, (0, parcelRequire("bwLf9")).default)((0, (0, parcelRequire("kfztd")).isDevopsFeatureDisabledInFedRamp), (0, (0, parcelRequire("5lsNZ")).default), (0, (0, parcelRequire("aA5DA")).default)),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("35Wvp")).projectSettingsToolchainResource)
                ],
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("aA5DA")).LazyDevOpsConnectionsSettings)
                ],
                ufoName: 'project-settings.devops-connections'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).classicProjectSettingsFeaturesRoute), ()=>({
                ufoName: 'classic-features-page',
                component: (0, (0, parcelRequire("4glor")).ClassicFeaturesPage),
                skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsFeaturesSkeleton),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("4glor")).LazySoftwareClassicFeatures)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).classicProjectSettingsSoftwareNotificationsIssueLogsRoute), ()=>({
                ufoName: 'project-settings.classic-issue-logs-page',
                component: (0, (0, parcelRequire("14B4q")).SoftwareNotificationsIssueLogs),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("14B4q")).LazySoftwareNotificationsIssueLogs)
                ],
                entryPoint () {
                    return (0, (0, parcelRequire("co1wz")).ff)('jlovep-692-changes-to-project-settings-notifications-page_jqk18') ? (0, (0, parcelRequire("14B4q")).emailNotificationsLogEntryPointPage) : undefined;
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).projectSettingsSoftwareNotificationEmailRoute), ()=>({
                component: (0, (0, parcelRequire("9T2qH")).default),
                skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsFeaturesSkeleton),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("4glor")).LazySoftwareClassicFeatures),
                    (0, (0, parcelRequire("9T2qH")).LazyProjectSettingsNotificationEmail)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).projectSettingsSoftwareNotificationEmail1Route), ()=>({
                component: (0, (0, parcelRequire("1XdKx")).RedirectForSettings),
                skeleton: (0, (0, parcelRequire("d0oNj")).ProjectSettingsFeaturesSkeleton),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).legacyProjectReleasesNoteRoute), ()=>({
                resources: [
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                component: $0acb8447d437de85$var$LegacyFrontendReleaseNoteRedirect,
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).legacyProjectReleasesNoteConfigRoute), ()=>({
                resources: [
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                component: $0acb8447d437de85$var$LegacyFrontendReleaseNoteRedirect,
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).softwareReleaseNotesRoute), ()=>({
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                component: $0acb8447d437de85$var$SpaReleaseNoteRedirectToVersionDetails,
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).routeGroupsProjectSettingsSoftwareAutomationRoute), ()=>({
                component: (0, (0, parcelRequire("kdqX9")).default),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("kdqX9")).LazyProjectSettingsJiraAutomation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).classicProjectSettingsSoftwareProformaFormsRoute), ()=>({
                component: (0, (0, parcelRequire("gyEpf")).default),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("gyEpf")).LazyProjectSettingsProformaProjectForms)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).classicProjectSettingsSoftwareProformaEditFormsRoute), ()=>({
                component: (0, (0, parcelRequire("8JnjW")).default),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("8JnjW")).LazyProjectSettingsProformaJiraFormBuilder)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).projectSettingsSoftwareBoardsRedirectRoute), ()=>({
                component: $0acb8447d437de85$var$BoardSettingsRedirectToCSM,
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                isRedirect: true,
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).projectSettingsSoftwareBoardsCsmRoute), ()=>({
                ufoName: 'software.next-gen.boards.column-status-mapping.page.load',
                component: (0, (0, parcelRequire("dtjqc")).default),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("dtjqc")).LazyCsmSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).projectSettingsSoftwareBoardsCustomFiltersRoute), ()=>({
                ufoName: 'project-settings.custom-filters',
                component: (0, (0, parcelRequire("gqIYW")).default),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT)),
                    (0, (0, parcelRequire("cD3jo")).customFiltersResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("gqIYW")).LazyCustomFiltersSettings)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).projectSettingsSoftwareBoardsCardRoute), ()=>({
                ufoName: 'board-settings-apps.card-cover-settings-page.page.load',
                component: (0, (0, parcelRequire("lN3Iw")).default),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT)),
                    (0, (0, parcelRequire("1xZqw")).cardCoverImageResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("lN3Iw")).LazyCard)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).projectSettingsSoftwareBoardsRoadmapRoute), ()=>({
                component: $0acb8447d437de85$var$RoadmapSettingsRedirectToTimelineSettings,
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT)),
                    (0, (0, parcelRequire("2FXLN")).roadmapSettingsResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("aXcNG")).LazyRoadmap)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).projectSettingsSoftwareBoardsTimelineRoute), ()=>({
                ufoName: 'board-settings-apps.roadmap-settings-page.page.load',
                component: (0, (0, parcelRequire("aXcNG")).default),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT)),
                    (0, (0, parcelRequire("2FXLN")).roadmapSettingsResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("aXcNG")).LazyRoadmap)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).projectSettingsAutomation1Route), ()=>({
                ufoName: 'project-settings-automation-c',
                component: (0, (0, parcelRequire("kdqX9")).default),
                layout: (0, (0, parcelRequire("e7bC3")).classicSoftwareProjectLayoutNoOnboarding),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("hBv66")).genericProjectSidebars),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("kdqX9")).LazyProjectSettingsJiraAutomation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).projectSettingsForgeAppsRoute), ()=>({
                component: (0, (0, parcelRequire("dBDdA")).default),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                    (0, (0, parcelRequire("dxCvy")).projectContextResource),
                    (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                    (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                    (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                    (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
                    ...(0, (0, parcelRequire("dBDdA")).forgeProjectSettingsPageResources)
                ],
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("9s3j1")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("dBDdA")).LazyForgeProjectSettingsPage)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).projectSettingsForgeAppsNextgenRoute), ()=>({
                component: (0, (0, parcelRequire("dBDdA")).default),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT)),
                    ...(0, (0, parcelRequire("dBDdA")).forgeProjectSettingsPageResources)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("dBDdA")).LazyForgeProjectSettingsPage)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).routeGroupsProjectSettingsSoftwareRedirectRoute), ()=>({
                component: (0, (0, parcelRequire("1XdKx")).RedirectForSettings),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("5Q4Uy")).classicProjectSettingsSoftwareRedirectRoute), ()=>({
                component: (0, (0, parcelRequire("1XdKx")).RedirectForSettingsForClassicProject),
                layout: (0, (0, parcelRequire("e7bC3")).softwareProjectLayoutNoOnboarding),
                navigation: {
                    horizontal: (0, $0c2b5b2aa81ed54b$export$712453ef44fd2eba),
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("koWFd")).default),
                    sidebarId: (0, (0, parcelRequire("lmyls")).SIDEBAR_ID).PROJECT_SETTINGS
                },
                resources: [
                    ...(0, (0, parcelRequire("1XdKx")).getSettingsNavigationResources)((0, (0, parcelRequire("1XdKx")).SOFTWARE_PRODUCT))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            }))
    ];
});
parcelRegister("1xZqw", function(module, exports) {
    $parcel$export(module.exports, "cardCoverImageResource", ()=>$0fcabd2255a2311c$export$f37f52e28126ce75);
    var $dXq4S;
    var $ao2h1;
    var $eQDse;
    const $0fcabd2255a2311c$export$f37f52e28126ce75 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $b9b0da783aed9042$export$d9d248919fbd0611),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("eQDse")).default),
                variables: {
                    boardId: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira-software',
                        cloudId: tenantContext.cloudId,
                        resourceType: 'board',
                        resourceId: String(match.params.boardId)
                    })
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("eQDse", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$19be575ffa3b6370$export$2e2bcd8739ae039);
    const $19be575ffa3b6370$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "boardId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "boardId",
                "variableName": "boardId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "id"
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "cardCoverSettingsQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": v1,
                            "concreteType": "BoardScope",
                            "kind": "LinkedField",
                            "name": "boardScope",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "SoftwareBoard",
                                        "kind": "LinkedField",
                                        "name": "board",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "toggle_boardSettingsCard_CardCoverToggle"
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "cardPreview_boardSettingsCard"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.board"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "boardScope"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "cardCoverSettingsQuery",
                "selections": [
                    {
                        "args": v1,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "SoftwareBoard",
                                "kind": "LinkedField",
                                "name": "board",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "CardMediaConfig",
                                        "kind": "LinkedField",
                                        "name": "cardMedia",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "enabled"
                                            }
                                        ]
                                    },
                                    v2
                                ]
                            },
                            v2
                        ]
                    }
                ]
            },
            "params": {
                "id": "4216a4fc24eb7ed0390f1effcdb5558af09a70f95660a0c572ae4b531ddc98fc",
                "metadata": {},
                "name": "cardCoverSettingsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $19be575ffa3b6370$var$node.hash = "eb3068eeffbe9ec2fb99186c54005ea6";
    var $19be575ffa3b6370$export$2e2bcd8739ae039 = $19be575ffa3b6370$var$node;
});
const $b9b0da783aed9042$export$d9d248919fbd0611 = 'BOARD_CONTEXT_CARD_COVER_SETTINGS';
parcelRegister("cD3jo", function(module, exports) {
    $parcel$export(module.exports, "customFiltersResource", ()=>$ca950ad823e84673$export$3e390340716755de);
    var $dXq4S;
    var $ao2h1;
    var $WcCM5;
    const $ca950ad823e84673$export$3e390340716755de = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $ad903674eb868bde$export$5917fd27c14066cd),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("WcCM5")).default),
                variables: {
                    boardId: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira-software',
                        cloudId: tenantContext.cloudId,
                        resourceType: 'board',
                        resourceId: String(match.params.boardId)
                    })
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("WcCM5", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5edc411e6b038299$export$2e2bcd8739ae039);
    const $5edc411e6b038299$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "boardId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "boardId",
                "variableName": "boardId"
            }
        ], v2 = {
            "kind": "ScalarField",
            "name": "id"
        }, v3 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "customFiltersQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": v1,
                            "concreteType": "BoardScope",
                            "kind": "LinkedField",
                            "name": "boardScope",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "CustomFilter",
                                        "kind": "LinkedField",
                                        "name": "customFilters",
                                        "plural": true,
                                        "selections": [
                                            v2,
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "card_projectSettingsCustomFilters_customFilterFragmentRef"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.customFilters"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "card_projectSettingsCustomFilters_boardScopeFragmentRef"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "expandedCard_projectSettingsCustomFilters_boardScopeFragmentRef"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "boardScope"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "customFiltersQuery",
                "selections": [
                    {
                        "args": v1,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "CustomFilter",
                                "kind": "LinkedField",
                                "name": "customFilters",
                                "plural": true,
                                "selections": [
                                    v2,
                                    {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "description"
                                    },
                                    {
                                        "concreteType": "FilterQuery",
                                        "kind": "LinkedField",
                                        "name": "filterQuery",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "sanitisedJql"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "errors"
                                            }
                                        ]
                                    },
                                    v3,
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            },
                            v3,
                            v2
                        ]
                    }
                ]
            },
            "params": {
                "id": "c990befb5021511de9b1550aa7300067f8d87644e0d370c3754283355de50686",
                "metadata": {},
                "name": "customFiltersQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $5edc411e6b038299$var$node.hash = "2c5c0d030a87f3820766a2a896d71275";
    var $5edc411e6b038299$export$2e2bcd8739ae039 = $5edc411e6b038299$var$node;
});
const $ad903674eb868bde$export$5917fd27c14066cd = 'NEXTGEN_PROJECT_SETTINGS_CUSTOM_FILTERS';
parcelRegister("b5AbL", function(module, exports) {
    $parcel$export(module.exports, "useProjectKeyByProjectResource", ()=>$347c2a822ae60413$export$899fd1c46031ece8);
    var $jcw0u;
    var $dIdda = parcelRequire("dIdda");
    var $dxCvy;
    const $347c2a822ae60413$export$899fd1c46031ece8 = (teamName)=>{
        const { data: data, error: resourceError, loading: loading } = (0, $dIdda.useResource)((0, (0, parcelRequire("dxCvy")).projectContextResource));
        if (resourceError && data == null) {
            const isErrorErrorType = resourceError instanceof Error;
            const error = isErrorErrorType ? resourceError : new Error(`projectContextResource returned error resourceError: ${JSON.stringify(resourceError)}, loading: ${loading}, data: null`);
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'useResourceProjectContext',
                    packageName: 'jiraRouterResourcesProjectContext',
                    teamName: teamName ?? 'magma'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            return {
                loading: false,
                error: error,
                projectKey: null
            };
        }
        if (loading) return {
            loading: true,
            error: null,
            projectKey: null
        };
        if (data == null) return {
            loading: false,
            error: new Error('projectContextResource returned data=null when loading false'),
            projectKey: null
        };
        return {
            loading: false,
            projectKey: data.projectKey,
            error: null
        };
    };
});
parcelRegister("35Wvp", function(module, exports) {
    $parcel$export(module.exports, "projectSettingsToolchainResource", ()=>$ed037648996bd812$export$182dfe2bc7c28567);
    var $ao2h1;
    var $avVgl;
    const $ed037648996bd812$export$b8927fea69d9f414 = 'PROJECT_SETTINGS_TOOLCHAIN';
    const $ed037648996bd812$export$182dfe2bc7c28567 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: $ed037648996bd812$export$b8927fea69d9f414,
        getQuery: (_, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("avVgl")).default),
                variables: {
                    cloudId: tenantContext?.cloudId || ''
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("avVgl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5afd24d8f370d3e2$export$2e2bcd8739ae039);
    const $5afd24d8f370d3e2$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            }
        ], v1 = [
            {
                "concreteType": "DvcsQuery",
                "kind": "LinkedField",
                "name": "dvcs",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            },
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 1
                            }
                        ],
                        "concreteType": "DvcsBitbucketWorkspaceConnection",
                        "kind": "LinkedField",
                        "name": "bitbucketWorkspacesLinkedToSite",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "DvcsBitbucketWorkspaceEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ];
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "ui_projectSettingsToolchainQuery",
                "selections": v1,
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "ui_projectSettingsToolchainQuery",
                "selections": v1
            },
            "params": {
                "id": "2fc1f152f5ebcdcb577d22b928c317e308c8daf161c302627c4f00951b909409",
                "metadata": {},
                "name": "ui_projectSettingsToolchainQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $5afd24d8f370d3e2$var$node.hash = "190735208b3c7baafbfc3c1808fa801b";
    var $5afd24d8f370d3e2$export$2e2bcd8739ae039 = $5afd24d8f370d3e2$var$node;
});
parcelRegister("2FXLN", function(module, exports) {
    $parcel$export(module.exports, "roadmapSettingsResource", ()=>$265fc06fbb6443a3$export$7901a008bd73bf46);
    var $dXq4S;
    var $ao2h1;
    var $6VnEZ;
    const $265fc06fbb6443a3$export$7901a008bd73bf46 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: (0, $87d7efe6336d8b83$export$e905b9170ecbb599),
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>{
            const { cloudId: cloudId } = tenantContext;
            return {
                parameters: (0, (0, parcelRequire("6VnEZ")).default),
                variables: {
                    sourceAri: (0, (0, parcelRequire("dXq4S")).createAri)({
                        resourceOwner: 'jira-software',
                        cloudId: cloudId,
                        resourceType: 'board',
                        resourceId: String(match.params.boardId)
                    }),
                    locationAri: undefined
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            };
        }
    });
});
parcelRegister("6VnEZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a28994bc59c1b6c$export$2e2bcd8739ae039);
    const $4a28994bc59c1b6c$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locationAri"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "sourceAri"
        }, v2 = [
            {
                "kind": "Variable",
                "name": "locationARI",
                "variableName": "locationAri"
            },
            {
                "kind": "Variable",
                "name": "sourceARI",
                "variableName": "sourceAri"
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "isSprintsFeatureEnabled"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "roadmapSettingsQuery",
                "selections": [
                    {
                        "concreteType": "RoadmapsQuery",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "RoadmapDetails",
                                "kind": "LinkedField",
                                "name": "roadmapForSource",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "RoadmapConfiguration",
                                            "kind": "LinkedField",
                                            "name": "roadmapConfiguration",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "concreteType": "RoadmapBoardConfiguration",
                                                        "kind": "LinkedField",
                                                        "name": "boardConfiguration",
                                                        "plural": false,
                                                        "selections": [
                                                            v3,
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "childIssuesSchedulingToggle_boardSettingsRoadmap"
                                                            },
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "childIssuesSchedulingPreview_boardSettingsRoadmap"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "roadmaps.roadmapForSource.roadmapConfiguration.boardConfiguration"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "roadmaps.roadmapForSource.roadmapConfiguration"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "roadmapSettingsQuery",
                "selections": [
                    {
                        "concreteType": "RoadmapsQuery",
                        "kind": "LinkedField",
                        "name": "roadmaps",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "RoadmapDetails",
                                "kind": "LinkedField",
                                "name": "roadmapForSource",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "RoadmapConfiguration",
                                        "kind": "LinkedField",
                                        "name": "roadmapConfiguration",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "RoadmapBoardConfiguration",
                                                "kind": "LinkedField",
                                                "name": "boardConfiguration",
                                                "plural": false,
                                                "selections": [
                                                    v3,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "isChildIssuePlanningEnabled"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "childIssuePlanningMode"
                                                    },
                                                    {
                                                        "kind": "ClientExtension",
                                                        "selections": [
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "__id"
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "6603bfc1272bd596fb67b3022210270e42d5bfb54ab2cf66470e7e5a8934ba80",
                "metadata": {},
                "name": "roadmapSettingsQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $4a28994bc59c1b6c$var$node.hash = "31c20159daaa03716587a1ccbe27ab14";
    var $4a28994bc59c1b6c$export$2e2bcd8739ae039 = $4a28994bc59c1b6c$var$node;
});
parcelRegister("5Q4Uy", function(module, exports) {
    $parcel$export(module.exports, "routeGroupsProjectSettingsSoftwareIssuetypesRoute", ()=>$70080ab689503b6b$export$dde867834e4a9f47);
    $parcel$export(module.exports, "routeGroupsProjectSettingsSoftwareIssuetypesWorkflowRoute", ()=>$70080ab689503b6b$export$955e8eef6e3bccfb);
    $parcel$export(module.exports, "routeGroupsProjectSettingsSoftwareAppsFieldsRoute", ()=>$70080ab689503b6b$export$8ddc76f4b4e66b2b);
    $parcel$export(module.exports, "routeGroupsProjectSettingsSoftwareApps1Route", ()=>$70080ab689503b6b$export$d9dea7be10efa583);
    $parcel$export(module.exports, "routeGroupsProjectSettingsSoftwareDetailsRoute", ()=>$70080ab689503b6b$export$18624b8612cb673d);
    $parcel$export(module.exports, "routeGroupsProjectSettingsSoftwareAccessRoute", ()=>$70080ab689503b6b$export$9d5b42fcb82012dd);
    $parcel$export(module.exports, "routeGroupsProjectSettingsSoftwareAccessRedirectRoute", ()=>$70080ab689503b6b$export$d782b5257932a66d);
    $parcel$export(module.exports, "routeGroupsProjectSettingsSoftwareProformaProjectFormsRoute", ()=>$70080ab689503b6b$export$396cdbbd6f2abcea);
    $parcel$export(module.exports, "routeGroupsProjectSettingsSoftwareProformaJiraFormBuilderRoute", ()=>$70080ab689503b6b$export$394d8f4806a90d7);
    $parcel$export(module.exports, "projectSettingsSoftwareAutomationRoute", ()=>$70080ab689503b6b$export$4d430aeb28b702f8);
    $parcel$export(module.exports, "routeGroupsProjectSettingsSoftwareDataClassificationsRoute", ()=>$70080ab689503b6b$export$61d54e538063bb07);
    $parcel$export(module.exports, "routeGroupsProjectSettingsSoftwareNextGenFeaturesRoute", ()=>$70080ab689503b6b$export$a598c3fe8cbf0c6c);
    $parcel$export(module.exports, "projectSettingsSoftwareNotificationsRoute", ()=>$70080ab689503b6b$export$c1d1892d6c07135a);
    $parcel$export(module.exports, "projectSettingsOpsgenieRoute", ()=>$70080ab689503b6b$export$c7039de5a4b78802);
    $parcel$export(module.exports, "classicProjectSettingsSoftwareRedirectRoute", ()=>$70080ab689503b6b$export$99b695c2b8299b5a);
    $parcel$export(module.exports, "classicProjectSettingsDetailsRoute", ()=>$70080ab689503b6b$export$37e0dbac44df25b9);
    $parcel$export(module.exports, "classicProjectSettingsOpsgenieRoute", ()=>$70080ab689503b6b$export$4e4a4b8762b611);
    $parcel$export(module.exports, "projectSettingsToolchainRoute", ()=>$70080ab689503b6b$export$e3e3877ec9c5e840);
    $parcel$export(module.exports, "classicProjectSettingsToolchainRoute", ()=>$70080ab689503b6b$export$7dbc23deac9553d4);
    $parcel$export(module.exports, "classicProjectSettingsFeaturesRoute", ()=>$70080ab689503b6b$export$d4bf23ba6f4199d7);
    $parcel$export(module.exports, "projectSettingsSoftwareNotificationEmailRoute", ()=>$70080ab689503b6b$export$d4ed083331cb6e00);
    $parcel$export(module.exports, "projectSettingsSoftwareNotificationEmail1Route", ()=>$70080ab689503b6b$export$b2e044c3dffeca69);
    $parcel$export(module.exports, "legacyProjectReleasesNoteRoute", ()=>$70080ab689503b6b$export$6ef734887b6da0c8);
    $parcel$export(module.exports, "legacyProjectReleasesNoteConfigRoute", ()=>$70080ab689503b6b$export$a9509017cabb1e30);
    $parcel$export(module.exports, "softwareReleaseNotesRoute", ()=>$70080ab689503b6b$export$a0223091962262d4);
    $parcel$export(module.exports, "routeGroupsProjectSettingsSoftwareAutomationRoute", ()=>$70080ab689503b6b$export$46e979217c179afd);
    $parcel$export(module.exports, "projectSettingsSoftwareNotificationsIssueLogsRoute", ()=>$70080ab689503b6b$export$ff4977f79c273b29);
    $parcel$export(module.exports, "classicProjectSettingsSoftwareNotificationsIssueLogsRoute", ()=>$70080ab689503b6b$export$5e2e0a895d6a14bd);
    $parcel$export(module.exports, "classicProjectSettingsSoftwareProformaFormsRoute", ()=>$70080ab689503b6b$export$2313ca001d58ab27);
    $parcel$export(module.exports, "classicProjectSettingsSoftwareProformaEditFormsRoute", ()=>$70080ab689503b6b$export$811ace4fee984f0e);
    $parcel$export(module.exports, "projectSettingsSoftwareBoardsRedirectRoute", ()=>$70080ab689503b6b$export$989ca67485551616);
    $parcel$export(module.exports, "projectSettingsSoftwareBoardsCsmRoute", ()=>$70080ab689503b6b$export$88e68eb447e3db49);
    $parcel$export(module.exports, "projectSettingsSoftwareBoardsCustomFiltersRoute", ()=>$70080ab689503b6b$export$9bc9b345958a301c);
    $parcel$export(module.exports, "projectSettingsSoftwareBoardsCardRoute", ()=>$70080ab689503b6b$export$d3f185a361401db7);
    $parcel$export(module.exports, "projectSettingsSoftwareBoardsRoadmapRoute", ()=>$70080ab689503b6b$export$17ccdaa366ec26b8);
    $parcel$export(module.exports, "projectSettingsSoftwareBoardsTimelineRoute", ()=>$70080ab689503b6b$export$e116d6b2a5f71426);
    $parcel$export(module.exports, "projectSettingsAutomation1Route", ()=>$70080ab689503b6b$export$ae89a2a3aaf095ef);
    $parcel$export(module.exports, "projectSettingsForgeAppsRoute", ()=>$70080ab689503b6b$export$f74a0b1be9d5b9f6);
    $parcel$export(module.exports, "projectSettingsForgeAppsNextgenRoute", ()=>$70080ab689503b6b$export$8559c4a0b692890e);
    $parcel$export(module.exports, "routeGroupsProjectSettingsSoftwareRedirectRoute", ()=>$70080ab689503b6b$export$7ce9914683cb1572);
    $parcel$export(module.exports, "routeGroupsProjectSettingsSoftwareFieldsRoute", ()=>$70080ab689503b6b$export$ad2c16468a73b68);
    var $65Ltd;
    const $70080ab689503b6b$var$SOFTWARE_PRODUCT = 'software';
    const $70080ab689503b6b$var$projectSettingsUrl = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $70080ab689503b6b$var$boardSettingsUrl = (product)=>`${$70080ab689503b6b$var$projectSettingsUrl(product)}/boards/:boardId`;
    const $70080ab689503b6b$export$dde867834e4a9f47 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-issuetypes`,
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/issuetypes/:issueTypeId?`,
        exact: true
    };
    const $70080ab689503b6b$export$955e8eef6e3bccfb = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-issuetypes-workflow`,
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/issuetypes/:issueTypeId/:initialSection(workflow)`,
        exact: true
    };
    const $70080ab689503b6b$export$8ddc76f4b4e66b2b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_APPS_FIELDS),
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/apps/app-fields`,
        exact: true
    };
    const $70080ab689503b6b$export$d9dea7be10efa583 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-apps`,
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/apps/:appId?`,
        exact: true
    };
    const $70080ab689503b6b$export$18624b8612cb673d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-details`,
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/details`,
        exact: true
    };
    const $70080ab689503b6b$export$9d5b42fcb82012dd = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-access`,
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/access`,
        exact: true
    };
    const $70080ab689503b6b$export$d782b5257932a66d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-access-redirect`,
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/people`,
        exact: true
    };
    const $70080ab689503b6b$export$396cdbbd6f2abcea = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-proforma-project-forms`,
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/forms`,
        exact: true
    };
    const $70080ab689503b6b$export$394d8f4806a90d7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-proforma-jira-form-builder`,
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/forms/form/:templateFormId/edit`,
        exact: true
    };
    const $70080ab689503b6b$export$4d430aeb28b702f8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/automate`
    };
    const $70080ab689503b6b$export$61d54e538063bb07 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-data-classifications`,
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/data-classifications`,
        exact: true
    };
    const $70080ab689503b6b$export$a598c3fe8cbf0c6c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-next-gen-features`,
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/features`,
        exact: true
    };
    const $70080ab689503b6b$export$c1d1892d6c07135a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS),
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/notifications`,
        exact: true
    };
    const $70080ab689503b6b$export$c7039de5a4b78802 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_OPSGENIE),
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/opsgenie`,
        exact: true
    };
    const $70080ab689503b6b$export$99b695c2b8299b5a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE)}-redirect`,
        path: `/jira/${$70080ab689503b6b$var$SOFTWARE_PRODUCT}/c/projects/:projectKey/settings`
    };
    const $70080ab689503b6b$export$37e0dbac44df25b9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_DETAILS),
        path: '/jira/software/c/projects/:projectKey/settings/details',
        exact: true
    };
    const $70080ab689503b6b$export$4e4a4b8762b611 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_OPSGENIE),
        path: '/jira/software/c/projects/:projectKey/settings/opsgenie',
        exact: true
    };
    const $70080ab689503b6b$export$e3e3877ec9c5e840 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_TOOLCHAIN),
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/toolchain`,
        exact: true
    };
    const $70080ab689503b6b$export$7dbc23deac9553d4 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_TOOLCHAIN),
        path: '/jira/software/c/projects/:projectKey/settings/toolchain',
        exact: true
    };
    const $70080ab689503b6b$export$d4bf23ba6f4199d7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_FEATURES),
        path: '/jira/software/c/projects/:projectKey/settings/features',
        exact: true
    };
    const $70080ab689503b6b$export$d4ed083331cb6e00 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATION_EMAIL),
        path: '/jira/software/c/projects/:projectKey/settings/notifications/notification-email',
        exact: true
    };
    const $70080ab689503b6b$export$b2e044c3dffeca69 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATION_EMAIL),
        path: '/jira/software/projects/:projectKey/settings/notifications/notification-email',
        exact: true
    };
    const $70080ab689503b6b$export$6ef734887b6da0c8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE),
        path: '/jira/secure/ReleaseNote.jspa',
        query: [
            'projectId',
            'version'
        ]
    };
    const $70080ab689503b6b$export$a9509017cabb1e30 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_LEGACY_PROJECT_RELEASES_NOTE_CONFIG),
        path: '/secure/ConfigureReleaseNote.jspa',
        query: [
            'projectId',
            'version'
        ]
    };
    const $70080ab689503b6b$export$a0223091962262d4 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_CLASSIC_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_RELEASE_NOTES),
        path: '/secure/ReleaseNote.jspa',
        query: [
            'projectId'
        ]
    };
    const $70080ab689503b6b$export$46e979217c179afd = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-automation`,
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/automation`,
        exact: true
    };
    const $70080ab689503b6b$export$ff4977f79c273b29 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS),
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/notifications/issue-logs`,
        exact: true
    };
    const $70080ab689503b6b$export$5e2e0a895d6a14bd = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_NOTIFICATIONS_ISSUE_LOGS),
        path: '/jira/software/c/projects/:projectKey/settings/notifications/issue-logs',
        query: [
            'projectId'
        ]
    };
    const $70080ab689503b6b$export$2313ca001d58ab27 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_FORMS),
        path: '/jira/software/c/projects/:projectKey/settings/forms',
        exact: true
    };
    const $70080ab689503b6b$export$811ace4fee984f0e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_PROJECT_SETTINGS_SOFTWARE_PROFORMA_EDIT_FORMS),
        path: '/jira/software/c/projects/:projectKey/settings/forms/form/:templateFormId/edit',
        exact: true
    };
    const $70080ab689503b6b$export$989ca67485551616 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_REDIRECT),
        path: `${$70080ab689503b6b$var$boardSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}`,
        exact: true
    };
    const $70080ab689503b6b$export$88e68eb447e3db49 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CSM),
        path: `${$70080ab689503b6b$var$boardSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/columns`,
        exact: true
    };
    const $70080ab689503b6b$export$9bc9b345958a301c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CUSTOM_FILTERS),
        path: `${$70080ab689503b6b$var$boardSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/custom-filters`,
        exact: true
    };
    const $70080ab689503b6b$export$d3f185a361401db7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_CARD),
        path: `${$70080ab689503b6b$var$boardSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/card`,
        exact: true
    };
    const $70080ab689503b6b$export$17ccdaa366ec26b8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_ROADMAP),
        path: `${$70080ab689503b6b$var$boardSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/roadmap`,
        exact: true
    };
    const $70080ab689503b6b$export$e116d6b2a5f71426 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_BOARDS_TIMELINE),
        path: `${$70080ab689503b6b$var$boardSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/timeline`,
        exact: true
    };
    const $70080ab689503b6b$export$ae89a2a3aaf095ef = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_AUTOMATION),
        path: '/jira/software/c/projects/:projectKey/settings/automate'
    };
    const $70080ab689503b6b$export$f74a0b1be9d5b9f6 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS),
        path: '/jira/software/c/projects/:projectKey/settings/apps/:appId/:envId/:route?'
    };
    const $70080ab689503b6b$export$8559c4a0b692890e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_FORGE_APPS_NEXTGEN),
        path: '/jira/software/projects/:projectKey/settings/apps/:appId/:envId/:route?'
    };
    const $70080ab689503b6b$export$7ce9914683cb1572 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: `${(0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE)}-redirect`,
        path: `/jira/${$70080ab689503b6b$var$SOFTWARE_PRODUCT}/projects/:projectKey/settings`
    };
    const $70080ab689503b6b$export$ad2c16468a73b68 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_PROJECT_SETTINGS_SOFTWARE),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_PROJECT_SETTINGS_SOFTWARE_FIELDS),
        path: `${$70080ab689503b6b$var$projectSettingsUrl($70080ab689503b6b$var$SOFTWARE_PRODUCT)}/fields`,
        exact: true
    };
});
parcelRegister("5GDQc", function(module, exports) {
    $parcel$export(module.exports, "LazyConnectAppControlsSettings", ()=>$c49a5a5e07aed0ac$export$246ec9cdadd2a163);
    $parcel$export(module.exports, "default", ()=>$c49a5a5e07aed0ac$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2vSU6;
    var $dAfqg;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $dIdda = parcelRequire("dIdda");
    var $looJs;
    const $c49a5a5e07aed0ac$export$246ec9cdadd2a163 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("9RXCH"))), {
        moduleId: "./src/packages/spa-apps/project-settings/connect-app-controls/src/index.tsx"
    });
    const $c49a5a5e07aed0ac$var$ConnectAppsRedirectInner = ({ match: match, basePath: basePath })=>{
        const { data: projectContext } = (0, (0, parcelRequire("dAfqg")).useProjectContext)();
        const shouldRedirect = projectContext != null && projectContext.simplified && projectContext.projectType === (0, (0, parcelRequire("2vSU6")).SERVICE_DESK_PROJECT);
        return shouldRedirect ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `${basePath}/projects/${String(match.params.projectKey)}/settings/apps/app-fields`,
            push: false
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("looJs")).default), null);
    };
    const $c49a5a5e07aed0ac$export$cc3414a2d9daf70d = (basePath)=>({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement($c49a5a5e07aed0ac$var$ConnectAppsRedirectInner, {
                match: match,
                basePath: basePath
            });
    var $c49a5a5e07aed0ac$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c49a5a5e07aed0ac$export$246ec9cdadd2a163,
            pageId: "project-settings-connect-app-controls",
            shouldShowSpinner: false
        });
});
parcelRegister("looJs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab1da42a9104ecee$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $ab1da42a9104ecee$export$fa3bc297af95f169 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("ghg5c"))), {
        moduleId: "./src/packages/spa-apps/project-settings/app-discovery-settings/src/index.tsx"
    });
    var $ab1da42a9104ecee$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ab1da42a9104ecee$export$fa3bc297af95f169,
            pageId: "project-settings-app-discovery-settings",
            shouldShowSpinner: false
        });
});
parcelRegister("jwbRB", function(module, exports) {
    $parcel$export(module.exports, "LazyConnectAppsSettings", ()=>$0d3ebe2f9030fc49$export$3633e017e520a1c2);
    $parcel$export(module.exports, "default", ()=>$0d3ebe2f9030fc49$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $0d3ebe2f9030fc49$export$3633e017e520a1c2 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("RJn1w"))), {
        moduleId: "./src/packages/spa-apps/project-settings/connect-apps/src/index.tsx"
    });
    var $0d3ebe2f9030fc49$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0d3ebe2f9030fc49$export$3633e017e520a1c2,
            pageId: "project-settings-connect-apps",
            shouldShowSpinner: false
        });
});
parcelRegister("aA5DA", function(module, exports) {
    $parcel$export(module.exports, "LazyDevOpsConnectionsSettings", ()=>$11c79a07a4ec83b8$export$9d468faf674a5201);
    $parcel$export(module.exports, "default", ()=>$11c79a07a4ec83b8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $11c79a07a4ec83b8$export$9d468faf674a5201 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("5Dbz7")), {
        moduleId: "./src/packages/spa-apps/project-settings/connections/src/index.tsx"
    });
    var $11c79a07a4ec83b8$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $11c79a07a4ec83b8$export$9d468faf674a5201,
            pageId: "devops-connections-settings",
            shouldShowSpinner: false
        });
});
parcelRegister("5Dbz7", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jwlH1")
    ]).then(()=>parcelRequire('a0GzC'));
});
parcelRegister("dtjqc", function(module, exports) {
    $parcel$export(module.exports, "LazyCsmSettings", ()=>$f25068ef108ee62d$export$de293ea44d0410ca);
    $parcel$export(module.exports, "default", ()=>$f25068ef108ee62d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $f25068ef108ee62d$export$de293ea44d0410ca = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("haLpa"))), {
        moduleId: "./src/packages/spa-apps/project-settings/csm/src/index.tsx"
    });
    var $f25068ef108ee62d$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f25068ef108ee62d$export$de293ea44d0410ca,
            pageId: "project-settings-csm",
            shouldShowSpinner: false
        });
});
parcelRegister("haLpa", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("fg4hm")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("kPUyC")
    ]).then(()=>parcelRequire('jFUmz'));
});
parcelRegister("gqIYW", function(module, exports) {
    $parcel$export(module.exports, "LazyCustomFiltersSettings", ()=>$26928850e3bfb37f$export$7e21d36a9d4548e6);
    $parcel$export(module.exports, "default", ()=>$26928850e3bfb37f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $26928850e3bfb37f$export$7e21d36a9d4548e6 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("d6oA5")), {
        moduleId: "./src/packages/spa-apps/project-settings/custom-filters/src/index.tsx"
    });
    var $26928850e3bfb37f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $26928850e3bfb37f$export$7e21d36a9d4548e6,
            pageId: "project-settings-custom-filters",
            shouldShowSpinner: true
        });
});
parcelRegister("d6oA5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("3R5lB")
    ]).then(()=>parcelRequire('keIpy'));
});
parcelRegister("ejqjx", function(module, exports) {
    $parcel$export(module.exports, "LazyDataClassificationsSettings", ()=>$81cf21747f4c944d$export$b8abcf8aa8f4df56);
    $parcel$export(module.exports, "default", ()=>$81cf21747f4c944d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $81cf21747f4c944d$export$b8abcf8aa8f4df56 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2igd7"))), {
        moduleId: "./src/packages/spa-apps/project-settings/data-classifications/src/index.tsx"
    });
    var $81cf21747f4c944d$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $81cf21747f4c944d$export$b8abcf8aa8f4df56,
            pageId: "project-settings-data-classifications",
            shouldShowSpinner: false
        });
});
parcelRegister("cYgMq", function(module, exports) {
    $parcel$export(module.exports, "LazyDetailsSettings", ()=>$5dcf6caa5da05571$export$6f16b5efddd5c646);
    $parcel$export(module.exports, "default", ()=>$5dcf6caa5da05571$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $5dcf6caa5da05571$export$6f16b5efddd5c646 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kVevk"))), {
        moduleId: "./src/packages/spa-apps/project-settings/details/src/index.tsx"
    });
    var $5dcf6caa5da05571$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $5dcf6caa5da05571$export$6f16b5efddd5c646,
            pageId: "project-settings-details",
            shouldShowSpinner: false
        });
});
parcelRegister("kwZwx", function(module, exports) {
    $parcel$export(module.exports, "LazyFieldsSettings", ()=>$628b742891e4f718$export$e309780f520d125a);
    $parcel$export(module.exports, "default", ()=>$628b742891e4f718$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $628b742891e4f718$export$e309780f520d125a = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("NWARb"))), {
        moduleId: "./src/packages/spa-apps/project-settings/fields/src/index.tsx"
    });
    var $628b742891e4f718$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $628b742891e4f718$export$e309780f520d125a,
            pageId: "project-settings-fields",
            shouldShowSpinner: true
        });
});
parcelRegister("dBDdA", function(module, exports) {
    $parcel$export(module.exports, "LazyForgeProjectSettingsPage", ()=>$fa6a5556191902b5$export$ef66d3f49a9953d8);
    $parcel$export(module.exports, "forgeProjectSettingsPageResources", ()=>$fa6a5556191902b5$export$33d85a1b2211b38);
    $parcel$export(module.exports, "default", ()=>$fa6a5556191902b5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5bkvv;
    var $dxCvy;
    var $5j7Th;
    var $hPtZI;
    const $fa6a5556191902b5$export$ef66d3f49a9953d8 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("3kJhU")), {
        moduleId: "./src/packages/spa-apps/forge/project-settings/src/index.tsx"
    });
    const $fa6a5556191902b5$export$33d85a1b2211b38 = [
        (0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache),
        (0, (0, parcelRequire("5bkvv")).forgeProjectSettingsModuleResource)
    ];
    const $fa6a5556191902b5$export$b943f48844c671a5 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $fa6a5556191902b5$export$ef66d3f49a9953d8,
            pageId: "forge-spa-project-settings",
            shouldShowSpinner: true
        });
    var $fa6a5556191902b5$export$2e2bcd8739ae039 = $fa6a5556191902b5$export$b943f48844c671a5;
});
parcelRegister("6UFDl", function(module, exports) {
    $parcel$export(module.exports, "LazyIssueTypeSettings", ()=>$8f1b2ea450c47b3b$export$36dcfb52d47cb93a);
    $parcel$export(module.exports, "default", ()=>$8f1b2ea450c47b3b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $8f1b2ea450c47b3b$export$36dcfb52d47cb93a = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("61LFA"))), {
        moduleId: "./src/packages/spa-apps/project-settings/issue-type/src/index.tsx"
    });
    var $8f1b2ea450c47b3b$export$2e2bcd8739ae039 = ({ match: match })=>{
        const { issueTypeId: issueTypeId } = match.params;
        const pageId = `project-settings-issue-types-${String(issueTypeId)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8f1b2ea450c47b3b$export$36dcfb52d47cb93a,
            pageId: pageId,
            shouldShowSpinner: false
        });
    };
});
parcelRegister("kdqX9", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsJiraAutomation", ()=>$4700cd79d99e02ea$export$dea5ad7e8eac12ae);
    $parcel$export(module.exports, "default", ()=>$4700cd79d99e02ea$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $4700cd79d99e02ea$export$dea5ad7e8eac12ae = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("c32Mm")), {
        moduleId: "./src/packages/spa-apps/project-settings/jira-automation/src/index.tsx"
    });
    var $4700cd79d99e02ea$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4700cd79d99e02ea$export$dea5ad7e8eac12ae,
            pageId: "project-settings-jira-automation",
            shouldShowSpinner: true
        });
});
parcelRegister("1KQBW", function(module, exports) {
    $parcel$export(module.exports, "LazyLinkOpsgeniePage", ()=>$dab3ab2feb1de470$export$ca5dba69148b337);
    $parcel$export(module.exports, "default", ()=>$dab3ab2feb1de470$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $dab3ab2feb1de470$export$ca5dba69148b337 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("7rq9z")), {
        moduleId: "./src/packages/spa-apps/project-settings/link-opsgenie/src/index.tsx"
    });
    var $dab3ab2feb1de470$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $dab3ab2feb1de470$export$ca5dba69148b337,
            pageId: "link-opsgenie-page",
            shouldShowSpinner: false
        });
});
parcelRegister("7rq9z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("2h1uc")
    ]).then(()=>parcelRequire('7AMRE'));
});
parcelRegister("eNw6s", function(module, exports) {
    $parcel$export(module.exports, "LazyFeaturesSettings", ()=>$4e545f86ddd60f53$export$da4d608b99858bfc);
    $parcel$export(module.exports, "default", ()=>$4e545f86ddd60f53$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $4e545f86ddd60f53$export$da4d608b99858bfc = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("8DLRI"))), {
        moduleId: "./src/packages/spa-apps/project-settings/next-gen-features/src/index.tsx"
    });
    var $4e545f86ddd60f53$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4e545f86ddd60f53$export$da4d608b99858bfc,
            pageId: "project-settings-next-gen-features",
            shouldShowSpinner: false
        });
});
parcelRegister("8DLRI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6IfzY")
    ]).then(()=>parcelRequire('2MwfB'));
});
parcelRegister("9T2qH", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsNotificationEmail", ()=>$6e8f6f53c599ad60$export$ea7d73c94d9369f4);
    $parcel$export(module.exports, "default", ()=>$6e8f6f53c599ad60$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $6e8f6f53c599ad60$export$ea7d73c94d9369f4 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("bm5Zl"))), {
        moduleId: "./src/packages/spa-apps/project-settings/notification-email/src/index.tsx"
    });
    var $6e8f6f53c599ad60$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6e8f6f53c599ad60$export$ea7d73c94d9369f4,
            pageId: "project-settings-email-notifications",
            shouldShowSpinner: true
        });
});
parcelRegister("8ODWq", function(module, exports) {
    $parcel$export(module.exports, "LazyPeopleSettings", ()=>$3671536b80f548b9$export$7eee4f97b7a1273);
    $parcel$export(module.exports, "peopleAccessRedirect", ()=>$3671536b80f548b9$export$45346ed2aa24e3f3);
    $parcel$export(module.exports, "default", ()=>$3671536b80f548b9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $dIdda = parcelRequire("dIdda");
    const $3671536b80f548b9$export$7eee4f97b7a1273 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("b3T21"))), {
        moduleId: "./src/packages/spa-apps/project-settings/people/src/index.tsx"
    });
    const $3671536b80f548b9$var$PeopleAccessRedirectInner = ({ match: match, basePath: basePath })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `${basePath}/projects/${String(match.params.projectKey)}/settings/access`,
            push: false
        });
    const $3671536b80f548b9$export$45346ed2aa24e3f3 = (basePath)=>({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement($3671536b80f548b9$var$PeopleAccessRedirectInner, {
                match: match,
                basePath: basePath
            });
    var $3671536b80f548b9$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3671536b80f548b9$export$7eee4f97b7a1273,
            pageId: "project-settings-people",
            shouldShowSpinner: false
        });
});
parcelRegister("1XdKx", function(module, exports) {
    $parcel$export(module.exports, "SOFTWARE_PRODUCT", ()=>$3caec8e095a44ec5$export$2954328f6207617a);
    $parcel$export(module.exports, "getSettingsNavigationResources", ()=>$3caec8e095a44ec5$export$586756e5c0542a50);
    $parcel$export(module.exports, "RedirectForSettings", ()=>$3caec8e095a44ec5$export$fb15a6ba8980fdac);
    $parcel$export(module.exports, "RedirectForSettingsForClassicProject", ()=>$3caec8e095a44ec5$export$f9befa0a4925b36d);
    var $5uXOq = parcelRequire("5uXOq");
    var $co1wz;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $1J3t1;
    var $lNicp;
    var $3RJkv;
    var $dxCvy;
    var $fpjJX;
    var $7GnDe;
    var $dIdda = parcelRequire("dIdda");
    const $3caec8e095a44ec5$export$b7262fe486f4b412 = 'core';
    const $3caec8e095a44ec5$export$2954328f6207617a = 'software';
    const $3caec8e095a44ec5$export$5575497f0592ee94 = 'servicedesk';
    const $3caec8e095a44ec5$export$5132c64eefe46250 = (product)=>`/jira/${product}/projects/:projectKey/settings`;
    const $3caec8e095a44ec5$export$586756e5c0542a50 = (product)=>{
        if (product === $3caec8e095a44ec5$export$5575497f0592ee94) return (0, (0, parcelRequire("fpjJX")).getServiceDeskSettingsResources)();
        if (product === $3caec8e095a44ec5$export$b7262fe486f4b412) return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("lNicp")).getBusinessProjectResources)()
        ];
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
            (0, (0, parcelRequire("dxCvy")).projectContextResource),
            (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
            (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
            (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
            (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource),
            ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectSettingsResource)()
        ];
    };
    const $3caec8e095a44ec5$export$fb15a6ba8980fdac = ({ match: match })=>{
        const { data: data } = (0, (0, parcelRequire("1J3t1")).useJiraSoftwareProjectNavigation)();
        const { projectKey: projectKey } = match.params;
        if ((0, (0, parcelRequire("co1wz")).ff)('olympus-da-157-enable-project-settings-navigation_zxaq5')) {
            if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
            });
            if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
            });
            if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/jira/software/projects/${String(match.params.projectKey)}/settings/details`
        });
    };
    const $3caec8e095a44ec5$export$f9befa0a4925b36d = ({ match: match })=>{
        const { data: data } = (0, (0, parcelRequire("1J3t1")).useJiraSoftwareProjectNavigation)();
        const { projectKey: projectKey } = match.params;
        if ((0, (0, parcelRequire("co1wz")).ff)('olympus-da-157-enable-project-settings-navigation_zxaq5')) {
            if (data?.permissionInfo?.isAdmin || data?.permissionInfo?.isSiteAdmin || data?.permissionInfo?.projectPermissionsQueried?.ADMINISTER_PROJECTS) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
            });
            if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_WORKFLOW === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `/plugins/servlet/project-config/${String(projectKey)}/workflows`
            });
            if (data?.permissionInfo?.projectPermissionsQueried?.EDIT_ISSUE_LAYOUT === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `/plugins/servlet/project-config/${String(projectKey)}/issuelayout`
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
            });
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/jira/software/c/projects/${String(projectKey)}/settings/details`
        });
    };
});
parcelRegister("lN3Iw", function(module, exports) {
    $parcel$export(module.exports, "LazyCard", ()=>$4bec2fc264f66dc5$export$40ff283c032abbc4);
    $parcel$export(module.exports, "default", ()=>$4bec2fc264f66dc5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $4bec2fc264f66dc5$export$40ff283c032abbc4 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("juWe0")), {
        moduleId: "./src/packages/spa-apps/project-settings/board-settings/card/src/index.tsx"
    });
    var $4bec2fc264f66dc5$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4bec2fc264f66dc5$export$40ff283c032abbc4,
            pageId: "board-settings-card",
            shouldShowSpinner: false
        });
});
parcelRegister("juWe0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("20nf9")),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gldEF")
    ]).then(()=>parcelRequire('dgQTq'));
});
parcelRegister("aXcNG", function(module, exports) {
    $parcel$export(module.exports, "LazyRoadmap", ()=>$50cd29d3245ccefc$export$8eca5454e72ee961);
    $parcel$export(module.exports, "default", ()=>$50cd29d3245ccefc$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $50cd29d3245ccefc$export$8eca5454e72ee961 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("hR0vX")), {
        moduleId: "./src/packages/spa-apps/project-settings/board-settings/roadmap/src/index.tsx"
    });
    var $50cd29d3245ccefc$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $50cd29d3245ccefc$export$8eca5454e72ee961,
            pageId: "board-settings-roadmap",
            shouldShowSpinner: false
        });
});
parcelRegister("hR0vX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("kO7MH").then(()=>parcelRequire('5d39M'));
});
parcelRegister("8JnjW", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsProformaJiraFormBuilder", ()=>$c3a9ed7dcac6be32$export$a7d63246a10aedd);
    $parcel$export(module.exports, "default", ()=>$c3a9ed7dcac6be32$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $c3a9ed7dcac6be32$export$a7d63246a10aedd = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("9Saqg")), {
        moduleId: "./src/packages/spa-apps/project-settings/proforma-jira-form-builder/src/index.tsx"
    });
    var $c3a9ed7dcac6be32$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $c3a9ed7dcac6be32$export$a7d63246a10aedd,
            pageId: "project-settings-proforma-jira-form-builder",
            shouldShowSpinner: true
        });
});
parcelRegister("gyEpf", function(module, exports) {
    $parcel$export(module.exports, "LazyProjectSettingsProformaProjectForms", ()=>$97406b66ba2de080$export$38414b624a749cec);
    $parcel$export(module.exports, "default", ()=>$97406b66ba2de080$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $97406b66ba2de080$export$38414b624a749cec = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("2Js68")), {
        moduleId: "./src/packages/spa-apps/project-settings/proforma-project-forms/src/index.tsx"
    });
    var $97406b66ba2de080$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $97406b66ba2de080$export$38414b624a749cec,
            pageId: "project-settings-proforma-project-forms",
            shouldShowSpinner: true
        });
});
parcelRegister("8Z6ZD", function(module, exports) {
    $parcel$export(module.exports, "LazySoftwareNotificationsSettings", ()=>$576f902bdb908a77$export$69a64a29d67ca160);
    $parcel$export(module.exports, "default", ()=>$576f902bdb908a77$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $576f902bdb908a77$export$69a64a29d67ca160 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3oy92"))), {
        moduleId: "./src/packages/spa-apps/project-settings/software-notifications/src/index.tsx"
    });
    var $576f902bdb908a77$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $576f902bdb908a77$export$69a64a29d67ca160,
            pageId: "project-settings-software-notifications",
            shouldShowSpinner: false
        });
});
parcelRegister("14B4q", function(module, exports) {
    $parcel$export(module.exports, "emailNotificationsLogEntryPointPage", ()=>$e5cbde6b3cad4f8b$export$cd8964bea0e3c2);
    $parcel$export(module.exports, "LazySoftwareNotificationsIssueLogs", ()=>$e5cbde6b3cad4f8b$export$6960a46ebd209756);
    $parcel$export(module.exports, "SoftwareNotificationsIssueLogs", ()=>$e5cbde6b3cad4f8b$export$4b75df09cc5b4e8e);
    var $5uXOq = parcelRequire("5uXOq");
    var $lkFvK;
    var $lmyls;
    var $femMW;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $e5cbde6b3cad4f8b$export$cd8964bea0e3c2 = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("femMW")).notificationsIssueLogsEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $e5cbde6b3cad4f8b$export$6960a46ebd209756 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1Nsfq"))), {
        moduleId: "./src/packages/spa-apps/project-settings/software-notifications-issue-logs/src/index.tsx"
    });
    const $e5cbde6b3cad4f8b$export$4b75df09cc5b4e8e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e5cbde6b3cad4f8b$export$6960a46ebd209756,
            pageId: "project-settings-software-notifications-issue-logs",
            shouldShowSpinner: false
        });
});
parcelRegister("cNuJO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48f5bfd32d483aba$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $48f5bfd32d483aba$export$cb608e3696682e76 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("l00Ww"))), {
        moduleId: "./src/packages/spa-apps/project-settings/workflow-navigation/src/index.tsx"
    });
    var $48f5bfd32d483aba$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $48f5bfd32d483aba$export$cb608e3696682e76,
            pageId: "project-settings-workflow-navigation",
            shouldShowSpinner: false
        });
});
parcelRegister("4glor", function(module, exports) {
    $parcel$export(module.exports, "LazySoftwareClassicFeatures", ()=>$70eea33e6c09b198$export$79fe16f960f3d89f);
    $parcel$export(module.exports, "ClassicFeaturesPage", ()=>$70eea33e6c09b198$export$8e6f565615e921dd);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $70eea33e6c09b198$export$79fe16f960f3d89f = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2tVe2"))), {
        moduleId: "./src/packages/spa-apps/project-settings/classic-features/src/index.tsx"
    });
    const $70eea33e6c09b198$export$8e6f565615e921dd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $70eea33e6c09b198$export$79fe16f960f3d89f,
            pageId: "classic-features",
            shouldShowSpinner: true
        });
});
parcelRegister("2tVe2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("57yIp")
    ]).then(()=>parcelRequire('hX1AL'));
});
parcelRegister("4biuz", function(module, exports) {
    $parcel$export(module.exports, "servicedeskRouteEntries", ()=>$6b03ae00f6427f42$export$b4944bd787708b82);
    var $5eUyE;
    var $dl4Ut;
    var $19U6C;
    var $jfcsr;
    var $2aC2J;
    var $cTOdl;
    var $l76zI;
    var $joBLj;
    var $iQv5q;
    var $lMbNa;
    var $lGNeL;
    var $cfD6c;
    var $4zmqn;
    var $h2i60;
    var $bX5mt;
    var $bA72A;
    var $Mn8Lz;
    var $1x70f;
    var $6oBRx;
    const $6b03ae00f6427f42$export$b4944bd787708b82 = [
        ...(0, (0, parcelRequire("lGNeL")).knowledgeHubRouteEntries),
        ...(0, (0, parcelRequire("1x70f")).reportsRouteEntries),
        ...(0, (0, parcelRequire("Mn8Lz")).queuesRouteEntries),
        ...(0, (0, parcelRequire("dl4Ut")).boardsRouteEntries),
        ...(0, (0, parcelRequire("iQv5q")).gettingStartedPageRouteEntries),
        ...(0, (0, parcelRequire("6oBRx")).servicesRouteEntries),
        ...(0, (0, parcelRequire("l76zI")).customersRouteEntries),
        ...(0, (0, parcelRequire("bX5mt")).organizationsRouteEntries),
        ...(0, (0, parcelRequire("h2i60")).organizationRouteEntries),
        ...(0, (0, parcelRequire("4zmqn")).oncallRouteEntries),
        ...(0, (0, parcelRequire("jfcsr")).changeCalendarRouteEntries),
        ...(0, (0, parcelRequire("19U6C")).calendarRouteEntries),
        ...(0, (0, parcelRequire("bA72A")).projectSummaryRouteEntries),
        ...(0, (0, parcelRequire("2aC2J")).insightRouteEntries),
        (0, (0, parcelRequire("cfD6c")).notificationLogsRouteEntry),
        (0, (0, parcelRequire("5eUyE")).servicedeskConnectProjectRouteEntry),
        (0, (0, parcelRequire("joBLj")).projectServiceDeskRouteEntry),
        (0, (0, parcelRequire("lMbNa")).servicedeskItsmSampleSpaceRouteEntry),
        (0, (0, parcelRequire("cTOdl")).servicedeskCreateProjectRouteEntry)
    ];
});
parcelRegister("dl4Ut", function(module, exports) {
    $parcel$export(module.exports, "boardsRouteEntries", ()=>$21abfb8c9573f56b$export$97cc5f4d7ce032e1);
    var $ffza4;
    var $6hJYB;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $f5kpo;
    var $bHhiy;
    var $dxCvy;
    var $fpjJX;
    var $f7Y15;
    var $gNStA;
    var $gAdgD;
    var $6Z2mh;
    var $gcguf;
    var $3LSwS;
    const $21abfb8c9573f56b$export$848a32cf0fcf8a61 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("gAdgD")).jsmBoardRoute), ()=>({
            component: (0, (0, parcelRequire("3LSwS")).ServicedeskBoard),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            skeleton: (0, (0, parcelRequire("gcguf")).ClassicBoardSkeleton),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("3LSwS")).LazyServicedeskBoard),
                (0, (0, parcelRequire("3LSwS")).LazyServicedeskLegacyBoardSettings)
            ],
            perfMetricKey: 'servicedesk-boards-load',
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default),
                horizontal: (0, (0, parcelRequire("6hJYB")).AsyncViewsNav),
                horizontalFeatureFlag: 'jsm_views_of_work_phase_1'
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                ...(0, (0, parcelRequire("f5kpo")).getRapidboardResources)(),
                (0, (0, parcelRequire("f5kpo")).getRapidBoardDataResource)(),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>!false, (0, (0, parcelRequire("f7Y15")).uifBoardResource)),
                (0, (0, parcelRequire("dxCvy")).projectContextResource)
            ]
        }));
    const $21abfb8c9573f56b$export$97cc5f4d7ce032e1 = [
        $21abfb8c9573f56b$export$848a32cf0fcf8a61
    ];
});
parcelRegister("6hJYB", function(module, exports) {
    $parcel$export(module.exports, "AsyncViewsNav", ()=>$7a169ab056601f38$export$b43adc74b6a33bde);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $hPtZI;
    const $7a169ab056601f38$var$LazyViewsNav = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("kSJIO")).then(({ ViewsBaseNav: ViewsBaseNav })=>ViewsBaseNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/views/src/ui/index.tsx"
    });
    const $7a169ab056601f38$export$b43adc74b6a33bde = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-jsm-views-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7a169ab056601f38$var$LazyViewsNav, null));
});
parcelRegister("kSJIO", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("boaHK")
    ]).then(()=>parcelRequire('l1Z7j'));
});
parcelRegister("gAdgD", function(module, exports) {
    $parcel$export(module.exports, "jsmBoardRoute", ()=>$5c5a2553f427d19f$export$a192088aab559fa1);
    var $65Ltd;
    const $5c5a2553f427d19f$export$a192088aab559fa1 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/projects/:projectKey/boards/:boardId',
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS),
        exact: true
    };
});
parcelRegister("3LSwS", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskBoard", ()=>$f5ee330ac2d6dd15$export$bb5ed4e7838cf30c);
    $parcel$export(module.exports, "LazyServicedeskLegacyBoardSettings", ()=>$f5ee330ac2d6dd15$export$6828c4b2d0ff0d5d);
    $parcel$export(module.exports, "ServicedeskBoard", ()=>$f5ee330ac2d6dd15$export$f058c0d1561d67f3);
    var $5uXOq = parcelRequire("5uXOq");
    var $ebyGx = parcelRequire("ebyGx");
    var $65Ltd;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    var $dIdda = parcelRequire("dIdda");
    const $f5ee330ac2d6dd15$export$bb5ed4e7838cf30c = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("40EFi"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/board/src/index.tsx"
    });
    const $f5ee330ac2d6dd15$export$6828c4b2d0ff0d5d = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("gf8DN"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/legacy-board-settings/src/index.tsx"
    });
    const $f5ee330ac2d6dd15$export$f058c0d1561d67f3 = (props)=>{
        const { route: route, query: query } = props;
        if (route.name !== (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_BOARDS)) return null;
        const allowedConfigurations = [
            'columns',
            'filter',
            'quickFilters',
            'swimlanes',
            'cardColors',
            'cardLayout',
            'dateFields'
        ];
        if (query.config && !allowedConfigurations.includes(query.config)) {
            const { config: config, ...restQuery } = query;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
                to: {
                    pathname: props.location.pathname,
                    hash: '',
                    search: (0, ($parcel$interopDefault($ebyGx))).stringify({
                        ...restQuery,
                        config: 'columns'
                    })
                }
            });
        }
        return query.config ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f5ee330ac2d6dd15$export$6828c4b2d0ff0d5d,
            pageId: "spa-apps/servicedesk/boards/legacy-board-settings",
            shouldShowSpinner: true
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f5ee330ac2d6dd15$export$bb5ed4e7838cf30c,
            pageId: "spa-apps/servicedesk/boards/board",
            shouldShowSpinner: true
        });
    };
});
parcelRegister("40EFi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("341YM")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6Yvcg")
    ]).then(()=>parcelRequire('fnC5S'));
});
parcelRegister("gf8DN", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("iK5gX")
    ]).then(()=>parcelRequire('lWiJj'));
});
parcelRegister("19U6C", function(module, exports) {
    $parcel$export(module.exports, "calendarRouteEntries", ()=>$f8d239e17d56a4ee$export$6e125037f42a1f62);
    var $4R6GH;
    var $6hJYB;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $jYeNO;
    var $f7Y15;
    var $gNStA;
    var $cF1gE;
    var $6Z2mh;
    var $e9YVH;
    var $hwWDb;
    var $f1mpQ;
    const $f8d239e17d56a4ee$export$6e125037f42a1f62 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cF1gE")).servicedeskCalendarRoute), ()=>({
                ufoName: 'jsm-calendar',
                component: ()=>null,
                skeleton: (0, (0, parcelRequire("hwWDb")).ClassicCalendarSkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, (0, parcelRequire("6hJYB")).AsyncViewsNav),
                    horizontalFeatureFlag: 'jsm_views_of_work_phase_1'
                },
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                    (0, (0, parcelRequire("jYeNO")).getCalendarFilterFieldsResource)(),
                    (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jsd_shield_weekly_view_fast_follow') && !false, (0, (0, parcelRequire("f7Y15")).uifBoardResource))
                ],
                entryPoint: ()=>(0, (0, parcelRequire("f1mpQ")).calendarPageEntryPoint),
                meta: {
                    reporting: {
                        id: 'calendar',
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CALENDAR),
                        teamName: 'jsd-shield'
                    }
                }
            }))
    ];
});
parcelRegister("jYeNO", function(module, exports) {
    $parcel$export(module.exports, "getCalendarFilterFieldsResource", ()=>$4dc70aab7904ddfa$export$5f02bf5f04197ed7);
    $parcel$export(module.exports, "useCalendarFilterResource", ()=>$4dc70aab7904ddfa$export$70361b748d216408);
    var $fZneA;
    var $eusud;
    var $1nb22;
    var $dIdda = parcelRequire("dIdda");
    var $3ezTL;
    var $30Hlr;
    const $4dc70aab7904ddfa$var$fetchFilterFields = async (cloudId, jqlContext)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                body: JSON.stringify({
                    query: (0, $8c2713286c62bdd7$export$2b91517d6d5b4365),
                    variables: {
                        cloudId: cloudId,
                        contextFieldsFilter: {
                            searchString: (0, (0, parcelRequire("3ezTL")).REQUEST_TYPE_FILTER)
                        },
                        jqlContext: jqlContext
                    }
                }),
                headers: {
                    'content-type': 'application/json',
                    'X-ExperimentalApi': 'JiraJqlBuilder'
                }
            });
            return (0, (0, parcelRequire("30Hlr")).transformAndReport)(response);
        } catch (error) {
            if (!(0, (0, parcelRequire("fZneA")).isHttpClientErrorResponse)(error)) (0, (0, parcelRequire("30Hlr")).reportError)(error);
            return 0, (0, parcelRequire("3ezTL")).DEFAULT_CALENDAR_FILTER_FIELDS;
        }
    };
    const $4dc70aab7904ddfa$var$filterFieldsResource = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("3ezTL")).RESOURCE_TYPE_FILTER_FIELD),
        getKey: ()=>(0, (0, parcelRequire("3ezTL")).RESOURCE_TYPE_FILTER_FIELD),
        getData: ({ match: match, query: query }, { tenantContext: { cloudId: cloudId } })=>{
            const { projectKey: projectKey, projectId: projectId } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(match, query);
            const projectIdOrKey = projectKey || projectId;
            const jqlContext = `project = '${projectIdOrKey}'`;
            return $4dc70aab7904ddfa$var$fetchFilterFields(cloudId, jqlContext);
        },
        maxAge: Infinity
    });
    const $4dc70aab7904ddfa$export$5f02bf5f04197ed7 = ()=>$4dc70aab7904ddfa$var$filterFieldsResource;
    const $4dc70aab7904ddfa$export$70361b748d216408 = ()=>(0, $dIdda.useResource)($4dc70aab7904ddfa$var$filterFieldsResource);
});
parcelRegister("3ezTL", function(module, exports) {
    $parcel$export(module.exports, "RESOURCE_TYPE_NAME", ()=>$2fdfca9bb2287268$export$186e93e8ef3f9358);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$2fdfca9bb2287268$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$2fdfca9bb2287268$export$d57b6b390e78d90f);
    $parcel$export(module.exports, "REQUEST_TYPE_FILTER", ()=>$2fdfca9bb2287268$export$2c388650eabddf5e);
    $parcel$export(module.exports, "RESOURCE_TYPE_FILTER_FIELD", ()=>$2fdfca9bb2287268$export$2019de80301f1da);
    $parcel$export(module.exports, "DEFAULT_CALENDAR_FILTER_FIELDS", ()=>$2fdfca9bb2287268$export$2912f30d4328fc00);
    const $2fdfca9bb2287268$export$186e93e8ef3f9358 = 'calendarFilterFieldResource';
    const $2fdfca9bb2287268$export$b8b9d90f9e5bd72b = 'jiraRouterResourcesServicedeskCalendar';
    const $2fdfca9bb2287268$export$d57b6b390e78d90f = 'jsd-shield';
    const $2fdfca9bb2287268$export$2c388650eabddf5e = 'request type';
    const $2fdfca9bb2287268$export$2019de80301f1da = 'RESOURCE_TYPE_FILTER_FIELD';
    const $2fdfca9bb2287268$export$2912f30d4328fc00 = [
        'status',
        'assignee'
    ];
});
const $8c2713286c62bdd7$export$2b91517d6d5b4365 = `
query findRequestTypeCustomFieldQuery($cloudId: ID!, $contextFieldsFilter: JiraJQLContextFieldsFilter!, $jqlContext: String!) {
  jira {
    jqlBuilder(cloudId: $cloudId) {
        fields(jqlContextFieldsFilter: $contextFieldsFilter, jqlContext: $jqlContext) {
          ... on JiraJqlFieldConnection {
            __typename
            edges {
              node {
                jqlTerm
                displayName
                type
                searchTemplate {
                  key
                }
                operators
              }
            }
          }
          ... on QueryError {
            __typename
          }
        }
      }
  }
}
`;
parcelRegister("30Hlr", function(module, exports) {
    $parcel$export(module.exports, "TARGET_FILTER_TYPE", ()=>$f86becf4a18b4f1f$export$64f54b13b7aea793);
    $parcel$export(module.exports, "reportError", ()=>$f86becf4a18b4f1f$export$b33b857ad1d9900e);
    $parcel$export(module.exports, "transformAndReport", ()=>$f86becf4a18b4f1f$export$af2aa11c88c551af);
    var $jcw0u;
    var $3ezTL;
    const $f86becf4a18b4f1f$export$64f54b13b7aea793 = 'com.atlassian.servicedesk:vp-origin';
    const $f86becf4a18b4f1f$var$TARGET_FILTER_SEARCH_TEMPLATE = 'com.atlassian.servicedesk:vp-origin-searcher';
    const $f86becf4a18b4f1f$export$b33b857ad1d9900e = (error)=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            meta: {
                id: (0, (0, parcelRequire("3ezTL")).RESOURCE_TYPE_NAME),
                packageName: (0, (0, parcelRequire("3ezTL")).PACKAGE_NAME),
                teamName: (0, (0, parcelRequire("3ezTL")).TEAM_NAME)
            }
        });
    };
    const $f86becf4a18b4f1f$export$af2aa11c88c551af = (response)=>{
        const edges = response.data?.jira?.jqlBuilder?.fields?.edges;
        const requestType = edges?.find((edge)=>edge?.node?.type === $f86becf4a18b4f1f$export$64f54b13b7aea793 && edge?.node?.searchTemplate?.key === $f86becf4a18b4f1f$var$TARGET_FILTER_SEARCH_TEMPLATE)?.node;
        if (!requestType) $f86becf4a18b4f1f$export$b33b857ad1d9900e(new Error('Unable to prefetch request type'));
        return requestType ? [
            {
                ...requestType,
                searchTemplate: requestType.searchTemplate.key,
                fieldType: requestType.type
            },
            ...(0, (0, parcelRequire("3ezTL")).DEFAULT_CALENDAR_FILTER_FIELDS)
        ] : (0, (0, parcelRequire("3ezTL")).DEFAULT_CALENDAR_FILTER_FIELDS);
    };
});
parcelRegister("cF1gE", function(module, exports) {
    $parcel$export(module.exports, "servicedeskCalendarRoute", ()=>$27449eef2998018e$export$28a386a00670c893);
    var $65Ltd;
    const $27449eef2998018e$export$28a386a00670c893 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CALENDAR),
        path: '/jira/servicedesk/projects/:projectKey/boards/:boardId/calendar',
        exact: true
    };
});
parcelRegister("hwWDb", function(module, exports) {
    $parcel$export(module.exports, "ClassicCalendarSkeleton", ()=>$56d7fe900d1fd6dd$export$49d3670908a8d8fe);
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $9JSfC = parcelRequire("9JSfC");
    const $56d7fe900d1fd6dd$export$49d3670908a8d8fe = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($9JSfC)))
        });
});
parcelRegister("9JSfC", function(module, exports) {
    module.exports = new URL("classic-calendar-skeleton.tpl.3dcfde16.svg", import.meta.url).toString();
});
parcelRegister("f1mpQ", function(module, exports) {
    $parcel$export(module.exports, "calendarPageEntryPoint", ()=>$c3ff53bf28ecf1c9$export$eda0c2fb67f7d7e7);
    var $lkFvK;
    var $lmyls;
    var $faaUu;
    const $c3ff53bf28ecf1c9$export$eda0c2fb67f7d7e7 = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("faaUu")).calendarEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
});
parcelRegister("faaUu", function(module, exports) {
    $parcel$export(module.exports, "calendarEntryPoint", ()=>$d491739a1b7483c1$export$19cf4b398f638dc6);
    var $4R6GH;
    var $7JhZX;
    var $2Ftxm;
    var $ikgNX;
    const $d491739a1b7483c1$var$ISSUE_SEARCH_INPUT_STORAGE_KEY = 'calendar-issue-search-input';
    const $d491739a1b7483c1$var$VIEW_SETTINGS_STORAGE_KEY = 'calendar-view-settings';
    const $d491739a1b7483c1$var$DEFAULT_DAY_STARTS_AT = '09:00 AM';
    function $d491739a1b7483c1$var$toBoardAri({ siteId: siteId, boardId: boardId }) {
        return `ari:cloud:jira-software:${siteId}:board/${boardId}`;
    }
    function $d491739a1b7483c1$var$toMidnightUTCString(date) {
        const utcMilliseconds = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
        return new Date(utcMilliseconds).toISOString();
    }
    function $d491739a1b7483c1$var$toDate(date) {
        if (!date) return new Date();
        try {
            const _date = new Date(date);
            return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
        } catch (e) {
            return new Date();
        }
    }
    function $d491739a1b7483c1$var$createScope({ context: context, tenantContext: tenantContext }, viewId) {
        const { cloudId: cloudId } = tenantContext;
        return {
            type: 'board',
            boardId: $d491739a1b7483c1$var$toBoardAri({
                siteId: cloudId,
                boardId: String(context.match.params.boardId)
            }),
            projectKeys: [
                String(context.match.params.projectKey)
            ],
            viewId: viewId
        };
    }
    function $d491739a1b7483c1$var$buildScopeInput({ tenantContext: tenantContext }, scope) {
        const { cloudId: cloudId } = tenantContext;
        return {
            ids: [
                scope.boardId
            ],
            projectKeys: {
                cloudId: cloudId,
                keys: scope.projectKeys
            }
        };
    }
    function $d491739a1b7483c1$var$toViewMode(mode) {
        switch(mode){
            case 'week':
                return 'WEEK';
            case 'day':
                return 'DAY';
            default:
                return 'MONTH';
        }
    }
    function $d491739a1b7483c1$var$toWeekStart(weekStart) {
        switch(weekStart){
            case 'monday':
                return 'MONDAY';
            case 'saturday':
                return 'SATURDAY';
            default:
                return 'SUNDAY';
        }
    }
    function $d491739a1b7483c1$var$buildConfigurationInput({ selectedDate: selectedDate, viewRange: viewRange, weekStartsOn: weekStartsOn, viewId: viewId }) {
        return {
            date: $d491739a1b7483c1$var$toMidnightUTCString(selectedDate),
            mode: $d491739a1b7483c1$var$toViewMode(viewRange),
            weekStart: $d491739a1b7483c1$var$toWeekStart(weekStartsOn),
            viewId: viewId
        };
    }
    function $d491739a1b7483c1$var$buildStorageKey({ cloudId: cloudId, activationId: activationId, boardId: boardId, featureKey: featureKey }) {
        const viewId = $d491739a1b7483c1$var$buildViewId({
            cloudId: cloudId,
            activationId: activationId,
            boardId: boardId
        });
        const LOCALSTORAGE_KEY_PREFIX = 'persist:calendar';
        return `${LOCALSTORAGE_KEY_PREFIX}/view/${viewId}/${featureKey}`;
    }
    function $d491739a1b7483c1$var$getStorageValue(storageKey) {
        if (typeof window !== 'undefined') return localStorage?.getItem(storageKey) || '';
        return '';
    }
    function $d491739a1b7483c1$var$buildIssuesSearchInput(storageKey) {
        return {
            additionalFilterQuery: $d491739a1b7483c1$var$getStorageValue(storageKey) || ''
        };
    }
    function $d491739a1b7483c1$var$buildUnscheduledIssuesSearchInput() {
        return {
            additionalFilterQuery: ''
        };
    }
    function $d491739a1b7483c1$var$buildVersionsSearchInput() {
        return {
            versionStatuses: [
                'RELEASED',
                'UNRELEASED'
            ]
        };
    }
    function $d491739a1b7483c1$var$buildSprintsSearchInput() {
        return {
            sprintStates: [
                'ACTIVE',
                'FUTURE',
                'CLOSED'
            ]
        };
    }
    function $d491739a1b7483c1$var$buildViewId({ cloudId: cloudId, activationId: activationId, boardId: boardId }) {
        return `ari:cloud:jira:${cloudId}:view/activation/${activationId}/board/${boardId}`;
    }
    const $d491739a1b7483c1$export$19cf4b398f638dc6 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("5H96Q")), {
            moduleId: "7a55ad65"
        }),
        getPreloadProps: (entryPointRouteParams)=>{
            const { context: context, tenantContext: tenantContext } = entryPointRouteParams;
            const { cloudId: cloudId, activationId: activationId } = tenantContext;
            const { date: date } = context.query;
            const selectedDate = $d491739a1b7483c1$var$toDate(date);
            const { boardId: boardId, projectKey: projectKey } = context.match.params;
            if (!boardId || !projectKey) throw new Error('boardId and projectKey must be provided.');
            const viewId = $d491739a1b7483c1$var$buildViewId({
                cloudId: cloudId,
                activationId: activationId,
                boardId: boardId
            });
            const scope = $d491739a1b7483c1$var$createScope(entryPointRouteParams, viewId || '');
            const storageKeyForIssueSearchInput = $d491739a1b7483c1$var$buildStorageKey({
                cloudId: cloudId,
                activationId: activationId,
                boardId: boardId,
                featureKey: $d491739a1b7483c1$var$ISSUE_SEARCH_INPUT_STORAGE_KEY
            });
            const storageKeyForViewSettings = $d491739a1b7483c1$var$buildStorageKey({
                cloudId: cloudId,
                activationId: activationId,
                boardId: boardId,
                featureKey: $d491739a1b7483c1$var$VIEW_SETTINGS_STORAGE_KEY
            });
            const defaultViewRange = 'month';
            const storedConfig = $d491739a1b7483c1$var$getStorageValue(storageKeyForViewSettings);
            const viewSettingsConfig = storedConfig ? JSON.parse(storedConfig) : {
                viewRange: defaultViewRange,
                weekStartsOn: null,
                dayStartsAt: $d491739a1b7483c1$var$DEFAULT_DAY_STARTS_AT,
                showWeekends: false,
                showIssueKey: true,
                showIn24HourClock: false,
                colorBy: 'status'
            };
            const viewRange = (0, (0, parcelRequire("4R6GH")).fg)('jsd_shield_jsm_calendar_weekly_view') ? viewSettingsConfig.viewRange ?? 'month' : 'month';
            const weekStartsOn = viewSettingsConfig.weekStartsOn ?? 'sunday';
            const colorBy = viewSettingsConfig.colorBy ?? 'status';
            const startDateField = 'startdate';
            const endDateField = 'duedate';
            const issueEventFields = {
                startDateField: startDateField,
                endDateField: endDateField
            };
            const issuesSearchInput = $d491739a1b7483c1$var$buildIssuesSearchInput(storageKeyForIssueSearchInput);
            return {
                queries: {
                    calendarData: {
                        options: {
                            fetchPolicy: 'network-only'
                        },
                        parameters: (0, parcelRequire("7JhZX")).default,
                        variables: {
                            cloudId: cloudId,
                            scopeInput: $d491739a1b7483c1$var$buildScopeInput(entryPointRouteParams, scope),
                            configurationInput: $d491739a1b7483c1$var$buildConfigurationInput({
                                selectedDate: selectedDate,
                                viewRange: viewRange,
                                weekStartsOn: weekStartsOn,
                                viewId: viewId
                            }),
                            issuesSearchInput: issuesSearchInput,
                            unscheduledIssuesSearchInput: $d491739a1b7483c1$var$buildUnscheduledIssuesSearchInput(),
                            versionsSearchInput: $d491739a1b7483c1$var$buildVersionsSearchInput(),
                            sprintsSearchInput: $d491739a1b7483c1$var$buildSprintsSearchInput(),
                            skipSprintSearch: false,
                            skipVersionSearch: false,
                            viewId: viewId,
                            ...(0, (0, parcelRequire("4R6GH")).fg)('jsd_shield_jsm_calendar_weekly_view') && {
                                skipFieldConfig: false
                            },
                            schedulePermissionsEnabled: (0, (0, parcelRequire("4R6GH")).fg)('calendar_schedule_issue_permissions_check')
                        }
                    }
                },
                entryPoints: {},
                extraProps: {
                    scope: scope,
                    selectedDate: selectedDate,
                    viewRange: viewRange,
                    weekStartsOn: weekStartsOn,
                    dayStartsAt: viewSettingsConfig.dayStartsAt,
                    issueEventFields: issueEventFields,
                    projectKey: projectKey,
                    storageKeyForViewSettings: storageKeyForViewSettings,
                    storageKeyForIssueSearchInput: storageKeyForIssueSearchInput,
                    showWeekends: viewSettingsConfig.showWeekends,
                    showIssueKey: viewSettingsConfig.showIssueKey,
                    showIn24HourClock: viewSettingsConfig.showIn24HourClock,
                    colorBy: colorBy
                }
            };
        }
    });
});
parcelRegister("5H96Q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("1QoV7")
    ]).then(()=>parcelRequire('2hdB5'));
});
parcelRegister("jfcsr", function(module, exports) {
    $parcel$export(module.exports, "changeCalendarRouteEntries", ()=>$788999c1ce4d32cc$export$38a3aa80b813d565);
    var $ffza4;
    var $co1wz;
    var $1cxvE;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $2pT4g;
    var $fpjJX;
    var $gNStA;
    var $8obNZ;
    var $6Z2mh;
    var $e9YVH;
    var $cOMjN;
    const $788999c1ce4d32cc$export$38a3aa80b813d565 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("8obNZ")).servicedeskChangeCalendarRoute), ()=>({
                ufoName: 'service-management.change-calendar',
                component: (0, (0, parcelRequire("cOMjN")).default),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, (0, parcelRequire("1cxvE")).AsyncJSMOperationsHorizontalNav),
                    onlyShowHorizontalOnNav4: true
                },
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                    (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('enable_jsm_repackaging_changes_vtwk9'), (0, (0, parcelRequire("2pT4g")).jsmRepackagingBannerResource))
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("cOMjN")).LazyChangeCalendar),
                    (0, (0, parcelRequire("1cxvE")).LazyJSMOperationsHorizontalNav)
                ],
                meta: {
                    reporting: {
                        id: 'changeCalendar',
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CHANGE_CALENDAR),
                        teamName: 'jenga'
                    }
                }
            }))
    ];
});
parcelRegister("1cxvE", function(module, exports) {
    $parcel$export(module.exports, "LazyJSMOperationsHorizontalNav", ()=>$f4b0e9313c9342f0$export$d9802671a2b1aa20);
    $parcel$export(module.exports, "AsyncJSMOperationsHorizontalNav", ()=>$f4b0e9313c9342f0$export$d4493569f106c71);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $hPtZI;
    const $f4b0e9313c9342f0$export$d9802671a2b1aa20 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("9SdDk")).then(({ JSMOperationsHorizontalNav: JSMOperationsHorizontalNav })=>JSMOperationsHorizontalNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/operations/src/ui/index.tsx"
    });
    const $f4b0e9313c9342f0$export$d4493569f106c71 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-operations-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "asyncHorizontalOperationsNav",
            packageName: "jiraHorizontalNavJsmOperations",
            fallback: "flag",
            teamName: "alexstrasza"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f4b0e9313c9342f0$export$d9802671a2b1aa20, null)));
});
parcelRegister("9SdDk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("ii98U")
    ]).then(()=>parcelRequire('6vvjk'));
});
parcelRegister("8obNZ", function(module, exports) {
    $parcel$export(module.exports, "servicedeskChangeCalendarRoute", ()=>$fbae9ba8fa6eccc0$export$3dbc16ae422c469);
    var $65Ltd;
    const $fbae9ba8fa6eccc0$export$3dbc16ae422c469 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CHANGE_CALENDAR),
        path: '/jira/servicedesk/projects/:projectKey/change-calendar',
        exact: true
    };
});
parcelRegister("cOMjN", function(module, exports) {
    $parcel$export(module.exports, "LazyChangeCalendar", ()=>$f705f6e0ca7ffaf5$export$a6cec2d1c2e631eb);
    $parcel$export(module.exports, "default", ()=>$f705f6e0ca7ffaf5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $f705f6e0ca7ffaf5$export$a6cec2d1c2e631eb = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4uj5r"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/change-calendar/src/index.tsx"
    });
    var $f705f6e0ca7ffaf5$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f705f6e0ca7ffaf5$export$a6cec2d1c2e631eb,
            pageId: "spa-apps/servicedesk/change-calendar",
            shouldShowSpinner: true
        });
});
parcelRegister("4uj5r", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("41TKw")
    ]).then(()=>parcelRequire('4cmmO'));
});
parcelRegister("2aC2J", function(module, exports) {
    $parcel$export(module.exports, "insightRouteEntries", ()=>$e1936f201d69a18a$export$5d38cb53852f589a);
    var $ffza4;
    var $65Ltd;
    var $7XYc4;
    var $9QpK7;
    var $4R6GH;
    var $2BrOV;
    var $lmyls;
    var $72NwO;
    var $3HwlS;
    var $2G9Bk;
    var $6j0IA;
    var $3RJkv;
    var $fpjJX;
    var $8naTI;
    var $gNStA;
    var $5lsNZ;
    var $aGpoe;
    var $e9YVH;
    var $gRzZD;
    var $ac6Qh;
    var $b93Zs;
    var $gXGYk;
    var $ia3qM;
    var $8lolW;
    var $2iVq4;
    var $2vrwM;
    var $ceEFi;
    const $e1936f201d69a18a$var$sharedRouteProps = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        layout: (0, (0, parcelRequire("2BrOV")).globalLayout),
        navigation: {
            menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).INSIGHT
        }
    };
    function $e1936f201d69a18a$var$getCmdbResources() {
        const servicedeskPageContextResources = (0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)().map((resource)=>(0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("4R6GH")).fg)('add_service_desk_page_context_resources'), resource));
        return [
            ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
            ...servicedeskPageContextResources,
            (0, (0, parcelRequire("gRzZD")).workspaceResource)
        ];
    }
    const $e1936f201d69a18a$export$5d38cb53852f589a = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aGpoe")).servicedeskCmdbAssetsRoute), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, (0, parcelRequire("ia3qM")).default),
                resources: $e1936f201d69a18a$var$getCmdbResources(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("ia3qM")).LazyServicedeskCmdbLandingPage)
                ],
                perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aGpoe")).servicedeskCmdbInsightRoute), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, (0, parcelRequire("ia3qM")).default),
                resources: $e1936f201d69a18a$var$getCmdbResources(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("ia3qM")).LazyServicedeskCmdbLandingPage)
                ],
                perfMetricKey: 'service-management.insight-cmdb.interact-with-landing-page'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aGpoe")).servicedeskCmdbAssetsDefaultRedirect), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("ceEFi")).AssetsReportsNav4HomePage), (0, (0, parcelRequire("ceEFi")).AssetsReportingDefaultRedirect)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("gRzZD")).workspaceResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("ceEFi")).LazyServicedeskCmdbDefaultReportsRedirect),
                    (0, (0, parcelRequire("ceEFi")).LazyServicedeskCmdbAssetsReportsNav4HomePage)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_ASSETS_REPORTS_DEFAULT_REDIRECT),
                        teamName: 'ITSM SAGA'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aGpoe")).servicedeskCmdbAssetsReportsRoute), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, (0, parcelRequire("9QpK7")).componentWithFF)('jsm-assets-reporting_seqk0', (0, (0, parcelRequire("ceEFi")).AssetsReports), (0, (0, parcelRequire("5lsNZ")).default)),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("gRzZD")).workspaceResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("ceEFi")).LazyServicedeskCmdbAssetsReports)
                ],
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PEOPLE,
                    sidebar: (0, (0, parcelRequire("72NwO")).default)
                },
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_ASSETS_REPORTS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_ASSETS_REPORTS),
                        teamName: 'ITSM SAGA'
                    }
                },
                perfMetricKey: 'service-management.insight-cmdb.load-assets-reports-template'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aGpoe")).servicedeskCmdbAssetsReportsUnsubscribeRoute), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, (0, parcelRequire("ceEFi")).AssetsReportsUnsubscribe),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("gRzZD")).workspaceResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("ceEFi")).LazyServicedeskCmdbAssetsReportsUnsubscribe)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_ASSETS_REPORTS_UNSUBSCRIBE),
                        teamName: 'ITSM SAGA'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aGpoe")).servicedeskCmdbAssetsObjectSchema1Route), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, (0, parcelRequire("2iVq4")).ObjectSchemaV2),
                resources: $e1936f201d69a18a$var$getCmdbResources(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("2iVq4")).LazyServicedeskCmdbObjectSchemaV2)
                ],
                perfMetricKey: 'service-management.insight-cmdb.load-schema-page'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aGpoe")).servicedeskCmdbInsightObjectSchemaRoute), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, (0, parcelRequire("2iVq4")).ObjectSchemaV2),
                resources: $e1936f201d69a18a$var$getCmdbResources(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("2iVq4")).LazyServicedeskCmdbObjectSchemaV2)
                ],
                perfMetricKey: 'service-management.insight-cmdb.load-schema-page'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aGpoe")).servicedeskCmdbAssetsObjectTypeConfigurationRoute), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, (0, parcelRequire("b93Zs")).default),
                resources: $e1936f201d69a18a$var$getCmdbResources(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("b93Zs")).LazyServicedeskCmdbConfigureObjectType)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                        teamName: 'falcons'
                    }
                },
                ufoName: 'service-management.insight-cmdb-object-type-configuration'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aGpoe")).servicedeskCmdbInsightObjectTypeConfigurationRoute), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, (0, parcelRequire("b93Zs")).default),
                resources: $e1936f201d69a18a$var$getCmdbResources(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("b93Zs")).LazyServicedeskCmdbConfigureObjectType)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_OBJECT_TYPE_CONFIGURATION),
                        teamName: 'falcons'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aGpoe")).servicedeskCmdbAssetsConfigureRoute), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                ufoName: 'servicedesk-cmdb-assets-configure',
                component: (0, (0, parcelRequire("gXGYk")).default),
                resources: $e1936f201d69a18a$var$getCmdbResources(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("gXGYk")).LazyServicedeskCmdbGlobalConfigure)
                ],
                perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                        teamName: 'falcons'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aGpoe")).servicedeskCmdbInsightConfigureGlobalRoute), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                ufoName: 'servicedesk-cmdb-insight-configure-global',
                component: (0, (0, parcelRequire("gXGYk")).default),
                resources: $e1936f201d69a18a$var$getCmdbResources(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("gXGYk")).LazyServicedeskCmdbGlobalConfigure)
                ],
                perfMetricKey: 'service-management.insight-cmdb.interact-with-global-config-page',
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION),
                        teamName: 'falcons'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aGpoe")).servicedeskCmdbAssetsObjectSchemaConfigurationRoute), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, (0, parcelRequire("2vrwM")).default),
                resources: [
                    ...$e1936f201d69a18a$var$getCmdbResources(),
                    (0, (0, parcelRequire("6j0IA")).serviceDeskAssetsImportTypeForgeDataResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("2vrwM")).LazyServicedeskCmdbObjectSchemaConfiguration)
                ],
                perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                        teamName: 'krispy-krew'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aGpoe")).servicedeskCmdbInsightObjectSchemaConfigurationRoute), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, (0, parcelRequire("2vrwM")).default),
                resources: $e1936f201d69a18a$var$getCmdbResources(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("2vrwM")).LazyServicedeskCmdbObjectSchemaConfiguration)
                ],
                perfMetricKey: 'service-management.insight-cmdb.interact-with-object-schema-config',
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_GLOBAL_CONFIGURATION,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
                        teamName: 'krispy-krew'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aGpoe")).servicedeskCmdbInsightConfigureRoute), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                ufoName: 'servicedesk-cmdb-insight-configure',
                component: (0, (0, parcelRequire("ac6Qh")).default),
                resources: $e1936f201d69a18a$var$getCmdbResources(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("ac6Qh")).LazyServicedeskCmdbConfigure)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aGpoe")).servicedeskCmdbAssetsObject4Route), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, (0, parcelRequire("8lolW")).InsightCmdbObjectViewV2),
                resources: [
                    ...$e1936f201d69a18a$var$getCmdbResources(),
                    (0, (0, parcelRequire("8naTI")).insightObjectResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("8lolW")).LazyServicedeskCmdbObjectV2)
                ],
                perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
                ufoName: 'service-management.insight-cmdb.object-view-page-load'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aGpoe")).servicedeskCmdbInsightObject4Route), ()=>({
                ...$e1936f201d69a18a$var$sharedRouteProps,
                component: (0, (0, parcelRequire("8lolW")).InsightCmdbObjectViewV2),
                resources: [
                    ...$e1936f201d69a18a$var$getCmdbResources(),
                    (0, (0, parcelRequire("8naTI")).insightObjectResource)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("8lolW")).LazyServicedeskCmdbObjectV2)
                ],
                perfMetricKey: 'service-management.insight-cmdb.object-view-page-load',
                ufoName: 'service-management.insight-cmdb.object-view-page-load'
            }))
    ];
});
parcelRegister("72NwO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d99ccdcd3c9cebe4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZQxE;
    var $gbGmI;
    var $hPtZI;
    const $d99ccdcd3c9cebe4$export$2260a0528570f8da = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>{
        (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadStart)();
        return (parcelRequire("8ym2X")).then((bundle)=>{
            (0, (0, parcelRequire("gbGmI")).setPerformanceMarkLoadEnd)();
            return bundle;
        });
    }, {
        moduleId: "./src/packages/navigation-apps/sidebar/assets-reports/src/index.tsx"
    });
    const $d99ccdcd3c9cebe4$var$AssetsReportsSidebar = (0, $5uXOq.memo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZQxE")).SidebarBoundary), {
            id: "assets-reports-sidebar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($d99ccdcd3c9cebe4$export$2260a0528570f8da, null)));
    $d99ccdcd3c9cebe4$var$AssetsReportsSidebar.displayName = 'AssetsReportsSidebar';
    var $d99ccdcd3c9cebe4$export$2e2bcd8739ae039 = $d99ccdcd3c9cebe4$var$AssetsReportsSidebar;
});
parcelRegister("8ym2X", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("fApFb").then(()=>parcelRequire('ejeJy'));
});
parcelRegister("6j0IA", function(module, exports) {
    $parcel$export(module.exports, "serviceDeskAssetsImportTypeForgeDataResource", ()=>$f0c74bdf86d6b898$export$58d2462746e91c7d);
    var $dIdda = parcelRequire("dIdda");
    const $f0c74bdf86d6b898$var$getDataLoader = ()=>(parcelRequire("aFxik"));
    const $f0c74bdf86d6b898$export$58d2462746e91c7d = (0, $dIdda.createResource)({
        type: 'ASSETS_IMPORT_TYPE_FORGE_DATA',
        getKey: ()=>'extensions',
        getDataLoader: $f0c74bdf86d6b898$var$getDataLoader,
        maxAge: Number.MAX_SAFE_INTEGER,
        isBrowserOnly: true
    });
});
parcelRegister("aFxik", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("29sLe").then(()=>parcelRequire('jwVSb'));
});
parcelRegister("8naTI", function(module, exports) {
    $parcel$export(module.exports, "insightObjectResource", ()=>$2ad42c3dacc09c9e$export$215464c8085c5e35);
    var $dIdda = parcelRequire("dIdda");
    var $7JHOP;
    const $2ad42c3dacc09c9e$var$RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT = 'SERVICEDESK_INSIGHT_OBJECT';
    const $2ad42c3dacc09c9e$export$215464c8085c5e35 = (0, $dIdda.createResource)({
        type: $2ad42c3dacc09c9e$var$RESOURCE_TYPE_SERVICEDESK_INSIGHT_OBJECT,
        getKey: ({ match: match })=>match.params.objectId || '',
        getData: (0, parcelRequire("7JHOP")).default,
        isBrowserOnly: true
    });
});
parcelRegister("7JHOP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$07f064c629fd32ba$export$2e2bcd8739ae039);
    var $x9xyg;
    var $dJl1T;
    var $jcw0u;
    var $4R6GH;
    var $7f4tk;
    var $8PRuf;
    var $iR3GG;
    var $eJOOa;
    var $ahEft;
    var $9NiTW;
    const $07f064c629fd32ba$var$fetchInsightObjectDetails = async (routeDataContext, routerContext)=>{
        try {
            const { match: { params: params } } = routeDataContext;
            const { objectId: objectId } = params;
            if (objectId == null) return null;
            const workspaceId = await (0, (0, parcelRequire("ahEft")).default)(routeDataContext, routerContext);
            if (workspaceId == null) return null;
            const data = await (0, (0, parcelRequire("7f4tk")).default)((0, (0, parcelRequire("eJOOa")).getCmdbObjectByIdUrl)(workspaceId, objectId));
            (0, (0, parcelRequire("x9xyg")).setMark)((0, (0, parcelRequire("8PRuf")).prefetchApiReadyMark));
            return data;
        } catch (error) {
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jiraServicedeskInsightObjectResource', error);
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'jiraServicedeskInsightObjectResource',
                    packageName: 'jiraSpa'
                },
                error: error
            });
            throw error;
        }
    };
    var $07f064c629fd32ba$export$2e2bcd8739ae039 = async (routeDataContext, routerContext)=>{
        const { tenantContext: tenantContext } = routerContext;
        if ((0, (0, parcelRequire("4R6GH")).fg)('jsm_throw_error_on_resource_auth_pre-check_failed')) {
            if (!(0, (0, parcelRequire("9NiTW")).checkAuthentication)(tenantContext)) throw (0, (0, parcelRequire("iR3GG")).createResourceError)({
                component: 'spa.view.routes.servicedesk.cmdb-object.getData',
                message: 'Current user is not authenticated',
                name: 'AuthenticationError',
                skipSentry: true
            });
        } else if (!(0, (0, parcelRequire("9NiTW")).checkAuthentication)(tenantContext)) return null;
        return $07f064c629fd32ba$var$fetchInsightObjectDetails(routeDataContext, routerContext);
    };
});
parcelRegister("eJOOa", function(module, exports) {
    $parcel$export(module.exports, "getCmdbObjectByIdUrl", ()=>$bba7f62e646e53a7$export$d33c3e25476d091d);
    $parcel$export(module.exports, "getCmdbObjectByIdUrlWithoutQueryParams", ()=>$bba7f62e646e53a7$export$6ef8997552257871);
    $parcel$export(module.exports, "getCmdbObjectByIdActivityUrl", ()=>$bba7f62e646e53a7$export$20c207abffb62450);
    $parcel$export(module.exports, "getCmdbObjectByIdAvatarUrl", ()=>$bba7f62e646e53a7$export$31df868d16d545f8);
    $parcel$export(module.exports, "getCmdbObjectByIdReferenceInfoUrl", ()=>$bba7f62e646e53a7$export$5044a1e9fc201773);
    $parcel$export(module.exports, "getCmdbObjectCloneByIdUrl", ()=>$bba7f62e646e53a7$export$d7f6dc1d4f622458);
    $parcel$export(module.exports, "getCmdbObjectCreateUrl", ()=>$bba7f62e646e53a7$export$9cdc19e8944d38cf);
    $parcel$export(module.exports, "getCmdbObjectNavlistUrl", ()=>$bba7f62e646e53a7$export$bf9c534c2cd21829);
    $parcel$export(module.exports, "getCmdbObjectNavlistQueryLanguageUrl", ()=>$bba7f62e646e53a7$export$b35334340ee827fa);
    $parcel$export(module.exports, "getCmdbObjectRecentUrl", ()=>$bba7f62e646e53a7$export$a0a7c6f22bebdef0);
    $parcel$export(module.exports, "getCmdbObjectQueryLanguageTotalCountUrl", ()=>$bba7f62e646e53a7$export$ee74f95a469c4433);
    $parcel$export(module.exports, "getCmdbObjectSearchUrl", ()=>$bba7f62e646e53a7$export$1016ae73c04d9079);
    $parcel$export(module.exports, "getCmdbAttributeSearchUrl", ()=>$bba7f62e646e53a7$export$cb41514f2508b033);
    $parcel$export(module.exports, "getCmdbObjectQueryLanguageUrl", ()=>$bba7f62e646e53a7$export$84a34ee3f18e226);
    $parcel$export(module.exports, "getCmdbAsyncObjectExportUrl", ()=>$bba7f62e646e53a7$export$878b627ac685384e);
    $parcel$export(module.exports, "getCmdbAsyncBulkQrCodeUrl", ()=>$bba7f62e646e53a7$export$8eb3a6b36886db0);
    $parcel$export(module.exports, "getCmdbAsyncBulkDeleteUrl", ()=>$bba7f62e646e53a7$export$b02201bcaeb75291);
    $parcel$export(module.exports, "getCmdbAsyncBulkEditUrl", ()=>$bba7f62e646e53a7$export$f4d68a6f0e3217b5);
    var $ebyGx = parcelRequire("ebyGx");
    var $klJ8b;
    const $bba7f62e646e53a7$var$getCmdbObjectUrl = (workspaceId)=>`${(0, (0, parcelRequire("klJ8b")).getCmdbRestBaseUrl)(workspaceId)}/object`;
    const $bba7f62e646e53a7$export$d33c3e25476d091d = (workspaceId, objectId, includeExtendedInfo = false)=>{
        const path = $bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId);
        if (!includeExtendedInfo) return `${path}?${(0, $ebyGx.stringify)({
            includeExtendedInfo: includeExtendedInfo
        })}`;
        return path;
    };
    const $bba7f62e646e53a7$export$6ef8997552257871 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/${objectId}`;
    const $bba7f62e646e53a7$export$20c207abffb62450 = (workspaceId, objectId, queryParams)=>`${$bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId)}/activity?${(0, $ebyGx.stringify)(queryParams)}`;
    const $bba7f62e646e53a7$export$31df868d16d545f8 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId)}/avatar`;
    const $bba7f62e646e53a7$export$5044a1e9fc201773 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$export$6ef8997552257871(workspaceId, objectId)}/referenceinfo`;
    const $bba7f62e646e53a7$export$d7f6dc1d4f622458 = (workspaceId, objectId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/clone/${objectId}`;
    const $bba7f62e646e53a7$export$9cdc19e8944d38cf = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/create`;
    const $bba7f62e646e53a7$export$bf9c534c2cd21829 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/navlist`;
    const $bba7f62e646e53a7$export$b35334340ee827fa = (workspaceId)=>`${$bba7f62e646e53a7$export$bf9c534c2cd21829(workspaceId)}/aql`;
    const $bba7f62e646e53a7$export$a0a7c6f22bebdef0 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/recent?${(0, $ebyGx.stringify)(queryParams)}`;
    const $bba7f62e646e53a7$export$ee74f95a469c4433 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/aql/totalcount`;
    const $bba7f62e646e53a7$export$1016ae73c04d9079 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/search?${(0, $ebyGx.stringify)(queryParams)}`;
    const $bba7f62e646e53a7$export$cb41514f2508b033 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/searchbyattributes?${(0, $ebyGx.stringify)(queryParams)}`;
    const $bba7f62e646e53a7$export$84a34ee3f18e226 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/aql?${(0, $ebyGx.stringify)(queryParams)}`;
    const $bba7f62e646e53a7$export$878b627ac685384e = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkexport`;
    const $bba7f62e646e53a7$export$8eb3a6b36886db0 = (workspaceId, queryParams)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkqrcode?${(0, $ebyGx.stringify)(queryParams)}`;
    const $bba7f62e646e53a7$export$b02201bcaeb75291 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkdelete`;
    const $bba7f62e646e53a7$export$f4d68a6f0e3217b5 = (workspaceId)=>`${$bba7f62e646e53a7$var$getCmdbObjectUrl(workspaceId)}/bulkedit`;
});
parcelRegister("klJ8b", function(module, exports) {
    $parcel$export(module.exports, "getCmdbRestBaseUrl", ()=>$a22cc15ea8014e15$export$28b6c003daedf1c2);
    const $a22cc15ea8014e15$export$28b6c003daedf1c2 = (workspaceId)=>`/gateway/api/jsm/assets/workspace/${workspaceId}/v1`;
});
parcelRegister("aGpoe", function(module, exports) {
    $parcel$export(module.exports, "servicedeskCmdbAssetsRoute", ()=>$344e7e7ebd923c11$export$152b5dead07808bc);
    $parcel$export(module.exports, "servicedeskCmdbInsightRoute", ()=>$344e7e7ebd923c11$export$1efada07b7203f2d);
    $parcel$export(module.exports, "servicedeskCmdbAssetsDefaultRedirect", ()=>$344e7e7ebd923c11$export$8629431cf690fe39);
    $parcel$export(module.exports, "servicedeskCmdbAssetsReportsRoute", ()=>$344e7e7ebd923c11$export$a075d8b7c4c55c41);
    $parcel$export(module.exports, "servicedeskCmdbAssetsReportsUnsubscribeRoute", ()=>$344e7e7ebd923c11$export$66ab60d374e8e458);
    $parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchema1Route", ()=>$344e7e7ebd923c11$export$246ae573df78317e);
    $parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaRoute", ()=>$344e7e7ebd923c11$export$fcde60ded71d4ae6);
    $parcel$export(module.exports, "servicedeskCmdbAssetsObjectTypeConfigurationRoute", ()=>$344e7e7ebd923c11$export$73b901e16d5e5a02);
    $parcel$export(module.exports, "servicedeskCmdbInsightObjectTypeConfigurationRoute", ()=>$344e7e7ebd923c11$export$12e89d5d79d59785);
    $parcel$export(module.exports, "servicedeskCmdbAssetsConfigureRoute", ()=>$344e7e7ebd923c11$export$9f6d42997c66cc4b);
    $parcel$export(module.exports, "servicedeskCmdbInsightConfigureGlobalRoute", ()=>$344e7e7ebd923c11$export$96e5da52356f214c);
    $parcel$export(module.exports, "servicedeskCmdbAssetsObjectSchemaConfigurationRoute", ()=>$344e7e7ebd923c11$export$b4a150d67181752);
    $parcel$export(module.exports, "servicedeskCmdbInsightObjectSchemaConfigurationRoute", ()=>$344e7e7ebd923c11$export$f6b688a8729943b3);
    $parcel$export(module.exports, "servicedeskCmdbInsightConfigureRoute", ()=>$344e7e7ebd923c11$export$e960ab4fcd3e80b6);
    $parcel$export(module.exports, "servicedeskCmdbAssetsObject4Route", ()=>$344e7e7ebd923c11$export$620f0fb687461e6);
    $parcel$export(module.exports, "servicedeskCmdbInsightObject4Route", ()=>$344e7e7ebd923c11$export$223f5bacfd3d39fd);
    var $65Ltd;
    const $344e7e7ebd923c11$export$152b5dead07808bc = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/assets',
        exact: true
    };
    const $344e7e7ebd923c11$export$1efada07b7203f2d = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_HOME),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/insight',
        exact: true
    };
    const $344e7e7ebd923c11$export$8629431cf690fe39 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_DEFAULT_REDIRECT),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/assets/reports',
        exact: true
    };
    const $344e7e7ebd923c11$export$a075d8b7c4c55c41 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/assets/reports/:templateId',
        exact: true
    };
    const $344e7e7ebd923c11$export$66ab60d374e8e458 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_REPORTS_UNSUBSCRIBE),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/assets/reports/unsubscribe/:templateId/:subscriptionId',
        exact: true
    };
    const $344e7e7ebd923c11$export$246ae573df78317e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/assets/object-schema/:objectSchemaId'
    };
    const $344e7e7ebd923c11$export$fcde60ded71d4ae6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/insight/object-schemas/:objectSchemaId'
    };
    const $344e7e7ebd923c11$export$73b901e16d5e5a02 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_TYPE_CONFIGURATION),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/assets/configure/object-type/:objectTypeId'
    };
    const $344e7e7ebd923c11$export$12e89d5d79d59785 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_TYPE_CONFIGURATION),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/insight/configure/object-type/:objectTypeId'
    };
    const $344e7e7ebd923c11$export$9f6d42997c66cc4b = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_CONFIGURE),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/assets/configure/global'
    };
    const $344e7e7ebd923c11$export$96e5da52356f214c = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/insight/configure/global'
    };
    const $344e7e7ebd923c11$export$b4a150d67181752 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT_SCHEMA_CONFIGURATION),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/assets/configure/object-schema/:objectSchemaId'
    };
    const $344e7e7ebd923c11$export$f6b688a8729943b3 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT_SCHEMA_CONFIGURATION),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/insight/configure/object-schema/:objectSchemaId'
    };
    const $344e7e7ebd923c11$export$e960ab4fcd3e80b6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_CONFIGURE),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/insight/configure'
    };
    const $344e7e7ebd923c11$export$620f0fb687461e6 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_ASSETS_OBJECT),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/assets/object/:objectId'
    };
    const $344e7e7ebd923c11$export$223f5bacfd3d39fd = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CMDB_INSIGHT_OBJECT),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/insight/assets/:objectId'
    };
});
parcelRegister("ac6Qh", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskCmdbConfigure", ()=>$9872d73b74d97014$export$8075d4042713bf6d);
    $parcel$export(module.exports, "default", ()=>$9872d73b74d97014$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $9872d73b74d97014$export$8075d4042713bf6d = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("5Bl21")), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure/src/index.tsx"
    });
    const $9872d73b74d97014$var$InsightConfigure = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9872d73b74d97014$export$8075d4042713bf6d,
            pageId: "spa-apps/servicedesk/insight/cmdb-configure",
            shouldShowSpinner: true
        });
    var $9872d73b74d97014$export$2e2bcd8739ae039 = $9872d73b74d97014$var$InsightConfigure;
});
parcelRegister("5Bl21", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("95JPD").then(()=>parcelRequire('cKWhs'));
});
parcelRegister("b93Zs", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskCmdbConfigureObjectType", ()=>$14de2d11a3985015$export$926956539e1f72ba);
    $parcel$export(module.exports, "default", ()=>$14de2d11a3985015$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $14de2d11a3985015$export$926956539e1f72ba = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("YkbdD")), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure-object-type/src/index.tsx"
    });
    const $14de2d11a3985015$var$InsightConfigureObjectType = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $14de2d11a3985015$export$926956539e1f72ba,
            pageId: "spa-apps/servicedesk/insight/cmdb-configure-object-type",
            shouldShowSpinner: true
        });
    var $14de2d11a3985015$export$2e2bcd8739ae039 = $14de2d11a3985015$var$InsightConfigureObjectType;
});
parcelRegister("YkbdD", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hloRW")
    ]).then(()=>parcelRequire('2lY4S'));
});
parcelRegister("gXGYk", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskCmdbGlobalConfigure", ()=>$faa956883f49da96$export$b80bd807bad3fd0a);
    $parcel$export(module.exports, "default", ()=>$faa956883f49da96$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $faa956883f49da96$export$b80bd807bad3fd0a = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("5A72l")), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-configure-v2/src/index.tsx"
    });
    const $faa956883f49da96$var$GlobalConfigure = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $faa956883f49da96$export$b80bd807bad3fd0a,
            pageId: "spa-apps/servicedesk/insight/cmdb-configure",
            shouldShowSpinner: true
        });
    var $faa956883f49da96$export$2e2bcd8739ae039 = $faa956883f49da96$var$GlobalConfigure;
});
parcelRegister("5A72l", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("aHtXH")
    ]).then(()=>parcelRequire('cB0p5'));
});
parcelRegister("ia3qM", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskCmdbLandingPage", ()=>$3371db153f9530b2$export$f6c79e6ff37913ee);
    $parcel$export(module.exports, "default", ()=>$3371db153f9530b2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $3371db153f9530b2$export$f6c79e6ff37913ee = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("eOYiU")), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-landing-page/src/index.tsx"
    });
    const $3371db153f9530b2$var$LandingPage = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3371db153f9530b2$export$f6c79e6ff37913ee,
            pageId: "spa-apps/servicedesk/insight/cmdb-landing-page",
            shouldShowSpinner: true
        });
    var $3371db153f9530b2$export$2e2bcd8739ae039 = $3371db153f9530b2$var$LandingPage;
});
parcelRegister("eOYiU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cTSd1")
    ]).then(()=>parcelRequire('9imjS'));
});
parcelRegister("8lolW", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskCmdbObjectV2", ()=>$3afd4c2d86bdef54$export$411c1981ced22249);
    $parcel$export(module.exports, "InsightCmdbObjectViewV2", ()=>$3afd4c2d86bdef54$export$3c208f927c6178ee);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $3afd4c2d86bdef54$export$411c1981ced22249 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("8oQUA")), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-v2/src/index.tsx"
    });
    const $3afd4c2d86bdef54$export$3c208f927c6178ee = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3afd4c2d86bdef54$export$411c1981ced22249,
            pageId: "spa-apps/servicedesk/insight/cmdb-object-v2",
            shouldShowSpinner: true
        });
    var $3afd4c2d86bdef54$export$2e2bcd8739ae039 = $3afd4c2d86bdef54$export$3c208f927c6178ee;
});
parcelRegister("8oQUA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8VYTt")
    ]).then(()=>parcelRequire('8V2Yz'));
});
parcelRegister("2iVq4", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskCmdbObjectSchemaV2", ()=>$3c1950a2c10ba0ce$export$1e50d5a65ac4f5fc);
    $parcel$export(module.exports, "ObjectSchemaV2", ()=>$3c1950a2c10ba0ce$export$f90a4f33c79fd86e);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $3c1950a2c10ba0ce$export$1e50d5a65ac4f5fc = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("ylQhQ")), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-schema-v2/src/index.tsx"
    });
    const $3c1950a2c10ba0ce$export$f90a4f33c79fd86e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3c1950a2c10ba0ce$export$1e50d5a65ac4f5fc,
            pageId: "spa-apps/servicedesk/insight/cmdb-object-schema",
            shouldShowSpinner: true
        });
    var $3c1950a2c10ba0ce$export$2e2bcd8739ae039 = $3c1950a2c10ba0ce$export$f90a4f33c79fd86e;
});
parcelRegister("ylQhQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6kkfK")
    ]).then(()=>parcelRequire('ciybC'));
});
parcelRegister("2vrwM", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskCmdbObjectSchemaConfiguration", ()=>$af13a504c251f159$export$8305a1bc1c5bee45);
    $parcel$export(module.exports, "default", ()=>$af13a504c251f159$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $af13a504c251f159$export$8305a1bc1c5bee45 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("c3dxs")), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-object-schema-configuration/src/index.tsx"
    });
    const $af13a504c251f159$var$ObjectSchemaConfiguration = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $af13a504c251f159$export$8305a1bc1c5bee45,
            pageId: "spa-apps/servicedesk/insight/cmdb-object-schema-configuration",
            shouldShowSpinner: true
        });
    var $af13a504c251f159$export$2e2bcd8739ae039 = $af13a504c251f159$var$ObjectSchemaConfiguration;
});
parcelRegister("c3dxs", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jCYvk")
    ]).then(()=>parcelRequire('hEchH'));
});
parcelRegister("ceEFi", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskCmdbAssetsReports", ()=>$2e02aa1a19501df5$export$9f75cdfdfe8c8aaa);
    $parcel$export(module.exports, "LazyServicedeskCmdbDefaultReportsRedirect", ()=>$2e02aa1a19501df5$export$2534c3e9f8e70d0d);
    $parcel$export(module.exports, "LazyServicedeskCmdbAssetsReportsUnsubscribe", ()=>$2e02aa1a19501df5$export$dec85f15dd805ac4);
    $parcel$export(module.exports, "LazyServicedeskCmdbAssetsReportsNav4HomePage", ()=>$2e02aa1a19501df5$export$c56cfef9aa68df09);
    $parcel$export(module.exports, "AssetsReports", ()=>$2e02aa1a19501df5$export$d45b40d40442434);
    $parcel$export(module.exports, "AssetsReportsUnsubscribe", ()=>$2e02aa1a19501df5$export$541b39e6d5be07df);
    $parcel$export(module.exports, "AssetsReportingDefaultRedirect", ()=>$2e02aa1a19501df5$export$4155da54bfeacf74);
    $parcel$export(module.exports, "AssetsReportsNav4HomePage", ()=>$2e02aa1a19501df5$export$9d28551695f98cae);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $2e02aa1a19501df5$export$9f75cdfdfe8c8aaa = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("hpGQh")).then((exportedMembers)=>exportedMembers.CmdbAssetsReports), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
    });
    const $2e02aa1a19501df5$export$2534c3e9f8e70d0d = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("hpGQh")).then((exportedMembers)=>exportedMembers.CmdbDefaultReportsRedirect), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
    });
    const $2e02aa1a19501df5$export$dec85f15dd805ac4 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("5tvXj")), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports-unsubscribe/src/index.tsx"
    });
    const $2e02aa1a19501df5$export$c56cfef9aa68df09 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("hpGQh")).then((exportedMembers)=>exportedMembers.CmdbAssetsReportsNav4HomePage), {
        moduleId: "./src/packages/spa-apps/servicedesk/cmdb-assets-reports/src/index.tsx"
    });
    const $2e02aa1a19501df5$export$d45b40d40442434 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2e02aa1a19501df5$export$9f75cdfdfe8c8aaa,
            pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports",
            shouldShowSpinner: true
        });
    const $2e02aa1a19501df5$export$541b39e6d5be07df = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2e02aa1a19501df5$export$dec85f15dd805ac4,
            pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-unsubscribe",
            shouldShowSpinner: true
        });
    const $2e02aa1a19501df5$export$4155da54bfeacf74 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2e02aa1a19501df5$export$2534c3e9f8e70d0d,
            pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-default-redirect",
            shouldShowSpinner: true
        });
    const $2e02aa1a19501df5$export$9d28551695f98cae = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2e02aa1a19501df5$export$c56cfef9aa68df09,
            pageId: "spa-apps/servicedesk/insight/cmdb-assets-reports-home-page",
            shouldShowSpinner: true
        });
});
parcelRegister("hpGQh", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("i8SQL")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("jluSR")
    ]).then(()=>parcelRequire('7Jr0E'));
});
parcelRegister("5tvXj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("838D9")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hWDKD")
    ]).then(()=>parcelRequire('imnQf'));
});
parcelRegister("cTOdl", function(module, exports) {
    $parcel$export(module.exports, "servicedeskCreateProjectRouteEntry", ()=>$9e649f3a8eb5dbcb$export$ac25abe07ac3f570);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $5bkvv;
    var $6zFAI;
    var $ggg5j;
    var $iEUaw;
    var $2G9Bk;
    var $3RJkv;
    var $dxCvy;
    var $7GnDe;
    var $17PFI;
    var $6Z2mh;
    var $e9YVH;
    var $5j7Th;
    var $hPtZI;
    const $9e649f3a8eb5dbcb$export$5004e0d4f1e57790 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("3pzt9")), {
        moduleId: "./src/packages/spa-apps/servicedesk/create-project/src/index.tsx"
    });
    const $9e649f3a8eb5dbcb$export$ffae8a2776195524 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9e649f3a8eb5dbcb$export$5004e0d4f1e57790,
            pageId: "spa-apps/servicedesk/create-project",
            shouldShowSpinner: true
        });
    const $9e649f3a8eb5dbcb$export$ac25abe07ac3f570 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("17PFI")).servicedeskCreateProjectRoute), ()=>({
            isRedirect: true,
            component: $9e649f3a8eb5dbcb$export$ffae8a2776195524,
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                (0, (0, parcelRequire("7GnDe")).incidentExperimentTraitResource),
                (0, (0, parcelRequire("dxCvy")).projectContextResource),
                (0, (0, parcelRequire("5bkvv")).forgeProjectModuleResource),
                (0, (0, parcelRequire("iEUaw")).staticSidebarShortcutsResource),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("6zFAI")).staticProjectSidebarConnectAddonsNavigationResource)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $9e649f3a8eb5dbcb$export$5004e0d4f1e57790
            ],
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).CREATE_PROJECT,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CREATE_PROJECT),
                    teamName: 'itops-mithril'
                }
            }
        }));
});
parcelRegister("17PFI", function(module, exports) {
    $parcel$export(module.exports, "servicedeskCreateProjectRoute", ()=>$8a9a109143c89aa7$export$1f409a894343952a);
    var $65Ltd;
    const $8a9a109143c89aa7$export$1f409a894343952a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CREATE_PROJECT),
        path: '/jira/servicedesk/create-project',
        exact: true
    };
});
parcelRegister("3pzt9", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("740y2").then(()=>parcelRequire('3hX8x'));
});
parcelRegister("l76zI", function(module, exports) {
    $parcel$export(module.exports, "customersRouteEntries", ()=>$dfe6b7b99f3a840b$export$6811a8ea7ba7651c);
    var $ffza4;
    var $cEOhb;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $fcMlY;
    var $4lqmX;
    var $aqQrr;
    var $6Z2mh;
    var $e9YVH;
    var $ctGuD;
    const $dfe6b7b99f3a840b$var$getCustomersRoutesCommon = ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        });
    const $dfe6b7b99f3a840b$export$6811a8ea7ba7651c = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aqQrr")).servicedeskCustomerDetailsRoute), ()=>({
                ...$dfe6b7b99f3a840b$var$getCustomersRoutesCommon(),
                component: (0, (0, parcelRequire("ctGuD")).ServicedeskCustomerDetails),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("ctGuD")).LazyServicedeskCustomerDetails)
                ],
                perfMetricKey: 'jsm-customer-details-component-load',
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_DETAILS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).CUSTOMER_DETAILS),
                        teamName: 'boysenberry'
                    }
                },
                resources: [
                    ...$dfe6b7b99f3a840b$var$getCustomersRoutesCommon().resources,
                    (0, (0, parcelRequire("fcMlY")).entitlementsCustomerQueryResource),
                    (0, (0, parcelRequire("4lqmX")).uiCustomerDetailsPageQueryResource)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aqQrr")).servicedeskCustomersV2Route), ()=>({
                ...$dfe6b7b99f3a840b$var$getCustomersRoutesCommon(),
                component: (0, (0, parcelRequire("ctGuD")).ServiceDeskCustomersV2),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("ctGuD")).LazyServicedeskCustomersV2)
                ],
                perfMetricKey: 'jsm-customers-component-load',
                ufoName: 'jsm-customers-component-load',
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, (0, parcelRequire("cEOhb")).AsyncDirectoryNav),
                    onlyShowHorizontalOnNav4: true
                }
            }))
    ];
});
parcelRegister("fcMlY", function(module, exports) {
    $parcel$export(module.exports, "entitlementsCustomerQueryResource", ()=>$b3b86d13796012d4$export$78737979422d6907);
    var $ao2h1;
    var $3KdBC;
    const $b3b86d13796012d4$export$78737979422d6907 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'ENTITLEMENTS_CUSTOMER_QUERY',
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("3KdBC")).default),
                variables: {
                    accountId: String(match.params.customerId),
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("3KdBC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$234ef4e6f5c8b134$export$2e2bcd8739ae039);
    const $234ef4e6f5c8b134$var$node = function() {
        var v0 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }, v1 = {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }, v2 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v3 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 1
            }
        ], v4 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v5 = [
            {
                "kind": "Variable",
                "name": "accountId",
                "variableName": "accountId"
            }
        ], v6 = {
            "kind": "ScalarField",
            "name": "name"
        }, v7 = {
            "kind": "ScalarField",
            "name": "id"
        }, v8 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }, v9 = [
            v7,
            v6
        ], v10 = {
            "kind": "InlineFragment",
            "selections": [
                v7
            ],
            "type": "Node",
            "abstractKey": "__isNode"
        };
        return {
            "fragment": {
                "argumentDefinitions": [
                    v0,
                    v1
                ],
                "kind": "Fragment",
                "name": "entitlementsCustomerQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": v2,
                            "concreteType": "CustomerServiceQueryApi",
                            "kind": "LinkedField",
                            "name": "customerService",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v3,
                                        "concreteType": "CustomerServiceProductConnection",
                                        "kind": "LinkedField",
                                        "name": "productConnections",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "CustomerServiceProductEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceProduct",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v4
                                                            ]
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "customerService.productConnections.edges"
                                            }
                                        ],
                                        "storageKey": "productConnections(first:1)"
                                    },
                                    "action": "THROW",
                                    "path": "customerService.productConnections"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v5,
                                        "kind": "LinkedField",
                                        "name": "individualByAccountId",
                                        "plural": false,
                                        "selections": [
                                            v4,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v6,
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v7,
                                                        "action": "THROW",
                                                        "path": "customerService.individualByAccountId.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CustomerServiceEntitlement",
                                                            "kind": "LinkedField",
                                                            "name": "entitlementList",
                                                            "plural": true,
                                                            "selections": [
                                                                v7,
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "includeEntityTypeName",
                                                                            "value": true
                                                                        }
                                                                    ],
                                                                    "kind": "FragmentSpread",
                                                                    "name": "entitlement_servicedeskCustomerServiceEntitlementsCard"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "customerService.individualByAccountId.entitlementList"
                                                    },
                                                    v8
                                                ],
                                                "type": "CustomerServiceIndividual"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                    }
                                                ],
                                                "type": "QueryError"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "customerService.individualByAccountId"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "customerService"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": [
                    v1,
                    v0
                ],
                "kind": "Operation",
                "name": "entitlementsCustomerQuery",
                "selections": [
                    {
                        "args": v2,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "args": v3,
                                "concreteType": "CustomerServiceProductConnection",
                                "kind": "LinkedField",
                                "name": "productConnections",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "CustomerServiceProductEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "CustomerServiceProduct",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v4,
                                                    v7
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "productConnections(first:1)"
                            },
                            {
                                "args": v5,
                                "kind": "LinkedField",
                                "name": "individualByAccountId",
                                "plural": false,
                                "selections": [
                                    v4,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v6,
                                            v7,
                                            {
                                                "concreteType": "CustomerServiceEntitlement",
                                                "kind": "LinkedField",
                                                "name": "entitlementList",
                                                "plural": true,
                                                "selections": [
                                                    v7,
                                                    {
                                                        "concreteType": "CustomerServiceProduct",
                                                        "kind": "LinkedField",
                                                        "name": "product",
                                                        "plural": false,
                                                        "selections": v9
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "entity",
                                                        "plural": false,
                                                        "selections": [
                                                            v4,
                                                            {
                                                                "kind": "InlineFragment",
                                                                "selections": v9,
                                                                "type": "CustomerServiceOrganization"
                                                            },
                                                            v10
                                                        ]
                                                    }
                                                ]
                                            },
                                            v8
                                        ],
                                        "type": "CustomerServiceIndividual"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "identifier"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "message"
                                            },
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": true,
                                                "selections": [
                                                    v4,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "statusCode"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "errorType"
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "QueryError"
                                    },
                                    v10
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "b6e68492e4403956991e93b2bec1552e11424884520f6d91d362bfb3f950af38",
                "metadata": {},
                "name": "entitlementsCustomerQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $234ef4e6f5c8b134$var$node.hash = "52b18fa6e520ef1142f20ddded30f5ba";
    var $234ef4e6f5c8b134$export$2e2bcd8739ae039 = $234ef4e6f5c8b134$var$node;
});
parcelRegister("4lqmX", function(module, exports) {
    $parcel$export(module.exports, "uiCustomerDetailsPageQueryResource", ()=>$bb7f2c1b84275683$export$d766b4bd7ad23814);
    var $ao2h1;
    var $bvCOc;
    const $bb7f2c1b84275683$export$d766b4bd7ad23814 = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'UI_CUSTOMER_DETAILS_PAGE_QUERY',
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("bvCOc")).default),
                variables: {
                    accountId: String(match.params.customerId),
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("bvCOc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb866aea27d5a9be$export$2e2bcd8739ae039);
    const $eb866aea27d5a9be$var$node = {
        "kind": "PreloadableConcreteRequest",
        "params": {
            "id": "1258d3244f4ada1c9a11aa7b81632c4706c41bef3110bbfaff26f94c93a1ee49",
            "metadata": {},
            "name": "uiCustomerDetailsPageQuery",
            "operationKind": "query",
            "text": null
        }
    };
    var $eb866aea27d5a9be$export$2e2bcd8739ae039 = $eb866aea27d5a9be$var$node;
});
parcelRegister("aqQrr", function(module, exports) {
    $parcel$export(module.exports, "servicedeskCustomersV2Route", ()=>$2cd6e21d82e9c391$export$89e9e350610ee31e);
    $parcel$export(module.exports, "servicedeskCustomerDetailsRoute", ()=>$2cd6e21d82e9c391$export$42c0f04d04ecd1f8);
    var $65Ltd;
    const $2cd6e21d82e9c391$export$89e9e350610ee31e = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMERS_V2),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/projects/:projectKey/customers',
        exact: true
    };
    const $2cd6e21d82e9c391$export$42c0f04d04ecd1f8 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_CUSTOMER_DETAILS),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/projects/:projectKey/customers/:customerId',
        exact: true
    };
});
parcelRegister("ctGuD", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskCustomersV2", ()=>$11e345ce4933debe$export$864b519a4059ac6b);
    $parcel$export(module.exports, "ServiceDeskCustomersV2", ()=>$11e345ce4933debe$export$ac54d7814cf71dd);
    $parcel$export(module.exports, "LazyServicedeskCustomerDetails", ()=>$11e345ce4933debe$export$6c5749ec31de847d);
    $parcel$export(module.exports, "ServicedeskCustomerDetails", ()=>$11e345ce4933debe$export$2412523c0e3657cc);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $11e345ce4933debe$export$864b519a4059ac6b = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("22OMj"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/customers-v2/src/index.tsx"
    });
    const $11e345ce4933debe$export$ac54d7814cf71dd = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $11e345ce4933debe$export$864b519a4059ac6b,
            pageId: "spa-apps/servicedesk/customers-v2",
            shouldShowSpinner: true
        });
    const $11e345ce4933debe$export$6c5749ec31de847d = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kEVl8"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/customer-details/src/index.tsx"
    });
    const $11e345ce4933debe$export$2412523c0e3657cc = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $11e345ce4933debe$export$6c5749ec31de847d,
            pageId: "spa-apps/servicedesk/customer-details",
            shouldShowSpinner: true
        });
});
parcelRegister("22OMj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("iWLC2")
    ]).then(()=>parcelRequire('dKNUD'));
});
parcelRegister("kEVl8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("9m8WM")
    ]).then(()=>parcelRequire('eRp4S'));
});
parcelRegister("joBLj", function(module, exports) {
    $parcel$export(module.exports, "projectServiceDeskRouteEntry", ()=>$0649b6fa57429fc5$export$8810bfd4f6a0eb22);
    var $ffza4;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $7MCPm;
    var $3e6VG;
    var $6Z2mh;
    const $0649b6fa57429fc5$export$8810bfd4f6a0eb22 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("3e6VG")).projectServiceDeskRoute), ()=>({
            isRedirect: true,
            component: (0, (0, parcelRequire("7MCPm")).RedirectToLastVisitedProjectPage),
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
            ]
        }));
});
parcelRegister("3e6VG", function(module, exports) {
    $parcel$export(module.exports, "projectServiceDeskRoute", ()=>$b4bfd79e01394a60$export$1cfc858068dd8718);
    var $65Ltd;
    const $b4bfd79e01394a60$export$1cfc858068dd8718 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REDIRECT),
        path: '/jira/servicedesk/projects/:projectKey',
        exact: true
    };
});
parcelRegister("iQv5q", function(module, exports) {
    $parcel$export(module.exports, "gettingStartedPageRouteEntries", ()=>$02546523c21c0f5a$export$abec122151c24b1b);
    var $lkFvK;
    var $co1wz;
    var $lmyls;
    var $ggg5j;
    var $h0bZU;
    var $2G9Bk;
    var $fpjJX;
    var $k8jl5;
    var $5lsNZ;
    var $em9Nv;
    var $6Z2mh;
    var $cAGKm;
    var $d1gXy;
    const $02546523c21c0f5a$var$gettingStartedPageEntryPoint = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("d1gXy")).gettingStartedEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
    const $02546523c21c0f5a$export$9f5707c751b4b364 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("em9Nv")).gspPageRoute), ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            perfMetricKey: 'servicedesk-getting-started-page-load',
            skeleton: (0, (0, parcelRequire("cAGKm")).GettingStartedPageSkeleton),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("ggg5j")).staticProjectSidebarNavigationResource),
                (0, (0, parcelRequire("k8jl5")).servicedeskIssueTypesResource)
            ],
            entryPoint () {
                return (0, (0, parcelRequire("co1wz")).ff)('getting_started_page_production_rollout') ? $02546523c21c0f5a$var$gettingStartedPageEntryPoint : undefined;
            },
            component: (0, (0, parcelRequire("5lsNZ")).default)
        }));
    const $02546523c21c0f5a$export$abec122151c24b1b = [
        $02546523c21c0f5a$export$9f5707c751b4b364
    ];
});
parcelRegister("em9Nv", function(module, exports) {
    $parcel$export(module.exports, "gspPageRoute", ()=>$668794df3079bf62$export$23f42abb017854bb);
    var $65Ltd;
    const $668794df3079bf62$export$23f42abb017854bb = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_GETTING_STARTED_PAGE),
        path: '/jira/servicedesk/projects/:projectKey/getting-started',
        exact: true
    };
});
parcelRegister("cAGKm", function(module, exports) {
    $parcel$export(module.exports, "GettingStartedPageSkeleton", ()=>$31c65c680f020453$export$525669daa9599ec);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $d3mkW = parcelRequire("d3mkW");
    const $31c65c680f020453$var$customCssStyles = null;
    const $31c65c680f020453$export$525669daa9599ec = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($d3mkW))),
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_rcuj1wug _o81c1wug _1l6u1wug _149m1wug _701wukw8 _9qarbrur"
            ])
        });
});
parcelRegister("d3mkW", function(module, exports) {
    module.exports = new URL("getting-started-page-app-skeleton.tpl.b9c0d034.svg", import.meta.url).toString();
});
parcelRegister("d1gXy", function(module, exports) {
    $parcel$export(module.exports, "gettingStartedEntryPoint", ()=>$7b51534336e501eb$export$a91a58d8bb93ad8e);
    var $2Ftxm;
    var $ikgNX;
    const $7b51534336e501eb$export$a91a58d8bb93ad8e = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("kPaTc")), {
            moduleId: "99c912b0"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("kPaTc", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("i3L0u")
    ]).then(()=>parcelRequire('8Xvm1'));
});
parcelRegister("lMbNa", function(module, exports) {
    $parcel$export(module.exports, "servicedeskItsmSampleSpaceRouteEntry", ()=>$ae7116290a20432f$export$61ad481262acd4e6);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $2G9Bk;
    var $3RJkv;
    var $eaPwE;
    var $6Z2mh;
    var $e9YVH;
    var $5j7Th;
    var $hPtZI;
    const $ae7116290a20432f$export$c1a5da0c35411fc1 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("6xxAH")), {
        moduleId: "./src/packages/spa-apps/servicedesk/itsm-sample-space/src/index.tsx"
    });
    const $ae7116290a20432f$export$389e7e12a5ae9f5a = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ae7116290a20432f$export$c1a5da0c35411fc1,
            pageId: "spa-apps/servicedesk/itsm-sample-space",
            shouldShowSpinner: true
        });
    const $ae7116290a20432f$export$61ad481262acd4e6 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("eaPwE")).servicedeskItsmSampleSpaceRoute), ()=>({
            isRedirect: true,
            component: $ae7116290a20432f$export$389e7e12a5ae9f5a,
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            resources: [
                ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                ...(0, (0, parcelRequire("3RJkv")).getNavigationSidebarProjectResource)()
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $ae7116290a20432f$export$c1a5da0c35411fc1
            ],
            perfMetricKey: 'jsm-sample-space-landing-page',
            meta: {
                reporting: {
                    id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).ITSM_SAMPLE_SPACE,
                    packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).ITSM_SAMPLE_SPACE),
                    teamName: 'itops-mithril'
                }
            }
        }));
});
parcelRegister("eaPwE", function(module, exports) {
    $parcel$export(module.exports, "servicedeskItsmSampleSpaceRoute", ()=>$b3a7b13fb49a20b0$export$5bc288fedb880892);
    var $65Ltd;
    const $b3a7b13fb49a20b0$export$5bc288fedb880892 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ITSM_SAMPLE_SPACE),
        path: '/jira/servicedesk/itsm-sample-space',
        exact: true
    };
});
parcelRegister("6xxAH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1hp0c").then(()=>parcelRequire('5eXru'));
});
parcelRegister("lGNeL", function(module, exports) {
    $parcel$export(module.exports, "knowledgeHubRouteEntries", ()=>$3898d1cf01d349b6$export$f1453c3517242ca1);
    var $ffza4;
    var $jIAHH;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bjZiV;
    var $bHhiy;
    var $fpjJX;
    var $cp8Sv;
    var $6Z2mh;
    var $e9YVH;
    var $bbBli;
    var $fDsbI;
    var $7EGTo;
    var $2KDj2;
    var $aNjVS;
    var $fWD3P;
    var $1iNof;
    var $hnJOJ;
    var $809cs;
    const $3898d1cf01d349b6$var$getKnowledgeHubResources = ()=>[
            ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
            (0, (0, parcelRequire("bjZiV")).kbConfluenceContextResource)
        ];
    const $3898d1cf01d349b6$export$f1453c3517242ca1 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubLandingRoute), ()=>({
                component: (0, (0, parcelRequire("fWD3P")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, (0, parcelRequire("jIAHH")).AsyncKbNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("fWD3P")).LazyServicedeskKnowledgeHubLanding)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_LANDING,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_LANDING),
                        teamName: 'jsm-nebula'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubBrowseAllArticlesRoute), ()=>({
                component: (0, (0, parcelRequire("bbBli")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, (0, parcelRequire("jIAHH")).AsyncKbNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("bbBli")).LazyServicedeskKnowledgeHubBrowseAllArticles)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_BROWSE_ARTICLES,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_BROWSE_ARTICLES),
                        teamName: 'jsm-nebula'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubDraftsRoute), ()=>({
                component: (0, (0, parcelRequire("2KDj2")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, (0, parcelRequire("jIAHH")).AsyncKbNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("2KDj2")).LazyServicedeskKnowledgeHubDrafts)
                ],
                perfMetricKey: 'service-management.kb-drafts',
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_DRAFTS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_DRAFTS),
                        teamName: 'jsm-nebula'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubBrowseAllCategoriesRoute), ()=>({
                component: (0, (0, parcelRequire("fDsbI")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, (0, parcelRequire("jIAHH")).AsyncKbNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("fDsbI")).LazyServicedeskKnowledgeHubBrowseAllCategories)
                ],
                perfMetricKey: 'service-management.kb-categories',
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_BROWSE_CATEGORIES,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_BROWSE_CATEGORIES),
                        teamName: 'jsm-nebula'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubSuggestedArticlesRoute), ()=>({
                component: (0, (0, parcelRequire("hnJOJ")).ServiceDeskKnowledgeHubSuggestedArticles),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, (0, parcelRequire("jIAHH")).AsyncKbNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("hnJOJ")).LazyServicedeskKnowledgeHubSuggestedArticles)
                ],
                perfMetricKey: 'service-management.kb-suggested-articles',
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_SUGGESTED_ARTICLES,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_SUGGESTED_ARTICLES),
                        teamName: 'jsm-nebula'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubBrowseViewArticleRoute), ()=>({
                perfMetricKey: 'service-management.knowledge.article',
                component: (0, (0, parcelRequire("809cs")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("809cs")).LazyServicedeskKnowledgeHubViewArticle)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_VIEW_ARTICLE,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_VIEW_ARTICLE),
                        teamName: 'jsm-nebula'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubArticleEmbedEditorRoute), ()=>({
                component: (0, (0, parcelRequire("aNjVS")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("aNjVS")).LazyServiceDeskKnowledgeArticleEmbedEditor)
                ],
                perfMetricKey: 'service-management.knowledge.ep-editor'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubAllArticlesRoute), ()=>({
                component: (0, (0, parcelRequire("bbBli")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, (0, parcelRequire("jIAHH")).AsyncKbNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("bbBli")).LazyServicedeskKnowledgeHubBrowseAllArticles)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_BROWSE_ARTICLES,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_BROWSE_ARTICLES),
                        teamName: 'jsm-nebula'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubArticleInCategoryRoute), ()=>({
                perfMetricKey: 'service-management.knowledge.article',
                component: (0, (0, parcelRequire("809cs")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("809cs")).LazyServicedeskKnowledgeHubViewArticle)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_VIEW_ARTICLE,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_VIEW_ARTICLE),
                        teamName: 'jsm-nebula'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubCategoryPageRoute), ()=>({
                component: (0, (0, parcelRequire("7EGTo")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("7EGTo")).LazyServicedeskKnowledgeHubCategory)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_CATEGORY,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_CATEGORY),
                        teamName: 'jsm-nebula'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubCategoryRoute), ()=>({
                ufoName: 'service-management.knowledge.category',
                component: (0, (0, parcelRequire("7EGTo")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("7EGTo")).LazyServicedeskKnowledgeHubCategory)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_CATEGORY,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_CATEGORY),
                        teamName: 'jsm-nebula'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubSearchRoute), ()=>({
                component: (0, (0, parcelRequire("809cs")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, (0, parcelRequire("jIAHH")).AsyncKbNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("809cs")).LazyServicedeskKnowledgeHubViewArticle)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_VIEW_ARTICLE,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_VIEW_ARTICLE),
                        teamName: 'jsm-nebula'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("cp8Sv")).knowledgeHubSetupRoute), ()=>({
                component: (0, (0, parcelRequire("1iNof")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$3898d1cf01d349b6$var$getKnowledgeHubResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("1iNof")).LazyServicedeskKnowledgeHubSetup)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_SETUP,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_SETUP),
                        teamName: 'jsm-nebula'
                    }
                }
            }))
    ];
});
parcelRegister("jIAHH", function(module, exports) {
    $parcel$export(module.exports, "AsyncKbNav", ()=>$22359123c06ce2f3$export$223f755b7799fe02);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $hPtZI;
    const $22359123c06ce2f3$var$LazyKbNav = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("aRGUb")).then(({ KnowledgeBaseNav: KnowledgeBaseNav })=>KnowledgeBaseNav), {
        moduleId: "./src/packages/navigation-apps/horizontal-nav/horizontal-nav-jsm/knowledge-base/src/ui/index.tsx"
    });
    const $22359123c06ce2f3$export$223f755b7799fe02 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "horizontal-jsm-kb-nav",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($22359123c06ce2f3$var$LazyKbNav, null));
});
parcelRegister("aRGUb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("dqfnF").then(()=>parcelRequire('gaKUF'));
});
parcelRegister("cp8Sv", function(module, exports) {
    $parcel$export(module.exports, "getKnowledgeHubBaseUrl", ()=>$63e01e761a94856d$export$1fe78c01c9fe0ebd);
    $parcel$export(module.exports, "knowledgeHubLandingRoute", ()=>$63e01e761a94856d$export$239eaf6a202e0f54);
    $parcel$export(module.exports, "knowledgeHubBrowseAllArticlesRoute", ()=>$63e01e761a94856d$export$c8e99e3434791c0e);
    $parcel$export(module.exports, "knowledgeHubDraftsRoute", ()=>$63e01e761a94856d$export$670f3b59aa55b7ae);
    $parcel$export(module.exports, "knowledgeHubBrowseAllCategoriesRoute", ()=>$63e01e761a94856d$export$256f841794b3f077);
    $parcel$export(module.exports, "knowledgeHubSuggestedArticlesRoute", ()=>$63e01e761a94856d$export$54edf5cef1c6b21b);
    $parcel$export(module.exports, "knowledgeHubBrowseViewArticleRoute", ()=>$63e01e761a94856d$export$ef8a9ec2979d1b10);
    $parcel$export(module.exports, "knowledgeHubArticleEmbedEditorRoute", ()=>$63e01e761a94856d$export$bd512c426b095693);
    $parcel$export(module.exports, "knowledgeHubAllArticlesRoute", ()=>$63e01e761a94856d$export$20e57a83f181da7b);
    $parcel$export(module.exports, "knowledgeHubArticleInCategoryRoute", ()=>$63e01e761a94856d$export$3afe8482ce820835);
    $parcel$export(module.exports, "knowledgeHubCategoryPageRoute", ()=>$63e01e761a94856d$export$79fb48a07e43639a);
    $parcel$export(module.exports, "knowledgeHubCategoryRoute", ()=>$63e01e761a94856d$export$69ed5b0214ea6ee5);
    $parcel$export(module.exports, "knowledgeHubSearchRoute", ()=>$63e01e761a94856d$export$a47c36fb081b544d);
    $parcel$export(module.exports, "knowledgeHubSetupRoute", ()=>$63e01e761a94856d$export$f20770545704547d);
    var $65Ltd;
    const $63e01e761a94856d$export$1fe78c01c9fe0ebd = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge`;
    const $63e01e761a94856d$export$239eaf6a202e0f54 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_LANDING),
        path: '/jira/servicedesk/projects/:projectKey/knowledge',
        exact: true
    };
    const $63e01e761a94856d$export$c8e99e3434791c0e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_ARTICLES),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/articles',
        exact: true
    };
    const $63e01e761a94856d$export$670f3b59aa55b7ae = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_DRAFTS),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/drafts',
        exact: true
    };
    const $63e01e761a94856d$export$256f841794b3f077 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_ALL_CATEGORIES),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/categories',
        exact: true
    };
    const $63e01e761a94856d$export$54edf5cef1c6b21b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SUGGESTED_TOPICS),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/suggested-topics',
        exact: true
    };
    const $63e01e761a94856d$export$ef8a9ec2979d1b10 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_BROWSE_VIEW_ARTICLE),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/articles/:articleId'
    };
    const $63e01e761a94856d$export$bd512c426b095693 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_EMBED_EDITOR),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/space/:spaceKey/articles/:articleId/edit',
        query: [
            'draftShareId?',
            'topicId?'
        ]
    };
    const $63e01e761a94856d$export$20e57a83f181da7b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ALL_ARTICLES),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/browse/page/:pageId'
    };
    const $63e01e761a94856d$export$3afe8482ce820835 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_ARTICLE_IN_CATEGORY),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/articles/:articleId'
    };
    const $63e01e761a94856d$export$79fb48a07e43639a = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY_PAGE),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId/browse/page/:pageId'
    };
    const $63e01e761a94856d$export$69ed5b0214ea6ee5 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_CATEGORY),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/categories/:categoryId'
    };
    const $63e01e761a94856d$export$a47c36fb081b544d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SEARCH),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/search/articles/:articleId'
    };
    const $63e01e761a94856d$export$f20770545704547d = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_KNOWLEDGE_HUB_SETUP),
        path: '/jira/servicedesk/projects/:projectKey/knowledge/setup'
    };
});
parcelRegister("bbBli", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskKnowledgeHubBrowseAllArticles", ()=>$7877fae2c22be3a0$export$c73ba7e80a805fb2);
    $parcel$export(module.exports, "default", ()=>$7877fae2c22be3a0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $7877fae2c22be3a0$export$c73ba7e80a805fb2 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("iBHYJ"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-browse-all-articles/src/index.tsx"
    });
    var $7877fae2c22be3a0$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7877fae2c22be3a0$export$c73ba7e80a805fb2,
            pageId: "spa-apps/servicedesk/knowledge-hub/browse-all-articles",
            shouldShowSpinner: true
        });
});
parcelRegister("iBHYJ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4ePds")
    ]).then(()=>parcelRequire('4uyp4'));
});
parcelRegister("fDsbI", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskKnowledgeHubBrowseAllCategories", ()=>$0ed31e41bd08d12a$export$a488cba75f18ade8);
    $parcel$export(module.exports, "default", ()=>$0ed31e41bd08d12a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $0ed31e41bd08d12a$export$a488cba75f18ade8 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fziFe"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-browse-all-categories/src/index.tsx"
    });
    var $0ed31e41bd08d12a$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0ed31e41bd08d12a$export$a488cba75f18ade8,
            pageId: "spa-apps/servicedesk/knowledge-hub/browse-all-categories",
            shouldShowSpinner: true
        });
});
parcelRegister("fziFe", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("aiUKx")
    ]).then(()=>parcelRequire('dseQM'));
});
parcelRegister("7EGTo", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskKnowledgeHubCategory", ()=>$cbedf43cff0d751d$export$c01a896b8d33aa9c);
    $parcel$export(module.exports, "default", ()=>$cbedf43cff0d751d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $cbedf43cff0d751d$export$c01a896b8d33aa9c = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dOIFm"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-category/src/index.tsx"
    });
    var $cbedf43cff0d751d$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cbedf43cff0d751d$export$c01a896b8d33aa9c,
            pageId: "spa-apps/servicedesk/knowledge-hub/category",
            shouldShowSpinner: true
        });
});
parcelRegister("dOIFm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("aly08")
    ]).then(()=>parcelRequire('lE3ki'));
});
parcelRegister("2KDj2", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskKnowledgeHubDrafts", ()=>$e2e95eba21898c94$export$53decb9d1eb60aed);
    $parcel$export(module.exports, "default", ()=>$e2e95eba21898c94$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $e2e95eba21898c94$export$53decb9d1eb60aed = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("jyJvE"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-drafts/src/index.tsx"
    });
    var $e2e95eba21898c94$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e2e95eba21898c94$export$53decb9d1eb60aed,
            pageId: "spa-apps/servicedesk/knowledge-hub/drafts",
            shouldShowSpinner: true
        });
});
parcelRegister("jyJvE", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("7Lxlr")
    ]).then(()=>parcelRequire('kl4T5'));
});
parcelRegister("aNjVS", function(module, exports) {
    $parcel$export(module.exports, "LazyServiceDeskKnowledgeArticleEmbedEditor", ()=>$398a28a595927246$export$35c6d2a033ef4c42);
    $parcel$export(module.exports, "default", ()=>$398a28a595927246$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $398a28a595927246$export$35c6d2a033ef4c42 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("5mJ01"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-article-embed-editor/src/index.tsx"
    });
    var $398a28a595927246$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $398a28a595927246$export$35c6d2a033ef4c42,
            pageId: "knowledge-article-embed-editor",
            shouldShowSpinner: true
        });
});
parcelRegister("5mJ01", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("03OxI")
    ]).then(()=>parcelRequire('l54tv'));
});
parcelRegister("fWD3P", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskKnowledgeHubLanding", ()=>$f59132c22330e6a8$export$f1266a588cfc310b);
    $parcel$export(module.exports, "default", ()=>$f59132c22330e6a8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $f59132c22330e6a8$export$f1266a588cfc310b = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("aMpsr")), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-landing/src/index.tsx"
    });
    var $f59132c22330e6a8$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f59132c22330e6a8$export$f1266a588cfc310b,
            pageId: "spa-apps/servicedesk/knowledge-hub/landing-page",
            shouldShowSpinner: true
        });
});
parcelRegister("aMpsr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("lq9Le")
    ]).then(()=>parcelRequire('baJ3W'));
});
parcelRegister("1iNof", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskKnowledgeHubSetup", ()=>$4cd10b3eae0d5ed2$export$6c08040d2dc71e43);
    $parcel$export(module.exports, "default", ()=>$4cd10b3eae0d5ed2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $4cd10b3eae0d5ed2$export$6c08040d2dc71e43 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("b1HFH")), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-setup/src/index.tsx"
    });
    var $4cd10b3eae0d5ed2$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $4cd10b3eae0d5ed2$export$6c08040d2dc71e43,
            pageId: "spa-apps/servicedesk/knowledge-hub/setup",
            shouldShowSpinner: true
        });
});
parcelRegister("b1HFH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("1phgE")
    ]).then(()=>parcelRequire('gBJGI'));
});
parcelRegister("hnJOJ", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskKnowledgeHubSuggestedArticles", ()=>$70c4d3c688caba8c$export$aee7d96c2ee4c388);
    $parcel$export(module.exports, "ServiceDeskKnowledgeHubSuggestedArticles", ()=>$70c4d3c688caba8c$export$ee4623542ebd573e);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $70c4d3c688caba8c$export$aee7d96c2ee4c388 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("dChOr"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-suggested-articles/src/index.tsx"
    });
    const $70c4d3c688caba8c$export$ee4623542ebd573e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $70c4d3c688caba8c$export$aee7d96c2ee4c388,
            pageId: "spa-apps/servicedesk/knowledge-hub/suggested-articles",
            shouldShowSpinner: true
        });
});
parcelRegister("dChOr", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("iFZBi")
    ]).then(()=>parcelRequire('hY7nq'));
});
parcelRegister("809cs", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskKnowledgeHubViewArticle", ()=>$8c5dbaffda117c43$export$efd0ec49853aa81);
    $parcel$export(module.exports, "default", ()=>$8c5dbaffda117c43$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $8c5dbaffda117c43$export$efd0ec49853aa81 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("1bWBT"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/knowledge-hub-view-article/src/index.tsx"
    });
    var $8c5dbaffda117c43$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8c5dbaffda117c43$export$efd0ec49853aa81,
            pageId: "spa-apps/servicedesk/knowledge-hub/view-article",
            shouldShowSpinner: true
        });
});
parcelRegister("1bWBT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("6afNs")
    ]).then(()=>parcelRequire('MNfxH'));
});
parcelRegister("cfD6c", function(module, exports) {
    $parcel$export(module.exports, "notificationLogsRouteEntry", ()=>$9a0a57cbd9b1e94a$export$20ab3a955246df95);
    var $ffza4;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $jdXuV;
    var $6Z2mh;
    var $1RPRU;
    const $9a0a57cbd9b1e94a$export$20ab3a955246df95 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jdXuV")).notificationLogsRoute), ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ],
            component: (0, (0, parcelRequire("1RPRU")).NotificationLogs),
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                (0, (0, parcelRequire("1RPRU")).LazyNotificationLogs)
            ],
            perfMetricKey: 'jsm-notification-logs-component-load'
        }));
});
parcelRegister("jdXuV", function(module, exports) {
    $parcel$export(module.exports, "notificationLogsRoute", ()=>$1d2941a19072c80a$export$c947c80f138bc137);
    var $65Ltd;
    const $1d2941a19072c80a$export$c947c80f138bc137 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_NOTIFICATION_LOGS),
        path: '/jira/servicedesk/projects/:projectKey/notification-logs',
        exact: true
    };
});
parcelRegister("1RPRU", function(module, exports) {
    $parcel$export(module.exports, "LazyNotificationLogs", ()=>$ce165317fbb6ef87$export$69cba5247233f8bc);
    $parcel$export(module.exports, "NotificationLogs", ()=>$ce165317fbb6ef87$export$1139895a5af7252e);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $ce165317fbb6ef87$export$69cba5247233f8bc = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("kdN12"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/notification-logs/src/index.tsx"
    });
    const $ce165317fbb6ef87$export$1139895a5af7252e = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ce165317fbb6ef87$export$69cba5247233f8bc,
            pageId: "spa-apps/servicedesk/notification-logs",
            shouldShowSpinner: true
        });
});
parcelRegister("kdN12", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("43uod")
    ]).then(()=>parcelRequire('9feT0'));
});
parcelRegister("4zmqn", function(module, exports) {
    $parcel$export(module.exports, "oncallRouteEntries", ()=>$2d418c3509154618$export$8e210af71fea11c9);
    var $ffza4;
    var $1cxvE;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $ehdxd;
    var $6Z2mh;
    var $cysbi;
    const $2d418c3509154618$export$8e210af71fea11c9 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("ehdxd")).servicedeskOncallScheduleRoute), ()=>({
                ufoName: 'service-management.on-call-schedule',
                component: (0, (0, parcelRequire("cysbi")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, (0, parcelRequire("1cxvE")).AsyncJSMOperationsHorizontalNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("cysbi")).LazyServicedeskOpsgenieSchedule),
                    (0, (0, parcelRequire("1cxvE")).LazyJSMOperationsHorizontalNav)
                ]
            }))
    ];
});
parcelRegister("ehdxd", function(module, exports) {
    $parcel$export(module.exports, "servicedeskOncallScheduleRoute", ()=>$8d97678b34cc700d$export$740e6e5e982b48a9);
    var $65Ltd;
    const $8d97678b34cc700d$export$e05c5e9dacfbd89d = '/jira/servicedesk/projects/:projectKey';
    const $8d97678b34cc700d$export$740e6e5e982b48a9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ONCALL_SCHEDULE),
        path: `${$8d97678b34cc700d$export$e05c5e9dacfbd89d}/on-call-schedule`,
        exact: true
    };
});
parcelRegister("cysbi", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskOpsgenieSchedule", ()=>$816d970487a82139$export$e8392650fdcd92d5);
    $parcel$export(module.exports, "default", ()=>$816d970487a82139$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $816d970487a82139$export$e8392650fdcd92d5 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("7v5JQ")), {
        moduleId: "./src/packages/spa-apps/servicedesk/opsgenie-schedule/src/index.tsx"
    });
    var $816d970487a82139$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $816d970487a82139$export$e8392650fdcd92d5,
            pageId: "spa-apps/servicedesk/opsgenie-schedule",
            shouldShowSpinner: true
        });
});
parcelRegister("7v5JQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("aVjGW")
    ]).then(()=>parcelRequire('gjKCT'));
});
parcelRegister("h2i60", function(module, exports) {
    $parcel$export(module.exports, "organizationRouteEntries", ()=>$aa95243ee0dbcb5f$export$f32a63b509fcdb4f);
    var $ffza4;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $38BXB;
    var $7CBZS;
    var $fpjJX;
    var $6x0wo;
    var $d6Q0M;
    var $6Z2mh;
    var $6gtea;
    const $aa95243ee0dbcb5f$export$f32a63b509fcdb4f = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("d6Q0M")).servicedeskOrganizationV2Route), ()=>({
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("6x0wo")).serviceDeskOrganizationPanelForgeDataResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                    (0, (0, parcelRequire("7CBZS")).productsJsmOrganizationDetailsResource),
                    (0, (0, parcelRequire("38BXB")).jsmEmailDomainsListResource)
                ],
                component: (0, (0, parcelRequire("6gtea")).ServiceDeskOrganizationV2),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("6gtea")).LazyServicedeskOrganizationV2)
                ],
                perfMetricKey: 'jsm-organizations-component-load'
            }))
    ];
});
parcelRegister("6x0wo", function(module, exports) {
    $parcel$export(module.exports, "serviceDeskOrganizationPanelForgeDataResource", ()=>$8bc812ed070bb2a3$export$f3c46a19f3594363);
    var $dIdda = parcelRequire("dIdda");
    const $8bc812ed070bb2a3$var$getDataLoader = ()=>(parcelRequire("6TA4Z"));
    const $8bc812ed070bb2a3$export$f3c46a19f3594363 = (0, $dIdda.createResource)({
        type: (0, $b6a87c89b0762905$export$66d6e1e05866ee2f),
        getKey: ({ match: match })=>{
            const { projectKey: projectKey } = match.params;
            return `extension-${projectKey}`;
        },
        getDataLoader: $8bc812ed070bb2a3$var$getDataLoader,
        maxAge: Number.MAX_SAFE_INTEGER,
        isBrowserOnly: true
    });
});
const $b6a87c89b0762905$export$66d6e1e05866ee2f = 'ORGANIZATION_PANEL_FORGE_DATA';
parcelRegister("6TA4Z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("6fToZ").then(()=>parcelRequire('emXcY'));
});
parcelRegister("d6Q0M", function(module, exports) {
    $parcel$export(module.exports, "servicedeskOrganizationV2Route", ()=>$d9e085eda1fa5205$export$7f878f9aeac61f1e);
    var $65Ltd;
    const $d9e085eda1fa5205$export$7f878f9aeac61f1e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATION_V2),
        path: '/jira/servicedesk/projects/:projectKey/organization/:organizationId',
        exact: true
    };
});
parcelRegister("6gtea", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskOrganizationV2", ()=>$f3c20d8fbb399193$export$1c7fcdb58f42db03);
    $parcel$export(module.exports, "ServiceDeskOrganizationV2", ()=>$f3c20d8fbb399193$export$5f69663d85db303d);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $f3c20d8fbb399193$export$1c7fcdb58f42db03 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("jNSqy"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/organization-v2/src/index.tsx"
    });
    const $f3c20d8fbb399193$export$5f69663d85db303d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $f3c20d8fbb399193$export$1c7fcdb58f42db03,
            pageId: "spa-apps/servicedesk/organization-v2",
            shouldShowSpinner: true
        });
});
parcelRegister("jNSqy", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("4SjA9")
    ]).then(()=>parcelRequire('3BhTj'));
});
parcelRegister("bX5mt", function(module, exports) {
    $parcel$export(module.exports, "organizationsRouteEntries", ()=>$dd0cd7c738b6ffe2$export$7dd191d527f3ef6f);
    var $ffza4;
    var $cEOhb;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $38BXB;
    var $7CBZS;
    var $fpjJX;
    var $8XgXN;
    var $iTeMQ;
    var $9cIRM;
    var $6Z2mh;
    var $e9YVH;
    var $rKFLU;
    const $dd0cd7c738b6ffe2$var$getOrganizationsRoutesCommon = ()=>({
            layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
            ]
        });
    const $dd0cd7c738b6ffe2$export$7dd191d527f3ef6f = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9cIRM")).servicedeskOrganizationDetailsRoute), ()=>({
                ...$dd0cd7c738b6ffe2$var$getOrganizationsRoutesCommon(),
                component: (0, (0, parcelRequire("rKFLU")).ServicedeskOrganizationDetails),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("rKFLU")).LazyServicedeskOrganizationDetails)
                ],
                perfMetricKey: 'jsm-organization-details-component-load',
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).ORGANIZATION_DETAILS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).ORGANIZATION_DETAILS),
                        teamName: 'boysenberry'
                    }
                },
                resources: [
                    ...$dd0cd7c738b6ffe2$var$getOrganizationsRoutesCommon().resources,
                    (0, (0, parcelRequire("8XgXN")).entitlementsOrganizationQueryResource),
                    (0, (0, parcelRequire("iTeMQ")).uiOrganizationDetailsPageQueryResource),
                    (0, (0, parcelRequire("7CBZS")).productsJsmOrganizationDetailsResource),
                    (0, (0, parcelRequire("38BXB")).jsmEmailDomainsListResource)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("9cIRM")).servicedeskOrganizationsRoute), ()=>({
                ...$dd0cd7c738b6ffe2$var$getOrganizationsRoutesCommon(),
                component: (0, (0, parcelRequire("rKFLU")).ServiceDeskOrganizations),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("rKFLU")).LazyServicedeskOrganizations)
                ],
                perfMetricKey: 'jsm-organizations-component-load',
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, (0, parcelRequire("cEOhb")).AsyncDirectoryNav),
                    onlyShowHorizontalOnNav4: true
                },
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).ORGANIZATIONS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).ORGANIZATIONS),
                        teamName: 'boysenberry'
                    }
                }
            }))
    ];
});
parcelRegister("8XgXN", function(module, exports) {
    $parcel$export(module.exports, "entitlementsOrganizationQueryResource", ()=>$275795ce1e7f33fe$export$fead08d66d56688e);
    var $ao2h1;
    var $9NGHY;
    const $275795ce1e7f33fe$export$fead08d66d56688e = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'ENTITLEMENTS_ORGANIZATION_QUERY',
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("9NGHY")).default),
                variables: {
                    organizationId: String(match.params.organizationId),
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("9NGHY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$42e659babe89c8d5$export$2e2bcd8739ae039);
    const $42e659babe89c8d5$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "organizationId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v2 = [
            {
                "kind": "Literal",
                "name": "first",
                "value": 1
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v4 = [
            {
                "kind": "Variable",
                "name": "organizationId",
                "variableName": "organizationId"
            }
        ], v5 = {
            "kind": "ScalarField",
            "name": "name"
        }, v6 = {
            "kind": "ScalarField",
            "name": "id"
        }, v7 = {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "entitlementsOrganizationQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": v1,
                            "concreteType": "CustomerServiceQueryApi",
                            "kind": "LinkedField",
                            "name": "customerService",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v2,
                                        "concreteType": "CustomerServiceProductConnection",
                                        "kind": "LinkedField",
                                        "name": "productConnections",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "concreteType": "CustomerServiceProductEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "CustomerServiceProduct",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v3
                                                            ]
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "customerService.productConnections.edges"
                                            }
                                        ],
                                        "storageKey": "productConnections(first:1)"
                                    },
                                    "action": "THROW",
                                    "path": "customerService.productConnections"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v4,
                                        "kind": "LinkedField",
                                        "name": "organizationByOrganizationId",
                                        "plural": false,
                                        "selections": [
                                            v3,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v5,
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v6,
                                                        "action": "THROW",
                                                        "path": "customerService.organizationByOrganizationId.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CustomerServiceEntitlement",
                                                            "kind": "LinkedField",
                                                            "name": "entitlementList",
                                                            "plural": true,
                                                            "selections": [
                                                                v6,
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "includeEntityTypeName",
                                                                            "value": false
                                                                        }
                                                                    ],
                                                                    "kind": "FragmentSpread",
                                                                    "name": "entitlement_servicedeskCustomerServiceEntitlementsCard"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "customerService.organizationByOrganizationId.entitlementList"
                                                    },
                                                    v7
                                                ],
                                                "type": "CustomerServiceOrganization"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                    }
                                                ],
                                                "type": "QueryError"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "customerService.organizationByOrganizationId"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "customerService"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "entitlementsOrganizationQuery",
                "selections": [
                    {
                        "args": v1,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "concreteType": "CustomerServiceProductConnection",
                                "kind": "LinkedField",
                                "name": "productConnections",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "CustomerServiceProductEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "concreteType": "CustomerServiceProduct",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v3,
                                                    v6
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "productConnections(first:1)"
                            },
                            {
                                "args": v4,
                                "kind": "LinkedField",
                                "name": "organizationByOrganizationId",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v5,
                                            v6,
                                            {
                                                "concreteType": "CustomerServiceEntitlement",
                                                "kind": "LinkedField",
                                                "name": "entitlementList",
                                                "plural": true,
                                                "selections": [
                                                    v6,
                                                    {
                                                        "concreteType": "CustomerServiceProduct",
                                                        "kind": "LinkedField",
                                                        "name": "product",
                                                        "plural": false,
                                                        "selections": [
                                                            v6,
                                                            v5
                                                        ]
                                                    }
                                                ]
                                            },
                                            v7
                                        ],
                                        "type": "CustomerServiceOrganization"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "identifier"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "message"
                                            },
                                            {
                                                "kind": "LinkedField",
                                                "name": "extensions",
                                                "plural": true,
                                                "selections": [
                                                    v3,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "statusCode"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "errorType"
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "QueryError"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v6
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "01a04225033d1c240e60c2831c34cc958b17cd0c6be52ce6b65c5484adb41a6f",
                "metadata": {},
                "name": "entitlementsOrganizationQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $42e659babe89c8d5$var$node.hash = "c2dbf2a99cb38657b66de75f23707712";
    var $42e659babe89c8d5$export$2e2bcd8739ae039 = $42e659babe89c8d5$var$node;
});
parcelRegister("iTeMQ", function(module, exports) {
    $parcel$export(module.exports, "uiOrganizationDetailsPageQueryResource", ()=>$6f42d74340bbf820$export$ab65064827d1831d);
    var $ao2h1;
    var $hpIsM;
    const $6f42d74340bbf820$export$ab65064827d1831d = (0, (0, parcelRequire("ao2h1")).createRelayResource)({
        type: 'UI_ORGANIZATION_DETAILS_PAGE_QUERY',
        getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
                parameters: (0, (0, parcelRequire("hpIsM")).default),
                variables: {
                    organizationId: String(match.params.organizationId),
                    cloudId: tenantContext.cloudId
                },
                options: {
                    fetchPolicy: 'store-and-network'
                }
            })
    });
});
parcelRegister("hpIsM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc8caf12ab702db6$export$2e2bcd8739ae039);
    const $bc8caf12ab702db6$var$node = function() {
        var v0 = [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "organizationId"
            }
        ], v1 = [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ], v2 = [
            {
                "kind": "Variable",
                "name": "organizationId",
                "variableName": "organizationId"
            }
        ], v3 = {
            "kind": "ScalarField",
            "name": "__typename"
        }, v4 = {
            "kind": "ScalarField",
            "name": "statusCode"
        }, v5 = {
            "kind": "ScalarField",
            "name": "id"
        }, v6 = {
            "kind": "ScalarField",
            "name": "name"
        }, v7 = {
            "kind": "ScalarField",
            "name": "identifier"
        }, v8 = {
            "kind": "ScalarField",
            "name": "message"
        }, v9 = {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v3,
                v4,
                {
                    "kind": "ScalarField",
                    "name": "errorType"
                }
            ]
        };
        return {
            "fragment": {
                "argumentDefinitions": v0,
                "kind": "Fragment",
                "name": "uiOrganizationDetailsPageQuery",
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": v1,
                            "concreteType": "CustomerServiceQueryApi",
                            "kind": "LinkedField",
                            "name": "customerService",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v2,
                                        "kind": "LinkedField",
                                        "name": "organizationByOrganizationId",
                                        "plural": false,
                                        "selections": [
                                            v3,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "details",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "FragmentSpread",
                                                                "name": "customDetailsSidebar_servicedeskCustomerServiceCustomDetailsSidebar_Inner"
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "CustomerServiceOrganization"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "extensions",
                                                        "plural": true,
                                                        "selections": [
                                                            v4
                                                        ]
                                                    },
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "throwOnQueryError_servicedeskCustomerServiceCommon"
                                                    }
                                                ],
                                                "type": "QueryError"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "customerService.organizationByOrganizationId"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "customerService"
                    }
                ],
                "type": "Query"
            },
            "kind": "Request",
            "operation": {
                "argumentDefinitions": v0,
                "kind": "Operation",
                "name": "uiOrganizationDetailsPageQuery",
                "selections": [
                    {
                        "args": v1,
                        "concreteType": "CustomerServiceQueryApi",
                        "kind": "LinkedField",
                        "name": "customerService",
                        "plural": false,
                        "selections": [
                            {
                                "args": v2,
                                "kind": "LinkedField",
                                "name": "organizationByOrganizationId",
                                "plural": false,
                                "selections": [
                                    v3,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "details",
                                                "plural": false,
                                                "selections": [
                                                    v3,
                                                    {
                                                        "kind": "TypeDiscriminator",
                                                        "abstractKey": "__isCustomerServiceCustomDetailValuesQueryResult"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "CustomerServiceCustomDetailValue",
                                                                "kind": "LinkedField",
                                                                "name": "results",
                                                                "plural": true,
                                                                "selections": [
                                                                    v5,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "canEdit"
                                                                    },
                                                                    v6,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "value"
                                                                    },
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "values"
                                                                    },
                                                                    {
                                                                        "concreteType": "CustomerServiceCustomDetailType",
                                                                        "kind": "LinkedField",
                                                                        "name": "type",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            v6,
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "options"
                                                                            }
                                                                        ]
                                                                    },
                                                                    {
                                                                        "concreteType": "CustomerServiceCustomDetailConfigMetadata",
                                                                        "kind": "LinkedField",
                                                                        "name": "config",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "concreteType": "CustomerServiceCustomAttributeStyleConfiguration",
                                                                                "kind": "LinkedField",
                                                                                "name": "styleConfiguration",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "concreteType": "CustomerServiceCustomAttributeOptionsStyleConfiguration",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "options",
                                                                                        "plural": true,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "ScalarField",
                                                                                                "name": "optionValue"
                                                                                            },
                                                                                            {
                                                                                                "concreteType": "CustomerServiceCustomAttributeOptionStyle",
                                                                                                "kind": "LinkedField",
                                                                                                "name": "style",
                                                                                                "plural": false,
                                                                                                "selections": [
                                                                                                    {
                                                                                                        "kind": "ScalarField",
                                                                                                        "name": "backgroundColour"
                                                                                                    }
                                                                                                ]
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                ]
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "CustomerServiceCustomDetailValues"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v7,
                                                            v8,
                                                            v9
                                                        ],
                                                        "type": "QueryError"
                                                    }
                                                ]
                                            }
                                        ],
                                        "type": "CustomerServiceOrganization"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v9,
                                            v7,
                                            v8
                                        ],
                                        "type": "QueryError"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v5
                                        ],
                                        "type": "Node",
                                        "abstractKey": "__isNode"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            "params": {
                "id": "a225e51b1ca0507ed6d9b7fea04e9939f9f90322a81d41da48011ddeff62c4d3",
                "metadata": {},
                "name": "uiOrganizationDetailsPageQuery",
                "operationKind": "query",
                "text": null
            }
        };
    }();
    $bc8caf12ab702db6$var$node.hash = "8781f4b4eca174196d95ee737ccdc3aa";
    var $bc8caf12ab702db6$export$2e2bcd8739ae039 = $bc8caf12ab702db6$var$node;
});
parcelRegister("9cIRM", function(module, exports) {
    $parcel$export(module.exports, "servicedeskOrganizationsRoute", ()=>$68bc8c78730a3759$export$d4a712c5bc3c3434);
    $parcel$export(module.exports, "servicedeskOrganizationDetailsRoute", ()=>$68bc8c78730a3759$export$eacc4723293cbc36);
    var $65Ltd;
    const $68bc8c78730a3759$export$d4a712c5bc3c3434 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATIONS),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/projects/:projectKey/organizations',
        exact: true
    };
    const $68bc8c78730a3759$export$eacc4723293cbc36 = {
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ORGANIZATION_DETAILS),
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/projects/:projectKey/organizations/:organizationId',
        exact: true
    };
});
parcelRegister("rKFLU", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskOrganizations", ()=>$b9e14ed4e63c050e$export$b40b4bfa472057b9);
    $parcel$export(module.exports, "ServiceDeskOrganizations", ()=>$b9e14ed4e63c050e$export$4abec67d7b34dda2);
    $parcel$export(module.exports, "LazyServicedeskOrganizationDetails", ()=>$b9e14ed4e63c050e$export$4a01866152e4a375);
    $parcel$export(module.exports, "ServicedeskOrganizationDetails", ()=>$b9e14ed4e63c050e$export$709be875ca0a7ead);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $b9e14ed4e63c050e$export$b40b4bfa472057b9 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("bOoEj"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/organizations/src/index.tsx"
    });
    const $b9e14ed4e63c050e$export$4abec67d7b34dda2 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b9e14ed4e63c050e$export$b40b4bfa472057b9,
            pageId: "spa-apps/servicedesk/organizations",
            shouldShowSpinner: true
        });
    const $b9e14ed4e63c050e$export$4a01866152e4a375 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("3bziv"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/organization-details/src/index.tsx"
    });
    const $b9e14ed4e63c050e$export$709be875ca0a7ead = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b9e14ed4e63c050e$export$4a01866152e4a375,
            pageId: "spa-apps/servicedesk/organization-details",
            shouldShowSpinner: true
        });
});
parcelRegister("bOoEj", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("h7cjl")
    ]).then(()=>parcelRequire('e2tYQ'));
});
parcelRegister("3bziv", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("3OcWv")
    ]).then(()=>parcelRequire('9LQpe'));
});
parcelRegister("bA72A", function(module, exports) {
    $parcel$export(module.exports, "projectSummaryRouteEntries", ()=>$09da2704609fb0f6$export$cef6a6370e56c273);
    var $7XYc4;
    var $4R6GH;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $fpjJX;
    var $5lsNZ;
    var $2bP5L;
    var $6Z2mh;
    var $e9YVH;
    var $i93hg;
    var $iZ8qR;
    const $09da2704609fb0f6$export$cef6a6370e56c273 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("2bP5L")).servicedeskProjectSummaryRoute), ()=>({
                ufoName: 'jsm.project-summary',
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('jsm-project-summary'), ()=>null, (0, (0, parcelRequire("5lsNZ")).default)),
                skeleton: (0, (0, parcelRequire("i93hg")).ProjectSummarySkeleton),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                entryPoint: ()=>(0, (0, parcelRequire("4R6GH")).fg)('jsm-project-summary') ? (0, (0, parcelRequire("iZ8qR")).projectSummaryPageEntryPoint) : undefined,
                meta: {
                    reporting: {
                        id: 'project-summary',
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).PROJECT_SUMMARY),
                        teamName: 'jsd-shield'
                    }
                }
            }))
    ];
});
parcelRegister("2bP5L", function(module, exports) {
    $parcel$export(module.exports, "servicedeskProjectSummaryRoute", ()=>$9bf5e06985e86271$export$a23b752ff24027ae);
    var $65Ltd;
    const $9bf5e06985e86271$export$a23b752ff24027ae = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        path: '/jira/servicedesk/projects/:projectKey/summary',
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PROJECT_SUMMARY)
    };
});
parcelRegister("i93hg", function(module, exports) {
    $parcel$export(module.exports, "ProjectSummarySkeleton", ()=>$c888779b3c2a7055$export$93a223cf4712c63d);
    var $5uXOq = parcelRequire("5uXOq");
    var $gnABE;
    var $jflJ3 = parcelRequire("jflJ3");
    const $c888779b3c2a7055$export$93a223cf4712c63d = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gnABE")).AppSkeletonImage), {
            src: (0, ($parcel$interopDefault($jflJ3)))
        });
});
parcelRegister("jflJ3", function(module, exports) {
    module.exports = new URL("project-summary-skeleton.tpl.f2232e71.svg", import.meta.url).toString();
});
parcelRegister("iZ8qR", function(module, exports) {
    $parcel$export(module.exports, "projectSummaryPageEntryPoint", ()=>$cfa42f0318b6392e$export$ae7c241893e7dab9);
    var $lkFvK;
    var $lmyls;
    var $fmaTw;
    const $cfa42f0318b6392e$export$ae7c241893e7dab9 = (0, (0, parcelRequire("lkFvK")).createPageEntryPoint)({
        main: (0, (0, parcelRequire("fmaTw")).projectSummaryEntryPoint),
        topNavigationMenuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS
    });
});
parcelRegister("fmaTw", function(module, exports) {
    $parcel$export(module.exports, "projectSummaryEntryPoint", ()=>$15ffffad92965566$export$95a2fe4e495efca5);
    var $2Ftxm;
    var $ikgNX;
    const $15ffffad92965566$export$95a2fe4e495efca5 = (0, (0, parcelRequire("ikgNX")).createEntryPoint)({
        root: (0, (0, parcelRequire("2Ftxm")).JSResourceForInteraction)(()=>(parcelRequire("aObDz")), {
            moduleId: "ac794fd1"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("aObDz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        (parcelRequire("aMHR6"))((parcelRequire("dy9lH")).resolve("gJl2n")),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("nwI1a")
    ]).then(()=>parcelRequire('i6ZtS'));
});
parcelRegister("Mn8Lz", function(module, exports) {
    $parcel$export(module.exports, "queuesRouteEntries", ()=>$9e240ff8903b873c$export$91a360c2f7f83db9);
    var $ffza4;
    var $g5RGc;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $1XrjK;
    var $jlOGG;
    var $bHhiy;
    var $fpjJX;
    var $d04s2;
    var $bgtos;
    var $e7zl2;
    var $6Z2mh;
    var $laAgE;
    var $hw6fm;
    var $4kils;
    var $i1TcK;
    var $erVva;
    var $57W6j;
    var $eyZxr;
    const $9e240ff8903b873c$export$91a360c2f7f83db9 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("e7zl2")).servicedeskIssueRoute), ()=>({
                component: (0, (0, parcelRequire("eyZxr")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getKnowledgeBaseResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getInsightResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("eyZxr")).LazyServicedeskQueuesIssueViewRedirect)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("e7zl2")).servicedeskQueuesLandingRoute), ()=>({
                isRedirect: true,
                component: (0, (0, parcelRequire("erVva")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                    (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("erVva")).LazyServicedeskQueuesLanding)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("e7zl2")).servicedeskQueuesNewRoute), ()=>({
                component: (0, (0, parcelRequire("hw6fm")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("hw6fm")).LazyServicedeskQueuesCreateView)
                ],
                ufoName: 'service-management.queues.new'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("e7zl2")).servicedeskQueuesEditRoute), ()=>({
                component: (0, (0, parcelRequire("4kils")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                    ...(0, (0, parcelRequire("fpjJX")).getIssueListSsrResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("4kils")).LazyServicedeskQueuesEditView)
                ],
                ufoName: 'service-management.queues.edit'
            })),
        (0, (0, parcelRequire("bgtos")).customQueueRouteEntry),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("e7zl2")).servicedeskQueuesIssueRoute), ()=>({
                component: (0, (0, parcelRequire("i1TcK")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                    {
                        params: [
                            {
                                key: 'issueKey'
                            }
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getKnowledgeBaseResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getInsightResources)(),
                    (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                afterPaint: [
                    (0, (0, parcelRequire("d04s2")).LazyIssueApp)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("i1TcK")).LazyServicedeskQueuesIssueView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("e7zl2")).servicedeskQueuesManageViewRoute), ()=>({
                component: (0, (0, parcelRequire("57W6j")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: (0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("57W6j")).LazyServicedeskQueuesManageView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("e7zl2")).servicedeskQueuesAddonRoute), ()=>({
                component: (0, (0, parcelRequire("laAgE")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("laAgE")).LazyServicedeskQueuesAddonView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("e7zl2")).servicedeskPracticeLandingRoute), ()=>({
                isRedirect: true,
                component: (0, (0, parcelRequire("erVva")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("erVva")).LazyServicedeskQueuesLanding)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("e7zl2")).servicedeskPracticeNewRoute), ()=>({
                component: (0, (0, parcelRequire("hw6fm")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("hw6fm")).LazyServicedeskQueuesCreateView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("e7zl2")).servicedeskPracticeManageViewRoute), ()=>({
                component: (0, (0, parcelRequire("57W6j")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: (0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("57W6j")).LazyServicedeskQueuesManageView)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("e7zl2")).servicedeskPracticeEditRoute), ()=>({
                component: (0, (0, parcelRequire("4kils")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getIssueListSsrResource)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("4kils")).LazyServicedeskQueuesEditView)
                ]
            })),
        (0, (0, parcelRequire("bgtos")).customPracticeQueueRouteEntry),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("e7zl2")).servicedeskPracticeIssueRoute), ()=>({
                component: (0, (0, parcelRequire("i1TcK")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)()),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getKnowledgeBaseResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getInsightResources)(),
                    (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                afterPaint: [
                    (0, (0, parcelRequire("d04s2")).LazyIssueApp)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("i1TcK")).LazyServicedeskQueuesIssueView)
                ]
            }))
    ];
});
parcelRegister("jlOGG", function(module, exports) {
    $parcel$export(module.exports, "newIssueViewLockInStatusResource", ()=>$951713022fad9069$export$647de7516d081bd8);
    $parcel$export(module.exports, "useNewIssueViewLockInStatus", ()=>$951713022fad9069$export$d8ba398930f2f5f);
    var $dIdda = parcelRequire("dIdda");
    var $1odlY;
    const $951713022fad9069$export$647de7516d081bd8 = (0, $dIdda.createResource)({
        type: (0, (0, parcelRequire("1odlY")).RESOURCE_TYPE_PROJECT_NEW_ISSUE_VIEW_LOCK_IN_STATUS),
        getKey: ({ match: match })=>match.params.projectKey || '',
        getDataLoader: ()=>(parcelRequire("c6e4J")),
        maxAge: Number.MAX_VALUE
    });
    const $951713022fad9069$export$d8ba398930f2f5f = ()=>{
        const { data: data, loading: loading, error: error } = (0, $dIdda.useResource)($951713022fad9069$export$647de7516d081bd8);
        return {
            loading: loading,
            error: error,
            newIssueViewLockedIn: data && data.newIssueViewLockedIn
        };
    };
});
parcelRegister("c6e4J", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("83I2X").then(()=>parcelRequire('7JV09'));
});
parcelRegister("bgtos", function(module, exports) {
    $parcel$export(module.exports, "customQueueRouteEntry", ()=>$9ff5a714e8ce1079$export$54a295e04e6cea33);
    $parcel$export(module.exports, "customPracticeQueueRouteEntry", ()=>$9ff5a714e8ce1079$export$b43128c9b5db2a5e);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $co1wz;
    var $g5RGc;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $1XrjK;
    var $jlOGG;
    var $bHhiy;
    var $2pT4g;
    var $fpjJX;
    var $aNLeB;
    var $gNStA;
    var $d04s2;
    var $aIkD8;
    var $6Z2mh;
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $9ff5a714e8ce1079$var$LazyServicedeskQueuesAgentAndIssueView = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("6SxPM"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/queues-agent-and-issue-view/src/index.tsx"
    });
    const $9ff5a714e8ce1079$export$59d555419fbaa611 = ({ match: match })=>{
        const queueId = match.params && match.params.queueId || '';
        const issueKey = match.params && match.params.issueKey || '';
        const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $9ff5a714e8ce1079$var$LazyServicedeskQueuesAgentAndIssueView,
            pageId: `spa-apps/servicedesk/queues/${queueId}/${issueKey}/${oldIssueView}`,
            shouldShowSpinner: true
        });
    };
    const $9ff5a714e8ce1079$export$54a295e04e6cea33 = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aIkD8")).customQueueRoute), ()=>({
            component: $9ff5a714e8ce1079$export$59d555419fbaa611,
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                {
                    params: [
                        {
                            key: 'issueKey'
                        }
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getInsightResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getIssueListSsrResource)(),
                (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("aNLeB")).servicedeskIsItsmProjectResource)
            ],
            afterPaint: [
                (0, (0, parcelRequire("d04s2")).LazyIssueApp)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $9ff5a714e8ce1079$var$LazyServicedeskQueuesAgentAndIssueView
            ]
        }));
    const $9ff5a714e8ce1079$export$b43128c9b5db2a5e = (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("aIkD8")).customPracticeQueueRoute), ()=>({
            component: $9ff5a714e8ce1079$export$59d555419fbaa611,
            layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                {
                    params: [
                        {
                            key: 'issueKey'
                        }
                    ]
                }
            ])),
            navigation: {
                menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                sidebar: (0, (0, parcelRequire("h0bZU")).default)
            },
            resources: [
                ...(0, (0, parcelRequire("fpjJX")).getQueuesResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getKnowledgeBaseResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getInsightResources)(),
                ...(0, (0, parcelRequire("fpjJX")).getIssueListSsrResource)(),
                (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)(),
                (0, (0, parcelRequire("gNStA")).resourceWithCondition2)(()=>(0, (0, parcelRequire("co1wz")).ff)('enable_jsm_repackaging_changes_vtwk9'), (0, (0, parcelRequire("2pT4g")).jsmRepackagingBannerResource))
            ],
            afterPaint: [
                (0, (0, parcelRequire("d04s2")).LazyIssueApp)
            ],
            forPaint: [
                (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                $9ff5a714e8ce1079$var$LazyServicedeskQueuesAgentAndIssueView
            ]
        }));
});
parcelRegister("aNLeB", function(module, exports) {
    $parcel$export(module.exports, "servicedeskIsItsmProjectResource", ()=>$31e43d0718118496$export$920308cef4e291b1);
    $parcel$export(module.exports, "useIsItsmTemplateProject", ()=>$31e43d0718118496$export$7bb46948fb84f164);
    var $5uXOq = parcelRequire("5uXOq");
    var $e5wyW;
    var $4R6GH;
    var $324W5;
    var $dK8AG;
    var $dIdda = parcelRequire("dIdda");
    const $31e43d0718118496$var$getDataLoader = ()=>(parcelRequire("MZzq5"));
    const $31e43d0718118496$var$ONE_DAY_IN_MILLIS = 86400000;
    const $31e43d0718118496$export$920308cef4e291b1 = (0, $dIdda.createResource)({
        type: (0, $6249ccfa4eeeb82a$export$543a8644640f4092),
        getKey: ({ match: match })=>(0, (0, parcelRequire("dK8AG")).getProjectKeyOrId)(match),
        getDataLoader: $31e43d0718118496$var$getDataLoader,
        maxAge: $31e43d0718118496$var$ONE_DAY_IN_MILLIS
    });
    const $31e43d0718118496$var$useIsItsmTemplateProjectNew = (projectKey)=>{
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)($31e43d0718118496$export$920308cef4e291b1, projectKey ? {
            matchParams: {
                projectKey: projectKey
            }
        } : undefined, {
            shouldPrefetch: true
        });
        return (0, $5uXOq.useMemo)(()=>({
                data: data,
                loading: loading,
                error: error
            }), [
            data,
            loading,
            error
        ]);
    };
    const $31e43d0718118496$var$useIsItsmTemplateProjectOld = (_)=>{
        const { data: data, loading: loading, error: error, refresh: refresh } = (0, $dIdda.useResource)($31e43d0718118496$export$920308cef4e291b1);
        (0, $5uXOq.useEffect)(()=>{
            if ((data === null || data === undefined) && !loading && !error) refresh();
        }, [
            data,
            loading,
            error,
            refresh
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                data: data,
                loading: loading,
                error: error
            }), [
            data,
            loading,
            error
        ]);
    };
    const $31e43d0718118496$export$7bb46948fb84f164 = (0, (0, parcelRequire("e5wyW")).functionWithCondition)(()=>(0, (0, parcelRequire("4R6GH")).fg)('fix_useinitresource_data_bug'), $31e43d0718118496$var$useIsItsmTemplateProjectNew, $31e43d0718118496$var$useIsItsmTemplateProjectOld);
});
const $6249ccfa4eeeb82a$export$543a8644640f4092 = 'SERVICEDESK_IS_ITSM_PROJECT';
parcelRegister("MZzq5", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("4CXUh").then(()=>parcelRequire('k9PUn'));
});
parcelRegister("aIkD8", function(module, exports) {
    $parcel$export(module.exports, "customQueueRoute", ()=>$4c49d5efc3cf0837$export$e1fac82ca0b0d637);
    $parcel$export(module.exports, "customPracticeQueueRoute", ()=>$4c49d5efc3cf0837$export$59d0bd42aa07faad);
    var $65Ltd;
    const $4c49d5efc3cf0837$export$e1fac82ca0b0d637 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_CUSTOM_AND_ISSUE),
        path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/:issueKey?',
        query: [
            'oldIssueView?'
        ],
        exact: true
    };
    const $4c49d5efc3cf0837$export$59d0bd42aa07faad = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_CUSTOM_AND_ISSUE),
        path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/:issueKey?',
        query: [
            'oldIssueView?'
        ],
        exact: true
    };
});
parcelRegister("6SxPM", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("b8Jun")
    ]).then(()=>parcelRequire('6o1Xn'));
});
parcelRegister("e7zl2", function(module, exports) {
    $parcel$export(module.exports, "servicedeskIssueRoute", ()=>$601c5f22bc0f8f6f$export$e146d4ae5415aa9);
    $parcel$export(module.exports, "servicedeskQueuesLandingRoute", ()=>$601c5f22bc0f8f6f$export$52b4c044e4929ebc);
    $parcel$export(module.exports, "servicedeskQueuesNewRoute", ()=>$601c5f22bc0f8f6f$export$c1908994722d1e73);
    $parcel$export(module.exports, "servicedeskQueuesEditRoute", ()=>$601c5f22bc0f8f6f$export$f8fd3a1f8c33aff8);
    $parcel$export(module.exports, "servicedeskQueuesIssueRoute", ()=>$601c5f22bc0f8f6f$export$52a24b9cf42d208b);
    $parcel$export(module.exports, "servicedeskQueuesManageViewRoute", ()=>$601c5f22bc0f8f6f$export$7f30d40b906894c5);
    $parcel$export(module.exports, "servicedeskQueuesAddonRoute", ()=>$601c5f22bc0f8f6f$export$1465f05b88a63f13);
    $parcel$export(module.exports, "servicedeskPracticeLandingRoute", ()=>$601c5f22bc0f8f6f$export$3c859c71be33b36c);
    $parcel$export(module.exports, "servicedeskPracticeNewRoute", ()=>$601c5f22bc0f8f6f$export$8595a5452f93a1fd);
    $parcel$export(module.exports, "servicedeskPracticeManageViewRoute", ()=>$601c5f22bc0f8f6f$export$125e0ab662806584);
    $parcel$export(module.exports, "servicedeskPracticeEditRoute", ()=>$601c5f22bc0f8f6f$export$dfaa99f66db1aa2);
    $parcel$export(module.exports, "servicedeskPracticeIssueRoute", ()=>$601c5f22bc0f8f6f$export$38a6ee0f22e74bf3);
    var $65Ltd;
    const $601c5f22bc0f8f6f$export$e146d4ae5415aa9 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ISSUE),
        path: '/jira/servicedesk/projects/:projectKey/issue/:issueKey',
        exact: true
    };
    const $601c5f22bc0f8f6f$export$52b4c044e4929ebc = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_LANDING),
        path: '/jira/servicedesk/projects/:projectKey/queues/(default|custom)?',
        exact: true
    };
    const $601c5f22bc0f8f6f$export$c1908994722d1e73 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_NEW),
        path: '/jira/servicedesk/projects/:projectKey/queues/custom/new',
        query: [
            'parentId?'
        ],
        exact: true
    };
    const $601c5f22bc0f8f6f$export$f8fd3a1f8c33aff8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_EDIT),
        path: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/edit',
        exact: true
    };
    const $601c5f22bc0f8f6f$export$52a24b9cf42d208b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_ISSUE),
        path: '/jira/servicedesk/projects/:projectKey/queues/issue/:issueKey',
        query: [
            'oldIssueView?'
        ],
        exact: true
    };
    const $601c5f22bc0f8f6f$export$7f30d40b906894c5 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_MANAGE_VIEW),
        path: '/jira/servicedesk/projects/:projectKey/queues/queue-settings',
        exact: true
    };
    const $601c5f22bc0f8f6f$export$1465f05b88a63f13 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_QUEUES_ADDON),
        path: '/jira/servicedesk/projects/:projectKey/queues/addon/:addonKey',
        exact: true
    };
    const $601c5f22bc0f8f6f$export$3c859c71be33b36c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_LANDING),
        path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/(custom)?',
        exact: true
    };
    const $601c5f22bc0f8f6f$export$8595a5452f93a1fd = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_NEW),
        path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/new',
        query: [
            'parentId?'
        ],
        exact: true
    };
    const $601c5f22bc0f8f6f$export$125e0ab662806584 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_MANAGE_VIEW),
        path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/queue-settings',
        exact: true
    };
    const $601c5f22bc0f8f6f$export$dfaa99f66db1aa2 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_EDIT),
        path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/edit',
        exact: true
    };
    const $601c5f22bc0f8f6f$export$38a6ee0f22e74bf3 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_PRACTICE_ISSUE),
        path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/issue/:issueKey',
        exact: true
    };
});
parcelRegister("laAgE", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskQueuesAddonView", ()=>$6cc059f7849819d9$export$451a7cce84b6b1e6);
    $parcel$export(module.exports, "default", ()=>$6cc059f7849819d9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $6cc059f7849819d9$export$451a7cce84b6b1e6 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("ajfQi")), {
        moduleId: "./src/packages/spa-apps/servicedesk/queues-addon-view/src/index.tsx"
    });
    var $6cc059f7849819d9$export$2e2bcd8739ae039 = ({ match: match })=>{
        const addonKey = match.params && match.params.addonKey || '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6cc059f7849819d9$export$451a7cce84b6b1e6,
            pageId: `spa-apps/servicedesk/queues/addon/${addonKey}`,
            shouldShowSpinner: true
        });
    };
});
parcelRegister("ajfQi", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("j8CYW")
    ]).then(()=>parcelRequire('jFMLI'));
});
parcelRegister("hw6fm", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskQueuesCreateView", ()=>$093d629913ef6b8e$export$c050b699bf9e3e40);
    $parcel$export(module.exports, "default", ()=>$093d629913ef6b8e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $093d629913ef6b8e$export$c050b699bf9e3e40 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("ifEQP"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/queues-create-view/src/index.tsx"
    });
    var $093d629913ef6b8e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $093d629913ef6b8e$export$c050b699bf9e3e40,
            pageId: "spa-apps/servicedesk/queues/create",
            shouldShowSpinner: true
        });
});
parcelRegister("ifEQP", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("jX3BJ")
    ]).then(()=>parcelRequire('aQuyJ'));
});
parcelRegister("4kils", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskQueuesEditView", ()=>$deaadf08ad128234$export$5bb02347e0261e6a);
    $parcel$export(module.exports, "default", ()=>$deaadf08ad128234$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $deaadf08ad128234$export$5bb02347e0261e6a = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fseMQ"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/queues-edit-view/src/index.tsx"
    });
    var $deaadf08ad128234$export$2e2bcd8739ae039 = ({ match: match })=>{
        const queueId = match.params && match.params.queueId || '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $deaadf08ad128234$export$5bb02347e0261e6a,
            pageId: `spa-apps/servicedesk/queues/edit/${queueId}`,
            shouldShowSpinner: true
        });
    };
});
parcelRegister("fseMQ", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("K7eQv")
    ]).then(()=>parcelRequire('3r23L'));
});
parcelRegister("i1TcK", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskQueuesIssueView", ()=>$e8099257b5d2aca0$export$164f2dfdd8dc056b);
    $parcel$export(module.exports, "default", ()=>$e8099257b5d2aca0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $e8099257b5d2aca0$export$164f2dfdd8dc056b = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("9gDVS")), {
        ssr: false,
        moduleId: "./src/packages/spa-apps/servicedesk/queues-issue-view/src/index.tsx"
    });
    var $e8099257b5d2aca0$export$2e2bcd8739ae039 = ({ match: match })=>{
        const issueKey = `/${match.params && match.params.issueKey || ''}`;
        const queueId = `/${match.params && match.params.queueId || ''}`;
        const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $e8099257b5d2aca0$export$164f2dfdd8dc056b,
            pageId: `spa-apps/servicedesk/queues/issue${queueId}${issueKey}${oldIssueView}`,
            shouldShowSpinner: true
        });
    };
});
parcelRegister("9gDVS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("3vo2B")
    ]).then(()=>parcelRequire('6qBzG'));
});
parcelRegister("erVva", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskQueuesLanding", ()=>$33ab495a6069d0db$export$bdf522692228bb6f);
    $parcel$export(module.exports, "default", ()=>$33ab495a6069d0db$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $33ab495a6069d0db$export$bdf522692228bb6f = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("6d9hm")), {
        moduleId: "./src/packages/spa-apps/servicedesk/queues-landing/src/index.tsx"
    });
    var $33ab495a6069d0db$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $33ab495a6069d0db$export$bdf522692228bb6f,
            pageId: "spa-apps/servicedesk/queues/landing",
            shouldShowSpinner: true
        });
});
parcelRegister("6d9hm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eRCFp")
    ]).then(()=>parcelRequire('5ou2F'));
});
parcelRegister("57W6j", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskQueuesManageView", ()=>$ad9d634f0cdcf391$export$9f1e189198f08c4a);
    $parcel$export(module.exports, "default", ()=>$ad9d634f0cdcf391$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $ad9d634f0cdcf391$export$9f1e189198f08c4a = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("diKh2"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/queues-manage-view/src/index.tsx"
    });
    var $ad9d634f0cdcf391$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ad9d634f0cdcf391$export$9f1e189198f08c4a,
            pageId: "spa-apps/servicedesk/queues/manage",
            shouldShowSpinner: true
        });
});
parcelRegister("diKh2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("cFmpd")
    ]).then(()=>parcelRequire('htw0K'));
});
parcelRegister("eyZxr", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskQueuesIssueViewRedirect", ()=>$3e1702b77575d903$export$52593b5917c5e179);
    $parcel$export(module.exports, "default", ()=>$3e1702b77575d903$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $3e1702b77575d903$export$52593b5917c5e179 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("gcllV")), {
        moduleId: "./src/packages/spa-apps/servicedesk/queues-issue-view-redirect/src/index.tsx"
    });
    var $3e1702b77575d903$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $3e1702b77575d903$export$52593b5917c5e179,
            pageId: "spa-apps/servicedesk/queues/issue-view-redirect",
            shouldShowSpinner: true
        });
});
parcelRegister("gcllV", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8QnWZ").then(()=>parcelRequire('blyWx'));
});
parcelRegister("1x70f", function(module, exports) {
    $parcel$export(module.exports, "reportsRouteEntries", ()=>$78d2bc6933594b61$export$721a27be140cb34d);
    var $5uXOq = parcelRequire("5uXOq");
    var $ffza4;
    var $7XYc4;
    var $g5RGc;
    var $lmyls;
    var $3HwlS;
    var $h0bZU;
    var $2G9Bk;
    var $1XrjK;
    var $jlOGG;
    var $bjZiV;
    var $bHhiy;
    var $hejqw;
    var $fpjJX;
    var $d04s2;
    var $jaWUd;
    var $6Z2mh;
    var $e9YVH;
    var $dIdda = parcelRequire("dIdda");
    var $6Hx2y;
    var $cm4j2;
    var $3FrpL;
    var $3I9YI;
    var $gnyZS;
    var $4QhHa;
    var $1hJVy;
    var $cVTuT;
    var $8Xwpi;
    var $iYH8s;
    const $78d2bc6933594b61$var$DefaultReportsRedirect = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: `/jira/servicedesk/projects/${String(match.params.projectKey)}${(0, $11b6f5430511c7a8$export$ddc580d759168f88)}`
        });
    const $78d2bc6933594b61$var$returnToSummary = ({ match: match })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $dIdda.Redirect), {
            to: String(match.params['0'])
        });
    const $78d2bc6933594b61$var$getReportsWithKbResources = ()=>[
            ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
            (0, (0, parcelRequire("bjZiV")).kbConfluenceContextResource)
        ];
    const $78d2bc6933594b61$export$721a27be140cb34d = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReportsSummaryRoute), ()=>({
                component: $78d2bc6933594b61$var$returnToSummary,
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReports1Route), ()=>({
                component: (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), (0, (0, parcelRequire("4QhHa")).default), $78d2bc6933594b61$var$DefaultReportsRedirect),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$78d2bc6933594b61$var$getReportsWithKbResources(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("4QhHa")).LazyServicedeskReportsHomePage)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskAtlassianAnalyticsRoute), ()=>({
                component: (0, (0, parcelRequire("cm4j2")).AtlassianAnalytics),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("hejqw")).servicedeskAtlassianAnalyticsResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("cm4j2")).LazyAtlassianAnalytics)
                ],
                meta: {
                    reporting: {
                        id: (0, (0, parcelRequire("e9YVH")).APP_NAMES).ATLASSIAN_ANALYTICS,
                        packageName: (0, (0, parcelRequire("e9YVH")).toPackageName)((0, (0, parcelRequire("e9YVH")).APP_NAMES).ATLASSIAN_ANALYTICS),
                        teamName: 'ITSM Saga'
                    }
                }
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReportsWorkloadRoute), ()=>({
                component: (0, (0, parcelRequire("iYH8s")).default),
                perfMetricKey: 'service-management.reports.workload',
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("iYH8s")).LazyServicedeskReportsWorkload)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReportsSatisfactionIssueRoute), ()=>({
                component: (0, (0, parcelRequire("1hJVy")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)()),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                afterPaint: [
                    (0, (0, parcelRequire("d04s2")).LazyIssueApp)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("1hJVy")).LazyServicedeskReportsIssueView)
                ],
                ufoName: 'service-management.reports.issue'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReportsSatisfactionTimeScaleRoute), ()=>({
                perfMetricKey: 'service-management.reports.satisfaction',
                component: (0, (0, parcelRequire("8Xwpi")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("8Xwpi")).LazyServicedeskReportsSatisfaction)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReportsSatisfaction2Route), ()=>({
                perfMetricKey: 'service-management.reports.satisfaction',
                component: (0, (0, parcelRequire("8Xwpi")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("8Xwpi")).LazyServicedeskReportsSatisfaction)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskKbRequestsReportsIssueRoute), ()=>({
                component: (0, (0, parcelRequire("1hJVy")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)()),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                afterPaint: [
                    (0, (0, parcelRequire("d04s2")).LazyIssueApp)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("1hJVy")).LazyServicedeskReportsIssueView)
                ],
                ufoName: 'service-management.reports.issue'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskKbRequestsReportsTimeScaleRoute), ()=>({
                perfMetricKey: 'service-management.reports.kb-requests',
                component: (0, (0, parcelRequire("cVTuT")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("cVTuT")).LazyServicedeskKbRequestsReports)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskKbRequestsReports2Route), ()=>({
                perfMetricKey: 'service-management.reports.kb-requests',
                component: (0, (0, parcelRequire("cVTuT")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("cVTuT")).LazyServicedeskKbRequestsReports)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReportsCustomEditRoute), ()=>({
                perfMetricKey: 'service-management.reports.custom-edit-view',
                component: (0, (0, parcelRequire("gnyZS")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("gnyZS")).LazyServicedeskReportsCustomEdit)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReportsCustomCreateRoute), ()=>({
                perfMetricKey: 'service-management.reports.custom-create',
                component: (0, (0, parcelRequire("3I9YI")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("3I9YI")).LazyServicedeskReportsCustomCreate)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReportsCustomIssueRoute), ()=>({
                component: (0, (0, parcelRequire("1hJVy")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)()),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                afterPaint: [
                    (0, (0, parcelRequire("d04s2")).LazyIssueApp)
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("1hJVy")).LazyServicedeskReportsIssueView)
                ],
                ufoName: 'service-management.reports.issue'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReportsCustomTimeScaleRoute), ()=>({
                component: (0, (0, parcelRequire("3FrpL")).default),
                perfMetricKey: 'service-management.reports.custom',
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("3FrpL")).LazyServicedeskReportsCustom)
                ],
                ufoName: 'service-management-custom-reports'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReportsCustom4Route), ()=>({
                component: (0, (0, parcelRequire("3FrpL")).default),
                perfMetricKey: 'service-management.reports.custom',
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("3FrpL")).LazyServicedeskReportsCustom)
                ],
                ufoName: 'service-management-custom-reports'
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("jaWUd")).servicedeskReportsTypeRoute), ()=>({
                component: (0, (0, parcelRequire("6Hx2y")).default),
                layout: (0, (0, parcelRequire("1XrjK")).composeLayouts)((0, (0, parcelRequire("6Z2mh")).serviceProjectLayout), (0, (0, parcelRequire("g5RGc")).embeddedIssuePreloadLayoutBuilder)([
                    {
                        params: [
                            {
                                key: 'issueKey'
                            }
                        ]
                    }
                ])),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...$78d2bc6933594b61$var$getReportsWithKbResources(),
                    (0, (0, parcelRequire("jlOGG")).newIssueViewLockInStatusResource),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("6Hx2y")).LazyServicedeskReports)
                ]
            }))
    ];
    var $78d2bc6933594b61$export$2e2bcd8739ae039 = (0, (0, parcelRequire("6Hx2y")).default);
});
parcelRegister("hejqw", function(module, exports) {
    $parcel$export(module.exports, "servicedeskAtlassianAnalyticsResource", ()=>$ccd9a1a485573887$export$eb2deca89cf3fb61);
    var $dIdda = parcelRequire("dIdda");
    const $ccd9a1a485573887$var$getDataLoader = ()=>(parcelRequire("jfmG6"));
    const $ccd9a1a485573887$export$eb2deca89cf3fb61 = (0, $dIdda.createResource)({
        type: (0, $125270e59037c004$export$73cf43fb073ce577),
        getKey: ()=>'atlassian analytics',
        getDataLoader: $ccd9a1a485573887$var$getDataLoader,
        isBrowserOnly: true
    });
});
const $125270e59037c004$export$73cf43fb073ce577 = 'SERVICEDESK_ATLASSIAN_ANALYTICS';
parcelRegister("jfmG6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1fLqt").then(()=>parcelRequire('ghpmF'));
});
parcelRegister("jaWUd", function(module, exports) {
    $parcel$export(module.exports, "servicedeskReportsSummaryRoute", ()=>$6cd4d40658b63531$export$44647b0fd2271ddb);
    $parcel$export(module.exports, "servicedeskReports1Route", ()=>$6cd4d40658b63531$export$f5adfd681a4e85ad);
    $parcel$export(module.exports, "servicedeskAtlassianAnalyticsRoute", ()=>$6cd4d40658b63531$export$399ef3a2d4288bba);
    $parcel$export(module.exports, "servicedeskReportsWorkloadRoute", ()=>$6cd4d40658b63531$export$ce9b409ccf53e93c);
    $parcel$export(module.exports, "servicedeskReportsSatisfactionIssueRoute", ()=>$6cd4d40658b63531$export$da606765550c7e7);
    $parcel$export(module.exports, "servicedeskReportsSatisfactionTimeScaleRoute", ()=>$6cd4d40658b63531$export$64ae70b2d6b34c4e);
    $parcel$export(module.exports, "servicedeskReportsSatisfaction2Route", ()=>$6cd4d40658b63531$export$22fd25b495033fdf);
    $parcel$export(module.exports, "servicedeskKbRequestsReportsIssueRoute", ()=>$6cd4d40658b63531$export$296aa46068d40f43);
    $parcel$export(module.exports, "servicedeskKbRequestsReportsTimeScaleRoute", ()=>$6cd4d40658b63531$export$1585b6f8f1838e19);
    $parcel$export(module.exports, "servicedeskKbRequestsReports2Route", ()=>$6cd4d40658b63531$export$276e2ed89304d21c);
    $parcel$export(module.exports, "servicedeskReportsCustomEditRoute", ()=>$6cd4d40658b63531$export$3b6b3105a9ef9b83);
    $parcel$export(module.exports, "servicedeskReportsCustomCreateRoute", ()=>$6cd4d40658b63531$export$333e623d5eb41af0);
    $parcel$export(module.exports, "servicedeskReportsCustomIssueRoute", ()=>$6cd4d40658b63531$export$1cfe539c854438e8);
    $parcel$export(module.exports, "servicedeskReportsCustomTimeScaleRoute", ()=>$6cd4d40658b63531$export$eae9a65fe3f035ef);
    $parcel$export(module.exports, "servicedeskReportsCustom4Route", ()=>$6cd4d40658b63531$export$39325072940fb58c);
    $parcel$export(module.exports, "servicedeskReportsTypeRoute", ()=>$6cd4d40658b63531$export$b955ac7f09c5dbb);
    var $65Ltd;
    const $6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX = '/jira/servicedesk/projects/:projectKey';
    const $6cd4d40658b63531$var$WORKLOAD_ROUTE_SUFFIX = '/reports/workload';
    const $6cd4d40658b63531$var$ATLASSIAN_ANALYTICS_ROUTE_SUFFIX = '/reports/atlassian-analytics';
    const $6cd4d40658b63531$var$CUSTOM_ROUTE_SUFFIX = '/reports/custom/:reportId';
    const $6cd4d40658b63531$var$REQUESTS_ROUTE_SUFFIX = '/reports/:reportId(kb-requests-resolved|kb-requests-deflected)';
    const $6cd4d40658b63531$var$TIME_SCALE = '/timescale/:timescaleId';
    const $6cd4d40658b63531$var$SATISFACTION_ROUTE_SUFFIX = '/reports/all-rating';
    const $6cd4d40658b63531$var$ISSUE_KEY = '/:issueKey';
    const $6cd4d40658b63531$export$44647b0fd2271ddb = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SUMMARY),
        path: '(/jira/servicedesk/projects/[^/]+/reports/.+)/summary',
        exact: true
    };
    const $6cd4d40658b63531$export$f5adfd681a4e85ad = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}/reports`,
        exact: true
    };
    const $6cd4d40658b63531$export$399ef3a2d4288bba = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_ATLASSIAN_ANALYTICS),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$ATLASSIAN_ANALYTICS_ROUTE_SUFFIX}`,
        exact: true
    };
    const $6cd4d40658b63531$export$ce9b409ccf53e93c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_WORKLOAD),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$WORKLOAD_ROUTE_SUFFIX}`,
        exact: true
    };
    const $6cd4d40658b63531$export$da606765550c7e7 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_ISSUE),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$SATISFACTION_ROUTE_SUFFIX}${$6cd4d40658b63531$var$TIME_SCALE}${$6cd4d40658b63531$var$ISSUE_KEY}`,
        query: [
            'oldIssueView?'
        ],
        exact: true
    };
    const $6cd4d40658b63531$export$64ae70b2d6b34c4e = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION_TIME_SCALE),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$SATISFACTION_ROUTE_SUFFIX}${$6cd4d40658b63531$var$TIME_SCALE}`
    };
    const $6cd4d40658b63531$export$22fd25b495033fdf = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_SATISFACTION),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$SATISFACTION_ROUTE_SUFFIX}`
    };
    const $6cd4d40658b63531$export$296aa46068d40f43 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_ISSUE),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$REQUESTS_ROUTE_SUFFIX}${$6cd4d40658b63531$var$TIME_SCALE}${$6cd4d40658b63531$var$ISSUE_KEY}`,
        query: [
            'oldIssueView?'
        ],
        exact: true
    };
    const $6cd4d40658b63531$export$1585b6f8f1838e19 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS_TIME_SCALE),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$REQUESTS_ROUTE_SUFFIX}${$6cd4d40658b63531$var$TIME_SCALE}`
    };
    const $6cd4d40658b63531$export$276e2ed89304d21c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_KB_REQUESTS_REPORTS),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$REQUESTS_ROUTE_SUFFIX}`
    };
    const $6cd4d40658b63531$export$3b6b3105a9ef9b83 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_EDIT),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$CUSTOM_ROUTE_SUFFIX}/edit`
    };
    const $6cd4d40658b63531$export$333e623d5eb41af0 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_CREATE),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}/reports/custom/new`
    };
    const $6cd4d40658b63531$export$1cfe539c854438e8 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_ISSUE),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$CUSTOM_ROUTE_SUFFIX}${$6cd4d40658b63531$var$TIME_SCALE}${$6cd4d40658b63531$var$ISSUE_KEY}`,
        query: [
            'oldIssueView?'
        ],
        exact: true
    };
    const $6cd4d40658b63531$export$eae9a65fe3f035ef = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM_TIME_SCALE),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$CUSTOM_ROUTE_SUFFIX}${$6cd4d40658b63531$var$TIME_SCALE}`
    };
    const $6cd4d40658b63531$export$39325072940fb58c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_CUSTOM),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}${$6cd4d40658b63531$var$CUSTOM_ROUTE_SUFFIX}`
    };
    const $6cd4d40658b63531$export$b955ac7f09c5dbb = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_REPORTS_TYPE),
        path: `${$6cd4d40658b63531$var$SERVICE_DESK_ROUTE_PREFIX}/reports/:reportType/:reportId?/:reportsAction?/:timescaleId?/:issueKey?`,
        query: [
            'oldIssueView?'
        ]
    };
});
const $11b6f5430511c7a8$export$e4c007d05145b8c2 = '/reports/all-rating';
const $11b6f5430511c7a8$export$5daa28d10e23592 = '/:issueKey';
const $11b6f5430511c7a8$export$ddc580d759168f88 = '/reports/workload';
const $11b6f5430511c7a8$export$13bdc187fca9c33e = '/reports';
parcelRegister("6Hx2y", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskReports", ()=>$7131a1cafe24fb0a$export$75e043cf7a4e3661);
    $parcel$export(module.exports, "default", ()=>$7131a1cafe24fb0a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $7131a1cafe24fb0a$export$75e043cf7a4e3661 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("ldZL8")), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports/src/index.tsx"
    });
    var $7131a1cafe24fb0a$export$2e2bcd8739ae039 = ({ match: match })=>{
        const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7131a1cafe24fb0a$export$75e043cf7a4e3661,
            pageId: `spa-apps/servicedesk/reports/${match ? match.url : ''}${oldIssueView}`,
            shouldShowSpinner: true
        });
    };
});
parcelRegister("ldZL8", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("lssra")
    ]).then(()=>parcelRequire('dp6PR'));
});
parcelRegister("cm4j2", function(module, exports) {
    $parcel$export(module.exports, "LazyAtlassianAnalytics", ()=>$8afe4cbad132cc61$export$78ffe2f6530d45d1);
    $parcel$export(module.exports, "AtlassianAnalytics", ()=>$8afe4cbad132cc61$export$6d23a188bb96b7ab);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $8afe4cbad132cc61$export$78ffe2f6530d45d1 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("gPETo"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/atlassian-analytics/src/index.tsx"
    });
    const $8afe4cbad132cc61$export$6d23a188bb96b7ab = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $8afe4cbad132cc61$export$78ffe2f6530d45d1,
            pageId: "spa-apps/servicedesk/atlassian-analytics",
            shouldShowSpinner: true
        });
});
parcelRegister("gPETo", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("ahZ5Q")
    ]).then(()=>parcelRequire('hUapH'));
});
parcelRegister("3FrpL", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskReportsCustom", ()=>$940ea7d208fcfce4$export$3ec5c3d7729889b9);
    $parcel$export(module.exports, "default", ()=>$940ea7d208fcfce4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $940ea7d208fcfce4$export$3ec5c3d7729889b9 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("cRCTf"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports-custom/src/index.tsx"
    });
    var $940ea7d208fcfce4$export$2e2bcd8739ae039 = ({ match: match })=>{
        const reportType = match.params.reportType || '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $940ea7d208fcfce4$export$3ec5c3d7729889b9,
            pageId: `spa-apps/servicedesk/reports/${reportType}`,
            shouldShowSpinner: true
        });
    };
});
parcelRegister("cRCTf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("6sXwS")
    ]).then(()=>parcelRequire('gIY6j'));
});
parcelRegister("3I9YI", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskReportsCustomCreate", ()=>$0aaa6fdfa8d01159$export$821b8201b24f8b7d);
    $parcel$export(module.exports, "default", ()=>$0aaa6fdfa8d01159$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $0aaa6fdfa8d01159$export$821b8201b24f8b7d = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4r62a"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports-custom-create/src/index.tsx"
    });
    var $0aaa6fdfa8d01159$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0aaa6fdfa8d01159$export$821b8201b24f8b7d,
            pageId: "spa-apps/servicedesk/reports/custom/create",
            shouldShowSpinner: true
        });
});
parcelRegister("4r62a", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("1v184")
    ]).then(()=>parcelRequire('bYkUJ'));
});
parcelRegister("gnyZS", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskReportsCustomEdit", ()=>$db3dd114755c3f65$export$53def03ace9a6c5b);
    $parcel$export(module.exports, "default", ()=>$db3dd114755c3f65$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $db3dd114755c3f65$export$53def03ace9a6c5b = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("2EqEW"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports-custom-edit/src/index.tsx"
    });
    var $db3dd114755c3f65$export$2e2bcd8739ae039 = ({ match: match })=>{
        const { reportId: reportId } = match.params;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $db3dd114755c3f65$export$53def03ace9a6c5b,
            pageId: `spa-apps/servicedesk/reports/custom/${reportId || ''}`,
            shouldShowSpinner: true
        });
    };
});
parcelRegister("2EqEW", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("hrAxT")
    ]).then(()=>parcelRequire('cOaoL'));
});
parcelRegister("4QhHa", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskReportsHomePage", ()=>$2636e09e0764ad56$export$121b9cfb2b001a53);
    $parcel$export(module.exports, "default", ()=>$2636e09e0764ad56$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $2636e09e0764ad56$export$121b9cfb2b001a53 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("7gVww"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports-home-page/src/index.tsx"
    });
    var $2636e09e0764ad56$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $2636e09e0764ad56$export$121b9cfb2b001a53,
            pageId: `spa-apps/servicedesk${(0, $11b6f5430511c7a8$export$13bdc187fca9c33e)}}`,
            shouldShowSpinner: true
        });
});
parcelRegister("7gVww", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("atEkV")
    ]).then(()=>parcelRequire('i1BaA'));
});
parcelRegister("1hJVy", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskReportsIssueView", ()=>$7281c34e15a34d51$export$c2f0d3c59c9d3bf3);
    $parcel$export(module.exports, "default", ()=>$7281c34e15a34d51$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $7281c34e15a34d51$export$c2f0d3c59c9d3bf3 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("lNm0S")), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports-issue-view/src/index.tsx"
    });
    var $7281c34e15a34d51$export$2e2bcd8739ae039 = ({ match: match })=>{
        const issueKey = `/${match.params && match.params.issueKey || ''}`;
        const timescaleId = `/${match.params && match.params.timescaleId || ''}`;
        const oldIssueView = `/${match.query && match.query.oldIssueView || ''}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $7281c34e15a34d51$export$c2f0d3c59c9d3bf3,
            pageId: `spa-apps/servicedesk/reports/issue${issueKey}${timescaleId}${oldIssueView}`,
            shouldShowSpinner: true
        });
    };
});
parcelRegister("lNm0S", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("8831k")
    ]).then(()=>parcelRequire('kXHaM'));
});
parcelRegister("cVTuT", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskKbRequestsReports", ()=>$12e91a60aa9991e2$export$f86e12b111395ad);
    $parcel$export(module.exports, "default", ()=>$12e91a60aa9991e2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $12e91a60aa9991e2$export$f86e12b111395ad = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("il0ku"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/kb-requests-reports/src/index.tsx"
    });
    var $12e91a60aa9991e2$export$2e2bcd8739ae039 = ({ match: match })=>{
        const reportType = match.params.reportType || '';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $12e91a60aa9991e2$export$f86e12b111395ad,
            pageId: `spa-apps/servicedesk/reports/${reportType}`,
            shouldShowSpinner: true
        });
    };
});
parcelRegister("il0ku", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("ktADJ")
    ]).then(()=>parcelRequire('exkzN'));
});
parcelRegister("8Xwpi", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskReportsSatisfaction", ()=>$66f1c14673116eb8$export$8edc7b9d922cd22f);
    $parcel$export(module.exports, "default", ()=>$66f1c14673116eb8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $66f1c14673116eb8$export$8edc7b9d922cd22f = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("fLZPu"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports-satisfaction/src/index.tsx"
    });
    var $66f1c14673116eb8$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $66f1c14673116eb8$export$8edc7b9d922cd22f,
            pageId: `spa-apps/servicedesk${(0, $11b6f5430511c7a8$export$e4c007d05145b8c2)}}`,
            shouldShowSpinner: true
        });
});
parcelRegister("fLZPu", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("ijyfm")
    ]).then(()=>parcelRequire('hLsyG'));
});
parcelRegister("iYH8s", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskReportsWorkload", ()=>$d985dd949edfaeac$export$e805fb47fdcd991);
    $parcel$export(module.exports, "default", ()=>$d985dd949edfaeac$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $d985dd949edfaeac$export$e805fb47fdcd991 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("huJzT"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/reports-workload/src/index.tsx"
    });
    var $d985dd949edfaeac$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $d985dd949edfaeac$export$e805fb47fdcd991,
            pageId: `spa-apps/servicedesk${(0, $11b6f5430511c7a8$export$ddc580d759168f88)}}`,
            shouldShowSpinner: true
        });
});
parcelRegister("huJzT", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gZXlE")
    ]).then(()=>parcelRequire('bQ0Tt'));
});
parcelRegister("6oBRx", function(module, exports) {
    $parcel$export(module.exports, "servicesRouteEntries", ()=>$7aec6a0c589216f2$export$57d6fec357eb220c);
    var $ffza4;
    var $1cxvE;
    var $lmyls;
    var $h0bZU;
    var $2G9Bk;
    var $bHhiy;
    var $3RJkv;
    var $fpjJX;
    var $HWK76;
    var $6Z2mh;
    var $cUmrA;
    var $eGEo2;
    var $3jBnk;
    var $3URFK;
    var $gLrf3;
    var $7zD3e;
    const $7aec6a0c589216f2$export$837d7aa221731e74 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("HWK76")).servicedeskServicesRoute), ()=>({
                ufoName: 'service-management.services',
                component: (0, (0, parcelRequire("gLrf3")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default),
                    horizontal: (0, (0, parcelRequire("1cxvE")).AsyncJSMOperationsHorizontalNav),
                    onlyShowHorizontalOnNav4: true
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("1cxvE")).LazyJSMOperationsHorizontalNav),
                    (0, (0, parcelRequire("gLrf3")).LazyServicedeskServicesWithProjectContext)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("HWK76")).servicedeskServiceDetailsRoute), ()=>({
                ufoName: 'service-management.service-details',
                component: (0, (0, parcelRequire("eGEo2")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                navigation: {
                    menuId: (0, (0, parcelRequire("lmyls")).MENU_ID).PROJECTS,
                    sidebar: (0, (0, parcelRequire("h0bZU")).default)
                },
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("eGEo2")).LazyServicedeskServiceDetailsWithProjectContext)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("HWK76")).serviceDeskServicesWithoutProjectRoute), ()=>({
                ufoName: 'service-management.services-without-project',
                component: (0, (0, parcelRequire("7zD3e")).default),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("7zD3e")).LazyServicedeskServicesWithoutProjectContext)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("HWK76")).serviceDeskServiceDetailsWithoutProjectRoute), ()=>({
                ufoName: 'service-management.service-details-without-project',
                component: (0, (0, parcelRequire("3jBnk")).default),
                resources: [
                    ...(0, (0, parcelRequire("3RJkv")).getNavigationResources)(),
                    (0, (0, parcelRequire("bHhiy")).getConsolidationStateResource)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("3jBnk")).LazyServicedeskServiceDetailsWithoutProjectContext)
                ]
            }))
    ];
    const $7aec6a0c589216f2$export$27385b29970830e7 = [
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("HWK76")).servicedeskServiceModalNewRoute), ()=>({
                component: (0, (0, parcelRequire("cUmrA")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("cUmrA")).LazyServiceCreateModalWithProjectContext)
                ]
            })),
        (0, (0, parcelRequire("2G9Bk")).createEntry)((0, (0, parcelRequire("HWK76")).servicedeskServiceModalEditRoute), ()=>({
                component: (0, (0, parcelRequire("3URFK")).default),
                layout: (0, (0, parcelRequire("6Z2mh")).serviceProjectLayout),
                resources: [
                    ...(0, (0, parcelRequire("fpjJX")).getServiceDeskNavigationResources)(),
                    ...(0, (0, parcelRequire("fpjJX")).getServicedeskPageContextResources)()
                ],
                forPaint: [
                    (0, (0, parcelRequire("ffza4")).LazyAtlassianNavigation),
                    (0, (0, parcelRequire("3URFK")).LazyServiceUpdateModalWithProjectContext)
                ]
            }))
    ];
    const $7aec6a0c589216f2$export$57d6fec357eb220c = [
        ...$7aec6a0c589216f2$export$837d7aa221731e74,
        ...$7aec6a0c589216f2$export$27385b29970830e7
    ];
});
parcelRegister("HWK76", function(module, exports) {
    $parcel$export(module.exports, "servicedeskServicesRoute", ()=>$c1c2642725d7bc92$export$4a800381bda6d53c);
    $parcel$export(module.exports, "servicedeskServiceDetailsRoute", ()=>$c1c2642725d7bc92$export$fe5fe00b6d5eab87);
    $parcel$export(module.exports, "servicedeskServiceModalNewRoute", ()=>$c1c2642725d7bc92$export$5b5ea97286af2784);
    $parcel$export(module.exports, "servicedeskServiceModalEditRoute", ()=>$c1c2642725d7bc92$export$319fbbab5eb49cbf);
    $parcel$export(module.exports, "serviceDeskServicesWithoutProjectRoute", ()=>$c1c2642725d7bc92$export$3210e7c54c21be97);
    $parcel$export(module.exports, "serviceDeskServiceDetailsWithoutProjectRoute", ()=>$c1c2642725d7bc92$export$25e1d58db18a7c8b);
    var $65Ltd;
    const $c1c2642725d7bc92$var$SERVICE_DESK_ROUTE_PREFIX = '/jira/servicedesk/projects/:projectKey';
    const $c1c2642725d7bc92$var$SERVICE_DESK_ROUTE_PREFIX_WITHOUT_PROJECT = '/jira/servicedesk';
    const $c1c2642725d7bc92$var$SERVICE_HASHED_ARI = '/:serviceAri';
    const $c1c2642725d7bc92$var$SERVICES_ROUTE_SUFFIX = '/services';
    const $c1c2642725d7bc92$var$SERVICE_MODAL_ROUTE_SUFFIX = '/service-modal';
    const $c1c2642725d7bc92$export$4a800381bda6d53c = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICES),
        path: `${$c1c2642725d7bc92$var$SERVICE_DESK_ROUTE_PREFIX}${$c1c2642725d7bc92$var$SERVICES_ROUTE_SUFFIX}`,
        exact: true
    };
    const $c1c2642725d7bc92$export$fe5fe00b6d5eab87 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS),
        path: `${$c1c2642725d7bc92$var$SERVICE_DESK_ROUTE_PREFIX}${$c1c2642725d7bc92$var$SERVICES_ROUTE_SUFFIX}${$c1c2642725d7bc92$var$SERVICE_HASHED_ARI}`
    };
    const $c1c2642725d7bc92$export$5b5ea97286af2784 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_NEW),
        path: `${$c1c2642725d7bc92$var$SERVICE_DESK_ROUTE_PREFIX_WITHOUT_PROJECT}${$c1c2642725d7bc92$var$SERVICE_MODAL_ROUTE_SUFFIX}`,
        exact: true
    };
    const $c1c2642725d7bc92$export$319fbbab5eb49cbf = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_MODAL_EDIT),
        path: `${$c1c2642725d7bc92$var$SERVICE_DESK_ROUTE_PREFIX_WITHOUT_PROJECT}${$c1c2642725d7bc92$var$SERVICE_MODAL_ROUTE_SUFFIX}${$c1c2642725d7bc92$var$SERVICE_HASHED_ARI}`
    };
    const $c1c2642725d7bc92$export$3210e7c54c21be97 = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICES_WITHOUT_PROJECT),
        path: `${$c1c2642725d7bc92$var$SERVICE_DESK_ROUTE_PREFIX_WITHOUT_PROJECT}${$c1c2642725d7bc92$var$SERVICES_ROUTE_SUFFIX}`,
        exact: true,
        meta: {
            reporting: {
                id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICES_WITHOUT_PROJECT),
                packageName: 'jiraSpaAppsServicedeskServicesWithoutProjectContext"',
                teamName: 'Falcons'
            }
        }
    };
    const $c1c2642725d7bc92$export$25e1d58db18a7c8b = {
        group: (0, (0, parcelRequire("65Ltd")).ROUTE_GROUPS_SERVICEDESK),
        name: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_WITHOUT_PROJECT),
        path: `${$c1c2642725d7bc92$var$SERVICE_DESK_ROUTE_PREFIX_WITHOUT_PROJECT}${$c1c2642725d7bc92$var$SERVICES_ROUTE_SUFFIX}${$c1c2642725d7bc92$var$SERVICE_HASHED_ARI}`,
        meta: {
            reporting: {
                id: (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SERVICEDESK_SERVICE_DETAILS_WITHOUT_PROJECT),
                packageName: 'jiraSpaAppsServicedeskServiceDetailsWithoutProjectContext"',
                teamName: 'Falcons'
            }
        }
    };
});
parcelRegister("cUmrA", function(module, exports) {
    $parcel$export(module.exports, "LazyServiceCreateModalWithProjectContext", ()=>$cd397b20b9604e50$export$7f4092c8e7b7d3ec);
    $parcel$export(module.exports, "default", ()=>$cd397b20b9604e50$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $cd397b20b9604e50$export$7f4092c8e7b7d3ec = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("dPmqq")), {
        moduleId: "./src/packages/spa-apps/servicedesk/service-create-modal-without-project-context/src/index.tsx"
    });
    var $cd397b20b9604e50$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $cd397b20b9604e50$export$7f4092c8e7b7d3ec,
            pageId: "spa-apps/servicedesk/service-create-modal",
            shouldShowSpinner: true
        });
});
parcelRegister("dPmqq", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("biuin")
    ]).then(()=>parcelRequire('jBLt3'));
});
parcelRegister("eGEo2", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskServiceDetailsWithProjectContext", ()=>$b6f27b3727e127d8$export$b154597f29589502);
    $parcel$export(module.exports, "default", ()=>$b6f27b3727e127d8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $b6f27b3727e127d8$export$b154597f29589502 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("4tHC0"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/service-details-with-project-context/src/index.tsx"
    });
    var $b6f27b3727e127d8$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $b6f27b3727e127d8$export$b154597f29589502,
            pageId: "spa-apps/servicedesk/service-details",
            shouldShowSpinner: true
        });
});
parcelRegister("4tHC0", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("gwvLC")
    ]).then(()=>parcelRequire('cIaZn'));
});
parcelRegister("3jBnk", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskServiceDetailsWithoutProjectContext", ()=>$0bd916f0e88ab362$export$ba1931edde0ce20c);
    $parcel$export(module.exports, "default", ()=>$0bd916f0e88ab362$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7yO8g;
    var $5j7Th;
    var $hPtZI;
    const $0bd916f0e88ab362$export$ba1931edde0ce20c = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(0, (0, parcelRequire("7yO8g")).markAsProductBundleReady)((parcelRequire("c3xXH"))), {
        moduleId: "./src/packages/spa-apps/servicedesk/service-details-without-project-context/src/index.tsx"
    });
    var $0bd916f0e88ab362$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $0bd916f0e88ab362$export$ba1931edde0ce20c,
            pageId: "spa-apps/servicedesk/service-details",
            shouldShowSpinner: true
        });
});
parcelRegister("c3xXH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("kRkzv")
    ]).then(()=>parcelRequire('bWPI8'));
});
parcelRegister("3URFK", function(module, exports) {
    $parcel$export(module.exports, "LazyServiceUpdateModalWithProjectContext", ()=>$ca64a28173fa79b9$export$8984aadca7e15d1);
    $parcel$export(module.exports, "default", ()=>$ca64a28173fa79b9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $ca64a28173fa79b9$export$8984aadca7e15d1 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("3TJga")), {
        moduleId: "./src/packages/spa-apps/servicedesk/service-update-modal-without-project-context/src/index.tsx"
    });
    var $ca64a28173fa79b9$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $ca64a28173fa79b9$export$8984aadca7e15d1,
            pageId: "spa-apps/servicedesk/service-update-modal",
            shouldShowSpinner: true
        });
});
parcelRegister("3TJga", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("6Zzbw")
    ]).then(()=>parcelRequire('9LJAj'));
});
parcelRegister("gLrf3", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskServicesWithProjectContext", ()=>$6f003aeaf484cf06$export$4aa60213b3477cf6);
    $parcel$export(module.exports, "default", ()=>$6f003aeaf484cf06$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $6f003aeaf484cf06$export$4aa60213b3477cf6 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("eOZlH")), {
        moduleId: "./src/packages/spa-apps/servicedesk/services-with-project-context/src/index.tsx"
    });
    var $6f003aeaf484cf06$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $6f003aeaf484cf06$export$4aa60213b3477cf6,
            pageId: "spa-apps/servicedesk/services",
            shouldShowSpinner: true
        });
});
parcelRegister("eOZlH", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("2tGNS")
    ]).then(()=>parcelRequire('6MNnt'));
});
parcelRegister("7zD3e", function(module, exports) {
    $parcel$export(module.exports, "LazyServicedeskServicesWithoutProjectContext", ()=>$be661d3f8fec3b0f$export$fc385e1392a8e28);
    $parcel$export(module.exports, "default", ()=>$be661d3f8fec3b0f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5j7Th;
    var $hPtZI;
    const $be661d3f8fec3b0f$export$fc385e1392a8e28 = (0, (0, parcelRequire("hPtZI")).lazyForPaint)(()=>(parcelRequire("04A9b")), {
        moduleId: "./src/packages/spa-apps/servicedesk/services-without-project-context/src/index.tsx"
    });
    var $be661d3f8fec3b0f$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5j7Th")).LazyPage), {
            Page: $be661d3f8fec3b0f$export$fc385e1392a8e28,
            pageId: "spa-apps/servicedesk/services",
            shouldShowSpinner: true
        });
});
parcelRegister("04A9b", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("hPzOn"),
        $6fhBS("hAezd")
    ]).then(()=>parcelRequire('1QgiZ'));
});
